
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire19f9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire19f9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("6Z7su", function(module, exports) {
/* global window */ 
var $1qzDT = parcelRequire("1qzDT");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $1qzDT.default)(root);
var $515e39ad6749f3aa$export$2e2bcd8739ae039 = result;

});
parcelRegister("1qzDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a3ddfbb4e508ab$export$2e2bcd8739ae039);
function $10a3ddfbb4e508ab$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("7dGEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $541ad4d15ffa42f6$export$2e2bcd8739ae039);

var $l7O8P = parcelRequire("l7O8P");
var $541ad4d15ffa42f6$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $541ad4d15ffa42f6$var$index = (0, $l7O8P.default)(function(prop) {
    return $541ad4d15ffa42f6$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $541ad4d15ffa42f6$export$2e2bcd8739ae039 = $541ad4d15ffa42f6$var$index;

});
parcelRegister("l7O8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6112573aba91cb3$export$2e2bcd8739ae039);
function $f6112573aba91cb3$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $f6112573aba91cb3$export$2e2bcd8739ae039 = $f6112573aba91cb3$var$memoize;

});


parcelRegister("jRevU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $e74e39a5eb2fcc24$var$invalidType = (message, actual)=>({
        type: 'invalid_type',
        message: message,
        actual: actual
    });
const $e74e39a5eb2fcc24$var$invalidObject = (actual)=>$e74e39a5eb2fcc24$var$invalidType('invalid object', actual);
const $e74e39a5eb2fcc24$var$invalidString = (actual)=>$e74e39a5eb2fcc24$var$invalidType('invalid string', actual);
const $e74e39a5eb2fcc24$var$invalidBoolean = (actual)=>$e74e39a5eb2fcc24$var$invalidType('invalid boolean', actual);
const $e74e39a5eb2fcc24$var$invalidNumber = (actual)=>$e74e39a5eb2fcc24$var$invalidType('invalid number', actual);
const $e74e39a5eb2fcc24$var$invalidArray = (actual)=>$e74e39a5eb2fcc24$var$invalidType('invalid array', actual);
const $e74e39a5eb2fcc24$var$invalidValue = (actual)=>$e74e39a5eb2fcc24$var$invalidType('invalid value', actual);
const $e74e39a5eb2fcc24$var$pathError = (path, error)=>({
        type: 'path_error',
        path: path,
        error: error
    });
const $e74e39a5eb2fcc24$var$multiError = (...errors)=>({
        type: 'multi_error',
        errors: errors
    });
const $e74e39a5eb2fcc24$var$formatError = (err, path = '')=>{
    var _a;
    switch(err.type){
        case 'invalid_type':
            {
                const location = path || 'value';
                const expected = err.message.replace('invalid ', '');
                const actualStr = (_a = JSON.stringify(err.actual)) !== null && _a !== void 0 ? _a : 'undefined';
                return [
                    `expected ${location} to be ${expected}, got ${actualStr}`
                ];
            }
        case 'path_error':
            {
                const newPath = path ? `${path}.${err.path}` : err.path;
                return $e74e39a5eb2fcc24$var$formatError(err.error, newPath);
            }
        case 'multi_error':
            {
                const [first, ...rest] = err.errors;
                const result = $e74e39a5eb2fcc24$var$formatError(first, path);
                for (const e of rest)result.push(...$e74e39a5eb2fcc24$var$formatError(e, path));
                return result;
            }
    }
};
const $e74e39a5eb2fcc24$var$simplifyError = (error)=>{
    if (error.type === 'path_error') {
        const subError = $e74e39a5eb2fcc24$var$simplifyError(error.error);
        if (subError.type === 'path_error') return $e74e39a5eb2fcc24$var$pathError(`${error.path}.${subError.path}`, subError.error);
        else return $e74e39a5eb2fcc24$var$pathError(error.path, subError);
    } else if (error.type === 'multi_error') {
        const mapped = error.errors.map($e74e39a5eb2fcc24$var$simplifyError);
        const errors = [];
        mapped.forEach((ee)=>{
            if (ee.type === 'multi_error') ee.errors.forEach((e)=>errors.push(e));
            else errors.push(ee);
        });
        if (errors.length === 1) return errors[0];
        else return $e74e39a5eb2fcc24$var$multiError(...errors);
    } else return error;
};
module.exports.default = {
    invalidType: $e74e39a5eb2fcc24$var$invalidType,
    invalidObject: $e74e39a5eb2fcc24$var$invalidObject,
    invalidString: $e74e39a5eb2fcc24$var$invalidString,
    invalidBoolean: $e74e39a5eb2fcc24$var$invalidBoolean,
    invalidNumber: $e74e39a5eb2fcc24$var$invalidNumber,
    invalidArray: $e74e39a5eb2fcc24$var$invalidArray,
    invalidValue: $e74e39a5eb2fcc24$var$invalidValue,
    pathError: $e74e39a5eb2fcc24$var$pathError,
    multiError: $e74e39a5eb2fcc24$var$multiError,
    simplifyError: $e74e39a5eb2fcc24$var$simplifyError,
    formatError: $e74e39a5eb2fcc24$var$formatError
};

});

parcelRegister("2ph7Y", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $1c0b33c1e0b66835$export$a7c73072b1a182ae, (v) => $1c0b33c1e0b66835$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $1c0b33c1e0b66835$export$9f27bc3417b4524d, (v) => $1c0b33c1e0b66835$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $1c0b33c1e0b66835$export$db77ccec0bb4ccac, (v) => $1c0b33c1e0b66835$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $1c0b33c1e0b66835$export$8392c0c9d3dcbd35, (v) => $1c0b33c1e0b66835$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $1c0b33c1e0b66835$export$ffb0004e005737fa, (v) => $1c0b33c1e0b66835$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $1c0b33c1e0b66835$export$b624eff549462981, (v) => $1c0b33c1e0b66835$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $1c0b33c1e0b66835$export$7897aa7841a5380c, (v) => $1c0b33c1e0b66835$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $1c0b33c1e0b66835$export$602eac185826482c, (v) => $1c0b33c1e0b66835$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $1c0b33c1e0b66835$export$e2c29f18771995cb, (v) => $1c0b33c1e0b66835$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $1c0b33c1e0b66835$export$5f8d39834fd61797, (v) => $1c0b33c1e0b66835$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c0b33c1e0b66835$export$74bf444e3cd11ea5, (v) => $1c0b33c1e0b66835$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $1c0b33c1e0b66835$export$998bcd577473dd93, (v) => $1c0b33c1e0b66835$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $1c0b33c1e0b66835$export$92387174baf9b227, (v) => $1c0b33c1e0b66835$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $1c0b33c1e0b66835$export$ec112efeb987d9c6, (v) => $1c0b33c1e0b66835$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $1c0b33c1e0b66835$export$b706b080d889d2c9, (v) => $1c0b33c1e0b66835$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $1c0b33c1e0b66835$export$5be5a87408f70ddc, (v) => $1c0b33c1e0b66835$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $1c0b33c1e0b66835$export$45a5e7f76e0caa8d, (v) => $1c0b33c1e0b66835$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $1c0b33c1e0b66835$export$455c2e768291efa6, (v) => $1c0b33c1e0b66835$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $1c0b33c1e0b66835$export$9522e17588c12572, (v) => $1c0b33c1e0b66835$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $1c0b33c1e0b66835$export$2110ac352bb060b9, (v) => $1c0b33c1e0b66835$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $1c0b33c1e0b66835$export$56885ab8b9c456ab, (v) => $1c0b33c1e0b66835$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $1c0b33c1e0b66835$export$d927fcb6adf8f9de, (v) => $1c0b33c1e0b66835$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $1c0b33c1e0b66835$export$b82d16f27459e05a, (v) => $1c0b33c1e0b66835$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $1c0b33c1e0b66835$export$522c17b4f5e123e8, (v) => $1c0b33c1e0b66835$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $1c0b33c1e0b66835$export$1aabd8a0274ecfd6, (v) => $1c0b33c1e0b66835$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $1c0b33c1e0b66835$export$3d6c20d97e46b957, (v) => $1c0b33c1e0b66835$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $1c0b33c1e0b66835$export$9b621391a187a31a, (v) => $1c0b33c1e0b66835$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $1c0b33c1e0b66835$export$f5bbd400c2f4426f, (v) => $1c0b33c1e0b66835$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c0b33c1e0b66835$export$a7c73072b1a182ae;
var $1c0b33c1e0b66835$export$9f27bc3417b4524d;
var $1c0b33c1e0b66835$export$db77ccec0bb4ccac;
var $1c0b33c1e0b66835$export$8392c0c9d3dcbd35;
var $1c0b33c1e0b66835$export$ffb0004e005737fa;
var $1c0b33c1e0b66835$export$b624eff549462981;
var $1c0b33c1e0b66835$export$7897aa7841a5380c;
var $1c0b33c1e0b66835$export$602eac185826482c;
var $1c0b33c1e0b66835$export$e2c29f18771995cb;
var $1c0b33c1e0b66835$export$5f8d39834fd61797;
var $1c0b33c1e0b66835$export$74bf444e3cd11ea5;
var $1c0b33c1e0b66835$export$998bcd577473dd93;
var $1c0b33c1e0b66835$export$92387174baf9b227;
var $1c0b33c1e0b66835$export$ec112efeb987d9c6;
var $1c0b33c1e0b66835$export$b706b080d889d2c9;
var $1c0b33c1e0b66835$export$5be5a87408f70ddc;
var $1c0b33c1e0b66835$export$45a5e7f76e0caa8d;
var $1c0b33c1e0b66835$export$455c2e768291efa6;
var $1c0b33c1e0b66835$export$9522e17588c12572;
var $1c0b33c1e0b66835$export$2110ac352bb060b9;
var $1c0b33c1e0b66835$export$56885ab8b9c456ab;
var $1c0b33c1e0b66835$export$d927fcb6adf8f9de;
var $1c0b33c1e0b66835$export$b82d16f27459e05a;
var $1c0b33c1e0b66835$export$522c17b4f5e123e8;
var $1c0b33c1e0b66835$export$1aabd8a0274ecfd6;
var $1c0b33c1e0b66835$export$3d6c20d97e46b957;
var $1c0b33c1e0b66835$export$9b621391a187a31a;
var $1c0b33c1e0b66835$export$f5bbd400c2f4426f;
'use strict';
var $1c0b33c1e0b66835$var$b = Symbol.for("react.element"), $1c0b33c1e0b66835$var$c = Symbol.for("react.portal"), $1c0b33c1e0b66835$var$d = Symbol.for("react.fragment"), $1c0b33c1e0b66835$var$e = Symbol.for("react.strict_mode"), $1c0b33c1e0b66835$var$f = Symbol.for("react.profiler"), $1c0b33c1e0b66835$var$g = Symbol.for("react.provider"), $1c0b33c1e0b66835$var$h = Symbol.for("react.context"), $1c0b33c1e0b66835$var$k = Symbol.for("react.server_context"), $1c0b33c1e0b66835$var$l = Symbol.for("react.forward_ref"), $1c0b33c1e0b66835$var$m = Symbol.for("react.suspense"), $1c0b33c1e0b66835$var$n = Symbol.for("react.suspense_list"), $1c0b33c1e0b66835$var$p = Symbol.for("react.memo"), $1c0b33c1e0b66835$var$q = Symbol.for("react.lazy"), $1c0b33c1e0b66835$var$t = Symbol.for("react.offscreen"), $1c0b33c1e0b66835$var$u;
$1c0b33c1e0b66835$var$u = Symbol.for("react.module.reference");
function $1c0b33c1e0b66835$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $1c0b33c1e0b66835$var$b:
                switch(a = a.type, a){
                    case $1c0b33c1e0b66835$var$d:
                    case $1c0b33c1e0b66835$var$f:
                    case $1c0b33c1e0b66835$var$e:
                    case $1c0b33c1e0b66835$var$m:
                    case $1c0b33c1e0b66835$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $1c0b33c1e0b66835$var$k:
                            case $1c0b33c1e0b66835$var$h:
                            case $1c0b33c1e0b66835$var$l:
                            case $1c0b33c1e0b66835$var$q:
                            case $1c0b33c1e0b66835$var$p:
                            case $1c0b33c1e0b66835$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $1c0b33c1e0b66835$var$c:
                return r;
        }
    }
}
$1c0b33c1e0b66835$export$a7c73072b1a182ae = $1c0b33c1e0b66835$var$h;
$1c0b33c1e0b66835$export$9f27bc3417b4524d = $1c0b33c1e0b66835$var$g;
$1c0b33c1e0b66835$export$db77ccec0bb4ccac = $1c0b33c1e0b66835$var$b;
$1c0b33c1e0b66835$export$8392c0c9d3dcbd35 = $1c0b33c1e0b66835$var$l;
$1c0b33c1e0b66835$export$ffb0004e005737fa = $1c0b33c1e0b66835$var$d;
$1c0b33c1e0b66835$export$b624eff549462981 = $1c0b33c1e0b66835$var$q;
$1c0b33c1e0b66835$export$7897aa7841a5380c = $1c0b33c1e0b66835$var$p;
$1c0b33c1e0b66835$export$602eac185826482c = $1c0b33c1e0b66835$var$c;
$1c0b33c1e0b66835$export$e2c29f18771995cb = $1c0b33c1e0b66835$var$f;
$1c0b33c1e0b66835$export$5f8d39834fd61797 = $1c0b33c1e0b66835$var$e;
$1c0b33c1e0b66835$export$74bf444e3cd11ea5 = $1c0b33c1e0b66835$var$m;
$1c0b33c1e0b66835$export$998bcd577473dd93 = $1c0b33c1e0b66835$var$n;
$1c0b33c1e0b66835$export$92387174baf9b227 = function() {
    return !1;
};
$1c0b33c1e0b66835$export$ec112efeb987d9c6 = function() {
    return !1;
};
$1c0b33c1e0b66835$export$b706b080d889d2c9 = function(a) {
    return $1c0b33c1e0b66835$var$v(a) === $1c0b33c1e0b66835$var$h;
};
$1c0b33c1e0b66835$export$5be5a87408f70ddc = function(a) {
    return $1c0b33c1e0b66835$var$v(a) === $1c0b33c1e0b66835$var$g;
};
$1c0b33c1e0b66835$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c0b33c1e0b66835$var$b;
};
$1c0b33c1e0b66835$export$455c2e768291efa6 = function(a) {
    return $1c0b33c1e0b66835$var$v(a) === $1c0b33c1e0b66835$var$l;
};
$1c0b33c1e0b66835$export$9522e17588c12572 = function(a) {
    return $1c0b33c1e0b66835$var$v(a) === $1c0b33c1e0b66835$var$d;
};
$1c0b33c1e0b66835$export$2110ac352bb060b9 = function(a) {
    return $1c0b33c1e0b66835$var$v(a) === $1c0b33c1e0b66835$var$q;
};
$1c0b33c1e0b66835$export$56885ab8b9c456ab = function(a) {
    return $1c0b33c1e0b66835$var$v(a) === $1c0b33c1e0b66835$var$p;
};
$1c0b33c1e0b66835$export$d927fcb6adf8f9de = function(a) {
    return $1c0b33c1e0b66835$var$v(a) === $1c0b33c1e0b66835$var$c;
};
$1c0b33c1e0b66835$export$b82d16f27459e05a = function(a) {
    return $1c0b33c1e0b66835$var$v(a) === $1c0b33c1e0b66835$var$f;
};
$1c0b33c1e0b66835$export$522c17b4f5e123e8 = function(a) {
    return $1c0b33c1e0b66835$var$v(a) === $1c0b33c1e0b66835$var$e;
};
$1c0b33c1e0b66835$export$1aabd8a0274ecfd6 = function(a) {
    return $1c0b33c1e0b66835$var$v(a) === $1c0b33c1e0b66835$var$m;
};
$1c0b33c1e0b66835$export$3d6c20d97e46b957 = function(a) {
    return $1c0b33c1e0b66835$var$v(a) === $1c0b33c1e0b66835$var$n;
};
$1c0b33c1e0b66835$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $1c0b33c1e0b66835$var$d || a === $1c0b33c1e0b66835$var$f || a === $1c0b33c1e0b66835$var$e || a === $1c0b33c1e0b66835$var$m || a === $1c0b33c1e0b66835$var$n || a === $1c0b33c1e0b66835$var$t || "object" === typeof a && null !== a && (a.$$typeof === $1c0b33c1e0b66835$var$q || a.$$typeof === $1c0b33c1e0b66835$var$p || a.$$typeof === $1c0b33c1e0b66835$var$g || a.$$typeof === $1c0b33c1e0b66835$var$h || a.$$typeof === $1c0b33c1e0b66835$var$l || a.$$typeof === $1c0b33c1e0b66835$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$1c0b33c1e0b66835$export$f5bbd400c2f4426f = $1c0b33c1e0b66835$var$v;

});

parcelRegister("eTYpT", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("3adcp"));

});
parcelRegister("3adcp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_tickFormat.default;
    }
});

var $24dc8b55daa987f9$var$_band = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("dlF1c")));

var $24dc8b55daa987f9$var$_identity = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("5Hf98")));

var $24dc8b55daa987f9$var$_linear = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("hvSDx")));

var $24dc8b55daa987f9$var$_log = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("aEI3x")));

var $24dc8b55daa987f9$var$_symlog = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("bzrFz")));

var $24dc8b55daa987f9$var$_ordinal = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("cndqj")));

var $24dc8b55daa987f9$var$_pow = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("cpAbf")));

var $24dc8b55daa987f9$var$_radial = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("5lxEG")));

var $24dc8b55daa987f9$var$_quantile = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("67PVh")));

var $24dc8b55daa987f9$var$_quantize = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("mgOAc")));

var $24dc8b55daa987f9$var$_threshold = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("g6ge9")));

var $24dc8b55daa987f9$var$_time = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("617BV")));

var $24dc8b55daa987f9$var$_utcTime = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("ne0st")));

var $24dc8b55daa987f9$var$_sequential = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("5pVeE")));

var $24dc8b55daa987f9$var$_sequentialQuantile = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("l4TSc")));

var $24dc8b55daa987f9$var$_diverging = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("fMWTD")));

var $24dc8b55daa987f9$var$_tickFormat = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("3ZXxn")));
function $24dc8b55daa987f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $24dc8b55daa987f9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($24dc8b55daa987f9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $24dc8b55daa987f9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $24dc8b55daa987f9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("dlF1c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b7d0de6b9b21ba7$var$band;
module.exports.point = $9b7d0de6b9b21ba7$var$point;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");

var $9b7d0de6b9b21ba7$var$_ordinal = $9b7d0de6b9b21ba7$var$_interopRequireDefault((parcelRequire("cndqj")));
function $9b7d0de6b9b21ba7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9b7d0de6b9b21ba7$var$band() {
    var scale = (0, $9b7d0de6b9b21ba7$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $baM4h.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $9b7d0de6b9b21ba7$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $98nei.initRange.apply(rescale(), arguments);
}
function $9b7d0de6b9b21ba7$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $9b7d0de6b9b21ba7$var$pointish(copy());
    };
    return scale;
}
function $9b7d0de6b9b21ba7$var$point() {
    return $9b7d0de6b9b21ba7$var$pointish($9b7d0de6b9b21ba7$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("baM4h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $aRMXC.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $7sRhp.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $7sRhp.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $aRMXC.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $aRMXC.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_zip.default;
    }
});

var $8225ea2cc440a857$var$_bisect = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("eiUsc")));

var $8225ea2cc440a857$var$_ascending = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("42JXN")));

var $8225ea2cc440a857$var$_bisector = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("7C7yR")));

var $8225ea2cc440a857$var$_count = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("ajdJT")));

var $8225ea2cc440a857$var$_cross = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("67S8D")));

var $8225ea2cc440a857$var$_cumsum = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("hG40Y")));

var $8225ea2cc440a857$var$_descending = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("j54An")));

var $8225ea2cc440a857$var$_deviation = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("7tsUa")));

var $8225ea2cc440a857$var$_extent = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("lRRFR")));

var $aRMXC = parcelRequire("aRMXC");

var $8225ea2cc440a857$var$_group = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("c1jhN")));

var $8225ea2cc440a857$var$_groupSort = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("g9Xbd")));

var $8225ea2cc440a857$var$_bin = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("cLuus")));

var $8225ea2cc440a857$var$_freedmanDiaconis = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("d1BC7")));

var $8225ea2cc440a857$var$_scott = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6i8dH")));

var $8225ea2cc440a857$var$_sturges = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("i7tuN")));

var $8225ea2cc440a857$var$_max = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("kHUkZ")));

var $8225ea2cc440a857$var$_maxIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("draOj")));

var $8225ea2cc440a857$var$_mean = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6DBgh")));

var $8225ea2cc440a857$var$_median = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("4HwgR")));

var $8225ea2cc440a857$var$_merge = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("gnNvC")));

var $8225ea2cc440a857$var$_min = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("5raSG")));

var $8225ea2cc440a857$var$_minIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("5nboE")));

var $8225ea2cc440a857$var$_mode = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("asMhi")));

var $8225ea2cc440a857$var$_nice = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("7mFci")));

var $8225ea2cc440a857$var$_pairs = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("ir717")));

var $8225ea2cc440a857$var$_permute = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("39H9X")));

var $8225ea2cc440a857$var$_quantile = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("26KnF")));

var $8225ea2cc440a857$var$_quickselect = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("3EDNm")));

var $8225ea2cc440a857$var$_range = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("hxxuu")));

var $8225ea2cc440a857$var$_rank = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("2Koeh")));

var $8225ea2cc440a857$var$_least = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("8ITro")));

var $8225ea2cc440a857$var$_leastIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("akUwn")));

var $8225ea2cc440a857$var$_greatest = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("ldDLn")));

var $8225ea2cc440a857$var$_greatestIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6g8Yn")));

var $8225ea2cc440a857$var$_scan = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("lfHoP")));

var $8225ea2cc440a857$var$_shuffle = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("jL9vH")));

var $8225ea2cc440a857$var$_sum = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("2zFIX")));

var $8225ea2cc440a857$var$_ticks = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("5nk0u")));

var $8225ea2cc440a857$var$_transpose = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("lcJcg")));

var $8225ea2cc440a857$var$_variance = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("eUraa")));

var $8225ea2cc440a857$var$_zip = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6s8G0")));

var $8225ea2cc440a857$var$_every = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("4tbza")));

var $8225ea2cc440a857$var$_some = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("1clrJ")));

var $8225ea2cc440a857$var$_filter = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("hR10Z")));

var $8225ea2cc440a857$var$_map = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("akUza")));

var $8225ea2cc440a857$var$_reduce = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("h6YjS")));

var $8225ea2cc440a857$var$_reverse = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("397w5")));

var $8225ea2cc440a857$var$_sort = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("c5SM0")));

var $8225ea2cc440a857$var$_difference = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("e1d1i")));

var $8225ea2cc440a857$var$_disjoint = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("fu4hi")));

var $8225ea2cc440a857$var$_intersection = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("YVzQY")));

var $8225ea2cc440a857$var$_subset = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("fg75q")));

var $8225ea2cc440a857$var$_superset = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("8D0Hg")));

var $8225ea2cc440a857$var$_union = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("aIUy7")));

var $7sRhp = parcelRequire("7sRhp");
function $8225ea2cc440a857$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8225ea2cc440a857$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8225ea2cc440a857$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8225ea2cc440a857$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8225ea2cc440a857$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("eiUsc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $a69e89b1b00926f6$var$_ascending = $a69e89b1b00926f6$var$_interopRequireDefault((parcelRequire("42JXN")));

var $a69e89b1b00926f6$var$_bisector = $a69e89b1b00926f6$var$_interopRequireDefault((parcelRequire("7C7yR")));

var $a69e89b1b00926f6$var$_number = $a69e89b1b00926f6$var$_interopRequireDefault((parcelRequire("gcfbT")));
function $a69e89b1b00926f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a69e89b1b00926f6$var$ascendingBisect = (0, $a69e89b1b00926f6$var$_bisector.default)($a69e89b1b00926f6$var$_ascending.default);
const $a69e89b1b00926f6$var$bisectRight = $a69e89b1b00926f6$var$ascendingBisect.right;
module.exports.bisectRight = $a69e89b1b00926f6$var$bisectRight;
const $a69e89b1b00926f6$var$bisectLeft = $a69e89b1b00926f6$var$ascendingBisect.left;
module.exports.bisectLeft = $a69e89b1b00926f6$var$bisectLeft;
const $a69e89b1b00926f6$var$bisectCenter = (0, $a69e89b1b00926f6$var$_bisector.default)($a69e89b1b00926f6$var$_number.default).center;
module.exports.bisectCenter = $a69e89b1b00926f6$var$bisectCenter;
var $a69e89b1b00926f6$var$_default = $a69e89b1b00926f6$var$bisectRight;
module.exports.default = $a69e89b1b00926f6$var$_default;

});
parcelRegister("42JXN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2f1b00b724dfee65$var$ascending;
function $2f1b00b724dfee65$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("7C7yR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58b1f287db5949a5$var$bisector;

var $58b1f287db5949a5$var$_ascending = $58b1f287db5949a5$var$_interopRequireDefault((parcelRequire("42JXN")));

var $58b1f287db5949a5$var$_descending = $58b1f287db5949a5$var$_interopRequireDefault((parcelRequire("j54An")));
function $58b1f287db5949a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $58b1f287db5949a5$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $58b1f287db5949a5$var$_ascending.default;
        compare2 = (d, x)=>(0, $58b1f287db5949a5$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $58b1f287db5949a5$var$_ascending.default || f === $58b1f287db5949a5$var$_descending.default ? f : $58b1f287db5949a5$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $58b1f287db5949a5$var$zero() {
    return 0;
}

});
parcelRegister("j54An", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de420a943e5c0a77$var$descending;
function $de420a943e5c0a77$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("gcfbT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bca98cef4eb74909$var$number;
module.exports.numbers = $bca98cef4eb74909$var$numbers;
function $bca98cef4eb74909$var$number(x) {
    return x === null ? NaN : +x;
}
function* $bca98cef4eb74909$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("ajdJT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7816560ab8fc6739$var$count;
function $7816560ab8fc6739$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("67S8D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $475d643bc06ac38a$var$cross;
function $475d643bc06ac38a$var$length(array) {
    return array.length | 0;
}
function $475d643bc06ac38a$var$empty(length) {
    return !(length > 0);
}
function $475d643bc06ac38a$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $475d643bc06ac38a$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $475d643bc06ac38a$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $475d643bc06ac38a$var$reducer(values.pop());
    values = values.map($475d643bc06ac38a$var$arrayify);
    const lengths = values.map($475d643bc06ac38a$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($475d643bc06ac38a$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("hG40Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cde979221a8d2882$var$cumsum;
function $cde979221a8d2882$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("7tsUa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5711a9c3c8056430$var$deviation;

var $5711a9c3c8056430$var$_variance = $5711a9c3c8056430$var$_interopRequireDefault((parcelRequire("eUraa")));
function $5711a9c3c8056430$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5711a9c3c8056430$var$deviation(values, valueof) {
    const v = (0, $5711a9c3c8056430$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("eUraa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adab5da989fb8953$var$variance;
function $adab5da989fb8953$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("lRRFR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $feb82ec2fd27e17d$var$extent;
function $feb82ec2fd27e17d$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("aRMXC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $7e94d527ee12243e$var$fcumsum;
module.exports.fsum = $7e94d527ee12243e$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $7e94d527ee12243e$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $7e94d527ee12243e$var$Adder;
function $7e94d527ee12243e$var$fsum(values, valueof) {
    const adder = new $7e94d527ee12243e$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $7e94d527ee12243e$var$fcumsum(values, valueof) {
    const adder = new $7e94d527ee12243e$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("c1jhN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c0489d5df4dc49a$var$group;
module.exports.flatGroup = $8c0489d5df4dc49a$var$flatGroup;
module.exports.flatRollup = $8c0489d5df4dc49a$var$flatRollup;
module.exports.groups = $8c0489d5df4dc49a$var$groups;
module.exports.index = $8c0489d5df4dc49a$var$index;
module.exports.indexes = $8c0489d5df4dc49a$var$indexes;
module.exports.rollup = $8c0489d5df4dc49a$var$rollup;
module.exports.rollups = $8c0489d5df4dc49a$var$rollups;

var $7sRhp = parcelRequire("7sRhp");

var $8c0489d5df4dc49a$var$_identity = $8c0489d5df4dc49a$var$_interopRequireDefault((parcelRequire("8zLyq")));
function $8c0489d5df4dc49a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c0489d5df4dc49a$var$group(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, $8c0489d5df4dc49a$var$_identity.default, $8c0489d5df4dc49a$var$_identity.default, keys);
}
function $8c0489d5df4dc49a$var$groups(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, Array.from, $8c0489d5df4dc49a$var$_identity.default, keys);
}
function $8c0489d5df4dc49a$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $8c0489d5df4dc49a$var$flatGroup(values, ...keys) {
    return $8c0489d5df4dc49a$var$flatten($8c0489d5df4dc49a$var$groups(values, ...keys), keys);
}
function $8c0489d5df4dc49a$var$flatRollup(values, reduce, ...keys) {
    return $8c0489d5df4dc49a$var$flatten($8c0489d5df4dc49a$var$rollups(values, reduce, ...keys), keys);
}
function $8c0489d5df4dc49a$var$rollup(values, reduce, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, $8c0489d5df4dc49a$var$_identity.default, reduce, keys);
}
function $8c0489d5df4dc49a$var$rollups(values, reduce, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, Array.from, reduce, keys);
}
function $8c0489d5df4dc49a$var$index(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, $8c0489d5df4dc49a$var$_identity.default, $8c0489d5df4dc49a$var$unique, keys);
}
function $8c0489d5df4dc49a$var$indexes(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, Array.from, $8c0489d5df4dc49a$var$unique, keys);
}
function $8c0489d5df4dc49a$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $8c0489d5df4dc49a$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $7sRhp.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("7sRhp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $56f47a2ee37085db$var$InternMap extends Map {
    constructor(entries, key = $56f47a2ee37085db$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($56f47a2ee37085db$var$intern_get(this, key));
    }
    has(key) {
        return super.has($56f47a2ee37085db$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($56f47a2ee37085db$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($56f47a2ee37085db$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $56f47a2ee37085db$var$InternMap;
class $56f47a2ee37085db$var$InternSet extends Set {
    constructor(values, key = $56f47a2ee37085db$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($56f47a2ee37085db$var$intern_get(this, value));
    }
    add(value) {
        return super.add($56f47a2ee37085db$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($56f47a2ee37085db$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $56f47a2ee37085db$var$InternSet;
function $56f47a2ee37085db$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $56f47a2ee37085db$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $56f47a2ee37085db$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $56f47a2ee37085db$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("8zLyq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63e67ae60b71c777$var$identity;
function $63e67ae60b71c777$var$identity(x) {
    return x;
}

});


parcelRegister("g9Xbd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc3b647cce9788a6$var$groupSort;

var $bc3b647cce9788a6$var$_ascending = $bc3b647cce9788a6$var$_interopRequireDefault((parcelRequire("42JXN")));

var $bc3b647cce9788a6$var$_group = $bc3b647cce9788a6$var$_interopRequireWildcard((parcelRequire("c1jhN")));

var $bc3b647cce9788a6$var$_sort = $bc3b647cce9788a6$var$_interopRequireDefault((parcelRequire("c5SM0")));
function $bc3b647cce9788a6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bc3b647cce9788a6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bc3b647cce9788a6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bc3b647cce9788a6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bc3b647cce9788a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bc3b647cce9788a6$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $bc3b647cce9788a6$var$_sort.default)((0, $bc3b647cce9788a6$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $bc3b647cce9788a6$var$_ascending.default)(av, bv) || (0, $bc3b647cce9788a6$var$_ascending.default)(ak, bk)) : (0, $bc3b647cce9788a6$var$_sort.default)((0, $bc3b647cce9788a6$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $bc3b647cce9788a6$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("c5SM0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $8ce0707f2a6c02b5$var$ascendingDefined;
module.exports.compareDefined = $8ce0707f2a6c02b5$var$compareDefined;
module.exports.default = $8ce0707f2a6c02b5$var$sort;

var $8ce0707f2a6c02b5$var$_ascending = $8ce0707f2a6c02b5$var$_interopRequireDefault((parcelRequire("42JXN")));

var $8ce0707f2a6c02b5$var$_permute = $8ce0707f2a6c02b5$var$_interopRequireDefault((parcelRequire("39H9X")));
function $8ce0707f2a6c02b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8ce0707f2a6c02b5$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $8ce0707f2a6c02b5$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$8ce0707f2a6c02b5$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $8ce0707f2a6c02b5$var$_permute.default)(values, index);
    }
    return values.sort($8ce0707f2a6c02b5$var$compareDefined(f));
}
function $8ce0707f2a6c02b5$var$compareDefined(compare = $8ce0707f2a6c02b5$var$_ascending.default) {
    if (compare === $8ce0707f2a6c02b5$var$_ascending.default) return $8ce0707f2a6c02b5$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $8ce0707f2a6c02b5$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("39H9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24c3b0f3203412d9$var$permute;
function $24c3b0f3203412d9$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("cLuus", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94b18691700bad11$var$bin;

var $8fPjY = parcelRequire("8fPjY");

var $94b18691700bad11$var$_bisect = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("eiUsc")));

var $94b18691700bad11$var$_constant = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("lWOD3")));

var $94b18691700bad11$var$_extent = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("lRRFR")));

var $94b18691700bad11$var$_identity = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("8zLyq")));

var $94b18691700bad11$var$_nice = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("7mFci")));

var $94b18691700bad11$var$_ticks = $94b18691700bad11$var$_interopRequireWildcard((parcelRequire("5nk0u")));

var $94b18691700bad11$var$_sturges = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("i7tuN")));
function $94b18691700bad11$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($94b18691700bad11$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $94b18691700bad11$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $94b18691700bad11$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $94b18691700bad11$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $94b18691700bad11$var$bin() {
    var value = $94b18691700bad11$var$_identity.default, domain = $94b18691700bad11$var$_extent.default, threshold = $94b18691700bad11$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $94b18691700bad11$var$_extent.default) [x0, x1] = (0, $94b18691700bad11$var$_nice.default)(x0, x1, tn);
            tz = (0, $94b18691700bad11$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $94b18691700bad11$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $94b18691700bad11$var$_extent.default) {
                    const step = (0, $94b18691700bad11$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $94b18691700bad11$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $94b18691700bad11$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $94b18691700bad11$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $94b18691700bad11$var$_constant.default)($8fPjY.slice.call(_)) : (0, $94b18691700bad11$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("8fPjY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $602788bdac406ac0$var$array = Array.prototype;
var $602788bdac406ac0$var$slice = $602788bdac406ac0$var$array.slice;
module.exports.slice = $602788bdac406ac0$var$slice;
var $602788bdac406ac0$var$map = $602788bdac406ac0$var$array.map;
module.exports.map = $602788bdac406ac0$var$map;

});

parcelRegister("lWOD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffa649a02a5bb3a3$var$constant;
function $ffa649a02a5bb3a3$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("7mFci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $55ca8b6e985ae2f5$var$nice;

var $5nk0u = parcelRequire("5nk0u");
function $55ca8b6e985ae2f5$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $5nk0u.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("5nk0u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e9e9eb054d2a742$var$ticks;
module.exports.tickIncrement = $3e9e9eb054d2a742$var$tickIncrement;
module.exports.tickStep = $3e9e9eb054d2a742$var$tickStep;
var $3e9e9eb054d2a742$var$e10 = Math.sqrt(50), $3e9e9eb054d2a742$var$e5 = Math.sqrt(10), $3e9e9eb054d2a742$var$e2 = Math.sqrt(2);
function $3e9e9eb054d2a742$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $3e9e9eb054d2a742$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $3e9e9eb054d2a742$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $3e9e9eb054d2a742$var$e10 ? 10 : error >= $3e9e9eb054d2a742$var$e5 ? 5 : error >= $3e9e9eb054d2a742$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $3e9e9eb054d2a742$var$e10 ? 10 : error >= $3e9e9eb054d2a742$var$e5 ? 5 : error >= $3e9e9eb054d2a742$var$e2 ? 2 : 1);
}
function $3e9e9eb054d2a742$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $3e9e9eb054d2a742$var$e10) step1 *= 10;
    else if (error >= $3e9e9eb054d2a742$var$e5) step1 *= 5;
    else if (error >= $3e9e9eb054d2a742$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("i7tuN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d30fc2ac2a08428f$var$thresholdSturges;

var $d30fc2ac2a08428f$var$_count = $d30fc2ac2a08428f$var$_interopRequireDefault((parcelRequire("ajdJT")));
function $d30fc2ac2a08428f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d30fc2ac2a08428f$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $d30fc2ac2a08428f$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("d1BC7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97b88ba8a5b45d42$var$thresholdFreedmanDiaconis;

var $97b88ba8a5b45d42$var$_count = $97b88ba8a5b45d42$var$_interopRequireDefault((parcelRequire("ajdJT")));

var $97b88ba8a5b45d42$var$_quantile = $97b88ba8a5b45d42$var$_interopRequireDefault((parcelRequire("26KnF")));
function $97b88ba8a5b45d42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $97b88ba8a5b45d42$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $97b88ba8a5b45d42$var$_quantile.default)(values, 0.75) - (0, $97b88ba8a5b45d42$var$_quantile.default)(values, 0.25)) * Math.pow((0, $97b88ba8a5b45d42$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("26KnF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $18901e8b3a4fd0ff$var$quantile;
module.exports.quantileSorted = $18901e8b3a4fd0ff$var$quantileSorted;

var $18901e8b3a4fd0ff$var$_max = $18901e8b3a4fd0ff$var$_interopRequireDefault((parcelRequire("kHUkZ")));

var $18901e8b3a4fd0ff$var$_min = $18901e8b3a4fd0ff$var$_interopRequireDefault((parcelRequire("5raSG")));

var $18901e8b3a4fd0ff$var$_quickselect = $18901e8b3a4fd0ff$var$_interopRequireDefault((parcelRequire("3EDNm")));

var $18901e8b3a4fd0ff$var$_number = $18901e8b3a4fd0ff$var$_interopRequireWildcard((parcelRequire("gcfbT")));
function $18901e8b3a4fd0ff$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($18901e8b3a4fd0ff$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $18901e8b3a4fd0ff$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $18901e8b3a4fd0ff$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $18901e8b3a4fd0ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $18901e8b3a4fd0ff$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $18901e8b3a4fd0ff$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $18901e8b3a4fd0ff$var$_min.default)(values);
    if (p >= 1) return (0, $18901e8b3a4fd0ff$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $18901e8b3a4fd0ff$var$_max.default)((0, $18901e8b3a4fd0ff$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $18901e8b3a4fd0ff$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $18901e8b3a4fd0ff$var$quantileSorted(values, p, valueof = $18901e8b3a4fd0ff$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("kHUkZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1338644b4c67516$var$max;
function $f1338644b4c67516$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("5raSG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f57ea15fd4fa697$var$min;
function $3f57ea15fd4fa697$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("3EDNm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a93f9ffa4634b87$var$quickselect;

var $c5SM0 = parcelRequire("c5SM0");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $2a93f9ffa4634b87$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $c5SM0.ascendingDefined : (0, $c5SM0.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $2a93f9ffa4634b87$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $2a93f9ffa4634b87$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $2a93f9ffa4634b87$var$swap(array, left, right);
        while(i < j){
            $2a93f9ffa4634b87$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $2a93f9ffa4634b87$var$swap(array, left, j);
        else ++j, $2a93f9ffa4634b87$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $2a93f9ffa4634b87$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("6i8dH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $494acccde647e16c$var$thresholdScott;

var $494acccde647e16c$var$_count = $494acccde647e16c$var$_interopRequireDefault((parcelRequire("ajdJT")));

var $494acccde647e16c$var$_deviation = $494acccde647e16c$var$_interopRequireDefault((parcelRequire("7tsUa")));
function $494acccde647e16c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $494acccde647e16c$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $494acccde647e16c$var$_count.default)(values)) / (3.49 * (0, $494acccde647e16c$var$_deviation.default)(values)));
}

});

parcelRegister("draOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c862eb3e14f7f21$var$maxIndex;
function $9c862eb3e14f7f21$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("6DBgh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d5349f5a83ddf13$var$mean;
function $4d5349f5a83ddf13$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("4HwgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36c435e6cfd0c994$var$median;

var $36c435e6cfd0c994$var$_quantile = $36c435e6cfd0c994$var$_interopRequireDefault((parcelRequire("26KnF")));
function $36c435e6cfd0c994$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $36c435e6cfd0c994$var$median(values, valueof) {
    return (0, $36c435e6cfd0c994$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("gnNvC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bed532caf95c2cc1$var$merge;
function* $bed532caf95c2cc1$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $bed532caf95c2cc1$var$merge(arrays) {
    return Array.from($bed532caf95c2cc1$var$flatten(arrays));
}

});

parcelRegister("5nboE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e97f0d92d44cfb5$var$minIndex;
function $3e97f0d92d44cfb5$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("asMhi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79e1f7e990dab177$var$mode;

var $7sRhp = parcelRequire("7sRhp");
function $79e1f7e990dab177$var$mode(values, valueof) {
    const counts = new $7sRhp.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("ir717", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d6c03112fa117caf$var$pairs;
module.exports.pair = $d6c03112fa117caf$var$pair;
function $d6c03112fa117caf$var$pairs(values, pairof = $d6c03112fa117caf$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $d6c03112fa117caf$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("hxxuu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc4f7f4c7cafdf17$var$range;
function $cc4f7f4c7cafdf17$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("2Koeh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2002ac11cfb6d638$var$rank;

var $2002ac11cfb6d638$var$_ascending = $2002ac11cfb6d638$var$_interopRequireDefault((parcelRequire("42JXN")));

var $c5SM0 = parcelRequire("c5SM0");
function $2002ac11cfb6d638$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2002ac11cfb6d638$var$rank(values, valueof = $2002ac11cfb6d638$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $2002ac11cfb6d638$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $2002ac11cfb6d638$var$_ascending.default ? (i, j)=>(0, $c5SM0.ascendingDefined)(V[i], V[j]) : (0, $c5SM0.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("8ITro", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $659d7030edb20224$var$least;

var $659d7030edb20224$var$_ascending = $659d7030edb20224$var$_interopRequireDefault((parcelRequire("42JXN")));
function $659d7030edb20224$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $659d7030edb20224$var$least(values, compare = $659d7030edb20224$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $659d7030edb20224$var$_ascending.default)(value, minValue) < 0 : (0, $659d7030edb20224$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("akUwn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $78679d96d8a8dfa8$var$leastIndex;

var $78679d96d8a8dfa8$var$_ascending = $78679d96d8a8dfa8$var$_interopRequireDefault((parcelRequire("42JXN")));

var $78679d96d8a8dfa8$var$_minIndex = $78679d96d8a8dfa8$var$_interopRequireDefault((parcelRequire("5nboE")));
function $78679d96d8a8dfa8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $78679d96d8a8dfa8$var$leastIndex(values, compare = $78679d96d8a8dfa8$var$_ascending.default) {
    if (compare.length === 1) return (0, $78679d96d8a8dfa8$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("ldDLn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f729a7fb558b06cf$var$greatest;

var $f729a7fb558b06cf$var$_ascending = $f729a7fb558b06cf$var$_interopRequireDefault((parcelRequire("42JXN")));
function $f729a7fb558b06cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f729a7fb558b06cf$var$greatest(values, compare = $f729a7fb558b06cf$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $f729a7fb558b06cf$var$_ascending.default)(value, maxValue) > 0 : (0, $f729a7fb558b06cf$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("6g8Yn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48eb32837203911a$var$greatestIndex;

var $48eb32837203911a$var$_ascending = $48eb32837203911a$var$_interopRequireDefault((parcelRequire("42JXN")));

var $48eb32837203911a$var$_maxIndex = $48eb32837203911a$var$_interopRequireDefault((parcelRequire("draOj")));
function $48eb32837203911a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $48eb32837203911a$var$greatestIndex(values, compare = $48eb32837203911a$var$_ascending.default) {
    if (compare.length === 1) return (0, $48eb32837203911a$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("lfHoP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f78ca9ea19eaeee4$var$scan;

var $f78ca9ea19eaeee4$var$_leastIndex = $f78ca9ea19eaeee4$var$_interopRequireDefault((parcelRequire("akUwn")));
function $f78ca9ea19eaeee4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f78ca9ea19eaeee4$var$scan(values, compare) {
    const index = (0, $f78ca9ea19eaeee4$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("jL9vH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $e629c8a42e8bf302$var$shuffler;
var $e629c8a42e8bf302$var$_default = $e629c8a42e8bf302$var$shuffler(Math.random);
module.exports.default = $e629c8a42e8bf302$var$_default;
function $e629c8a42e8bf302$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("2zFIX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1dff3733b9c4bd4d$var$sum;
function $1dff3733b9c4bd4d$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("lcJcg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6fdc71f51d85f9f$var$transpose;

var $f6fdc71f51d85f9f$var$_min = $f6fdc71f51d85f9f$var$_interopRequireDefault((parcelRequire("5raSG")));
function $f6fdc71f51d85f9f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f6fdc71f51d85f9f$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $f6fdc71f51d85f9f$var$_min.default)(matrix, $f6fdc71f51d85f9f$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $f6fdc71f51d85f9f$var$length(d) {
    return d.length;
}

});

parcelRegister("6s8G0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b2c16983adf6c04$var$zip;

var $4b2c16983adf6c04$var$_transpose = $4b2c16983adf6c04$var$_interopRequireDefault((parcelRequire("lcJcg")));
function $4b2c16983adf6c04$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4b2c16983adf6c04$var$zip() {
    return (0, $4b2c16983adf6c04$var$_transpose.default)(arguments);
}

});

parcelRegister("4tbza", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3412d7ab2a2d2c83$var$every;
function $3412d7ab2a2d2c83$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("1clrJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0df78c3c85287a4f$var$some;
function $0df78c3c85287a4f$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("hR10Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cff82c72a5b8b509$var$filter;
function $cff82c72a5b8b509$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("akUza", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7867a68277e09c2f$var$map;
function $7867a68277e09c2f$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("h6YjS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c751c9725add00ba$var$reduce;
function $c751c9725add00ba$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("397w5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24a80b0230cdfb4b$var$reverse;
function $24a80b0230cdfb4b$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("e1d1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a34b4226c9d69ac9$var$difference;

var $7sRhp = parcelRequire("7sRhp");
function $a34b4226c9d69ac9$var$difference(values, ...others) {
    values = new $7sRhp.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("fu4hi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b45cf9dd28454a0d$var$disjoint;

var $7sRhp = parcelRequire("7sRhp");
function $b45cf9dd28454a0d$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $7sRhp.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("YVzQY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b72445c1f450e7c$var$intersection;

var $7sRhp = parcelRequire("7sRhp");
function $0b72445c1f450e7c$var$intersection(values, ...others) {
    values = new $7sRhp.InternSet(values);
    others = others.map($0b72445c1f450e7c$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $0b72445c1f450e7c$var$set(values) {
    return values instanceof $7sRhp.InternSet ? values : new $7sRhp.InternSet(values);
}

});

parcelRegister("fg75q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1bdd8db4dd52b60$var$subset;

var $b1bdd8db4dd52b60$var$_superset = $b1bdd8db4dd52b60$var$_interopRequireDefault((parcelRequire("8D0Hg")));
function $b1bdd8db4dd52b60$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b1bdd8db4dd52b60$var$subset(values, other) {
    return (0, $b1bdd8db4dd52b60$var$_superset.default)(other, values);
}

});
parcelRegister("8D0Hg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6482819a31cea494$var$superset;
function $6482819a31cea494$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $6482819a31cea494$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $6482819a31cea494$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $6482819a31cea494$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("aIUy7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ce9e0f4038492e4$var$union;

var $7sRhp = parcelRequire("7sRhp");
function $7ce9e0f4038492e4$var$union(...others) {
    const set = new $7sRhp.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("98nei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $6a66e152678b40cc$var$initInterpolator;
module.exports.initRange = $6a66e152678b40cc$var$initRange;
function $6a66e152678b40cc$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $6a66e152678b40cc$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("cndqj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90220b9f6d3aba30$var$ordinal;
module.exports.implicit = void 0;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");
const $90220b9f6d3aba30$var$implicit = Symbol("implicit");
module.exports.implicit = $90220b9f6d3aba30$var$implicit;
function $90220b9f6d3aba30$var$ordinal() {
    var index = new $baM4h.InternMap(), domain = [], range = [], unknown = $90220b9f6d3aba30$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $90220b9f6d3aba30$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $baM4h.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $90220b9f6d3aba30$var$ordinal(domain, range).unknown(unknown);
    };
    $98nei.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("5Hf98", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $425cb7a96912c4d8$var$identity;

var $hvSDx = parcelRequire("hvSDx");

var $425cb7a96912c4d8$var$_number = $425cb7a96912c4d8$var$_interopRequireDefault((parcelRequire("jerFr")));
function $425cb7a96912c4d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $425cb7a96912c4d8$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $425cb7a96912c4d8$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $425cb7a96912c4d8$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $425cb7a96912c4d8$var$_number.default) : [
        0,
        1
    ];
    return (0, $hvSDx.linearish)(scale);
}

});
parcelRegister("hvSDx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cbffb6a56efcbb3c$var$linear;
module.exports.linearish = $cbffb6a56efcbb3c$var$linearish;

var $baM4h = parcelRequire("baM4h");

var $cbffb6a56efcbb3c$var$_continuous = $cbffb6a56efcbb3c$var$_interopRequireWildcard((parcelRequire("dTLbh")));

var $98nei = parcelRequire("98nei");

var $cbffb6a56efcbb3c$var$_tickFormat = $cbffb6a56efcbb3c$var$_interopRequireDefault((parcelRequire("3ZXxn")));
function $cbffb6a56efcbb3c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cbffb6a56efcbb3c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cbffb6a56efcbb3c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cbffb6a56efcbb3c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cbffb6a56efcbb3c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cbffb6a56efcbb3c$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $baM4h.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $cbffb6a56efcbb3c$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $baM4h.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $cbffb6a56efcbb3c$var$linear() {
    var scale = (0, $cbffb6a56efcbb3c$var$_continuous.default)();
    scale.copy = function() {
        return (0, $cbffb6a56efcbb3c$var$_continuous.copy)(scale, $cbffb6a56efcbb3c$var$linear());
    };
    $98nei.initRange.apply(scale, arguments);
    return $cbffb6a56efcbb3c$var$linearish(scale);
}

});
parcelRegister("dTLbh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $a1e5028e49e95242$var$copy;
module.exports.default = $a1e5028e49e95242$var$continuous;
module.exports.identity = $a1e5028e49e95242$var$identity;
module.exports.transformer = $a1e5028e49e95242$var$transformer;

var $baM4h = parcelRequire("baM4h");

var $665th = parcelRequire("665th");

var $a1e5028e49e95242$var$_constant = $a1e5028e49e95242$var$_interopRequireDefault((parcelRequire("jgTuH")));

var $a1e5028e49e95242$var$_number = $a1e5028e49e95242$var$_interopRequireDefault((parcelRequire("jerFr")));
function $a1e5028e49e95242$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a1e5028e49e95242$var$unit = [
    0,
    1
];
function $a1e5028e49e95242$var$identity(x) {
    return x;
}
function $a1e5028e49e95242$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $a1e5028e49e95242$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $a1e5028e49e95242$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $a1e5028e49e95242$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $a1e5028e49e95242$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $a1e5028e49e95242$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $a1e5028e49e95242$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $a1e5028e49e95242$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $baM4h.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $a1e5028e49e95242$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $a1e5028e49e95242$var$transformer() {
    var domain = $a1e5028e49e95242$var$unit, range = $a1e5028e49e95242$var$unit, interpolate = $665th.interpolate, transform, untransform, unknown, clamp = $a1e5028e49e95242$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $a1e5028e49e95242$var$identity) clamp = $a1e5028e49e95242$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $a1e5028e49e95242$var$polymap : $a1e5028e49e95242$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $665th.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $a1e5028e49e95242$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $665th.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $a1e5028e49e95242$var$identity, rescale()) : clamp !== $a1e5028e49e95242$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $a1e5028e49e95242$var$continuous() {
    return $a1e5028e49e95242$var$transformer()($a1e5028e49e95242$var$identity, $a1e5028e49e95242$var$identity);
}

});
parcelRegister("665th", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $O407u.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $O407u.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_quantize.default;
    }
});

var $47078c155d673c7c$var$_value = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("k8gaa")));

var $47078c155d673c7c$var$_array = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("c2a7V")));

var $47078c155d673c7c$var$_basis = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("hurAB")));

var $47078c155d673c7c$var$_basisClosed = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("7JEhq")));

var $47078c155d673c7c$var$_date = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("ck059")));

var $47078c155d673c7c$var$_discrete = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("9bEkd")));

var $47078c155d673c7c$var$_hue = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("gPZC5")));

var $47078c155d673c7c$var$_number = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("4TXx0")));

var $47078c155d673c7c$var$_numberArray = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("4Xtub")));

var $47078c155d673c7c$var$_object = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("eWQsD")));

var $47078c155d673c7c$var$_round = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("1qcvW")));

var $47078c155d673c7c$var$_string = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("aQhro")));

var $O407u = parcelRequire("O407u");

var $47078c155d673c7c$var$_zoom = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("4ymTx")));

var $47078c155d673c7c$var$_rgb = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("3CWNZ")));

var $47078c155d673c7c$var$_hsl = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("h8Xdb")));

var $47078c155d673c7c$var$_lab = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("6bPgS")));

var $47078c155d673c7c$var$_hcl = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("dWbd5")));

var $47078c155d673c7c$var$_cubehelix = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("1chdf")));

var $47078c155d673c7c$var$_piecewise = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("1d2kq")));

var $47078c155d673c7c$var$_quantize = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("7rbIB")));
function $47078c155d673c7c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($47078c155d673c7c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $47078c155d673c7c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $47078c155d673c7c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $47078c155d673c7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("k8gaa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea8117a067b5834a$var$_default;

var $4xVlj = parcelRequire("4xVlj");

var $ea8117a067b5834a$var$_rgb = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("3CWNZ")));

var $c2a7V = parcelRequire("c2a7V");

var $ea8117a067b5834a$var$_date = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("ck059")));

var $ea8117a067b5834a$var$_number = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("4TXx0")));

var $ea8117a067b5834a$var$_object = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("eWQsD")));

var $ea8117a067b5834a$var$_string = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("aQhro")));

var $ea8117a067b5834a$var$_constant = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("iRCSk")));

var $ea8117a067b5834a$var$_numberArray = $ea8117a067b5834a$var$_interopRequireWildcard((parcelRequire("4Xtub")));
function $ea8117a067b5834a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ea8117a067b5834a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ea8117a067b5834a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ea8117a067b5834a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ea8117a067b5834a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ea8117a067b5834a$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $ea8117a067b5834a$var$_constant.default)(b) : (t === "number" ? $ea8117a067b5834a$var$_number.default : t === "string" ? (c = (0, $4xVlj.color)(b)) ? (b = c, $ea8117a067b5834a$var$_rgb.default) : $ea8117a067b5834a$var$_string.default : b instanceof $4xVlj.color ? $ea8117a067b5834a$var$_rgb.default : b instanceof Date ? $ea8117a067b5834a$var$_date.default : (0, $ea8117a067b5834a$var$_numberArray.isNumberArray)(b) ? $ea8117a067b5834a$var$_numberArray.default : Array.isArray(b) ? $c2a7V.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $ea8117a067b5834a$var$_object.default : $ea8117a067b5834a$var$_number.default)(a, b);
}

});
parcelRegister("4xVlj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_color.rgb;
    }
});

var $34f6b991f3373171$var$_color = $34f6b991f3373171$var$_interopRequireWildcard((parcelRequire("hCN5L")));

var $34f6b991f3373171$var$_lab = $34f6b991f3373171$var$_interopRequireWildcard((parcelRequire("9xOfl")));

var $34f6b991f3373171$var$_cubehelix = $34f6b991f3373171$var$_interopRequireDefault((parcelRequire("45fUy")));
function $34f6b991f3373171$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34f6b991f3373171$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($34f6b991f3373171$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $34f6b991f3373171$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $34f6b991f3373171$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("hCN5L", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("4Ivzr")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("4Ivzr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36f3c2bb271333d6$var$_default;
module.exports.extend = $36f3c2bb271333d6$var$extend;
function $36f3c2bb271333d6$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $36f3c2bb271333d6$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("9xOfl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $6f2e2c04ae38a42e$var$Hcl;
module.exports.Lab = $6f2e2c04ae38a42e$var$Lab;
module.exports.default = $6f2e2c04ae38a42e$var$lab;
module.exports.gray = $6f2e2c04ae38a42e$var$gray;
module.exports.hcl = $6f2e2c04ae38a42e$var$hcl;
module.exports.lch = $6f2e2c04ae38a42e$var$lch;

var $6f2e2c04ae38a42e$var$_define = $6f2e2c04ae38a42e$var$_interopRequireWildcard((parcelRequire("4Ivzr")));

var $hCN5L = parcelRequire("hCN5L");

var $hPqOe = parcelRequire("hPqOe");
function $6f2e2c04ae38a42e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6f2e2c04ae38a42e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6f2e2c04ae38a42e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6f2e2c04ae38a42e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $6f2e2c04ae38a42e$var$K = 18, $6f2e2c04ae38a42e$var$Xn = 0.96422, $6f2e2c04ae38a42e$var$Yn = 1, $6f2e2c04ae38a42e$var$Zn = 0.82521, $6f2e2c04ae38a42e$var$t0 = 4 / 29, $6f2e2c04ae38a42e$var$t1 = 6 / 29, $6f2e2c04ae38a42e$var$t2 = 3 * $6f2e2c04ae38a42e$var$t1 * $6f2e2c04ae38a42e$var$t1, $6f2e2c04ae38a42e$var$t3 = $6f2e2c04ae38a42e$var$t1 * $6f2e2c04ae38a42e$var$t1 * $6f2e2c04ae38a42e$var$t1;
function $6f2e2c04ae38a42e$var$labConvert(o) {
    if (o instanceof $6f2e2c04ae38a42e$var$Lab) return new $6f2e2c04ae38a42e$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $6f2e2c04ae38a42e$var$Hcl) return $6f2e2c04ae38a42e$var$hcl2lab(o);
    if (!(o instanceof $hCN5L.Rgb)) o = (0, $hCN5L.rgbConvert)(o);
    var r = $6f2e2c04ae38a42e$var$rgb2lrgb(o.r), g = $6f2e2c04ae38a42e$var$rgb2lrgb(o.g), b = $6f2e2c04ae38a42e$var$rgb2lrgb(o.b), y = $6f2e2c04ae38a42e$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $6f2e2c04ae38a42e$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $6f2e2c04ae38a42e$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $6f2e2c04ae38a42e$var$Xn);
        z = $6f2e2c04ae38a42e$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $6f2e2c04ae38a42e$var$Zn);
    }
    return new $6f2e2c04ae38a42e$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $6f2e2c04ae38a42e$var$gray(l, opacity) {
    return new $6f2e2c04ae38a42e$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $6f2e2c04ae38a42e$var$labConvert(l) : new $6f2e2c04ae38a42e$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $6f2e2c04ae38a42e$var$_define.default)($6f2e2c04ae38a42e$var$Lab, $6f2e2c04ae38a42e$var$lab, (0, $6f2e2c04ae38a42e$var$_define.extend)($hCN5L.Color, {
    brighter (k) {
        return new $6f2e2c04ae38a42e$var$Lab(this.l + $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $6f2e2c04ae38a42e$var$Lab(this.l - $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $6f2e2c04ae38a42e$var$Xn * $6f2e2c04ae38a42e$var$lab2xyz(x);
        y = $6f2e2c04ae38a42e$var$Yn * $6f2e2c04ae38a42e$var$lab2xyz(y);
        z = $6f2e2c04ae38a42e$var$Zn * $6f2e2c04ae38a42e$var$lab2xyz(z);
        return new $hCN5L.Rgb($6f2e2c04ae38a42e$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $6f2e2c04ae38a42e$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $6f2e2c04ae38a42e$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $6f2e2c04ae38a42e$var$xyz2lab(t) {
    return t > $6f2e2c04ae38a42e$var$t3 ? Math.pow(t, 1 / 3) : t / $6f2e2c04ae38a42e$var$t2 + $6f2e2c04ae38a42e$var$t0;
}
function $6f2e2c04ae38a42e$var$lab2xyz(t) {
    return t > $6f2e2c04ae38a42e$var$t1 ? t * t * t : $6f2e2c04ae38a42e$var$t2 * (t - $6f2e2c04ae38a42e$var$t0);
}
function $6f2e2c04ae38a42e$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $6f2e2c04ae38a42e$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $6f2e2c04ae38a42e$var$hclConvert(o) {
    if (o instanceof $6f2e2c04ae38a42e$var$Hcl) return new $6f2e2c04ae38a42e$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $6f2e2c04ae38a42e$var$Lab)) o = $6f2e2c04ae38a42e$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $6f2e2c04ae38a42e$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $hPqOe.degrees;
    return new $6f2e2c04ae38a42e$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $6f2e2c04ae38a42e$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $6f2e2c04ae38a42e$var$hclConvert(l) : new $6f2e2c04ae38a42e$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $6f2e2c04ae38a42e$var$hclConvert(h) : new $6f2e2c04ae38a42e$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $6f2e2c04ae38a42e$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $6f2e2c04ae38a42e$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $hPqOe.radians;
    return new $6f2e2c04ae38a42e$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $6f2e2c04ae38a42e$var$_define.default)($6f2e2c04ae38a42e$var$Hcl, $6f2e2c04ae38a42e$var$hcl, (0, $6f2e2c04ae38a42e$var$_define.extend)($hCN5L.Color, {
    brighter (k) {
        return new $6f2e2c04ae38a42e$var$Hcl(this.h, this.c, this.l + $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $6f2e2c04ae38a42e$var$Hcl(this.h, this.c, this.l - $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $6f2e2c04ae38a42e$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("hPqOe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $cfabfed4d344b6c6$var$radians = Math.PI / 180;
module.exports.radians = $cfabfed4d344b6c6$var$radians;
const $cfabfed4d344b6c6$var$degrees = 180 / Math.PI;
module.exports.degrees = $cfabfed4d344b6c6$var$degrees;

});


parcelRegister("45fUy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $2f93f8ad649541d1$var$Cubehelix;
module.exports.default = $2f93f8ad649541d1$var$cubehelix;

var $2f93f8ad649541d1$var$_define = $2f93f8ad649541d1$var$_interopRequireWildcard((parcelRequire("4Ivzr")));

var $hCN5L = parcelRequire("hCN5L");

var $hPqOe = parcelRequire("hPqOe");
function $2f93f8ad649541d1$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2f93f8ad649541d1$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2f93f8ad649541d1$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2f93f8ad649541d1$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $2f93f8ad649541d1$var$A = -0.14861, $2f93f8ad649541d1$var$B = 1.78277, $2f93f8ad649541d1$var$C = -0.29227, $2f93f8ad649541d1$var$D = -0.90649, $2f93f8ad649541d1$var$E = 1.97294, $2f93f8ad649541d1$var$ED = $2f93f8ad649541d1$var$E * $2f93f8ad649541d1$var$D, $2f93f8ad649541d1$var$EB = $2f93f8ad649541d1$var$E * $2f93f8ad649541d1$var$B, $2f93f8ad649541d1$var$BC_DA = $2f93f8ad649541d1$var$B * $2f93f8ad649541d1$var$C - $2f93f8ad649541d1$var$D * $2f93f8ad649541d1$var$A;
function $2f93f8ad649541d1$var$cubehelixConvert(o) {
    if (o instanceof $2f93f8ad649541d1$var$Cubehelix) return new $2f93f8ad649541d1$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $hCN5L.Rgb)) o = (0, $hCN5L.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($2f93f8ad649541d1$var$BC_DA * b + $2f93f8ad649541d1$var$ED * r - $2f93f8ad649541d1$var$EB * g) / ($2f93f8ad649541d1$var$BC_DA + $2f93f8ad649541d1$var$ED - $2f93f8ad649541d1$var$EB), bl = b - l, k = ($2f93f8ad649541d1$var$E * (g - l) - $2f93f8ad649541d1$var$C * bl) / $2f93f8ad649541d1$var$D, s = Math.sqrt(k * k + bl * bl) / ($2f93f8ad649541d1$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $hPqOe.degrees - 120 : NaN;
    return new $2f93f8ad649541d1$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $2f93f8ad649541d1$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $2f93f8ad649541d1$var$cubehelixConvert(h) : new $2f93f8ad649541d1$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $2f93f8ad649541d1$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $2f93f8ad649541d1$var$_define.default)($2f93f8ad649541d1$var$Cubehelix, $2f93f8ad649541d1$var$cubehelix, (0, $2f93f8ad649541d1$var$_define.extend)($hCN5L.Color, {
    brighter (k) {
        k = k == null ? $hCN5L.brighter : Math.pow($hCN5L.brighter, k);
        return new $2f93f8ad649541d1$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $hCN5L.darker : Math.pow($hCN5L.darker, k);
        return new $2f93f8ad649541d1$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $hPqOe.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $hCN5L.Rgb(255 * (l + a * ($2f93f8ad649541d1$var$A * cosh + $2f93f8ad649541d1$var$B * sinh)), 255 * (l + a * ($2f93f8ad649541d1$var$C * cosh + $2f93f8ad649541d1$var$D * sinh)), 255 * (l + a * ($2f93f8ad649541d1$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("3CWNZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $2a428938b73abdd0$var$_basis = $2a428938b73abdd0$var$_interopRequireDefault((parcelRequire("hurAB")));

var $2a428938b73abdd0$var$_basisClosed = $2a428938b73abdd0$var$_interopRequireDefault((parcelRequire("7JEhq")));

var $2a428938b73abdd0$var$_color = $2a428938b73abdd0$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $2a428938b73abdd0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2a428938b73abdd0$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2a428938b73abdd0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2a428938b73abdd0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2a428938b73abdd0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2a428938b73abdd0$var$_default = function rgbGamma(y) {
    var color = (0, $2a428938b73abdd0$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $4xVlj.rgb)(start)).r, (end = (0, $4xVlj.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $2a428938b73abdd0$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $2a428938b73abdd0$var$_default;
function $2a428938b73abdd0$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $4xVlj.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $2a428938b73abdd0$var$rgbBasis = $2a428938b73abdd0$var$rgbSpline($2a428938b73abdd0$var$_basis.default);
module.exports.rgbBasis = $2a428938b73abdd0$var$rgbBasis;
var $2a428938b73abdd0$var$rgbBasisClosed = $2a428938b73abdd0$var$rgbSpline($2a428938b73abdd0$var$_basisClosed.default);
module.exports.rgbBasisClosed = $2a428938b73abdd0$var$rgbBasisClosed;

});
parcelRegister("hurAB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $cbbaa3aa677f5a3b$var$basis;
module.exports.default = $cbbaa3aa677f5a3b$var$_default;
function $cbbaa3aa677f5a3b$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $cbbaa3aa677f5a3b$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $cbbaa3aa677f5a3b$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("7JEhq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5a1bfb292f547c5a$var$_default;

var $hurAB = parcelRequire("hurAB");
function $5a1bfb292f547c5a$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $hurAB.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("b3Scd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $80da03bd38d34502$var$nogamma;
module.exports.gamma = $80da03bd38d34502$var$gamma;
module.exports.hue = $80da03bd38d34502$var$hue;

var $80da03bd38d34502$var$_constant = $80da03bd38d34502$var$_interopRequireDefault((parcelRequire("iRCSk")));
function $80da03bd38d34502$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $80da03bd38d34502$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $80da03bd38d34502$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $80da03bd38d34502$var$hue(a, b) {
    var d = b - a;
    return d ? $80da03bd38d34502$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $80da03bd38d34502$var$_constant.default)(isNaN(a) ? b : a);
}
function $80da03bd38d34502$var$gamma(y) {
    return (y = +y) === 1 ? $80da03bd38d34502$var$nogamma : function(a, b) {
        return b - a ? $80da03bd38d34502$var$exponential(a, b, y) : (0, $80da03bd38d34502$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $80da03bd38d34502$var$nogamma(a, b) {
    var d = b - a;
    return d ? $80da03bd38d34502$var$linear(a, d) : (0, $80da03bd38d34502$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("iRCSk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $dbbb550bf3b8cf75$var$_default = (x)=>()=>x;
module.exports.default = $dbbb550bf3b8cf75$var$_default;

});



parcelRegister("c2a7V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c2d86ed32487c0d$var$_default;
module.exports.genericArray = $8c2d86ed32487c0d$var$genericArray;

var $8c2d86ed32487c0d$var$_value = $8c2d86ed32487c0d$var$_interopRequireDefault((parcelRequire("k8gaa")));

var $8c2d86ed32487c0d$var$_numberArray = $8c2d86ed32487c0d$var$_interopRequireWildcard((parcelRequire("4Xtub")));
function $8c2d86ed32487c0d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8c2d86ed32487c0d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8c2d86ed32487c0d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8c2d86ed32487c0d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8c2d86ed32487c0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c2d86ed32487c0d$var$_default(a, b) {
    return ((0, $8c2d86ed32487c0d$var$_numberArray.isNumberArray)(b) ? $8c2d86ed32487c0d$var$_numberArray.default : $8c2d86ed32487c0d$var$genericArray)(a, b);
}
function $8c2d86ed32487c0d$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8c2d86ed32487c0d$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("4Xtub", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $39c38b6190d0c1f6$var$_default;
module.exports.isNumberArray = $39c38b6190d0c1f6$var$isNumberArray;
function $39c38b6190d0c1f6$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $39c38b6190d0c1f6$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("ck059", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f876a9bd8834a98$var$_default;
function $8f876a9bd8834a98$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("4TXx0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $391a7a2535dd71f8$var$_default;
function $391a7a2535dd71f8$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("eWQsD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae1f2d19cc5303ea$var$_default;

var $ae1f2d19cc5303ea$var$_value = $ae1f2d19cc5303ea$var$_interopRequireDefault((parcelRequire("k8gaa")));
function $ae1f2d19cc5303ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ae1f2d19cc5303ea$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $ae1f2d19cc5303ea$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("aQhro", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e4c4a1e1697197c$var$_default;

var $7e4c4a1e1697197c$var$_number = $7e4c4a1e1697197c$var$_interopRequireDefault((parcelRequire("4TXx0")));
function $7e4c4a1e1697197c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7e4c4a1e1697197c$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $7e4c4a1e1697197c$var$reB = new RegExp($7e4c4a1e1697197c$var$reA.source, "g");
function $7e4c4a1e1697197c$var$zero(b) {
    return function() {
        return b;
    };
}
function $7e4c4a1e1697197c$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $7e4c4a1e1697197c$var$_default(a, b) {
    var bi = $7e4c4a1e1697197c$var$reA.lastIndex = $7e4c4a1e1697197c$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $7e4c4a1e1697197c$var$reA.exec(a)) && (bm = $7e4c4a1e1697197c$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $7e4c4a1e1697197c$var$_number.default)(am, bm)
            });
        }
        bi = $7e4c4a1e1697197c$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $7e4c4a1e1697197c$var$one(q[0].x) : $7e4c4a1e1697197c$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("9bEkd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b046bd8ca223f2b$var$_default;
function $6b046bd8ca223f2b$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("gPZC5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c42133e20db58540$var$_default;

var $b3Scd = parcelRequire("b3Scd");
function $c42133e20db58540$var$_default(a, b) {
    var i = (0, $b3Scd.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("1qcvW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1091ed2fd6f93976$var$_default;
function $1091ed2fd6f93976$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("O407u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $0967c620c111940e$var$_number = $0967c620c111940e$var$_interopRequireDefault((parcelRequire("4TXx0")));

var $bJ37r = parcelRequire("bJ37r");
function $0967c620c111940e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0967c620c111940e$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $0967c620c111940e$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $0967c620c111940e$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $0967c620c111940e$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $0967c620c111940e$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $0967c620c111940e$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $0967c620c111940e$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $0967c620c111940e$var$interpolateTransformCss = $0967c620c111940e$var$interpolateTransform($bJ37r.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $0967c620c111940e$var$interpolateTransformCss;
var $0967c620c111940e$var$interpolateTransformSvg = $0967c620c111940e$var$interpolateTransform($bJ37r.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $0967c620c111940e$var$interpolateTransformSvg;

});
parcelRegister("bJ37r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $8896510fbfd72d82$var$parseCss;
module.exports.parseSvg = $8896510fbfd72d82$var$parseSvg;

var $8896510fbfd72d82$var$_decompose = $8896510fbfd72d82$var$_interopRequireWildcard((parcelRequire("5pgbl")));
function $8896510fbfd72d82$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8896510fbfd72d82$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8896510fbfd72d82$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8896510fbfd72d82$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $8896510fbfd72d82$var$svgNode;
/* eslint-disable no-undef */ function $8896510fbfd72d82$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $8896510fbfd72d82$var$_decompose.identity : (0, $8896510fbfd72d82$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $8896510fbfd72d82$var$parseSvg(value) {
    if (value == null) return $8896510fbfd72d82$var$_decompose.identity;
    if (!$8896510fbfd72d82$var$svgNode) $8896510fbfd72d82$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $8896510fbfd72d82$var$svgNode.setAttribute("transform", value);
    if (!(value = $8896510fbfd72d82$var$svgNode.transform.baseVal.consolidate())) return $8896510fbfd72d82$var$_decompose.identity;
    value = value.matrix;
    return (0, $8896510fbfd72d82$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("5pgbl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3efbd6f206ca181f$var$_default;
module.exports.identity = void 0;
var $3efbd6f206ca181f$var$degrees = 180 / Math.PI;
var $3efbd6f206ca181f$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $3efbd6f206ca181f$var$identity;
function $3efbd6f206ca181f$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $3efbd6f206ca181f$var$degrees,
        skewX: Math.atan(skewX) * $3efbd6f206ca181f$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("4ymTx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $350c18cead77b4c8$var$epsilon2 = 1e-12;
function $350c18cead77b4c8$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $350c18cead77b4c8$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $350c18cead77b4c8$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $350c18cead77b4c8$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $350c18cead77b4c8$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $350c18cead77b4c8$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $350c18cead77b4c8$var$tanh(rho * s + r0) - $350c18cead77b4c8$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $350c18cead77b4c8$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $350c18cead77b4c8$var$_default;

});

parcelRegister("h8Xdb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $c7b11d37ff7aa7ad$var$_color = $c7b11d37ff7aa7ad$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $c7b11d37ff7aa7ad$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c7b11d37ff7aa7ad$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c7b11d37ff7aa7ad$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c7b11d37ff7aa7ad$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c7b11d37ff7aa7ad$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $4xVlj.hsl)(start)).h, (end = (0, $4xVlj.hsl)(end)).h), s = (0, $c7b11d37ff7aa7ad$var$_color.default)(start.s, end.s), l = (0, $c7b11d37ff7aa7ad$var$_color.default)(start.l, end.l), opacity = (0, $c7b11d37ff7aa7ad$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $c7b11d37ff7aa7ad$var$_default = $c7b11d37ff7aa7ad$var$hsl($c7b11d37ff7aa7ad$var$_color.hue);
module.exports.default = $c7b11d37ff7aa7ad$var$_default;
var $c7b11d37ff7aa7ad$var$hslLong = $c7b11d37ff7aa7ad$var$hsl($c7b11d37ff7aa7ad$var$_color.default);
module.exports.hslLong = $c7b11d37ff7aa7ad$var$hslLong;

});

parcelRegister("6bPgS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $481b8a88abe10bce$var$lab;

var $4xVlj = parcelRequire("4xVlj");

var $481b8a88abe10bce$var$_color = $481b8a88abe10bce$var$_interopRequireDefault((parcelRequire("b3Scd")));
function $481b8a88abe10bce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $481b8a88abe10bce$var$lab(start, end) {
    var l = (0, $481b8a88abe10bce$var$_color.default)((start = (0, $4xVlj.lab)(start)).l, (end = (0, $4xVlj.lab)(end)).l), a = (0, $481b8a88abe10bce$var$_color.default)(start.a, end.a), b = (0, $481b8a88abe10bce$var$_color.default)(start.b, end.b), opacity = (0, $481b8a88abe10bce$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("dWbd5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $a259633f8ae92865$var$_color = $a259633f8ae92865$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $a259633f8ae92865$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a259633f8ae92865$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a259633f8ae92865$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a259633f8ae92865$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a259633f8ae92865$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $4xVlj.hcl)(start)).h, (end = (0, $4xVlj.hcl)(end)).h), c = (0, $a259633f8ae92865$var$_color.default)(start.c, end.c), l = (0, $a259633f8ae92865$var$_color.default)(start.l, end.l), opacity = (0, $a259633f8ae92865$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $a259633f8ae92865$var$_default = $a259633f8ae92865$var$hcl($a259633f8ae92865$var$_color.hue);
module.exports.default = $a259633f8ae92865$var$_default;
var $a259633f8ae92865$var$hclLong = $a259633f8ae92865$var$hcl($a259633f8ae92865$var$_color.default);
module.exports.hclLong = $a259633f8ae92865$var$hclLong;

});

parcelRegister("1chdf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $0df4438370b2da5e$var$_color = $0df4438370b2da5e$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $0df4438370b2da5e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0df4438370b2da5e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0df4438370b2da5e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0df4438370b2da5e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0df4438370b2da5e$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $4xVlj.cubehelix)(start)).h, (end = (0, $4xVlj.cubehelix)(end)).h), s = (0, $0df4438370b2da5e$var$_color.default)(start.s, end.s), l = (0, $0df4438370b2da5e$var$_color.default)(start.l, end.l), opacity = (0, $0df4438370b2da5e$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $0df4438370b2da5e$var$_default = $0df4438370b2da5e$var$cubehelix($0df4438370b2da5e$var$_color.hue);
module.exports.default = $0df4438370b2da5e$var$_default;
var $0df4438370b2da5e$var$cubehelixLong = $0df4438370b2da5e$var$cubehelix($0df4438370b2da5e$var$_color.default);
module.exports.cubehelixLong = $0df4438370b2da5e$var$cubehelixLong;

});

parcelRegister("1d2kq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e18cfb4c16c4104$var$piecewise;

var $0e18cfb4c16c4104$var$_value = $0e18cfb4c16c4104$var$_interopRequireDefault((parcelRequire("k8gaa")));
function $0e18cfb4c16c4104$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0e18cfb4c16c4104$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $0e18cfb4c16c4104$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("7rbIB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56a425076c517cf9$var$_default;
function $56a425076c517cf9$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("jgTuH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e07a8ef03a1474be$var$constants;
function $e07a8ef03a1474be$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("jerFr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e004c94f2a5276f3$var$number;
function $e004c94f2a5276f3$var$number(x) {
    return +x;
}

});


parcelRegister("3ZXxn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e954078d0c875a8$var$tickFormat;

var $baM4h = parcelRequire("baM4h");

var $itzmc = parcelRequire("itzmc");
function $2e954078d0c875a8$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $baM4h.tickStep)(start, stop, count), precision;
    specifier = (0, $itzmc.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $itzmc.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $itzmc.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $itzmc.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $itzmc.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $itzmc.format)(specifier);
}

});
parcelRegister("itzmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_precisionRound.default;
    }
});

var $d7365c9f4c120e49$var$_defaultLocale = $d7365c9f4c120e49$var$_interopRequireWildcard((parcelRequire("52crh")));

var $d7365c9f4c120e49$var$_locale = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("jdHNs")));

var $d7365c9f4c120e49$var$_formatSpecifier = $d7365c9f4c120e49$var$_interopRequireWildcard((parcelRequire("22nPw")));

var $d7365c9f4c120e49$var$_precisionFixed = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("lzwe8")));

var $d7365c9f4c120e49$var$_precisionPrefix = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("9ymIQ")));

var $d7365c9f4c120e49$var$_precisionRound = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("dK8tE")));
function $d7365c9f4c120e49$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d7365c9f4c120e49$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d7365c9f4c120e49$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d7365c9f4c120e49$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d7365c9f4c120e49$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("52crh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3aa6c9ca8743f64c$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $3aa6c9ca8743f64c$var$_locale = $3aa6c9ca8743f64c$var$_interopRequireDefault((parcelRequire("jdHNs")));
function $3aa6c9ca8743f64c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3aa6c9ca8743f64c$var$locale;
var $3aa6c9ca8743f64c$var$format;
module.exports.format = $3aa6c9ca8743f64c$var$format;
var $3aa6c9ca8743f64c$var$formatPrefix;
module.exports.formatPrefix = $3aa6c9ca8743f64c$var$formatPrefix;
$3aa6c9ca8743f64c$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $3aa6c9ca8743f64c$var$defaultLocale(definition) {
    $3aa6c9ca8743f64c$var$locale = (0, $3aa6c9ca8743f64c$var$_locale.default)(definition);
    module.exports.format = $3aa6c9ca8743f64c$var$format = $3aa6c9ca8743f64c$var$locale.format;
    module.exports.formatPrefix = $3aa6c9ca8743f64c$var$formatPrefix = $3aa6c9ca8743f64c$var$locale.formatPrefix;
    return $3aa6c9ca8743f64c$var$locale;
}

});
parcelRegister("jdHNs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dfe1345305b146cd$var$_default;

var $dfe1345305b146cd$var$_exponent = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("9WmdL")));

var $dfe1345305b146cd$var$_formatGroup = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("bR58D")));

var $dfe1345305b146cd$var$_formatNumerals = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("2gEYt")));

var $dfe1345305b146cd$var$_formatSpecifier = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("22nPw")));

var $dfe1345305b146cd$var$_formatTrim = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("sIRm4")));

var $dfe1345305b146cd$var$_formatTypes = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("9AK8c")));

var $csczD = parcelRequire("csczD");

var $dfe1345305b146cd$var$_identity = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("jJFZc")));
function $dfe1345305b146cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dfe1345305b146cd$var$map = Array.prototype.map, $dfe1345305b146cd$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $dfe1345305b146cd$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $dfe1345305b146cd$var$_identity.default : (0, $dfe1345305b146cd$var$_formatGroup.default)($dfe1345305b146cd$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $dfe1345305b146cd$var$_identity.default : (0, $dfe1345305b146cd$var$_formatNumerals.default)($dfe1345305b146cd$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $dfe1345305b146cd$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$dfe1345305b146cd$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $dfe1345305b146cd$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $dfe1345305b146cd$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $dfe1345305b146cd$var$prefixes[8 + $csczD.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $dfe1345305b146cd$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $dfe1345305b146cd$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $dfe1345305b146cd$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("9WmdL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $73cac4781972bb68$var$_default;

var $ek6ef = parcelRequire("ek6ef");
function $73cac4781972bb68$var$_default(x) {
    return x = (0, $ek6ef.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("ek6ef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6d7c3d6a68b9f55$var$_default;
module.exports.formatDecimalParts = $a6d7c3d6a68b9f55$var$formatDecimalParts;
function $a6d7c3d6a68b9f55$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $a6d7c3d6a68b9f55$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("bR58D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a18a14b4c6d5ad1$var$_default;
function $8a18a14b4c6d5ad1$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("2gEYt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a6cdc0d667ac473$var$_default;
function $1a6cdc0d667ac473$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("22nPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $17be40d45524154b$var$FormatSpecifier;
module.exports.default = $17be40d45524154b$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $17be40d45524154b$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $17be40d45524154b$var$formatSpecifier(specifier) {
    if (!(match = $17be40d45524154b$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $17be40d45524154b$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$17be40d45524154b$var$formatSpecifier.prototype = $17be40d45524154b$var$FormatSpecifier.prototype; // instanceof
function $17be40d45524154b$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$17be40d45524154b$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("sIRm4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $056569d07d5aff33$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $056569d07d5aff33$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("9AK8c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fbb428c1ef09695$var$_formatDecimal = $6fbb428c1ef09695$var$_interopRequireDefault((parcelRequire("ek6ef")));

var $6fbb428c1ef09695$var$_formatPrefixAuto = $6fbb428c1ef09695$var$_interopRequireDefault((parcelRequire("csczD")));

var $6fbb428c1ef09695$var$_formatRounded = $6fbb428c1ef09695$var$_interopRequireDefault((parcelRequire("lNpva")));
function $6fbb428c1ef09695$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6fbb428c1ef09695$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $6fbb428c1ef09695$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $6fbb428c1ef09695$var$_formatRounded.default)(x * 100, p),
    "r": $6fbb428c1ef09695$var$_formatRounded.default,
    "s": $6fbb428c1ef09695$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $6fbb428c1ef09695$var$_default;

});
parcelRegister("csczD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9111da6de56a44e7$var$_default;
module.exports.prefixExponent = void 0;

var $ek6ef = parcelRequire("ek6ef");
var $9111da6de56a44e7$var$prefixExponent;
module.exports.prefixExponent = $9111da6de56a44e7$var$prefixExponent;
function $9111da6de56a44e7$var$_default(x, p) {
    var d = (0, $ek6ef.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $9111da6de56a44e7$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $ek6ef.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("lNpva", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fde1f4b20b992562$var$_default;

var $ek6ef = parcelRequire("ek6ef");
function $fde1f4b20b992562$var$_default(x, p) {
    var d = (0, $ek6ef.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("jJFZc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e5e2c9e09981bca9$var$_default;
function $e5e2c9e09981bca9$var$_default(x) {
    return x;
}

});



parcelRegister("lzwe8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fb45dd7ad9d5b52f$var$_default;

var $fb45dd7ad9d5b52f$var$_exponent = $fb45dd7ad9d5b52f$var$_interopRequireDefault((parcelRequire("9WmdL")));
function $fb45dd7ad9d5b52f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fb45dd7ad9d5b52f$var$_default(step) {
    return Math.max(0, -(0, $fb45dd7ad9d5b52f$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("9ymIQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f48ea33e817f9e5$var$_default;

var $6f48ea33e817f9e5$var$_exponent = $6f48ea33e817f9e5$var$_interopRequireDefault((parcelRequire("9WmdL")));
function $6f48ea33e817f9e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f48ea33e817f9e5$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $6f48ea33e817f9e5$var$_exponent.default)(value) / 3))) * 3 - (0, $6f48ea33e817f9e5$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("dK8tE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a01625a8f580c632$var$_default;

var $a01625a8f580c632$var$_exponent = $a01625a8f580c632$var$_interopRequireDefault((parcelRequire("9WmdL")));
function $a01625a8f580c632$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a01625a8f580c632$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $a01625a8f580c632$var$_exponent.default)(max) - (0, $a01625a8f580c632$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("aEI3x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c1fd0730f0c3a86$var$log;
module.exports.loggish = $7c1fd0730f0c3a86$var$loggish;

var $baM4h = parcelRequire("baM4h");

var $itzmc = parcelRequire("itzmc");

var $7c1fd0730f0c3a86$var$_nice = $7c1fd0730f0c3a86$var$_interopRequireDefault((parcelRequire("3CPJt")));

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $7c1fd0730f0c3a86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c1fd0730f0c3a86$var$transformLog(x) {
    return Math.log(x);
}
function $7c1fd0730f0c3a86$var$transformExp(x) {
    return Math.exp(x);
}
function $7c1fd0730f0c3a86$var$transformLogn(x) {
    return -Math.log(-x);
}
function $7c1fd0730f0c3a86$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $7c1fd0730f0c3a86$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $7c1fd0730f0c3a86$var$powp(base) {
    return base === 10 ? $7c1fd0730f0c3a86$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $7c1fd0730f0c3a86$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $7c1fd0730f0c3a86$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $7c1fd0730f0c3a86$var$loggish(transform) {
    const scale = transform($7c1fd0730f0c3a86$var$transformLog, $7c1fd0730f0c3a86$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $7c1fd0730f0c3a86$var$logp(base), pows = $7c1fd0730f0c3a86$var$powp(base);
        if (domain()[0] < 0) {
            logs = $7c1fd0730f0c3a86$var$reflect(logs), pows = $7c1fd0730f0c3a86$var$reflect(pows);
            transform($7c1fd0730f0c3a86$var$transformLogn, $7c1fd0730f0c3a86$var$transformExpn);
        } else transform($7c1fd0730f0c3a86$var$transformLog, $7c1fd0730f0c3a86$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $baM4h.ticks)(u, v, n);
        } else z = (0, $baM4h.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $itzmc.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $itzmc.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $7c1fd0730f0c3a86$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $7c1fd0730f0c3a86$var$log() {
    const scale = $7c1fd0730f0c3a86$var$loggish((0, $dTLbh.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $dTLbh.copy)(scale, $7c1fd0730f0c3a86$var$log()).base(scale.base());
    $98nei.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("3CPJt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a3d0cb2bab01a48$var$nice;
function $2a3d0cb2bab01a48$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("bzrFz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86c86d2b217611f5$var$symlog;
module.exports.symlogish = $86c86d2b217611f5$var$symlogish;

var $hvSDx = parcelRequire("hvSDx");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $86c86d2b217611f5$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $86c86d2b217611f5$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $86c86d2b217611f5$var$symlogish(transform) {
    var c = 1, scale = transform($86c86d2b217611f5$var$transformSymlog(c), $86c86d2b217611f5$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($86c86d2b217611f5$var$transformSymlog(c = +_), $86c86d2b217611f5$var$transformSymexp(c)) : c;
    };
    return (0, $hvSDx.linearish)(scale);
}
function $86c86d2b217611f5$var$symlog() {
    var scale = $86c86d2b217611f5$var$symlogish((0, $dTLbh.transformer)());
    scale.copy = function() {
        return (0, $dTLbh.copy)(scale, $86c86d2b217611f5$var$symlog()).constant(scale.constant());
    };
    return $98nei.initRange.apply(scale, arguments);
}

});

parcelRegister("cpAbf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9093e282c6b6bc7f$var$pow;
module.exports.powish = $9093e282c6b6bc7f$var$powish;
module.exports.sqrt = $9093e282c6b6bc7f$var$sqrt;

var $hvSDx = parcelRequire("hvSDx");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $9093e282c6b6bc7f$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $9093e282c6b6bc7f$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $9093e282c6b6bc7f$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $9093e282c6b6bc7f$var$powish(transform) {
    var scale = transform($dTLbh.identity, $dTLbh.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($dTLbh.identity, $dTLbh.identity) : exponent === 0.5 ? transform($9093e282c6b6bc7f$var$transformSqrt, $9093e282c6b6bc7f$var$transformSquare) : transform($9093e282c6b6bc7f$var$transformPow(exponent), $9093e282c6b6bc7f$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $hvSDx.linearish)(scale);
}
function $9093e282c6b6bc7f$var$pow() {
    var scale = $9093e282c6b6bc7f$var$powish((0, $dTLbh.transformer)());
    scale.copy = function() {
        return (0, $dTLbh.copy)(scale, $9093e282c6b6bc7f$var$pow()).exponent(scale.exponent());
    };
    $98nei.initRange.apply(scale, arguments);
    return scale;
}
function $9093e282c6b6bc7f$var$sqrt() {
    return $9093e282c6b6bc7f$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("5lxEG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e4905273b67de17$var$radial;

var $3e4905273b67de17$var$_continuous = $3e4905273b67de17$var$_interopRequireDefault((parcelRequire("dTLbh")));

var $98nei = parcelRequire("98nei");

var $hvSDx = parcelRequire("hvSDx");

var $3e4905273b67de17$var$_number = $3e4905273b67de17$var$_interopRequireDefault((parcelRequire("jerFr")));
function $3e4905273b67de17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3e4905273b67de17$var$square(x) {
    return Math.sign(x) * x * x;
}
function $3e4905273b67de17$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $3e4905273b67de17$var$radial() {
    var squared = (0, $3e4905273b67de17$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $3e4905273b67de17$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($3e4905273b67de17$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $3e4905273b67de17$var$_number.default)).map($3e4905273b67de17$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $3e4905273b67de17$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $98nei.initRange.apply(scale, arguments);
    return (0, $hvSDx.linearish)(scale);
}

});

parcelRegister("67PVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $475bac569bb46018$var$quantile;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");
function $475bac569bb46018$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $baM4h.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $baM4h.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($baM4h.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $475bac569bb46018$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $98nei.initRange.apply(scale, arguments);
}

});

parcelRegister("mgOAc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $042f19449e73ffae$var$quantize;

var $baM4h = parcelRequire("baM4h");

var $hvSDx = parcelRequire("hvSDx");

var $98nei = parcelRequire("98nei");
function $042f19449e73ffae$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $baM4h.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $042f19449e73ffae$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $98nei.initRange.apply((0, $hvSDx.linearish)(scale), arguments);
}

});

parcelRegister("g6ge9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bb89cb437536b92a$var$threshold;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");
function $bb89cb437536b92a$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $baM4h.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $bb89cb437536b92a$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $98nei.initRange.apply(scale, arguments);
}

});

parcelRegister("617BV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $4618bd65b703261b$var$calendar;
module.exports.default = $4618bd65b703261b$var$time;

var $kym6t = parcelRequire("kym6t");

var $2qXVT = parcelRequire("2qXVT");

var $4618bd65b703261b$var$_continuous = $4618bd65b703261b$var$_interopRequireWildcard((parcelRequire("dTLbh")));

var $98nei = parcelRequire("98nei");

var $4618bd65b703261b$var$_nice = $4618bd65b703261b$var$_interopRequireDefault((parcelRequire("3CPJt")));
function $4618bd65b703261b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4618bd65b703261b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4618bd65b703261b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4618bd65b703261b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4618bd65b703261b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4618bd65b703261b$var$date(t) {
    return new Date(t);
}
function $4618bd65b703261b$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $4618bd65b703261b$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $4618bd65b703261b$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $4618bd65b703261b$var$number)) : domain().map($4618bd65b703261b$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $4618bd65b703261b$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $4618bd65b703261b$var$_continuous.copy)(scale, $4618bd65b703261b$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $4618bd65b703261b$var$time() {
    return $98nei.initRange.apply($4618bd65b703261b$var$calendar($kym6t.timeTicks, $kym6t.timeTickInterval, $kym6t.timeYear, $kym6t.timeMonth, $kym6t.timeWeek, $kym6t.timeDay, $kym6t.timeHour, $kym6t.timeMinute, $kym6t.timeSecond, $2qXVT.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("kym6t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $exwcm.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $exwcm.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $exwcm.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $exwcm.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $exwcm.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $exwcm.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $exwcm.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $exwcm.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $exwcm.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $exwcm.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $c02Yy.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $c02Yy.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $exwcm.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $exwcm.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $exwcm.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $exwcm.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $exwcm.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $exwcm.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $c02Yy.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $c02Yy.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcYear.utcYears;
    }
});

var $ef6820ebdc1f168f$var$_interval = $ef6820ebdc1f168f$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $ef6820ebdc1f168f$var$_millisecond = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("hRCmg")));

var $ef6820ebdc1f168f$var$_second = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("jFJeY")));

var $ef6820ebdc1f168f$var$_minute = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("izQ7P")));

var $ef6820ebdc1f168f$var$_hour = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4kq4i")));

var $ef6820ebdc1f168f$var$_day = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("kSMPp")));

var $exwcm = parcelRequire("exwcm");

var $ef6820ebdc1f168f$var$_month = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4YFnz")));

var $ef6820ebdc1f168f$var$_year = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("lzVRI")));

var $ef6820ebdc1f168f$var$_utcMinute = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("9FVE8")));

var $ef6820ebdc1f168f$var$_utcHour = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4wGkR")));

var $ef6820ebdc1f168f$var$_utcDay = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("i3XOj")));

var $kSPvm = parcelRequire("kSPvm");

var $ef6820ebdc1f168f$var$_utcMonth = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("9ILJ1")));

var $ef6820ebdc1f168f$var$_utcYear = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4hSHL")));

var $c02Yy = parcelRequire("c02Yy");
function $ef6820ebdc1f168f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ef6820ebdc1f168f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ef6820ebdc1f168f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ef6820ebdc1f168f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ef6820ebdc1f168f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("bSxHc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a5ee026fcfc7249$var$newInterval;
var $8a5ee026fcfc7249$var$t0 = new Date(), $8a5ee026fcfc7249$var$t1 = new Date();
function $8a5ee026fcfc7249$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $8a5ee026fcfc7249$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $8a5ee026fcfc7249$var$t0.setTime(+start), $8a5ee026fcfc7249$var$t1.setTime(+end);
            floori($8a5ee026fcfc7249$var$t0), floori($8a5ee026fcfc7249$var$t1);
            return Math.floor(count($8a5ee026fcfc7249$var$t0, $8a5ee026fcfc7249$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("hRCmg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $d0152406c3f5521e$var$_interval = $d0152406c3f5521e$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $d0152406c3f5521e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d0152406c3f5521e$var$millisecond = (0, $d0152406c3f5521e$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$d0152406c3f5521e$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $d0152406c3f5521e$var$millisecond;
    return (0, $d0152406c3f5521e$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $d0152406c3f5521e$var$_default = $d0152406c3f5521e$var$millisecond;
module.exports.default = $d0152406c3f5521e$var$_default;
var $d0152406c3f5521e$var$milliseconds = $d0152406c3f5521e$var$millisecond.range;
module.exports.milliseconds = $d0152406c3f5521e$var$milliseconds;

});

parcelRegister("jFJeY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $e524f07ae6002e66$var$_interval = $e524f07ae6002e66$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $e524f07ae6002e66$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e524f07ae6002e66$var$second = (0, $e524f07ae6002e66$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationSecond);
}, function(start, end) {
    return (end - start) / $188mN.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $e524f07ae6002e66$var$_default = $e524f07ae6002e66$var$second;
module.exports.default = $e524f07ae6002e66$var$_default;
var $e524f07ae6002e66$var$seconds = $e524f07ae6002e66$var$second.range;
module.exports.seconds = $e524f07ae6002e66$var$seconds;

});
parcelRegister("188mN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $0d2d073c443f27b5$var$durationSecond = 1000;
module.exports.durationSecond = $0d2d073c443f27b5$var$durationSecond;
const $0d2d073c443f27b5$var$durationMinute = $0d2d073c443f27b5$var$durationSecond * 60;
module.exports.durationMinute = $0d2d073c443f27b5$var$durationMinute;
const $0d2d073c443f27b5$var$durationHour = $0d2d073c443f27b5$var$durationMinute * 60;
module.exports.durationHour = $0d2d073c443f27b5$var$durationHour;
const $0d2d073c443f27b5$var$durationDay = $0d2d073c443f27b5$var$durationHour * 24;
module.exports.durationDay = $0d2d073c443f27b5$var$durationDay;
const $0d2d073c443f27b5$var$durationWeek = $0d2d073c443f27b5$var$durationDay * 7;
module.exports.durationWeek = $0d2d073c443f27b5$var$durationWeek;
const $0d2d073c443f27b5$var$durationMonth = $0d2d073c443f27b5$var$durationDay * 30;
module.exports.durationMonth = $0d2d073c443f27b5$var$durationMonth;
const $0d2d073c443f27b5$var$durationYear = $0d2d073c443f27b5$var$durationDay * 365;
module.exports.durationYear = $0d2d073c443f27b5$var$durationYear;

});


parcelRegister("izQ7P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $d863eddd69e079ff$var$_interval = $d863eddd69e079ff$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $d863eddd69e079ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d863eddd69e079ff$var$minute = (0, $d863eddd69e079ff$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $188mN.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationMinute);
}, function(start, end) {
    return (end - start) / $188mN.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $d863eddd69e079ff$var$_default = $d863eddd69e079ff$var$minute;
module.exports.default = $d863eddd69e079ff$var$_default;
var $d863eddd69e079ff$var$minutes = $d863eddd69e079ff$var$minute.range;
module.exports.minutes = $d863eddd69e079ff$var$minutes;

});

parcelRegister("4kq4i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $326d404cf7731152$var$_interval = $326d404cf7731152$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $326d404cf7731152$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $326d404cf7731152$var$hour = (0, $326d404cf7731152$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $188mN.durationSecond - date.getMinutes() * $188mN.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationHour);
}, function(start, end) {
    return (end - start) / $188mN.durationHour;
}, function(date) {
    return date.getHours();
});
var $326d404cf7731152$var$_default = $326d404cf7731152$var$hour;
module.exports.default = $326d404cf7731152$var$_default;
var $326d404cf7731152$var$hours = $326d404cf7731152$var$hour.range;
module.exports.hours = $326d404cf7731152$var$hours;

});

parcelRegister("kSMPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $f33eba0c8fefd714$var$_interval = $f33eba0c8fefd714$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $f33eba0c8fefd714$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f33eba0c8fefd714$var$day = (0, $f33eba0c8fefd714$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $188mN.durationMinute) / $188mN.durationDay, (date)=>date.getDate() - 1);
var $f33eba0c8fefd714$var$_default = $f33eba0c8fefd714$var$day;
module.exports.default = $f33eba0c8fefd714$var$_default;
var $f33eba0c8fefd714$var$days = $f33eba0c8fefd714$var$day.range;
module.exports.days = $f33eba0c8fefd714$var$days;

});

parcelRegister("exwcm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $a95d1fb36d555b21$var$_interval = $a95d1fb36d555b21$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $a95d1fb36d555b21$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a95d1fb36d555b21$var$weekday(i) {
    return (0, $a95d1fb36d555b21$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $188mN.durationMinute) / $188mN.durationWeek;
    });
}
var $a95d1fb36d555b21$var$sunday = $a95d1fb36d555b21$var$weekday(0);
module.exports.sunday = $a95d1fb36d555b21$var$sunday;
var $a95d1fb36d555b21$var$monday = $a95d1fb36d555b21$var$weekday(1);
module.exports.monday = $a95d1fb36d555b21$var$monday;
var $a95d1fb36d555b21$var$tuesday = $a95d1fb36d555b21$var$weekday(2);
module.exports.tuesday = $a95d1fb36d555b21$var$tuesday;
var $a95d1fb36d555b21$var$wednesday = $a95d1fb36d555b21$var$weekday(3);
module.exports.wednesday = $a95d1fb36d555b21$var$wednesday;
var $a95d1fb36d555b21$var$thursday = $a95d1fb36d555b21$var$weekday(4);
module.exports.thursday = $a95d1fb36d555b21$var$thursday;
var $a95d1fb36d555b21$var$friday = $a95d1fb36d555b21$var$weekday(5);
module.exports.friday = $a95d1fb36d555b21$var$friday;
var $a95d1fb36d555b21$var$saturday = $a95d1fb36d555b21$var$weekday(6);
module.exports.saturday = $a95d1fb36d555b21$var$saturday;
var $a95d1fb36d555b21$var$sundays = $a95d1fb36d555b21$var$sunday.range;
module.exports.sundays = $a95d1fb36d555b21$var$sundays;
var $a95d1fb36d555b21$var$mondays = $a95d1fb36d555b21$var$monday.range;
module.exports.mondays = $a95d1fb36d555b21$var$mondays;
var $a95d1fb36d555b21$var$tuesdays = $a95d1fb36d555b21$var$tuesday.range;
module.exports.tuesdays = $a95d1fb36d555b21$var$tuesdays;
var $a95d1fb36d555b21$var$wednesdays = $a95d1fb36d555b21$var$wednesday.range;
module.exports.wednesdays = $a95d1fb36d555b21$var$wednesdays;
var $a95d1fb36d555b21$var$thursdays = $a95d1fb36d555b21$var$thursday.range;
module.exports.thursdays = $a95d1fb36d555b21$var$thursdays;
var $a95d1fb36d555b21$var$fridays = $a95d1fb36d555b21$var$friday.range;
module.exports.fridays = $a95d1fb36d555b21$var$fridays;
var $a95d1fb36d555b21$var$saturdays = $a95d1fb36d555b21$var$saturday.range;
module.exports.saturdays = $a95d1fb36d555b21$var$saturdays;

});

parcelRegister("4YFnz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $39fcdd0c8c747959$var$_interval = $39fcdd0c8c747959$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $39fcdd0c8c747959$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $39fcdd0c8c747959$var$month = (0, $39fcdd0c8c747959$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $39fcdd0c8c747959$var$_default = $39fcdd0c8c747959$var$month;
module.exports.default = $39fcdd0c8c747959$var$_default;
var $39fcdd0c8c747959$var$months = $39fcdd0c8c747959$var$month.range;
module.exports.months = $39fcdd0c8c747959$var$months;

});

parcelRegister("lzVRI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $fb59c0bdd551f11c$var$_interval = $fb59c0bdd551f11c$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $fb59c0bdd551f11c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fb59c0bdd551f11c$var$year = (0, $fb59c0bdd551f11c$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$fb59c0bdd551f11c$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $fb59c0bdd551f11c$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $fb59c0bdd551f11c$var$_default = $fb59c0bdd551f11c$var$year;
module.exports.default = $fb59c0bdd551f11c$var$_default;
var $fb59c0bdd551f11c$var$years = $fb59c0bdd551f11c$var$year.range;
module.exports.years = $fb59c0bdd551f11c$var$years;

});

parcelRegister("9FVE8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $70b4a8c4dc5c94df$var$_interval = $70b4a8c4dc5c94df$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $70b4a8c4dc5c94df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $70b4a8c4dc5c94df$var$utcMinute = (0, $70b4a8c4dc5c94df$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationMinute);
}, function(start, end) {
    return (end - start) / $188mN.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $70b4a8c4dc5c94df$var$_default = $70b4a8c4dc5c94df$var$utcMinute;
module.exports.default = $70b4a8c4dc5c94df$var$_default;
var $70b4a8c4dc5c94df$var$utcMinutes = $70b4a8c4dc5c94df$var$utcMinute.range;
module.exports.utcMinutes = $70b4a8c4dc5c94df$var$utcMinutes;

});

parcelRegister("4wGkR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $34bafd84c6844820$var$_interval = $34bafd84c6844820$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $34bafd84c6844820$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $34bafd84c6844820$var$utcHour = (0, $34bafd84c6844820$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationHour);
}, function(start, end) {
    return (end - start) / $188mN.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $34bafd84c6844820$var$_default = $34bafd84c6844820$var$utcHour;
module.exports.default = $34bafd84c6844820$var$_default;
var $34bafd84c6844820$var$utcHours = $34bafd84c6844820$var$utcHour.range;
module.exports.utcHours = $34bafd84c6844820$var$utcHours;

});

parcelRegister("i3XOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $d266e6f0c540d430$var$_interval = $d266e6f0c540d430$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $d266e6f0c540d430$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d266e6f0c540d430$var$utcDay = (0, $d266e6f0c540d430$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $188mN.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $d266e6f0c540d430$var$_default = $d266e6f0c540d430$var$utcDay;
module.exports.default = $d266e6f0c540d430$var$_default;
var $d266e6f0c540d430$var$utcDays = $d266e6f0c540d430$var$utcDay.range;
module.exports.utcDays = $d266e6f0c540d430$var$utcDays;

});

parcelRegister("kSPvm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $f340cd979f69f122$var$_interval = $f340cd979f69f122$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $f340cd979f69f122$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f340cd979f69f122$var$utcWeekday(i) {
    return (0, $f340cd979f69f122$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $188mN.durationWeek;
    });
}
var $f340cd979f69f122$var$utcSunday = $f340cd979f69f122$var$utcWeekday(0);
module.exports.utcSunday = $f340cd979f69f122$var$utcSunday;
var $f340cd979f69f122$var$utcMonday = $f340cd979f69f122$var$utcWeekday(1);
module.exports.utcMonday = $f340cd979f69f122$var$utcMonday;
var $f340cd979f69f122$var$utcTuesday = $f340cd979f69f122$var$utcWeekday(2);
module.exports.utcTuesday = $f340cd979f69f122$var$utcTuesday;
var $f340cd979f69f122$var$utcWednesday = $f340cd979f69f122$var$utcWeekday(3);
module.exports.utcWednesday = $f340cd979f69f122$var$utcWednesday;
var $f340cd979f69f122$var$utcThursday = $f340cd979f69f122$var$utcWeekday(4);
module.exports.utcThursday = $f340cd979f69f122$var$utcThursday;
var $f340cd979f69f122$var$utcFriday = $f340cd979f69f122$var$utcWeekday(5);
module.exports.utcFriday = $f340cd979f69f122$var$utcFriday;
var $f340cd979f69f122$var$utcSaturday = $f340cd979f69f122$var$utcWeekday(6);
module.exports.utcSaturday = $f340cd979f69f122$var$utcSaturday;
var $f340cd979f69f122$var$utcSundays = $f340cd979f69f122$var$utcSunday.range;
module.exports.utcSundays = $f340cd979f69f122$var$utcSundays;
var $f340cd979f69f122$var$utcMondays = $f340cd979f69f122$var$utcMonday.range;
module.exports.utcMondays = $f340cd979f69f122$var$utcMondays;
var $f340cd979f69f122$var$utcTuesdays = $f340cd979f69f122$var$utcTuesday.range;
module.exports.utcTuesdays = $f340cd979f69f122$var$utcTuesdays;
var $f340cd979f69f122$var$utcWednesdays = $f340cd979f69f122$var$utcWednesday.range;
module.exports.utcWednesdays = $f340cd979f69f122$var$utcWednesdays;
var $f340cd979f69f122$var$utcThursdays = $f340cd979f69f122$var$utcThursday.range;
module.exports.utcThursdays = $f340cd979f69f122$var$utcThursdays;
var $f340cd979f69f122$var$utcFridays = $f340cd979f69f122$var$utcFriday.range;
module.exports.utcFridays = $f340cd979f69f122$var$utcFridays;
var $f340cd979f69f122$var$utcSaturdays = $f340cd979f69f122$var$utcSaturday.range;
module.exports.utcSaturdays = $f340cd979f69f122$var$utcSaturdays;

});

parcelRegister("9ILJ1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $01d391858e0bc807$var$_interval = $01d391858e0bc807$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $01d391858e0bc807$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $01d391858e0bc807$var$utcMonth = (0, $01d391858e0bc807$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $01d391858e0bc807$var$_default = $01d391858e0bc807$var$utcMonth;
module.exports.default = $01d391858e0bc807$var$_default;
var $01d391858e0bc807$var$utcMonths = $01d391858e0bc807$var$utcMonth.range;
module.exports.utcMonths = $01d391858e0bc807$var$utcMonths;

});

parcelRegister("4hSHL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $31f32f2daf3ec1ad$var$_interval = $31f32f2daf3ec1ad$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $31f32f2daf3ec1ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $31f32f2daf3ec1ad$var$utcYear = (0, $31f32f2daf3ec1ad$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$31f32f2daf3ec1ad$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $31f32f2daf3ec1ad$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $31f32f2daf3ec1ad$var$_default = $31f32f2daf3ec1ad$var$utcYear;
module.exports.default = $31f32f2daf3ec1ad$var$_default;
var $31f32f2daf3ec1ad$var$utcYears = $31f32f2daf3ec1ad$var$utcYear.range;
module.exports.utcYears = $31f32f2daf3ec1ad$var$utcYears;

});

parcelRegister("c02Yy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $baM4h = parcelRequire("baM4h");

var $188mN = parcelRequire("188mN");

var $8bc7cb069ddd56a7$var$_millisecond = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("hRCmg")));

var $8bc7cb069ddd56a7$var$_second = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("jFJeY")));

var $8bc7cb069ddd56a7$var$_minute = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("izQ7P")));

var $8bc7cb069ddd56a7$var$_hour = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4kq4i")));

var $8bc7cb069ddd56a7$var$_day = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("kSMPp")));

var $exwcm = parcelRequire("exwcm");

var $8bc7cb069ddd56a7$var$_month = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4YFnz")));

var $8bc7cb069ddd56a7$var$_year = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("lzVRI")));

var $8bc7cb069ddd56a7$var$_utcMinute = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("9FVE8")));

var $8bc7cb069ddd56a7$var$_utcHour = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4wGkR")));

var $8bc7cb069ddd56a7$var$_utcDay = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("i3XOj")));

var $kSPvm = parcelRequire("kSPvm");

var $8bc7cb069ddd56a7$var$_utcMonth = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("9ILJ1")));

var $8bc7cb069ddd56a7$var$_utcYear = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4hSHL")));
function $8bc7cb069ddd56a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8bc7cb069ddd56a7$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $8bc7cb069ddd56a7$var$_second.default,
            1,
            $188mN.durationSecond
        ],
        [
            $8bc7cb069ddd56a7$var$_second.default,
            5,
            5 * $188mN.durationSecond
        ],
        [
            $8bc7cb069ddd56a7$var$_second.default,
            15,
            15 * $188mN.durationSecond
        ],
        [
            $8bc7cb069ddd56a7$var$_second.default,
            30,
            30 * $188mN.durationSecond
        ],
        [
            minute,
            1,
            $188mN.durationMinute
        ],
        [
            minute,
            5,
            5 * $188mN.durationMinute
        ],
        [
            minute,
            15,
            15 * $188mN.durationMinute
        ],
        [
            minute,
            30,
            30 * $188mN.durationMinute
        ],
        [
            hour,
            1,
            $188mN.durationHour
        ],
        [
            hour,
            3,
            3 * $188mN.durationHour
        ],
        [
            hour,
            6,
            6 * $188mN.durationHour
        ],
        [
            hour,
            12,
            12 * $188mN.durationHour
        ],
        [
            day,
            1,
            $188mN.durationDay
        ],
        [
            day,
            2,
            2 * $188mN.durationDay
        ],
        [
            week,
            1,
            $188mN.durationWeek
        ],
        [
            month,
            1,
            $188mN.durationMonth
        ],
        [
            month,
            3,
            3 * $188mN.durationMonth
        ],
        [
            year,
            1,
            $188mN.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $baM4h.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $baM4h.tickStep)(start / $188mN.durationYear, stop / $188mN.durationYear, count));
        if (i === 0) return $8bc7cb069ddd56a7$var$_millisecond.default.every(Math.max((0, $baM4h.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$8bc7cb069ddd56a7$var$utcTicks, $8bc7cb069ddd56a7$var$utcTickInterval] = $8bc7cb069ddd56a7$var$ticker($8bc7cb069ddd56a7$var$_utcYear.default, $8bc7cb069ddd56a7$var$_utcMonth.default, $kSPvm.utcSunday, $8bc7cb069ddd56a7$var$_utcDay.default, $8bc7cb069ddd56a7$var$_utcHour.default, $8bc7cb069ddd56a7$var$_utcMinute.default);
module.exports.utcTickInterval = $8bc7cb069ddd56a7$var$utcTickInterval;
module.exports.utcTicks = $8bc7cb069ddd56a7$var$utcTicks;
const [$8bc7cb069ddd56a7$var$timeTicks, $8bc7cb069ddd56a7$var$timeTickInterval] = $8bc7cb069ddd56a7$var$ticker($8bc7cb069ddd56a7$var$_year.default, $8bc7cb069ddd56a7$var$_month.default, $exwcm.sunday, $8bc7cb069ddd56a7$var$_day.default, $8bc7cb069ddd56a7$var$_hour.default, $8bc7cb069ddd56a7$var$_minute.default);
module.exports.timeTickInterval = $8bc7cb069ddd56a7$var$timeTickInterval;
module.exports.timeTicks = $8bc7cb069ddd56a7$var$timeTicks;

});


parcelRegister("2qXVT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.utcParse;
    }
});

var $1c5c7fdd0d9de9a3$var$_defaultLocale = $1c5c7fdd0d9de9a3$var$_interopRequireWildcard((parcelRequire("UhGoU")));

var $1c5c7fdd0d9de9a3$var$_locale = $1c5c7fdd0d9de9a3$var$_interopRequireDefault((parcelRequire("h1gUO")));

var $1c5c7fdd0d9de9a3$var$_isoFormat = $1c5c7fdd0d9de9a3$var$_interopRequireDefault((parcelRequire("k4LLC")));

var $1c5c7fdd0d9de9a3$var$_isoParse = $1c5c7fdd0d9de9a3$var$_interopRequireDefault((parcelRequire("ipWNh")));
function $1c5c7fdd0d9de9a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c5c7fdd0d9de9a3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1c5c7fdd0d9de9a3$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1c5c7fdd0d9de9a3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1c5c7fdd0d9de9a3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("UhGoU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a92f287880e1421$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $0a92f287880e1421$var$_locale = $0a92f287880e1421$var$_interopRequireDefault((parcelRequire("h1gUO")));
function $0a92f287880e1421$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0a92f287880e1421$var$locale;
var $0a92f287880e1421$var$timeFormat;
module.exports.timeFormat = $0a92f287880e1421$var$timeFormat;
var $0a92f287880e1421$var$timeParse;
module.exports.timeParse = $0a92f287880e1421$var$timeParse;
var $0a92f287880e1421$var$utcFormat;
module.exports.utcFormat = $0a92f287880e1421$var$utcFormat;
var $0a92f287880e1421$var$utcParse;
module.exports.utcParse = $0a92f287880e1421$var$utcParse;
$0a92f287880e1421$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $0a92f287880e1421$var$defaultLocale(definition) {
    $0a92f287880e1421$var$locale = (0, $0a92f287880e1421$var$_locale.default)(definition);
    module.exports.timeFormat = $0a92f287880e1421$var$timeFormat = $0a92f287880e1421$var$locale.format;
    module.exports.timeParse = $0a92f287880e1421$var$timeParse = $0a92f287880e1421$var$locale.parse;
    module.exports.utcFormat = $0a92f287880e1421$var$utcFormat = $0a92f287880e1421$var$locale.utcFormat;
    module.exports.utcParse = $0a92f287880e1421$var$utcParse = $0a92f287880e1421$var$locale.utcParse;
    return $0a92f287880e1421$var$locale;
}

});
parcelRegister("h1gUO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c63fa6af19e13ce4$var$formatLocale;

var $kym6t = parcelRequire("kym6t");
function $c63fa6af19e13ce4$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $c63fa6af19e13ce4$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $c63fa6af19e13ce4$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $c63fa6af19e13ce4$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $c63fa6af19e13ce4$var$formatRe(locale_periods), periodLookup = $c63fa6af19e13ce4$var$formatLookup(locale_periods), weekdayRe = $c63fa6af19e13ce4$var$formatRe(locale_weekdays), weekdayLookup = $c63fa6af19e13ce4$var$formatLookup(locale_weekdays), shortWeekdayRe = $c63fa6af19e13ce4$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $c63fa6af19e13ce4$var$formatLookup(locale_shortWeekdays), monthRe = $c63fa6af19e13ce4$var$formatRe(locale_months), monthLookup = $c63fa6af19e13ce4$var$formatLookup(locale_months), shortMonthRe = $c63fa6af19e13ce4$var$formatRe(locale_shortMonths), shortMonthLookup = $c63fa6af19e13ce4$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $c63fa6af19e13ce4$var$formatDayOfMonth,
        "e": $c63fa6af19e13ce4$var$formatDayOfMonth,
        "f": $c63fa6af19e13ce4$var$formatMicroseconds,
        "g": $c63fa6af19e13ce4$var$formatYearISO,
        "G": $c63fa6af19e13ce4$var$formatFullYearISO,
        "H": $c63fa6af19e13ce4$var$formatHour24,
        "I": $c63fa6af19e13ce4$var$formatHour12,
        "j": $c63fa6af19e13ce4$var$formatDayOfYear,
        "L": $c63fa6af19e13ce4$var$formatMilliseconds,
        "m": $c63fa6af19e13ce4$var$formatMonthNumber,
        "M": $c63fa6af19e13ce4$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $c63fa6af19e13ce4$var$formatUnixTimestamp,
        "s": $c63fa6af19e13ce4$var$formatUnixTimestampSeconds,
        "S": $c63fa6af19e13ce4$var$formatSeconds,
        "u": $c63fa6af19e13ce4$var$formatWeekdayNumberMonday,
        "U": $c63fa6af19e13ce4$var$formatWeekNumberSunday,
        "V": $c63fa6af19e13ce4$var$formatWeekNumberISO,
        "w": $c63fa6af19e13ce4$var$formatWeekdayNumberSunday,
        "W": $c63fa6af19e13ce4$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $c63fa6af19e13ce4$var$formatYear,
        "Y": $c63fa6af19e13ce4$var$formatFullYear,
        "Z": $c63fa6af19e13ce4$var$formatZone,
        "%": $c63fa6af19e13ce4$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $c63fa6af19e13ce4$var$formatUTCDayOfMonth,
        "e": $c63fa6af19e13ce4$var$formatUTCDayOfMonth,
        "f": $c63fa6af19e13ce4$var$formatUTCMicroseconds,
        "g": $c63fa6af19e13ce4$var$formatUTCYearISO,
        "G": $c63fa6af19e13ce4$var$formatUTCFullYearISO,
        "H": $c63fa6af19e13ce4$var$formatUTCHour24,
        "I": $c63fa6af19e13ce4$var$formatUTCHour12,
        "j": $c63fa6af19e13ce4$var$formatUTCDayOfYear,
        "L": $c63fa6af19e13ce4$var$formatUTCMilliseconds,
        "m": $c63fa6af19e13ce4$var$formatUTCMonthNumber,
        "M": $c63fa6af19e13ce4$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $c63fa6af19e13ce4$var$formatUnixTimestamp,
        "s": $c63fa6af19e13ce4$var$formatUnixTimestampSeconds,
        "S": $c63fa6af19e13ce4$var$formatUTCSeconds,
        "u": $c63fa6af19e13ce4$var$formatUTCWeekdayNumberMonday,
        "U": $c63fa6af19e13ce4$var$formatUTCWeekNumberSunday,
        "V": $c63fa6af19e13ce4$var$formatUTCWeekNumberISO,
        "w": $c63fa6af19e13ce4$var$formatUTCWeekdayNumberSunday,
        "W": $c63fa6af19e13ce4$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $c63fa6af19e13ce4$var$formatUTCYear,
        "Y": $c63fa6af19e13ce4$var$formatUTCFullYear,
        "Z": $c63fa6af19e13ce4$var$formatUTCZone,
        "%": $c63fa6af19e13ce4$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $c63fa6af19e13ce4$var$parseDayOfMonth,
        "e": $c63fa6af19e13ce4$var$parseDayOfMonth,
        "f": $c63fa6af19e13ce4$var$parseMicroseconds,
        "g": $c63fa6af19e13ce4$var$parseYear,
        "G": $c63fa6af19e13ce4$var$parseFullYear,
        "H": $c63fa6af19e13ce4$var$parseHour24,
        "I": $c63fa6af19e13ce4$var$parseHour24,
        "j": $c63fa6af19e13ce4$var$parseDayOfYear,
        "L": $c63fa6af19e13ce4$var$parseMilliseconds,
        "m": $c63fa6af19e13ce4$var$parseMonthNumber,
        "M": $c63fa6af19e13ce4$var$parseMinutes,
        "p": parsePeriod,
        "q": $c63fa6af19e13ce4$var$parseQuarter,
        "Q": $c63fa6af19e13ce4$var$parseUnixTimestamp,
        "s": $c63fa6af19e13ce4$var$parseUnixTimestampSeconds,
        "S": $c63fa6af19e13ce4$var$parseSeconds,
        "u": $c63fa6af19e13ce4$var$parseWeekdayNumberMonday,
        "U": $c63fa6af19e13ce4$var$parseWeekNumberSunday,
        "V": $c63fa6af19e13ce4$var$parseWeekNumberISO,
        "w": $c63fa6af19e13ce4$var$parseWeekdayNumberSunday,
        "W": $c63fa6af19e13ce4$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $c63fa6af19e13ce4$var$parseYear,
        "Y": $c63fa6af19e13ce4$var$parseFullYear,
        "Z": $c63fa6af19e13ce4$var$parseZone,
        "%": $c63fa6af19e13ce4$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $c63fa6af19e13ce4$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $c63fa6af19e13ce4$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $c63fa6af19e13ce4$var$utcDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $kym6t.utcMonday.ceil(week) : (0, $kym6t.utcMonday)(week);
                    week = $kym6t.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $c63fa6af19e13ce4$var$localDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $kym6t.timeMonday.ceil(week) : (0, $kym6t.timeMonday)(week);
                    week = $kym6t.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $c63fa6af19e13ce4$var$utcDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)).getUTCDay() : $c63fa6af19e13ce4$var$localDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $c63fa6af19e13ce4$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $c63fa6af19e13ce4$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $c63fa6af19e13ce4$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $c63fa6af19e13ce4$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $c63fa6af19e13ce4$var$numberRe = /^\s*\d+/, // note: ignores next directive
$c63fa6af19e13ce4$var$percentRe = /^%/, $c63fa6af19e13ce4$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $c63fa6af19e13ce4$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $c63fa6af19e13ce4$var$requote(s) {
    return s.replace($c63fa6af19e13ce4$var$requoteRe, "\\$&");
}
function $c63fa6af19e13ce4$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($c63fa6af19e13ce4$var$requote).join("|") + ")", "i");
}
function $c63fa6af19e13ce4$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $c63fa6af19e13ce4$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekNumberSunday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekNumberISO(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekNumberMonday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseFullYear(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseYear(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseQuarter(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMonthNumber(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseDayOfMonth(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseDayOfYear(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseHour24(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMinutes(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseSeconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMilliseconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMicroseconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseLiteralPercent(d, string, i) {
    var n = $c63fa6af19e13ce4$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $c63fa6af19e13ce4$var$parseUnixTimestamp(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$formatDayOfMonth(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getDate(), p, 2);
}
function $c63fa6af19e13ce4$var$formatHour24(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getHours(), p, 2);
}
function $c63fa6af19e13ce4$var$formatHour12(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $c63fa6af19e13ce4$var$formatDayOfYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(1 + $kym6t.timeDay.count((0, $kym6t.timeYear)(d), d), p, 3);
}
function $c63fa6af19e13ce4$var$formatMilliseconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getMilliseconds(), p, 3);
}
function $c63fa6af19e13ce4$var$formatMicroseconds(d, p) {
    return $c63fa6af19e13ce4$var$formatMilliseconds(d, p) + "000";
}
function $c63fa6af19e13ce4$var$formatMonthNumber(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getMonth() + 1, p, 2);
}
function $c63fa6af19e13ce4$var$formatMinutes(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getMinutes(), p, 2);
}
function $c63fa6af19e13ce4$var$formatSeconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getSeconds(), p, 2);
}
function $c63fa6af19e13ce4$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $c63fa6af19e13ce4$var$formatWeekNumberSunday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.timeSunday.count((0, $kym6t.timeYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $kym6t.timeThursday)(d) : $kym6t.timeThursday.ceil(d);
}
function $c63fa6af19e13ce4$var$formatWeekNumberISO(d, p) {
    d = $c63fa6af19e13ce4$var$dISO(d);
    return $c63fa6af19e13ce4$var$pad($kym6t.timeThursday.count((0, $kym6t.timeYear)(d), d) + ((0, $kym6t.timeYear)(d).getDay() === 4), p, 2);
}
function $c63fa6af19e13ce4$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $c63fa6af19e13ce4$var$formatWeekNumberMonday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.timeMonday.count((0, $kym6t.timeYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$formatYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatYearISO(d, p) {
    d = $c63fa6af19e13ce4$var$dISO(d);
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatFullYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $kym6t.timeThursday)(d) : $kym6t.timeThursday.ceil(d);
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $c63fa6af19e13ce4$var$pad(z / 60 | 0, "0", 2) + $c63fa6af19e13ce4$var$pad(z % 60, "0", 2);
}
function $c63fa6af19e13ce4$var$formatUTCDayOfMonth(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCDate(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCHour24(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCHours(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCHour12(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCDayOfYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(1 + $kym6t.utcDay.count((0, $kym6t.utcYear)(d), d), p, 3);
}
function $c63fa6af19e13ce4$var$formatUTCMilliseconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $c63fa6af19e13ce4$var$formatUTCMicroseconds(d, p) {
    return $c63fa6af19e13ce4$var$formatUTCMilliseconds(d, p) + "000";
}
function $c63fa6af19e13ce4$var$formatUTCMonthNumber(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCMinutes(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCMinutes(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCSeconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCSeconds(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $c63fa6af19e13ce4$var$formatUTCWeekNumberSunday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.utcSunday.count((0, $kym6t.utcYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $kym6t.utcThursday)(d) : $kym6t.utcThursday.ceil(d);
}
function $c63fa6af19e13ce4$var$formatUTCWeekNumberISO(d, p) {
    d = $c63fa6af19e13ce4$var$UTCdISO(d);
    return $c63fa6af19e13ce4$var$pad($kym6t.utcThursday.count((0, $kym6t.utcYear)(d), d) + ((0, $kym6t.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $c63fa6af19e13ce4$var$formatUTCWeekNumberMonday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.utcMonday.count((0, $kym6t.utcYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCYearISO(d, p) {
    d = $c63fa6af19e13ce4$var$UTCdISO(d);
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCFullYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $kym6t.utcThursday)(d) : $kym6t.utcThursday.ceil(d);
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatUTCZone() {
    return "+0000";
}
function $c63fa6af19e13ce4$var$formatLiteralPercent() {
    return "%";
}
function $c63fa6af19e13ce4$var$formatUnixTimestamp(d) {
    return +d;
}
function $c63fa6af19e13ce4$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("k4LLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $UhGoU = parcelRequire("UhGoU");
var $e9d93beb7b18b592$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $e9d93beb7b18b592$var$isoSpecifier;
function $e9d93beb7b18b592$var$formatIsoNative(date) {
    return date.toISOString();
}
var $e9d93beb7b18b592$var$formatIso = Date.prototype.toISOString ? $e9d93beb7b18b592$var$formatIsoNative : (0, $UhGoU.utcFormat)($e9d93beb7b18b592$var$isoSpecifier);
var $e9d93beb7b18b592$var$_default = $e9d93beb7b18b592$var$formatIso;
module.exports.default = $e9d93beb7b18b592$var$_default;

});

parcelRegister("ipWNh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $k4LLC = parcelRequire("k4LLC");

var $UhGoU = parcelRequire("UhGoU");
function $d6882b05ea79e09e$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $d6882b05ea79e09e$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $d6882b05ea79e09e$var$parseIsoNative : (0, $UhGoU.utcParse)($k4LLC.isoSpecifier);
var $d6882b05ea79e09e$var$_default = $d6882b05ea79e09e$var$parseIso;
module.exports.default = $d6882b05ea79e09e$var$_default;

});



parcelRegister("ne0st", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $045d0379864c58f8$var$utcTime;

var $kym6t = parcelRequire("kym6t");

var $2qXVT = parcelRequire("2qXVT");

var $617BV = parcelRequire("617BV");

var $98nei = parcelRequire("98nei");
function $045d0379864c58f8$var$utcTime() {
    return $98nei.initRange.apply((0, $617BV.calendar)($kym6t.utcTicks, $kym6t.utcTickInterval, $kym6t.utcYear, $kym6t.utcMonth, $kym6t.utcWeek, $kym6t.utcDay, $kym6t.utcHour, $kym6t.utcMinute, $kym6t.utcSecond, $2qXVT.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("5pVeE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $3f1baf43dc1248ab$var$copy;
module.exports.default = $3f1baf43dc1248ab$var$sequential;
module.exports.sequentialLog = $3f1baf43dc1248ab$var$sequentialLog;
module.exports.sequentialPow = $3f1baf43dc1248ab$var$sequentialPow;
module.exports.sequentialSqrt = $3f1baf43dc1248ab$var$sequentialSqrt;
module.exports.sequentialSymlog = $3f1baf43dc1248ab$var$sequentialSymlog;

var $665th = parcelRequire("665th");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");

var $hvSDx = parcelRequire("hvSDx");

var $aEI3x = parcelRequire("aEI3x");

var $bzrFz = parcelRequire("bzrFz");

var $cpAbf = parcelRequire("cpAbf");
function $3f1baf43dc1248ab$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $dTLbh.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($665th.interpolate);
    scale.rangeRound = range($665th.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $3f1baf43dc1248ab$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $3f1baf43dc1248ab$var$sequential() {
    var scale = (0, $hvSDx.linearish)($3f1baf43dc1248ab$var$transformer()($dTLbh.identity));
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequential());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialLog() {
    var scale = (0, $aEI3x.loggish)($3f1baf43dc1248ab$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequentialLog()).base(scale.base());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialSymlog() {
    var scale = (0, $bzrFz.symlogish)($3f1baf43dc1248ab$var$transformer());
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequentialSymlog()).constant(scale.constant());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialPow() {
    var scale = (0, $cpAbf.powish)($3f1baf43dc1248ab$var$transformer());
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequentialPow()).exponent(scale.exponent());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialSqrt() {
    return $3f1baf43dc1248ab$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("l4TSc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5854ff20784e77c$var$sequentialQuantile;

var $baM4h = parcelRequire("baM4h");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $f5854ff20784e77c$var$sequentialQuantile() {
    var domain = [], interpolator = $dTLbh.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $baM4h.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($baM4h.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $baM4h.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $f5854ff20784e77c$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("fMWTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7e906464bbf9363$var$diverging;
module.exports.divergingLog = $b7e906464bbf9363$var$divergingLog;
module.exports.divergingPow = $b7e906464bbf9363$var$divergingPow;
module.exports.divergingSqrt = $b7e906464bbf9363$var$divergingSqrt;
module.exports.divergingSymlog = $b7e906464bbf9363$var$divergingSymlog;

var $665th = parcelRequire("665th");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");

var $hvSDx = parcelRequire("hvSDx");

var $aEI3x = parcelRequire("aEI3x");

var $5pVeE = parcelRequire("5pVeE");

var $bzrFz = parcelRequire("bzrFz");

var $cpAbf = parcelRequire("cpAbf");
function $b7e906464bbf9363$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $dTLbh.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $665th.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($665th.interpolate);
    scale.rangeRound = range($665th.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $b7e906464bbf9363$var$diverging() {
    var scale = (0, $hvSDx.linearish)($b7e906464bbf9363$var$transformer()($dTLbh.identity));
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$diverging());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingLog() {
    var scale = (0, $aEI3x.loggish)($b7e906464bbf9363$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$divergingLog()).base(scale.base());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingSymlog() {
    var scale = (0, $bzrFz.symlogish)($b7e906464bbf9363$var$transformer());
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$divergingSymlog()).constant(scale.constant());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingPow() {
    var scale = (0, $cpAbf.powish)($b7e906464bbf9363$var$transformer());
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$divergingPow()).exponent(scale.exponent());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingSqrt() {
    return $b7e906464bbf9363$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("CKTDO", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("bszMs"));

});
parcelRegister("bszMs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $evZCX.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $evZCX.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $eqBPr.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $eqBPr.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $3WvWY.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $3WvWY.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $3WvWY.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $3WvWY.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.symbolsStroke;
    }
});

var $857e1081b5aa9262$var$_arc = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("8sWC8")));

var $857e1081b5aa9262$var$_area = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("cYK15")));

var $857e1081b5aa9262$var$_line = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("2gJml")));

var $857e1081b5aa9262$var$_pie = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("fM93E")));

var $857e1081b5aa9262$var$_areaRadial = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7s0ZM")));

var $857e1081b5aa9262$var$_lineRadial = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7auFH")));

var $857e1081b5aa9262$var$_pointRadial = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("5wAin")));

var $3WvWY = parcelRequire("3WvWY");

var $857e1081b5aa9262$var$_symbol = $857e1081b5aa9262$var$_interopRequireWildcard((parcelRequire("l3mP4")));

var $857e1081b5aa9262$var$_asterisk = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("hNi5e")));

var $857e1081b5aa9262$var$_circle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("80b5j")));

var $857e1081b5aa9262$var$_cross = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("34kQO")));

var $857e1081b5aa9262$var$_diamond = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("aSxHZ")));

var $857e1081b5aa9262$var$_diamond2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("3rBZo")));

var $857e1081b5aa9262$var$_plus = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("l9ST9")));

var $857e1081b5aa9262$var$_square = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("3oWT7")));

var $857e1081b5aa9262$var$_square2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("k3QGU")));

var $857e1081b5aa9262$var$_star = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1WZhf")));

var $857e1081b5aa9262$var$_triangle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("hQr8g")));

var $857e1081b5aa9262$var$_triangle2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("NGszi")));

var $857e1081b5aa9262$var$_wye = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7fYkN")));

var $857e1081b5aa9262$var$_x = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("3oXF4")));

var $857e1081b5aa9262$var$_basisClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("a65kp")));

var $857e1081b5aa9262$var$_basisOpen = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("aFwZp")));

var $857e1081b5aa9262$var$_basis = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4MmJ6")));

var $evZCX = parcelRequire("evZCX");

var $857e1081b5aa9262$var$_bundle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1uOPP")));

var $857e1081b5aa9262$var$_cardinalClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1RBVE")));

var $857e1081b5aa9262$var$_cardinalOpen = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("88R3u")));

var $857e1081b5aa9262$var$_cardinal = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("8MEVA")));

var $857e1081b5aa9262$var$_catmullRomClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("63Rg9")));

var $857e1081b5aa9262$var$_catmullRomOpen = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4JV2s")));

var $857e1081b5aa9262$var$_catmullRom = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("jeCIz")));

var $857e1081b5aa9262$var$_linearClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7HCNf")));

var $857e1081b5aa9262$var$_linear = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1wm0G")));

var $eqBPr = parcelRequire("eqBPr");

var $857e1081b5aa9262$var$_natural = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("dY7QQ")));

var $857e1081b5aa9262$var$_step = $857e1081b5aa9262$var$_interopRequireWildcard((parcelRequire("llSQy")));

var $857e1081b5aa9262$var$_stack = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("l6qno")));

var $857e1081b5aa9262$var$_expand = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("fpjqO")));

var $857e1081b5aa9262$var$_diverging = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("l5EV1")));

var $857e1081b5aa9262$var$_none = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7CMPN")));

var $857e1081b5aa9262$var$_silhouette = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4ViQy")));

var $857e1081b5aa9262$var$_wiggle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("fIpqC")));

var $857e1081b5aa9262$var$_appearance = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("5qWRn")));

var $857e1081b5aa9262$var$_ascending = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("klspr")));

var $857e1081b5aa9262$var$_descending = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("kwAJ5")));

var $857e1081b5aa9262$var$_insideOut = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4fWJp")));

var $857e1081b5aa9262$var$_none2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("5Nf2s")));

var $857e1081b5aa9262$var$_reverse = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("aFPqy")));
function $857e1081b5aa9262$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($857e1081b5aa9262$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $857e1081b5aa9262$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $857e1081b5aa9262$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $857e1081b5aa9262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("8sWC8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $629e67c3e170e9e8$var$_default;

var $ahT4l = parcelRequire("ahT4l");

var $629e67c3e170e9e8$var$_constant = $629e67c3e170e9e8$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $8EE7R = parcelRequire("8EE7R");
function $629e67c3e170e9e8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $629e67c3e170e9e8$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $629e67c3e170e9e8$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $629e67c3e170e9e8$var$arcStartAngle(d) {
    return d.startAngle;
}
function $629e67c3e170e9e8$var$arcEndAngle(d) {
    return d.endAngle;
}
function $629e67c3e170e9e8$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $629e67c3e170e9e8$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $8EE7R.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $629e67c3e170e9e8$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $8EE7R.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $8EE7R.sqrt)((0, $8EE7R.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $629e67c3e170e9e8$var$_default() {
    var innerRadius = $629e67c3e170e9e8$var$arcInnerRadius, outerRadius = $629e67c3e170e9e8$var$arcOuterRadius, cornerRadius = (0, $629e67c3e170e9e8$var$_constant.default)(0), padRadius = null, startAngle = $629e67c3e170e9e8$var$arcStartAngle, endAngle = $629e67c3e170e9e8$var$arcEndAngle, padAngle = $629e67c3e170e9e8$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $8EE7R.halfPi, a1 = endAngle.apply(this, arguments) - $8EE7R.halfPi, da = (0, $8EE7R.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $ahT4l.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $8EE7R.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $8EE7R.tau - $8EE7R.epsilon) {
            context.moveTo(r1 * (0, $8EE7R.cos)(a0), r1 * (0, $8EE7R.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $8EE7R.epsilon) {
                context.moveTo(r0 * (0, $8EE7R.cos)(a1), r0 * (0, $8EE7R.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $8EE7R.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $8EE7R.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $8EE7R.min)((0, $8EE7R.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $8EE7R.epsilon) {
                var p0 = (0, $8EE7R.asin)(rp / r0 * (0, $8EE7R.sin)(ap)), p1 = (0, $8EE7R.asin)(rp / r1 * (0, $8EE7R.sin)(ap));
                if ((da0 -= p0 * 2) > $8EE7R.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $8EE7R.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $8EE7R.cos)(a01), y01 = r1 * (0, $8EE7R.sin)(a01), x10 = r0 * (0, $8EE7R.cos)(a10), y10 = r0 * (0, $8EE7R.sin)(a10); // Apply rounded corners?
            if (rc > $8EE7R.epsilon) {
                var x11 = r1 * (0, $8EE7R.cos)(a11), y11 = r1 * (0, $8EE7R.sin)(a11), x00 = r0 * (0, $8EE7R.cos)(a00), y00 = r0 * (0, $8EE7R.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $8EE7R.pi && (oc = $629e67c3e170e9e8$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $8EE7R.sin)((0, $8EE7R.acos)((ax * bx + ay * by) / ((0, $8EE7R.sqrt)(ax * ax + ay * ay) * (0, $8EE7R.sqrt)(bx * bx + by * by))) / 2), lc = (0, $8EE7R.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $8EE7R.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $8EE7R.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $8EE7R.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $8EE7R.epsilon) {
                t0 = $629e67c3e170e9e8$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $629e67c3e170e9e8$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $8EE7R.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8EE7R.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $8EE7R.atan2)(t1.y11, t1.x11), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $8EE7R.epsilon) || !(da0 > $8EE7R.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $8EE7R.epsilon) {
                t0 = $629e67c3e170e9e8$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $629e67c3e170e9e8$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $8EE7R.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8EE7R.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $8EE7R.atan2)(t1.y11, t1.x11), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $8EE7R.pi / 2;
        return [
            (0, $8EE7R.cos)(a) * r,
            (0, $8EE7R.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("ahT4l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $77d6357a38850c18$var$_path.default;
    }
});

var $77d6357a38850c18$var$_path = $77d6357a38850c18$var$_interopRequireDefault((parcelRequire("le6pz")));
function $77d6357a38850c18$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("le6pz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f73fe0f2b8713871$var$pi = Math.PI, $f73fe0f2b8713871$var$tau = 2 * $f73fe0f2b8713871$var$pi, $f73fe0f2b8713871$var$epsilon = 1e-6, $f73fe0f2b8713871$var$tauEpsilon = $f73fe0f2b8713871$var$tau - $f73fe0f2b8713871$var$epsilon;
function $f73fe0f2b8713871$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $f73fe0f2b8713871$var$path() {
    return new $f73fe0f2b8713871$var$Path();
}
$f73fe0f2b8713871$var$Path.prototype = $f73fe0f2b8713871$var$path.prototype = {
    constructor: $f73fe0f2b8713871$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $f73fe0f2b8713871$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $f73fe0f2b8713871$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($f73fe0f2b8713871$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $f73fe0f2b8713871$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $f73fe0f2b8713871$var$epsilon || Math.abs(this._y1 - y0) > $f73fe0f2b8713871$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $f73fe0f2b8713871$var$tau + $f73fe0f2b8713871$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $f73fe0f2b8713871$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $f73fe0f2b8713871$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $f73fe0f2b8713871$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $f73fe0f2b8713871$var$_default = $f73fe0f2b8713871$var$path;
module.exports.default = $f73fe0f2b8713871$var$_default;

});


parcelRegister("1SFIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15eb3195f18fef30$var$_default;
function $15eb3195f18fef30$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("8EE7R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $64d12f47b5cdfb44$var$acos;
module.exports.asin = $64d12f47b5cdfb44$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $64d12f47b5cdfb44$var$abs = Math.abs;
module.exports.abs = $64d12f47b5cdfb44$var$abs;
const $64d12f47b5cdfb44$var$atan2 = Math.atan2;
module.exports.atan2 = $64d12f47b5cdfb44$var$atan2;
const $64d12f47b5cdfb44$var$cos = Math.cos;
module.exports.cos = $64d12f47b5cdfb44$var$cos;
const $64d12f47b5cdfb44$var$max = Math.max;
module.exports.max = $64d12f47b5cdfb44$var$max;
const $64d12f47b5cdfb44$var$min = Math.min;
module.exports.min = $64d12f47b5cdfb44$var$min;
const $64d12f47b5cdfb44$var$sin = Math.sin;
module.exports.sin = $64d12f47b5cdfb44$var$sin;
const $64d12f47b5cdfb44$var$sqrt = Math.sqrt;
module.exports.sqrt = $64d12f47b5cdfb44$var$sqrt;
const $64d12f47b5cdfb44$var$epsilon = 1e-12;
module.exports.epsilon = $64d12f47b5cdfb44$var$epsilon;
const $64d12f47b5cdfb44$var$pi = Math.PI;
module.exports.pi = $64d12f47b5cdfb44$var$pi;
const $64d12f47b5cdfb44$var$halfPi = $64d12f47b5cdfb44$var$pi / 2;
module.exports.halfPi = $64d12f47b5cdfb44$var$halfPi;
const $64d12f47b5cdfb44$var$tau = 2 * $64d12f47b5cdfb44$var$pi;
module.exports.tau = $64d12f47b5cdfb44$var$tau;
function $64d12f47b5cdfb44$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $64d12f47b5cdfb44$var$pi : Math.acos(x);
}
function $64d12f47b5cdfb44$var$asin(x) {
    return x >= 1 ? $64d12f47b5cdfb44$var$halfPi : x <= -1 ? -$64d12f47b5cdfb44$var$halfPi : Math.asin(x);
}

});


parcelRegister("cYK15", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $972ec88a4d5ed3c6$var$_default;

var $ahT4l = parcelRequire("ahT4l");

var $972ec88a4d5ed3c6$var$_array = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("72xzV")));

var $972ec88a4d5ed3c6$var$_constant = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $972ec88a4d5ed3c6$var$_linear = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("1wm0G")));

var $972ec88a4d5ed3c6$var$_line = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("2gJml")));

var $97E2D = parcelRequire("97E2D");
function $972ec88a4d5ed3c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $972ec88a4d5ed3c6$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $972ec88a4d5ed3c6$var$_constant.default)(true), context = null, curve = $972ec88a4d5ed3c6$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $97E2D.x : (0, $972ec88a4d5ed3c6$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $972ec88a4d5ed3c6$var$_constant.default)(0) : (0, $972ec88a4d5ed3c6$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $97E2D.y : (0, $972ec88a4d5ed3c6$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $972ec88a4d5ed3c6$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $ahT4l.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $972ec88a4d5ed3c6$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("72xzV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5202c4444202b759$var$_default;
module.exports.slice = void 0;
var $5202c4444202b759$var$slice = Array.prototype.slice;
module.exports.slice = $5202c4444202b759$var$slice;
function $5202c4444202b759$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("1wm0G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11b9da5b73dc4d76$var$_default;
function $11b9da5b73dc4d76$var$Linear(context) {
    this._context = context;
}
$11b9da5b73dc4d76$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $11b9da5b73dc4d76$var$_default(context) {
    return new $11b9da5b73dc4d76$var$Linear(context);
}

});

parcelRegister("2gJml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a7042d356f33d45$var$_default;

var $ahT4l = parcelRequire("ahT4l");

var $1a7042d356f33d45$var$_array = $1a7042d356f33d45$var$_interopRequireDefault((parcelRequire("72xzV")));

var $1a7042d356f33d45$var$_constant = $1a7042d356f33d45$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $1a7042d356f33d45$var$_linear = $1a7042d356f33d45$var$_interopRequireDefault((parcelRequire("1wm0G")));

var $97E2D = parcelRequire("97E2D");
function $1a7042d356f33d45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a7042d356f33d45$var$_default(x, y) {
    var defined = (0, $1a7042d356f33d45$var$_constant.default)(true), context = null, curve = $1a7042d356f33d45$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $97E2D.x : (0, $1a7042d356f33d45$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $97E2D.y : (0, $1a7042d356f33d45$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $1a7042d356f33d45$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $ahT4l.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $1a7042d356f33d45$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $1a7042d356f33d45$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $1a7042d356f33d45$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("97E2D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $6a43d3ea9922a71a$var$x;
module.exports.y = $6a43d3ea9922a71a$var$y;
function $6a43d3ea9922a71a$var$x(p) {
    return p[0];
}
function $6a43d3ea9922a71a$var$y(p) {
    return p[1];
}

});



parcelRegister("fM93E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7c25d6f0d698acb$var$_default;

var $b7c25d6f0d698acb$var$_array = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("72xzV")));

var $b7c25d6f0d698acb$var$_constant = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $b7c25d6f0d698acb$var$_descending = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("fI7FW")));

var $b7c25d6f0d698acb$var$_identity = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("gi9bQ")));

var $8EE7R = parcelRequire("8EE7R");
function $b7c25d6f0d698acb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b7c25d6f0d698acb$var$_default() {
    var value = $b7c25d6f0d698acb$var$_identity.default, sortValues = $b7c25d6f0d698acb$var$_descending.default, sort = null, startAngle = (0, $b7c25d6f0d698acb$var$_constant.default)(0), endAngle = (0, $b7c25d6f0d698acb$var$_constant.default)($8EE7R.tau), padAngle = (0, $b7c25d6f0d698acb$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $b7c25d6f0d698acb$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($8EE7R.tau, Math.max(-$8EE7R.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("fI7FW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b700eb49b0c7926d$var$_default;
function $b700eb49b0c7926d$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("gi9bQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bdc574b68d16a31a$var$_default;
function $bdc574b68d16a31a$var$_default(d) {
    return d;
}

});


parcelRegister("7s0ZM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56cbeb94d955b565$var$_default;

var $56cbeb94d955b565$var$_radial = $56cbeb94d955b565$var$_interopRequireWildcard((parcelRequire("dqrdl")));

var $56cbeb94d955b565$var$_area = $56cbeb94d955b565$var$_interopRequireDefault((parcelRequire("cYK15")));

var $7auFH = parcelRequire("7auFH");
function $56cbeb94d955b565$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $56cbeb94d955b565$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($56cbeb94d955b565$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $56cbeb94d955b565$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $56cbeb94d955b565$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $56cbeb94d955b565$var$_default() {
    var a = (0, $56cbeb94d955b565$var$_area.default)().curve($56cbeb94d955b565$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $7auFH.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $7auFH.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $7auFH.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $7auFH.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $56cbeb94d955b565$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("dqrdl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $9c62d03c39ca9869$var$curveRadial;

var $9c62d03c39ca9869$var$_linear = $9c62d03c39ca9869$var$_interopRequireDefault((parcelRequire("1wm0G")));
function $9c62d03c39ca9869$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9c62d03c39ca9869$var$curveRadialLinear = $9c62d03c39ca9869$var$curveRadial($9c62d03c39ca9869$var$_linear.default);
module.exports.curveRadialLinear = $9c62d03c39ca9869$var$curveRadialLinear;
function $9c62d03c39ca9869$var$Radial(curve) {
    this._curve = curve;
}
$9c62d03c39ca9869$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $9c62d03c39ca9869$var$curveRadial(curve) {
    function radial(context) {
        return new $9c62d03c39ca9869$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("7auFH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5381424cea8627da$var$_default;
module.exports.lineRadial = $5381424cea8627da$var$lineRadial;

var $5381424cea8627da$var$_radial = $5381424cea8627da$var$_interopRequireWildcard((parcelRequire("dqrdl")));

var $5381424cea8627da$var$_line = $5381424cea8627da$var$_interopRequireDefault((parcelRequire("2gJml")));
function $5381424cea8627da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5381424cea8627da$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5381424cea8627da$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5381424cea8627da$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5381424cea8627da$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5381424cea8627da$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $5381424cea8627da$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $5381424cea8627da$var$_default() {
    return $5381424cea8627da$var$lineRadial((0, $5381424cea8627da$var$_line.default)().curve($5381424cea8627da$var$_radial.curveRadialLinear));
}

});


parcelRegister("5wAin", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $405c1869ebbc3c11$var$_default;
function $405c1869ebbc3c11$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("3WvWY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $2def9285c4745f69$var$link;
module.exports.linkHorizontal = $2def9285c4745f69$var$linkHorizontal;
module.exports.linkRadial = $2def9285c4745f69$var$linkRadial;
module.exports.linkVertical = $2def9285c4745f69$var$linkVertical;

var $ahT4l = parcelRequire("ahT4l");

var $72xzV = parcelRequire("72xzV");

var $2def9285c4745f69$var$_constant = $2def9285c4745f69$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $evZCX = parcelRequire("evZCX");

var $97E2D = parcelRequire("97E2D");
function $2def9285c4745f69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2def9285c4745f69$var$linkSource(d) {
    return d.source;
}
function $2def9285c4745f69$var$linkTarget(d) {
    return d.target;
}
function $2def9285c4745f69$var$link(curve) {
    let source = $2def9285c4745f69$var$linkSource;
    let target = $2def9285c4745f69$var$linkTarget;
    let x = $97E2D.x;
    let y = $97E2D.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $72xzV.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $ahT4l.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $2def9285c4745f69$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $2def9285c4745f69$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $2def9285c4745f69$var$linkHorizontal() {
    return $2def9285c4745f69$var$link($evZCX.bumpX);
}
function $2def9285c4745f69$var$linkVertical() {
    return $2def9285c4745f69$var$link($evZCX.bumpY);
}
function $2def9285c4745f69$var$linkRadial() {
    const l = $2def9285c4745f69$var$link($evZCX.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("evZCX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $a913c3def1aa11e0$var$bumpRadial;
module.exports.bumpX = $a913c3def1aa11e0$var$bumpX;
module.exports.bumpY = $a913c3def1aa11e0$var$bumpY;

var $a913c3def1aa11e0$var$_pointRadial = $a913c3def1aa11e0$var$_interopRequireDefault((parcelRequire("5wAin")));
function $a913c3def1aa11e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $a913c3def1aa11e0$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $a913c3def1aa11e0$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $a913c3def1aa11e0$var$bumpX(context) {
    return new $a913c3def1aa11e0$var$Bump(context, true);
}
function $a913c3def1aa11e0$var$bumpY(context) {
    return new $a913c3def1aa11e0$var$Bump(context, false);
}
function $a913c3def1aa11e0$var$bumpRadial(context) {
    return new $a913c3def1aa11e0$var$BumpRadial(context);
}

});


parcelRegister("l3mP4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f53b94ec46d9e16d$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $ahT4l = parcelRequire("ahT4l");

var $f53b94ec46d9e16d$var$_constant = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $f53b94ec46d9e16d$var$_asterisk = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("hNi5e")));

var $f53b94ec46d9e16d$var$_circle = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("80b5j")));

var $f53b94ec46d9e16d$var$_cross = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("34kQO")));

var $f53b94ec46d9e16d$var$_diamond = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("aSxHZ")));

var $f53b94ec46d9e16d$var$_diamond2 = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("3rBZo")));

var $f53b94ec46d9e16d$var$_plus = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("l9ST9")));

var $f53b94ec46d9e16d$var$_square = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("3oWT7")));

var $f53b94ec46d9e16d$var$_square2 = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("k3QGU")));

var $f53b94ec46d9e16d$var$_star = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("1WZhf")));

var $f53b94ec46d9e16d$var$_triangle = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("hQr8g")));

var $f53b94ec46d9e16d$var$_triangle2 = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("NGszi")));

var $f53b94ec46d9e16d$var$_wye = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("7fYkN")));

var $f53b94ec46d9e16d$var$_x = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("3oXF4")));
function $f53b94ec46d9e16d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $f53b94ec46d9e16d$var$symbolsFill = [
    $f53b94ec46d9e16d$var$_circle.default,
    $f53b94ec46d9e16d$var$_cross.default,
    $f53b94ec46d9e16d$var$_diamond.default,
    $f53b94ec46d9e16d$var$_square.default,
    $f53b94ec46d9e16d$var$_star.default,
    $f53b94ec46d9e16d$var$_triangle.default,
    $f53b94ec46d9e16d$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $f53b94ec46d9e16d$var$symbolsFill;
const $f53b94ec46d9e16d$var$symbolsStroke = [
    $f53b94ec46d9e16d$var$_circle.default,
    $f53b94ec46d9e16d$var$_plus.default,
    $f53b94ec46d9e16d$var$_x.default,
    $f53b94ec46d9e16d$var$_triangle2.default,
    $f53b94ec46d9e16d$var$_asterisk.default,
    $f53b94ec46d9e16d$var$_square2.default,
    $f53b94ec46d9e16d$var$_diamond2.default
];
module.exports.symbolsStroke = $f53b94ec46d9e16d$var$symbolsStroke;
function $f53b94ec46d9e16d$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $f53b94ec46d9e16d$var$_constant.default)(type || $f53b94ec46d9e16d$var$_circle.default);
    size = typeof size === "function" ? size : (0, $f53b94ec46d9e16d$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $ahT4l.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $f53b94ec46d9e16d$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $f53b94ec46d9e16d$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("hNi5e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $cf450a3c0731ada3$var$sqrt3 = (0, $8EE7R.sqrt)(3);
var $cf450a3c0731ada3$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size + (0, $8EE7R.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $cf450a3c0731ada3$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $cf450a3c0731ada3$var$_default;

});

parcelRegister("80b5j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $5d36ebfe49ab4f39$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size / $8EE7R.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $8EE7R.tau);
    }
};
module.exports.default = $5d36ebfe49ab4f39$var$_default;

});

parcelRegister("34kQO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $23c1eb5d54df31fd$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $23c1eb5d54df31fd$var$_default;

});

parcelRegister("aSxHZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $7eb9185183e161be$var$tan30 = (0, $8EE7R.sqrt)(1 / 3);
const $7eb9185183e161be$var$tan30_2 = $7eb9185183e161be$var$tan30 * 2;
var $7eb9185183e161be$var$_default = {
    draw (context, size) {
        const y = (0, $8EE7R.sqrt)(size / $7eb9185183e161be$var$tan30_2);
        const x = y * $7eb9185183e161be$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $7eb9185183e161be$var$_default;

});

parcelRegister("3rBZo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $28215c91c44f670d$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $28215c91c44f670d$var$_default;

});

parcelRegister("l9ST9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $f67503ef4c2b53b7$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size - (0, $8EE7R.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $f67503ef4c2b53b7$var$_default;

});

parcelRegister("3oWT7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $27a14ae956ab4069$var$_default = {
    draw (context, size) {
        const w = (0, $8EE7R.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $27a14ae956ab4069$var$_default;

});

parcelRegister("k3QGU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $e9acf5d321c8d9b2$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $e9acf5d321c8d9b2$var$_default;

});

parcelRegister("1WZhf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $16babd934cfaf5dd$var$ka = 0.89081309152928522810;
const $16babd934cfaf5dd$var$kr = (0, $8EE7R.sin)($8EE7R.pi / 10) / (0, $8EE7R.sin)(7 * $8EE7R.pi / 10);
const $16babd934cfaf5dd$var$kx = (0, $8EE7R.sin)($8EE7R.tau / 10) * $16babd934cfaf5dd$var$kr;
const $16babd934cfaf5dd$var$ky = -(0, $8EE7R.cos)($8EE7R.tau / 10) * $16babd934cfaf5dd$var$kr;
var $16babd934cfaf5dd$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size * $16babd934cfaf5dd$var$ka);
        const x = $16babd934cfaf5dd$var$kx * r;
        const y = $16babd934cfaf5dd$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $8EE7R.tau * i / 5;
            const c = (0, $8EE7R.cos)(a);
            const s = (0, $8EE7R.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $16babd934cfaf5dd$var$_default;

});

parcelRegister("hQr8g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $cfdc56e10135b109$var$sqrt3 = (0, $8EE7R.sqrt)(3);
var $cfdc56e10135b109$var$_default = {
    draw (context, size) {
        const y = -(0, $8EE7R.sqrt)(size / ($cfdc56e10135b109$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$cfdc56e10135b109$var$sqrt3 * y, -y);
        context.lineTo($cfdc56e10135b109$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $cfdc56e10135b109$var$_default;

});

parcelRegister("NGszi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $095583585e5011bc$var$sqrt3 = (0, $8EE7R.sqrt)(3);
var $095583585e5011bc$var$_default = {
    draw (context, size) {
        const s = (0, $8EE7R.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $095583585e5011bc$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $095583585e5011bc$var$_default;

});

parcelRegister("7fYkN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $5488bc434537f81a$var$c = -0.5;
const $5488bc434537f81a$var$s = (0, $8EE7R.sqrt)(3) / 2;
const $5488bc434537f81a$var$k = 1 / (0, $8EE7R.sqrt)(12);
const $5488bc434537f81a$var$a = ($5488bc434537f81a$var$k / 2 + 1) * 3;
var $5488bc434537f81a$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size / $5488bc434537f81a$var$a);
        const x0 = r / 2, y0 = r * $5488bc434537f81a$var$k;
        const x1 = x0, y1 = r * $5488bc434537f81a$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($5488bc434537f81a$var$c * x0 - $5488bc434537f81a$var$s * y0, $5488bc434537f81a$var$s * x0 + $5488bc434537f81a$var$c * y0);
        context.lineTo($5488bc434537f81a$var$c * x1 - $5488bc434537f81a$var$s * y1, $5488bc434537f81a$var$s * x1 + $5488bc434537f81a$var$c * y1);
        context.lineTo($5488bc434537f81a$var$c * x2 - $5488bc434537f81a$var$s * y2, $5488bc434537f81a$var$s * x2 + $5488bc434537f81a$var$c * y2);
        context.lineTo($5488bc434537f81a$var$c * x0 + $5488bc434537f81a$var$s * y0, $5488bc434537f81a$var$c * y0 - $5488bc434537f81a$var$s * x0);
        context.lineTo($5488bc434537f81a$var$c * x1 + $5488bc434537f81a$var$s * y1, $5488bc434537f81a$var$c * y1 - $5488bc434537f81a$var$s * x1);
        context.lineTo($5488bc434537f81a$var$c * x2 + $5488bc434537f81a$var$s * y2, $5488bc434537f81a$var$c * y2 - $5488bc434537f81a$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $5488bc434537f81a$var$_default;

});

parcelRegister("3oXF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $27a1e47f32a4af98$var$_default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size - (0, $8EE7R.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $27a1e47f32a4af98$var$_default;

});


parcelRegister("a65kp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $759e98ff97b5ba2e$var$_default;

var $759e98ff97b5ba2e$var$_noop = $759e98ff97b5ba2e$var$_interopRequireDefault((parcelRequire("9Id5q")));

var $4MmJ6 = parcelRequire("4MmJ6");
function $759e98ff97b5ba2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $759e98ff97b5ba2e$var$BasisClosed(context) {
    this._context = context;
}
$759e98ff97b5ba2e$var$BasisClosed.prototype = {
    areaStart: $759e98ff97b5ba2e$var$_noop.default,
    areaEnd: $759e98ff97b5ba2e$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $4MmJ6.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $759e98ff97b5ba2e$var$_default(context) {
    return new $759e98ff97b5ba2e$var$BasisClosed(context);
}

});
parcelRegister("9Id5q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71225fd811f521df$var$_default;
function $71225fd811f521df$var$_default() {}

});

parcelRegister("4MmJ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $37ad461e07222a10$var$Basis;
module.exports.default = $37ad461e07222a10$var$_default;
module.exports.point = $37ad461e07222a10$var$point;
function $37ad461e07222a10$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $37ad461e07222a10$var$Basis(context) {
    this._context = context;
}
$37ad461e07222a10$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $37ad461e07222a10$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $37ad461e07222a10$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $37ad461e07222a10$var$_default(context) {
    return new $37ad461e07222a10$var$Basis(context);
}

});


parcelRegister("aFwZp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c4752bb83e8ecae$var$_default;

var $4MmJ6 = parcelRequire("4MmJ6");
function $7c4752bb83e8ecae$var$BasisOpen(context) {
    this._context = context;
}
$7c4752bb83e8ecae$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $4MmJ6.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $7c4752bb83e8ecae$var$_default(context) {
    return new $7c4752bb83e8ecae$var$BasisOpen(context);
}

});

parcelRegister("1uOPP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4MmJ6 = parcelRequire("4MmJ6");
function $117006928d6a0b46$var$Bundle(context, beta) {
    this._basis = new $4MmJ6.Basis(context);
    this._beta = beta;
}
$117006928d6a0b46$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $117006928d6a0b46$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $4MmJ6.Basis(context) : new $117006928d6a0b46$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $117006928d6a0b46$var$_default;

});

parcelRegister("1RBVE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $15b8298ff61d0817$var$CardinalClosed;
module.exports.default = void 0;

var $15b8298ff61d0817$var$_noop = $15b8298ff61d0817$var$_interopRequireDefault((parcelRequire("9Id5q")));

var $8MEVA = parcelRequire("8MEVA");
function $15b8298ff61d0817$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $15b8298ff61d0817$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$15b8298ff61d0817$var$CardinalClosed.prototype = {
    areaStart: $15b8298ff61d0817$var$_noop.default,
    areaEnd: $15b8298ff61d0817$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $8MEVA.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $15b8298ff61d0817$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $15b8298ff61d0817$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $15b8298ff61d0817$var$_default;

});
parcelRegister("8MEVA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $66528dd5d1af4c7e$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $66528dd5d1af4c7e$var$point;
function $66528dd5d1af4c7e$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $66528dd5d1af4c7e$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$66528dd5d1af4c7e$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $66528dd5d1af4c7e$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $66528dd5d1af4c7e$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $66528dd5d1af4c7e$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $66528dd5d1af4c7e$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $66528dd5d1af4c7e$var$_default;

});


parcelRegister("88R3u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $5ed839c05fa37c42$var$CardinalOpen;
module.exports.default = void 0;

var $8MEVA = parcelRequire("8MEVA");
function $5ed839c05fa37c42$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$5ed839c05fa37c42$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $8MEVA.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $5ed839c05fa37c42$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $5ed839c05fa37c42$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $5ed839c05fa37c42$var$_default;

});

parcelRegister("63Rg9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1RBVE = parcelRequire("1RBVE");

var $469c561ba2a63423$var$_noop = $469c561ba2a63423$var$_interopRequireDefault((parcelRequire("9Id5q")));

var $jeCIz = parcelRequire("jeCIz");
function $469c561ba2a63423$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $469c561ba2a63423$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$469c561ba2a63423$var$CatmullRomClosed.prototype = {
    areaStart: $469c561ba2a63423$var$_noop.default,
    areaEnd: $469c561ba2a63423$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $jeCIz.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $469c561ba2a63423$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $469c561ba2a63423$var$CatmullRomClosed(context, alpha) : new $1RBVE.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $469c561ba2a63423$var$_default;

});
parcelRegister("jeCIz", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $8EE7R = parcelRequire("8EE7R");

var $8MEVA = parcelRequire("8MEVA");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $8EE7R.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $8EE7R.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $8MEVA.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("4JV2s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88R3u = parcelRequire("88R3u");

var $jeCIz = parcelRequire("jeCIz");
function $37379c0e81acd368$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$37379c0e81acd368$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $jeCIz.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $37379c0e81acd368$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $37379c0e81acd368$var$CatmullRomOpen(context, alpha) : new $88R3u.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $37379c0e81acd368$var$_default;

});

parcelRegister("7HCNf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $59baa41516fc43b4$var$_default;

var $59baa41516fc43b4$var$_noop = $59baa41516fc43b4$var$_interopRequireDefault((parcelRequire("9Id5q")));
function $59baa41516fc43b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $59baa41516fc43b4$var$LinearClosed(context) {
    this._context = context;
}
$59baa41516fc43b4$var$LinearClosed.prototype = {
    areaStart: $59baa41516fc43b4$var$_noop.default,
    areaEnd: $59baa41516fc43b4$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $59baa41516fc43b4$var$_default(context) {
    return new $59baa41516fc43b4$var$LinearClosed(context);
}

});

parcelRegister("eqBPr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $a810d6679ecb238b$var$monotoneX;
module.exports.monotoneY = $a810d6679ecb238b$var$monotoneY;
function $a810d6679ecb238b$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $a810d6679ecb238b$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($a810d6679ecb238b$var$sign(s0) + $a810d6679ecb238b$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $a810d6679ecb238b$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $a810d6679ecb238b$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $a810d6679ecb238b$var$MonotoneX(context) {
    this._context = context;
}
$a810d6679ecb238b$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $a810d6679ecb238b$var$point(this, this._t0, $a810d6679ecb238b$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $a810d6679ecb238b$var$point(this, $a810d6679ecb238b$var$slope2(this, t1 = $a810d6679ecb238b$var$slope3(this, x, y)), t1);
                break;
            default:
                $a810d6679ecb238b$var$point(this, this._t0, t1 = $a810d6679ecb238b$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $a810d6679ecb238b$var$MonotoneY(context) {
    this._context = new $a810d6679ecb238b$var$ReflectContext(context);
}
($a810d6679ecb238b$var$MonotoneY.prototype = Object.create($a810d6679ecb238b$var$MonotoneX.prototype)).point = function(x, y) {
    $a810d6679ecb238b$var$MonotoneX.prototype.point.call(this, y, x);
};
function $a810d6679ecb238b$var$ReflectContext(context) {
    this._context = context;
}
$a810d6679ecb238b$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $a810d6679ecb238b$var$monotoneX(context) {
    return new $a810d6679ecb238b$var$MonotoneX(context);
}
function $a810d6679ecb238b$var$monotoneY(context) {
    return new $a810d6679ecb238b$var$MonotoneY(context);
}

});

parcelRegister("dY7QQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a2b6f811606136fa$var$_default;
function $a2b6f811606136fa$var$Natural(context) {
    this._context = context;
}
$a2b6f811606136fa$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $a2b6f811606136fa$var$controlPoints(x), py = $a2b6f811606136fa$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $a2b6f811606136fa$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $a2b6f811606136fa$var$_default(context) {
    return new $a2b6f811606136fa$var$Natural(context);
}

});

parcelRegister("llSQy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8b61a9052882a76$var$_default;
module.exports.stepAfter = $f8b61a9052882a76$var$stepAfter;
module.exports.stepBefore = $f8b61a9052882a76$var$stepBefore;
function $f8b61a9052882a76$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$f8b61a9052882a76$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $f8b61a9052882a76$var$_default(context) {
    return new $f8b61a9052882a76$var$Step(context, 0.5);
}
function $f8b61a9052882a76$var$stepBefore(context) {
    return new $f8b61a9052882a76$var$Step(context, 0);
}
function $f8b61a9052882a76$var$stepAfter(context) {
    return new $f8b61a9052882a76$var$Step(context, 1);
}

});

parcelRegister("l6qno", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5ce9e484cf7993d$var$_default;

var $f5ce9e484cf7993d$var$_array = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("72xzV")));

var $f5ce9e484cf7993d$var$_constant = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $f5ce9e484cf7993d$var$_none = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("7CMPN")));

var $f5ce9e484cf7993d$var$_none2 = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $f5ce9e484cf7993d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f5ce9e484cf7993d$var$stackValue(d, key) {
    return d[key];
}
function $f5ce9e484cf7993d$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $f5ce9e484cf7993d$var$_default() {
    var keys = (0, $f5ce9e484cf7993d$var$_constant.default)([]), order = $f5ce9e484cf7993d$var$_none2.default, offset = $f5ce9e484cf7993d$var$_none.default, value = $f5ce9e484cf7993d$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $f5ce9e484cf7993d$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $f5ce9e484cf7993d$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $f5ce9e484cf7993d$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $f5ce9e484cf7993d$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $f5ce9e484cf7993d$var$_none2.default : typeof _ === "function" ? _ : (0, $f5ce9e484cf7993d$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $f5ce9e484cf7993d$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("7CMPN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58d1f689330b7a76$var$_default;
function $58d1f689330b7a76$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("5Nf2s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $437d31b0a43c0970$var$_default;
function $437d31b0a43c0970$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("fpjqO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b378437dd6c974d0$var$_default;

var $b378437dd6c974d0$var$_none = $b378437dd6c974d0$var$_interopRequireDefault((parcelRequire("7CMPN")));
function $b378437dd6c974d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b378437dd6c974d0$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $b378437dd6c974d0$var$_none.default)(series, order);
}

});

parcelRegister("l5EV1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5a9ce2ee69901dc$var$_default;
function $f5a9ce2ee69901dc$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("4ViQy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $395b1adc41e49f8c$var$_default;

var $395b1adc41e49f8c$var$_none = $395b1adc41e49f8c$var$_interopRequireDefault((parcelRequire("7CMPN")));
function $395b1adc41e49f8c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $395b1adc41e49f8c$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $395b1adc41e49f8c$var$_none.default)(series, order);
}

});

parcelRegister("fIpqC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b70eb098f6aa193f$var$_default;

var $b70eb098f6aa193f$var$_none = $b70eb098f6aa193f$var$_interopRequireDefault((parcelRequire("7CMPN")));
function $b70eb098f6aa193f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b70eb098f6aa193f$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $b70eb098f6aa193f$var$_none.default)(series, order);
}

});

parcelRegister("5qWRn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f4d09d5c255cbed$var$_default;

var $3f4d09d5c255cbed$var$_none = $3f4d09d5c255cbed$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $3f4d09d5c255cbed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f4d09d5c255cbed$var$_default(series) {
    var peaks = series.map($3f4d09d5c255cbed$var$peak);
    return (0, $3f4d09d5c255cbed$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $3f4d09d5c255cbed$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("klspr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ecfbce4dec6048ef$var$_default;
module.exports.sum = $ecfbce4dec6048ef$var$sum;

var $ecfbce4dec6048ef$var$_none = $ecfbce4dec6048ef$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $ecfbce4dec6048ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ecfbce4dec6048ef$var$_default(series) {
    var sums = series.map($ecfbce4dec6048ef$var$sum);
    return (0, $ecfbce4dec6048ef$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $ecfbce4dec6048ef$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("kwAJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef1348de13f9b72a$var$_default;

var $ef1348de13f9b72a$var$_ascending = $ef1348de13f9b72a$var$_interopRequireDefault((parcelRequire("klspr")));
function $ef1348de13f9b72a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ef1348de13f9b72a$var$_default(series) {
    return (0, $ef1348de13f9b72a$var$_ascending.default)(series).reverse();
}

});

parcelRegister("4fWJp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31961efae4ac3cd9$var$_default;

var $31961efae4ac3cd9$var$_appearance = $31961efae4ac3cd9$var$_interopRequireDefault((parcelRequire("5qWRn")));

var $klspr = parcelRequire("klspr");
function $31961efae4ac3cd9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $31961efae4ac3cd9$var$_default(series) {
    var n = series.length, i, j, sums = series.map($klspr.sum), order = (0, $31961efae4ac3cd9$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("aFPqy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c55a01e302bb624$var$_default;

var $7c55a01e302bb624$var$_none = $7c55a01e302bb624$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $7c55a01e302bb624$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c55a01e302bb624$var$_default(series) {
    return (0, $7c55a01e302bb624$var$_none.default)(series).reverse();
}

});



parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});


parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("f1q41", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("MqLpf", function(module, exports) {

$parcel$export(module.exports, "array", () => array);
$parcel$export(module.exports, "string", () => string);
$parcel$export(module.exports, "number", () => number);
$parcel$export(module.exports, "boolean", () => boolean);
$parcel$export(module.exports, "unknown", () => unknown);
$parcel$export(module.exports, "enum", () => _enum);
$parcel$export(module.exports, "object", () => object);
$parcel$export(module.exports, "discriminatedUnion", () => discriminatedUnion);
$parcel$export(module.exports, "record", () => record);
$parcel$export(module.exports, "literal", () => literal);

var $7w6aQ = parcelRequire("7w6aQ");
var $5SN0M = parcelRequire("5SN0M");
var $jvcvr = parcelRequire("jvcvr");
var $ggkLI = parcelRequire("ggkLI");
var $23ixW = parcelRequire("23ixW");
var $5VtTM = parcelRequire("5VtTM");
var $g96lk = parcelRequire("g96lk");
var $dZBpt = parcelRequire("dZBpt");

var $lA7b0 = parcelRequire("lA7b0");

var $jSi9q = parcelRequire("jSi9q");

var $lp4KX = parcelRequire("lp4KX");

var $7w6aQ = parcelRequire("7w6aQ");

var $lLi5e = parcelRequire("lLi5e");
var $57W0y = parcelRequire("57W0y");
// Register English as the default locale on first ZodType construction. Hooked into the `ZodType` `$constructor` (rather than a top-level `config(en())` in `external.ts`) so bundlers honoring `sideEffects: false` can't tree-shake it out — see #5953, #5725. An explicit `z.config(z.locales.xx())` call wins regardless of order, since this only sets the default when none is present.
function _ensureDefaultLocale() {
    if (!$5SN0M.globalConfig.localeError) $5SN0M.config((0, $lp4KX.default)());
}
// the default memoizer is read by the core container init, which runs before `ZodType.init`, so each container calls this first
function _ensureDefaultMemoizer() {
    if (!$5SN0M.globalConfig.memoizer) $5SN0M.config({
        memoizer: $g96lk.memoizer()
    });
}
const ZodType = /*@__PURE__*/ $5SN0M.$constructor("ZodType", (inst, def)=>{
    _ensureDefaultLocale();
    $jvcvr.$ZodType.init(inst, def);
    inst.def = def;
    inst.type = def.type;
    return inst;
}, {
    check (...chks) {
        const def = this.def;
        return this.clone((0, $23ixW).mergeDefs(def, {
            checks: [
                ...def.checks ?? [],
                ...chks.map((ch)=>typeof ch === "function" ? {
                        _zod: {
                            check: ch,
                            def: {
                                check: "custom"
                            },
                            onattach: []
                        }
                    } : ch)
            ]
        }), {
            parent: true
        });
    },
    with (...chks) {
        return this.check(...chks);
    },
    clone (def, params) {
        return $23ixW.clone(this, def, params);
    },
    brand () {
        return this;
    },
    register (reg, meta) {
        reg.add(this, meta);
        return this;
    },
    refine (check, params) {
        return this.check(refine(check, params));
    },
    superRefine (refinement, params) {
        return this.check(superRefine(refinement, params));
    },
    overwrite (fn) {
        return this.check($7w6aQ._overwrite(fn));
    },
    optional () {
        return optional(this);
    },
    exactOptional () {
        return exactOptional(this);
    },
    nullable () {
        return nullable(this);
    },
    nullish () {
        return optional(nullable(this));
    },
    nonoptional (params) {
        return nonoptional(this, params);
    },
    array () {
        return array(this);
    },
    or (arg) {
        return union([
            this,
            arg
        ]);
    },
    and (arg) {
        return intersection(this, arg);
    },
    transform (tx) {
        return pipe(this, transform(tx));
    },
    default (d) {
        return _default(this, d);
    },
    prefault (d) {
        return prefault(this, d);
    },
    catch (params) {
        return _catch(this, params);
    },
    pipe (target) {
        return pipe(this, target);
    },
    readonly () {
        return readonly(this);
    },
    describe (description) {
        const cl = this.clone();
        $5VtTM.globalRegistry.add(cl, {
            description: description
        });
        return cl;
    },
    meta (...args) {
        // overloaded: meta() returns the registered metadata, meta(data) returns a clone with `data` registered. The mapped type picks up the second overload, so we accept variadic any-args and return `any` to satisfy both at runtime.
        if (args.length === 0) return $5VtTM.globalRegistry.get(this);
        const cl = this.clone();
        $5VtTM.globalRegistry.add(cl, args[0]);
        return cl;
    },
    isOptional () {
        return this.safeParse(undefined).success;
    },
    isNullable () {
        return this.safeParse(null).success;
    },
    apply (fn, ...args) {
        return args.length === 0 ? fn(this) : fn(this, ...args);
    },
    // Overrides core's `~standard` to add `jsonSchema`. Must stay a prototype entry: redefining it per instance demotes instances to dictionary mode.
    get "~standard" () {
        return (0, $23ixW).hide(this, "~standard", {
            ...$jvcvr.standardProps(this),
            jsonSchema: {
                input: (0, $jSi9q.createStandardJSONSchemaMethod)(this, "input"),
                output: (0, $jSi9q.createStandardJSONSchemaMethod)(this, "output")
            }
        });
    },
    set "~standard" (value){
        (0, $23ixW).own(this, "~standard", value);
    },
    parse: function _parse(data, params) {
        return $lLi5e.parse(this, data, params, {
            callee: _parse
        });
    },
    parseAsync: async function _parseAsync(data, params) {
        return await $lLi5e.parseAsync(this, data, params, {
            callee: _parseAsync
        });
    },
    safeParse (data, params) {
        return $lLi5e.safeParse(this, data, params);
    },
    async safeParseAsync (data, params) {
        return $lLi5e.safeParseAsync(this, data, params);
    },
    // `spa` is an alias: same function object as `safeParseAsync`, as before.
    get spa () {
        return this?.safeParseAsync;
    },
    set spa (value){
        (0, $23ixW).own(this, "spa", value);
    },
    validate (data, params) {
        return $57W0y.validate(this, data, params);
    },
    validateAsync (data, params) {
        return $57W0y.validateAsync(this, data, params);
    },
    encode: function _encode(data, params) {
        return $lLi5e.encode(this, data, params, {
            callee: _encode
        });
    },
    decode: function _decode(data, params) {
        return $lLi5e.decode(this, data, params, {
            callee: _decode
        });
    },
    encodeAsync: async function _encodeAsync(data, params) {
        return await $lLi5e.encodeAsync(this, data, params, {
            callee: _encodeAsync
        });
    },
    decodeAsync: async function _decodeAsync(data, params) {
        return await $lLi5e.decodeAsync(this, data, params, {
            callee: _decodeAsync
        });
    },
    safeEncode (data, params) {
        return $lLi5e.safeEncode(this, data, params);
    },
    safeDecode (data, params) {
        return $lLi5e.safeDecode(this, data, params);
    },
    async safeEncodeAsync (data, params) {
        return $lLi5e.safeEncodeAsync(this, data, params);
    },
    async safeDecodeAsync (data, params) {
        return $lLi5e.safeDecodeAsync(this, data, params);
    },
    toJSONSchema (params) {
        return (0, $jSi9q.createToJSONSchemaMethod)(this, {})(params);
    },
    // Reads through to the registry on every access, so it must not cache.
    get description () {
        return $5VtTM.globalRegistry.get(this)?.description;
    },
    // No setter: `schema._def = x` throws, as it did when `_def` was a non-writable own property.
    get _def () {
        return this._zod.def;
    }
});
const _ZodString = /*@__PURE__*/ $5SN0M.$constructor("_ZodString", (inst, def)=>{
    $jvcvr.$ZodString.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.stringProcessor(inst, ctx, json, params);
}, /*@__PURE__*/ (0, $23ixW).derived({
    format: (inst)=>$lA7b0.aggregateChecks(inst).format ?? null,
    minLength: (inst)=>$lA7b0.aggregateChecks(inst).minimum ?? null,
    maxLength: (inst)=>$lA7b0.aggregateChecks(inst).maximum ?? null
}, {
    regex (...args) {
        return this.check($7w6aQ._regex(...args));
    },
    includes (...args) {
        return this.check($7w6aQ._includes(...args));
    },
    startsWith (...args) {
        return this.check($7w6aQ._startsWith(...args));
    },
    endsWith (...args) {
        return this.check($7w6aQ._endsWith(...args));
    },
    min (...args) {
        return this.check($7w6aQ._minLength(...args));
    },
    max (...args) {
        return this.check($7w6aQ._maxLength(...args));
    },
    length (...args) {
        return this.check($7w6aQ._length(...args));
    },
    nonempty (...args) {
        return this.check($7w6aQ._minLength(1, ...args));
    },
    lowercase (params) {
        return this.check($7w6aQ._lowercase(params));
    },
    uppercase (params) {
        return this.check($7w6aQ._uppercase(params));
    },
    trim () {
        return this.check($7w6aQ._trim());
    },
    normalize (...args) {
        return this.check($7w6aQ._normalize(...args));
    },
    toLowerCase () {
        return this.check($7w6aQ._toLowerCase());
    },
    toUpperCase () {
        return this.check($7w6aQ._toUpperCase());
    },
    slugify () {
        return this.check($7w6aQ._slugify());
    }
}));
const ZodString = /*@__PURE__*/ $5SN0M.$constructor("ZodString", (inst, def)=>{
    $jvcvr.$ZodString.init(inst, def);
    _ZodString.init(inst, def);
}, {
    email (params) {
        return this.check($7w6aQ._email(ZodEmail, params));
    },
    url (params) {
        return this.check($7w6aQ._url(ZodURL, params));
    },
    jwt (params) {
        return this.check($7w6aQ._jwt(ZodJWT, params));
    },
    emoji (params) {
        return this.check($7w6aQ._emoji(ZodEmoji, params));
    },
    guid (params) {
        return this.check($7w6aQ._guid(ZodGUID, params));
    },
    uuid (params) {
        return this.check($7w6aQ._uuid(ZodUUID, params));
    },
    uuidv4 (params) {
        return this.check($7w6aQ._uuidv4(ZodUUID, params));
    },
    uuidv6 (params) {
        return this.check($7w6aQ._uuidv6(ZodUUID, params));
    },
    uuidv7 (params) {
        return this.check($7w6aQ._uuidv7(ZodUUID, params));
    },
    nanoid (params) {
        return this.check($7w6aQ._nanoid(ZodNanoID, params));
    },
    cuid (params) {
        return this.check($7w6aQ._cuid(ZodCUID, params));
    },
    cuid2 (params) {
        return this.check($7w6aQ._cuid2(ZodCUID2, params));
    },
    ulid (params) {
        return this.check($7w6aQ._ulid(ZodULID, params));
    },
    base64 (params) {
        return this.check($7w6aQ._base64(ZodBase64, params));
    },
    base64url (params) {
        return this.check($7w6aQ._base64url(ZodBase64URL, params));
    },
    xid (params) {
        return this.check($7w6aQ._xid(ZodXID, params));
    },
    ksuid (params) {
        return this.check($7w6aQ._ksuid(ZodKSUID, params));
    },
    ipv4 (params) {
        return this.check($7w6aQ._ipv4(ZodIPv4, params));
    },
    ipv6 (params) {
        return this.check($7w6aQ._ipv6(ZodIPv6, params));
    },
    cidrv4 (params) {
        return this.check($7w6aQ._cidrv4(ZodCIDRv4, params));
    },
    cidrv6 (params) {
        return this.check($7w6aQ._cidrv6(ZodCIDRv6, params));
    },
    e164 (params) {
        return this.check($7w6aQ._e164(ZodE164, params));
    },
    datetime (params) {
        return this.check($7w6aQ._isoDateTime(ZodISODateTime, params));
    },
    date (params) {
        return this.check($7w6aQ._isoDate(ZodISODate, params));
    },
    time (params) {
        return this.check($7w6aQ._isoTime(ZodISOTime, params));
    },
    duration (params) {
        return this.check($7w6aQ._isoDuration(ZodISODuration, params));
    }
});
function string(params) {
    return $7w6aQ._string(ZodString, params);
}
const ZodStringFormat = /*@__PURE__*/ $5SN0M.$constructor("ZodStringFormat", (inst, def)=>{
    $jvcvr.$ZodStringFormat.init(inst, def);
    _ZodString.init(inst, def);
});
const ZodISODateTime = /*@__PURE__*/ $5SN0M.$constructor("ZodISODateTime", (inst, def)=>{
    $jvcvr.$ZodISODateTime.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodISODate = /*@__PURE__*/ $5SN0M.$constructor("ZodISODate", (inst, def)=>{
    $jvcvr.$ZodISODate.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodISOTime = /*@__PURE__*/ $5SN0M.$constructor("ZodISOTime", (inst, def)=>{
    $jvcvr.$ZodISOTime.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodISODuration = /*@__PURE__*/ $5SN0M.$constructor("ZodISODuration", (inst, def)=>{
    $jvcvr.$ZodISODuration.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodEmail = /*@__PURE__*/ $5SN0M.$constructor("ZodEmail", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodEmail.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function email(params) {
    return $7w6aQ._email(ZodEmail, params);
}
const ZodGUID = /*@__PURE__*/ $5SN0M.$constructor("ZodGUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodGUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function guid(params) {
    return $7w6aQ._guid(ZodGUID, params);
}
const ZodUUID = /*@__PURE__*/ $5SN0M.$constructor("ZodUUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodUUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function uuid(params) {
    return $7w6aQ._uuid(ZodUUID, params);
}
function uuidv4(params) {
    return $7w6aQ._uuidv4(ZodUUID, params);
}
function uuidv6(params) {
    return $7w6aQ._uuidv6(ZodUUID, params);
}
function uuidv7(params) {
    return $7w6aQ._uuidv7(ZodUUID, params);
}
const ZodURL = /*@__PURE__*/ $5SN0M.$constructor("ZodURL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodURL.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function url(params) {
    return $7w6aQ._url(ZodURL, params);
}
function httpUrl(params) {
    return $7w6aQ._url(ZodURL, {
        protocol: $dZBpt.httpProtocol,
        hostname: $dZBpt.domain,
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodEmoji = /*@__PURE__*/ $5SN0M.$constructor("ZodEmoji", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodEmoji.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function emoji(params) {
    return $7w6aQ._emoji(ZodEmoji, params);
}
const ZodNanoID = /*@__PURE__*/ $5SN0M.$constructor("ZodNanoID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodNanoID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function nanoid(params) {
    return $7w6aQ._nanoid(ZodNanoID, params);
}
const ZodCUID = /*@__PURE__*/ $5SN0M.$constructor("ZodCUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodCUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cuid(params) {
    return $7w6aQ._cuid(ZodCUID, params);
}
const ZodCUID2 = /*@__PURE__*/ $5SN0M.$constructor("ZodCUID2", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodCUID2.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cuid2(params) {
    return $7w6aQ._cuid2(ZodCUID2, params);
}
const ZodULID = /*@__PURE__*/ $5SN0M.$constructor("ZodULID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodULID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ulid(params) {
    return $7w6aQ._ulid(ZodULID, params);
}
const ZodXID = /*@__PURE__*/ $5SN0M.$constructor("ZodXID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodXID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function xid(params) {
    return $7w6aQ._xid(ZodXID, params);
}
const ZodKSUID = /*@__PURE__*/ $5SN0M.$constructor("ZodKSUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodKSUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ksuid(params) {
    return $7w6aQ._ksuid(ZodKSUID, params);
}
const ZodIPv4 = /*@__PURE__*/ $5SN0M.$constructor("ZodIPv4", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodIPv4.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ipv4(params) {
    return $7w6aQ._ipv4(ZodIPv4, params);
}
const ZodMAC = /*@__PURE__*/ $5SN0M.$constructor("ZodMAC", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodMAC.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function mac(params) {
    return $7w6aQ._mac(ZodMAC, params);
}
const ZodIPv6 = /*@__PURE__*/ $5SN0M.$constructor("ZodIPv6", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodIPv6.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ipv6(params) {
    return $7w6aQ._ipv6(ZodIPv6, params);
}
const ZodCIDRv4 = /*@__PURE__*/ $5SN0M.$constructor("ZodCIDRv4", (inst, def)=>{
    $jvcvr.$ZodCIDRv4.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cidrv4(params) {
    return $7w6aQ._cidrv4(ZodCIDRv4, params);
}
const ZodCIDRv6 = /*@__PURE__*/ $5SN0M.$constructor("ZodCIDRv6", (inst, def)=>{
    $jvcvr.$ZodCIDRv6.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cidrv6(params) {
    return $7w6aQ._cidrv6(ZodCIDRv6, params);
}
const ZodBase64 = /*@__PURE__*/ $5SN0M.$constructor("ZodBase64", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodBase64.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function base64(params) {
    return $7w6aQ._base64(ZodBase64, params);
}
const ZodBase64URL = /*@__PURE__*/ $5SN0M.$constructor("ZodBase64URL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodBase64URL.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function base64url(params) {
    return $7w6aQ._base64url(ZodBase64URL, params);
}
const ZodE164 = /*@__PURE__*/ $5SN0M.$constructor("ZodE164", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodE164.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function e164(params) {
    return $7w6aQ._e164(ZodE164, params);
}
const ZodCreditCard = /*@__PURE__*/ $5SN0M.$constructor("ZodCreditCard", (inst, def)=>{
    $jvcvr.$ZodCreditCard.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function creditCard(params) {
    return $7w6aQ._creditCard(ZodCreditCard, params);
}
const ZodIBAN = /*@__PURE__*/ $5SN0M.$constructor("ZodIBAN", (inst, def)=>{
    $jvcvr.$ZodIBAN.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function iban(params) {
    return $7w6aQ._iban(ZodIBAN, params);
}
const ZodJWT = /*@__PURE__*/ $5SN0M.$constructor("ZodJWT", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodJWT.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function jwt(params) {
    return $7w6aQ._jwt(ZodJWT, params);
}
const ZodCustomStringFormat = /*@__PURE__*/ $5SN0M.$constructor("ZodCustomStringFormat", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $jvcvr.$ZodCustomStringFormat.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function stringFormat(format, fnOrRegex, _params = {}) {
    return $7w6aQ._stringFormat(ZodCustomStringFormat, format, fnOrRegex, _params);
}
function hostname(_params) {
    return $7w6aQ._stringFormat(ZodCustomStringFormat, "hostname", $dZBpt.hostname, _params);
}
function hex(_params) {
    return $7w6aQ._stringFormat(ZodCustomStringFormat, "hex", $dZBpt.hex, _params);
}
function hash(alg, params) {
    const enc = params?.enc ?? "hex";
    const format = `${alg}_${enc}`;
    const regex = $dZBpt[format];
    if (!regex) throw new Error(`Unrecognized hash format: ${format}`);
    return $7w6aQ._stringFormat(ZodCustomStringFormat, format, regex, params);
}
const ZodNumber = /*@__PURE__*/ $5SN0M.$constructor("ZodNumber", (inst, def)=>{
    $jvcvr.$ZodNumber.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.numberProcessor(inst, ctx, json, params);
    inst.isFinite = true;
}, /*@__PURE__*/ (0, $23ixW).derived({
    minValue: (inst)=>{
        const { minimum, exclusiveMinimum } = $lA7b0.aggregateChecks(inst);
        return Math.max(minimum ?? Number.NEGATIVE_INFINITY, exclusiveMinimum ?? Number.NEGATIVE_INFINITY);
    },
    maxValue: (inst)=>{
        const { maximum, exclusiveMaximum } = $lA7b0.aggregateChecks(inst);
        return Math.min(maximum ?? Number.POSITIVE_INFINITY, exclusiveMaximum ?? Number.POSITIVE_INFINITY);
    },
    isInt: (inst)=>{
        const { isInt, multipleOf } = $lA7b0.aggregateChecks(inst);
        return !!isInt || !!multipleOf?.some(Number.isSafeInteger);
    },
    format: (inst)=>$lA7b0.aggregateChecks(inst).format ?? null
}, {
    gt (value1, params) {
        return this.check($7w6aQ._gt(value1, params));
    },
    gte (value1, params) {
        return this.check($7w6aQ._gte(value1, params));
    },
    min (value1, params) {
        return this.check($7w6aQ._gte(value1, params));
    },
    lt (value1, params) {
        return this.check($7w6aQ._lt(value1, params));
    },
    lte (value1, params) {
        return this.check($7w6aQ._lte(value1, params));
    },
    max (value1, params) {
        return this.check($7w6aQ._lte(value1, params));
    },
    int (params) {
        return this.check(int(params));
    },
    safe (params) {
        return this.check(int(params));
    },
    positive (params) {
        return this.check($7w6aQ._gt(0, params));
    },
    nonnegative (params) {
        return this.check($7w6aQ._gte(0, params));
    },
    negative (params) {
        return this.check($7w6aQ._lt(0, params));
    },
    nonpositive (params) {
        return this.check($7w6aQ._lte(0, params));
    },
    multipleOf (value1, params) {
        return this.check($7w6aQ._multipleOf(value1, params));
    },
    step (value1, params) {
        return this.check($7w6aQ._multipleOf(value1, params));
    },
    finite () {
        return this;
    }
}));
function number(params) {
    return $7w6aQ._number(ZodNumber, params);
}
const ZodNumberFormat = /*@__PURE__*/ $5SN0M.$constructor("ZodNumberFormat", (inst, def)=>{
    $jvcvr.$ZodNumberFormat.init(inst, def);
    ZodNumber.init(inst, def);
});
function int(params) {
    return $7w6aQ._int(ZodNumberFormat, params);
}
function float32(params) {
    return $7w6aQ._float32(ZodNumberFormat, params);
}
function float64(params) {
    return $7w6aQ._float64(ZodNumberFormat, params);
}
function int32(params) {
    return $7w6aQ._int32(ZodNumberFormat, params);
}
function uint32(params) {
    return $7w6aQ._uint32(ZodNumberFormat, params);
}
const ZodBoolean = /*@__PURE__*/ $5SN0M.$constructor("ZodBoolean", (inst, def)=>{
    $jvcvr.$ZodBoolean.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.booleanProcessor(inst, ctx, json, params);
});
function boolean(params) {
    return $7w6aQ._boolean(ZodBoolean, params);
}
const ZodBigInt = /*@__PURE__*/ $5SN0M.$constructor("ZodBigInt", (inst, def)=>{
    $jvcvr.$ZodBigInt.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.bigintProcessor(inst, ctx, json, params);
}, /*@__PURE__*/ (0, $23ixW).derived({
    minValue: (inst)=>$lA7b0.aggregateChecks(inst).minimum ?? null,
    maxValue: (inst)=>$lA7b0.aggregateChecks(inst).maximum ?? null,
    format: (inst)=>$lA7b0.aggregateChecks(inst).format ?? null
}, {
    gte (value1, params) {
        return this.check($7w6aQ._gte(value1, params));
    },
    min (value1, params) {
        return this.check($7w6aQ._gte(value1, params));
    },
    gt (value1, params) {
        return this.check($7w6aQ._gt(value1, params));
    },
    lt (value1, params) {
        return this.check($7w6aQ._lt(value1, params));
    },
    lte (value1, params) {
        return this.check($7w6aQ._lte(value1, params));
    },
    max (value1, params) {
        return this.check($7w6aQ._lte(value1, params));
    },
    positive (params) {
        return this.check($7w6aQ._gt(BigInt(0), params));
    },
    negative (params) {
        return this.check($7w6aQ._lt(BigInt(0), params));
    },
    nonpositive (params) {
        return this.check($7w6aQ._lte(BigInt(0), params));
    },
    nonnegative (params) {
        return this.check($7w6aQ._gte(BigInt(0), params));
    },
    multipleOf (value1, params) {
        return this.check($7w6aQ._multipleOf(value1, params));
    }
}));
function bigint(params) {
    return $7w6aQ._bigint(ZodBigInt, params);
}
const ZodBigIntFormat = /*@__PURE__*/ $5SN0M.$constructor("ZodBigIntFormat", (inst, def)=>{
    $jvcvr.$ZodBigIntFormat.init(inst, def);
    ZodBigInt.init(inst, def);
});
function int64(params) {
    return $7w6aQ._int64(ZodBigIntFormat, params);
}
function uint64(params) {
    return $7w6aQ._uint64(ZodBigIntFormat, params);
}
const ZodSymbol = /*@__PURE__*/ $5SN0M.$constructor("ZodSymbol", (inst, def)=>{
    $jvcvr.$ZodSymbol.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.symbolProcessor(inst, ctx, json, params);
});
function symbol(params) {
    return $7w6aQ._symbol(ZodSymbol, params);
}
const ZodUndefined = /*@__PURE__*/ $5SN0M.$constructor("ZodUndefined", (inst, def)=>{
    $jvcvr.$ZodUndefined.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.undefinedProcessor(inst, ctx, json, params);
});
function _undefined(params) {
    return $7w6aQ._undefined(ZodUndefined, params);
}
const ZodNull = /*@__PURE__*/ $5SN0M.$constructor("ZodNull", (inst, def)=>{
    $jvcvr.$ZodNull.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.nullProcessor(inst, ctx, json, params);
});
function _null(params) {
    return $7w6aQ._null(ZodNull, params);
}
const ZodAny = /*@__PURE__*/ $5SN0M.$constructor("ZodAny", (inst, def)=>{
    $jvcvr.$ZodAny.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.anyProcessor(inst, ctx, json, params);
});
function any() {
    return $7w6aQ._any(ZodAny);
}
const ZodUnknown = /*@__PURE__*/ $5SN0M.$constructor("ZodUnknown", (inst, def)=>{
    $jvcvr.$ZodUnknown.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.unknownProcessor(inst, ctx, json, params);
});
function unknown() {
    return $7w6aQ._unknown(ZodUnknown);
}
const ZodNever = /*@__PURE__*/ $5SN0M.$constructor("ZodNever", (inst, def)=>{
    $jvcvr.$ZodNever.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.neverProcessor(inst, ctx, json, params);
});
function never(params) {
    return $7w6aQ._never(ZodNever, params);
}
const ZodVoid = /*@__PURE__*/ $5SN0M.$constructor("ZodVoid", (inst, def)=>{
    $jvcvr.$ZodVoid.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.voidProcessor(inst, ctx, json, params);
});
function _void(params) {
    return $7w6aQ._void(ZodVoid, params);
}
const ZodDate = /*@__PURE__*/ $5SN0M.$constructor("ZodDate", (inst, def)=>{
    $jvcvr.$ZodDate.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.dateProcessor(inst, ctx, json, params);
    inst.min = (value1, params)=>inst.check($7w6aQ._gte(value1, params));
    inst.max = (value1, params)=>inst.check($7w6aQ._lte(value1, params));
}, /*@__PURE__*/ (0, $23ixW).derived({
    minDate: (inst)=>{
        const { minimum } = $lA7b0.aggregateChecks(inst);
        return minimum ? new Date(minimum) : null;
    },
    maxDate: (inst)=>{
        const { maximum } = $lA7b0.aggregateChecks(inst);
        return maximum ? new Date(maximum) : null;
    }
}, {}));
function date(params) {
    return $7w6aQ._date(ZodDate, params);
}
const ZodArray = /*@__PURE__*/ $5SN0M.$constructor("ZodArray", (inst, def)=>{
    _ensureDefaultMemoizer();
    $jvcvr.$ZodArray.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.arrayProcessor(inst, ctx, json, params);
    inst.element = def.element;
}, {
    min (n, params) {
        return this.check($7w6aQ._minLength(n, params));
    },
    nonempty (params) {
        return this.check($7w6aQ._minLength(1, params));
    },
    max (n, params) {
        return this.check($7w6aQ._maxLength(n, params));
    },
    length (n, params) {
        return this.check($7w6aQ._length(n, params));
    },
    unwrap () {
        return this.element;
    }
});
function array(element, params) {
    return $7w6aQ._array(ZodArray, element, params);
}
function keyof(schema) {
    const shape = schema._zod.def.shape;
    return _enum(Object.keys(shape));
}
const ZodObject = /*@__PURE__*/ $5SN0M.$constructor("ZodObject", (inst, def)=>{
    _ensureDefaultMemoizer();
    $jvcvr.$ZodObjectJIT.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.objectProcessor(inst, ctx, json, params);
    (0, $23ixW).installLazyProp(inst, "shape", (self)=>self._zod.def.shape, false);
}, {
    keyof () {
        return _enum(Object.keys(this._zod.def.shape));
    },
    catchall (catchall) {
        // `mergeDefs` rather than a spread: spreading reads `shape`, and resolving it can mint a whole fresh subtree
        return this.clone((0, $23ixW).mergeDefs(this._zod.def, {
            catchall: catchall
        }));
    },
    passthrough () {
        return this.clone((0, $23ixW).mergeDefs(this._zod.def, {
            catchall: unknown()
        }));
    },
    loose () {
        return this.clone((0, $23ixW).mergeDefs(this._zod.def, {
            catchall: unknown()
        }));
    },
    strict () {
        return this.clone((0, $23ixW).mergeDefs(this._zod.def, {
            catchall: never()
        }));
    },
    strip () {
        return this.clone((0, $23ixW).mergeDefs(this._zod.def, {
            catchall: undefined
        }));
    },
    extend (incoming) {
        return (0, $23ixW).extend(this, incoming);
    },
    safeExtend (incoming) {
        return (0, $23ixW).safeExtend(this, incoming);
    },
    merge (other) {
        return (0, $23ixW).merge(this, other);
    },
    pick (mask) {
        return (0, $23ixW).pick(this, mask);
    },
    omit (mask) {
        return (0, $23ixW).omit(this, mask);
    },
    partial (...args) {
        return (0, $23ixW).partial(ZodOptional, this, args[0]);
    },
    exactPartial (...args) {
        return (0, $23ixW).partial(ZodExactOptional, this, args[0], "exactPartial");
    },
    required (...args) {
        return (0, $23ixW).required(ZodNonOptional, this, args[0]);
    }
});
function object(shape, params) {
    const def = {
        type: "object",
        shape: shape ?? {},
        ...(0, $23ixW).normalizeParams(params)
    };
    return new ZodObject(def);
}
function strictObject(shape, params) {
    return new ZodObject({
        type: "object",
        shape: shape,
        catchall: never(),
        ...(0, $23ixW).normalizeParams(params)
    });
}
function looseObject(shape, params) {
    return new ZodObject({
        type: "object",
        shape: shape,
        catchall: unknown(),
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodUnion = /*@__PURE__*/ $5SN0M.$constructor("ZodUnion", (inst, def)=>{
    $jvcvr.$ZodUnion.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.unionProcessor(inst, ctx, json, params);
    inst.options = def.options;
});
function union(options, params) {
    return new ZodUnion({
        type: "union",
        options: options,
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodXor = /*@__PURE__*/ $5SN0M.$constructor("ZodXor", (inst, def)=>{
    ZodUnion.init(inst, def);
    $jvcvr.$ZodXor.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.unionProcessor(inst, ctx, json, params);
    inst.options = def.options;
});
function xor(options, params) {
    return new ZodXor({
        type: "union",
        options: options,
        inclusive: false,
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodDiscriminatedUnion = /*@__PURE__*/ $5SN0M.$constructor("ZodDiscriminatedUnion", (inst, def)=>{
    ZodUnion.init(inst, def);
    $jvcvr.$ZodDiscriminatedUnion.init(inst, def);
});
function discriminatedUnion(discriminator, options, params) {
    // const [options, params] = args;
    return new ZodDiscriminatedUnion({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodIntersection = /*@__PURE__*/ $5SN0M.$constructor("ZodIntersection", (inst, def)=>{
    $jvcvr.$ZodIntersection.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.intersectionProcessor(inst, ctx, json, params);
});
function intersection(left, right) {
    return new ZodIntersection({
        type: "intersection",
        left: left,
        right: right
    });
}
const ZodTuple = /*@__PURE__*/ $5SN0M.$constructor("ZodTuple", (inst, def)=>{
    _ensureDefaultMemoizer();
    $jvcvr.$ZodTuple.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.tupleProcessor(inst, ctx, json, params);
}, {
    rest (rest) {
        return this.clone({
            ...this._zod.def,
            rest: rest
        });
    },
    partial () {
        const def = this._zod.def;
        // a refinement was authored against the full arity; partialing would run it on a shorter array
        if (def.checks?.length) throw new Error(".partial() cannot be used on tuple schemas containing refinements");
        return this.clone({
            ...def,
            items: def.items.map((item)=>new ZodOptional({
                    type: "optional",
                    innerType: item
                }))
        });
    }
});
function tuple(items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $jvcvr.$ZodType;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new ZodTuple({
        type: "tuple",
        items: items,
        rest: rest,
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodRecord = /*@__PURE__*/ $5SN0M.$constructor("ZodRecord", (inst, def)=>{
    _ensureDefaultMemoizer();
    $jvcvr.$ZodRecord.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.recordProcessor(inst, ctx, json, params);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
});
function record(keyType, valueType, params) {
    // v3-compat: z.record(valueType, params?) — defaults keyType to z.string()
    if (!valueType || !valueType._zod) return new ZodRecord({
        type: "record",
        keyType: string(),
        valueType: keyType,
        ...(0, $23ixW).normalizeParams(valueType)
    });
    return new ZodRecord({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...(0, $23ixW).normalizeParams(params)
    });
}
function partialRecord(keyType, valueType, params) {
    return new ZodRecord({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...(0, $23ixW).normalizeParams(params),
        partial: true
    });
}
function looseRecord(keyType, valueType, params) {
    return new ZodRecord({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        mode: "loose",
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodMap = /*@__PURE__*/ $5SN0M.$constructor("ZodMap", (inst, def)=>{
    _ensureDefaultMemoizer();
    $jvcvr.$ZodMap.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.mapProcessor(inst, ctx, json, params);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
    inst.min = (...args)=>inst.check($7w6aQ._minSize(...args));
    inst.nonempty = (params)=>inst.check($7w6aQ._minSize(1, params));
    inst.max = (...args)=>inst.check($7w6aQ._maxSize(...args));
    inst.size = (...args)=>inst.check($7w6aQ._size(...args));
});
function map(keyType, valueType, params) {
    return new ZodMap({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodSet = /*@__PURE__*/ $5SN0M.$constructor("ZodSet", (inst, def)=>{
    _ensureDefaultMemoizer();
    $jvcvr.$ZodSet.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.setProcessor(inst, ctx, json, params);
    inst.min = (...args)=>inst.check($7w6aQ._minSize(...args));
    inst.nonempty = (params)=>inst.check($7w6aQ._minSize(1, params));
    inst.max = (...args)=>inst.check($7w6aQ._maxSize(...args));
    inst.size = (...args)=>inst.check($7w6aQ._size(...args));
});
function set(valueType, params) {
    return new ZodSet({
        type: "set",
        valueType: valueType,
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodEnum = /*@__PURE__*/ $5SN0M.$constructor("ZodEnum", (inst, def)=>{
    $jvcvr.$ZodEnum.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.enumProcessor(inst, ctx, json, params);
    inst.enum = def.entries;
    // reuse the parsed value set so a numeric TS enum's reverse-mapping keys stay out
    inst.options = [
        ...inst._zod.values
    ];
    const keys = new Set(Object.keys(def.entries));
    inst.extract = (values, params)=>{
        const newEntries = {};
        for (const value1 of values){
            if (keys.has(value1)) newEntries[value1] = def.entries[value1];
            else throw new Error(`Key ${value1} not found in enum`);
        }
        return new ZodEnum({
            ...def,
            checks: [],
            ...(0, $23ixW).normalizeParams(params),
            entries: newEntries
        });
    };
    inst.exclude = (values, params)=>{
        const newEntries = {
            ...def.entries
        };
        for (const value1 of values){
            if (keys.has(value1)) delete newEntries[value1];
            else throw new Error(`Key ${value1} not found in enum`);
        }
        return new ZodEnum({
            ...def,
            checks: [],
            ...(0, $23ixW).normalizeParams(params),
            entries: newEntries
        });
    };
});
function _enum(values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    return new ZodEnum({
        type: "enum",
        entries: entries,
        ...(0, $23ixW).normalizeParams(params)
    });
}
function nativeEnum(entries, params) {
    return new ZodEnum({
        type: "enum",
        entries: entries,
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodLiteral = /*@__PURE__*/ $5SN0M.$constructor("ZodLiteral", (inst, def)=>{
    $jvcvr.$ZodLiteral.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.literalProcessor(inst, ctx, json, params);
    inst.values = new Set(def.values);
    Object.defineProperty(inst, "value", {
        get () {
            if (def.values.length > 1) throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
            return def.values[0];
        }
    });
});
function literal(value1, params) {
    return new ZodLiteral({
        type: "literal",
        values: Array.isArray(value1) ? value1 : [
            value1
        ],
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodFile = /*@__PURE__*/ $5SN0M.$constructor("ZodFile", (inst, def)=>{
    $jvcvr.$ZodFile.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.fileProcessor(inst, ctx, json, params);
    inst.min = (size, params)=>inst.check($7w6aQ._minSize(size, params));
    inst.max = (size, params)=>inst.check($7w6aQ._maxSize(size, params));
    inst.mime = (types, params)=>inst.check($7w6aQ._mime(Array.isArray(types) ? types : [
            types
        ], params));
});
function file(params) {
    return $7w6aQ._file(ZodFile, params);
}
const ZodTransform = /*@__PURE__*/ $5SN0M.$constructor("ZodTransform", (inst, def)=>{
    _ensureDefaultMemoizer();
    $jvcvr.$ZodTransform.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.transformProcessor(inst, ctx, json, params);
    inst._zod.parse = (payload, _ctx)=>{
        if (_ctx.direction === "backward") throw new $5SN0M.$ZodEncodeError(inst.constructor.name);
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push((0, $23ixW).issue(issue, payload.value, def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                if (!("input" in _issue)) _issue.input = payload.value;
                _issue.inst ?? (_issue.inst = inst);
                // _issue.continue ??= true;
                payload.issues.push((0, $23ixW).issue(_issue));
            }
        };
        const output = def.transform(payload.value, payload);
        if (output instanceof Promise) return output.then((output)=>{
            payload.value = output;
            return payload;
        });
        payload.value = output;
        return payload;
    };
});
function transform(fn) {
    return new ZodTransform({
        type: "transform",
        transform: fn
    });
}
const ZodOptional = /*@__PURE__*/ $5SN0M.$constructor("ZodOptional", (inst, def)=>{
    $jvcvr.$ZodOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.optionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function optional(innerType) {
    return new ZodOptional({
        type: "optional",
        innerType: innerType
    });
}
const ZodExactOptional = /*@__PURE__*/ $5SN0M.$constructor("ZodExactOptional", (inst, def)=>{
    $jvcvr.$ZodExactOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.optionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function exactOptional(innerType) {
    return new ZodExactOptional({
        type: "optional",
        innerType: innerType
    });
}
const ZodNullable = /*@__PURE__*/ $5SN0M.$constructor("ZodNullable", (inst, def)=>{
    $jvcvr.$ZodNullable.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.nullableProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function nullable(innerType) {
    return new ZodNullable({
        type: "nullable",
        innerType: innerType
    });
}
function nullish(innerType) {
    return optional(nullable(innerType));
}
const ZodDefault = /*@__PURE__*/ $5SN0M.$constructor("ZodDefault", (inst, def)=>{
    $jvcvr.$ZodDefault.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.defaultProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeDefault = inst.unwrap;
});
function _default(innerType, defaultValue) {
    return new ZodDefault({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $23ixW).shallowClone(defaultValue);
        }
    });
}
const ZodPrefault = /*@__PURE__*/ $5SN0M.$constructor("ZodPrefault", (inst, def)=>{
    $jvcvr.$ZodPrefault.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.prefaultProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function prefault(innerType, defaultValue) {
    return new ZodPrefault({
        type: "prefault",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $23ixW).shallowClone(defaultValue);
        }
    });
}
const ZodNonOptional = /*@__PURE__*/ $5SN0M.$constructor("ZodNonOptional", (inst, def)=>{
    $jvcvr.$ZodNonOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.nonoptionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function nonoptional(innerType, params) {
    return new ZodNonOptional({
        type: "nonoptional",
        innerType: innerType,
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodSuccess = /*@__PURE__*/ $5SN0M.$constructor("ZodSuccess", (inst, def)=>{
    $jvcvr.$ZodSuccess.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.successProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function success(innerType) {
    return new ZodSuccess({
        type: "success",
        innerType: innerType
    });
}
const ZodCatch = /*@__PURE__*/ $5SN0M.$constructor("ZodCatch", (inst, def)=>{
    $jvcvr.$ZodCatch.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.catchProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeCatch = inst.unwrap;
});
function _catch(innerType, catchValue) {
    return new ZodCatch({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : $23ixW.constantCatch(catchValue)
    });
}
const ZodNaN = /*@__PURE__*/ $5SN0M.$constructor("ZodNaN", (inst, def)=>{
    $jvcvr.$ZodNaN.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.nanProcessor(inst, ctx, json, params);
});
function nan(params) {
    return $7w6aQ._nan(ZodNaN, params);
}
const ZodPipe = /*@__PURE__*/ $5SN0M.$constructor("ZodPipe", (inst, def)=>{
    $jvcvr.$ZodPipe.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.pipeProcessor(inst, ctx, json, params);
    inst.in = def.in;
    inst.out = def.out;
});
function pipe(in_, out) {
    return new ZodPipe({
        type: "pipe",
        in: in_,
        out: out
    });
}
const ZodCodec = /*@__PURE__*/ $5SN0M.$constructor("ZodCodec", (inst, def)=>{
    ZodPipe.init(inst, def);
    $jvcvr.$ZodCodec.init(inst, def);
});
function codec(in_, out, params) {
    return new ZodCodec({
        type: "pipe",
        in: in_,
        out: out,
        transform: params.decode,
        reverseTransform: params.encode
    });
}
function invertCodec(codec) {
    const def = codec._zod.def;
    return new ZodCodec({
        type: "pipe",
        in: def.out,
        out: def.in,
        transform: def.reverseTransform,
        reverseTransform: def.transform
    });
}
const ZodPreprocess = /*@__PURE__*/ $5SN0M.$constructor("ZodPreprocess", (inst, def)=>{
    ZodPipe.init(inst, def);
    $jvcvr.$ZodPreprocess.init(inst, def);
});
const ZodReadonly = /*@__PURE__*/ $5SN0M.$constructor("ZodReadonly", (inst, def)=>{
    $jvcvr.$ZodReadonly.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.readonlyProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function readonly(innerType) {
    return new ZodReadonly({
        type: "readonly",
        innerType: innerType
    });
}
const ZodTemplateLiteral = /*@__PURE__*/ $5SN0M.$constructor("ZodTemplateLiteral", (inst, def)=>{
    $jvcvr.$ZodTemplateLiteral.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.templateLiteralProcessor(inst, ctx, json, params);
});
function templateLiteral(parts, params) {
    return new ZodTemplateLiteral({
        type: "template_literal",
        parts: parts,
        ...(0, $23ixW).normalizeParams(params)
    });
}
const ZodLazy = /*@__PURE__*/ $5SN0M.$constructor("ZodLazy", (inst, def)=>{
    $jvcvr.$ZodLazy.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.lazyProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.getter();
});
function lazy(getter) {
    return new ZodLazy({
        type: "lazy",
        getter: getter
    });
}
const ZodPromise = /*@__PURE__*/ $5SN0M.$constructor("ZodPromise", (inst, def)=>{
    $jvcvr.$ZodPromise.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.promiseProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function promise(innerType) {
    return new ZodPromise({
        type: "promise",
        innerType: innerType
    });
}
const ZodFunction = /*@__PURE__*/ $5SN0M.$constructor("ZodFunction", (inst, def)=>{
    $jvcvr.$ZodFunction.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.functionProcessor(inst, ctx, json, params);
});
function _function(params) {
    return new ZodFunction({
        type: "function",
        input: Array.isArray(params?.input) ? tuple(params?.input) : params?.input ?? array(unknown()),
        output: params?.output ?? unknown()
    });
}
const ZodCustom = /*@__PURE__*/ $5SN0M.$constructor("ZodCustom", (inst, def)=>{
    $jvcvr.$ZodCustom.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$lA7b0.customProcessor(inst, ctx, json, params);
});
const ZodProperties = /*@__PURE__*/ $5SN0M.$constructor("ZodProperties", (inst, def)=>{
    _ensureDefaultMemoizer();
    $jvcvr.$ZodProperties.init(inst, def);
    ZodType.init(inst, def);
});
function properties(shape, params) {
    return $7w6aQ._properties(ZodProperties, shape, params);
}
function check(fn) {
    const ch = new $ggkLI.$ZodCheck({
        check: "custom"
    });
    ch._zod.check = fn;
    return ch;
}
function custom(fn, _params) {
    return $7w6aQ._custom(ZodCustom, fn ?? (()=>true), _params);
}
function refine(fn, _params = {}) {
    return $7w6aQ._refine(ZodCustom, fn, _params);
}
function superRefine(fn, params) {
    return $7w6aQ._superRefine(fn, params);
}
const describe = $7w6aQ.describe;
const meta = $7w6aQ.meta;
const ZodInstanceOf = /*@__PURE__*/ $5SN0M.$constructor("ZodInstanceOf", (inst, def)=>{
    ZodCustom.init(inst, def);
}, {
    properties (shape, params) {
        // asserts in place, so the narrowed output type is truthful without a wrapper
        return this.check(properties(shape, params));
    }
});
function _instanceof(cls, params = {}) {
    const inst = new ZodInstanceOf({
        type: "custom",
        check: "custom",
        fn: (data)=>data instanceof cls,
        abort: true,
        ...(0, $23ixW).normalizeParams(params)
    });
    inst._zod.bag.Class = cls;
    // Override check to emit invalid_type instead of custom
    inst._zod.check = (payload)=>{
        if (!(payload.value instanceof cls)) payload.issues.push({
            code: "invalid_type",
            expected: cls.name,
            input: payload.value,
            inst: inst,
            path: [
                ...inst._zod.def.path ?? []
            ]
        });
    };
    return inst;
}
const stringbool = (...args)=>$7w6aQ._stringbool({
        Codec: ZodCodec,
        Boolean: ZodBoolean,
        String: ZodString
    }, ...args);
function json(params) {
    const jsonSchema = lazy(()=>{
        return union([
            string(params),
            number(),
            boolean(),
            _null(),
            array(jsonSchema),
            record(string(), jsonSchema)
        ]);
    });
    return jsonSchema;
}
function preprocess(fn, schema) {
    return new ZodPreprocess({
        type: "pipe",
        in: transform(fn),
        out: schema
    });
}

});
parcelRegister("7w6aQ", function(module, exports) {

$parcel$export(module.exports, "_string", () => $57904f98be373a74$export$25986a84359f8f7f);
$parcel$export(module.exports, "_email", () => $57904f98be373a74$export$471b39521bec3299);
$parcel$export(module.exports, "_guid", () => $57904f98be373a74$export$129b5399d64cccb0);
$parcel$export(module.exports, "_uuid", () => $57904f98be373a74$export$f2f3139038bea52c);
$parcel$export(module.exports, "_uuidv4", () => $57904f98be373a74$export$a5559d7da37a112f);
$parcel$export(module.exports, "_uuidv6", () => $57904f98be373a74$export$53b427a8173231a);
$parcel$export(module.exports, "_uuidv7", () => $57904f98be373a74$export$588d23d6e9ec2ed5);
$parcel$export(module.exports, "_url", () => $57904f98be373a74$export$e3f203373341d39);
$parcel$export(module.exports, "_emoji", () => $57904f98be373a74$export$936e26d261396f46);
$parcel$export(module.exports, "_nanoid", () => $57904f98be373a74$export$a030949b19390ea0);
$parcel$export(module.exports, "_cuid", () => $57904f98be373a74$export$639125837b796148);
$parcel$export(module.exports, "_cuid2", () => $57904f98be373a74$export$36b63ef9af7972c2);
$parcel$export(module.exports, "_ulid", () => $57904f98be373a74$export$95acf3b3fa11bdc9);
$parcel$export(module.exports, "_xid", () => $57904f98be373a74$export$bbb0a2cfb079fa90);
$parcel$export(module.exports, "_ksuid", () => $57904f98be373a74$export$1306ede2f9ea153f);
$parcel$export(module.exports, "_ipv4", () => $57904f98be373a74$export$c77a1c80cebc2aad);
$parcel$export(module.exports, "_ipv6", () => $57904f98be373a74$export$964dfe0e2e4e8895);
$parcel$export(module.exports, "_mac", () => $57904f98be373a74$export$84f8b3e041d8e7d9);
$parcel$export(module.exports, "_cidrv4", () => $57904f98be373a74$export$feaac4e27a421ddc);
$parcel$export(module.exports, "_cidrv6", () => $57904f98be373a74$export$a0518ffc5273ec92);
$parcel$export(module.exports, "_base64", () => $57904f98be373a74$export$9fdb09384fbc4988);
$parcel$export(module.exports, "_base64url", () => $57904f98be373a74$export$178c70fb89c949fa);
$parcel$export(module.exports, "_e164", () => $57904f98be373a74$export$b8bf0b70d4bc7855);
$parcel$export(module.exports, "_creditCard", () => $57904f98be373a74$export$86d44988408f3a7f);
$parcel$export(module.exports, "_iban", () => $57904f98be373a74$export$ca14e367b122da36);
$parcel$export(module.exports, "_jwt", () => $57904f98be373a74$export$4a9318e6b46f1aa1);
$parcel$export(module.exports, "_isoDateTime", () => $57904f98be373a74$export$a62adeb27809351b);
$parcel$export(module.exports, "_isoDate", () => $57904f98be373a74$export$e4f19dd0a54e7a59);
$parcel$export(module.exports, "_isoTime", () => $57904f98be373a74$export$36f9f051d5e817c);
$parcel$export(module.exports, "_isoDuration", () => $57904f98be373a74$export$7d70539c76fbff4);
$parcel$export(module.exports, "_number", () => $57904f98be373a74$export$9249bb0b45639623);
$parcel$export(module.exports, "_int", () => $57904f98be373a74$export$3d5b343b1f51efdd);
$parcel$export(module.exports, "_float32", () => $57904f98be373a74$export$656ad65d6cf64174);
$parcel$export(module.exports, "_float64", () => $57904f98be373a74$export$9ddff8176107cc11);
$parcel$export(module.exports, "_int32", () => $57904f98be373a74$export$5ec965fd114a2f9f);
$parcel$export(module.exports, "_uint32", () => $57904f98be373a74$export$a43c28c6e86e066e);
$parcel$export(module.exports, "_boolean", () => $57904f98be373a74$export$e23c41ce5ce2db39);
$parcel$export(module.exports, "_bigint", () => $57904f98be373a74$export$c96ff33878177e4c);
$parcel$export(module.exports, "_int64", () => $57904f98be373a74$export$cb7d3ec922804f3f);
$parcel$export(module.exports, "_uint64", () => $57904f98be373a74$export$c51606f0dfa0f5a1);
$parcel$export(module.exports, "_symbol", () => $57904f98be373a74$export$a8f93f5b7c030e84);
$parcel$export(module.exports, "_undefined", () => $57904f98be373a74$export$60e4c9fe67803d40);
$parcel$export(module.exports, "_null", () => $57904f98be373a74$export$a2cbb38cda512d16);
$parcel$export(module.exports, "_any", () => $57904f98be373a74$export$4678886173313220);
$parcel$export(module.exports, "_unknown", () => $57904f98be373a74$export$e0ed508a47e00801);
$parcel$export(module.exports, "_never", () => $57904f98be373a74$export$887f43204ffc2a69);
$parcel$export(module.exports, "_void", () => $57904f98be373a74$export$9480825d3c8e9ad6);
$parcel$export(module.exports, "_date", () => $57904f98be373a74$export$da799735c76175a);
$parcel$export(module.exports, "_nan", () => $57904f98be373a74$export$a5e7e1f8491a5e50);
$parcel$export(module.exports, "_lt", () => $57904f98be373a74$export$2a42c74e76a068a);
$parcel$export(module.exports, "_lte", () => $57904f98be373a74$export$7a060cf3d60b84a6);
$parcel$export(module.exports, "_gt", () => $57904f98be373a74$export$7582466e3ab4d25b);
$parcel$export(module.exports, "_gte", () => $57904f98be373a74$export$a1c6d8834a3b19c9);
$parcel$export(module.exports, "_multipleOf", () => $57904f98be373a74$export$c41e40f80e978ab1);
$parcel$export(module.exports, "_maxSize", () => $57904f98be373a74$export$3eed6ccb98bc18db);
$parcel$export(module.exports, "_minSize", () => $57904f98be373a74$export$e379713268c2c18a);
$parcel$export(module.exports, "_size", () => $57904f98be373a74$export$2621565b966a8d23);
$parcel$export(module.exports, "_maxLength", () => $57904f98be373a74$export$ec76627108655a22);
$parcel$export(module.exports, "_minLength", () => $57904f98be373a74$export$21f6711a906c1450);
$parcel$export(module.exports, "_length", () => $57904f98be373a74$export$620b9f7ab17ff8a9);
$parcel$export(module.exports, "_regex", () => $57904f98be373a74$export$c4768a1bd8f8393);
$parcel$export(module.exports, "_lowercase", () => $57904f98be373a74$export$ea67c3edeec85c63);
$parcel$export(module.exports, "_uppercase", () => $57904f98be373a74$export$2998381b41c6902a);
$parcel$export(module.exports, "_includes", () => $57904f98be373a74$export$fccf016a6caa651d);
$parcel$export(module.exports, "_startsWith", () => $57904f98be373a74$export$2f37aaf99060de76);
$parcel$export(module.exports, "_endsWith", () => $57904f98be373a74$export$eaeaa2fcd833167e);
$parcel$export(module.exports, "_properties", () => $57904f98be373a74$export$a72788ae987f5bef);
$parcel$export(module.exports, "_mime", () => $57904f98be373a74$export$267177285a1a8b37);
$parcel$export(module.exports, "_overwrite", () => $57904f98be373a74$export$aeea8f004f34f8c2);
$parcel$export(module.exports, "_normalize", () => $57904f98be373a74$export$2b99bb23a814f78e);
$parcel$export(module.exports, "_trim", () => $57904f98be373a74$export$8be2de0b60774d1e);
$parcel$export(module.exports, "_toLowerCase", () => $57904f98be373a74$export$d9cfe939403a2525);
$parcel$export(module.exports, "_toUpperCase", () => $57904f98be373a74$export$cf76ef1ae9e9944e);
$parcel$export(module.exports, "_slugify", () => $57904f98be373a74$export$2801993b93f3c232);
$parcel$export(module.exports, "_array", () => $57904f98be373a74$export$4ea446333e3db634);
$parcel$export(module.exports, "_file", () => $57904f98be373a74$export$e335cd0b9f8bab1e);
$parcel$export(module.exports, "_custom", () => $57904f98be373a74$export$8bfc2ce1398e3071);
$parcel$export(module.exports, "_refine", () => $57904f98be373a74$export$ac822e05051812e1);
$parcel$export(module.exports, "_superRefine", () => $57904f98be373a74$export$f2b01ecb843d7ab9);
$parcel$export(module.exports, "describe", () => $57904f98be373a74$export$cd5450f3a47e3789);
$parcel$export(module.exports, "meta", () => $57904f98be373a74$export$6990040ee07315);
$parcel$export(module.exports, "_stringbool", () => $57904f98be373a74$export$a75528509e3a7006);
$parcel$export(module.exports, "_stringFormat", () => $57904f98be373a74$export$e25dde89ba546b88);

var $ggkLI = parcelRequire("ggkLI");

var $5VtTM = parcelRequire("5VtTM");

var $jvcvr = parcelRequire("jvcvr");

var $23ixW = parcelRequire("23ixW");
function $57904f98be373a74$export$25986a84359f8f7f(Class, params) {
    return new Class({
        type: "string",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$614049477c642ce0(Class, params) {
    return new Class({
        type: "string",
        coerce: true,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$471b39521bec3299(Class, params) {
    return new Class({
        type: "string",
        format: "email",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$129b5399d64cccb0(Class, params) {
    return new Class({
        type: "string",
        format: "guid",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$f2f3139038bea52c(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$a5559d7da37a112f(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v4",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$53b427a8173231a(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v6",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$588d23d6e9ec2ed5(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v7",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$e3f203373341d39(Class, params) {
    return new Class({
        type: "string",
        format: "url",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$936e26d261396f46(Class, params) {
    return new Class({
        type: "string",
        format: "emoji",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$a030949b19390ea0(Class, params) {
    return new Class({
        type: "string",
        format: "nanoid",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$639125837b796148(Class, params) {
    return new Class({
        type: "string",
        format: "cuid",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$36b63ef9af7972c2(Class, params) {
    return new Class({
        type: "string",
        format: "cuid2",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$95acf3b3fa11bdc9(Class, params) {
    return new Class({
        type: "string",
        format: "ulid",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$bbb0a2cfb079fa90(Class, params) {
    return new Class({
        type: "string",
        format: "xid",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$1306ede2f9ea153f(Class, params) {
    return new Class({
        type: "string",
        format: "ksuid",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$c77a1c80cebc2aad(Class, params) {
    return new Class({
        type: "string",
        format: "ipv4",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$964dfe0e2e4e8895(Class, params) {
    return new Class({
        type: "string",
        format: "ipv6",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$84f8b3e041d8e7d9(Class, params) {
    return new Class({
        type: "string",
        format: "mac",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$feaac4e27a421ddc(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv4",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$a0518ffc5273ec92(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv6",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$9fdb09384fbc4988(Class, params) {
    return new Class({
        type: "string",
        format: "base64",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$178c70fb89c949fa(Class, params) {
    return new Class({
        type: "string",
        format: "base64url",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$b8bf0b70d4bc7855(Class, params) {
    return new Class({
        type: "string",
        format: "e164",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$86d44988408f3a7f(Class, params) {
    return new Class({
        type: "string",
        format: "credit_card",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$ca14e367b122da36(Class, params) {
    return new Class({
        type: "string",
        format: "iban",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$4a9318e6b46f1aa1(Class, params) {
    return new Class({
        type: "string",
        format: "jwt",
        check: "string_format",
        abort: false,
        ...$23ixW.normalizeParams(params)
    });
}
const $57904f98be373a74$export$3a3ade082c590099 = {
    Any: null,
    Minute: -1,
    Second: 0,
    Millisecond: 3,
    Microsecond: 6
};
function $57904f98be373a74$export$a62adeb27809351b(Class, params) {
    return new Class({
        type: "string",
        format: "datetime",
        check: "string_format",
        offset: false,
        local: false,
        precision: null,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$e4f19dd0a54e7a59(Class, params) {
    return new Class({
        type: "string",
        format: "date",
        check: "string_format",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$36f9f051d5e817c(Class, params) {
    return new Class({
        type: "string",
        format: "time",
        check: "string_format",
        precision: null,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$7d70539c76fbff4(Class, params) {
    return new Class({
        type: "string",
        format: "duration",
        check: "string_format",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$9249bb0b45639623(Class, params) {
    return new Class({
        type: "number",
        checks: [],
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$272511620e4661dd(Class, params) {
    return new Class({
        type: "number",
        coerce: true,
        checks: [],
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$3d5b343b1f51efdd(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "safeint",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$656ad65d6cf64174(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float32",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$9ddff8176107cc11(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float64",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$5ec965fd114a2f9f(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "int32",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$a43c28c6e86e066e(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "uint32",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$e23c41ce5ce2db39(Class, params) {
    return new Class({
        type: "boolean",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$c3eb0e1c7c887e5c(Class, params) {
    return new Class({
        type: "boolean",
        coerce: true,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$c96ff33878177e4c(Class, params) {
    return new Class({
        type: "bigint",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$8ff745acc355d077(Class, params) {
    return new Class({
        type: "bigint",
        coerce: true,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$cb7d3ec922804f3f(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "int64",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$c51606f0dfa0f5a1(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "uint64",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$a8f93f5b7c030e84(Class, params) {
    return new Class({
        type: "symbol",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$60e4c9fe67803d40(Class, params) {
    return new Class({
        type: "undefined",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$a2cbb38cda512d16(Class, params) {
    return new Class({
        type: "null",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$4678886173313220(Class) {
    return new Class({
        type: "any"
    });
}
function $57904f98be373a74$export$e0ed508a47e00801(Class) {
    return new Class({
        type: "unknown"
    });
}
function $57904f98be373a74$export$887f43204ffc2a69(Class, params) {
    return new Class({
        type: "never",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$9480825d3c8e9ad6(Class, params) {
    return new Class({
        type: "void",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$da799735c76175a(Class, params) {
    return new Class({
        type: "date",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$2efeac445ea43f33(Class, params) {
    return new Class({
        type: "date",
        coerce: true,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$a5e7e1f8491a5e50(Class, params) {
    return new Class({
        type: "nan",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$2a42c74e76a068a(value, params) {
    return new $ggkLI.$ZodCheckLessThan({
        check: "less_than",
        ...$23ixW.normalizeParams(params),
        value: value,
        inclusive: false
    });
}
function $57904f98be373a74$export$7a060cf3d60b84a6(value, params) {
    return new $ggkLI.$ZodCheckLessThan({
        check: "less_than",
        ...$23ixW.normalizeParams(params),
        value: value,
        inclusive: true
    });
}
function $57904f98be373a74$export$7582466e3ab4d25b(value, params) {
    return new $ggkLI.$ZodCheckGreaterThan({
        check: "greater_than",
        ...$23ixW.normalizeParams(params),
        value: value,
        inclusive: false
    });
}
function $57904f98be373a74$export$a1c6d8834a3b19c9(value, params) {
    return new $ggkLI.$ZodCheckGreaterThan({
        check: "greater_than",
        ...$23ixW.normalizeParams(params),
        value: value,
        inclusive: true
    });
}
function $57904f98be373a74$export$ddfc6f0a2e49a568(params) {
    return $57904f98be373a74$export$7582466e3ab4d25b(0, params);
}
function $57904f98be373a74$export$d30568dda7134ca5(params) {
    return $57904f98be373a74$export$2a42c74e76a068a(0, params);
}
function $57904f98be373a74$export$c3e51eea33419c94(params) {
    return $57904f98be373a74$export$7a060cf3d60b84a6(0, params);
}
function $57904f98be373a74$export$93ec5f75848b1928(params) {
    return $57904f98be373a74$export$a1c6d8834a3b19c9(0, params);
}
function $57904f98be373a74$export$c41e40f80e978ab1(value, params) {
    return new $ggkLI.$ZodCheckMultipleOf({
        check: "multiple_of",
        ...$23ixW.normalizeParams(params),
        value: value
    });
}
function $57904f98be373a74$export$3eed6ccb98bc18db(maximum, params) {
    return new $ggkLI.$ZodCheckMaxSize({
        check: "max_size",
        ...$23ixW.normalizeParams(params),
        maximum: maximum
    });
}
function $57904f98be373a74$export$e379713268c2c18a(minimum, params) {
    return new $ggkLI.$ZodCheckMinSize({
        check: "min_size",
        ...$23ixW.normalizeParams(params),
        minimum: minimum
    });
}
function $57904f98be373a74$export$2621565b966a8d23(size, params) {
    return new $ggkLI.$ZodCheckSizeEquals({
        check: "size_equals",
        ...$23ixW.normalizeParams(params),
        size: size
    });
}
function $57904f98be373a74$export$ec76627108655a22(maximum, params) {
    const ch = new $ggkLI.$ZodCheckMaxLength({
        check: "max_length",
        ...$23ixW.normalizeParams(params),
        maximum: maximum
    });
    return ch;
}
function $57904f98be373a74$export$21f6711a906c1450(minimum, params) {
    return new $ggkLI.$ZodCheckMinLength({
        check: "min_length",
        ...$23ixW.normalizeParams(params),
        minimum: minimum
    });
}
function $57904f98be373a74$export$620b9f7ab17ff8a9(length, params) {
    return new $ggkLI.$ZodCheckLengthEquals({
        check: "length_equals",
        ...$23ixW.normalizeParams(params),
        length: length
    });
}
function $57904f98be373a74$export$c4768a1bd8f8393(pattern, params) {
    return new $ggkLI.$ZodCheckRegex({
        check: "string_format",
        format: "regex",
        ...$23ixW.normalizeParams(params),
        pattern: pattern
    });
}
function $57904f98be373a74$export$ea67c3edeec85c63(params) {
    return new $ggkLI.$ZodCheckLowerCase({
        check: "string_format",
        format: "lowercase",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$2998381b41c6902a(params) {
    return new $ggkLI.$ZodCheckUpperCase({
        check: "string_format",
        format: "uppercase",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$fccf016a6caa651d(includes, params) {
    return new $ggkLI.$ZodCheckIncludes({
        check: "string_format",
        format: "includes",
        ...$23ixW.normalizeParams(params),
        includes: includes
    });
}
function $57904f98be373a74$export$2f37aaf99060de76(prefix, params) {
    return new $ggkLI.$ZodCheckStartsWith({
        check: "string_format",
        format: "starts_with",
        ...$23ixW.normalizeParams(params),
        prefix: prefix
    });
}
function $57904f98be373a74$export$eaeaa2fcd833167e(suffix, params) {
    return new $ggkLI.$ZodCheckEndsWith({
        check: "string_format",
        format: "ends_with",
        ...$23ixW.normalizeParams(params),
        suffix: suffix
    });
}
function $57904f98be373a74$export$537db06738ee7f1b(property, schema, params) {
    return new $ggkLI.$ZodCheckProperty({
        check: "property",
        property: property,
        schema: schema,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$a72788ae987f5bef(Class, shape, params) {
    return new Class({
        type: "properties",
        check: "properties",
        shape: shape,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$267177285a1a8b37(types, params) {
    return new $ggkLI.$ZodCheckMimeType({
        check: "mime_type",
        mime: types,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$aeea8f004f34f8c2(tx) {
    return new $ggkLI.$ZodCheckOverwrite({
        check: "overwrite",
        tx: tx
    });
}
function $57904f98be373a74$export$2b99bb23a814f78e(form) {
    return $57904f98be373a74$export$aeea8f004f34f8c2((input)=>input.normalize(form));
}
function $57904f98be373a74$export$8be2de0b60774d1e() {
    return $57904f98be373a74$export$aeea8f004f34f8c2((input)=>input.trim());
}
function $57904f98be373a74$export$d9cfe939403a2525() {
    return $57904f98be373a74$export$aeea8f004f34f8c2((input)=>input.toLowerCase());
}
function $57904f98be373a74$export$cf76ef1ae9e9944e() {
    return $57904f98be373a74$export$aeea8f004f34f8c2((input)=>input.toUpperCase());
}
function $57904f98be373a74$export$2801993b93f3c232() {
    return $57904f98be373a74$export$aeea8f004f34f8c2((input)=>$23ixW.slugify(input));
}
function $57904f98be373a74$export$4ea446333e3db634(Class, element, params) {
    return new Class({
        type: "array",
        element: element,
        // get element() {
        //   return element;
        // },
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$48eec03fd15d025b(Class, options, params) {
    return new Class({
        type: "union",
        options: options,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$d941708f3b69bf5a(Class, options, params) {
    return new Class({
        type: "union",
        options: options,
        inclusive: false,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$ffbf51421b0acee1(Class, discriminator, options, params) {
    return new Class({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$3d0d84e16c5ea809(Class, left, right) {
    return new Class({
        type: "intersection",
        left: left,
        right: right
    });
}
function $57904f98be373a74$export$a13693bfb304605a(Class, items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $jvcvr.$ZodType;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new Class({
        type: "tuple",
        items: items,
        rest: rest,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$64440e3f2e29d7bc(Class, keyType, valueType, params) {
    return new Class({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$a0135aecf4a782ab(Class, keyType, valueType, params) {
    return new Class({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$c37fd9e9b598996d(Class, valueType, params) {
    return new Class({
        type: "set",
        valueType: valueType,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$3290a9b46bcfecc1(Class, values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    // if (Array.isArray(values)) {
    //   for (const value of values) {
    //     entries[value] = value;
    //   }
    // } else {
    //   Object.assign(entries, values);
    // }
    // const entries: util.EnumLike = {};
    // for (const val of values) {
    //   entries[val] = val;
    // }
    return new Class({
        type: "enum",
        entries: entries,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$6b94bba2375b9e3d(Class, entries, params) {
    return new Class({
        type: "enum",
        entries: entries,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$a03e276eec27de8b(Class, value, params) {
    return new Class({
        type: "literal",
        values: Array.isArray(value) ? value : [
            value
        ],
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$e335cd0b9f8bab1e(Class, params) {
    return new Class({
        type: "file",
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$fa4a3df4db7f3166(Class, fn) {
    return new Class({
        type: "transform",
        transform: fn
    });
}
function $57904f98be373a74$export$6d07c57dda792495(Class, innerType) {
    return new Class({
        type: "optional",
        innerType: innerType
    });
}
function $57904f98be373a74$export$4e46ee4534ff341d(Class, innerType) {
    return new Class({
        type: "nullable",
        innerType: innerType
    });
}
function $57904f98be373a74$export$d4b0f68d0d916971(Class, innerType, defaultValue) {
    return new Class({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : $23ixW.shallowClone(defaultValue);
        }
    });
}
function $57904f98be373a74$export$24cb0533b28b009b(Class, innerType, params) {
    return new Class({
        type: "nonoptional",
        innerType: innerType,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$6f570707f72cba02(Class, innerType) {
    return new Class({
        type: "success",
        innerType: innerType
    });
}
function $57904f98be373a74$export$7f43fa37c3d8a0b3(Class, innerType, catchValue) {
    return new Class({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : $23ixW.constantCatch(catchValue)
    });
}
function $57904f98be373a74$export$fc24e256ce7b145(Class, in_, out) {
    return new Class({
        type: "pipe",
        in: in_,
        out: out
    });
}
function $57904f98be373a74$export$4fe7ff2cfb7a6dd7(Class, innerType) {
    return new Class({
        type: "readonly",
        innerType: innerType
    });
}
function $57904f98be373a74$export$f30d99994777b6d(Class, parts, params) {
    return new Class({
        type: "template_literal",
        parts: parts,
        ...$23ixW.normalizeParams(params)
    });
}
function $57904f98be373a74$export$137d76f65e4bcae1(Class, getter) {
    return new Class({
        type: "lazy",
        getter: getter
    });
}
function $57904f98be373a74$export$d91bbb815217feb6(Class, innerType) {
    return new Class({
        type: "promise",
        innerType: innerType
    });
}
function $57904f98be373a74$export$8bfc2ce1398e3071(Class, fn, _params) {
    const norm = $23ixW.normalizeParams(_params);
    norm.abort ?? (norm.abort = true); // default to abort:false
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...norm
    });
    return schema;
}
function $57904f98be373a74$export$ac822e05051812e1(Class, fn, _params) {
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...$23ixW.normalizeParams(_params)
    });
    return schema;
}
function $57904f98be373a74$export$f2b01ecb843d7ab9(fn, params) {
    const ch = $57904f98be373a74$export$d37145829e4ff88e((payload)=>{
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push($23ixW.issue(issue, payload.value, ch._zod.def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                if (!("input" in _issue)) _issue.input = payload.value;
                _issue.inst ?? (_issue.inst = ch);
                _issue.continue ?? (_issue.continue = !ch._zod.def.abort); // abort is always undefined, so this is always true...
                payload.issues.push($23ixW.issue(_issue));
            }
        };
        return fn(payload.value, payload);
    }, params);
    return ch;
}
function $57904f98be373a74$export$d37145829e4ff88e(fn, params) {
    const ch = new $ggkLI.$ZodCheck({
        check: "custom",
        ...$23ixW.normalizeParams(params)
    });
    ch._zod.check = fn;
    return ch;
}
function $57904f98be373a74$export$cd5450f3a47e3789(description) {
    const ch = new $ggkLI.$ZodCheck({
        check: "describe"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = $5VtTM.globalRegistry.get(inst) ?? {};
            $5VtTM.globalRegistry.add(inst, {
                ...existing,
                description: description
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function $57904f98be373a74$export$6990040ee07315(metadata) {
    const ch = new $ggkLI.$ZodCheck({
        check: "meta"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = $5VtTM.globalRegistry.get(inst) ?? {};
            $5VtTM.globalRegistry.add(inst, {
                ...existing,
                ...metadata
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function $57904f98be373a74$export$a75528509e3a7006(Classes, _params) {
    const params = $23ixW.normalizeParams(_params);
    let truthyArray = params.truthy ?? [
        "true",
        "1",
        "yes",
        "on",
        "y",
        "enabled"
    ];
    let falsyArray = params.falsy ?? [
        "false",
        "0",
        "no",
        "off",
        "n",
        "disabled"
    ];
    if (params.case !== "sensitive") {
        truthyArray = truthyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
        falsyArray = falsyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
    }
    const truthySet = new Set(truthyArray);
    const falsySet = new Set(falsyArray);
    const _Codec = Classes.Codec ?? $jvcvr.$ZodCodec;
    const _Boolean = Classes.Boolean ?? $jvcvr.$ZodBoolean;
    const _String = Classes.String ?? $jvcvr.$ZodString;
    const stringSchema = new _String({
        type: "string",
        error: params.error
    });
    const booleanSchema = new _Boolean({
        type: "boolean",
        error: params.error
    });
    const codec = new _Codec({
        type: "pipe",
        in: stringSchema,
        out: booleanSchema,
        transform: (input, payload)=>{
            let data = input;
            if (params.case !== "sensitive") data = data.toLowerCase();
            if (truthySet.has(data)) return true;
            else if (falsySet.has(data)) return false;
            else {
                payload.issues.push({
                    code: "invalid_value",
                    expected: "stringbool",
                    values: [
                        ...truthySet,
                        ...falsySet
                    ],
                    input: payload.value,
                    inst: codec,
                    continue: false
                });
                return {};
            }
        },
        reverseTransform: (input, _payload)=>{
            if (input === true) return truthyArray[0] || "true";
            else return falsyArray[0] || "false";
        },
        error: params.error
    });
    codec._zod.bag.truthy = truthyArray;
    codec._zod.bag.falsy = falsyArray;
    codec._zod.bag.case = params.case ?? "insensitive";
    return codec;
}
function $57904f98be373a74$export$e25dde89ba546b88(Class, format, fnOrRegex, _params = {}) {
    const params = $23ixW.normalizeParams(_params);
    const def = {
        check: "string_format",
        type: "string",
        format: format,
        fn: typeof fnOrRegex === "function" ? fnOrRegex : (val)=>fnOrRegex.test(val),
        ...params
    };
    if (fnOrRegex instanceof RegExp) def.pattern = fnOrRegex;
    const inst = new Class(def);
    return inst;
}

});
parcelRegister("ggkLI", function(module, exports) {

$parcel$export(module.exports, "$ZodCheck", () => $bd6e402f1568d28b$export$c05d9110ef20bb2c);
$parcel$export(module.exports, "$ZodCheckLessThan", () => $bd6e402f1568d28b$export$294415ecbdd02022);
$parcel$export(module.exports, "$ZodCheckGreaterThan", () => $bd6e402f1568d28b$export$8b670f58decbca18);
$parcel$export(module.exports, "$ZodCheckMultipleOf", () => $bd6e402f1568d28b$export$ae602e11c1dd0628);
$parcel$export(module.exports, "$ZodCheckNumberFormat", () => $bd6e402f1568d28b$export$5c26c85ad6aed3e8);
$parcel$export(module.exports, "$ZodCheckBigIntFormat", () => $bd6e402f1568d28b$export$a0a6d75ce7dc4d36);
$parcel$export(module.exports, "$ZodCheckMaxSize", () => $bd6e402f1568d28b$export$b3cec505675cf50c);
$parcel$export(module.exports, "$ZodCheckMinSize", () => $bd6e402f1568d28b$export$59fb0a2e7217c42b);
$parcel$export(module.exports, "$ZodCheckSizeEquals", () => $bd6e402f1568d28b$export$af532c490f33cd47);
$parcel$export(module.exports, "$ZodCheckMaxLength", () => $bd6e402f1568d28b$export$b07b097887f4c15a);
$parcel$export(module.exports, "$ZodCheckMinLength", () => $bd6e402f1568d28b$export$cd5336aa96b8417c);
$parcel$export(module.exports, "$ZodCheckLengthEquals", () => $bd6e402f1568d28b$export$ccdb9b9d477068fb);
$parcel$export(module.exports, "$ZodCheckStringFormat", () => $bd6e402f1568d28b$export$e0c7f6847ab1b629);
$parcel$export(module.exports, "$ZodCheckRegex", () => $bd6e402f1568d28b$export$6faea86ff718d6df);
$parcel$export(module.exports, "$ZodCheckLowerCase", () => $bd6e402f1568d28b$export$e18e268bd5c9f27a);
$parcel$export(module.exports, "$ZodCheckUpperCase", () => $bd6e402f1568d28b$export$6d0944a5127e820a);
$parcel$export(module.exports, "$ZodCheckIncludes", () => $bd6e402f1568d28b$export$600021c28f0498dc);
$parcel$export(module.exports, "$ZodCheckStartsWith", () => $bd6e402f1568d28b$export$8e83a74b4b83cc62);
$parcel$export(module.exports, "$ZodCheckEndsWith", () => $bd6e402f1568d28b$export$4a10f85c6af4e92);
$parcel$export(module.exports, "$ZodCheckProperty", () => $bd6e402f1568d28b$export$d36a4eecd766dbc0);
$parcel$export(module.exports, "$ZodCheckMimeType", () => $bd6e402f1568d28b$export$5546147f1877f806);
$parcel$export(module.exports, "$ZodCheckOverwrite", () => $bd6e402f1568d28b$export$1bda1934456013d3);
// import { $ZodType } from "./schemas.js";

var $5SN0M = parcelRequire("5SN0M");

var $dZBpt = parcelRequire("dZBpt");

var $23ixW = parcelRequire("23ixW");
const $bd6e402f1568d28b$export$c05d9110ef20bb2c = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheck", (inst, def)=>{
    var _a;
    inst._zod ?? (inst._zod = {});
    inst._zod.def = def;
    (_a = inst._zod).onattach ?? (_a.onattach = []);
});
/** Default `when` for size-based checks: run only on non-nullish values with a `size`. */ const $bd6e402f1568d28b$var$_whenHasSize = (payload)=>{
    const val = payload.value;
    return !$23ixW.nullish(val) && val.size !== undefined;
};
/** Default `when` for length-based checks: run only on non-nullish values with a `length`. */ const $bd6e402f1568d28b$var$_whenHasLength = (payload)=>{
    const val = payload.value;
    return !$23ixW.nullish(val) && val.length !== undefined;
};
const $bd6e402f1568d28b$var$numericOriginMap = {
    number: "number",
    bigint: "bigint",
    object: "date"
};
const $bd6e402f1568d28b$export$294415ecbdd02022 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckLessThan", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $bd6e402f1568d28b$var$numericOriginMap[typeof def.value];
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value <= def.value : payload.value < def.value) return;
        payload.issues.push({
            origin: $bd6e402f1568d28b$var$numericOriginMap[typeof payload.value] ?? origin,
            code: "too_big",
            maximum: typeof def.value === "object" ? def.value.getTime() : def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$8b670f58decbca18 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckGreaterThan", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $bd6e402f1568d28b$var$numericOriginMap[typeof def.value];
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value >= def.value : payload.value > def.value) return;
        payload.issues.push({
            origin: $bd6e402f1568d28b$var$numericOriginMap[typeof payload.value] ?? origin,
            code: "too_small",
            minimum: typeof def.value === "object" ? def.value.getTime() : def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$ae602e11c1dd0628 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckMultipleOf", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        if (typeof payload.value !== typeof def.value) throw new Error("Cannot mix number and bigint in multiple_of check.");
        const isMultiple = typeof payload.value === "bigint" ? def.value !== BigInt(0) && payload.value % def.value === BigInt(0) : $23ixW.floatSafeRemainder(payload.value, def.value) === 0;
        if (isMultiple) return;
        payload.issues.push({
            origin: typeof payload.value,
            code: "not_multiple_of",
            divisor: def.value,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$5c26c85ad6aed3e8 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckNumberFormat", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    def.format = def.format || "float64";
    const isInt = def.format?.includes("int");
    const origin = isInt ? "int" : "number";
    const [minimum, maximum] = $23ixW.NUMBER_FORMAT_RANGES[def.format];
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (isInt) {
            if (!Number.isInteger(input)) {
                // invalid_format issue
                // payload.issues.push({
                //   expected: def.format,
                //   format: def.format,
                //   code: "invalid_format",
                //   input,
                //   inst,
                // });
                // invalid_type issue
                payload.issues.push({
                    expected: origin,
                    format: def.format,
                    code: "invalid_type",
                    continue: false,
                    input: input,
                    inst: inst
                });
                return;
            // not_multiple_of issue
            // payload.issues.push({
            //   code: "not_multiple_of",
            //   origin: "number",
            //   input,
            //   inst,
            //   divisor: 1,
            // });
            }
            if (!Number.isSafeInteger(input)) {
                if (input > 0) // too_big
                payload.issues.push({
                    input: input,
                    code: "too_big",
                    maximum: Number.MAX_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    inclusive: true,
                    continue: !def.abort
                });
                else // too_small
                payload.issues.push({
                    input: input,
                    code: "too_small",
                    minimum: Number.MIN_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    inclusive: true,
                    continue: !def.abort
                });
                return;
            }
        }
        if (input < minimum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_big",
            maximum: maximum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$a0a6d75ce7dc4d36 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckBigIntFormat", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    const [minimum, maximum] = $23ixW.BIGINT_FORMAT_RANGES[def.format];
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (input < minimum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_big",
            maximum: maximum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$b3cec505675cf50c = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckMaxSize", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $bd6e402f1568d28b$var$_whenHasSize);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size <= def.maximum) return;
        payload.issues.push({
            origin: $23ixW.getSizableOrigin(input),
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$59fb0a2e7217c42b = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckMinSize", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $bd6e402f1568d28b$var$_whenHasSize);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size >= def.minimum) return;
        payload.issues.push({
            origin: $23ixW.getSizableOrigin(input),
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$af532c490f33cd47 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckSizeEquals", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $bd6e402f1568d28b$var$_whenHasSize);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size === def.size) return;
        const tooBig = size > def.size;
        payload.issues.push({
            origin: $23ixW.getSizableOrigin(input),
            ...tooBig ? {
                code: "too_big",
                maximum: def.size
            } : {
                code: "too_small",
                minimum: def.size
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$b07b097887f4c15a = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckMaxLength", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $bd6e402f1568d28b$var$_whenHasLength);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const units = input.length;
        // Strings are measured in Unicode code points, not UTF-16 units. A code point is at most two units, so a string that already fits in units fits in code points; only an overflow has to be counted.
        const length = typeof input === "string" && units > def.maximum ? $23ixW.codePointLength(input) : units;
        if (length <= def.maximum) return;
        const origin = $23ixW.getLengthableOrigin(input);
        payload.issues.push({
            origin: origin,
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$cd5336aa96b8417c = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckMinLength", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $bd6e402f1568d28b$var$_whenHasLength);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const units = input.length;
        // A code point is one or two UTF-16 units, so fewer units than the floor can never reach it and twice the floor always clears it. Only in between is the exact count in doubt.
        const length = typeof input === "string" && units >= def.minimum && units < def.minimum * 2 ? $23ixW.codePointLength(input) : units;
        if (length >= def.minimum) return;
        const origin = $23ixW.getLengthableOrigin(input);
        payload.issues.push({
            origin: origin,
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$ccdb9b9d477068fb = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckLengthEquals", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $bd6e402f1568d28b$var$_whenHasLength);
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const units = input.length;
        // A code point is one or two UTF-16 units, so outside `[length, length * 2]` units the target is missed either way — and missed in the same direction in both measures.
        const length = typeof input === "string" && units >= def.length && units <= def.length * 2 ? $23ixW.codePointLength(input) : units;
        if (length === def.length) return;
        const origin = $23ixW.getLengthableOrigin(input);
        const tooBig = length > def.length;
        payload.issues.push({
            origin: origin,
            ...tooBig ? {
                code: "too_big",
                maximum: def.length
            } : {
                code: "too_small",
                minimum: def.length
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$e0c7f6847ab1b629 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckStringFormat", (inst, def)=>{
    var _a, _b;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    if (def.pattern) (_a = inst._zod).check ?? (_a.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            ...def.pattern ? {
                pattern: def.pattern.toString()
            } : {},
            inst: inst,
            continue: !def.abort
        });
    });
    else (_b = inst._zod).check ?? (_b.check = ()=>{});
});
const $bd6e402f1568d28b$export$6faea86ff718d6df = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckRegex", (inst, def)=>{
    $bd6e402f1568d28b$export$e0c7f6847ab1b629.init(inst, def);
    inst._zod.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "regex",
            input: payload.value,
            pattern: def.pattern.toString(),
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$e18e268bd5c9f27a = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckLowerCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.lowercase);
    $bd6e402f1568d28b$export$e0c7f6847ab1b629.init(inst, def);
});
const $bd6e402f1568d28b$export$6d0944a5127e820a = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckUpperCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.uppercase);
    $bd6e402f1568d28b$export$e0c7f6847ab1b629.init(inst, def);
});
const $bd6e402f1568d28b$export$600021c28f0498dc = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckIncludes", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const escapedRegex = $23ixW.escapeRegex(def.includes);
    // `String.prototype.includes(sub, position)` matches `sub` at `position`
    // OR LATER, so the pattern must allow at least `position` leading chars
    // (`{N,}`), not exactly `position` chars (`{N}`).
    const pattern = new RegExp(typeof def.position === "number" ? `^.{${def.position},}${escapedRegex}` : escapedRegex);
    def.pattern = pattern;
    inst._zod.check = (payload)=>{
        if (payload.value.includes(def.includes, def.position)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "includes",
            includes: def.includes,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$8e83a74b4b83cc62 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckStartsWith", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`^${$23ixW.escapeRegex(def.prefix)}.*`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.check = (payload)=>{
        if (payload.value.startsWith(def.prefix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "starts_with",
            prefix: def.prefix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$4a10f85c6af4e92 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckEndsWith", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`.*${$23ixW.escapeRegex(def.suffix)}$`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.check = (payload)=>{
        if (payload.value.endsWith(def.suffix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "ends_with",
            suffix: def.suffix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
///////////////////////////////////
/////    $ZodCheckProperty    /////
///////////////////////////////////
function $bd6e402f1568d28b$var$handleCheckPropertyResult(result, payload, property) {
    if (result.issues.length) payload.issues.push(...$23ixW.prefixIssues(property, result.issues));
}
const $bd6e402f1568d28b$export$d36a4eecd766dbc0 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckProperty", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        const result = def.schema._zod.run({
            value: payload.value[def.property],
            issues: []
        }, {});
        if (result instanceof Promise) return result.then((result)=>$bd6e402f1568d28b$var$handleCheckPropertyResult(result, payload, def.property));
        $bd6e402f1568d28b$var$handleCheckPropertyResult(result, payload, def.property);
        return;
    };
});
const $bd6e402f1568d28b$export$5546147f1877f806 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckMimeType", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const mimeSet = new Set(def.mime);
    inst._zod.check = (payload)=>{
        if (mimeSet.has(payload.value.type)) return;
        payload.issues.push({
            code: "invalid_value",
            values: def.mime,
            input: payload.value.type,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$1bda1934456013d3 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCheckOverwrite", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        payload.value = def.tx(payload.value);
    };
});

});
parcelRegister("5SN0M", function(module, exports) {

$parcel$export(module.exports, "$constructor", () => $4488038d123e8fa5$export$3122533d606194de);
$parcel$export(module.exports, "$ZodAsyncError", () => $4488038d123e8fa5$export$13016bcec11ba196);
$parcel$export(module.exports, "$ZodEncodeError", () => $4488038d123e8fa5$export$a36d4c29b1151bde);
$parcel$export(module.exports, "globalConfig", () => $4488038d123e8fa5$export$f9cd1e43211d8a4a);
$parcel$export(module.exports, "config", () => $4488038d123e8fa5$export$e506a1d27d1eaa20);

var $23ixW = parcelRequire("23ixW");
var $4488038d123e8fa5$var$_a;
const $4488038d123e8fa5$export$96c94437c95d7862 = /*@__PURE__*/ Object.freeze({
    status: "aborted"
});
/* Shared descriptor for installing `_zod`; defineProperty reads it
 * synchronously, so reusing one object avoids a per-instance allocation. */ const $4488038d123e8fa5$var$_zodDesc = {
    value: undefined,
    enumerable: false
};
// null where suppressing the capture would be unrecoverable: `parse()` puts the frames back with `captureStackTrace`, so without it the throw would lose its stack. also latched to null once `stackTraceLimit` proves unassignable, which a realm can do at any point by hardening Error
let $4488038d123e8fa5$var$_E = "captureStackTrace" in Error ? Error : null;
// v8 captures a stack trace inside the Error constructor, which dominates a failed parse; costs only the frames, and parse() restores those. the constructor must RUN: Object.create is cheaper and passes instanceof, but Error.isError and util.types.isNativeError check an internal slot
function $4488038d123e8fa5$var$newError(Definition) {
    const E = $4488038d123e8fa5$var$_E;
    if (E) {
        const saved = E.stackTraceLimit;
        if (typeof saved === "number") {
            try {
                E.stackTraceLimit = 0;
            } catch  {
                $4488038d123e8fa5$var$_E = null;
                return new Definition();
            }
            try {
                return new Definition();
            } finally{
                E.stackTraceLimit = saved;
            }
        }
    }
    return new Definition();
}
/*@__NO_SIDE_EFFECTS__*/ function $4488038d123e8fa5$export$3122533d606194de(name, initializer, /** This trait's members, installed once on every prototype that composes it. They cannot be declared in the initializer above: that runs per instance, and the prototype is shared. */ proto, params) {
    // Prototype for this constructor's `_zod` internals. Lazily-derived fields (`values`, `pattern`, `optin`, …) install here once rather than as an accessor on every instance.
    const zodProto = {};
    // Assigning the fields in the constructor body is what gives instances in-object slots; building the object literally and reparenting it costs a second allocation and a generic property copy.
    function Internals(def) {
        this.def = def;
        this.constr = _;
        this.traits = new Set();
    }
    Internals.prototype = zodProto;
    const protoMembers = proto;
    // One trait's members land on every prototype whose chain composes it, so the answer is per prototype rather than per trait.
    const initialized = protoMembers && new WeakSet();
    function init(inst, def) {
        if (!inst._zod) {
            $4488038d123e8fa5$var$_zodDesc.value = new Internals(def);
            try {
                Object.defineProperty(inst, "_zod", $4488038d123e8fa5$var$_zodDesc);
            } finally{
                // Cleared even on throw, so the shared descriptor never leaks one instance's internals into the next.
                $4488038d123e8fa5$var$_zodDesc.value = undefined;
            }
        }
        if (inst._zod.traits.has(name)) return;
        inst._zod.traits.add(name);
        initializer(inst, def);
        if (initialized) {
            // `super(def)` from a user subclass gives `this` a prototype the subclass owns, and installing there would overwrite whatever the subclass declared. `constr` built the instance, so its prototype is the one below the subclass's that should carry the members. A receiver whose chain never reaches that prototype installs on its own, which for a plain object handed straight to `init` means `Object.prototype` — unchanged from before.
            const own = Object.getPrototypeOf(inst);
            const ctorProto = inst._zod.constr.prototype;
            let up = own;
            while(up && up !== ctorProto)up = Object.getPrototypeOf(up);
            const target = up ?? own;
            if (!initialized.has(target)) {
                initialized.add(target);
                (0, $23ixW.members)(target, protoMembers);
            }
        }
        // support prototype modifications; for-in avoids the array allocation of Object.keys on the (usually empty) prototype
        const proto = _.prototype;
        for(const k in proto){
            if (!Object.prototype.hasOwnProperty.call(proto, k)) continue;
            if (!(k in inst)) inst[k] = proto[k].bind(inst);
        }
    }
    // doesn't work if Parent has a constructor with arguments
    const Parent = params?.Parent ?? Object;
    class Definition extends Parent {
    }
    Object.defineProperty(Definition, "name", {
        value: name
    });
    function _(def) {
        const inst = params?.Parent ? $4488038d123e8fa5$var$newError(Definition) : this;
        init(inst, def);
        const deferred = inst._zod.deferred;
        if (deferred) {
            for (const fn of deferred)fn();
            // Released: initializers run once, and the list would otherwise be retained for the schema's lifetime.
            inst._zod.deferred = undefined;
        }
        // Global post-processor hook. Internal: installed by `import "zod/compile"` to enable AOT compilation for every constructed schema. Runs last, once the instance is fully built, because it hands the instance to compile(). The post-processor is expected to be reentrancy-guarded by its own implementation.
        const pp = globalThis.__zod_globalConfig?.postProcessor;
        if (pp) pp(inst);
        return inst;
    }
    Object.defineProperty(_, "init", {
        value: init
    });
    Object.defineProperty(_, Symbol.hasInstance, {
        value: (inst)=>{
            if (params?.Parent && inst instanceof params.Parent) return true;
            return inst?._zod?.traits?.has(name);
        }
    });
    Object.defineProperty(_, "name", {
        value: name
    });
    return _;
}
const $4488038d123e8fa5$export$7d40e40c5b5a6c8f = /*@__PURE__*/ Symbol("zod_brand");
class $4488038d123e8fa5$export$13016bcec11ba196 extends Error {
    constructor(){
        super(`Encountered Promise during synchronous parse. Use .parseAsync() instead.`);
    }
}
class $4488038d123e8fa5$export$a36d4c29b1151bde extends Error {
    constructor(name){
        super(`Encountered unidirectional transform during encode: ${name}`);
        this.name = "ZodEncodeError";
    }
}
($4488038d123e8fa5$var$_a = globalThis).__zod_globalConfig ?? ($4488038d123e8fa5$var$_a.__zod_globalConfig = {});
const $4488038d123e8fa5$export$f9cd1e43211d8a4a = globalThis.__zod_globalConfig;
function $4488038d123e8fa5$export$e506a1d27d1eaa20(newConfig) {
    if (newConfig) Object.assign($4488038d123e8fa5$export$f9cd1e43211d8a4a, newConfig);
    return $4488038d123e8fa5$export$f9cd1e43211d8a4a;
}

});
parcelRegister("23ixW", function(module, exports) {

$parcel$export(module.exports, "assertEqual", () => $17ea3f861a2ff584$export$27555cdfb0b84a1a);
$parcel$export(module.exports, "assertNotEqual", () => $17ea3f861a2ff584$export$49eedac51f614f7d);
$parcel$export(module.exports, "toZod", () => $17ea3f861a2ff584$export$e95468e219bfe076);
$parcel$export(module.exports, "assertIs", () => $17ea3f861a2ff584$export$6fee1f82edcf4a03);
$parcel$export(module.exports, "assertNever", () => $17ea3f861a2ff584$export$cbadc5a7223772a8);
$parcel$export(module.exports, "assert", () => $17ea3f861a2ff584$export$a7a9523472993e97);
$parcel$export(module.exports, "getEnumValues", () => $17ea3f861a2ff584$export$70a5d58ec00f3c11);
$parcel$export(module.exports, "joinValues", () => $17ea3f861a2ff584$export$e79b744344f50f50);
$parcel$export(module.exports, "stringifyPrimitive", () => $17ea3f861a2ff584$export$5859860f650378f4);
$parcel$export(module.exports, "jsonStringifyReplacer", () => $17ea3f861a2ff584$export$f4defb13cab882b2);
$parcel$export(module.exports, "cached", () => $17ea3f861a2ff584$export$ade7a147f5129058);
$parcel$export(module.exports, "nullish", () => $17ea3f861a2ff584$export$69fd1b70ebae5687);
$parcel$export(module.exports, "cleanRegex", () => $17ea3f861a2ff584$export$78d521805d6c22e4);
$parcel$export(module.exports, "floatSafeRemainder", () => $17ea3f861a2ff584$export$7807b52a740a7117);
$parcel$export(module.exports, "defineLazy", () => $17ea3f861a2ff584$export$d43070a5843c1e2);
$parcel$export(module.exports, "objectClone", () => $17ea3f861a2ff584$export$103832c7353c2f50);
$parcel$export(module.exports, "assignProp", () => $17ea3f861a2ff584$export$2e23d0571746a3fb);
$parcel$export(module.exports, "rawShape", () => $17ea3f861a2ff584$export$fd1f02864f419aa5);
$parcel$export(module.exports, "mergeDefs", () => $17ea3f861a2ff584$export$8969f8c824382d73);
$parcel$export(module.exports, "cloneDef", () => $17ea3f861a2ff584$export$21596dc63856f4c1);
$parcel$export(module.exports, "getElementAtPath", () => $17ea3f861a2ff584$export$4b74d241e1cc7892);
$parcel$export(module.exports, "promiseAllObject", () => $17ea3f861a2ff584$export$3db3408dad58da23);
$parcel$export(module.exports, "randomString", () => $17ea3f861a2ff584$export$7fa8378418b4411e);
$parcel$export(module.exports, "esc", () => $17ea3f861a2ff584$export$a1a11b095f88289a);
$parcel$export(module.exports, "slugify", () => $17ea3f861a2ff584$export$c383cdd2a518017a);
$parcel$export(module.exports, "captureStackTrace", () => $17ea3f861a2ff584$export$756e5cd2d260237b);
$parcel$export(module.exports, "isObject", () => $17ea3f861a2ff584$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "allowsEval", () => $17ea3f861a2ff584$export$1f119cb4d720843b);
$parcel$export(module.exports, "isPlainObject", () => $17ea3f861a2ff584$export$53b83ca8eaab0383);
$parcel$export(module.exports, "shallowClone", () => $17ea3f861a2ff584$export$370e8311c3cdebd9);
$parcel$export(module.exports, "numKeys", () => $17ea3f861a2ff584$export$71667e74ba29447f);
$parcel$export(module.exports, "getParsedType", () => $17ea3f861a2ff584$export$3e9057828ebd5c7a);
$parcel$export(module.exports, "propertyKeyTypes", () => $17ea3f861a2ff584$export$b99c149ecf60be48);
$parcel$export(module.exports, "primitiveTypes", () => $17ea3f861a2ff584$export$c34ffd355f76f0e4);
$parcel$export(module.exports, "escapeRegex", () => $17ea3f861a2ff584$export$104ed90cc1a13451);
$parcel$export(module.exports, "clone", () => $17ea3f861a2ff584$export$9cd59f9826255e47);
$parcel$export(module.exports, "normalizeParams", () => $17ea3f861a2ff584$export$d6b7b25dfacfd300);
$parcel$export(module.exports, "createTransparentProxy", () => $17ea3f861a2ff584$export$6ebbd8d3cb03909b);
$parcel$export(module.exports, "optionalKeys", () => $17ea3f861a2ff584$export$240159211e66adb9);
$parcel$export(module.exports, "NUMBER_FORMAT_RANGES", () => $17ea3f861a2ff584$export$8e78302060ccf26f);
$parcel$export(module.exports, "BIGINT_FORMAT_RANGES", () => $17ea3f861a2ff584$export$538d1d6d5cfcb3b6);
$parcel$export(module.exports, "pick", () => $17ea3f861a2ff584$export$357523c63a2253b9);
$parcel$export(module.exports, "omit", () => $17ea3f861a2ff584$export$30a06c8d3562193f);
$parcel$export(module.exports, "extend", () => $17ea3f861a2ff584$export$8b58be045bf06082);
$parcel$export(module.exports, "safeExtend", () => $17ea3f861a2ff584$export$40c90eb222f50efb);
$parcel$export(module.exports, "merge", () => $17ea3f861a2ff584$export$4950aa0f605343fb);
$parcel$export(module.exports, "partial", () => $17ea3f861a2ff584$export$e45945969df8035a);
$parcel$export(module.exports, "required", () => $17ea3f861a2ff584$export$a7a0278c004aac3f);
$parcel$export(module.exports, "aborted", () => $17ea3f861a2ff584$export$bd75b6d981b9c7f2);
$parcel$export(module.exports, "explicitlyAborted", () => $17ea3f861a2ff584$export$a5fe2d8610d815ec);
$parcel$export(module.exports, "prefixIssues", () => $17ea3f861a2ff584$export$7f35a4c434118b9e);
$parcel$export(module.exports, "unwrapMessage", () => $17ea3f861a2ff584$export$56590e5a47837d61);
$parcel$export(module.exports, "attachSchema", () => $17ea3f861a2ff584$export$5f3bf32142eef856);
$parcel$export(module.exports, "finalizeIssue", () => $17ea3f861a2ff584$export$c5e667bbfc286a9d);
$parcel$export(module.exports, "getSizableOrigin", () => $17ea3f861a2ff584$export$67a7c9c676c45d2b);
$parcel$export(module.exports, "codePointLength", () => $17ea3f861a2ff584$export$89f26bd0a2764944);
$parcel$export(module.exports, "getLengthableOrigin", () => $17ea3f861a2ff584$export$479f5a070abeb487);
$parcel$export(module.exports, "parsedType", () => $17ea3f861a2ff584$export$858d360cf6da2b65);
$parcel$export(module.exports, "issue", () => $17ea3f861a2ff584$export$69ad3503f98be476);
$parcel$export(module.exports, "cleanEnum", () => $17ea3f861a2ff584$export$9b57aa937148f32);
$parcel$export(module.exports, "base64ToUint8Array", () => $17ea3f861a2ff584$export$f01069a3c307e50e);
$parcel$export(module.exports, "uint8ArrayToBase64", () => $17ea3f861a2ff584$export$36bac84b1c2da9c7);
$parcel$export(module.exports, "base64urlToUint8Array", () => $17ea3f861a2ff584$export$b9fa2551f2db41e1);
$parcel$export(module.exports, "uint8ArrayToBase64url", () => $17ea3f861a2ff584$export$975f78e50159df6f);
$parcel$export(module.exports, "hexToUint8Array", () => $17ea3f861a2ff584$export$6c74ef56152ffb8d);
$parcel$export(module.exports, "uint8ArrayToHex", () => $17ea3f861a2ff584$export$c44b02fb03dbac82);
$parcel$export(module.exports, "Class", () => $17ea3f861a2ff584$export$4c85e640eb41c31b);
$parcel$export(module.exports, "members", () => $17ea3f861a2ff584$export$100ad4af8c8d544f);
$parcel$export(module.exports, "own", () => $17ea3f861a2ff584$export$a97a0f27b0201230);
$parcel$export(module.exports, "hide", () => $17ea3f861a2ff584$export$fe8985bb6374093c);
$parcel$export(module.exports, "derived", () => $17ea3f861a2ff584$export$90b0b54dab0a340a);
$parcel$export(module.exports, "defineLazyInternal", () => $17ea3f861a2ff584$export$ab4d63bd6339ba82);
$parcel$export(module.exports, "installLazyProp", () => $17ea3f861a2ff584$export$fd3ec217a5ca1bc7);
$parcel$export(module.exports, "CONSTANT_CATCH", () => $17ea3f861a2ff584$export$2644f2739b5380cd);
$parcel$export(module.exports, "constantCatch", () => $17ea3f861a2ff584$export$79bf7eed34458669);

var $5SN0M = parcelRequire("5SN0M");
function $17ea3f861a2ff584$export$27555cdfb0b84a1a(val) {
    return val;
}
function $17ea3f861a2ff584$export$49eedac51f614f7d(val) {
    return val;
}
function $17ea3f861a2ff584$export$e95468e219bfe076() {
    return (schema)=>schema;
}
function $17ea3f861a2ff584$export$6fee1f82edcf4a03(_arg) {}
function $17ea3f861a2ff584$export$cbadc5a7223772a8(_x) {
    throw new Error("Unexpected value in exhaustive check");
}
function $17ea3f861a2ff584$export$a7a9523472993e97(_) {}
function $17ea3f861a2ff584$export$70a5d58ec00f3c11(entries) {
    const numericValues = Object.values(entries).filter((v)=>typeof v === "number");
    const values = Object.entries(entries).filter(([k, _])=>numericValues.indexOf(+k) === -1).map(([_, v])=>v);
    return values;
}
function $17ea3f861a2ff584$export$e79b744344f50f50(array, separator = "|") {
    return array.map((val)=>$17ea3f861a2ff584$export$5859860f650378f4(val)).join(separator);
}
function $17ea3f861a2ff584$export$f4defb13cab882b2(_, value) {
    if (typeof value === "bigint") return value.toString();
    return value;
}
// the accessor lives on a shared prototype: an own accessor makes every box a dictionary-mode object (~360 B and a slow load per read against ~100 B and an inlined getter here)
class $17ea3f861a2ff584$var$Cached {
    constructor(getter){
        this._getter = getter;
        this._value = undefined;
    }
    get value() {
        const getter = this._getter;
        if (getter !== undefined) {
            this._value = getter();
            this._getter = undefined;
        }
        return this._value;
    }
}
function $17ea3f861a2ff584$export$ade7a147f5129058(getter) {
    return new $17ea3f861a2ff584$var$Cached(getter);
}
function $17ea3f861a2ff584$export$69fd1b70ebae5687(input) {
    return input === null || input === undefined;
}
function $17ea3f861a2ff584$export$78d521805d6c22e4(source) {
    const start = source.startsWith("^") ? 1 : 0;
    const end = source.endsWith("$") ? source.length - 1 : source.length;
    return source.slice(start, end);
}
function $17ea3f861a2ff584$export$7807b52a740a7117(val, step) {
    const ratio = val / step;
    const roundedRatio = Math.round(ratio);
    // `val` and `step` each round to a double before the division rounds again, so a true decimal multiple's quotient can sit up to 1.5 of these scaled epsilons from the integer. A 1x tolerance therefore rejected 2.03 as a multiple of 0.07; 4x covers the worst case with margin.
    const tolerance = 4 * Number.EPSILON * Math.max(Math.abs(ratio), 1);
    if (Math.abs(ratio - roundedRatio) < tolerance) return 0;
    return ratio - roundedRatio;
}
const $17ea3f861a2ff584$var$EVALUATING = /* @__PURE__*/ Symbol("evaluating");
function $17ea3f861a2ff584$export$d43070a5843c1e2(object, key, getter) {
    let value = undefined;
    Object.defineProperty(object, key, {
        get () {
            if (value === $17ea3f861a2ff584$var$EVALUATING) // Circular reference detected, return undefined to break the cycle
            return undefined;
            if (value === undefined) {
                value = $17ea3f861a2ff584$var$EVALUATING;
                value = getter();
            }
            return value;
        },
        set (v) {
            Object.defineProperty(object, key, {
                value: v
            });
        // object[key] = v;
        },
        configurable: true
    });
}
function $17ea3f861a2ff584$export$103832c7353c2f50(obj) {
    return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
}
function $17ea3f861a2ff584$export$2e23d0571746a3fb(target, prop, value) {
    Object.defineProperty(target, prop, {
        value: value,
        writable: true,
        enumerable: true,
        configurable: true
    });
}
function $17ea3f861a2ff584$export$fd1f02864f419aa5(def) {
    const desc = Object.getOwnPropertyDescriptor(def, "shape");
    return desc?.get ? desc.get.raw : desc?.value;
}
// where a builder reads its source's keys and descriptors, resolving only a shape a def answers for itself. A shape resolves by object spread, so only its enumerable keys are ever part of it.
function $17ea3f861a2ff584$var$sourceShape(schema) {
    return $17ea3f861a2ff584$export$fd1f02864f419aa5(schema._zod.def) ?? schema._zod.def.shape;
}
// a key whose value is not settled yet, self-caching so every read after the first gets the same one
function $17ea3f861a2ff584$var$deferProp(target, key, getter) {
    Object.defineProperty(target, key, {
        get () {
            const value = getter();
            $17ea3f861a2ff584$export$2e23d0571746a3fb(this, key, value);
            return value;
        },
        enumerable: true,
        configurable: true
    });
}
// Writes a settled key. A plain assignment is much cheaper than `defineProperty` and produces the same descriptor, but it runs whatever setter already answers to the key — an accessor this shape deferred, or an inherited one, which `__proto__` has on every object and prototype pollution can add for any name.
function $17ea3f861a2ff584$var$putProp(target, key, value) {
    if (key in target) $17ea3f861a2ff584$export$2e23d0571746a3fb(target, key, value);
    else target[key] = value;
}
/**
 * Copies `keys` of `source`'s shape onto `target`, each value passed through `wrap`.
 *
 * A key the source has resolved is copied through now, so the derived shape states it outright and nothing has to resolve it to learn what it holds. A key the source still defers stays deferred, and reads back through the source's own `shape`, so it resolves once and both shapes get that one schema.
 */ function $17ea3f861a2ff584$var$mirrorShape(target, source, keys, wrap) {
    const raw = $17ea3f861a2ff584$var$sourceShape(source);
    for (const key of keys){
        const desc = Object.getOwnPropertyDescriptor(raw, key);
        if (!desc.enumerable) continue;
        if (desc.get) $17ea3f861a2ff584$var$deferProp(target, key, ()=>{
            const value = source._zod.def.shape[key];
            return wrap ? wrap(value, key) : value;
        });
        else $17ea3f861a2ff584$var$putProp(target, key, wrap ? wrap(desc.value, key) : desc.value);
    }
}
// same, for a plain shape a caller passed rather than a schema's
function $17ea3f861a2ff584$var$mirrorProps(target, source) {
    for (const key of Reflect.ownKeys(source)){
        const desc = Object.getOwnPropertyDescriptor(source, key);
        if (!desc.enumerable) continue;
        if (desc.get) $17ea3f861a2ff584$var$deferProp(target, key, ()=>source[key]);
        else $17ea3f861a2ff584$var$putProp(target, key, desc.value);
    }
}
function $17ea3f861a2ff584$export$8969f8c824382d73(...defs) {
    const mergedDescriptors = {};
    for (const def of defs){
        const descriptors = Object.getOwnPropertyDescriptors(def);
        Object.assign(mergedDescriptors, descriptors);
    }
    return Object.defineProperties({}, mergedDescriptors);
}
function $17ea3f861a2ff584$export$21596dc63856f4c1(schema) {
    return $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def);
}
function $17ea3f861a2ff584$export$4b74d241e1cc7892(obj, path) {
    if (!path) return obj;
    return path.reduce((acc, key)=>acc?.[key], obj);
}
function $17ea3f861a2ff584$export$3db3408dad58da23(promisesObj) {
    const keys = Object.keys(promisesObj);
    const promises = keys.map((key)=>promisesObj[key]);
    return Promise.all(promises).then((results)=>{
        const resolvedObj = {};
        for(let i = 0; i < keys.length; i++)resolvedObj[keys[i]] = results[i];
        return resolvedObj;
    });
}
function $17ea3f861a2ff584$export$7fa8378418b4411e(length = 10) {
    const chars = "abcdefghijklmnopqrstuvwxyz";
    let str = "";
    for(let i = 0; i < length; i++)str += chars[Math.floor(Math.random() * chars.length)];
    return str;
}
function $17ea3f861a2ff584$export$a1a11b095f88289a(str) {
    return JSON.stringify(str);
}
function $17ea3f861a2ff584$export$c383cdd2a518017a(input) {
    return input.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const $17ea3f861a2ff584$export$756e5cd2d260237b = "captureStackTrace" in Error ? Error.captureStackTrace : (..._args)=>{};
function $17ea3f861a2ff584$export$a6cdc56e425d0d0a(data) {
    return typeof data === "object" && data !== null && !Array.isArray(data);
}
const $17ea3f861a2ff584$export$1f119cb4d720843b = /* @__PURE__*/ $17ea3f861a2ff584$export$ade7a147f5129058(()=>{
    // Skip the probe under `jitless`: strict CSPs report the caught `new Function` as a `securitypolicyviolation` even though the throw is swallowed.
    if ((0, $5SN0M.globalConfig).jitless) return false;
    // @ts-ignore
    if (typeof navigator !== "undefined" && navigator?.userAgent?.includes("Cloudflare")) return false;
    try {
        const F = Function;
        new F("");
        return true;
    } catch (_) {
        return false;
    }
});
function $17ea3f861a2ff584$export$53b83ca8eaab0383(o) {
    if ($17ea3f861a2ff584$export$a6cdc56e425d0d0a(o) === false) return false;
    // modified constructor
    const ctor = o.constructor;
    if (ctor === undefined) return true;
    if (typeof ctor !== "function") return true;
    // modified prototype
    const prot = ctor.prototype;
    if ($17ea3f861a2ff584$export$a6cdc56e425d0d0a(prot) === false) return false;
    // ctor doesn't have static `isPrototypeOf`
    if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) return false;
    return true;
}
function $17ea3f861a2ff584$export$370e8311c3cdebd9(o) {
    if ($17ea3f861a2ff584$export$53b83ca8eaab0383(o)) return {
        ...o
    };
    if (Array.isArray(o)) return [
        ...o
    ];
    if (o instanceof Map) return new Map(o);
    if (o instanceof Set) return new Set(o);
    return o;
}
function $17ea3f861a2ff584$export$71667e74ba29447f(data) {
    let keyCount = 0;
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) keyCount++;
    return keyCount;
}
const $17ea3f861a2ff584$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return "undefined";
        case "string":
            return "string";
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "boolean":
            return "boolean";
        case "function":
            return "function";
        case "bigint":
            return "bigint";
        case "symbol":
            return "symbol";
        case "object":
            if (Array.isArray(data)) return "array";
            if (data === null) return "null";
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return "promise";
            if (typeof Map !== "undefined" && data instanceof Map) return "map";
            if (typeof Set !== "undefined" && data instanceof Set) return "set";
            if (typeof Date !== "undefined" && data instanceof Date) return "date";
            // @ts-ignore
            if (typeof File !== "undefined" && data instanceof File) return "file";
            return "object";
        default:
            throw new Error(`Unknown data type: ${t}`);
    }
};
const $17ea3f861a2ff584$export$b99c149ecf60be48 = /* @__PURE__*/ new Set([
    "string",
    "number",
    "symbol"
]);
const $17ea3f861a2ff584$export$c34ffd355f76f0e4 = /* @__PURE__*/ new Set([
    "string",
    "number",
    "bigint",
    "boolean",
    "symbol",
    "undefined"
]);
function $17ea3f861a2ff584$export$104ed90cc1a13451(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $17ea3f861a2ff584$export$9cd59f9826255e47(inst, def, params) {
    const cl = new inst._zod.constr(def ?? inst._zod.def);
    if (!def || params?.parent) cl._zod.parent = inst;
    return cl;
}
function $17ea3f861a2ff584$export$d6b7b25dfacfd300(_params) {
    const params = _params;
    if (!params) return {};
    if (typeof params === "string") return {
        error: ()=>params
    };
    if (params?.message !== undefined) {
        if (params?.error !== undefined) throw new Error("Cannot specify both `message` and `error` params");
        params.error = params.message;
    }
    delete params.message;
    if (typeof params.error === "string") return {
        ...params,
        error: ()=>params.error
    };
    return params;
}
function $17ea3f861a2ff584$export$6ebbd8d3cb03909b(getter) {
    let target;
    return new Proxy({}, {
        get (_, prop, receiver) {
            target ?? (target = getter());
            return Reflect.get(target, prop, receiver);
        },
        set (_, prop, value, receiver) {
            target ?? (target = getter());
            return Reflect.set(target, prop, value, receiver);
        },
        has (_, prop) {
            target ?? (target = getter());
            return Reflect.has(target, prop);
        },
        deleteProperty (_, prop) {
            target ?? (target = getter());
            return Reflect.deleteProperty(target, prop);
        },
        ownKeys (_) {
            target ?? (target = getter());
            return Reflect.ownKeys(target);
        },
        getOwnPropertyDescriptor (_, prop) {
            target ?? (target = getter());
            return Reflect.getOwnPropertyDescriptor(target, prop);
        },
        defineProperty (_, prop, descriptor) {
            target ?? (target = getter());
            return Reflect.defineProperty(target, prop, descriptor);
        }
    });
}
function $17ea3f861a2ff584$export$5859860f650378f4(value) {
    if (typeof value === "bigint") return value.toString() + "n";
    if (typeof value === "string") return `"${value}"`;
    return `${value}`;
}
function $17ea3f861a2ff584$export$240159211e66adb9(shape) {
    return Object.keys(shape).filter((k)=>{
        return shape[k]._zod.optin !== undefined && shape[k]._zod.optout === "optional";
    });
}
const $17ea3f861a2ff584$export$8e78302060ccf26f = /*@__PURE__*/ (()=>({
        safeint: [
            Number.MIN_SAFE_INTEGER,
            Number.MAX_SAFE_INTEGER
        ],
        int32: [
            -2147483648,
            2147483647
        ],
        uint32: [
            0,
            4294967295
        ],
        float32: [
            -340282346638528860000000000000000000000,
            3.4028234663852886e38
        ],
        float64: [
            -Number.MAX_VALUE,
            Number.MAX_VALUE
        ]
    }))();
const $17ea3f861a2ff584$export$538d1d6d5cfcb3b6 = {
    int64: [
        /* @__PURE__*/ BigInt("-9223372036854775808"),
        /* @__PURE__*/ BigInt("9223372036854775807")
    ],
    uint64: [
        /* @__PURE__*/ BigInt(0),
        /* @__PURE__*/ BigInt("18446744073709551615")
    ]
};
function $17ea3f861a2ff584$export$357523c63a2253b9(schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".pick() cannot be used on object schemas containing refinements");
    const newShape = {};
    $17ea3f861a2ff584$var$mirrorShape(newShape, schema, $17ea3f861a2ff584$var$maskedKeys(schema, mask));
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, $17ea3f861a2ff584$export$8969f8c824382d73(currDef, {
        shape: newShape,
        checks: []
    }));
}
// the mask keys that select something, checked against the source's shape without resolving it
function $17ea3f861a2ff584$var$maskedKeys(schema, mask) {
    const raw = $17ea3f861a2ff584$var$sourceShape(schema);
    const keys = [];
    // `for...in` skips symbols, so a symbol in the mask would select nothing
    for (const key of Reflect.ownKeys(mask)){
        if (!Object.getOwnPropertyDescriptor(raw, key)?.enumerable) throw new Error(`Unrecognized key: "${String(key)}"`);
        if (mask[key]) keys.push(key);
    }
    return keys;
}
function $17ea3f861a2ff584$export$30a06c8d3562193f(schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".omit() cannot be used on object schemas containing refinements");
    const omitted = new Set($17ea3f861a2ff584$var$maskedKeys(schema, mask));
    const newShape = {};
    $17ea3f861a2ff584$var$mirrorShape(newShape, schema, Reflect.ownKeys($17ea3f861a2ff584$var$sourceShape(schema)).filter((key)=>!omitted.has(key)));
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, $17ea3f861a2ff584$export$8969f8c824382d73(currDef, {
        shape: newShape,
        checks: []
    }));
}
function $17ea3f861a2ff584$export$8b58be045bf06082(schema, shape) {
    if (!$17ea3f861a2ff584$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to extend: expected a plain object");
    const checks = schema._zod.def.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) {
        // Only throw if new shape overlaps with existing shape. Use getOwnPropertyDescriptor to check key existence without accessing values
        const existingShape = $17ea3f861a2ff584$var$sourceShape(schema);
        for (const key of Reflect.ownKeys(shape)){
            if (Object.getOwnPropertyDescriptor(existingShape, key) !== undefined) throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
        }
    }
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def, {
        shape: $17ea3f861a2ff584$var$extended(schema, shape)
    }));
}
// the source's keys, then the caller's overlaid on top
function $17ea3f861a2ff584$var$extended(schema, shape) {
    const newShape = {};
    $17ea3f861a2ff584$var$mirrorShape(newShape, schema, Reflect.ownKeys($17ea3f861a2ff584$var$sourceShape(schema)));
    $17ea3f861a2ff584$var$mirrorProps(newShape, shape);
    return newShape;
}
function $17ea3f861a2ff584$export$40c90eb222f50efb(schema, shape) {
    if (!$17ea3f861a2ff584$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to safeExtend: expected a plain object");
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def, {
        shape: $17ea3f861a2ff584$var$extended(schema, shape)
    }));
}
function $17ea3f861a2ff584$export$4950aa0f605343fb(a, b) {
    if (!b?._zod?.def) throw new Error("Invalid input to merge: expected an object schema. To merge a plain shape, use `.extend()`.");
    if (a._zod.def.checks?.length) throw new Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
    const newShape = {};
    $17ea3f861a2ff584$var$mirrorShape(newShape, a, Reflect.ownKeys($17ea3f861a2ff584$var$sourceShape(a)));
    $17ea3f861a2ff584$var$mirrorShape(newShape, b, Reflect.ownKeys($17ea3f861a2ff584$var$sourceShape(b)));
    const def = $17ea3f861a2ff584$export$8969f8c824382d73(a._zod.def, {
        shape: newShape,
        get catchall () {
            return b._zod.def.catchall;
        },
        checks: b._zod.def.checks ?? []
    });
    return $17ea3f861a2ff584$export$9cd59f9826255e47(a, def);
}
function $17ea3f861a2ff584$export$e45945969df8035a(Class, schema, mask, name = "partial") {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(`.${name}() cannot be used on object schemas containing refinements`);
    const selected = mask ? new Set($17ea3f861a2ff584$var$maskedKeys(schema, mask)) : undefined;
    const newShape = {};
    $17ea3f861a2ff584$var$mirrorShape(newShape, schema, Reflect.ownKeys($17ea3f861a2ff584$var$sourceShape(schema)), Class && ((value, key)=>selected && !selected.has(key) ? value : new Class({
            type: "optional",
            innerType: value
        })));
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def, {
        shape: newShape,
        checks: []
    }));
}
function $17ea3f861a2ff584$export$a7a0278c004aac3f(Class, schema, mask) {
    const selected = mask ? new Set($17ea3f861a2ff584$var$maskedKeys(schema, mask)) : undefined;
    const newShape = {};
    $17ea3f861a2ff584$var$mirrorShape(newShape, schema, Reflect.ownKeys($17ea3f861a2ff584$var$sourceShape(schema)), (value, key)=>// overwrite with non-optional
        selected && !selected.has(key) ? value : new Class({
            type: "nonoptional",
            innerType: value
        }));
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def, {
        shape: newShape
    }));
}
function $17ea3f861a2ff584$export$bd75b6d981b9c7f2(x, startIndex = 0) {
    if (x.aborted === true) return true;
    for(let i = startIndex; i < x.issues.length; i++){
        if (x.issues[i]?.continue !== true) return true;
    }
    return false;
}
function $17ea3f861a2ff584$export$a5fe2d8610d815ec(x, startIndex = 0) {
    if (x.aborted === true) return true;
    for(let i = startIndex; i < x.issues.length; i++){
        if (x.issues[i]?.continue === false) return true;
    }
    return false;
}
function $17ea3f861a2ff584$export$7f35a4c434118b9e(path, issues) {
    return issues.map((iss)=>{
        var _a;
        (_a = iss).path ?? (_a.path = []);
        iss.path.unshift(path);
        return iss;
    });
}
function $17ea3f861a2ff584$export$56590e5a47837d61(message) {
    return typeof message === "string" ? message : message?.message;
}
function $17ea3f861a2ff584$export$5f3bf32142eef856(issues, start, inst) {
    var _a;
    for(let i = start; i < issues.length; i++)(_a = issues[i]).schema ?? (_a.schema = inst);
}
function $17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, config) {
    var _a;
    // A schema that raised an issue itself owns it outright, and outranks any stamp an enclosing check left in `attachSchema`. String formats and z.custom() are schema and check at once, so when they act as a check they defer to that stamp instead.
    const traits = iss.inst?._zod?.traits;
    if (traits?.has("$ZodType")) {
        if (traits.has("$ZodCheck")) (_a = iss).schema ?? (_a.schema = iss.inst);
        else iss.schema = iss.inst;
    }
    // Decreasing specificity, first map to return a message wins. `inst` is whatever raised the issue, so a check's own map outranks the owning schema's.
    const schemaError = iss.schema !== iss.inst ? iss.schema?._zod.def?.error : undefined;
    const message = iss.message ? iss.message : $17ea3f861a2ff584$export$56590e5a47837d61(iss.inst?._zod.def?.error?.(iss)) ?? $17ea3f861a2ff584$export$56590e5a47837d61(schemaError?.(iss)) ?? $17ea3f861a2ff584$export$56590e5a47837d61(ctx?.error?.(iss)) ?? $17ea3f861a2ff584$export$56590e5a47837d61(config.customError?.(iss)) ?? $17ea3f861a2ff584$export$56590e5a47837d61(config.localeError?.(iss)) ?? "Invalid input";
    // an explicit own-key copy beats object rest with excluded keys, which v8 routes through a generic runtime call; Object.keys rather than for-in so an issue pushed with a prototype does not leak inherited keys, and an own __proto__ key is dropped rather than assigned through the setter
    const full = {};
    for (const k of Object.keys(iss)){
        if (k === "inst" || k === "schema" || k === "continue" || k === "input" || k === "__proto__") continue;
        full[k] = iss[k];
    }
    full.path ?? (full.path = []);
    full.message = message;
    if (ctx?.reportInput) full.input = iss.input;
    return full;
}
function $17ea3f861a2ff584$export$67a7c9c676c45d2b(input) {
    if (input instanceof Set) return "set";
    if (input instanceof Map) return "map";
    // @ts-ignore
    if (input instanceof File) return "file";
    return "unknown";
}
const $17ea3f861a2ff584$var$highSurrogate = /[\uD800-\uDBFF]/;
function $17ea3f861a2ff584$export$89f26bd0a2764944(str) {
    const units = str.length;
    if (!$17ea3f861a2ff584$var$highSurrogate.test(str)) return units;
    let count = units;
    for(let i = 0; i < units - 1; i++)if ((str.charCodeAt(i) & 0xfc00) === 0xd800 && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
        count--;
        i++;
    }
    return count;
}
function $17ea3f861a2ff584$export$479f5a070abeb487(input) {
    if (Array.isArray(input)) return "array";
    if (typeof input === "string") return "string";
    return "unknown";
}
function $17ea3f861a2ff584$export$858d360cf6da2b65(data) {
    const t = typeof data;
    switch(t){
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "object":
            {
                if (data === null) return "null";
                if (Array.isArray(data)) return "array";
                const obj = data;
                if (obj && Object.getPrototypeOf(obj) !== Object.prototype && "constructor" in obj && obj.constructor) return obj.constructor.name;
            }
    }
    return t;
}
function $17ea3f861a2ff584$export$69ad3503f98be476(...args) {
    const [iss, input, inst] = args;
    if (typeof iss === "string") return {
        message: iss,
        code: "custom",
        input: input,
        inst: inst
    };
    return {
        ...iss
    };
}
function $17ea3f861a2ff584$export$9b57aa937148f32(obj) {
    return Object.entries(obj).filter(([k, _])=>{
        // return true if NaN, meaning it's not a number, thus a string key
        return Number.isNaN(Number.parseInt(k, 10));
    }).map((el)=>el[1]);
}
function $17ea3f861a2ff584$export$f01069a3c307e50e(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes;
}
function $17ea3f861a2ff584$export$36bac84b1c2da9c7(bytes) {
    let binaryString = "";
    for(let i = 0; i < bytes.length; i++)binaryString += String.fromCharCode(bytes[i]);
    return btoa(binaryString);
}
function $17ea3f861a2ff584$export$b9fa2551f2db41e1(base64url) {
    const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
    const padding = "=".repeat((4 - base64.length % 4) % 4);
    return $17ea3f861a2ff584$export$f01069a3c307e50e(base64 + padding);
}
function $17ea3f861a2ff584$export$975f78e50159df6f(bytes) {
    return $17ea3f861a2ff584$export$36bac84b1c2da9c7(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $17ea3f861a2ff584$export$6c74ef56152ffb8d(hex) {
    const cleanHex = hex.replace(/^0x/, "");
    if (cleanHex.length % 2 !== 0) throw new Error("Invalid hex string length");
    const bytes = new Uint8Array(cleanHex.length / 2);
    for(let i = 0; i < cleanHex.length; i += 2)bytes[i / 2] = Number.parseInt(cleanHex.slice(i, i + 2), 16);
    return bytes;
}
function $17ea3f861a2ff584$export$c44b02fb03dbac82(bytes) {
    return Array.from(bytes).map((b)=>b.toString(16).padStart(2, "0")).join("");
}
class $17ea3f861a2ff584$export$4c85e640eb41c31b {
    constructor(..._args){}
}
function $17ea3f861a2ff584$export$100ad4af8c8d544f(proto, table) {
    for(const key in table){
        const desc = Object.getOwnPropertyDescriptor(table, key);
        // a getter installs as written, so it stays live: `description` reads through to the registry on every access. not enumerable: an object literal's is, and a prototype member never was
        if (desc.get) Object.defineProperty(proto, key, {
            ...desc,
            enumerable: false
        });
        else $17ea3f861a2ff584$var$defineBound(proto, key, desc.value);
    }
    // for..in sees no symbol keys, so well-known members like Symbol.iterator install here
    for (const sym of Object.getOwnPropertySymbols(table))$17ea3f861a2ff584$var$defineBound(proto, sym, table[sym]);
}
function $17ea3f861a2ff584$export$a97a0f27b0201230(inst, key, value, enumerable = true) {
    Object.defineProperty(inst, key, {
        configurable: true,
        writable: true,
        enumerable: enumerable,
        value: value
    });
    return value;
}
function $17ea3f861a2ff584$export$fe8985bb6374093c(inst, key, value) {
    return $17ea3f861a2ff584$export$a97a0f27b0201230(inst, key, value, false);
}
/*@__NO_SIDE_EFFECTS__*/ function $17ea3f861a2ff584$export$90b0b54dab0a340a(computes, table) {
    for(const key in computes){
        const compute = computes[key];
        // an object literal's accessor is configurable and enumerable, and `members` copies the descriptor as written
        Object.defineProperty(table, key, {
            configurable: true,
            enumerable: true,
            get () {
                return $17ea3f861a2ff584$export$a97a0f27b0201230(this, key, compute(this));
            },
            set (value) {
                $17ea3f861a2ff584$export$a97a0f27b0201230(this, key, value);
            }
        });
    }
    return table;
}
function $17ea3f861a2ff584$var$defineBound(proto, key, fn) {
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            // vitest's spyOn calls a prototype getter bare to find the function it wraps, so a nullish receiver answers the raw method
            return this == null ? fn : $17ea3f861a2ff584$export$a97a0f27b0201230(this, key, fn.bind(this));
        },
        set (value) {
            $17ea3f861a2ff584$export$a97a0f27b0201230(this, key, value);
        }
    });
}
/** Returns the prototype to install on, or `undefined` if this group is already installed on it. */ function $17ea3f861a2ff584$var$claim(inst, sentinel) {
    const proto = Object.getPrototypeOf(inst);
    // Runs on every construction, so `in` rather than the costlier `hasOwnProperty.call`. Sentinels are keys the group itself defines.
    return sentinel in proto ? undefined : proto;
}
// The internals whose init chain is installing. A second call for the same one is a derived constructor overriding its base, so it must not construct another schema in between or the override is dropped.
let $17ea3f861a2ff584$var$installing;
// Set while a getter is running, so a value that resolved through a recursion break is not memoized. One shared descriptor shadows the key for the duration, which costs no per-key allocation.
let $17ea3f861a2ff584$var$broke = false;
const $17ea3f861a2ff584$var$breaker = {
    configurable: true,
    get () {
        $17ea3f861a2ff584$var$broke = true;
        return undefined;
    }
};
function $17ea3f861a2ff584$export$ab4d63bd6339ba82(inst, key, compute) {
    const proto = Object.getPrototypeOf(inst._zod);
    if (key in proto && $17ea3f861a2ff584$var$installing !== inst._zod) {
        // A repeat construction: everything is installed already. Cleared here so the reference is not held past the first construction of every type.
        $17ea3f861a2ff584$var$installing = undefined;
        return;
    }
    $17ea3f861a2ff584$var$installing = inst._zod;
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            // Shadowed before computing so a re-entrant read from a recursive schema resolves to undefined instead of running the getter again.
            Object.defineProperty(this, key, $17ea3f861a2ff584$var$breaker);
            const outer = $17ea3f861a2ff584$var$broke;
            $17ea3f861a2ff584$var$broke = false;
            try {
                const value = compute(this);
                // A result that resolved through a recursion break is recomputed once the graph is complete; everything else memoizes, undefined included.
                if ($17ea3f861a2ff584$var$broke) delete this[key];
                else Object.defineProperty(this, key, {
                    configurable: true,
                    writable: true,
                    value: value
                });
                $17ea3f861a2ff584$var$broke = $17ea3f861a2ff584$var$broke || outer;
                return value;
            } catch (err) {
                // A compute that threw memoizes nothing, so a later read runs it again and fails the same way. The shadow goes with it, since leaving it installed would answer undefined for every later read.
                delete this[key];
                $17ea3f861a2ff584$var$broke = $17ea3f861a2ff584$var$broke || outer;
                throw err;
            }
        },
        set (value) {
            Object.defineProperty(this, key, {
                configurable: true,
                writable: true,
                value: value
            });
        }
    });
}
function $17ea3f861a2ff584$export$fd3ec217a5ca1bc7(inst, key, make, enumerable) {
    const proto = $17ea3f861a2ff584$var$claim(inst, key);
    if (!proto) return;
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            // Shadowed before computing, so a re-entrant read from a self-referential shape resolves to undefined instead of running the getter again. A data property rather than an accessor: an own accessor is the dictionary-mode transition this exists to avoid.
            const desc = {
                configurable: true,
                writable: true,
                enumerable: enumerable,
                value: undefined
            };
            Object.defineProperty(this, key, desc);
            // a compute that throws leaves the shadow behind, so later reads answer undefined instead of re-throwing; `defineLazy` did the same, and `defineLazyInternal`'s delete-on-catch would cost bytes in every bundle for a case only a throwing user getter reaches
            desc.value = make(this);
            Object.defineProperty(this, key, desc);
            return desc.value;
        },
        set (value) {
            Object.defineProperty(this, key, {
                configurable: true,
                writable: true,
                enumerable: enumerable,
                value: value
            });
        }
    });
}
const $17ea3f861a2ff584$export$2644f2739b5380cd = "~constantCatch";
function $17ea3f861a2ff584$export$79bf7eed34458669(value) {
    const fn = ()=>value;
    fn[$17ea3f861a2ff584$export$2644f2739b5380cd] = true;
    return fn;
}

});


parcelRegister("dZBpt", function(module, exports) {

$parcel$export(module.exports, "cuid", () => $a2fdfdb502fc74b8$export$e057ec210c7d3443);
$parcel$export(module.exports, "cuid2", () => $a2fdfdb502fc74b8$export$af5866a6cccce9f0);
$parcel$export(module.exports, "ulid", () => $a2fdfdb502fc74b8$export$c34778236461ea95);
$parcel$export(module.exports, "xid", () => $a2fdfdb502fc74b8$export$5eecaf20006cb6cb);
$parcel$export(module.exports, "ksuid", () => $a2fdfdb502fc74b8$export$f49b11deeb9beb0f);
$parcel$export(module.exports, "nanoid", () => $a2fdfdb502fc74b8$export$ac4959f4f1338dfc);
$parcel$export(module.exports, "nanoidOfLength", () => $a2fdfdb502fc74b8$export$5e38a73263010503);
$parcel$export(module.exports, "duration", () => $a2fdfdb502fc74b8$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "extendedDuration", () => $a2fdfdb502fc74b8$export$e30244ba59a8cd84);
$parcel$export(module.exports, "guid", () => $a2fdfdb502fc74b8$export$46e8f25c7328f77e);
$parcel$export(module.exports, "uuid", () => $a2fdfdb502fc74b8$export$31b40729666a4ae0);
$parcel$export(module.exports, "uuid4", () => $a2fdfdb502fc74b8$export$19f53698e68b2496);
$parcel$export(module.exports, "uuid6", () => $a2fdfdb502fc74b8$export$1d78c41b29712c01);
$parcel$export(module.exports, "uuid7", () => $a2fdfdb502fc74b8$export$b3092b3ac1fa0ace);
$parcel$export(module.exports, "email", () => $a2fdfdb502fc74b8$export$d290fa47940df19d);
$parcel$export(module.exports, "html5Email", () => $a2fdfdb502fc74b8$export$d2c782992f0a89ee);
$parcel$export(module.exports, "rfc5322Email", () => $a2fdfdb502fc74b8$export$54f6bc2d4fd0bb08);
$parcel$export(module.exports, "unicodeEmail", () => $a2fdfdb502fc74b8$export$f8855510ae7521df);
$parcel$export(module.exports, "idnEmail", () => $a2fdfdb502fc74b8$export$d402ea1c27a77371);
$parcel$export(module.exports, "browserEmail", () => $a2fdfdb502fc74b8$export$9d1ec0311c8ce72e);
$parcel$export(module.exports, "emoji", () => $a2fdfdb502fc74b8$export$a19185d1233fc4b2);
$parcel$export(module.exports, "ipv4", () => $a2fdfdb502fc74b8$export$291a17a16047f284);
$parcel$export(module.exports, "ipv6", () => $a2fdfdb502fc74b8$export$4e0c86a59c658526);
$parcel$export(module.exports, "mac", () => $a2fdfdb502fc74b8$export$f8d11e097856efcf);
$parcel$export(module.exports, "cidrv4", () => $a2fdfdb502fc74b8$export$fc96793d9715e5a1);
$parcel$export(module.exports, "cidrv6", () => $a2fdfdb502fc74b8$export$b6e650831cac87fb);
$parcel$export(module.exports, "base64", () => $a2fdfdb502fc74b8$export$b3b2de96497acc47);
$parcel$export(module.exports, "base64url", () => $a2fdfdb502fc74b8$export$7d21597c7bc64465);
$parcel$export(module.exports, "hostname", () => $a2fdfdb502fc74b8$export$640106f6dc7d2706);
$parcel$export(module.exports, "domain", () => $a2fdfdb502fc74b8$export$21779e503be4cd98);
$parcel$export(module.exports, "httpProtocol", () => $a2fdfdb502fc74b8$export$b23749f357fbda41);
$parcel$export(module.exports, "e164", () => $a2fdfdb502fc74b8$export$2fa5ed24c9ef198e);
$parcel$export(module.exports, "creditCard", () => $a2fdfdb502fc74b8$export$34823d8b18327f02);
$parcel$export(module.exports, "iban", () => $a2fdfdb502fc74b8$export$a829806fb5977d78);
$parcel$export(module.exports, "date", () => $a2fdfdb502fc74b8$export$324d90190a8b822a);
$parcel$export(module.exports, "time", () => $a2fdfdb502fc74b8$export$2da9be4cfdb689b1);
$parcel$export(module.exports, "datetime", () => $a2fdfdb502fc74b8$export$7ba4466dbd0f07e1);
$parcel$export(module.exports, "anyString", () => $a2fdfdb502fc74b8$export$24da0a402b44e53a);
$parcel$export(module.exports, "string", () => $a2fdfdb502fc74b8$export$22b082955e083ec3);
$parcel$export(module.exports, "bigint", () => $a2fdfdb502fc74b8$export$a0f65b52274bcc00);
$parcel$export(module.exports, "integer", () => $a2fdfdb502fc74b8$export$32744b5b3bba4764);
$parcel$export(module.exports, "number", () => $a2fdfdb502fc74b8$export$98e628dec113755e);
$parcel$export(module.exports, "boolean", () => $a2fdfdb502fc74b8$export$4a21f16c33752377);
$parcel$export(module.exports, "null", () => $a2fdfdb502fc74b8$export$7b1b591b262c240);
$parcel$export(module.exports, "undefined", () => $a2fdfdb502fc74b8$export$1db45310990710a5);
$parcel$export(module.exports, "lowercase", () => $a2fdfdb502fc74b8$export$5b1f80f3c282648c);
$parcel$export(module.exports, "uppercase", () => $a2fdfdb502fc74b8$export$6cfe151e6b925e83);
$parcel$export(module.exports, "hex", () => $a2fdfdb502fc74b8$export$834dfc94dde4b3d8);
$parcel$export(module.exports, "md5_hex", () => $a2fdfdb502fc74b8$export$7d7ef811f6d53a1);
$parcel$export(module.exports, "md5_base64", () => $a2fdfdb502fc74b8$export$85425f7cda9f4890);
$parcel$export(module.exports, "md5_base64url", () => $a2fdfdb502fc74b8$export$e54699b04083758c);
$parcel$export(module.exports, "sha1_hex", () => $a2fdfdb502fc74b8$export$2f163473ef893e12);
$parcel$export(module.exports, "sha1_base64", () => $a2fdfdb502fc74b8$export$fc9670fedfd2524a);
$parcel$export(module.exports, "sha1_base64url", () => $a2fdfdb502fc74b8$export$5b6729b977839ffd);
$parcel$export(module.exports, "sha256_hex", () => $a2fdfdb502fc74b8$export$a923016129fea5fb);
$parcel$export(module.exports, "sha256_base64", () => $a2fdfdb502fc74b8$export$ebc25582a9e85396);
$parcel$export(module.exports, "sha256_base64url", () => $a2fdfdb502fc74b8$export$9b7979bfebd9716e);
$parcel$export(module.exports, "sha384_hex", () => $a2fdfdb502fc74b8$export$61d1fe464d10a5d1);
$parcel$export(module.exports, "sha384_base64", () => $a2fdfdb502fc74b8$export$103403cb96133ac3);
$parcel$export(module.exports, "sha384_base64url", () => $a2fdfdb502fc74b8$export$eeafcb7aab6a9870);
$parcel$export(module.exports, "sha512_hex", () => $a2fdfdb502fc74b8$export$e246a4310a1ad74d);
$parcel$export(module.exports, "sha512_base64", () => $a2fdfdb502fc74b8$export$f698997e063dbdae);
$parcel$export(module.exports, "sha512_base64url", () => $a2fdfdb502fc74b8$export$a63330069e1b81f6);

var $23ixW = parcelRequire("23ixW");
const $a2fdfdb502fc74b8$export$e057ec210c7d3443 = /^[cC][0-9a-z]{6,}$/;
const $a2fdfdb502fc74b8$export$af5866a6cccce9f0 = /^[0-9a-z]+$/;
const $a2fdfdb502fc74b8$export$c34778236461ea95 = /^[0-7][0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{25}$/;
const $a2fdfdb502fc74b8$export$5eecaf20006cb6cb = /^[0-9a-vA-V]{20}$/;
const $a2fdfdb502fc74b8$export$f49b11deeb9beb0f = /^[A-Za-z0-9]{27}$/;
const $a2fdfdb502fc74b8$export$ac4959f4f1338dfc = /^[a-zA-Z0-9_-]{21}$/;
function $a2fdfdb502fc74b8$export$5e38a73263010503(length) {
    return new RegExp(`^[a-zA-Z0-9_-]{${length}}$`);
}
const $a2fdfdb502fc74b8$export$1f34108aa9eb96ab = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/;
const $a2fdfdb502fc74b8$export$e30244ba59a8cd84 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
const $a2fdfdb502fc74b8$export$46e8f25c7328f77e = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
const $a2fdfdb502fc74b8$export$31b40729666a4ae0 = (version)=>{
    if (!version) return /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
    return new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${version}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`);
};
const $a2fdfdb502fc74b8$export$19f53698e68b2496 = /*@__PURE__*/ $a2fdfdb502fc74b8$export$31b40729666a4ae0(4);
const $a2fdfdb502fc74b8$export$1d78c41b29712c01 = /*@__PURE__*/ $a2fdfdb502fc74b8$export$31b40729666a4ae0(6);
const $a2fdfdb502fc74b8$export$b3092b3ac1fa0ace = /*@__PURE__*/ $a2fdfdb502fc74b8$export$31b40729666a4ae0(7);
const $a2fdfdb502fc74b8$export$d290fa47940df19d = /^(?:[A-Za-z0-9_'+\-]+\.)*[A-Za-z0-9_'+\-]*[A-Za-z0-9_+-]@(?:[A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
const $a2fdfdb502fc74b8$export$d2c782992f0a89ee = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const $a2fdfdb502fc74b8$export$54f6bc2d4fd0bb08 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const $a2fdfdb502fc74b8$export$f8855510ae7521df = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
const $a2fdfdb502fc74b8$export$d402ea1c27a77371 = $a2fdfdb502fc74b8$export$f8855510ae7521df;
const $a2fdfdb502fc74b8$export$9d1ec0311c8ce72e = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
// Single character class, not an alternation: the two properties overlap (U+1F9B0-U+1F9B3), so `(A|B)+` backtracks exponentially on a failed match. The leading lookahead then demands one anchor — a pictograph, a regional indicator, or the enclosing keycap — because `\p{Emoji_Component}` on its own covers ASCII digits, `#`, `*`, ZWJ, variation selectors and skin tone modifiers, none of which is an emoji without a base.
const $a2fdfdb502fc74b8$var$_emoji = `^(?=[\\s\\S]*[\\p{Extended_Pictographic}\\p{Regional_Indicator}\\u20E3])[\\p{Extended_Pictographic}\\p{Emoji_Component}]+$`;
function $a2fdfdb502fc74b8$export$a19185d1233fc4b2() {
    return new RegExp($a2fdfdb502fc74b8$var$_emoji, "u");
}
const $a2fdfdb502fc74b8$export$291a17a16047f284 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $a2fdfdb502fc74b8$export$4e0c86a59c658526 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
const $a2fdfdb502fc74b8$export$f8d11e097856efcf = (delimiter)=>{
    const escapedDelim = $23ixW.escapeRegex(delimiter ?? ":");
    return new RegExp(`^(?:[0-9A-F]{2}${escapedDelim}){5}[0-9A-F]{2}$|^(?:[0-9a-f]{2}${escapedDelim}){5}[0-9a-f]{2}$`);
};
const $a2fdfdb502fc74b8$export$fc96793d9715e5a1 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/;
const $a2fdfdb502fc74b8$export$b6e650831cac87fb = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
const $a2fdfdb502fc74b8$export$b3b2de96497acc47 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/;
const $a2fdfdb502fc74b8$export$7d21597c7bc64465 = /^(?:[A-Za-z0-9_-]{4})*(?:[A-Za-z0-9_-]{2,3})?$/;
const $a2fdfdb502fc74b8$export$640106f6dc7d2706 = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/;
const $a2fdfdb502fc74b8$export$21779e503be4cd98 = /^(?=.{1,253}$)([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;
const $a2fdfdb502fc74b8$export$b23749f357fbda41 = /^https?$/;
const $a2fdfdb502fc74b8$export$2fa5ed24c9ef198e = /^\+[1-9]\d{6,14}$/;
const $a2fdfdb502fc74b8$export$34823d8b18327f02 = /^\d(?:[ -]?\d){11,18}$/;
const $a2fdfdb502fc74b8$export$a829806fb5977d78 = /^[A-Z]{2}(?!00|01|99)\d{2}[A-Z0-9]{11,30}$/;
const $a2fdfdb502fc74b8$var$dateSource = `(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))`;
/** Anchors a pattern source. The interpolation lives here rather than at the call site because
 * esbuild will not drop a `@__PURE__` call whose own argument interpolates a variable, but it
 * will drop `anchor(dateSource)`. Keeping it inline pinned `date` into every bundle. */ function $a2fdfdb502fc74b8$var$anchor(source) {
    return new RegExp(`^${source}$`);
}
const $a2fdfdb502fc74b8$export$324d90190a8b822a = /*@__PURE__*/ $a2fdfdb502fc74b8$var$anchor($a2fdfdb502fc74b8$var$dateSource);
function $a2fdfdb502fc74b8$var$timeSource(args) {
    const hhmm = `(?:[01]\\d|2[0-3]):[0-5]\\d`;
    const regex = typeof args.precision === "number" ? args.precision === -1 ? `${hhmm}` : args.precision === 0 ? `${hhmm}:[0-5]\\d` : `${hhmm}:[0-5]\\d\\.\\d{${args.precision}}` : args.seconds ? `${hhmm}:[0-5]\\d(?:\\.\\d+)?` : `${hhmm}(?::[0-5]\\d(?:\\.\\d+)?)?`;
    return regex;
}
function $a2fdfdb502fc74b8$export$2da9be4cfdb689b1(args) {
    return new RegExp(`^${$a2fdfdb502fc74b8$var$timeSource(args)}$`);
}
function $a2fdfdb502fc74b8$export$7ba4466dbd0f07e1(args) {
    const opts = [
        "Z"
    ];
    // if (args.offset) opts.push(`([+-]\\d{2}:\\d{2})`);
    if (args.offset) opts.push(`([+-](?:[01]\\d|2[0-3]):[0-5]\\d)`);
    // RFC 3339 mandates seconds wherever the time carries a `Z` or an offset, so only the unqualified form `local` adds may omit them
    const qualified = `${$a2fdfdb502fc74b8$var$timeSource({
        precision: args.precision,
        seconds: true
    })}(?:${opts.join("|")})`;
    const timeRegex = args.local ? `${qualified}|${$a2fdfdb502fc74b8$var$timeSource({
        precision: args.precision
    })}` : qualified;
    return new RegExp(`^${$a2fdfdb502fc74b8$var$dateSource}T(?:${timeRegex})$`);
}
const $a2fdfdb502fc74b8$export$24da0a402b44e53a = /^[\s\S]{0,}$/;
const $a2fdfdb502fc74b8$export$22b082955e083ec3 = (params)=>{
    const regex = params ? `[\\s\\S]{${params?.minimum ?? 0},${params?.maximum ?? ""}}` : `[\\s\\S]*`;
    return new RegExp(`^${regex}$`);
};
const $a2fdfdb502fc74b8$export$a0f65b52274bcc00 = /^-?\d+n?$/;
const $a2fdfdb502fc74b8$export$32744b5b3bba4764 = /^-?\d+$/;
const $a2fdfdb502fc74b8$export$98e628dec113755e = /^-?\d+(?:\.\d+)?$/;
const $a2fdfdb502fc74b8$export$4a21f16c33752377 = /^(?:true|false)$/i;
const $a2fdfdb502fc74b8$export$7b1b591b262c240 = /^null$/i;
const $a2fdfdb502fc74b8$export$1db45310990710a5 = /^undefined$/i;
const $a2fdfdb502fc74b8$export$5b1f80f3c282648c = /^[^A-Z]*$/;
const $a2fdfdb502fc74b8$export$6cfe151e6b925e83 = /^[^a-z]*$/;
const $a2fdfdb502fc74b8$export$834dfc94dde4b3d8 = /^[0-9a-fA-F]*$/;
// Hash regexes for different algorithms and encodings
// Helper function to create base64 regex with exact length and padding
function $a2fdfdb502fc74b8$var$fixedBase64(bodyLength, padding) {
    return new RegExp(`^[A-Za-z0-9+/]{${bodyLength}}${padding}$`);
}
// Helper function to create base64url regex with exact length (no padding)
function $a2fdfdb502fc74b8$var$fixedBase64url(length) {
    return new RegExp(`^[A-Za-z0-9_-]{${length}}$`);
}
const $a2fdfdb502fc74b8$export$7d7ef811f6d53a1 = /^[0-9a-fA-F]{32}$/;
const $a2fdfdb502fc74b8$export$85425f7cda9f4890 = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64(22, "==");
const $a2fdfdb502fc74b8$export$e54699b04083758c = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64url(22);
const $a2fdfdb502fc74b8$export$2f163473ef893e12 = /^[0-9a-fA-F]{40}$/;
const $a2fdfdb502fc74b8$export$fc9670fedfd2524a = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64(27, "=");
const $a2fdfdb502fc74b8$export$5b6729b977839ffd = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64url(27);
const $a2fdfdb502fc74b8$export$a923016129fea5fb = /^[0-9a-fA-F]{64}$/;
const $a2fdfdb502fc74b8$export$ebc25582a9e85396 = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64(43, "=");
const $a2fdfdb502fc74b8$export$9b7979bfebd9716e = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64url(43);
const $a2fdfdb502fc74b8$export$61d1fe464d10a5d1 = /^[0-9a-fA-F]{96}$/;
const $a2fdfdb502fc74b8$export$103403cb96133ac3 = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64(64, "");
const $a2fdfdb502fc74b8$export$eeafcb7aab6a9870 = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64url(64);
const $a2fdfdb502fc74b8$export$e246a4310a1ad74d = /^[0-9a-fA-F]{128}$/;
const $a2fdfdb502fc74b8$export$f698997e063dbdae = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64(86, "==");
const $a2fdfdb502fc74b8$export$a63330069e1b81f6 = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64url(86);

});


parcelRegister("5VtTM", function(module, exports) {

$parcel$export(module.exports, "globalRegistry", () => $450977dbcfd5dec3$export$bc58ce2776ecdb6f);
var $450977dbcfd5dec3$var$_a;
const $450977dbcfd5dec3$export$26c272954616d4a2 = /*@__PURE__*/ Symbol("ZodOutput");
const $450977dbcfd5dec3$export$4159eb10f43487af = /*@__PURE__*/ Symbol("ZodInput");
class $450977dbcfd5dec3$export$dc03955eec152cc5 {
    constructor(){
        this._map = new WeakMap();
        this._idmap = new Map();
    }
    add(schema, ..._meta) {
        const meta = _meta[0];
        this._map.set(schema, meta);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.set(meta.id, schema);
        return this;
    }
    clear() {
        this._map = new WeakMap();
        this._idmap = new Map();
        return this;
    }
    remove(schema) {
        const meta = this._map.get(schema);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.delete(meta.id);
        this._map.delete(schema);
        return this;
    }
    get(schema) {
        // return this._map.get(schema) as any;
        // inherit metadata
        const p = schema._zod.parent;
        if (p) {
            const pm = {
                ...this.get(p) ?? {}
            };
            delete pm.id; // do not inherit id
            const f = {
                ...pm,
                ...this._map.get(schema)
            };
            return Object.keys(f).length ? f : undefined;
        }
        return this._map.get(schema);
    }
    has(schema) {
        return this._map.has(schema);
    }
}
function $450977dbcfd5dec3$export$4bb7493d241fd8a5() {
    return new $450977dbcfd5dec3$export$dc03955eec152cc5();
}
($450977dbcfd5dec3$var$_a = globalThis).__zod_globalRegistry ?? ($450977dbcfd5dec3$var$_a.__zod_globalRegistry = $450977dbcfd5dec3$export$4bb7493d241fd8a5());
const $450977dbcfd5dec3$export$bc58ce2776ecdb6f = globalThis.__zod_globalRegistry;

});

parcelRegister("jvcvr", function(module, exports) {

$parcel$export(module.exports, "$ZodType", () => $e32a9d04eaeb9d0c$export$f43a5c3966de8238);
$parcel$export(module.exports, "standardProps", () => $e32a9d04eaeb9d0c$export$bcaeb817fdf064d3);
$parcel$export(module.exports, "$ZodString", () => $e32a9d04eaeb9d0c$export$4342b4432d7b1471);
$parcel$export(module.exports, "$ZodStringFormat", () => $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d);
$parcel$export(module.exports, "$ZodGUID", () => $e32a9d04eaeb9d0c$export$4ca4397e3147da59);
$parcel$export(module.exports, "$ZodUUID", () => $e32a9d04eaeb9d0c$export$8794aae384e3c177);
$parcel$export(module.exports, "$ZodEmail", () => $e32a9d04eaeb9d0c$export$a3726aadb6108cdc);
$parcel$export(module.exports, "$ZodURL", () => $e32a9d04eaeb9d0c$export$7e12af57cac08b7a);
$parcel$export(module.exports, "$ZodEmoji", () => $e32a9d04eaeb9d0c$export$154cd448b85bb5a3);
$parcel$export(module.exports, "$ZodNanoID", () => $e32a9d04eaeb9d0c$export$5a160d28c6d62c88);
$parcel$export(module.exports, "$ZodCUID", () => $e32a9d04eaeb9d0c$export$f4f84bd3c6706e60);
$parcel$export(module.exports, "$ZodCUID2", () => $e32a9d04eaeb9d0c$export$faf1483c11362df6);
$parcel$export(module.exports, "$ZodULID", () => $e32a9d04eaeb9d0c$export$c5788701f4f55294);
$parcel$export(module.exports, "$ZodXID", () => $e32a9d04eaeb9d0c$export$e721fd3317199b85);
$parcel$export(module.exports, "$ZodKSUID", () => $e32a9d04eaeb9d0c$export$baa9849ea82bee6e);
$parcel$export(module.exports, "$ZodISODateTime", () => $e32a9d04eaeb9d0c$export$3273e4d2df37774b);
$parcel$export(module.exports, "$ZodISODate", () => $e32a9d04eaeb9d0c$export$75b9bf98f4d806dc);
$parcel$export(module.exports, "$ZodISOTime", () => $e32a9d04eaeb9d0c$export$e9b9c3c2359a3ebc);
$parcel$export(module.exports, "$ZodISODuration", () => $e32a9d04eaeb9d0c$export$d9e850ab18e4b22e);
$parcel$export(module.exports, "$ZodIPv4", () => $e32a9d04eaeb9d0c$export$93fc833bbf7ceb99);
$parcel$export(module.exports, "$ZodIPv6", () => $e32a9d04eaeb9d0c$export$8c939a460418a1bf);
$parcel$export(module.exports, "$ZodMAC", () => $e32a9d04eaeb9d0c$export$747370108f97e6ea);
$parcel$export(module.exports, "$ZodCIDRv4", () => $e32a9d04eaeb9d0c$export$e164feaf5ae5296b);
$parcel$export(module.exports, "$ZodCIDRv6", () => $e32a9d04eaeb9d0c$export$3c3aacb740759234);
$parcel$export(module.exports, "base64Charset", () => $e32a9d04eaeb9d0c$export$a9609837d77c7102);
$parcel$export(module.exports, "$ZodBase64", () => $e32a9d04eaeb9d0c$export$d7d4932079e2113d);
$parcel$export(module.exports, "base64urlCharset", () => $e32a9d04eaeb9d0c$export$be54091f6dba12e7);
$parcel$export(module.exports, "$ZodBase64URL", () => $e32a9d04eaeb9d0c$export$f5c3c3bbec012fa6);
$parcel$export(module.exports, "$ZodE164", () => $e32a9d04eaeb9d0c$export$46d3507e8483217);
$parcel$export(module.exports, "$ZodCreditCard", () => $e32a9d04eaeb9d0c$export$901cea49d453364b);
$parcel$export(module.exports, "$ZodIBAN", () => $e32a9d04eaeb9d0c$export$3742722adf5f31af);
$parcel$export(module.exports, "$ZodJWT", () => $e32a9d04eaeb9d0c$export$f515616cf0cda103);
$parcel$export(module.exports, "$ZodCustomStringFormat", () => $e32a9d04eaeb9d0c$export$9dde4397c7b8a192);
$parcel$export(module.exports, "$ZodNumber", () => $e32a9d04eaeb9d0c$export$b7292ed81eaafd49);
$parcel$export(module.exports, "$ZodNumberFormat", () => $e32a9d04eaeb9d0c$export$2cfebe79b769ec9);
$parcel$export(module.exports, "$ZodBoolean", () => $e32a9d04eaeb9d0c$export$828bf41e557d7dda);
$parcel$export(module.exports, "$ZodBigInt", () => $e32a9d04eaeb9d0c$export$7600843f2a3baa73);
$parcel$export(module.exports, "$ZodBigIntFormat", () => $e32a9d04eaeb9d0c$export$487194b75209a5dd);
$parcel$export(module.exports, "$ZodSymbol", () => $e32a9d04eaeb9d0c$export$c9e7e1831bb8dd12);
$parcel$export(module.exports, "$ZodUndefined", () => $e32a9d04eaeb9d0c$export$379ccf61f9830869);
$parcel$export(module.exports, "$ZodNull", () => $e32a9d04eaeb9d0c$export$d05db4d7bc9da27d);
$parcel$export(module.exports, "$ZodAny", () => $e32a9d04eaeb9d0c$export$de3a83ac65a18f35);
$parcel$export(module.exports, "$ZodUnknown", () => $e32a9d04eaeb9d0c$export$37ea092643879ea0);
$parcel$export(module.exports, "$ZodNever", () => $e32a9d04eaeb9d0c$export$4b2a18191b39c3b4);
$parcel$export(module.exports, "$ZodVoid", () => $e32a9d04eaeb9d0c$export$6fd82db70787afbb);
$parcel$export(module.exports, "$ZodDate", () => $e32a9d04eaeb9d0c$export$9a0ab9fbd61629f8);
$parcel$export(module.exports, "$ZodArray", () => $e32a9d04eaeb9d0c$export$fd77bdade7d2292b);
$parcel$export(module.exports, "$ZodObjectJIT", () => $e32a9d04eaeb9d0c$export$330feb3f8e03c085);
$parcel$export(module.exports, "$ZodUnion", () => $e32a9d04eaeb9d0c$export$37a2350ef0bd638c);
$parcel$export(module.exports, "$ZodXor", () => $e32a9d04eaeb9d0c$export$b04ced974a46c0b4);
$parcel$export(module.exports, "$ZodDiscriminatedUnion", () => $e32a9d04eaeb9d0c$export$aad4f17edfb83795);
$parcel$export(module.exports, "$ZodIntersection", () => $e32a9d04eaeb9d0c$export$2299250b426aba4b);
$parcel$export(module.exports, "$ZodTuple", () => $e32a9d04eaeb9d0c$export$bba1b90a721dbd94);
$parcel$export(module.exports, "$ZodRecord", () => $e32a9d04eaeb9d0c$export$cc20b90ec1a8c208);
$parcel$export(module.exports, "$ZodMap", () => $e32a9d04eaeb9d0c$export$5ccfd30a7e358409);
$parcel$export(module.exports, "$ZodSet", () => $e32a9d04eaeb9d0c$export$20cf27bc33a30268);
$parcel$export(module.exports, "$ZodEnum", () => $e32a9d04eaeb9d0c$export$31462b6e6c50b618);
$parcel$export(module.exports, "$ZodLiteral", () => $e32a9d04eaeb9d0c$export$86699355265fa258);
$parcel$export(module.exports, "$ZodFile", () => $e32a9d04eaeb9d0c$export$1997de0576a81377);
$parcel$export(module.exports, "$ZodTransform", () => $e32a9d04eaeb9d0c$export$14b591f873519189);
$parcel$export(module.exports, "$ZodOptional", () => $e32a9d04eaeb9d0c$export$980e9af565c4d7aa);
$parcel$export(module.exports, "$ZodExactOptional", () => $e32a9d04eaeb9d0c$export$384d083c2a6b693f);
$parcel$export(module.exports, "$ZodNullable", () => $e32a9d04eaeb9d0c$export$7994573b6604ec66);
$parcel$export(module.exports, "$ZodDefault", () => $e32a9d04eaeb9d0c$export$ae2d21004b7243f7);
$parcel$export(module.exports, "$ZodPrefault", () => $e32a9d04eaeb9d0c$export$29a8d757258be679);
$parcel$export(module.exports, "$ZodNonOptional", () => $e32a9d04eaeb9d0c$export$30ca726c4c50a6d7);
$parcel$export(module.exports, "$ZodSuccess", () => $e32a9d04eaeb9d0c$export$3cc4d03e729326ea);
$parcel$export(module.exports, "$ZodCatch", () => $e32a9d04eaeb9d0c$export$d6f8b228374f6d37);
$parcel$export(module.exports, "$ZodNaN", () => $e32a9d04eaeb9d0c$export$528f71701e6a7aee);
$parcel$export(module.exports, "$ZodPipe", () => $e32a9d04eaeb9d0c$export$4cb25cfde430326c);
$parcel$export(module.exports, "$ZodCodec", () => $e32a9d04eaeb9d0c$export$c622e07db8a40b53);
$parcel$export(module.exports, "$ZodPreprocess", () => $e32a9d04eaeb9d0c$export$200c161ed581d39b);
$parcel$export(module.exports, "$ZodReadonly", () => $e32a9d04eaeb9d0c$export$f9f268f3fbb1601b);
$parcel$export(module.exports, "$ZodTemplateLiteral", () => $e32a9d04eaeb9d0c$export$37ea86c57a77af54);
$parcel$export(module.exports, "$ZodFunction", () => $e32a9d04eaeb9d0c$export$877c6e9c05ede764);
$parcel$export(module.exports, "$ZodPromise", () => $e32a9d04eaeb9d0c$export$bdefabff0dd84ca4);
$parcel$export(module.exports, "$ZodLazy", () => $e32a9d04eaeb9d0c$export$662fecee2efa1a66);
$parcel$export(module.exports, "$ZodCustom", () => $e32a9d04eaeb9d0c$export$3a5d0e5e098b79ba);
$parcel$export(module.exports, "$ZodProperties", () => $e32a9d04eaeb9d0c$export$8fb7482084c5d413);

var $ggkLI = parcelRequire("ggkLI");

var $5SN0M = parcelRequire("5SN0M");

var $knYnh = parcelRequire("knYnh");

var $57W0y = parcelRequire("57W0y");

var $dZBpt = parcelRequire("dZBpt");

var $23ixW = parcelRequire("23ixW");

var $hqqad = parcelRequire("hqqad");
const $e32a9d04eaeb9d0c$export$f43a5c3966de8238 = /*@__PURE__*/ $5SN0M.$constructor("$ZodType", (inst, def)=>{
    var _a;
    inst ?? (inst = {});
    inst._zod.def = def; // set _def property
    inst._zod.bag = inst._zod.bag || {}; // initialize _bag object
    inst._zod.version = (0, $hqqad.version);
    const defChecks = inst._zod.def.checks;
    // if inst is itself a checks.$ZodCheck, run it as a check
    const checks = inst._zod.traits.has("$ZodCheck") ? [
        inst,
        ...defChecks ?? []
    ] : defChecks?.length ? [
        ...defChecks
    ] : [];
    for (const ch of checks)for (const fn of ch._zod.onattach)fn(inst);
    if (checks.length === 0) {
        // deferred initializer inst._zod.parse is not yet defined
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred?.push(()=>{
            inst._zod.run = inst._zod.parse;
        });
    } else {
        const runChecks = (payload, checks, ctx)=>{
            if (payload.memo) return payload;
            let isAborted = $23ixW.aborted(payload);
            let asyncResult;
            for (const ch of checks){
                if (ch._zod.def.when) {
                    if ($23ixW.explicitlyAborted(payload)) continue;
                    const shouldRun = ch._zod.def.when(payload);
                    if (!shouldRun) continue;
                } else if (isAborted) continue;
                const currLen = payload.issues.length;
                const _ = ch._zod.check(payload);
                if (_ instanceof Promise && ctx?.async === false) throw new $5SN0M.$ZodAsyncError();
                if (asyncResult || _ instanceof Promise) asyncResult = (asyncResult ?? Promise.resolve()).then(async ()=>{
                    await _;
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) return;
                    $23ixW.attachSchema(payload.issues, currLen, inst);
                    if (!isAborted) isAborted = $23ixW.aborted(payload, currLen);
                });
                else {
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) continue;
                    $23ixW.attachSchema(payload.issues, currLen, inst);
                    if (!isAborted) isAborted = $23ixW.aborted(payload, currLen);
                }
            }
            if (asyncResult) return asyncResult.then(()=>{
                return payload;
            });
            return payload;
        };
        const handleCanaryResult = (canary, payload, ctx)=>{
            // abort if the canary is aborted
            if ($23ixW.aborted(canary)) {
                canary.aborted = true;
                return canary;
            }
            // run checks first, then
            const checkResult = runChecks(payload, checks, ctx);
            if (checkResult instanceof Promise) {
                if (ctx.async === false) throw new $5SN0M.$ZodAsyncError();
                return checkResult.then((checkResult)=>inst._zod.parse(checkResult, ctx));
            }
            return inst._zod.parse(checkResult, ctx);
        };
        inst._zod.run = (payload, ctx)=>{
            if (ctx.skipChecks) return inst._zod.parse(payload, ctx);
            if (ctx.direction === "backward") {
                // run canary initial pass (no checks)
                const canary = inst._zod.parse({
                    value: payload.value,
                    issues: []
                }, {
                    ...ctx,
                    skipChecks: true
                });
                if (canary instanceof Promise) return canary.then((canary)=>{
                    return handleCanaryResult(canary, payload, ctx);
                });
                return handleCanaryResult(canary, payload, ctx);
            }
            // forward
            const result = inst._zod.parse(payload, ctx);
            if (result instanceof Promise) {
                if (ctx.async === false) throw new $5SN0M.$ZodAsyncError();
                return result.then((result)=>runChecks(result, checks, ctx));
            }
            return runChecks(result, checks, ctx);
        };
    }
}, {
    // Wrappers extend this by installing a richer factory over it; reading it eagerly would defeat the laziness.
    get "~standard" () {
        return $23ixW.hide(this, "~standard", $e32a9d04eaeb9d0c$export$bcaeb817fdf064d3(this));
    },
    set "~standard" (value){
        $23ixW.own(this, "~standard", value);
    }
});
/** The Standard Schema surface for `inst`. Shared so wrappers can extend it without forcing it. */ // a Standard Schema result only reports issues, so a failure finalizes them straight off the raw payload: no ZodError, and no lazy result to read through
const $e32a9d04eaeb9d0c$var$toStandardResult = (r, ctx)=>r.issues.length ? {
        issues: r.issues.map((iss)=>$23ixW.finalizeIssue(iss, ctx, $5SN0M.config()))
    } : {
        value: r.value
    };
async function $e32a9d04eaeb9d0c$var$validateAsync(inst, value1) {
    const ctx = {
        async: true
    };
    return $e32a9d04eaeb9d0c$var$toStandardResult(await inst._zod.run({
        value: value1,
        issues: []
    }, ctx), ctx);
}
function $e32a9d04eaeb9d0c$export$bcaeb817fdf064d3(inst) {
    return {
        validate: (value1)=>{
            const ctx = {
                async: false
            };
            try {
                const r = inst._zod.run({
                    value: value1,
                    issues: []
                }, ctx);
                if (!(r instanceof Promise)) return $e32a9d04eaeb9d0c$var$toStandardResult(r, ctx);
            } catch (_) {}
            // async function so a synchronously throwing check rejects instead of escaping validate
            return $e32a9d04eaeb9d0c$var$validateAsync(inst, value1);
        },
        vendor: "zod",
        version: 1
    };
}
const $e32a9d04eaeb9d0c$export$4342b4432d7b1471 = /*@__PURE__*/ $5SN0M.$constructor("$ZodString", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    // a format's own pattern, else unbounded; a template literal derives the check-aware form itself
    inst._zod.pattern = def.pattern ?? $dZBpt.anyString;
    inst._zod.parse = (payload, _)=>{
        if (def.coerce) try {
            payload.value = String(payload.value);
        } catch (_) {}
        if (typeof payload.value === "string") return payload;
        payload.issues.push({
            expected: "string",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d = /*@__PURE__*/ $5SN0M.$constructor("$ZodStringFormat", (inst, def)=>{
    // check initialization must come first
    $ggkLI.$ZodCheckStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$4342b4432d7b1471.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$4ca4397e3147da59 = /*@__PURE__*/ $5SN0M.$constructor("$ZodGUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.guid);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$8794aae384e3c177 = /*@__PURE__*/ $5SN0M.$constructor("$ZodUUID", (inst, def)=>{
    if (def.version) {
        const versionMap = {
            v1: 1,
            v2: 2,
            v3: 3,
            v4: 4,
            v5: 5,
            v6: 6,
            v7: 7,
            v8: 8
        };
        const v = versionMap[def.version];
        if (v === undefined) throw new Error(`Invalid UUID version: "${def.version}"`);
        def.pattern ?? (def.pattern = $dZBpt.uuid(v));
    } else def.pattern ?? (def.pattern = $dZBpt.uuid());
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$a3726aadb6108cdc = /*@__PURE__*/ $5SN0M.$constructor("$ZodEmail", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.email);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$f460f59bb193614e = 1;
const $e32a9d04eaeb9d0c$export$95483bc06fdd8d2 = 2;
function $e32a9d04eaeb9d0c$export$f2bb86aa76d51ae5(trimmed, def) {
    // When normalize is off, require :// for http/https URLs. This prevents strings like "http:example.com" or "https:/path" from being silently accepted
    if (!def.normalize && def.protocol?.source === $dZBpt.httpProtocol.source && !/^https?:\/\//i.test(trimmed)) return $e32a9d04eaeb9d0c$export$f460f59bb193614e;
    try {
        // @ts-ignore
        return new URL(trimmed);
    } catch  {
        return $e32a9d04eaeb9d0c$export$95483bc06fdd8d2;
    }
}
const $e32a9d04eaeb9d0c$var$asciiTabOrNewline = /[\t\n\r]/g;
function $e32a9d04eaeb9d0c$export$165c9bc4c1279215(value1) {
    return value1.replace($e32a9d04eaeb9d0c$var$asciiTabOrNewline, "");
}
function $e32a9d04eaeb9d0c$export$1c04d86e3f4d2da0(url, hostname) {
    hostname.lastIndex = 0;
    return hostname.test(url.hostname);
}
function $e32a9d04eaeb9d0c$export$d090bf6bb05011ae(url, protocol) {
    protocol.lastIndex = 0;
    return protocol.test(url.protocol.endsWith(":") ? url.protocol.slice(0, -1) : url.protocol);
}
const $e32a9d04eaeb9d0c$export$7e12af57cac08b7a = /*@__PURE__*/ $5SN0M.$constructor("$ZodURL", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        try {
            // Trim whitespace from input
            const trimmed = payload.value.trim();
            const url = $e32a9d04eaeb9d0c$export$f2bb86aa76d51ae5(trimmed, def);
            if (url === $e32a9d04eaeb9d0c$export$f460f59bb193614e) {
                payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    note: "Invalid URL format",
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
                return;
            }
            if (url === $e32a9d04eaeb9d0c$export$95483bc06fdd8d2) {
                payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
                return;
            }
            if (def.hostname && !$e32a9d04eaeb9d0c$export$1c04d86e3f4d2da0(url, def.hostname)) payload.issues.push({
                code: "invalid_format",
                format: "url",
                note: "Invalid hostname",
                pattern: def.hostname.source,
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
            if (def.protocol && !$e32a9d04eaeb9d0c$export$d090bf6bb05011ae(url, def.protocol)) payload.issues.push({
                code: "invalid_format",
                format: "url",
                note: "Invalid protocol",
                pattern: def.protocol.source,
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
            // Set the output value based on normalize flag
            payload.value = def.normalize ? url.href : $e32a9d04eaeb9d0c$export$165c9bc4c1279215(trimmed);
            return;
        } catch (_) {
            payload.issues.push({
                code: "invalid_format",
                format: "url",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
const $e32a9d04eaeb9d0c$export$154cd448b85bb5a3 = /*@__PURE__*/ $5SN0M.$constructor("$ZodEmoji", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.emoji());
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$5a160d28c6d62c88 = /*@__PURE__*/ $5SN0M.$constructor("$ZodNanoID", (inst, def)=>{
    if (def.length !== undefined && (!Number.isInteger(def.length) || def.length < 1)) throw new Error(`Invalid nanoid length: ${def.length}`);
    def.pattern ?? (def.pattern = def.length === undefined ? $dZBpt.nanoid : $dZBpt.nanoidOfLength(def.length));
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$f4f84bd3c6706e60 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.cuid);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$faf1483c11362df6 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCUID2", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.cuid2);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$c5788701f4f55294 = /*@__PURE__*/ $5SN0M.$constructor("$ZodULID", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.ulid);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$e721fd3317199b85 = /*@__PURE__*/ $5SN0M.$constructor("$ZodXID", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.xid);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$baa9849ea82bee6e = /*@__PURE__*/ $5SN0M.$constructor("$ZodKSUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.ksuid);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$3273e4d2df37774b = /*@__PURE__*/ $5SN0M.$constructor("$ZodISODateTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.datetime(def));
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$75b9bf98f4d806dc = /*@__PURE__*/ $5SN0M.$constructor("$ZodISODate", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.date);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$e9b9c3c2359a3ebc = /*@__PURE__*/ $5SN0M.$constructor("$ZodISOTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.time(def));
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$d9e850ab18e4b22e = /*@__PURE__*/ $5SN0M.$constructor("$ZodISODuration", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.duration);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$93fc833bbf7ceb99 = /*@__PURE__*/ $5SN0M.$constructor("$ZodIPv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.ipv4);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
/** An IPv6 address is written with hex digits, colons and dots, and nothing else. The guard is what makes the check below an IPv6 check: `new URL("http://[...]")` parses an authority, not an address, so `@` and `\` re-delimit it and `"::@1\\"` validates against the host `0.0.0.1`. The URL parser also deletes ASCII tab, LF and CR rather than failing, which is how `"::1\n"` validated as `::1`. */ const $e32a9d04eaeb9d0c$var$ipv6Alphabet = /^[0-9a-fA-F:.]+$/;
function $e32a9d04eaeb9d0c$export$a04342fa1d51a93c(value1) {
    if (!$e32a9d04eaeb9d0c$var$ipv6Alphabet.test(value1)) return false;
    try {
        // @ts-ignore
        new URL(`http://[${value1}]`);
        return true;
    } catch  {
        return false;
    }
}
const $e32a9d04eaeb9d0c$export$8c939a460418a1bf = /*@__PURE__*/ $5SN0M.$constructor("$ZodIPv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.ipv6);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if (!$e32a9d04eaeb9d0c$export$a04342fa1d51a93c(payload.value)) payload.issues.push({
            code: "invalid_format",
            format: "ipv6",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $e32a9d04eaeb9d0c$export$747370108f97e6ea = /*@__PURE__*/ $5SN0M.$constructor("$ZodMAC", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.mac(def.delimiter));
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$e164feaf5ae5296b = /*@__PURE__*/ $5SN0M.$constructor("$ZodCIDRv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.cidrv4);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
function $e32a9d04eaeb9d0c$export$5a4fa0b686dce6df(value1) {
    const parts = value1.split("/");
    if (parts.length !== 2) return false;
    const [address, prefix] = parts;
    if (!prefix) return false;
    const prefixNum = Number(prefix);
    if (`${prefixNum}` !== prefix) return false;
    if (prefixNum < 0 || prefixNum > 128) return false;
    return $e32a9d04eaeb9d0c$export$a04342fa1d51a93c(address);
}
const $e32a9d04eaeb9d0c$export$3c3aacb740759234 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCIDRv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.cidrv6); // not used for validation
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if (!$e32a9d04eaeb9d0c$export$5a4fa0b686dce6df(payload.value)) payload.issues.push({
            code: "invalid_format",
            format: "cidrv6",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
function $e32a9d04eaeb9d0c$export$5f5b3f6a560c676b(data) {
    if (data === "") return true;
    // atob ignores whitespace, so reject it up front.
    if (/\s/.test(data)) return false;
    if (data.length % 4 !== 0) return false;
    try {
        // @ts-ignore
        atob(data);
        return true;
    } catch  {
        return false;
    }
}
const $e32a9d04eaeb9d0c$export$a9609837d77c7102 = /^[0-9a-zA-Z+/]*={0,2}$/;
const $e32a9d04eaeb9d0c$export$d7d4932079e2113d = /*@__PURE__*/ $5SN0M.$constructor("$ZodBase64", (inst, def)=>{
    def.pattern ?? (def.pattern = $e32a9d04eaeb9d0c$export$a9609837d77c7102);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($e32a9d04eaeb9d0c$export$5f5b3f6a560c676b(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $e32a9d04eaeb9d0c$export$be54091f6dba12e7 = /^[A-Za-z0-9_-]*$/;
function $e32a9d04eaeb9d0c$export$eb95420c5686a3be(data) {
    if (!$e32a9d04eaeb9d0c$export$be54091f6dba12e7.test(data)) return false;
    const base64 = data.replace(/[-_]/g, (c)=>c === "-" ? "+" : "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    return $e32a9d04eaeb9d0c$export$5f5b3f6a560c676b(padded);
}
const $e32a9d04eaeb9d0c$export$f5c3c3bbec012fa6 = /*@__PURE__*/ $5SN0M.$constructor("$ZodBase64URL", (inst, def)=>{
    def.pattern ?? (def.pattern = $e32a9d04eaeb9d0c$export$be54091f6dba12e7);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($e32a9d04eaeb9d0c$export$eb95420c5686a3be(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64url",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $e32a9d04eaeb9d0c$export$46d3507e8483217 = /*@__PURE__*/ $5SN0M.$constructor("$ZodE164", (inst, def)=>{
    def.pattern ?? (def.pattern = $dZBpt.e164);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
//////////////////////////////   ZodCreditCard   //////////////////////////////
const $e32a9d04eaeb9d0c$var$CC_SANITIZE = /[- ]/g;
/** Luhn checksum on a digit-only string. Adapted from valibot (MIT). */ function $e32a9d04eaeb9d0c$var$isLuhnAlgo(digits) {
    let length = digits.length;
    let bit = 1;
    let sum = 0;
    while(length){
        const value1 = digits.charCodeAt(--length) - 48;
        bit ^= 1;
        sum += bit ? [
            0,
            2,
            4,
            6,
            8,
            1,
            3,
            5,
            7,
            9
        ][value1] : value1;
    }
    return sum % 10 === 0;
}
function $e32a9d04eaeb9d0c$export$16723e63da389301(input) {
    if (!$dZBpt.creditCard.test(input)) return false;
    return $e32a9d04eaeb9d0c$var$isLuhnAlgo(input.replace($e32a9d04eaeb9d0c$var$CC_SANITIZE, ""));
}
const $e32a9d04eaeb9d0c$export$901cea49d453364b = /*@__PURE__*/ $5SN0M.$constructor("$ZodCreditCard", (inst, def)=>{
    // Shape only — the Luhn check below is not expressible as a pattern, so consumers of `pattern` (JSON Schema, template literals) get the length and separator rules alone.
    def.pattern ?? (def.pattern = $dZBpt.creditCard);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($e32a9d04eaeb9d0c$export$16723e63da389301(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "credit_card",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
//////////////////////////////   ZodIBAN   //////////////////////////////
// iso 7064 mod 97-10 checksum without BigInt
function $e32a9d04eaeb9d0c$var$isIso7064Mod97(iban) {
    let remainder = 0;
    const len = iban.length;
    for(let i = 4; i < len; i++){
        const code = iban.charCodeAt(i);
        remainder = (code >= 65 ? remainder * 100 + (code - 55) : remainder * 10 + (code - 48)) % 97;
    }
    for(let i = 0; i < 4; i++){
        const code = iban.charCodeAt(i);
        remainder = (code >= 65 ? remainder * 100 + (code - 55) : remainder * 10 + (code - 48)) % 97;
    }
    return remainder === 1;
}
function $e32a9d04eaeb9d0c$export$90cbbdc8889fba6c(input) {
    if (!$dZBpt.iban.test(input)) return false;
    return $e32a9d04eaeb9d0c$var$isIso7064Mod97(input);
}
const $e32a9d04eaeb9d0c$export$3742722adf5f31af = /*@__PURE__*/ $5SN0M.$constructor("$ZodIBAN", (inst, def)=>{
    // shape only — checksum is not expressible as a pattern
    def.pattern ?? (def.pattern = $dZBpt.iban);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($e32a9d04eaeb9d0c$export$90cbbdc8889fba6c(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "iban",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
function $e32a9d04eaeb9d0c$export$5fc0c2a4042aff0a(token, algorithm = null) {
    try {
        const tokensParts = token.split(".");
        if (tokensParts.length !== 3) return false;
        const [header] = tokensParts;
        if (!header) return false;
        // @ts-ignore
        const parsedHeader = JSON.parse(atob(header));
        if ("typ" in parsedHeader && parsedHeader?.typ !== "JWT") return false;
        if (!parsedHeader.alg) return false;
        if (algorithm && (!("alg" in parsedHeader) || parsedHeader.alg !== algorithm)) return false;
        return true;
    } catch  {
        return false;
    }
}
const $e32a9d04eaeb9d0c$export$f515616cf0cda103 = /*@__PURE__*/ $5SN0M.$constructor("$ZodJWT", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($e32a9d04eaeb9d0c$export$5fc0c2a4042aff0a(payload.value, def.alg)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "jwt",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $e32a9d04eaeb9d0c$export$9dde4397c7b8a192 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCustomStringFormat", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if (def.fn(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $e32a9d04eaeb9d0c$export$b7292ed81eaafd49 = /*@__PURE__*/ $5SN0M.$constructor("$ZodNumber", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $dZBpt.number;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Number(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) return payload;
        const received = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? String(input) : undefined : undefined;
        payload.issues.push({
            expected: "number",
            code: "invalid_type",
            input: input,
            inst: inst,
            ...received ? {
                received: received
            } : {}
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$2cfebe79b769ec9 = /*@__PURE__*/ $5SN0M.$constructor("$ZodNumberFormat", (inst, def)=>{
    $ggkLI.$ZodCheckNumberFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$b7292ed81eaafd49.init(inst, def); // no format checks
});
const $e32a9d04eaeb9d0c$export$828bf41e557d7dda = /*@__PURE__*/ $5SN0M.$constructor("$ZodBoolean", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $dZBpt.boolean;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Boolean(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "boolean") return payload;
        payload.issues.push({
            expected: "boolean",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$7600843f2a3baa73 = /*@__PURE__*/ $5SN0M.$constructor("$ZodBigInt", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $dZBpt.bigint;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = BigInt(payload.value);
        } catch (_) {}
        if (typeof payload.value === "bigint") return payload;
        payload.issues.push({
            expected: "bigint",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$487194b75209a5dd = /*@__PURE__*/ $5SN0M.$constructor("$ZodBigIntFormat", (inst, def)=>{
    $ggkLI.$ZodCheckBigIntFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$7600843f2a3baa73.init(inst, def); // no format checks
});
const $e32a9d04eaeb9d0c$export$c9e7e1831bb8dd12 = /*@__PURE__*/ $5SN0M.$constructor("$ZodSymbol", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "symbol") return payload;
        payload.issues.push({
            expected: "symbol",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$379ccf61f9830869 = /*@__PURE__*/ $5SN0M.$constructor("$ZodUndefined", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $dZBpt.undefined;
    inst._zod.values = new Set([
        undefined
    ]);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "undefined",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$d05db4d7bc9da27d = /*@__PURE__*/ $5SN0M.$constructor("$ZodNull", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $dZBpt.null;
    inst._zod.values = new Set([
        null
    ]);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (input === null) return payload;
        payload.issues.push({
            expected: "null",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$de3a83ac65a18f35 = /*@__PURE__*/ $5SN0M.$constructor("$ZodAny", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $e32a9d04eaeb9d0c$export$37ea092643879ea0 = /*@__PURE__*/ $5SN0M.$constructor("$ZodUnknown", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $e32a9d04eaeb9d0c$export$4b2a18191b39c3b4 = /*@__PURE__*/ $5SN0M.$constructor("$ZodNever", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        payload.issues.push({
            expected: "never",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$6fd82db70787afbb = /*@__PURE__*/ $5SN0M.$constructor("$ZodVoid", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "void",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$9a0ab9fbd61629f8 = /*@__PURE__*/ $5SN0M.$constructor("$ZodDate", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = new Date(payload.value);
        } catch (_err) {}
        const input = payload.value;
        const isDate = input instanceof Date;
        const isValidDate = isDate && !Number.isNaN(input.getTime());
        if (isValidDate) return payload;
        payload.issues.push({
            expected: "date",
            code: "invalid_type",
            input: input,
            ...isDate ? {
                received: "Invalid Date"
            } : {},
            inst: inst
        });
        return payload;
    };
});
function $e32a9d04eaeb9d0c$var$handleArrayResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$23ixW.prefixIssues(index, result.issues));
    final.value[index] = result.value;
}
const $e32a9d04eaeb9d0c$export$fd77bdade7d2292b = /*@__PURE__*/ $5SN0M.$constructor("$ZodArray", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const memo = $5SN0M.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                expected: "array",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = memo ? memo.alloc(inst, payload, Array(input.length), ctx) : Array(input.length);
        const proms = [];
        const abortEarly = ctx?.abortEarly;
        for(let i = 0; i < input.length; i++){
            const item = input[i];
            const result = def.element._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$e32a9d04eaeb9d0c$var$handleArrayResult(result, payload, i)));
            else {
                $e32a9d04eaeb9d0c$var$handleArrayResult(result, payload, i);
                // the element's payload is authoritative here, since handleArrayResult forwards every issue; an object's is not, because it drops a failed absent optional
                if (abortEarly && result.issues.length !== 0 && $23ixW.aborted(result)) break;
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload; //handleArrayResultsAsync(parseResults, final);
    };
});
function $e32a9d04eaeb9d0c$var$handlePropertyResult(result, final, key, input, optin, optout) {
    const isPresent = key in input;
    const isOptionalOut = optout === "optional";
    // The middle rung means "absence permitted, nothing supplied in its place", so an absent key contributes nothing — whatever the schema made of `undefined` is invented, not substituted. Only `optional` reaches this with a value: `defaulted` substitutes, and a schema that isn't optional-out has to keep the key.
    if (!isPresent && isOptionalOut && optin === "optional") return;
    if (result.issues.length) {
        // For optional-in/out schemas, ignore errors on absent keys.
        if (optin !== undefined && isOptionalOut && !isPresent) return;
        final.issues.push(...$23ixW.prefixIssues(key, result.issues));
    }
    if (!isPresent && optin === undefined) {
        if (!result.issues.length) final.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [
                key
            ]
        });
        return;
    }
    if (result.value === undefined) {
        if (isPresent || optin === "defaulted" && !isOptionalOut) final.value[key] = undefined;
    } else final.value[key] = result.value;
}
// one shared instance; a fresh [] per schema cost 56 bytes retained
const $e32a9d04eaeb9d0c$var$NO_SYMBOL_KEYS = [];
function $e32a9d04eaeb9d0c$var$normalizeDef(def) {
    const keys = Object.keys(def.shape);
    const ownSymbols = Object.getOwnPropertySymbols(def.shape);
    const symbolKeys = ownSymbols.length ? ownSymbols : $e32a9d04eaeb9d0c$var$NO_SYMBOL_KEYS;
    // aliases `keys` when there are no symbols, so a string-only shape keeps one array
    const allKeys = symbolKeys.length ? [
        ...keys,
        ...symbolKeys
    ] : keys;
    for (const k of allKeys){
        if (!def.shape?.[k]?._zod?.traits?.has("$ZodType")) throw new Error(`Invalid element at key "${String(k)}": expected a Zod schema`);
    }
    const okeys = $23ixW.optionalKeys(def.shape);
    return {
        ...def,
        allKeys: allKeys,
        symbolKeys: symbolKeys,
        // string-only: handleCatchall matches it against `for...in`, which never yields a symbol
        keySet: new Set(keys),
        numKeys: keys.length,
        optionalKeys: new Set(okeys)
    };
}
function $e32a9d04eaeb9d0c$var$handleCatchall(proms, input, payload, ctx, def, inst, abortEarly) {
    const unrecognized = [];
    const keySet = def.keySet;
    const _catchall = def.catchall._zod;
    const t = _catchall.def.type;
    const optin = _catchall.optin;
    const optout = _catchall.optout;
    // starts at 0, not the current length: the shape phase already ran and may have aborted
    let seen = 0;
    for(const key in input){
        if (abortEarly && payload.issues.length !== seen) {
            if ($23ixW.aborted(payload, seen)) break;
            seen = payload.issues.length;
        }
        // Must precede the __proto__ branch: a declared key is not unrecognized, even though the shape loop deliberately strips __proto__ from the parsed output.
        if (keySet.has(key)) continue;
        // Don't copy an undeclared __proto__ into the result; assignment to a plain {} would replace the result prototype. But in strict mode it is still an unknown key, so report it before skipping.
        if (key === "__proto__") {
            if (t === "never") unrecognized.push(key);
            continue;
        }
        if (t === "never") {
            unrecognized.push(key);
            continue;
        }
        const r = _catchall.run({
            value: input[key],
            issues: []
        }, ctx);
        if (r instanceof Promise) proms.push(r.then((r)=>$e32a9d04eaeb9d0c$var$handlePropertyResult(r, payload, key, input, optin, optout)));
        else $e32a9d04eaeb9d0c$var$handlePropertyResult(r, payload, key, input, optin, optout);
    }
    if (unrecognized.length) payload.issues.push({
        code: "unrecognized_keys",
        keys: unrecognized,
        input: input,
        inst: inst,
        // Describes the shape of the input, not the validity of the parsed value, so it never aborts. The parse still fails; the schema's own checks just get to run first, and an enclosing intersection can reconcile the key against a sibling operand.
        continue: true
    });
    if (!proms.length) return payload;
    return Promise.all(proms).then(()=>{
        return payload;
    });
}
const $e32a9d04eaeb9d0c$export$54037a1ef79a4f1a = /*@__PURE__*/ $5SN0M.$constructor("$ZodObject", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const desc = Object.getOwnPropertyDescriptor(def, "shape");
    // a cloned def carries its source's accessor, which knows the shape it answers from; adopting that keeps the clone's keys readable without running it
    const sh = desc?.get ? desc.get.raw : def.shape ?? {};
    if (sh) {
        // Freezes the shape on first read, so its getters resolve once and every later read sees the same schemas.
        const get = ()=>{
            const newSh = {
                ...sh
            };
            Object.defineProperty(def, "shape", {
                value: newSh
            });
            get.raw = newSh;
            return newSh;
        };
        get.raw = sh;
        Object.defineProperty(def, "shape", {
            get: get
        });
    }
    const _normalized = $23ixW.cached(()=>$e32a9d04eaeb9d0c$var$normalizeDef(def));
    $23ixW.defineLazyInternal(inst, "propValues", (zod)=>{
        const shape = zod.def.shape;
        const propValues = {};
        for(const key in shape){
            const field = shape[key]._zod;
            if (field.values) {
                if (!Object.prototype.hasOwnProperty.call(propValues, key)) $23ixW.assignProp(propValues, key, new Set());
                for (const v of field.values)propValues[key].add(v);
                // An omittable slot reads back as undefined at a discriminator lookup, so it has to claim undefined: two options that can both omit the key are not discriminable on it.
                if (field.optin !== undefined) propValues[key].add(undefined);
            }
        }
        return propValues;
    });
    const isObject = $23ixW.isObject;
    const catchall = def.catchall;
    let value1;
    const memo = $5SN0M.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        value1 ?? (value1 = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
        const proms = [];
        const shape = value1.shape;
        const abortEarly = ctx?.abortEarly;
        let seen = payload.issues.length;
        for (const key of value1.allKeys){
            if (abortEarly && payload.issues.length !== seen) {
                if ($23ixW.aborted(payload, seen)) break;
                seen = payload.issues.length;
            }
            if (key === "__proto__") continue;
            const el = shape[key];
            const optin = el._zod.optin;
            const optout = el._zod.optout;
            const r = el._zod.run({
                value: input[key],
                issues: []
            }, ctx);
            if (r instanceof Promise) proms.push(r.then((r)=>$e32a9d04eaeb9d0c$var$handlePropertyResult(r, payload, key, input, optin, optout)));
            else $e32a9d04eaeb9d0c$var$handlePropertyResult(r, payload, key, input, optin, optout);
        }
        if (!catchall) return proms.length ? Promise.all(proms).then(()=>payload) : payload;
        return $e32a9d04eaeb9d0c$var$handleCatchall(proms, input, payload, ctx, _normalized.value, inst, abortEarly === true);
    };
});
const $e32a9d04eaeb9d0c$export$330feb3f8e03c085 = /*@__PURE__*/ $5SN0M.$constructor("$ZodObjectJIT", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $e32a9d04eaeb9d0c$export$54037a1ef79a4f1a.init(inst, def);
    const superParse = inst._zod.parse;
    const _normalized = $23ixW.cached(()=>$e32a9d04eaeb9d0c$var$normalizeDef(def));
    const memo = $5SN0M.globalConfig.memoizer;
    const generateFastpass = (shape)=>{
        const normalized = _normalized.value;
        const syms = normalized.symbolKeys;
        // a symbol has no source literal, so it is read as `syms[i]` off the closed-over scope
        const doc = new (0, $knYnh.Doc)([
            "payload",
            "ctx"
        ], {
            shape: shape,
            inst: inst,
            memo: memo,
            syms: syms
        });
        const parseStr = (k)=>`shape[${k}]._zod.run({ value: input[${k}], issues: [] }, ctx)`;
        // prefixes in place, like util.prefixIssues. newResult must land before the early return: a catchall runs after this and would otherwise write onto the caller's input
        const prefixStr = (id, k)=>`
          let ${id}_ab = false;
          for (let i = 0; i < ${id}.issues.length; i++) {
            const iss = ${id}.issues[i];
            iss.path = iss.path ? [${k}, ...iss.path] : [${k}];
            payload.issues.push(iss);
            if (iss.continue !== true) ${id}_ab = true;
          }
          if (${id}_ab && ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }`;
        doc.write(`const input = payload.value;`);
        const ids = Object.create(null);
        let counter = 0;
        for (const key of normalized.allKeys)ids[key] = `key_${counter++}`;
        // A: preserve key order {
        doc.write(memo ? `const newResult = memo.alloc(inst, payload, {}, ctx);` : `const newResult = {};`);
        for (const key of normalized.allKeys){
            if (key === "__proto__") continue;
            const id = ids[key];
            const k = typeof key === "symbol" ? `syms[${syms.indexOf(key)}]` : $23ixW.esc(key);
            const isPresent = `${k} in input`;
            const schema = shape[key];
            const optin = schema?._zod?.optin;
            const isOptionalIn = optin !== undefined;
            const isOptionalOut = schema?._zod?.optout === "optional";
            doc.write(`const ${id} = ${parseStr(k)};`);
            if (isOptionalIn && isOptionalOut) {
                // For optional-in/out schemas, ignore errors on absent keys — and, like the interpreted path, drop the value produced alongside them. The middle rung goes further: it permits absence without supplying anything in its place, so an absent key contributes nothing at all.
                const assign = optin === "optional" ? `${id}_present` : `${id}.value !== undefined || ${id}_present`;
                doc.write(`
        const ${id}_present = ${isPresent};
        if (!${id}.issues.length || ${id}_present) {
          if (${id}.issues.length) {${prefixStr(id, k)}
          }

          if (${assign}) {
            newResult[${k}] = ${id}.value;
          }
        }

      `);
            } else if (!isOptionalIn) doc.write(`
        const ${id}_present = ${isPresent};
        if (${id}.issues.length) {${prefixStr(id, k)}
        }
        if (!${id}_present && !${id}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${k}]
          });
          if (ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }
        }

        if (${id}_present) {
          newResult[${k}] = ${id}.value;
        }

      `);
            else {
                doc.write(`
        if (${id}.issues.length) {${prefixStr(id, k)}
        }
      `);
                if (optin === "defaulted") doc.write(`newResult[${k}] = ${id}.value;`);
                else doc.write(`
        if (${id}.value !== undefined || ${isPresent}) {
          newResult[${k}] = ${id}.value;
        }
      `);
            }
        }
        doc.write(`payload.value = newResult;`);
        doc.write(`return payload;`);
        // closing `shape` in is what pays: turbofan specializes the parser against that one shape object, so every `shape[k]._zod.run` folds to a known callee. as a parameter it stays a generic load and measures 13% slower even with the forwarding frame gone
        return doc.compile();
    };
    let fastpass;
    const isObject = $23ixW.isObject;
    const jit = !$5SN0M.globalConfig.jitless;
    const allowsEval = $23ixW.allowsEval;
    const fastEnabled = jit && allowsEval.value; // && !def.catchall;
    const catchall = def.catchall;
    let value1;
    inst._zod.parse = (payload, ctx)=>{
        value1 ?? (value1 = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        if (jit && fastEnabled && ctx?.async === false && ctx.jitless !== true) {
            // always synchronous
            if (!fastpass) fastpass = generateFastpass(def.shape);
            payload = fastpass(payload, ctx);
            if (!catchall) return payload;
            return $e32a9d04eaeb9d0c$var$handleCatchall([], input, payload, ctx, value1, inst, ctx?.abortEarly === true);
        }
        return superParse(payload, ctx);
    };
});
function $e32a9d04eaeb9d0c$var$handleUnionResults(results, final, inst, ctx) {
    for (const result of results)if (result.issues.length === 0) {
        final.value = result.value;
        return final;
    }
    const nonaborted = results.filter((r)=>!$23ixW.aborted(r));
    if (nonaborted.length === 1) {
        final.value = nonaborted[0].value;
        return nonaborted[0];
    }
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: results.map((result)=>result.issues.map((iss)=>$23ixW.finalizeIssue(iss, ctx, $5SN0M.config())))
    });
    return final;
}
const $e32a9d04eaeb9d0c$export$37a2350ef0bd638c = /*@__PURE__*/ $5SN0M.$constructor("$ZodUnion", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $23ixW.defineLazyInternal(inst, "optin", (zod)=>zod.def.options.some((o)=>o._zod.optin === "defaulted") ? "defaulted" : zod.def.options.some((o)=>o._zod.optin !== undefined) ? "optional" : undefined);
    $23ixW.defineLazyInternal(inst, "optout", (zod)=>zod.def.options.some((o)=>o._zod.optout === "optional") ? "optional" : undefined);
    $23ixW.defineLazyInternal(inst, "values", (zod)=>{
        if (zod.def.options.every((o)=>o._zod.values)) return new Set(zod.def.options.flatMap((option)=>Array.from(option._zod.values)));
        return undefined;
    });
    $23ixW.defineLazyInternal(inst, "pattern", (zod)=>{
        if (zod.def.options.every((o)=>o._zod.pattern)) {
            const patterns = zod.def.options.map((o)=>o._zod.pattern);
            return new RegExp(`^(${patterns.map((p)=>$23ixW.cleanRegex(p.source)).join("|")})$`);
        }
        return undefined;
    });
    const first = def.options.length === 1 ? def.options[0]._zod.run : null;
    inst._zod.parse = (payload, ctx)=>{
        if (first) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else {
                if (result.issues.length === 0) return result;
                results.push(result);
            }
        }
        if (!async) return $e32a9d04eaeb9d0c$var$handleUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return $e32a9d04eaeb9d0c$var$handleUnionResults(results, payload, inst, ctx);
        });
    };
});
function $e32a9d04eaeb9d0c$var$handleExclusiveUnionResults(results, final, inst, ctx) {
    const matches = [];
    for(let i = 0; i < results.length; i++)if (results[i].issues.length === 0) matches.push(i);
    if (matches.length === 1) {
        final.value = results[matches[0]].value;
        return final;
    }
    if (matches.length === 0) // No matches - same as regular union
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: results.map((result)=>result.issues.map((iss)=>$23ixW.finalizeIssue(iss, ctx, $5SN0M.config())))
    });
    else // Multiple matches - exclusive union failure
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: [],
        inclusive: false,
        matches: matches
    });
    return final;
}
const $e32a9d04eaeb9d0c$export$b04ced974a46c0b4 = /*@__PURE__*/ $5SN0M.$constructor("$ZodXor", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$37a2350ef0bd638c.init(inst, def);
    def.inclusive = false;
    const first = def.options.length === 1 ? def.options[0]._zod.run : null;
    inst._zod.parse = (payload, ctx)=>{
        if (first) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else results.push(result);
        }
        if (!async) return $e32a9d04eaeb9d0c$var$handleExclusiveUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return $e32a9d04eaeb9d0c$var$handleExclusiveUnionResults(results, payload, inst, ctx);
        });
    };
});
function $e32a9d04eaeb9d0c$export$d95dcd4112c08983(union, value1) {
    const internals = union._zod;
    let map = internals.bag.optionsMap;
    if (!map) {
        map = $e32a9d04eaeb9d0c$var$discriminatorMap(internals.def);
        internals.bag.optionsMap = map;
    }
    const option = map.get(value1);
    if (option === null) throw new Error(`Ambiguous discriminator value "${String(value1)}"`);
    return option;
}
function $e32a9d04eaeb9d0c$var$discriminatorMap(def) {
    const map = new Map();
    for (const option of def.options){
        const values = option._zod.propValues?.[def.discriminator];
        if (!values || values.size === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(option)}"`);
        for (const value1 of values)if (map.has(value1)) {
            if (value1 !== undefined) throw new Error(`Duplicate discriminator value "${String(value1)}"`);
            // keep the collision marked so a later member cannot reclaim it
            map.set(value1, null);
        } else map.set(value1, option);
    }
    return map;
}
const $e32a9d04eaeb9d0c$export$aad4f17edfb83795 = /*@__PURE__*/ $5SN0M.$constructor("$ZodDiscriminatedUnion", (inst, def)=>{
    def.inclusive = false;
    $e32a9d04eaeb9d0c$export$37a2350ef0bd638c.init(inst, def);
    const _super = inst._zod.parse;
    $23ixW.defineLazyInternal(inst, "propValues", (zod)=>{
        const propValues = {};
        let undefinedCount = 0;
        for (const option of zod.def.options){
            const pv = option._zod.propValues;
            if (!pv || Object.keys(pv).length === 0) throw new Error(`Invalid discriminated union option at index "${zod.def.options.indexOf(option)}"`);
            if (pv[zod.def.discriminator]?.has(undefined)) undefinedCount++;
            for (const [k, v] of Object.entries(pv)){
                if (!Object.prototype.hasOwnProperty.call(propValues, k)) $23ixW.assignProp(propValues, k, new Set());
                for (const val of v)propValues[k].add(val);
            }
        }
        if (!zod.def.unionFallback && undefinedCount > 1) propValues[zod.def.discriminator]?.delete(undefined);
        return propValues;
    });
    // Checked now rather than in the lookup map below, so an option that lacks the discriminator fails at the `discriminatedUnion` call instead of on the first object parsed. Options whose shape cannot be enumerated without resolving it — pipes and lazies — are left to the map.
    def.options.forEach((option, i)=>{
        const propShape = $23ixW.rawShape(option._zod.def);
        if (propShape && !Object.prototype.hasOwnProperty.call(propShape, def.discriminator)) throw new Error(`Invalid discriminated union option at index "${i}"`);
    });
    const disc = $23ixW.cached(()=>$e32a9d04eaeb9d0c$var$discriminatorMap(def));
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$23ixW.isObject(input)) {
            payload.issues.push({
                code: "invalid_type",
                expected: "object",
                input: input,
                inst: inst
            });
            return payload;
        }
        const value1 = input?.[def.discriminator];
        const opt = disc.value.get(value1);
        // forward metadata cannot choose an encoder for an absent tag
        if (opt && (value1 !== undefined || ctx.direction !== "backward")) return opt._zod.run(payload, ctx);
        // Fall back to union matching when the fast discriminator path fails:
        // - explicitly enabled via unionFallback, or
        // - during backward direction (encode), since codec-based discriminators have different values in forward vs backward directions
        if (def.unionFallback || ctx.direction === "backward") return _super(payload, ctx);
        // no matching discriminator
        payload.issues.push({
            code: "invalid_union",
            errors: [],
            note: "No matching discriminator",
            discriminator: def.discriminator,
            options: Array.from(disc.value.keys()).filter((value1)=>disc.value.get(value1) !== null),
            input: input,
            path: [
                def.discriminator
            ],
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$2299250b426aba4b = /*@__PURE__*/ $5SN0M.$constructor("$ZodIntersection", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        const left = def.left._zod.run({
            value: input,
            issues: []
        }, ctx);
        const right = def.right._zod.run({
            value: input,
            issues: []
        }, ctx);
        const async = left instanceof Promise || right instanceof Promise;
        if (async) return Promise.all([
            left,
            right
        ]).then(([left, right])=>{
            return $e32a9d04eaeb9d0c$var$handleIntersectionResults(payload, left, right);
        });
        return $e32a9d04eaeb9d0c$var$handleIntersectionResults(payload, left, right);
    };
});
function $e32a9d04eaeb9d0c$export$4c2c6f84c333dcbc(a, b) {
    // const aType = parse.t(a);
    // const bType = parse.t(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    if (a instanceof Date && b instanceof Date && +a === +b) return {
        valid: true,
        data: a
    };
    if ($23ixW.isPlainObject(a) && $23ixW.isPlainObject(b)) {
        const bKeys = Object.keys(b);
        const sharedKeys = Object.keys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        if (Object.prototype.hasOwnProperty.call(newObj, "__proto__")) delete newObj.__proto__;
        for (const key of sharedKeys){
            if (key === "__proto__") continue;
            const sharedValue = $e32a9d04eaeb9d0c$export$4c2c6f84c333dcbc(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    key,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return {
            valid: false,
            mergeErrorPath: []
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $e32a9d04eaeb9d0c$export$4c2c6f84c333dcbc(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    index,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    }
    return {
        valid: false,
        mergeErrorPath: []
    };
}
function $e32a9d04eaeb9d0c$var$handleIntersectionResults(result, left, right) {
    // Track which side(s) reject each key. A key rejection is reported only when BOTH sides reject it, so a key owned by one branch survives the other's key schema. strictObject reports these as unrecognized_keys; a record with an open key schema reports one invalid_key per key.
    const unrecKeys = new Map();
    let unrecIssue;
    const keyIssues = new Map();
    const collect = (iss, side)=>{
        let keys;
        if (iss.code === "unrecognized_keys" && !iss.path?.length) {
            unrecIssue ?? (unrecIssue = iss);
            keys = iss.keys;
        } else if (iss.code === "invalid_key" && iss.origin === "record" && iss.path?.length === 1) {
            const k = String(iss.path[0]);
            if (!keyIssues.has(k)) keyIssues.set(k, iss);
            keys = [
                k
            ];
        } else return false;
        for (const k of keys){
            if (!unrecKeys.has(k)) unrecKeys.set(k, {});
            unrecKeys.get(k)[side] = true;
        }
        return true;
    };
    for (const iss of left.issues)if (!collect(iss, "l")) result.issues.push(iss);
    for (const iss of right.issues)if (!collect(iss, "r")) result.issues.push(iss);
    // Report only keys rejected by BOTH sides
    const bothKeys = [
        ...unrecKeys
    ].filter(([, f])=>f.l && f.r).map(([k])=>k);
    if (bothKeys.length) {
        const aggregated = unrecIssue ? bothKeys.filter((k)=>unrecIssue.keys.includes(k)) : [];
        if (aggregated.length) result.issues.push({
            ...unrecIssue,
            keys: aggregated
        });
        for (const k of bothKeys)if (!aggregated.includes(k) && keyIssues.has(k)) result.issues.push(keyIssues.get(k));
    }
    const merged = $e32a9d04eaeb9d0c$export$4c2c6f84c333dcbc(left.value, right.value);
    if (!merged.valid) {
        if ($23ixW.aborted(result)) return result;
        throw new Error(`Unmergable intersection. Error path: ` + `${JSON.stringify(merged.mergeErrorPath)}`);
    }
    result.value = merged.data;
    return result;
}
const $e32a9d04eaeb9d0c$export$bba1b90a721dbd94 = /*@__PURE__*/ $5SN0M.$constructor("$ZodTuple", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const items = def.items;
    const memo = $5SN0M.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "tuple",
                code: "invalid_type"
            });
            return payload;
        }
        payload.value = memo ? memo.alloc(inst, payload, [], ctx) : [];
        const proms = [];
        const optinStart = $e32a9d04eaeb9d0c$var$getTupleOptStart(items, "optin");
        const optoutStart = $e32a9d04eaeb9d0c$var$getTupleOptStart(items, "optout");
        if (!def.rest) {
            if (input.length < optinStart) {
                payload.issues.push({
                    code: "too_small",
                    minimum: optinStart,
                    inclusive: true,
                    input: input,
                    inst: inst,
                    origin: "array"
                });
                return payload;
            }
            if (input.length > items.length) payload.issues.push({
                code: "too_big",
                maximum: items.length,
                inclusive: true,
                input: input,
                inst: inst,
                origin: "array"
            });
        }
        // Run every item in parallel, collecting results into an indexed array. The post-processing in `handleTupleResults` walks them in order so it can decide whether an absent optional-output error can truncate the tail or must be reported to preserve required output.
        const itemResults = new Array(items.length);
        // only tracked when there is a rest loop to skip
        const abortEarly = def.rest ? ctx?.abortEarly : undefined;
        let itemAborted = false;
        for(let i = 0; i < items.length; i++){
            const r = items[i]._zod.run({
                value: input[i],
                issues: []
            }, ctx);
            if (r instanceof Promise) proms.push(r.then((rr)=>{
                itemResults[i] = rr;
            }));
            else {
                itemResults[i] = r;
                if (abortEarly && !itemAborted && r.issues.length) itemAborted = $23ixW.aborted(r);
            }
        }
        // sound because rest is non-empty exactly when every fixed index is present, the one case handleTupleResults cannot discard an item's issues
        if (def.rest && !itemAborted) {
            let i = items.length - 1;
            const rest = input.slice(items.length);
            let seen = payload.issues.length;
            for (const el of rest){
                if (abortEarly && payload.issues.length !== seen) {
                    if ($23ixW.aborted(payload, seen)) break;
                    seen = payload.issues.length;
                }
                i++;
                const result = def.rest._zod.run({
                    value: el,
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((r)=>$e32a9d04eaeb9d0c$var$handleTupleResult(r, payload, i)));
                else $e32a9d04eaeb9d0c$var$handleTupleResult(result, payload, i);
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>$e32a9d04eaeb9d0c$var$handleTupleResults(itemResults, payload, items, input, optoutStart));
        return $e32a9d04eaeb9d0c$var$handleTupleResults(itemResults, payload, items, input, optoutStart);
    };
});
function $e32a9d04eaeb9d0c$var$getTupleOptStart(items, key) {
    for(let i = items.length - 1; i >= 0; i--){
        // optin is a three-rung ladder so any rung above `undefined` permits an absent slot; optout stays two-valued.
        const omittable = key === "optin" ? items[i]._zod.optin !== undefined : items[i]._zod.optout === "optional";
        if (!omittable) return i + 1;
    }
    return 0;
}
function $e32a9d04eaeb9d0c$var$handleTupleResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$23ixW.prefixIssues(index, result.issues));
    final.value[index] = result.value;
}
function $e32a9d04eaeb9d0c$var$handleTupleResults(itemResults, final, items, input, optoutStart) {
    // Walk results in order. Mirror $ZodObject's swallow-on-absent-optional rule, but only after `optoutStart`: the first index where the output tuple tail can be absent.
    for(let i = 0; i < items.length; i++){
        const r = itemResults[i];
        const isPresent = i < input.length;
        // The array analog of `handlePropertyResult`'s absent-key early return: the middle rung permits absence without supplying anything in its place, so the tail truncates here instead of materializing whatever the item made of `undefined`.
        if (!isPresent && i >= optoutStart && items[i]._zod.optin === "optional") {
            final.value.length = i;
            break;
        }
        if (r.issues.length) {
            if (!isPresent && i >= optoutStart) {
                final.value.length = i;
                break;
            }
            final.issues.push(...$23ixW.prefixIssues(i, r.issues));
        }
        final.value[i] = r.value;
    }
    // Drop trailing slots that produced `undefined` for absent input
    // (the array analog of an absent optional key on an object). The
    // `i >= input.length` floor is critical: an explicit `undefined`
    // *inside* the input must be preserved even when the schema is
    // optional-out (e.g. `z.string().or(z.undefined())` accepting an
    // explicit undefined value).
    for(let i = final.value.length - 1; i >= input.length; i--){
        if (items[i]._zod.optout === "optional" && final.value[i] === undefined) final.value.length = i;
        else break;
    }
    return final;
}
const $e32a9d04eaeb9d0c$export$cc20b90ec1a8c208 = /*@__PURE__*/ $5SN0M.$constructor("$ZodRecord", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const memo = $5SN0M.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$23ixW.isPlainObject(input)) {
            payload.issues.push({
                expected: "record",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        // no guard in either loop below: a record's invalid_key aborts but an enclosing intersection can reconcile it, so a stopped loop hides keys the sibling does not own and the intersection then rejects nothing
        const proms = [];
        const values = def.keyType._zod.values;
        if (values && !def.partial) {
            payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
            const recordKeys = new Set();
            for (const key of values)if (typeof key === "string" || typeof key === "number" || typeof key === "symbol") {
                recordKeys.add(typeof key === "number" ? key.toString() : key);
                // A declared __proto__ is stripped but is not an unrecognized key.
                if (key === "__proto__") continue;
                const keyResult = def.keyType._zod.run({
                    value: key,
                    issues: []
                }, ctx);
                if (keyResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                if (keyResult.issues.length) {
                    payload.issues.push({
                        code: "invalid_key",
                        origin: "record",
                        issues: keyResult.issues.map((iss)=>$23ixW.finalizeIssue(iss, ctx, $5SN0M.config())),
                        input: key,
                        path: [
                            key
                        ],
                        inst: inst
                    });
                    continue;
                }
                const outKey = keyResult.value;
                if (outKey === "__proto__") continue;
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$23ixW.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$23ixW.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }
            }
            let unrecognized;
            for(const key in input)if (!recordKeys.has(key)) {
                if (def.mode === "loose") {
                    // skip __proto__ so it can't replace the result prototype via the assignment setter on the plain {} we build into
                    if (key === "__proto__") continue;
                    payload.value[key] = input[key];
                } else {
                    unrecognized = unrecognized ?? [];
                    unrecognized.push(key);
                }
            }
            if (unrecognized && unrecognized.length > 0) payload.issues.push({
                code: "unrecognized_keys",
                input: input,
                inst: inst,
                keys: unrecognized,
                continue: true
            });
        } else {
            payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
            // An enumerable key schema declares which keys the record owns, so a key outside the set is unrecognized. A non-enumerable one (regex, refine) is a constraint every key must satisfy, so a failing key is invalid. Only the former is reconcilable against the other side of an intersection.
            let unrecognized;
            // Reflect.ownKeys for Symbol-key support; filter non-enumerable to match z.object()
            for (const key of Reflect.ownKeys(input)){
                if (key === "__proto__") continue;
                if (!Object.prototype.propertyIsEnumerable.call(input, key)) continue;
                let keyResult = def.keyType._zod.run({
                    value: key,
                    issues: []
                }, ctx);
                if (keyResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                // Numeric string fallback: if key is a numeric string and failed, retry with Number(key). This handles z.number(), z.literal([1, 2, 3]), and unions containing numeric literals
                const checkNumericKey = typeof key === "string" && $dZBpt.number.test(key) && keyResult.issues.length;
                if (checkNumericKey) {
                    const retryResult = def.keyType._zod.run({
                        value: Number(key),
                        issues: []
                    }, ctx);
                    if (retryResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                    if (retryResult.issues.length === 0) keyResult = retryResult;
                }
                if (keyResult.issues.length) {
                    if (def.mode === "loose") // Pass through unchanged
                    payload.value[key] = input[key];
                    else if (values) {
                        unrecognized = unrecognized ?? [];
                        unrecognized.push(key);
                    } else // Default "strict" behavior: error on invalid key
                    payload.issues.push({
                        code: "invalid_key",
                        origin: "record",
                        issues: keyResult.issues.map((iss)=>$23ixW.finalizeIssue(iss, ctx, $5SN0M.config())),
                        input: key,
                        path: [
                            key
                        ],
                        inst: inst
                    });
                    continue;
                }
                // the guard above tests the raw input key, but the key schema can normalize an ordinary key into __proto__; re-check the key we actually write under
                const outKey = keyResult.value;
                if (outKey === "__proto__") continue;
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$23ixW.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$23ixW.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }
            }
            if (unrecognized && unrecognized.length > 0) payload.issues.push({
                code: "unrecognized_keys",
                input: input,
                inst: inst,
                keys: unrecognized,
                continue: true
            });
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$5ccfd30a7e358409 = /*@__PURE__*/ $5SN0M.$constructor("$ZodMap", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const memo = $5SN0M.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Map)) {
            payload.issues.push({
                expected: "map",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        const proms = [];
        payload.value = memo ? memo.alloc(inst, payload, new Map(), ctx) : new Map();
        const abortEarly = ctx?.abortEarly;
        let seen = payload.issues.length;
        for (const [key, value1] of input){
            if (abortEarly && payload.issues.length !== seen) {
                if ($23ixW.aborted(payload, seen)) break;
                seen = payload.issues.length;
            }
            const keyResult = def.keyType._zod.run({
                value: key,
                issues: []
            }, ctx);
            const valueResult = def.valueType._zod.run({
                value: value1,
                issues: []
            }, ctx);
            if (keyResult instanceof Promise || valueResult instanceof Promise) proms.push(Promise.all([
                keyResult,
                valueResult
            ]).then(([keyResult, valueResult])=>{
                $e32a9d04eaeb9d0c$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
            }));
            else $e32a9d04eaeb9d0c$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $e32a9d04eaeb9d0c$var$handleMapResult(keyResult, valueResult, final, key, input, inst, ctx) {
    if (keyResult.issues.length) {
        if ($23ixW.propertyKeyTypes.has(typeof key)) final.issues.push(...$23ixW.prefixIssues(key, keyResult.issues));
        else final.issues.push({
            code: "invalid_key",
            origin: "map",
            input: input,
            inst: inst,
            issues: keyResult.issues.map((iss)=>$23ixW.finalizeIssue(iss, ctx, $5SN0M.config()))
        });
    }
    if (valueResult.issues.length) {
        if ($23ixW.propertyKeyTypes.has(typeof key)) final.issues.push(...$23ixW.prefixIssues(key, valueResult.issues));
        else final.issues.push({
            origin: "map",
            code: "invalid_element",
            input: input,
            inst: inst,
            key: key,
            issues: valueResult.issues.map((iss)=>$23ixW.finalizeIssue(iss, ctx, $5SN0M.config()))
        });
    }
    final.value.set(keyResult.value, valueResult.value);
}
const $e32a9d04eaeb9d0c$export$20cf27bc33a30268 = /*@__PURE__*/ $5SN0M.$constructor("$ZodSet", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const memo = $5SN0M.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Set)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "set",
                code: "invalid_type"
            });
            return payload;
        }
        const proms = [];
        payload.value = memo ? memo.alloc(inst, payload, new Set(), ctx) : new Set();
        const abortEarly = ctx?.abortEarly;
        let seen = payload.issues.length;
        for (const item of input){
            if (abortEarly && payload.issues.length !== seen) {
                if ($23ixW.aborted(payload, seen)) break;
                seen = payload.issues.length;
            }
            const result = def.valueType._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$e32a9d04eaeb9d0c$var$handleSetResult(result, payload)));
            else $e32a9d04eaeb9d0c$var$handleSetResult(result, payload);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $e32a9d04eaeb9d0c$var$handleSetResult(result, final) {
    if (result.issues.length) final.issues.push(...result.issues);
    final.value.add(result.value);
}
const $e32a9d04eaeb9d0c$export$31462b6e6c50b618 = /*@__PURE__*/ $5SN0M.$constructor("$ZodEnum", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const values = $23ixW.getEnumValues(def.entries);
    const valuesSet = new Set(values);
    inst._zod.values = valuesSet;
    $23ixW.defineLazyInternal(inst, "pattern", (zod)=>{
        const patternValues = $23ixW.getEnumValues(zod.def.entries).filter((k)=>$23ixW.propertyKeyTypes.has(typeof k));
        // unmatchable fallback, RE2-safe: an empty alternation would compile to /^()$/, which matches ""
        return new RegExp(patternValues.length ? `^(${patternValues.map((o)=>$23ixW.escapeRegex(o.toString())).join("|")})$` : "^[^\\s\\S]$");
    });
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (valuesSet.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$86699355265fa258 = /*@__PURE__*/ $5SN0M.$constructor("$ZodLiteral", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const values = new Set(def.values);
    inst._zod.values = values;
    $23ixW.defineLazyInternal(inst, "pattern", (zod)=>{
        const vals = zod.def.values;
        // unmatchable fallback, RE2-safe: an empty alternation would compile to /^()$/, which matches ""
        return new RegExp(vals.length ? `^(${vals.map((o)=>typeof o === "string" ? $23ixW.escapeRegex(o) : o ? $23ixW.escapeRegex(o.toString()) : String(o)).join("|")})$` : "^[^\\s\\S]$");
    });
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (values.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: def.values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$1997de0576a81377 = /*@__PURE__*/ $5SN0M.$constructor("$ZodFile", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        // @ts-ignore
        if (input instanceof File) return payload;
        payload.issues.push({
            expected: "file",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$14b591f873519189 = /*@__PURE__*/ $5SN0M.$constructor("$ZodTransform", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "optional";
    $5SN0M.globalConfig.memoizer?.guard(inst);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $5SN0M.$ZodEncodeError(inst.constructor.name);
        const _out = def.transform(payload.value, payload);
        if (ctx.async) {
            const output = _out instanceof Promise ? _out : Promise.resolve(_out);
            return output.then((output)=>{
                payload.value = output;
                return payload;
            });
        }
        if (_out instanceof Promise) throw new $5SN0M.$ZodAsyncError();
        payload.value = _out;
        return payload;
    };
});
function $e32a9d04eaeb9d0c$var$handleOptionalResult(payload, result) {
    // A substituting schema that still failed has no usable answer; yield undefined. Its issues are simply dropped: it ran on a payload of its own, so there is no shared array to truncate and nothing of the caller's to lose with it.
    payload.value = result.issues.length ? undefined : result.value;
    return payload;
}
const $e32a9d04eaeb9d0c$export$980e9af565c4d7aa = /*@__PURE__*/ $5SN0M.$constructor("$ZodOptional", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    // .optional() propagates absence rather than substituting for it, so a defaulted inner keeps its rung.
    $23ixW.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional");
    inst._zod.optout = "optional";
    $23ixW.defineLazyInternal(inst, "values", (zod)=>{
        const values = zod.def.innerType._zod.values;
        return values ? new Set([
            ...values,
            undefined
        ]) : undefined;
    });
    $23ixW.defineLazyInternal(inst, "pattern", (zod)=>{
        const pattern = zod.def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$23ixW.cleanRegex(pattern.source)})?$`) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        if (payload.value === undefined) {
            // Only the top rung substitutes a value for absence; everything else leaves it intact, which is what .optional() means.
            if (def.innerType._zod.optin !== "defaulted") return payload;
            // Its own payload, for the same reason $ZodCatch gets one: a pipe forwards an unrecognized key through the caller's issues array, and this must not read that as the substituting schema failing and drop it.
            const result = def.innerType._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) return result.then((result)=>$e32a9d04eaeb9d0c$var$handleOptionalResult(payload, result));
            return $e32a9d04eaeb9d0c$var$handleOptionalResult(payload, result);
        }
        return def.innerType._zod.run(payload, ctx);
    };
});
const $e32a9d04eaeb9d0c$export$384d083c2a6b693f = /*@__PURE__*/ $5SN0M.$constructor("$ZodExactOptional", (inst, def)=>{
    // Call parent init - inherits optin/optout = "optional"
    $e32a9d04eaeb9d0c$export$980e9af565c4d7aa.init(inst, def);
    // Override values/pattern to NOT add undefined
    $23ixW.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    $23ixW.defineLazyInternal(inst, "pattern", (zod)=>zod.def.innerType._zod.pattern);
    // Override parse to just delegate (no undefined handling)
    inst._zod.parse = (payload, ctx)=>{
        return def.innerType._zod.run(payload, ctx);
    };
});
const $e32a9d04eaeb9d0c$export$7994573b6604ec66 = /*@__PURE__*/ $5SN0M.$constructor("$ZodNullable", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $23ixW.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType._zod.optin);
    $23ixW.defineLazyInternal(inst, "optout", (zod)=>zod.def.innerType._zod.optout);
    $23ixW.defineLazyInternal(inst, "pattern", (zod)=>{
        const pattern = zod.def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$23ixW.cleanRegex(pattern.source)}|null)$`) : undefined;
    });
    $23ixW.defineLazyInternal(inst, "values", (zod)=>{
        return zod.def.innerType._zod.values ? new Set([
            ...zod.def.innerType._zod.values,
            null
        ]) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        // Forward direction (decode): allow null to pass through
        if (payload.value === null) return payload;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $e32a9d04eaeb9d0c$export$ae2d21004b7243f7 = /*@__PURE__*/ $5SN0M.$constructor("$ZodDefault", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    // inst._zod.qin = "true";
    inst._zod.optin = "defaulted";
    $23ixW.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply defaults for undefined input
        if (payload.value === undefined) {
            payload.value = def.defaultValue;
            /**
             * $ZodDefault returns the default value immediately in forward direction.
             * It doesn't pass the default value into the validator ("prefault"). There's no reason to pass the default value through validation. The validity of the default is enforced by TypeScript statically. Otherwise, it's the responsibility of the user to ensure the default is valid. In the case of pipes with divergent in/out types, you can specify the default on the `in` schema of your ZodPipe to set a "prefault" for the pipe.   */ return payload;
        }
        // Forward direction: continue with default handling
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$e32a9d04eaeb9d0c$var$handleDefaultResult(result, def));
        return $e32a9d04eaeb9d0c$var$handleDefaultResult(result, def);
    };
});
function $e32a9d04eaeb9d0c$var$handleDefaultResult(payload, def) {
    if (payload.value === undefined) payload.value = def.defaultValue;
    return payload;
}
const $e32a9d04eaeb9d0c$export$29a8d757258be679 = /*@__PURE__*/ $5SN0M.$constructor("$ZodPrefault", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "defaulted";
    $23ixW.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply prefault for undefined input
        if (payload.value === undefined) payload.value = def.defaultValue;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $e32a9d04eaeb9d0c$export$30ca726c4c50a6d7 = /*@__PURE__*/ $5SN0M.$constructor("$ZodNonOptional", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $23ixW.defineLazyInternal(inst, "values", (zod)=>{
        const v = zod.def.innerType._zod.values;
        return v ? new Set([
            ...v
        ].filter((x)=>x !== undefined)) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$e32a9d04eaeb9d0c$var$handleNonOptionalResult(result, inst));
        return $e32a9d04eaeb9d0c$var$handleNonOptionalResult(result, inst);
    };
});
function $e32a9d04eaeb9d0c$var$handleNonOptionalResult(payload, inst) {
    if (!payload.issues.length && payload.value === undefined) payload.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: payload.value,
        inst: inst
    });
    return payload;
}
const $e32a9d04eaeb9d0c$export$3cc4d03e729326ea = /*@__PURE__*/ $5SN0M.$constructor("$ZodSuccess", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $5SN0M.$ZodEncodeError("ZodSuccess");
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>{
            payload.value = result.issues.length === 0;
            return payload;
        });
        payload.value = result.issues.length === 0;
        return payload;
    };
});
function $e32a9d04eaeb9d0c$var$handleCatchResult(payload, result, def, ctx) {
    if (!result.issues.length) {
        payload.value = result.value;
        // The value carries up, so the flag describing it has to carry with it: a back-edge into a node still being parsed must not be frozen by an enclosing readonly, and its checks belong to the node itself. Guarded so the ordinary case adds no own property.
        if (result.memo) payload.memo = true;
        return payload;
    }
    // Spread the inner's own payload, not ours: `value` has to stay the input the catch was handed, and the inner ran on a payload of its own so its issues are already private to this call.
    payload.value = def.catchValue({
        ...result,
        value: payload.value,
        error: {
            issues: result.issues.map((iss)=>$23ixW.finalizeIssue(iss, ctx, $5SN0M.config()))
        },
        input: payload.value
    });
    return payload;
}
const $e32a9d04eaeb9d0c$export$d6f8b228374f6d37 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCatch", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $23ixW.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional");
    $23ixW.defineLazyInternal(inst, "optout", (zod)=>zod.def.innerType._zod.optout);
    $23ixW.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply catch logic
        const result = def.innerType._zod.run({
            value: payload.value,
            issues: []
        }, ctx);
        if (result instanceof Promise) return result.then((result)=>$e32a9d04eaeb9d0c$var$handleCatchResult(payload, result, def, ctx));
        return $e32a9d04eaeb9d0c$var$handleCatchResult(payload, result, def, ctx);
    };
});
const $e32a9d04eaeb9d0c$export$528f71701e6a7aee = /*@__PURE__*/ $5SN0M.$constructor("$ZodNaN", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "number" || !Number.isNaN(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "nan",
                code: "invalid_type"
            });
            return payload;
        }
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$4cb25cfde430326c = /*@__PURE__*/ $5SN0M.$constructor("$ZodPipe", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $23ixW.defineLazyInternal(inst, "values", (zod)=>zod.def.in._zod.values);
    $23ixW.defineLazyInternal(inst, "optin", (zod)=>zod.def.in._zod.optin);
    $23ixW.defineLazyInternal(inst, "optout", (zod)=>zod.def.out._zod.optout);
    $23ixW.defineLazyInternal(inst, "propValues", (zod)=>zod.def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$e32a9d04eaeb9d0c$var$handlePipeResult(right, def.in, ctx));
            return $e32a9d04eaeb9d0c$var$handlePipeResult(right, def.in, ctx);
        }
        const left = def.in._zod.run(payload, ctx);
        if (left instanceof Promise) return left.then((left)=>$e32a9d04eaeb9d0c$var$handlePipeResult(left, def.out, ctx));
        return $e32a9d04eaeb9d0c$var$handlePipeResult(left, def.out, ctx);
    };
});
function $e32a9d04eaeb9d0c$var$handlePipeResult(left, next, ctx) {
    // Any issue stops the pipe, so a failing refinement never feeds its transform. An unrecognized key is the exception: it describes the input's extra properties, not the value being piped, and an enclosing intersection may yet reconcile it.
    if (left.issues.some((iss)=>iss.code !== "unrecognized_keys")) {
        // prevent further checks
        left.aborted = true;
        return left;
    }
    return next._zod.run({
        value: left.value,
        issues: left.issues
    }, ctx);
}
const $e32a9d04eaeb9d0c$export$c622e07db8a40b53 = /*@__PURE__*/ $5SN0M.$constructor("$ZodCodec", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $23ixW.defineLazyInternal(inst, "values", (zod)=>zod.def.in._zod.values);
    $23ixW.defineLazyInternal(inst, "optin", (zod)=>zod.def.in._zod.optin);
    $23ixW.defineLazyInternal(inst, "optout", (zod)=>zod.def.out._zod.optout);
    $23ixW.defineLazyInternal(inst, "propValues", (zod)=>zod.def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        const direction = ctx.direction || "forward";
        if (direction === "forward") {
            const left = def.in._zod.run(payload, ctx);
            if (left instanceof Promise) return left.then((left)=>$e32a9d04eaeb9d0c$var$handleCodecAResult(left, def, ctx));
            return $e32a9d04eaeb9d0c$var$handleCodecAResult(left, def, ctx);
        } else {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$e32a9d04eaeb9d0c$var$handleCodecAResult(right, def, ctx));
            return $e32a9d04eaeb9d0c$var$handleCodecAResult(right, def, ctx);
        }
    };
});
function $e32a9d04eaeb9d0c$var$handleCodecAResult(result, def, ctx) {
    if (result.issues.length) {
        // prevent further checks
        result.aborted = true;
        return result;
    }
    const direction = ctx.direction || "forward";
    if (direction === "forward") {
        const transformed = def.transform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value1)=>$e32a9d04eaeb9d0c$var$handleCodecTxResult(result, value1, def.out, ctx));
        return $e32a9d04eaeb9d0c$var$handleCodecTxResult(result, transformed, def.out, ctx);
    } else {
        const transformed = def.reverseTransform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value1)=>$e32a9d04eaeb9d0c$var$handleCodecTxResult(result, value1, def.in, ctx));
        return $e32a9d04eaeb9d0c$var$handleCodecTxResult(result, transformed, def.in, ctx);
    }
}
function $e32a9d04eaeb9d0c$var$handleCodecTxResult(left, value1, nextSchema, ctx) {
    // Check if transform added any issues
    if (left.issues.length) {
        left.aborted = true;
        return left;
    }
    return nextSchema._zod.run({
        value: value1,
        issues: left.issues
    }, ctx);
}
const $e32a9d04eaeb9d0c$export$200c161ed581d39b = /*@__PURE__*/ $5SN0M.$constructor("$ZodPreprocess", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$4cb25cfde430326c.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$f9f268f3fbb1601b = /*@__PURE__*/ $5SN0M.$constructor("$ZodReadonly", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $23ixW.defineLazyInternal(inst, "propValues", (zod)=>zod.def.innerType._zod.propValues);
    $23ixW.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    $23ixW.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType?._zod?.optin);
    $23ixW.defineLazyInternal(inst, "optout", (zod)=>zod.def.innerType?._zod?.optout);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then($e32a9d04eaeb9d0c$var$handleReadonlyResult);
        return $e32a9d04eaeb9d0c$var$handleReadonlyResult(result);
    };
});
function $e32a9d04eaeb9d0c$var$handleReadonlyResult(payload) {
    // A repeat visit hands back a node that is still being built; freezing it here would make the rest of its keys fail to assign.
    if (!payload.memo) payload.value = Object.freeze(payload.value);
    return payload;
}
// a leaf's pattern source with its own checks folded in: the last pattern-carrying check wins, else length bounds narrow the catch-all, else an integer format narrows the number form. the fold lives here instead of on `_zod.pattern` so a bundle without template literals never pays for it
function $e32a9d04eaeb9d0c$var$leafPattern(schema) {
    const def = schema._zod.def;
    let pattern = def.pattern;
    let isInt = !!def.format?.includes("int");
    let minimum;
    let maximum;
    for (const ch of def.checks ?? []){
        const d = ch._zod.def;
        if (d.pattern) pattern = d.pattern;
        isInt || (isInt = !!d.format?.includes("int"));
        const lo = d.minimum ?? d.length;
        const hi = d.maximum ?? d.length;
        if (lo !== undefined && (minimum === undefined || lo > minimum)) minimum = lo;
        if (hi !== undefined && (maximum === undefined || hi < maximum)) maximum = hi;
    }
    if (pattern) return pattern.source;
    // an empty range matches nothing at runtime, and `{8,5}` is not a legal quantifier
    if (minimum !== undefined && maximum !== undefined && minimum > maximum) return "(?!)";
    if (minimum !== undefined || maximum !== undefined) return $dZBpt.string({
        minimum: minimum,
        maximum: maximum
    }).source;
    const own = schema._zod.pattern;
    return (isInt && own === $dZBpt.number ? $dZBpt.integer : own)?.source;
}
// a part's pattern source. a wrapper's pattern embeds its inner pattern's source verbatim, so the folded form is substituted in place without knowing the wrapper's own composition; a union's options are joined the way the union builds its own pattern
function $e32a9d04eaeb9d0c$var$partPattern(schema) {
    const def = schema._zod.def;
    const own = schema._zod.pattern?.source;
    // lazy resolves its inner on the internals, not the def
    const inner = def.innerType ?? schema._zod.innerType;
    if (inner) {
        const before = inner._zod.pattern?.source;
        const after = $e32a9d04eaeb9d0c$var$partPattern(inner);
        if (own && before && after && after !== before) return own.replace($23ixW.cleanRegex(before), ()=>$23ixW.cleanRegex(after));
        return own;
    }
    if (def.options) {
        const sources = def.options.map($e32a9d04eaeb9d0c$var$partPattern);
        if (sources.every(Boolean)) return `^(${sources.map((s)=>$23ixW.cleanRegex(s)).join("|")})$`;
    }
    return $e32a9d04eaeb9d0c$var$leafPattern(schema);
}
const $e32a9d04eaeb9d0c$export$37ea86c57a77af54 = /*@__PURE__*/ $5SN0M.$constructor("$ZodTemplateLiteral", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const regexParts = [];
    for (const part of def.parts){
        if (typeof part === "object" && part !== null) {
            // is Zod schema
            const source = $e32a9d04eaeb9d0c$var$partPattern(part);
            if (!source) throw new Error(`Invalid template literal part, no pattern found: ${[
                ...part._zod.traits
            ].shift()}`);
            regexParts.push($23ixW.cleanRegex(source));
        } else if (part === null || $23ixW.primitiveTypes.has(typeof part)) regexParts.push($23ixW.escapeRegex(`${part}`));
        else throw new Error(`Invalid template literal part: ${part}`);
    }
    inst._zod.pattern = new RegExp(`^${regexParts.join("")}$`);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "string") {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "string",
                code: "invalid_type"
            });
            return payload;
        }
        inst._zod.pattern.lastIndex = 0;
        if (!inst._zod.pattern.test(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                code: "invalid_format",
                format: def.format ?? "template_literal",
                pattern: inst._zod.pattern.source
            });
            return payload;
        }
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$877c6e9c05ede764 = /*@__PURE__*/ $5SN0M.$constructor("$ZodFunction", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    // Defined, not assigned: the classic prototype exposes `_def` as a getter with no setter.
    Object.defineProperty(inst, "_def", {
        value: def
    });
    inst._zod.def = def;
    inst.implement = (func)=>{
        if (typeof func !== "function") throw new Error("implement() must be called with a function");
        // Defined inline so the closure stays anonymous: binding it to a `const` first names it, which costs 256 bytes per implemented function.
        return Object.defineProperty(function(...args) {
            const parsedArgs = inst._def.input ? (0, $57W0y.parse)(inst._def.input, args) : args;
            const result = Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return (0, $57W0y.parse)(inst._def.output, result);
            return result;
        }, "_zod", {
            value: inst._zod,
            enumerable: false
        });
    };
    inst.implementAsync = (func)=>{
        if (typeof func !== "function") throw new Error("implementAsync() must be called with a function");
        return Object.defineProperty(async function(...args) {
            const parsedArgs = inst._def.input ? await (0, $57W0y.parseAsync)(inst._def.input, args) : args;
            const result = await Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return await (0, $57W0y.parseAsync)(inst._def.output, result);
            return result;
        }, "_zod", {
            value: inst._zod,
            enumerable: false
        });
    };
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "function") {
            payload.issues.push({
                code: "invalid_type",
                expected: "function",
                input: payload.value,
                inst: inst
            });
            return payload;
        }
        // Check if output is a promise type to determine if we should use async implementation
        const hasPromiseOutput = inst._def.output && inst._def.output._zod.def.type === "promise";
        if (hasPromiseOutput) payload.value = inst.implementAsync(payload.value);
        else payload.value = inst.implement(payload.value);
        return payload;
    };
    inst.input = (...args)=>{
        const F = inst.constructor;
        if (Array.isArray(args[0])) return new F({
            type: "function",
            input: new $e32a9d04eaeb9d0c$export$bba1b90a721dbd94({
                type: "tuple",
                items: args[0],
                rest: args[1]
            }),
            output: inst._def.output
        });
        return new F({
            type: "function",
            input: args[0],
            output: inst._def.output
        });
    };
    inst.output = (output)=>{
        const F = inst.constructor;
        return new F({
            type: "function",
            input: inst._def.input,
            output: output
        });
    };
    return inst;
});
const $e32a9d04eaeb9d0c$export$bdefabff0dd84ca4 = /*@__PURE__*/ $5SN0M.$constructor("$ZodPromise", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        return Promise.resolve(payload.value).then((inner)=>def.innerType._zod.run({
                value: inner,
                issues: []
            }, ctx));
    };
});
const $e32a9d04eaeb9d0c$export$662fecee2efa1a66 = /*@__PURE__*/ $5SN0M.$constructor("$ZodLazy", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    // Cache the resolved inner type on the shared `def` so all clones of this lazy (e.g. via `.describe()`/`.meta()`) share the same inner instance, preserving identity for cycle detection on recursive schemas.
    $23ixW.defineLazy(inst._zod, "innerType", ()=>{
        const d = def;
        if (!d._cachedInner) d._cachedInner = def.getter();
        return d._cachedInner;
    });
    $23ixW.defineLazyInternal(inst, "pattern", (zod)=>zod.innerType?._zod?.pattern);
    $23ixW.defineLazyInternal(inst, "propValues", (zod)=>zod.innerType?._zod?.propValues);
    $23ixW.defineLazyInternal(inst, "optin", (zod)=>zod.innerType?._zod?.optin ?? undefined);
    $23ixW.defineLazyInternal(inst, "optout", (zod)=>zod.innerType?._zod?.optout ?? undefined);
    inst._zod.parse = (payload, ctx)=>{
        const inner = inst._zod.innerType;
        return inner._zod.run(payload, ctx);
    };
});
const $e32a9d04eaeb9d0c$export$3a5d0e5e098b79ba = /*@__PURE__*/ $5SN0M.$constructor("$ZodCustom", (inst, def)=>{
    $ggkLI.$ZodCheck.init(inst, def);
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _)=>{
        return payload;
    };
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const r = def.fn(input);
        if (r instanceof Promise) return r.then((r)=>$e32a9d04eaeb9d0c$var$handleRefineResult(r, payload, input, inst));
        $e32a9d04eaeb9d0c$var$handleRefineResult(r, payload, input, inst);
        return;
    };
});
function $e32a9d04eaeb9d0c$var$handleRefineResult(result, payload, input, inst) {
    if (!result) {
        const _iss = {
            code: "custom",
            input: input,
            inst: inst,
            path: [
                ...inst._zod.def.path ?? []
            ],
            continue: !inst._zod.def.abort
        };
        if (inst._zod.def.params) _iss.params = inst._zod.def.params;
        payload.issues.push($23ixW.issue(_iss));
    }
}
// asserts in place: the child result's value is discarded, matching z.property(), because a nested object or array schema rebuilds its output even when nothing transformed
function $e32a9d04eaeb9d0c$var$handlePropertiesResult(result, payload, key) {
    if (result.issues.length) payload.issues.push(...$23ixW.prefixIssues(key, result.issues));
}
const $e32a9d04eaeb9d0c$export$8fb7482084c5d413 = /*@__PURE__*/ $5SN0M.$constructor("$ZodProperties", (inst, def)=>{
    // $ZodType.init prepends an instance that already carries the $ZodCheck trait to its own `checks`, which would run the shape a second time and cost the parse context. Initializing the check trait after it keeps the schema role in `parse`, where the context arrives.
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $ggkLI.$ZodCheck.init(inst, def);
    const memo = $5SN0M.globalConfig.memoizer;
    memo?.attach(inst);
    // key and schema snapshotted together: reading one live and the other cached lets a later mutation of the caller's shape object pair a stale key with a missing schema
    let entries;
    const runShape = (payload, ctx)=>{
        entries ?? (entries = Reflect.ownKeys(def.shape).map((key)=>[
                key,
                def.shape[key]
            ]));
        const input = payload.value;
        let proms;
        for (const [key, schema] of entries){
            const result = schema._zod.run({
                value: input[key],
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                proms ?? (proms = []);
                proms.push(result.then((result)=>$e32a9d04eaeb9d0c$var$handlePropertiesResult(result, payload, key)));
            } else $e32a9d04eaeb9d0c$var$handlePropertiesResult(result, payload, key);
        }
        if (proms) return Promise.all(proms).then(()=>undefined);
        return undefined;
    };
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        // as a schema this is the type gate, and it infers an object shape, so a primitive is a type error. A function passes: its properties read like any other object's, and z.instanceof allows one.
        if (input === null || typeof input !== "object" && typeof input !== "function") {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        // both sides declare the shape's input type, so the assertion runs forward in either direction; encoding the children backward would reject the very type this schema claims to take
        if (ctx.direction === "backward") ctx = {
            ...ctx,
            direction: "forward"
        };
        // the input is its own output here, so it registers as its own memo entry: a cycle re-entering this node hits the bucket instead of recursing forever
        if (memo) memo.alloc(inst, payload, input, ctx);
        const result = runShape(payload, ctx);
        return result instanceof Promise ? result.then(()=>payload) : payload;
    };
    // as a check the base schema already typed the value, so this only asserts the properties — which read on a primitive too, matching z.property() on a string's length. It gets no context of its own, so a cycle through a spread schema is not tracked.
    inst._zod.check = (payload)=>{
        if (payload.value == null) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: payload.value,
                inst: inst
            });
            return undefined;
        }
        return runShape(payload, {});
    };
}, {
    *[Symbol.iterator] () {
        yield this;
    }
});

});
parcelRegister("knYnh", function(module, exports) {

$parcel$export(module.exports, "Doc", () => $ed74c9c3a820a125$export$bceacc74c2212615);
class $ed74c9c3a820a125$export$bceacc74c2212615 {
    constructor(args = [], closed = {}){
        this.content = [];
        this.indent = 0;
        this.args = args;
        this.closed = closed;
    }
    // the compiler catches a child's throw and keeps writing into this doc, so the indent has to unwind with it
    indented(fn) {
        this.indent += 1;
        try {
            fn(this);
        } finally{
            this.indent -= 1;
        }
    }
    write(arg) {
        if (typeof arg === "function") {
            arg(this, {
                execution: "sync"
            });
            arg(this, {
                execution: "async"
            });
            return;
        }
        const content = arg;
        const lines = content.split("\n").filter((x)=>x);
        const minIndent = Math.min(...lines.map((x)=>x.length - x.trimStart().length));
        const dedented = lines.map((x)=>x.slice(minIndent)).map((x)=>" ".repeat(this.indent * 2) + x);
        for (const line of dedented)this.content.push(line);
    }
    compile() {
        const F = Function;
        const content = this?.content ?? [
            ``
        ];
        const factory = new F(...Object.keys(this.closed), `return function (${this.args.join(", ")}) {\n${content.join("\n")}\n};`);
        return factory(...Object.values(this.closed));
    }
}

});

parcelRegister("57W0y", function(module, exports) {

$parcel$export(module.exports, "_parse", () => $3bba9a623c1bec43$export$dcd1bb9991b57edf);
$parcel$export(module.exports, "parse", () => $3bba9a623c1bec43$export$98e6a39c04603d36);
$parcel$export(module.exports, "_parseAsync", () => $3bba9a623c1bec43$export$1fcca22dc6c780d0);
$parcel$export(module.exports, "parseAsync", () => $3bba9a623c1bec43$export$59b6f938fbf579e3);
$parcel$export(module.exports, "_safeParse", () => $3bba9a623c1bec43$export$5ec32605bf51e98e);
$parcel$export(module.exports, "_safeParseAsync", () => $3bba9a623c1bec43$export$c08c7322f5625faf);
$parcel$export(module.exports, "validate", () => $3bba9a623c1bec43$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "validateAsync", () => $3bba9a623c1bec43$export$ec9e0a98ddb8e655);
$parcel$export(module.exports, "_encode", () => $3bba9a623c1bec43$export$50e4445ccc10715b);
$parcel$export(module.exports, "_decode", () => $3bba9a623c1bec43$export$bb4a21772f43c982);
$parcel$export(module.exports, "_encodeAsync", () => $3bba9a623c1bec43$export$9954740a1a5eaaf1);
$parcel$export(module.exports, "_decodeAsync", () => $3bba9a623c1bec43$export$74b09e12c8956d91);
$parcel$export(module.exports, "_safeEncode", () => $3bba9a623c1bec43$export$6d688d774257f486);
$parcel$export(module.exports, "_safeDecode", () => $3bba9a623c1bec43$export$b2ef531a734faad5);
$parcel$export(module.exports, "_safeEncodeAsync", () => $3bba9a623c1bec43$export$fa2ac180d22758d6);
$parcel$export(module.exports, "_safeDecodeAsync", () => $3bba9a623c1bec43$export$f66d2b402dc6318c);

var $5SN0M = parcelRequire("5SN0M");

var $YNwBR = parcelRequire("YNwBR");

var $23ixW = parcelRequire("23ixW");
// Always both keys, so the `_params` read site in `_parse` sees one object shape rather than two.
function $3bba9a623c1bec43$var$finalizeParams(callee, params) {
    return {
        callee: params?.callee ?? callee,
        Err: params?.Err
    };
}
const $3bba9a623c1bec43$export$dcd1bb9991b57edf = (_Err)=>{
    const fn = (schema, value, _ctx, _params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: false
        } : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $5SN0M.$ZodAsyncError();
        if (result.issues.length) {
            const e1 = new (_params?.Err ?? _Err)(result.issues.map((iss)=>$23ixW.finalizeIssue(iss, ctx, $5SN0M.config())));
            $23ixW.captureStackTrace(e1, _params?.callee ?? fn);
            throw e1;
        }
        return result.value;
    };
    return fn;
};
const $3bba9a623c1bec43$export$98e6a39c04603d36 = /* @__PURE__*/ $3bba9a623c1bec43$export$dcd1bb9991b57edf($YNwBR.$ZodRealError);
const $3bba9a623c1bec43$export$1fcca22dc6c780d0 = (_Err)=>{
    const fn = async (schema, value, _ctx, params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: true
        } : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        if (result.issues.length) {
            const e1 = new (params?.Err ?? _Err)(result.issues.map((iss)=>$23ixW.finalizeIssue(iss, ctx, $5SN0M.config())));
            $23ixW.captureStackTrace(e1, params?.callee ?? fn);
            throw e1;
        }
        return result.value;
    };
    return fn;
};
const $3bba9a623c1bec43$export$59b6f938fbf579e3 = /* @__PURE__*/ $3bba9a623c1bec43$export$1fcca22dc6c780d0($YNwBR.$ZodRealError);
const $3bba9a623c1bec43$export$5ec32605bf51e98e = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: false
        } : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $5SN0M.$ZodAsyncError();
        return result.issues.length ? $3bba9a623c1bec43$var$failure(_Err, result.issues, ctx) : {
            success: true,
            data: result.value
        };
    };
const $3bba9a623c1bec43$export$b48ee232557adc37 = /* @__PURE__*/ $3bba9a623c1bec43$export$5ec32605bf51e98e($YNwBR.$ZodRealError);
// the error is built on the first read of `error`: finalizing the issues and constructing the instance is most of a failing parse, and a caller that only branches on `success` never pays it. a getter in the literal keeps this small; the alternative, one shared accessor descriptor plus a hidden state slot, reads ~15% faster but costs ~75 B gzipped in every bundle
function $3bba9a623c1bec43$var$failure(Err, issues, ctx) {
    let error;
    return {
        success: false,
        get error () {
            if (!error) {
                error = new Err(issues.map((iss)=>$23ixW.finalizeIssue(iss, ctx, $5SN0M.config())));
                // finalizeIssue drops `input`, so the built error holds nothing; keeping the raw issues past this point pins the parsed value for the life of the result
                issues = undefined;
                ctx = undefined;
            }
            return error;
        },
        set error (e){
            error = e;
            // a replacement makes the getter's branch unreachable, so the captures have to go here too
            issues = undefined;
            ctx = undefined;
        }
    };
}
const $3bba9a623c1bec43$export$c08c7322f5625faf = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: true
        } : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        return result.issues.length ? $3bba9a623c1bec43$var$failure(_Err, result.issues, ctx) : {
            success: true,
            data: result.value
        };
    };
const $3bba9a623c1bec43$export$9b07b0d6e0389261 = /* @__PURE__*/ $3bba9a623c1bec43$export$c08c7322f5625faf($YNwBR.$ZodRealError);
// registry mirrors of the compiler's sentinels, so this module never imports the compiler
const $3bba9a623c1bec43$var$COMPILE_INVALID = /* @__PURE__ */ Symbol.for("zod.compile.invalid");
const $3bba9a623c1bec43$var$COMPILE_FALLBACK = /* @__PURE__ */ Symbol.for("zod.compile.fallback");
const $3bba9a623c1bec43$export$a22775fa5e2eebd9 = (schema, value, _ctx)=>{
    const validator = schema._zod.bag.validator;
    if (validator !== undefined) {
        if (validator(value) !== $3bba9a623c1bec43$var$COMPILE_INVALID) return true;
        // a definite sentinel means the runtime would reject, so skip the re-parse; a ctx can still change the answer
        if (validator.definite === true && _ctx === undefined) return false;
    }
    return $3bba9a623c1bec43$var$validateFallback(schema, value, _ctx);
};
function $3bba9a623c1bec43$var$validateFallback(schema, value, _ctx) {
    const ctx = _ctx ? {
        ..._ctx,
        async: false,
        abortEarly: true
    } : {
        async: false,
        abortEarly: true
    };
    const fallbackRun = schema._zod.bag.fallbackRun;
    let result;
    if (fallbackRun) {
        // skip nested fast paths on the fallback, so user callbacks keep the at-most-twice bound
        ctx[$3bba9a623c1bec43$var$COMPILE_FALLBACK] = true;
        result = fallbackRun({
            value: value,
            issues: []
        }, ctx);
    } else result = schema._zod.run({
        value: value,
        issues: []
    }, ctx);
    if (result instanceof Promise) throw new $5SN0M.$ZodAsyncError();
    return result.issues.length === 0;
}
const $3bba9a623c1bec43$export$ec9e0a98ddb8e655 = async (schema, value, _ctx)=>{
    const ctx = _ctx ? {
        ..._ctx,
        async: true,
        abortEarly: true
    } : {
        async: true,
        abortEarly: true
    };
    let result = schema._zod.run({
        value: value,
        issues: []
    }, ctx);
    if (result instanceof Promise) result = await result;
    return result.issues.length === 0;
};
const $3bba9a623c1bec43$export$50e4445ccc10715b = (_Err)=>{
    const parse = $3bba9a623c1bec43$export$dcd1bb9991b57edf(_Err);
    const fn = (schema, value, _ctx, _params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return parse(schema, value, ctx, $3bba9a623c1bec43$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $3bba9a623c1bec43$export$c564cdbbe6da493 = /* @__PURE__*/ $3bba9a623c1bec43$export$50e4445ccc10715b($YNwBR.$ZodRealError);
const $3bba9a623c1bec43$export$bb4a21772f43c982 = (_Err)=>{
    const parse = $3bba9a623c1bec43$export$dcd1bb9991b57edf(_Err);
    const fn = (schema, value, _ctx, _params)=>{
        return parse(schema, value, _ctx, $3bba9a623c1bec43$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $3bba9a623c1bec43$export$2f872c0f2117be69 = /* @__PURE__*/ $3bba9a623c1bec43$export$bb4a21772f43c982($YNwBR.$ZodRealError);
const $3bba9a623c1bec43$export$9954740a1a5eaaf1 = (_Err)=>{
    const parseAsync = $3bba9a623c1bec43$export$1fcca22dc6c780d0(_Err);
    const fn = async (schema, value, _ctx, _params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return await parseAsync(schema, value, ctx, $3bba9a623c1bec43$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $3bba9a623c1bec43$export$1a62660bbffb8f11 = /* @__PURE__*/ $3bba9a623c1bec43$export$9954740a1a5eaaf1($YNwBR.$ZodRealError);
const $3bba9a623c1bec43$export$74b09e12c8956d91 = (_Err)=>{
    const parseAsync = $3bba9a623c1bec43$export$1fcca22dc6c780d0(_Err);
    const fn = async (schema, value, _ctx, _params)=>{
        return await parseAsync(schema, value, _ctx, $3bba9a623c1bec43$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $3bba9a623c1bec43$export$e4c183687a6ff9b = /* @__PURE__*/ $3bba9a623c1bec43$export$74b09e12c8956d91($YNwBR.$ZodRealError);
const $3bba9a623c1bec43$export$6d688d774257f486 = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return $3bba9a623c1bec43$export$5ec32605bf51e98e(_Err)(schema, value, ctx);
    };
const $3bba9a623c1bec43$export$c094f85f253e4d7d = /* @__PURE__*/ $3bba9a623c1bec43$export$6d688d774257f486($YNwBR.$ZodRealError);
const $3bba9a623c1bec43$export$b2ef531a734faad5 = (_Err)=>(schema, value, _ctx)=>{
        return $3bba9a623c1bec43$export$5ec32605bf51e98e(_Err)(schema, value, _ctx);
    };
const $3bba9a623c1bec43$export$7a47376c130cfeac = /* @__PURE__*/ $3bba9a623c1bec43$export$b2ef531a734faad5($YNwBR.$ZodRealError);
const $3bba9a623c1bec43$export$fa2ac180d22758d6 = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return $3bba9a623c1bec43$export$c08c7322f5625faf(_Err)(schema, value, ctx);
    };
const $3bba9a623c1bec43$export$ed163a34170fecc5 = /* @__PURE__*/ $3bba9a623c1bec43$export$fa2ac180d22758d6($YNwBR.$ZodRealError);
const $3bba9a623c1bec43$export$f66d2b402dc6318c = (_Err)=>async (schema, value, _ctx)=>{
        return $3bba9a623c1bec43$export$c08c7322f5625faf(_Err)(schema, value, _ctx);
    };
const $3bba9a623c1bec43$export$9f879005292a9bc9 = /* @__PURE__*/ $3bba9a623c1bec43$export$f66d2b402dc6318c($YNwBR.$ZodRealError);

});
parcelRegister("YNwBR", function(module, exports) {

$parcel$export(module.exports, "$ZodError", () => $0b6c05566f4aeada$export$544878318730b1d8);
$parcel$export(module.exports, "$ZodRealError", () => $0b6c05566f4aeada$export$4e07b515db2f7672);
$parcel$export(module.exports, "flattenError", () => $0b6c05566f4aeada$export$4d7e0dfd5ca8366f);
$parcel$export(module.exports, "formatError", () => $0b6c05566f4aeada$export$7b5b869ee98c16ab);

var $5SN0M = parcelRequire("5SN0M");

var $23ixW = parcelRequire("23ixW");
/* Computing the message eagerly is expensive (pretty-printed JSON of all
 * issues), so defer it until first read. The accessor functions and
 * descriptors are shared across instances to keep error construction
 * cheap; the computed message is cached on the internals object. The
 * setter preserves plain assignment semantics for consumers that
 * overwrite `message`. */ function $0b6c05566f4aeada$var$_getMessage() {
    const internals = this._zod;
    internals.message ?? (internals.message = JSON.stringify(internals.def, $23ixW.jsonStringifyReplacer, 2));
    return internals.message;
}
function $0b6c05566f4aeada$var$_setMessage(value) {
    this._zod.message = value;
}
const $0b6c05566f4aeada$var$_messageDesc = {
    get: $0b6c05566f4aeada$var$_getMessage,
    set: $0b6c05566f4aeada$var$_setMessage,
    enumerable: true,
    configurable: true
};
const $0b6c05566f4aeada$var$_issuesDesc = {
    value: undefined,
    enumerable: false
};
/* Prototypes that already carry the lazy `toString`. Seeded with the
 * intrinsics so that `init` on a foreign object — it accepts any object —
 * can never install an accessor onto a prototype we do not own. */ const $0b6c05566f4aeada$var$_installedToString = /* @__PURE__ */ new WeakSet([
    Object.prototype,
    Error.prototype
]);
const $0b6c05566f4aeada$var$initializer = (inst, def)=>{
    inst.name = "$ZodError";
    // `_zod` is already non-enumerable: $constructor's init defined it with this same descriptor
    $0b6c05566f4aeada$var$_issuesDesc.value = def;
    Object.defineProperty(inst, "issues", $0b6c05566f4aeada$var$_issuesDesc);
    // Clear the shared slot; a retained `value` pins the last error's issues.
    $0b6c05566f4aeada$var$_issuesDesc.value = undefined;
    Object.defineProperty(inst, "message", $0b6c05566f4aeada$var$_messageDesc);
    /* `toString` lives as a non-enumerable lazy getter on the shared
     * prototype; on first access it caches a per-instance closure so
     * detached usage still works. */ const proto = Object.getPrototypeOf(inst);
    if (!$0b6c05566f4aeada$var$_installedToString.has(proto)) {
        $0b6c05566f4aeada$var$_installedToString.add(proto);
        Object.defineProperty(proto, "toString", {
            configurable: true,
            enumerable: false,
            get () {
                const value = ()=>this.message;
                Object.defineProperty(this, "toString", {
                    value: value,
                    configurable: true,
                    writable: true
                });
                return value;
            },
            set (value) {
                Object.defineProperty(this, "toString", {
                    value: value,
                    configurable: true,
                    writable: true
                });
            }
        });
    }
};
const $0b6c05566f4aeada$export$544878318730b1d8 = (0, $5SN0M.$constructor)("$ZodError", $0b6c05566f4aeada$var$initializer);
const $0b6c05566f4aeada$export$4e07b515db2f7672 = (0, $5SN0M.$constructor)("$ZodError", $0b6c05566f4aeada$var$initializer, undefined, {
    Parent: Error
});
/** Get-or-create `obj[key]` as an own data property. A path segment naming an inherited member
 * ("toString", "constructor") would otherwise read through to the prototype, and assigning
 * "__proto__" would hit the setter instead of creating a key. */ function $0b6c05566f4aeada$var$node(obj, key, make) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
        if (key === "__proto__") Object.defineProperty(obj, key, {
            value: make(),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else obj[key] = make();
    }
    return obj[key];
}
function $0b6c05566f4aeada$export$4d7e0dfd5ca8366f(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of error.issues)if (sub.path.length > 0) $0b6c05566f4aeada$var$node(fieldErrors, sub.path[0], ()=>[]).push(mapper(sub));
    else formErrors.push(mapper(sub));
    return {
        formErrors: formErrors,
        fieldErrors: fieldErrors
    };
}
function $0b6c05566f4aeada$export$7b5b869ee98c16ab(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {
        _errors: []
    };
    const processError = (error, path = [])=>{
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) issue.errors.map((issues)=>processError({
                    issues: issues
                }, [
                    ...path,
                    ...issue.path
                ]));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else {
                const fullpath = [
                    ...path,
                    ...issue.path
                ];
                if (fullpath.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < fullpath.length){
                        const el = fullpath[i];
                        const terminal = i === fullpath.length - 1;
                        // `_errors` is reserved by this legacy format, so merge a matching path segment into the current node instead of treating its array as a child.
                        if (el === "_errors") {
                            if (terminal) curr._errors.push(mapper(issue));
                            i++;
                            continue;
                        }
                        // A path element may collide with an inherited property name such as
                        // "__proto__" or "constructor". Truthiness checks read the prototype
                        // (so no node is created, then ._errors.push throws), and bracket
                        // assignment of "__proto__" hits the setter instead of creating an
                        // own key. Guard the read with hasOwnProperty and create the node
                        // with defineProperty so any path element becomes a real own key.
                        if (!Object.prototype.hasOwnProperty.call(curr, el)) Object.defineProperty(curr, el, {
                            value: {
                                _errors: []
                            },
                            enumerable: true,
                            writable: true,
                            configurable: true
                        });
                        const node = curr[el];
                        if (terminal) node._errors.push(mapper(issue));
                        curr = node;
                        i++;
                    }
                }
            }
        }
    };
    processError(error);
    return fieldErrors;
}
function $0b6c05566f4aeada$export$93701dc89257de2f(error, mapper = (issue)=>issue.message) {
    const result = {
        errors: []
    };
    const processError = (error, path = [])=>{
        var _a;
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) // regular union error
            issue.errors.map((issues)=>processError({
                    issues: issues
                }, [
                    ...path,
                    ...issue.path
                ]));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else {
                const fullpath = [
                    ...path,
                    ...issue.path
                ];
                if (fullpath.length === 0) {
                    result.errors.push(mapper(issue));
                    continue;
                }
                let curr = result;
                let i = 0;
                while(i < fullpath.length){
                    const el = fullpath[i];
                    const terminal = i === fullpath.length - 1;
                    if (typeof el === "string") {
                        curr.properties ?? (curr.properties = {});
                        // el may collide with an inherited property name ("__proto__",
                        // "constructor", ...); ??= reads the prototype so the node is never
                        // created and curr.errors.push throws. Guard with hasOwnProperty and
                        // create the node with defineProperty so "__proto__" becomes a real
                        // own key rather than invoking the prototype setter.
                        if (!Object.prototype.hasOwnProperty.call(curr.properties, el)) Object.defineProperty(curr.properties, el, {
                            value: {
                                errors: []
                            },
                            enumerable: true,
                            writable: true,
                            configurable: true
                        });
                        curr = curr.properties[el];
                    } else {
                        curr.items ?? (curr.items = []);
                        (_a = curr.items)[el] ?? (_a[el] = {
                            errors: []
                        });
                        curr = curr.items[el];
                    }
                    if (terminal) curr.errors.push(mapper(issue));
                    i++;
                }
            }
        }
    };
    processError(error);
    return result;
}
function $0b6c05566f4aeada$export$47768e8997ceb13a(_path) {
    const segs = [];
    const path = _path.map((seg)=>typeof seg === "object" ? seg.key : seg);
    for (const seg of path){
        if (typeof seg === "number") segs.push(`[${seg}]`);
        else if (typeof seg === "symbol") segs.push(`[${JSON.stringify(String(seg))}]`);
        else if (/[^\w$]/.test(seg)) segs.push(`[${JSON.stringify(seg)}]`);
        else {
            if (segs.length) segs.push(".");
            segs.push(seg);
        }
    }
    return segs.join("");
}
function $0b6c05566f4aeada$export$44eaaa72d914fe8c(error) {
    const lines = [];
    // sort by path length
    const issues = [
        ...error.issues
    ].sort((a, b)=>(a.path ?? []).length - (b.path ?? []).length);
    // Process each issue
    for (const issue of issues){
        lines.push(`\u{2716} ${issue.message}`);
        if (issue.path?.length) lines.push(`  \u{2192} at ${$0b6c05566f4aeada$export$47768e8997ceb13a(issue.path)}`);
    }
    // Convert Map to formatted string
    return lines.join("\n");
}

});


parcelRegister("hqqad", function(module, exports) {

$parcel$export(module.exports, "version", () => $caf928fb0a91b5fd$export$83d89fbfd8236492);
const $caf928fb0a91b5fd$export$83d89fbfd8236492 = {
    major: 4,
    minor: 6,
    patch: 2
};

});



parcelRegister("g96lk", function(module, exports) {

$parcel$export(module.exports, "memoizer", () => $bc126832b02bd69f$export$17ac4b5c50355589);

var $23ixW = parcelRequire("23ixW");
class $bc126832b02bd69f$export$a41a050c6c386536 extends Error {
    constructor(){
        super(`Cannot parse a reference cycle that closes through a transform`);
        this.name = "ZodCyclicError";
    }
}
/** Keyed off the context object every schema in one parse call already shares. */ const $bc126832b02bd69f$var$STATE = "~memo";
const $bc126832b02bd69f$var$NO_ISSUES = [];
// a value a cycle can close through; callables count, since z.properties asserts on one
function $bc126832b02bd69f$var$isRef(value) {
    return value !== null && (typeof value === "object" || typeof value === "function");
}
// Receivers prefix paths in place, so the cache and every hand-out need their own copies.
function $bc126832b02bd69f$var$cloneIssues(issues) {
    return issues.map((iss)=>iss.path ? {
            ...iss,
            path: iss.path.slice()
        } : {
            ...iss
        });
}
const $bc126832b02bd69f$var$recursive = /*@__PURE__*/ new WeakMap();
/** What the walk established, in order of certainty: ordered so the strongest answer among children wins. */ const $bc126832b02bd69f$var$NONE = 0;
const $bc126832b02bd69f$var$ASSUMED = 1;
const $bc126832b02bd69f$var$PROVEN = 2;
/** Whether this schema's subtree contains a cycle, so one parse can re-enter it. */ function $bc126832b02bd69f$var$isRecursive(inst, stack, resolve) {
    const cached = $bc126832b02bd69f$var$recursive.get(inst);
    if (cached !== undefined) return cached ? $bc126832b02bd69f$var$PROVEN : $bc126832b02bd69f$var$NONE;
    // Relative to the walk in progress, so not cached.
    if (stack.has(inst)) return $bc126832b02bd69f$var$PROVEN;
    stack.add(inst);
    let result = $bc126832b02bd69f$var$NONE;
    const check = (child)=>{
        if (result !== $bc126832b02bd69f$var$PROVEN && child?._zod) {
            const answer = $bc126832b02bd69f$var$isRecursive(child, stack, resolve);
            if (answer > result) result = answer;
        }
    };
    // `Reflect.ownKeys` rather than `Object.keys`, so a cycle through a declared symbol key is still seen
    const shape = (sh, spread)=>{
        let answer = $bc126832b02bd69f$var$NONE;
        for (const key of Reflect.ownKeys(sh)){
            const desc = Object.getOwnPropertyDescriptor(sh, key);
            // an object resolves its shape by spread, so a key it does not enumerate is never parsed; `z.properties` reads every own key and so keeps them all
            if (spread && !desc.enumerable) continue;
            // resolving runs user code, and a factory mints a fresh subtree per read, so an edge the walk can't follow counts as a cycle
            const child = desc.get ? $bc126832b02bd69f$var$ASSUMED : desc.value?._zod ? $bc126832b02bd69f$var$isRecursive(desc.value, stack, resolve) : $bc126832b02bd69f$var$NONE;
            if (child > answer) answer = child;
        }
        return answer;
    };
    const merge = (answer)=>{
        if (answer > result) result = answer;
    };
    const def = inst._zod.def;
    const kind = def.type;
    switch(kind){
        case "object":
            {
                const raw = $23ixW.rawShape(def);
                // a def with no raw shape answers `shape` from an accessor of its own, and running that can mint a whole fresh subtree
                merge(raw ? shape(raw, true) : $bc126832b02bd69f$var$ASSUMED);
                check(def.catchall);
                break;
            }
        case "properties":
            merge(shape(def.shape, false));
            break;
        case "array":
            check(def.element);
            break;
        case "tuple":
            for (const el of def.items)check(el);
            check(def.rest);
            break;
        case "record":
        case "map":
            check(def.keyType);
            check(def.valueType);
            break;
        case "set":
            check(def.valueType);
            break;
        case "union":
            for (const el of def.options)check(el);
            break;
        case "intersection":
            check(def.left);
            check(def.right);
            break;
        case "optional":
        case "nullable":
        case "default":
        case "prefault":
        case "catch":
        case "readonly":
        case "nonoptional":
        case "promise":
        case "success":
            check(def.innerType);
            break;
        case "pipe":
            check(def.in);
            check(def.out);
            break;
        case "function":
            check(def.input);
            check(def.output);
            break;
        // `$ZodLazy` caches its inner on the def, so a resolved edge is followed exactly
        case "lazy":
            {
                const inner = def._cachedInner ?? (resolve ? inst._zod.innerType : undefined);
                // walked with resolution off: one hop sees past the deferral, and a lazy that yields only another unresolved lazy is generative, so it stops there
                merge(inner ? $bc126832b02bd69f$var$isRecursive(inner, stack, false) : $bc126832b02bd69f$var$ASSUMED);
                break;
            }
        // a leaf by choice: `parts` are regex fragments, not data positions
        case "template_literal":
        // leaves
        case "string":
        case "number":
        case "int":
        case "boolean":
        case "bigint":
        case "symbol":
        case "undefined":
        case "null":
        case "void":
        case "never":
        case "any":
        case "unknown":
        case "date":
        case "nan":
        case "enum":
        case "literal":
        case "file":
        case "transform":
        case "custom":
            break;
        default:
            // a new built-in kind becomes a compile error here
            kind;
            // a user-defined kind can still hold children, and only its author knows where, so fall back to scanning the def — skipping accessors, since reading one can run user code
            for(const key in def){
                const desc = Object.getOwnPropertyDescriptor(def, key);
                if (!desc || desc.get) continue;
                const value = desc.value;
                if (!value || typeof value !== "object") continue;
                if (value._zod) check(value);
                else if (Array.isArray(value)) for (const el of value)check(el);
            }
    }
    stack.delete(inst);
    return $bc126832b02bd69f$var$settle(inst, result);
}
/** An assumed answer must not outlive the resolution that settles it, so only a certain one is cached. */ function $bc126832b02bd69f$var$settle(inst, answer) {
    if (answer !== $bc126832b02bd69f$var$ASSUMED) $bc126832b02bd69f$var$recursive.set(inst, answer === $bc126832b02bd69f$var$PROVEN);
    return answer;
}
function $bc126832b02bd69f$export$2cdda7da3ed37816(inst) {
    // z.compile never parses, so nothing would ever resolve a lazy for it; it runs once and already treats a throw here as recursive
    return $bc126832b02bd69f$var$isRecursive(inst, new Set(), true) !== $bc126832b02bd69f$var$NONE;
}
function $bc126832b02bd69f$var$bucketFor(state, inst) {
    let bucket = state.buckets.get(inst);
    if (!bucket) {
        bucket = new WeakMap();
        state.buckets.set(inst, bucket);
    }
    return bucket;
}
// Set immediately before delegating to core and cleared immediately after, so `alloc` registers only for a visit this module is driving.
let $bc126832b02bd69f$var$handoff;
// Allocated but unfinished entries. `alloc` and the matching pop both happen in the synchronous part of a parse, so they nest even when children are async, and one stack serves every schema.
const $bc126832b02bd69f$var$open = [];
const $bc126832b02bd69f$var$memo = {
    alloc (_inst, payload, empty) {
        const bucket = $bc126832b02bd69f$var$handoff;
        if (!bucket) return empty;
        $bc126832b02bd69f$var$handoff = undefined;
        const entry = {
            value: empty,
            issues: null
        };
        bucket.set(payload.value, entry);
        $bc126832b02bd69f$var$open.push(entry);
        return empty;
    },
    guard (inst) {
        var _a;
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred.push(()=>{
            const base = inst._zod.parse;
            const wrapped = (payload, ctx)=>{
                // The value is a placeholder a back-edge is still waiting on, so the cycle closes through this transform. Its output can't exist in time to bind.
                if (ctx.direction !== "backward" && $bc126832b02bd69f$export$2832d97103138047(ctx, payload.value)) throw new $bc126832b02bd69f$export$a41a050c6c386536();
                return base(payload, ctx);
            };
            inst._zod.parse = wrapped;
            if (inst._zod.run === base) inst._zod.run = wrapped;
        });
    },
    attach (inst) {
        var _a;
        let isRecursiveInst;
        let rechecked = false;
        // a recursive schema is re-entered many times per parse and its bucket never changes
        let lastCtx;
        let lastBucket;
        // Wraps `parse` in a deferred so it sees the container's final parse. Core's own deferred copies `parse` into `run` when there are no checks, and it ran first, so `run` is patched to match; with checks, `run` reads `parse` dynamically.
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred.push(()=>{
            const base = inst._zod.parse;
            const wrapped = (payload, ctx)=>{
                if (isRecursiveInst === undefined) {
                    const walked = $bc126832b02bd69f$var$isRecursive(inst, new Set(), false);
                    if (walked === $bc126832b02bd69f$var$NONE) {
                        // Nothing here can ever fire, so take it back out.
                        inst._zod.parse = base;
                        if (inst._zod.run === wrapped) inst._zod.run = base;
                        return base(payload, ctx);
                    }
                    // this parse resolves the deferred edges on its own path, so ask once more before latching
                    if (walked === $bc126832b02bd69f$var$PROVEN || rechecked) isRecursiveInst = true;
                    else rechecked = true;
                }
                const input = payload.value;
                if (!$bc126832b02bd69f$var$isRef(input)) return base(payload, ctx);
                let state = ctx[$bc126832b02bd69f$var$STATE];
                if (!state) {
                    state = {
                        buckets: new WeakMap(),
                        backEdges: undefined
                    };
                    ctx[$bc126832b02bd69f$var$STATE] = state;
                }
                let bucket;
                if (lastCtx === ctx) bucket = lastBucket;
                else {
                    bucket = $bc126832b02bd69f$var$bucketFor(state, inst);
                    lastCtx = ctx;
                    lastBucket = bucket;
                }
                const hit = bucket.get(input);
                if (hit) {
                    payload.value = hit.value;
                    if (hit.issues) {
                        if (hit.issues.length) payload.issues.push(...$bc126832b02bd69f$var$cloneIssues(hit.issues));
                    } else {
                        // Still being parsed: its own checks cover it, so skip them here.
                        payload.memo = true;
                        state.backEdges ?? (state.backEdges = new WeakSet());
                        state.backEdges.add(hit.value);
                    }
                    return payload;
                }
                $bc126832b02bd69f$var$handoff = bucket;
                const depth = $bc126832b02bd69f$var$open.length;
                const result = base(payload, ctx);
                $bc126832b02bd69f$var$handoff = undefined;
                // A container that rejected its input outright allocated nothing.
                const entry = $bc126832b02bd69f$var$open.length > depth ? $bc126832b02bd69f$var$open.pop() : undefined;
                // Both paths written out so the sync one allocates no closure. It runs once per node, and capturing here cost more than everything else combined.
                if (result instanceof Promise) return result.then((r)=>{
                    if (entry) entry.issues = r.issues.length ? $bc126832b02bd69f$var$cloneIssues(r.issues) : $bc126832b02bd69f$var$NO_ISSUES;
                    return r;
                });
                if (entry) entry.issues = result.issues.length ? $bc126832b02bd69f$var$cloneIssues(result.issues) : $bc126832b02bd69f$var$NO_ISSUES;
                return result;
            };
            inst._zod.parse = wrapped;
            if (inst._zod.run === base) inst._zod.run = wrapped;
        });
    }
};
function $bc126832b02bd69f$export$17ac4b5c50355589() {
    return $bc126832b02bd69f$var$memo;
}
function $bc126832b02bd69f$export$2832d97103138047(ctx, value) {
    const backEdges = ctx[$bc126832b02bd69f$var$STATE]?.backEdges;
    return backEdges !== undefined && $bc126832b02bd69f$var$isRef(value) && backEdges.has(value);
}

});

parcelRegister("lA7b0", function(module, exports) {

$parcel$export(module.exports, "aggregateChecks", () => $fb6286dd552db993$export$9329961b252a50ea);
$parcel$export(module.exports, "stringProcessor", () => $fb6286dd552db993$export$c6950985d9de996d);
$parcel$export(module.exports, "numberProcessor", () => $fb6286dd552db993$export$afd08f475b2e134f);
$parcel$export(module.exports, "booleanProcessor", () => $fb6286dd552db993$export$f03e9163a5233fc4);
$parcel$export(module.exports, "bigintProcessor", () => $fb6286dd552db993$export$8810d61ae56edc9c);
$parcel$export(module.exports, "symbolProcessor", () => $fb6286dd552db993$export$fd2b3c73524160ce);
$parcel$export(module.exports, "nullProcessor", () => $fb6286dd552db993$export$7667b76b86382b1f);
$parcel$export(module.exports, "undefinedProcessor", () => $fb6286dd552db993$export$9838a7ce212344b0);
$parcel$export(module.exports, "voidProcessor", () => $fb6286dd552db993$export$b5910bb267c78233);
$parcel$export(module.exports, "neverProcessor", () => $fb6286dd552db993$export$694b9cd80480ac33);
$parcel$export(module.exports, "anyProcessor", () => $fb6286dd552db993$export$a92de72ffd9087b5);
$parcel$export(module.exports, "unknownProcessor", () => $fb6286dd552db993$export$4e1fea7b2e7474f);
$parcel$export(module.exports, "dateProcessor", () => $fb6286dd552db993$export$d044e6246fe40d06);
$parcel$export(module.exports, "enumProcessor", () => $fb6286dd552db993$export$a0f7e3681bbe4f0b);
$parcel$export(module.exports, "literalProcessor", () => $fb6286dd552db993$export$b7a483a046d3a9b);
$parcel$export(module.exports, "nanProcessor", () => $fb6286dd552db993$export$f33d8739d51ecc4b);
$parcel$export(module.exports, "templateLiteralProcessor", () => $fb6286dd552db993$export$59812826ec9f1850);
$parcel$export(module.exports, "fileProcessor", () => $fb6286dd552db993$export$62de47a40c7b42b0);
$parcel$export(module.exports, "successProcessor", () => $fb6286dd552db993$export$1e296a49315ba27a);
$parcel$export(module.exports, "customProcessor", () => $fb6286dd552db993$export$fe3af043a76e4dab);
$parcel$export(module.exports, "functionProcessor", () => $fb6286dd552db993$export$654f185ba88226ab);
$parcel$export(module.exports, "transformProcessor", () => $fb6286dd552db993$export$707b17683f9c9ec0);
$parcel$export(module.exports, "mapProcessor", () => $fb6286dd552db993$export$5e912d1710885757);
$parcel$export(module.exports, "setProcessor", () => $fb6286dd552db993$export$2ff44e7a32269271);
$parcel$export(module.exports, "arrayProcessor", () => $fb6286dd552db993$export$afeff382d55f455b);
$parcel$export(module.exports, "objectProcessor", () => $fb6286dd552db993$export$8cc078cf99794668);
$parcel$export(module.exports, "unionProcessor", () => $fb6286dd552db993$export$f387dff1d8008b49);
$parcel$export(module.exports, "intersectionProcessor", () => $fb6286dd552db993$export$2a29f9128b7167c3);
$parcel$export(module.exports, "tupleProcessor", () => $fb6286dd552db993$export$7767a398545ac85c);
$parcel$export(module.exports, "recordProcessor", () => $fb6286dd552db993$export$6cf7a4b4a95ef1a8);
$parcel$export(module.exports, "nullableProcessor", () => $fb6286dd552db993$export$452ce6f96b49219a);
$parcel$export(module.exports, "nonoptionalProcessor", () => $fb6286dd552db993$export$7c6ac5b60b42bfc9);
$parcel$export(module.exports, "defaultProcessor", () => $fb6286dd552db993$export$f76e6c36e8fb062b);
$parcel$export(module.exports, "prefaultProcessor", () => $fb6286dd552db993$export$1ded4e432f286ac2);
$parcel$export(module.exports, "catchProcessor", () => $fb6286dd552db993$export$3f81793c903cb504);
$parcel$export(module.exports, "pipeProcessor", () => $fb6286dd552db993$export$3a3e6911d4012a24);
$parcel$export(module.exports, "readonlyProcessor", () => $fb6286dd552db993$export$dd90252c562e1d9);
$parcel$export(module.exports, "promiseProcessor", () => $fb6286dd552db993$export$ecb899a95fe4bdc0);
$parcel$export(module.exports, "optionalProcessor", () => $fb6286dd552db993$export$4b1db46aa3739c48);
$parcel$export(module.exports, "lazyProcessor", () => $fb6286dd552db993$export$9980155f320c317b);

var $dZBpt = parcelRequire("dZBpt");

var $jvcvr = parcelRequire("jvcvr");

var $jSi9q = parcelRequire("jSi9q");

var $23ixW = parcelRequire("23ixW");
const $fb6286dd552db993$var$narrowMin = (agg, key, value)=>{
    if (agg[key] === undefined || value > agg[key]) agg[key] = value;
};
const $fb6286dd552db993$var$narrowMax = (agg, key, value)=>{
    if (agg[key] === undefined || value < agg[key]) agg[key] = value;
};
const $fb6286dd552db993$var$narrowBoth = (agg, value)=>{
    $fb6286dd552db993$var$narrowMin(agg, "minimum", value);
    $fb6286dd552db993$var$narrowMax(agg, "maximum", value);
};
const $fb6286dd552db993$var$addDivisor = (agg, value)=>{
    agg.multipleOf ?? (agg.multipleOf = []);
    if (!agg.multipleOf.includes(value)) agg.multipleOf.push(value);
};
const $fb6286dd552db993$var$addPattern = (agg, pattern)=>{
    agg.patterns ?? (agg.patterns = new Set());
    agg.patterns.add(pattern);
};
const $fb6286dd552db993$var$intersectMime = (agg, mime)=>{
    agg.mime = agg.mime ? agg.mime.filter((m)=>mime.includes(m)) : [
        ...mime
    ];
};
// last-wins, matching the bag's historical write order; the flag keeps an integer format from being lost to a later float one
const $fb6286dd552db993$var$setFormat = (agg, format)=>{
    agg.format = format;
    if (format.includes("int")) agg.isInt = true;
};
const $fb6286dd552db993$var$minContributor = (agg, def)=>$fb6286dd552db993$var$narrowMin(agg, "minimum", def.minimum);
const $fb6286dd552db993$var$maxContributor = (agg, def)=>$fb6286dd552db993$var$narrowMax(agg, "maximum", def.maximum);
const $fb6286dd552db993$var$formatContributor = (ranges)=>(agg, def)=>{
        $fb6286dd552db993$var$setFormat(agg, def.format);
        const [minimum, maximum] = ranges[def.format];
        $fb6286dd552db993$var$narrowMin(agg, "minimum", minimum);
        $fb6286dd552db993$var$narrowMax(agg, "maximum", maximum);
    };
const $fb6286dd552db993$var$contributors = {
    greater_than: (agg, def)=>$fb6286dd552db993$var$narrowMin(agg, def.inclusive ? "minimum" : "exclusiveMinimum", def.value),
    less_than: (agg, def)=>$fb6286dd552db993$var$narrowMax(agg, def.inclusive ? "maximum" : "exclusiveMaximum", def.value),
    multiple_of: (agg, def)=>$fb6286dd552db993$var$addDivisor(agg, def.value),
    number_format: $fb6286dd552db993$var$formatContributor((0, $23ixW.NUMBER_FORMAT_RANGES)),
    bigint_format: $fb6286dd552db993$var$formatContributor((0, $23ixW.BIGINT_FORMAT_RANGES)),
    min_length: $fb6286dd552db993$var$minContributor,
    max_length: $fb6286dd552db993$var$maxContributor,
    length_equals: (agg, def)=>$fb6286dd552db993$var$narrowBoth(agg, def.length),
    min_size: $fb6286dd552db993$var$minContributor,
    max_size: $fb6286dd552db993$var$maxContributor,
    size_equals: (agg, def)=>$fb6286dd552db993$var$narrowBoth(agg, def.size),
    string_format: (agg, def)=>{
        $fb6286dd552db993$var$setFormat(agg, def.format);
        if (def.pattern) $fb6286dd552db993$var$addPattern(agg, def.pattern);
        if (def.format === "base64" || def.format === "base64url") agg.contentEncoding = def.format;
        if (def.local || def.precision === -1) agg.laxFormat = true;
    },
    mime_type: (agg, def)=>$fb6286dd552db993$var$intersectMime(agg, def.mime)
};
function $fb6286dd552db993$export$9329961b252a50ea(schema) {
    const agg = {};
    const def = schema._zod.def;
    // a format schema is its own first check, same rule as $ZodType init
    const list = schema._zod.traits.has("$ZodCheck") ? [
        schema,
        ...def.checks ?? []
    ] : def.checks ?? [];
    for (const ch of list)$fb6286dd552db993$var$contributors[ch._zod.def.check]?.(agg, ch._zod.def);
    // reconcile with the bag so third-party onattach contributions still land; first-party residue is never tighter than the fold, so merging it back is idempotent for one and additive for the other
    const bag = schema._zod.bag;
    if (bag.minimum !== undefined) $fb6286dd552db993$var$narrowMin(agg, "minimum", bag.minimum);
    if (bag.exclusiveMinimum !== undefined) $fb6286dd552db993$var$narrowMin(agg, "exclusiveMinimum", bag.exclusiveMinimum);
    if (bag.maximum !== undefined) $fb6286dd552db993$var$narrowMax(agg, "maximum", bag.maximum);
    if (bag.exclusiveMaximum !== undefined) $fb6286dd552db993$var$narrowMax(agg, "exclusiveMaximum", bag.exclusiveMaximum);
    if (bag.multipleOf !== undefined) $fb6286dd552db993$var$addDivisor(agg, bag.multipleOf);
    if (bag.format !== undefined) {
        agg.format ?? (agg.format = bag.format);
        if (bag.format.includes("int")) agg.isInt = true;
    }
    if (bag.mime) $fb6286dd552db993$var$intersectMime(agg, bag.mime);
    for (const pattern of bag.patterns ?? [])$fb6286dd552db993$var$addPattern(agg, pattern);
    return agg;
}
const $fb6286dd552db993$var$formatMap = {
    guid: "uuid",
    url: "uri",
    datetime: "date-time",
    json_string: "json-string",
    regex: ""
};
// ==================== SIMPLE TYPE PROCESSORS ====================
// the runtime patterns are lax so parse paths never overflow the regex stack; the emitted schema swaps in the exact block forms, which zod itself never executes
const $fb6286dd552db993$var$exactPatterns = new Map([
    [
        (0, $jvcvr.base64Charset),
        $dZBpt.base64
    ],
    [
        (0, $jvcvr.base64urlCharset),
        $dZBpt.base64url
    ]
]);
const $fb6286dd552db993$var$exactPattern = (p)=>$fb6286dd552db993$var$exactPatterns.get(p) ?? p;
const $fb6286dd552db993$export$c6950985d9de996d = (schema, ctx, _json, _params)=>{
    const json = _json;
    json.type = "string";
    const { minimum: minimum, maximum: maximum, format: format, patterns: patterns, contentEncoding: contentEncoding, laxFormat: laxFormat } = $fb6286dd552db993$export$9329961b252a50ea(schema);
    if (typeof minimum === "number") json.minLength = minimum;
    if (typeof maximum === "number") json.maxLength = maximum;
    // custom pattern overrides format
    if (format) {
        json.format = $fb6286dd552db993$var$formatMap[format] ?? format;
        if (json.format === "") delete json.format; // empty format is not valid
        // `z.iso.time()` is never full-time, and `laxFormat` carries the datetime shapes that also accept what their keyword forbids
        if (format === "time" || laxFormat) delete json.format;
    }
    if (contentEncoding) json.contentEncoding = contentEncoding;
    if (patterns && patterns.size > 0) {
        const patternList = [
            ...patterns
        ].map($fb6286dd552db993$var$exactPattern);
        if (patternList.length === 1) json.pattern = patternList[0].source;
        else if (patternList.length > 1) json.allOf = [
            ...patternList.map((regex)=>({
                    ...ctx.target === "draft-07" || ctx.target === "draft-04" || ctx.target === "openapi-3.0" ? {
                        type: "string"
                    } : {},
                    pattern: regex.source
                }))
        ];
    }
};
const $fb6286dd552db993$export$afd08f475b2e134f = (schema, ctx, _json, params)=>{
    const json = _json;
    const { minimum: minimum, maximum: maximum, multipleOf: multipleOf, exclusiveMaximum: exclusiveMaximum, exclusiveMinimum: exclusiveMinimum, isInt: isInt } = $fb6286dd552db993$export$9329961b252a50ea(schema);
    json.type = isInt ? "integer" : "number";
    // when both minimum and exclusiveMinimum exist, pick the more restrictive one
    const exMin = typeof exclusiveMinimum === "number" && exclusiveMinimum >= (minimum ?? Number.NEGATIVE_INFINITY);
    const exMax = typeof exclusiveMaximum === "number" && exclusiveMaximum <= (maximum ?? Number.POSITIVE_INFINITY);
    const legacy = ctx.target === "draft-04" || ctx.target === "openapi-3.0";
    if (exMin) {
        if (legacy) {
            json.minimum = exclusiveMinimum;
            json.exclusiveMinimum = true;
        } else json.exclusiveMinimum = exclusiveMinimum;
    } else if (typeof minimum === "number") json.minimum = minimum;
    if (exMax) {
        if (legacy) {
            json.maximum = exclusiveMaximum;
            json.exclusiveMaximum = true;
        } else json.exclusiveMaximum = exclusiveMaximum;
    } else if (typeof maximum === "number") json.maximum = maximum;
    if (multipleOf) {
        // JSON Schema requires a divisor strictly greater than zero, and a non-finite one does not survive JSON at all. A negative divisor accepts exactly what its absolute value accepts, so it still maps; zero, NaN and Infinity have no keyword form.
        const divisors = new Set();
        for (const divisor of multipleOf)if (Number.isFinite(divisor) && divisor !== 0) divisors.add(Math.abs(divisor));
        else (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, `A multipleOf divisor of ${divisor} cannot be represented in JSON Schema`);
        // chained divisors are a conjunction the keyword cannot carry alone, so extras ride an allOf, same as stacked patterns
        const [first, ...rest] = divisors;
        if (first !== undefined) json.multipleOf = first;
        if (rest.length) json.allOf = [
            ...json.allOf ?? [],
            ...rest.map((m)=>({
                    multipleOf: m
                }))
        ];
    }
};
const $fb6286dd552db993$export$f03e9163a5233fc4 = (_schema, _ctx, json, _params)=>{
    json.type = "boolean";
};
const $fb6286dd552db993$export$8810d61ae56edc9c = (schema, ctx, json, params)=>{
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "BigInt cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$fd2b3c73524160ce = (schema, ctx, json, params)=>{
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Symbols cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$7667b76b86382b1f = (_schema, ctx, json, _params)=>{
    if (ctx.target === "openapi-3.0") {
        json.type = "string";
        json.nullable = true;
        json.enum = [
            null
        ];
    } else json.type = "null";
};
const $fb6286dd552db993$export$9838a7ce212344b0 = (schema, ctx, json, params)=>{
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Undefined cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$b5910bb267c78233 = (schema, ctx, json, params)=>{
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Void cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$694b9cd80480ac33 = (_schema, _ctx, json, _params)=>{
    json.not = {};
};
const $fb6286dd552db993$export$a92de72ffd9087b5 = (_schema, _ctx, _json, _params)=>{
// empty schema accepts anything
};
const $fb6286dd552db993$export$4e1fea7b2e7474f = (_schema, _ctx, _json, _params)=>{
// empty schema accepts anything
};
const $fb6286dd552db993$export$d044e6246fe40d06 = (schema, ctx, json, params)=>{
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Date cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$a0f7e3681bbe4f0b = (schema, _ctx, json, _params)=>{
    const def = schema._zod.def;
    const values = (0, $23ixW.getEnumValues)(def.entries);
    // an empty enum accepts nothing, same as z.never()
    if (values.length === 0) {
        json.not = {};
        return;
    }
    // Number enums can have both string and number values
    if (values.every((v)=>typeof v === "number")) json.type = "number";
    if (values.every((v)=>typeof v === "string")) json.type = "string";
    json.enum = values;
};
const $fb6286dd552db993$export$b7a483a046d3a9b = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    // a literal with no values accepts nothing, same as z.never()
    if (def.values.length === 0) {
        json.not = {};
        return;
    }
    const vals = [];
    for (const val of def.values){
        if (val === undefined) {
            // a custom schema replaces the whole literal, so there is nothing left to accumulate
            if ((0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Literal `undefined` cannot be represented in JSON Schema")) return;
        // otherwise do not add to vals
        } else if (typeof val === "bigint") {
            if ((0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "BigInt literals cannot be represented in JSON Schema")) return;
            vals.push(Number(val));
        } else vals.push(val);
    }
    if (vals.length === 0) ;
    else if (vals.length === 1) {
        const val = vals[0];
        json.type = val === null ? "null" : typeof val;
        if (ctx.target === "draft-04" || ctx.target === "openapi-3.0") json.enum = [
            val
        ];
        else json.const = val;
    } else {
        if (vals.every((v)=>typeof v === "number")) json.type = "number";
        if (vals.every((v)=>typeof v === "string")) json.type = "string";
        if (vals.every((v)=>typeof v === "boolean")) json.type = "boolean";
        if (vals.every((v)=>v === null)) json.type = "null";
        json.enum = vals;
    }
};
const $fb6286dd552db993$export$f33d8739d51ecc4b = (schema, ctx, json, params)=>{
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "NaN cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$59812826ec9f1850 = (schema, _ctx, json, _params)=>{
    const _json = json;
    const pattern = schema._zod.pattern;
    if (!pattern) throw new Error("Pattern not found in template literal");
    _json.type = "string";
    _json.pattern = pattern.source;
};
const $fb6286dd552db993$export$62de47a40c7b42b0 = (schema, _ctx, json, _params)=>{
    const _json = json;
    _json.type = "string";
    _json.format = "binary";
    _json.contentEncoding = "binary";
    const { minimum: minimum, maximum: maximum, mime: mime } = $fb6286dd552db993$export$9329961b252a50ea(schema);
    if (minimum !== undefined) _json.minLength = minimum;
    if (maximum !== undefined) _json.maxLength = maximum;
    if (!mime) return;
    // an empty intersection means the mime checks share no value, so nothing passes at runtime; `anyOf` must be non-empty, so the false schema is `not: {}`
    if (mime.length === 0) _json.not = {};
    else if (mime.length === 1) _json.contentMediaType = mime[0];
    else _json.anyOf = mime.map((m)=>({
            contentMediaType: m
        }));
};
const $fb6286dd552db993$export$1e296a49315ba27a = (_schema, _ctx, json, _params)=>{
    json.type = "boolean";
};
const $fb6286dd552db993$export$fe3af043a76e4dab = (schema, ctx, json, params)=>{
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Custom types cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$654f185ba88226ab = (schema, ctx, json, params)=>{
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Function types cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$707b17683f9c9ec0 = (schema, ctx, json, params)=>{
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Transforms cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$5e912d1710885757 = (schema, ctx, json, params)=>{
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Map cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$2ff44e7a32269271 = (schema, ctx, json, params)=>{
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Set cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$afeff382d55f455b = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    const { minimum: minimum, maximum: maximum } = $fb6286dd552db993$export$9329961b252a50ea(schema);
    if (typeof minimum === "number") json.minItems = minimum;
    if (typeof maximum === "number") json.maxItems = maximum;
    json.type = "array";
    json.items = (0, $jSi9q.processSchema)(def.element, ctx, {
        ...params,
        path: [
            ...params.path,
            "items"
        ]
    });
};
// Transform and catch set `optin = "optional"` at runtime so the parser lets them observe an
// absent key, but their declared input type stays required. An input JSON Schema describes the
// declared type, so resolve past them to the schema that actually carries the optionality.
// Used by both `objectProcessor` (for `required`) and `tupleProcessor` (for `minItems`); see
// wiki/optionality.md, "The JSON Schema emitter reads the *static* value".
function $fb6286dd552db993$var$inputOptin(schema) {
    const def = schema._zod.def;
    if (def.type === "pipe" && def.in._zod.traits.has("$ZodTransform")) return $fb6286dd552db993$var$inputOptin(def.out);
    if (def.type === "catch") return $fb6286dd552db993$var$inputOptin(def.innerType);
    return schema._zod.optin;
}
const $fb6286dd552db993$export$8cc078cf99794668 = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    const shape = def.shape;
    // dropping it while still emitting `additionalProperties: false` would emit a schema that rejects data this one requires
    const symbolKeys = Object.getOwnPropertySymbols(shape);
    if (symbolKeys.length && (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Symbol keys cannot be represented in JSON Schema")) return;
    json.type = "object";
    json.properties = {};
    for(const key in shape)// assignProp so a __proto__ key becomes an own property instead of hitting the inherited setter on the plain {} we build into
    (0, $23ixW.assignProp)(json.properties, key, (0, $jSi9q.processSchema)(shape[key], ctx, {
        ...params,
        path: [
            ...params.path,
            "properties",
            key
        ]
    }));
    // required keys
    const allKeys = new Set(Object.keys(shape));
    const requiredKeys = new Set([
        ...allKeys
    ].filter((key)=>{
        const field = def.shape[key];
        if (ctx.io === "input") return $fb6286dd552db993$var$inputOptin(field) === undefined;
        else return field._zod.optout === undefined;
    }));
    if (requiredKeys.size > 0) json.required = Array.from(requiredKeys);
    // catchall
    if (def.catchall?._zod.def.type === "never") // strict
    json.additionalProperties = false;
    else if (!def.catchall) // regular
    {
        if (ctx.io === "output") json.additionalProperties = false;
    } else if (def.catchall) json.additionalProperties = (0, $jSi9q.processSchema)(def.catchall, ctx, {
        ...params,
        path: [
            ...params.path,
            "additionalProperties"
        ]
    });
};
const $fb6286dd552db993$export$c9f36bee6661d730 = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    // dropping a symbol key silently would emit a schema that asserts less than this one does
    if (Object.getOwnPropertySymbols(def.shape).length && (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Symbol keys cannot be represented in JSON Schema")) return;
    // the parsed value is the input, so an output-mode emission would describe a transformed value this schema never returns
    if (ctx.io === "output") for(const key in def.shape){
        if ((0, $jSi9q.isTransforming)(def.shape[key]) && (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, `z.properties() returns its input, so the output of a transforming schema at key "${key}" cannot be represented in JSON Schema`)) return;
    }
    json.type = "object";
    json.properties = {};
    for(const key in def.shape)(0, $23ixW.assignProp)(json.properties, key, (0, $jSi9q.processSchema)(def.shape[key], ctx, {
        ...params,
        path: [
            ...params.path,
            "properties",
            key
        ]
    }));
    // input-side optionality in both modes: the parsed value is the input, so a defaulted key that stays absent must not be required of the output either
    const required = Object.keys(def.shape).filter((key)=>$fb6286dd552db993$var$inputOptin(def.shape[key]) === undefined);
    if (required.length > 0) json.required = required;
};
const $fb6286dd552db993$export$f387dff1d8008b49 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    // Exclusive unions (inclusive === false) use oneOf (exactly one match) instead of anyOf (one or more matches). This includes both z.xor() and discriminated unions
    const isExclusive = def.inclusive === false;
    const options = def.options.map((x, i)=>(0, $jSi9q.processSchema)(x, ctx, {
            ...params,
            path: [
                ...params.path,
                isExclusive ? "oneOf" : "anyOf",
                i
            ]
        }));
    if (isExclusive) json.oneOf = options;
    else json.anyOf = options;
};
const $fb6286dd552db993$export$2a29f9128b7167c3 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    const a = (0, $jSi9q.processSchema)(def.left, ctx, {
        ...params,
        path: [
            ...params.path,
            "allOf",
            0
        ]
    });
    const b = (0, $jSi9q.processSchema)(def.right, ctx, {
        ...params,
        path: [
            ...params.path,
            "allOf",
            1
        ]
    });
    const isSimpleIntersection = (val)=>"allOf" in val && Object.keys(val).length === 1;
    const allOf = [
        ...isSimpleIntersection(a) ? a.allOf : [
            a
        ],
        ...isSimpleIntersection(b) ? b.allOf : [
            b
        ]
    ];
    json.allOf = allOf;
    // Recorded innermost first, so a nested intersection has already folded by the time this one is considered. The array is the handle rather than the schema, because a wrapper that inherits this schema shares the same array; `finalize` folds every object holding it. See `foldIntersection`.
    ctx.intersections.push(allOf);
};
const $fb6286dd552db993$export$7767a398545ac85c = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "array";
    const prefixPath = ctx.target === "draft-2020-12" ? "prefixItems" : "items";
    const restPath = ctx.target === "draft-2020-12" ? "items" : ctx.target === "openapi-3.0" ? "items" : "additionalItems";
    const prefixItems = def.items.map((x, i)=>(0, $jSi9q.processSchema)(x, ctx, {
            ...params,
            path: [
                ...params.path,
                prefixPath,
                i
            ]
        }));
    const rest = def.rest ? (0, $jSi9q.processSchema)(def.rest, ctx, {
        ...params,
        path: [
            ...params.path,
            restPath,
            ...ctx.target === "openapi-3.0" ? [
                def.items.length
            ] : []
        ]
    }) : null;
    let minItems = def.items.length;
    while(minItems > 0){
        const item = def.items[minItems - 1];
        const optional = ctx.io === "input" ? $fb6286dd552db993$var$inputOptin(item) !== undefined : item._zod.optout === "optional";
        if (!optional) break;
        minItems--;
    }
    const maxItems = def.items.length;
    const isClosed = !def.rest;
    if (ctx.target === "draft-2020-12") {
        json.prefixItems = prefixItems;
        if (isClosed) json.items = false;
        else if (rest) json.items = rest;
        if (minItems > 0) json.minItems = minItems;
        if (isClosed) json.maxItems = maxItems;
    } else if (ctx.target === "openapi-3.0") {
        json.items = {
            anyOf: prefixItems
        };
        if (rest) json.items.anyOf.push(rest);
        if (minItems > 0) json.minItems = minItems;
        if (isClosed) json.maxItems = maxItems;
    } else {
        json.items = prefixItems;
        if (isClosed) json.additionalItems = false;
        else if (rest) json.additionalItems = rest;
        if (minItems > 0) json.minItems = minItems;
        if (isClosed) json.maxItems = maxItems;
    }
    // explicit user-defined length checks take precedence
    const { minimum: minimum, maximum: maximum } = $fb6286dd552db993$export$9329961b252a50ea(schema);
    if (typeof minimum === "number") json.minItems = minimum;
    if (typeof maximum === "number") json.maxItems = maximum;
};
/** JSON object keys are always strings, so a numeric record key schema is re-expressed over the
 * numeric-string form the record parser matches. Deferred to `finalize`, after the flatten: a key
 * behind a wrapper only carries its own `type` before then, and a union key only has its branches.
 *
 * A numeric bound cannot apply to a property name, so `minimum` and its siblings are dropped rather
 * than carried over: keeping them beside `type: "string"` reproduces the match-nothing schema this
 * exists to fix. A key that carries one therefore emits wider than the record parses — `z.record(z.number().min(5), V)`
 * accepts `"3"` — which is the deliberate trade, since throwing on it would reject an ordinary schema
 * outright. */ function $fb6286dd552db993$var$stringifyKeyNames(bySchema, json, visited) {
    // an extracted key that rewrites cannot go on sharing its definition — the string form a key position needs is not the number form every other reference wants — so it inlines. One that does not rewrite keeps the `$ref`.
    if (json.$ref) {
        // a recursive key holds its own reference inside its definition, so a node already on the path is left alone rather than resolved again
        if (visited.has(json)) return json;
        visited.add(json);
        const def = bySchema.get(json)?.def;
        if (!def) return json;
        const inlined = $fb6286dd552db993$var$stringifyKeyNames(bySchema, def, visited);
        return inlined === def ? json : inlined;
    }
    for (const keyword of [
        "anyOf",
        "oneOf"
    ]){
        const branches = json[keyword];
        if (!Array.isArray(branches)) continue;
        const mapped = branches.map((branch)=>$fb6286dd552db993$var$stringifyKeyNames(bySchema, branch, visited));
        // rebuilding regardless would detach a key that had nothing to re-express, dropping its `$ref` and leaking the internal `id`
        if (mapped.some((branch, i)=>branch !== branches[i])) json = {
            ...json,
            [keyword]: mapped
        };
    }
    // a member that already admits a string leaves the key unconstrained, so the node's own type re-expresses only when every member is numeric
    const types = Array.isArray(json.type) ? json.type : [
        json.type
    ];
    const numericType = !types.includes("string") && types.some((t)=>t === "number" || t === "integer");
    // a heterogeneous key carries no type at all, so its numeric members are caught here instead
    const values = json.enum ?? (json.const !== undefined ? [
        json.const
    ] : undefined);
    if (!numericType && !values?.some((v)=>typeof v === "number")) return json;
    const { minimum: minimum, maximum: maximum, exclusiveMinimum: exclusiveMinimum, exclusiveMaximum: exclusiveMaximum, multipleOf: multipleOf, format: format, id: id, ...rest } = json;
    if (rest.enum) rest.enum = rest.enum.map((v)=>typeof v === "number" ? String(v) : v);
    else if (typeof rest.const === "number") rest.const = String(rest.const);
    // a heterogeneous key keeps its absent type: the stringified members already say what a key may be
    if (!numericType) return rest;
    rest.type = "string";
    if (!values) rest.pattern = (types.includes("number") ? $dZBpt.number : $dZBpt.integer).source;
    return rest;
}
/** Every record of one conversion, so the carriers are found in a single pass rather than once per record. */ const $fb6286dd552db993$var$pendingRecords = new WeakMap();
function $fb6286dd552db993$var$rewriteKeyNames(ctx) {
    // an extracted key is resolved by the object `extractToDef` left in its place, so the map is built once rather than searched per reference. `_zod.toJSONSchema` can hand the same object to two schemas, so the first entry carrying a body wins, as a search would have found it.
    const bySchema = new Map();
    for (const entry of ctx.seen.values())if (entry.def && !bySchema.has(entry.schema)) bySchema.set(entry.schema, entry);
    const rewrites = new Map();
    for (const record of $fb6286dd552db993$var$pendingRecords.get(ctx) ?? []){
        const seen = ctx.seen.get(record);
        const names = (seen?.def ?? seen?.schema)?.propertyNames;
        if (!names || names === true || rewrites.has(names)) continue;
        const rewritten = $fb6286dd552db993$var$stringifyKeyNames(bySchema, names, new Set());
        if (rewritten !== names) rewrites.set(names, rewritten);
    }
    if (!rewrites.size) return;
    // the flatten has already copied each record's own properties onto every wrapper by reference, and an extracted body is another such copy, so every carrier holding a rewritten key is updated together
    for (const entry of ctx.seen.values())for (const carrier of [
        entry.schema,
        entry.def
    ]){
        const rewritten = carrier && rewrites.get(carrier.propertyNames);
        if (rewritten) carrier.propertyNames = rewritten;
    }
}
const $fb6286dd552db993$export$6cf7a4b4a95ef1a8 = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "object";
    // For looseRecord with regex patterns, use patternProperties. This correctly represents "only validate keys matching the pattern" semantics and composes well with allOf (intersections)
    const keyType = def.keyType;
    const patterns = $fb6286dd552db993$export$9329961b252a50ea(keyType).patterns;
    if (def.mode === "loose" && patterns && patterns.size > 0) {
        // Use patternProperties for looseRecord with regex patterns
        const valueSchema = (0, $jSi9q.processSchema)(def.valueType, ctx, {
            ...params,
            path: [
                ...params.path,
                "patternProperties",
                "*"
            ]
        });
        json.patternProperties = {};
        for (const pattern of patterns)(0, $23ixW.assignProp)(json.patternProperties, $fb6286dd552db993$var$exactPattern(pattern).source, valueSchema);
    } else {
        // Default behavior: use propertyNames + additionalProperties
        if (ctx.target === "draft-07" || ctx.target === "draft-2020-12") {
            json.propertyNames = (0, $jSi9q.processSchema)(def.keyType, ctx, {
                ...params,
                path: [
                    ...params.path,
                    "propertyNames"
                ]
            });
            let pending = $fb6286dd552db993$var$pendingRecords.get(ctx);
            if (!pending) {
                pending = [];
                $fb6286dd552db993$var$pendingRecords.set(ctx, pending);
                ctx.deferred.push(()=>$fb6286dd552db993$var$rewriteKeyNames(ctx));
            }
            pending.push(schema);
        }
        json.additionalProperties = (0, $jSi9q.processSchema)(def.valueType, ctx, {
            ...params,
            path: [
                ...params.path,
                "additionalProperties"
            ]
        });
    }
    // Add required for keys with discrete values (enum, literal, etc.)
    const keyValues = keyType._zod.values;
    // Every key shares one value schema, so an optional-in value makes the whole key set omittable on input. Output keeps them: the exhaustive branch assigns every key, even one whose value came back undefined.
    const omittableOnInput = ctx.io === "input" && $fb6286dd552db993$var$inputOptin(def.valueType) !== undefined;
    if (keyValues && !def.partial && !omittableOnInput) {
        const validKeyValues = [
            ...keyValues
        ].filter((v)=>typeof v === "string" || typeof v === "number");
        if (validKeyValues.length > 0) json.required = validKeyValues.map(String);
    }
};
const $fb6286dd552db993$export$452ce6f96b49219a = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    const inner = (0, $jSi9q.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    if (ctx.target === "openapi-3.0") {
        seen.ref = def.innerType;
        json.nullable = true;
    } else json.anyOf = [
        inner,
        {
            type: "null"
        }
    ];
};
const $fb6286dd552db993$export$7c6ac5b60b42bfc9 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $jSi9q.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
/** Round-trips a default value through JSON so the emitted schema is guaranteed to be valid JSON.
 * A BigInt has no reliable encoding, so it goes through `unrepresentable` like any other
 * unrepresentable value. Returns a sentinel when the caller must not write a default of its own. */ const $fb6286dd552db993$var$UNREPRESENTABLE_DEFAULT = Symbol();
function $fb6286dd552db993$var$serializeDefaultValue(value, schema, ctx, json, params) {
    let unrepresentable = false;
    const serialized = JSON.stringify(value, (_, val)=>{
        if (typeof val !== "bigint") return val;
        unrepresentable = true;
        return null;
    });
    if (!unrepresentable) return JSON.parse(serialized);
    (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "BigInt defaults cannot be represented in JSON Schema");
    return $fb6286dd552db993$var$UNREPRESENTABLE_DEFAULT;
}
const $fb6286dd552db993$export$f76e6c36e8fb062b = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $jSi9q.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    const value = $fb6286dd552db993$var$serializeDefaultValue(def.defaultValue, schema, ctx, json, params);
    if (value !== $fb6286dd552db993$var$UNREPRESENTABLE_DEFAULT) json.default = value;
};
const $fb6286dd552db993$export$1ded4e432f286ac2 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $jSi9q.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    if (ctx.io !== "input") return;
    const value = $fb6286dd552db993$var$serializeDefaultValue(def.defaultValue, schema, ctx, json, params);
    if (value !== $fb6286dd552db993$var$UNREPRESENTABLE_DEFAULT) json._prefault = value;
};
const $fb6286dd552db993$export$3f81793c903cb504 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $jSi9q.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    let catchValue;
    try {
        catchValue = def.catchValue(undefined);
    } catch  {
        (0, $jSi9q.handleUnrepresentable)(schema, ctx, json, params, "Dynamic catch values are not supported in JSON Schema");
        return;
    }
    json.default = catchValue;
};
const $fb6286dd552db993$export$3a3e6911d4012a24 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    const inIsTransform = def.in._zod.traits.has("$ZodTransform");
    const innerType = ctx.io === "input" ? inIsTransform ? def.out : def.in : def.out;
    (0, $jSi9q.processSchema)(innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = innerType;
};
const $fb6286dd552db993$export$dd90252c562e1d9 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $jSi9q.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    json.readOnly = true;
};
const $fb6286dd552db993$export$ecb899a95fe4bdc0 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $jSi9q.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const $fb6286dd552db993$export$4b1db46aa3739c48 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $jSi9q.processSchema)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const $fb6286dd552db993$export$9980155f320c317b = (schema, ctx, _json, params)=>{
    const innerType = schema._zod.innerType;
    (0, $jSi9q.processSchema)(innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = innerType;
};
const $fb6286dd552db993$export$e462eec3d35f5c06 = {
    string: $fb6286dd552db993$export$c6950985d9de996d,
    number: $fb6286dd552db993$export$afd08f475b2e134f,
    boolean: $fb6286dd552db993$export$f03e9163a5233fc4,
    bigint: $fb6286dd552db993$export$8810d61ae56edc9c,
    symbol: $fb6286dd552db993$export$fd2b3c73524160ce,
    null: $fb6286dd552db993$export$7667b76b86382b1f,
    undefined: $fb6286dd552db993$export$9838a7ce212344b0,
    void: $fb6286dd552db993$export$b5910bb267c78233,
    never: $fb6286dd552db993$export$694b9cd80480ac33,
    any: $fb6286dd552db993$export$a92de72ffd9087b5,
    unknown: $fb6286dd552db993$export$4e1fea7b2e7474f,
    date: $fb6286dd552db993$export$d044e6246fe40d06,
    enum: $fb6286dd552db993$export$a0f7e3681bbe4f0b,
    literal: $fb6286dd552db993$export$b7a483a046d3a9b,
    nan: $fb6286dd552db993$export$f33d8739d51ecc4b,
    template_literal: $fb6286dd552db993$export$59812826ec9f1850,
    file: $fb6286dd552db993$export$62de47a40c7b42b0,
    success: $fb6286dd552db993$export$1e296a49315ba27a,
    custom: $fb6286dd552db993$export$fe3af043a76e4dab,
    properties: $fb6286dd552db993$export$c9f36bee6661d730,
    function: $fb6286dd552db993$export$654f185ba88226ab,
    transform: $fb6286dd552db993$export$707b17683f9c9ec0,
    map: $fb6286dd552db993$export$5e912d1710885757,
    set: $fb6286dd552db993$export$2ff44e7a32269271,
    array: $fb6286dd552db993$export$afeff382d55f455b,
    object: $fb6286dd552db993$export$8cc078cf99794668,
    union: $fb6286dd552db993$export$f387dff1d8008b49,
    intersection: $fb6286dd552db993$export$2a29f9128b7167c3,
    tuple: $fb6286dd552db993$export$7767a398545ac85c,
    record: $fb6286dd552db993$export$6cf7a4b4a95ef1a8,
    nullable: $fb6286dd552db993$export$452ce6f96b49219a,
    nonoptional: $fb6286dd552db993$export$7c6ac5b60b42bfc9,
    default: $fb6286dd552db993$export$f76e6c36e8fb062b,
    prefault: $fb6286dd552db993$export$1ded4e432f286ac2,
    catch: $fb6286dd552db993$export$3f81793c903cb504,
    pipe: $fb6286dd552db993$export$3a3e6911d4012a24,
    readonly: $fb6286dd552db993$export$dd90252c562e1d9,
    promise: $fb6286dd552db993$export$ecb899a95fe4bdc0,
    optional: $fb6286dd552db993$export$4b1db46aa3739c48,
    lazy: $fb6286dd552db993$export$9980155f320c317b
};
function $fb6286dd552db993$export$395d8e19463d4f49(input, params) {
    if ("_idmap" in input) {
        // Registry case
        const registry = input;
        const ctx = (0, $jSi9q.initializeContext)({
            ...params,
            processors: $fb6286dd552db993$export$e462eec3d35f5c06
        });
        const defs = {};
        // First pass: process all schemas to build the seen map
        for (const entry of registry._idmap.entries()){
            const [_, schema] = entry;
            (0, $jSi9q.processSchema)(schema, ctx);
        }
        const schemas = {};
        const external = {
            registry: registry,
            uri: params?.uri,
            defs: defs
        };
        // Update the context with external configuration
        ctx.external = external;
        // Second pass: emit each schema
        for (const entry of registry._idmap.entries()){
            const [key, schema] = entry;
            (0, $jSi9q.extractDefs)(ctx, schema);
            (0, $23ixW.assignProp)(schemas, key, (0, $jSi9q.finalize)(ctx, schema));
        }
        if (Object.keys(defs).length > 0) {
            const defsSegment = ctx.target === "draft-2020-12" ? "$defs" : "definitions";
            schemas.__shared = {
                [defsSegment]: defs
            };
        }
        return {
            schemas: schemas
        };
    }
    // Single schema case
    const ctx = (0, $jSi9q.initializeContext)({
        ...params,
        processors: $fb6286dd552db993$export$e462eec3d35f5c06
    });
    (0, $jSi9q.processSchema)(input, ctx);
    (0, $jSi9q.extractDefs)(ctx, input);
    return (0, $jSi9q.finalize)(ctx, input);
}

});
parcelRegister("jSi9q", function(module, exports) {

$parcel$export(module.exports, "initializeContext", () => $e78123e42965e820$export$881f7fb71351b304);
$parcel$export(module.exports, "handleUnrepresentable", () => $e78123e42965e820$export$e3c1b0b829661475);
$parcel$export(module.exports, "processSchema", () => $e78123e42965e820$export$f85120451780a2ef);
$parcel$export(module.exports, "isTransforming", () => $e78123e42965e820$export$84a7cf931c2d45cc);
$parcel$export(module.exports, "extractDefs", () => $e78123e42965e820$export$ba2613251eadea93);
$parcel$export(module.exports, "finalize", () => $e78123e42965e820$export$578723aef62d92f5);
$parcel$export(module.exports, "createStandardJSONSchemaMethod", () => $e78123e42965e820$export$b29c48d79372468a);
$parcel$export(module.exports, "createToJSONSchemaMethod", () => $e78123e42965e820$export$d24eb8c1ef5f4df1);

var $5VtTM = parcelRequire("5VtTM");

var $23ixW = parcelRequire("23ixW");
function $e78123e42965e820$var$assignProps(target, ...sources) {
    for (const source of sources){
        for (const key of Reflect.ownKeys(source))if (Object.prototype.propertyIsEnumerable.call(source, key)) (0, $23ixW.assignProp)(target, key, source[key]);
    }
    return target;
}
function $e78123e42965e820$export$881f7fb71351b304(params) {
    // Normalize target: convert old non-hyphenated versions to hyphenated versions
    let target = params?.target ?? "draft-2020-12";
    if (target === "draft-4") target = "draft-04";
    if (target === "draft-7") target = "draft-07";
    return {
        processors: params.processors ?? {},
        metadataRegistry: params?.metadata ?? (0, $5VtTM.globalRegistry),
        target: target,
        unrepresentable: params?.unrepresentable ?? "throw",
        override: params?.override ?? (()=>{}),
        io: params?.io ?? "output",
        counter: 0,
        seen: new Map(),
        sharedDefsExtractedFor: undefined,
        sharedEmitDoneFor: undefined,
        cycles: params?.cycles ?? "ref",
        reused: params?.reused ?? "inline",
        intersections: [],
        deferred: [],
        external: params?.external ?? undefined
    };
}
function $e78123e42965e820$export$e3c1b0b829661475(schema, ctx, json, params, message) {
    const result = typeof ctx.unrepresentable === "function" ? ctx.unrepresentable({
        zodSchema: schema,
        path: params.path,
        message: message
    }) : ctx.unrepresentable;
    if (result === "any") return false;
    if (result === undefined || result === "throw") throw new Error(message);
    Object.assign(json, result);
    return true;
}
function $e78123e42965e820$export$f85120451780a2ef(schema, ctx, _params = {
    path: [],
    schemaPath: []
}) {
    var _a;
    const def = schema._zod.def;
    // check for schema in seens
    const seen = ctx.seen.get(schema);
    if (seen) {
        seen.count++;
        // check if cycle
        const isCycle = _params.schemaPath.includes(schema);
        if (isCycle) seen.cycle = _params.path;
        return seen.schema;
    }
    // initialize
    const result = {
        schema: {},
        count: 1,
        cycle: undefined,
        path: _params.path
    };
    ctx.seen.set(schema, result);
    ctx.sharedDefsExtractedFor = undefined;
    ctx.sharedEmitDoneFor = undefined;
    // custom method overrides default behavior
    const overrideSchema = schema._zod.toJSONSchema?.();
    if (overrideSchema) result.schema = overrideSchema;
    else {
        const params = {
            ..._params,
            schemaPath: [
                ..._params.schemaPath,
                schema
            ],
            path: _params.path
        };
        if (schema._zod.processJSONSchema) schema._zod.processJSONSchema(ctx, result.schema, params);
        else {
            const _json = result.schema;
            const processor = ctx.processors[def.type];
            if (!processor) throw new Error(`[toJSONSchema]: Non-representable type encountered: ${def.type}`);
            processor(schema, ctx, _json, params);
        }
        const parent = schema._zod.parent;
        if (parent) {
            // Also set ref if processor didn't (for inheritance)
            if (!result.ref) result.ref = parent;
            $e78123e42965e820$export$f85120451780a2ef(parent, ctx, params);
            ctx.seen.get(parent).isParent = true;
        }
    }
    // metadata
    const meta = ctx.metadataRegistry.get(schema);
    if (meta) $e78123e42965e820$var$assignProps(result.schema, meta);
    if (ctx.io === "input" && $e78123e42965e820$export$84a7cf931c2d45cc(schema)) {
        // examples/defaults only apply to output type of pipe
        delete result.schema.examples;
        delete result.schema.default;
    }
    // set prefault as default
    if (ctx.io === "input" && "_prefault" in result.schema) (_a = result.schema).default ?? (_a.default = result.schema._prefault);
    delete result.schema._prefault;
    // pulling fresh from ctx.seen in case it was overwritten
    const _result = ctx.seen.get(schema);
    return _result.schema;
}
// Escape a reference token for use in a JSON Pointer fragment (RFC 6901): `~` becomes `~0` and `/` becomes `~1`. The `~` replacement must run first.
function $e78123e42965e820$var$encodeJSONPointerSegment(segment) {
    return segment.replace(/~/g, "~0").replace(/\//g, "~1");
}
function $e78123e42965e820$export$ba2613251eadea93(ctx, schema) {
    // iterate over seen map;
    const root = ctx.seen.get(schema);
    if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
    // With `external` set, every registered schema resolves through the external branch of `makeURI`, so the root branch below produces the same ref the external branch would — this pass is identical whichever schema it is called with, and only needs to run once.
    if (ctx.external && ctx.sharedDefsExtractedFor === ctx.external) return;
    // Track ids to detect duplicates across different schemas
    const idToSchema = new Map();
    for (const entry of ctx.seen.entries()){
        const id = ctx.metadataRegistry.get(entry[0])?.id;
        if (id) {
            const existing = idToSchema.get(id);
            if (existing && existing !== entry[0]) throw new Error(`Duplicate schema id "${id}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
            idToSchema.set(id, entry[0]);
        }
    }
    // returns a ref to the schema defId will be empty if the ref points to an external schema (or #)
    const makeURI = (entry)=>{
        // comparing the seen objects because sometimes multiple schemas map to the same seen object. e.g. lazy
        // external is configured
        const defsSegment = ctx.target === "draft-2020-12" ? "$defs" : "definitions";
        if (ctx.external) {
            const externalId = ctx.external.registry.get(entry[0])?.id; // ?? "__shared";// `__schema${ctx.counter++}`;
            // check if schema is in the external registry
            const uriGenerator = ctx.external.uri ?? ((id)=>id);
            if (externalId) return {
                ref: uriGenerator(externalId)
            };
            // otherwise, add to __shared
            const id = entry[1].defId ?? entry[1].schema.id ?? `schema${ctx.counter++}`;
            entry[1].defId = id; // set defId so it will be reused if needed
            return {
                defId: id,
                ref: `${uriGenerator("__shared")}#/${defsSegment}/${$e78123e42965e820$var$encodeJSONPointerSegment(id)}`
            };
        }
        const uriPrefix = `#`;
        const defUriPrefix = `${uriPrefix}/${defsSegment}/`;
        // an id-less root has nowhere to be extracted to, so it stays inline and self-references as `#`
        if (entry[1] === root && !entry[1].schema.id) return {
            ref: uriPrefix
        };
        // self-contained schema
        const defId = entry[1].schema.id ?? `__schema${ctx.counter++}`;
        return {
            defId: defId,
            ref: defUriPrefix + $e78123e42965e820$var$encodeJSONPointerSegment(defId)
        };
    };
    // stored cached version in `def` property remove all properties, set $ref
    const extractToDef = (entry)=>{
        // if the schema is already a reference, do not extract it
        if (entry[1].schema.$ref) return;
        const seen = entry[1];
        const { ref: ref, defId: defId } = makeURI(entry);
        seen.def = {
            ...seen.schema
        };
        // defId won't be set if the schema is a reference to an external schema or if the schema is the root schema
        if (defId) seen.defId = defId;
        // wipe away all properties except $ref
        const schema = seen.schema;
        for(const key in schema)delete schema[key];
        schema.$ref = ref;
    };
    // throw on cycles
    // break cycles
    if (ctx.cycles === "throw") for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        if (seen.cycle) throw new Error("Cycle detected: " + `#/${seen.cycle?.join("/")}/<root>` + '\n\nSet the `cycles` parameter to `"ref"` to resolve cyclical schemas with defs.');
    }
    // extract schemas into $defs
    for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        // convert root schema to # $ref
        if (schema === entry[0]) {
            extractToDef(entry); // this has special handling for the root schema
            continue;
        }
        // extract schemas that are in the external registry
        if (ctx.external) {
            const ext = ctx.external.registry.get(entry[0])?.id;
            if (schema !== entry[0] && ext) {
                extractToDef(entry);
                continue;
            }
        }
        // extract schemas with `id` meta
        const id = ctx.metadataRegistry.get(entry[0])?.id;
        if (id) {
            extractToDef(entry);
            continue;
        }
        // break cycles
        if (seen.cycle) {
            // any
            extractToDef(entry);
            continue;
        }
        // extract reused schemas
        if (seen.count > 1) {
            if (ctx.reused === "ref") extractToDef(entry);
        }
    }
    if (ctx.external) ctx.sharedDefsExtractedFor = ctx.external;
}
/** Rewrites `anyOf: [{type: "a"}, {type: "b"}]` to `type: ["a", "b"]`, which every JSON Schema draft treats as equivalent and most consumers render far better for the nullable case. Only branches that are a bare type assertion qualify — anything carrying a constraint, `$ref`, `const` or metadata is left alone. Runs after `flattenRef`, so a branch an override decorated or `$defs` extraction turned into a `$ref` is no longer bare and correctly stays in `anyOf`. `oneOf` is excluded: `integer` and `number` overlap, so "exactly one" and "at least one" are not the same there. OpenAPI 3.0 is excluded: its `type` must be a single string. */ function $e78123e42965e820$var$compactTypeUnion(schema) {
    const options = schema.anyOf;
    if (!Array.isArray(options) || options.length === 0 || schema.type !== undefined) return;
    const types = [];
    for (const option of options){
        if (!option || typeof option !== "object") return;
        // A branch that is itself a compactible union folds into this one — nested `anyOf` and a flat `type` array say the same thing. Compacting it first also makes the result independent of the order this pass walks the seen map in.
        $e78123e42965e820$var$compactTypeUnion(option);
        const keys = Object.keys(option);
        if (keys.length !== 1 || keys[0] !== "type") return;
        const type = option.type;
        for (const member of Array.isArray(type) ? type : [
            type
        ]){
            if (typeof member !== "string") return;
            if (!types.includes(member)) types.push(member);
        }
    }
    delete schema.anyOf;
    // A `type` array must be non-empty and unique (metaschema); a single member is spelled as a bare string.
    schema.type = types.length === 1 ? types[0] : types;
}
/** Keywords `foldIntersection` knows how to combine. Anything else — `$ref`, `patternProperties`,
 * an annotation like `description` — makes a member unfoldable, so a constraint this does not
 * understand leaves the `allOf` alone instead of being silently dropped or misattributed. */ const $e78123e42965e820$var$FOLDABLE_KEYS = new Set([
    "type",
    "properties",
    "required",
    "additionalProperties"
]);
const $e78123e42965e820$var$UNION_KEYS = [
    "oneOf",
    "anyOf"
];
/** A member's constraint on a key it does not declare itself. A `catchall` states one; `false`, an absent `additionalProperties`, and the empty schema a loose object emits state nothing. */ function $e78123e42965e820$var$undeclaredConstraint(member) {
    const extra = member.additionalProperties;
    if (extra === undefined || extra === false || typeof extra !== "object" || extra === null) return null;
    return Object.keys(extra).length ? extra : null;
}
/** Combines object members into the single object they describe together, or returns `null` if any of them carries a keyword outside {@link FOLDABLE_KEYS}. */ function $e78123e42965e820$var$foldObjects(members) {
    const objects = [];
    for (const member of members){
        // A boolean subschema is legal JSON Schema and carries no keywords to fold.
        if (typeof member !== "object" || member.type !== "object") return null;
        for(const key in member){
            if (!$e78123e42965e820$var$FOLDABLE_KEYS.has(key)) return null;
        }
        objects.push(member);
    }
    const properties = {};
    const required = new Set();
    for (const object of objects){
        for(const key in object.properties){
            // `in` would report a `__proto__` key as already present via the prototype chain and skip it.
            if (Object.prototype.hasOwnProperty.call(properties, key)) continue;
            // Every member constrains this key: the ones that declare it say how, and a `catchall` member constrains it too even though it does not name it. The key has to satisfy all of them, which is the same intersection one level down.
            const parts = [];
            for (const other of objects){
                const part = other.properties?.[key] ?? $e78123e42965e820$var$undeclaredConstraint(other);
                if (part === null || part === undefined) continue;
                if (!parts.some((seen)=>JSON.stringify(seen) === JSON.stringify(part))) parts.push(part);
            }
            const merged = parts.length === 1 ? parts[0] : $e78123e42965e820$var$foldObjects(parts) ?? {
                allOf: parts
            };
            (0, $23ixW.assignProp)(properties, key, merged);
        }
        for (const key of object.required ?? [])required.add(key);
    }
    const folded = {
        type: "object",
        properties: properties
    };
    if (required.size) folded.required = [
        ...required
    ];
    // A key no member declares is rejected only when every member rejects it, so the fold is closed only when every member is. Otherwise it carries whatever the `catchall` members demand of such a key.
    if (objects.every((object)=>object.additionalProperties === false)) folded.additionalProperties = false;
    else {
        const constraints = [];
        for (const object of objects){
            const constraint = $e78123e42965e820$var$undeclaredConstraint(object);
            if (constraint && !constraints.some((seen)=>JSON.stringify(seen) === JSON.stringify(constraint))) constraints.push(constraint);
        }
        if (constraints.length === 1) folded.additionalProperties = constraints[0];
        else if (constraints.length > 1) folded.additionalProperties = {
            allOf: constraints
        };
    }
    return folded;
}
/** `additionalProperties` in an `allOf` member sees only that member's own `properties`, so two
 * closed object members reject each other's keys and the schema validates nothing. Zod's parser
 * pools the key sets instead — `handleIntersectionResults` reports a key as unrecognized only when
 * *every* side rejects it — so the emitted schema has to pool them too, and folding the members
 * into one object is the encoding that says so on every target.
 *
 * This runs from `finalize`, after `extractDefs`, which is what keeps it clear of the `$ref`
 * machinery: a member extracted into `$defs` is already a `$ref` by now and declines to fold, so it
 * keeps its reference and its own closedness rather than being inlined as a stale copy. */ function $e78123e42965e820$var$foldIntersection(json) {
    const allOf = json.allOf;
    if (!Array.isArray(allOf) || allOf.length < 2) return;
    // An `override` runs before this pass and may have written object keywords onto the intersection itself. Those are deliberate, so decline rather than overwrite them.
    for (const key of $e78123e42965e820$var$FOLDABLE_KEYS)if (key in json) return;
    // An intersection distributes over a union: `A & (X | Y)` is `(A & X) | (A & Y)`. Only the first union is distributed over; a second one stays among the members every branch folds against, where it fails the object check and declines the whole intersection rather than multiplying out.
    const unions = allOf.filter((m)=>$e78123e42965e820$var$UNION_KEYS.some((k)=>Array.isArray(m[k])));
    let folded = null;
    if (!unions.length) folded = $e78123e42965e820$var$foldObjects(allOf);
    else {
        const union = unions[0];
        const keyword = $e78123e42965e820$var$UNION_KEYS.find((k)=>Array.isArray(union[k]));
        if (Object.keys(union).length !== 1) return;
        const rest = allOf.filter((m)=>m !== union);
        const branches = union[keyword].map((branch)=>$e78123e42965e820$var$foldObjects([
                ...rest,
                branch
            ]));
        if (branches.some((b)=>!b)) return;
        folded = {
            [keyword]: branches
        };
    }
    if (!folded) return;
    delete json.allOf;
    $e78123e42965e820$var$assignProps(json, folded);
}
function $e78123e42965e820$export$578723aef62d92f5(ctx, schema) {
    const root = ctx.seen.get(schema);
    if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
    // flatten refs - inherit properties from parent schemas
    const flattenRef = (zodSchema)=>{
        const seen = ctx.seen.get(zodSchema);
        // already processed
        if (seen.ref === null) return;
        const schema = seen.def ?? seen.schema;
        const _cached = {
            ...schema
        };
        const ref = seen.ref;
        seen.ref = null; // prevent infinite recursion
        if (ref) {
            flattenRef(ref);
            const refSeen = ctx.seen.get(ref);
            const refSchema = refSeen.schema;
            // merge referenced schema into current
            if (refSchema.$ref && (ctx.target === "draft-07" || ctx.target === "draft-04" || ctx.target === "openapi-3.0")) {
                // older drafts can't combine $ref with other properties
                schema.allOf = schema.allOf ?? [];
                schema.allOf.push(refSchema);
            } else $e78123e42965e820$var$assignProps(schema, refSchema);
            // restore child's own properties (child wins)
            $e78123e42965e820$var$assignProps(schema, _cached);
            const isParentRef = zodSchema._zod.parent === ref;
            // For parent chain, child is a refinement - remove parent-only properties
            if (isParentRef) for(const key in schema){
                if (key === "$ref" || key === "allOf") continue;
                if (!(key in _cached)) delete schema[key];
            }
            // When ref was extracted to $defs, remove properties that match the definition
            if (refSchema.$ref && refSeen.def) for(const key in schema){
                if (key === "$ref" || key === "allOf") continue;
                if (key in refSeen.def && JSON.stringify(schema[key]) === JSON.stringify(refSeen.def[key])) delete schema[key];
            }
        }
        // If parent was extracted (has $ref), propagate $ref to this schema. This handles cases like: readonly().meta({id}).describe() where processor sets ref to innerType but parent should be referenced
        const parent = zodSchema._zod.parent;
        if (parent && parent !== ref) {
            // Ensure parent is processed first so its def has inherited properties
            flattenRef(parent);
            const parentSeen = ctx.seen.get(parent);
            if (parentSeen?.schema.$ref) {
                schema.$ref = parentSeen.schema.$ref;
                // De-duplicate with parent's definition
                if (parentSeen.def) for(const key in schema){
                    if (key === "$ref" || key === "allOf") continue;
                    if (key in parentSeen.def && JSON.stringify(schema[key]) === JSON.stringify(parentSeen.def[key])) delete schema[key];
                }
            }
        }
        // execute overrides
        ctx.override({
            zodSchema: zodSchema,
            jsonSchema: schema,
            path: seen.path ?? []
        });
    };
    // Flattening walks the whole map and clears each `ref` as it goes, so a second call over the same map is a no-op scan. Skip it outright once it has run for a registry conversion.
    if (!ctx.external || ctx.sharedEmitDoneFor !== ctx.external) {
        for (const entry of [
            ...ctx.seen.entries()
        ].reverse())flattenRef(entry[0]);
        if (ctx.target !== "openapi-3.0") for (const entry of ctx.seen.entries())$e78123e42965e820$var$compactTypeUnion(entry[1].def ?? entry[1].schema);
        for (const rewrite of ctx.deferred)rewrite();
        // After flattening, every member that was extracted is a `$ref`, so the fold sees the final shape. A schema that inherits an intersection — through `z.lazy`, or any `ref` chain — holds the same `allOf` array, so fold by array identity to catch every copy.
        if (ctx.intersections.length) {
            const carriers = new Map();
            for (const seen of ctx.seen.values())for (const json of [
                seen.schema,
                seen.def
            ]){
                const allOf = json?.allOf;
                if (!Array.isArray(allOf)) continue;
                const existing = carriers.get(allOf);
                if (existing) existing.push(json);
                else carriers.set(allOf, [
                    json
                ]);
            }
            for (const allOf of ctx.intersections)for (const json of carriers.get(allOf) ?? [])$e78123e42965e820$var$foldIntersection(json);
        }
    }
    const result = {};
    if (ctx.target === "draft-2020-12") result.$schema = "https://json-schema.org/draft/2020-12/schema";
    else if (ctx.target === "draft-07") result.$schema = "http://json-schema.org/draft-07/schema#";
    else if (ctx.target === "draft-04") result.$schema = "http://json-schema.org/draft-04/schema#";
    else ctx.target;
    if (ctx.external?.uri) {
        const id = ctx.external.registry.get(schema)?.id;
        if (!id) throw new Error("Schema is missing an `id` property");
        result.$id = ctx.external.uri(id);
    }
    // when the root was extracted into $defs, `root.schema` is the `$ref` wrapper and `root.def` is the body that now lives under $defs
    $e78123e42965e820$var$assignProps(result, root.defId ? root.schema : root.def ?? root.schema);
    // The `id` in `.meta()` is a Zod-specific registration tag used to extract schemas into $defs — it is not user-facing JSON Schema metadata. Strip it from the output body where it would otherwise leak. The id is preserved implicitly via the $defs key (and via $ref paths).
    const rootMetaId = ctx.metadataRegistry.get(schema)?.id;
    if (rootMetaId !== undefined && result.id === rootMetaId) delete result.id;
    // build defs object. With `external`, `defs` is the shared object every schema writes into, so the same entries are reassigned on every call. Without it, `defs` is fresh per call and must be rebuilt.
    const defs = ctx.external?.defs ?? {};
    if (!ctx.external || ctx.sharedEmitDoneFor !== ctx.external) for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        if (seen.def && seen.defId) {
            if (seen.def.id === seen.defId) delete seen.def.id;
            (0, $23ixW.assignProp)(defs, seen.defId, seen.def);
        }
    }
    if (ctx.external) ctx.sharedEmitDoneFor = ctx.external;
    // set definitions in result
    if (ctx.external) ;
    else if (Object.keys(defs).length > 0) {
        if (ctx.target === "draft-2020-12") result.$defs = defs;
        else result.definitions = defs;
    }
    try {
        // this "finalizes" this schema and ensures all cycles are removed each call to finalize() is functionally independent though the seen map is shared
        const finalized = JSON.parse(JSON.stringify(result));
        Object.defineProperty(finalized, "~standard", {
            value: {
                ...schema["~standard"],
                jsonSchema: {
                    input: $e78123e42965e820$export$b29c48d79372468a(schema, "input", ctx.processors),
                    output: $e78123e42965e820$export$b29c48d79372468a(schema, "output", ctx.processors)
                }
            },
            enumerable: false,
            writable: false
        });
        return finalized;
    } catch (_err) {
        throw new Error("Error converting schema to JSON.");
    }
}
function $e78123e42965e820$export$84a7cf931c2d45cc(_schema, _ctx) {
    const ctx = _ctx ?? {
        seen: new Set()
    };
    if (ctx.seen.has(_schema)) return false;
    ctx.seen.add(_schema);
    const def = _schema._zod.def;
    if (def.type === "transform") return true;
    if (def.type === "array") return $e78123e42965e820$export$84a7cf931c2d45cc(def.element, ctx);
    if (def.type === "set") return $e78123e42965e820$export$84a7cf931c2d45cc(def.valueType, ctx);
    if (def.type === "lazy") return $e78123e42965e820$export$84a7cf931c2d45cc(def.getter(), ctx);
    if (def.type === "promise" || def.type === "optional" || def.type === "nonoptional" || def.type === "nullable" || def.type === "readonly" || def.type === "default" || def.type === "prefault" || def.type === "catch") return $e78123e42965e820$export$84a7cf931c2d45cc(def.innerType, ctx);
    if (def.type === "intersection") return $e78123e42965e820$export$84a7cf931c2d45cc(def.left, ctx) || $e78123e42965e820$export$84a7cf931c2d45cc(def.right, ctx);
    if (def.type === "record" || def.type === "map") return $e78123e42965e820$export$84a7cf931c2d45cc(def.keyType, ctx) || $e78123e42965e820$export$84a7cf931c2d45cc(def.valueType, ctx);
    if (def.type === "pipe") {
        if (_schema._zod.traits.has("$ZodCodec")) return true;
        return $e78123e42965e820$export$84a7cf931c2d45cc(def.in, ctx) || $e78123e42965e820$export$84a7cf931c2d45cc(def.out, ctx);
    }
    if (def.type === "object") {
        for(const key in def.shape){
            if ($e78123e42965e820$export$84a7cf931c2d45cc(def.shape[key], ctx)) return true;
        }
        return false;
    }
    if (def.type === "union") {
        for (const option of def.options){
            if ($e78123e42965e820$export$84a7cf931c2d45cc(option, ctx)) return true;
        }
        return false;
    }
    if (def.type === "tuple") {
        for (const item of def.items){
            if ($e78123e42965e820$export$84a7cf931c2d45cc(item, ctx)) return true;
        }
        if (def.rest && $e78123e42965e820$export$84a7cf931c2d45cc(def.rest, ctx)) return true;
        return false;
    }
    return false;
}
const $e78123e42965e820$export$d24eb8c1ef5f4df1 = (schema, processors = {})=>(params)=>{
        const ctx = $e78123e42965e820$export$881f7fb71351b304({
            ...params,
            processors: processors
        });
        $e78123e42965e820$export$f85120451780a2ef(schema, ctx);
        $e78123e42965e820$export$ba2613251eadea93(ctx, schema);
        return $e78123e42965e820$export$578723aef62d92f5(ctx, schema);
    };
const $e78123e42965e820$export$b29c48d79372468a = (schema, io, processors = {})=>(params)=>{
        const { libraryOptions: libraryOptions, target: target } = params ?? {};
        const ctx = $e78123e42965e820$export$881f7fb71351b304({
            ...libraryOptions ?? {},
            target: target,
            io: io,
            processors: processors
        });
        $e78123e42965e820$export$f85120451780a2ef(schema, ctx);
        $e78123e42965e820$export$ba2613251eadea93(ctx, schema);
        return $e78123e42965e820$export$578723aef62d92f5(ctx, schema);
    };

});


parcelRegister("lp4KX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94f9f481fcdc5e7$export$2e2bcd8739ae039);

var $23ixW = parcelRequire("23ixW");
const $f94f9f481fcdc5e7$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "characters",
            verb: "to have"
        },
        file: {
            unit: "bytes",
            verb: "to have"
        },
        array: {
            unit: "items",
            verb: "to have"
        },
        set: {
            unit: "items",
            verb: "to have"
        },
        map: {
            unit: "entries",
            verb: "to have"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        mac: "MAC address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        credit_card: "credit card number",
        iban: "IBAN",
        jwt: "JWT",
        template_literal: "input"
    };
    // type names: missing keys = do not translate (use raw value via ?? fallback)
    const TypeDictionary = {
        // Compatibility: "nan" -> "NaN" for display
        nan: "NaN"
    };
    function getTypeName(type, input) {
        if (type === "number" && typeof input === "number" && !Number.isFinite(input)) return String(input);
        return TypeDictionary[type] ?? type;
    }
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = getTypeName(issue.expected);
                    const receivedType = $23ixW.parsedType(issue.input);
                    const received = getTypeName(receivedType, issue.input);
                    return `Invalid input: expected ${expected}, received ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Invalid input: expected ${$23ixW.stringifyPrimitive(issue.values[0])}`;
                return `Invalid option: expected one of ${$23ixW.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.exact ? "exactly " : issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too big: expected ${issue.origin ?? "value"} to have ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
                    return `Too big: expected ${issue.origin ?? "value"} to be ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.exact ? "exactly " : issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too small: expected ${issue.origin} to have ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Too small: expected ${issue.origin} to be ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Invalid string: must start with "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Invalid string: must end with "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Invalid string: must include "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Invalid string: must match pattern ${_issue.pattern}`;
                    return `Invalid ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Invalid number: must be a multiple of ${issue.divisor}`;
            case "unrecognized_keys":
                return `Unrecognized key${issue.keys.length > 1 ? "s" : ""}: ${$23ixW.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Invalid key in ${issue.origin}`;
            case "invalid_union":
                if (issue.options && Array.isArray(issue.options) && issue.options.length > 0) {
                    const opts = issue.options.map((o)=>`'${o}'`).join(" | ");
                    return `Invalid discriminator value. Expected ${opts}`;
                }
                if (issue.inclusive === false) return "Invalid input: more than one option matched";
                return "Invalid input";
            case "invalid_element":
                return `Invalid value in ${issue.origin}`;
            default:
                return `Invalid input`;
        }
    };
};
function $f94f9f481fcdc5e7$export$2e2bcd8739ae039() {
    return {
        localeError: $f94f9f481fcdc5e7$var$error()
    };
}

});

parcelRegister("lLi5e", function(module, exports) {

$parcel$export(module.exports, "parse", () => $fd7c03c13241ea63$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseAsync", () => $fd7c03c13241ea63$export$59b6f938fbf579e3);
$parcel$export(module.exports, "safeParse", () => $fd7c03c13241ea63$export$b48ee232557adc37);
$parcel$export(module.exports, "safeParseAsync", () => $fd7c03c13241ea63$export$9b07b0d6e0389261);
$parcel$export(module.exports, "encode", () => $fd7c03c13241ea63$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $fd7c03c13241ea63$export$2f872c0f2117be69);
$parcel$export(module.exports, "encodeAsync", () => $fd7c03c13241ea63$export$1a62660bbffb8f11);
$parcel$export(module.exports, "decodeAsync", () => $fd7c03c13241ea63$export$e4c183687a6ff9b);
$parcel$export(module.exports, "safeEncode", () => $fd7c03c13241ea63$export$c094f85f253e4d7d);
$parcel$export(module.exports, "safeDecode", () => $fd7c03c13241ea63$export$7a47376c130cfeac);
$parcel$export(module.exports, "safeEncodeAsync", () => $fd7c03c13241ea63$export$ed163a34170fecc5);
$parcel$export(module.exports, "safeDecodeAsync", () => $fd7c03c13241ea63$export$9f879005292a9bc9);

var $57W0y = parcelRequire("57W0y");

var $jlVOs = parcelRequire("jlVOs");
const $fd7c03c13241ea63$export$98e6a39c04603d36 = /* @__PURE__ */ $57W0y._parse((0, $jlVOs.ZodRealError));
const $fd7c03c13241ea63$export$59b6f938fbf579e3 = /* @__PURE__ */ $57W0y._parseAsync((0, $jlVOs.ZodRealError));
const $fd7c03c13241ea63$export$b48ee232557adc37 = /* @__PURE__ */ $57W0y._safeParse((0, $jlVOs.ZodRealError));
const $fd7c03c13241ea63$export$9b07b0d6e0389261 = /* @__PURE__ */ $57W0y._safeParseAsync((0, $jlVOs.ZodRealError));
const $fd7c03c13241ea63$export$c564cdbbe6da493 = /* @__PURE__ */ $57W0y._encode((0, $jlVOs.ZodRealError));
const $fd7c03c13241ea63$export$2f872c0f2117be69 = /* @__PURE__ */ $57W0y._decode((0, $jlVOs.ZodRealError));
const $fd7c03c13241ea63$export$1a62660bbffb8f11 = /* @__PURE__ */ $57W0y._encodeAsync((0, $jlVOs.ZodRealError));
const $fd7c03c13241ea63$export$e4c183687a6ff9b = /* @__PURE__ */ $57W0y._decodeAsync((0, $jlVOs.ZodRealError));
const $fd7c03c13241ea63$export$c094f85f253e4d7d = /* @__PURE__ */ $57W0y._safeEncode((0, $jlVOs.ZodRealError));
const $fd7c03c13241ea63$export$7a47376c130cfeac = /* @__PURE__ */ $57W0y._safeDecode((0, $jlVOs.ZodRealError));
const $fd7c03c13241ea63$export$ed163a34170fecc5 = /* @__PURE__ */ $57W0y._safeEncodeAsync((0, $jlVOs.ZodRealError));
const $fd7c03c13241ea63$export$9f879005292a9bc9 = /* @__PURE__ */ $57W0y._safeDecodeAsync((0, $jlVOs.ZodRealError));

});
parcelRegister("jlVOs", function(module, exports) {

$parcel$export(module.exports, "ZodRealError", () => $e16cd2eede213549$export$42f76a3b4eb5449a);

var $5SN0M = parcelRequire("5SN0M");
var $YNwBR = parcelRequire("YNwBR");

var $23ixW = parcelRequire("23ixW");
/* Prototypes that already carry the lazy helper methods. Seeded with the
 * intrinsics so that `init` on a foreign object — it accepts any object —
 * can never install an accessor onto a prototype we do not own. */ const $e16cd2eede213549$var$_installedErrorProtos = /* @__PURE__ */ new WeakSet([
    Object.prototype,
    Error.prototype
]);
/* Helper methods live as non-enumerable lazy getters on the shared
 * prototype instead of own properties on every instance. On first
 * access the getter allocates the per-instance closure and caches it
 * as a non-enumerable own property, so detached usage still works and
 * the allocation only happens for methods actually touched. */ function $e16cd2eede213549$var$_lazyMethod(proto, key, make) {
    Object.defineProperty(proto, key, {
        configurable: true,
        enumerable: false,
        get () {
            const value = make(this);
            Object.defineProperty(this, key, {
                value: value,
                configurable: true,
                writable: true
            });
            return value;
        },
        set (value) {
            Object.defineProperty(this, key, {
                value: value,
                configurable: true,
                writable: true
            });
        }
    });
}
const $e16cd2eede213549$var$initializer = (inst, issues)=>{
    (0, $YNwBR.$ZodError).init(inst, issues);
    inst.name = "ZodError";
    const proto = Object.getPrototypeOf(inst);
    if ($e16cd2eede213549$var$_installedErrorProtos.has(proto)) return;
    $e16cd2eede213549$var$_installedErrorProtos.add(proto);
    $e16cd2eede213549$var$_lazyMethod(proto, "format", (self)=>(mapper)=>$YNwBR.formatError(self, mapper));
    $e16cd2eede213549$var$_lazyMethod(proto, "flatten", (self)=>(mapper)=>$YNwBR.flattenError(self, mapper));
    $e16cd2eede213549$var$_lazyMethod(proto, "addIssue", (self)=>(issue)=>{
            self.issues.push(issue);
            self.message = JSON.stringify(self.issues, $23ixW.jsonStringifyReplacer, 2);
        });
    $e16cd2eede213549$var$_lazyMethod(proto, "addIssues", (self)=>(issues)=>{
            self.issues.push(...issues);
            self.message = JSON.stringify(self.issues, $23ixW.jsonStringifyReplacer, 2);
        });
    Object.defineProperty(proto, "isEmpty", {
        configurable: true,
        enumerable: false,
        get () {
            return this.issues.length === 0;
        }
    });
};
const $e16cd2eede213549$export$f98dac4b251ab333 = /*@__PURE__*/ $5SN0M.$constructor("ZodError", $e16cd2eede213549$var$initializer);
const $e16cd2eede213549$export$42f76a3b4eb5449a = /*@__PURE__*/ $5SN0M.$constructor("ZodError", $e16cd2eede213549$var$initializer, undefined, {
    Parent: Error
}); // /** @deprecated Use `z.core.$ZodErrorMapCtx` instead. */
 // export type ErrorMapCtx = core.$ZodErrorMapCtx;

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



var $7c30baa29d2eb832$var$genericMessage = "Invariant Violation";
var $7c30baa29d2eb832$var$_a = Object.setPrototypeOf, $7c30baa29d2eb832$var$setPrototypeOf = $7c30baa29d2eb832$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $7c30baa29d2eb832$var$_a;
var $7c30baa29d2eb832$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $7c30baa29d2eb832$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $7c30baa29d2eb832$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $7c30baa29d2eb832$var$genericMessage;
        $7c30baa29d2eb832$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $7c30baa29d2eb832$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $7c30baa29d2eb832$export$cea12affaee22fe8(message);
}
var $7c30baa29d2eb832$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $7c30baa29d2eb832$var$verbosityLevel = $7c30baa29d2eb832$var$verbosityLevels.indexOf("log");
function $7c30baa29d2eb832$var$wrapConsoleMethod(name) {
    return function() {
        if ($7c30baa29d2eb832$var$verbosityLevels.indexOf(name) >= $7c30baa29d2eb832$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $7c30baa29d2eb832$var$wrapConsoleMethod("debug");
    invariant.log = $7c30baa29d2eb832$var$wrapConsoleMethod("log");
    invariant.warn = $7c30baa29d2eb832$var$wrapConsoleMethod("warn");
    invariant.error = $7c30baa29d2eb832$var$wrapConsoleMethod("error");
})($7c30baa29d2eb832$export$f5708dca728d7177 || ($7c30baa29d2eb832$export$f5708dca728d7177 = {}));
function $7c30baa29d2eb832$export$a80e09f2cd325fb8(level) {
    var old = $7c30baa29d2eb832$var$verbosityLevels[$7c30baa29d2eb832$var$verbosityLevel];
    $7c30baa29d2eb832$var$verbosityLevel = Math.max(0, $7c30baa29d2eb832$var$verbosityLevels.indexOf(level));
    return old;
}
var $7c30baa29d2eb832$export$2e2bcd8739ae039 = $7c30baa29d2eb832$export$f5708dca728d7177;


var $fb2c94d2c044c7c5$export$83d89fbfd8236492 = "3.14.0";


function $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $d461b0c33b06d27f$export$2e2bcd8739ae039 = (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf).constructor("return this")();
});


var $14071c0503b706b7$var$prefixCounts = new Map();
function $14071c0503b706b7$export$d0c8ec0fe1b18b70(prefix) {
    var count = $14071c0503b706b7$var$prefixCounts.get(prefix) || 1;
    $14071c0503b706b7$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}


function $29a424226342d3ac$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $14071c0503b706b7$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}


function $28d90d877eb1e517$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $28d90d877eb1e517$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $28d90d877eb1e517$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $28d90d877eb1e517$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $7c30baa29d2eb832$export$f5708dca728d7177)(condition, $28d90d877eb1e517$var$getHandledErrorMsg(message, args) || $28d90d877eb1e517$var$getFallbackErrorMsg(message, args));
}, {
    debug: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).debug),
    log: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).log),
    warn: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).warn),
    error: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $28d90d877eb1e517$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $7c30baa29d2eb832$export$cea12affaee22fe8)($28d90d877eb1e517$var$getHandledErrorMsg(message, optionalParams) || $28d90d877eb1e517$var$getFallbackErrorMsg(message, optionalParams));
}
var $28d90d877eb1e517$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $fb2c94d2c044c7c5$export$83d89fbfd8236492));
function $28d90d877eb1e517$var$stringify(arg) {
    if (typeof arg == "string") return arg;
    try {
        return (0, $29a424226342d3ac$export$f341b4883239463f)(arg, 2).slice(0, 1000);
    } catch (_a) {
        return "<non-serializable>";
    }
}
function $28d90d877eb1e517$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $d461b0c33b06d27f$export$2e2bcd8739ae039)[$28d90d877eb1e517$export$b8ca975fa04efdf3] && (0, $d461b0c33b06d27f$export$2e2bcd8739ae039)[$28d90d877eb1e517$export$b8ca975fa04efdf3](message, messageArgs.map($28d90d877eb1e517$var$stringify));
}
function $28d90d877eb1e517$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $fb2c94d2c044c7c5$export$83d89fbfd8236492),
        message: message,
        args: messageArgs.map($28d90d877eb1e517$var$stringify)
    })));
}




var $bd560f7419fc8fee$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;



function $6d99a9de69717ea6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6d99a9de69717ea6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d99a9de69717ea6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6d99a9de69717ea6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6d99a9de69717ea6$var$_arrayLikeToArray(o, minLen);
}
function $6d99a9de69717ea6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6d99a9de69717ea6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6d99a9de69717ea6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6d99a9de69717ea6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6d99a9de69717ea6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $6d99a9de69717ea6$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $6d99a9de69717ea6$var$hasSymbol = function(name) {
    return $6d99a9de69717ea6$var$hasSymbols() && Boolean(Symbol[name]);
};
var $6d99a9de69717ea6$var$getSymbol = function(name) {
    return $6d99a9de69717ea6$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($6d99a9de69717ea6$var$hasSymbols() && !$6d99a9de69717ea6$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $6d99a9de69717ea6$var$SymbolIterator = $6d99a9de69717ea6$var$getSymbol('iterator');
var $6d99a9de69717ea6$var$SymbolObservable = $6d99a9de69717ea6$var$getSymbol('observable');
var $6d99a9de69717ea6$var$SymbolSpecies = $6d99a9de69717ea6$var$getSymbol('species'); // === Abstract Operations ===
function $6d99a9de69717ea6$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $6d99a9de69717ea6$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$6d99a9de69717ea6$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $6d99a9de69717ea6$export$77cea355fa80b5f4;
}
function $6d99a9de69717ea6$var$isObservable(x) {
    return x instanceof $6d99a9de69717ea6$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $6d99a9de69717ea6$var$hostReportError(e) {
    if ($6d99a9de69717ea6$var$hostReportError.log) $6d99a9de69717ea6$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $6d99a9de69717ea6$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $6d99a9de69717ea6$var$hostReportError(e);
        }
    });
}
function $6d99a9de69717ea6$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $6d99a9de69717ea6$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $6d99a9de69717ea6$var$hostReportError(e);
    }
}
function $6d99a9de69717ea6$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $6d99a9de69717ea6$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $6d99a9de69717ea6$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $6d99a9de69717ea6$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $6d99a9de69717ea6$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $6d99a9de69717ea6$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $6d99a9de69717ea6$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $6d99a9de69717ea6$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $6d99a9de69717ea6$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $6d99a9de69717ea6$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $6d99a9de69717ea6$var$enqueue(function() {
            return $6d99a9de69717ea6$var$flushSubscription(subscription);
        });
        return;
    }
    $6d99a9de69717ea6$var$notifySubscription(subscription, type, value);
}
var $6d99a9de69717ea6$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $6d99a9de69717ea6$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $6d99a9de69717ea6$var$closeSubscription(this);
            $6d99a9de69717ea6$var$cleanupSubscription(this);
        }
    };
    $6d99a9de69717ea6$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $6d99a9de69717ea6$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $6d99a9de69717ea6$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $6d99a9de69717ea6$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $6d99a9de69717ea6$var$onNotify(this._subscription, 'complete');
    };
    $6d99a9de69717ea6$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $6d99a9de69717ea6$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $6d99a9de69717ea6$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$6d99a9de69717ea6$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $6d99a9de69717ea6$var$getMethod(x, $6d99a9de69717ea6$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($6d99a9de69717ea6$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($6d99a9de69717ea6$var$hasSymbol('iterator')) {
            method = $6d99a9de69717ea6$var$getMethod(x, $6d99a9de69717ea6$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $6d99a9de69717ea6$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $6d99a9de69717ea6$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $6d99a9de69717ea6$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $6d99a9de69717ea6$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $6d99a9de69717ea6$var$_createClass(Observable, null, [
        {
            key: $6d99a9de69717ea6$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($6d99a9de69717ea6$var$hasSymbols()) Object.defineProperty($6d99a9de69717ea6$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $6d99a9de69717ea6$var$SymbolObservable,
        hostReportError: $6d99a9de69717ea6$var$hostReportError
    },
    configurable: true
});


parcelRequire("6Z7su");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $58650dd67955ab9d$var$prototype = (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).prototype;
var $58650dd67955ab9d$var$fakeObsSymbol = "@@observable";
if (!$58650dd67955ab9d$var$prototype[$58650dd67955ab9d$var$fakeObsSymbol]) // @ts-expect-error
$58650dd67955ab9d$var$prototype[$58650dd67955ab9d$var$fakeObsSymbol] = function() {
    return this;
};



function $159d5dc79a8added$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}



function $3a16601e2096f4cd$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $3a16601e2096f4cd$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}




function $8beb5260c793fc92$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $9541a54af6a37409$var$MAX_ARRAY_LENGTH = 10;
const $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH = 2;
function $9541a54af6a37409$export$9dec5d1b3b6a130d(value) {
    return $9541a54af6a37409$var$formatValue(value, []);
}
function $9541a54af6a37409$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $9541a54af6a37409$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $9541a54af6a37409$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($9541a54af6a37409$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $9541a54af6a37409$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $9541a54af6a37409$var$formatArray(value, seenValues);
    return $9541a54af6a37409$var$formatObject(value, seenValues);
}
function $9541a54af6a37409$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $9541a54af6a37409$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return '[' + $9541a54af6a37409$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $9541a54af6a37409$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $9541a54af6a37409$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($9541a54af6a37409$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($9541a54af6a37409$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $9541a54af6a37409$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $11b06753ce50693f$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $11b06753ce50693f$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $11b06753ce50693f$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'description',
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ],
    TypeCoordinate: [
        'name'
    ],
    MemberCoordinate: [
        'name',
        'memberName'
    ],
    ArgumentCoordinate: [
        'name',
        'fieldName',
        'argumentName'
    ],
    DirectiveCoordinate: [
        'name'
    ],
    DirectiveArgumentCoordinate: [
        'name',
        'argumentName'
    ]
};
const $11b06753ce50693f$var$kindValues = new Set(Object.keys($11b06753ce50693f$export$4fcd777a40ccf407));
function $11b06753ce50693f$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $11b06753ce50693f$var$kindValues.has(maybeKind);
}
/** Name */ var $11b06753ce50693f$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($11b06753ce50693f$export$f58c50edb4aef9d4 || ($11b06753ce50693f$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed kind values for AST nodes.
 */ var $b7b8db97a7d116fe$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
    Kind['TYPE_COORDINATE'] = 'TypeCoordinate';
    Kind['MEMBER_COORDINATE'] = 'MemberCoordinate';
    Kind['ARGUMENT_COORDINATE'] = 'ArgumentCoordinate';
    Kind['DIRECTIVE_COORDINATE'] = 'DirectiveCoordinate';
    Kind['DIRECTIVE_ARGUMENT_COORDINATE'] = 'DirectiveArgumentCoordinate';
})($b7b8db97a7d116fe$export$a84bdc57c5122798 || ($b7b8db97a7d116fe$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 

const $78b48476e314521e$export$a89c95c098ac2a58 = Object.freeze({});
function $78b48476e314521e$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $11b06753ce50693f$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $b7b8db97a7d116fe$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $78b48476e314521e$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = {
                        ...node
                    };
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $11b06753ce50693f$export$8ee0fc9ee280b4ee)(node) || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $9541a54af6a37409$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $78b48476e314521e$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $11b06753ce50693f$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $78b48476e314521e$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $b7b8db97a7d116fe$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $78b48476e314521e$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $78b48476e314521e$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $78b48476e314521e$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $78b48476e314521e$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $7f688c9754699513$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $28d90d877eb1e517$export$3991762405098ea)(113, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragments.length === 1, 114, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $7f688c9754699513$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $7f688c9754699513$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragment, 115, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}
function $7f688c9754699513$export$5b84f3d7865d4e49(document) {
    var isUnmasked = true;
    (0, $78b48476e314521e$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: function(node) {
            isUnmasked = !!node.directives && node.directives.some(function(directive) {
                return directive.name.value === "unmask";
            });
            if (!isUnmasked) return 0, $78b48476e314521e$export$a89c95c098ac2a58;
        }
    });
    return isUnmasked;
}


function $557c26506c40b8f1$var$defaultDispose() {}
class $557c26506c40b8f1$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $557c26506c40b8f1$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

function $947797cdb9e55a2d$var$noop() {}
const $947797cdb9e55a2d$var$defaultDispose = $947797cdb9e55a2d$var$noop;
const $947797cdb9e55a2d$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $947797cdb9e55a2d$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $947797cdb9e55a2d$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $947797cdb9e55a2d$var$noop,
        unregister: $947797cdb9e55a2d$var$noop
    };
};
const $947797cdb9e55a2d$var$finalizationBatchSize = 10024;
class $947797cdb9e55a2d$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $947797cdb9e55a2d$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $947797cdb9e55a2d$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $947797cdb9e55a2d$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $947797cdb9e55a2d$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $947797cdb9e55a2d$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}


var $b3ac5bdec858bda0$var$scheduledCleanup = new WeakSet();
function $b3ac5bdec858bda0$var$schedule(cache) {
    if (cache.size <= (cache.max || -1)) return;
    if (!$b3ac5bdec858bda0$var$scheduledCleanup.has(cache)) {
        $b3ac5bdec858bda0$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $b3ac5bdec858bda0$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $b3ac5bdec858bda0$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $947797cdb9e55a2d$export$87b462129af3b7d4)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $947797cdb9e55a2d$export$87b462129af3b7d4).prototype.set.call(this, key, value);
        $b3ac5bdec858bda0$var$schedule(this);
        return ret;
    };
    return cache;
};
var $b3ac5bdec858bda0$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $557c26506c40b8f1$export$d3a0331d2c286dc8)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $557c26506c40b8f1$export$d3a0331d2c286dc8).prototype.set.call(this, key, value);
        $b3ac5bdec858bda0$var$schedule(this);
        return ret;
    };
    return cache;
};



var $c506be9be1a65610$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $c506be9be1a65610$export$f29926b23b28936b = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $d461b0c33b06d27f$export$2e2bcd8739ae039)[$c506be9be1a65610$var$cacheSizeSymbol]);




var $1da01699264b6e1e$var$globalCaches = {};
function $1da01699264b6e1e$export$a8fcd406d9e37621(name, getSize) {
    $1da01699264b6e1e$var$globalCaches[name] = getSize;
}
var $1da01699264b6e1e$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $1da01699264b6e1e$var$_getApolloClientMemoryInternals : undefined;
var $1da01699264b6e1e$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $1da01699264b6e1e$var$_getInMemoryCacheMemoryInternals : undefined;
var $1da01699264b6e1e$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $1da01699264b6e1e$var$_getApolloCacheMemoryInternals : undefined;
function $1da01699264b6e1e$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $c506be9be1a65610$export$f29926b23b28936b)[k] || v
        ];
    }));
}
function $1da01699264b6e1e$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $1da01699264b6e1e$var$getCurrentCacheSizes(),
        sizes: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            print: (_a = $1da01699264b6e1e$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($1da01699264b6e1e$var$globalCaches),
            parser: (_b = $1da01699264b6e1e$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($1da01699264b6e1e$var$globalCaches),
            canonicalStringify: (_c = $1da01699264b6e1e$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($1da01699264b6e1e$var$globalCaches),
            links: $1da01699264b6e1e$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $1da01699264b6e1e$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $1da01699264b6e1e$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $1da01699264b6e1e$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $1da01699264b6e1e$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $1da01699264b6e1e$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $1da01699264b6e1e$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $1da01699264b6e1e$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $1da01699264b6e1e$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $1da01699264b6e1e$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $1da01699264b6e1e$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $1da01699264b6e1e$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $1da01699264b6e1e$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $1da01699264b6e1e$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $1da01699264b6e1e$var$getWrapperInformation(f) {
    return $1da01699264b6e1e$var$isWrapper(f) ? f.size : undefined;
}
function $1da01699264b6e1e$var$isDefined(value) {
    return value != null;
}
function $1da01699264b6e1e$var$transformInfo(transform) {
    return $1da01699264b6e1e$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $1da01699264b6e1e$var$recurseTransformInfo(transform) {
    return transform ? (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        $1da01699264b6e1e$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $1da01699264b6e1e$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $1da01699264b6e1e$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($1da01699264b6e1e$var$isDefined) : [];
}
function $1da01699264b6e1e$var$linkInfo(link) {
    var _a;
    return link ? (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $1da01699264b6e1e$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $1da01699264b6e1e$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($1da01699264b6e1e$var$isDefined) : [];
}


var $0bef48da5254bd54$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $0bef48da5254bd54$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $0bef48da5254bd54$var$sortingMap = new (0, $b3ac5bdec858bda0$export$5b4f745137d91413)((0, $c506be9be1a65610$export$f29926b23b28936b).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $1da01699264b6e1e$export$a8fcd406d9e37621)("canonicalStringify", function() {
    return $0bef48da5254bd54$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $0bef48da5254bd54$var$sortingMap;
$0bef48da5254bd54$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $0bef48da5254bd54$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($0bef48da5254bd54$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $0bef48da5254bd54$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $0bef48da5254bd54$var$sortingMap.get(sortedKey) || keys;
                $0bef48da5254bd54$var$sortingMap.set(unsortedKey, sortedKeys);
                $0bef48da5254bd54$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $0bef48da5254bd54$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}


function $9d830e5028848843$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $9d830e5028848843$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $9d830e5028848843$export$540432d49fcec6c9(value) {
    return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $9d830e5028848843$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $9d830e5028848843$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $9d830e5028848843$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $9d830e5028848843$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $9d830e5028848843$var$isVariable(value) {
    return value.kind === "Variable";
}
function $9d830e5028848843$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $9d830e5028848843$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $9d830e5028848843$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $9d830e5028848843$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $9d830e5028848843$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($9d830e5028848843$var$isIntValue(value) || $9d830e5028848843$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($9d830e5028848843$var$isBooleanValue(value) || $9d830e5028848843$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($9d830e5028848843$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $9d830e5028848843$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($9d830e5028848843$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($9d830e5028848843$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $9d830e5028848843$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($9d830e5028848843$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($9d830e5028848843$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $28d90d877eb1e517$export$3991762405098ea)(124, name.value, value.kind);
}
function $9d830e5028848843$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $9d830e5028848843$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $9d830e5028848843$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $9d830e5028848843$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $9d830e5028848843$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $9d830e5028848843$var$storeKeyNameStringify = (0, $0bef48da5254bd54$export$88a0ad9b6f961b51);
var $9d830e5028848843$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($9d830e5028848843$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $9d830e5028848843$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($9d830e5028848843$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($9d830e5028848843$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $9d830e5028848843$var$storeKeyNameStringify;
        $9d830e5028848843$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $9d830e5028848843$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $9d830e5028848843$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $9d830e5028848843$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $9d830e5028848843$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($9d830e5028848843$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$9d830e5028848843$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $9d830e5028848843$export$cf7bf7e4f289cc26(result, (0, $7f688c9754699513$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $9d830e5028848843$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $9d830e5028848843$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}


function $818d93327cb72c29$export$a7d0d8111d2386df(doc) {
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(doc && doc.kind === "Document", 116);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $28d90d877eb1e517$export$3991762405098ea)(117, definition.kind);
        return definition;
    });
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(operations.length <= 1, 118, operations.length);
    return doc;
}
function $818d93327cb72c29$export$7a5b1fa979d2c158(doc) {
    $818d93327cb72c29$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $818d93327cb72c29$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $818d93327cb72c29$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $818d93327cb72c29$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $818d93327cb72c29$export$7a5b1fa979d2c158(doc);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 119);
    return queryDef;
}
function $818d93327cb72c29$export$772111caef41b3f5(doc) {
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(doc.kind === "Document", 120);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(doc.definitions.length <= 1, 121);
    var fragmentDef = doc.definitions[0];
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 122);
    return fragmentDef;
}
function $818d93327cb72c29$export$f431198736b7f96d(queryDoc) {
    $818d93327cb72c29$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $28d90d877eb1e517$export$3991762405098ea)(123);
}
function $818d93327cb72c29$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $9d830e5028848843$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}


function $6a49a3d7d64e95e4$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}


function $f3beb697e0729913$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $28d90d877eb1e517$export$3991762405098ea)(58, key);
    }
    return operation;
}



// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $02443dfd16cf74b4$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $02443dfd16cf74b4$var$forEach, slice: $02443dfd16cf74b4$var$slice } = Array.prototype;
const { hasOwnProperty: $02443dfd16cf74b4$var$hasOwnProperty } = Object.prototype;
class $02443dfd16cf74b4$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $02443dfd16cf74b4$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $02443dfd16cf74b4$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $02443dfd16cf74b4$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($02443dfd16cf74b4$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($02443dfd16cf74b4$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $02443dfd16cf74b4$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $02443dfd16cf74b4$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $02443dfd16cf74b4$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}



// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $1b7dab7b0d0a41be$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $1b7dab7b0d0a41be$var$MISSING_VALUE = {};
let $1b7dab7b0d0a41be$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $1b7dab7b0d0a41be$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $1b7dab7b0d0a41be$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $1b7dab7b0d0a41be$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $1b7dab7b0d0a41be$var$MISSING_VALUE) break;
                if (context !== $1b7dab7b0d0a41be$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $1b7dab7b0d0a41be$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($1b7dab7b0d0a41be$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $1b7dab7b0d0a41be$var$currentContext.slots[this.id] = $1b7dab7b0d0a41be$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $1b7dab7b0d0a41be$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $1b7dab7b0d0a41be$var$currentContext;
            $1b7dab7b0d0a41be$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $1b7dab7b0d0a41be$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $1b7dab7b0d0a41be$var$currentContext;
            return function() {
                const saved = $1b7dab7b0d0a41be$var$currentContext;
                try {
                    $1b7dab7b0d0a41be$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $1b7dab7b0d0a41be$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($1b7dab7b0d0a41be$var$currentContext) {
                const saved = $1b7dab7b0d0a41be$var$currentContext;
                try {
                    $1b7dab7b0d0a41be$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $1b7dab7b0d0a41be$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $1b7dab7b0d0a41be$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $1b7dab7b0d0a41be$var$globalKey = "@wry/context:Slot";
const $1b7dab7b0d0a41be$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$1b7dab7b0d0a41be$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$1b7dab7b0d0a41be$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $1b7dab7b0d0a41be$var$globalHost = $1b7dab7b0d0a41be$var$host;
const $1b7dab7b0d0a41be$export$8c6ed5c666ac1360 = $1b7dab7b0d0a41be$var$globalHost[$1b7dab7b0d0a41be$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$1b7dab7b0d0a41be$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($1b7dab7b0d0a41be$var$globalHost, $1b7dab7b0d0a41be$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($1b7dab7b0d0a41be$var$makeSlotClass());


const { bind: $1f2d3d2c6c19c650$export$2385a24977818dd0, noContext: $1f2d3d2c6c19c650$export$9fa6f2e300a97f8 } = (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360);
function $1f2d3d2c6c19c650$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($1f2d3d2c6c19c650$export$2385a24977818dd0(callback), delay);
}
function $1f2d3d2c6c19c650$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $1f2d3d2c6c19c650$export$2385a24977818dd0(gen.next);
        const boundThrow = $1f2d3d2c6c19c650$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($1f2d3d2c6c19c650$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $1f2d3d2c6c19c650$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $1f2d3d2c6c19c650$var$wrappedFibers = [];
function $1f2d3d2c6c19c650$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($1f2d3d2c6c19c650$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $1f2d3d2c6c19c650$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $1f2d3d2c6c19c650$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


const $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1 = new (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360)();
function $ef3c9a5ce6618ec2$export$d906efd39458576(fn) {
    return $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1.withValue(void 0, fn);
}


const { hasOwnProperty: $ad641868d96e626a$export$5a15a386532a5ea4 } = Object.prototype;
const $ad641868d96e626a$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $ad641868d96e626a$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}


const $2a376116df8c597f$var$emptySetPool = [];
const $2a376116df8c597f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $2a376116df8c597f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $2a376116df8c597f$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $2a376116df8c597f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $2a376116df8c597f$var$valueCopy(value) {
    return value.slice(0);
}
class $2a376116df8c597f$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$2a376116df8c597f$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$2a376116df8c597f$var$mightBeDirty(this)) {
            $2a376116df8c597f$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $2a376116df8c597f$var$assert(!this.recomputing, "already recomputing");
        $2a376116df8c597f$var$rememberParent(this);
        return $2a376116df8c597f$var$mightBeDirty(this) ? $2a376116df8c597f$var$reallyRecompute(this, args) : $2a376116df8c597f$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $2a376116df8c597f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $ad641868d96e626a$export$50527b97338c0f71)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $2a376116df8c597f$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $2a376116df8c597f$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $2a376116df8c597f$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $2a376116df8c597f$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $ad641868d96e626a$export$1eb72f2488cedd93)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $2a376116df8c597f$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$2a376116df8c597f$export$3bb977b3ba9d3b59.count = 0;
function $2a376116df8c597f$var$rememberParent(child) {
    const parent = (0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($2a376116df8c597f$var$mightBeDirty(child)) $2a376116df8c597f$var$reportDirtyChild(parent, child);
        else $2a376116df8c597f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $2a376116df8c597f$var$reallyRecompute(entry, args) {
    $2a376116df8c597f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).withValue(entry, $2a376116df8c597f$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($2a376116df8c597f$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $2a376116df8c597f$var$setClean(entry);
    return $2a376116df8c597f$var$valueGet(entry.value);
}
function $2a376116df8c597f$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $2a376116df8c597f$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$2a376116df8c597f$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $2a376116df8c597f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $2a376116df8c597f$var$setClean(entry) {
    entry.dirty = false;
    if ($2a376116df8c597f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $2a376116df8c597f$var$reportClean(entry);
}
function $2a376116df8c597f$var$reportDirty(child) {
    $2a376116df8c597f$var$eachParent(child, $2a376116df8c597f$var$reportDirtyChild);
}
function $2a376116df8c597f$var$reportClean(child) {
    $2a376116df8c597f$var$eachParent(child, $2a376116df8c597f$var$reportCleanChild);
}
function $2a376116df8c597f$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $ad641868d96e626a$export$1eb72f2488cedd93)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $2a376116df8c597f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $2a376116df8c597f$var$assert(parent.childValues.has(child));
    $2a376116df8c597f$var$assert($2a376116df8c597f$var$mightBeDirty(child));
    const parentWasClean = !$2a376116df8c597f$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $2a376116df8c597f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $2a376116df8c597f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $2a376116df8c597f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $2a376116df8c597f$var$assert(parent.childValues.has(child));
    $2a376116df8c597f$var$assert(!$2a376116df8c597f$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $2a376116df8c597f$var$valueCopy(child.value));
    else if (!$2a376116df8c597f$var$valueIs(childValue, child.value)) parent.setDirty();
    $2a376116df8c597f$var$removeDirtyChild(parent, child);
    if ($2a376116df8c597f$var$mightBeDirty(parent)) return;
    $2a376116df8c597f$var$reportClean(parent);
}
function $2a376116df8c597f$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($2a376116df8c597f$var$emptySetPool.length < $2a376116df8c597f$var$POOL_TARGET_SIZE) $2a376116df8c597f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $2a376116df8c597f$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $2a376116df8c597f$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $2a376116df8c597f$var$assert(parent.dirtyChildren === null);
}
function $2a376116df8c597f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $2a376116df8c597f$var$removeDirtyChild(parent, child);
}
function $2a376116df8c597f$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $ad641868d96e626a$export$50527b97338c0f71)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}





const $f96bffcf733fdbbf$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $f96bffcf733fdbbf$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $ad641868d96e626a$export$50527b97338c0f71)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $ad641868d96e626a$export$5a15a386532a5ea4).call($f96bffcf733fdbbf$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $ad641868d96e626a$export$1eb72f2488cedd93)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $ad641868d96e626a$export$50527b97338c0f71)(dep);
        }
    };
    return depend;
}


// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $0fc5e093b69637b4$var$defaultKeyTrie;
function $0fc5e093b69637b4$export$cd3144f8dd136006(...args) {
    const trie = $0fc5e093b69637b4$var$defaultKeyTrie || ($0fc5e093b69637b4$var$defaultKeyTrie = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $0fc5e093b69637b4$var$caches = new Set();
function $0fc5e093b69637b4$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $0fc5e093b69637b4$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $557c26506c40b8f1$export$d3a0331d2c286dc8) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $2a376116df8c597f$export$3bb977b3ba9d3b59)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $0fc5e093b69637b4$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).hasValue()) {
            $0fc5e093b69637b4$var$caches.forEach((cache)=>cache.clean());
            $0fc5e093b69637b4$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}



var $c7b1e48e566741e9$var$muteAllDeprecations = Symbol.for("apollo.deprecations");
var $c7b1e48e566741e9$var$global = (0, $d461b0c33b06d27f$export$2e2bcd8739ae039);
var $c7b1e48e566741e9$var$slot = new (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360)();
function $c7b1e48e566741e9$var$isMuted(name) {
    return $c7b1e48e566741e9$var$global[$c7b1e48e566741e9$var$muteAllDeprecations] || ($c7b1e48e566741e9$var$slot.getValue() || []).includes(name);
}
function $c7b1e48e566741e9$export$d18d1529326946c4(name) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $c7b1e48e566741e9$var$slot.withValue.apply($c7b1e48e566741e9$var$slot, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        Array.isArray(name) ? name : [
            name
        ]
    ], args, false));
}
function $c7b1e48e566741e9$export$6d0d09df4c29a84a(options, name, callSite, recommendation) {
    if (recommendation === void 0) recommendation = "Please remove this option.";
    $c7b1e48e566741e9$export$606a5c06d13e04b6(name, function() {
        if (name in options) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(104, callSite, name, recommendation);
    });
}
function $c7b1e48e566741e9$export$606a5c06d13e04b6(name, cb) {
    if (!$c7b1e48e566741e9$var$isMuted(name)) cb();
}
function $c7b1e48e566741e9$export$7a58b5cb8fdfd94c() {
    var _a;
    var prev = $c7b1e48e566741e9$var$global[$c7b1e48e566741e9$var$muteAllDeprecations];
    $c7b1e48e566741e9$var$global[$c7b1e48e566741e9$var$muteAllDeprecations] = true;
    return _a = {}, _a[Symbol.dispose] = function() {
        $c7b1e48e566741e9$var$global[$c7b1e48e566741e9$var$muteAllDeprecations] = prev;
    }, _a;
}


function $60c07ffd02e3617d$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
}
function $60c07ffd02e3617d$var$toLink(handler) {
    return typeof handler === "function" ? new $60c07ffd02e3617d$export$2fed3d61f740bc7f(handler) : handler;
}
function $60c07ffd02e3617d$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $60c07ffd02e3617d$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($60c07ffd02e3617d$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $60c07ffd02e3617d$var$toLink(left);
        var rightLink = $60c07ffd02e3617d$var$toLink(right || new ApolloLink($60c07ffd02e3617d$var$passthrough));
        var ret;
        if ($60c07ffd02e3617d$var$isTerminating(leftLink) && $60c07ffd02e3617d$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $159d5dc79a8added$export$f29bedd62f56fcb2)(operation.context, (0, $6a49a3d7d64e95e4$export$4f3f7df1b558c729)((0, $f3beb697e0729913$export$a92a48117d546c9)(operation)))) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $60c07ffd02e3617d$var$toLink(first);
        if ($60c07ffd02e3617d$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(47, firstLink);
            return firstLink;
        }
        var nextLink = $60c07ffd02e3617d$var$toLink(second);
        var ret;
        if ($60c07ffd02e3617d$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
            }) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
            }) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($60c07ffd02e3617d$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $28d90d877eb1e517$export$3991762405098ea)(48);
    };
    /**
     * @deprecated `onError` will be removed with Apollo Client 4.0. Please
     * discontinue using this method.
     */ ApolloLink.prototype.onError = function(error, observer) {
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$606a5c06d13e04b6)("onError", function() {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(49);
        });
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    /**
     * @deprecated `setOnError` will be removed with Apollo Client 4.0. Please
     * discontinue using this method.
     */ ApolloLink.prototype.setOnError = function(fn) {
        if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(50);
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $88c17748fb93d3ed$export$51396ec711da548b = (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f).execute;










function $89c1eec09879e1ca$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $89c1eec09879e1ca$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(evaledValue !== void 0, 106, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $89c1eec09879e1ca$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $78b48476e314521e$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $89c1eec09879e1ca$export$528b5e7d8ba07fbf = function(names, root) {
    return $89c1eec09879e1ca$export$2dafb573e282fe8d(names, root, false);
};
var $89c1eec09879e1ca$export$ad1b63b26c1a9b76 = function(names, root) {
    return $89c1eec09879e1ca$export$2dafb573e282fe8d(names, root, true);
};
function $89c1eec09879e1ca$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $78b48476e314521e$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $78b48476e314521e$export$a89c95c098ac2a58;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $89c1eec09879e1ca$export$8d1e9e5bbfa5d09a(document) {
    return document && $89c1eec09879e1ca$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $89c1eec09879e1ca$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $89c1eec09879e1ca$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$89c1eec09879e1ca$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 107, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 108, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 109, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}
function $89c1eec09879e1ca$export$d6913ace4214003(fragment) {
    var _a, _b;
    var directive = (_a = fragment.directives) === null || _a === void 0 ? void 0 : _a.find(function(_a) {
        var name = _a.name;
        return name.value === "unmask";
    });
    if (!directive) return "mask";
    var modeArg = (_b = directive.arguments) === null || _b === void 0 ? void 0 : _b.find(function(_a) {
        var name = _a.name;
        return name.value === "mode";
    });
    if (globalThis.__DEV__ !== false) {
        if (modeArg) {
            if (modeArg.value.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(110);
            else if (modeArg.value.kind !== (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).STRING) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(111);
            else if (modeArg.value.value !== "migrate") globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(112, modeArg.value.value);
        }
    }
    if (modeArg && "value" in modeArg.value && modeArg.value.value === "migrate") return "migrate";
    return "unmask";
}







// A version of Array.isArray that works better with readonly arrays.
var $e6aaa0e65613edd7$export$43bee75e5e14138e = Array.isArray;
function $e6aaa0e65613edd7$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}


var $202b8a19e6086c64$var$TYPENAME_FIELD = {
    kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD,
    name: {
        kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAME,
        value: "__typename"
    }
};
function $202b8a19e6086c64$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD && $202b8a19e6086c64$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $202b8a19e6086c64$var$nullIfDocIsEmpty(doc) {
    return $202b8a19e6086c64$var$isEmpty((0, $818d93327cb72c29$export$7a5b1fa979d2c158)(doc) || (0, $818d93327cb72c29$export$772111caef41b3f5)(doc), (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $202b8a19e6086c64$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $202b8a19e6086c64$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $202b8a19e6086c64$export$e5ae0530da5fe96c(directives, doc) {
    (0, $818d93327cb72c29$export$a7d0d8111d2386df)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = $202b8a19e6086c64$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $202b8a19e6086c64$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(ancestor)) continue;
            if (ancestor.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(125);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $202b8a19e6086c64$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $202b8a19e6086c64$var$nullIfDocIsEmpty((0, $78b48476e314521e$export$bf638b60ea8b89b7)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $202b8a19e6086c64$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, $9d830e5028848843$export$fb56ad75dd311c12)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], selections, true), [
                        $202b8a19e6086c64$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $202b8a19e6086c64$var$TYPENAME_FIELD;
    }
});
var $202b8a19e6086c64$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(126);
        }
        return willRemove;
    }
};
function $202b8a19e6086c64$export$74985f3324559867(doc) {
    return $202b8a19e6086c64$export$e5ae0530da5fe96c([
        $202b8a19e6086c64$var$connectionRemoveConfig
    ], (0, $818d93327cb72c29$export$a7d0d8111d2386df)(doc));
}
function $202b8a19e6086c64$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $202b8a19e6086c64$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $202b8a19e6086c64$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($202b8a19e6086c64$var$getDirectiveMatcher(directives)) || nestedCheck && $202b8a19e6086c64$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $202b8a19e6086c64$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $202b8a19e6086c64$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $202b8a19e6086c64$var$getArgumentMatcher(config);
    return $202b8a19e6086c64$var$nullIfDocIsEmpty((0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $202b8a19e6086c64$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $202b8a19e6086c64$var$nullIfDocIsEmpty((0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $202b8a19e6086c64$export$57c368c23873f32b(document) {
    var definition = (0, $818d93327cb72c29$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, $78b48476e314521e$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $202b8a19e6086c64$export$8eae69e876ee321e(document) {
    (0, $818d93327cb72c29$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $202b8a19e6086c64$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}
function $202b8a19e6086c64$export$b6125cad5877ac5e(document) {
    (0, $818d93327cb72c29$export$a7d0d8111d2386df)(document);
    return (0, $78b48476e314521e$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: function(node) {
            var _a;
            // Do not add `@nonreactive` if the fragment is marked with `@unmask`
            // since we want to react to changes in this fragment.
            if ((_a = node.directives) === null || _a === void 0 ? void 0 : _a.some(function(directive) {
                return directive.name.value === "unmask";
            })) return;
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, node), {
                directives: (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], node.directives || [], true), [
                    {
                        kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE,
                        name: {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAME,
                            value: "nonreactive"
                        }
                    }
                ], false)
            });
        }
    });
}



var $c32b8dc3cfa701c7$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $28d90d877eb1e517$export$3991762405098ea)(54, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};


var $5a02450356081318$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};



/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ 
var $5d0a073f980bb2a3$var$isReactNative = (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.product;
}) == "ReactNative";
var $5d0a073f980bb2a3$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !($5d0a073f980bb2a3$var$isReactNative && !$parcel$global.HermesInternal);
var $5d0a073f980bb2a3$export$7293b8a0b474028d = typeof WeakSet === "function";
var $5d0a073f980bb2a3$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $5d0a073f980bb2a3$export$c34f882e9f1c1637 = $5d0a073f980bb2a3$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $5d0a073f980bb2a3$export$71594e8a50f746f4 = typeof (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return window.document.createElement;
}) === "function";
var $5d0a073f980bb2a3$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $5d0a073f980bb2a3$export$4001f6cd4a62405b = ($5d0a073f980bb2a3$export$71594e8a50f746f4 || $5d0a073f980bb2a3$var$isReactNative) && !$5d0a073f980bb2a3$var$usingJSDOM;


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ function $1601b71e849a21db$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ 
function $7a3bb2c4baa2eb3c$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ 
function $4a4ee00566e93faf$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ 
function $5fd38885ae4d12e0$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


function $fd4188fd4ad08084$var$isNodeResponse(value) {
    return !!value.body;
}
function $fd4188fd4ad08084$var$isReadableStream(value) {
    return !!value.getReader;
}
function $fd4188fd4ad08084$var$isAsyncIterableIterator(value) {
    return !!((0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) && value[Symbol.asyncIterator]);
}
function $fd4188fd4ad08084$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $fd4188fd4ad08084$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $fd4188fd4ad08084$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $fd4188fd4ad08084$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($fd4188fd4ad08084$var$isNodeResponse(response)) body = response.body;
    if ($fd4188fd4ad08084$var$isAsyncIterableIterator(body)) return (0, $1601b71e849a21db$export$2e2bcd8739ae039)(body);
    if ($fd4188fd4ad08084$var$isReadableStream(body)) return (0, $5fd38885ae4d12e0$export$2e2bcd8739ae039)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if ($fd4188fd4ad08084$var$isStreamableBlob(body)) return (0, $5fd38885ae4d12e0$export$2e2bcd8739ae039)(body.stream().getReader());
    if ($fd4188fd4ad08084$var$isBlob(body)) return (0, $4a4ee00566e93faf$export$2e2bcd8739ae039)(body.arrayBuffer());
    if ($fd4188fd4ad08084$var$isNodeReadableStream(body)) return (0, $7a3bb2c4baa2eb3c$export$2e2bcd8739ae039)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}


/**
 * @deprecated `throwServerError` will be removed in Apollo Client 4.0. This is
 * safe to use in Apollo Client 3.x.
 *
 * **Recommended now**
 *
 * No action needed
 *
 * **When migrating**
 *
 * `ServerError` is a subclass of `Error`. To throw a server error, use
 * `throw new ServerError(...)` instead.
 *
 * ```ts
 * throw new ServerError("error message", { response, result });
 * ```
 */ var $844103e0eea42137$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};





var $456cf4c370166a0f$export$4995664c1b49842e = Symbol();
function $456cf4c370166a0f$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$456cf4c370166a0f$export$4995664c1b49842e]);
    return false;
}
function $456cf4c370166a0f$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $456cf4c370166a0f$var$generateErrorMessage = function(err) {
    var errors = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $456cf4c370166a0f$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ApolloError, _super);
    // Constructs an instance of ApolloError given serialized GraphQL errors,
    // client errors, protocol errors or network errors.
    // Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $456cf4c370166a0f$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.cause = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            networkError
        ], graphQLErrors || [], true), protocolErrors || [], true), clientErrors || [], true).find(function(e) {
            return !!e;
        }) || null;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);






var $0217b27a7999d1ae$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0217b27a7999d1ae$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $0217b27a7999d1ae$export$160070228be94b08(sources);
}
function $0217b27a7999d1ae$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $0217b27a7999d1ae$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $0217b27a7999d1ae$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $0217b27a7999d1ae$export$509e11c221f576c0 = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $0217b27a7999d1ae$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $3a16601e2096f4cd$export$417207af72fad9c9);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(source) && (0, $3a16601e2096f4cd$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($0217b27a7999d1ae$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();


function $4753a78f97af1d82$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $4753a78f97af1d82$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $4753a78f97af1d82$export$f90dc0a3531b8b83(value) {
    return $4753a78f97af1d82$export$879767c5cdf33cb3(value) || $4753a78f97af1d82$export$6c17a45d8c64ff02(value);
}
function $4753a78f97af1d82$export$3f32b6369f408f33(value) {
    return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && "payload" in value;
}
function $4753a78f97af1d82$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
    if ($4753a78f97af1d82$export$879767c5cdf33cb3(result) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}


var $6ba89ebc2766b493$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6ba89ebc2766b493$export$ccb60864026baf09(response, nextValue) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _b, _c;
        var _d;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $fd4188fd4ad08084$export$7e4ac9ed9577f145)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _a = _e.sent(), value = _a.value, done = _a.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _b = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _b[0], buffer = _b[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $6ba89ebc2766b493$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $6ba89ebc2766b493$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $4753a78f97af1d82$export$3f32b6369f408f33)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        if (Object.keys(result).length === 1 && result.payload === null) return [
                                            2 /*return*/ 
                                        ];
                                        next = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result.payload);
                                    }
                                    if ("errors" in result) next = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, next), {
                                        extensions: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, "extensions" in next ? next.extensions : null), (_c = {}, _c[0, $456cf4c370166a0f$export$4995664c1b49842e] = result.errors, _c))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6ba89ebc2766b493$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $6ba89ebc2766b493$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $844103e0eea42137$export$c33ef9219f27efd7)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $6ba89ebc2766b493$export$d3da1ecaf1206c58(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function $6ba89ebc2766b493$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $6ba89ebc2766b493$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !$6ba89ebc2766b493$var$hasOwnProperty.call(result, "data") && !$6ba89ebc2766b493$var$hasOwnProperty.call(result, "errors")) // Data error
            (0, $844103e0eea42137$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}



var $fc846bb2ae15ec15$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $28d90d877eb1e517$export$3991762405098ea)(51);
};



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $876b79dde797933a$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $876b79dde797933a$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $876b79dde797933a$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $876b79dde797933a$export$45a677ea7cb6d5c8(code) {
    return $876b79dde797933a$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $876b79dde797933a$export$d3f406ff46035894(code) {
    return $876b79dde797933a$export$79c5d5217943d6a7(code) || $876b79dde797933a$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $a51b3e37e1f6e888$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $a51b3e37e1f6e888$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $a51b3e37e1f6e888$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $876b79dde797933a$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $a51b3e37e1f6e888$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $a51b3e37e1f6e888$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $876b79dde797933a$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $876b79dde797933a$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $670ab209adef6fbd$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($670ab209adef6fbd$var$escapedRegExp, $670ab209adef6fbd$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $670ab209adef6fbd$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $670ab209adef6fbd$var$escapedReplacer(str) {
    return $670ab209adef6fbd$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $670ab209adef6fbd$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];



function $e6602c9cee6df4a2$export$c2d084dc44961371(ast) {
    return (0, $78b48476e314521e$export$bf638b60ea8b89b7)(ast, $e6602c9cee6df4a2$var$printDocASTReducer);
}
const $e6602c9cee6df4a2$var$MAX_LINE_LENGTH = 80;
const $e6602c9cee6df4a2$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$e6602c9cee6df4a2$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $e6602c9cee6df4a2$var$hasMultilineItems(node.variableDefinitions) ? $e6602c9cee6df4a2$var$wrap('(\n', $e6602c9cee6df4a2$var$join(node.variableDefinitions, '\n'), '\n)') : $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $e6602c9cee6df4a2$var$wrap('', node.description, '\n') + $e6602c9cee6df4a2$var$join([
                node.operation,
                $e6602c9cee6df4a2$var$join([
                    node.name,
                    varDefs
                ]),
                $e6602c9cee6df4a2$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives, description: description })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + variable + ': ' + type + $e6602c9cee6df4a2$var$wrap(' = ', defaultValue) + $e6602c9cee6df4a2$var$wrap(' ', $e6602c9cee6df4a2$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$e6602c9cee6df4a2$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $e6602c9cee6df4a2$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')');
            if (argsLine.length > $e6602c9cee6df4a2$var$MAX_LINE_LENGTH) argsLine = prefix + $e6602c9cee6df4a2$var$wrap('(\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, '\n')), '\n)');
            return $e6602c9cee6df4a2$var$join([
                argsLine,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $e6602c9cee6df4a2$var$wrap(' ', $e6602c9cee6df4a2$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$e6602c9cee6df4a2$var$join([
                '...',
                $e6602c9cee6df4a2$var$wrap('on ', typeCondition),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet, description: description })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + // Note: fragment variable definitions are experimental and may be changed
            // or removed in the future.
            `fragment ${name}${$e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$e6602c9cee6df4a2$var$wrap('', $e6602c9cee6df4a2$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $a51b3e37e1f6e888$export$adb6ca997eeb1f45)(value) : (0, $670ab209adef6fbd$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $e6602c9cee6df4a2$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $e6602c9cee6df4a2$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'schema',
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'scalar',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'type',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap('(\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, '\n')), '\n)') : $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')')) + ': ' + type + $e6602c9cee6df4a2$var$wrap(' ', $e6602c9cee6df4a2$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                name + ': ' + type,
                $e6602c9cee6df4a2$var$wrap('= ', defaultValue),
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'interface',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'union',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$wrap('= ', $e6602c9cee6df4a2$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'enum',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                name,
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'input',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + 'directive @' + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap('(\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, '\n')), '\n)') : $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $e6602c9cee6df4a2$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$e6602c9cee6df4a2$var$join([
                'extend schema',
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$e6602c9cee6df4a2$var$join([
                'extend scalar',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                'extend type',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                'extend interface',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$e6602c9cee6df4a2$var$join([
                'extend union',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$wrap('= ', $e6602c9cee6df4a2$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$e6602c9cee6df4a2$var$join([
                'extend enum',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                'extend input',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    // Schema Coordinates
    TypeCoordinate: {
        leave: ({ name: name })=>name
    },
    MemberCoordinate: {
        leave: ({ name: name, memberName: memberName })=>$e6602c9cee6df4a2$var$join([
                name,
                $e6602c9cee6df4a2$var$wrap('.', memberName)
            ])
    },
    ArgumentCoordinate: {
        leave: ({ name: name, fieldName: fieldName, argumentName: argumentName })=>$e6602c9cee6df4a2$var$join([
                name,
                $e6602c9cee6df4a2$var$wrap('.', fieldName),
                $e6602c9cee6df4a2$var$wrap('(', argumentName, ':)')
            ])
    },
    DirectiveCoordinate: {
        leave: ({ name: name })=>$e6602c9cee6df4a2$var$join([
                '@',
                name
            ])
    },
    DirectiveArgumentCoordinate: {
        leave: ({ name: name, argumentName: argumentName })=>$e6602c9cee6df4a2$var$join([
                '@',
                name,
                $e6602c9cee6df4a2$var$wrap('(', argumentName, ':)')
            ])
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $e6602c9cee6df4a2$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $e6602c9cee6df4a2$var$block(array) {
    return $e6602c9cee6df4a2$var$wrap('{\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $e6602c9cee6df4a2$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $e6602c9cee6df4a2$var$indent(str) {
    return $e6602c9cee6df4a2$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $e6602c9cee6df4a2$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}




var $722312be2835bfdf$var$printCache;
var $722312be2835bfdf$export$c2d084dc44961371 = Object.assign(function(ast) {
    var result = $722312be2835bfdf$var$printCache.get(ast);
    if (!result) {
        result = (0, $e6602c9cee6df4a2$export$c2d084dc44961371)(ast);
        $722312be2835bfdf$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        $722312be2835bfdf$var$printCache = new (0, $b3ac5bdec858bda0$export$8dbad6f439bb2331)((0, $c506be9be1a65610$export$f29926b23b28936b).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$722312be2835bfdf$export$c2d084dc44961371.reset();
if (globalThis.__DEV__ !== false) (0, $1da01699264b6e1e$export$a8fcd406d9e37621)("print", function() {
    return $722312be2835bfdf$var$printCache ? $722312be2835bfdf$var$printCache.size : 0;
});


var $9778f37d6aa7b324$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $9778f37d6aa7b324$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var $9778f37d6aa7b324$var$defaultOptions = {
    method: "POST"
};
var $9778f37d6aa7b324$export$dd86f00dc866e75d = {
    http: $9778f37d6aa7b324$var$defaultHttpOptions,
    headers: $9778f37d6aa7b324$var$defaultHeaders,
    options: $9778f37d6aa7b324$var$defaultOptions
};
var $9778f37d6aa7b324$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $9778f37d6aa7b324$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $9778f37d6aa7b324$export$12d90ccf75844275.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        operation,
        $9778f37d6aa7b324$export$e88934976ca4fd65
    ], configs, false));
}
function $9778f37d6aa7b324$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), config.options), {
            headers: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, http), config.http);
    });
    if (options.headers) options.headers = $9778f37d6aa7b324$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $722312be2835bfdf$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $9778f37d6aa7b324$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = {};
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = {};
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = {};
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}



function $d07bf4cf2912bc0e$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $c32b8dc3cfa701c7$export$5f8e80ac52052e28)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $c32b8dc3cfa701c7$export$5f8e80ac52052e28)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}




function $c8ea6bc4a603e6d1$export$de246493ae27fe3f(variables, query) {
    var result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $78b48476e314521e$export$bf638b60ea8b89b7)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}


function $045bb098515a5bfc$export$4fd972edbe7450d3(errorValue) {
    return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
        observer.error(errorValue);
    });
}


var $0c8dd0eb947866f7$var$backupFetch = (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return fetch;
});
var $0c8dd0eb947866f7$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $9778f37d6aa7b324$export$e88934976ca4fd65) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, $fc846bb2ae15ec15$export$8423f0cd3773115e)(preferredFetch || $0c8dd0eb947866f7$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $5a02450356081318$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
            "client"
        ], operation.query)) {
            if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(52);
            var transformedQuery = (0, $202b8a19e6086c64$export$8eae69e876ee321e)(operation.query);
            if (!transformedQuery) return (0, $045bb098515a5bfc$export$4fd972edbe7450d3)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, $9778f37d6aa7b324$export$12d90ccf75844275)(operation, print, (0, $9778f37d6aa7b324$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $c8ea6bc4a603e6d1$export$de246493ae27fe3f)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $818d93327cb72c29$export$f431198736b7f96d)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(53);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $d07bf4cf2912bc0e$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $045bb098515a5bfc$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $c32b8dc3cfa701c7$export$5f8e80ac52052e28)(body, "Payload");
        } catch (parseError) {
            return (0, $045bb098515a5bfc$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
                return fetch;
            }) || $0c8dd0eb947866f7$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $6ba89ebc2766b493$export$ccb60864026baf09)(response, observerNext);
                else return (0, $6ba89ebc2766b493$export$d4051215bea0639f)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $6ba89ebc2766b493$export$d3da1ecaf1206c58)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};


var $4c2d109245a5920b$export$f4bbf1aec241cc1 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $0c8dd0eb947866f7$export$95180a16573d6675)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $60c07ffd02e3617d$export$2fed3d61f740bc7f));




const { toString: $a2b6f433e732b502$var$toString, hasOwnProperty: $a2b6f433e732b502$var$hasOwnProperty } = Object.prototype;
const $a2b6f433e732b502$var$fnToStr = Function.prototype.toString;
const $a2b6f433e732b502$var$previousComparisons = new Map();
function $a2b6f433e732b502$export$411ce8e5a71e3069(a, b) {
    try {
        return $a2b6f433e732b502$var$check(a, b);
    } finally{
        $a2b6f433e732b502$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$a2b6f433e732b502$export$2e2bcd8739ae039 = $a2b6f433e732b502$export$411ce8e5a71e3069;
function $a2b6f433e732b502$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $a2b6f433e732b502$var$toString.call(a);
    const bTag = $a2b6f433e732b502$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            {
                if ($a2b6f433e732b502$var$previouslyCompared(a, b)) return true;
                const aKeys = $a2b6f433e732b502$var$definedKeys(a);
                const bKeys = $a2b6f433e732b502$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$a2b6f433e732b502$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$a2b6f433e732b502$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]':
            {
                if (a.size !== b.size) return false;
                if ($a2b6f433e732b502$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === '[object Map]';
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$a2b6f433e732b502$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            {
                const aCode = $a2b6f433e732b502$var$fnToStr.call(a);
                if (aCode !== $a2b6f433e732b502$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$a2b6f433e732b502$var$endsWith(aCode, $a2b6f433e732b502$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $a2b6f433e732b502$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($a2b6f433e732b502$var$isDefinedKey, obj);
}
function $a2b6f433e732b502$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $a2b6f433e732b502$var$nativeCodeSuffix = "{ [native code] }";
function $a2b6f433e732b502$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $a2b6f433e732b502$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $a2b6f433e732b502$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $a2b6f433e732b502$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}




function $558b9f91eb7bf726$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, key) {
            return function(arg) {
                if (examiner) {
                    var both = function() {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ? /* will be swallowed */ 0 : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function(result) {
                        return observer.next(result);
                    }, function(error) {
                        return observer.error(error);
                    });
                } else observer[key](arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function() {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function() {
                    return observer.complete();
                });
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}



/**
 * @deprecated `iterateObserversSafely` will be removed with Apollo Client 4.0.
 * Please discontinue using this function.
 */ function $de072e4be1d4d57a$export$9f6c99ae166dbeca(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}




function $af26a5afbde47a9e$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, {
            value: (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)
        });
    }
    if ((0, $5d0a073f980bb2a3$export$23ba675b4b838b92) && Symbol.species) set(Symbol.species);
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}


function $5bb23690c12ed9a4$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(_this.observers, "complete");
                    } else if ($5bb23690c12ed9a4$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    }, _this.handlers.error);
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.error(reason);
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function(_) {});
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") sources = [
            new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(sources)
        ];
        if ($5bb23690c12ed9a4$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) // In case there are still any listeners in this.nextResultListeners, and
        // no error or completion has been broadcast yet, make sure those
        // observers have a chance to run and then remove themselves from
        // this.observers.
        this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $6d99a9de69717ea6$export$77cea355fa80b5f4));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0, $af26a5afbde47a9e$export$33c8bd820eece9b2)($5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e);








function $2e04132f91cc06f1$var$identity(document) {
    return document;
}
var $2e04132f91cc06f1$export$f887060e48e5dc1b = /** @class */ function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $5d0a073f980bb2a3$export$7293b8a0b474028d) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform($2e04132f91cc06f1$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return Object.assign(new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */ DocumentTransform.prototype.resetCache = function() {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
            this.performWork = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function(document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(Array.isArray(cacheKeys), 105);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: (0, $c506be9be1a65610$export$f29926b23b28936b)["documentTransform.cache"],
                cache: (0, $947797cdb9e55a2d$export$87b462129af3b7d4)
            });
        }
    };
    DocumentTransform.prototype.performWork = function(document) {
        (0, $818d93327cb72c29$export$a7d0d8111d2386df)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    };
    return DocumentTransform;
}();



function $5333c7f04e9cca43$export$b4df399e879e53ab(result) {
    var errors = $5333c7f04e9cca43$export$a163557155188b6e(result);
    return (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(errors);
}
function $5333c7f04e9cca43$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}








/**
 * The current status of a query’s execution in our system.
 */ var $72c5140a632c7fa1$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($72c5140a632c7fa1$export$bd096ddbd246c79c || ($72c5140a632c7fa1$export$bd096ddbd246c79c = {}));
function $72c5140a632c7fa1$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $72c5140a632c7fa1$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}


var $e398dba65b0b4cec$var$toString = Object.prototype.toString;
function $e398dba65b0b4cec$export$629a2bd3f5a49ecc(value) {
    return $e398dba65b0b4cec$var$cloneDeepHelper(value);
}
function $e398dba65b0b4cec$var$cloneDeepHelper(val, seen) {
    switch($e398dba65b0b4cec$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e398dba65b0b4cec$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e398dba65b0b4cec$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ function $2f3cebf1a05c1b38$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

function $a52ba2117a948b92$export$7ff41c6e01127226(promise) {
    promise.catch(function() {});
    return promise;
}






function $3703278c0cb633ee$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_b, [
        "data"
    ]);
    return (0, $a2b6f433e732b502$export$2e2bcd8739ae039)(aRest, bRest) && $3703278c0cb633ee$var$equalBySelectionSet((0, $818d93327cb72c29$export$f431198736b7f96d)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(query)),
        variables: variables
    });
}
function $3703278c0cb633ee$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function(selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if ($3703278c0cb633ee$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) {
            var resultKey = (0, $9d830e5028848843$export$7d1ad22471852218)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, $a2b6f433e732b502$export$2e2bcd8739ae039)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$3703278c0cb633ee$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $3703278c0cb633ee$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $7f688c9754699513$export$f80bdb85f299186)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if ($3703278c0cb633ee$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $3703278c0cb633ee$var$equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function $3703278c0cb633ee$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($3703278c0cb633ee$var$directiveIsNonreactive);
}
function $3703278c0cb633ee$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}




var $3118fa29bcf9f4b2$var$assign = Object.assign, $3118fa29bcf9f4b2$var$hasOwnProperty = Object.hasOwnProperty;
var $3118fa29bcf9f4b2$export$6c1b56eac59c9584 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = this;
        var startedInactive = ObservableQuery.inactiveOnCreation.getValue();
        _this = _super.call(this, function(observer) {
            _this._getOrCreateQuery();
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $3118fa29bcf9f4b2$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(_this.maskResult(last.result));
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) // Blindly catching here prevents unhandled promise rejections,
            // and is safe because the ObservableQuery handles this error with
            // this.observer.error, so we're not just swallowing the error by
            // ignoring it here.
            _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.dirty = false;
        _this._getOrCreateQuery = function() {
            if (startedInactive) {
                queryManager["queries"].set(_this.queryId, queryInfo);
                startedInactive = false;
            }
            return _this.queryManager.getOrCreateQuery(_this.queryId);
        };
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = $3118fa29bcf9f4b2$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        _this.subscribeToMore = _this.subscribeToMore.bind(_this);
        _this.maskResult = _this.maskResult.bind(_this);
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $818d93327cb72c29$export$7a5b1fa979d2c158)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */ get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @deprecated `result` will be removed in Apollo Client 4.0.
     *
     * **Recommended now**
     *
     * If you continue to need this functionality, subscribe to `ObservableQuery`
     * to get the first value emitted from the observable, then immediately unsubscribe.
     *
     * **When upgrading**
     *
     * Use RxJS's [`firstResultFrom`](https://rxjs.dev/api/index/function/firstValueFrom) function to mimic this functionality.
     *
     * ```ts
     * const result = await firstValueFrom(from(observableQuery));
     * ```
     */ ObservableQuery.prototype.result = function() {
        var _this = this;
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$606a5c06d13e04b6)("observableQuery.result", function() {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(23);
        });
        return new Promise(function(resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function(result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */ ObservableQuery.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentFullResult = function(saveAsLastResult) {
        var _this = this;
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        // Use the last result as long as the variables match this.variables.
        var lastResult = (0, $c7b1e48e566741e9$export$d18d1529326946c4)("getLastResult", function() {
            return _this.getLastResult(true);
        });
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready;
        var result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, lastResult), {
            loading: (0, $72c5140a632c7fa1$export$37509604341a3464)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (// These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        $3118fa29bcf9f4b2$var$skipCacheDataFor(fetchPolicy) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) // This would usually be a part of `QueryInfo.getDiff()`.
        // which we skip in the waitForOwnResult case since we are not
        // interested in the diff.
        this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete && result.networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            // We need to check for both both `error` and `errors` field because there
            // are cases where sometimes `error` is set, but not `errors` and
            // vice-versa. This will be updated in the next major version when
            // `errors` is deprecated in favor of `error`.
            if (result.networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready && (result.error || result.errors)) result.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $3118fa29bcf9f4b2$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        return this.maskResult(this.getCurrentFullResult(saveAsLastResult));
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var documentInfo = this.queryManager.getDocumentInfo(this.query);
        var dataMasking = this.queryManager.dataMasking;
        var query = dataMasking ? documentInfo.nonReactiveQuery : this.query;
        var resultIsDifferent = dataMasking || documentInfo.hasNonreactiveDirective ? !(0, $3703278c0cb633ee$export$5e40714c5ad44445)(query, this.last.result, newResult, this.variables) : !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(last.variables, this.variables))) return last[key];
    };
    /**
     * @deprecated `getLastResult` will be removed in Apollo Client 4.0. Please
     * discontinue using this method.
     */ ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$606a5c06d13e04b6)("getLastResult", function() {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(24);
        });
        return this.getLast("result", variablesMustMatch);
    };
    /**
     * @deprecated `getLastError` will be removed in Apollo Client 4.0. Please
     * discontinue using this method.
     */ ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$606a5c06d13e04b6)("getLastError", function() {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(25);
        });
        return this.getLast("error", variablesMustMatch);
    };
    /**
     * @deprecated `resetLastResults` will be removed in Apollo Client 4.0. Please
     * discontinue using this method.
     */ ObservableQuery.prototype.resetLastResults = function() {
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$606a5c06d13e04b6)("resetLastResults", function() {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(26);
        });
        delete this.last;
        this.isTornDown = false;
    };
    /**
     * @deprecated `resetQueryStoreErrors` will be removed in Apollo Client 4.0.
     * Please discontinue using this method.
     */ ObservableQuery.prototype.resetQueryStoreErrors = function() {
        if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(27);
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $3118fa29bcf9f4b2$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $818d93327cb72c29$export$d96b2213c1b9d3a9)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(28, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.options.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */ ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        var updateQuery = fetchMoreOptions === null || fetchMoreOptions === void 0 ? void 0 : fetchMoreOptions.updateQuery;
        var isCached = this.options.fetchPolicy !== "no-cache";
        if (!isCached) (0, $28d90d877eb1e517$export$f5708dca728d7177)(updateQuery, 29);
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            if (isCached) // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else // If we're using a field policy instead of updateQuery, the only
                    // thing we need to do is write the new data to the cache using
                    // combinedOptions.variables (instead of this.variables, which is
                    // what this.updateQuery uses, because it works by abusing the
                    // original field value, keyed by the original variables).
                    cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                }
            });
            else {
                // There is a possibility `lastResult` may not be set when
                // `fetchMore` is called which would cause this to crash. This should
                // only happen if we haven't previously reported a result. We don't
                // quite know what the right behavior should be here since this block
                // of code runs after the fetch result has executed on the network.
                // We plan to let it crash in the meantime.
                //
                // If we get bug reports due to the `data` property access on
                // undefined, this should give us a real-world scenario that we can
                // use to test against and determine the right behavior. If we do end
                // up changing this behavior, this may require, for example, an
                // adjustment to the types on `updateQuery` since that function
                // expects that the first argument always contains previous result
                // data, but not `undefined`.
                var lastResult = _this.getLast("result");
                var data = updateQuery(lastResult.data, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
                _this.reportResult((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, lastResult), {
                    networkStatus: originalNetworkStatus,
                    loading: (0, $72c5140a632c7fa1$export$37509604341a3464)(originalNetworkStatus),
                    data: data
                }), _this.variables);
            }
            return _this.maskResult(fetchMoreResult);
        }).finally(function() {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (isCached && !updatedQuerySet.has(_this.query)) _this.reobserveCacheFirst();
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, updateOptions) {
                    return updateQuery(previous, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        subscriptionData: subscriptionData
                    }, updateOptions));
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(30, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    /**
     * @deprecated `setOptions` will be removed in Apollo Client 4.0. Please use
     * `observableQuery.reobserve(newOptions)` instead.
     */ ObservableQuery.prototype.setOptions = function(newOptions) {
        if (globalThis.__DEV__ !== false) {
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(newOptions, "canonizeResults", "setOptions");
            (0, $c7b1e48e566741e9$export$606a5c06d13e04b6)("setOptions", function() {
                globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(31);
            });
        }
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(this.options, newOptions || {});
        $3118fa29bcf9f4b2$var$assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.setVariables = function(variables) {
        var _this = this;
        if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return this.observers.size ? (0, $c7b1e48e566741e9$export$d18d1529326946c4)("observableQuery.result", function() {
            return _this.result();
        }) : Promise.resolve();
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }), result = _a.result, complete = _a.complete;
        var newResult = mapFn(result, {
            variables: this.variables,
            complete: !!complete,
            previousData: result
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.setOptions.
            options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        var queryInfo = this._getOrCreateQuery();
        queryInfo.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](queryInfo, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval || !this.hasObservers()) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(pollInterval, 32);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0, $72c5140a632c7fa1$export$37509604341a3464)(_this.queryInfo.networkStatus) && !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) _this.reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var error = (0, $c7b1e48e566741e9$export$d18d1529326946c4)("getLastError", function() {
            return _this.getLastError();
        });
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $e398dba65b0b4cec$export$629a2bd3f5a49ecc)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        newNetworkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(this.options, newOptions || {});
        var options = useDisposableConcast ? // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : $3118fa29bcf9f4b2$var$assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            (options.fetchPolicy === oldFetchPolicy || // A `nextFetchPolicy` function has even higher priority, though,
            // so in that case `applyNextFetchPolicy` must be called.
            typeof options.nextFetchPolicy === "function")) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).setVariables;
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = $3118fa29bcf9f4b2$var$skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = options.variables && (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function(error) {
                if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    // Coming from `getResultsFromLink`, `error` here should always be an `ApolloError`.
                    // However, calling `concast.cancel` can inject another type of error, so we have to
                    // wrap it again here.
                    if (!(0, $456cf4c370166a0f$export$17f5e6bd290bb15d)(error)) error = new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                        networkError: error
                    });
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return (0, $a52ba2117a948b92$export$7ff41c6e01127226)(this.reobserveAsConcast(newOptions, newNetworkStatus).promise.then(this.maskResult));
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        (0, $c7b1e48e566741e9$export$d18d1529326946c4)("resetLastResults", function() {
            return _this.resetLastResults();
        });
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function() {
        this.reportResult(// Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var _this = this;
        var lastError = (0, $c7b1e48e566741e9$export$d18d1529326946c4)("getLastError", function() {
            return _this.getLastError();
        });
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(this.observers, "next", this.maskResult(result));
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        var _this = this;
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $c7b1e48e566741e9$export$d18d1529326946c4)("getLastResult", function() {
            return _this.getLastResult();
        })), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    ObservableQuery.prototype.maskResult = function(result) {
        return result && "data" in result ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), {
            data: this.queryManager.maskOperation({
                document: this.query,
                data: result.data,
                fetchPolicy: this.options.fetchPolicy,
                id: this.queryId
            })
        }) : result;
    };
    /** @internal */ ObservableQuery.prototype.resetNotifications = function() {
        this.cancelNotifyTimeout();
        this.dirty = false;
    };
    ObservableQuery.prototype.cancelNotifyTimeout = function() {
        if (this.notifyTimeout) {
            clearTimeout(this.notifyTimeout);
            this.notifyTimeout = void 0;
        }
    };
    /** @internal */ ObservableQuery.prototype.scheduleNotify = function() {
        var _this = this;
        if (this.dirty) return;
        this.dirty = true;
        if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
            return _this.notify();
        }, 0);
    };
    /** @internal */ ObservableQuery.prototype.notify = function() {
        this.cancelNotifyTimeout();
        if (this.dirty) {
            if (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !(0, $72c5140a632c7fa1$export$37509604341a3464)(this.queryInfo.networkStatus)) {
                var diff = this.queryInfo.getDiff();
                if (diff.fromOptimisticTransaction) // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                this.observe();
                else // Otherwise, make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, isDifferentFromLastResult still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                this.reobserveCacheFirst();
            }
        }
        this.dirty = false;
    };
    // Reobserve with fetchPolicy effectively set to "cache-first", triggering
    // delivery of any new data from the cache, possibly falling back to the network
    // if any cache data are missing. This allows _complete_ cache results to be
    // delivered without also kicking off unnecessary network requests when
    // this.options.fetchPolicy is "cache-and-network" or "network-only". When
    // this.options.fetchPolicy is any other policy ("cache-first", "cache-only",
    // "standby", or "no-cache"), we call this.reobserve() as usual.
    ObservableQuery.prototype.reobserveCacheFirst = function() {
        var _a = this.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
        if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return this.reobserve({
            fetchPolicy: "cache-first",
            // Use a temporary nextFetchPolicy function that replaces itself with the
            // previous nextFetchPolicy value and returns the original fetchPolicy.
            nextFetchPolicy: function(currentFetchPolicy, context) {
                // Replace this nextFetchPolicy function in the options object with the
                // original this.options.nextFetchPolicy value.
                this.nextFetchPolicy = nextFetchPolicy;
                // If the original nextFetchPolicy value was a function, give it a
                // chance to decide what happens here.
                if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
                // Otherwise go back to the original this.options.fetchPolicy.
                return fetchPolicy;
            }
        });
        return this.reobserve();
    };
    /**
     * @internal
     * A slot used by the `useQuery` hook to indicate that `client.watchQuery`
     * should not register the query immediately, but instead wait for the query to
     * be started registered with the `QueryManager` when `useSyncExternalStore`
     * actively subscribes to it.
     */ ObservableQuery.inactiveOnCreation = new (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360)();
    return ObservableQuery;
}((0, $6d99a9de69717ea6$export$77cea355fa80b5f4));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0, $af26a5afbde47a9e$export$33c8bd820eece9b2)($3118fa29bcf9f4b2$export$6c1b56eac59c9584);
function $3118fa29bcf9f4b2$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(33, error.message, error.stack);
}
function $3118fa29bcf9f4b2$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).debug(34, missing);
}
function $3118fa29bcf9f4b2$var$skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */ ) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}








var $f8e7d4b4bf21978e$var$destructiveMethodCounts = new ((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        $f8e7d4b4bf21978e$var$destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        ($f8e7d4b4bf21978e$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var $f8e7d4b4bf21978e$export$79a6120a39c90b6a = /** @class */ function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!$f8e7d4b4bf21978e$var$destructiveMethodCounts.has(cache)) {
            $f8e7d4b4bf21978e$var$destructiveMethodCounts.set(cache, 0);
            $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, "evict");
            $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, "modify");
            $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
        if (this.variables && this.networkStatus !== (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.variables, query.variables)) networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).setVariables;
        if (!(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(query.variables, this.variables)) {
            this.lastDiff = void 0;
            // Ensure we don't continue to receive cache updates for old variables
            this.cancel();
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.resetDiff = function() {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function() {
        var _this = this;
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = (0, $c7b1e48e566741e9$export$d18d1529326946c4)("canonizeResults", function() {
            return _this.cache.diff(options);
        });
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var _a;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we are trying to deliver an incomplete cache result, we avoid
        // reporting it if the query has errored, otherwise we let the broadcast try
        // and repair the partial result by refetching the query. This check avoids
        // a situation where a query that errors and another succeeds with
        // overlapping data does not report the partial data result to the errored
        // query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff && !diff.complete && (0, $c7b1e48e566741e9$export$d18d1529326946c4)("getLastError", function() {
            var _a;
            return (_a = _this.observableQuery) === null || _a === void 0 ? void 0 : _a.getLastError();
        })) return;
        this.updateLastDiff(diff);
        if (!(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(oldDiff && oldDiff.result, diff && diff.result)) (_a = this.observableQuery) === null || _a === void 0 || _a["scheduleNotify"]();
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        if (oq === this.observableQuery) return;
        this.observableQuery = oq;
        if (oq) oq["queryInfo"] = this;
    };
    QueryInfo.prototype.stop = function() {
        var _a;
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
            this.cancel();
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function() {
        var _a;
        (_a = this.cancelWatch) === null || _a === void 0 || _a.call(this);
        this.cancelWatch = void 0;
    };
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancelWatch = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === $f8e7d4b4bf21978e$var$destructiveMethodCounts.get(this.cache) && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(variables, lastWrite.variables) && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var _a;
        var merger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
        var graphQLErrors = (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
        if ("incremental" in result && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) {
            var mergedData = (0, $4753a78f97af1d82$export$9a905f57d6393874)(this.getDiff().result, result);
            result.data = mergedData;
        // Detect the first chunk of a deferred query and merge it with existing
        // cache data. This ensures a `cache-first` fetch policy that returns
        // partial cache data or a `cache-and-network` fetch policy that already
        // has full data in the cache does not complain when trying to merge the
        // initial deferred server data with existing cache data.
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if ($f8e7d4b4bf21978e$export$5f47a9fb9a521654(result, options.errorPolicy)) // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ 
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $f8e7d4b4bf21978e$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = (0, $c7b1e48e566741e9$export$d18d1529326946c4)("canonizeResults", function() {
                    return cache.diff(diffOptions);
                });
                // In case the QueryManager stops this QueryInfo before its
                // results are delivered, it's important to avoid restarting the
                // cache watch when markResult is called. We also avoid updating
                // the watch if we are writing a result that doesn't match the current
                // variables to avoid race conditions from broadcasting the wrong
                // result.
                if (!_this.stopped && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(_this.variables, options.variables)) // Any time we're about to update this.diff, we need to make
                // sure we've started watching the cache.
                _this.updateWatch(options.variables);
                // If we're allowed to write to the cache, and we can read a
                // complete result from the cache, update result.data to be the
                // result from the cache, rather than the raw network result.
                // Set without setDiff to avoid triggering a notify call, since
                // we have other ways of notifying for this result.
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        var _a;
        this.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error;
        this.lastWrite = void 0;
        (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $f8e7d4b4bf21978e$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $5333c7f04e9cca43$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}







var $6e5089e13e4c0db0$export$dadc3b13206cb3ad = (0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9) ? WeakMap : Map;
var $6e5089e13e4c0db0$export$de8324a23c9fae9a = (0, $5d0a073f980bb2a3$export$7293b8a0b474028d) ? WeakSet : Set;
var $6e5089e13e4c0db0$export$2ddf8815a8abe8b = new (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360)();
var $6e5089e13e4c0db0$var$issuedWarning = false;
function $6e5089e13e4c0db0$export$f21dbf49e2bec78b() {
    if (!$6e5089e13e4c0db0$var$issuedWarning) {
        $6e5089e13e4c0db0$var$issuedWarning = true;
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(64);
    }
}






function $310a6ebe531ba02b$export$7e32b29e1cb162e1(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(obj) && $310a6ebe531ba02b$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $310a6ebe531ba02b$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $310a6ebe531ba02b$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $310a6ebe531ba02b$export$7e32b29e1cb162e1(obj);
    return obj;
}




function $9502062b2d53558f$export$d4ee6fea56447c82(data, selectionSet, context) {
    return (0, $6e5089e13e4c0db0$export$2ddf8815a8abe8b).withValue(true, function() {
        var masked = $9502062b2d53558f$var$maskSelectionSet(data, selectionSet, context, false);
        if (Object.isFrozen(data)) (0, $310a6ebe531ba02b$export$7f9c177735b71f18)(masked);
        return masked;
    });
}
function $9502062b2d53558f$var$getMutableTarget(data, mutableTargets) {
    if (mutableTargets.has(data)) return mutableTargets.get(data);
    var mutableTarget = Array.isArray(data) ? [] : Object.create(null);
    mutableTargets.set(data, mutableTarget);
    return mutableTarget;
}
function $9502062b2d53558f$var$maskSelectionSet(data, selectionSet, context, migration, path) {
    var _a;
    var knownChanged = context.knownChanged;
    var memo = $9502062b2d53558f$var$getMutableTarget(data, context.mutableTargets);
    if (Array.isArray(data)) {
        for(var _i = 0, _b = Array.from(data.entries()); _i < _b.length; _i++){
            var _c = _b[_i], index = _c[0], item = _c[1];
            if (item === null) {
                memo[index] = null;
                continue;
            }
            var masked = $9502062b2d53558f$var$maskSelectionSet(item, selectionSet, context, migration, globalThis.__DEV__ !== false ? "".concat(path || "", "[").concat(index, "]") : void 0);
            if (knownChanged.has(masked)) knownChanged.add(memo);
            memo[index] = masked;
        }
        return knownChanged.has(memo) ? memo : data;
    }
    for(var _d = 0, _e = selectionSet.selections; _d < _e.length; _d++){
        var selection = _e[_d];
        var value = void 0;
        // we later want to add acessor warnings to the final result
        // so we need a new object to add the accessor warning to
        if (migration) knownChanged.add(memo);
        if (selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD) {
            var keyName = (0, $9d830e5028848843$export$7d1ad22471852218)(selection);
            var childSelectionSet = selection.selectionSet;
            value = memo[keyName] || data[keyName];
            if (value === void 0) continue;
            if (childSelectionSet && value !== null) {
                var masked = $9502062b2d53558f$var$maskSelectionSet(data[keyName], childSelectionSet, context, migration, globalThis.__DEV__ !== false ? "".concat(path || "", ".").concat(keyName) : void 0);
                if (knownChanged.has(masked)) value = masked;
            }
            if (!(globalThis.__DEV__ !== false)) memo[keyName] = value;
            if (globalThis.__DEV__ !== false) {
                if (migration && keyName !== "__typename" && // either the field is not present in the memo object
                // or it has a `get` descriptor, not a `value` descriptor
                // => it is a warning accessor and we can overwrite it
                // with another accessor
                !((_a = Object.getOwnPropertyDescriptor(memo, keyName)) === null || _a === void 0 ? void 0 : _a.value)) Object.defineProperty(memo, keyName, $9502062b2d53558f$var$getAccessorWarningDescriptor(keyName, value, path || "", context.operationName, context.operationType));
                else {
                    delete memo[keyName];
                    memo[keyName] = value;
                }
            }
        }
        if (selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INLINE_FRAGMENT && (!selection.typeCondition || context.cache.fragmentMatches(selection, data.__typename))) value = $9502062b2d53558f$var$maskSelectionSet(data, selection.selectionSet, context, migration, path);
        if (selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD) {
            var fragmentName = selection.name.value;
            var fragment = context.fragmentMap[fragmentName] || (context.fragmentMap[fragmentName] = context.cache.lookupFragment(fragmentName));
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragment, 59, fragmentName);
            var mode = (0, $89c1eec09879e1ca$export$d6913ace4214003)(selection);
            if (mode !== "mask") value = $9502062b2d53558f$var$maskSelectionSet(data, fragment.selectionSet, context, mode === "migrate", path);
        }
        if (knownChanged.has(value)) knownChanged.add(memo);
    }
    if ("__typename" in data && !("__typename" in memo)) memo.__typename = data.__typename;
    // This check prevents cases where masked fields may accidentally be
    // returned as part of this object when the fragment also selects
    // additional fields from the same child selection.
    if (Object.keys(memo).length !== Object.keys(data).length) knownChanged.add(memo);
    return knownChanged.has(memo) ? memo : data;
}
function $9502062b2d53558f$var$getAccessorWarningDescriptor(fieldName, value, path, operationName, operationType) {
    var getValue = function() {
        if ((0, $6e5089e13e4c0db0$export$2ddf8815a8abe8b).getValue()) return value;
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(60, operationName ? "".concat(operationType, " '").concat(operationName, "'") : "anonymous ".concat(operationType), "".concat(path, ".").concat(fieldName).replace(/^\./, ""));
        getValue = function() {
            return value;
        };
        return value;
    };
    return {
        get: function() {
            return getValue();
        },
        set: function(newValue) {
            getValue = function() {
                return newValue;
            };
        },
        enumerable: true,
        configurable: true
    };
}



function $553b831e0c7e9b12$export$adbebb59d1aeea97(data, document, cache, fragmentName) {
    if (!cache.fragmentMatches) {
        if (globalThis.__DEV__ !== false) (0, $6e5089e13e4c0db0$export$f21dbf49e2bec78b)();
        return data;
    }
    var fragments = document.definitions.filter(function(node) {
        return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
    });
    if (typeof fragmentName === "undefined") {
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragments.length === 1, 61, fragments.length);
        fragmentName = fragments[0].name.value;
    }
    var fragment = fragments.find(function(fragment) {
        return fragment.name.value === fragmentName;
    });
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!!fragment, 62, fragmentName);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    if ((0, $a2b6f433e732b502$export$2e2bcd8739ae039)(data, {})) // Return early and skip the masking algorithm if we don't have any data
    // yet. This can happen when cache.diff returns an empty object which is
    // used from watchFragment.
    return data;
    return (0, $9502062b2d53558f$export$d4ee6fea56447c82)(data, fragment.selectionSet, {
        operationType: "fragment",
        operationName: fragment.name.value,
        fragmentMap: (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(document)),
        cache: cache,
        mutableTargets: new (0, $6e5089e13e4c0db0$export$dadc3b13206cb3ad)(),
        knownChanged: new (0, $6e5089e13e4c0db0$export$de8324a23c9fae9a)()
    });
}





function $c0327452fa319b31$export$74a61e4252a4a2ef(data, document, cache) {
    var _a;
    if (!cache.fragmentMatches) {
        if (globalThis.__DEV__ !== false) (0, $6e5089e13e4c0db0$export$f21dbf49e2bec78b)();
        return data;
    }
    var definition = (0, $818d93327cb72c29$export$7a5b1fa979d2c158)(document);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(definition, 63);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    return (0, $9502062b2d53558f$export$d4ee6fea56447c82)(data, definition.selectionSet, {
        operationType: definition.operation,
        operationName: (_a = definition.name) === null || _a === void 0 ? void 0 : _a.value,
        fragmentMap: (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(document)),
        cache: cache,
        mutableTargets: new (0, $6e5089e13e4c0db0$export$dadc3b13206cb3ad)(),
        knownChanged: new (0, $6e5089e13e4c0db0$export$de8324a23c9fae9a)()
    });
}



var $957978b378afd274$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $957978b378afd274$var$IGNORE = Object.create(null);
var $957978b378afd274$export$b986383a50b53ea4 = /** @class */ function() {
    function QueryManager(options) {
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (0, $b3ac5bdec858bda0$export$8dbad6f439bb2331)((0, $c506be9be1a65610$export$f29926b23b28936b)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)(false);
        this.noCacheWarningsByQueryId = new Set();
        var defaultDocumentTransform = new (0, $2e04132f91cc06f1$export$f887060e48e5dc1b)(function(document) {
            return _this.cache.transformDocument(document);
        }, // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.cache = options.cache;
        this.link = options.link;
        this.defaultOptions = options.defaultOptions;
        this.queryDeduplication = options.queryDeduplication;
        this.clientAwareness = options.clientAwareness;
        this.localState = options.localState;
        this.ssrMode = options.ssrMode;
        this.assumeImmutableResults = options.assumeImmutableResults;
        this.dataMasking = options.dataMasking;
        var documentTransform = options.documentTransform;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = options.defaultContext || Object.create(null);
        if (this.onBroadcast = options.onBroadcast) this.mutationStore = Object.create(null);
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $28d90d877eb1e517$export$3991762405098ea)(35));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            var _c, _d;
            var mutation = _b.mutation, variables = _b.variables, optimisticResponse = _b.optimisticResponse, updateQueries = _b.updateQueries, _e = _b.refetchQueries, refetchQueries = _e === void 0 ? [] : _e, _f = _b.awaitRefetchQueries, awaitRefetchQueries = _f === void 0 ? false : _f, updateWithProxyFn = _b.update, onQueryUpdated = _b.onQueryUpdated, _g = _b.fetchPolicy, fetchPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.fetchPolicy) || "network-only" : _g, _h = _b.errorPolicy, errorPolicy = _h === void 0 ? ((_d = this.defaultOptions.mutate) === null || _d === void 0 ? void 0 : _d.errorPolicy) || "none" : _h, keepRootFields = _b.keepRootFields, context = _b.context;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(mutation, 36);
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 37);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        isOptimistic = optimisticResponse && this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                return (0, $558b9f91eb7bf726$export$707ee4c4c95d39e3)(self.getObservableFromLink(mutation, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), {
                                    optimisticResponse: isOptimistic ? optimisticResponse : void 0
                                }), variables, {}, false), function(result) {
                                    if ((0, $5333c7f04e9cca43$export$b4df399e879e53ab)(result) && errorPolicy === "none") throw new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                                        graphQLErrors: (0, $5333c7f04e9cca43$export$a163557155188b6e)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $5333c7f04e9cca43$export$b4df399e879e53ab)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, storeResult), {
                                            data: self.maskOperation({
                                                document: mutation,
                                                data: storeResult.data,
                                                fetchPolicy: fetchPolicy,
                                                id: mutationId
                                            })
                                        }));
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $456cf4c370166a0f$export$26a337512320b8c6) ? err : new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $f8e7d4b4bf21978e$export$5f47a9fb9a521654)(result, mutation.errorPolicy)) {
            if (!(0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $4753a78f97af1d82$export$9a905f57d6393874)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$957978b378afd274$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                // Read the current query result from the store.
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || (mutation.refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0, $4753a78f97af1d82$export$f90dc0a3531b8b83)(result) || (0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: $957978b378afd274$var$IGNORE
        }) : optimisticResponse;
        if (data === $957978b378afd274$var$IGNORE) return false;
        this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(this.getOrCreateQuery(queryId), options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, $89c1eec09879e1ca$export$8d1e9e5bbfa5d09a)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
                    "nonreactive"
                ], document),
                nonReactiveQuery: (0, $202b8a19e6086c64$export$b6125cad5877ac5e)(document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $202b8a19e6086c64$export$e5ae0530da5fe96c)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    },
                    {
                        name: "unmask"
                    }
                ], document),
                defaultVars: (0, $818d93327cb72c29$export$84c19026e616569e)((0, $818d93327cb72c29$export$7a5b1fa979d2c158)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $f8e7d4b4bf21978e$export$79a6120a39c90b6a)(this);
        var observable = new (0, $3118fa29bcf9f4b2$export$6c1b56eac59c9584)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        if (!(0, $3118fa29bcf9f4b2$export$6c1b56eac59c9584)["inactiveOnCreation"].getValue()) this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(options.query, 38);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(options.query.kind === "Document", 39);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(!options.returnPartialData, 40);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(!options.pollInterval, 41);
        var query = this.transform(options.query);
        return this.fetchQuery(queryId, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            query: query
        })).then(function(result) {
            return result && (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), {
                data: _this.maskOperation({
                    document: query,
                    data: result.data,
                    fetchPolicy: options.fetchPolicy,
                    id: queryId
                })
            });
        }).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, $28d90d877eb1e517$export$3991762405098ea)(42));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            queryInfo.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNames = new Map();
        var queryNamesAndQueryStrings = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") {
                queryNames.set(desc, desc);
                queryNamesAndQueryStrings.set(desc, false);
            } else if ((0, $9d830e5028848843$export$540432d49fcec6c9)(desc)) {
                var queryString = (0, $722312be2835bfdf$export$c2d084dc44961371)(_this.transform(desc));
                queryNames.set(queryString, (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(desc));
                queryNamesAndQueryStrings.set(queryString, false);
            } else if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndQueryStrings.has(queryName) || document && queryNamesAndQueryStrings.has((0, $722312be2835bfdf$export$c2d084dc44961371)(document))) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndQueryStrings.set(queryName, true);
                    if (document) queryNamesAndQueryStrings.set((0, $722312be2835bfdf$export$c2d084dc44961371)(document), true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            // We will be issuing a fresh network request for this query, so we
            // pre-allocate a new query ID here, using a special prefix to enable
            // cleaning up these temporary queries later, after fetching.
            var queryId = (0, $14071c0503b706b7$export$d0c8ec0fe1b18b70)("legacyOneTimeQuery");
            var queryInfo = _this.getOrCreateQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $3118fa29bcf9f4b2$export$6c1b56eac59c9584)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndQueryStrings.size) queryNamesAndQueryStrings.forEach(function(included, nameOrQueryString) {
            if (!included) {
                var queryName = queryNames.get(nameOrQueryString);
                if (queryName) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(43, queryName);
                else globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(44);
            }
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            (0, $c7b1e48e566741e9$export$d18d1529326946c4)("resetLastResults", function() {
                return observableQuery.resetLastResults();
            });
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            (_this.queries.get(queryId) || observableQuery["queryInfo"]).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.startGraphQLSubscription = function(options) {
        var _this = this;
        var query = options.query, variables = options.variables;
        var fetchPolicy = options.fetchPolicy, _a = options.errorPolicy, errorPolicy = _a === void 0 ? "none" : _a, _b = options.context, context = _b === void 0 ? {} : _b, _c = options.extensions, extensions = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables, extensions).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if ((0, $f8e7d4b4bf21978e$export$5f47a9fb9a521654)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $5333c7f04e9cca43$export$b4df399e879e53ab)(result);
                var hasProtocolErrors = (0, $456cf4c370166a0f$export$345f95cc6b6b9b0b)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $456cf4c370166a0f$export$4995664c1b49842e];
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, $456cf4c370166a0f$export$26a337512320b8c6)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        var _a;
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            (_a = this.queries.get(queryId)) === null || _a === void 0 || _a.stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            var _a;
            return (_a = info.observableQuery) === null || _a === void 0 ? void 0 : _a["notify"]();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, extensions, // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(serverQuery) || void 0,
                context: this.prepareContext((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), {
                    forceFetch: !deduplication
                })),
                extensions: extensions
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $722312be2835bfdf$export$c2d084dc44961371)(serverQuery);
                var varJson_1 = (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast_1 = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)([
                        (0, $88c17748fb93d3ed$export$51396ec711da548b)(link, operation)
                    ]);
                    observable = entry.observable = concast_1;
                    concast_1.beforeNext(function cb(method, arg) {
                        if (method === "next" && "hasNext" in arg && arg.hasNext) concast_1.beforeNext(cb);
                        else inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            } else observable = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)([
                (0, $88c17748fb93d3ed$export$51396ec711da548b)(link, operation)
            ]);
        } else {
            observable = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)([
                (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $558b9f91eb7bf726$export$707ee4c4c95d39e3)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $558b9f91eb7bf726$export$707ee4c4c95d39e3)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $5333c7f04e9cca43$export$a163557155188b6e)(result);
            var hasErrors = graphQLErrors.length > 0;
            var errorPolicy = options.errorPolicy;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && errorPolicy === "none") // Throwing here effectively calls observer.error.
                throw queryInfo.markError(new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                    graphQLErrors: graphQLErrors
                }));
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready
            };
            // In the case we start multiple network requests simulatenously, we
            // want to ensure we properly set `data` if we're reporting on an old
            // result which will not be caught by the conditional above that ends up
            // throwing the markError result.
            if (hasErrors && errorPolicy === "none") aqr.data = void 0;
            if (hasErrors && errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $456cf4c370166a0f$export$17f5e6bd290bb15d)(networkError) ? networkError : new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                networkError: networkError
            });
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryInfo, options, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
        if (query === void 0) query = options.query;
        var variables = this.getVariables(query, options.variables);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryInfo.queryId);
        };
        this.fetchCancelFns.set(queryInfo.queryId, function(reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $14071c0503b706b7$export$d0c8ec0fe1b18b70)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: (_this.queries.get(queryId) || oq["queryInfo"]).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            // Since you can perform any combination of cache reads and/or writes in
            // the cache.batch update function, its optimistic option can be either
            // a boolean or a string, representing three distinct modes of
            // operation:
            //
            // * false: read/write only the root layer
            // * true: read/write the topmost layer
            // * string: read/write a fresh optimistic layer with that ID string
            //
            // When typeof optimistic === "string", a new optimistic layer will be
            // temporarily created within cache.batch with that string as its ID. If
            // we then pass that same string as the removeOptimistic option, we can
            // make cache.batch immediately remove the optimistic layer after
            // running the updateCache function, triggering only one broadcast.
            //
            // However, the refetchQueries method accepts only true or false for its
            // optimistic option (not string). We interpret true to mean a temporary
            // optimistic layer should be created, to allow efficiently rolling back
            // the effect of the updateCache function, which involves passing a
            // string instead of true as the optimistic option to cache.batch, when
            // refetchQueries receives optimistic: true.
            //
            // In other words, we are deliberately not supporting the use case of
            // writing to an *existing* optimistic layer (using the refetchQueries
            // updateCache function), since that would potentially interfere with
            // other optimistic updates in progress. Instead, you can read/write
            // only the root layer by passing optimistic: false to refetchQueries,
            // or you can read/write a brand new optimistic layer that will be
            // automatically removed by passing optimistic: true.
            optimistic: optimistic && removeOptimistic || false,
            // The removeOptimistic option can also be provided by itself, even if
            // optimistic === false, to remove some previously-added optimistic
            // layer safely and efficiently, like we do in markMutationResult.
            //
            // If an explicit removeOptimistic string is provided with optimistic:
            // true, the removeOptimistic string will determine the ID of the
            // temporary optimistic layer, in case that ever matters.
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $f8e7d4b4bf21978e$export$79a6120a39c90b6a) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        // Since we're about to handle this query now, remove it from
                        // includedQueriesById, in case it was added earlier because of
                        // options.include.
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) // The onQueryUpdated function requested the default refetching
                        // behavior by returning true.
                        result = oq.refetch();
                        // Record the result in the results Map, as long as onQueryUpdated
                        // did not return false to skip/ignore this result.
                        if (result !== false) results.set(oq, result);
                        // Allow the default cache broadcast to happen, except when
                        // onQueryUpdated returns false.
                        return result;
                    }
                    if (onQueryUpdated !== null) // If we don't have an onQueryUpdated function, and onQueryUpdated
                    // was not disabled by passing null, make sure this query is
                    // "included" like any other options.include-specified query.
                    includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) diff = (0, $c7b1e48e566741e9$export$d18d1529326946c4)("canonizeResults", function() {
                    return _this.cache.diff(oq["queryInfo"]["getDiffOptions"]());
                });
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.maskOperation = function(options) {
        var _a, _b, _c;
        var document = options.document, data = options.data;
        if (globalThis.__DEV__ !== false) {
            var fetchPolicy = options.fetchPolicy, id = options.id;
            var operationType = (_a = (0, $818d93327cb72c29$export$7a5b1fa979d2c158)(document)) === null || _a === void 0 ? void 0 : _a.operation;
            var operationId = ((_b = operationType === null || operationType === void 0 ? void 0 : operationType[0]) !== null && _b !== void 0 ? _b : "o") + id;
            if (this.dataMasking && fetchPolicy === "no-cache" && !(0, $7f688c9754699513$export$5b84f3d7865d4e49)(document) && !this.noCacheWarningsByQueryId.has(operationId)) {
                this.noCacheWarningsByQueryId.add(operationId);
                globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(45, (_c = (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(document)) !== null && _c !== void 0 ? _c : "Unnamed ".concat(operationType !== null && operationType !== void 0 ? operationType : "operation"));
            }
        }
        return this.dataMasking ? (0, $c0327452fa319b31$export$74a61e4252a4a2ef)(data, document, this.cache) : data;
    };
    QueryManager.prototype.maskFragment = function(options) {
        var data = options.data, fragment = options.fragment, fragmentName = options.fragmentName;
        return this.dataMasking ? (0, $553b831e0c7e9b12$export$adbebb59d1aeea97)(data, fragment, this.cache, fragmentName) : data;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(data, {})) (0, $3118fa29bcf9f4b2$export$b7e1973aacac3ae7)(diff.missing);
            var fromData = function(data) {
                return (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    data: data,
                    loading: (0, $72c5140a632c7fa1$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch && refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $72c5140a632c7fa1$export$37509604341a3464)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    // Note that queryInfo.getDiff() for no-cache queries does not call
                    // cache.diff, but instead returns a { complete: false } stub result
                    // when there is no queryInfo.diff already defined.
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getOrCreateQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $f8e7d4b4bf21978e$export$79a6120a39c90b6a)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.defaultContext), newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();





function $6320ab015e2889cc$export$e7ecd7c16613ccfd(node) {
    return $6320ab015e2889cc$export$4cedd8740794bd78(node) || $6320ab015e2889cc$export$b05c7141ec7770ba(node) || $6320ab015e2889cc$export$fbc18e88163d676d(node);
}
function $6320ab015e2889cc$export$4cedd8740794bd78(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
}
function $6320ab015e2889cc$export$65772b71e1d017ba(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INLINE_FRAGMENT;
}
function $6320ab015e2889cc$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INT || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FLOAT || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).STRING || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).BOOLEAN || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NULL || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT;
}
function $6320ab015e2889cc$export$f95bfad9e6aea45f(node) {
    return $6320ab015e2889cc$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST ? node.values.some($6320ab015e2889cc$export$f95bfad9e6aea45f) : node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT ? node.fields.some((field)=>$6320ab015e2889cc$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE);
}
function $6320ab015e2889cc$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAMED_TYPE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST_TYPE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NON_NULL_TYPE;
}
function $6320ab015e2889cc$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_DEFINITION || $6320ab015e2889cc$export$a3584bba04f5bfe0(node) || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_DEFINITION;
}
function $6320ab015e2889cc$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION;
}
function $6320ab015e2889cc$export$fbc18e88163d676d(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_EXTENSION || $6320ab015e2889cc$export$d7907721b241e11f(node);
}
function $6320ab015e2889cc$export$d7907721b241e11f(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION;
}
function $6320ab015e2889cc$export$9c93c002c59dc2d6(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).TYPE_COORDINATE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).MEMBER_COORDINATE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ARGUMENT_COORDINATE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_COORDINATE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_ARGUMENT_COORDINATE;
}




var $0b37964519c908de$export$ac9723609f5c76c2 = new (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360)();
var $0b37964519c908de$var$cacheInfoMap = new WeakMap();
function $0b37964519c908de$var$getCacheInfo(cache) {
    var info = $0b37964519c908de$var$cacheInfoMap.get(cache);
    if (!info) $0b37964519c908de$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $f96bffcf733fdbbf$export$c723b7eff9d8f870)()
    });
    return info;
}
function $0b37964519c908de$export$cbe12faed7725318(cache) {
    $0b37964519c908de$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $0b37964519c908de$export$f342bdd61b3e9412(cache) {
    $0b37964519c908de$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $0b37964519c908de$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    $0b37964519c908de$var$getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    $0b37964519c908de$var$broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = $0b37964519c908de$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $0b37964519c908de$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $0b37964519c908de$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $0b37964519c908de$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}


var $99c0c2fd8aedf706$export$19901bcd339c3ded = /** @class */ function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $0217b27a7999d1ae$export$dd702b3c8240390c)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $0217b27a7999d1ae$export$dd702b3c8240390c)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function(_a) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var document = _b.document, remoteResult = _b.remoteResult, context = _b.context, variables = _b.variables, _c = _b.onlyRunForcedResolvers, onlyRunForcedResolvers = _c === void 0 ? false : _c;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2 /*return*/ ,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function(document) {
        return (0, $202b8a19e6086c64$export$8eae69e876ee321e)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), {
            cache: cache,
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function(document_1) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2 /*return*/ ,
                    (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $78b48476e314521e$export$bf638b60ea8b89b7)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $78b48476e314521e$export$a89c95c098ac2a58;
                    }
                }
            }
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $202b8a19e6086c64$export$57c368c23873f32b)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document_1, rootValue_1) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
                mainDefinition = (0, $818d93327cb72c29$export$f431198736b7f96d)(document);
                fragments = (0, $818d93327cb72c29$export$5320a7ba9466a3df)(document);
                fragmentMap = (0, $7f688c9754699513$export$193789b4c8246dd4)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2 /*return*/ ,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [
                                2 /*return*/ 
                            ];
                            if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, variables)) // Skip this entirely.
                            return [
                                2 /*return*/ 
                            ];
                            if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) return [
                                2 /*return*/ ,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $9d830e5028848843$export$7d1ad22471852218)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $9d830e5028848843$export$22a1cdafaf27bcff)(selection)) fragment = selection;
                            else {
                                // This is a named fragment.
                                fragment = fragmentMap[selection.name.value];
                                (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragment, 21, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2 /*return*/ ,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $0217b27a7999d1ae$export$160070228be94b08)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                if (!rootValue) return [
                    2 /*return*/ ,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $9d830e5028848843$export$7d1ad22471852218)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(// In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        (0, $0b37964519c908de$export$ac9723609f5c76c2).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2 /*return*/ ,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        // Handle all scalar types here.
                        if (!field.selectionSet) return result;
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) // Basically any field in a GraphQL response can be null, or missing
                        return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            // This is a nested array, recurse.
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            // This is an object, run the selection set on it.
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $78b48476e314521e$export$bf638b60ea8b89b7)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $6320ab015e2889cc$export$65772b71e1d017ba)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragment, 22, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $6320ab015e2889cc$export$65772b71e1d017ba)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();




function $1a9f9b47c9ebef70$export$235b7fc70b9fc359(defaults, options) {
    return (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, defaults && defaults.variables), options.variables))
    });
}




var $9cf0de8518e6cdc4$var$hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an `ApolloLink` instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through `Observable` instances.
 */ var $9cf0de8518e6cdc4$export$13f5a5f0f1dbab88 = /** @class */ function() {
    /**
     * Constructs an instance of `ApolloClient`.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */ function ApolloClient(options) {
        var _this = this;
        var _a, _b, _c;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $28d90d877eb1e517$export$3991762405098ea)(16);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _d = options.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = options.ssrForceFetchDelay, ssrForceFetchDelay = _e === void 0 ? 0 : _e, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = options.connectToDevTools, _f = options.queryDeduplication, queryDeduplication = _f === void 0 ? true : _f, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _g = options.assumeImmutableResults, assumeImmutableResults = _g === void 0 ? cache.assumeImmutableResults : _g, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwareness = options.clientAwareness, clientAwarenessName = options.name, clientAwarenessVersion = options.version, devtools = options.devtools, dataMasking = options.dataMasking;
        if (globalThis.__DEV__ !== false) {
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead.");
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead.");
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead.");
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead.");
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead.");
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead.");
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "typeDefs", "ApolloClient");
            if (!options.link) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(17);
        }
        var link = options.link;
        if (!link) link = uri ? new (0, $4c2d109245a5920b$export$f4bbf1aec241cc1)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        this.devtoolsConfig = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, devtools), {
            enabled: (_a = devtools === null || devtools === void 0 ? void 0 : devtools.enabled) !== null && _a !== void 0 ? _a : connectToDevTools
        });
        if (this.devtoolsConfig.enabled === undefined) this.devtoolsConfig.enabled = globalThis.__DEV__ !== false;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.watchFragment = this.watchFragment.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, $fb2c94d2c044c7c5$export$83d89fbfd8236492);
        this.localState = new (0, $99c0c2fd8aedf706$export$19901bcd339c3ded)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $957978b378afd274$export$b986383a50b53ea4)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            dataMasking: !!dataMasking,
            clientAwareness: {
                name: (_b = clientAwareness === null || clientAwareness === void 0 ? void 0 : clientAwareness.name) !== null && _b !== void 0 ? _b : clientAwarenessName,
                version: (_c = clientAwareness === null || clientAwareness === void 0 ? void 0 : clientAwareness.version) !== null && _c !== void 0 ? _c : clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: this.devtoolsConfig.enabled ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (this.devtoolsConfig.enabled) this.connectToDevTools();
    }
    Object.defineProperty(ApolloClient.prototype, "prioritizeCacheValues", {
        /**
         * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
         * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
         * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
         *
         * This can e.g. be used to prioritize the cache during the first render after SSR.
         */ get: function() {
            return this.disableNetworkFetches;
        },
        set: function(value) {
            this.disableNetworkFetches = value;
        },
        enumerable: false,
        configurable: true
    });
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "undefined") return;
        var windowWithDevTools = window;
        var devtoolsSymbol = Symbol.for("apollo.devtools");
        (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
        windowWithDevTools.__APOLLO_CLIENT__ = this;
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!$9cf0de8518e6cdc4$var$hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            $9cf0de8518e6cdc4$var$hasSuggestedDevtools = true;
            if (window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol)) setTimeout(function() {
                if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */ get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */ ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an `ObservableQuery`. We can subscribe to this `ObservableQuery` and
     * receive updated results through an observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options);
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        if (globalThis.__DEV__ !== false) {
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "canonizeResults", "client.watchQuery");
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "partialRefetch", "client.watchQuery");
        }
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type `QueryOptions` that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(this.defaultOptions.query, options);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(options.fetchPolicy !== "cache-and-network", 18);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        if (globalThis.__DEV__ !== false) {
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "canonizeResults", "client.query");
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed.");
            if (options.fetchPolicy === "standby") globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(19);
        }
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */ ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * `Observable` which either emits received data or an error.
     */ ApolloClient.prototype.subscribe = function(options) {
        var _this = this;
        var id = this.queryManager.generateQueryId();
        return this.queryManager.startGraphQLSubscription(options).map(function(result) {
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), {
                data: _this.queryManager.maskOperation({
                    document: options.query,
                    data: result.data,
                    fetchPolicy: options.fetchPolicy,
                    id: id
                })
            });
        });
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Watches the cache store of the fragment according to the options specified
     * and returns an `Observable`. We can subscribe to this
     * `Observable` and receive updated results through an
     * observer when the cache store changes.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @since 3.10.0
     * @param options - An object of type `WatchFragmentOptions` that allows
     * the cache to identify the fragment and optionally specify whether to react
     * to optimistic updates.
     */ ApolloClient.prototype.watchFragment = function(options) {
        var _a;
        return this.cache.watchFragment((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), (_a = {}, _a[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, _a)));
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */ ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $88c17748fb93d3ed$export$51396ec711da548b)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */ ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).debug(20, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */ ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */ ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     *
     * @deprecated `addResolvers` will been removed in Apollo Client 4.0. It is
     * safe to continue using this method in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * No action needed
     *
     * **When upgrading**
     *
     * Use `client.localState.addResolvers(resolvers)`. Alternatively, store
     * the `LocalState` instance in a separate variable and call `addResolvers` on
     * that.
     */ ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     *
     * @deprecated `setResolvers` will been removed in Apollo Client 4.0. It is
     * safe to continue using this method in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * If possible, stop using the `setResolvers` method.
     *
     * **When upgrading**
     *
     * Remove the use of `setResolvers`.
     */ ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     *
     * @deprecated `getResolvers` will be removed in Apollo Client 4.0. It is
     * safe to continue using this method in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * If possible, stop using the `getResolvers` method.
     *
     * **When upgrading**
     *
     * Remove the use of `getResolvers`.
     */ ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     *
     * @deprecated Custom fragment matchers will no longer be supported in Apollo
     * Client 4.0 and has been replaced by `cache.fragmentMatches`. It is safe to
     * continue using `setLocalStateFragmentMatcher` in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * No action needed
     *
     * **When upgrading**
     *
     * Leverage `possibleTypes` with `InMemoryCache` to ensure fragments match
     * correctly. Ensure `possibleTypes` include local types if needed. If working
     * with a 3rd party cache implementation, ensure the 3rd party cache implements
     * the `cache.fragmentMatches` method. This function should no longer be used.
     */ ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function() {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}();
if (globalThis.__DEV__ !== false) $9cf0de8518e6cdc4$export$13f5a5f0f1dbab88.prototype.getMemoryInternals = (0, $1da01699264b6e1e$export$dfdba94ce46d2ea5);



var $69607e38bd2400f2$exports = {};
"use strict";
// We don't want bundlers to error when they encounter usage of any of these exports.
// It's up to the package author to ensure that if they access React internals,
// they do so in a safe way that won't break if React changes how they use these internals.
// (e.g. only access them in development, and only in an optional way that won't
// break if internals are not there or do not have the expected structure)
// @ts-ignore
$69607e38bd2400f2$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = undefined;
// @ts-ignore
$69607e38bd2400f2$exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;
// @ts-ignore
$69607e38bd2400f2$exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;

// Here we actually pull in the React library and add everything
// it exports to our own `module.exports`.
// If React suddenly were to add one of the above "polyfilled" exports,
// the React version would overwrite our version, so this should be
// future-proof.
Object.assign($69607e38bd2400f2$exports, (parcelRequire("acw62")));





// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var $14505e8b7f660318$var$contextKey = (0, $5d0a073f980bb2a3$export$23ba675b4b838b92) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $14505e8b7f660318$export$a47505d961ee3a1() {
    (0, $28d90d877eb1e517$export$f5708dca728d7177)("createContext" in $69607e38bd2400f2$exports, 69);
    var context = $69607e38bd2400f2$exports.createContext[$14505e8b7f660318$var$contextKey];
    if (!context) {
        Object.defineProperty($69607e38bd2400f2$exports.createContext, $14505e8b7f660318$var$contextKey, {
            value: context = $69607e38bd2400f2$exports.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $14505e8b7f660318$export$c2ee824bcc89ca6a = function() {
    if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(70);
    return $14505e8b7f660318$export$a47505d961ee3a1();
};


var $93ef3346b14b7851$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $14505e8b7f660318$export$a47505d961ee3a1)();
    var parentContext = $69607e38bd2400f2$exports.useContext(ApolloContext);
    var context = $69607e38bd2400f2$exports.useMemo(function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(context.client, 71);
    return $69607e38bd2400f2$exports.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};















var $3b55b3aff583fbaf$export$5fc74f25506aa9c = /** @class */ function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)((0, $7f688c9754699513$export$abbf37c7cf644e41), {
            max: (0, $c506be9be1a65610$export$f29926b23b28936b)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
            cache: (0, $947797cdb9e55a2d$export$87b462129af3b7d4)
        });
    }
    // Function used to lookup a fragment when a fragment definition is not part
    // of the GraphQL document. This is useful for caches, such as InMemoryCache,
    // that register fragments ahead of time so they can be referenced by name.
    ApolloCache.prototype.lookupFragment = function(fragmentName) {
        return null;
    };
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        var _this = this;
        if (optimistic === void 0) optimistic = !!options.optimistic;
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.readQuery");
        return (0, $c7b1e48e566741e9$export$d18d1529326946c4)("canonizeResults", function() {
            return _this.read((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                rootId: options.id || "ROOT_QUERY",
                optimistic: optimistic
            }));
        });
    };
    /** {@inheritDoc @apollo/client!ApolloClient#watchFragment:member(1)} */ ApolloCache.prototype.watchFragment = function(options) {
        var _this = this;
        var fragment = options.fragment, fragmentName = options.fragmentName, from = options.from, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, otherOptions = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(options, [
            "fragment",
            "fragmentName",
            "from",
            "optimistic"
        ]);
        var query = this.getFragmentDoc(fragment, fragmentName);
        // While our TypeScript types do not allow for `undefined` as a valid
        // `from`, its possible `useFragment` gives us an `undefined` since it
        // calls` cache.identify` and provides that value to `from`. We are
        // adding this fix here however to ensure those using plain JavaScript
        // and using `cache.identify` themselves will avoid seeing the obscure
        // warning.
        var id = typeof from === "undefined" || typeof from === "string" ? from : this.identify(from);
        var dataMasking = !!options[Symbol.for("apollo.dataMasking")];
        if (globalThis.__DEV__ !== false) {
            var actualFragmentName = fragmentName || (0, $818d93327cb72c29$export$772111caef41b3f5)(fragment).name.value;
            if (!id) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(1, actualFragmentName);
        }
        var diffOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, otherOptions), {
            returnPartialData: true,
            id: id,
            query: query,
            optimistic: optimistic
        });
        var latestDiff;
        return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
            return _this.watch((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, diffOptions), {
                immediate: true,
                callback: function(diff) {
                    var data = dataMasking ? (0, $553b831e0c7e9b12$export$adbebb59d1aeea97)(diff.result, fragment, _this, fragmentName) : diff.result;
                    if (// Always ensure we deliver the first result
                    latestDiff && (0, $3703278c0cb633ee$export$5e40714c5ad44445)(query, {
                        data: latestDiff.result
                    }, {
                        data: data
                    }, // TODO: Fix the type on WatchFragmentOptions so that TVars
                    // extends OperationVariables
                    options.variables)) return;
                    var result = {
                        data: data,
                        complete: !!diff.complete
                    };
                    if (diff.missing) result.missing = (0, $0217b27a7999d1ae$export$160070228be94b08)(diff.missing.map(function(error) {
                        return error.missing;
                    }));
                    latestDiff = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, diff), {
                        result: data
                    });
                    observer.next(result);
                }
            }));
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        var _this = this;
        if (optimistic === void 0) optimistic = !!options.optimistic;
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.readFragment");
        return (0, $c7b1e48e566741e9$export$d18d1529326946c4)("canonizeResults", function() {
            return _this.read((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                query: _this.getFragmentDoc(options.fragment, options.fragmentName),
                rootId: options.id,
                optimistic: optimistic
            }));
        });
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.updateQuery");
        return this.batch({
            update: function(cache) {
                var value = (0, $c7b1e48e566741e9$export$d18d1529326946c4)("canonizeResults", function() {
                    return cache.readQuery(options);
                });
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.updateFragment");
        return this.batch({
            update: function(cache) {
                var value = (0, $c7b1e48e566741e9$export$d18d1529326946c4)("canonizeResults", function() {
                    return cache.readFragment(options);
                });
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();
if (globalThis.__DEV__ !== false) $3b55b3aff583fbaf$export$5fc74f25506aa9c.prototype.getMemoryInternals = (0, $1da01699264b6e1e$export$e7ed438e82606689);



var $5b6ca74647771eb2$export$257c68286583b0f9 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);















var $3f1d3403edb822de$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $3f1d3403edb822de$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $3f1d3403edb822de$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$3f1d3403edb822de$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$3f1d3403edb822de$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if ($3f1d3403edb822de$export$b931b78cbb3caf86(id) && !$3f1d3403edb822de$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$3f1d3403edb822de$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $3f1d3403edb822de$var$defaultConfig = {
    dataIdFromObject: $3f1d3403edb822de$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false
};
function $3f1d3403edb822de$export$fa542f9ee3f7f4e2(config) {
    return (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)($3f1d3403edb822de$var$defaultConfig, config);
}
function $3f1d3403edb822de$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $3f1d3403edb822de$var$defaultConfig.canonizeResults : value;
}
function $3f1d3403edb822de$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $3f1d3403edb822de$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $3f1d3403edb822de$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($3f1d3403edb822de$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $3f1d3403edb822de$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(result)) return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(result) ? result.every(function(item) {
        return $3f1d3403edb822de$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(field) && (0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(field, variables)) {
            var key = (0, $9d830e5028848843$export$7d1ad22471852218)(field);
            return $3f1d3403edb822de$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $3f1d3403edb822de$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function $3f1d3403edb822de$export$4f39afca21bd938e(value) {
    return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && !(0, $9d830e5028848843$export$fa99cac1c0883c47)(value) && !(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value);
}
function $3f1d3403edb822de$export$b874a818f7a2fa6d() {
    return new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
}
function $3f1d3403edb822de$export$3a33c00f0ae4a480(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}


var $0268d457c22a2684$var$DELETE = Object.create(null);
var $0268d457c22a2684$var$delModifier = function() {
    return $0268d457c22a2684$var$DELETE;
};
var $0268d457c22a2684$var$INVALIDATE = Object.create(null);
var $0268d457c22a2684$export$cb507f57054c7321 = /** @class */ function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $310a6ebe531ba02b$export$7f9c177735b71f18)((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function(objOrRef) {
            return (0, $9d830e5028848843$export$fa99cac1c0883c47)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $9d830e5028848843$export$634ae0e932e9be99)(objOrIdOrRef);
            if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $9d830e5028848843$export$634ae0e932e9be99)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $0268d457c22a2684$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $0268d457c22a2684$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(older)) older = older.__ref;
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(typeof dataId === "string", 2);
        var merged = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)($0268d457c22a2684$var$storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $0268d457c22a2684$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $0268d457c22a2684$var$DELETE,
                INVALIDATE: $0268d457c22a2684$var$INVALIDATE,
                isReference: (0, $9d830e5028848843$export$fa99cac1c0883c47),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $9d830e5028848843$export$634ae0e932e9be99)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $0268d457c22a2684$var$delModifier ? $0268d457c22a2684$var$DELETE : modify((0, $310a6ebe531ba02b$export$7f9c177735b71f18)(fieldValue), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $0268d457c22a2684$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $0268d457c22a2684$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function(ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(3, ref);
                                        return true;
                                    }
                                };
                                if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for(var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++){
                                        var value = newValue_1[_i];
                                        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            var id = _this.policies.identify(value)[0];
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(4, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $0268d457c22a2684$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $0268d457c22a2684$var$delModifier, _a) : $0268d457c22a2684$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $0268d457c22a2684$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $0268d457c22a2684$var$Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $0268d457c22a2684$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function(obj) {
                if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(obj)) found_1[obj.__ref] = true;
                if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var $0268d457c22a2684$var$CacheGroup = /** @class */ function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $f96bffcf733fdbbf$export$c723b7eff9d8f870)() : null;
        this.keyMaker = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($0268d457c22a2684$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d($0268d457c22a2684$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($0268d457c22a2684$var$makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $0268d457c22a2684$var$makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function $0268d457c22a2684$export$f8068a30967ddc18(store, entityId) {
    if ($0268d457c22a2684$export$488c0743feab3d61(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ function(_super) {
        (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $0268d457c22a2684$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $0268d457c22a2684$var$Stump(_this);
            _this.storageTrie = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($0268d457c22a2684$export$cb507f57054c7321 || ($0268d457c22a2684$export$cb507f57054c7321 = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var $0268d457c22a2684$var$Layer = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                _this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, dataId) ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, // @ts-expect-error
        arguments);
    };
    return Layer;
}($0268d457c22a2684$export$cb507f57054c7321);
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var $0268d457c22a2684$var$Stump = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $0268d457c22a2684$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}($0268d457c22a2684$var$Layer);
function $0268d457c22a2684$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $0268d457c22a2684$export$488c0743feab3d61(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof $0268d457c22a2684$export$cb507f57054c7321 && store.group.caching);
}








function $4a344505b0ae796e$var$shallowCopy(value) {
    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value) ? value.slice(0) : (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var $4a344505b0ae796e$export$c2e7fdd82233f4a4 = /** @class */ function() {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new ((0, $5d0a073f980bb2a3$export$7293b8a0b474028d) ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
            var copy = $4a344505b0ae796e$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();


function $145a33e3a7865af6$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults
    ];
}
var $145a33e3a7865af6$export$628ef07ba8965f12 = /** @class */ function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.config = (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $3f1d3403edb822de$export$3ac2a95fbd99c479)(config)
        });
        this.canon = config.canon || new (0, $4a344505b0ae796e$export$c2e7fdd82233f4a4)();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $145a33e3a7865af6$var$execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, other), {
                    // If we previously read this result without canonizing it, we can
                    // reuse that result simply by canonizing it now.
                    result: _this.canon.admit(other.result)
                });
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            (0, $0268d457c22a2684$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $c506be9be1a65610$export$f29926b23b28936b)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: $145a33e3a7865af6$var$execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $0268d457c22a2684$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $9d830e5028848843$export$fa99cac1c0883c47)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(function(options) {
            (0, $0268d457c22a2684$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $c506be9be1a65610$export$f29926b23b28936b)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $0268d457c22a2684$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $4a344505b0ae796e$export$c2e7fdd82233f4a4)();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $818d93327cb72c29$export$84c19026e616569e)((0, $818d93327cb72c29$export$d96b2213c1b9d3a9)(query))), variables);
        var rootRef = (0, $9d830e5028848843$export$634ae0e932e9be99)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $818d93327cb72c29$export$f431198736b7f96d)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)(variables),
                canonizeResults: canonizeResults
            }, (0, $3f1d3403edb822de$export$3a33c00f0ae4a480)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new (0, $5b6ca74647771eb2$export$257c68286583b0f9)($145a33e3a7865af6$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $0268d457c22a2684$export$488c0743feab3d61)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one, and this.config.addTypename is true. Note
        // that this field can be overridden by other merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, variables)) return;
            if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $9d830e5028848843$export$7d1ad22471852218)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $202b8a19e6086c64$export$43b332f87950a467).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(fieldValue)) {
                    if (fieldValue.length > 0) fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context
                    }), resultName);
                } else if (!selection.selectionSet) // If the field does not have a selection set, then we handle it
                // as a scalar value. To keep this.canon from canonicalizing
                // this value, we use this.canon.pass to wrap fieldValue in a
                // Pass object that this.canon.admit will later unwrap as-is.
                {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $9d830e5028848843$export$fa99cac1c0883c47)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $7f688c9754699513$export$f80bdb85f299186)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $28d90d877eb1e517$export$3991762405098ea)(10, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $0217b27a7999d1ae$export$160070228be94b08)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $310a6ebe531ba02b$export$7f9c177735b71f18)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $9d830e5028848843$export$fa99cac1c0883c47)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $145a33e3a7865af6$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $145a33e3a7865af6$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $145a33e3a7865af6$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
                (0, $28d90d877eb1e517$export$f5708dca728d7177)(!(0, $9d830e5028848843$export$fa99cac1c0883c47)(value), 11, (0, $3f1d3403edb822de$export$fdef206c83ff2c09)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

















// Mapping from JSON-encoded KeySpecifier strings to associated information.
var $113f43d0843b9450$var$specifierInfoCache = Object.create(null);
function $113f43d0843b9450$var$lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return $113f43d0843b9450$var$specifierInfoCache[cacheKey] || ($113f43d0843b9450$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $113f43d0843b9450$export$f1953a0407594d2c(specifier) {
    var info = $113f43d0843b9450$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $113f43d0843b9450$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $113f43d0843b9450$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = $113f43d0843b9450$export$e8f64f7a025887d3(object, schemaKeyPath, $113f43d0843b9450$var$extractKey);
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(extracted !== void 0, 5, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $113f43d0843b9450$export$550737ee0cc371ac(specifier) {
    var info = $113f43d0843b9450$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $113f43d0843b9450$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    var directiveArgs = d && (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && $113f43d0843b9450$export$e8f64f7a025887d3(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $113f43d0843b9450$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return $113f43d0843b9450$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $113f43d0843b9450$export$2db31da99613c21f(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
    return $113f43d0843b9450$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $113f43d0843b9450$export$eca459f173e85801(spec) {
    var info = $113f43d0843b9450$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(s)) {
                $113f43d0843b9450$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $113f43d0843b9450$var$extractKey(object, key) {
    return object[key];
}
function $113f43d0843b9450$export$e8f64f7a025887d3(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || $113f43d0843b9450$var$extractKey;
    return $113f43d0843b9450$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $113f43d0843b9450$var$normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
        if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value)) return value.map($113f43d0843b9450$var$normalize);
        return $113f43d0843b9450$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $113f43d0843b9450$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}



function $8557ced3c8197c32$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(spec.field, spec.variables) : null;
}
var $8557ced3c8197c32$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $8557ced3c8197c32$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var $8557ced3c8197c32$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $8557ced3c8197c32$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $8557ced3c8197c32$export$e9859ad90648930b = /** @class */ function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            dataIdFromObject: (0, $3f1d3403edb822de$export$bd03c5a9c99d6bce)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $8557ced3c8197c32$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        (0, $6e5089e13e4c0db0$export$2ddf8815a8abe8b).withValue(true, function() {
            while(keyFn){
                var specifierOrId = keyFn((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, object), storeObject), context);
                if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(specifierOrId)) keyFn = (0, $113f43d0843b9450$export$f1953a0407594d2c)(specifierOrId);
                else {
                    id = specifierOrId;
                    break;
                }
            }
        });
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming, existingFieldPolicies) {
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $8557ced3c8197c32$var$mergeTrueFn : merge === false ? $8557ced3c8197c32$var$mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? $8557ced3c8197c32$var$nullKeyFieldsFn : (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(keyFields) ? (0, $113f43d0843b9450$export$f1953a0407594d2c)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = existingFieldPolicies[fieldName];
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            // So here we avoid merging an inherited field policy with an updated one.
            if (!existing || (existing === null || existing === void 0 ? void 0 : existing.typename) !== typename) existing = existingFieldPolicies[fieldName] = {
                typename: typename
            };
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? $8557ced3c8197c32$var$simpleKeyArgsFn : (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(keyArgs) ? (0, $113f43d0843b9450$export$550737ee0cc371ac)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || $8557ced3c8197c32$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(!old || old === which, 6, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $3f1d3403edb822de$export$6ed54d4784f1ce28));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy, _this.typePolicies[typename].fields);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName) {
        if (typename) return this.getTypePolicy(typename).fields[fieldName];
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(7, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue_1.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, $3f1d3403edb822de$export$60bd1cbb09c1a4a2)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $8557ced3c8197c32$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(specifierOrString)) keyFn = (0, $113f43d0843b9450$export$550737ee0cc371ac)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $9d830e5028848843$export$54be8689c65f3b56)(fieldSpec.field, fieldSpec.variables) : (0, $9d830e5028848843$export$3cdb6c178b88cabe)(fieldName, $8557ced3c8197c32$var$argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $8557ced3c8197c32$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, $0b37964519c908de$export$ac9723609f5c76c2).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $8557ced3c8197c32$var$mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return $8557ced3c8197c32$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $8557ced3c8197c32$var$mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $8557ced3c8197c32$var$makeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $8557ced3c8197c32$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $8557ced3c8197c32$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $9d830e5028848843$export$fa99cac1c0883c47),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($8557ced3c8197c32$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $8557ced3c8197c32$var$makeMergeObjectsFunction(context.store)
    };
}
function $8557ced3c8197c32$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(8, (0, $29a424226342d3ac$export$f341b4883239463f)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $8557ced3c8197c32$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(existing) || (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(incoming)) throw (0, $28d90d877eb1e517$export$3991762405098ea)(9);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(existing) && (0, $3a16601e2096f4cd$export$417207af72fad9c9)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(existing) && (0, $3f1d3403edb822de$export$4f39afca21bd938e)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $3f1d3403edb822de$export$4f39afca21bd938e)(existing) && (0, $9d830e5028848843$export$fa99cac1c0883c47)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $3f1d3403edb822de$export$4f39afca21bd938e)(existing) && (0, $3f1d3403edb822de$export$4f39afca21bd938e)(incoming)) return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, existing), incoming);
        }
        return incoming;
    };
}


// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function $e28f51741d388e97$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $e28f51741d388e97$export$eb8361c5d132fb8f = /** @class */ function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $818d93327cb72c29$export$7a5b1fa979d2c158)(query);
        var merger = (0, $3f1d3403edb822de$export$b874a818f7a2fa6d)();
        variables = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $818d93327cb72c29$export$84c19026e616569e)(operationDefinition)), variables);
        var context = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)(variables)
        }, (0, $3f1d3403edb822de$export$3a33c00f0ae4a480)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, $9d830e5028848843$export$fa99cac1c0883c47)(ref)) throw (0, $28d90d877eb1e517$export$3991762405098ea)(12, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $9d830e5028848843$export$634ae0e932e9be99)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $e28f51741d388e97$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $9d830e5028848843$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function() {
            var options = (0, $8557ced3c8197c32$export$1ad7a877581bdf2e)(arguments, incoming, context.variables);
            if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $9d830e5028848843$export$7d1ad22471852218)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $e28f51741d388e97$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? $e28f51741d388e97$var$getContextFlavor(context, false, false) : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, $9d830e5028848843$export$fa99cac1c0883c47)(incomingValue) || (0, $3f1d3403edb822de$export$4f39afca21bd938e)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    // TODO Check compatibility against any existing childTree.field?
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $e28f51741d388e97$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $202b8a19e6086c64$export$43b332f87950a467).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(13, (0, $9d830e5028848843$export$7d1ad22471852218)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $9d830e5028848843$export$634ae0e932e9be99)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $e28f51741d388e97$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: $e28f51741d388e97$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return globalThis.__DEV__ !== false ? (0, $e398dba65b0b4cec$export$629a2bd3f5a49ecc)(value) : value;
        if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $e28f51741d388e97$var$getChildMergeTree(mergeTree, i));
            $e28f51741d388e97$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $9d830e5028848843$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $e28f51741d388e97$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $7f688c9754699513$export$f80bdb85f299186)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $28d90d877eb1e517$export$3991762405098ea)(14, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $e28f51741d388e97$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $9d830e5028848843$export$fa99cac1c0883c47)(incoming)) {
            var e_1 = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, $9d830e5028848843$export$fa99cac1c0883c47)(existing) || (0, $3f1d3403edb822de$export$4f39afca21bd938e)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $9d830e5028848843$export$fa99cac1c0883c47)(e_1) ? e_1.__ref : e_1
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $28d90d877eb1e517$export$f5708dca728d7177)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(i_1) ? i_1.slice(0) : (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $e28f51741d388e97$var$emptyMergeTreePool = [];
function $e28f51741d388e97$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $e28f51741d388e97$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $e28f51741d388e97$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $e28f51741d388e97$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $e28f51741d388e97$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $e28f51741d388e97$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $e28f51741d388e97$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $e28f51741d388e97$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $e28f51741d388e97$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $e28f51741d388e97$var$mergeTreeIsEmpty(childTree)) {
        $e28f51741d388e97$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $e28f51741d388e97$var$warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function $e28f51741d388e97$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if ($e28f51741d388e97$var$warnings.has(typeDotName)) return;
    $e28f51741d388e97$var$warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(existing) && !(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(15, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, existing), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, incoming));
}








var $49c8996098641f51$export$467265324939f47f = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $2e04132f91cc06f1$export$f887060e48e5dc1b)((0, $202b8a19e6086c64$export$43b332f87950a467));
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $0b37964519c908de$export$5345c8ac69b4a9db);
        _this.txCount = 0;
        if (globalThis.__DEV__ !== false) {
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(config, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`.");
            (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(config, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.");
        }
        _this.config = (0, $3f1d3403edb822de$export$fa542f9ee3f7f4e2)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $8557ced3c8197c32$export$e9859ad90648930b)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = this.data = new (0, $0268d457c22a2684$export$cb507f57054c7321).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.addTypenameTransform.resetCache();
        fragments === null || fragments === void 0 || fragments.resetCaches();
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, $e28f51741d388e97$export$eb8361c5d132fb8f)(this, this.storeReader = new (0, $145a33e3a7865af6$export$628ef07ba8965f12)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $3f1d3403edb822de$export$3ac2a95fbd99c479)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $c506be9be1a65610$export$f29926b23b28936b)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: function(c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $0268d457c22a2684$export$488c0743feab3d61)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.read");
        var // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $5b6ca74647771eb2$export$257c68286583b0f9)) // Swallow MissingFieldError and return null, so callers do not need to
            // worry about catching "normal" exceptions resulting from incomplete
            // cache data. Unexpected errors will be re-thrown. If you need more
            // information about which fields were missing, use cache.diff instead,
            // and examine diffResult.missing.
            return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        var store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.diff");
        return this.storeReader.diffQueryAgainstStore((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, $0b37964519c908de$export$f342bdd61b3e9412)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $0b37964519c908de$export$cbe12faed7725318)(_this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        if (globalThis.__DEV__ !== false) (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(options || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option.");
        (0, $0bef48da5254bd54$export$88a0ad9b6f961b51).reset();
        (0, $722312be2835bfdf$export$c2d084dc44961371).reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $0bef48da5254bd54$export$88a0ad9b6f961b51).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $0b37964519c908de$export$cbe12faed7725318)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.fragmentMatches = function(fragment, typename) {
        return this.policies.fragmentMatches(fragment, typename);
    };
    InMemoryCache.prototype.lookupFragment = function(fragmentName) {
        var _a;
        return ((_a = this.config.fragments) === null || _a === void 0 ? void 0 : _a.lookup(fragmentName)) || null;
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var _this = this;
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = (0, $c7b1e48e566741e9$export$d18d1529326946c4)("canonizeResults", function() {
            return _this.diff(c);
        });
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $3b55b3aff583fbaf$export$5fc74f25506aa9c));
if (globalThis.__DEV__ !== false) $49c8996098641f51$export$467265324939f47f.prototype.getMemoryInternals = (0, $1da01699264b6e1e$export$e95a5a2210e62466);


const $aaaeb85662150812$export$3035850968eaa3b6 = // @apollo/client/includeErrors entry point.
// This file is not meant to be imported manually.
{
    2: {
        file: "@apollo/client/cache/inmemory/entityStore.js",
        condition: "typeof dataId === \"string\"",
        message: "store.merge expects a string ID"
    },
    5: {
        file: "@apollo/client/cache/inmemory/key-extractor.js",
        condition: "extracted !== void 0",
        message: "Missing field '%s' while extracting keyFields from %s"
    },
    6: {
        file: "@apollo/client/cache/inmemory/policies.js",
        condition: "!old || old === which",
        message: "Cannot change root %s __typename more than once"
    },
    9: {
        file: "@apollo/client/cache/inmemory/policies.js",
        message: "Cannot automatically merge arrays"
    },
    10: {
        file: "@apollo/client/cache/inmemory/readFromStore.js",
        message: "No fragment named %s"
    },
    11: {
        file: "@apollo/client/cache/inmemory/readFromStore.js",
        condition: "!isReference(value)",
        message: "Missing selection set for object of type %s returned for query field %s"
    },
    12: {
        file: "@apollo/client/cache/inmemory/writeToStore.js",
        message: "Could not identify object %s"
    },
    14: {
        file: "@apollo/client/cache/inmemory/writeToStore.js",
        message: "No fragment named %s"
    },
    16: {
        file: "@apollo/client/core/ApolloClient.js",
        message: "To initialize Apollo Client, you must specify a 'cache' property in the options object. \nFor more information, please visit: https://go.apollo.dev/c/docs"
    },
    18: {
        file: "@apollo/client/core/ApolloClient.js",
        condition: "options.fetchPolicy !== \"cache-and-network\"",
        message: "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only."
    },
    21: {
        file: "@apollo/client/core/LocalState.js",
        condition: "fragment",
        message: "No fragment named %s"
    },
    22: {
        file: "@apollo/client/core/LocalState.js",
        condition: "fragment",
        message: "No fragment named %s"
    },
    29: {
        file: "@apollo/client/core/ObservableQuery.js",
        condition: "updateQuery",
        message: "You must provide an `updateQuery` function when using `fetchMore` with a `no-cache` fetch policy."
    },
    32: {
        file: "@apollo/client/core/ObservableQuery.js",
        condition: "pollInterval",
        message: "Attempted to start a polling query without a polling interval."
    },
    35: {
        file: "@apollo/client/core/QueryManager.js",
        message: "QueryManager stopped while query was in flight"
    },
    36: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "mutation",
        message: "mutation option is required. You must specify your GraphQL document in the mutation option."
    },
    37: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "fetchPolicy === \"network-only\" || fetchPolicy === \"no-cache\"",
        message: "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write."
    },
    38: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "options.query",
        message: "query option is required. You must specify your GraphQL document in the query option."
    },
    39: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "options.query.kind === \"Document\"",
        message: 'You must wrap the query string in a "gql" tag.'
    },
    40: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "!options.returnPartialData",
        message: "returnPartialData option only supported on watchQuery."
    },
    41: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "!options.pollInterval",
        message: "pollInterval option only supported on watchQuery."
    },
    42: {
        file: "@apollo/client/core/QueryManager.js",
        message: "Store reset while query was in flight (not completed in link chain)"
    },
    48: {
        file: "@apollo/client/link/core/ApolloLink.js",
        message: "request is not implemented"
    },
    51: {
        file: "@apollo/client/link/http/checkFetcher.js",
        message: "\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    "
    },
    54: {
        file: "@apollo/client/link/http/serializeFetchParameter.js",
        message: "Network request failed. %s is not serializable: %s"
    },
    55: {
        file: "@apollo/client/link/persisted-queries/index.js",
        condition: "options &&\n    (typeof options.sha256 === \"function\" ||\n        typeof options.generateHash === \"function\")",
        message: 'Missing/invalid "sha256" or "generateHash" function. Please configure one using the "createPersistedQueryLink(options)" options parameter.'
    },
    56: {
        file: "@apollo/client/link/persisted-queries/index.js",
        condition: "forward",
        message: "PersistedQueryLink cannot be the last link in the chain."
    },
    58: {
        file: "@apollo/client/link/utils/validateOperation.js",
        message: "illegal argument: %s"
    },
    59: {
        file: "@apollo/client/masking/maskDefinition.js",
        condition: "fragment",
        message: "Could not find fragment with name '%s'."
    },
    61: {
        file: "@apollo/client/masking/maskFragment.js",
        condition: "fragments.length === 1",
        message: "Found %s fragments. `fragmentName` must be provided when there is not exactly 1 fragment."
    },
    62: {
        file: "@apollo/client/masking/maskFragment.js",
        condition: "!!fragment",
        message: "Could not find fragment with name \"%s\"."
    },
    63: {
        file: "@apollo/client/masking/maskOperation.js",
        condition: "definition",
        message: "Expected a parsed GraphQL document with a query, mutation, or subscription."
    },
    68: {
        file: "@apollo/client/react/context/ApolloConsumer.js",
        condition: "context && context.client",
        message: 'Could not find "client" in the context of ApolloConsumer. Wrap the root component in an <ApolloProvider>.'
    },
    69: {
        file: "@apollo/client/react/context/ApolloContext.js",
        condition: "\"createContext\" in React",
        message: 'Invoking `getApolloContext` in an environment where `React.createContext` is not available.\nThe Apollo Client functionality you are trying to use is only available in React Client Components.\nPlease make sure to add "use client" at the top of your file.\nFor more information, see https://nextjs.org/docs/getting-started/react-essentials#client-components'
    },
    71: {
        file: "@apollo/client/react/context/ApolloProvider.js",
        condition: "context.client",
        message: 'ApolloProvider was not passed a client instance. Make sure you pass in your client via the "client" prop.'
    },
    73: {
        file: "@apollo/client/react/hoc/hoc-utils.js",
        condition: "this.withRef",
        message: "To access the wrapped instance, you need to specify { withRef: true } in the options"
    },
    77: {
        file: "@apollo/client/react/hoc/withApollo.js",
        condition: "operationOptions.withRef",
        message: "To access the wrapped instance, you need to specify { withRef: true } in the options"
    },
    79: {
        file: "@apollo/client/react/hooks/useApolloClient.js",
        condition: "!!client",
        message: 'Could not find "client" in the context or passed in as an option. Wrap the root component in an <ApolloProvider>, or pass an ApolloClient instance in via options.'
    },
    82: {
        file: "@apollo/client/react/hooks/useLoadableQuery.js",
        condition: "!calledDuringRender()",
        message: "useLoadableQuery: 'loadQuery' should not be called during render. To start a query during render, use the 'useBackgroundQuery' hook."
    },
    83: {
        file: "@apollo/client/react/hooks/useLoadableQuery.js",
        condition: "internalQueryRef",
        message: "The query has not been loaded. Please load the query."
    },
    89: {
        file: "@apollo/client/react/hooks/useSubscription.js",
        condition: "!optionsRef.current.skip",
        message: "A subscription that is skipped cannot be restarted."
    },
    90: {
        file: "@apollo/client/react/hooks/useSuspenseQuery.js",
        condition: "supportedFetchPolicies.includes(fetchPolicy)",
        message: "The fetch policy `%s` is not supported with suspense."
    },
    93: {
        file: "@apollo/client/react/internal/cache/QueryReference.js",
        condition: "!queryRef || QUERY_REFERENCE_SYMBOL in queryRef",
        message: "Expected a QueryRef object, but got something else instead."
    },
    95: {
        file: "@apollo/client/react/parser/index.js",
        condition: "!!document && !!document.kind",
        message: "Argument of %s passed to parser was not a valid GraphQL DocumentNode. You may need to use 'graphql-tag' or another method to convert your operation into a document"
    },
    96: {
        file: "@apollo/client/react/parser/index.js",
        condition: "!fragments.length ||\n    queries.length ||\n    mutations.length ||\n    subscriptions.length",
        message: "Passing only a fragment to 'graphql' is not yet supported. You must include a query, subscription or mutation as well"
    },
    97: {
        file: "@apollo/client/react/parser/index.js",
        condition: "queries.length + mutations.length + subscriptions.length <= 1",
        message: "react-apollo only supports a query, subscription, or a mutation per HOC. %s had %s queries, %s subscriptions and %s mutations. You can use 'compose' to join multiple operation types to a component"
    },
    98: {
        file: "@apollo/client/react/parser/index.js",
        condition: "definitions.length === 1",
        message: "react-apollo only supports one definition per HOC. %s had %s definitions. You can use 'compose' to join multiple operation types to a component"
    },
    99: {
        file: "@apollo/client/react/parser/index.js",
        condition: "operation.type === type",
        message: "Running a %s requires a graphql %s, but a %s was used instead."
    },
    102: {
        file: "@apollo/client/testing/core/mocking/mockLink.js",
        condition: "queryWithoutClientOnlyDirectives",
        message: "query is required"
    },
    103: {
        file: "@apollo/client/testing/core/mocking/mockLink.js",
        condition: "mockedResponse.maxUsageCount > 0",
        message: "Mock response maxUsageCount must be greater than 0, %s given"
    },
    105: {
        file: "@apollo/client/utilities/graphql/DocumentTransform.js",
        condition: "Array.isArray(cacheKeys)",
        message: "`getCacheKey` must return an array or undefined"
    },
    106: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: "evaledValue !== void 0",
        message: "Invalid variable referenced in @%s directive."
    },
    107: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: "directiveArguments && directiveArguments.length === 1",
        message: "Incorrect number of arguments for the @%s directive."
    },
    108: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: "ifArgument.name && ifArgument.name.value === \"if\"",
        message: "Invalid argument for the @%s directive."
    },
    109: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: "ifValue &&\n    (ifValue.kind === \"Variable\" || ifValue.kind === \"BooleanValue\")",
        message: "Argument for the @%s directive must be a variable or a boolean value."
    },
    113: {
        file: "@apollo/client/utilities/graphql/fragments.js",
        message: "Found a %s operation%s. No operations are allowed when using a fragment as a query. Only fragments are allowed."
    },
    114: {
        file: "@apollo/client/utilities/graphql/fragments.js",
        condition: "fragments.length === 1",
        message: "Found %s fragments. `fragmentName` must be provided when there is not exactly 1 fragment."
    },
    115: {
        file: "@apollo/client/utilities/graphql/fragments.js",
        condition: "fragment",
        message: "No fragment named %s"
    },
    116: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: "doc && doc.kind === \"Document\"",
        message: "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql"
    },
    117: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        message: "Schema type definitions not allowed in queries. Found: \"%s\""
    },
    118: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: "operations.length <= 1",
        message: "Ambiguous GraphQL document: contains %s operations"
    },
    119: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: "queryDef && queryDef.operation === \"query\"",
        message: "Must contain a query definition."
    },
    120: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: "doc.kind === \"Document\"",
        message: "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql"
    },
    121: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: "doc.definitions.length <= 1",
        message: "Fragment must have exactly one definition."
    },
    122: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: "fragmentDef.kind === \"FragmentDefinition\"",
        message: "Must be a fragment definition."
    },
    123: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        message: "Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment."
    },
    124: {
        file: "@apollo/client/utilities/graphql/storeUtils.js",
        message: 'The inline argument "%s" of kind "%s"is not supported. Use variables instead of inline arguments to overcome this limitation.'
    }
};
const $aaaeb85662150812$export$ddb9677fe3712516 = {
    20: {
        file: "@apollo/client/core/ApolloClient.js",
        message: "In client.refetchQueries, Promise.all promise rejected with error %o"
    },
    34: {
        file: "@apollo/client/core/ObservableQuery.js",
        message: "Missing cache result fields: %o"
    }
};
const $aaaeb85662150812$export$c45ebb6cef9d5b7b = {};
const $aaaeb85662150812$export$9ac06e44a6262020 = {
    1: {
        file: "@apollo/client/cache/core/cache.js",
        message: "Could not identify object passed to `from` for '%s' fragment, either because the object is non-normalized or the key fields are missing. If you are masking this object, please ensure the key fields are requested by the parent object."
    },
    3: {
        file: "@apollo/client/cache/inmemory/entityStore.js",
        message: "cache.modify: You are trying to write a Reference that is not part of the store: %o\nPlease make sure to set the `mergeIntoStore` parameter to `true` when creating a Reference that is not part of the store yet:\n`toReference(object, true)`"
    },
    4: {
        file: "@apollo/client/cache/inmemory/entityStore.js",
        message: "cache.modify: Writing an array with a mix of both References and Objects will not result in the Objects being normalized correctly.\nPlease convert the object instance %o to a Reference before writing it to the cache by calling `toReference(object, true)`."
    },
    7: {
        file: "@apollo/client/cache/inmemory/policies.js",
        message: "Inferring subtype %s of supertype %s"
    },
    8: {
        file: "@apollo/client/cache/inmemory/policies.js",
        message: "Undefined 'from' passed to readField with arguments %s"
    },
    15: {
        file: "@apollo/client/cache/inmemory/writeToStore.js",
        message: "Cache data may be lost when replacing the %s field of a %s object.\n\nThis could cause additional (usually avoidable) network requests to fetch data that were otherwise cached.\n\nTo address this problem (which is not a bug in Apollo Client), %sdefine a custom merge function for the %s field, so InMemoryCache can safely merge these objects:\n\n  existing: %o\n  incoming: %o\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"
    },
    17: {
        file: "@apollo/client/core/ApolloClient.js",
        message: "[ApolloClient]: Apollo Client 4.0 will require a `link` option and will not create a default link when not provided. Please provide a `link` option."
    },
    19: {
        file: "@apollo/client/core/ApolloClient.js",
        message: "[client.query]: Apollo Client 4.0 will no longer support the `standby` fetch policy with `client.query`. Please use a different fetch policy."
    },
    23: {
        file: "@apollo/client/core/ObservableQuery.js",
        message: "[observableQuery.result]: `result` is deprecated and will be removed with Apollo Client 4.0."
    },
    24: {
        file: "@apollo/client/core/ObservableQuery.js",
        message: "[ObservableQuery]: `getLastResult` is deprecated and will be removed in Apollo Client 4.0. Please discontinue using this method."
    },
    25: {
        file: "@apollo/client/core/ObservableQuery.js",
        message: "[ObservableQuery]: `getLastResult` is deprecated and will be removed in Apollo Client 4.0. Please discontinue using this method."
    },
    26: {
        file: "@apollo/client/core/ObservableQuery.js",
        message: "[ObservableQuery]: `getLastResult` is deprecated and will be removed in Apollo Client 4.0. Please discontinue using this method."
    },
    27: {
        file: "@apollo/client/core/ObservableQuery.js",
        message: "[observableQuery.resetQueryStoreErrors]: `resetQueryStoreErrors` is deprecated and will be removed with Apollo Client 4.0. Please discontinue using this method."
    },
    28: {
        file: "@apollo/client/core/ObservableQuery.js",
        message: "Called refetch(%o) for query %o, which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"
    },
    31: {
        file: "@apollo/client/core/ObservableQuery.js",
        message: "[observableQuery.setOptions] `setOptions` is deprecated and will be removed in Apollo Client 4.0. Please use `observableQuery.reobserve(newOptions)` instead."
    },
    43: {
        file: "@apollo/client/core/QueryManager.js",
        message: "Unknown query named \"%s\" requested in refetchQueries options.include array"
    },
    44: {
        file: "@apollo/client/core/QueryManager.js",
        message: "Unknown anonymous query requested in refetchQueries options.include array"
    },
    45: {
        file: "@apollo/client/core/QueryManager.js",
        message: '[%s]: Fragments masked by data masking are inaccessible when using fetch policy "no-cache". Please add `@unmask` to each fragment spread to access the data.'
    },
    46: {
        file: "@apollo/client/link/batch-http/batchHttpLink.js",
        message: "[BatchHttpLink]: Apollo Client 4.0 will no longer remove `@client` fields from queries sent through the link chain. Please open an issue if this warning is displayed under standard usage."
    },
    47: {
        file: "@apollo/client/link/core/ApolloLink.js",
        message: "You are calling concat on a terminating link, which will have no effect %o"
    },
    49: {
        file: "@apollo/client/link/core/ApolloLink.js",
        message: "[ApolloLink] `onError` is deprecated and will be removed with Apollo Client 4.0. Please discontinue using it."
    },
    50: {
        file: "@apollo/client/link/core/ApolloLink.js",
        message: "[ApolloLink] `setOnError` is deprecated and will be removed with Apollo Client 4.0. Please discontinue using it."
    },
    52: {
        file: "@apollo/client/link/http/createHttpLink.js",
        message: "[HttpLink]: Apollo Client 4.0 will no longer remove `@client` fields from queries sent through the link chain. Please open an issue if this warning is displayed under standard usage."
    },
    53: {
        file: "@apollo/client/link/http/createHttpLink.js",
        message: "Multipart-subscriptions do not support @defer"
    },
    57: {
        file: "@apollo/client/link/utils/toPromise.js",
        message: "Promise Wrapper does not support multiple results from Observable"
    },
    60: {
        file: "@apollo/client/masking/maskDefinition.js",
        message: "Accessing unmasked field on %s at path '%s'. This field will not be available when masking is enabled. Please read the field from the fragment instead."
    },
    64: {
        file: "@apollo/client/masking/utils.js",
        message: "The configured cache does not support data masking which effectively disables it. Please use a cache that supports data masking or disable data masking to silence this warning. Caches will be required to support the necessary data masking APIs in Apollo Client 4.0."
    },
    65: {
        file: "@apollo/client/react/components/Mutation.js",
        message: "[Mutation]: The `<Mutation />` component is deprecated and will be removed in Apollo Client 4.0. Please use the `useMutation` React hook instead."
    },
    66: {
        file: "@apollo/client/react/components/Query.js",
        message: "[Query]: The `<Query />` component is deprecated and will be removed in Apollo Client 4.0. Please use an available React hook such as `useQuery` instead."
    },
    67: {
        file: "@apollo/client/react/components/Subscription.js",
        message: "[Subscription]: The `<Subscription />` component is deprecated and will be removed in Apollo Client 4.0. Please use the `useSubscription` React hook instead."
    },
    70: {
        file: "@apollo/client/react/context/ApolloContext.js",
        message: "[resetApolloContext]: `resetApolloContext` is deprecated and will be removed in Apollo Client 4.0. Please use `getApolloContext` instead."
    },
    72: {
        file: "@apollo/client/react/hoc/graphql.js",
        message: "[graphql]: The `graphql` higher order component is deprecated and will be removed in Apollo Client 4.0. Please switch to an available React hook such as `useQuery`, `useMutation`, or `useSubscription`."
    },
    74: {
        file: "@apollo/client/react/hoc/mutation-hoc.js",
        message: "[withMutation]: The `withMutation` higher order component is deprecated and will be removed in Apollo Client 4.0. Please switch to an available React hook such as `useQuery`."
    },
    75: {
        file: "@apollo/client/react/hoc/query-hoc.js",
        message: "[withQuery]: The `withQuery` higher order component is deprecated and will be removed in Apollo Client 4.0. Please switch to an available React hook such as `useQuery`."
    },
    76: {
        file: "@apollo/client/react/hoc/subscription-hoc.js",
        message: "[withSubscription]: The `withSubscription` higher order component is deprecated and will be removed in Apollo Client 4.0. Please switch to an available React hook such as `useSubscription`."
    },
    78: {
        file: "@apollo/client/react/hooks/internal/useWarnRemovedOption.js",
        message: "[%s]: `%s` is a deprecated hook option and will be removed in Apollo Client 4.0. %s"
    },
    80: {
        file: "@apollo/client/react/hooks/useLazyQuery.js",
        message: "[useLazyQuery]: `reobserve` is deprecated and will removed in Apollo Client 4.0. Please change options by rerendering `useLazyQuery` with new options."
    },
    81: {
        file: "@apollo/client/react/hooks/useLazyQuery.js",
        message: "[useLazyQuery]: Calling `execute` in render will throw in Apollo Client 4.0. Either switch to `useQuery` to run the query during render or move the `execute` call inside of `useEffect`."
    },
    84: {
        file: "@apollo/client/react/hooks/useQuery.js",
        message: "[useQuery]: `reobserve` is deprecated and will removed in Apollo Client 4.0. Please change options by rerendering `useQuery` with new options."
    },
    85: {
        file: "@apollo/client/react/hooks/useSubscription.js",
        message: "'useSubscription' supports only the 'onSubscriptionData' or 'onData' option, but not both. Only the 'onData' option will be used."
    },
    86: {
        file: "@apollo/client/react/hooks/useSubscription.js",
        message: "[useSubscription]: `onSubscriptionData` is deprecated and will be removed in Apollo Client 4.0. Please use the 'onData' option instead."
    },
    87: {
        file: "@apollo/client/react/hooks/useSubscription.js",
        message: "'useSubscription' supports only the 'onSubscriptionComplete' or 'onComplete' option, but not both. Only the 'onComplete' option will be used."
    },
    88: {
        file: "@apollo/client/react/hooks/useSubscription.js",
        message: "[useSubscription]: `onSubscriptionComplete` is deprecated and will be removed in Apollo Client 4.0. Please use the 'onComplete' option instead."
    },
    91: {
        file: "@apollo/client/react/hooks/useSuspenseQuery.js",
        message: "Using `returnPartialData` with a `no-cache` fetch policy has no effect. To read partial data from the cache, consider using an alternate fetch policy."
    },
    94: {
        file: "@apollo/client/react/parser/index.js",
        message: "[parser]: `parser` is deprecated and will be removed in Apollo Client 4.0. Please remove all usages of `parser`."
    },
    100: {
        file: "@apollo/client/testing/core/mocking/mockLink.js",
        message: "[MockLink]: `newData` is deprecated and will be removed in Apollo Client 4.0. Please use the `result` option with a callback function and set the `maxUsageCount` option to `Number.POSITIVE_INFINITY`.\n\nFound `newData` on response:\n%o"
    },
    101: {
        file: "@apollo/client/testing/core/mocking/mockLink.js",
        message: "[MockLink]: Apollo Client 4.0 will throw when mocking client-only query '%s'. Please ensure the query has at least 1 non-client field."
    },
    104: {
        file: "@apollo/client/utilities/deprecation/index.js",
        message: "[%s]: `%s` is deprecated and will be removed in Apollo Client 4.0. %s"
    },
    110: {
        file: "@apollo/client/utilities/graphql/directives.js",
        message: "@unmask 'mode' argument does not support variables."
    },
    111: {
        file: "@apollo/client/utilities/graphql/directives.js",
        message: "@unmask 'mode' argument must be of type string."
    },
    112: {
        file: "@apollo/client/utilities/graphql/directives.js",
        message: "@unmask 'mode' argument does not recognize value '%s'."
    },
    126: {
        file: "@apollo/client/utilities/graphql/transform.js",
        message: "Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key."
    }
};
const $aaaeb85662150812$export$ad899535f58d908b = {
    13: {
        file: "@apollo/client/cache/inmemory/writeToStore.js",
        message: "Missing field '%s' while writing result %o"
    },
    30: {
        file: "@apollo/client/core/ObservableQuery.js",
        message: "Unhandled GraphQL subscription error"
    },
    33: {
        file: "@apollo/client/core/ObservableQuery.js",
        message: "Unhandled error"
    },
    92: {
        file: "@apollo/client/react/hooks/useSyncExternalStore.js",
        message: "The result of getSnapshot should be cached to avoid an infinite loop"
    },
    125: {
        file: "@apollo/client/utilities/graphql/transform.js",
        message: "Could not find operation or fragment"
    }
};






function $3c18da80adac0636$export$255136c09ea6b5b5(handler) {
    (0, $d461b0c33b06d27f$export$2e2bcd8739ae039)[0, $28d90d877eb1e517$export$b8ca975fa04efdf3] = handler;
}


function $b3dd759910bdaea0$export$d27d255b4e9cc9da() {
    var errorCodes = [];
    for(var _i = 0; _i < arguments.length; _i++)errorCodes[_i] = arguments[_i];
    (0, $3c18da80adac0636$export$255136c09ea6b5b5)($b3dd759910bdaea0$var$handler);
    for(var _a = 0, errorCodes_1 = errorCodes; _a < errorCodes_1.length; _a++){
        var codes = errorCodes_1[_a];
        Object.assign($b3dd759910bdaea0$var$handler, codes);
    }
    return $b3dd759910bdaea0$var$handler;
}
var $b3dd759910bdaea0$var$handler = function(message, args) {
    if (typeof message === "number") {
        var definition = (0, $d461b0c33b06d27f$export$2e2bcd8739ae039)[0, $28d90d877eb1e517$export$b8ca975fa04efdf3][message];
        if (!message || !(definition === null || definition === void 0 ? void 0 : definition.message)) return;
        message = definition.message;
    }
    return args.reduce(function(msg, arg) {
        return msg.replace(/%[sdfo]/, String(arg));
    }, String(message));
};


function $397097105d245cb5$export$b02ae4968e6dfe7c() {
    (0, $b3dd759910bdaea0$export$d27d255b4e9cc9da)((0, $aaaeb85662150812$export$ddb9677fe3712516), (0, $aaaeb85662150812$export$ad899535f58d908b), (0, $aaaeb85662150812$export$c45ebb6cef9d5b7b), (0, $aaaeb85662150812$export$9ac06e44a6262020));
}



function $e3a0985ab2c84eac$export$e515cd8d2458b886() {
    (0, $b3dd759910bdaea0$export$d27d255b4e9cc9da)((0, $aaaeb85662150812$export$3035850968eaa3b6));
}



var $acw62 = parcelRequire("acw62");


// Stamped valuation fields on the unified Transaction type. They go stale on
// entities still waiting for basis (auto-assignment can value those the
// moment a conversion lands) and on valued FOREIGN entities (attaching
// another raw restamps the target's draws). Only USD stamps never move.
const $efb28c3b118d81a4$var$TRANSACTION_FIELDS = [
    'homeNetAmount',
    'needsBasis',
    'basisDraws'
];
const $efb28c3b118d81a4$export$d812922a37751046 = (cache)=>{
    const entities = cache.extract();
    let evicted = false;
    for (const [id, entity] of Object.entries(entities)){
        if (entity == null) continue;
        if (entity.__typename === 'RawTransaction') {
            // Foreign rows only: a USD row's amount IS its dollar value and
            // carries no preview, so all-USD lists stay complete and keep their
            // cursor pages and scroll restoration.
            const currency = entity.currency;
            if (typeof currency !== 'string' || currency === 'USD') continue;
            if (!('homeAmountPreview' in entity)) continue;
            cache.evict({
                id: id,
                fieldName: 'homeAmountPreview'
            });
            evicted = true;
            continue;
        }
        if (entity.__typename === 'Transaction') {
            // Two arms, both needed. needsBasis === true catches transactions a
            // conversion can value behind the cache's back — including pending
            // conversions themselves, which are stored with currency USD (even
            // foreign-to-foreign ones) and would slip through a currency filter.
            // currency !== USD catches VALUED foreign transactions: attaching
            // another foreign raw to one ("Add to transaction") restamps its
            // draws server-side, so its stamp is not immutable to every mutation
            // — only USD transactions' values truly never move.
            if (entity.needsBasis !== true && (typeof entity.currency !== 'string' || entity.currency === 'USD')) continue;
            for (const fieldName of $efb28c3b118d81a4$var$TRANSACTION_FIELDS){
                if (!(fieldName in entity)) continue;
                cache.evict({
                    id: id,
                    fieldName: fieldName
                });
                evicted = true;
            }
        }
    }
    if (evicted) cache.gc();
};
const $efb28c3b118d81a4$export$b4c6cf3ce3579c04 = (query)=>query.definitions.some((definition)=>definition.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION && definition.operation === (0, $11b06753ce50693f$export$f58c50edb4aef9d4).MUTATION);
const $efb28c3b118d81a4$export$8d1c5ff5ae58806 = (cache)=>new (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f)((operation, forward)=>forward(operation).map((result)=>{
            if ($efb28c3b118d81a4$export$b4c6cf3ce3579c04(operation.query)) $efb28c3b118d81a4$export$d812922a37751046(cache);
            return result;
        }));





const $26ceba732074f5a9$var$rawTransactionIdsOf = (args)=>{
    const ids = args?.rawTransactionIds;
    return Array.isArray(ids) ? ids.filter((id)=>typeof id === 'string') : [];
};
const $26ceba732074f5a9$export$e22ee1fab15aa00d = {
    keyArgs: false,
    merge: (existing, incoming, { args: args, readField: readField })=>{
        const rows = {
            ...existing?.rows
        };
        for (const id of $26ceba732074f5a9$var$rawTransactionIdsOf(args))rows[id] = [];
        for (const suggestion of incoming){
            const id = readField('rawTransactionId', suggestion);
            if (id != null) rows[id] = [
                ...rows[id] ?? [],
                suggestion
            ];
        }
        return {
            rows: rows
        };
    },
    read: (existing, { args: args })=>{
        const ids = $26ceba732074f5a9$var$rawTransactionIdsOf(args);
        if (existing == null || ids.some((id)=>!(id in existing.rows))) return undefined;
        return ids.flatMap((id)=>existing.rows[id]);
    }
};
const $26ceba732074f5a9$var$selectsSuggestions = (query)=>query.definitions.some((definition)=>definition.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION && definition.selectionSet.selections.some((selection)=>selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD && selection.name.value === 'suggestCategorizations'));
const $26ceba732074f5a9$export$3ad9927561b3ec96 = (cache)=>{
    let writes = 0;
    return new (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f)((operation, forward)=>{
        if ((0, $efb28c3b118d81a4$export$b4c6cf3ce3579c04)(operation.query)) return forward(operation).map((result)=>{
            writes++;
            cache.evict({
                id: 'ROOT_QUERY',
                fieldName: 'suggestCategorizations'
            });
            cache.gc();
            return result;
        });
        if (!$26ceba732074f5a9$var$selectsSuggestions(operation.query)) return forward(operation);
        const fetchFresh = ()=>{
            const writesAtStart = writes;
            return forward(operation).flatMap((result)=>writes === writesAtStart ? (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of(result) : fetchFresh());
        };
        return fetchFresh();
    });
};


(0, $397097105d245cb5$export$b02ae4968e6dfe7c)();
(0, $e3a0985ab2c84eac$export$e515cd8d2458b886)();
// Cursor-paginated list fields accumulate their pages under a single cache
// entry keyed by the filter args (not the cursor), so navigating back to a
// list re-renders everything the user had loaded. A fetch without a cursor
// is a fresh first page and replaces the entry.
const $8207f3c9182267bf$var$cursorPagination = (keyArgs)=>({
        keyArgs: keyArgs,
        merge: (existing, incoming, { args: args })=>args?.beforeCursor && existing ? {
                ...incoming,
                items: [
                    ...existing.items,
                    ...incoming.items
                ]
            } : incoming
    });
const $8207f3c9182267bf$var$_ApolloProvider = (props)=>{
    // The client (and its cache) must be created exactly once: pages rely on
    // the cache surviving navigation (e.g. scroll restoration re-renders
    // previously loaded list pages from it), so a re-render of this provider
    // must not rebuild the client and silently drop all cached data.
    const client = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        // Auth rides on the httpOnly session cookie (BFF), so the request needs
        // no auth header — just credentials. The URI is relative in dev too:
        // the Parcel dev server proxies /graphql to the backend (.proxyrc.json)
        // so cookies are first-party in both environments.
        const httpLink = (0, $0c8dd0eb947866f7$export$95180a16573d6675)({
            uri: '/graphql',
            credentials: 'include'
        });
        const cache = new (0, $49c8996098641f51$export$467265324939f47f)({
            typePolicies: {
                Query: {
                    fields: {
                        // Every filter arg must be listed: a missing one merges queries
                        // that differ only in that arg into ONE cache entry, so whichever
                        // fetch lands last clobbers the other's rows. That is how the
                        // needs-basis inbox card went blank whenever a picker or list
                        // refetch ran — TransactionsNeedingBasis shared its entry with
                        // unfiltered queries.
                        transactions: $8207f3c9182267bf$var$cursorPagination([
                            'categories',
                            'tags',
                            'search',
                            'fieldFilters',
                            'netAmountFilter',
                            'kinds',
                            'minAmount',
                            'maxAmount',
                            'pending',
                            'needsBasis',
                            'startDate',
                            'endDate',
                            'transferTypes',
                            'excludeTransferTypes',
                            'currency',
                            'limit'
                        ]),
                        suggestCategorizations: (0, $26ceba732074f5a9$export$e22ee1fab15aa00d)
                    }
                },
                RawTransactions: {
                    keyFields: [
                        '_id'
                    ]
                },
                Accounts: {
                    keyFields: [
                        '_id'
                    ]
                },
                // PlaidConnectionInfo has no id, so it's stored embedded in its parent
                // account. Different queries select different plaid subsets (the Account
                // fragment vs AccountPlaidConnection); without a merge policy each write
                // would replace the object and drop the other query's fields, leaving
                // watchers partial and triggering spurious refetches.
                DepositoryAccount: {
                    fields: {
                        plaid: {
                            merge: true
                        }
                    }
                },
                // performance is likewise embedded (InvestmentPerformance has no id)
                // and is written both by AllInvestmentAccountsPerformance and the full
                // InvestmentAccountFragment; merge field-wise so a write from one
                // never drops fields the other's watchers selected.
                InvestmentAccount: {
                    fields: {
                        plaid: {
                            merge: true
                        },
                        performance: {
                            merge: true
                        }
                    }
                }
            },
            possibleTypes: {
                TransactionUnion: [
                    'PaymentTransaction',
                    'TransferTransaction'
                ],
                AccountUnion: [
                    'DepositoryAccount',
                    'InvestmentAccount'
                ]
            }
        });
        return new (0, $9cf0de8518e6cdc4$export$13f5a5f0f1dbab88)({
            // Preview invalidation rides the link chain so EVERY mutation clears
            // cached homeAmountPreview scalars — see apolloCache/previews for why
            // this is not done per call site.
            link: (0, $efb28c3b118d81a4$export$8d1c5ff5ae58806)(cache).concat((0, $26ceba732074f5a9$export$3ad9927561b3ec96)(cache)).concat(httpLink),
            cache: cache,
            devtools: {
                enabled: true
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93ef3346b14b7851$export$c16b04c8a9956446), {
        client: client,
        children: props.children
    });
};
var $8207f3c9182267bf$export$2e2bcd8739ae039 = $8207f3c9182267bf$var$_ApolloProvider;



parcelRequire("acw62");
/**
 * React Router DOM v6.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $6d23e34a443a4a03$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($6d23e34a443a4a03$export$e19cd5f9376f8cee || ($6d23e34a443a4a03$export$e19cd5f9376f8cee = {}));
var $6d23e34a443a4a03$var$readOnly = function(obj) {
    return obj;
};
function $6d23e34a443a4a03$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $6d23e34a443a4a03$var$BeforeUnloadEventType = 'beforeunload';
var $6d23e34a443a4a03$var$HashChangeEventType = 'hashchange';
var $6d23e34a443a4a03$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $6d23e34a443a4a03$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $6d23e34a443a4a03$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($6d23e34a443a4a03$var$PopStateEventType, handlePop);
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $6d23e34a443a4a03$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $6d23e34a443a4a03$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $6d23e34a443a4a03$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($6d23e34a443a4a03$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($6d23e34a443a4a03$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($6d23e34a443a4a03$export$fe53371bee54353d(nextLocation) !== $6d23e34a443a4a03$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $6d23e34a443a4a03$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $6d23e34a443a4a03$var$readOnly((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $6d23e34a443a4a03$var$createKey()
        }, typeof entry === 'string' ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $6d23e34a443a4a03$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $6d23e34a443a4a03$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $6d23e34a443a4a03$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $6d23e34a443a4a03$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $6d23e34a443a4a03$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $6d23e34a443a4a03$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $6d23e34a443a4a03$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $6d23e34a443a4a03$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}


/**
 * React Router v6.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $acw62 = parcelRequire("acw62");
const $926608a7a86d7371$export$26749e8557646306 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $926608a7a86d7371$export$c7914228fb69b0f5 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $926608a7a86d7371$export$9072aa6dd1f93057 = /*#__PURE__*/ (0, $acw62.createContext)({
    outlet: null,
    matches: []
});
function $926608a7a86d7371$var$invariant(cond, message) {
    if (!cond) throw new Error(message);
}
function $926608a7a86d7371$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
const $926608a7a86d7371$var$alreadyWarned = {};
function $926608a7a86d7371$var$warningOnce(key, cond, message) {
    if (!cond && !$926608a7a86d7371$var$alreadyWarned[key]) $926608a7a86d7371$var$alreadyWarned[key] = true;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/api#generatepath
 */ function $926608a7a86d7371$export$82476f982757e71e(path, params) {
    if (params === void 0) params = {};
    return path.replace(/:(\w+)/g, (_, key)=>{
        !(params[key] != null) && $926608a7a86d7371$var$invariant(false);
        return params[key];
    }).replace(/\/*\*$/, (_)=>params["*"] == null ? "" : params["*"].replace(/^\/*/, "/"));
}
/**
 * A RouteMatch contains info about how a route matched a URL.
 */ /**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchroutes
 */ function $926608a7a86d7371$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(locationArg) : locationArg;
    let pathname = $926608a7a86d7371$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $926608a7a86d7371$var$flattenRoutes(routes);
    $926608a7a86d7371$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $926608a7a86d7371$var$matchRouteBranch(branches[i], pathname);
    return matches;
}
function $926608a7a86d7371$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    routes.forEach((route, index)=>{
        let meta = {
            relativePath: route.path || "",
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            !meta.relativePath.startsWith(parentPath) && $926608a7a86d7371$var$invariant(false);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $926608a7a86d7371$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            !(route.index !== true) && $926608a7a86d7371$var$invariant(false);
            $926608a7a86d7371$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $926608a7a86d7371$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $926608a7a86d7371$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $926608a7a86d7371$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $926608a7a86d7371$var$paramRe = /^:\w+$/;
const $926608a7a86d7371$var$dynamicSegmentValue = 3;
const $926608a7a86d7371$var$indexRouteValue = 2;
const $926608a7a86d7371$var$emptySegmentValue = 1;
const $926608a7a86d7371$var$staticSegmentValue = 10;
const $926608a7a86d7371$var$splatPenalty = -2;
const $926608a7a86d7371$var$isSplat = (s)=>s === "*";
function $926608a7a86d7371$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($926608a7a86d7371$var$isSplat)) initialScore += $926608a7a86d7371$var$splatPenalty;
    if (index) initialScore += $926608a7a86d7371$var$indexRouteValue;
    return segments.filter((s)=>!$926608a7a86d7371$var$isSplat(s)).reduce((score, segment)=>score + ($926608a7a86d7371$var$paramRe.test(segment) ? $926608a7a86d7371$var$dynamicSegmentValue : segment === "" ? $926608a7a86d7371$var$emptySegmentValue : $926608a7a86d7371$var$staticSegmentValue), initialScore);
}
function $926608a7a86d7371$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $926608a7a86d7371$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $926608a7a86d7371$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            params: matchedParams,
            pathname: $926608a7a86d7371$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $926608a7a86d7371$var$normalizePathname($926608a7a86d7371$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $926608a7a86d7371$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * A PathPattern is used to match on some portion of a URL pathname.
 */ /**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchpath
 */ function $926608a7a86d7371$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $926608a7a86d7371$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $926608a7a86d7371$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $926608a7a86d7371$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else regexpSource += end ? "\\/*$" // When matching to the end, ignore trailing slashes
     : // parent routes to matching only their own words and nothing more, e.g. parent
    // route "/home" should not match "/home2".
    // Additionally, allow paths starting with `.`, `-`, `~`, and url-encoded entities,
    // but do not consume the character in the matched path so they can match against
    // nested paths.
    "(?:(?=[.~-]|%[0-9A-F]{2})|\\b|\\/|$)";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $926608a7a86d7371$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/docs/en/v6/api#resolvepath
 */ function $926608a7a86d7371$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $926608a7a86d7371$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $926608a7a86d7371$var$normalizeSearch(search),
        hash: $926608a7a86d7371$var$normalizeHash(hash)
    };
}
function $926608a7a86d7371$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $926608a7a86d7371$var$resolveTo(toArg, routePathnames, locationPathname) {
    let to = typeof toArg === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(toArg) : toArg;
    let toPathname = toArg === "" || to.pathname === "" ? "/" : to.pathname; // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $926608a7a86d7371$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original to value had one.
    if (toPathname && toPathname !== "/" && toPathname.endsWith("/") && !path.pathname.endsWith("/")) path.pathname += "/";
    return path;
}
function $926608a7a86d7371$var$getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(to).pathname : to.pathname;
}
function $926608a7a86d7371$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let nextChar = pathname.charAt(basename.length);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(basename.length) || "/";
}
const $926608a7a86d7371$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
const $926608a7a86d7371$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
const $926608a7a86d7371$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $926608a7a86d7371$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usehref
 */ function $926608a7a86d7371$export$b66bb29c5006f12f(to) {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $acw62.useContext)($926608a7a86d7371$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $926608a7a86d7371$export$e75d2a2d1b3c245b(to);
    let joinedPathname = pathname;
    if (basename !== "/") {
        let toPathname = $926608a7a86d7371$var$getToPathname(to);
        let endsWithSlash = toPathname != null && toPathname.endsWith("/");
        joinedPathname = pathname === "/" ? basename + (endsWithSlash ? "/" : "") : $926608a7a86d7371$var$joinPaths([
            basename,
            pathname
        ]);
    }
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useinroutercontext
 */ function $926608a7a86d7371$export$9c954a9d03d32f4a() {
    return (0, $acw62.useContext)($926608a7a86d7371$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/docs/en/v6/api#uselocation
 */ function $926608a7a86d7371$export$45d76561a5302f2b() {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    return (0, $acw62.useContext)($926608a7a86d7371$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigationtype
 */ function $926608a7a86d7371$export$1b3f31771c5d07c() {
    return (0, $acw62.useContext)($926608a7a86d7371$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns true if the URL for the given "to" value matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usematch
 */ function $926608a7a86d7371$export$6c330e8992e8a295(pattern) {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { pathname: pathname } = $926608a7a86d7371$export$45d76561a5302f2b();
    return (0, $acw62.useMemo)(()=>$926608a7a86d7371$export$81336c211d5ff295(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigate
 */ function $926608a7a86d7371$export$9770f232ac06a008() {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $acw62.useContext)($926608a7a86d7371$export$26749e8557646306);
    let { matches: matches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $926608a7a86d7371$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    let activeRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        activeRef.current = true;
    });
    let navigate = (0, $acw62.useCallback)(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $926608a7a86d7371$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname);
        if (basename !== "/") path.pathname = $926608a7a86d7371$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $926608a7a86d7371$var$OutletContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/docs/en/v6/api#useoutletcontext
 */ function $926608a7a86d7371$export$4138103a3ae699cc() {
    return (0, $acw62.useContext)($926608a7a86d7371$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useoutlet
 */ function $926608a7a86d7371$export$a3be3530d8e40d0b(context) {
    let outlet = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useparams
 */ function $926608a7a86d7371$export$99eaa27ddbbb95ef() {
    let { matches: matches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useresolvedpath
 */ function $926608a7a86d7371$export$e75d2a2d1b3c245b(to) {
    let { matches: matches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $926608a7a86d7371$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    return (0, $acw62.useMemo)(()=>$926608a7a86d7371$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname), [
        to,
        routePathnamesJson,
        locationPathname
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useroutes
 */ function $926608a7a86d7371$export$5d3fca4a98652595(routes, locationArg) {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { matches: parentMatches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $926608a7a86d7371$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && $926608a7a86d7371$var$invariant(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = $926608a7a86d7371$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    return $926608a7a86d7371$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $926608a7a86d7371$var$joinPaths([
                parentPathnameBase,
                match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $926608a7a86d7371$var$joinPaths([
                parentPathnameBase,
                match.pathnameBase
            ])
        })), parentMatches);
}
function $926608a7a86d7371$var$_renderMatches(matches, parentMatches) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) return null;
    return matches.reduceRight((outlet, match, index)=>{
        return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$9072aa6dd1f93057.Provider, {
            children: match.route.element !== undefined ? match.route.element : outlet,
            value: {
                outlet: outlet,
                matches: parentMatches.concat(matches.slice(0, index + 1))
            }
        });
    }, null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/docs/en/v6/api#memoryrouter
 */ function $926608a7a86d7371$export$ae46f04cfaffe093(_ref) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref;
    let historyRef = (0, $acw62.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $6d23e34a443a4a03$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex
    });
    let history = historyRef.current;
    let [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/docs/en/v6/api#navigate
 */ function $926608a7a86d7371$export$444b3ab0cb9aec40(_ref2) {
    let { to: to, replace: replace, state: state } = _ref2;
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let navigate = $926608a7a86d7371$export$9770f232ac06a008();
    (0, $acw62.useEffect)(()=>{
        navigate(to, {
            replace: replace,
            state: state
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/docs/en/v6/api#outlet
 */ function $926608a7a86d7371$export$910ae8079b2c2852(props) {
    return $926608a7a86d7371$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#route
 */ function $926608a7a86d7371$export$e7b0ac011bb776c6(_props) {
    $926608a7a86d7371$var$invariant(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/docs/en/v6/api#router
 */ function $926608a7a86d7371$export$55185c17a0fcbe46(_ref3) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $6d23e34a443a4a03$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref3;
    !!$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let basename = $926608a7a86d7371$var$normalizePathname(basenameProp);
    let navigationContext = (0, $acw62.useMemo)(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = (0, $acw62.useMemo)(()=>{
        let trailingPathname = $926608a7a86d7371$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#routes
 */ function $926608a7a86d7371$export$3565eb3d00ca5a74(_ref4) {
    let { children: children, location: location } = _ref4;
    return $926608a7a86d7371$export$5d3fca4a98652595($926608a7a86d7371$export$16da398f5434bdec(children), location);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/docs/en/v6/api#createroutesfromchildren
 */ function $926608a7a86d7371$export$16da398f5434bdec(children) {
    let routes = [];
    (0, $acw62.Children).forEach(children, (element)=>{
        if (!/*#__PURE__*/ (0, $acw62.isValidElement)(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === (0, $acw62.Fragment)) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $926608a7a86d7371$export$16da398f5434bdec(element.props.children));
            return;
        }
        !(element.type === $926608a7a86d7371$export$e7b0ac011bb776c6) && $926608a7a86d7371$var$invariant(false);
        let route = {
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path
        };
        if (element.props.children) route.children = $926608a7a86d7371$export$16da398f5434bdec(element.props.children);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $926608a7a86d7371$export$daf73786167a7f72(matches) {
    return $926608a7a86d7371$var$_renderMatches(matches);
}


function $0c90f43fc3673aef$var$_extends() {
    $0c90f43fc3673aef$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0c90f43fc3673aef$var$_extends.apply(this, arguments);
}
function $0c90f43fc3673aef$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0c90f43fc3673aef$var$_excluded = [
    "onClick",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to"
], $0c90f43fc3673aef$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
];
function $0c90f43fc3673aef$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} ////////////////////////////////////////////////////////////////////////////////
// COMPONENTS
////////////////////////////////////////////////////////////////////////////////
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0c90f43fc3673aef$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window } = _ref;
    let historyRef = (0, $acw62.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $6d23e34a443a4a03$export$719fc203c4e16dee)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $926608a7a86d7371$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0c90f43fc3673aef$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window } = _ref2;
    let historyRef = (0, $acw62.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $6d23e34a443a4a03$export$b71fdd3798280242)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $926608a7a86d7371$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0c90f43fc3673aef$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $926608a7a86d7371$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $0c90f43fc3673aef$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $0c90f43fc3673aef$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $acw62.forwardRef)(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, reloadDocument: reloadDocument, replace: replace = false, state: state, target: target, to: to } = _ref4, rest = $0c90f43fc3673aef$var$_objectWithoutPropertiesLoose(_ref4, $0c90f43fc3673aef$var$_excluded);
    let href = (0, $926608a7a86d7371$export$b66bb29c5006f12f)(to);
    let internalOnClick = $0c90f43fc3673aef$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented && !reloadDocument) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    (0, $acw62.createElement)("a", $0c90f43fc3673aef$var$_extends({}, rest, {
        href: href,
        onClick: handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $0c90f43fc3673aef$export$b0d92dbee9b5b60d = /*#__PURE__*/ (0, $acw62.forwardRef)(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $0c90f43fc3673aef$var$_objectWithoutPropertiesLoose(_ref5, $0c90f43fc3673aef$var$_excluded2);
    let location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    let path = (0, $926608a7a86d7371$export$e75d2a2d1b3c245b)(to);
    let locationPathname = location.pathname;
    let toPathname = path.pathname;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive
    }) : styleProp;
    return /*#__PURE__*/ (0, $acw62.createElement)($0c90f43fc3673aef$export$a6c7ac8248d6e38a, $0c90f43fc3673aef$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive
    }) : children);
});
// HOOKS
////////////////////////////////////////////////////////////////////////////////
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0c90f43fc3673aef$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    let location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    let path = (0, $926608a7a86d7371$export$e75d2a2d1b3c245b)(to);
    return (0, $acw62.useCallback)((event)=>{
        if (event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
        !$0c90f43fc3673aef$var$isModifiedEvent(event) // Ignore clicks with modifier keys
        ) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here.
            let replace = !!replaceProp || (0, $6d23e34a443a4a03$export$fe53371bee54353d)(location) === (0, $6d23e34a443a4a03$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0c90f43fc3673aef$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = (0, $acw62.useRef)($0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    let searchParams = (0, $acw62.useMemo)(()=>{
        let searchParams = $0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(location.search);
        for (let key of defaultSearchParamsRef.current.keys())if (!searchParams.has(key)) defaultSearchParamsRef.current.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
        return searchParams;
    }, [
        location.search
    ]);
    let navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    let setSearchParams = (0, $acw62.useCallback)((nextInit, navigateOptions)=>{
        navigate("?" + $0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(nextInit), navigateOptions);
    }, [
        navigate
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}



var $acw62 = parcelRequire("acw62");
/**
 * Session gate for BFF auth: probes the server's session once and either
 * renders the app or bounces through the server's /login route (which runs
 * the OAuth flow with Auth0 and redirects back to returnTo). The probe is a
 * same-origin fetch against our own server — tens of milliseconds, not the
 * cross-origin silent-auth round trip the old client-side flow paid on
 * every load.
 */ const $15f87bc0c48f0318$var$AuthenticationRequired = (props)=>{
    const [authenticated, setAuthenticated] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        let cancelled = false;
        (async ()=>{
            try {
                const response = await fetch('/api/auth/me', {
                    credentials: 'include'
                });
                const body = await response.json();
                const isAuthed = typeof body === 'object' && body !== null && 'authenticated' in body && body.authenticated === true;
                if (!cancelled) setAuthenticated(isAuthed);
            } catch (err) {
                console.error('[auth] Session probe failed:', err);
                if (!cancelled) setAuthenticated(false);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, []);
    $acw62.useEffect(()=>{
        if (authenticated === false) {
            const returnTo = `${window.location.pathname}${window.location.search}`;
            window.location.assign(`/login?returnTo=${encodeURIComponent(returnTo)}`);
        }
    }, [
        authenticated
    ]);
    if (authenticated) return props.children;
    return null;
};
var $15f87bc0c48f0318$export$2e2bcd8739ae039 = $15f87bc0c48f0318$var$AuthenticationRequired;




var $acw62 = parcelRequire("acw62");
const $e48c19e6a5217ff7$export$93d4e7f90805808f = ()=>{
    const context = $acw62.useContext($e48c19e6a5217ff7$var$ThemeContext);
    if (!context) throw new Error('useTheme must be used within a ThemeProvider');
    return context;
};
const $e48c19e6a5217ff7$var$ThemeContext = /*#__PURE__*/ $acw62.createContext({
    theme: 'light',
    toggleTheme: ()=>{}
});
// --background in globals.css, as hex for the browser's theme-color.
const $e48c19e6a5217ff7$var$THEME_COLORS = {
    light: '#ffffff',
    dark: '#111620'
};
const $e48c19e6a5217ff7$var$getInitialTheme = ()=>{
    return document.documentElement.classList.contains('dark') || window.matchMedia('(prefers-color-scheme: dark)').matches || localStorage.getItem('theme') === 'dark' ? 'dark' : 'light';
};
const $e48c19e6a5217ff7$export$d8964aec282183a3 = ({ children: children })=>{
    const [theme, setTheme] = $acw62.useState($e48c19e6a5217ff7$var$getInitialTheme());
    $acw62.useEffect(()=>{
        document.documentElement.classList.toggle('dark', theme === 'dark');
        document.documentElement.classList.toggle('light', theme === 'light');
        localStorage.setItem('theme', theme);
        document.querySelector('meta[name="theme-color"]')?.setAttribute('content', $e48c19e6a5217ff7$var$THEME_COLORS[theme]);
    }, [
        theme
    ]);
    const toggleTheme = ()=>{
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e48c19e6a5217ff7$var$ThemeContext.Provider, {
        value: {
            theme: theme,
            toggleTheme: toggleTheme
        },
        children: children
    });
};
var $e48c19e6a5217ff7$export$2e2bcd8739ae039 = $e48c19e6a5217ff7$export$93d4e7f90805808f;



/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $db42588f972bc829$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $db42588f972bc829$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $db42588f972bc829$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = $db42588f972bc829$export$86f54f62aa7a7514(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const $db42588f972bc829$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const $db42588f972bc829$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};


/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $db42588f972bc829$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $db42588f972bc829$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));


const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $d2b1338ec3fa0df8$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $db42588f972bc829$export$3d46f4579dba46e5)(`lucide-${(0, $db42588f972bc829$export$73bda83cddbc7187)((0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $efa6e18e6227061d$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M9 3v18",
            key: "fh3hqa"
        }
    ]
];
const $efa6e18e6227061d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("panel-left", $efa6e18e6227061d$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");


var $80214a2a1ebe2fb0$export$1aa5a89531b7670d = Symbol.for("apollo.skipToken");










var $4653928bf51922ba$var$didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var $4653928bf51922ba$var$uSESKey = "useSyncExternalStore";
var $4653928bf51922ba$var$realHook = $69607e38bd2400f2$exports[$4653928bf51922ba$var$uSESKey];
var $4653928bf51922ba$export$306c0aa65ff9ec16 = $4653928bf51922ba$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    // Read the current snapshot from the store on every render. Again, this
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    var value = getSnapshot();
    if (// DEVIATION: Using __DEV__
    globalThis.__DEV__ !== false && !$4653928bf51922ba$var$didWarnUncachedGetSnapshot && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    value !== getSnapshot()) {
        $4653928bf51922ba$var$didWarnUncachedGetSnapshot = true;
        // DEVIATION: Using invariant.error instead of console.error directly.
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(92);
    }
    // Because updates are synchronous, we don't queue them. Instead we force a
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    var _a = $69607e38bd2400f2$exports.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    if (0, $5d0a073f980bb2a3$export$4001f6cd4a62405b) // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
    // which may seem like a conditional hook, but this code ends up behaving
    // unconditionally (one way or the other) because canUseLayoutEffect is
    // constant.
    $69607e38bd2400f2$exports.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($4653928bf51922ba$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
    // React Hook React.useLayoutEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $69607e38bd2400f2$exports.useEffect(function() {
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($4653928bf51922ba$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        // Subscribe to the store and return a clean-up function.
        return subscribe(function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($4653928bf51922ba$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        });
    // React Hook React.useEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    return value;
};
function $4653928bf51922ba$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}











var $0feb9bd81dd1c3b8$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($0feb9bd81dd1c3b8$export$d1d99cf900472499 || ($0feb9bd81dd1c3b8$export$d1d99cf900472499 = {}));
var $0feb9bd81dd1c3b8$var$cache;
function $0feb9bd81dd1c3b8$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $0feb9bd81dd1c3b8$export$d1d99cf900472499.Query:
            name = "Query";
            break;
        case $0feb9bd81dd1c3b8$export$d1d99cf900472499.Mutation:
            name = "Mutation";
            break;
        case $0feb9bd81dd1c3b8$export$d1d99cf900472499.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function $0feb9bd81dd1c3b8$export$8f49e4af10703ce3(document) {
    (0, $c7b1e48e566741e9$export$606a5c06d13e04b6)("parser", function() {
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(94);
    });
    if (!$0feb9bd81dd1c3b8$var$cache) $0feb9bd81dd1c3b8$var$cache = new (0, $b3ac5bdec858bda0$export$8dbad6f439bb2331)((0, $c506be9be1a65610$export$f29926b23b28936b).parser || 1000 /* defaultCacheSizes.parser */ );
    var cached = $0feb9bd81dd1c3b8$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!!document && !!document.kind, 95, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") switch(x.operation){
            case "query":
                queries.push(x);
                break;
            case "mutation":
                mutations.push(x);
                break;
            case "subscription":
                subscriptions.push(x);
                break;
        }
    }
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, 96);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, 97, document, queries.length, subscriptions.length, mutations.length);
    type = queries.length ? $0feb9bd81dd1c3b8$export$d1d99cf900472499.Query : $0feb9bd81dd1c3b8$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $0feb9bd81dd1c3b8$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(definitions.length === 1, 98, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data"; // fallback to using data if no name
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $0feb9bd81dd1c3b8$var$cache.set(document, payload);
    return payload;
}
$0feb9bd81dd1c3b8$export$8f49e4af10703ce3.resetCache = function() {
    $0feb9bd81dd1c3b8$var$cache = undefined;
};
if (globalThis.__DEV__ !== false) (0, $1da01699264b6e1e$export$a8fcd406d9e37621)("parser", function() {
    return $0feb9bd81dd1c3b8$var$cache ? $0feb9bd81dd1c3b8$var$cache.size : 0;
});
function $0feb9bd81dd1c3b8$export$6dfb8732f737404c(document, type) {
    var operation = (0, $c7b1e48e566741e9$export$d18d1529326946c4)("parser", $0feb9bd81dd1c3b8$export$8f49e4af10703ce3, [
        document
    ]);
    var requiredOperationName = $0feb9bd81dd1c3b8$export$5db520940cf00715(type);
    var usedOperationName = $0feb9bd81dd1c3b8$export$5db520940cf00715(operation.type);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(operation.type === type, 99, requiredOperationName, requiredOperationName, usedOperationName);
}





function $0868e36814f766fc$export$eb9a56e7a29e494(override) {
    var context = $69607e38bd2400f2$exports.useContext((0, $14505e8b7f660318$export$a47505d961ee3a1)());
    var client = override || context.client;
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!!client, 79);
    return client;
}




function $5fe534a73eec9b4d$export$d5e35053e4aec331(options, name, callSite, recommendation) {
    "use no memo";
    if (recommendation === void 0) recommendation = "Please remove this option.";
    var didWarn = $69607e38bd2400f2$exports.useRef(false);
    if (name in options && !didWarn.current) {
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(78, callSite, name, recommendation);
        // eslint-disable-next-line react-compiler/react-compiler
        didWarn.current = true;
    }
}

var $966349df9047bbed$var$wrapperSymbol = Symbol.for("apollo.hook.wrappers");
function $966349df9047bbed$export$7f12579c79e39619(hookName, useHook, clientOrObsQuery) {
    var queryManager = clientOrObsQuery["queryManager"];
    var wrappers = queryManager && queryManager[$966349df9047bbed$var$wrapperSymbol];
    var wrapper = wrappers && wrappers[hookName];
    return wrapper ? wrapper(useHook) : useHook;
}



var $0ad8e3d9f4959055$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0ad8e3d9f4959055$var$noop() {}
var $0ad8e3d9f4959055$var$lastWatchOptions = Symbol();
function $0ad8e3d9f4959055$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return (0, $966349df9047bbed$export$7f12579c79e39619)("useQuery", $0ad8e3d9f4959055$var$useQuery_, (0, $0868e36814f766fc$export$eb9a56e7a29e494)(options && options.client))(query, options);
}
function $0ad8e3d9f4959055$var$useQuery_(query, options) {
    if (globalThis.__DEV__ !== false) {
        /* eslint-disable react-hooks/rules-of-hooks, react-compiler/react-compiler */ (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(options, "canonizeResults", "useQuery");
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(options, "partialRefetch", "useQuery");
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(options, "defaultOptions", "useQuery", "Pass the options directly to the hook instead.");
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(options, "onCompleted", "useQuery", "If your `onCompleted` callback sets local state, switch to use derived state using `data` returned from the hook instead. Use `useEffect` to perform side-effects as a result of updates to `data`.");
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(options, "onError", "useQuery", "If your `onError` callback sets local state, switch to use derived state using `data`, `error` or `errors` returned from the hook instead. Use `useEffect` if you need to perform side-effects as a result of updates to `data`, `error` or `errors`.");
    /* eslint-enable react-hooks/rules-of-hooks, react-compiler/react-compiler */ }
    var _a = $0ad8e3d9f4959055$export$5c23c59ff7f655a8(query, options), result = _a.result, obsQueryFields = _a.obsQueryFields;
    return $69607e38bd2400f2$exports.useMemo(function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), obsQueryFields);
    }, [
        result,
        obsQueryFields
    ]);
}
function $0ad8e3d9f4959055$var$useInternalState(client, query, options, renderPromises, makeWatchQueryOptions) {
    function createInternalState(previous) {
        var _a;
        (0, $0feb9bd81dd1c3b8$export$6dfb8732f737404c)(query, (0, $0feb9bd81dd1c3b8$export$d1d99cf900472499).Query);
        var internalState = {
            client: client,
            query: query,
            observable: // See if there is an existing observable that was used to fetch the same
            // data and if so, use it instead since it will contain the proper queryId
            // to fetch the result set. This is used during SSR.
            renderPromises && renderPromises.getSSRObservable(makeWatchQueryOptions()) || (0, $3118fa29bcf9f4b2$export$6c1b56eac59c9584)["inactiveOnCreation"].withValue(!renderPromises, function() {
                return (0, $c7b1e48e566741e9$export$d18d1529326946c4)("canonizeResults", function() {
                    return client.watchQuery($0ad8e3d9f4959055$export$2167b7db3cd527f2(void 0, client, options, makeWatchQueryOptions()));
                });
            }),
            resultData: {
                // Reuse previousData from previous InternalState (if any) to provide
                // continuity of previousData even if/when the query or client changes.
                previousData: (_a = previous === null || previous === void 0 ? void 0 : previous.resultData.current) === null || _a === void 0 ? void 0 : _a.data
            }
        };
        return internalState;
    }
    var _a = $69607e38bd2400f2$exports.useState(createInternalState), internalState = _a[0], updateInternalState = _a[1];
    /**
     * Used by `useLazyQuery` when a new query is executed.
     * We keep this logic here since it needs to update things in unsafe
     * ways and here we at least can keep track of that in a single place.
     */ function onQueryExecuted(watchQueryOptions) {
        var _a;
        var _b;
        // this needs to be set to prevent an immediate `resubscribe` in the
        // next rerender of the `useQuery` internals
        Object.assign(internalState.observable, (_a = {}, _a[$0ad8e3d9f4959055$var$lastWatchOptions] = watchQueryOptions, _a));
        var resultData = internalState.resultData;
        updateInternalState((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, internalState), {
            // might be a different query
            query: watchQueryOptions.query,
            resultData: Object.assign(resultData, {
                // We need to modify the previous `resultData` object as we rely on the
                // object reference in other places
                previousData: ((_b = resultData.current) === null || _b === void 0 ? void 0 : _b.data) || resultData.previousData,
                current: undefined
            })
        }));
    }
    if (client !== internalState.client || query !== internalState.query) {
        // If the client or query have changed, we need to create a new InternalState.
        // This will trigger a re-render with the new state, but it will also continue
        // to run the current render function to completion.
        // Since we sometimes trigger some side-effects in the render function, we
        // re-assign `state` to the new state to ensure that those side-effects are
        // triggered with the new state.
        var newInternalState = createInternalState(internalState);
        updateInternalState(newInternalState);
        return [
            newInternalState,
            onQueryExecuted
        ];
    }
    return [
        internalState,
        onQueryExecuted
    ];
}
function $0ad8e3d9f4959055$export$5c23c59ff7f655a8(query, options) {
    var client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)(options.client);
    var renderPromises = $69607e38bd2400f2$exports.useContext((0, $14505e8b7f660318$export$a47505d961ee3a1)()).renderPromises;
    var isSyncSSR = !!renderPromises;
    var disableNetworkFetches = client.disableNetworkFetches;
    var ssrAllowed = options.ssr !== false && !options.skip;
    var partialRefetch = options.partialRefetch;
    var makeWatchQueryOptions = $0ad8e3d9f4959055$export$63539d93836ebf9c(client, query, options, isSyncSSR);
    var _a = $0ad8e3d9f4959055$var$useInternalState(client, query, options, renderPromises, makeWatchQueryOptions), _b = _a[0], observable = _b.observable, resultData = _b.resultData, onQueryExecuted = _a[1];
    var watchQueryOptions = makeWatchQueryOptions(observable);
    $0ad8e3d9f4959055$var$useResubscribeIfNecessary(resultData, observable, client, options, watchQueryOptions);
    var obsQueryFields = $69607e38bd2400f2$exports.useMemo(function() {
        return $0ad8e3d9f4959055$var$bindObservableMethods(observable);
    }, [
        observable
    ]);
    $0ad8e3d9f4959055$var$useRegisterSSRObservable(observable, renderPromises, ssrAllowed);
    var result = $0ad8e3d9f4959055$var$useObservableSubscriptionResult(resultData, observable, client, options, watchQueryOptions, disableNetworkFetches, partialRefetch, isSyncSSR, {
        onCompleted: options.onCompleted || $0ad8e3d9f4959055$var$noop,
        onError: options.onError || $0ad8e3d9f4959055$var$noop
    });
    return {
        result: result,
        obsQueryFields: obsQueryFields,
        observable: observable,
        resultData: resultData,
        client: client,
        onQueryExecuted: onQueryExecuted
    };
}
function $0ad8e3d9f4959055$var$useObservableSubscriptionResult(resultData, observable, client, options, watchQueryOptions, disableNetworkFetches, partialRefetch, isSyncSSR, callbacks) {
    var callbackRef = $69607e38bd2400f2$exports.useRef(callbacks);
    $69607e38bd2400f2$exports.useEffect(function() {
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        callbackRef.current = callbacks;
    });
    var resultOverride = (isSyncSSR || disableNetworkFetches) && options.ssr === false && !options.skip ? // If SSR has been explicitly disabled, and this function has been called
    // on the server side, return the default loading state.
    $0ad8e3d9f4959055$var$ssrDisabledResult : options.skip || watchQueryOptions.fetchPolicy === "standby" ? // When skipping a query (ie. we're not querying for data but still want to
    // render children), make sure the `data` is cleared out and `loading` is
    // set to `false` (since we aren't loading anything).
    //
    // NOTE: We no longer think this is the correct behavior. Skipping should
    // not automatically set `data` to `undefined`, but instead leave the
    // previous data in place. In other words, skipping should not mandate that
    // previously received data is all of a sudden removed. Unfortunately,
    // changing this is breaking, so we'll have to wait until Apollo Client 4.0
    // to address this.
    $0ad8e3d9f4959055$var$skipStandbyResult : void 0;
    var previousData = resultData.previousData;
    var currentResultOverride = $69607e38bd2400f2$exports.useMemo(function() {
        return resultOverride && $0ad8e3d9f4959055$export$de3acc9431f1695e(resultOverride, previousData, observable, client);
    }, [
        client,
        observable,
        resultOverride,
        previousData
    ]);
    return (0, $4653928bf51922ba$export$306c0aa65ff9ec16)($69607e38bd2400f2$exports.useCallback(function(handleStoreChange) {
        // reference `disableNetworkFetches` here to ensure that the rules of hooks
        // keep it as a dependency of this effect, even though it's not used
        disableNetworkFetches;
        if (isSyncSSR) return function() {};
        var onNext = function() {
            var previousResult = resultData.current;
            // We use `getCurrentResult()` instead of the onNext argument because
            // the values differ slightly. Specifically, loading results will have
            // an empty object for data instead of `undefined` for some reason.
            var result = observable.getCurrentResult();
            // Make sure we're not attempting to re-render similar results
            if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(previousResult.data, result.data)) return;
            $0ad8e3d9f4959055$var$setResult(result, resultData, observable, client, partialRefetch, handleStoreChange, callbackRef.current);
        };
        var onError = function(error) {
            subscription.current.unsubscribe();
            subscription.current = observable.resubscribeAfterError(onNext, onError);
            if (!$0ad8e3d9f4959055$var$hasOwnProperty.call(error, "graphQLErrors")) // The error is not a GraphQL error
            throw error;
            var previousResult = resultData.current;
            if (!previousResult || previousResult && previousResult.loading || !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(error, previousResult.error)) $0ad8e3d9f4959055$var$setResult({
                data: previousResult && previousResult.data,
                error: error,
                loading: false,
                networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error
            }, resultData, observable, client, partialRefetch, handleStoreChange, callbackRef.current);
        };
        // TODO evaluate if we keep this in
        // React Compiler cannot handle scoped `let` access, but a mutable object
        // like this is fine.
        // was:
        // let subscription = observable.subscribe(onNext, onError);
        var subscription = {
            current: observable.subscribe(onNext, onError)
        };
        // Do the "unsubscribe" with a short delay.
        // This way, an existing subscription can be reused without an additional
        // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
        // happen in very fast succession.
        return function() {
            setTimeout(function() {
                return subscription.current.unsubscribe();
            });
        };
    }, [
        disableNetworkFetches,
        isSyncSSR,
        observable,
        resultData,
        partialRefetch,
        client
    ]), function() {
        return currentResultOverride || $0ad8e3d9f4959055$var$getCurrentResult(resultData, observable, callbackRef.current, partialRefetch, client);
    }, function() {
        return currentResultOverride || $0ad8e3d9f4959055$var$getCurrentResult(resultData, observable, callbackRef.current, partialRefetch, client);
    });
}
function $0ad8e3d9f4959055$var$useRegisterSSRObservable(observable, renderPromises, ssrAllowed) {
    if (renderPromises && ssrAllowed) {
        renderPromises.registerSSRObservable(observable);
        if (observable.getCurrentResult().loading) // TODO: This is a legacy API which could probably be cleaned up
        renderPromises.addObservableQueryPromise(observable);
    }
}
// this hook is not compatible with any rules of React, and there's no good way to rewrite it.
// it should stay a separate hook that will not be optimized by the compiler
function $0ad8e3d9f4959055$var$useResubscribeIfNecessary(/** this hook will mutate properties on `resultData` */ resultData, /** this hook will mutate properties on `observable` */ observable, client, options, watchQueryOptions) {
    var _a;
    if (observable[$0ad8e3d9f4959055$var$lastWatchOptions] && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(observable[$0ad8e3d9f4959055$var$lastWatchOptions], watchQueryOptions)) {
        // Though it might be tempting to postpone this reobserve call to the
        // useEffect block, we need getCurrentResult to return an appropriate
        // loading:true result synchronously (later within the same call to
        // useQuery). Since we already have this.observable here (not true for
        // the very first call to useQuery), we are not initiating any new
        // subscriptions, though it does feel less than ideal that reobserve
        // (potentially) kicks off a network request (for example, when the
        // variables have changed), which is technically a side-effect.
        observable.reobserve($0ad8e3d9f4959055$export$2167b7db3cd527f2(observable, client, options, watchQueryOptions));
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        resultData.previousData = ((_a = resultData.current) === null || _a === void 0 ? void 0 : _a.data) || resultData.previousData;
        resultData.current = void 0;
    }
    observable[$0ad8e3d9f4959055$var$lastWatchOptions] = watchQueryOptions;
}
function $0ad8e3d9f4959055$export$63539d93836ebf9c(client, query, _a, isSyncSSR) {
    if (_a === void 0) _a = {};
    var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, // The above options are useQuery-specific, so this ...otherOptions spread
    // makes otherOptions almost a WatchQueryOptions object, except for the
    // query property that we add below.
    otherOptions = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "skip",
        "ssr",
        "onCompleted",
        "onError",
        "defaultOptions"
    ]);
    return function(observable) {
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, {
            query: query
        });
        if (isSyncSSR && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) // this behavior was added to react-apollo without explanation in this PR
        // https://github.com/apollographql/react-apollo/pull/1579
        watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            watchQueryOptions.initialFetchPolicy = watchQueryOptions.initialFetchPolicy || watchQueryOptions.fetchPolicy || $0ad8e3d9f4959055$export$e700754533d2c94f(defaultOptions, client.defaultOptions);
            watchQueryOptions.fetchPolicy = "standby";
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = (observable === null || observable === void 0 ? void 0 : observable.options.initialFetchPolicy) || $0ad8e3d9f4959055$export$e700754533d2c94f(defaultOptions, client.defaultOptions);
        return watchQueryOptions;
    };
}
function $0ad8e3d9f4959055$export$2167b7db3cd527f2(observable, client, queryHookOptions, watchQueryOptions) {
    var toMerge = [];
    var globalDefaults = client.defaultOptions.watchQuery;
    if (globalDefaults) toMerge.push(globalDefaults);
    if (queryHookOptions.defaultOptions) toMerge.push(queryHookOptions.defaultOptions);
    // We use compact rather than mergeOptions for this part of the merge,
    // because we want watchQueryOptions.variables (if defined) to replace
    // this.observable.options.variables whole. This replacement allows
    // removing variables by removing them from the variables input to
    // useQuery. If the variables were always merged together (rather than
    // replaced), there would be no way to remove existing variables.
    // However, the variables from options.defaultOptions and globalDefaults
    // (if provided) should be merged, to ensure individual defaulted
    // variables always have values, if not otherwise defined in
    // observable.options or watchQueryOptions.
    toMerge.push((0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(observable && observable.options, watchQueryOptions));
    return toMerge.reduce((0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359));
}
function $0ad8e3d9f4959055$var$setResult(nextResult, resultData, observable, client, partialRefetch, forceUpdate, callbacks) {
    var previousResult = resultData.current;
    if (previousResult && previousResult.data) resultData.previousData = previousResult.data;
    if (!nextResult.error && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(nextResult.errors)) // Until a set naming convention for networkError and graphQLErrors is
    // decided upon, we map errors (graphQLErrors) to the error options.
    // TODO: Is it possible for both result.error and result.errors to be
    // defined here?
    nextResult.error = new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
        graphQLErrors: nextResult.errors
    });
    resultData.current = $0ad8e3d9f4959055$export$de3acc9431f1695e($0ad8e3d9f4959055$var$unsafeHandlePartialRefetch(nextResult, observable, partialRefetch), resultData.previousData, observable, client);
    // Calling state.setResult always triggers an update, though some call sites
    // perform additional equality checks before committing to an update.
    forceUpdate();
    $0ad8e3d9f4959055$var$handleErrorOrCompleted(nextResult, previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus, callbacks);
}
function $0ad8e3d9f4959055$var$handleErrorOrCompleted(result, previousNetworkStatus, callbacks) {
    if (!result.loading) {
        var error_1 = $0ad8e3d9f4959055$export$b2c90f1874ba96bf(result);
        // wait a tick in case we are in the middle of rendering a component
        Promise.resolve().then(function() {
            if (error_1) callbacks.onError(error_1);
            else if (result.data && previousNetworkStatus !== result.networkStatus && result.networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready) callbacks.onCompleted(result.data);
        }).catch(function(error) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(error);
        });
    }
}
function $0ad8e3d9f4959055$var$getCurrentResult(resultData, observable, callbacks, partialRefetch, client) {
    // Using this.result as a cache ensures getCurrentResult continues returning
    // the same (===) result object, unless state.setResult has been called, or
    // we're doing server rendering and therefore override the result below.
    if (!resultData.current) // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
    // this could call unsafeHandlePartialRefetch
    $0ad8e3d9f4959055$var$setResult(observable.getCurrentResult(), resultData, observable, client, partialRefetch, function() {}, callbacks);
    return resultData.current;
}
function $0ad8e3d9f4959055$export$e700754533d2c94f(queryHookDefaultOptions, clientDefaultOptions) {
    var _a;
    return (queryHookDefaultOptions === null || queryHookDefaultOptions === void 0 ? void 0 : queryHookDefaultOptions.fetchPolicy) || ((_a = clientDefaultOptions === null || clientDefaultOptions === void 0 ? void 0 : clientDefaultOptions.watchQuery) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || "cache-first";
}
function $0ad8e3d9f4959055$export$b2c90f1874ba96bf(result) {
    return (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.errors) ? new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
        graphQLErrors: result.errors
    }) : result.error;
}
function $0ad8e3d9f4959055$export$de3acc9431f1695e(result, previousData, observable, client) {
    var data = result.data, partial = result.partial, resultWithoutPartial = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(result, [
        "data",
        "partial"
    ]);
    var queryResult = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        data: data
    }, resultWithoutPartial), {
        client: client,
        observable: observable,
        variables: observable.variables,
        called: result !== $0ad8e3d9f4959055$var$ssrDisabledResult && result !== $0ad8e3d9f4959055$var$skipStandbyResult,
        previousData: previousData
    });
    return queryResult;
}
function $0ad8e3d9f4959055$var$unsafeHandlePartialRefetch(result, observable, partialRefetch) {
    // TODO: This code should be removed when the partialRefetch option is
    // removed. I was unable to get this hook to behave reasonably in certain
    // edge cases when this block was put in an effect.
    if (result.partial && partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && observable.options.fetchPolicy !== "cache-only") {
        observable.refetch();
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), {
            loading: true,
            networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch
        });
    }
    return result;
}
var $0ad8e3d9f4959055$var$ssrDisabledResult = (0, $310a6ebe531ba02b$export$7f9c177735b71f18)({
    loading: true,
    data: void 0,
    error: void 0,
    networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading
});
var $0ad8e3d9f4959055$var$skipStandbyResult = (0, $310a6ebe531ba02b$export$7f9c177735b71f18)({
    loading: false,
    data: void 0,
    error: void 0,
    networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready
});
function $0ad8e3d9f4959055$var$bindObservableMethods(observable) {
    return {
        refetch: observable.refetch.bind(observable),
        reobserve: function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(84);
            return observable.reobserve.apply(observable, args);
        },
        fetchMore: observable.fetchMore.bind(observable),
        updateQuery: observable.updateQuery.bind(observable),
        startPolling: observable.startPolling.bind(observable),
        stopPolling: observable.stopPolling.bind(observable),
        subscribeToMore: observable.subscribeToMore.bind(observable)
    };
}




var $5a2b96547ab615e1$export$700979bc83e7db82 = (0, $5d0a073f980bb2a3$export$71594e8a50f746f4) ? $69607e38bd2400f2$exports.useLayoutEffect : $69607e38bd2400f2$exports.useEffect;






var $9fce6b9b9f6fbc08$var$Ctx;
function $9fce6b9b9f6fbc08$var$noop() {}
function $9fce6b9b9f6fbc08$export$3e6dc71f325021bd() {
    if (!$9fce6b9b9f6fbc08$var$Ctx) // we want the intialization to be lazy because `createContext` would error on import in a RSC
    $9fce6b9b9f6fbc08$var$Ctx = $69607e38bd2400f2$exports.createContext(null);
    return $69607e38bd2400f2$exports.useCallback(/**
     * @returns true if the hook was called during render
     */ function() {
        var orig = console.error;
        try {
            console.error = $9fce6b9b9f6fbc08$var$noop;
            /**
             * `useContext` can be called conditionally during render, so this is safe.
             * (Also, during render we would want to throw as a reaction to this anyways, so it
             * wouldn't even matter if we got the order of hooks mixed up...)
             *
             * They cannot however be called outside of Render, and that's what we're testing here.
             *
             * Different versions of React have different behaviour on an invalid hook call:
             *
             * React 16.8 - 17: throws an error
             * https://github.com/facebook/react/blob/2b93d686e359c7afa299e2ec5cf63160a32a1155/packages/react/src/ReactHooks.js#L18-L26
             *
             * React 18 & 19: `console.error` in development, then `resolveDispatcher` returns `null` and a member access on `null` throws.
             * https://github.com/facebook/react/blob/58e8304483ebfadd02a295339b5e9a989ac98c6e/packages/react/src/ReactHooks.js#L28-L35
             */ $69607e38bd2400f2$exports.useContext($9fce6b9b9f6fbc08$var$Ctx);
            return true;
        } catch (e) {
            return false;
        } finally{
            console.error = orig;
        }
    }, []);
}


// The following methods, when called will execute the query, regardless of
// whether the useLazyQuery execute function was called before.
var $cea895d27273d5ec$var$EAGER_METHODS = [
    "refetch",
    "reobserve",
    "fetchMore",
    "updateQuery",
    "startPolling",
    "stopPolling",
    "subscribeToMore"
];
var $cea895d27273d5ec$var$REMOVED_EXECUTE_OPTIONS = [
    "initialFetchPolicy",
    "onCompleted",
    "onError",
    "defaultOptions",
    "partialRefetch",
    "canonizeResults"
];
var $cea895d27273d5ec$var$DEPRECATED_EXECUTE_OPTIONS = [
    "query",
    "ssr",
    "client",
    "fetchPolicy",
    "nextFetchPolicy",
    "refetchWritePolicy",
    "errorPolicy",
    "pollInterval",
    "notifyOnNetworkStatusChange",
    "returnPartialData",
    "skipPollAttempt"
];
function $cea895d27273d5ec$export$fd83eea6ecd2d8fa(query, options) {
    var _a;
    if (globalThis.__DEV__ !== false) {
        /* eslint-disable react-hooks/rules-of-hooks, react-compiler/react-compiler */ var warnOpts = options || {};
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(warnOpts, "canonizeResults", "useLazyQuery");
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(warnOpts, "variables", "useLazyQuery", "Pass all `variables` to the returned `execute` function instead.");
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(warnOpts, "context", "useLazyQuery", "Pass `context` to the returned `execute` function instead.");
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(warnOpts, "onCompleted", "useLazyQuery", "If your `onCompleted` callback sets local state, switch to use derived state using `data` returned from the hook instead. Use `useEffect` to perform side-effects as a result of updates to `data`.");
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(warnOpts, "onError", "useLazyQuery", "If your `onError` callback sets local state, switch to use derived state using `data`, `error` or `errors` returned from the hook instead. Use `useEffect` if you need to perform side-effects as a result of updates to `data`, `error` or `errors`.");
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(warnOpts, "defaultOptions", "useLazyQuery", "Pass the options directly to the hook instead.");
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(warnOpts, "initialFetchPolicy", "useLazyQuery", "Use the `fetchPolicy` option instead.");
        (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(warnOpts, "partialRefetch", "useLazyQuery");
    /* eslint-enable react-hooks/rules-of-hooks, react-compiler/react-compiler */ }
    var execOptionsRef = $69607e38bd2400f2$exports.useRef(void 0);
    var optionsRef = $69607e38bd2400f2$exports.useRef(void 0);
    var queryRef = $69607e38bd2400f2$exports.useRef(void 0);
    var merged = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(options, execOptionsRef.current || {});
    var document = (_a = merged === null || merged === void 0 ? void 0 : merged.query) !== null && _a !== void 0 ? _a : query;
    // Use refs to track options and the used query to ensure the `execute`
    // function remains referentially stable between renders.
    optionsRef.current = options;
    queryRef.current = document;
    var queryHookOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, merged), {
        skip: !execOptionsRef.current
    });
    var _b = (0, $0ad8e3d9f4959055$export$5c23c59ff7f655a8)(document, queryHookOptions), obsQueryFields = _b.obsQueryFields, useQueryResult = _b.result, client = _b.client, resultData = _b.resultData, observable = _b.observable, onQueryExecuted = _b.onQueryExecuted;
    var initialFetchPolicy = observable.options.initialFetchPolicy || (0, $0ad8e3d9f4959055$export$e700754533d2c94f)(queryHookOptions.defaultOptions, client.defaultOptions);
    var forceUpdateState = $69607e38bd2400f2$exports.useReducer(function(tick) {
        return tick + 1;
    }, 0)[1];
    // We use useMemo here to make sure the eager methods have a stable identity.
    var eagerMethods = $69607e38bd2400f2$exports.useMemo(function() {
        var eagerMethods = {};
        var _loop_1 = function(key) {
            var method = obsQueryFields[key];
            eagerMethods[key] = function() {
                if (globalThis.__DEV__ !== false) {
                    if (key === "reobserve") globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(80);
                }
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    // Only the first time populating execOptionsRef.current matters here.
                    forceUpdateState();
                }
                // @ts-expect-error this is just too generic to type
                return method.apply(this, arguments);
            };
        };
        for(var _i = 0, EAGER_METHODS_1 = $cea895d27273d5ec$var$EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++){
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, [
        forceUpdateState,
        obsQueryFields
    ]);
    var called = !!execOptionsRef.current;
    var result = $69607e38bd2400f2$exports.useMemo(function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, useQueryResult), eagerMethods), {
            called: called
        });
    }, [
        useQueryResult,
        eagerMethods,
        called
    ]);
    var calledDuringRender = (0, $9fce6b9b9f6fbc08$export$3e6dc71f325021bd)();
    var warnRef = $69607e38bd2400f2$exports.useRef(new Set());
    var execute = $69607e38bd2400f2$exports.useCallback(function(executeOptions) {
        if (globalThis.__DEV__ !== false) {
            if (calledDuringRender()) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(81);
            for(var _i = 0, REMOVED_EXECUTE_OPTIONS_1 = $cea895d27273d5ec$var$REMOVED_EXECUTE_OPTIONS; _i < REMOVED_EXECUTE_OPTIONS_1.length; _i++){
                var name_1 = REMOVED_EXECUTE_OPTIONS_1[_i];
                if (!warnRef.current.has(name_1)) {
                    (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(executeOptions || {}, name_1, "useLazyQuery.execute");
                    warnRef.current.add(name_1);
                }
            }
            for(var _a = 0, DEPRECATED_EXECUTE_OPTIONS_1 = $cea895d27273d5ec$var$DEPRECATED_EXECUTE_OPTIONS; _a < DEPRECATED_EXECUTE_OPTIONS_1.length; _a++){
                var name_2 = DEPRECATED_EXECUTE_OPTIONS_1[_a];
                if (!warnRef.current.has(name_2)) {
                    (0, $c7b1e48e566741e9$export$6d0d09df4c29a84a)(executeOptions || {}, name_2, "useLazyQuery.execute", "Please pass the option to the `useLazyQuery` hook instead.");
                    warnRef.current.add(name_2);
                }
            }
        }
        execOptionsRef.current = executeOptions ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, executeOptions), {
            fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy
        }) : {
            fetchPolicy: initialFetchPolicy
        };
        var options = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(optionsRef.current, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            query: queryRef.current
        }, execOptionsRef.current));
        var promise = $cea895d27273d5ec$var$executeQuery(resultData, observable, client, document, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            skip: false
        }), onQueryExecuted).then(function(queryResult) {
            return Object.assign(queryResult, eagerMethods);
        });
        // Because the return value of `useLazyQuery` is usually floated, we need
        // to catch the promise to prevent unhandled rejections.
        promise.catch(function() {});
        return promise;
    }, [
        calledDuringRender,
        client,
        document,
        eagerMethods,
        initialFetchPolicy,
        observable,
        resultData,
        onQueryExecuted
    ]);
    var executeRef = $69607e38bd2400f2$exports.useRef(execute);
    (0, $5a2b96547ab615e1$export$700979bc83e7db82)(function() {
        executeRef.current = execute;
    });
    var stableExecute = $69607e38bd2400f2$exports.useCallback(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return executeRef.current.apply(executeRef, args);
    }, []);
    return [
        stableExecute,
        result
    ];
}
function $cea895d27273d5ec$var$executeQuery(resultData, observable, client, currentQuery, options, onQueryExecuted) {
    var query = options.query || currentQuery;
    var watchQueryOptions = (0, $0ad8e3d9f4959055$export$63539d93836ebf9c)(client, query, options, false)(observable);
    var concast = observable.reobserveAsConcast((0, $0ad8e3d9f4959055$export$2167b7db3cd527f2)(observable, client, options, watchQueryOptions));
    onQueryExecuted(watchQueryOptions);
    return new Promise(function(resolve) {
        var result;
        // Subscribe to the concast independently of the ObservableQuery in case
        // the component gets unmounted before the promise resolves. This prevents
        // the concast from terminating early and resolving with `undefined` when
        // there are no more subscribers for the concast.
        concast.subscribe({
            next: function(value) {
                result = value;
            },
            error: function() {
                resolve((0, $0ad8e3d9f4959055$export$de3acc9431f1695e)(observable.getCurrentResult(), resultData.previousData, observable, client));
            },
            complete: function() {
                resolve((0, $0ad8e3d9f4959055$export$de3acc9431f1695e)(observable["maskResult"](result), resultData.previousData, observable, client));
            }
        });
    });
}










function $6ce4d937b84048d1$export$609860bf8b0084c(mutation, options) {
    if (globalThis.__DEV__ !== false) // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(options || {}, "ignoreResults", "useMutation", "If you don't want to synchronize component state with the mutation, please use the `useApolloClient` hook to get the client instance and call `client.mutate` directly.");
    var client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)(options === null || options === void 0 ? void 0 : options.client);
    (0, $0feb9bd81dd1c3b8$export$6dfb8732f737404c)(mutation, (0, $0feb9bd81dd1c3b8$export$d1d99cf900472499).Mutation);
    var _a = $69607e38bd2400f2$exports.useState({
        called: false,
        loading: false,
        client: client
    }), result = _a[0], setResult = _a[1];
    var ref = $69607e38bd2400f2$exports.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options
    });
    (0, $5a2b96547ab615e1$export$700979bc83e7db82)(function() {
        Object.assign(ref.current, {
            client: client,
            options: options,
            mutation: mutation
        });
    });
    var execute = $69607e38bd2400f2$exports.useCallback(function(executeOptions) {
        if (executeOptions === void 0) executeOptions = {};
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            mutation: mutation
        });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) setResult(ref.current.result = {
            loading: true,
            error: void 0,
            data: void 0,
            called: true,
            client: client
        });
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function(response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                graphQLErrors: errors
            }) : void 0;
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (error && onError) onError(error, clientOptions);
            if (mutationId === ref.current.mutationId && !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client
                };
                if (ref.current.isMounted && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(ref.current.result, result_1)) setResult(ref.current.result = result_1);
            }
            var onCompleted = executeOptions.onCompleted || ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onCompleted);
            if (!error) onCompleted === null || onCompleted === void 0 || onCompleted(response.data, clientOptions);
            return response;
        }, function(error) {
            var _a;
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client
                };
                if (!(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(ref.current.result, result_2)) setResult(ref.current.result = result_2);
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                // TODO(brian): why are we returning this here???
                return {
                    data: void 0,
                    errors: error
                };
            }
            throw error;
        });
    }, []);
    var reset = $69607e38bd2400f2$exports.useCallback(function() {
        if (ref.current.isMounted) {
            var result_3 = {
                called: false,
                loading: false,
                client: ref.current.client
            };
            Object.assign(ref.current, {
                mutationId: 0,
                result: result_3
            });
            setResult(result_3);
        }
    }, []);
    $69607e38bd2400f2$exports.useEffect(function() {
        var current = ref.current;
        current.isMounted = true;
        return function() {
            current.isMounted = false;
        };
    }, []);
    return [
        execute,
        (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            reset: reset
        }, result)
    ];
}








function $99c3602150b5e682$export$2ce622d4a52d9584(value) {
    var promise = Promise.resolve(value);
    promise.status = "fulfilled";
    promise.value = value;
    return promise;
}
function $99c3602150b5e682$export$d22877ef6074ba31(reason) {
    var promise = Promise.reject(reason);
    // prevent potential edge cases leaking unhandled error rejections
    promise.catch(function() {});
    promise.status = "rejected";
    promise.reason = reason;
    return promise;
}
function $99c3602150b5e682$export$eb00ffac1f7b439a(promise) {
    return "status" in promise;
}
function $99c3602150b5e682$export$954ba518324b0e0f(promise) {
    if ($99c3602150b5e682$export$eb00ffac1f7b439a(promise)) return promise;
    var pendingPromise = promise;
    pendingPromise.status = "pending";
    pendingPromise.then(function(value) {
        if (pendingPromise.status === "pending") {
            var fulfilledPromise = pendingPromise;
            fulfilledPromise.status = "fulfilled";
            fulfilledPromise.value = value;
        }
    }, function(reason) {
        if (pendingPromise.status === "pending") {
            var rejectedPromise = pendingPromise;
            rejectedPromise.status = "rejected";
            rejectedPromise.reason = reason;
        }
    });
    return promise;
}



// Prevent webpack from complaining about our feature detection of the
// use property of the React namespace, which is expected not
// to exist when using current stable versions, and that's fine.
var $8ed67bd4d94ce2d4$var$useKey = "use";
var $8ed67bd4d94ce2d4$var$realHook = $69607e38bd2400f2$exports[$8ed67bd4d94ce2d4$var$useKey];
var $8ed67bd4d94ce2d4$export$92629c20d6a56587 = $8ed67bd4d94ce2d4$var$realHook || function __use(promise) {
    var statefulPromise = (0, $99c3602150b5e682$export$954ba518324b0e0f)(promise);
    switch(statefulPromise.status){
        case "pending":
            throw statefulPromise;
        case "rejected":
            throw statefulPromise.reason;
        case "fulfilled":
            return statefulPromise.value;
    }
};



function $76629976780e9cfc$export$722debc0e56fea39(memoFn, deps) {
    var ref = $69607e38bd2400f2$exports.useRef(void 0);
    if (!ref.current || !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(ref.current.deps, deps)) // eslint-disable-next-line react-compiler/react-compiler
    ref.current = {
        value: memoFn(),
        deps: deps
    };
    return ref.current.value;
}










var $14e82582f58c487a$var$QUERY_REFERENCE_SYMBOL = Symbol.for("apollo.internal.queryRef");
var $14e82582f58c487a$var$PROMISE_SYMBOL = Symbol.for("apollo.internal.refPromise");
function $14e82582f58c487a$export$d596989234857a70(internalQueryRef) {
    var _a;
    var ref = (_a = {
        toPromise: function() {
            // We avoid resolving this promise with the query data because we want to
            // discourage using the server data directly from the queryRef. Instead,
            // the data should be accessed through `useReadQuery`. When the server
            // data is needed, its better to use `client.query()` directly.
            //
            // Here we resolve with the ref itself to make using this in React Router
            // or TanStack Router `loader` functions a bit more ergonomic e.g.
            //
            // function loader() {
            //   return { queryRef: await preloadQuery(query).toPromise() }
            // }
            return $14e82582f58c487a$export$c9c310289852f904(ref).then(function() {
                return ref;
            });
        }
    }, _a[$14e82582f58c487a$var$QUERY_REFERENCE_SYMBOL] = internalQueryRef, _a[$14e82582f58c487a$var$PROMISE_SYMBOL] = internalQueryRef.promise, _a);
    return ref;
}
function $14e82582f58c487a$export$212d896173921d75(queryRef) {
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!queryRef || $14e82582f58c487a$var$QUERY_REFERENCE_SYMBOL in queryRef, 93);
}
function $14e82582f58c487a$export$c9c310289852f904(queryRef) {
    var internalQueryRef = $14e82582f58c487a$export$39359b12e11a00e3(queryRef);
    return internalQueryRef.promise.status === "fulfilled" ? internalQueryRef.promise : queryRef[$14e82582f58c487a$var$PROMISE_SYMBOL];
}
function $14e82582f58c487a$export$39359b12e11a00e3(queryRef) {
    return queryRef[$14e82582f58c487a$var$QUERY_REFERENCE_SYMBOL];
}
function $14e82582f58c487a$export$24cbda35be00f1a(queryRef, promise) {
    queryRef[$14e82582f58c487a$var$PROMISE_SYMBOL] = promise;
}
var $14e82582f58c487a$var$OBSERVED_CHANGED_OPTIONS = [
    "canonizeResults",
    "context",
    "errorPolicy",
    "fetchPolicy",
    "refetchWritePolicy",
    "returnPartialData"
];
var $14e82582f58c487a$export$d72b52f31231b813 = /** @class */ function() {
    function InternalQueryReference(observable, options) {
        var _this = this;
        this.key = {};
        this.listeners = new Set();
        this.references = 0;
        this.softReferences = 0;
        this.handleNext = this.handleNext.bind(this);
        this.handleError = this.handleError.bind(this);
        this.dispose = this.dispose.bind(this);
        this.observable = observable;
        if (options.onDispose) this.onDispose = options.onDispose;
        this.setResult();
        this.subscribeToQuery();
        // Start a timer that will automatically dispose of the query if the
        // suspended resource does not use this queryRef in the given time. This
        // helps prevent memory leaks when a component has unmounted before the
        // query has finished loading.
        var startDisposeTimer = function() {
            var _a;
            if (!_this.references) _this.autoDisposeTimeoutId = setTimeout(_this.dispose, (_a = options.autoDisposeTimeoutMs) !== null && _a !== void 0 ? _a : 30000);
        };
        // We wait until the request has settled to ensure we don't dispose of the
        // query ref before the request finishes, otherwise we would leave the
        // promise in a pending state rendering the suspense boundary indefinitely.
        this.promise.then(startDisposeTimer, startDisposeTimer);
    }
    Object.defineProperty(InternalQueryReference.prototype, "disposed", {
        get: function() {
            return this.subscription.closed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InternalQueryReference.prototype, "watchQueryOptions", {
        get: function() {
            return this.observable.options;
        },
        enumerable: false,
        configurable: true
    });
    InternalQueryReference.prototype.reinitialize = function() {
        var observable = this.observable;
        var originalFetchPolicy = this.watchQueryOptions.fetchPolicy;
        var avoidNetworkRequests = originalFetchPolicy === "no-cache" || originalFetchPolicy === "standby";
        try {
            if (avoidNetworkRequests) observable.silentSetOptions({
                fetchPolicy: "standby"
            });
            else {
                (0, $c7b1e48e566741e9$export$d18d1529326946c4)("resetLastResults", function() {
                    return observable.resetLastResults();
                });
                observable.silentSetOptions({
                    fetchPolicy: "cache-first"
                });
            }
            this.subscribeToQuery();
            if (avoidNetworkRequests) return;
            observable.resetDiff();
            this.setResult();
        } finally{
            observable.silentSetOptions({
                fetchPolicy: originalFetchPolicy
            });
        }
    };
    InternalQueryReference.prototype.retain = function() {
        var _this = this;
        this.references++;
        clearTimeout(this.autoDisposeTimeoutId);
        var disposed = false;
        return function() {
            if (disposed) return;
            disposed = true;
            _this.references--;
            setTimeout(function() {
                if (!_this.references) _this.dispose();
            });
        };
    };
    InternalQueryReference.prototype.softRetain = function() {
        var _this = this;
        this.softReferences++;
        var disposed = false;
        return function() {
            // Tracking if this has already been called helps ensure that
            // multiple calls to this function won't decrement the reference
            // counter more than it should. Subsequent calls just result in a noop.
            if (disposed) return;
            disposed = true;
            _this.softReferences--;
            setTimeout(function() {
                if (!_this.softReferences && !_this.references) _this.dispose();
            });
        };
    };
    InternalQueryReference.prototype.didChangeOptions = function(watchQueryOptions) {
        var _this = this;
        return $14e82582f58c487a$var$OBSERVED_CHANGED_OPTIONS.some(function(option) {
            return option in watchQueryOptions && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(_this.watchQueryOptions[option], watchQueryOptions[option]);
        });
    };
    InternalQueryReference.prototype.applyOptions = function(watchQueryOptions) {
        var _a = this.watchQueryOptions, currentFetchPolicy = _a.fetchPolicy, currentCanonizeResults = _a.canonizeResults;
        // "standby" is used when `skip` is set to `true`. Detect when we've
        // enabled the query (i.e. `skip` is `false`) to execute a network request.
        if (currentFetchPolicy === "standby" && currentFetchPolicy !== watchQueryOptions.fetchPolicy) this.initiateFetch(this.observable.reobserve(watchQueryOptions));
        else {
            this.observable.silentSetOptions(watchQueryOptions);
            if (currentCanonizeResults !== watchQueryOptions.canonizeResults) {
                this.result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.result), this.observable.getCurrentResult());
                this.promise = (0, $99c3602150b5e682$export$2ce622d4a52d9584)(this.result);
            }
        }
        return this.promise;
    };
    InternalQueryReference.prototype.listen = function(listener) {
        var _this = this;
        this.listeners.add(listener);
        return function() {
            _this.listeners.delete(listener);
        };
    };
    InternalQueryReference.prototype.refetch = function(variables) {
        return this.initiateFetch(this.observable.refetch(variables));
    };
    InternalQueryReference.prototype.fetchMore = function(options) {
        return this.initiateFetch(this.observable.fetchMore(options));
    };
    InternalQueryReference.prototype.dispose = function() {
        this.subscription.unsubscribe();
        this.onDispose();
    };
    InternalQueryReference.prototype.onDispose = function() {
    // noop. overridable by options
    };
    InternalQueryReference.prototype.handleNext = function(result) {
        var _a;
        switch(this.promise.status){
            case "pending":
                // Maintain the last successful `data` value if the next result does not
                // have one.
                if (result.data === void 0) result.data = this.result.data;
                this.result = result;
                (_a = this.resolve) === null || _a === void 0 || _a.call(this, result);
                break;
            default:
                // This occurs when switching to a result that is fully cached when this
                // class is instantiated. ObservableQuery will run reobserve when
                // subscribing, which delivers a result from the cache.
                if (result.data === this.result.data && result.networkStatus === this.result.networkStatus) return;
                // Maintain the last successful `data` value if the next result does not
                // have one.
                if (result.data === void 0) result.data = this.result.data;
                this.result = result;
                this.promise = (0, $99c3602150b5e682$export$2ce622d4a52d9584)(result);
                this.deliver(this.promise);
                break;
        }
    };
    InternalQueryReference.prototype.handleError = function(error) {
        var _a;
        this.subscription.unsubscribe();
        this.subscription = this.observable.resubscribeAfterError(this.handleNext, this.handleError);
        switch(this.promise.status){
            case "pending":
                (_a = this.reject) === null || _a === void 0 || _a.call(this, error);
                break;
            default:
                this.promise = (0, $99c3602150b5e682$export$d22877ef6074ba31)(error);
                this.deliver(this.promise);
        }
    };
    InternalQueryReference.prototype.deliver = function(promise) {
        this.listeners.forEach(function(listener) {
            return listener(promise);
        });
    };
    InternalQueryReference.prototype.initiateFetch = function(returnedPromise) {
        var _this = this;
        this.promise = this.createPendingPromise();
        this.promise.catch(function() {});
        // If the data returned from the fetch is deeply equal to the data already
        // in the cache, `handleNext` will not be triggered leaving the promise we
        // created in a pending state forever. To avoid this situtation, we attempt
        // to resolve the promise if `handleNext` hasn't been run to ensure the
        // promise is resolved correctly.
        returnedPromise.then(function() {
            // In the case of `fetchMore`, this promise is resolved before a cache
            // result is emitted due to the fact that `fetchMore` sets a `no-cache`
            // fetch policy and runs `cache.batch` in its `.then` handler. Because
            // the timing is different, we accidentally run this update twice
            // causing an additional re-render with the `fetchMore` result by
            // itself. By wrapping in `setTimeout`, this should provide a short
            // delay to allow the `QueryInfo.notify` handler to run before this
            // promise is checked.
            // See https://github.com/apollographql/apollo-client/issues/11315 for
            // more information
            setTimeout(function() {
                var _a;
                if (_this.promise.status === "pending") {
                    // Use the current result from the observable instead of the value
                    // resolved from the promise. This avoids issues in some cases where
                    // the raw resolved value should not be the emitted value, such as
                    // when a `fetchMore` call returns an empty array after it has
                    // reached the end of the list.
                    //
                    // See the following for more information:
                    // https://github.com/apollographql/apollo-client/issues/11642
                    _this.result = _this.observable.getCurrentResult();
                    (_a = _this.resolve) === null || _a === void 0 || _a.call(_this, _this.result);
                }
            });
        }).catch(function(error) {
            var _a;
            return (_a = _this.reject) === null || _a === void 0 ? void 0 : _a.call(_this, error);
        });
        return returnedPromise;
    };
    InternalQueryReference.prototype.subscribeToQuery = function() {
        var _this = this;
        this.subscription = this.observable.filter(function(result) {
            return !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result.data, {}) && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result, _this.result);
        }).subscribe(this.handleNext, this.handleError);
    };
    InternalQueryReference.prototype.setResult = function() {
        // Don't save this result as last result to prevent delivery of last result
        // when first subscribing
        var result = this.observable.getCurrentResult(false);
        if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result, this.result)) return;
        this.result = result;
        this.promise = result.data && (!result.partial || this.watchQueryOptions.returnPartialData) ? (0, $99c3602150b5e682$export$2ce622d4a52d9584)(result) : this.createPendingPromise();
    };
    InternalQueryReference.prototype.createPendingPromise = function() {
        var _this = this;
        return (0, $99c3602150b5e682$export$954ba518324b0e0f)(new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        }));
    };
    return InternalQueryReference;
}();





var $929004aa3455ca92$export$5ad20f9b6f32cad2 = /** @class */ function() {
    function FragmentReference(client, watchFragmentOptions, options) {
        var _this = this;
        this.key = {};
        this.listeners = new Set();
        this.references = 0;
        this.dispose = this.dispose.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleError = this.handleError.bind(this);
        this.observable = client.watchFragment(watchFragmentOptions);
        if (options.onDispose) this.onDispose = options.onDispose;
        var diff = this.getDiff(client, watchFragmentOptions);
        // Start a timer that will automatically dispose of the query if the
        // suspended resource does not use this fragmentRef in the given time. This
        // helps prevent memory leaks when a component has unmounted before the
        // query has finished loading.
        var startDisposeTimer = function() {
            var _a;
            if (!_this.references) _this.autoDisposeTimeoutId = setTimeout(_this.dispose, (_a = options.autoDisposeTimeoutMs) !== null && _a !== void 0 ? _a : 30000);
        };
        this.promise = diff.complete ? (0, $99c3602150b5e682$export$2ce622d4a52d9584)(diff.result) : this.createPendingPromise();
        this.subscribeToFragment();
        this.promise.then(startDisposeTimer, startDisposeTimer);
    }
    FragmentReference.prototype.listen = function(listener) {
        var _this = this;
        this.listeners.add(listener);
        return function() {
            _this.listeners.delete(listener);
        };
    };
    FragmentReference.prototype.retain = function() {
        var _this = this;
        this.references++;
        clearTimeout(this.autoDisposeTimeoutId);
        var disposed = false;
        return function() {
            if (disposed) return;
            disposed = true;
            _this.references--;
            setTimeout(function() {
                if (!_this.references) _this.dispose();
            });
        };
    };
    FragmentReference.prototype.dispose = function() {
        this.subscription.unsubscribe();
        this.onDispose();
    };
    FragmentReference.prototype.onDispose = function() {
    // noop. overridable by options
    };
    FragmentReference.prototype.subscribeToFragment = function() {
        this.subscription = this.observable.subscribe(this.handleNext.bind(this), this.handleError.bind(this));
    };
    FragmentReference.prototype.handleNext = function(result) {
        var _a;
        switch(this.promise.status){
            case "pending":
                if (result.complete) return (_a = this.resolve) === null || _a === void 0 ? void 0 : _a.call(this, result.data);
                this.deliver(this.promise);
                break;
            case "fulfilled":
                // This can occur when we already have a result written to the cache and
                // we subscribe for the first time. We create a fulfilled promise in the
                // constructor with a value that is the same as the first emitted value
                // so we want to skip delivering it.
                if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.promise.value, result.data)) return;
                this.promise = result.complete ? (0, $99c3602150b5e682$export$2ce622d4a52d9584)(result.data) : this.createPendingPromise();
                this.deliver(this.promise);
        }
    };
    FragmentReference.prototype.handleError = function(error) {
        var _a;
        (_a = this.reject) === null || _a === void 0 || _a.call(this, error);
    };
    FragmentReference.prototype.deliver = function(promise) {
        this.listeners.forEach(function(listener) {
            return listener(promise);
        });
    };
    FragmentReference.prototype.createPendingPromise = function() {
        var _this = this;
        return (0, $99c3602150b5e682$export$954ba518324b0e0f)(new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        }));
    };
    FragmentReference.prototype.getDiff = function(client, options) {
        var cache = client.cache;
        var from = options.from, fragment = options.fragment, fragmentName = options.fragmentName;
        var diff = cache.diff((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            query: cache["getFragmentDoc"](fragment, fragmentName),
            returnPartialData: true,
            id: from,
            optimistic: true
        }));
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, diff), {
            result: client["queryManager"].maskFragment({
                fragment: fragment,
                fragmentName: fragmentName,
                data: diff.result
            })
        });
    };
    return FragmentReference;
}();


var $f5a0c48552257915$export$7a8323d1591be59f = /** @class */ function() {
    function SuspenseCache(options) {
        if (options === void 0) options = Object.create(null);
        this.queryRefs = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
        this.fragmentRefs = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
        this.options = options;
    }
    SuspenseCache.prototype.getQueryRef = function(cacheKey, createObservable) {
        var ref = this.queryRefs.lookupArray(cacheKey);
        if (!ref.current) ref.current = new (0, $14e82582f58c487a$export$d72b52f31231b813)(createObservable(), {
            autoDisposeTimeoutMs: this.options.autoDisposeTimeoutMs,
            onDispose: function() {
                delete ref.current;
            }
        });
        return ref.current;
    };
    SuspenseCache.prototype.getFragmentRef = function(cacheKey, client, options) {
        var ref = this.fragmentRefs.lookupArray(cacheKey);
        if (!ref.current) ref.current = new (0, $929004aa3455ca92$export$5ad20f9b6f32cad2)(client, options, {
            autoDisposeTimeoutMs: this.options.autoDisposeTimeoutMs,
            onDispose: function() {
                delete ref.current;
            }
        });
        return ref.current;
    };
    SuspenseCache.prototype.add = function(cacheKey, queryRef) {
        var ref = this.queryRefs.lookupArray(cacheKey);
        ref.current = queryRef;
    };
    return SuspenseCache;
}();


var $d9329d606ac77d7c$var$suspenseCacheSymbol = Symbol.for("apollo.suspenseCache");
function $d9329d606ac77d7c$export$d841506be5d0acb2(client) {
    var _a;
    if (!client[$d9329d606ac77d7c$var$suspenseCacheSymbol]) client[$d9329d606ac77d7c$var$suspenseCacheSymbol] = new (0, $f5a0c48552257915$export$7a8323d1591be59f)((_a = client.defaultOptions.react) === null || _a === void 0 ? void 0 : _a.suspense);
    return client[$d9329d606ac77d7c$var$suspenseCacheSymbol];
}




function $b6b5458965dbc84d$export$5bf2755c0a009e74(query, options) {
    if (options === void 0) options = Object.create(null);
    return (0, $966349df9047bbed$export$7f12579c79e39619)("useSuspenseQuery", // eslint-disable-next-line react-compiler/react-compiler
    $b6b5458965dbc84d$var$useSuspenseQuery_, (0, $0868e36814f766fc$export$eb9a56e7a29e494)(typeof options === "object" ? options.client : undefined))(query, options);
}
function $b6b5458965dbc84d$var$useSuspenseQuery_(query, options) {
    if (globalThis.__DEV__ !== false) // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    (0, $5fe534a73eec9b4d$export$d5e35053e4aec331)(typeof options === "symbol" ? {} : options, "canonizeResults", "useSuspenseQuery");
    var client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)(options.client);
    var suspenseCache = (0, $d9329d606ac77d7c$export$d841506be5d0acb2)(client);
    var watchQueryOptions = $b6b5458965dbc84d$export$85ae642579670efb({
        client: client,
        query: query,
        options: options
    });
    var fetchPolicy = watchQueryOptions.fetchPolicy, variables = watchQueryOptions.variables;
    var _a = options.queryKey, queryKey = _a === void 0 ? [] : _a;
    var cacheKey = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        query,
        (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)(variables)
    ], [].concat(queryKey), true);
    var queryRef = (0, $c7b1e48e566741e9$export$d18d1529326946c4)("canonizeResults", function() {
        return suspenseCache.getQueryRef(cacheKey, function() {
            return client.watchQuery(watchQueryOptions);
        });
    });
    var _b = $69607e38bd2400f2$exports.useState([
        queryRef.key,
        queryRef.promise
    ]), current = _b[0], setPromise = _b[1];
    // This saves us a re-execution of the render function when a variable changed.
    if (current[0] !== queryRef.key) {
        current[0] = queryRef.key;
        current[1] = queryRef.promise;
    }
    var promise = current[1];
    if (queryRef.didChangeOptions(watchQueryOptions)) current[1] = promise = queryRef.applyOptions(watchQueryOptions);
    $69607e38bd2400f2$exports.useEffect(function() {
        var dispose = queryRef.retain();
        var removeListener = queryRef.listen(function(promise) {
            setPromise([
                queryRef.key,
                promise
            ]);
        });
        return function() {
            removeListener();
            dispose();
        };
    }, [
        queryRef
    ]);
    var skipResult = $69607e38bd2400f2$exports.useMemo(function() {
        var error = $b6b5458965dbc84d$export$b2c90f1874ba96bf(queryRef.result);
        return {
            loading: false,
            data: queryRef.result.data,
            networkStatus: error ? (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error : (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready,
            error: error
        };
    }, [
        queryRef.result
    ]);
    var result = fetchPolicy === "standby" ? skipResult : (0, $8ed67bd4d94ce2d4$export$92629c20d6a56587)(promise);
    var fetchMore = $69607e38bd2400f2$exports.useCallback(function(options) {
        var promise = queryRef.fetchMore(options);
        setPromise([
            queryRef.key,
            queryRef.promise
        ]);
        return promise;
    }, [
        queryRef
    ]);
    var refetch = $69607e38bd2400f2$exports.useCallback(function(variables) {
        var promise = queryRef.refetch(variables);
        setPromise([
            queryRef.key,
            queryRef.promise
        ]);
        return promise;
    }, [
        queryRef
    ]);
    // TODO: The internalQueryRef doesn't have TVariables' type information so we have to cast it here
    var subscribeToMore = queryRef.observable.subscribeToMore;
    return $69607e38bd2400f2$exports.useMemo(function() {
        return {
            client: client,
            data: result.data,
            error: $b6b5458965dbc84d$export$b2c90f1874ba96bf(result),
            networkStatus: result.networkStatus,
            fetchMore: fetchMore,
            refetch: refetch,
            subscribeToMore: subscribeToMore
        };
    }, [
        client,
        fetchMore,
        refetch,
        result,
        subscribeToMore
    ]);
}
function $b6b5458965dbc84d$var$validateOptions(options) {
    var query = options.query, fetchPolicy = options.fetchPolicy, returnPartialData = options.returnPartialData;
    (0, $0feb9bd81dd1c3b8$export$6dfb8732f737404c)(query, (0, $0feb9bd81dd1c3b8$export$d1d99cf900472499).Query);
    $b6b5458965dbc84d$var$validateFetchPolicy(fetchPolicy);
    $b6b5458965dbc84d$var$validatePartialDataReturn(fetchPolicy, returnPartialData);
}
function $b6b5458965dbc84d$var$validateFetchPolicy(fetchPolicy) {
    if (fetchPolicy === void 0) fetchPolicy = "cache-first";
    var supportedFetchPolicies = [
        "cache-first",
        "network-only",
        "no-cache",
        "cache-and-network"
    ];
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(supportedFetchPolicies.includes(fetchPolicy), 90, fetchPolicy);
}
function $b6b5458965dbc84d$var$validatePartialDataReturn(fetchPolicy, returnPartialData) {
    if (fetchPolicy === "no-cache" && returnPartialData) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(91);
}
function $b6b5458965dbc84d$export$b2c90f1874ba96bf(result) {
    return (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.errors) ? new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
        graphQLErrors: result.errors
    }) : result.error;
}
function $b6b5458965dbc84d$export$85ae642579670efb(_a) {
    var client = _a.client, query = _a.query, options = _a.options;
    return (0, $76629976780e9cfc$export$722debc0e56fea39)(function() {
        var _a;
        if (options === (0, $80214a2a1ebe2fb0$export$1aa5a89531b7670d)) return {
            query: query,
            fetchPolicy: "standby"
        };
        var fetchPolicy = options.fetchPolicy || ((_a = client.defaultOptions.watchQuery) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || "cache-first";
        var watchQueryOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: fetchPolicy,
            query: query,
            notifyOnNetworkStatusChange: false,
            nextFetchPolicy: void 0
        });
        if (globalThis.__DEV__ !== false) $b6b5458965dbc84d$var$validateOptions(watchQueryOptions);
        // Assign the updated fetch policy after our validation since `standby` is
        // not a supported fetch policy on its own without the use of `skip`.
        if (options.skip) watchQueryOptions.fetchPolicy = "standby";
        return watchQueryOptions;
    }, [
        client,
        options,
        query
    ]);
}


const $ce9d9e524be20f53$var$defaultOptions = {};
var $ce9d9e524be20f53$export$9587d26f28d066a = /*#__PURE__*/ function(BenefitCadence) {
    BenefitCadence["Annual"] = "annual";
    BenefitCadence["Monthly"] = "monthly";
    BenefitCadence["Quarterly"] = "quarterly";
    BenefitCadence["SemiAnnual"] = "semi_annual";
    return BenefitCadence;
}({});
var $ce9d9e524be20f53$export$f725fc4d50930da7 = /*#__PURE__*/ function(CategorizationConfidence) {
    CategorizationConfidence["High"] = "HIGH";
    CategorizationConfidence["Low"] = "LOW";
    CategorizationConfidence["Medium"] = "MEDIUM";
    return CategorizationConfidence;
}({});
var $ce9d9e524be20f53$export$ad6c84d83d033109 = /*#__PURE__*/ function(CategorizationMatchMethod) {
    CategorizationMatchMethod["Amount"] = "AMOUNT";
    CategorizationMatchMethod["Description"] = "DESCRIPTION";
    CategorizationMatchMethod["MerchantId"] = "MERCHANT_ID";
    CategorizationMatchMethod["MerchantName"] = "MERCHANT_NAME";
    CategorizationMatchMethod["PayeeName"] = "PAYEE_NAME";
    return CategorizationMatchMethod;
}({});
var $ce9d9e524be20f53$export$f61e026aa933aaad = /*#__PURE__*/ function(CategorizationSource) {
    CategorizationSource["HistoryMatch"] = "HISTORY_MATCH";
    return CategorizationSource;
}({});
var $ce9d9e524be20f53$export$1ae0be870e8f30b1 = /*#__PURE__*/ function(DepositoryType) {
    DepositoryType["Cash"] = "CASH";
    DepositoryType["Checking"] = "CHECKING";
    DepositoryType["CreditCard"] = "CREDIT_CARD";
    DepositoryType["Ledger"] = "LEDGER";
    DepositoryType["Loan"] = "LOAN";
    DepositoryType["Other"] = "OTHER";
    DepositoryType["Savings"] = "SAVINGS";
    DepositoryType["Wallet"] = "WALLET";
    return DepositoryType;
}({});
var $ce9d9e524be20f53$export$9d6b5f78b73e2a8d = /*#__PURE__*/ function(FieldFilterMatch) {
    FieldFilterMatch["Contains"] = "contains";
    FieldFilterMatch["Exact"] = "exact";
    FieldFilterMatch["Regex"] = "regex";
    FieldFilterMatch["Unset"] = "unset";
    return FieldFilterMatch;
}({});
var $ce9d9e524be20f53$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["Enum"] = "enum";
    FieldType["Text"] = "text";
    return FieldType;
}({});
var $ce9d9e524be20f53$export$19445fdc19724941 = /*#__PURE__*/ function(InvestmentType) {
    InvestmentType["Brokerage"] = "BROKERAGE";
    /** A 529 plan */ InvestmentType["Education"] = "EDUCATION";
    InvestmentType["Hsa"] = "HSA";
    InvestmentType["Ira"] = "IRA";
    InvestmentType["Other"] = "OTHER";
    InvestmentType["RothIra"] = "ROTH_IRA";
    InvestmentType["401K"] = "_401K";
    return InvestmentType;
}({});
var $ce9d9e524be20f53$export$2e1a1b092c43cfb8 = /*#__PURE__*/ function(NetAmountFilter) {
    NetAmountFilter["All"] = "ALL";
    NetAmountFilter["Balanced"] = "BALANCED";
    NetAmountFilter["Income"] = "INCOME";
    NetAmountFilter["Spending"] = "SPENDING";
    return NetAmountFilter;
}({});
var $ce9d9e524be20f53$export$8b4ae5b47902f98d = /*#__PURE__*/ function(NetWorthRole) {
    NetWorthRole["Brokerage"] = "BROKERAGE";
    NetWorthRole["Cash"] = "CASH";
    NetWorthRole["CompanyStock"] = "COMPANY_STOCK";
    NetWorthRole["Education"] = "EDUCATION";
    NetWorthRole["Loans"] = "LOANS";
    NetWorthRole["Other"] = "OTHER";
    NetWorthRole["Retirement"] = "RETIREMENT";
    NetWorthRole["SharedLedgers"] = "SHARED_LEDGERS";
    NetWorthRole["Spending"] = "SPENDING";
    NetWorthRole["StoredValue"] = "STORED_VALUE";
    return NetWorthRole;
}({});
var $ce9d9e524be20f53$export$176402696c519123 = /*#__PURE__*/ function(PatchOpType) {
    PatchOpType["Add"] = "ADD";
    PatchOpType["Remove"] = "REMOVE";
    PatchOpType["Set"] = "SET";
    PatchOpType["Unset"] = "UNSET";
    return PatchOpType;
}({});
var $ce9d9e524be20f53$export$7033551c6b85f4b7 = /*#__PURE__*/ function(PortfolioResolution) {
    PortfolioResolution["Daily"] = "DAILY";
    PortfolioResolution["Monthly"] = "MONTHLY";
    PortfolioResolution["Weekly"] = "WEEKLY";
    return PortfolioResolution;
}({});
var $ce9d9e524be20f53$export$731580143a09eb02 = /*#__PURE__*/ function(ReturnsGranularity) {
    ReturnsGranularity["Month"] = "MONTH";
    ReturnsGranularity["Quarter"] = "QUARTER";
    ReturnsGranularity["Year"] = "YEAR";
    return ReturnsGranularity;
}({});
var $ce9d9e524be20f53$export$41f0e3fcd76586db = /*#__PURE__*/ function(TransactionKind) {
    TransactionKind["AccountTransfer"] = "account_transfer";
    TransactionKind["Conversion"] = "conversion";
    TransactionKind["CreditCardPayment"] = "credit_card_payment";
    TransactionKind["Income"] = "income";
    TransactionKind["Prepaid"] = "prepaid";
    TransactionKind["Refund"] = "refund";
    TransactionKind["Reimbursement"] = "reimbursement";
    TransactionKind["Spending"] = "spending";
    TransactionKind["UntypedTransfer"] = "untyped_transfer";
    return TransactionKind;
}({});
var $ce9d9e524be20f53$export$1b5eb083c754a86b = /*#__PURE__*/ function(TransferType) {
    TransferType["AccountTransfer"] = "account_transfer";
    TransferType["Conversion"] = "conversion";
    TransferType["CreditCardPayment"] = "credit_card_payment";
    TransferType["Prepaid"] = "prepaid";
    TransferType["Refund"] = "refund";
    TransferType["Reimbursement"] = "reimbursement";
    return TransferType;
}({});
const $ce9d9e524be20f53$export$254be908d98a4244 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AttachmentCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$cdb2b75a72845e22 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AttachmentFeePeriod"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "FeePeriod"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefits"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "AttachmentCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AttachmentCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$1fdc27b6052af6dd = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AccountListItem"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$8895f7b905fb951b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "DepositoryAccountFragment"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "DepositoryAccount"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeBalance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balanceStaleSince"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "depositoryType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "closingAnchorId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "trackBalance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaid"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionName"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$7c3522b120a7dc7d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$81d32727a17f3b79 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$ac650bf5b0e45b95 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$ca5955d8c89cc20b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$e3215903df8db8f6 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$69c004aa081eacc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "DetailTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": {
                            "kind": "Name",
                            "value": "UnifiedTransaction"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "basisDraws"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lotTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "units"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lotTransaction"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransaction"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BasicRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$1ebe838be8defc8b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullAnalystCard"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AnalystCard"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "question"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "title"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "commentary"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "chart"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createdAt"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$131cf089091aa5be = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategoryGroup"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CategoryGroup"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "categoryIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$73f52bbf193f3e54 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$450bafd721f750ea = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredRawTransactions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BenefitRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$cdcaf22ee7536f40 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullFeePeriod"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "FeePeriod"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransaction"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefits"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredRawTransactions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BenefitRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$48fb8f68dc6e9441 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullField"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Field"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "values"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allowMultiple"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$b7c2f7132dff651b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullPlaidAccessToken"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "PlaidAccessToken"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tokenSuffix"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "environment"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "active"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "institutionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "institutionName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "products"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accounts"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$562a498c293580a2 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": {
                            "kind": "Name",
                            "value": "BasicRawTransaction"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidData"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionData"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "ezpassData"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumers"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transaction"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "UnifiedTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$58f589a4ac951211 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullUnit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Unit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "singular"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plural"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "displayDecimals"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$1c72565bc26be8d6 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "InvestmentAccountFragment"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "InvestmentAccount"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "presentBalance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "investmentType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "closingAnchorId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastSyncedAt"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaid"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionName"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "snapshotCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "performance"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalValue"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "costBasis"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalGain"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "xirr"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$dd7c7513ca91a14b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "SecurityFields"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Security"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "ticker"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cusip"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isin"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "securityType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isCash"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "treatAsCash"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "identityKey"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$a9b46227f28fe32d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "InvestmentAdjustmentFields"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "InvestmentAdjustment"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "kind"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "securityId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "securityLabel"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "quantity"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cash"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$dcb32e37eaa44101 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "PlaidSyncPreviewTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "PlaidSyncPreviewTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pendingTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "authorizedDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "merchantName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "personalFinanceCategory"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "wouldSync"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "skipReason"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbStatus"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbRawTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbCurrency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbDescription"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbMatches"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidJson"
                        }
                    }
                ]
            }
        }
    ]
};
const $ce9d9e524be20f53$export$c5e6f96e05335e57 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$83a5bf0e4425c554(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$c5e6f96e05335e57, options);
}
function $ce9d9e524be20f53$export$82cc222b1c121b13(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$c5e6f96e05335e57, options);
}
function $ce9d9e524be20f53$export$8847ac8640a070ef(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$c5e6f96e05335e57, options);
}
const $ce9d9e524be20f53$export$32ff86f03c9426a4 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AccountBalances"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allAccounts"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "balance"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "homeBalance"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "balanceStaleSince"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "hasRecentActivity"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "balance"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "balanceAsOf"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "hasRecentActivity"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$6d85013179a40a0d(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$32ff86f03c9426a4, options);
}
function $ce9d9e524be20f53$export$cb8a99aec70ab8dd(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$32ff86f03c9426a4, options);
}
function $ce9d9e524be20f53$export$ff59367323c8afc0(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$32ff86f03c9426a4, options);
}
const $ce9d9e524be20f53$export$40c84f756581c0a8 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AccountPlaidConnection"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "plaid"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "accountId"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "institutionName"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "connectionActive"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "lastSuccessfulSyncAt"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "plaid"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "accountId"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "institutionName"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "connectionActive"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "lastSuccessfulSyncAt"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$14196d3121b7a06(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$40c84f756581c0a8, options);
}
function $ce9d9e524be20f53$export$c9a58418daafc18b(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$40c84f756581c0a8, options);
}
function $ce9d9e524be20f53$export$ae9ec305f31319d0(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$40c84f756581c0a8, options);
}
const $ce9d9e524be20f53$export$c255d7193c249b97 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AccountPlaidJson"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "plaid"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "accountId"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "plaidJson"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "plaid"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "accountId"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "plaidJson"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$daca90b073bacfa0(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$c255d7193c249b97, options);
}
function $ce9d9e524be20f53$export$6c9620547bd278e9(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$c255d7193c249b97, options);
}
function $ce9d9e524be20f53$export$7f1402e1a26c8360(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$c255d7193c249b97, options);
}
const $ce9d9e524be20f53$export$a9506d34966fbeb6 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AccountTypeOrder"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountTypeOrder"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$b1e5e46b10f75f8b(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$a9506d34966fbeb6, options);
}
function $ce9d9e524be20f53$export$2545ac5f0deeecfa(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$a9506d34966fbeb6, options);
}
function $ce9d9e524be20f53$export$be25563ab62eb26c(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$a9506d34966fbeb6, options);
}
const $ce9d9e524be20f53$export$32cb069586f1107 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "AddConsumptionToTransaction"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transactionId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionIds"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "clearFields"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "categoryName"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TransferType"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "addConsumptionToTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "transactionId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "rawTransactionIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionIds"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "clearFields"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "clearFields"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "payee"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "categoryName"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "categoryName"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "transferType"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transferType"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transferType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "netAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeNetAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "needsBasis"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "consumptions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rawTransactionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$9fe0c1647f422e4c(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$32cb069586f1107, options);
}
const $ce9d9e524be20f53$export$eebec288fa89845d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "AddFieldValue"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "fieldId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "value"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "addFieldValue"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "fieldId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fieldId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "value"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullField"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullField"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Field"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "values"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allowMultiple"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$dbb3787b81fec8b8(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$eebec288fa89845d, options);
}
const $ce9d9e524be20f53$export$2f2991a875f1875d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllAccounts"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allAccounts"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "AccountListItem"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AccountListItem"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$cb6e321bdf608ddb(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$2f2991a875f1875d, options);
}
function $ce9d9e524be20f53$export$3c25b019ad533aeb(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$2f2991a875f1875d, options);
}
function $ce9d9e524be20f53$export$b0f85440d422602a(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$2f2991a875f1875d, options);
}
const $ce9d9e524be20f53$export$d1f4bc308fd4c7e3 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllCardBenefits"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allCardBenefits"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredRawTransactions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BenefitRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$d85677968e5ae42e(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$d1f4bc308fd4c7e3, options);
}
function $ce9d9e524be20f53$export$e7944f5a725a20af(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$d1f4bc308fd4c7e3, options);
}
function $ce9d9e524be20f53$export$892b14d62fa6b7fb(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$d1f4bc308fd4c7e3, options);
}
const $ce9d9e524be20f53$export$d17ad941deb6ba54 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllCategories"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allCategories"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$1f9e2535d0d42ab9(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$d17ad941deb6ba54, options);
}
function $ce9d9e524be20f53$export$bd24d6983e79a93f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$d17ad941deb6ba54, options);
}
function $ce9d9e524be20f53$export$540f7d70eb8b78d6(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$d17ad941deb6ba54, options);
}
const $ce9d9e524be20f53$export$3843ec340ebce4f5 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllCategoryGroups"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allCategoryGroups"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategoryGroup"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategoryGroup"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CategoryGroup"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "categoryIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$9dda77d697c51272(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$3843ec340ebce4f5, options);
}
function $ce9d9e524be20f53$export$32a272ceaf4f3578(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$3843ec340ebce4f5, options);
}
function $ce9d9e524be20f53$export$e0dc64679acd2bdd(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$3843ec340ebce4f5, options);
}
const $ce9d9e524be20f53$export$3557c8d197445a9f = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllFeePeriods"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allFeePeriods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullFeePeriod"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredRawTransactions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BenefitRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullFeePeriod"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "FeePeriod"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransaction"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefits"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$46a1dde66166f325(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$3557c8d197445a9f, options);
}
function $ce9d9e524be20f53$export$ca94746654f7fb70(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$3557c8d197445a9f, options);
}
function $ce9d9e524be20f53$export$f801fa8b7c15b2f9(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$3557c8d197445a9f, options);
}
const $ce9d9e524be20f53$export$d90eefb80c8f7fb0 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllFields"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allFields"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullField"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullField"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Field"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "values"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allowMultiple"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$f7e7e8c15204f3c5(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$d90eefb80c8f7fb0, options);
}
function $ce9d9e524be20f53$export$2d35bb6784555ba7(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$d90eefb80c8f7fb0, options);
}
function $ce9d9e524be20f53$export$70346b98a4281692(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$d90eefb80c8f7fb0, options);
}
const $ce9d9e524be20f53$export$8df4202360325415 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllInvestmentAccounts"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allInvestmentAccounts"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceAsOf"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "presentBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "presentBalanceAsOf"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$34fd8d1d279e4cb6(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$8df4202360325415, options);
}
function $ce9d9e524be20f53$export$a07838fa0fceee81(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$8df4202360325415, options);
}
function $ce9d9e524be20f53$export$a0f1a4b81db52211(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$8df4202360325415, options);
}
const $ce9d9e524be20f53$export$91c1447d7c64a6d8 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllInvestmentAccountsPerformance"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allInvestmentAccounts"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "performance"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totalValue"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "costBasis"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totalGain"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "xirr"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$a771ba3c52d2e375(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$91c1447d7c64a6d8, options);
}
function $ce9d9e524be20f53$export$639bd7c3cf0076d3(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$91c1447d7c64a6d8, options);
}
function $ce9d9e524be20f53$export$a05b87eabc873422(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$91c1447d7c64a6d8, options);
}
const $ce9d9e524be20f53$export$93b6c794bcd86056 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllPayees"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allPayees"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$4c1a1d4cb0307c88(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$93b6c794bcd86056, options);
}
function $ce9d9e524be20f53$export$8eded7bbbb388ca8(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$93b6c794bcd86056, options);
}
function $ce9d9e524be20f53$export$9e5b59a43ee04ae0(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$93b6c794bcd86056, options);
}
const $ce9d9e524be20f53$export$d0cf06536cad3268 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllRawTransactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "includeProcessed"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "limit"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "before"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "after"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "beforeCursor"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "afterCursor"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "search"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "excludeIds"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "reconciled"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "allocated"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "minAmount"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "maxAmount"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allRawTransactions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountIds"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "includeProcessed"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "includeProcessed"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "limit"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "limit"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "before"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "before"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "after"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "after"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "beforeCursor"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "beforeCursor"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "afterCursor"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "afterCursor"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "search"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "search"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "excludeIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "excludeIds"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "benefitId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "benefitId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "reconciled"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciled"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "allocated"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "allocated"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "minAmount"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "minAmount"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "maxAmount"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "maxAmount"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "items"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BasicRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startCursor"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endCursor"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "hasMore"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$410de0888c608cef(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$d0cf06536cad3268, options);
}
function $ce9d9e524be20f53$export$d1531303a4748421(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$d0cf06536cad3268, options);
}
function $ce9d9e524be20f53$export$d84a819abaab0ab1(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$d0cf06536cad3268, options);
}
const $ce9d9e524be20f53$export$99aad9650dac1e8d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllRawTransactionsLite"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "includeProcessed"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "limit"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "beforeCursor"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allRawTransactions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountIds"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "includeProcessed"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "includeProcessed"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "limit"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "limit"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "beforeCursor"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "beforeCursor"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "items"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currency"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "reconciliation"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "reconciledAt"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "reconciliationId"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startCursor"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endCursor"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "hasMore"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$4804775d7f2aae89(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$99aad9650dac1e8d, options);
}
function $ce9d9e524be20f53$export$8042f7d4b67affe8(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$99aad9650dac1e8d, options);
}
function $ce9d9e524be20f53$export$d328fe468d9d1993(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$99aad9650dac1e8d, options);
}
const $ce9d9e524be20f53$export$15db7ce0a4517c9e = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllTags"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allTags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$1f229484873dfcfd(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$15db7ce0a4517c9e, options);
}
function $ce9d9e524be20f53$export$325ce7916f157bb9(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$15db7ce0a4517c9e, options);
}
function $ce9d9e524be20f53$export$adc4a8fd7296c0a0(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$15db7ce0a4517c9e, options);
}
const $ce9d9e524be20f53$export$7b157d29dd825b13 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllUnits"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allUnits"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullUnit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullUnit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Unit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "singular"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plural"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "displayDecimals"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$20437837b60921de(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$7b157d29dd825b13, options);
}
function $ce9d9e524be20f53$export$6ae2c3d040d1c39f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$7b157d29dd825b13, options);
}
function $ce9d9e524be20f53$export$f1365e15bad29e1c(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$7b157d29dd825b13, options);
}
const $ce9d9e524be20f53$export$a5e2d9027e723dda = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AnalystCards"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "analystCards"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullAnalystCard"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullAnalystCard"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AnalystCard"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "question"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "title"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "commentary"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "chart"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createdAt"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$9a225e934a844fbf(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$a5e2d9027e723dda, options);
}
function $ce9d9e524be20f53$export$dadfdfafad708ab2(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$a5e2d9027e723dda, options);
}
function $ce9d9e524be20f53$export$88eee14547f006ab(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$a5e2d9027e723dda, options);
}
const $ce9d9e524be20f53$export$7e66b9a6ead4b94c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AnalystRun"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "JSON"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "analystRun"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "source"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$7ec599901543f4fc(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$7e66b9a6ead4b94c, options);
}
function $ce9d9e524be20f53$export$da3d7a5eae5dcd3e(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$7e66b9a6ead4b94c, options);
}
function $ce9d9e524be20f53$export$2de96a874f27323a(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$7e66b9a6ead4b94c, options);
}
const $ce9d9e524be20f53$export$ac61947d8e814c38 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "AssignBasis"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transactionId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "assignBasis"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "transactionId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "UnifiedTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$a0fb838635ed18f0(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$ac61947d8e814c38, options);
}
const $ce9d9e524be20f53$export$d6f370444ac9922b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AttachmentFeePeriods"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allFeePeriods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "AttachmentFeePeriod"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AttachmentCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AttachmentFeePeriod"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "FeePeriod"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefits"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "AttachmentCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$6c4da8612d49971(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$d6f370444ac9922b, options);
}
function $ce9d9e524be20f53$export$aa7df3ba16cd0d8c(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$d6f370444ac9922b, options);
}
function $ce9d9e524be20f53$export$8b71051c29ce14c8(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$d6f370444ac9922b, options);
}
const $ce9d9e524be20f53$export$e2c3174e2843e07d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "BalanceAnchor"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "anchorId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balanceAnchor"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "anchorId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "anchorId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "needsReview"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliation"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "startDate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "endDate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "reconciledAt"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rawTransactionIds"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "baselineAnchor"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "_id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "date"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "balance"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rawTransactions"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "BasicRawTransaction"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$aeaa97dc60d8067(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$e2c3174e2843e07d, options);
}
function $ce9d9e524be20f53$export$60825c7e4a231b64(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$e2c3174e2843e07d, options);
}
function $ce9d9e524be20f53$export$2af54cbd9a02a3a0(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$e2c3174e2843e07d, options);
}
const $ce9d9e524be20f53$export$b1e784610a7bd25b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "BalanceAnchors"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "before"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "limit"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balanceAnchors"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "before"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "before"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "limit"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "limit"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "needsReview"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliation"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "startDate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "endDate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "reconciledAt"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rawTransactionIds"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "baselineAnchor"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "_id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "date"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$4b244df86d92b624(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$b1e784610a7bd25b, options);
}
function $ce9d9e524be20f53$export$8e575b372e210829(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$b1e784610a7bd25b, options);
}
function $ce9d9e524be20f53$export$bf48055dc48fe3a1(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$b1e784610a7bd25b, options);
}
const $ce9d9e524be20f53$export$e0a711d943e3b761 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "BalanceHistory"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balanceHistory"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "points"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "balance"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "source"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "spans"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "startDate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "endDate"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$d44efaed59ed22d0(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$e0a711d943e3b761, options);
}
function $ce9d9e524be20f53$export$b028e697bd48d647(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$e0a711d943e3b761, options);
}
function $ce9d9e524be20f53$export$21ea386378eb62eb(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$e0a711d943e3b761, options);
}
const $ce9d9e524be20f53$export$b161471a1080f29d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "BalanceReadings"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "before"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "limit"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balanceReadings"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "before"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "before"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "limit"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "limit"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAt"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$a3b544ccb0f6d05(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$b161471a1080f29d, options);
}
function $ce9d9e524be20f53$export$dd8de213c0a311e9(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$b161471a1080f29d, options);
}
function $ce9d9e524be20f53$export$271ebd0bf6dd6e37(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$b161471a1080f29d, options);
}
const $ce9d9e524be20f53$export$4f708d8a93df716a = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "Bindings"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "bindings"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "key"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "entityId"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$7d26fb86ec9e5950(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$4f708d8a93df716a, options);
}
function $ce9d9e524be20f53$export$35e5c974b98f29e7(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$4f708d8a93df716a, options);
}
function $ce9d9e524be20f53$export$92a89bbfb35b1c20(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$4f708d8a93df716a, options);
}
const $ce9d9e524be20f53$export$13bba204e58d46d3 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CardBenefitsByAccount"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cardBenefitsByAccount"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredRawTransactions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BenefitRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$b37e41f64d3d4a69(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$13bba204e58d46d3, options);
}
function $ce9d9e524be20f53$export$730df2cbd21cd330(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$13bba204e58d46d3, options);
}
function $ce9d9e524be20f53$export$9cc19ea7ef81a67f(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$13bba204e58d46d3, options);
}
const $ce9d9e524be20f53$export$2e3da1aa8cde8041 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CashFlowByCategory"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cashFlowByCategory"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "key"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "net"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "count"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$532d39b2a97ef848(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$2e3da1aa8cde8041, options);
}
function $ce9d9e524be20f53$export$13d3eb403f519077(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$2e3da1aa8cde8041, options);
}
function $ce9d9e524be20f53$export$ad853a566e6f209c(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$2e3da1aa8cde8041, options);
}
const $ce9d9e524be20f53$export$c88c9e9dd64988d1 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CashFlowByPayee"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "categoryId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cashFlowByPayee"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "categoryId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "categoryId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "key"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "net"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "count"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$e1cff32f4295f5ee(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$c88c9e9dd64988d1, options);
}
function $ce9d9e524be20f53$export$ef4c3fd918755bf8(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$c88c9e9dd64988d1, options);
}
function $ce9d9e524be20f53$export$e9e1cf0ae426c97d(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$c88c9e9dd64988d1, options);
}
const $ce9d9e524be20f53$export$a7dd8150f878e2fa = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "UnallocatedCashFlow"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "unallocatedCashFlow"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "net"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "count"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "foreignCount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$5cbc24df0057fcf4(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$a7dd8150f878e2fa, options);
}
function $ce9d9e524be20f53$export$1041547bc96396f1(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$a7dd8150f878e2fa, options);
}
function $ce9d9e524be20f53$export$f4308c22f7a16a4a(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$a7dd8150f878e2fa, options);
}
const $ce9d9e524be20f53$export$8df7e16771371ff7 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CashFlowByCategoryByMonth"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cashFlowByCategoryByMonth"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "key"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "month"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "net"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "count"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$e8213614668719ff(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$8df7e16771371ff7, options);
}
function $ce9d9e524be20f53$export$1ad5653ca0b1beb2(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$8df7e16771371ff7, options);
}
function $ce9d9e524be20f53$export$e20c9f1ea51d962e(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$8df7e16771371ff7, options);
}
const $ce9d9e524be20f53$export$76a7de2eed3f35e8 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CategoryById"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "categoryById"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$b781d19289d47f28(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$76a7de2eed3f35e8, options);
}
function $ce9d9e524be20f53$export$7ab735233cfb932a(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$76a7de2eed3f35e8, options);
}
function $ce9d9e524be20f53$export$7c06400fd1aa3aa7(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$76a7de2eed3f35e8, options);
}
const $ce9d9e524be20f53$export$1f9496b02d5d489d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "ClearPayeeLogo"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "clearPayeeLogo"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "payee"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$4ef18ce3a173b118(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$1f9496b02d5d489d, options);
}
const $ce9d9e524be20f53$export$f5f6077b67cf3d65 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ConsolidatedPortfolioHistory"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "resolution"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "PortfolioResolution"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consolidatedPortfolioHistory"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "resolution"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "resolution"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "portfolioValue"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "costBasis"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gain"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$2895a0c5aea6a6e1(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$f5f6077b67cf3d65, options);
}
function $ce9d9e524be20f53$export$45e192479301b497(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$f5f6077b67cf3d65, options);
}
function $ce9d9e524be20f53$export$2eaf02262ccdf971(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$f5f6077b67cf3d65, options);
}
const $ce9d9e524be20f53$export$c07906029d47c285 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CopyBenefitsFromFeePeriod"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "sourceFeePeriodId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "targetFeePeriodId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "copyBenefitsFromFeePeriod"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "sourceFeePeriodId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sourceFeePeriodId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "targetFeePeriodId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "targetFeePeriodId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredRawTransactions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BenefitRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$a15cb28a00ce8458(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$c07906029d47c285, options);
}
const $ce9d9e524be20f53$export$b0e69161daa9e9b2 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateCardBenefit"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "cadence"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "BenefitCadence"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "amountPerPeriod"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "calendarAligned"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "BenefitPeriodInput"
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createCardBenefit"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "feePeriodId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "feePeriodId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "category"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "category"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "cadence"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cadence"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "amountPerPeriod"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amountPerPeriod"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "calendarAligned"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "calendarAligned"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "creditAccountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "creditAccountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "periods"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "periods"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredRawTransactions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BenefitRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$ddae66c6df44b5a7(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$b0e69161daa9e9b2, options);
}
const $ce9d9e524be20f53$export$1b98c0d173b5ba22 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateCategory"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createCategory"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "icon"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "icon"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "color"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "color"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$b8da3e59c773b24a(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$1b98c0d173b5ba22, options);
}
const $ce9d9e524be20f53$export$e5fe524af1cacabc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateCategoryGroup"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createCategoryGroup"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategoryGroup"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategoryGroup"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CategoryGroup"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "categoryIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$c98005c22c1df9a0(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$e5fe524af1cacabc, options);
}
const $ce9d9e524be20f53$export$45ab29deb8e31b69 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateDepositoryAccount"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "depositoryType"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryType"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "trackBalance"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createDepositoryAccount"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "depositoryType"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "logo"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "cardProduct"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "trackBalance"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "currency"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "DepositoryAccountFragment"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "DepositoryAccountFragment"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "DepositoryAccount"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeBalance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balanceStaleSince"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "depositoryType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "closingAnchorId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "trackBalance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaid"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionName"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$9c00ed426f67b5b7(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$45ab29deb8e31b69, options);
}
const $ce9d9e524be20f53$export$e0fae2947b89d842 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateFeePeriod"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createFeePeriod"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "rawTransactionId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "amount"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "payee"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "cardProduct"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullFeePeriod"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredRawTransactions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BenefitRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullFeePeriod"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "FeePeriod"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransaction"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefits"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$14858aeec370c3a1(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$e0fae2947b89d842, options);
}
const $ce9d9e524be20f53$export$df56d239f013716a = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateField"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "FieldType"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "values"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FieldValueInput"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "allowMultiple"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createField"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "type"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "values"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "values"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "allowMultiple"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "allowMultiple"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "required"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "required"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullField"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullField"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Field"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "values"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allowMultiple"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$dedb17a472ec9063(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$df56d239f013716a, options);
}
const $ce9d9e524be20f53$export$23b86e0d85136a61 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateInvestmentAccount"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "investmentType"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentType"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createInvestmentAccount"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "investmentType"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "logo"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "InvestmentAccountFragment"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "InvestmentAccountFragment"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "InvestmentAccount"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "presentBalance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "investmentType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "closingAnchorId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastSyncedAt"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaid"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionName"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "snapshotCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "performance"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalValue"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "costBasis"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalGain"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "xirr"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$e242736be31c4ea0(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$23b86e0d85136a61, options);
}
const $ce9d9e524be20f53$export$171b91209da4b90a = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CreateLinkToken"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "env"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "products"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createLinkToken"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "env"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "env"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "products"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "products"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$170e4aa7bab53c83(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$171b91209da4b90a, options);
}
function $ce9d9e524be20f53$export$4d955784ab97d150(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$171b91209da4b90a, options);
}
function $ce9d9e524be20f53$export$485d26a83e2cc08e(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$171b91209da4b90a, options);
}
const $ce9d9e524be20f53$export$9ff193f794ff6c8d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateRawTransaction"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "props"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "CreateRawTransactionArgs"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createRawTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "props"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "props"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BasicRawTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$44575aef3a6c207(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$9ff193f794ff6c8d, options);
}
const $ce9d9e524be20f53$export$dec7d8c999f5b288 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateRawTransactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transactions"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "CreateRawTransactionArgs"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createRawTransactions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "transactions"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactions"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BasicRawTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$93673fb014a748bd(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$dec7d8c999f5b288, options);
}
const $ce9d9e524be20f53$export$6507718f2d0ca200 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateTransaction"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactions"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "JSON"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TransferType"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "allocations"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "RawTransactionAllocationInput"
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "rawTransactions"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "allocations"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "allocations"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "properties"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "date"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "payee"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "payee"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "description"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "category"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "category"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "tags"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "tags"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "fieldValues"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "fieldValues"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "pending"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "pending"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "transferType"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transferType"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "UnifiedTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$5694853076d71b4a(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$6507718f2d0ca200, options);
}
const $ce9d9e524be20f53$export$77b9a0c05b584808 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateUnit"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "singular"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "plural"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "displayDecimals"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createUnit"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "singular"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "singular"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "plural"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plural"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "displayDecimals"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "displayDecimals"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "logo"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullUnit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullUnit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Unit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "singular"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plural"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "displayDecimals"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$ac83f9d48a6d7c8c(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$77b9a0c05b584808, options);
}
const $ce9d9e524be20f53$export$663de546e80d89fd = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateUpdateLinkToken"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accessTokenId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createUpdateLinkToken"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accessTokenId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accessTokenId"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$d30b9f47d38efbc1(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$663de546e80d89fd, options);
}
const $ce9d9e524be20f53$export$843997ec67648183 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteAccount"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteAccount"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$94986b58b70e2d42(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$843997ec67648183, options);
}
const $ce9d9e524be20f53$export$ccb3e67306ed5c59 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteBalanceAnchor"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "anchorId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteBalanceAnchor"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "anchorId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "anchorId"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$b24be224d4f4a7fe(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$ccb3e67306ed5c59, options);
}
const $ce9d9e524be20f53$export$910470e11f64fec7 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteBalanceReading"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "readingId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteBalanceReading"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "readingId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "readingId"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$c78712a61e8c6f22(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$910470e11f64fec7, options);
}
const $ce9d9e524be20f53$export$41c28041416d18da = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteCardBenefit"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteCardBenefit"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$2da0d793ed75c38c(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$41c28041416d18da, options);
}
const $ce9d9e524be20f53$export$83e8f73439ca83fa = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteCategory"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteCategory"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$a2281196ed640bc7(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$83e8f73439ca83fa, options);
}
const $ce9d9e524be20f53$export$b2ddfde93c600f18 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteCategoryGroup"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteCategoryGroup"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategoryGroup"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategoryGroup"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CategoryGroup"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "categoryIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$b944ea19df7f9ed0(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$b2ddfde93c600f18, options);
}
const $ce9d9e524be20f53$export$c1c5f4ce047349e3 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteFeePeriod"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteFeePeriod"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$5f8fb7bb9a730c4c(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$c1c5f4ce047349e3, options);
}
const $ce9d9e524be20f53$export$679746dc21edc3a5 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteField"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "force"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteField"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "force"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "force"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$39416e8dff3fda6f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$679746dc21edc3a5, options);
}
const $ce9d9e524be20f53$export$4e7cd97bb89476ed = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteRawTransactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "ids"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteRawTransactions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "ids"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ids"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$d89c4bc38f3faef7(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$4e7cd97bb89476ed, options);
}
const $ce9d9e524be20f53$export$d2184d4ec601e441 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteReconciliation"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliationId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteReconciliation"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "reconciliationId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliation"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$d6c3bbb7a188fe0f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$d2184d4ec601e441, options);
}
const $ce9d9e524be20f53$export$5fa4e89ffe9001fb = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteUnit"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteUnit"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$6c48a9eed4669ece(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$5fa4e89ffe9001fb, options);
}
const $ce9d9e524be20f53$export$e31dc48da481a452 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "EquityIssuers"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "equityIssuers"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesHeld"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "valueCents"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "grants"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "issuerId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "strikePerShare"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currency"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sharesTotal"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "tranches"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "date"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "shares"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "importKey"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "note"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "marks"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "issuerId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "price"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currency"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "source"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "anchorId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "note"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lots"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "issuerId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "acquiredDate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "source"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sharesAcquired"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sharesRemaining"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "basisPerShare"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currency"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "grantId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sharesWithheldForTax"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "certificateRefs"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "importKey"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "note"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "events"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "issuerId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "price"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currency"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "draws"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "lotId"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "shares"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sharesSold"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "grossCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "exerciseCostCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "withholdingCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "netCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "estimated"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionIds"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "importKey"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "note"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "realizedGainCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "missingTransactionLinks"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$3d4eca0a186358cf(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$e31dc48da481a452, options);
}
function $ce9d9e524be20f53$export$ceeb1522aa9b587f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$e31dc48da481a452, options);
}
function $ce9d9e524be20f53$export$5d50a99daee5e11d(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$e31dc48da481a452, options);
}
const $ce9d9e524be20f53$export$ba704de9921859b8 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateEquityIssuer"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createEquityIssuer"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "logo"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$9679e668bf5083e8(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$ba704de9921859b8, options);
}
const $ce9d9e524be20f53$export$4d54e7037841b896 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateEquityIssuer"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "issuerId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateEquityIssuer"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "issuerId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "logo"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$820b39b30991f529(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$4d54e7037841b896, options);
}
const $ce9d9e524be20f53$export$97a1e256c7f3454 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteEquityIssuer"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "issuerId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteEquityIssuer"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "issuerId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$e16bae7318357df8(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$97a1e256c7f3454, options);
}
const $ce9d9e524be20f53$export$4cab4a30df90cacc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateEquityMark"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "issuerId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "writeAnchor"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createEquityMark"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "issuerId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "price"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "currency"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "source"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "writeAnchor"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "writeAnchor"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "anchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$6d9e0e901161e4be(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$4cab4a30df90cacc, options);
}
const $ce9d9e524be20f53$export$6820a9008e8fb448 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateEquityMark"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "markId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "writeAnchor"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateEquityMark"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "markId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "markId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "price"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "currency"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "source"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "writeAnchor"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "writeAnchor"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "anchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$491850dbefcb5690(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$6820a9008e8fb448, options);
}
const $ce9d9e524be20f53$export$7b16218bc65daa69 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteEquityMark"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "markId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteEquityMark"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "markId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "markId"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$da3bf4fdb6aa51ab(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$7b16218bc65daa69, options);
}
const $ce9d9e524be20f53$export$c5e722b619fde1b0 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateEquityLot"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "issuerId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "acquiredDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "sharesAcquired"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "basisPerShare"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "grantId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "sharesWithheldForTax"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "certificateRefs"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "importKey"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createEquityLot"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "issuerId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "acquiredDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "acquiredDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "source"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "sharesAcquired"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesAcquired"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "basisPerShare"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "basisPerShare"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "currency"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "grantId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "grantId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "sharesWithheldForTax"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesWithheldForTax"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "certificateRefs"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "certificateRefs"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "importKey"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "importKey"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "acquiredDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesAcquired"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesRemaining"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "basisPerShare"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "grantId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesWithheldForTax"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "certificateRefs"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "importKey"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$a185d0818b38e0f8(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$c5e722b619fde1b0, options);
}
const $ce9d9e524be20f53$export$2c09bf9fc69b9d2e = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateEquityLot"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "lotId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "acquiredDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "sharesAcquired"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "basisPerShare"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "grantId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "sharesWithheldForTax"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "certificateRefs"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateEquityLot"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "lotId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lotId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "acquiredDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "acquiredDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "source"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "sharesAcquired"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesAcquired"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "basisPerShare"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "basisPerShare"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "currency"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "grantId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "grantId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "sharesWithheldForTax"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesWithheldForTax"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "certificateRefs"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "certificateRefs"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "acquiredDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesAcquired"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesRemaining"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "basisPerShare"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "grantId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesWithheldForTax"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "certificateRefs"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$c571acd9794b159b(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$2c09bf9fc69b9d2e, options);
}
const $ce9d9e524be20f53$export$bcd3fd4d3a81f277 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteEquityLot"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "lotId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteEquityLot"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "lotId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lotId"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$912d9f88c7e84e7d(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$bcd3fd4d3a81f277, options);
}
const $ce9d9e524be20f53$export$c867f4ba9d2993a = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateEquityGrant"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "issuerId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "strikePerShare"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "tranches"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "EquityGrantTrancheInput"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "importKey"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createEquityGrant"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "issuerId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "strikePerShare"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "strikePerShare"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "currency"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "tranches"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tranches"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "importKey"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "importKey"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "strikePerShare"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesTotal"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tranches"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shares"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "importKey"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$532d1f40c4041bdc(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$c867f4ba9d2993a, options);
}
const $ce9d9e524be20f53$export$b751ae7f3891400a = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateEquityGrant"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "grantId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "strikePerShare"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "tranches"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "EquityGrantTrancheInput"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateEquityGrant"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "grantId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "grantId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "strikePerShare"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "strikePerShare"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "currency"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "tranches"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tranches"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "strikePerShare"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesTotal"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tranches"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shares"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$38a27002ed80784c(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$b751ae7f3891400a, options);
}
const $ce9d9e524be20f53$export$5aee5d10197eb708 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteEquityGrant"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "grantId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteEquityGrant"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "grantId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "grantId"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$a928182c2490bcc1(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$5aee5d10197eb708, options);
}
const $ce9d9e524be20f53$export$276abfe2651df956 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateEquityEvent"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "issuerId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "draws"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "EquityDrawInput"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "grossCents"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "exerciseCostCents"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "withholdingCents"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "netCents"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "estimated"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transactionIds"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "importKey"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createEquityEvent"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "issuerId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "price"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "currency"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "draws"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "draws"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "grossCents"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "grossCents"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "exerciseCostCents"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "exerciseCostCents"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "withholdingCents"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "withholdingCents"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "netCents"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "netCents"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "estimated"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "estimated"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "transactionIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionIds"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "importKey"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "importKey"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "draws"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "lotId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shares"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesSold"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "grossCents"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "exerciseCostCents"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "withholdingCents"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "netCents"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "estimated"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionIds"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "importKey"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "realizedGainCents"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "missingTransactionLinks"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$cfd5931879c26168(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$276abfe2651df956, options);
}
const $ce9d9e524be20f53$export$a561dc4d9cca9d8b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateEquityEvent"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "eventId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "draws"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "EquityDrawInput"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "grossCents"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "exerciseCostCents"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "withholdingCents"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "netCents"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "estimated"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transactionIds"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateEquityEvent"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "eventId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "eventId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "price"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "currency"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "draws"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "draws"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "grossCents"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "grossCents"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "exerciseCostCents"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "exerciseCostCents"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "withholdingCents"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "withholdingCents"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "netCents"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "netCents"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "estimated"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "estimated"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "transactionIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionIds"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "draws"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "lotId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shares"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sharesSold"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "grossCents"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "exerciseCostCents"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "withholdingCents"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "netCents"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "estimated"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionIds"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "realizedGainCents"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$1e82161d9f33f542(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$a561dc4d9cca9d8b, options);
}
const $ce9d9e524be20f53$export$d9bac423bd582e5e = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteEquityEvent"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "eventId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteEquityEvent"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "eventId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "eventId"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$3d4803f3ff32b8ab(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$d9bac423bd582e5e, options);
}
const $ce9d9e524be20f53$export$eb856e8d5308d4e7 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ExistingExternalIds"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "externalSource"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "externalIds"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "existingExternalIds"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "externalSource"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "externalSource"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "externalIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "externalIds"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$6c933d32658b04d3(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$eb856e8d5308d4e7, options);
}
function $ce9d9e524be20f53$export$96c4c66480c4375b(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$eb856e8d5308d4e7, options);
}
function $ce9d9e524be20f53$export$28f2f3eaefd5deef(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$eb856e8d5308d4e7, options);
}
const $ce9d9e524be20f53$export$2c91473fa62ff46b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "FeePeriodLinkedRawTransactions"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allFeePeriods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$4b01c6b56b3fa664(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$2c91473fa62ff46b, options);
}
function $ce9d9e524be20f53$export$c493329bc54ddf45(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$2c91473fa62ff46b, options);
}
function $ce9d9e524be20f53$export$bcb3c8b15ce4d187(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$2c91473fa62ff46b, options);
}
const $ce9d9e524be20f53$export$57862cdd9be7ef37 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "FeePeriodsByAccount"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodsByAccount"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullFeePeriod"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredRawTransactions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BenefitRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullFeePeriod"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "FeePeriod"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransaction"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefits"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$97b73cd64565cbb0(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$57862cdd9be7ef37, options);
}
function $ce9d9e524be20f53$export$97358e969cc67e72(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$57862cdd9be7ef37, options);
}
function $ce9d9e524be20f53$export$c1a08a6039d6da7b(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$57862cdd9be7ef37, options);
}
const $ce9d9e524be20f53$export$971d6994bb1bf937 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "GenerateBenefitCredits"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "periodStartDates"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "Int"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "categoryName"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "generateBenefitCredits"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "benefitId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "benefitId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "periodStartDates"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "periodStartDates"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "payee"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "categoryName"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "categoryName"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BasicRawTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$f754234a06224569(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$971d6994bb1bf937, options);
}
const $ce9d9e524be20f53$export$901b60bca2c876ec = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "GenerateBenefitPeriods"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "years"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "generateBenefitPeriods"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "years"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "years"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$1008bbcb8498d18d(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$901b60bca2c876ec, options);
}
const $ce9d9e524be20f53$export$c19a560555e9ac9b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "GetLinkTokenForConnection"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "plaidAccessTokenId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "products"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "getLinkTokenForConnection"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "plaidAccessTokenId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaidAccessTokenId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "products"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "products"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$19671fa43eafe14e(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$c19a560555e9ac9b, options);
}
const $ce9d9e524be20f53$export$7a860db0d50e6d46 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "InboxBacklogSummary"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "inboxBacklogSummary"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "frontierDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "recentCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "backlogCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "backlogOldestDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "backlogNewestDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "processedCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "years"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "year"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "unallocated"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "total"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$edf7816f5074c300(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$7a860db0d50e6d46, options);
}
function $ce9d9e524be20f53$export$3b64cb534cdaad24(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$7a860db0d50e6d46, options);
}
function $ce9d9e524be20f53$export$7ee9a75d67244a62(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$7a860db0d50e6d46, options);
}
const $ce9d9e524be20f53$export$b6a94fae4a131594 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "InvestmentAccount"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "investmentAccount"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "InvestmentAccountFragment"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "InvestmentAccountFragment"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "InvestmentAccount"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "presentBalance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "investmentType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "closingAnchorId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastSyncedAt"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaid"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionName"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "snapshotCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "performance"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalValue"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "costBasis"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalGain"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "xirr"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$b9614cb2f3723202(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$b6a94fae4a131594, options);
}
function $ce9d9e524be20f53$export$8cbd5906f3b3ee9f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$b6a94fae4a131594, options);
}
function $ce9d9e524be20f53$export$845496de602dae8a(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$b6a94fae4a131594, options);
}
const $ce9d9e524be20f53$export$ee6ce295e128f0c4 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "InvestmentHoldings"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "investmentHoldings"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cash"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "securityId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "security"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "SecurityFields"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "taxTreatment"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "asOf"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "quantity"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "costBasis"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "priceDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unrealized"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "SecurityFields"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Security"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "ticker"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cusip"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isin"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "securityType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isCash"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "treatAsCash"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "identityKey"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$ead319b6397ec50e(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$ee6ce295e128f0c4, options);
}
function $ce9d9e524be20f53$export$df50d6b1e6c4e426(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$ee6ce295e128f0c4, options);
}
function $ce9d9e524be20f53$export$fec90524d99be6ba(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$ee6ce295e128f0c4, options);
}
const $ce9d9e524be20f53$export$b0eca4e518180dd4 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "InvestmentPeriods"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "from"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "to"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "investmentPeriods"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "from"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "from"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "to"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "to"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "issuerName"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "taxTreatment"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "from"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "to"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceChange"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "saved"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "income"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fees"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "marketChange"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "realized"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "realizedUnknown"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unrealizedChange"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unclassified"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unclassifiedSecurities"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "residualChange"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "exact"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cashGap"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "quantityGaps"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "securityId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "quantity"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "label"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "writtenOff"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$883d962555a42fa1(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$b0eca4e518180dd4, options);
}
function $ce9d9e524be20f53$export$3cc1177216c01374(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$b0eca4e518180dd4, options);
}
function $ce9d9e524be20f53$export$d0406d3b47d6fc7d(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$b0eca4e518180dd4, options);
}
const $ce9d9e524be20f53$export$e99b182eaa5c9436 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "InvestmentGaps"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "investmentGaps"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "securityId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "since"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "after"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balancedThrough"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "day"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "history"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "day"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "quantity"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cash"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "status"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "securityLabel"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "pairedSecurityId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "suggestion"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "kind"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "securityId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "quantity"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "cash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "confident"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "evidence"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subtype"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "undoAdjustmentId"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$2d57afd40a6482f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$e99b182eaa5c9436, options);
}
function $ce9d9e524be20f53$export$a813f76e5e38a6b(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$e99b182eaa5c9436, options);
}
function $ce9d9e524be20f53$export$256235e1422741ab(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$e99b182eaa5c9436, options);
}
const $ce9d9e524be20f53$export$ceb15ea4f6fb5350 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "InvestmentActivity"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "from"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "to"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "byPosting"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "investmentActivity"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "from"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "from"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "to"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "to"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "byPosting"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "byPosting"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "securityId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tradeDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subtype"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "quantity"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fees"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "taxTreatment"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "effect"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "quantity"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "cash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "saved"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "income"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "fees"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "inKind"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "foreign"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "unvalued"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "cashUnknown"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "foreignCash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "cancelled"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$c310ea9dc61709c1(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$ceb15ea4f6fb5350, options);
}
function $ce9d9e524be20f53$export$6f4ba897e162272c(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$ceb15ea4f6fb5350, options);
}
function $ce9d9e524be20f53$export$dc97815afc4597ac(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$ceb15ea4f6fb5350, options);
}
const $ce9d9e524be20f53$export$6e3d7c0fb6a3c48d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "InvestmentAdjustments"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "investmentAdjustments"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "InvestmentAdjustmentFields"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "InvestmentAdjustmentFields"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "InvestmentAdjustment"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "kind"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "securityId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "securityLabel"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "quantity"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cash"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$63f8c5540b7f5b5d(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$6e3d7c0fb6a3c48d, options);
}
function $ce9d9e524be20f53$export$ad63da9992424d76(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$6e3d7c0fb6a3c48d, options);
}
function $ce9d9e524be20f53$export$83b39ae8f7e5cddb(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$6e3d7c0fb6a3c48d, options);
}
const $ce9d9e524be20f53$export$fadde859ad4236cb = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateInvestmentAdjustment"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "kind"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "securityId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "quantity"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "cash"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "gapSince"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "gapDay"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createInvestmentAdjustment"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "kind"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "kind"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "securityId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "securityId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "quantity"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "quantity"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "cash"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cash"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "gapSince"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gapSince"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "gapDay"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gapDay"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "InvestmentAdjustmentFields"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "InvestmentAdjustmentFields"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "InvestmentAdjustment"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "kind"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "securityId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "securityLabel"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "quantity"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cash"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$e285bb2a5fec598f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$fadde859ad4236cb, options);
}
const $ce9d9e524be20f53$export$fc2a127212736e44 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteInvestmentAdjustment"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "gapSince"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "gapDay"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deleteInvestmentAdjustment"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "adjustmentId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "adjustmentId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "gapSince"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gapSince"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "gapDay"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gapDay"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$ad50449646c4ffc3(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$fc2a127212736e44, options);
}
const $ce9d9e524be20f53$export$82faab7cd390d918 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "SetSecurityTreatAsCash"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "securityId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "treatAsCash"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Boolean"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "setSecurityTreatAsCash"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "securityId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "securityId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "treatAsCash"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "treatAsCash"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "SecurityFields"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "SecurityFields"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Security"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "ticker"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cusip"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isin"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "securityType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isCash"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "treatAsCash"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "identityKey"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$76f5b6594ca7408b(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$82faab7cd390d918, options);
}
const $ce9d9e524be20f53$export$644c00def38e7697 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "InvestmentReturnsMatrix"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "granularity"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ReturnsGranularity"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "investmentReturnsMatrix"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "granularity"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "granularity"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "periods"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "periods"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "periodKeys"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rows"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "presentValue"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "xirr"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "total"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "periodKey"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "returnPercent"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gainAmount"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "hasData"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "periods"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "periodKey"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "returnPercent"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gainAmount"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "hasData"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totals"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "presentValue"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "xirr"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "total"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "periodKey"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "returnPercent"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gainAmount"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "hasData"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "periods"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "periodKey"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "returnPercent"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gainAmount"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "hasData"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$354be1f4a2728511(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$644c00def38e7697, options);
}
function $ce9d9e524be20f53$export$dc59927e2dd1f387(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$644c00def38e7697, options);
}
function $ce9d9e524be20f53$export$d843255997a0e72b(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$644c00def38e7697, options);
}
const $ce9d9e524be20f53$export$4d5fb6a5cd42302c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "LinkBenefitToRawTransaction"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "linkBenefitToRawTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "rawTransactionId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "benefitId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "benefitId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BasicRawTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$1d5034815fcbdd74(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$4d5fb6a5cd42302c, options);
}
const $ce9d9e524be20f53$export$7eea60b8d07f9646 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "LinkPlaidAccount"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "plaidEnvironment"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "token"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "institutionId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "institutionName"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "products"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "linkPlaidAccount"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "plaidEnvironment"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaidEnvironment"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "token"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "institutionId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "institutionName"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionName"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "products"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "products"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$ec41e5b1c0d93f43(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$7eea60b8d07f9646, options);
}
const $ce9d9e524be20f53$export$dc899aa0f885add9 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "MergeTransactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transactionIds"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "JSON"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TransferType"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "mergeTransactions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "transactionIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionIds"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "properties"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "date"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "payee"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "payee"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "description"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "category"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "category"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "tags"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "tags"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "fieldValues"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "fieldValues"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "pending"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "pending"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "transferType"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transferType"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "UnifiedTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$3b0b120d5fcdcbea(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$dc899aa0f885add9, options);
}
const $ce9d9e524be20f53$export$c096663e2e6caf02 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "MigrateRawTransactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "fromAccountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "toAccountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "force"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "migrateRawTransactions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "fromAccountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fromAccountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "toAccountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "toAccountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "force"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "force"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "movedCount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$caba9bf89508cc17(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$c096663e2e6caf02, options);
}
const $ce9d9e524be20f53$export$4bfd7b2523a7b86a = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "NetWorth"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netWorth"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "asOf"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "groups"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "label"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "note"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "total"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "assets"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "liabilities"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "roles"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "total"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountCount"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unvaluedAccounts"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "value"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "history"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "total"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "assets"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "liabilities"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "roleSeries"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totals"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$77791f30fba5f4d(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$4bfd7b2523a7b86a, options);
}
function $ce9d9e524be20f53$export$9f1307a6ff53353e(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$4bfd7b2523a7b86a, options);
}
function $ce9d9e524be20f53$export$a74a991a1a8f001a(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$4bfd7b2523a7b86a, options);
}
const $ce9d9e524be20f53$export$bf666b91e0785ba = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "NetWorthInvestmentSplit"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "from"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "to"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netWorthInvestmentSplit"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "from"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "from"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "to"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "to"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "realized"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unrealized"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unclassified"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "residual"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "income"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fees"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investments"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "recordsFrom"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "recordsThrough"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unsplit"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unreconciled"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "estimated"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "byTreatment"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "taxTreatment"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "realized"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "unrealized"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "income"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$c202ce6a22e6adcd(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$bf666b91e0785ba, options);
}
function $ce9d9e524be20f53$export$e131fb8de8a6b7d9(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$bf666b91e0785ba, options);
}
function $ce9d9e524be20f53$export$b4e98d629a0e3b9d(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$bf666b91e0785ba, options);
}
const $ce9d9e524be20f53$export$28fecb41df4c8603 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "PatchTransactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transactionIds"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "operations"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "TransactionPatchOp"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "patchTransactions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "transactionIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionIds"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "operations"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "operations"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "UnifiedTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$f3779a398990be49(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$28fecb41df4c8603, options);
}
const $ce9d9e524be20f53$export$67ca861fb9158cde = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "PayeeLogos"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payeeLogos"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAt"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$17f63838241c8bb7(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$67ca861fb9158cde, options);
}
function $ce9d9e524be20f53$export$c7db0c1760f2fda0(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$67ca861fb9158cde, options);
}
function $ce9d9e524be20f53$export$db1c047093c2a707(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$67ca861fb9158cde, options);
}
const $ce9d9e524be20f53$export$1a840f2472d58a23 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "PayeesWithLogos"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "assignedOnly"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payeesWithLogos"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "assignedOnly"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "assignedOnly"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$1b5dafb855b1a431(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$1a840f2472d58a23, options);
}
function $ce9d9e524be20f53$export$c726f9d2693836ae(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$1a840f2472d58a23, options);
}
function $ce9d9e524be20f53$export$628e3349298081a5(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$1a840f2472d58a23, options);
}
const $ce9d9e524be20f53$export$868d966ce74f5bf8 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "PayrollRecords"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payrollRecords"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "slipId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "employer"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gross"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "net"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "taxesWithheld"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "otherPretax"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lines"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$1d8c1b4eaf3a0f32(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$868d966ce74f5bf8, options);
}
function $ce9d9e524be20f53$export$be900fb672200743(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$868d966ce74f5bf8, options);
}
function $ce9d9e524be20f53$export$e918d3ffe710bec1(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$868d966ce74f5bf8, options);
}
const $ce9d9e524be20f53$export$111a3a1890d0227c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "PayrollSummary"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payrollSummary"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gross"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "net"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "taxesWithheld"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "otherPretax"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "count"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$e68038f01f25b5a2(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$111a3a1890d0227c, options);
}
function $ce9d9e524be20f53$export$dc0dd68729777af1(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$111a3a1890d0227c, options);
}
function $ce9d9e524be20f53$export$a2ab548d37b050a2(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$111a3a1890d0227c, options);
}
const $ce9d9e524be20f53$export$48a4b5c5df8aa1af = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "PinAnalystCard"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "question"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "card"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "JSON"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pinAnalystCard"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "question"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "question"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "card"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "card"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullAnalystCard"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullAnalystCard"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AnalystCard"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "question"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "title"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "commentary"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "chart"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createdAt"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$9853c752e055c1df(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$48a4b5c5df8aa1af, options);
}
const $ce9d9e524be20f53$export$2a0722effc80e496 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllPlaidAccessTokens"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allPlaidAccessTokens"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullPlaidAccessToken"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullPlaidAccessToken"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "PlaidAccessToken"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tokenSuffix"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "environment"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "active"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "institutionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "institutionName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "products"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accounts"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$5e3a1aad06c8e637(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$2a0722effc80e496, options);
}
function $ce9d9e524be20f53$export$47a2920c6c789dff(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$2a0722effc80e496, options);
}
function $ce9d9e524be20f53$export$f9790307ab2ab99a(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$2a0722effc80e496, options);
}
const $ce9d9e524be20f53$export$17b4900e46f8b25f = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdatePlaidAccessToken"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "active"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Boolean"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updatePlaidAccessToken"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "active"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "active"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "active"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$8019a84102a1c641(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$17b4900e46f8b25f, options);
}
const $ce9d9e524be20f53$export$641fad97c35a49a6 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeletePlaidAccessToken"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deletePlaidAccessToken"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$3e40c5d7e45f95c8(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$641fad97c35a49a6, options);
}
const $ce9d9e524be20f53$export$13751ce3a59d236c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdatePlaidAccessTokenProducts"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "products"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updatePlaidAccessToken"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "products"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "products"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "products"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$2082bb0a4062f3aa(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$13751ce3a59d236c, options);
}
const $ce9d9e524be20f53$export$7ef3f299bd8be50c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "PlaidSyncPreview"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accessTokenId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "cursor"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "fromStart"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "count"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidSyncPreview"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accessTokenId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accessTokenId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "cursor"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cursor"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "fromStart"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fromStart"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "count"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "count"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accessTokenId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedCursor"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cursorSource"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "nextCursor"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "hasMore"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "added"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "PlaidSyncPreviewTransaction"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "modified"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "PlaidSyncPreviewTransaction"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "removed"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "dbStatus"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "dbRawTransactionId"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accounts"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "plaidAccountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "mask"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "type"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subtype"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currentBalance"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currency"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "PlaidSyncPreviewTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "PlaidSyncPreviewTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pendingTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "authorizedDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "merchantName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "personalFinanceCategory"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "wouldSync"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "skipReason"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbStatus"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbRawTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbCurrency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbDescription"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dbMatches"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidJson"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$e77f84adaf5dd504(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$7ef3f299bd8be50c, options);
}
function $ce9d9e524be20f53$export$f4b3364035de1951(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$7ef3f299bd8be50c, options);
}
function $ce9d9e524be20f53$export$620226942c151c67(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$7ef3f299bd8be50c, options);
}
const $ce9d9e524be20f53$export$a962a5f3b2cbf1f9 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "PlaidUpdatesAvailable"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidUpdatesAvailable"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "recentSyncs"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "limit"
                                },
                                "value": {
                                    "kind": "IntValue",
                                    "value": "5"
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "completedAt"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$58942d93e6b347e6(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$a962a5f3b2cbf1f9, options);
}
function $ce9d9e524be20f53$export$e840da656e36df03(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$a962a5f3b2cbf1f9, options);
}
function $ce9d9e524be20f53$export$2aa99e7143dae0ec(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$a962a5f3b2cbf1f9, options);
}
const $ce9d9e524be20f53$export$3652b5e635c14470 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "PortfolioHistoryByAccount"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "resolution"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "PortfolioResolution"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "portfolioHistoryByAccount"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "resolution"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "resolution"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "points"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "portfolioValue"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "costBasis"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gain"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "observed"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$36c0441e1d5ae93(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$3652b5e635c14470, options);
}
function $ce9d9e524be20f53$export$d44d6c7c9dff3db8(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$3652b5e635c14470, options);
}
function $ce9d9e524be20f53$export$8731b25a194b6e77(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$3652b5e635c14470, options);
}
const $ce9d9e524be20f53$export$ca33ca7b1ccceebc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "PortfolioPerformanceSummary"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "asOf"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "portfolioPerformanceSummary"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "asOf"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "asOf"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "key"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gainChange"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "returnPercent"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$ab46317acd8c7e9f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$ca33ca7b1ccceebc, options);
}
function $ce9d9e524be20f53$export$905678408dd01605(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$ca33ca7b1ccceebc, options);
}
function $ce9d9e524be20f53$export$f81a92e2983322d2(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$ca33ca7b1ccceebc, options);
}
const $ce9d9e524be20f53$export$3dc80f5a47f123a1 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "PortfolioSnapshotsPage"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "limit"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "beforeCursor"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "afterCursor"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "portfolioSnapshotsPage"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "limit"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "limit"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "beforeCursor"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "beforeCursor"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "afterCursor"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "afterCursor"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "items"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "value"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "source"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "createdAt"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startCursor"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endCursor"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "hasMore"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$72facc932598e46(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$3dc80f5a47f123a1, options);
}
function $ce9d9e524be20f53$export$735a540bfe988308(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$3dc80f5a47f123a1, options);
}
function $ce9d9e524be20f53$export$7babd701836afcc(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$3dc80f5a47f123a1, options);
}
const $ce9d9e524be20f53$export$40b239e1a93b3ff = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "PortfolioXIRR"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "asOf"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "portfolioXIRR"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "asOf"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "asOf"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "annualizedReturn"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$d26ea4fc663d858b(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$40b239e1a93b3ff, options);
}
function $ce9d9e524be20f53$export$bfb0c6a24f3c9bce(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$40b239e1a93b3ff, options);
}
function $ce9d9e524be20f53$export$bf9ca6f9000e463d(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$40b239e1a93b3ff, options);
}
const $ce9d9e524be20f53$export$fd03690d37574f74 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "RawTransactionConsumerIds"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "consumers"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionId"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$b693ba864982f93b(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$fd03690d37574f74, options);
}
function $ce9d9e524be20f53$export$81d6ed435ecac6e9(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$fd03690d37574f74, options);
}
function $ce9d9e524be20f53$export$25fc3a2359a4274b(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$fd03690d37574f74, options);
}
const $ce9d9e524be20f53$export$d72550435d67e255 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "RawTransactionMigrationPreview"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "fromAccountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "toAccountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionMigrationPreview"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "fromAccountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fromAccountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "toAccountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "toAccountId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "count"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "deletedCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fromOldestDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fromNewestDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "toCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "toOldestDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "toNewestDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "overlapStartDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "overlapEndDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "blockers"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "feePeriodCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "snapshotCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timelineUnit"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timeline"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "start"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "fromCount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "toCount"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$d2508b6395c940aa(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$d72550435d67e255, options);
}
function $ce9d9e524be20f53$export$a93e57f3dcfc9c9c(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$d72550435d67e255, options);
}
function $ce9d9e524be20f53$export$c3197026f33767b(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$d72550435d67e255, options);
}
const $ce9d9e524be20f53$export$fb132f48b9ed851e = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "RawTransactionsWithConsumers"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "ids"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionsByIds"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "ids"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ids"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BasicRawTransaction"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "consumers"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transaction"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "UnifiedTransaction"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$3df9816e98d6b2cc(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$fb132f48b9ed851e, options);
}
function $ce9d9e524be20f53$export$4aec44fa9e2d4714(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$fb132f48b9ed851e, options);
}
function $ce9d9e524be20f53$export$7b3752e0ce1c14e1(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$fb132f48b9ed851e, options);
}
const $ce9d9e524be20f53$export$43360f97201593be = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "RecentSyncs"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "limit"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "recentSyncs"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "limit"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "limit"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "completedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "durationMs"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "status"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tokensProcessed"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tokensSucceeded"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tokensFailed"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionsCreated"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountsUpdated"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "results"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "tokenId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "status"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionsCreated"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "error"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "needsRelink"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$60773f2c3f6c88b3(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$43360f97201593be, options);
}
function $ce9d9e524be20f53$export$4e3cad36ada4017f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$43360f97201593be, options);
}
function $ce9d9e524be20f53$export$d7a742b4527361ab(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$43360f97201593be, options);
}
const $ce9d9e524be20f53$export$791d542a9f1cf636 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "ReconcileBalanceAnchor"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "anchorId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionIds"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconcileBalanceAnchor"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "anchorId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "anchorId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "rawTransactionIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionIds"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliation"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "baselineAnchorId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "startDate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "endDate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "reconciledAt"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rawTransactionIds"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$16d26a75ed907543(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$791d542a9f1cf636, options);
}
const $ce9d9e524be20f53$export$bbc13b3736b37ea8 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ReconciliationCoverage"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliationCoverage"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "spans"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "startDate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "endDate"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "pendingAnchorDates"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unreconciledCount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$8b40ef46f4966285(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$bbc13b3736b37ea8, options);
}
function $ce9d9e524be20f53$export$f09f80403f3e8ee2(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$bbc13b3736b37ea8, options);
}
function $ce9d9e524be20f53$export$a094881011214305(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$bbc13b3736b37ea8, options);
}
const $ce9d9e524be20f53$export$d0c081ad5359fcd3 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ReconciliationDailyBalances"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "anchorId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balanceAnchor"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "anchorId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "anchorId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliation"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "dailyBalances"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "date"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "balance"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$cfecf2625be5c16f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$d0c081ad5359fcd3, options);
}
function $ce9d9e524be20f53$export$68d43b47a45d4211(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$d0c081ad5359fcd3, options);
}
function $ce9d9e524be20f53$export$8cb66662ee40e4ce(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$d0c081ad5359fcd3, options);
}
const $ce9d9e524be20f53$export$ea020ef882a94909 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ReconciliationRawTransactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "anchorId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balanceAnchor"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "anchorId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "anchorId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliation"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rawTransactions"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "BasicRawTransaction"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$61845bc4eb54f5b0(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$ea020ef882a94909, options);
}
function $ce9d9e524be20f53$export$a50679970de28296(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$ea020ef882a94909, options);
}
function $ce9d9e524be20f53$export$9569ece8f77cb87d(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$ea020ef882a94909, options);
}
const $ce9d9e524be20f53$export$dee947ddbe9e383b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "RecordBalanceAnchor"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "balance"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Float"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "source"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "recordBalanceAnchor"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "balance"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "source"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAt"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$3a0b388d2d812ec5(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$dee947ddbe9e383b, options);
}
const $ce9d9e524be20f53$export$c3b8d9fb24089bf5 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "RecordBenefitCredit"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "recordBenefitCredit"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "benefitId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "benefitId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "amount"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BasicRawTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$2a9fd5e50f70d62f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$c3b8d9fb24089bf5, options);
}
const $ce9d9e524be20f53$export$5f4bada7a8cf5541 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "RemoveFieldValue"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "fieldId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "value"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "force"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "removeFieldValue"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "fieldId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fieldId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "value"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "force"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "force"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullField"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullField"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Field"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "values"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allowMultiple"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$9adfbf425d61c49b(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$5f4bada7a8cf5541, options);
}
const $ce9d9e524be20f53$export$1160f9ff8a70b2f4 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "RenameFieldValue"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "fieldId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "oldValue"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "newValue"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "renameFieldValue"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "fieldId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fieldId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "oldValue"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "oldValue"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "newValue"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "newValue"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullField"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullField"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Field"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "values"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allowMultiple"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$56b79aeffb5131b4(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$1160f9ff8a70b2f4, options);
}
const $ce9d9e524be20f53$export$5aec791438878189 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "ReorderAccountTypes"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "typeKeys"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reorderAccountTypes"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "typeKeys"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "typeKeys"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$3f4718b52420ac4f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$5aec791438878189, options);
}
const $ce9d9e524be20f53$export$da5e3aed71c44232 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "ReorderAccounts"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accounts"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reorderAccounts"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accounts"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accounts"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$692d0e7c834b29a4(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$da5e3aed71c44232, options);
}
const $ce9d9e524be20f53$export$8910750b654ff23a = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "ReorderCategoryGroups"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "groups"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "CategoryGroupOrderInput"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reorderCategoryGroups"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "groups"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "groups"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategoryGroup"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategoryGroup"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CategoryGroup"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "categoryIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$6b955fa2a90548cf(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$8910750b654ff23a, options);
}
const $ce9d9e524be20f53$export$db23f67c0febaad1 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "ReorderStarredAccounts"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reorderStarredAccounts"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountIds"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$5ed95d73adb82be9(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$db23f67c0febaad1, options);
}
const $ce9d9e524be20f53$export$76b45ad9f853c81f = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "ResetRawTransaction"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "resetRawTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "rawTransactionId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BasicRawTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$6d9c901034bee97f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$76b45ad9f853c81f, options);
}
const $ce9d9e524be20f53$export$496cb29f911ae157 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "ResetTransaction"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "resetTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$8edbdb11cd48f91f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$496cb29f911ae157, options);
}
const $ce9d9e524be20f53$export$80f1a52301acd404 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "RetrieveRawTransaction"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullRawTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": {
                            "kind": "Name",
                            "value": "BasicRawTransaction"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidData"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionData"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "ezpassData"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumers"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transaction"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "UnifiedTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$920ac3c36ab45eb9(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$80f1a52301acd404, options);
}
function $ce9d9e524be20f53$export$b8ba724becffcf6f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$80f1a52301acd404, options);
}
function $ce9d9e524be20f53$export$575617473d97ddc(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$80f1a52301acd404, options);
}
const $ce9d9e524be20f53$export$36d4af02304fe163 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "RetrieveRawTransactionReconciliation"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliation"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "reconciliationId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "reconciledAt"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$a770892053c40fd9(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$36d4af02304fe163, options);
}
function $ce9d9e524be20f53$export$d0fc440bbc117a62(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$36d4af02304fe163, options);
}
function $ce9d9e524be20f53$export$d61972193d40e431(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$36d4af02304fe163, options);
}
const $ce9d9e524be20f53$export$d6241934fb3760ad = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "SetAccountClosingAnchor"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "anchorId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "setAccountClosingAnchor"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "anchorId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "anchorId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "AccountListItem"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AccountListItem"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$2c19470a6f45d0b2(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$d6241934fb3760ad, options);
}
const $ce9d9e524be20f53$export$a89b2a4eed309f7 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "SetAccountOpeningAnchor"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "anchorId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "setAccountOpeningAnchor"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "anchorId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "anchorId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$ab9ffb3bbc50f2da(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$a89b2a4eed309f7, options);
}
const $ce9d9e524be20f53$export$6d9ca585f68c77ec = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "SetAccountStarred"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "starred"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Boolean"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "setAccountStarred"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "accountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "starred"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "starred"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$198b10a9120605da(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$6d9ca585f68c77ec, options);
}
const $ce9d9e524be20f53$export$4e63f5f11a48fa42 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "SetBenefitOnRawTransactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "ids"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "setBenefitOnRawTransactions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "ids"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ids"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "benefit"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "benefit"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BasicRawTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$55bd5587b7471132(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$4e63f5f11a48fa42, options);
}
const $ce9d9e524be20f53$export$188828dbfa79cc4c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "SetBinding"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "key"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "entityId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "setBinding"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "key"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "key"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "entityId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "entityId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "key"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "entityId"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$cd4833426b480f1a(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$188828dbfa79cc4c, options);
}
const $ce9d9e524be20f53$export$a9339c28590706db = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "SetCategoryGroup"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "categoryId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "groupId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "setCategoryGroup"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "categoryId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "categoryId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "groupId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "groupId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategoryGroup"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategoryGroup"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CategoryGroup"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "categoryIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$2b522cad18185c8(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$a9339c28590706db, options);
}
const $ce9d9e524be20f53$export$90fae55f7961e98e = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "SetPayeeLogo"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "setPayeeLogo"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "payee"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "logo"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAt"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$6d35ada5387177c2(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$90fae55f7961e98e, options);
}
const $ce9d9e524be20f53$export$7f33c65cbe444f7e = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "SplitRawTransactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionIds"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "splits"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "SplitInput"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "splitRawTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "rawTransactionIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionIds"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "splits"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "splits"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "UnifiedTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$2362b77adec85bb(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$7f33c65cbe444f7e, options);
}
const $ce9d9e524be20f53$export$7515a9fdedea4c20 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "StarredAccountIds"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "starredAccountIds"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$7b126d375cf15981(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$7515a9fdedea4c20, options);
}
function $ce9d9e524be20f53$export$a2be6b88d212f858(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$7515a9fdedea4c20, options);
}
function $ce9d9e524be20f53$export$2333b96fadccc62c(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$7515a9fdedea4c20, options);
}
const $ce9d9e524be20f53$export$86075784d192ffd6 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "SuggestCategorizations"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionIds"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "suggestCategorizations"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "rawTransactionIds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionIds"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "categoryName"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "confidence"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "matchMethod"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "matchCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payeeMatchCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalCount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$5e3cc446f2bf8ebc(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$86075784d192ffd6, options);
}
function $ce9d9e524be20f53$export$42f090d018cc2ca0(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$86075784d192ffd6, options);
}
function $ce9d9e524be20f53$export$68bd044cd6ce5820(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$86075784d192ffd6, options);
}
const $ce9d9e524be20f53$export$a2747f9a5abffbe8 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "TaxYearReport"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "taxYearReport"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fieldBound"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rows"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "year"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "paid"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "refunded"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unattributedCount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$6fcc7ed8f7135ba3(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$a2747f9a5abffbe8, options);
}
function $ce9d9e524be20f53$export$11a4f0f2e630ac01(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$a2747f9a5abffbe8, options);
}
function $ce9d9e524be20f53$export$e338046b600aa3eb(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$a2747f9a5abffbe8, options);
}
const $ce9d9e524be20f53$export$2ddc8274ad76796d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "TrackedBalances"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "trackedBalances"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastActivityDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "latestAnchorDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "account"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currency"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "closingAnchorId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "trackBalance"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$90b1a46cc327be66(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$2ddc8274ad76796d, options);
}
function $ce9d9e524be20f53$export$c9e805ae93fa9e12(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$2ddc8274ad76796d, options);
}
function $ce9d9e524be20f53$export$b6a8ce9c2235179f(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$2ddc8274ad76796d, options);
}
const $ce9d9e524be20f53$export$d8b473d5c677b29c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "TransactionById"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionById"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "DetailTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "DetailTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": {
                            "kind": "Name",
                            "value": "UnifiedTransaction"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "basisDraws"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lotTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "units"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lotTransaction"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransaction"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BasicRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$27549920c2be446e(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$d8b473d5c677b29c, options);
}
function $ce9d9e524be20f53$export$7b47b9a4f467b0c(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$d8b473d5c677b29c, options);
}
function $ce9d9e524be20f53$export$ecfa6184926b7d3a(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$d8b473d5c677b29c, options);
}
const $ce9d9e524be20f53$export$7a168c8e111ca3b2 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "Transactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "limit"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transferTypes"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "TransferType"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "excludeTransferTypes"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "TransferType"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "netAmountFilter"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "NetAmountFilter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "kinds"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "TransactionKind"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "categories"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "search"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "beforeCursor"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "fieldFilters"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "FieldFilterInput"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "minAmount"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "maxAmount"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "limit"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "limit"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "transferTypes"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transferTypes"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "excludeTransferTypes"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "excludeTransferTypes"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "netAmountFilter"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "netAmountFilter"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "kinds"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "kinds"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "categories"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "categories"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "tags"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tags"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "search"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "search"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "beforeCursor"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "beforeCursor"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "fieldFilters"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fieldFilters"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "pending"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "pending"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "currency"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "minAmount"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "minAmount"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "maxAmount"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "maxAmount"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "items"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "UnifiedTransaction"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startCursor"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endCursor"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "hasMore"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$c16de15367a0de91(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$7a168c8e111ca3b2, options);
}
function $ce9d9e524be20f53$export$ef9441937bc56420(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$7a168c8e111ca3b2, options);
}
function $ce9d9e524be20f53$export$a4af327031441032(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$7a168c8e111ca3b2, options);
}
const $ce9d9e524be20f53$export$f69d70c20f55e2d3 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "TransactionsNeedingBasis"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "limit"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "needsBasis"
                                },
                                "value": {
                                    "kind": "BooleanValue",
                                    "value": true
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "limit"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "limit"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "items"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "UnifiedTransaction"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "hasMore"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$2390a609b2cd0982(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$f69d70c20f55e2d3, options);
}
function $ce9d9e524be20f53$export$6aa39e1e1856ebb3(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$f69d70c20f55e2d3, options);
}
function $ce9d9e524be20f53$export$421b44036793f041(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$f69d70c20f55e2d3, options);
}
const $ce9d9e524be20f53$export$1fc28848f1baaa0c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UnlinkBenefitFromRawTransaction"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "unlinkBenefitFromRawTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "rawTransactionId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BasicRawTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$40c676965d981712(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$1fc28848f1baaa0c, options);
}
const $ce9d9e524be20f53$export$da2c01170d30c82a = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UnpinAnalystCard"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "unpinAnalystCard"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$ab389ddab2f96c84(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$da2c01170d30c82a, options);
}
const $ce9d9e524be20f53$export$cd3f83b43415ec72 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "UpcomingBenefitCredits"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "upcomingBenefitCredits"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "benefitId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "benefitName"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "creditAccountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "creditAccountName"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$6a6218148cb41524(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($ce9d9e524be20f53$export$cd3f83b43415ec72, options);
}
function $ce9d9e524be20f53$export$cec28f0b756cf43b(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($ce9d9e524be20f53$export$cd3f83b43415ec72, options);
}
function $ce9d9e524be20f53$export$53493cfe9e4d9fd3(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($ce9d9e524be20f53$export$cd3f83b43415ec72, options);
}
const $ce9d9e524be20f53$export$ceda7c5d5ae5c33 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateBalanceAnchor"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "anchorId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "balance"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "note"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateBalanceAnchor"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "anchorId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "anchorId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "balance"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "note"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "source"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAt"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$2a466906a4d7f6d8(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$ceda7c5d5ae5c33, options);
}
const $ce9d9e524be20f53$export$7bfbe843d7b24ad2 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateCardBenefit"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "cadence"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "BenefitCadence"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "amountPerPeriod"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "calendarAligned"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "BenefitPeriodInput"
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateCardBenefit"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "category"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "category"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "cadence"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cadence"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "amountPerPeriod"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amountPerPeriod"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "calendarAligned"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "calendarAligned"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "creditAccountId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "creditAccountId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "periods"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "periods"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredRawTransactions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BenefitRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$5dc743b5f02bd9da(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$7bfbe843d7b24ad2, options);
}
const $ce9d9e524be20f53$export$d216fbad2d4d64ac = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateCategory"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateCategory"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "category"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "icon"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "icon"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "color"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "color"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$8e85b26ab949ed92(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$d216fbad2d4d64ac, options);
}
const $ce9d9e524be20f53$export$384ff4946a2b9845 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateCategoryGroup"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateCategoryGroup"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "color"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "color"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategoryGroup"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategoryGroup"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CategoryGroup"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "categoryIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$443797c541be6504(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$384ff4946a2b9845, options);
}
const $ce9d9e524be20f53$export$93133a4bb03cc76 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateDepositoryAccount"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "depositoryType"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryType"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "trackBalance"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateDepositoryAccount"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "depositoryType"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "logo"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "cardProduct"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "trackBalance"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "DepositoryAccountFragment"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "DepositoryAccountFragment"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "DepositoryAccount"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeBalance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balanceStaleSince"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "depositoryType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "closingAnchorId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "trackBalance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaid"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionName"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$70c15c7fb508a6a0(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$93133a4bb03cc76, options);
}
const $ce9d9e524be20f53$export$4e977e1dd8f48444 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateFeePeriod"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateFeePeriod"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "rawTransactionId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "startDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "endDate"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "amount"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "payee"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payee"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "cardProduct"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullFeePeriod"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BenefitRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCardBenefit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CardBenefit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "feePeriodId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "creditAccount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "__typename"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DepositoryAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "depositoryType"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "InvestmentAccount"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logo"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "uncoveredRawTransactions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "periods"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "endDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "usedAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "remainingAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactions"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "BenefitRawTransaction"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullFeePeriod"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "FeePeriod"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rawTransaction"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BenefitRawTransaction"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "startDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "endDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cardProduct"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefits"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCardBenefit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$c6418001d73d888f(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$4e977e1dd8f48444, options);
}
const $ce9d9e524be20f53$export$20e2ccba8ea0b099 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateField"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "allowMultiple"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "values"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "FieldValueInput"
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateField"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "allowMultiple"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "allowMultiple"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "required"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "required"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "values"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "values"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullField"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullField"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Field"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "values"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allowMultiple"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$68dc441545c63e86(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$20e2ccba8ea0b099, options);
}
const $ce9d9e524be20f53$export$758abd83e8f75a1a = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateFieldValue"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "fieldId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "value"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateFieldValue"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "fieldId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "fieldId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "value"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullField"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullField"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Field"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "values"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "allowMultiple"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$12bf8cc8fd0d0ea9(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$758abd83e8f75a1a, options);
}
const $ce9d9e524be20f53$export$a0ada81e3f1bb018 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateInvestmentAccount"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "investmentType"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentType"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateInvestmentAccount"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "investmentType"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "logo"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "InvestmentAccountFragment"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "InvestmentAccountFragment"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "InvestmentAccount"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "balance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "presentBalance"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "investmentType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "closingAnchorId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastSyncedAt"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaid"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "institutionName"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "snapshotCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "performance"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalValue"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "costBasis"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalGain"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "xirr"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$d24a759ecf66d85a(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$a0ada81e3f1bb018, options);
}
const $ce9d9e524be20f53$export$a816827dbf97cab1 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateRawTransaction"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Float"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateRawTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "account"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "account"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "amount"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BasicRawTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$bdd78803ba0ffd49(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$a816827dbf97cab1, options);
}
const $ce9d9e524be20f53$export$bdab8912fddfb2e6 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateRawTransactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "ids"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "String"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateRawTransactions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "ids"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ids"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "account"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "account"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "date"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "date"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "BasicRawTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Account"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AccountUnion"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "__typename"
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "DepositoryAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "homeBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceStaleSince"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "depositoryType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cardProduct"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trackBalance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "openingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "InvestmentAccount"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "investmentType"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "closingAnchorId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastSyncedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plaid"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "institutionName"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "BasicRawTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RawTransaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plaidInvestmentTransactionId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "venmoId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeAmountPreview"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefitId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "benefit"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "accountId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "account"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Account"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "reconciliation"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciledAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reconciliationId"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "adjustmentForAnchorId"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$a48dcf481f9e74a4(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$bdab8912fddfb2e6, options);
}
const $ce9d9e524be20f53$export$78407cbd60a6aa28 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateTransaction"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transaction"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        }
                    },
                    "type": {
                        "kind": "ListType",
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String"
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "JSON"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TransferType"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateTransaction"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "transaction"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transaction"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "properties"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "payee"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "payee"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "description"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "category"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "category"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "tags"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "tags"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "date"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "date"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "fieldValues"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "fieldValues"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "pending"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "pending"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "transferType"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transferType"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "UnifiedTransaction"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullCategory"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Category"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "icon"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "color"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullTag"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Tag"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UnifiedTransaction"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Transaction"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferType"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currency"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "date"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullCategory"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tags"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullTag"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldValues"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "netAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "homeNetAmount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "needsBasis"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "pending"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountIds"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "consumptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rawTransactionId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$b1d214c903a2f723(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$78407cbd60a6aa28, options);
}
const $ce9d9e524be20f53$export$511c7999a37cf437 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateUnit"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "singular"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "plural"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "displayDecimals"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "updateUnit"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "name"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "singular"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "singular"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "plural"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "plural"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "displayDecimals"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "displayDecimals"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "description"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "logo"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logo"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "FullUnit"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "FullUnit"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Unit"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "singular"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plural"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "displayDecimals"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "logo"
                        }
                    }
                ]
            }
        }
    ]
};
function $ce9d9e524be20f53$export$1a8852189f232b76(baseOptions) {
    const options = {
        ...$ce9d9e524be20f53$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($ce9d9e524be20f53$export$511c7999a37cf437, options);
}




/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $76d71077487353ea$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 3 4 4-4 4",
            key: "1x1c3m"
        }
    ],
    [
        "path",
        {
            d: "M20 7H4",
            key: "zbl0bi"
        }
    ],
    [
        "path",
        {
            d: "m8 21-4-4 4-4",
            key: "h9nckh"
        }
    ],
    [
        "path",
        {
            d: "M4 17h16",
            key: "g4d7ey"
        }
    ]
];
const $76d71077487353ea$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-right-left", $76d71077487353ea$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6c2a827dd5c2d433$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
];
const $6c2a827dd5c2d433$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pencil", $6c2a827dd5c2d433$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $04b006b04b8c21eb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
            key: "r04s7s"
        }
    ]
];
const $04b006b04b8c21eb$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("star", $04b006b04b8c21eb$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6ac1617fbee1ebd3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43",
            key: "16m0ql"
        }
    ],
    [
        "path",
        {
            d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91",
            key: "1vt8nq"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "2",
            y2: "22",
            key: "a6p6uj"
        }
    ]
];
const $6ac1617fbee1ebd3$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("star-off", $6ac1617fbee1ebd3$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1d55a58c47e43a5b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 11v6",
            key: "nco0om"
        }
    ],
    [
        "path",
        {
            d: "M14 11v6",
            key: "outv1u"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
            key: "miytrc"
        }
    ],
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
            key: "e791ji"
        }
    ]
];
const $1d55a58c47e43a5b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trash-2", $1d55a58c47e43a5b$export$3efd853dbb351e94);


parcelRequire("acw62");


const $e597f4605156a89e$export$881343af68ecca95 = (account)=>account.closingAnchorId != null;
const $e597f4605156a89e$export$ad17ddbed40f1c23 = (account, activity)=>!$e597f4605156a89e$export$881343af68ecca95(account) && activity != null && activity.balance === 0 && activity.hasRecentActivity === false;
const $e597f4605156a89e$export$49a87e04cfe7c710 = (value)=>value === 'all' || value === 'active' || value === 'closed' || value === 'inactive' ? value : null;
const $e597f4605156a89e$export$fabe442d1eda117c = (value)=>$e597f4605156a89e$export$49a87e04cfe7c710(value) ?? 'active';
const $e597f4605156a89e$export$175da04470876f6a = (filter, account, activity)=>{
    switch(filter){
        case 'all':
            return true;
        case 'closed':
            return $e597f4605156a89e$export$881343af68ecca95(account);
        case 'inactive':
            return $e597f4605156a89e$export$ad17ddbed40f1c23(account, activity);
        case 'active':
            return !$e597f4605156a89e$export$881343af68ecca95(account) && !$e597f4605156a89e$export$ad17ddbed40f1c23(account, activity);
    }
};
// [enum value, URL slug, display label]. Slugs are explicit (not derived from
// the generated enum values, which are SCREAMING_CASE) to keep URLs readable
// and stable across codegen changes.
const $e597f4605156a89e$var$DEPOSITORY_TYPES = [
    [
        (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Checking,
        'checking',
        'Checking'
    ],
    [
        (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Savings,
        'savings',
        'Savings'
    ],
    [
        (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard,
        'credit_card',
        'Credit Card'
    ],
    [
        (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Cash,
        'cash',
        'Cash'
    ],
    [
        (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Wallet,
        'wallet',
        'Wallet'
    ],
    [
        (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Loan,
        'loan',
        'Loan'
    ],
    [
        (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Ledger,
        'ledger',
        'Ledger'
    ],
    [
        (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Other,
        'other',
        'Other'
    ]
];
const $e597f4605156a89e$var$INVESTMENT_TYPES = [
    [
        (0, $ce9d9e524be20f53$export$19445fdc19724941).Brokerage,
        'brokerage',
        'Brokerage'
    ],
    [
        (0, $ce9d9e524be20f53$export$19445fdc19724941)['401K'],
        '401k',
        '401(k)'
    ],
    [
        (0, $ce9d9e524be20f53$export$19445fdc19724941).Ira,
        'ira',
        'IRA'
    ],
    [
        (0, $ce9d9e524be20f53$export$19445fdc19724941).RothIra,
        'roth_ira',
        'Roth IRA'
    ],
    [
        (0, $ce9d9e524be20f53$export$19445fdc19724941).Hsa,
        'hsa',
        'HSA'
    ],
    [
        (0, $ce9d9e524be20f53$export$19445fdc19724941).Education,
        'education',
        '529 plan'
    ],
    [
        (0, $ce9d9e524be20f53$export$19445fdc19724941).Other,
        'other',
        'Other'
    ]
];
const $e597f4605156a89e$export$6096865e4aa58c8a = [
    ...$e597f4605156a89e$var$DEPOSITORY_TYPES.map(([type, slug, label])=>({
            key: `dep:${slug}`,
            label: label,
            group: 'Banking',
            matches: (account)=>account.__typename === 'DepositoryAccount' && account.depositoryType === type
        })),
    ...$e597f4605156a89e$var$INVESTMENT_TYPES.map(([type, slug, label])=>({
            key: `inv:${slug}`,
            label: label,
            group: 'Investments',
            matches: (account)=>account.__typename === 'InvestmentAccount' && account.investmentType === type
        }))
];
const $e597f4605156a89e$var$typeOptionByKey = new Map($e597f4605156a89e$export$6096865e4aa58c8a.map((option)=>[
        option.key,
        option
    ]));
const $e597f4605156a89e$export$2fd2effeb17443f1 = (value)=>(value ?? '').split(',').filter((key)=>$e597f4605156a89e$var$typeOptionByKey.has(key))// Dedupe while preserving order (a hand-edited URL may repeat keys)
    .filter((key, index, keys)=>keys.indexOf(key) === index);
const $e597f4605156a89e$export$e04f9e18b7296b99 = (filter)=>filter.length === 0 ? null : filter.join(',');
const $e597f4605156a89e$export$86f6532dce6b4d32 = (filter, account)=>filter.length === 0 || filter.some((key)=>$e597f4605156a89e$var$typeOptionByKey.get(key)?.matches(account) ?? false);
const $e597f4605156a89e$export$b61c24e8eaadd648 = [
    ...$e597f4605156a89e$var$DEPOSITORY_TYPES.map(([type, slug, label])=>({
            key: `dep:${slug}`,
            label: label,
            matches: (account)=>account.__typename === 'DepositoryAccount' && account.depositoryType === type
        })),
    {
        key: 'investments',
        label: 'Investments',
        matches: (account)=>account.__typename === 'InvestmentAccount'
    }
];
const $e597f4605156a89e$var$sectionByKey = new Map($e597f4605156a89e$export$b61c24e8eaadd648.map((section)=>[
        section.key,
        section
    ]));
const $e597f4605156a89e$export$9b4ce3dceeb152b6 = (persistedOrder)=>{
    const listed = persistedOrder.flatMap((key)=>{
        const section = $e597f4605156a89e$var$sectionByKey.get(key);
        return section ? [
            section
        ] : [];
    });
    const listedKeys = new Set(listed.map((section)=>section.key));
    return [
        ...listed,
        ...$e597f4605156a89e$export$b61c24e8eaadd648.filter((section)=>!listedKeys.has(section.key))
    ];
};





var $acw62 = parcelRequire("acw62");

const $28ed348052d72cb7$export$46b7e047635b952b = (store, ids)=>{
    store.writeQuery({
        query: (0, $ce9d9e524be20f53$export$7515a9fdedea4c20),
        data: {
            starredAccountIds: ids
        }
    });
};


const $9e78a066568deb1b$export$6fedb39e019288e9 = ()=>{
    const { data: data, loading: loading } = (0, $ce9d9e524be20f53$export$7b126d375cf15981)();
    const [setStarred] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$6d9ca585f68c77ec));
    const starredIds = $acw62.useMemo(()=>data?.starredAccountIds ?? [], [
        data
    ]);
    const toggleStar = (accountId)=>{
        const starred = !starredIds.includes(accountId);
        const without = starredIds.filter((id)=>id !== accountId);
        const next = starred ? [
            ...without,
            accountId
        ] : without;
        setStarred({
            variables: {
                accountId: accountId,
                starred: starred
            },
            optimisticResponse: {
                setAccountStarred: next
            },
            update: (cache, result)=>{
                const ids = result.data?.setAccountStarred;
                if (ids) (0, $28ed348052d72cb7$export$46b7e047635b952b)(cache, ids);
            }
        });
    };
    return {
        starredIds: starredIds,
        loading: loading,
        toggleStar: toggleStar
    };
};



/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7979593adeba180b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-right", $7979593adeba180b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b698d1771218a1ca$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "12",
            r: "1",
            key: "1wjl8i"
        }
    ],
    [
        "circle",
        {
            cx: "5",
            cy: "12",
            r: "1",
            key: "1pcz8c"
        }
    ]
];
const $b698d1771218a1ca$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ellipsis", $b698d1771218a1ca$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

const $09fc5346bd733ea4$var$MAX_TRAIL_LENGTH = 8;
const $09fc5346bd733ea4$var$STORAGE_KEY = 'breadcrumb-trail';
const $09fc5346bd733ea4$var$isTrailEntry = (value)=>typeof value === 'object' && value !== null && 'key' in value && typeof value.key === 'string' && 'label' in value && typeof value.label === 'string' && 'href' in value && typeof value.href === 'string';
const $09fc5346bd733ea4$export$326e9553c5420a00 = ()=>{
    try {
        window.sessionStorage.removeItem($09fc5346bd733ea4$var$STORAGE_KEY);
    } catch  {
    // Best-effort; sessionStorage may be unavailable.
    }
};
const $09fc5346bd733ea4$var$loadStoredTrail = ()=>{
    try {
        const raw = window.sessionStorage.getItem($09fc5346bd733ea4$var$STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter($09fc5346bd733ea4$var$isTrailEntry).slice(-$09fc5346bd733ea4$var$MAX_TRAIL_LENGTH);
    } catch  {
        return [];
    }
};
const $09fc5346bd733ea4$var$entriesEqual = (a, b)=>a.key === b.key && a.label === b.label && a.href === b.href && a.logo === b.logo;
const $09fc5346bd733ea4$var$trailsEqual = (a, b)=>a.length === b.length && a.every((entry, i)=>$09fc5346bd733ea4$var$entriesEqual(entry, b[i]));
const $09fc5346bd733ea4$var$BreadcrumbContext = /*#__PURE__*/ $acw62.createContext({
    trail: [],
    register: ()=>{}
});
const $09fc5346bd733ea4$export$d1cbd6d8a28c0f1 = ({ children: children })=>{
    const [trail, setTrail] = $acw62.useState($09fc5346bd733ea4$var$loadStoredTrail);
    // True until the first page registers after a full page load. The stored
    // trail is only trustworthy for that first registration when it already
    // contains the current page (refresh, or back/forward into the journey);
    // a fresh deep link to an unvisited page should seed from its fallback
    // rather than extend an unrelated stored trail.
    const isFirstRegistrationRef = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        try {
            window.sessionStorage.setItem($09fc5346bd733ea4$var$STORAGE_KEY, JSON.stringify(trail));
        } catch  {
        // Persistence is best-effort; the trail still works in memory.
        }
    }, [
        trail
    ]);
    const register = $acw62.useCallback((crumb, location)=>{
        const key = crumb.key ?? location.pathname;
        const entry = {
            key: key,
            label: crumb.label,
            href: `${location.pathname}${location.search}`,
            logo: crumb.logo ?? null
        };
        const isFirstRegistration = isFirstRegistrationRef.current;
        isFirstRegistrationRef.current = false;
        setTrail((prev)=>{
            let next;
            if (crumb.reset) next = [
                entry
            ];
            else {
                const index = prev.findIndex((e)=>e.key === key);
                if (index >= 0) // Revisiting a page already in the trail (breadcrumb click,
                // browser back, or a navigation loop): rewind to it.
                next = [
                    ...prev.slice(0, index),
                    entry
                ];
                else {
                    // A hydrated trail that doesn't contain the page we booted on is
                    // unrelated history (fresh deep link) — start from the fallback.
                    const usePrev = prev.length > 0 && !isFirstRegistration;
                    const base = usePrev ? prev : (crumb.fallback ?? []).map((item)=>({
                            key: item.href,
                            label: item.label,
                            href: item.href
                        }));
                    next = [
                        ...base,
                        entry
                    ].slice(-$09fc5346bd733ea4$var$MAX_TRAIL_LENGTH);
                }
            }
            return $09fc5346bd733ea4$var$trailsEqual(prev, next) ? prev : next;
        });
    }, []);
    const value = $acw62.useMemo(()=>({
            trail: trail,
            register: register
        }), [
        trail,
        register
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($09fc5346bd733ea4$var$BreadcrumbContext.Provider, {
        value: value,
        children: children
    });
};
const $09fc5346bd733ea4$export$942cde81de89b1ba = (crumb)=>{
    const { register: register } = $acw62.useContext($09fc5346bd733ea4$var$BreadcrumbContext);
    const location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    const crumbRef = $acw62.useRef(crumb);
    crumbRef.current = crumb;
    const serialized = crumb === null ? null : JSON.stringify(crumb);
    $acw62.useEffect(()=>{
        const current = crumbRef.current;
        if (current === null) return;
        register(current, {
            pathname: location.pathname,
            search: location.search
        });
    }, [
        serialized,
        register,
        location.pathname,
        location.search
    ]);
};
const $09fc5346bd733ea4$export$2b0682676e510409 = ()=>{
    return $acw62.useContext($09fc5346bd733ea4$var$BreadcrumbContext);
};



const $24175cbf70f85c9e$var$absurd = (input)=>{
    throw new Error("absurd");
};
var $24175cbf70f85c9e$export$2e2bcd8739ae039 = $24175cbf70f85c9e$var$absurd;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $341f959ff997aeae$export$f370f12c28dec737 = (root)=>{
    return Array.from((root || document).querySelectorAll('a[href], button:not(:disabled), input, textarea, select, details, [tabindex]:not([tabindex="-1"])'));
};


const $9feaa5924c876b6a$var$findNextFocusable = (root, element, offset)=>{
    const allFocusable = (0, $341f959ff997aeae$export$f370f12c28dec737)(root);
    const foundIndex = allFocusable.findIndex((el)=>el === element);
    const found = allFocusable[foundIndex + offset];
    return found;
};
const $9feaa5924c876b6a$var$FocusTrap = (props)=>{
    const containerRef = $acw62.useRef(null);
    const startRef = $acw62.useRef(null);
    const endRef = $acw62.useRef(null);
    const originalFocus = $acw62.useRef(null);
    const activeElement = document.activeElement;
    $acw62.useEffect(()=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        originalFocus.current = activeElement;
    }, []);
    const focusBackward = ()=>{
        if (props.behavior === 'trap') {
            const next = $9feaa5924c876b6a$var$findNextFocusable(containerRef.current, endRef.current, -1);
            next?.focus();
        } else if (props.behavior === 'continue') {
            const next = $9feaa5924c876b6a$var$findNextFocusable(document.body, originalFocus.current, -1);
            next?.focus();
            props.onFocusOutside && props.onFocusOutside();
        } else (0, $24175cbf70f85c9e$export$2e2bcd8739ae039)(props.behavior);
    };
    const focusForward = ()=>{
        if (props.behavior === 'trap') {
            const next = $9feaa5924c876b6a$var$findNextFocusable(containerRef.current, startRef.current, 1);
            next?.focus();
        } else if (props.behavior === 'continue') {
            const next = $9feaa5924c876b6a$var$findNextFocusable(document.body, originalFocus.current, 1);
            next?.focus();
            props.onFocusOutside && props.onFocusOutside();
        } else (0, $24175cbf70f85c9e$export$2e2bcd8739ae039)(props.behavior);
    };
    if (props.focusControlsRef) props.focusControlsRef.current = {
        focusForward: focusForward,
        focusBackward: focusBackward
    };
    const handleFocusStart = (e)=>{
        e.preventDefault();
        focusBackward();
    };
    const handleFocusEnd = (e)=>{
        e.preventDefault();
        focusForward();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: containerRef,
        className: "contents",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: startRef,
                tabIndex: 0,
                onFocus: handleFocusStart
            }),
            props.children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: endRef,
                tabIndex: 0,
                onFocus: handleFocusEnd
            })
        ]
    });
};
var $9feaa5924c876b6a$export$2e2bcd8739ae039 = $9feaa5924c876b6a$var$FocusTrap;





var $acw62 = parcelRequire("acw62");
/**
 * Browser-safe usage of process
 */ var $99d7f0237561b447$var$defaultEnvironment = "production";
var $99d7f0237561b447$export$a7b6bc01c63cdfc3 = $99d7f0237561b447$var$defaultEnvironment;



const $1c49e3de0f86bd12$export$f8caf8121275292d = 1 / 60 * 1000;
const $1c49e3de0f86bd12$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $1c49e3de0f86bd12$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($1c49e3de0f86bd12$var$getCurrentTime()), $1c49e3de0f86bd12$export$f8caf8121275292d);


function $56b75657d7530209$export$b995e5e85f5c8289(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData)=>{
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $741aad569b766a4c$var$maxElapsed = 40;
let $741aad569b766a4c$var$useDefaultElapsed = true;
let $741aad569b766a4c$var$runNextFrame = false;
let $741aad569b766a4c$var$isProcessing = false;
const $741aad569b766a4c$var$frame = {
    delta: 0,
    timestamp: 0
};
const $741aad569b766a4c$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $741aad569b766a4c$var$steps = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $56b75657d7530209$export$b995e5e85f5c8289)(()=>$741aad569b766a4c$var$runNextFrame = true);
    return acc;
}, {});
const $741aad569b766a4c$var$sync = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    const step = $741aad569b766a4c$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$741aad569b766a4c$var$runNextFrame) $741aad569b766a4c$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $741aad569b766a4c$export$d93e9c1fe0553512 = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $741aad569b766a4c$var$steps[key].cancel;
    return acc;
}, {});
const $741aad569b766a4c$export$cd75ccfd720a3cd4 = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$741aad569b766a4c$var$steps[key].process($741aad569b766a4c$var$frame);
    return acc;
}, {});
const $741aad569b766a4c$var$processStep = (stepId)=>$741aad569b766a4c$var$steps[stepId].process($741aad569b766a4c$var$frame);
const $741aad569b766a4c$var$processFrame = (timestamp)=>{
    $741aad569b766a4c$var$runNextFrame = false;
    $741aad569b766a4c$var$frame.delta = $741aad569b766a4c$var$useDefaultElapsed ? (0, $1c49e3de0f86bd12$export$f8caf8121275292d) : Math.max(Math.min(timestamp - $741aad569b766a4c$var$frame.timestamp, $741aad569b766a4c$var$maxElapsed), 1);
    $741aad569b766a4c$var$frame.timestamp = timestamp;
    $741aad569b766a4c$var$isProcessing = true;
    $741aad569b766a4c$var$stepsOrder.forEach($741aad569b766a4c$var$processStep);
    $741aad569b766a4c$var$isProcessing = false;
    if ($741aad569b766a4c$var$runNextFrame) {
        $741aad569b766a4c$var$useDefaultElapsed = false;
        (0, $1c49e3de0f86bd12$export$4fdea63ab5513fd5)($741aad569b766a4c$var$processFrame);
    }
};
const $741aad569b766a4c$var$startLoop = ()=>{
    $741aad569b766a4c$var$runNextFrame = true;
    $741aad569b766a4c$var$useDefaultElapsed = true;
    if (!$741aad569b766a4c$var$isProcessing) (0, $1c49e3de0f86bd12$export$4fdea63ab5513fd5)($741aad569b766a4c$var$processFrame);
};
const $741aad569b766a4c$export$7244445918e670ed = ()=>$741aad569b766a4c$var$frame;
var $741aad569b766a4c$export$2e2bcd8739ae039 = $741aad569b766a4c$var$sync;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $784730508f12f72c$export$4e09c449d6c407f7 = typeof document !== "undefined";


var $9c674755a93db746$export$700979bc83e7db82 = (0, $784730508f12f72c$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


function $c0a2e592950340df$export$80c2a3957bcb42ea() {
    var isMounted = (0, $acw62.useRef)(false);
    (0, $9c674755a93db746$export$700979bc83e7db82)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


function $0316e1262c81ebb4$export$91db9bc4f8ac944a() {
    var isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    var _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)((0, $acw62.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    var forceRender = (0, $acw62.useCallback)(function() {
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ var deferredForceRender = (0, $acw62.useCallback)(function() {
        return (0, $741aad569b766a4c$export$2e2bcd8739ae039).postRender(forceRender);
    }, [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ var $dba5d94a982c4145$export$f224e4635b6f8ce2 = (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $40f5fd83135889a9$export$fe4300aa8eebea86(init) {
    var ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $127b7aeab05cc0df$var$counter = 0;
var $127b7aeab05cc0df$var$incrementId = function() {
    return $127b7aeab05cc0df$var$counter++;
};
var $127b7aeab05cc0df$export$f680877a34711e37 = function() {
    return (0, $40f5fd83135889a9$export$fe4300aa8eebea86)($127b7aeab05cc0df$var$incrementId);
};


var $f57f9e9f321f3a7c$export$979daf65881a382a = function(_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)($f57f9e9f321f3a7c$var$newChildrenMap);
    var id = (0, $127b7aeab05cc0df$export$f680877a34711e37)();
    var context = (0, $acw62.useMemo)(function() {
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: function(childId) {
                var e_1, _a;
                presenceChildren.set(childId, true);
                try {
                    for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(presenceChildren.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var isComplete = _c.value;
                        if (!isComplete) return; // can stop searching when any is incomplete
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                onExitComplete === null || onExitComplete === void 0 || onExitComplete();
            },
            register: function(childId) {
                presenceChildren.set(childId, false);
                return function() {
                    return presenceChildren.delete(childId);
                };
            }
        };
    }, /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $acw62.useMemo)(function() {
        presenceChildren.forEach(function(_, key) {
            return presenceChildren.set(key, false);
        });
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $acw62.useEffect(function() {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
    }, [
        isPresent
    ]);
    return $acw62.createElement((0, $dba5d94a982c4145$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $f57f9e9f321f3a7c$var$newChildrenMap() {
    return new Map();
}



var $acw62 = parcelRequire("acw62");
var $4ae202aab5791dbc$export$a3579ca508007a95 = (0, $acw62.createContext)({});




var $acw62 = parcelRequire("acw62");
function $7bbbf777b15ef7cf$export$f3a192d0cbd30b96(callback) {
    return (0, $acw62.useEffect)(function() {
        return function() {
            return callback();
        };
    }, []);
}


var $06516233abcfeeff$var$getChildKey = function(child) {
    return child.key || "";
};
function $06516233abcfeeff$var$updateChildLookup(children, allChildren) {
    children.forEach(function(child) {
        var key = $06516233abcfeeff$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $06516233abcfeeff$var$onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $acw62.Children).forEach(children, function(child) {
        if ((0, $acw62.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ var $06516233abcfeeff$export$3ae376d12526dd6f = function(_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var _d = (0, $5c96a02c592fcff1$export$8d051b38c9118094)((0, $0316e1262c81ebb4$export$91db9bc4f8ac944a)(), 1), forceRender = _d[0];
    var forceRenderLayoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).forceRender;
    if (forceRenderLayoutGroup) forceRender = forceRenderLayoutGroup;
    var isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = $06516233abcfeeff$var$onlyElements(children);
    var childrenToRender = filteredChildren;
    var exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0, $acw62.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    var allChildren = (0, $acw62.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    var isInitialRender = (0, $acw62.useRef)(true);
    (0, $9c674755a93db746$export$700979bc83e7db82)(function() {
        isInitialRender.current = false;
        $06516233abcfeeff$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $7bbbf777b15ef7cf$export$f3a192d0cbd30b96)(function() {
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) return $acw62.createElement($acw62.Fragment, null, childrenToRender.map(function(child) {
        return $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout
        }, child);
    }));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(childrenToRender), false);
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map($06516233abcfeeff$var$getChildKey);
    var targetKeys = filteredChildren.map($06516233abcfeeff$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for(var i = 0; i < numPresent; i++){
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function(key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        var child = allChildren.get(key);
        if (!child) return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function() {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function(presentChild) {
                return presentChild.key === key;
            });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false) return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function(child) {
        var key = child.key;
        return exiting.has(key) ? child : $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout
        }, child);
    });
    if ((0, $99d7f0237561b447$export$a7b6bc01c63cdfc3) !== "production" && exitBeforeEnter && childrenToRender.length > 1) console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
    return $acw62.createElement($acw62.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map(function(child) {
        return (0, $acw62.cloneElement)(child);
    }));
};



// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
const $72de694199324d9d$var$portalRoot = document.getElementById('portals');
const $72de694199324d9d$var$Layer = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        children: props.children
    }), $72de694199324d9d$var$portalRoot);
};
var $72de694199324d9d$export$2e2bcd8739ae039 = $72de694199324d9d$var$Layer;



var $f8f45ddea4959097$exports = {};
"use strict";
Object.defineProperty($f8f45ddea4959097$exports, "__esModule", {
    value: true
});
$f8f45ddea4959097$exports.Option = $f8f45ddea4959097$exports.some = $f8f45ddea4959097$exports.none = void 0;
const $f8f45ddea4959097$var$defaultEquals = (a, b)=>a === b;
class $f8f45ddea4959097$var$AbstractOption {
    // Concrete
    map(f) {
        return this.isEmpty ? $f8f45ddea4959097$exports.none : (0, $f8f45ddea4959097$exports.some)(f(this.get()));
    }
    flatMap(f) {
        return this.isEmpty ? $f8f45ddea4959097$exports.none : f(this.get());
    }
    forEach(f) {
        if (this.nonEmpty) f(this.get());
    }
    getOrElse(def) {
        return this.isEmpty ? def : this.get();
    }
    getOrElseL(def) {
        return this.isEmpty ? def() : this.get();
    }
    orElse(def) {
        return this.isEmpty ? def : this;
    }
    orElseL(def) {
        return this.isEmpty ? def() : this;
    }
    filter(p) {
        return this.isEmpty || p(this.get()) ? this : $f8f45ddea4959097$exports.none;
    }
    equals(anything, equalityFn) {
        const equals = equalityFn || $f8f45ddea4959097$var$defaultEquals;
        if (anything instanceof $f8f45ddea4959097$var$AbstractOption) return this.isEmpty ? anything.isEmpty : anything.nonEmpty && equals(this.get(), anything.get());
        else return false;
    }
    inspect() {
        if (this.isEmpty) return 'None';
        else {
            const val = this.get();
            if (val instanceof $f8f45ddea4959097$var$_None || val instanceof $f8f45ddea4959097$var$_Some) return `Some(${val.inspect()})`;
            else return `Some(${JSON.stringify(val)})`;
        }
    }
}
class $f8f45ddea4959097$var$_Some extends $f8f45ddea4959097$var$AbstractOption {
    constructor(value){
        super();
        this.type = 'some';
        this.isEmpty = false;
        this.nonEmpty = true;
        this.value = value;
    }
    get() {
        return this.value;
    }
}
class $f8f45ddea4959097$var$_None extends $f8f45ddea4959097$var$AbstractOption {
    constructor(){
        super(...arguments);
        this.type = 'none';
        this.isEmpty = true;
        this.nonEmpty = false;
    }
    get() {
        throw new Error('Called None.get');
    }
}
$f8f45ddea4959097$exports.none = new $f8f45ddea4959097$var$_None();
const $f8f45ddea4959097$var$some = (value)=>new $f8f45ddea4959097$var$_Some(value);
$f8f45ddea4959097$exports.some = $f8f45ddea4959097$var$some;
const $f8f45ddea4959097$var$OptionMain = (value)=>{
    if (value === null || value === undefined) return $f8f45ddea4959097$exports.none;
    else return (0, $f8f45ddea4959097$exports.some)(value);
};
$f8f45ddea4959097$var$OptionMain.allObject = (obj)=>{
    const result = {};
    for(const key in obj)if (Object.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        if (value.nonEmpty) result[key] = value.get();
        else return $f8f45ddea4959097$exports.none;
    }
    return (0, $f8f45ddea4959097$exports.some)(result);
};
$f8f45ddea4959097$exports.Option = $f8f45ddea4959097$var$OptionMain;
$f8f45ddea4959097$exports.default = $f8f45ddea4959097$exports.Option;





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $a8d82256030e9525$var$createDefinition = function(propNames) {
    return {
        isEnabled: function(props) {
            return propNames.some(function(name) {
                return !!props[name];
            });
        }
    };
};
var $a8d82256030e9525$export$65570e08d843624d = {
    measureLayout: $a8d82256030e9525$var$createDefinition([
        "layout",
        "layoutId",
        "drag"
    ]),
    animation: $a8d82256030e9525$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView"
    ]),
    exit: $a8d82256030e9525$var$createDefinition([
        "exit"
    ]),
    drag: $a8d82256030e9525$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $a8d82256030e9525$var$createDefinition([
        "whileFocus"
    ]),
    hover: $a8d82256030e9525$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $a8d82256030e9525$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $a8d82256030e9525$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    inView: $a8d82256030e9525$var$createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ])
};
function $a8d82256030e9525$export$449561ec5703cdc8(features) {
    for(var key in features){
        if (features[key] === null) continue;
        if (key === "projectionNodeConstructor") $a8d82256030e9525$export$65570e08d843624d.projectionNodeConstructor = features[key];
        else $a8d82256030e9525$export$65570e08d843624d[key].Component = features[key];
    }
}


var $4fd1ae9b00853f6f$export$491112666e282270 = function() {};
var $4fd1ae9b00853f6f$export$f5708dca728d7177 = function() {};



var $acw62 = parcelRequire("acw62");
var $410b846e117db9e1$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});


var $73c1b54532db957d$var$featureNames = Object.keys((0, $a8d82256030e9525$export$65570e08d843624d));
var $73c1b54532db957d$var$numFeatures = $73c1b54532db957d$var$featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */ function $73c1b54532db957d$export$4a39035bacc4ed76(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171));
    if (!visualElement) return null;
    /**
     * If we're in development mode, check to make sure we're not rendering a motion component
     * as a child of LazyMotion, as this will break the file-size benefits of using it.
     */ if ((0, $99d7f0237561b447$export$a7b6bc01c63cdfc3) !== "production" && preloadedFeatures && lazyContext.strict) (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
    for(var i = 0; i < $73c1b54532db957d$var$numFeatures; i++){
        var name_1 = $73c1b54532db957d$var$featureNames[i];
        var _a = (0, $a8d82256030e9525$export$65570e08d843624d)[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */ if (isEnabled(props) && Component) features.push($acw62.createElement(Component, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            key: name_1
        }, props, {
            visualElement: visualElement
        })));
    }
    return features;
}



var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ var $3bbbde5b328b4154$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false,
    reducedMotion: "never"
});



var $acw62 = parcelRequire("acw62");
var $3ce32ada97cfc8f7$export$2285bbca2c666415 = (0, $acw62.createContext)({});
function $3ce32ada97cfc8f7$export$cd995842eb2ab956() {
    return (0, $acw62.useContext)($3ce32ada97cfc8f7$export$2285bbca2c666415).visualElement;
}



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");


// Does this device prefer reduced motion? Returns `null` server-side.
var $5332c6c3d284aaae$var$prefersReducedMotion = {
    current: null
};
var $5332c6c3d284aaae$var$hasDetected = false;
function $5332c6c3d284aaae$var$initPrefersReducedMotion() {
    $5332c6c3d284aaae$var$hasDetected = true;
    if (!(0, $784730508f12f72c$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)");
        var setReducedMotionPreferences = function() {
            return $5332c6c3d284aaae$var$prefersReducedMotion.current = motionMediaQuery_1.matches;
        };
        motionMediaQuery_1.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else $5332c6c3d284aaae$var$prefersReducedMotion.current = false;
}
/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function $5332c6c3d284aaae$export$6a42007cf1e7b6f8() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !$5332c6c3d284aaae$var$hasDetected && $5332c6c3d284aaae$var$initPrefersReducedMotion();
    var _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)((0, $acw62.useState)($5332c6c3d284aaae$var$prefersReducedMotion.current), 1), shouldReduceMotion = _a[0];
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}
function $5332c6c3d284aaae$export$ec21f7709af6bc1e() {
    var reducedMotionPreference = $5332c6c3d284aaae$export$6a42007cf1e7b6f8();
    var reducedMotion = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)).reducedMotion;
    if (reducedMotion === "never") return false;
    else if (reducedMotion === "always") return true;
    else return reducedMotionPreference;
}


function $7fb0f4644b9cc8ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    var lazyContext = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171));
    var parent = (0, $3ce32ada97cfc8f7$export$cd995842eb2ab956)();
    var presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    var shouldReduceMotion = (0, $5332c6c3d284aaae$export$ec21f7709af6bc1e)();
    var visualElementRef = (0, $acw62.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ if (!createVisualElement) createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
        blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
        shouldReduceMotion: shouldReduceMotion
    });
    var visualElement = visualElementRef.current;
    (0, $9c674755a93db746$export$700979bc83e7db82)(function() {
        visualElement === null || visualElement === void 0 || visualElement.syncRender();
    });
    (0, $acw62.useEffect)(function() {
        var _a;
        (_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.animationState) === null || _a === void 0 || _a.animateChanges();
    });
    (0, $9c674755a93db746$export$700979bc83e7db82)(function() {
        return function() {
            return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount();
        };
    }, []);
    return visualElement;
}



var $acw62 = parcelRequire("acw62");
function $d157673547c2a934$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $88efa764bb00537b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)(function(instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 || _a.call(visualState, instance));
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $d157673547c2a934$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $acw62 = parcelRequire("acw62");

/**
 * Decides if the supplied variable is an array of variant labels
 */ function $0861f93f2aa87ed8$export$562271cd22f751d(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */ function $0861f93f2aa87ed8$export$720b90e312cea233(v) {
    return typeof v === "string" || $0861f93f2aa87ed8$export$562271cd22f751d(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $0861f93f2aa87ed8$var$getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function(value, key) {
        return current[key] = value.get();
    });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $0861f93f2aa87ed8$var$getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function(value, key) {
        return velocity[key] = value.getVelocity();
    });
    return velocity;
}
function $0861f93f2aa87ed8$export$d68f140c4d9b48bc(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) currentValues = {};
    if (currentVelocity === void 0) currentVelocity = {};
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}
function $0861f93f2aa87ed8$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return $0861f93f2aa87ed8$export$d68f140c4d9b48bc(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, $0861f93f2aa87ed8$var$getCurrent(visualElement), $0861f93f2aa87ed8$var$getVelocity(visualElement));
}
function $0861f93f2aa87ed8$export$cf3a7bd331c35bf0(props) {
    var _a;
    return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || $0861f93f2aa87ed8$export$720b90e312cea233(props.initial) || $0861f93f2aa87ed8$export$720b90e312cea233(props.animate) || $0861f93f2aa87ed8$export$720b90e312cea233(props.whileHover) || $0861f93f2aa87ed8$export$720b90e312cea233(props.whileDrag) || $0861f93f2aa87ed8$export$720b90e312cea233(props.whileTap) || $0861f93f2aa87ed8$export$720b90e312cea233(props.whileFocus) || $0861f93f2aa87ed8$export$720b90e312cea233(props.exit);
}
function $0861f93f2aa87ed8$export$c0eba02279c18fea(props) {
    return Boolean($0861f93f2aa87ed8$export$cf3a7bd331c35bf0(props) || props.variants);
}


function $9e57028cf0cad086$export$12fc32fc096a04a3(props, context) {
    if ((0, $0861f93f2aa87ed8$export$cf3a7bd331c35bf0)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $0861f93f2aa87ed8$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $0861f93f2aa87ed8$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $4cb87fa0b981df8c$export$c5638d843b37a176(props) {
    var _a = (0, $9e57028cf0cad086$export$12fc32fc096a04a3)(props, (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415))), initial = _a.initial, animate = _a.animate;
    return (0, $acw62.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, [
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(initial),
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(animate)
    ]);
}
function $4cb87fa0b981df8c$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}





/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var $b29dc04080b74d0c$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};


var $050be86dbc9816d5$var$id = 1;
function $050be86dbc9816d5$export$5ed57b87c18af11a() {
    return (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(function() {
        if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated) return $050be86dbc9816d5$var$id++;
    });
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Internal, exported only for usage in Framer
 */ var $c612a166b65a9c69$export$da5f7b802957459a = (0, $acw62.createContext)({});


function $c3c3c69892b6a008$export$80ade90e64f5118b(projectionId, _a, visualElement, ProjectionNodeConstructor) {
    var _b;
    var layoutId = _a.layoutId, layout = _a.layout, drag = _a.drag, dragConstraints = _a.dragConstraints, layoutScroll = _a.layoutScroll;
    var initialPromotionConfig = (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a));
    if (!ProjectionNodeConstructor || !visualElement || (visualElement === null || visualElement === void 0 ? void 0 : visualElement.projection)) return;
    visualElement.projection = new ProjectionNodeConstructor(projectionId, visualElement.getLatestValues(), (_b = visualElement.parent) === null || _b === void 0 ? void 0 : _b.projection);
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        scheduleRender: function() {
            return visualElement.scheduleRender();
        },
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll
    });
}




var $acw62 = parcelRequire("acw62");
var $f5d17fe65e7e845e$export$a9ca437df31f9491 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(VisualElementHandler, _super);
    function VisualElementHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */ VisualElementHandler.prototype.getSnapshotBeforeUpdate = function() {
        this.updateProps();
        return null;
    };
    VisualElementHandler.prototype.componentDidUpdate = function() {};
    VisualElementHandler.prototype.updateProps = function() {
        var _a = this.props, visualElement = _a.visualElement, props = _a.props;
        if (visualElement) visualElement.setProps(props);
    };
    VisualElementHandler.prototype.render = function() {
        return this.props.children;
    };
    return VisualElementHandler;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b40dad60036091a1$export$46b7e4b9dc6110c3(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, projectionNodeConstructor = _a.projectionNodeConstructor, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && (0, $a8d82256030e9525$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        var layoutId = $b40dad60036091a1$var$useLayoutId(props);
        props = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props), {
            layoutId: layoutId
        });
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */ var config = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d));
        var features = null;
        var context = (0, $4cb87fa0b981df8c$export$c5638d843b37a176)(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */ var projectionId = config.isStatic ? undefined : (0, $050be86dbc9816d5$export$5ed57b87c18af11a)();
        /**
         *
         */ var visualState = useVisualState(props, config.isStatic);
        if (!config.isStatic && (0, $784730508f12f72c$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7fb0f4644b9cc8ad$export$dc0335d73ab0b115)(Component, visualState, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, config), props), createVisualElement);
            (0, $c3c3c69892b6a008$export$80ade90e64f5118b)(projectionId, props, context.visualElement, projectionNodeConstructor || (0, $a8d82256030e9525$export$65570e08d843624d).projectionNodeConstructor);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ features = (0, $73c1b54532db957d$export$4a39035bacc4ed76)(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $acw62.createElement((0, $f5d17fe65e7e845e$export$a9ca437df31f9491), {
            visualElement: context.visualElement,
            props: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, config), props)
        }, features, $acw62.createElement((0, $3ce32ada97cfc8f7$export$2285bbca2c666415).Provider, {
            value: context
        }, useRender(Component, props, projectionId, (0, $88efa764bb00537b$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, config.isStatic, context.visualElement)));
    }
    return (0, $acw62.forwardRef)(MotionComponent);
}
function $b40dad60036091a1$var$useLayoutId(_a) {
    var _b;
    var layoutId = _a.layoutId;
    var layoutGroupId = (_b = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95))) === null || _b === void 0 ? void 0 : _b.id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $16a09bb264d348bb$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) customMotionComponentConfig = {};
        return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}



/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $1d85745fbdd79bfa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view"
];


function $ca4ea6365adee72d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $1d85745fbdd79bfa$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $eced91e16bda42df$export$91ddd985b97788d1 = {};
function $eced91e16bda42df$export$de9e7791c71225fd(correctors) {
    Object.assign($eced91e16bda42df$export$91ddd985b97788d1, correctors);
}


/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ var $ac502869c4d3e65a$export$67cd428da31419e1 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ var $ac502869c4d3e65a$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
/**
 * Generate a list of every possible transform key.
 */ var $ac502869c4d3e65a$export$7b42a0094fb00b6e = [
    "transformPerspective",
    "x",
    "y",
    "z"
];
$ac502869c4d3e65a$var$order.forEach(function(operationKey) {
    return $ac502869c4d3e65a$export$67cd428da31419e1.forEach(function(axesKey) {
        return $ac502869c4d3e65a$export$7b42a0094fb00b6e.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ function $ac502869c4d3e65a$export$61f68472e7973485(a, b) {
    return $ac502869c4d3e65a$export$7b42a0094fb00b6e.indexOf(a) - $ac502869c4d3e65a$export$7b42a0094fb00b6e.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */ var $ac502869c4d3e65a$var$transformPropSet = new Set($ac502869c4d3e65a$export$7b42a0094fb00b6e);
function $ac502869c4d3e65a$export$15240a8a4379d8de(key) {
    return $ac502869c4d3e65a$var$transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */ var $ac502869c4d3e65a$var$transformOriginProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
function $ac502869c4d3e65a$export$91fe49ee9d172523(key) {
    return $ac502869c4d3e65a$var$transformOriginProps.has(key);
}


function $443c859766df5778$export$6d27ce8e3de1c3cf(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (0, $ac502869c4d3e65a$export$15240a8a4379d8de)(key) || (0, $ac502869c4d3e65a$export$91fe49ee9d172523)(key) || (layout || layoutId !== undefined) && (!!(0, $eced91e16bda42df$export$91ddd985b97788d1)[key] || key === "opacity");
}


var $55c3387a92452647$export$605d60a2578142d3 = function(value) {
    return Boolean(value !== null && typeof value === "object" && value.getVelocity);
};



var $1724c99b9b724858$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1724c99b9b724858$export$bdc96e0d5c8f914(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort((0, $ac502869c4d3e65a$export$61f68472e7973485));
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for(var i = 0; i < numTransformKeys; i++){
        var key = transformKeys[i];
        transformString += "".concat($1724c99b9b724858$var$translateAlias[key] || key, "(").concat(transform[key], ") ");
        if (key === "z") transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) transformString += "translateZ(0)";
    else transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */ function $1724c99b9b724858$export$22d2fbf39767d07a(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return "".concat(originX, " ").concat(originY, " ").concat(originZ);
}


/**
 * Returns true if the provided key is a CSS variable
 */ function $f9c5e88311214d2a$export$451bc42768436155(key) {
    return key.startsWith("--");
}



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $a19b1277e1098e3a$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $470374f87b8ca393$export$7d15b64cf5a3a4c4 = (min, max)=>(v)=>Math.max(Math.min(v, max), min);
const $470374f87b8ca393$export$83d2e9e3e4ee39ed = (v)=>v % 1 ? Number(v.toFixed(5)) : v;
const $470374f87b8ca393$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $470374f87b8ca393$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
const $470374f87b8ca393$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function $470374f87b8ca393$export$844ec244b1367d54(v) {
    return typeof v === 'string';
}


const $b4f6d145fa485818$export$98e628dec113755e = {
    test: (v)=>typeof v === 'number',
    parse: parseFloat,
    transform: (v)=>v
};
const $b4f6d145fa485818$export$58f0f39f63f3cf42 = Object.assign(Object.assign({}, $b4f6d145fa485818$export$98e628dec113755e), {
    transform: (0, $470374f87b8ca393$export$7d15b64cf5a3a4c4)(0, 1)
});
const $b4f6d145fa485818$export$dcdf75081b88279d = Object.assign(Object.assign({}, $b4f6d145fa485818$export$98e628dec113755e), {
    default: 1
});


const $9ad32cb76340910d$var$createUnitType = (unit)=>({
        test: (v)=>(0, $470374f87b8ca393$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(' ').length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $9ad32cb76340910d$export$41fc368e1a942b97 = $9ad32cb76340910d$var$createUnitType('deg');
const $9ad32cb76340910d$export$626336c2cd4b14de = $9ad32cb76340910d$var$createUnitType('%');
const $9ad32cb76340910d$export$91c0eda1d06bf008 = $9ad32cb76340910d$var$createUnitType('px');
const $9ad32cb76340910d$export$f91e8c45a95a32f2 = $9ad32cb76340910d$var$createUnitType('vh');
const $9ad32cb76340910d$export$aed3d7b7d206c196 = $9ad32cb76340910d$var$createUnitType('vw');
const $9ad32cb76340910d$export$44e2e1705876d7ed = Object.assign(Object.assign({}, $9ad32cb76340910d$export$626336c2cd4b14de), {
    parse: (v)=>$9ad32cb76340910d$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$9ad32cb76340910d$export$626336c2cd4b14de.transform(v * 100)
});




var $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $b4f6d145fa485818$export$98e628dec113755e)), {
    transform: Math.round
});


var $d5c56ef81d4ff9c2$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    borderTopWidth: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    borderRightWidth: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    borderRadius: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    radius: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    maxWidth: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    height: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    maxHeight: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    size: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    top: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    right: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    bottom: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    left: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    paddingTop: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    paddingRight: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    paddingBottom: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    paddingLeft: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    margin: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    marginTop: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    marginRight: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    marginBottom: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    marginLeft: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $9ad32cb76340910d$export$41fc368e1a942b97),
    rotateX: (0, $9ad32cb76340910d$export$41fc368e1a942b97),
    rotateY: (0, $9ad32cb76340910d$export$41fc368e1a942b97),
    rotateZ: (0, $9ad32cb76340910d$export$41fc368e1a942b97),
    scale: (0, $b4f6d145fa485818$export$dcdf75081b88279d),
    scaleX: (0, $b4f6d145fa485818$export$dcdf75081b88279d),
    scaleY: (0, $b4f6d145fa485818$export$dcdf75081b88279d),
    scaleZ: (0, $b4f6d145fa485818$export$dcdf75081b88279d),
    skew: (0, $9ad32cb76340910d$export$41fc368e1a942b97),
    skewX: (0, $9ad32cb76340910d$export$41fc368e1a942b97),
    skewY: (0, $9ad32cb76340910d$export$41fc368e1a942b97),
    distance: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    translateX: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    translateY: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    translateZ: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    x: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    y: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    z: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    perspective: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    transformPerspective: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    opacity: (0, $b4f6d145fa485818$export$58f0f39f63f3cf42),
    originX: (0, $9ad32cb76340910d$export$44e2e1705876d7ed),
    originY: (0, $9ad32cb76340910d$export$44e2e1705876d7ed),
    originZ: (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $b4f6d145fa485818$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $b4f6d145fa485818$export$58f0f39f63f3cf42),
    numOctaves: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e)
};


function $a883e7c624291d03$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $f9c5e88311214d2a$export$451bc42768436155)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = (0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b)[key];
        var valueAsType = (0, $a19b1277e1098e3a$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $ac502869c4d3e65a$export$15240a8a4379d8de)(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0)) transformIsNone = false;
        } else if ((0, $ac502869c4d3e65a$export$91fe49ee9d172523)(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        } else style[key] = valueAsType;
    }
    if (hasTransform) style.transform = (0, $1724c99b9b724858$export$bdc96e0d5c8f914)(state, options, transformIsNone, transformTemplate);
    else if (transformTemplate) style.transform = transformTemplate({}, "");
    else if (!latestValues.transform && style.transform) style.transform = "none";
    if (hasTransformOrigin) style.transformOrigin = (0, $1724c99b9b724858$export$22d2fbf39767d07a)(transformOrigin);
}


var $57bb451bc3d87577$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    };
};


function $81d8dfeeb8038b0d$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $55c3387a92452647$export$605d60a2578142d3)(source[key]) && !(0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $81d8dfeeb8038b0d$var$useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0, $acw62.useMemo)(function() {
        var state = (0, $57bb451bc3d87577$export$8940b483cf52eeda)();
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        var vars = state.vars, style = state.style;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, vars), style);
    }, [
        visualState
    ]);
}
function $81d8dfeeb8038b0d$export$72c85e333541e7f(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81d8dfeeb8038b0d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81d8dfeeb8038b0d$var$useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) style = props.transformValues(style);
    return style;
}
function $81d8dfeeb8038b0d$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $81d8dfeeb8038b0d$export$72c85e333541e7f(props, visualState, isStatic);
    if (Boolean(props.drag) && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $c4bee6acbf082b7d$var$validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport",
    "layoutScroll"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c4bee6acbf082b7d$export$2f9c46555243bf04(key) {
    return $c4bee6acbf082b7d$var$validMotionProps.has(key);
}


var $05db6db4ebcdf5f1$var$shouldForward = function(key) {
    return !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key);
};
function $05db6db4ebcdf5f1$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $05db6db4ebcdf5f1$var$shouldForward = function(key) {
        return key.startsWith("on") ? !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) : isValidProp(key);
    };
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $05db6db4ebcdf5f1$export$59d6962c470509a5((parcelRequire("7dGEo")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $05db6db4ebcdf5f1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props)if ($05db6db4ebcdf5f1$var$shouldForward(key) || forwardMotionProps === true && (0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || !isDom && !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    return filteredProps;
}





var $acw62 = parcelRequire("acw62");




function $2860344bf6c6c49f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $9ad32cb76340910d$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2860344bf6c6c49f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    var pxOriginX = $2860344bf6c6c49f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = $2860344bf6c6c49f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return "".concat(pxOriginX, " ").concat(pxOriginY);
}



var $f5fdba1fd96a9ba7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $f5fdba1fd96a9ba7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f5fdba1fd96a9ba7$export$311b43f666da1d82(attrs, length, spacing, offset, useDashCase) {
    if (spacing === void 0) spacing = 1;
    if (offset === void 0) offset = 0;
    if (useDashCase === void 0) useDashCase = true;
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $f5fdba1fd96a9ba7$var$dashKeys : $f5fdba1fd96a9ba7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $9ad32cb76340910d$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    var pathLength = (0, $9ad32cb76340910d$export$91c0eda1d06bf008).transform(length);
    var pathSpacing = (0, $9ad32cb76340910d$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $59f141cfaf6fcabb$export$5475d24f125d7053(state, _a, options, transformTemplate) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, // This is object creation, which we try to avoid per-frame.
    latest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "attrX",
        "attrY",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $2860344bf6c6c49f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $f5fdba1fd96a9ba7$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}




var $b7a2547211637b3c$export$41be8b43e1c4d4f9 = function() {
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $57bb451bc3d87577$export$8940b483cf52eeda)()), {
        attrs: {}
    });
};


function $268dc116ac4d3a3d$export$84309c4f53cb1bd5(props, visualState) {
    var visualProps = (0, $acw62.useMemo)(function() {
        var state = (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9)();
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, props.transformTemplate);
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, state.attrs), {
            style: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $81d8dfeeb8038b0d$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rawStyles), visualProps.style);
    }
    return visualProps;
}


function $dc80cb5954e76638$export$5d29104eefd89cc8(forwardMotionProps) {
    if (forwardMotionProps === void 0) forwardMotionProps = false;
    var useRender = function(Component, props, projectionId, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $268dc116ac4d3a3d$export$84309c4f53cb1bd5) : (0, $81d8dfeeb8038b0d$export$57be0a314572d87d);
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = (0, $05db6db4ebcdf5f1$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        var elementProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, filteredProps), visualProps), {
            ref: ref
        });
        if (projectionId) elementProps["data-projection-id"] = projectionId;
        return (0, $acw62.createElement)(Component, elementProps);
    };
    return useRender;
}


var $9dc069bda924fd3f$var$CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var $9dc069bda924fd3f$var$REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */ var $9dc069bda924fd3f$export$9fd24a634729c672 = function(str) {
    return str.replace($9dc069bda924fd3f$var$CAMEL_CASE_PATTERN, $9dc069bda924fd3f$var$REPLACE_TEMPLATE).toLowerCase();
};


function $a52b6fc2f3af305f$export$1a32bf6229c258c0(element, _a, styleProp, projection) {
    var style = _a.style, vars = _a.vars;
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(var key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ var $ea3ecc5fb2887a0f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength"
]);


function $9422342e44092cf6$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(var key in renderState.attrs)element.setAttribute(!(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $a8ee53e44f8c4ac8$export$16da615486abaa45(props) {
    var style = props.style;
    var newValues = {};
    for(var key in style)if ((0, $55c3387a92452647$export$605d60a2578142d3)(style[key]) || (0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}


function $eac085b45c9e0925$export$16da615486abaa45(props) {
    var newValues = (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props);
    for(var key in props)if ((0, $55c3387a92452647$export$605d60a2578142d3)(props[key])) {
        var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}




var $acw62 = parcelRequire("acw62");
function $1e5344c7f0db9c8f$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}





var $ef59b2359a289b82$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};


var $21f654501c04362b$export$2f308ad9864b3ac9 = function(v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var $21f654501c04362b$export$5485128c47bd48bb = function(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $18cbbcef55016eac$export$fcc2206ecb6d74b(value) {
    var unwrappedValue = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $21f654501c04362b$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}



function $5c26ebcca6422185$var$makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = function(instance) {
        return onMount(props, instance, state);
    };
    return state;
}
var $5c26ebcca6422185$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
        var presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
        return isStatic ? $5c26ebcca6422185$var$makeState(config, props, context, presenceContext) : (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(function() {
            return $5c26ebcca6422185$var$makeState(config, props, context, presenceContext);
        });
    };
};
function $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for(var key in motionValues)values[key] = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = (0, $0861f93f2aa87ed8$export$cf3a7bd331c35bf0)(props);
    var isVariantNode = (0, $0861f93f2aa87ed8$export$c0eba02279c18fea)(props);
    if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : initial = context.initial;
        animate !== null && animate !== void 0 ? animate : animate = context.animate;
    }
    var initialAnimationIsBlocked = blockInitialAnimation || initial === false;
    var variantToSet = initialAnimationIsBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach(function(definition) {
            var resolved = (0, $0861f93f2aa87ed8$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            var transitionEnd = resolved.transitionEnd;
            resolved.transition;
            var target = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(var key in target){
                var valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ var index = initialAnimationIsBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(var key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}




var $fde6d634ecc7ed6c$export$44dabd3fae512e85 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $eac085b45c9e0925$export$16da615486abaa45),
        createRenderState: (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9),
        onMount: function(props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, props.transformTemplate);
            (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState);
        }
    })
};





var $dcb38e10dcfb6316$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $a8ee53e44f8c4ac8$export$16da615486abaa45),
        createRenderState: (0, $57bb451bc3d87577$export$8940b483cf52eeda)
    })
};


function $73e3a8d89278ed7b$export$732916c0e88175fb(Component, _a, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $fde6d634ecc7ed6c$export$44dabd3fae512e85) : (0, $dcb38e10dcfb6316$export$e13ea21d87ea57c8);
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $dc80cb5954e76638$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        projectionNodeConstructor: projectionNodeConstructor,
        Component: Component
    });
}


var $bc94049262afe059$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})($bc94049262afe059$export$2deb71ebd3734d23 || ($bc94049262afe059$export$2deb71ebd3734d23 = {}));



var $acw62 = parcelRequire("acw62");
function $cba4f237926ffdf7$export$b1d829ddf82884aa(target, eventName, handler, options) {
    if (options === void 0) options = {
        passive: true
    };
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler);
    };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $cba4f237926ffdf7$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $acw62.useEffect)(function() {
        var element = ref.current;
        if (handler && element) return $cba4f237926ffdf7$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}


/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $5431ad674d2aa8ad$export$cac52d7cca250a66(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Focus, true);
    };
    var onBlur = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Focus, false);
    };
    (0, $cba4f237926ffdf7$export$c1052189363cb2e0)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $cba4f237926ffdf7$export$c1052189363cb2e0)(visualElement, "blur", whileFocus ? onBlur : undefined);
}


function $c87aba2e7df5c6a6$export$764db16956f554f8(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function $c87aba2e7df5c6a6$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}





/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $23ab615c547792c0$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $23ab615c547792c0$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $23ab615c547792c0$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $23ab615c547792c0$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $23ab615c547792c0$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $23ab615c547792c0$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: (0, $c87aba2e7df5c6a6$export$c4dfce035d43d1e0)(event) ? $23ab615c547792c0$var$pointFromTouch(event, pointType) : $23ab615c547792c0$var$pointFromMouse(event, pointType)
    };
}
var $23ab615c547792c0$export$f4437ba81469b709 = function(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function(event) {
        return handler(event, $23ab615c547792c0$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $23ab615c547792c0$var$filterPrimaryPointer(listener) : listener;
};



// We check for event support via functions in case they've been mocked by a testing suite.
var $4162ff6cb212f32f$export$ed662207763ba653 = function() {
    return (0, $784730508f12f72c$export$4e09c449d6c407f7) && window.onpointerdown === null;
};
var $4162ff6cb212f32f$export$58e9cbc5718eb8c2 = function() {
    return (0, $784730508f12f72c$export$4e09c449d6c407f7) && window.ontouchstart === null;
};
var $4162ff6cb212f32f$export$1a3879af679d3ede = function() {
    return (0, $784730508f12f72c$export$4e09c449d6c407f7) && window.onmousedown === null;
};


var $a3f7c96fbe45f23e$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $a3f7c96fbe45f23e$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $a3f7c96fbe45f23e$var$getPointerEventName(name) {
    if ((0, $4162ff6cb212f32f$export$ed662207763ba653)()) return name;
    else if ((0, $4162ff6cb212f32f$export$58e9cbc5718eb8c2)()) return $a3f7c96fbe45f23e$var$touchEventNames[name];
    else if ((0, $4162ff6cb212f32f$export$1a3879af679d3ede)()) return $a3f7c96fbe45f23e$var$mouseEventNames[name];
    return name;
}
function $a3f7c96fbe45f23e$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $cba4f237926ffdf7$export$b1d829ddf82884aa)(target, $a3f7c96fbe45f23e$var$getPointerEventName(eventName), (0, $23ab615c547792c0$export$f4437ba81469b709)(handler, eventName === "pointerdown"), options);
}
function $a3f7c96fbe45f23e$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $cba4f237926ffdf7$export$c1052189363cb2e0)(ref, $a3f7c96fbe45f23e$var$getPointerEventName(eventName), handler && (0, $23ab615c547792c0$export$f4437ba81469b709)(handler, eventName === "pointerdown"), options);
}


function $df8cc4eab047d382$export$518c5fc2dcb7974b(name) {
    var lock = null;
    return function() {
        var openLock = function() {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var $df8cc4eab047d382$var$globalHorizontalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragHorizontal");
var $df8cc4eab047d382$var$globalVerticalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragVertical");
function $df8cc4eab047d382$export$2b7959ed03c1a3fe(drag) {
    var lock = false;
    if (drag === "y") lock = $df8cc4eab047d382$var$globalVerticalLock();
    else if (drag === "x") lock = $df8cc4eab047d382$var$globalHorizontalLock();
    else {
        var openHorizontal_1 = $df8cc4eab047d382$var$globalHorizontalLock();
        var openVertical_1 = $df8cc4eab047d382$var$globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) lock = function() {
            openHorizontal_1();
            openVertical_1();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1) openHorizontal_1();
            if (openVertical_1) openVertical_1();
        }
    }
    return lock;
}
function $df8cc4eab047d382$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = $df8cc4eab047d382$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


function $68f67e0924891ff4$var$createHoverEvent(visualElement, isActive, callback) {
    return function(event, info) {
        var _a;
        if (!(0, $c87aba2e7df5c6a6$export$764db16956f554f8)(event) || (0, $df8cc4eab047d382$export$1b3dd616664938e4)()) return;
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Hover, isActive);
        callback === null || callback === void 0 || callback(event, info);
    };
}
function $68f67e0924891ff4$export$dea06860711b7ebc(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    (0, $a3f7c96fbe45f23e$export$734d04395f5243cd)(visualElement, "pointerenter", onHoverStart || whileHover ? $68f67e0924891ff4$var$createHoverEvent(visualElement, true, onHoverStart) : undefined, {
        passive: !onHoverStart
    });
    (0, $a3f7c96fbe45f23e$export$734d04395f5243cd)(visualElement, "pointerleave", onHoverEnd || whileHover ? $68f67e0924891ff4$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined, {
        passive: !onHoverEnd
    });
}



var $acw62 = parcelRequire("acw62");
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $ae5289b89bf4fd95$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $ae5289b89bf4fd95$export$e841ada32ff745b(parent, child.parentElement);
};




const $bcf7a994d3c628d6$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $bcf7a994d3c628d6$export$a4627e546088548d = (...transformers)=>transformers.reduce($bcf7a994d3c628d6$var$combineFunctions);




/**
 * @param handlers -
 * @internal
 */ function $3f9742550fb7ca4c$export$16dee6ef8c34532(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0, $acw62.useRef)(false);
    var cancelPointerEndListeners = (0, $acw62.useRef)(null);
    /**
     * Only set listener to passive if there are no external listeners.
     */ var eventOptions = {
        passive: !(onTapStart || onTap || onTapCancel || onPointerDown)
    };
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 || _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Tap, false);
        return !(0, $df8cc4eab047d382$export$1b3dd616664938e4)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $ae5289b89bf4fd95$export$e841ada32ff745b)(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info) : onTap === null || onTap === void 0 || onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $bcf7a994d3c628d6$export$a4627e546088548d)((0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(window, "pointerup", onPointerUp, eventOptions), (0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(window, "pointercancel", onPointerCancel, eventOptions));
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Tap, true);
        onTapStart === null || onTapStart === void 0 || onTapStart(event, info);
    }
    (0, $a3f7c96fbe45f23e$export$734d04395f5243cd)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined, eventOptions);
    (0, $7bbbf777b15ef7cf$export$f3a192d0cbd30b96)(removePointerEndListener);
}




var $acw62 = parcelRequire("acw62");

var $60b2a1a48da7d044$var$warned = new Set();
function $60b2a1a48da7d044$export$5b28268982f175ba(condition, message, element) {
    if (condition || $60b2a1a48da7d044$var$warned.has(message)) return;
    console.warn(message);
    if (element) console.warn(element);
    $60b2a1a48da7d044$var$warned.add(message);
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ var $577133ec08d9e334$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ var $577133ec08d9e334$var$observers = new WeakMap();
var $577133ec08d9e334$var$fireObserverCallback = function(entry) {
    var _a;
    (_a = $577133ec08d9e334$var$observerCallbacks.get(entry.target)) === null || _a === void 0 || _a(entry);
};
var $577133ec08d9e334$var$fireAllObserverCallbacks = function(entries) {
    entries.forEach($577133ec08d9e334$var$fireObserverCallback);
};
function $577133ec08d9e334$var$initIntersectionObserver(_a) {
    var root = _a.root, options = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "root"
    ]);
    var lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$577133ec08d9e334$var$observers.has(lookupRoot)) $577133ec08d9e334$var$observers.set(lookupRoot, {});
    var rootObservers = $577133ec08d9e334$var$observers.get(lookupRoot);
    var key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($577133ec08d9e334$var$fireAllObserverCallbacks, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        root: root
    }, options));
    return rootObservers[key];
}
function $577133ec08d9e334$export$b2bcd62fb7925aa5(element, options, callback) {
    var rootInteresectionObserver = $577133ec08d9e334$var$initIntersectionObserver(options);
    $577133ec08d9e334$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return function() {
        $577133ec08d9e334$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


function $554007e400b24229$export$297ec8eb77d6211d(_a) {
    var visualElement = _a.visualElement, whileInView = _a.whileInView, onViewportEnter = _a.onViewportEnter, onViewportLeave = _a.onViewportLeave, _b = _a.viewport, viewport = _b === void 0 ? {} : _b;
    var state = (0, $acw62.useRef)({
        hasEnteredView: false,
        isInView: false
    });
    var shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView) shouldObserve = false;
    var useObserver = typeof IntersectionObserver === "undefined" ? $554007e400b24229$var$useMissingIntersectionObserver : $554007e400b24229$var$useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
var $554007e400b24229$var$thresholdNames = {
    some: 0,
    all: 1
};
function $554007e400b24229$var$useIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var root = _a.root, rootMargin = _a.margin, _b = _a.amount, amount = _b === void 0 ? "some" : _b, once = _a.once;
    (0, $acw62.useEffect)(function() {
        if (!shouldObserve) return;
        var options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $554007e400b24229$var$thresholdNames[amount]
        };
        var intersectionCallback = function(entry) {
            var _a;
            var isIntersecting = entry.isIntersecting;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (state.isInView === isIntersecting) return;
            state.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && state.hasEnteredView) return;
            else if (isIntersecting) state.hasEnteredView = true;
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).InView, isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ var props = visualElement.getProps();
            var callback = isIntersecting ? props.onViewportEnter : props.onViewportLeave;
            callback === null || callback === void 0 || callback(entry);
        };
        return (0, $577133ec08d9e334$export$b2bcd62fb7925aa5)(visualElement.getInstance(), options, intersectionCallback);
    }, [
        shouldObserve,
        root,
        rootMargin,
        amount
    ]);
}
/**
 * If IntersectionObserver is missing, we activate inView and fire onViewportEnter
 * on mount. This way, the page will be in the state the author expects users
 * to see it in for everyone.
 */ function $554007e400b24229$var$useMissingIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var _b = _a.fallback, fallback = _b === void 0 ? true : _b;
    (0, $acw62.useEffect)(function() {
        if (!shouldObserve || !fallback) return;
        if ((0, $99d7f0237561b447$export$a7b6bc01c63cdfc3) !== "production") (0, $60b2a1a48da7d044$export$5b28268982f175ba)(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         *
         * This hook should be quite rarely called so setting this in an rAF
         * is preferred to changing the behaviour of the animation state.
         */ requestAnimationFrame(function() {
            var _a;
            state.hasEnteredView = true;
            var onViewportEnter = visualElement.getProps().onViewportEnter;
            onViewportEnter === null || onViewportEnter === void 0 || onViewportEnter(null);
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).InView, true);
        });
    }, [
        shouldObserve
    ]);
}


var $ff62e0eea2bbc1b2$export$46d1d6d046f826e4 = function(hook) {
    return function(props) {
        hook(props);
        return null;
    };
};


var $5e115984cd871deb$export$e5b72898e5a201f1 = {
    inView: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $554007e400b24229$export$297ec8eb77d6211d)),
    tap: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $3f9742550fb7ca4c$export$16dee6ef8c34532)),
    focus: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $5431ad674d2aa8ad$export$cac52d7cca250a66)),
    hover: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $68f67e0924891ff4$export$dea06860711b7ebc))
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $bc77fac60b5d77cc$export$2a8c16d82a0a0e26() {
    var context = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useId when released in React
    var id = (0, $127b7aeab05cc0df$export$f680877a34711e37)();
    (0, $acw62.useEffect)(function() {
        return register(id);
    }, []);
    var safeToRemove = function() {
        return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
    };
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $bc77fac60b5d77cc$export$8249053f690ea39a() {
    return $bc77fac60b5d77cc$export$ee27c052bca048fb((0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2)));
}
function $bc77fac60b5d77cc$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}






function $21ec58272207c53a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}







const $8fe3552f3a53f5df$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $b1fa26b3c95498fa$var$safeMin = 0.001;
const $b1fa26b3c95498fa$export$a3cdb76e84ee608e = 0.01;
const $b1fa26b3c95498fa$export$1824b851fad8862b = 10.0;
const $b1fa26b3c95498fa$export$ff08f2d53484465 = 0.05;
const $b1fa26b3c95498fa$export$201ca48e54038115 = 1;
function $b1fa26b3c95498fa$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $4fd1ae9b00853f6f$export$491112666e282270)(duration <= $b1fa26b3c95498fa$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    dampingRatio = (0, $8fe3552f3a53f5df$export$7d15b64cf5a3a4c4)($b1fa26b3c95498fa$export$ff08f2d53484465, $b1fa26b3c95498fa$export$201ca48e54038115, dampingRatio);
    duration = (0, $8fe3552f3a53f5df$export$7d15b64cf5a3a4c4)($b1fa26b3c95498fa$export$a3cdb76e84ee608e, $b1fa26b3c95498fa$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $b1fa26b3c95498fa$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $b1fa26b3c95498fa$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $b1fa26b3c95498fa$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $b1fa26b3c95498fa$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$b1fa26b3c95498fa$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $b1fa26b3c95498fa$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $b1fa26b3c95498fa$var$rootIterations = 12;
function $b1fa26b3c95498fa$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $b1fa26b3c95498fa$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $b1fa26b3c95498fa$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $2d5853cd754ec0a8$var$durationKeys = [
    "duration",
    "bounce"
];
const $2d5853cd754ec0a8$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $2d5853cd754ec0a8$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $2d5853cd754ec0a8$var$getSpringOptions(options) {
    let springOptions = Object.assign({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    if (!$2d5853cd754ec0a8$var$isSpringType(options, $2d5853cd754ec0a8$var$physicsKeys) && $2d5853cd754ec0a8$var$isSpringType(options, $2d5853cd754ec0a8$var$durationKeys)) {
        const derived = (0, $b1fa26b3c95498fa$export$b15f158dc6d6f458)(options);
        springOptions = Object.assign(Object.assign(Object.assign({}, springOptions), derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $2d5853cd754ec0a8$export$b36281d89752ae66(_a) {
    var { from: from = 0.0, to: to = 1.0, restSpeed: restSpeed = 2, restDelta: restDelta } = _a, options = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "from",
        "to",
        "restSpeed",
        "restDelta"
    ]);
    const state = {
        done: false,
        value: from
    };
    let { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $2d5853cd754ec0a8$var$getSpringOptions(options);
    let resolveSpring = $2d5853cd754ec0a8$var$zero;
    let resolveVelocity = $2d5853cd754ec0a8$var$zero;
    function createSpring() {
        const initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        const initialDelta = to - from;
        const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        if (restDelta === undefined) restDelta = Math.min(Math.abs(to - from) / 100, 0.4);
        if (dampingRatio < 1) {
            const angularFreq = (0, $b1fa26b3c95498fa$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
            };
            resolveVelocity = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq + initialDelta * Math.cos(angularFreq * t)) - envelope * (Math.cos(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq * initialDelta * Math.sin(angularFreq * t));
            };
        } else if (dampingRatio === 1) resolveSpring = (t)=>to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        else {
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
            };
        }
    }
    createSpring();
    return {
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = resolveVelocity(t) * 1000;
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: ()=>{
            velocity = -velocity;
            [from, to] = [
                to,
                from
            ];
            createSpring();
        }
    };
}
$2d5853cd754ec0a8$export$b36281d89752ae66.needsInterpolation = (a, b)=>typeof a === "string" || typeof b === "string";
const $2d5853cd754ec0a8$var$zero = (_t)=>0;


const $8719e706e42e5d1d$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


const $9e031a435715a19b$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;






const $e52c9920d7616a04$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $470374f87b8ca393$export$844ec244b1367d54)(v) && (0, $470374f87b8ca393$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $e52c9920d7616a04$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $470374f87b8ca393$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $470374f87b8ca393$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $4c712cf83c0d6669$var$clampRgbUnit = (0, $470374f87b8ca393$export$7d15b64cf5a3a4c4)(0, 255);
const $4c712cf83c0d6669$export$7a99c86b5b1f4c9e = Object.assign(Object.assign({}, (0, $b4f6d145fa485818$export$98e628dec113755e)), {
    transform: (v)=>Math.round($4c712cf83c0d6669$var$clampRgbUnit(v))
});
const $4c712cf83c0d6669$export$4e46ac54fc82cf3b = {
    test: (0, $e52c9920d7616a04$export$2c8400d58aca05e)('rgb', 'red'),
    parse: (0, $e52c9920d7616a04$export$73d6f35be992df24)('red', 'green', 'blue'),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>'rgba(' + $4c712cf83c0d6669$export$7a99c86b5b1f4c9e.transform(red) + ', ' + $4c712cf83c0d6669$export$7a99c86b5b1f4c9e.transform(green) + ', ' + $4c712cf83c0d6669$export$7a99c86b5b1f4c9e.transform(blue) + ', ' + (0, $470374f87b8ca393$export$83d2e9e3e4ee39ed)((0, $b4f6d145fa485818$export$58f0f39f63f3cf42).transform(alpha$1)) + ')'
};



function $6ec2859d7d1d6efc$var$parseHex(v) {
    let r = '';
    let g = '';
    let b = '';
    let a = '';
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $6ec2859d7d1d6efc$export$834dfc94dde4b3d8 = {
    test: (0, $e52c9920d7616a04$export$2c8400d58aca05e)('#'),
    parse: $6ec2859d7d1d6efc$var$parseHex,
    transform: (0, $4c712cf83c0d6669$export$4e46ac54fc82cf3b).transform
};





const $5c4e1dc606ae22d6$export$810b04175080204c = {
    test: (0, $e52c9920d7616a04$export$2c8400d58aca05e)('hsl', 'hue'),
    parse: (0, $e52c9920d7616a04$export$73d6f35be992df24)('hue', 'saturation', 'lightness'),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return 'hsla(' + Math.round(hue) + ', ' + (0, $9ad32cb76340910d$export$626336c2cd4b14de).transform((0, $470374f87b8ca393$export$83d2e9e3e4ee39ed)(saturation)) + ', ' + (0, $9ad32cb76340910d$export$626336c2cd4b14de).transform((0, $470374f87b8ca393$export$83d2e9e3e4ee39ed)(lightness)) + ', ' + (0, $470374f87b8ca393$export$83d2e9e3e4ee39ed)((0, $b4f6d145fa485818$export$58f0f39f63f3cf42).transform(alpha$1)) + ')';
    }
};



function $dffcb3dff20862a2$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $dffcb3dff20862a2$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $dffcb3dff20862a2$var$hueToRgb(p, q, hue + 1 / 3);
        green = $dffcb3dff20862a2$var$hueToRgb(p, q, hue);
        blue = $dffcb3dff20862a2$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}


const $fdafb3318c3fe2b0$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
const $fdafb3318c3fe2b0$var$colorTypes = [
    (0, $6ec2859d7d1d6efc$export$834dfc94dde4b3d8),
    (0, $4c712cf83c0d6669$export$4e46ac54fc82cf3b),
    (0, $5c4e1dc606ae22d6$export$810b04175080204c)
];
const $fdafb3318c3fe2b0$var$getColorType = (v)=>$fdafb3318c3fe2b0$var$colorTypes.find((type)=>type.test(v));
const $fdafb3318c3fe2b0$var$notAnimatable = (color)=>`'${color}' is not an animatable color. Use the equivalent color code instead.`;
const $fdafb3318c3fe2b0$export$51e568cf5c039bac = (from, to)=>{
    let fromColorType = $fdafb3318c3fe2b0$var$getColorType(from);
    let toColorType = $fdafb3318c3fe2b0$var$getColorType(to);
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(!!fromColorType, $fdafb3318c3fe2b0$var$notAnimatable(from));
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(!!toColorType, $fdafb3318c3fe2b0$var$notAnimatable(to));
    let fromColor = fromColorType.parse(from);
    let toColor = toColorType.parse(to);
    if (fromColorType === (0, $5c4e1dc606ae22d6$export$810b04175080204c)) {
        fromColor = (0, $dffcb3dff20862a2$export$6ae64dbcd6bfc33e)(fromColor);
        fromColorType = (0, $4c712cf83c0d6669$export$4e46ac54fc82cf3b);
    }
    if (toColorType === (0, $5c4e1dc606ae22d6$export$810b04175080204c)) {
        toColor = (0, $dffcb3dff20862a2$export$6ae64dbcd6bfc33e)(toColor);
        toColorType = (0, $4c712cf83c0d6669$export$4e46ac54fc82cf3b);
    }
    const blended = Object.assign({}, fromColor);
    return (v)=>{
        for(const key in blended)if (key !== "alpha") blended[key] = $fdafb3318c3fe2b0$export$d4ecea248cce73c(fromColor[key], toColor[key], v);
        blended.alpha = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};






const $fcbc8d85f0f592e3$export$35e9368ef982300f = {
    test: (v)=>(0, $4c712cf83c0d6669$export$4e46ac54fc82cf3b).test(v) || (0, $6ec2859d7d1d6efc$export$834dfc94dde4b3d8).test(v) || (0, $5c4e1dc606ae22d6$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $4c712cf83c0d6669$export$4e46ac54fc82cf3b).test(v)) return (0, $4c712cf83c0d6669$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $5c4e1dc606ae22d6$export$810b04175080204c).test(v)) return (0, $5c4e1dc606ae22d6$export$810b04175080204c).parse(v);
        else return (0, $6ec2859d7d1d6efc$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $470374f87b8ca393$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty('red') ? (0, $4c712cf83c0d6669$export$4e46ac54fc82cf3b).transform(v) : (0, $5c4e1dc606ae22d6$export$810b04175080204c).transform(v);
    }
};




const $fe3e8d578aa8b27f$var$colorToken = '${c}';
const $fe3e8d578aa8b27f$var$numberToken = '${n}';
function $fe3e8d578aa8b27f$var$test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && (0, $470374f87b8ca393$export$844ec244b1367d54)(v) && ((_b = (_a = v.match((0, $470374f87b8ca393$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match((0, $470374f87b8ca393$export$740b69c5fad25dba))) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function $fe3e8d578aa8b27f$var$analyse(v) {
    if (typeof v === 'number') v = `${v}`;
    const values = [];
    let numColors = 0;
    const colors = v.match((0, $470374f87b8ca393$export$740b69c5fad25dba));
    if (colors) {
        numColors = colors.length;
        v = v.replace((0, $470374f87b8ca393$export$740b69c5fad25dba), $fe3e8d578aa8b27f$var$colorToken);
        values.push(...colors.map((0, $fcbc8d85f0f592e3$export$35e9368ef982300f).parse));
    }
    const numbers = v.match((0, $470374f87b8ca393$export$2444ca58c08448e4));
    if (numbers) {
        v = v.replace((0, $470374f87b8ca393$export$2444ca58c08448e4), $fe3e8d578aa8b27f$var$numberToken);
        values.push(...numbers.map((0, $b4f6d145fa485818$export$98e628dec113755e).parse));
    }
    return {
        values: values,
        numColors: numColors,
        tokenised: v
    };
}
function $fe3e8d578aa8b27f$var$parse(v) {
    return $fe3e8d578aa8b27f$var$analyse(v).values;
}
function $fe3e8d578aa8b27f$var$createTransformer(v) {
    const { values: values, numColors: numColors, tokenised: tokenised } = $fe3e8d578aa8b27f$var$analyse(v);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? $fe3e8d578aa8b27f$var$colorToken : $fe3e8d578aa8b27f$var$numberToken, i < numColors ? (0, $fcbc8d85f0f592e3$export$35e9368ef982300f).transform(v[i]) : (0, $470374f87b8ca393$export$83d2e9e3e4ee39ed)(v[i]));
        return output;
    };
}
const $fe3e8d578aa8b27f$var$convertNumbersToZero = (v)=>typeof v === 'number' ? 0 : v;
function $fe3e8d578aa8b27f$var$getAnimatableNone(v) {
    const parsed = $fe3e8d578aa8b27f$var$parse(v);
    const transformer = $fe3e8d578aa8b27f$var$createTransformer(v);
    return transformer(parsed.map($fe3e8d578aa8b27f$var$convertNumbersToZero));
}
const $fe3e8d578aa8b27f$export$83a0e34f1302825b = {
    test: $fe3e8d578aa8b27f$var$test,
    parse: $fe3e8d578aa8b27f$var$parse,
    createTransformer: $fe3e8d578aa8b27f$var$createTransformer,
    getAnimatableNone: $fe3e8d578aa8b27f$var$getAnimatableNone
};




const $a75d904cf9cd8fdb$export$c0c148ccc4f34a76 = {
    x: 0,
    y: 0,
    z: 0
};
const $a75d904cf9cd8fdb$export$4e960b977ccfec97 = (v)=>typeof v === 'number';




function $096fbb201a57836c$var$getMixer(origin, target) {
    if ((0, $a75d904cf9cd8fdb$export$4e960b977ccfec97)(origin)) return (v)=>(0, $9e031a435715a19b$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $fcbc8d85f0f592e3$export$35e9368ef982300f).test(origin)) return (0, $fdafb3318c3fe2b0$export$51e568cf5c039bac)(origin, target);
    else return $096fbb201a57836c$export$65516310a87d8205(origin, target);
}
const $096fbb201a57836c$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$096fbb201a57836c$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $096fbb201a57836c$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = Object.assign(Object.assign({}, origin), target);
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $096fbb201a57836c$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function $096fbb201a57836c$var$analyse(value) {
    const parsed = (0, $fe3e8d578aa8b27f$export$83a0e34f1302825b).parse(value);
    const numValues = parsed.length;
    let numNumbers = 0;
    let numRGB = 0;
    let numHSL = 0;
    for(let i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed: parsed,
        numNumbers: numNumbers,
        numRGB: numRGB,
        numHSL: numHSL
    };
}
const $096fbb201a57836c$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $fe3e8d578aa8b27f$export$83a0e34f1302825b).createTransformer(target);
    const originStats = $096fbb201a57836c$var$analyse(origin);
    const targetStats = $096fbb201a57836c$var$analyse(target);
    const canInterpolate = originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $bcf7a994d3c628d6$export$a4627e546088548d)($096fbb201a57836c$export$3bbefa2f402845c4(originStats.parsed, targetStats.parsed), template);
    else {
        (0, $4fd1ae9b00853f6f$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p)=>`${p > 0 ? target : origin}`;
    }
};






const $be73afde9516fed0$var$mixNumber = (from, to)=>(p)=>(0, $9e031a435715a19b$export$2c9e8a9632a706b2)(from, to, p);
function $be73afde9516fed0$var$detectMixerFactory(v) {
    if (typeof v === 'number') return $be73afde9516fed0$var$mixNumber;
    else if (typeof v === 'string') {
        if ((0, $fcbc8d85f0f592e3$export$35e9368ef982300f).test(v)) return 0, $fdafb3318c3fe2b0$export$51e568cf5c039bac;
        else return 0, $096fbb201a57836c$export$65516310a87d8205;
    } else if (Array.isArray(v)) return 0, $096fbb201a57836c$export$3bbefa2f402845c4;
    else if (typeof v === 'object') return 0, $096fbb201a57836c$export$ebc23b6840c51ba1;
}
function $be73afde9516fed0$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $be73afde9516fed0$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $bcf7a994d3c628d6$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function $be73afde9516fed0$var$fastInterpolate([from, to], [mixer]) {
    return (v)=>mixer((0, $8719e706e42e5d1d$export$504d7abb21fa8c9)(from, to, v));
}
function $be73afde9516fed0$var$slowInterpolate(input, mixers) {
    const inputLength = input.length;
    const lastInputIndex = inputLength - 1;
    return (v)=>{
        let mixerIndex = 0;
        let foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            let i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        const progressInRange = (0, $8719e706e42e5d1d$export$504d7abb21fa8c9)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function $be73afde9516fed0$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(inputLength === output.length, 'Both input and output ranges must be the same length');
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    const mixers = $be73afde9516fed0$var$createMixers(output, ease, mixer);
    const interpolator = inputLength === 2 ? $be73afde9516fed0$var$fastInterpolate(input, mixers) : $be73afde9516fed0$var$slowInterpolate(input, mixers);
    return isClamp ? (v)=>interpolator((0, $8fe3552f3a53f5df$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}


const $2b1e2a499c7bcc27$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);
const $2b1e2a499c7bcc27$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
const $2b1e2a499c7bcc27$export$c90c8c5a3c7a5e80 = (power)=>(p)=>Math.pow(p, power);
const $2b1e2a499c7bcc27$export$2a739ba6da1d1495 = (power)=>(p)=>p * p * ((power + 1) * p - power);
const $2b1e2a499c7bcc27$export$222fa0be41d8b537 = (power)=>{
    const backEasing = $2b1e2a499c7bcc27$export$2a739ba6da1d1495(power);
    return (p)=>(p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};


const $d43a9d278bbed66c$var$DEFAULT_OVERSHOOT_STRENGTH = 1.525;
const $d43a9d278bbed66c$var$BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
const $d43a9d278bbed66c$var$BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
const $d43a9d278bbed66c$var$BOUNCE_THIRD_THRESHOLD = 0.9;
const $d43a9d278bbed66c$export$45db2fc2f15997e7 = (p)=>p;
const $d43a9d278bbed66c$export$929e5a82286172a6 = (0, $2b1e2a499c7bcc27$export$c90c8c5a3c7a5e80)(2);
const $d43a9d278bbed66c$export$57636bb43b1ccbb0 = (0, $2b1e2a499c7bcc27$export$2c07eeff45156d4d)($d43a9d278bbed66c$export$929e5a82286172a6);
const $d43a9d278bbed66c$export$c07234257a03d5e9 = (0, $2b1e2a499c7bcc27$export$f946554fb8aeaf0d)($d43a9d278bbed66c$export$929e5a82286172a6);
const $d43a9d278bbed66c$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $d43a9d278bbed66c$export$c8d67a19199d1a50 = (0, $2b1e2a499c7bcc27$export$2c07eeff45156d4d)($d43a9d278bbed66c$export$e444123e42d03385);
const $d43a9d278bbed66c$export$30d3455eee55bed5 = (0, $2b1e2a499c7bcc27$export$f946554fb8aeaf0d)($d43a9d278bbed66c$export$c8d67a19199d1a50);
const $d43a9d278bbed66c$export$b01116c84cdfe1a2 = (0, $2b1e2a499c7bcc27$export$2a739ba6da1d1495)($d43a9d278bbed66c$var$DEFAULT_OVERSHOOT_STRENGTH);
const $d43a9d278bbed66c$export$77edfce482316a60 = (0, $2b1e2a499c7bcc27$export$2c07eeff45156d4d)($d43a9d278bbed66c$export$b01116c84cdfe1a2);
const $d43a9d278bbed66c$export$ddc5fd596f6c71b2 = (0, $2b1e2a499c7bcc27$export$f946554fb8aeaf0d)($d43a9d278bbed66c$export$b01116c84cdfe1a2);
const $d43a9d278bbed66c$export$6b0af63b873d419e = (0, $2b1e2a499c7bcc27$export$222fa0be41d8b537)($d43a9d278bbed66c$var$DEFAULT_OVERSHOOT_STRENGTH);
const $d43a9d278bbed66c$var$ca = 4356.0 / 361.0;
const $d43a9d278bbed66c$var$cb = 35442.0 / 1805.0;
const $d43a9d278bbed66c$var$cc = 16061.0 / 1805.0;
const $d43a9d278bbed66c$export$cccc9e04465dce11 = (p)=>{
    if (p === 1 || p === 0) return p;
    const p2 = p * p;
    return p < $d43a9d278bbed66c$var$BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < $d43a9d278bbed66c$var$BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < $d43a9d278bbed66c$var$BOUNCE_THIRD_THRESHOLD ? $d43a9d278bbed66c$var$ca * p2 - $d43a9d278bbed66c$var$cb * p + $d43a9d278bbed66c$var$cc : 10.8 * p * p - 20.52 * p + 10.72;
};
const $d43a9d278bbed66c$export$fccebd7948554554 = (0, $2b1e2a499c7bcc27$export$2c07eeff45156d4d)($d43a9d278bbed66c$export$cccc9e04465dce11);
const $d43a9d278bbed66c$export$41ad9e9849a703ce = (p)=>p < 0.5 ? 0.5 * (1.0 - $d43a9d278bbed66c$export$cccc9e04465dce11(1.0 - p * 2.0)) : 0.5 * $d43a9d278bbed66c$export$cccc9e04465dce11(p * 2.0 - 1.0) + 0.5;


function $f140e7c3230b24ec$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $d43a9d278bbed66c$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $f140e7c3230b24ec$export$24dbcec0b26e6d9d(values) {
    const numValues = values.length;
    return values.map((_value, i)=>i !== 0 ? i / (numValues - 1) : 0);
}
function $f140e7c3230b24ec$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}
function $f140e7c3230b24ec$export$d25ddfdf17c3ad3e({ from: from = 0, to: to = 1, ease: ease, offset: offset, duration: duration = 300 }) {
    const state = {
        done: false,
        value: from
    };
    const values = Array.isArray(to) ? to : [
        from,
        to
    ];
    const times = $f140e7c3230b24ec$export$2a91b4e3a4539316(offset && offset.length === values.length ? offset : $f140e7c3230b24ec$export$24dbcec0b26e6d9d(values), duration);
    function createInterpolator() {
        return (0, $be73afde9516fed0$export$89e29e4ab65e70a9)(times, values, {
            ease: Array.isArray(ease) ? ease : $f140e7c3230b24ec$export$6b60b58e4ea7d715(values, ease)
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t)=>{
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: ()=>{
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}


function $eafa347091683871$export$e9341ba102272ab9({ velocity: velocity = 0, from: from = 0, power: power = 0.8, timeConstant: timeConstant = 350, restDelta: restDelta = 0.5, modifyTarget: modifyTarget }) {
    const state = {
        done: false,
        value: from
    };
    let amplitude = power * velocity;
    const ideal = from + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: (t)=>{
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: ()=>{}
    };
}


const $62946488586fc0f6$var$types = {
    keyframes: $f140e7c3230b24ec$export$d25ddfdf17c3ad3e,
    spring: $2d5853cd754ec0a8$export$b36281d89752ae66,
    decay: $eafa347091683871$export$e9341ba102272ab9
};
function $62946488586fc0f6$export$74df49bbebf8cb2c(config) {
    if (Array.isArray(config.to)) return 0, $f140e7c3230b24ec$export$d25ddfdf17c3ad3e;
    else if ($62946488586fc0f6$var$types[config.type]) return $62946488586fc0f6$var$types[config.type];
    const keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) return 0, $f140e7c3230b24ec$export$d25ddfdf17c3ad3e;
    else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) return 0, $2d5853cd754ec0a8$export$b36281d89752ae66;
    return 0, $f140e7c3230b24ec$export$d25ddfdf17c3ad3e;
}




function $230e5bd75deb454c$export$7d0784e050d8e25f(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function $230e5bd75deb454c$export$ab9042754680126b(elapsed, duration, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback ? $230e5bd75deb454c$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $230e5bd75deb454c$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}


const $78eae5210e62d013$var$framesync = (update)=>{
    const passTimestamp = ({ delta: delta })=>update(delta);
    return {
        start: ()=>(0, $741aad569b766a4c$export$2e2bcd8739ae039).update(passTimestamp, true),
        stop: ()=>(0, $741aad569b766a4c$export$d93e9c1fe0553512).update(passTimestamp)
    };
};
function $78eae5210e62d013$export$e3607ec2d7a891c4(_a) {
    var _b, _c;
    var { from: from, autoplay: autoplay = true, driver: driver = $78eae5210e62d013$var$framesync, elapsed: elapsed = 0, repeat: repeatMax = 0, repeatType: repeatType = "loop", repeatDelay: repeatDelay = 0, onPlay: onPlay, onStop: onStop, onComplete: onComplete, onRepeat: onRepeat, onUpdate: onUpdate } = _a, options = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "from",
        "autoplay",
        "driver",
        "elapsed",
        "repeat",
        "repeatType",
        "repeatDelay",
        "onPlay",
        "onStop",
        "onComplete",
        "onRepeat",
        "onUpdate"
    ]);
    let { to: to } = options;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = options.duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = (0, $62946488586fc0f6$export$74df49bbebf8cb2c)(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = (0, $be73afde9516fed0$export$89e29e4ab65e70a9)([
            0,
            100
        ], [
            from,
            to
        ], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    const animation = animator(Object.assign(Object.assign({}, options), {
        from: from,
        to: to
    }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = (0, $230e5bd75deb454c$export$ab9042754680126b)(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = (0, $230e5bd75deb454c$export$7d0784e050d8e25f)(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 || onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) (0, $230e5bd75deb454c$export$c9c9437f9b8733b5)(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 || onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: ()=>{
            onStop === null || onStop === void 0 || onStop();
            driverControls.stop();
        }
    };
}


function $4e1c00700aa06d40$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}



function $f0c0f80569e2e087$export$ee3ff3a17106998({ from: from = 0, velocity: velocity = 0, min: min, max: max, power: power = 0.8, timeConstant: timeConstant = 750, bounceStiffness: bounceStiffness = 500, bounceDamping: bounceDamping = 10, restDelta: restDelta = 1, modifyTarget: modifyTarget, driver: driver, onUpdate: onUpdate, onComplete: onComplete, onStop: onStop }) {
    let currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $78eae5210e62d013$export$e3607ec2d7a891c4)(Object.assign(Object.assign({}, options), {
            driver: driver,
            onUpdate: (v)=>{
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete,
            onStop: onStop
        }));
    }
    function startSpring(options) {
        startAnimation(Object.assign({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta
        }, options));
    }
    if (isOutOfBounds(from)) startSpring({
        from: from,
        velocity: velocity,
        to: boundaryNearest(from)
    });
    else {
        let target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        const boundary = boundaryNearest(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v)=>{
            prev = current;
            current = v;
            velocity = (0, $4e1c00700aa06d40$export$eab0632f7ad4f9d7)(v - prev, (0, $741aad569b766a4c$export$7244445918e670ed)().delta);
            if (heading === 1 && v > boundary || heading === -1 && v < boundary) startSpring({
                from: v,
                to: boundary,
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: ()=>currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop()
    };
}


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var $083454c8244247d6$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};





const $fb965d9058fcbe5e$var$a = (a1, a2)=>1.0 - 3.0 * a2 + 3.0 * a1;
const $fb965d9058fcbe5e$var$b = (a1, a2)=>3.0 * a2 - 6.0 * a1;
const $fb965d9058fcbe5e$var$c = (a1)=>3.0 * a1;
const $fb965d9058fcbe5e$var$calcBezier = (t, a1, a2)=>(($fb965d9058fcbe5e$var$a(a1, a2) * t + $fb965d9058fcbe5e$var$b(a1, a2)) * t + $fb965d9058fcbe5e$var$c(a1)) * t;
const $fb965d9058fcbe5e$var$getSlope = (t, a1, a2)=>3.0 * $fb965d9058fcbe5e$var$a(a1, a2) * t * t + 2.0 * $fb965d9058fcbe5e$var$b(a1, a2) * t + $fb965d9058fcbe5e$var$c(a1);
const $fb965d9058fcbe5e$var$subdivisionPrecision = 0.0000001;
const $fb965d9058fcbe5e$var$subdivisionMaxIterations = 10;
function $fb965d9058fcbe5e$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $fb965d9058fcbe5e$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $fb965d9058fcbe5e$var$subdivisionPrecision && ++i < $fb965d9058fcbe5e$var$subdivisionMaxIterations);
    return currentT;
}
const $fb965d9058fcbe5e$var$newtonIterations = 8;
const $fb965d9058fcbe5e$var$newtonMinSlope = 0.001;
function $fb965d9058fcbe5e$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(let i = 0; i < $fb965d9058fcbe5e$var$newtonIterations; ++i){
        const currentSlope = $fb965d9058fcbe5e$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        const currentX = $fb965d9058fcbe5e$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
const $fb965d9058fcbe5e$var$kSplineTableSize = 11;
const $fb965d9058fcbe5e$var$kSampleStepSize = 1.0 / ($fb965d9058fcbe5e$var$kSplineTableSize - 1.0);
function $fb965d9058fcbe5e$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return 0, $d43a9d278bbed66c$export$45db2fc2f15997e7;
    const sampleValues = new Float32Array($fb965d9058fcbe5e$var$kSplineTableSize);
    for(let i = 0; i < $fb965d9058fcbe5e$var$kSplineTableSize; ++i)sampleValues[i] = $fb965d9058fcbe5e$var$calcBezier(i * $fb965d9058fcbe5e$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        let intervalStart = 0.0;
        let currentSample = 1;
        const lastSample = $fb965d9058fcbe5e$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $fb965d9058fcbe5e$var$kSampleStepSize;
        --currentSample;
        const dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        const guessForT = intervalStart + dist * $fb965d9058fcbe5e$var$kSampleStepSize;
        const initialSlope = $fb965d9058fcbe5e$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $fb965d9058fcbe5e$var$newtonMinSlope) return $fb965d9058fcbe5e$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $fb965d9058fcbe5e$var$binarySubdivide(aX, intervalStart, intervalStart + $fb965d9058fcbe5e$var$kSampleStepSize, mX1, mX2);
    }
    return (t)=>t === 0 || t === 1 ? t : $fb965d9058fcbe5e$var$calcBezier(getTForX(t), mY1, mY2);
}


var $09ac0b286989a3ae$var$easingLookup = {
    linear: (0, $d43a9d278bbed66c$export$45db2fc2f15997e7),
    easeIn: (0, $d43a9d278bbed66c$export$929e5a82286172a6),
    easeInOut: (0, $d43a9d278bbed66c$export$c07234257a03d5e9),
    easeOut: (0, $d43a9d278bbed66c$export$57636bb43b1ccbb0),
    circIn: (0, $d43a9d278bbed66c$export$e444123e42d03385),
    circInOut: (0, $d43a9d278bbed66c$export$30d3455eee55bed5),
    circOut: (0, $d43a9d278bbed66c$export$c8d67a19199d1a50),
    backIn: (0, $d43a9d278bbed66c$export$b01116c84cdfe1a2),
    backInOut: (0, $d43a9d278bbed66c$export$ddc5fd596f6c71b2),
    backOut: (0, $d43a9d278bbed66c$export$77edfce482316a60),
    anticipate: (0, $d43a9d278bbed66c$export$6b0af63b873d419e),
    bounceIn: (0, $d43a9d278bbed66c$export$fccebd7948554554),
    bounceInOut: (0, $d43a9d278bbed66c$export$41ad9e9849a703ce),
    bounceOut: (0, $d43a9d278bbed66c$export$cccc9e04465dce11)
};
var $09ac0b286989a3ae$export$ef97fe084f156ca4 = function(definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return (0, $fb965d9058fcbe5e$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)($09ac0b286989a3ae$var$easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"));
        return $09ac0b286989a3ae$var$easingLookup[definition];
    }
    return definition;
};
var $09ac0b286989a3ae$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $ef4086713d7b0bdb$export$65676b58b122bc38 = function(key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $fe3e8d578aa8b27f$export$83a0e34f1302825b).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};




var $5f1d5ca1d398e82d$export$2577c2184b2254d3 = function() {
    return {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restSpeed: 10
    };
};
var $5f1d5ca1d398e82d$export$a743142a31c132c = function(to) {
    return {
        type: "spring",
        stiffness: 550,
        damping: to === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    };
};
var $5f1d5ca1d398e82d$export$c2d663fbb86d66d6 = function() {
    return {
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    };
};
var $5f1d5ca1d398e82d$var$keyframes = function(values) {
    return {
        type: "keyframes",
        duration: 0.8,
        values: values
    };
};
var $5f1d5ca1d398e82d$var$defaultTransitions = {
    x: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    y: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    z: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotate: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotateX: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotateY: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotateZ: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    scaleX: $5f1d5ca1d398e82d$export$a743142a31c132c,
    scaleY: $5f1d5ca1d398e82d$export$a743142a31c132c,
    scale: $5f1d5ca1d398e82d$export$a743142a31c132c,
    opacity: $5f1d5ca1d398e82d$export$c2d663fbb86d66d6,
    backgroundColor: $5f1d5ca1d398e82d$export$c2d663fbb86d66d6,
    color: $5f1d5ca1d398e82d$export$c2d663fbb86d66d6,
    default: $5f1d5ca1d398e82d$export$a743142a31c132c
};
var $5f1d5ca1d398e82d$export$262124b154b9f1c0 = function(valueKey, to) {
    var transitionFactory;
    if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(to)) transitionFactory = $5f1d5ca1d398e82d$var$keyframes;
    else transitionFactory = $5f1d5ca1d398e82d$var$defaultTransitions[valueKey] || $5f1d5ca1d398e82d$var$defaultTransitions.default;
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        to: to
    }, transitionFactory(to));
};





const $bd3d3cb23febe6a9$var$maxDefaults = new Set([
    'brightness',
    'contrast',
    'saturate',
    'opacity'
]);
function $bd3d3cb23febe6a9$var$applyDefaultFilter(v) {
    let [name, value] = v.slice(0, -1).split('(');
    if (name === 'drop-shadow') return v;
    const [number] = value.match((0, $470374f87b8ca393$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, '');
    let defaultValue = $bd3d3cb23febe6a9$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + '(' + defaultValue + unit + ')';
}
const $bd3d3cb23febe6a9$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $bd3d3cb23febe6a9$export$3dea766d36a8935f = Object.assign(Object.assign({}, (0, $fe3e8d578aa8b27f$export$83a0e34f1302825b)), {
    getAnimatableNone: (v)=>{
        const functions = v.match($bd3d3cb23febe6a9$var$functionRegex);
        return functions ? functions.map($bd3d3cb23febe6a9$var$applyDefaultFilter).join(' ') : v;
    }
});





/**
 * A map of default value types for common values
 */ var $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b)), {
    // Color props
    color: (0, $fcbc8d85f0f592e3$export$35e9368ef982300f),
    backgroundColor: (0, $fcbc8d85f0f592e3$export$35e9368ef982300f),
    outlineColor: (0, $fcbc8d85f0f592e3$export$35e9368ef982300f),
    fill: (0, $fcbc8d85f0f592e3$export$35e9368ef982300f),
    stroke: (0, $fcbc8d85f0f592e3$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $fcbc8d85f0f592e3$export$35e9368ef982300f),
    borderTopColor: (0, $fcbc8d85f0f592e3$export$35e9368ef982300f),
    borderRightColor: (0, $fcbc8d85f0f592e3$export$35e9368ef982300f),
    borderBottomColor: (0, $fcbc8d85f0f592e3$export$35e9368ef982300f),
    borderLeftColor: (0, $fcbc8d85f0f592e3$export$35e9368ef982300f),
    filter: (0, $bd3d3cb23febe6a9$export$3dea766d36a8935f),
    WebkitFilter: (0, $bd3d3cb23febe6a9$export$3dea766d36a8935f)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $6da1de6e0a9a8c9d$export$67d1babe0338d23b = function(key) {
    return $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb[key];
};


function $ca0a3798777df465$export$cea0cedcb94873b5(key, value) {
    var _a;
    var defaultValueType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $bd3d3cb23febe6a9$export$3dea766d36a8935f)) defaultValueType = (0, $fe3e8d578aa8b27f$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}


var $77818709e1bb6833$export$888a3d84909f9e3d = {
    current: false
};



/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7(_a) {
    _a.when;
    _a.delay;
    _a.delayChildren;
    _a.staggerChildren;
    _a.staggerDirection;
    _a.repeat;
    _a.repeatType;
    _a.repeatDelay;
    _a.from;
    var transition = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from"
    ]);
    return !!Object.keys(transition).length;
}
var $ec9bae3b9c638c7a$var$legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */ function $ec9bae3b9c638c7a$export$998eb6d72a6574db(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "ease",
        "times",
        "yoyo",
        "flip",
        "loop"
    ]);
    var options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, transition);
    if (times) options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */ if (transition.duration) options["duration"] = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(transition.duration);
    if (transition.repeatDelay) options.repeatDelay = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */ if (ease) options["ease"] = (0, $09ac0b286989a3ae$export$216948827bbdc797)(ease) ? ease.map((0, $09ac0b286989a3ae$export$ef97fe084f156ca4)) : (0, $09ac0b286989a3ae$export$ef97fe084f156ca4)(ease);
    /**
     * Support legacy transition API
     */ if (transition.type === "tween") options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */ if (yoyo || loop || flip) {
        (0, $4fd1ae9b00853f6f$export$491112666e282270)(!$ec9bae3b9c638c7a$var$legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        $ec9bae3b9c638c7a$var$legacyRepeatWarning = true;
        if (yoyo) options.repeatType = "reverse";
        else if (loop) options.repeatType = "loop";
        else if (flip) options.repeatType = "mirror";
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */ if (transition.type !== "spring") options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */ function $ec9bae3b9c638c7a$export$b55a0e77aebddb70(transition, key) {
    var _a, _b;
    var valueTransition = $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) || {};
    return (_b = (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : transition.delay) !== null && _b !== void 0 ? _b : 0;
}
function $ec9bae3b9c638c7a$export$3d2f5b3e7004e0cf(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(options.to), false);
        options.to[0] = options.from;
    }
    return options;
}
function $ec9bae3b9c638c7a$export$9019a69adbea191(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
    $ec9bae3b9c638c7a$export$3d2f5b3e7004e0cf(options);
    /**
     * Get a default transition if none is determined to be defined.
     */ if (!$ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7(transition)) transition = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, transition), (0, $5f1d5ca1d398e82d$export$262124b154b9f1c0)(key, options.to));
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), $ec9bae3b9c638c7a$export$998eb6d72a6574db(transition));
}
/**
 *
 */ function $ec9bae3b9c638c7a$var$getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(key, target);
    else if ($ec9bae3b9c638c7a$export$c46ec7d82fb1f602(origin) && typeof target === "string") origin = $ec9bae3b9c638c7a$export$36cd6032f9de8a48(target);
    else if (!Array.isArray(target) && $ec9bae3b9c638c7a$export$c46ec7d82fb1f602(target) && typeof origin === "string") target = $ec9bae3b9c638c7a$export$36cd6032f9de8a48(origin);
    var isOriginAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(key, origin);
    (0, $4fd1ae9b00853f6f$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(key, " from \"").concat(origin, "\" to \"").concat(target, "\". ").concat(origin, " is not an animatable value - to enable this animation set ").concat(origin, " to a value animatable to ").concat(target, " via the `style` property."));
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function(v) {
                return value.set(v);
            }
        };
        return valueTransition.type === "inertia" || valueTransition.type === "decay" ? (0, $f0c0f80569e2e087$export$ee3ff3a17106998)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), valueTransition)) : (0, $78eae5210e62d013$export$e3607ec2d7a891c4)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $ec9bae3b9c638c7a$export$9019a69adbea191(valueTransition, options, key)), {
            onUpdate: function(v) {
                var _a;
                options.onUpdate(v);
                (_a = valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, v);
            },
            onComplete: function() {
                var _a;
                options.onComplete();
                (_a = valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
            }
        }));
    }
    function set() {
        var _a, _b;
        var finalTarget = (0, $21f654501c04362b$export$5485128c47bd48bb)(target);
        value.set(finalTarget);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, finalTarget);
        (_b = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _b === void 0 || _b.call(valueTransition);
        return {
            stop: function() {}
        };
    }
    return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function $ec9bae3b9c638c7a$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $ec9bae3b9c638c7a$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $ca0a3798777df465$export$cea0cedcb94873b5)("", potentialUnitType);
}
function $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 */ function $ec9bae3b9c638c7a$export$592dbd515a49cf1b(key, value, target, transition) {
    if (transition === void 0) transition = {};
    if ((0, $77818709e1bb6833$export$888a3d84909f9e3d).current) transition = {
        type: false
    };
    return value.start(function(onComplete) {
        var delayTimer;
        var controls;
        var animation = $ec9bae3b9c638c7a$var$getAnimation(key, value, target, transition, onComplete);
        var delay = $ec9bae3b9c638c7a$export$b55a0e77aebddb70(transition, key);
        var start = function() {
            return controls = animation();
        };
        if (delay) delayTimer = window.setTimeout(start, (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(delay));
        else start();
        return function() {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 || controls.stop();
        };
    });
}




/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $d56714d1e4e43615$export$65583ed5a868f2d9 = function(v) {
    return /^\-?\d*\.?\d+$/.test(v);
};


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var $933209bc9c035719$export$ade84c85e44a6cb1 = function(v) {
    return /^0[^.\s]+$/.test(v);
};






function $f9c6cc6428ae273c$export$20e507e47fae79fd(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function $f9c6cc6428ae273c$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}
// Adapted from array-move
function $f9c6cc6428ae273c$export$ec937e64de6c1257(_a, fromIndex, toIndex) {
    var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a), arr = _b.slice(0);
    var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(arr.splice(fromIndex, 1), 1), item = _c[0];
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


var $ad746ac6e5aa4783$export$e7dff9482a5fd23c = /** @class */ function() {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function(handler) {
        var _this = this;
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.subscriptions, handler);
        return function() {
            return (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(_this.subscriptions, handler);
        };
    };
    SubscriptionManager.prototype.notify = function(a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(var i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    };
    SubscriptionManager.prototype.getSize = function() {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function() {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}();


var $e32104bb79321603$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $e32104bb79321603$export$8cea36d14ee64562 = /** @class */ function() {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ function MotionValue(init) {
        var _this = this;
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "6.5.1";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */ this.updateSubscribers = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */ this.velocityUpdateSubscribers = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */ this.renderSubscribers = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        this.updateAndNotify = function(v, render) {
            if (render === void 0) render = true;
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = (0, $741aad569b766a4c$export$7244445918e670ed)(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                (0, $741aad569b766a4c$export$2e2bcd8739ae039).postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) _this.updateSubscribers.notify(_this.current);
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            // Update render subscribers
            if (render) _this.renderSubscribers.notify(_this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = function() {
            return (0, $741aad569b766a4c$export$2e2bcd8739ae039).postRender(_this.velocityCheck);
        };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = function(_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $e32104bb79321603$var$isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @privateRemarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */ MotionValue.prototype.onChange = function(subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function() {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */ MotionValue.prototype.onRenderRequest = function(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ MotionValue.prototype.attach = function(passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ MotionValue.prototype.set = function(v, render) {
        if (render === void 0) render = true;
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ MotionValue.prototype.get = function() {
        return this.current;
    };
    /**
     * @public
     */ MotionValue.prototype.getPrevious = function() {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ MotionValue.prototype.getVelocity = function() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $4e1c00700aa06d40$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ MotionValue.prototype.start = function(animation) {
        var _this = this;
        this.stop();
        return new Promise(function(resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function() {
            return _this.clearAnimation();
        });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */ MotionValue.prototype.stop = function() {
        if (this.stopAnimation) this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ MotionValue.prototype.isAnimating = function() {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function() {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ MotionValue.prototype.destroy = function() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}();
function $e32104bb79321603$export$ce8bdc721e76545f(init) {
    return new $e32104bb79321603$export$8cea36d14ee64562(init);
}






/**
 * Tests a provided value against a ValueType
 */ var $a1e2618328995be8$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};


/**
 * ValueType for "auto"
 */ var $c231a4375b038d3c$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};


/**
 * A list of value types commonly used for dimensions
 */ var $a90ec5e4ad59372f$export$d176691c1998a1f5 = [
    (0, $b4f6d145fa485818$export$98e628dec113755e),
    (0, $9ad32cb76340910d$export$91c0eda1d06bf008),
    (0, $9ad32cb76340910d$export$626336c2cd4b14de),
    (0, $9ad32cb76340910d$export$41fc368e1a942b97),
    (0, $9ad32cb76340910d$export$aed3d7b7d206c196),
    (0, $9ad32cb76340910d$export$f91e8c45a95a32f2),
    (0, $c231a4375b038d3c$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $a90ec5e4ad59372f$export$eefdd52e3ccae428 = function(v) {
    return $a90ec5e4ad59372f$export$d176691c1998a1f5.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));
};



/**
 * A list of all ValueTypes
 */ var $0bb49f6c51badae3$var$valueTypes = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)((0, $a90ec5e4ad59372f$export$d176691c1998a1f5)), false), [
    (0, $fcbc8d85f0f592e3$export$35e9368ef982300f),
    (0, $fe3e8d578aa8b27f$export$83a0e34f1302825b)
], false);
/**
 * Tests a value against the list of ValueTypes
 */ var $0bb49f6c51badae3$export$950e7e59ea1ffed7 = function(v) {
    return $0bb49f6c51badae3$var$valueTypes.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));
};



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ea04fe669600292a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value));
}
function $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $0861f93f2aa87ed8$export$7b1b1c981f4f0558)(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
    _a.transition;
    var target = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, target), transitionEnd);
    for(var key in target){
        var value = (0, $21f654501c04362b$export$5485128c47bd48bb)(target[key]);
        $ea04fe669600292a$var$setMotionValue(visualElement, key, value);
    }
}
function $ea04fe669600292a$var$setVariants(visualElement, variantLabels) {
    var reversedLabels = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(variantLabels), false).reverse();
    reversedLabels.forEach(function(key) {
        var _a;
        var variant = visualElement.getVariant(key);
        variant && $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            $ea04fe669600292a$var$setVariants(child, variantLabels);
        });
    });
}
function $ea04fe669600292a$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $ea04fe669600292a$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $ea04fe669600292a$var$setVariants(visualElement, [
        definition
    ]);
    else $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition);
}
function $ea04fe669600292a$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function(key) {
        return !visualElement.hasValue(key);
    });
    var numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(var i = 0; i < numNewValues; i++){
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $d56714d1e4e43615$export$65583ed5a868f2d9)(value) || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $0bb49f6c51badae3$export$950e7e59ea1ffed7)(value) && (0, $fe3e8d578aa8b27f$export$83a0e34f1302825b).test(targetValue)) value = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
        visualElement.setBaseTarget(key, value);
    }
}
function $ea04fe669600292a$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $ea04fe669600292a$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for(var key in target)origin[key] = (_a = $ea04fe669600292a$export$c3befe8e18686628(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    return origin;
}




function $66bcda5a48aeb596$export$ff62cf473653f109(visualElement, definition, options) {
    if (options === void 0) options = {};
    visualElement.notifyAnimationStart(definition);
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return $66bcda5a48aeb596$var$animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $66bcda5a48aeb596$var$animateVariant(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $0861f93f2aa87ed8$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = $66bcda5a48aeb596$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function() {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function $66bcda5a48aeb596$var$animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) options = {};
    var resolved = (0, $0861f93f2aa87ed8$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return $66bcda5a48aeb596$var$animateTarget(visualElement, resolved, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
        if (forwardDelay === void 0) forwardDelay = 0;
        var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $66bcda5a48aeb596$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _c = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _c[0], last = _c[1];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $66bcda5a48aeb596$var$animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_e, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for(var key in target){
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $66bcda5a48aeb596$var$shouldBlockAnimation(animationTypeState, key)) continue;
        var valueTransition = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            delay: delay
        }, transition);
        /**
         * Make animation instant if this is a transform prop and we should reduce motion.
         */ if (visualElement.shouldReduceMotion && (0, $ac502869c4d3e65a$export$15240a8a4379d8de)(key)) valueTransition = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, valueTransition), {
            type: false,
            delay: 0
        });
        var animation = (0, $ec9bae3b9c638c7a$export$592dbd515a49cf1b)(key, value, valueTarget, valueTransition);
        animations.push(animation);
    }
    return Promise.all(animations).then(function() {
        transitionEnd && (0, $ea04fe669600292a$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
}
function $66bcda5a48aeb596$var$animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) delayChildren = 0;
    if (staggerChildren === void 0) staggerChildren = 0;
    if (staggerDirection === void 0) staggerDirection = 1;
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function(i) {
        if (i === void 0) i = 0;
        return i * staggerChildren;
    } : function(i) {
        if (i === void 0) i = 0;
        return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(visualElement.variantChildren).sort($66bcda5a48aeb596$export$523a0bedf33ad781).forEach(function(child, i) {
        animations.push($66bcda5a48aeb596$var$animateVariant(child, variant, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(function() {
            return child.notifyAnimationComplete(variant);
        }));
    });
    return Promise.all(animations);
}
function $66bcda5a48aeb596$export$3cc6f911ef1fd837(visualElement) {
    visualElement.forEachValue(function(value) {
        return value.stop();
    });
}
function $66bcda5a48aeb596$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $66bcda5a48aeb596$var$shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}




var $351ff45a987b08cc$export$16e45afcc206d3a8 = [
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Animate,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).InView,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Focus,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Hover,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Tap,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Drag,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Exit
];
var $351ff45a987b08cc$var$reversePriorityOrder = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)($351ff45a987b08cc$export$16e45afcc206d3a8), false).reverse();
var $351ff45a987b08cc$var$numAnimationTypes = $351ff45a987b08cc$export$16e45afcc206d3a8.length;
function $351ff45a987b08cc$var$animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(_a) {
            var animation = _a.animation, options = _a.options;
            return (0, $66bcda5a48aeb596$export$ff62cf473653f109)(visualElement, animation, options);
        }));
    };
}
function $351ff45a987b08cc$export$bb53502b7a672aa8(visualElement) {
    var animate = $351ff45a987b08cc$var$animateList(visualElement);
    var state = $351ff45a987b08cc$var$createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(acc, definition) {
        var resolved = (0, $0861f93f2aa87ed8$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            resolved.transition;
            var transitionEnd = resolved.transitionEnd, target = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        var _loop_1 = function(i) {
            var type = $351ff45a987b08cc$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = (0, $0861f93f2aa87ed8$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var variantDidChange = $351ff45a987b08cc$export$68651800594fd43c(typeState.prevProp, prop);
            var shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(next) && (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, encounteredKeys), resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push.apply(animations, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(definitionList.map(function(animation) {
                return {
                    animation: animation,
                    options: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        type: type
                    }, options)
                };
            })), false));
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $351ff45a987b08cc$var$numAnimationTypes; i++)_loop_1(i);
        allAnimatedKeys = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation_1[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation_1
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        var animations = animateChanges(options, type);
        for(var key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        }
    };
}
function $351ff45a987b08cc$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if ((0, $0861f93f2aa87ed8$export$562271cd22f751d)(next)) return !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $351ff45a987b08cc$var$createTypeState(isActive) {
    if (isActive === void 0) isActive = false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $351ff45a987b08cc$var$createState() {
    var _a;
    return _a = {}, _a[(0, $bc94049262afe059$export$2deb71ebd3734d23).Animate] = $351ff45a987b08cc$var$createTypeState(true), _a[(0, $bc94049262afe059$export$2deb71ebd3734d23).InView] = $351ff45a987b08cc$var$createTypeState(), _a[(0, $bc94049262afe059$export$2deb71ebd3734d23).Hover] = $351ff45a987b08cc$var$createTypeState(), _a[(0, $bc94049262afe059$export$2deb71ebd3734d23).Tap] = $351ff45a987b08cc$var$createTypeState(), _a[(0, $bc94049262afe059$export$2deb71ebd3734d23).Drag] = $351ff45a987b08cc$var$createTypeState(), _a[(0, $bc94049262afe059$export$2deb71ebd3734d23).Focus] = $351ff45a987b08cc$var$createTypeState(), _a[(0, $bc94049262afe059$export$2deb71ebd3734d23).Exit] = $351ff45a987b08cc$var$createTypeState(), _a;
}




var $03e8b675a1009b68$export$7f9953c70dacfd7f = {
    animation: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)(function(_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $351ff45a987b08cc$export$bb53502b7a672aa8)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(animate)) (0, $acw62.useEffect)(function() {
            return animate.subscribe(visualElement);
        }, [
            animate
        ]);
    }),
    exit: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)(function(props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)((0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)(), 2), isPresent = _a[0], safeToRemove = _a[1];
        var presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
        (0, $acw62.useEffect)(function() {
            var _a, _b;
            visualElement.isPresent = isPresent;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Exit, !isPresent, {
                custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
            });
            !isPresent && (animation === null || animation === void 0 || animation.then(safeToRemove));
        }, [
            isPresent
        ]);
    })
};



var $acw62 = parcelRequire("acw62");








const $e0f954ec4e900a72$export$aff838a5553f2a92 = (point)=>point.hasOwnProperty('x') && point.hasOwnProperty('y');



const $b52ae3d15e0e9b72$export$319d74662aaa2966 = (point)=>(0, $e0f954ec4e900a72$export$aff838a5553f2a92)(point) && point.hasOwnProperty('z');



const $2b642d68d8bc1f9f$var$distance1D = (a, b)=>Math.abs(a - b);
function $2b642d68d8bc1f9f$export$9f17032d917177de(a, b) {
    if ((0, $a75d904cf9cd8fdb$export$4e960b977ccfec97)(a) && (0, $a75d904cf9cd8fdb$export$4e960b977ccfec97)(b)) return $2b642d68d8bc1f9f$var$distance1D(a, b);
    else if ((0, $e0f954ec4e900a72$export$aff838a5553f2a92)(a) && (0, $e0f954ec4e900a72$export$aff838a5553f2a92)(b)) {
        const xDelta = $2b642d68d8bc1f9f$var$distance1D(a.x, b.x);
        const yDelta = $2b642d68d8bc1f9f$var$distance1D(a.y, b.y);
        const zDelta = (0, $b52ae3d15e0e9b72$export$319d74662aaa2966)(a) && (0, $b52ae3d15e0e9b72$export$319d74662aaa2966)(b) ? $2b642d68d8bc1f9f$var$distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}


/**
 * @internal
 */ var $6af3e4ae1e03c8d7$export$d9c66232c9c4689c = /** @class */ function() {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = $6af3e4ae1e03c8d7$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = (0, $2b642d68d8bc1f9f$export$9f17032d917177de)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $741aad569b766a4c$export$7244445918e670ed)().timestamp;
            _this.history.push((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, point), {
                timestamp: timestamp
            }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = $6af3e4ae1e03c8d7$var$transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $c87aba2e7df5c6a6$export$764db16956f554f8)(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            (0, $741aad569b766a4c$export$2e2bcd8739ae039).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = $6af3e4ae1e03c8d7$var$getPanInfo($6af3e4ae1e03c8d7$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $c87aba2e7df5c6a6$export$c4dfce035d43d1e0)(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = (0, $23ab615c547792c0$export$12f84bb882d06e1a)(event);
        var initialInfo = $6af3e4ae1e03c8d7$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $741aad569b766a4c$export$7244445918e670ed)().timestamp;
        this.history = [
            (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $6af3e4ae1e03c8d7$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $bcf7a994d3c628d6$export$a4627e546088548d)((0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function(handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function() {
        this.removeListeners && this.removeListeners();
        (0, $741aad569b766a4c$export$d93e9c1fe0553512).update(this.updatePoint);
    };
    return PanSession;
}();
function $6af3e4ae1e03c8d7$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $6af3e4ae1e03c8d7$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $6af3e4ae1e03c8d7$var$getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: $6af3e4ae1e03c8d7$var$subtractPoint(point, $6af3e4ae1e03c8d7$var$lastDevicePoint(history)),
        offset: $6af3e4ae1e03c8d7$var$subtractPoint(point, $6af3e4ae1e03c8d7$var$startDevicePoint(history)),
        velocity: $6af3e4ae1e03c8d7$var$getVelocity(history, 0.1)
    };
}
function $6af3e4ae1e03c8d7$var$startDevicePoint(history) {
    return history[0];
}
function $6af3e4ae1e03c8d7$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $6af3e4ae1e03c8d7$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $6af3e4ae1e03c8d7$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}








function $b352f7cdd42c49d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b352f7cdd42c49d7$export$28d0384c4b79bde2(value, target, maxDistance) {
    if (target === void 0) target = 0;
    if (maxDistance === void 0) maxDistance = 0.01;
    return (0, $2b642d68d8bc1f9f$export$9f17032d917177de)(value, target) < maxDistance;
}
function $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta, source, target, origin) {
    if (origin === void 0) origin = 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $b352f7cdd42c49d7$export$c1c127004b72a37(target) / $b352f7cdd42c49d7$export$c1c127004b72a37(source);
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $b352f7cdd42c49d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function $b352f7cdd42c49d7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(relative);
}
function $b352f7cdd42c49d7$export$426154f9d100f99(target, relative, parent) {
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(layout);
}
function $b352f7cdd42c49d7$export$2785bfcc929c5650(target, layout, parent) {
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}


/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $2df0cf7aa8fef8fc$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $2df0cf7aa8fef8fc$export$4e9195bf7793bc78(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.x, left, right),
        y: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)([
        max,
        min
    ], 2), min = _a[0], max = _a[1];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $2df0cf7aa8fef8fc$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $2df0cf7aa8fef8fc$export$13abbfca044ca46d(source, target) {
    var origin = 0.5;
    var sourceLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(source);
    var targetLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $8719e706e42e5d1d$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $8719e706e42e5d1d$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $8fe3552f3a53f5df$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $2df0cf7aa8fef8fc$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22(dragElastic) {
    if (dragElastic === void 0) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    return {
        x: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}



var $a3727e4e12b23353$export$ff25708b37f72782 = function() {
    return {
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    };
};
var $a3727e4e12b23353$export$3d227df54007d73a = function() {
    return {
        x: $a3727e4e12b23353$export$ff25708b37f72782(),
        y: $a3727e4e12b23353$export$ff25708b37f72782()
    };
};
var $a3727e4e12b23353$export$6db76765312617ac = function() {
    return {
        min: 0,
        max: 0
    };
};
var $a3727e4e12b23353$export$6459fc9e86be362e = function() {
    return {
        x: $a3727e4e12b23353$export$6db76765312617ac(),
        y: $a3727e4e12b23353$export$6db76765312617ac()
    };
};


function $247f90d2510fbc55$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0e0401fe38bd0bd1$export$d3955c6a8f65a36b(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0e0401fe38bd0bd1$export$b6b9cd4198191a47(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0e0401fe38bd0bd1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    var topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    var bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}




function $fe0ee806cd19fc1f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fe0ee806cd19fc1f$export$bdf30dca883ea463(_a) {
    var scale = _a.scale, scaleX = _a.scaleX, scaleY = _a.scaleY;
    return !$fe0ee806cd19fc1f$var$isIdentityScale(scale) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleX) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleY);
}
function $fe0ee806cd19fc1f$export$a545127cf1fbb600(values) {
    return $fe0ee806cd19fc1f$export$bdf30dca883ea463(values) || $fe0ee806cd19fc1f$var$hasTranslate(values.x) || $fe0ee806cd19fc1f$var$hasTranslate(values.y) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $fe0ee806cd19fc1f$var$hasTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d8332eb74969584e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d8332eb74969584e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d8332eb74969584e$export$e8e3a712e9ebf422(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    axis.min = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d8332eb74969584e$export$d80074982803af5c(box, _a) {
    var x = _a.x, y = _a.y;
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d8332eb74969584e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition) {
    var _a, _b;
    if (isSharedTransition === void 0) isSharedTransition = false;
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d8332eb74969584e$export$58b16271041fbfb(box, {
            x: -node.scroll.x,
            y: -node.scroll.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d8332eb74969584e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) $d8332eb74969584e$export$58b16271041fbfb(box, node.latestValues);
    }
}
function $d8332eb74969584e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d8332eb74969584e$export$625f1dd140a2f5e7(axis, transforms, _a) {
    var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d8332eb74969584e$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $d8332eb74969584e$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $d8332eb74969584e$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d8332eb74969584e$export$58b16271041fbfb(box, transform) {
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.x, transform, $d8332eb74969584e$var$xKeys);
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.y, transform, $d8332eb74969584e$var$yKeys);
}


function $4ca2f8055771ddf4$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)((0, $0e0401fe38bd0bd1$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $4ca2f8055771ddf4$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = $4ca2f8055771ddf4$export$d8718b6a7e5c624e(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.x, scroll.x);
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.y, scroll.y);
    }
    return viewportBox;
}









var $59924ee873defaad$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: AnyPointerEvent
var $59924ee873defaad$export$86bff71f18910307 = /** @class */ function() {
    function VisualElementDragControls(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    VisualElementDragControls.prototype.start = function(originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c;
        /**
         * Don't start dragging if this component is exiting
         */ if (this.visualElement.isPresent === false) return;
        var onSessionStart = function(event) {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopAnimation();
            if (snapToCursor) _this.snapToCursor((0, $23ab615c547792c0$export$12f84bb882d06e1a)(event, "page").point);
        };
        var onStart = function(event, info) {
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _b = _this.getProps(), drag = _b.drag, dragPropagation = _b.dragPropagation, onDragStart = _b.onDragStart;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock) _this.openGlobalLock();
                _this.openGlobalLock = (0, $df8cc4eab047d382$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock) return;
            }
            _this.isDragging = true;
            _this.currentDirection = null;
            _this.resolveConstraints();
            if (_this.visualElement.projection) {
                _this.visualElement.projection.isAnimationBlocked = true;
                _this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $247f90d2510fbc55$export$b789de563eb43b1)(function(axis) {
                var _a, _b;
                var current = _this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $9ad32cb76340910d$export$626336c2cd4b14de).test(current)) {
                    var measuredAxis = (_b = (_a = _this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.actual[axis];
                    if (measuredAxis) {
                        var length_1 = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(measuredAxis);
                        current = length_1 * (parseFloat(current) / 100);
                    }
                }
                _this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 || onDragStart(event, info);
            (_a = _this.visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Drag, true);
        };
        var onMove = function(event, info) {
            // latestPointerEvent = event
            var _a = _this.getProps(), dragPropagation = _a.dragPropagation, dragDirectionLock = _a.dragDirectionLock, onDirectionLock = _a.onDirectionLock, onDrag = _a.onDrag;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock) return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = $59924ee873defaad$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) onDirectionLock === null || onDirectionLock === void 0 || onDirectionLock(_this.currentDirection);
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ _this.visualElement.syncRender();
            /**
             * This must fire after the syncRender call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag === null || onDrag === void 0 || onDrag(event, info);
        };
        var onSessionEnd = function(event, info) {
            return _this.stop(event, info);
        };
        this.panSession = new (0, $6af3e4ae1e03c8d7$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    };
    VisualElementDragControls.prototype.stop = function(event, info) {
        var isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        var velocity = info.velocity;
        this.startAnimation(velocity);
        var onDragEnd = this.getProps().onDragEnd;
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(event, info);
    };
    VisualElementDragControls.prototype.cancel = function() {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) this.visualElement.projection.isAnimationBlocked = false;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = undefined;
        var dragPropagation = this.getProps().dragPropagation;
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Drag, false);
    };
    VisualElementDragControls.prototype.updateAxis = function(axis, _point, offset) {
        var drag = this.getProps().drag;
        // If we're not dragging this axis, do an early return.
        if (!offset || !$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
        var axisValue = this.getAxisMotionValue(axis);
        var next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    };
    VisualElementDragControls.prototype.resolveConstraints = function() {
        var _this = this;
        var _a = this.getProps(), dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = (this.visualElement.projection || {}).layout;
        var prevConstraints = this.constraints;
        if (dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $2df0cf7aa8fef8fc$export$4e9195bf7793bc78)(layout.actual, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $247f90d2510fbc55$export$b789de563eb43b1)(function(axis) {
            if (_this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87)(layout.actual[axis], _this.constraints[axis]);
        });
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function() {
        var _a = this.getProps(), constraints = _a.dragConstraints, onMeasureDragConstraints = _a.onMeasureDragConstraints;
        if (!constraints || !(0, $d157673547c2a934$export$dedd81df7bc1307)(constraints)) return false;
        var constraintsElement = constraints.current;
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        var projection = this.visualElement.projection;
        // TODO
        if (!projection || !projection.layout) return false;
        var constraintsBox = (0, $4ca2f8055771ddf4$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        var measuredConstraints = (0, $2df0cf7aa8fef8fc$export$4228500f19d4cdf7)(projection.layout.actual, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints((0, $0e0401fe38bd0bd1$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.startAnimation = function(velocity) {
        var _this = this;
        var _a = this.getProps(), drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition, dragSnapToOrigin = _a.dragSnapToOrigin, onDragTransitionEnd = _a.onDragTransitionEnd;
        var constraints = this.constraints || {};
        var momentumAnimations = (0, $247f90d2510fbc55$export$b789de563eb43b1)(function(axis) {
            var _a;
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function(axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        return (0, $ec9bae3b9c638c7a$export$592dbd515a49cf1b)(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.stopAnimation = function() {
        var _this = this;
        (0, $247f90d2510fbc55$export$b789de563eb43b1)(function(axis) {
            return _this.getAxisMotionValue(axis).stop();
        });
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ VisualElementDragControls.prototype.getAxisMotionValue = function(axis) {
        var _a, _b;
        var dragKey = "_drag" + axis.toUpperCase();
        var externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
    };
    VisualElementDragControls.prototype.snapToCursor = function(point) {
        var _this = this;
        (0, $247f90d2510fbc55$export$b789de563eb43b1)(function(axis) {
            var drag = _this.getProps().drag;
            // If we're not dragging this axis, do an early return.
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var projection = _this.visualElement.projection;
            var axisValue = _this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                var _a = projection.layout.actual[axis], min = _a.min, max = _a.max;
                axisValue.set(point[axis] - (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    };
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ VisualElementDragControls.prototype.scalePositionWithinConstraints = function() {
        var _this = this;
        var _a;
        var _b = this.getProps(), drag = _b.drag, dragConstraints = _b.dragConstraints;
        var projection = this.visualElement.projection;
        if (!(0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ var boxProgress = {
            x: 0,
            y: 0
        };
        (0, $247f90d2510fbc55$export$b789de563eb43b1)(function(axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var latest = axisValue.get();
                boxProgress[axis] = (0, $2df0cf7aa8fef8fc$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, _this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ var transformTemplate = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $247f90d2510fbc55$export$b789de563eb43b1)(function(axis) {
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ var axisValue = _this.getAxisMotionValue(axis);
            var _a = _this.constraints[axis], min = _a.min, max = _a.max;
            axisValue.set((0, $9e031a435715a19b$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    };
    VisualElementDragControls.prototype.addListeners = function() {
        var _this = this;
        var _a;
        $59924ee873defaad$export$f0a15892c27dc07c.set(this.visualElement, this);
        var element = this.visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(element, "pointerdown", function(event) {
            var _a = _this.getProps(), drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        var measureDragConstraints = function() {
            var dragConstraints = _this.getProps().dragConstraints;
            if ((0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) _this.constraints = _this.resolveRefConstraints();
        };
        var projection = this.visualElement.projection;
        var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, $cba4f237926ffdf7$export$b1d829ddf82884aa)(window, "resize", function() {
            return _this.scalePositionWithinConstraints();
        });
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ projection.addEventListener("didUpdate", function(_a) {
            var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged;
            if (_this.isDragging && hasLayoutChanged) {
                (0, $247f90d2510fbc55$export$b789de563eb43b1)(function(axis) {
                    var motionValue = _this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    _this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                _this.visualElement.syncRender();
            }
        });
        return function() {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
        };
    };
    VisualElementDragControls.prototype.getProps = function() {
        var props = this.visualElement.getProps();
        var _a = props.drag, drag = _a === void 0 ? false : _a, _b = props.dragDirectionLock, dragDirectionLock = _b === void 0 ? false : _b, _c = props.dragPropagation, dragPropagation = _c === void 0 ? false : _c, _d = props.dragConstraints, dragConstraints = _d === void 0 ? false : _d, _e = props.dragElastic, dragElastic = _e === void 0 ? (0, $2df0cf7aa8fef8fc$export$a3366d3bac43a742) : _e, _f = props.dragMomentum, dragMomentum = _f === void 0 ? true : _f;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props), {
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        });
    };
    return VisualElementDragControls;
}();
function $59924ee873defaad$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $59924ee873defaad$var$getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) lockThreshold = 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}



/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $b89949ca91f83f6d$export$7941f8aafa4b6021(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var dragControls = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(function() {
        return new (0, $59924ee873defaad$export$86bff71f18910307)(visualElement);
    });
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $acw62.useEffect)(function() {
        return groupDragControls && groupDragControls.subscribe(dragControls);
    }, [
        dragControls,
        groupDragControls
    ]);
    // Apply the event listeners to the element
    (0, $acw62.useEffect)(function() {
        return dragControls.addListeners();
    }, [
        dragControls
    ]);
}



var $acw62 = parcelRequire("acw62");




/**
 *
 * @param handlers -
 * @param ref -
 *
 * @privateRemarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $86a042f96484b9fd$export$eb0f62174cac1aec(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0, $acw62.useRef)(null);
    var transformPagePoint = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function(event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $acw62.useEffect)(function() {
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $6af3e4ae1e03c8d7$export$d9c66232c9c4689c)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $a3f7c96fbe45f23e$export$734d04395f5243cd)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $7bbbf777b15ef7cf$export$f3a192d0cbd30b96)(function() {
        return panSession.current && panSession.current.end();
    });
}



var $fc1974bcfc4fde1a$export$d7d5d435647ed5a0 = {
    pan: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $86a042f96484b9fd$export$eb0f62174cac1aec)),
    drag: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $b89949ca91f83f6d$export$7941f8aafa4b6021))
};










var $e09883f5c35cc3a7$var$names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "LayoutAnimationStart",
    "SetAxisTarget",
    "Unmount"
];
function $e09883f5c35cc3a7$export$f6841af6ea5003ab() {
    var managers = $e09883f5c35cc3a7$var$names.map(function() {
        return new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
    });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function() {
            return managers.forEach(function(manager) {
                return manager.clear();
            });
        },
        updatePropListeners: function(props) {
            $e09883f5c35cc3a7$var$names.forEach(function(name) {
                var _a;
                var on = "on" + name;
                var propListener = props[on];
                // Unsubscribe existing subscription
                (_a = propSubscriptions[name]) === null || _a === void 0 || _a.call(propSubscriptions);
                // Add new subscription
                if (propListener) propSubscriptions[name] = lifecycles[on](propListener);
            });
        }
    };
    managers.forEach(function(manager, i) {
        lifecycles["on" + $e09883f5c35cc3a7$var$names[i]] = function(handler) {
            return manager.add(handler);
        };
        lifecycles["notify" + $e09883f5c35cc3a7$var$names[i]] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.notify.apply(manager, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args), false));
        };
    });
    return lifecycles;
}





function $69635cdb8982f9d2$export$9a552858d5197f6e(element, next, prev) {
    var _a;
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $55c3387a92452647$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */ element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(nextValue));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
        }
    }
    // Handle removed values
    for(var key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}



var $cb00410237ef0648$export$5ad594e944c33d76 = function(_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function(_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState, shouldReduceMotion = _a.shouldReduceMotion;
        if (options === void 0) options = {};
        var isMounted = false;
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */ var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender
         */ var lifecycles = (0, $e09883f5c35cc3a7$export$f6841af6ea5003ab)();
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ var prevMotionValues = {};
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */ var baseTarget = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */ var removeFromVariantTree;
        /**
         * Render the element with the latest styles outside of the React
         * render lifecycle
         */ function render() {
            if (!instance || !isMounted) return;
            triggerBuild();
            renderInstance(instance, renderState, props.style, element.projection);
        }
        function triggerBuild() {
            build(element, renderState, latestValues, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        /**
         *
         */ function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function(latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && (0, $741aad569b766a4c$export$2e2bcd8739ae039).update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function() {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ var initialMotionValues = scrapeMotionValuesFromProps(props);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $55c3387a92452647$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */ var isControllingVariants = (0, $0861f93f2aa87ed8$export$cf3a7bd331c35bf0)(props);
        var isVariantNode = (0, $0861f93f2aa87ed8$export$c0eba02279c18fea)(props);
        var element = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            treeType: treeType,
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */ current: null,
            /**
             * The depth of this visual element within the visual element tree.
             */ depth: parent ? parent.depth + 1 : 0,
            parent: parent,
            children: new Set(),
            /**
             *
             */ presenceId: presenceId,
            shouldReduceMotion: shouldReduceMotion,
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */ variantChildren: isVariantNode ? new Set() : undefined,
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by the projection tree, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */ isVisible: undefined,
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */ manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */ blockInitialAnimation: blockInitialAnimation,
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */ isMounted: function() {
                return Boolean(instance);
            },
            mount: function(newInstance) {
                isMounted = true;
                instance = element.current = newInstance;
                if (element.projection) element.projection.mount(newInstance);
                if (isVariantNode && parent && !isControllingVariants) removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                values.forEach(function(value, key) {
                    return bindToMotionValue(key, value);
                });
                parent === null || parent === void 0 || parent.children.add(element);
                element.setProps(props);
            },
            /**
             *
             */ unmount: function() {
                var _a;
                (_a = element.projection) === null || _a === void 0 || _a.unmount();
                (0, $741aad569b766a4c$export$d93e9c1fe0553512).update(update);
                (0, $741aad569b766a4c$export$d93e9c1fe0553512).render(render);
                valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                removeFromVariantTree === null || removeFromVariantTree === void 0 || removeFromVariantTree();
                parent === null || parent === void 0 || parent.children.delete(element);
                lifecycles.clearAllListeners();
                instance = undefined;
                isMounted = false;
            },
            /**
             * Add a child visual element to our set of children.
             */ addVariantChild: function(child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            },
            sortNodePosition: function(other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */ if (!sortNodePosition || treeType !== other.treeType) return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */ getClosestVariantNode: function() {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            /**
             * Expose the latest layoutId prop.
             */ getLayoutId: function() {
                return props.layoutId;
            },
            /**
             * Returns the current instance.
             */ getInstance: function() {
                return instance;
            },
            /**
             * Get/set the latest static values.
             */ getStaticValue: function(key) {
                return latestValues[key];
            },
            setStaticValue: function(key, value) {
                return latestValues[key] = value;
            },
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */ getLatestValues: function() {
                return latestValues;
            },
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */ setVisibility: function(visibility) {
                if (element.isVisible === visibility) return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */ makeTargetAnimatable: function(target, canMutate) {
                if (canMutate === void 0) canMutate = true;
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */ measureViewportBox: function() {
                return measureViewportBox(instance, props);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */ addValue: function(key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key)) element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */ removeValue: function(key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 || _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            /**
             * Check whether we have a motion value for this key
             */ hasValue: function(key) {
                return values.has(key);
            },
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */ getValue: function(key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $e32104bb79321603$export$ce8bdc721e76545f)(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            /**
             * Iterate over our motion values.
             */ forEachValue: function(callback) {
                return values.forEach(callback);
            },
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */ readValue: function(key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */ setBaseTarget: function(key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */ getBaseTarget: function(key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !(0, $55c3387a92452647$export$605d60a2578142d3)(target)) return target;
                }
                return baseTarget[key];
            }
        }, lifecycles), {
            /**
             * Build the renderer state based on the latest visual state.
             */ build: function() {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */ scheduleRender: function() {
                (0, $741aad569b766a4c$export$2e2bcd8739ae039).render(render, false, true);
            },
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */ syncRender: render,
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */ setProps: function(newProps) {
                if (newProps.transformTemplate || props.transformTemplate) element.scheduleRender();
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = (0, $69635cdb8982f9d2$export$9a552858d5197f6e)(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            },
            getProps: function() {
                return props;
            },
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */ getVariant: function(name) {
                var _a;
                return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name];
            },
            /**
             * Returns the defined default transition on this component.
             */ getDefaultTransition: function() {
                return props.transition;
            },
            getTransformPagePoint: function() {
                return props.transformPagePoint;
            },
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */ getVariantContext: function(startAtParent) {
                if (startAtParent === void 0) startAtParent = false;
                if (startAtParent) return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) context_1.initial = props.initial;
                    return context_1;
                }
                var context = {};
                for(var i = 0; i < $cb00410237ef0648$var$numVariantProps; i++){
                    var name_1 = $cb00410237ef0648$var$variantProps[i];
                    var prop = props[name_1];
                    if ((0, $0861f93f2aa87ed8$export$720b90e312cea233)(prop) || prop === false) context[name_1] = prop;
                }
                return context;
            }
        });
        return element;
    };
};
var $cb00410237ef0648$var$variantProps = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
    "initial"
], (0, $5c96a02c592fcff1$export$8d051b38c9118094)((0, $351ff45a987b08cc$export$16e45afcc206d3a8)), false);
var $cb00410237ef0648$var$numVariantProps = $cb00410237ef0648$var$variantProps.length;







function $ac0e5a3978f40f61$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $ac0e5a3978f40f61$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current) {
    var match = $ac0e5a3978f40f61$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    var _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(match, 3), token = _a[1], fallback = _a[2];
    return [
        token,
        fallback
    ];
}
var $ac0e5a3978f40f61$var$maxDepth = 4;
function $ac0e5a3978f40f61$var$getVariableValue(current, element, depth) {
    if (depth === void 0) depth = 1;
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(depth <= $ac0e5a3978f40f61$var$maxDepth, "Max CSS variable fallback depth detected in property \"".concat(current, "\". This may indicate a circular fallback dependency."));
    var _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)($ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($ac0e5a3978f40f61$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $ac0e5a3978f40f61$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $ac0e5a3978f40f61$export$669319b042b57350(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function(value) {
        var current = value.get();
        if (!$ac0e5a3978f40f61$var$isCSSVariable(current)) return;
        var resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(var key in target){
        var current = target[key];
        if (!$ac0e5a3978f40f61$var$isCSSVariable(current)) continue;
        var resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd) (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}








var $a731b8aa4fe311d9$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
var $a731b8aa4fe311d9$var$isPositionalKey = function(key) {
    return $a731b8aa4fe311d9$var$positionalKeys.has(key);
};
var $a731b8aa4fe311d9$var$hasPositionalKey = function(target) {
    return Object.keys(target).some($a731b8aa4fe311d9$var$isPositionalKey);
};
var $a731b8aa4fe311d9$var$setAndResetVelocity = function(value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var $a731b8aa4fe311d9$var$isNumOrPxType = function(v) {
    return v === (0, $b4f6d145fa485818$export$98e628dec113755e) || v === (0, $9ad32cb76340910d$export$91c0eda1d06bf008);
};
var $a731b8aa4fe311d9$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($a731b8aa4fe311d9$export$d0c75e4fa9e69db8 || ($a731b8aa4fe311d9$export$d0c75e4fa9e69db8 = {}));
var $a731b8aa4fe311d9$var$getPosFromMatrix = function(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var $a731b8aa4fe311d9$var$getTranslateFromMatrix = function(pos2, pos3) {
    return function(_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform) return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
};
var $a731b8aa4fe311d9$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $a731b8aa4fe311d9$var$nonTranslationalTransformKeys = (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).filter(function(key) {
    return !$a731b8aa4fe311d9$var$transformKeys.has(key);
});
function $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    $a731b8aa4fe311d9$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.syncRender();
    return removedTransforms;
}
var $a731b8aa4fe311d9$export$781d46a8aa670d52 = {
    // Dimensions
    width: function(_a, _b) {
        var x = _a.x;
        var _c = _b.paddingLeft, paddingLeft = _c === void 0 ? "0" : _c, _d = _b.paddingRight, paddingRight = _d === void 0 ? "0" : _d;
        return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function(_a, _b) {
        var y = _a.y;
        var _c = _b.paddingTop, paddingTop = _c === void 0 ? "0" : _c, _d = _b.paddingBottom, paddingBottom = _d === void 0 ? "0" : _d;
        return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function(_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function(_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function(_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: $a731b8aa4fe311d9$var$getTranslateFromMatrix(4, 13),
    y: $a731b8aa4fe311d9$var$getTranslateFromMatrix(5, 14)
};
var $a731b8aa4fe311d9$var$convertChangedValueTypes = function(target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display;
    var origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach(function(key) {
        origin[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function(key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        $a731b8aa4fe311d9$var$setAndResetVelocity(value, origin[key]);
        target[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes = function(visualElement, target, origin, transitionEnd) {
    if (origin === void 0) origin = {};
    if (transitionEnd === void 0) transitionEnd = {};
    target = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, target);
    transitionEnd = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter($a731b8aa4fe311d9$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        var from = origin[key];
        var fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
        var to = target[key];
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(to)) {
            var numKeyframes = to.length;
            var fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
            for(var i = fromIndex; i < numKeyframes; i++)if (!toType) {
                toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]);
                (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(toType === fromType || $a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)((0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $9ad32cb76340910d$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                $a731b8aa4fe311d9$var$setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var scrollY_1 = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        var convertedTarget = $a731b8aa4fe311d9$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(function(_a) {
            var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.syncRender();
        // Restore scroll position
        if (scrollY_1 !== null) window.scrollTo({
            top: scrollY_1
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $a731b8aa4fe311d9$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $a731b8aa4fe311d9$var$hasPositionalKey(target) ? $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ var $d9a589b84d5ec1d1$export$5849e743e29831d6 = function(visualElement, target, origin, transitionEnd) {
    var resolved = (0, $ac0e5a3978f40f61$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $a731b8aa4fe311d9$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};







function $f16d3e35a730d0e1$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $f16d3e35a730d0e1$export$985b1494d4aeee90 = {
    treeType: "dom",
    readValueFromInstance: function(domElement, key) {
        if ((0, $ac502869c4d3e65a$export$15240a8a4379d8de)(key)) {
            var defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            var computedStyle = $f16d3e35a730d0e1$export$3735103072e4a80(domElement);
            return ((0, $f9c5e88311214d2a$export$451bc42768436155)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        }
    },
    sortNodePosition: function(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function(element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return (0, $4ca2f8055771ddf4$export$d8718b6a7e5c624e)(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */ resetTransform: function(element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function(instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function(key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */ makeTargetAnimatable: function(element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) isMounted = true;
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "transition",
            "transitionEnd"
        ]);
        var origin = (0, $ea04fe669600292a$export$5a759dc7a1cfb72a)(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $ea04fe669600292a$export$6afbed164019a54c)(element, target, origin);
            var parsed = (0, $d9a589b84d5ec1d1$export$5849e743e29831d6)(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    },
    scrapeMotionValuesFromProps: (0, $a8ee53e44f8c4ac8$export$16da615486abaa45),
    build: function(element, renderState, latestValues, options, props) {
        if (element.isVisible !== undefined) renderState.style.visibility = element.isVisible ? "visible" : "hidden";
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)
};
var $f16d3e35a730d0e1$export$9509f7c142585e92 = (0, $cb00410237ef0648$export$5ad594e944c33d76)($f16d3e35a730d0e1$export$985b1494d4aeee90);












var $697788b593031f52$export$3ba8992de7b705bc = (0, $cb00410237ef0648$export$5ad594e944c33d76)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $f16d3e35a730d0e1$export$985b1494d4aeee90)), {
    getBaseTarget: function(props, key) {
        return props[key];
    },
    readValueFromInstance: function(domElement, key) {
        var _a;
        if ((0, $ac502869c4d3e65a$export$15240a8a4379d8de)(key)) return ((_a = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: (0, $eac085b45c9e0925$export$16da615486abaa45),
    build: function(_element, renderState, latestValues, options, props) {
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $9422342e44092cf6$export$c5f8399d19a7394b)
}));



var $2f8881102ac6dde9$export$56ba0183203348f5 = function(Component, options) {
    return (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $697788b593031f52$export$3ba8992de7b705bc)(options, {
        enableHardwareAcceleration: false
    }) : (0, $f16d3e35a730d0e1$export$9509f7c142585e92)(options, {
        enableHardwareAcceleration: true
    });
};





var $acw62 = parcelRequire("acw62");





function $967b202c839557ef$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ var $967b202c839557ef$export$5eafb6257a5844c = {
    correct: function(latest, node) {
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $9ad32cb76340910d$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ var x = $967b202c839557ef$export$fafff692be55225d(latest, node.target.x);
        var y = $967b202c839557ef$export$fafff692be55225d(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    }
};





var $a42cd9e0ef50cb70$var$varToken = "_$css";
var $a42cd9e0ef50cb70$export$eb0bc629e74dcf8 = {
    correct: function(latest, _a) {
        var treeScale = _a.treeScale, projectionDelta = _a.projectionDelta;
        var original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */ var containsCSSVariables = latest.includes("var(");
        var cssVariables = [];
        if (containsCSSVariables) latest = latest.replace((0, $ac0e5a3978f40f61$export$f7c0a352d8ef6313), function(match) {
            cssVariables.push(match);
            return $a42cd9e0ef50cb70$var$varToken;
        });
        var shadow = (0, $fe3e8d578aa8b27f$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        var template = (0, $fe3e8d578aa8b27f$export$83a0e34f1302825b).createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ var averageScale = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        var output = template(shadow);
        if (containsCSSVariables) {
            var i_1 = 0;
            output = output.replace($a42cd9e0ef50cb70$var$varToken, function() {
                var cssVariable = cssVariables[i_1];
                i_1++;
                return cssVariable;
            });
        }
        return output;
    }
};



var $cdf2a2ac04e7ce67$var$MeasureLayoutWithContext = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MeasureLayoutWithContext, _super);
    function MeasureLayoutWithContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ MeasureLayoutWithContext.prototype.componentDidMount = function() {
        var _this = this;
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, switchLayoutGroup = _a.switchLayoutGroup, layoutId = _a.layoutId;
        var projection = visualElement.projection;
        (0, $eced91e16bda42df$export$de9e7791c71225fd)($cdf2a2ac04e7ce67$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.add(projection);
            if ((switchLayoutGroup === null || switchLayoutGroup === void 0 ? void 0 : switchLayoutGroup.register) && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", function() {
                _this.safeToRemove();
            });
            projection.setOptions((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, projection.options), {
                onExitComplete: function() {
                    return _this.safeToRemove();
                }
            }));
        }
        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated = true;
    };
    MeasureLayoutWithContext.prototype.getSnapshotBeforeUpdate = function(prevProps) {
        var _this = this;
        var _a = this.props, layoutDependency = _a.layoutDependency, visualElement = _a.visualElement, drag = _a.drag, isPresent = _a.isPresent;
        var projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $741aad569b766a4c$export$2e2bcd8739ae039).postRender(function() {
                var _a;
                if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) _this.safeToRemove();
            });
        }
        return null;
    };
    MeasureLayoutWithContext.prototype.componentDidUpdate = function() {
        var projection = this.props.visualElement.projection;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
        }
    };
    MeasureLayoutWithContext.prototype.componentWillUnmount = function() {
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, promoteContext = _a.switchLayoutGroup;
        var projection = visualElement.projection;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister) promoteContext.deregister(projection);
        }
    };
    MeasureLayoutWithContext.prototype.safeToRemove = function() {
        var safeToRemove = this.props.safeToRemove;
        safeToRemove === null || safeToRemove === void 0 || safeToRemove();
    };
    MeasureLayoutWithContext.prototype.render = function() {
        return null;
    };
    return MeasureLayoutWithContext;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
function $cdf2a2ac04e7ce67$export$779f5fb01ad751cd(props) {
    var _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)((0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)(), 2), isPresent = _a[0], safeToRemove = _a[1];
    var layoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cdf2a2ac04e7ce67$var$MeasureLayoutWithContext, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}
var $cdf2a2ac04e7ce67$var$defaultScaleCorrectors = {
    borderRadius: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $967b202c839557ef$export$5eafb6257a5844c)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    boxShadow: (0, $a42cd9e0ef50cb70$export$eb0bc629e74dcf8)
};


var $2cb9ab33756189ff$export$518df03f164c507 = {
    measureLayout: (0, $cdf2a2ac04e7ce67$export$779f5fb01ad751cd)
};








/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */ function $1ef13963bb19565a$export$e3607ec2d7a891c4(from, to, transition) {
    if (transition === void 0) transition = {};
    var value = (0, $55c3387a92452647$export$605d60a2578142d3)(from) ? from : (0, $e32104bb79321603$export$ce8bdc721e76545f)(from);
    (0, $ec9bae3b9c638c7a$export$592dbd515a49cf1b)("", value, to, transition);
    return {
        stop: function() {
            return value.stop();
        },
        isAnimating: function() {
            return value.isAnimating();
        }
    };
}





var $82b1c16a20b13fa0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
var $82b1c16a20b13fa0$var$numBorders = $82b1c16a20b13fa0$var$borders.length;
var $82b1c16a20b13fa0$var$asNumber = function(value) {
    return typeof value === "string" ? parseFloat(value) : value;
};
var $82b1c16a20b13fa0$var$isPx = function(value) {
    return typeof value === "number" || (0, $9ad32cb76340910d$export$91c0eda1d06bf008).test(value);
};
function $82b1c16a20b13fa0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _a, _b, _c, _d;
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(0, // (follow?.opacity as number) ?? 0,
        // TODO Reinstate this if only child
        (_a = lead.opacity) !== null && _a !== void 0 ? _a : 1, $82b1c16a20b13fa0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)((_b = follow.opacity) !== null && _b !== void 0 ? _b : 1, 0, $82b1c16a20b13fa0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)((_c = follow.opacity) !== null && _c !== void 0 ? _c : 1, (_d = lead.opacity) !== null && _d !== void 0 ? _d : 1, progress);
    /**
     * Mix border radius
     */ for(var i = 0; i < $82b1c16a20b13fa0$var$numBorders; i++){
        var borderLabel = "border".concat($82b1c16a20b13fa0$var$borders[i], "Radius");
        var followRadius = $82b1c16a20b13fa0$var$getRadius(follow, borderLabel);
        var leadRadius = $82b1c16a20b13fa0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        var canMix = followRadius === 0 || leadRadius === 0 || $82b1c16a20b13fa0$var$isPx(followRadius) === $82b1c16a20b13fa0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $9e031a435715a19b$export$2c9e8a9632a706b2)($82b1c16a20b13fa0$var$asNumber(followRadius), $82b1c16a20b13fa0$var$asNumber(leadRadius), progress), 0);
            if ((0, $9ad32cb76340910d$export$626336c2cd4b14de).test(leadRadius) || (0, $9ad32cb76340910d$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $82b1c16a20b13fa0$var$getRadius(values, radiusName) {
    var _a;
    return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
var $82b1c16a20b13fa0$var$easeCrossfadeIn = $82b1c16a20b13fa0$var$compress(0, 0.5, (0, $d43a9d278bbed66c$export$c8d67a19199d1a50));
var $82b1c16a20b13fa0$var$easeCrossfadeOut = $82b1c16a20b13fa0$var$compress(0.5, 0.95, (0, $d43a9d278bbed66c$export$45db2fc2f15997e7));
function $82b1c16a20b13fa0$var$compress(min, max, easing) {
    return function(p) {
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $8719e706e42e5d1d$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$c53fd88f45d77e4b(box, originBox) {
    $5960d81994414d5a$export$a0230ae482601ae8(box.x, originBox.x);
    $5960d81994414d5a$export$a0230ae482601ae8(box.y, originBox.y);
}








/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $db628fcc785b8b87$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, translate, scale, origin, boxScale, originAxis, sourceAxis) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    if (origin === void 0) origin = 0.5;
    if (originAxis === void 0) originAxis = axis;
    if (sourceAxis === void 0) sourceAxis = axis;
    if ((0, $9ad32cb76340910d$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    var originPoint = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $db628fcc785b8b87$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $db628fcc785b8b87$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$42b76f1d0d16d5b(axis, transforms, _a, origin, sourceAxis) {
    var _b = (0, $5c96a02c592fcff1$export$8d051b38c9118094)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $db628fcc785b8b87$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $db628fcc785b8b87$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.x, transforms, $db628fcc785b8b87$var$xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.y, transforms, $db628fcc785b8b87$var$yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}




function $b070f9c5f268d45c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $b070f9c5f268d45c$export$a7ec7642fe550fb6(delta) {
    return $b070f9c5f268d45c$var$isAxisDeltaZero(delta.x) && $b070f9c5f268d45c$var$isAxisDeltaZero(delta.y);
}
function $b070f9c5f268d45c$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}



var $a040ab986103db06$export$39be5b2d82fc9dc7 = /** @class */ function() {
    function NodeStack() {
        this.members = [];
    }
    NodeStack.prototype.add = function(node) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    };
    NodeStack.prototype.remove = function(node) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            var prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    };
    NodeStack.prototype.relegate = function(node) {
        var indexOfNode = this.members.findIndex(function(member) {
            return node === member;
        });
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ var prevLead;
        for(var i = indexOfNode; i >= 0; i--){
            var member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    };
    NodeStack.prototype.promote = function(node, preserveFollowOpacity) {
        var _a;
        var prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                node.snapshot.isShared = true;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) node.isLayoutDirty = true;
            var crossfade = node.options.crossfade;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    };
    NodeStack.prototype.exitAnimationComplete = function() {
        this.members.forEach(function(node) {
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 || _e.call(_d);
        });
    };
    NodeStack.prototype.scheduleRender = function() {
        this.members.forEach(function(node) {
            node.instance && node.scheduleRender(false);
        });
    };
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ NodeStack.prototype.removeLeadSnapshot = function() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    };
    return NodeStack;
}();



var $0214cdf9d4bb801d$export$f6730f82d2dcfda3 = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function $0214cdf9d4bb801d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, 0) ");
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate) transform += "rotate(".concat(rotate, "deg) ");
        if (rotateX) transform += "rotateX(".concat(rotateX, "deg) ");
        if (rotateY) transform += "rotateY(".concat(rotateY, "deg) ");
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ var elementScaleX = delta.x.scale * treeScale.x;
    var elementScaleY = delta.y.scale * treeScale.y;
    transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
    return transform === $0214cdf9d4bb801d$export$f6730f82d2dcfda3 ? "none" : transform;
}






var $8e214807702da081$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};


var $e21f5e6c9473a18c$export$1465d17e3de78a96 = /** @class */ function() {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function(child) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function(child) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function(callback) {
        this.isDirty && this.children.sort((0, $8e214807702da081$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}();




/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ var $d2ca41ba1b84bcfe$var$animationTarget = 1000;
function $d2ca41ba1b84bcfe$export$a84b61f69daa9da0(_a) {
    var attachResizeListener = _a.attachResizeListener, defaultParent = _a.defaultParent, measureScroll = _a.measureScroll, checkIsScrollRoot = _a.checkIsScrollRoot, resetTransform = _a.resetTransform;
    return /** @class */ function() {
        function ProjectionNode(id, latestValues, parent) {
            var _this = this;
            if (latestValues === void 0) latestValues = {};
            if (parent === void 0) parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to actually
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = function() {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            this.updateProjection = function() {
                _this.nodes.forEach($d2ca41ba1b84bcfe$var$resolveTargetDelta);
                _this.nodes.forEach($d2ca41ba1b84bcfe$var$calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.id = id;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(parent.path), false), [
                parent
            ], false) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            id && this.root.registerPotentialNode(id, this);
            for(var i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e21f5e6c9473a18c$export$1465d17e3de78a96)();
        }
        ProjectionNode.prototype.addEventListener = function(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        };
        ProjectionNode.prototype.notifyListeners = function(name) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 || subscriptionManager.notify.apply(subscriptionManager, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args), false));
        };
        ProjectionNode.prototype.hasListeners = function(name) {
            return this.eventHandlers.has(name);
        };
        ProjectionNode.prototype.registerPotentialNode = function(id, node) {
            this.potentialNodes.set(id, node);
        };
        /**
         * Lifecycles
         */ ProjectionNode.prototype.mount = function(instance, isLayoutDirty) {
            var _this = this;
            var _a;
            if (isLayoutDirty === void 0) isLayoutDirty = false;
            if (this.instance) return;
            this.isSVG = instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            var _b = this.options, layoutId = _b.layoutId, layout = _b.layout, visualElement = _b.visualElement;
            if (visualElement && !visualElement.getInstance()) visualElement.mount(instance);
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 || _a.children.add(this);
            this.id && this.root.potentialNodes.delete(this.id);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                var unblockTimeout_1;
                var resizeUnblockUpdate_1 = function() {
                    return _this.root.updateBlockedByResize = false;
                };
                attachResizeListener(instance, function() {
                    _this.root.updateBlockedByResize = true;
                    clearTimeout(unblockTimeout_1);
                    unblockTimeout_1 = window.setTimeout(resizeUnblockUpdate_1, 250);
                    if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        _this.nodes.forEach($d2ca41ba1b84bcfe$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", function(_a) {
                var _b, _c, _d, _e, _f;
                var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged, hasRelativeTargetChanged = _a.hasRelativeTargetChanged, newLayout = _a.layout;
                if (_this.isTreeAnimationBlocked()) {
                    _this.target = undefined;
                    _this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                var layoutTransition = (_c = (_b = _this.options.transition) !== null && _b !== void 0 ? _b : visualElement.getDefaultTransition()) !== null && _c !== void 0 ? _c : $d2ca41ba1b84bcfe$var$defaultLayoutTransition;
                var _g = visualElement.getProps(), onLayoutAnimationStart = _g.onLayoutAnimationStart, onLayoutAnimationComplete = _g.onLayoutAnimationComplete;
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ var targetChanged = !_this.targetLayout || !(0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(_this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (((_d = _this.resumeFrom) === null || _d === void 0 ? void 0 : _d.instance) || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !_this.currentAnimation)) {
                    if (_this.resumeFrom) {
                        _this.resumingFrom = _this.resumeFrom;
                        _this.resumingFrom.resumingFrom = undefined;
                    }
                    _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    var animationOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $ec9bae3b9c638c7a$export$7c1391340308742e)(layoutTransition, "layout")), {
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    });
                    if (visualElement.shouldReduceMotion) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    _this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged && _this.animationProgress === 0) _this.finishAnimation();
                    _this.isLead() && ((_f = (_e = _this.options).onExitComplete) === null || _f === void 0 || _f.call(_e));
                }
                _this.targetLayout = newLayout;
            });
        };
        ProjectionNode.prototype.unmount = function() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 || _a.remove(this);
            (_b = this.parent) === null || _b === void 0 || _b.children.delete(this);
            this.instance = undefined;
            (0, $741aad569b766a4c$export$d93e9c1fe0553512).preRender(this.updateProjection);
        };
        // only on the root
        ProjectionNode.prototype.blockUpdate = function() {
            this.updateManuallyBlocked = true;
        };
        ProjectionNode.prototype.unblockUpdate = function() {
            this.updateManuallyBlocked = false;
        };
        ProjectionNode.prototype.isUpdateBlocked = function() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        };
        ProjectionNode.prototype.isTreeAnimationBlocked = function() {
            var _a;
            return this.isAnimationBlocked || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) || false;
        };
        // Note: currently only running on root node
        ProjectionNode.prototype.startUpdate = function() {
            var _a;
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 || _a.forEach($d2ca41ba1b84bcfe$var$resetRotation);
        };
        ProjectionNode.prototype.willUpdate = function(shouldNotifyListeners) {
            var _a, _b, _c;
            if (shouldNotifyListeners === void 0) shouldNotifyListeners = true;
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * TODO: Check we haven't updated the scroll
                 * since the last didUpdate
                 */ node.updateScroll();
            }
            var _d = this.options, layoutId = _d.layoutId, layout = _d.layout;
            if (layoutId === undefined && !layout) return;
            var transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        };
        // Note: Currently only running on root node
        ProjectionNode.prototype.didUpdate = function() {
            var updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */ if (this.potentialNodes.size) {
                this.potentialNodes.forEach($d2ca41ba1b84bcfe$var$mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */ this.nodes.forEach($d2ca41ba1b84bcfe$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($d2ca41ba1b84bcfe$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($d2ca41ba1b84bcfe$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            (0, $741aad569b766a4c$export$cd75ccfd720a3cd4).update();
            (0, $741aad569b766a4c$export$cd75ccfd720a3cd4).preRender();
            (0, $741aad569b766a4c$export$cd75ccfd720a3cd4).render();
        };
        ProjectionNode.prototype.clearAllSnapshots = function() {
            this.nodes.forEach($d2ca41ba1b84bcfe$var$clearSnapshot);
            this.sharedNodes.forEach($d2ca41ba1b84bcfe$var$removeLeadSnapshots);
        };
        ProjectionNode.prototype.scheduleUpdateProjection = function() {
            (0, $741aad569b766a4c$export$2e2bcd8739ae039).preRender(this.updateProjection, false, true);
        };
        ProjectionNode.prototype.scheduleCheckAfterUnmount = function() {
            var _this = this;
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $741aad569b766a4c$export$2e2bcd8739ae039).postRender(function() {
                if (_this.isLayoutDirty) _this.root.didUpdate();
                else _this.root.checkUpdateFailed();
            });
        };
        /**
         * Update measurements
         */ ProjectionNode.prototype.updateSnapshot = function() {
            if (this.snapshot || !this.instance) return;
            var measured = this.measure();
            var layout = this.removeTransform(this.removeElementScroll(measured));
            $d2ca41ba1b84bcfe$var$roundBox(layout);
            this.snapshot = {
                measured: measured,
                layout: layout,
                latestValues: {}
            };
        };
        ProjectionNode.prototype.updateLayout = function() {
            var _a;
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.updateScroll();
            }
            var measured = this.measure();
            $d2ca41ba1b84bcfe$var$roundBox(measured);
            var prevLayout = this.layout;
            this.layout = {
                measured: measured,
                actual: this.removeElementScroll(measured)
            };
            this.layoutCorrected = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.actual);
            (_a = this.options.visualElement) === null || _a === void 0 || _a.notifyLayoutMeasure(this.layout.actual, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.actual);
        };
        ProjectionNode.prototype.updateScroll = function() {
            if (this.options.layoutScroll && this.instance) {
                this.isScrollRoot = checkIsScrollRoot(this.instance);
                this.scroll = measureScroll(this.instance);
            }
        };
        ProjectionNode.prototype.resetTransform = function() {
            var _a;
            if (!resetTransform) return;
            var isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            var hasProjection = this.projectionDelta && !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(this.projectionDelta);
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            var transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        };
        ProjectionNode.prototype.measure = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            var box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            var scroll = this.root.scroll;
            if (scroll) {
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.x, scroll.x);
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.y, scroll.y);
            }
            return box;
        };
        ProjectionNode.prototype.removeElementScroll = function(box) {
            var boxWithoutScroll = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                var scroll_1 = node.scroll, options = node.options, isScrollRoot = node.isScrollRoot;
                if (node !== this.root && scroll_1 && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (isScrollRoot) {
                        (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        var rootScroll = this.root.scroll;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.x);
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.y);
                        }
                    }
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll_1.x);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll_1.y);
                }
            }
            return boxWithoutScroll;
        };
        ProjectionNode.prototype.applyTransform = function(box, transformOnly) {
            if (transformOnly === void 0) transformOnly = false;
            var withTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(withTransforms, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.x,
                    y: -node.scroll.y
                });
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        };
        ProjectionNode.prototype.removeTransform = function(box) {
            var _a;
            var boxWithoutTransform = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                var sourceBox = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                var nodeBox = node.measure();
                (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layout, sourceBox);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        };
        /**
         *
         */ ProjectionNode.prototype.setTargetDelta = function(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
        };
        ProjectionNode.prototype.setOptions = function(options) {
            var _a;
            this.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options), options), {
                crossfade: (_a = options.crossfade) !== null && _a !== void 0 ? _a : true
            });
        };
        ProjectionNode.prototype.clearMeasurements = function() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        };
        /**
         * Frame calculations
         */ ProjectionNode.prototype.resolveTargetDelta = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && this.relativeParent.layout) {
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) (0, $b352f7cdd42c49d7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.actual);
                else (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.actual);
                (0, $d8332eb74969584e$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.actual);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && Boolean(this.relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !this.relativeParent.options.layoutScroll && this.relativeParent.target) {
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, this.relativeParent.target);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
        };
        ProjectionNode.prototype.getClosestProjectingParent = function() {
            if (!this.parent || (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.parent.latestValues)) return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout) return this.parent;
            else return this.parent.getClosestProjectingParent();
        };
        ProjectionNode.prototype.calcProjection = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            var lead = this.getLead();
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.actual);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d8332eb74969584e$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, Boolean(this.resumingFrom) || this !== lead);
            var target = lead.target;
            if (!target) return;
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            }
            var prevTreeScaleX = this.treeScale.x;
            var prevTreeScaleY = this.treeScale.y;
            var prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        };
        ProjectionNode.prototype.hide = function() {
            this.isVisible = false;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.show = function() {
            this.isVisible = true;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.scheduleRender = function(notifyAll) {
            var _a, _b, _c;
            if (notifyAll === void 0) notifyAll = true;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 || _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 || _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        };
        ProjectionNode.prototype.setAnimationOrigin = function(delta, hasOnlyRelativeTargetChanged) {
            var _this = this;
            var _a;
            if (hasOnlyRelativeTargetChanged === void 0) hasOnlyRelativeTargetChanged = false;
            var snapshot = this.snapshot;
            var snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            var mixedValues = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.latestValues);
            var targetDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            var relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            var isSharedLayoutAnimation = snapshot === null || snapshot === void 0 ? void 0 : snapshot.isShared;
            var isOnlyMember = (((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.members.length) || 0) <= 1;
            var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d2ca41ba1b84bcfe$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            this.mixTargetDelta = function(latest) {
                var _a;
                var progress = latest / 1000;
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                _this.setTargetDelta(targetDelta);
                if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && ((_a = _this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, _this.layout.actual, _this.relativeParent.layout.actual);
                    $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    _this.animationValues = mixedValues;
                    (0, $82b1c16a20b13fa0$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                _this.root.scheduleUpdateProjection();
                _this.scheduleRender();
                _this.animationProgress = progress;
            };
            this.mixTargetDelta(0);
        };
        ProjectionNode.prototype.startAnimation = function(options) {
            var _this = this;
            var _a, _b;
            this.notifyListeners("animationStart");
            (_a = this.currentAnimation) === null || _a === void 0 || _a.stop();
            if (this.resumingFrom) (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 || _b.stop();
            if (this.pendingAnimation) {
                (0, $741aad569b766a4c$export$d93e9c1fe0553512).update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $741aad569b766a4c$export$2e2bcd8739ae039).update(function() {
                (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                _this.currentAnimation = (0, $1ef13963bb19565a$export$e3607ec2d7a891c4)(0, $d2ca41ba1b84bcfe$var$animationTarget, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                    onUpdate: function(latest) {
                        var _a;
                        _this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, latest);
                    },
                    onComplete: function() {
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 || _a.call(options);
                        _this.completeAnimation();
                    }
                }));
                if (_this.resumingFrom) _this.resumingFrom.currentAnimation = _this.currentAnimation;
                _this.pendingAnimation = undefined;
            });
        };
        ProjectionNode.prototype.completeAnimation = function() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 || _a.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        };
        ProjectionNode.prototype.finishAnimation = function() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 || _a.call(this, $d2ca41ba1b84bcfe$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        };
        ProjectionNode.prototype.applyTransformsToTarget = function() {
            var _a = this.getLead(), targetWithTransforms = _a.targetWithTransforms, target = _a.target, layout = _a.layout, latestValues = _a.latestValues;
            if (!targetWithTransforms || !target || !layout) return;
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d8332eb74969584e$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its actual layout
             * into the desired bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        };
        ProjectionNode.prototype.registerSharedNode = function(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $a040ab986103db06$export$39be5b2d82fc9dc7)());
            var stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node)
            });
        };
        ProjectionNode.prototype.isLead = function() {
            var stack = this.getStack();
            return stack ? stack.lead === this : true;
        };
        ProjectionNode.prototype.getLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        };
        ProjectionNode.prototype.getPrevLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        };
        ProjectionNode.prototype.getStack = function() {
            var layoutId = this.options.layoutId;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        };
        ProjectionNode.prototype.promote = function(_a) {
            var _b = _a === void 0 ? {} : _a, needsReset = _b.needsReset, transition = _b.transition, preserveFollowOpacity = _b.preserveFollowOpacity;
            var stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        };
        ProjectionNode.prototype.relegate = function() {
            var stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        };
        ProjectionNode.prototype.resetRotation = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            var hasRotate = false;
            // Keep a record of all the values we've reset
            var resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(var i = 0; i < (0, $ac502869c4d3e65a$export$67cd428da31419e1).length; i++){
                var axis = (0, $ac502869c4d3e65a$export$67cd428da31419e1)[i];
                var key = "rotate" + axis;
                // If this rotation doesn't exist as a motion value, then we don't
                // need to reset it
                if (!visualElement.getStaticValue(key)) continue;
                hasRotate = true;
                // Record the rotation and then temporarily set it to 0
                resetValues[key] = visualElement.getStaticValue(key);
                visualElement.setStaticValue(key, 0);
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 || visualElement.syncRender();
            // Put back all the values we reset
            for(var key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        };
        ProjectionNode.prototype.getProjectionStyles = function(styleProp) {
            var _a, _b, _c, _d, _e, _f;
            if (styleProp === void 0) styleProp = {};
            // TODO: Return lifecycle-persistent object
            var styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            var lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                var emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = (_b = this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1;
                    emptyStyles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            var valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            var _g = this.projectionDelta, x = _g.x, y = _g.y;
            styles.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_d = (_c = valuesToRender.opacity) !== null && _c !== void 0 ? _c : this.latestValues.opacity) !== null && _d !== void 0 ? _d : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its actual
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? (_e = valuesToRender.opacity) !== null && _e !== void 0 ? _e : "" : (_f = valuesToRender.opacityExit) !== null && _f !== void 0 ? _f : 0;
            /**
             * Apply scale correction
             */ for(var key in 0, $eced91e16bda42df$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                var _h = (0, $eced91e16bda42df$export$91ddd985b97788d1)[key], correct = _h.correct, applyTo = _h.applyTo;
                var corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    var num = applyTo.length;
                    for(var i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        };
        ProjectionNode.prototype.clearSnapshot = function() {
            this.resumeFrom = this.snapshot = undefined;
        };
        // Only run on root
        ProjectionNode.prototype.resetTree = function() {
            this.root.nodes.forEach(function(node) {
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
            this.root.sharedNodes.clear();
        };
        return ProjectionNode;
    }();
}
function $d2ca41ba1b84bcfe$var$updateLayout(node) {
    node.updateLayout();
}
function $d2ca41ba1b84bcfe$var$notifyLayoutUpdate(node) {
    var _a, _b, _c, _d;
    var snapshot = (_b = (_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) !== null && _b !== void 0 ? _b : node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        var _e = node.layout, layout_1 = _e.actual, measuredLayout = _e.measured;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (node.options.animationType === "size") (0, $247f90d2510fbc55$export$b789de563eb43b1)(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout_1[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (node.options.animationType === "position") (0, $247f90d2510fbc55$export$b789de563eb43b1)(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(layout_1[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
        });
        var layoutDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(layoutDelta, layout_1, snapshot.layout);
        var visualDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        if (snapshot.isShared) (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measured);
        else (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, layout_1, snapshot.layout);
        var hasLayoutChanged = !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(layoutDelta);
        var hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            node.relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (node.relativeParent && !node.relativeParent.resumeFrom) {
                var _f = node.relativeParent, parentSnapshot = _f.snapshot, parentLayout = _f.layout;
                if (parentSnapshot && parentLayout) {
                    var relativeSnapshot = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layout, parentSnapshot.layout);
                    var relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, layout_1, parentLayout.actual);
                    if (!(0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout_1,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) (_d = (_c = node.options).onExitComplete) === null || _d === void 0 || _d.call(_c);
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d2ca41ba1b84bcfe$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d2ca41ba1b84bcfe$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d2ca41ba1b84bcfe$var$resetTransformStyle(node) {
    var visualElement = node.options.visualElement;
    if (visualElement === null || visualElement === void 0 ? void 0 : visualElement.getProps().onBeforeLayoutMeasure) visualElement.notifyBeforeLayoutMeasure();
    node.resetTransform();
}
function $d2ca41ba1b84bcfe$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function $d2ca41ba1b84bcfe$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d2ca41ba1b84bcfe$var$calcProjection(node) {
    node.calcProjection();
}
function $d2ca41ba1b84bcfe$var$resetRotation(node) {
    node.resetRotation();
}
function $d2ca41ba1b84bcfe$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $9e031a435715a19b$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(output, from, to, p) {
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d2ca41ba1b84bcfe$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
var $d2ca41ba1b84bcfe$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $d2ca41ba1b84bcfe$var$mountNodeEarly(node, id) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */ var searchNode = node.root;
    for(var i = node.path.length - 1; i >= 0; i--)if (Boolean(node.path[i].instance)) {
        searchNode = node.path[i];
        break;
    }
    var searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    var element = searchElement.querySelector("[data-projection-id=\"".concat(id, "\"]"));
    if (element) node.mount(element, true);
}
function $d2ca41ba1b84bcfe$var$roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function $d2ca41ba1b84bcfe$var$roundBox(box) {
    $d2ca41ba1b84bcfe$var$roundAxis(box.x);
    $d2ca41ba1b84bcfe$var$roundAxis(box.y);
}




var $6e97f3a9a89d5fc1$export$2d029a49a09b6177 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    attachResizeListener: function(ref, notify) {
        return (0, $cba4f237926ffdf7$export$b1d829ddf82884aa)(ref, "resize", notify);
    },
    measureScroll: function() {
        return {
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        };
    },
    checkIsScrollRoot: function() {
        return true;
    }
});


var $a3289660bde9b219$export$b91509fcf893b648 = {
    current: undefined
};
var $a3289660bde9b219$export$b61a9eb3dbde8858 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    measureScroll: function(instance) {
        return {
            x: instance.scrollLeft,
            y: instance.scrollTop
        };
    },
    defaultParent: function() {
        if (!$a3289660bde9b219$export$b91509fcf893b648.current) {
            var documentNode = new (0, $6e97f3a9a89d5fc1$export$2d029a49a09b6177)(0, {});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a3289660bde9b219$export$b91509fcf893b648.current = documentNode;
        }
        return $a3289660bde9b219$export$b91509fcf893b648.current;
    },
    resetTransform: function(instance, value) {
        instance.style.transform = value !== null && value !== void 0 ? value : "none";
    },
    checkIsScrollRoot: function(instance) {
        return Boolean(window.getComputedStyle(instance).position === "fixed");
    }
});


var $a93b6401f922fd1e$var$featureBundle = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $03e8b675a1009b68$export$7f9953c70dacfd7f)), (0, $5e115984cd871deb$export$e5b72898e5a201f1)), (0, $fc1974bcfc4fde1a$export$d7d5d435647ed5a0)), (0, $2cb9ab33756189ff$export$518df03f164c507));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ var $a93b6401f922fd1e$export$e25e478948902b8b = /*@__PURE__*/ (0, $16a09bb264d348bb$export$a28d6df673050e18)(function(Component, config) {
    return (0, $73e3a8d89278ed7b$export$732916c0e88175fb)(Component, config, $a93b6401f922fd1e$var$featureBundle, (0, $2f8881102ac6dde9$export$56ba0183203348f5), (0, $a3289660bde9b219$export$b61a9eb3dbde8858));
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $a93b6401f922fd1e$export$546614c4a05701f9(key) {
    return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)((0, $73e3a8d89278ed7b$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $a93b6401f922fd1e$var$featureBundle, (0, $2f8881102ac6dde9$export$56ba0183203348f5), (0, $a3289660bde9b219$export$b61a9eb3dbde8858)));
}



var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


var $85fc2fe65ff21506$exports = {};
'use strict';
Object.defineProperty($85fc2fe65ff21506$exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Concatenates two arrays faster than the array spread operator.
 */ const $85fc2fe65ff21506$var$concatArrays = (array1, array2)=>{
    // Pre-allocate for better V8 optimization
    const combinedArray = new Array(array1.length + array2.length);
    for(let i = 0; i < array1.length; i++)combinedArray[i] = array1[i];
    for(let i = 0; i < array2.length; i++)combinedArray[array1.length + i] = array2[i];
    return combinedArray;
};
// Factory function ensures consistent object shapes
const $85fc2fe65ff21506$var$createClassValidatorObject = (classGroupId, validator)=>({
        classGroupId: classGroupId,
        validator: validator
    });
// Factory ensures consistent ClassPartObject shape
const $85fc2fe65ff21506$var$createClassPartObject = (nextPart = new Map(), validators = null, classGroupId)=>({
        nextPart: nextPart,
        validators: validators,
        classGroupId: classGroupId
    });
const $85fc2fe65ff21506$var$CLASS_PART_SEPARATOR = '-';
const $85fc2fe65ff21506$var$EMPTY_CONFLICTS = [];
// I use two dots here because one dot is used as prefix for class groups in plugins
const $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX = 'arbitrary..';
const $85fc2fe65ff21506$var$createClassGroupUtils = (config)=>{
    const classMap = $85fc2fe65ff21506$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        if (className.startsWith('[') && className.endsWith(']')) return $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty(className);
        const classParts = className.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and skip it.
        const startIndex = classParts[0] === '' && classParts.length > 1 ? 1 : 0;
        return $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex, classMap);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        if (hasPostfixModifier) {
            const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
            const baseConflicts = conflictingClassGroups[classGroupId];
            if (modifierConflicts) {
                if (baseConflicts) // Merge base conflicts with modifier conflicts
                return $85fc2fe65ff21506$var$concatArrays(baseConflicts, modifierConflicts);
                // Only modifier conflicts
                return modifierConflicts;
            }
            // Fall back to without postfix if no modifier conflicts
            return baseConflicts || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
        }
        return conflictingClassGroups[classGroupId] || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $85fc2fe65ff21506$var$getGroupRecursive = (classParts, startIndex, classPartObject)=>{
    const classPathsLength = classParts.length - startIndex;
    if (classPathsLength === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[startIndex];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    if (nextClassPartObject) {
        const result = $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
        if (result) return result;
    }
    const validators = classPartObject.validators;
    if (validators === null) return undefined;
    // Build classRest string efficiently by joining from startIndex onwards
    const classRest = startIndex === 0 ? classParts.join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const validatorsLength = validators.length;
    for(let i = 0; i < validatorsLength; i++){
        const validatorObj = validators[i];
        if (validatorObj.validator(classRest)) return validatorObj.classGroupId;
    }
    return undefined;
};
/**
 * Get the class group ID for an arbitrary property.
 *
 * @param className - The class name to get the group ID for. Is expected to be string starting with `[` and ending with `]`.
 */ const $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty = (className)=>className.slice(1, -1).indexOf(':') === -1 ? undefined : (()=>{
        const content = className.slice(1, -1);
        const colonIndex = content.indexOf(':');
        const property = content.slice(0, colonIndex);
        return property ? $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX + property : undefined;
    })();
/**
 * Exported for testing only
 */ const $85fc2fe65ff21506$var$createClassMap = (config)=>{
    const { theme: theme, classGroups: classGroups } = config;
    return $85fc2fe65ff21506$var$processClassGroups(classGroups, theme);
};
// Split into separate functions to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassGroups = (classGroups, theme)=>{
    const classMap = $85fc2fe65ff21506$var$createClassPartObject();
    for(const classGroupId in classGroups){
        const group = classGroups[classGroupId];
        $85fc2fe65ff21506$var$processClassesRecursively(group, classMap, classGroupId, theme);
    }
    return classMap;
};
const $85fc2fe65ff21506$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    const len = classGroup.length;
    for(let i = 0; i < len; i++){
        const classDefinition = classGroup[i];
        $85fc2fe65ff21506$var$processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
    }
};
// Split into separate functions for each type to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if (typeof classDefinition === 'string') {
        $85fc2fe65ff21506$var$processStringDefinition(classDefinition, classPartObject, classGroupId);
        return;
    }
    if (typeof classDefinition === 'function') {
        $85fc2fe65ff21506$var$processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
        return;
    }
    $85fc2fe65ff21506$var$processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
const $85fc2fe65ff21506$var$processStringDefinition = (classDefinition, classPartObject, classGroupId)=>{
    const classPartObjectToEdit = classDefinition === '' ? classPartObject : $85fc2fe65ff21506$var$getPart(classPartObject, classDefinition);
    classPartObjectToEdit.classGroupId = classGroupId;
};
const $85fc2fe65ff21506$var$processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if ($85fc2fe65ff21506$var$isThemeGetter(classDefinition)) {
        $85fc2fe65ff21506$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
    }
    if (classPartObject.validators === null) classPartObject.validators = [];
    classPartObject.validators.push($85fc2fe65ff21506$var$createClassValidatorObject(classGroupId, classDefinition));
};
const $85fc2fe65ff21506$var$processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    const entries = Object.entries(classDefinition);
    const len = entries.length;
    for(let i = 0; i < len; i++){
        const [key, value] = entries[i];
        $85fc2fe65ff21506$var$processClassesRecursively(value, $85fc2fe65ff21506$var$getPart(classPartObject, key), classGroupId, theme);
    }
};
const $85fc2fe65ff21506$var$getPart = (classPartObject, path)=>{
    let current = classPartObject;
    const parts = path.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const len = parts.length;
    for(let i = 0; i < len; i++){
        const part = parts[i];
        let next = current.nextPart.get(part);
        if (!next) {
            next = $85fc2fe65ff21506$var$createClassPartObject();
            current.nextPart.set(part, next);
        }
        current = next;
    }
    return current;
};
// Type guard maintains monomorphic check
const $85fc2fe65ff21506$var$isThemeGetter = (func)=>'isThemeGetter' in func && func.isThemeGetter === true;
// LRU cache implementation using plain objects for simplicity
const $85fc2fe65ff21506$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = Object.create(null);
    let previousCache = Object.create(null);
    const update = (key, value)=>{
        cache[key] = value;
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = Object.create(null);
        }
    };
    return {
        get (key) {
            let value = cache[key];
            if (value !== undefined) return value;
            if ((value = previousCache[key]) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (key in cache) cache[key] = value;
            else update(key, value);
        }
    };
};
const $85fc2fe65ff21506$var$IMPORTANT_MODIFIER = '!';
const $85fc2fe65ff21506$var$MODIFIER_SEPARATOR = ':';
const $85fc2fe65ff21506$var$EMPTY_MODIFIERS = [];
// Pre-allocated result object shape for consistency
const $85fc2fe65ff21506$var$createResultObject = (modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal)=>({
        modifiers: modifiers,
        hasImportantModifier: hasImportantModifier,
        baseClassName: baseClassName,
        maybePostfixModifierPosition: maybePostfixModifierPosition,
        isExternal: isExternal
    });
const $85fc2fe65ff21506$var$createParseClassName = (config)=>{
    const { prefix: prefix, experimentalParseClassName: experimentalParseClassName } = config;
    /**
   * Parse class name into parts.
   *
   * Inspired by `splitAtTopLevelOnly` used in Tailwind CSS
   * @see https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
   */ let parseClassName = (className)=>{
        // Use simple array with push for better performance
        const modifiers = [];
        let bracketDepth = 0;
        let parenDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        const len = className.length;
        for(let index = 0; index < len; index++){
            const currentCharacter = className[index];
            if (bracketDepth === 0 && parenDepth === 0) {
                if (currentCharacter === $85fc2fe65ff21506$var$MODIFIER_SEPARATOR) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + 1;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
            else if (currentCharacter === '(') parenDepth++;
            else if (currentCharacter === ')') parenDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
        // Inline important modifier check
        let baseClassName = baseClassNameWithImportantModifier;
        let hasImportantModifier = false;
        if (baseClassNameWithImportantModifier.endsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
            hasImportantModifier = true;
        } else if (/**
     * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
     * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
     */ baseClassNameWithImportantModifier.startsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(1);
            hasImportantModifier = true;
        }
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return $85fc2fe65ff21506$var$createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
    };
    if (prefix) {
        const fullPrefix = prefix + $85fc2fe65ff21506$var$MODIFIER_SEPARATOR;
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : $85fc2fe65ff21506$var$createResultObject($85fc2fe65ff21506$var$EMPTY_MODIFIERS, false, className, undefined, true);
    }
    if (experimentalParseClassName) {
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>experimentalParseClassName({
                className: className,
                parseClassName: parseClassNameOriginal
            });
    }
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $85fc2fe65ff21506$var$createSortModifiers = (config)=>{
    // Pre-compute weights for all known modifiers for O(1) comparison
    const modifierWeights = new Map();
    // Assign weights to sensitive modifiers (highest priority, but preserve order)
    config.orderSensitiveModifiers.forEach((mod, index)=>{
        modifierWeights.set(mod, 1000000 + index); // High weights for sensitive mods
    });
    return (modifiers)=>{
        const result = [];
        let currentSegment = [];
        // Process modifiers in one pass
        for(let i = 0; i < modifiers.length; i++){
            const modifier = modifiers[i];
            // Check if modifier is sensitive (starts with '[' or in orderSensitiveModifiers)
            const isArbitrary = modifier[0] === '[';
            const isOrderSensitive = modifierWeights.has(modifier);
            if (isArbitrary || isOrderSensitive) {
                // Sort and flush current segment alphabetically
                if (currentSegment.length > 0) {
                    currentSegment.sort();
                    result.push(...currentSegment);
                    currentSegment = [];
                }
                result.push(modifier);
            } else // Regular modifier - add to current segment for batch sorting
            currentSegment.push(modifier);
        }
        // Sort and add any remaining segment items
        if (currentSegment.length > 0) {
            currentSegment.sort();
            result.push(...currentSegment);
        }
        return result;
    };
};
const $85fc2fe65ff21506$var$createConfigUtils = (config)=>({
        cache: $85fc2fe65ff21506$var$createLruCache(config.cacheSize),
        parseClassName: $85fc2fe65ff21506$var$createParseClassName(config),
        sortModifiers: $85fc2fe65ff21506$var$createSortModifiers(config),
        ...$85fc2fe65ff21506$var$createClassGroupUtils(config)
    });
const $85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX = /\s+/;
const $85fc2fe65ff21506$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds, sortModifiers: sortModifiers } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX);
    let result = '';
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { isExternal: isExternal, modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        if (isExternal) {
            result = originalClassName + (result.length > 0 ? ' ' + result : result);
            continue;
        }
        let hasPostfixModifier = !!maybePostfixModifierPosition;
        let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        // Fast path: skip sorting for empty or single modifier
        const variantModifier = modifiers.length === 0 ? '' : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + $85fc2fe65ff21506$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.indexOf(classId) > -1) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ const $85fc2fe65ff21506$var$twJoin = (...classLists)=>{
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < classLists.length){
        if (argument = classLists[index++]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$toValue = (mix)=>{
    // Fast path for strings
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$createTailwindMerge = (createConfigFirst, ...createConfigRest)=>{
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall;
    const initTailwindMerge = (classList)=>{
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $85fc2fe65ff21506$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    const tailwindMerge = (classList)=>{
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $85fc2fe65ff21506$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    functionToCall = initTailwindMerge;
    return (...args)=>functionToCall($85fc2fe65ff21506$var$twJoin(...args));
};
const $85fc2fe65ff21506$var$fallbackThemeArr = [];
const $85fc2fe65ff21506$var$fromTheme = (key)=>{
    const themeGetter = (theme)=>theme[key] || $85fc2fe65ff21506$var$fallbackThemeArr;
    themeGetter.isThemeGetter = true;
    return themeGetter;
};
const $85fc2fe65ff21506$var$arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const $85fc2fe65ff21506$var$arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const $85fc2fe65ff21506$var$fractionRegex = /^\d+\/\d+$/;
const $85fc2fe65ff21506$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $85fc2fe65ff21506$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $85fc2fe65ff21506$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $85fc2fe65ff21506$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $85fc2fe65ff21506$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $85fc2fe65ff21506$var$isFraction = (value)=>$85fc2fe65ff21506$var$fractionRegex.test(value);
const $85fc2fe65ff21506$var$isNumber = (value)=>!!value && !Number.isNaN(Number(value));
const $85fc2fe65ff21506$var$isInteger = (value)=>!!value && Number.isInteger(Number(value));
const $85fc2fe65ff21506$var$isPercent = (value)=>value.endsWith('%') && $85fc2fe65ff21506$var$isNumber(value.slice(0, -1));
const $85fc2fe65ff21506$var$isTshirtSize = (value)=>$85fc2fe65ff21506$var$tshirtUnitRegex.test(value);
const $85fc2fe65ff21506$var$isAny = ()=>true;
const $85fc2fe65ff21506$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $85fc2fe65ff21506$var$lengthUnitRegex.test(value) && !$85fc2fe65ff21506$var$colorFunctionRegex.test(value);
const $85fc2fe65ff21506$var$isNever = ()=>false;
const $85fc2fe65ff21506$var$isShadow = (value)=>$85fc2fe65ff21506$var$shadowRegex.test(value);
const $85fc2fe65ff21506$var$isImage = (value)=>$85fc2fe65ff21506$var$imageRegex.test(value);
const $85fc2fe65ff21506$var$isAnyNonArbitrary = (value)=>!$85fc2fe65ff21506$var$isArbitraryValue(value) && !$85fc2fe65ff21506$var$isArbitraryVariable(value);
const $85fc2fe65ff21506$var$isArbitrarySize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelSize, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryValue = (value)=>$85fc2fe65ff21506$var$arbitraryValueRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelLength, $85fc2fe65ff21506$var$isLengthOnly);
const $85fc2fe65ff21506$var$isArbitraryNumber = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelNumber, $85fc2fe65ff21506$var$isNumber);
const $85fc2fe65ff21506$var$isArbitraryPosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelPosition, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelImage, $85fc2fe65ff21506$var$isImage);
const $85fc2fe65ff21506$var$isArbitraryShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelShadow, $85fc2fe65ff21506$var$isShadow);
const $85fc2fe65ff21506$var$isArbitraryVariable = (value)=>$85fc2fe65ff21506$var$arbitraryVariableRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryVariableLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelLength);
const $85fc2fe65ff21506$var$isArbitraryVariableFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelFamilyName);
const $85fc2fe65ff21506$var$isArbitraryVariablePosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelPosition);
const $85fc2fe65ff21506$var$isArbitraryVariableSize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelSize);
const $85fc2fe65ff21506$var$isArbitraryVariableImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelImage);
const $85fc2fe65ff21506$var$isArbitraryVariableShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelShadow, true);
// Helpers
const $85fc2fe65ff21506$var$getIsArbitraryValue = (value, testLabel, testValue)=>{
    const result = $85fc2fe65ff21506$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $85fc2fe65ff21506$var$getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false)=>{
    const result = $85fc2fe65ff21506$var$arbitraryVariableRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return shouldMatchNoLabel;
    }
    return false;
};
// Labels
const $85fc2fe65ff21506$var$isLabelPosition = (label)=>label === 'position' || label === 'percentage';
const $85fc2fe65ff21506$var$isLabelImage = (label)=>label === 'image' || label === 'url';
const $85fc2fe65ff21506$var$isLabelSize = (label)=>label === 'length' || label === 'size' || label === 'bg-size';
const $85fc2fe65ff21506$var$isLabelLength = (label)=>label === 'length';
const $85fc2fe65ff21506$var$isLabelNumber = (label)=>label === 'number';
const $85fc2fe65ff21506$var$isLabelFamilyName = (label)=>label === 'family-name';
const $85fc2fe65ff21506$var$isLabelShadow = (label)=>label === 'shadow';
const $85fc2fe65ff21506$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $85fc2fe65ff21506$var$isAny,
    isAnyNonArbitrary: $85fc2fe65ff21506$var$isAnyNonArbitrary,
    isArbitraryImage: $85fc2fe65ff21506$var$isArbitraryImage,
    isArbitraryLength: $85fc2fe65ff21506$var$isArbitraryLength,
    isArbitraryNumber: $85fc2fe65ff21506$var$isArbitraryNumber,
    isArbitraryPosition: $85fc2fe65ff21506$var$isArbitraryPosition,
    isArbitraryShadow: $85fc2fe65ff21506$var$isArbitraryShadow,
    isArbitrarySize: $85fc2fe65ff21506$var$isArbitrarySize,
    isArbitraryValue: $85fc2fe65ff21506$var$isArbitraryValue,
    isArbitraryVariable: $85fc2fe65ff21506$var$isArbitraryVariable,
    isArbitraryVariableFamilyName: $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
    isArbitraryVariableImage: $85fc2fe65ff21506$var$isArbitraryVariableImage,
    isArbitraryVariableLength: $85fc2fe65ff21506$var$isArbitraryVariableLength,
    isArbitraryVariablePosition: $85fc2fe65ff21506$var$isArbitraryVariablePosition,
    isArbitraryVariableShadow: $85fc2fe65ff21506$var$isArbitraryVariableShadow,
    isArbitraryVariableSize: $85fc2fe65ff21506$var$isArbitraryVariableSize,
    isFraction: $85fc2fe65ff21506$var$isFraction,
    isInteger: $85fc2fe65ff21506$var$isInteger,
    isNumber: $85fc2fe65ff21506$var$isNumber,
    isPercent: $85fc2fe65ff21506$var$isPercent,
    isTshirtSize: $85fc2fe65ff21506$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
const $85fc2fe65ff21506$var$getDefaultConfig = ()=>{
    /**
   * Theme getters for theme variable namespaces
   * @see https://tailwindcss.com/docs/theme#theme-variable-namespaces
   */ /***/ const themeColor = $85fc2fe65ff21506$var$fromTheme('color');
    const themeFont = $85fc2fe65ff21506$var$fromTheme('font');
    const themeText = $85fc2fe65ff21506$var$fromTheme('text');
    const themeFontWeight = $85fc2fe65ff21506$var$fromTheme('font-weight');
    const themeTracking = $85fc2fe65ff21506$var$fromTheme('tracking');
    const themeLeading = $85fc2fe65ff21506$var$fromTheme('leading');
    const themeBreakpoint = $85fc2fe65ff21506$var$fromTheme('breakpoint');
    const themeContainer = $85fc2fe65ff21506$var$fromTheme('container');
    const themeSpacing = $85fc2fe65ff21506$var$fromTheme('spacing');
    const themeRadius = $85fc2fe65ff21506$var$fromTheme('radius');
    const themeShadow = $85fc2fe65ff21506$var$fromTheme('shadow');
    const themeInsetShadow = $85fc2fe65ff21506$var$fromTheme('inset-shadow');
    const themeTextShadow = $85fc2fe65ff21506$var$fromTheme('text-shadow');
    const themeDropShadow = $85fc2fe65ff21506$var$fromTheme('drop-shadow');
    const themeBlur = $85fc2fe65ff21506$var$fromTheme('blur');
    const themePerspective = $85fc2fe65ff21506$var$fromTheme('perspective');
    const themeAspect = $85fc2fe65ff21506$var$fromTheme('aspect');
    const themeEase = $85fc2fe65ff21506$var$fromTheme('ease');
    const themeAnimate = $85fc2fe65ff21506$var$fromTheme('animate');
    /**
   * Helpers to avoid repeating the same scales
   *
   * We use functions that create a new array every time they're called instead of static arrays.
   * This ensures that users who modify any scale by mutating the array (e.g. with `array.push(element)`) don't accidentally mutate arrays in other parts of the config.
   */ /***/ const scaleBreak = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const scalePosition = ()=>[
            'center',
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-top',
            'top-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-top',
            'bottom-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-bottom',
            'bottom-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-bottom'
        ];
    const scalePositionWithArbitrary = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const scaleOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const scaleUnambiguousSpacing = ()=>[
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue,
            themeSpacing
        ];
    const scaleInset = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleGridTemplateColsRows = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'none',
            'subgrid',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartAndEnd = ()=>[
            'auto',
            {
                span: [
                    'full',
                    $85fc2fe65ff21506$var$isInteger,
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            },
            $85fc2fe65ff21506$var$isInteger,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartOrEnd = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'auto',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridAutoColsRows = ()=>[
            'auto',
            'min',
            'max',
            'fr',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleAlignPrimaryAxis = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch',
            'baseline',
            'center-safe',
            'end-safe'
        ];
    const scaleAlignSecondaryAxis = ()=>[
            'start',
            'end',
            'center',
            'stretch',
            'center-safe',
            'end-safe'
        ];
    const scaleMargin = ()=>[
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizing = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'auto',
            'full',
            'dvw',
            'dvh',
            'lvw',
            'lvh',
            'svw',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleColor = ()=>[
            themeColor,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBgPosition = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition,
            {
                position: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleBgRepeat = ()=>[
            'no-repeat',
            {
                repeat: [
                    '',
                    'x',
                    'y',
                    'space',
                    'round'
                ]
            }
        ];
    const scaleBgSize = ()=>[
            'auto',
            'cover',
            'contain',
            $85fc2fe65ff21506$var$isArbitraryVariableSize,
            $85fc2fe65ff21506$var$isArbitrarySize,
            {
                size: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleGradientStopPosition = ()=>[
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleRadius = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            'full',
            themeRadius,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBorderWidth = ()=>[
            '',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleLineStyle = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double'
        ];
    const scaleBlendMode = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const scaleMaskImagePosition = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition
        ];
    const scaleBlur = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            themeBlur,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleRotate = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleScale = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleSkew = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleTranslate = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            ...scaleUnambiguousSpacing()
        ];
    return {
        cacheSize: 500,
        theme: {
            animate: [
                'spin',
                'ping',
                'pulse',
                'bounce'
            ],
            aspect: [
                'video'
            ],
            blur: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            breakpoint: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            color: [
                $85fc2fe65ff21506$var$isAny
            ],
            container: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'drop-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            ease: [
                'in',
                'out',
                'in-out'
            ],
            font: [
                $85fc2fe65ff21506$var$isAnyNonArbitrary
            ],
            'font-weight': [
                'thin',
                'extralight',
                'light',
                'normal',
                'medium',
                'semibold',
                'bold',
                'extrabold',
                'black'
            ],
            'inset-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            leading: [
                'none',
                'tight',
                'snug',
                'normal',
                'relaxed',
                'loose'
            ],
            perspective: [
                'dramatic',
                'near',
                'normal',
                'midrange',
                'distant',
                'none'
            ],
            radius: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            shadow: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            spacing: [
                'px',
                $85fc2fe65ff21506$var$isNumber
            ],
            text: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'text-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            tracking: [
                'tighter',
                'tight',
                'normal',
                'wide',
                'wider',
                'widest'
            ]
        },
        classGroups: {
            // --------------
            // --- Layout ---
            // --------------
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        $85fc2fe65ff21506$var$isFraction,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeAspect
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */ container: [
                'container'
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeContainer
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': scaleBreak()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': scaleBreak()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: scalePositionWithArbitrary()
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: scaleOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': scaleOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': scaleOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': scaleOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: scaleInset()
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': scaleInset()
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': scaleInset()
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: scaleInset()
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: scaleInset()
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: scaleInset()
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: scaleInset()
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: scaleInset()
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: scaleInset()
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        $85fc2fe65ff21506$var$isInteger,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------------
            // --- Flexbox and Grid ---
            // ------------------------
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: [
                        $85fc2fe65ff21506$var$isFraction,
                        'full',
                        'auto',
                        themeContainer,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'nowrap',
                        'wrap',
                        'wrap-reverse'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isFraction,
                        'auto',
                        'initial',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        $85fc2fe65ff21506$var$isInteger,
                        'first',
                        'last',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': scaleGridAutoColsRows()
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': scaleGridAutoColsRows()
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        ...scaleAlignPrimaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        ...scaleAlignSecondaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...scaleAlignPrimaryAxis()
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': scaleAlignPrimaryAxis()
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        ...scaleAlignSecondaryAxis(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: scaleMargin()
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: scaleMargin()
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: scaleMargin()
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: scaleMargin()
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: scaleMargin()
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: scaleMargin()
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: scaleMargin()
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: scaleMargin()
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: scaleMargin()
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x': [
                {
                    'space-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y': [
                {
                    'space-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // --------------
            // --- Sizing ---
            // --------------
            /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */ size: [
                {
                    size: scaleSizing()
                }
            ],
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        themeContainer,
                        'screen',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        themeContainer,
                        'screen',
                        /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        themeContainer,
                        'screen',
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'prose',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ {
                            screen: [
                                themeBreakpoint
                            ]
                        },
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            // ------------------
            // --- Typography ---
            // ------------------
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        themeText,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        themeFontWeight,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */ 'font-stretch': [
                {
                    'font-stretch': [
                        'ultra-condensed',
                        'extra-condensed',
                        'condensed',
                        'semi-condensed',
                        'normal',
                        'semi-expanded',
                        'expanded',
                        'extra-expanded',
                        'ultra-expanded',
                        $85fc2fe65ff21506$var$isPercent,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        themeFont
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        themeTracking,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        $85fc2fe65ff21506$var$isNumber,
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ themeLeading,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'disc',
                        'decimal',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: scaleColor()
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: scaleColor()
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...scaleLineStyle(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'from-font',
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: scaleColor()
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */ wrap: [
                {
                    wrap: [
                        'break-word',
                        'anywhere',
                        'normal'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -------------------
            // --- Backgrounds ---
            // -------------------
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: scaleBgPosition()
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: scaleBgRepeat()
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: scaleBgSize()
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            linear: [
                                {
                                    to: [
                                        't',
                                        'tr',
                                        'r',
                                        'br',
                                        'b',
                                        'bl',
                                        'l',
                                        'tl'
                                    ]
                                },
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            radial: [
                                '',
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            conic: [
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ]
                        },
                        $85fc2fe65ff21506$var$isArbitraryVariableImage,
                        $85fc2fe65ff21506$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: scaleColor()
                }
            ],
            // ---------------
            // --- Borders ---
            // ---------------
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: scaleRadius()
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': scaleRadius()
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': scaleRadius()
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': scaleRadius()
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': scaleRadius()
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': scaleRadius()
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': scaleRadius()
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': scaleRadius()
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': scaleRadius()
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': scaleRadius()
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: scaleBorderWidth()
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': scaleBorderWidth()
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x': [
                {
                    'divide-x': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y': [
                {
                    'divide-y': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */ 'divide-style': [
                {
                    divide: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: scaleColor()
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': scaleColor()
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': scaleColor()
                }
            ],
            /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': scaleColor()
                }
            ],
            /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': scaleColor()
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': scaleColor()
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': scaleColor()
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': scaleColor()
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': scaleColor()
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: scaleColor()
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        ...scaleLineStyle(),
                        'none',
                        'hidden'
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: scaleColor()
                }
            ],
            // ---------------
            // --- Effects ---
            // ---------------
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */ 'shadow-color': [
                {
                    shadow: scaleColor()
                }
            ],
            /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */ 'inset-shadow': [
                {
                    'inset-shadow': [
                        'none',
                        themeInsetShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */ 'inset-shadow-color': [
                {
                    'inset-shadow': scaleColor()
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */ 'ring-w': [
                {
                    ring: scaleBorderWidth()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */ 'ring-color': [
                {
                    ring: scaleColor()
                }
            ],
            /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-color': [
                {
                    'ring-offset': scaleColor()
                }
            ],
            /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */ 'inset-ring-w': [
                {
                    'inset-ring': scaleBorderWidth()
                }
            ],
            /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */ 'inset-ring-color': [
                {
                    'inset-ring': scaleColor()
                }
            ],
            /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */ 'text-shadow': [
                {
                    'text-shadow': [
                        'none',
                        themeTextShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */ 'text-shadow-color': [
                {
                    'text-shadow': scaleColor()
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...scaleBlendMode(),
                        'plus-darker',
                        'plus-lighter'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': scaleBlendMode()
                }
            ],
            /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */ 'mask-clip': [
                {
                    'mask-clip': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                },
                'mask-no-clip'
            ],
            /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */ 'mask-composite': [
                {
                    mask: [
                        'add',
                        'subtract',
                        'intersect',
                        'exclude'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image-linear-pos': [
                {
                    'mask-linear': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-linear-from-pos': [
                {
                    'mask-linear-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-to-pos': [
                {
                    'mask-linear-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-from-color': [
                {
                    'mask-linear-from': scaleColor()
                }
            ],
            'mask-image-linear-to-color': [
                {
                    'mask-linear-to': scaleColor()
                }
            ],
            'mask-image-t-from-pos': [
                {
                    'mask-t-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-to-pos': [
                {
                    'mask-t-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-from-color': [
                {
                    'mask-t-from': scaleColor()
                }
            ],
            'mask-image-t-to-color': [
                {
                    'mask-t-to': scaleColor()
                }
            ],
            'mask-image-r-from-pos': [
                {
                    'mask-r-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-to-pos': [
                {
                    'mask-r-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-from-color': [
                {
                    'mask-r-from': scaleColor()
                }
            ],
            'mask-image-r-to-color': [
                {
                    'mask-r-to': scaleColor()
                }
            ],
            'mask-image-b-from-pos': [
                {
                    'mask-b-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-to-pos': [
                {
                    'mask-b-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-from-color': [
                {
                    'mask-b-from': scaleColor()
                }
            ],
            'mask-image-b-to-color': [
                {
                    'mask-b-to': scaleColor()
                }
            ],
            'mask-image-l-from-pos': [
                {
                    'mask-l-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-to-pos': [
                {
                    'mask-l-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-from-color': [
                {
                    'mask-l-from': scaleColor()
                }
            ],
            'mask-image-l-to-color': [
                {
                    'mask-l-to': scaleColor()
                }
            ],
            'mask-image-x-from-pos': [
                {
                    'mask-x-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-to-pos': [
                {
                    'mask-x-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-from-color': [
                {
                    'mask-x-from': scaleColor()
                }
            ],
            'mask-image-x-to-color': [
                {
                    'mask-x-to': scaleColor()
                }
            ],
            'mask-image-y-from-pos': [
                {
                    'mask-y-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-to-pos': [
                {
                    'mask-y-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-from-color': [
                {
                    'mask-y-from': scaleColor()
                }
            ],
            'mask-image-y-to-color': [
                {
                    'mask-y-to': scaleColor()
                }
            ],
            'mask-image-radial': [
                {
                    'mask-radial': [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            'mask-image-radial-from-pos': [
                {
                    'mask-radial-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-to-pos': [
                {
                    'mask-radial-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-from-color': [
                {
                    'mask-radial-from': scaleColor()
                }
            ],
            'mask-image-radial-to-color': [
                {
                    'mask-radial-to': scaleColor()
                }
            ],
            'mask-image-radial-shape': [
                {
                    'mask-radial': [
                        'circle',
                        'ellipse'
                    ]
                }
            ],
            'mask-image-radial-size': [
                {
                    'mask-radial': [
                        {
                            closest: [
                                'side',
                                'corner'
                            ],
                            farthest: [
                                'side',
                                'corner'
                            ]
                        }
                    ]
                }
            ],
            'mask-image-radial-pos': [
                {
                    'mask-radial-at': scalePosition()
                }
            ],
            'mask-image-conic-pos': [
                {
                    'mask-conic': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-conic-from-pos': [
                {
                    'mask-conic-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-to-pos': [
                {
                    'mask-conic-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-from-color': [
                {
                    'mask-conic-from': scaleColor()
                }
            ],
            'mask-image-conic-to-color': [
                {
                    'mask-conic-to': scaleColor()
                }
            ],
            /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */ 'mask-mode': [
                {
                    mask: [
                        'alpha',
                        'luminance',
                        'match'
                    ]
                }
            ],
            /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */ 'mask-origin': [
                {
                    'mask-origin': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                }
            ],
            /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */ 'mask-position': [
                {
                    mask: scaleBgPosition()
                }
            ],
            /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */ 'mask-repeat': [
                {
                    mask: scaleBgRepeat()
                }
            ],
            /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */ 'mask-size': [
                {
                    mask: scaleBgSize()
                }
            ],
            /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */ 'mask-type': [
                {
                    'mask-type': [
                        'alpha',
                        'luminance'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image': [
                {
                    mask: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------
            // --- Filters ---
            // ---------------
            /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: scaleBlur()
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeDropShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */ 'drop-shadow-color': [
                {
                    'drop-shadow': scaleColor()
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': scaleBlur()
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // --------------
            // --- Tables ---
            // --------------
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // ---------------------------------
            // --- Transitions and Animation ---
            // ---------------------------------
            /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        '',
                        'all',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */ 'transition-behavior': [
                {
                    transition: [
                        'normal',
                        'discrete'
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'initial',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'initial',
                        themeEase,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        themeAnimate,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------
            // --- Transforms ---
            // ------------------
            /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */ backface: [
                {
                    backface: [
                        'hidden',
                        'visible'
                    ]
                }
            ],
            /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */ perspective: [
                {
                    perspective: [
                        themePerspective,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */ 'perspective-origin': [
                {
                    'perspective-origin': scalePositionWithArbitrary()
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: scaleRotate()
                }
            ],
            /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-x': [
                {
                    'rotate-x': scaleRotate()
                }
            ],
            /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-y': [
                {
                    'rotate-y': scaleRotate()
                }
            ],
            /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-z': [
                {
                    'rotate-z': scaleRotate()
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: scaleScale()
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': scaleScale()
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': scaleScale()
                }
            ],
            /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-z': [
                {
                    'scale-z': scaleScale()
                }
            ],
            /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-3d': [
                'scale-3d'
            ],
            /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */ skew: [
                {
                    skew: scaleSkew()
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': scaleSkew()
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': scaleSkew()
                }
            ],
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        '',
                        'none',
                        'gpu',
                        'cpu'
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: scalePositionWithArbitrary()
                }
            ],
            /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */ 'transform-style': [
                {
                    transform: [
                        '3d',
                        'flat'
                    ]
                }
            ],
            /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */ translate: [
                {
                    translate: scaleTranslate()
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': scaleTranslate()
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': scaleTranslate()
                }
            ],
            /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-z': [
                {
                    'translate-z': scaleTranslate()
                }
            ],
            /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-none': [
                'translate-none'
            ],
            // ---------------------
            // --- Interactivity ---
            // ---------------------
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: scaleColor()
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: scaleColor()
                }
            ],
            /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */ 'color-scheme': [
                {
                    scheme: [
                        'normal',
                        'dark',
                        'light',
                        'light-dark',
                        'only-dark',
                        'only-light'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */ 'field-sizing': [
                {
                    'field-sizing': [
                        'fixed',
                        'content'
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'auto',
                        'none'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        '',
                        'y',
                        'x'
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -----------
            // --- SVG ---
            // -----------
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            // ---------------------
            // --- Accessibility ---
            // ---------------------
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'right',
                'left'
            ],
            'inset-y': [
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'pr',
                'pl'
            ],
            py: [
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'mr',
                'ml'
            ],
            my: [
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-x',
                'border-w-y',
                'border-w-s',
                'border-w-e',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-x',
                'border-color-y',
                'border-color-s',
                'border-color-e',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-t',
                'border-color-b'
            ],
            translate: [
                'translate-x',
                'translate-y',
                'translate-none'
            ],
            'translate-none': [
                'translate',
                'translate-x',
                'translate-y',
                'translate-z'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        },
        orderSensitiveModifiers: [
            '*',
            '**',
            'after',
            'backdrop',
            'before',
            'details-content',
            'file',
            'first-letter',
            'first-line',
            'marker',
            'placeholder',
            'selection'
        ]
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $85fc2fe65ff21506$var$mergeConfigs = (baseConfig, { cacheSize: cacheSize, prefix: prefix, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'prefix', prefix);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.theme, override.theme);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.classGroups, override.classGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'orderSensitiveModifiers', override.orderSensitiveModifiers);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.theme, extend.theme);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'orderSensitiveModifiers');
    return baseConfig;
};
const $85fc2fe65ff21506$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $85fc2fe65ff21506$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$85fc2fe65ff21506$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $85fc2fe65ff21506$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject)$85fc2fe65ff21506$var$mergeArrayProperties(baseObject, mergeObject, key);
};
const $85fc2fe65ff21506$var$mergeArrayProperties = (baseObject, mergeObject, key)=>{
    const mergeValue = mergeObject[key];
    if (mergeValue !== undefined) baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
};
const $85fc2fe65ff21506$var$extendTailwindMerge = (configExtension, ...createConfig)=>typeof configExtension === 'function' ? $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig, configExtension, ...createConfig) : $85fc2fe65ff21506$var$createTailwindMerge(()=>$85fc2fe65ff21506$var$mergeConfigs($85fc2fe65ff21506$var$getDefaultConfig(), configExtension), ...createConfig);
const $85fc2fe65ff21506$var$twMerge = /*#__PURE__*/ $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig);
$85fc2fe65ff21506$exports.createTailwindMerge = $85fc2fe65ff21506$var$createTailwindMerge;
$85fc2fe65ff21506$exports.extendTailwindMerge = $85fc2fe65ff21506$var$extendTailwindMerge;
$85fc2fe65ff21506$exports.fromTheme = $85fc2fe65ff21506$var$fromTheme;
$85fc2fe65ff21506$exports.getDefaultConfig = $85fc2fe65ff21506$var$getDefaultConfig;
$85fc2fe65ff21506$exports.mergeConfigs = $85fc2fe65ff21506$var$mergeConfigs;
$85fc2fe65ff21506$exports.twJoin = $85fc2fe65ff21506$var$twJoin;
$85fc2fe65ff21506$exports.twMerge = $85fc2fe65ff21506$var$twMerge;
$85fc2fe65ff21506$exports.validators = $85fc2fe65ff21506$var$validators;


function $3fb8b98e60e6c18f$export$1343a74baacb0543(...inputs) {
    return (0, $85fc2fe65ff21506$exports.twMerge)((0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(inputs));
}


const $94339ef075b24dd2$export$c6fdb837b070b4ff = (props)=>{
    const { onOverlayClick: onOverlayClick, dimBackground: dimBackground, blurBackground: blurBackground, interactive: interactive, ...rest } = props;
    const isInteractive = (0, (/*@__PURE__*/$parcel$interopDefault($f8f45ddea4959097$exports)))(interactive).getOrElse(true);
    const ref = $acw62.useRef(null);
    const handleClick = (e)=>{
        if (ref.current === e.target) onOverlayClick?.();
    };
    const shouldDim = (0, (/*@__PURE__*/$parcel$interopDefault($f8f45ddea4959097$exports)))(dimBackground).getOrElse(false);
    const dimProps = shouldDim ? {
        initial: {
            backgroundColor: 'rgba(0, 0, 0, 0)'
        },
        animate: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)'
        },
        exit: {
            backgroundColor: 'rgba(0, 0, 0, 0)'
        },
        transition: {
            duration: 0.3
        }
    } : {};
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
        ...rest,
        ...dimProps,
        ref: ref,
        onClick: handleClick,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('fixed inset-0 z-[1]', isInteractive ? 'pointer-events-auto' : 'pointer-events-none', blurBackground && 'backdrop-blur-[1px]'),
        children: props.children
    });
};


const $497d44d806a05c0a$var$getPosition = (anchor, triggerRect, contentRect)=>{
    switch(anchor){
        case 'top-left':
            return {
                top: triggerRect.top,
                left: triggerRect.left
            };
        case 'top-right':
            return {
                top: triggerRect.bottom,
                left: triggerRect.right - contentRect.width
            };
        case 'bottom-left':
            return {
                top: triggerRect.bottom,
                left: triggerRect.left
            };
        case 'bottom-right':
            return {
                top: triggerRect.bottom,
                left: triggerRect.right - contentRect.width
            };
        // Opens upward: for triggers pinned to the bottom of the screen, where a
        // menu opening downward would be clamped back up over its own trigger.
        case 'above-right':
            return {
                top: triggerRect.top - contentRect.height,
                left: triggerRect.right - contentRect.width
            };
        default:
            return (0, $24175cbf70f85c9e$export$2e2bcd8739ae039)(anchor);
    }
};
const $497d44d806a05c0a$var$Popover = (props)=>{
    const triggerRef = $acw62.useRef(null);
    const contentRef = $acw62.useRef(null);
    const [position, setPosition] = $acw62.useState({
        top: -10000,
        left: -10000
    });
    const updatePosition = $acw62.useCallback(()=>{
        const triggerEl = triggerRef.current;
        const contentEl = contentRef.current;
        if (!triggerEl || !contentEl) return;
        const triggerRect = triggerEl.getBoundingClientRect();
        const contentRect = contentEl.getBoundingClientRect();
        const anchor = props.popoverAnchor || 'top-left';
        const nextPosition = $497d44d806a05c0a$var$getPosition(anchor, triggerRect, contentRect);
        const viewport = window.visualViewport;
        if (viewport) {
            const margin = 8;
            const viewportTop = viewport.offsetTop + margin;
            const viewportBottom = viewport.offsetTop + viewport.height - contentRect.height - margin;
            if (viewportBottom >= viewportTop) nextPosition.top = Math.min(Math.max(nextPosition.top, viewportTop), viewportBottom);
            const viewportLeft = viewport.offsetLeft + margin;
            const viewportRight = viewport.offsetLeft + viewport.width - contentRect.width - margin;
            if (viewportRight >= viewportLeft) nextPosition.left = Math.min(Math.max(nextPosition.left, viewportLeft), viewportRight);
        }
        setPosition((prev)=>{
            if (prev.top === nextPosition.top && prev.left === nextPosition.left) return prev;
            return nextPosition;
        });
    }, [
        props.popoverAnchor
    ]);
    $acw62.useEffect(()=>{
        if (!props.open) return;
        updatePosition();
        window.addEventListener('resize', updatePosition);
        window.addEventListener('scroll', updatePosition, true);
        const viewport = window.visualViewport;
        viewport?.addEventListener('resize', updatePosition);
        viewport?.addEventListener('scroll', updatePosition);
        // Contents that grow after opening (e.g. the date filter revealing its
        // custom-range inputs, which widen the menu well past the option list)
        // would otherwise keep the position measured for the smaller box and hang
        // off the edge of a narrow viewport.
        const observer = new ResizeObserver(updatePosition);
        if (contentRef.current) observer.observe(contentRef.current);
        // None of the above fires when the TRIGGER moves without a resize or a
        // scroll — e.g. FilterPillRow floats a pill to the front the moment its
        // value lands, mid-open for menus that stay up (multi-selects, typed
        // bounds committed on blur). Poll the rects while open so the menu
        // follows its trigger; updatePosition bails out of the state update when
        // nothing moved, so an idle frame costs two rect reads and no render.
        let frame = 0;
        const follow = ()=>{
            updatePosition();
            frame = requestAnimationFrame(follow);
        };
        frame = requestAnimationFrame(follow);
        return ()=>{
            cancelAnimationFrame(frame);
            observer.disconnect();
            window.removeEventListener('resize', updatePosition);
            window.removeEventListener('scroll', updatePosition, true);
            viewport?.removeEventListener('resize', updatePosition);
            viewport?.removeEventListener('scroll', updatePosition);
        };
    }, [
        props.open,
        updatePosition
    ]);
    const anchorRef = (element)=>{
        if (element && triggerRef.current !== element) {
            triggerRef.current = element;
            updatePosition();
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            props.children(anchorRef),
            position && props.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72de694199324d9d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94339ef075b24dd2$export$c6fdb837b070b4ff), {
                    onOverlayClick: props.onOutsideClick,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "fixed",
                        style: {
                            top: `${position.top}px`,
                            left: `${position.left}px`
                        },
                        onBlur: props.onContentBlur,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9feaa5924c876b6a$export$2e2bcd8739ae039), {
                            behavior: "continue",
                            onFocusOutside: props.onOutsideFocus,
                            focusControlsRef: props.focusControlsRef,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                ref: contentRef,
                                children: props.popoverContents
                            })
                        })
                    })
                })
            })
        ]
    });
};
var $497d44d806a05c0a$export$2e2bcd8739ae039 = $497d44d806a05c0a$var$Popover;



// GENERATED FILE — do not edit by hand.
// Run `yarn generate:logos` after changing frontend/static/logos/ or
// logos/labels.json. See logos/README.md.
/** Every logo committed to frontend/static/logos/, rendered as /logos/{id}.png */ const $cd179cdb1a4beac3$export$e2ad04535ed8af93 = [
    {
        value: '',
        label: 'None'
    },
    {
        value: '1800contacts',
        label: '1-800 Contacts'
    },
    {
        value: '5ive_spice',
        label: '5ive Spice'
    },
    {
        value: '85c_bakery',
        label: '85C Bakery'
    },
    {
        value: '99_ranch',
        label: '99 Ranch'
    },
    {
        value: 'aaa',
        label: 'AAA'
    },
    {
        value: 'adobe',
        label: 'Adobe'
    },
    {
        value: 'aesop',
        label: 'Aesop'
    },
    {
        value: 'air_canada',
        label: 'Air Canada'
    },
    {
        value: 'airbnb',
        label: 'Airbnb'
    },
    {
        value: 'alamo_drafthouse',
        label: 'Alamo Drafthouse'
    },
    {
        value: 'alaska',
        label: 'Alaska Airlines'
    },
    {
        value: 'ally',
        label: 'Ally'
    },
    {
        value: 'amazon',
        label: 'Amazon'
    },
    {
        value: 'american_airlines',
        label: 'American Airlines'
    },
    {
        value: 'amex',
        label: 'American Express'
    },
    {
        value: 'anthropic',
        label: 'Anthropic'
    },
    {
        value: 'apple',
        label: 'Apple'
    },
    {
        value: 'arcteryx',
        label: "Arc'teryx"
    },
    {
        value: 'asiana',
        label: 'Asiana Airlines'
    },
    {
        value: 'backcountry',
        label: 'Backcountry'
    },
    {
        value: 'barclays',
        label: 'Barclays'
    },
    {
        value: 'barnes_noble',
        label: 'Barnes & Noble'
    },
    {
        value: 'bed_bath_beyond',
        label: 'Bed Bath & Beyond'
    },
    {
        value: 'bellagio',
        label: 'Bellagio'
    },
    {
        value: 'berkeley_bowl',
        label: 'Berkeley Bowl'
    },
    {
        value: 'best_buy',
        label: 'Best Buy'
    },
    {
        value: 'bh_photo',
        label: 'B&H Photo'
    },
    {
        value: 'big_sky',
        label: 'Big Sky Resort'
    },
    {
        value: 'blank_street',
        label: 'Blank Street Coffee'
    },
    {
        value: 'blue_apron',
        label: 'Blue Apron'
    },
    {
        value: 'blue_bottle',
        label: 'Blue Bottle'
    },
    {
        value: 'bluestone_lane',
        label: 'Bluestone Lane'
    },
    {
        value: 'boa',
        label: 'Bank of America'
    },
    {
        value: 'bombas',
        label: 'Bombas'
    },
    {
        value: 'bond_vet',
        label: 'Bond Vet'
    },
    {
        value: 'breckenridge',
        label: 'Breckenridge'
    },
    {
        value: 'brooklyn_paramount',
        label: 'Brooklyn Paramount'
    },
    {
        value: 'burger_king',
        label: 'Burger King'
    },
    {
        value: 'capital_one',
        label: 'Capital One'
    },
    {
        value: 'cava',
        label: 'Cava'
    },
    {
        value: 'centurylink',
        label: 'CenturyLink'
    },
    {
        value: 'chargepoint',
        label: 'ChargePoint'
    },
    {
        value: 'chase',
        label: 'Chase'
    },
    {
        value: 'chelsea_piers',
        label: 'Chelsea Piers Fitness'
    },
    {
        value: 'chevron',
        label: 'Chevron'
    },
    {
        value: 'chewy',
        label: 'Chewy'
    },
    {
        value: 'chipotle',
        label: 'Chipotle'
    },
    {
        value: 'cigna',
        label: 'Cigna'
    },
    {
        value: 'citi',
        label: 'Citi'
    },
    {
        value: 'classpass',
        label: 'Classpass'
    },
    {
        value: 'claude',
        label: 'Claude'
    },
    {
        value: 'cnb',
        label: 'City National Bank'
    },
    {
        value: 'coinbase',
        label: 'Coinbase'
    },
    {
        value: 'coned',
        label: 'ConEd'
    },
    {
        value: 'container_store',
        label: 'Container Store'
    },
    {
        value: 'cosmopolitan',
        label: 'Cosmopolitan'
    },
    {
        value: 'costco',
        label: 'Costco'
    },
    {
        value: 'court16',
        label: 'Court 16'
    },
    {
        value: 'cvs',
        label: 'CVS'
    },
    {
        value: 'dell',
        label: 'Dell'
    },
    {
        value: 'delta',
        label: 'Delta'
    },
    {
        value: 'design_within_reach',
        label: 'Design Within Reach'
    },
    {
        value: 'dicks',
        label: "Dick's"
    },
    {
        value: 'didi',
        label: 'Didi'
    },
    {
        value: 'digitalocean',
        label: 'DigitalOcean'
    },
    {
        value: 'din_tai_fung',
        label: 'Din Tai Fung'
    },
    {
        value: 'doordash',
        label: 'Doordash'
    },
    {
        value: 'dropbox',
        label: 'Dropbox'
    },
    {
        value: 'dunkin',
        label: "Dunkin' Donuts"
    },
    {
        value: 'dyson',
        label: 'Dyson'
    },
    {
        value: 'eataly',
        label: 'Eataly'
    },
    {
        value: 'emmy_squared',
        label: 'Emmy Squared Pizza'
    },
    {
        value: 'eq3',
        label: 'EQ3'
    },
    {
        value: 'espresso_vivace',
        label: 'Espresso Vivace'
    },
    {
        value: 'expedia',
        label: 'Expedia'
    },
    {
        value: 'exxonmobil',
        label: 'ExxonMobil'
    },
    {
        value: 'ezpass',
        label: 'E-ZPass'
    },
    {
        value: 'facebook',
        label: 'Facebook Marketplace'
    },
    {
        value: 'fandango',
        label: 'Fandango'
    },
    {
        value: 'fastmail',
        label: 'Fastmail'
    },
    {
        value: 'fastrak',
        label: 'Fastrak'
    },
    {
        value: 'fedex',
        label: 'FedEx'
    },
    {
        value: 'fidelity',
        label: 'Fidelity'
    },
    {
        value: 'first_republic',
        label: 'First Republic'
    },
    {
        value: 'five_guys',
        label: 'Five Guys'
    },
    {
        value: 'geico',
        label: 'Geico'
    },
    {
        value: 'gong_cha',
        label: 'Gong Cha'
    },
    {
        value: 'goodtogo',
        label: 'GoodToGo'
    },
    {
        value: 'google',
        label: 'Google'
    },
    {
        value: 'grab',
        label: 'Grab'
    },
    {
        value: 'h_mart',
        label: 'H Mart'
    },
    {
        value: 'haidilao',
        label: 'Hai Di Lao'
    },
    {
        value: 'hertz',
        label: 'Hertz'
    },
    {
        value: 'heytea',
        label: 'Heytea'
    },
    {
        value: 'hinge',
        label: 'Hinge'
    },
    {
        value: 'holafly',
        label: 'Holafly'
    },
    {
        value: 'home_depot',
        label: 'Home Depot'
    },
    {
        value: 'ikea',
        label: 'Ikea'
    },
    {
        value: 'irs',
        label: 'IRS'
    },
    {
        value: 'jetblue',
        label: 'JetBlue'
    },
    {
        value: 'jr_central',
        label: 'JR Central'
    },
    {
        value: 'juniors',
        label: "Junior's Cheesecake"
    },
    {
        value: 'just_salad',
        label: 'Just Salad'
    },
    {
        value: 'kiehls',
        label: "Kiehl's"
    },
    {
        value: 'klook',
        label: 'Klook'
    },
    {
        value: 'korail',
        label: 'Korail'
    },
    {
        value: 'krispy_kreme',
        label: 'Krispy Kreme'
    },
    {
        value: 'lego',
        label: 'Lego'
    },
    {
        value: 'lemonade',
        label: 'Lemonade'
    },
    {
        value: 'life_time',
        label: 'Life Time'
    },
    {
        value: 'lime',
        label: 'Lime'
    },
    {
        value: 'luckin',
        label: 'Luckin Coffee'
    },
    {
        value: 'lululemon',
        label: 'Lululemon'
    },
    {
        value: 'lyft',
        label: 'Lyft'
    },
    {
        value: 'madewell',
        label: 'Madewell'
    },
    {
        value: 'max',
        label: 'HBO Max'
    },
    {
        value: 'mcdonalds',
        label: "McDonald's"
    },
    {
        value: 'meowtel',
        label: 'Meowtel'
    },
    {
        value: 'microsoft',
        label: 'Microsoft Store'
    },
    {
        value: 'molly_moon',
        label: "Molly Moon's"
    },
    {
        value: 'mox',
        label: 'Mox Boarding House'
    },
    {
        value: 'mta',
        label: 'MTA'
    },
    {
        value: 'muji',
        label: 'Muji'
    },
    {
        value: 'nenes_taqueria',
        label: "Nene's Taqueria"
    },
    {
        value: 'netflix',
        label: 'Netflix'
    },
    {
        value: 'new_york_life',
        label: 'New York Life'
    },
    {
        value: 'nintendo',
        label: 'Nintendo'
    },
    {
        value: 'nyc_finance',
        label: 'NYC Finance'
    },
    {
        value: 'nyrr',
        label: 'NYRR'
    },
    {
        value: 'nytimes',
        label: 'New York Times'
    },
    {
        value: 'obe_fitness',
        label: 'Obe Fitness'
    },
    {
        value: 'one_medical',
        label: 'One Medical'
    },
    {
        value: 'openai',
        label: 'OpenAI'
    },
    {
        value: 'paris_baguette',
        label: 'Paris Baguette'
    },
    {
        value: 'partners_coffee',
        label: 'Partners Coffee'
    },
    {
        value: 'patreon',
        label: 'Patreon'
    },
    {
        value: 'pax',
        label: 'PAX'
    },
    {
        value: 'paypal',
        label: 'PayPal'
    },
    {
        value: 'petco',
        label: 'Petco'
    },
    {
        value: 'philz',
        label: 'Philz Coffee'
    },
    {
        value: 'plaid',
        label: 'Plaid'
    },
    {
        value: 'progressive',
        label: 'Progressive'
    },
    {
        value: 'pseg',
        label: 'PSEG'
    },
    {
        value: 'qfc',
        label: 'QFC'
    },
    {
        value: 'rakuten',
        label: 'Rakuten'
    },
    {
        value: 'ratp',
        label: 'RATP'
    },
    {
        value: 'rei',
        label: 'REI'
    },
    {
        value: 'render',
        label: 'Render'
    },
    {
        value: 'riot_games',
        label: 'Riot Games'
    },
    {
        value: 'safeway',
        label: 'Safeway'
    },
    {
        value: 'saks',
        label: 'Saks Fifth Avenue'
    },
    {
        value: 'salt_and_straw',
        label: 'Salt & Straw'
    },
    {
        value: 'sbp',
        label: 'Seattle Bouldering Project'
    },
    {
        value: 'schwab',
        label: 'Schwab'
    },
    {
        value: 'seats_aero',
        label: 'seats.aero'
    },
    {
        value: 'seattle_city_light',
        label: 'Seattle City Light'
    },
    {
        value: 'seattle_coffee_works',
        label: 'Seattle Coffee Works'
    },
    {
        value: 'seven_eleven',
        label: '7-Eleven'
    },
    {
        value: 'shell',
        label: 'Shell'
    },
    {
        value: 'shoppers_drug_mart',
        label: 'Shoppers Drug Mart'
    },
    {
        value: 'shoprite',
        label: 'Shoprite'
    },
    {
        value: 'southwest',
        label: 'Southwest'
    },
    {
        value: 'splitwise',
        label: 'Splitwise'
    },
    {
        value: 'spotify',
        label: 'Spotify'
    },
    {
        value: 'staples',
        label: 'Staples'
    },
    {
        value: 'starbucks',
        label: 'Starbucks'
    },
    {
        value: 'state_farm',
        label: 'State Farm'
    },
    {
        value: 'steam',
        label: 'Steam'
    },
    {
        value: 'stewarts_shops',
        label: "Stewart's Shops"
    },
    {
        value: 'stowe',
        label: 'Stowe'
    },
    {
        value: 'stripe',
        label: 'Stripe'
    },
    {
        value: 'stumptown',
        label: 'Stumptown Coffee'
    },
    {
        value: 'summit_snoqualmie',
        label: 'The Summit at Snoqualmie'
    },
    {
        value: 'sweetgreen',
        label: 'Sweetgreen'
    },
    {
        value: 't_mobile',
        label: 'T-Mobile'
    },
    {
        value: 'taim',
        label: 'Taim'
    },
    {
        value: 'target',
        label: 'Target'
    },
    {
        value: 'taskrabbit',
        label: 'Taskrabbit'
    },
    {
        value: 'tennis_warehouse',
        label: 'Tennis Warehouse'
    },
    {
        value: 'tesla',
        label: 'Tesla'
    },
    {
        value: 'the_sill',
        label: 'The Sill'
    },
    {
        value: 'ticketmaster',
        label: 'Ticketmaster'
    },
    {
        value: 'tim_hortons',
        label: 'Tim Hortons'
    },
    {
        value: 'tj_maxx',
        label: 'T.J.Maxx'
    },
    {
        value: 'trade_coffee',
        label: 'Trade Coffee'
    },
    {
        value: 'trader_joes',
        label: "Trader Joe's"
    },
    {
        value: 'treasury_direct',
        label: 'TreasuryDirect'
    },
    {
        value: 'uber',
        label: 'Uber'
    },
    {
        value: 'uber_eats',
        label: 'Uber Eats'
    },
    {
        value: 'uhaul',
        label: 'U-Haul'
    },
    {
        value: 'uniqlo',
        label: 'Uniqlo'
    },
    {
        value: 'united',
        label: 'United Airlines'
    },
    {
        value: 'ups',
        label: 'UPS'
    },
    {
        value: 'us_bank',
        label: 'US Bank'
    },
    {
        value: 'usps',
        label: 'USPS'
    },
    {
        value: 'uwajimaya',
        label: 'Uwajimaya'
    },
    {
        value: 'van_leeuwen',
        label: 'Van Leeuwen Ice Cream'
    },
    {
        value: 'venmo',
        label: 'Venmo'
    },
    {
        value: 'verizon',
        label: 'Verizon'
    },
    {
        value: 'vrbo',
        label: 'VRBO'
    },
    {
        value: 'vsp',
        label: 'VSP'
    },
    {
        value: 'walgreens',
        label: 'Walgreens'
    },
    {
        value: 'walmart',
        label: 'Walmart'
    },
    {
        value: 'wayfair',
        label: 'Wayfair'
    },
    {
        value: 'waymo',
        label: 'Waymo'
    },
    {
        value: 'wealthfront',
        label: 'Wealthfront'
    },
    {
        value: 'wegmans',
        label: 'Wegmans'
    },
    {
        value: 'wendys',
        label: "Wendy's"
    },
    {
        value: 'wework',
        label: 'WeWork'
    },
    {
        value: 'whole_foods',
        label: 'Whole Foods'
    },
    {
        value: 'wyze',
        label: 'Wyze'
    },
    {
        value: 'youtube',
        label: 'YouTube'
    },
    {
        value: 'zipcar',
        label: 'Zipcar'
    }
];
const $cd179cdb1a4beac3$export$56459e09a3b6cec7 = new Set([
    'cava',
    'treasury_direct'
]);
const $cd179cdb1a4beac3$export$5786b3bbd1515b69 = $cd179cdb1a4beac3$export$e2ad04535ed8af93.flatMap((option)=>option.value === '' ? [] : [
        option.value
    ]);
const $cd179cdb1a4beac3$var$LOGO_ID_SET = new Set($cd179cdb1a4beac3$export$5786b3bbd1515b69);
const $cd179cdb1a4beac3$export$f2c0893036cb40f8 = (value)=>value != null && $cd179cdb1a4beac3$var$LOGO_ID_SET.has(value);
/**
 * Content tag per logo: the first 8 hex of the file's sha256.
 *
 * Logo files are not content-hashed the way Parcel hashes bundles, because
 * the slug is the API — the database stores it and the server validates
 * against it — so the tag rides in the query string instead. It changes only
 * when the bytes change, which is what lets the server serve /logos/ as
 * immutable: a replaced logo gets a new URL, an unchanged one is never
 * re-fetched.
 */ const $cd179cdb1a4beac3$var$LOGO_VERSIONS = new Map([
    [
        '1800contacts',
        '69595f33'
    ],
    [
        '5ive_spice',
        '34276877'
    ],
    [
        '85c_bakery',
        '1e9ad0f6'
    ],
    [
        '99_ranch',
        'ba551ae4'
    ],
    [
        'aaa',
        'b34934bb'
    ],
    [
        'adobe',
        '77db37b7'
    ],
    [
        'aesop',
        '99b91b88'
    ],
    [
        'air_canada',
        '88810019'
    ],
    [
        'airbnb',
        'a40e1f95'
    ],
    [
        'alamo_drafthouse',
        'c5e8f9c0'
    ],
    [
        'alaska',
        'b049b213'
    ],
    [
        'ally',
        'b8fc8453'
    ],
    [
        'amazon',
        '67222b38'
    ],
    [
        'american_airlines',
        '8d03cdc2'
    ],
    [
        'amex',
        '52e54ecb'
    ],
    [
        'anthropic',
        '83a13746'
    ],
    [
        'apple',
        '56389c79'
    ],
    [
        'arcteryx',
        'dbecaecd'
    ],
    [
        'asiana',
        'd8658de8'
    ],
    [
        'backcountry',
        'c719dd1e'
    ],
    [
        'barclays',
        '831cd2e6'
    ],
    [
        'barnes_noble',
        'fffacf32'
    ],
    [
        'bed_bath_beyond',
        '17d446f5'
    ],
    [
        'bellagio',
        'f7ad90aa'
    ],
    [
        'berkeley_bowl',
        '49ea8e9c'
    ],
    [
        'best_buy',
        '55e96801'
    ],
    [
        'bh_photo',
        '54263405'
    ],
    [
        'big_sky',
        '7ed4a71c'
    ],
    [
        'blank_street',
        '2938ecd3'
    ],
    [
        'blue_apron',
        '82246fc0'
    ],
    [
        'blue_bottle',
        'db73f5c7'
    ],
    [
        'bluestone_lane',
        '9a6d177d'
    ],
    [
        'boa',
        '9291f1e5'
    ],
    [
        'bombas',
        '2d949591'
    ],
    [
        'bond_vet',
        'b7519ead'
    ],
    [
        'breckenridge',
        'bf41e908'
    ],
    [
        'brooklyn_paramount',
        '7a334aca'
    ],
    [
        'burger_king',
        'fca821a7'
    ],
    [
        'capital_one',
        '26d962e7'
    ],
    [
        'cava',
        'aef0d051'
    ],
    [
        'centurylink',
        'b4db2373'
    ],
    [
        'chargepoint',
        '6c6a9e96'
    ],
    [
        'chase',
        '8c3086a4'
    ],
    [
        'chelsea_piers',
        'df29989b'
    ],
    [
        'chevron',
        '86ee2eca'
    ],
    [
        'chewy',
        '5b3df40c'
    ],
    [
        'chipotle',
        '5e2fd706'
    ],
    [
        'cigna',
        'f464844a'
    ],
    [
        'citi',
        '9051e3c1'
    ],
    [
        'classpass',
        '65fe86e3'
    ],
    [
        'claude',
        '2f93a46d'
    ],
    [
        'cnb',
        'c013b202'
    ],
    [
        'coinbase',
        'bf66ec6b'
    ],
    [
        'coned',
        '6b70e916'
    ],
    [
        'container_store',
        'ce361231'
    ],
    [
        'cosmopolitan',
        '876af6de'
    ],
    [
        'costco',
        '5957fdd5'
    ],
    [
        'court16',
        '07813b7b'
    ],
    [
        'cvs',
        'd1a7eb38'
    ],
    [
        'dell',
        '7f7892cd'
    ],
    [
        'delta',
        '0a9c5dfb'
    ],
    [
        'design_within_reach',
        '55628452'
    ],
    [
        'dicks',
        'cceeb678'
    ],
    [
        'didi',
        'cc9a2a1c'
    ],
    [
        'digitalocean',
        '673c1a78'
    ],
    [
        'din_tai_fung',
        '8ed96462'
    ],
    [
        'doordash',
        '86fdb675'
    ],
    [
        'dropbox',
        '037f1c3b'
    ],
    [
        'dunkin',
        '5c557ae1'
    ],
    [
        'dyson',
        '71414334'
    ],
    [
        'eataly',
        'd9900662'
    ],
    [
        'emmy_squared',
        '49f2d8b2'
    ],
    [
        'eq3',
        '746da4a1'
    ],
    [
        'espresso_vivace',
        '556a4c7f'
    ],
    [
        'expedia',
        '8e6ed90e'
    ],
    [
        'exxonmobil',
        '2650df9b'
    ],
    [
        'ezpass',
        '9127ff86'
    ],
    [
        'facebook',
        '87d709c5'
    ],
    [
        'fandango',
        '6887dc52'
    ],
    [
        'fastmail',
        '9248daf0'
    ],
    [
        'fastrak',
        'b7d79fa2'
    ],
    [
        'fedex',
        'b8691c54'
    ],
    [
        'fidelity',
        'a1099ba3'
    ],
    [
        'first_republic',
        '156da0ca'
    ],
    [
        'five_guys',
        '199257d4'
    ],
    [
        'geico',
        '4534eb74'
    ],
    [
        'gong_cha',
        'b1d35152'
    ],
    [
        'goodtogo',
        'dbf988a6'
    ],
    [
        'google',
        '69f45460'
    ],
    [
        'grab',
        '1abfc274'
    ],
    [
        'h_mart',
        '249d2587'
    ],
    [
        'haidilao',
        '3b48af1b'
    ],
    [
        'hertz',
        '24ccdd7f'
    ],
    [
        'heytea',
        'ddf6ce71'
    ],
    [
        'hinge',
        '3e1f4c13'
    ],
    [
        'holafly',
        '26b9bcc5'
    ],
    [
        'home_depot',
        '15ebcbbf'
    ],
    [
        'ikea',
        '97dd5aed'
    ],
    [
        'irs',
        '4ae0ee3d'
    ],
    [
        'jetblue',
        '32e4ff2d'
    ],
    [
        'jr_central',
        'fa0af1cc'
    ],
    [
        'juniors',
        '3ff7be22'
    ],
    [
        'just_salad',
        '906f3c2e'
    ],
    [
        'kiehls',
        '096dcaa3'
    ],
    [
        'klook',
        '38b55d9a'
    ],
    [
        'korail',
        '8315096a'
    ],
    [
        'krispy_kreme',
        'e59cb0c0'
    ],
    [
        'lego',
        '0e9ccd50'
    ],
    [
        'lemonade',
        'd4d3ab18'
    ],
    [
        'life_time',
        '90e43973'
    ],
    [
        'lime',
        '9152323b'
    ],
    [
        'luckin',
        'adde1846'
    ],
    [
        'lululemon',
        'e5389e7a'
    ],
    [
        'lyft',
        'a3676fc0'
    ],
    [
        'madewell',
        'b283bc68'
    ],
    [
        'max',
        '8121d91d'
    ],
    [
        'mcdonalds',
        'a31c025d'
    ],
    [
        'meowtel',
        'faa6a281'
    ],
    [
        'microsoft',
        'ab733ed6'
    ],
    [
        'molly_moon',
        '729fd969'
    ],
    [
        'mox',
        'f5ab4a4c'
    ],
    [
        'mta',
        '13ca082c'
    ],
    [
        'muji',
        '2daf7660'
    ],
    [
        'nenes_taqueria',
        '7ae07a4e'
    ],
    [
        'netflix',
        'e7e50d77'
    ],
    [
        'new_york_life',
        '699de547'
    ],
    [
        'nintendo',
        '6e52dcca'
    ],
    [
        'nyc_finance',
        '2a4f0a89'
    ],
    [
        'nyrr',
        '647a2b3f'
    ],
    [
        'nytimes',
        'b16927b9'
    ],
    [
        'obe_fitness',
        'ade7d08c'
    ],
    [
        'one_medical',
        'd5afa03a'
    ],
    [
        'openai',
        '335b85cf'
    ],
    [
        'paris_baguette',
        'b4abc43e'
    ],
    [
        'partners_coffee',
        '970101aa'
    ],
    [
        'patreon',
        '5bfaa43b'
    ],
    [
        'pax',
        '08b7e47e'
    ],
    [
        'paypal',
        '504c6a0c'
    ],
    [
        'petco',
        'e712a9b5'
    ],
    [
        'philz',
        '05a5dd3f'
    ],
    [
        'plaid',
        '213f5e35'
    ],
    [
        'progressive',
        '7579aaa1'
    ],
    [
        'pseg',
        '58ea5a45'
    ],
    [
        'qfc',
        '48bec78c'
    ],
    [
        'rakuten',
        'bcc31b79'
    ],
    [
        'ratp',
        '7dee9fdb'
    ],
    [
        'rei',
        'cd62ca12'
    ],
    [
        'render',
        '74a9eecb'
    ],
    [
        'riot_games',
        '607bcb43'
    ],
    [
        'safeway',
        'e0d6f20b'
    ],
    [
        'saks',
        '62d7f97a'
    ],
    [
        'salt_and_straw',
        '700d340f'
    ],
    [
        'sbp',
        '8062517b'
    ],
    [
        'schwab',
        'ada86324'
    ],
    [
        'seats_aero',
        'a22bd9d1'
    ],
    [
        'seattle_city_light',
        'df1c8c9b'
    ],
    [
        'seattle_coffee_works',
        '637542a8'
    ],
    [
        'seven_eleven',
        '3b563219'
    ],
    [
        'shell',
        '3b27e677'
    ],
    [
        'shoppers_drug_mart',
        'd72e8c57'
    ],
    [
        'shoprite',
        '979bfc29'
    ],
    [
        'southwest',
        'caf02cec'
    ],
    [
        'splitwise',
        '434f0de3'
    ],
    [
        'spotify',
        '29c069c4'
    ],
    [
        'staples',
        'f715c7d4'
    ],
    [
        'starbucks',
        'be7df4ca'
    ],
    [
        'state_farm',
        '2b3b9ed8'
    ],
    [
        'steam',
        '740034d9'
    ],
    [
        'stewarts_shops',
        'cc447547'
    ],
    [
        'stowe',
        '6523ae83'
    ],
    [
        'stripe',
        'fe14e67e'
    ],
    [
        'stumptown',
        '1e2aa3fe'
    ],
    [
        'summit_snoqualmie',
        '32da24cc'
    ],
    [
        'sweetgreen',
        '9db3646e'
    ],
    [
        't_mobile',
        'fd0db42d'
    ],
    [
        'taim',
        'ef87a46f'
    ],
    [
        'target',
        'a24b2138'
    ],
    [
        'taskrabbit',
        'd31654dd'
    ],
    [
        'tennis_warehouse',
        'feceb10d'
    ],
    [
        'tesla',
        '4689e5e3'
    ],
    [
        'the_sill',
        'fb78c48e'
    ],
    [
        'ticketmaster',
        '2a392f17'
    ],
    [
        'tim_hortons',
        '2d7adb18'
    ],
    [
        'tj_maxx',
        'e7e4b246'
    ],
    [
        'trade_coffee',
        'd3fcc568'
    ],
    [
        'trader_joes',
        'cece8153'
    ],
    [
        'treasury_direct',
        '4593f1b9'
    ],
    [
        'uber',
        'e154b2b8'
    ],
    [
        'uber_eats',
        'd124db59'
    ],
    [
        'uhaul',
        'ac5a4cba'
    ],
    [
        'uniqlo',
        'a1acf902'
    ],
    [
        'united',
        '2f398266'
    ],
    [
        'ups',
        '149ed08d'
    ],
    [
        'us_bank',
        'aa69eadb'
    ],
    [
        'usps',
        '70482f05'
    ],
    [
        'uwajimaya',
        '36d10ec7'
    ],
    [
        'van_leeuwen',
        '7869b9ec'
    ],
    [
        'venmo',
        'd67d5491'
    ],
    [
        'verizon',
        '3ae5937f'
    ],
    [
        'vrbo',
        'd450ff44'
    ],
    [
        'vsp',
        'b4e75e18'
    ],
    [
        'walgreens',
        'fad7a3bc'
    ],
    [
        'walmart',
        'b49e77ea'
    ],
    [
        'wayfair',
        '813e680c'
    ],
    [
        'waymo',
        'b694a2ed'
    ],
    [
        'wealthfront',
        '0d4c8781'
    ],
    [
        'wegmans',
        '8352d7c8'
    ],
    [
        'wendys',
        'd7680382'
    ],
    [
        'wework',
        '45cb301f'
    ],
    [
        'whole_foods',
        'ae4755ce'
    ],
    [
        'wyze',
        'd58aecba'
    ],
    [
        'youtube',
        '40eff1cb'
    ],
    [
        'zipcar',
        '3fee8efe'
    ]
]);
const $cd179cdb1a4beac3$export$2e8a6207c9cc2bb8 = (logo)=>{
    const version = $cd179cdb1a4beac3$var$LOGO_VERSIONS.get(logo);
    return `/logos/${logo}.png${version === undefined ? '' : `?v=${version}`}`;
};


/**
 * Trails longer than this collapse their middle entries into a "…" popover:
 * first crumb, …, and the last (MAX_VISIBLE_CRUMBS - 2) crumbs stay visible.
 */ const $0bc606ab8db3c36e$var$MAX_VISIBLE_CRUMBS = 4;
const $0bc606ab8db3c36e$var$Separator = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
        className: "h-4 w-4 shrink-0 text-muted-foreground"
    });
const $0bc606ab8db3c36e$var$CrumbLink = ({ entry: entry })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
        to: entry.href,
        className: "flex max-w-48 min-w-0 items-center gap-1 text-muted-foreground no-underline hover:text-foreground",
        children: [
            entry.logo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, $cd179cdb1a4beac3$export$2e8a6207c9cc2bb8)(entry.logo),
                alt: "",
                className: "size-3.5 shrink-0 rounded-sm"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "truncate",
                children: entry.label
            })
        ]
    });
const $0bc606ab8db3c36e$var$OverflowMenu = ({ entries: entries })=>{
    const [isOpen, setIsOpen] = $acw62.useState(false);
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const handleSelect = (entry)=>{
        setIsOpen(false);
        navigate(entry.href);
    };
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('shadow-popover bg-popover text-popover-foreground outline-ring/50', 'flex flex-col overflow-y-auto rounded-md py-1 outline-1'),
        role: "menu",
        children: entries.map((entry, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                role: "menuitem",
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('hover:bg-accent/50 cursor-pointer px-3 py-1.5 text-left text-sm', 'max-w-64 truncate'),
                onClick: ()=>handleSelect(entry),
                children: entry.label
            }, i))
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $497d44d806a05c0a$export$2e2bcd8739ae039), {
        open: isOpen,
        popoverContents: content,
        popoverAnchor: "bottom-left",
        onOutsideClick: ()=>setIsOpen(false),
        children: (anchorRef)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                ref: anchorRef,
                "aria-label": "Show hidden breadcrumbs",
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex cursor-pointer items-center rounded p-0.5', 'text-muted-foreground hover:bg-accent/50 hover:text-foreground'),
                onClick: ()=>setIsOpen((open)=>!open),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b698d1771218a1ca$export$2e2bcd8739ae039), {
                    className: "h-4 w-4"
                })
            })
    });
};
const $0bc606ab8db3c36e$export$dabcc1ec9dd9d1cc = ()=>{
    const { trail: trail } = (0, $09fc5346bd733ea4$export$2b0682676e510409)();
    if (trail.length === 0) return null;
    const shouldCollapse = trail.length > $0bc606ab8db3c36e$var$MAX_VISIBLE_CRUMBS;
    const head = shouldCollapse ? [
        trail[0]
    ] : trail.slice(0, -1);
    const hidden = shouldCollapse ? trail.slice(1, trail.length - ($0bc606ab8db3c36e$var$MAX_VISIBLE_CRUMBS - 2)) : [];
    const tail = shouldCollapse ? trail.slice(trail.length - ($0bc606ab8db3c36e$var$MAX_VISIBLE_CRUMBS - 2), -1) : [];
    const last = trail[trail.length - 1];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
        "aria-label": "Breadcrumb",
        className: "flex min-w-0 items-center gap-1.5 text-lg",
        children: [
            head.map((entry, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                    children: [
                        i > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0bc606ab8db3c36e$var$Separator, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0bc606ab8db3c36e$var$CrumbLink, {
                            entry: entry
                        })
                    ]
                }, `head-${i}`)),
            hidden.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0bc606ab8db3c36e$var$Separator, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0bc606ab8db3c36e$var$OverflowMenu, {
                        entries: hidden
                    })
                ]
            }),
            tail.map((entry, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0bc606ab8db3c36e$var$Separator, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0bc606ab8db3c36e$var$CrumbLink, {
                            entry: entry
                        })
                    ]
                }, `tail-${i}`)),
            trail.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0bc606ab8db3c36e$var$Separator, {}),
            last.logo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, $cd179cdb1a4beac3$export$2e8a6207c9cc2bb8)(last.logo),
                alt: "",
                className: "size-4 shrink-0 rounded-sm"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "aria-current": "page",
                className: "min-w-0 truncate font-medium text-foreground",
                children: last.label
            })
        ]
    });
};






parcelRequire("acw62");
// GENERATED FILE — do not edit by hand.
// Run `yarn generate:cards` after changing frontend/static/cards/ or
// cards/labels.json. See cards/README.md.
/** Every card face committed to frontend/static/cards/, rendered as /cards/{id}.webp */ const $86559021d806b4ea$export$cdf9be4b8896bd67 = [
    {
        value: 'amex_platinum',
        label: 'American Express Platinum'
    },
    {
        value: 'barclays_jetblue',
        label: 'Barclays JetBlue Card'
    },
    {
        value: 'barclays_jetblue_premier',
        label: 'Barclays JetBlue Premier Card'
    },
    {
        value: 'capital_one_venture_x',
        label: 'Capital One Venture X'
    },
    {
        value: 'chase_freedom',
        label: 'Chase Freedom'
    },
    {
        value: 'chase_freedom_unlimited',
        label: 'Chase Freedom Unlimited'
    },
    {
        value: 'chase_sapphire_preferred',
        label: 'Chase Sapphire Preferred'
    },
    {
        value: 'chase_sapphire_reserve',
        label: 'Chase Sapphire Reserve'
    },
    {
        value: 'chase_united_gateway',
        label: 'Chase United Gateway'
    },
    {
        value: 'citi_aadvantage_mileup',
        label: 'Citi AAdvantage MileUp'
    },
    {
        value: 'citi_aadvantage_platinum_select',
        label: 'Citi AAdvantage Platinum Select'
    },
    {
        value: 'citi_custom_cash',
        label: 'Citi Custom Cash'
    },
    {
        value: 'citi_strata_premier',
        label: 'Citi Strata Premier'
    },
    {
        value: 'citi_thankyou_preferred',
        label: 'Citi ThankYou Preferred'
    }
];
const $86559021d806b4ea$var$LABELS = new Map($86559021d806b4ea$export$cdf9be4b8896bd67.map((option)=>[
        option.value,
        option.label
    ]));
const $86559021d806b4ea$export$f2ae116f2284ed4d = (value)=>value != null && $86559021d806b4ea$var$LABELS.has(value);
const $86559021d806b4ea$export$16faba7ad8bb8def = (value)=>value == null ? null : $86559021d806b4ea$var$LABELS.get(value) ?? null;
/**
 * Content tag per face: the first 8 hex of the file's sha256. Same reason as
 * logoOptions.ts — the slug is stored in the database, so the filename can
 * never carry the hash, and the tag rides in the query string instead so the
 * server can serve /cards/ as immutable.
 */ const $86559021d806b4ea$var$CARD_VERSIONS = new Map([
    [
        'amex_platinum',
        '6f20e7f9'
    ],
    [
        'barclays_jetblue',
        '85d65612'
    ],
    [
        'barclays_jetblue_premier',
        'b2d4f8c3'
    ],
    [
        'capital_one_venture_x',
        'de63c64f'
    ],
    [
        'chase_freedom',
        '25cdae6a'
    ],
    [
        'chase_freedom_unlimited',
        '072437b8'
    ],
    [
        'chase_sapphire_preferred',
        '2fb56991'
    ],
    [
        'chase_sapphire_reserve',
        '17d64910'
    ],
    [
        'chase_united_gateway',
        '2efeaae8'
    ],
    [
        'citi_aadvantage_mileup',
        'a8f9b363'
    ],
    [
        'citi_aadvantage_platinum_select',
        '9063a5f8'
    ],
    [
        'citi_custom_cash',
        'a5a86bdd'
    ],
    [
        'citi_strata_premier',
        'b9d5d4b6'
    ],
    [
        'citi_thankyou_preferred',
        '4c01fa27'
    ]
]);
const $86559021d806b4ea$export$4bae84b05780a0af = (product)=>{
    const version = $86559021d806b4ea$var$CARD_VERSIONS.get(product);
    return `/cards/${product}.webp${version === undefined ? '' : `?v=${version}`}`;
};


const $7b39b2c71e902baf$export$ebcc69552e0d5c4c = ({ product: product, className: className = 'w-9', alt: alt = '' })=>{
    if (!(0, $86559021d806b4ea$export$f2ae116f2284ed4d)(product)) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: (0, $86559021d806b4ea$export$4bae84b05780a0af)(product),
        alt: alt,
        loading: "lazy",
        // Square corners: every committed face is a hard rectangle with its
        // own artwork running to the edge, so rounding it clips the art rather
        // than following it. The faint ring keeps a dark face from dissolving
        // into a dark surface and a silver one from floating on white.
        className: `${className} ring-foreground/10 aspect-[1.586] shrink-0 object-cover ring-1`
    });
};





/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1571f1c57333e026$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "12",
            x: "2",
            y: "6",
            rx: "2",
            key: "9lu3g6"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "2",
            key: "1c9p78"
        }
    ],
    [
        "path",
        {
            d: "M6 12h.01M18 12h.01",
            key: "113zkx"
        }
    ]
];
const $1571f1c57333e026$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("banknote", $1571f1c57333e026$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1299b0a605d22052$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "5",
            rx: "2",
            key: "ynyp8z"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "10",
            y2: "10",
            key: "1b3vmo"
        }
    ]
];
const $1299b0a605d22052$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("credit-card", $1299b0a605d22052$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $07139920b5ad0ce2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17",
            key: "geh8rc"
        }
    ],
    [
        "path",
        {
            d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
            key: "1fto5m"
        }
    ],
    [
        "path",
        {
            d: "m2 16 6 6",
            key: "1pfhp9"
        }
    ],
    [
        "circle",
        {
            cx: "16",
            cy: "9",
            r: "2.9",
            key: "1n0dlu"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "5",
            r: "3",
            key: "151irh"
        }
    ]
];
const $07139920b5ad0ce2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("hand-coins", $07139920b5ad0ce2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $05565f19ab398c04$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 18v-7",
            key: "wt116b"
        }
    ],
    [
        "path",
        {
            d: "M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z",
            key: "1m329m"
        }
    ],
    [
        "path",
        {
            d: "M14 18v-7",
            key: "vav6t3"
        }
    ],
    [
        "path",
        {
            d: "M18 18v-7",
            key: "aexdmj"
        }
    ],
    [
        "path",
        {
            d: "M3 22h18",
            key: "8prr45"
        }
    ],
    [
        "path",
        {
            d: "M6 18v-7",
            key: "1ivflk"
        }
    ]
];
const $05565f19ab398c04$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("landmark", $05565f19ab398c04$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0811c1891b547863$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3v18",
            key: "108xh3"
        }
    ],
    [
        "path",
        {
            d: "m19 8 3 8a5 5 0 0 1-6 0zV7",
            key: "zcdpyk"
        }
    ],
    [
        "path",
        {
            d: "M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1",
            key: "1yorad"
        }
    ],
    [
        "path",
        {
            d: "m5 8 3 8a5 5 0 0 1-6 0zV7",
            key: "eua70x"
        }
    ],
    [
        "path",
        {
            d: "M7 21h10",
            key: "1b0cd5"
        }
    ]
];
const $0811c1891b547863$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("scale", $0811c1891b547863$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c9921f4f81a419f0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 7h6v6",
            key: "box55l"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.5 8.5-5-5L2 17",
            key: "1t1m79"
        }
    ]
];
const $c9921f4f81a419f0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trending-up", $c9921f4f81a419f0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $33b542e8915cec79$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
            key: "18etb6"
        }
    ],
    [
        "path",
        {
            d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4",
            key: "xoc0q4"
        }
    ]
];
const $33b542e8915cec79$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("wallet", $33b542e8915cec79$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $676ce5437a069c0b$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2",
            key: "4125el"
        }
    ],
    [
        "path",
        {
            d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
            key: "1dpki6"
        }
    ]
];
const $676ce5437a069c0b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("wallet-cards", $676ce5437a069c0b$export$3efd853dbb351e94);


parcelRequire("acw62");

const $8f6f28ec3b697fb2$var$styleForAccount = (account)=>{
    if (account.__typename === 'InvestmentAccount') return {
        Icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
        background: 'bg-orange-600'
    };
    switch(account.depositoryType){
        case (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Checking:
        case (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Savings:
            return {
                Icon: (0, $05565f19ab398c04$export$2e2bcd8739ae039),
                background: 'bg-blue-600'
            };
        case (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard:
            return {
                Icon: (0, $1299b0a605d22052$export$2e2bcd8739ae039),
                background: 'bg-violet-600'
            };
        case (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Cash:
            return {
                Icon: (0, $1571f1c57333e026$export$2e2bcd8739ae039),
                background: 'bg-emerald-600'
            };
        case (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Wallet:
            return {
                Icon: (0, $676ce5437a069c0b$export$2e2bcd8739ae039),
                background: 'bg-teal-600'
            };
        case (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Loan:
            return {
                Icon: (0, $07139920b5ad0ce2$export$2e2bcd8739ae039),
                background: 'bg-rose-600'
            };
        case (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Ledger:
            // Clearing ledgers settle back to zero — the scale reads "balancing
            // out", and cyan keeps it distinct from every institution color.
            return {
                Icon: (0, $0811c1891b547863$export$2e2bcd8739ae039),
                background: 'bg-cyan-600'
            };
        case (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Other:
        default:
            return {
                Icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
                background: 'bg-slate-500'
            };
    }
};
const $8f6f28ec3b697fb2$export$fdaddccc706daa3a = ({ account: account, className: className })=>{
    const { Icon: Icon, background: background } = $8f6f28ec3b697fb2$var$styleForAccount(account);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex aspect-square size-4 items-center justify-center rounded-[25%] text-white', background, className),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
            className: "size-[70%]"
        })
    });
};




parcelRequire("acw62");
const $f4e98da5ab86bcf9$var$Empty = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex h-full w-full items-center justify-center text-xl text-muted-foreground",
        children: props.children
    });
};
var $f4e98da5ab86bcf9$export$2e2bcd8739ae039 = $f4e98da5ab86bcf9$var$Empty;





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ 
const $7d867aa0bbfd521e$var$falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const $7d867aa0bbfd521e$export$a274e22fb40f762e = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
const $7d867aa0bbfd521e$export$87dc52566e90b739 = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $7d867aa0bbfd521e$var$falsyToString(variantProp) || $7d867aa0bbfd521e$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };



var $acw62 = parcelRequire("acw62");

const $bd245b1ec6e3b89c$var$variants = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)([
    'flex items-center justify-center shadow-xs transition cursor-pointer'
], {
    variants: {
        variant: {
            primary: 'bg-primary text-primary-foreground hover:bg-primary/80',
            destructive: 'dark:bg-destructive/60 dark:hover:bg-destructive/80 bg-destructive text-white hover:bg-destructive/80',
            ghost: 'bg-transparent text-foreground hover:bg-accent shadow-none',
            outline: 'border border-input text-foreground hover:bg-accent/30'
        },
        disabled: {
            true: 'opacity-50 pointer-events-none'
        },
        size: {
            icon: 'rounded-full p-2.5',
            default: 'rounded-md px-4 py-2'
        }
    },
    defaultVariants: {
        variant: 'primary',
        size: 'default'
    }
});
const $bd245b1ec6e3b89c$export$353f5b6fc5456de1 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { variant: variant, size: size, type: type, className: className, disabled: disabled, ...otherProps } = props;
    const baseClassName = $bd245b1ec6e3b89c$var$variants({
        variant: variant,
        size: size,
        disabled: disabled
    });
    const mergedClassName = (0, $85fc2fe65ff21506$exports.twMerge)(baseClassName, className);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ref: ref,
        type: type || 'button',
        className: mergedClassName,
        disabled: disabled,
        ...otherProps
    });
});




/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cfb3b3013a649f15$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $cfb3b3013a649f15$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("x", $cfb3b3013a649f15$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
const $0d782dda3ae8b215$export$32d5543ab307c01 = (query, options = {})=>{
    const getMatches = ()=>typeof window !== 'undefined' ? window.matchMedia(query).matches : options.defaultValue ?? false;
    const [matches, setMatches] = $acw62.useState(getMatches);
    $acw62.useEffect(()=>{
        if (typeof window === 'undefined') return;
        const mediaQuery = window.matchMedia(query);
        const listener = (event)=>setMatches(event.matches);
        setMatches(mediaQuery.matches);
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', listener);
            return ()=>mediaQuery.removeEventListener('change', listener);
        } else {
            mediaQuery.addListener(listener);
            return ()=>mediaQuery.removeListener(listener);
        }
    }, [
        query
    ]);
    return matches;
};


const $d720d4657ad5543c$export$dcc4079bc63af6b8 = '(max-width: 40rem)';
const $d720d4657ad5543c$export$2b96349243a56116 = (options = {
    defaultValue: true
})=>(0, $0d782dda3ae8b215$export$32d5543ab307c01)($d720d4657ad5543c$export$dcc4079bc63af6b8, options);


const $cf217f12860fadff$export$2b77a92f1a5ad772 = ({ children: children, size: size = 'md', className: className, dimBackground: dimBackground = true, onRequestClose: onRequestClose, header: header, label: label, footer: footer })=>{
    const isMobile = (0, $d720d4657ad5543c$export$2b96349243a56116)();
    const headerId = $acw62.useId();
    const variants = isMobile ? {
        hidden: {
            y: '100%',
            opacity: 0
        },
        visible: {
            y: 0,
            opacity: 1
        },
        exit: {
            y: '100%',
            opacity: 0
        }
    } : {
        hidden: {
            transform: 'scale(0.96)',
            opacity: 0
        },
        visible: {
            transform: 'scale(1)',
            opacity: 1
        },
        exit: {
            transform: 'scale(0.96)',
            opacity: 0
        }
    };
    const dialogClassName = (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('bg-background ring-ring/50 rounded-lg shadow-lg ring-1', 'flex flex-col max-w-full overflow-hidden', // Mobile: use dvh to account for keyboard. top-8 = 2rem offset from top.
    'fixed top-8 left-0 right-0 h-[calc(100dvh-2rem)]', // Desktop: anchored to a fixed top rather than vertically centered, so a
    // modal whose content arrives asynchronously grows downward instead of
    // shifting every field by half the delta in both directions.
    'sm:inset-auto sm:top-[9vh] sm:left-1/2 sm:w-auto sm:-translate-x-1/2', 'sm:h-auto sm:max-h-[85vh]', size === 'sm' && 'sm:w-sm', size === 'md' && 'sm:w-md', size === 'lg' && 'sm:w-lg', className);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94339ef075b24dd2$export$c6fdb837b070b4ff), {
        dimBackground: dimBackground,
        onOverlayClick: onRequestClose,
        blurBackground: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            initial: "hidden",
            animate: "visible",
            exit: "exit",
            variants: variants,
            transition: {
                duration: 0.3,
                ease: 'easeOut'
            },
            className: dialogClassName,
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": header ? headerId : undefined,
            "aria-label": label,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9feaa5924c876b6a$export$2e2bcd8739ae039), {
                behavior: "trap",
                children: [
                    header && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border-border flex shrink-0 flex-row items-center justify-between border-b px-6 py-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                id: headerId,
                                className: "text-lg",
                                children: header
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                onClick: onRequestClose,
                                "aria-label": "Close",
                                className: "size-8",
                                variant: "ghost",
                                size: "icon",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    className: "size-4"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        onClick: (e)=>e.stopPropagation(),
                        className: "min-h-0 flex-1 overflow-y-auto px-6 py-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                        initial: false,
                        children: footer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                            initial: {
                                height: 0
                            },
                            animate: {
                                height: 'auto'
                            },
                            exit: {
                                height: 0
                            },
                            transition: {
                                duration: 0.26,
                                ease: [
                                    0.2,
                                    0.8,
                                    0.2,
                                    1
                                ]
                            },
                            className: "shrink-0 overflow-hidden",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "border-border flex flex-row items-center justify-end gap-2 border-t px-6 py-4",
                                children: footer
                            })
                        }, "footer")
                    })
                ]
            })
        })
    });
};


const $8a12bf80f6fca0b5$export$776b8bf98ad485ed = (props)=>{
    const { kind: kind, entryId: entryId, entryDate: entryDate, onDeleted: onDeleted, onRequestClose: onRequestClose } = props;
    const [deleteAnchor, { loading: deletingAnchor }] = (0, $ce9d9e524be20f53$export$b24be224d4f4a7fe)();
    const [deleteReading, { loading: deletingReading }] = (0, $ce9d9e524be20f53$export$c78712a61e8c6f22)();
    const loading = deletingAnchor || deletingReading;
    const [error, setError] = $acw62.useState(null);
    const handleDelete = async ()=>{
        setError(null);
        try {
            if (kind === 'anchor') await deleteAnchor({
                variables: {
                    anchorId: entryId
                }
            });
            else await deleteReading({
                variables: {
                    readingId: entryId
                }
            });
            onDeleted?.();
            onRequestClose();
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Failed to delete balance');
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                onClick: ()=>void handleDelete(),
                disabled: loading,
                children: loading ? 'Deleting...' : 'Delete'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: kind === 'anchor' ? 'Delete balance' : 'Delete synced balance',
        footer: footer,
        size: "sm",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-destructive/10 text-destructive mb-3 rounded-md p-3 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Are you sure you want to delete the balance for",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: entryDate
                    }),
                    "? This action cannot be undone."
                ]
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");


const $7db86d96a9b2815e$export$da78efecf8378488 = (props)=>{
    const { reconciliationId: reconciliationId, anchorDate: anchorDate, transactionCount: transactionCount, onDeleted: onDeleted, onRequestClose: onRequestClose } = props;
    const [deleteReconciliation, { loading: loading }] = (0, $ce9d9e524be20f53$export$d6c3bbb7a188fe0f)();
    const [error, setError] = $acw62.useState(null);
    const handleDelete = async ()=>{
        setError(null);
        try {
            await deleteReconciliation({
                variables: {
                    reconciliationId: reconciliationId
                }
            });
            onDeleted?.();
            onRequestClose();
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Failed to delete reconciliation');
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                onClick: ()=>void handleDelete(),
                disabled: loading,
                children: loading ? 'Unreconciling...' : 'Unreconcile'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Unreconcile balance",
        footer: footer,
        size: "sm",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-destructive/10 text-destructive mb-3 rounded-md p-3 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Are you sure you want to unreconcile the balance for",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: anchorDate
                    }),
                    "? The balance itself is kept; this deletes the reconciliation and unlocks the",
                    ' ',
                    transactionCount === 1 ? 'associated transaction' : `${transactionCount} associated transactions`,
                    "."
                ]
            })
        ]
    });
};




class $145d7e42bdaa79ff$var$Money {
    constructor(amount, currency){
        this.equals = (other)=>this.currency === other.currency && this.amount === other.amount;
        this.toInt = ()=>{
            return {
                amount: this.amount,
                currency: this.currency
            };
        };
        this.negative = ()=>$145d7e42bdaa79ff$var$Money.fromInt(-1 * this.amount, this.currency);
        this.amount = amount;
        this.currency = currency;
        this.isPositive = amount > 0;
        this.isNegative = amount < 0;
        this.isZero = amount === 0;
    }
    static{
        this.plus = (l, r)=>{
            if (l.currency !== r.currency) throw new Error("Adding multiple currencies together");
            return new $145d7e42bdaa79ff$var$Money(l.amount + r.amount, l.currency);
        };
    }
    static{
        this.minus = (l, r)=>{
            if (l.currency !== r.currency) throw new Error("Adding multiple currencies together");
            return new $145d7e42bdaa79ff$var$Money(l.amount - r.amount, l.currency);
        };
    }
    static{
        this.fromInt = (amount, currency)=>{
            return new $145d7e42bdaa79ff$var$Money(amount, currency);
        };
    }
    static{
        this.fromDecimal = (amount, currency)=>{
            return $145d7e42bdaa79ff$var$Money.fromInt(parseFloat((amount * 100).toFixed(2)), currency);
        };
    }
    static{
        this.fromServer = ({ amount: amount, currency: currency })=>{
            return $145d7e42bdaa79ff$var$Money.fromInt(amount, currency);
        };
    }
    static{
        this.toServer = (money)=>{
            return {
                amount: money.amount,
                currency: money.currency
            };
        };
    }
    static{
        this.zero = (currency)=>$145d7e42bdaa79ff$var$Money.fromInt(0, currency);
    }
    static{
        this.toDecimalString = (money, options)=>{
            let formatted;
            try {
                // Storage is uniform hundredths, so a currency's third decimal (KWD,
                // BHD) is unrepresentable; clamp display to two digits so rendered
                // strings round-trip through amount inputs, which parse typed digits
                // at min(2, the currency's Intl digits).
                const defaultDigits = new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: money.currency
                }).resolvedOptions().maximumFractionDigits ?? 2;
                formatted = new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: money.currency,
                    ...defaultDigits > 2 ? {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    } : {}
                }).format(money.amount / 100);
            } catch  {
                // Non-ISO commodity currencies (TENNIS_CLASS, MILES) have no Intl
                // formatting; render the bare number with the code as a suffix.
                // Always two decimals: amount inputs parse displayed digits by the
                // currency's minor unit, so the rendering must round-trip.
                const bare = new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(money.amount / 100);
                formatted = options?.showCurrency === false ? bare : `${bare} ${money.currency}`;
            }
            return options?.showCurrency === false ? formatted.replace(/[^0-9-,.]/g, "") : formatted;
        };
    }
}
var $145d7e42bdaa79ff$export$2e2bcd8739ae039 = $145d7e42bdaa79ff$var$Money;


var $63618293c58b5f80$exports = {};
'use strict';
Object.defineProperty($63618293c58b5f80$exports, '__esModule', {
    value: true
});
function $63618293c58b5f80$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $63618293c58b5f80$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $63618293c58b5f80$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $63618293c58b5f80$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $63618293c58b5f80$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $63618293c58b5f80$var$_getPrototypeOf(o) {
    $63618293c58b5f80$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $63618293c58b5f80$var$_getPrototypeOf(o);
}
function $63618293c58b5f80$var$_setPrototypeOf(o, p) {
    $63618293c58b5f80$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $63618293c58b5f80$var$_setPrototypeOf(o, p);
}
function $63618293c58b5f80$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$_construct(Parent, args, Class) {
    if ($63618293c58b5f80$var$_isNativeReflectConstruct()) $63618293c58b5f80$var$_construct = Reflect.construct;
    else $63618293c58b5f80$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $63618293c58b5f80$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $63618293c58b5f80$var$_construct.apply(null, arguments);
}
function $63618293c58b5f80$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $63618293c58b5f80$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $63618293c58b5f80$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$63618293c58b5f80$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $63618293c58b5f80$var$_construct(Class, arguments, $63618293c58b5f80$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $63618293c58b5f80$var$_setPrototypeOf(Wrapper, Class);
    };
    return $63618293c58b5f80$var$_wrapNativeSuper(Class);
}
function $63618293c58b5f80$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $63618293c58b5f80$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
}
function $63618293c58b5f80$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $63618293c58b5f80$var$_createForOfIteratorHelperLoose(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $63618293c58b5f80$var$_unsupportedIterableToArray(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $63618293c58b5f80$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $63618293c58b5f80$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $63618293c58b5f80$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $63618293c58b5f80$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $63618293c58b5f80$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$n = "numeric", $63618293c58b5f80$var$s = "short", $63618293c58b5f80$var$l = "long";
var $63618293c58b5f80$var$DATE_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATE_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_24_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    hour12: false
};
/**
 * {@link toLocaleString}; format like '09:30:23', always 24-hour.
 */ var $63618293c58b5f80$var$TIME_24_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hour12: false
};
/**
 * {@link toLocaleString}; format like '09:30:23 EDT', always 24-hour.
 */ var $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hour12: false,
    timeZoneName: $63618293c58b5f80$var$s
};
/**
 * {@link toLocaleString}; format like '09:30:23 Eastern Daylight Time', always 24-hour.
 */ var $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hour12: false,
    timeZoneName: $63618293c58b5f80$var$l
};
/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
 */ var $63618293c58b5f80$var$DATETIME_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
 */ var $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/ /**
 * @private
 */ // TYPES
function $63618293c58b5f80$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $63618293c58b5f80$var$isNumber(o) {
    return typeof o === "number";
}
function $63618293c58b5f80$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $63618293c58b5f80$var$isString(o) {
    return typeof o === "string";
}
function $63618293c58b5f80$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
} // CAPABILITIES
function $63618293c58b5f80$var$hasIntl() {
    try {
        return typeof Intl !== "undefined" && Intl.DateTimeFormat;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$hasFormatToParts() {
    return !$63618293c58b5f80$var$isUndefined(Intl.DateTimeFormat.prototype.formatToParts);
}
function $63618293c58b5f80$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
} // OBJECTS AND ARRAYS
function $63618293c58b5f80$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $63618293c58b5f80$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $63618293c58b5f80$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $63618293c58b5f80$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
} // NUMBERS AND STRINGS
function $63618293c58b5f80$var$integerBetween(thing, bottom, top) {
    return $63618293c58b5f80$var$isInteger(thing) && thing >= bottom && thing <= top;
} // x % n but takes the sign of n instead of x
function $63618293c58b5f80$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $63618293c58b5f80$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var minus = input < 0 ? "-" : "";
    var target = minus ? input * -1 : input;
    var result;
    if (target.toString().length < n) result = ("0".repeat(n) + target).slice(-n);
    else result = target.toString();
    return "" + minus + result;
}
function $63618293c58b5f80$var$parseInteger(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $63618293c58b5f80$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($63618293c58b5f80$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $63618293c58b5f80$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
} // DATE BASICS
function $63618293c58b5f80$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $63618293c58b5f80$var$daysInYear(year) {
    return $63618293c58b5f80$var$isLeapYear(year) ? 366 : 365;
}
function $63618293c58b5f80$var$daysInMonth(year, month) {
    var modMonth = $63618293c58b5f80$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $63618293c58b5f80$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $63618293c58b5f80$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        d.setUTCFullYear(d.getUTCFullYear() - 1900);
    }
    return +d;
}
function $63618293c58b5f80$var$weeksInWeekYear(weekYear) {
    var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $63618293c58b5f80$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > 60 ? 1900 + year : 2000 + year;
} // PARSING
function $63618293c58b5f80$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = Object.assign({
        timeZoneName: offsetFormat
    }, intlOpts), intl = $63618293c58b5f80$var$hasIntl();
    if (intl && $63618293c58b5f80$var$hasFormatToParts()) {
        var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
            return m.type.toLowerCase() === "timezonename";
        });
        return parsed ? parsed.value : null;
    } else if (intl) {
        // this probably doesn't work for all locales
        var without = new Intl.DateTimeFormat(locale, intlOpts).format(date), included = new Intl.DateTimeFormat(locale, modified).format(date), diffed = included.substring(without.length), trimmed = diffed.replace(/^[, \u200e]+/, "");
        return trimmed;
    } else return null;
} // signedOffset('-5', '30') -> -330
function $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10); // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
} // COERCION
function $63618293c58b5f80$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $63618293c58b5f80$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $63618293c58b5f80$var$normalizeObject(obj, normalizer, nonUnitKeys) {
    var normalized = {};
    for(var u in obj)if ($63618293c58b5f80$var$hasOwnProperty(obj, u)) {
        if (nonUnitKeys.indexOf(u) >= 0) continue;
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $63618293c58b5f80$var$asNumber(v);
    }
    return normalized;
}
function $63618293c58b5f80$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + ":" + $63618293c58b5f80$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + $63618293c58b5f80$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $63618293c58b5f80$var$timeObject(obj) {
    return $63618293c58b5f80$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
var $63618293c58b5f80$var$ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?/;
function $63618293c58b5f80$var$stringify(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}
/**
 * @private
 */ var $63618293c58b5f80$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $63618293c58b5f80$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $63618293c58b5f80$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $63618293c58b5f80$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$monthsNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$monthsShort);
        case "long":
            return [].concat($63618293c58b5f80$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $63618293c58b5f80$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $63618293c58b5f80$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $63618293c58b5f80$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$weekdaysNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$weekdaysShort);
        case "long":
            return [].concat($63618293c58b5f80$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$meridiems = [
    "AM",
    "PM"
];
var $63618293c58b5f80$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $63618293c58b5f80$var$erasShort = [
    "BC",
    "AD"
];
var $63618293c58b5f80$var$erasNarrow = [
    "B",
    "A"
];
function $63618293c58b5f80$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$erasNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$erasShort);
        case "long":
            return [].concat($63618293c58b5f80$var$erasLong);
        default:
            return null;
    }
}
function $63618293c58b5f80$var$meridiemForDateTime(dt) {
    return $63618293c58b5f80$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $63618293c58b5f80$var$weekdayForDateTime(dt, length) {
    return $63618293c58b5f80$var$weekdays(length)[dt.weekday - 1];
}
function $63618293c58b5f80$var$monthForDateTime(dt, length) {
    return $63618293c58b5f80$var$months(length)[dt.month - 1];
}
function $63618293c58b5f80$var$eraForDateTime(dt, length) {
    return $63618293c58b5f80$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $63618293c58b5f80$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $63618293c58b5f80$var$formatString(knownFormat) {
    // these all have the offsets removed because we don't have access to them
    // without all the intl stuff this is backfilling
    var filtered = $63618293c58b5f80$var$pick(knownFormat, [
        "weekday",
        "era",
        "year",
        "month",
        "day",
        "hour",
        "minute",
        "second",
        "timeZoneName",
        "hour12"
    ]), key = $63618293c58b5f80$var$stringify(filtered), dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";
    switch(key){
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATE_SHORT):
            return "M/d/yyyy";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATE_MED):
            return "LLL d, yyyy";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY):
            return "EEE, LLL d, yyyy";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATE_FULL):
            return "LLLL d, yyyy";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATE_HUGE):
            return "EEEE, LLLL d, yyyy";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_SIMPLE):
            return "h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_WITH_SECONDS):
            return "h:mm:ss a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET):
            return "h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_WITH_LONG_OFFSET):
            return "h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_24_SIMPLE):
            return "HH:mm";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_24_WITH_SECONDS):
            return "HH:mm:ss";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET):
            return "HH:mm";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET):
            return "HH:mm";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_SHORT):
            return "M/d/yyyy, h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_MED):
            return "LLL d, yyyy, h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_FULL):
            return "LLLL d, yyyy, h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_HUGE):
            return dateTimeHuge;
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS):
            return "M/d/yyyy, h:mm:ss a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS):
            return "LLL d, yyyy, h:mm:ss a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY):
            return "EEE, d LLL yyyy, h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS):
            return "LLLL d, yyyy, h:mm:ss a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS):
            return "EEEE, LLLL d, yyyy, h:mm:ss a";
        default:
            return dateTimeHuge;
    }
}
function $63618293c58b5f80$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $63618293c58b5f80$var$_macroTokenToFormatOpts = {
    D: $63618293c58b5f80$var$DATE_SHORT,
    DD: $63618293c58b5f80$var$DATE_MED,
    DDD: $63618293c58b5f80$var$DATE_FULL,
    DDDD: $63618293c58b5f80$var$DATE_HUGE,
    t: $63618293c58b5f80$var$TIME_SIMPLE,
    tt: $63618293c58b5f80$var$TIME_WITH_SECONDS,
    ttt: $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET,
    tttt: $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET,
    T: $63618293c58b5f80$var$TIME_24_SIMPLE,
    TT: $63618293c58b5f80$var$TIME_24_WITH_SECONDS,
    TTT: $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET,
    f: $63618293c58b5f80$var$DATETIME_SHORT,
    ff: $63618293c58b5f80$var$DATETIME_MED,
    fff: $63618293c58b5f80$var$DATETIME_FULL,
    ffff: $63618293c58b5f80$var$DATETIME_HUGE,
    F: $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS,
    FFF: $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $63618293c58b5f80$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed,
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: false,
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed,
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $63618293c58b5f80$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, Object.assign({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
        return df.formatToParts();
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
        return df.resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $63618293c58b5f80$var$padStart(n, p);
        var opts = Object.assign({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory" && $63618293c58b5f80$var$hasFormatToParts(), string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $63618293c58b5f80$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hour12: true
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $63618293c58b5f80$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $63618293c58b5f80$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $63618293c58b5f80$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
var $63618293c58b5f80$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
/**
 * @interface
 */ var $63618293c58b5f80$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    };
    $63618293c58b5f80$var$_createClass(Zone, [
        {
            key: "type",
            /**
     * The type of zone
     * @abstract
     * @type {string}
     */ get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "universal",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $63618293c58b5f80$var$singleton = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$LocalZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(LocalZone, _Zone);
    function LocalZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = LocalZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "local";
    };
    $63618293c58b5f80$var$_createClass(LocalZone, [
        {
            key: "type",
            /** @override **/ get: function get() {
                return "local";
            }
        },
        {
            key: "name",
            get: function get() {
                if ($63618293c58b5f80$var$hasIntl()) return new Intl.DateTimeFormat().resolvedOptions().timeZone;
                else return "local";
            }
        },
        {
            key: "universal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            /**
     * Get a singleton instance of the local zone
     * @return {LocalZone}
     */ get: function get() {
                if ($63618293c58b5f80$var$singleton === null) $63618293c58b5f80$var$singleton = new LocalZone();
                return $63618293c58b5f80$var$singleton;
            }
        }
    ]);
    return LocalZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$matchingRegex = RegExp("^" + $63618293c58b5f80$var$ianaRegex.source + "$");
var $63618293c58b5f80$var$dtfCache = {};
function $63618293c58b5f80$var$makeDTF(zone) {
    if (!$63618293c58b5f80$var$dtfCache[zone]) $63618293c58b5f80$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    });
    return $63618293c58b5f80$var$dtfCache[zone];
}
var $63618293c58b5f80$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $63618293c58b5f80$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fHour = parsed[4], fMinute = parsed[5], fSecond = parsed[6];
    return [
        fYear,
        fMonth,
        fDay,
        fHour,
        fMinute,
        fSecond
    ];
}
function $63618293c58b5f80$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date), filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value, pos = $63618293c58b5f80$var$typeToPos[type];
        if (!$63618293c58b5f80$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $63618293c58b5f80$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $63618293c58b5f80$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$63618293c58b5f80$var$ianaZoneCache[name]) $63618293c58b5f80$var$ianaZoneCache[name] = new IANAZone(name);
        return $63618293c58b5f80$var$ianaZoneCache[name];
    };
    IANAZone.resetCache = function resetCache() {
        $63618293c58b5f80$var$ianaZoneCache = {};
        $63618293c58b5f80$var$dtfCache = {};
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return !!(s && s.match($63618293c58b5f80$var$matchingRegex));
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    } // Etc/GMT+8 -> -480
    ;
    IANAZone.parseGMTOffset = function parseGMTOffset(specifier) {
        if (specifier) {
            var match = specifier.match(/^Etc\/GMT(0|[+-]\d{1,2})$/i);
            if (match) return -60 * parseInt(match[1]);
        }
        return null;
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $63618293c58b5f80$var$makeDTF(this.name), _ref2 = dtf.formatToParts ? $63618293c58b5f80$var$partsOffset(dtf, date) : $63618293c58b5f80$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], hour = _ref2[3], minute = _ref2[4], second = _ref2[5], adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $63618293c58b5f80$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    $63618293c58b5f80$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "universal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$singleton$1 = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $63618293c58b5f80$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($63618293c58b5f80$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    $63618293c58b5f80$var$_createClass(FixedOffsetZone, null, [
        {
            key: "utcInstance",
            /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ get: function get() {
                if ($63618293c58b5f80$var$singleton$1 === null) $63618293c58b5f80$var$singleton$1 = new FixedOffsetZone(0);
                return $63618293c58b5f80$var$singleton$1;
            }
        }
    ]);
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.fixed, format);
    };
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    $63618293c58b5f80$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $63618293c58b5f80$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "universal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ]);
    return FixedOffsetZone;
}($63618293c58b5f80$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    $63618293c58b5f80$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "universal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($63618293c58b5f80$var$Zone);
/**
 * @private
 */ function $63618293c58b5f80$var$normalizeZone(input, defaultZone) {
    var offset;
    if ($63618293c58b5f80$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $63618293c58b5f80$var$Zone) return input;
    else if ($63618293c58b5f80$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "local") return defaultZone;
        else if (lowered === "utc" || lowered === "gmt") return $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        else if ((offset = $63618293c58b5f80$var$IANAZone.parseGMTOffset(input)) != null) // handle Etc/GMT-4, which V8 chokes on
        return $63618293c58b5f80$var$FixedOffsetZone.instance(offset);
        else if ($63618293c58b5f80$var$IANAZone.isValidSpecifier(lowered)) return $63618293c58b5f80$var$IANAZone.create(input);
        else return $63618293c58b5f80$var$FixedOffsetZone.parseSpecifier(lowered) || new $63618293c58b5f80$var$InvalidZone(input);
    } else if ($63618293c58b5f80$var$isNumber(input)) return $63618293c58b5f80$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && input.offset && typeof input.offset === "number") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $63618293c58b5f80$var$InvalidZone(input);
}
var $63618293c58b5f80$var$now = function now() {
    return Date.now();
}, $63618293c58b5f80$var$defaultZone = null, // not setting this directly to LocalZone.instance bc loading order issues
$63618293c58b5f80$var$defaultLocale = null, $63618293c58b5f80$var$defaultNumberingSystem = null, $63618293c58b5f80$var$defaultOutputCalendar = null, $63618293c58b5f80$var$throwOnInvalid = false;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $63618293c58b5f80$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $63618293c58b5f80$var$Locale.resetCache();
        $63618293c58b5f80$var$IANAZone.resetCache();
    };
    $63618293c58b5f80$var$_createClass(Settings, null, [
        {
            key: "now",
            /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ get: function get() {
                return $63618293c58b5f80$var$now;
            },
            set: function set(n) {
                $63618293c58b5f80$var$now = n;
            }
        },
        {
            key: "defaultZoneName",
            get: function get() {
                return Settings.defaultZone.name;
            },
            set: function set(z) {
                if (!z) $63618293c58b5f80$var$defaultZone = null;
                else $63618293c58b5f80$var$defaultZone = $63618293c58b5f80$var$normalizeZone(z);
            }
        },
        {
            key: "defaultZone",
            get: function get() {
                return $63618293c58b5f80$var$defaultZone || $63618293c58b5f80$var$LocalZone.instance;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $63618293c58b5f80$var$defaultLocale;
            },
            set: function set(locale) {
                $63618293c58b5f80$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $63618293c58b5f80$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $63618293c58b5f80$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $63618293c58b5f80$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $63618293c58b5f80$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $63618293c58b5f80$var$throwOnInvalid;
            },
            set: function set(t) {
                $63618293c58b5f80$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $63618293c58b5f80$var$intlDTCache = {};
function $63618293c58b5f80$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $63618293c58b5f80$var$intlNumCache = {};
function $63618293c58b5f80$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $63618293c58b5f80$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $63618293c58b5f80$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$intlRelCache = {};
function $63618293c58b5f80$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts, base = _opts.base, cacheKeyOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(_opts, [
        "base"
    ]); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $63618293c58b5f80$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$sysLocaleCache = null;
function $63618293c58b5f80$var$systemLocale() {
    if ($63618293c58b5f80$var$sysLocaleCache) return $63618293c58b5f80$var$sysLocaleCache;
    else if ($63618293c58b5f80$var$hasIntl()) {
        var computedSys = new Intl.DateTimeFormat().resolvedOptions().locale; // node sometimes defaults to "und". Override that because that is dumb
        $63618293c58b5f80$var$sysLocaleCache = !computedSys || computedSys === "und" ? "en-US" : computedSys;
        return $63618293c58b5f80$var$sysLocaleCache;
    } else {
        $63618293c58b5f80$var$sysLocaleCache = "en-US";
        return $63618293c58b5f80$var$sysLocaleCache;
    }
}
function $63618293c58b5f80$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var smaller = localeStr.substring(0, uIndex);
        try {
            options = $63618293c58b5f80$var$getCachedDTF(localeStr).resolvedOptions();
        } catch (e) {
            options = $63618293c58b5f80$var$getCachedDTF(smaller).resolvedOptions();
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it
        return [
            smaller,
            numberingSystem,
            calendar
        ];
    }
}
function $63618293c58b5f80$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if ($63618293c58b5f80$var$hasIntl()) {
        if (outputCalendar || numberingSystem) {
            localeStr += "-u";
            if (outputCalendar) localeStr += "-ca-" + outputCalendar;
            if (numberingSystem) localeStr += "-nu-" + numberingSystem;
            return localeStr;
        } else return localeStr;
    } else return [];
}
function $63618293c58b5f80$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2016, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$listStuff(loc, length, defaultOK, englishFn, intlFn) {
    var mode = loc.listingMode(defaultOK);
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $63618293c58b5f80$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || $63618293c58b5f80$var$hasIntl() && new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $63618293c58b5f80$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        if (!forceSimple && $63618293c58b5f80$var$hasIntl()) {
            var intlOpts = {
                useGrouping: false
            };
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $63618293c58b5f80$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $63618293c58b5f80$var$roundTo(i, 3);
            return $63618293c58b5f80$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.hasIntl = $63618293c58b5f80$var$hasIntl();
        var z;
        if (dt.zone.universal && this.hasIntl) {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            var isOffsetZoneSupported = $63618293c58b5f80$var$IANAZone.isValidZone(offsetZ);
            if (dt.offset !== 0 && isOffsetZoneSupported) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata.
                // So we have to make do. Two cases:
                // 1. The format options tell us to show the zone. We can't do that, so the best
                // we can do is format the date in UTC.
                // 2. The format options don't tell us to show the zone. Then we can adjust them
                // the time and tell the formatter to show it to us in UTC, so that the time is right
                // and the bad zone doesn't show up.
                z = "UTC";
                if (opts.timeZoneName) this.dt = dt;
                else this.dt = dt.offset === 0 ? dt : $63618293c58b5f80$var$DateTime.fromMillis(dt.ts + dt.offset * 60000);
            }
        } else if (dt.zone.type === "local") this.dt = dt;
        else {
            this.dt = dt;
            z = dt.zone.name;
        }
        if (this.hasIntl) {
            var intlOpts = Object.assign({}, this.opts);
            if (z) intlOpts.timeZone = z;
            this.dtf = $63618293c58b5f80$var$getCachedDTF(intl, intlOpts);
        }
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.hasIntl) return this.dtf.format(this.dt.toJSDate());
        else {
            var tokenFormat = $63618293c58b5f80$var$formatString(this.opts), loc = $63618293c58b5f80$var$Locale.create("en-US");
            return $63618293c58b5f80$var$Formatter.create(loc).formatDateTimeFromString(this.dt, tokenFormat);
        }
    };
    _proto2.formatToParts = function formatToParts() {
        if (this.hasIntl && $63618293c58b5f80$var$hasFormatToParts()) return this.dtf.formatToParts(this.dt.toJSDate());
        else // This is kind of a cop out. We actually could do this for English. However, we couldn't do it for intl strings
        // and IMO it's too weird to have an uncanny valley like that
        return [];
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        if (this.hasIntl) return this.dtf.resolvedOptions();
        else return {
            locale: "en-US",
            numberingSystem: "latn",
            outputCalendar: "gregory"
        };
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = Object.assign({
            style: "long"
        }, opts);
        if (!isEnglish && $63618293c58b5f80$var$hasRelative()) this.rtf = $63618293c58b5f80$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $63618293c58b5f80$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $63618293c58b5f80$var$Settings.defaultLocale, // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        localeR = specifiedLocale || (defaultToEN ? "en-US" : $63618293c58b5f80$var$systemLocale()), numberingSystemR = numberingSystem || $63618293c58b5f80$var$Settings.defaultNumberingSystem, outputCalendarR = outputCalendar || $63618293c58b5f80$var$Settings.defaultOutputCalendar;
        return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $63618293c58b5f80$var$sysLocaleCache = null;
        $63618293c58b5f80$var$intlDTCache = {};
        $63618293c58b5f80$var$intlNumCache = {};
        $63618293c58b5f80$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, outputCalendar = _ref.outputCalendar;
        return Locale.create(locale, numberingSystem, outputCalendar);
    };
    function Locale(locale, numbering, outputCalendar, specifiedLocale) {
        var _parseLocaleString = $63618293c58b5f80$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $63618293c58b5f80$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode(defaultOK) {
        if (defaultOK === void 0) defaultOK = true;
        var intl = $63618293c58b5f80$var$hasIntl(), hasFTP = intl && $63618293c58b5f80$var$hasFormatToParts(), isActuallyEn = this.isEnglish(), hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        if (!hasFTP && !(isActuallyEn && hasNoWeirdness) && !defaultOK) return "error";
        else if (!hasFTP || isActuallyEn && hasNoWeirdness) return "en";
        else return "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone(Object.assign({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone(Object.assign({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format, defaultOK) {
        var _this = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, length, defaultOK, $63618293c58b5f80$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this.monthsCache[formatStr][length]) _this.monthsCache[formatStr][length] = $63618293c58b5f80$var$mapMonths(function(dt) {
                return _this.extract(dt, intl, "month");
            });
            return _this.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
        var _this2 = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, length, defaultOK, $63618293c58b5f80$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.weekdaysCache[formatStr][length]) _this2.weekdaysCache[formatStr][length] = $63618293c58b5f80$var$mapWeekdays(function(dt) {
                return _this2.extract(dt, intl, "weekday");
            });
            return _this2.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1(defaultOK) {
        var _this3 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, undefined, defaultOK, function() {
            return $63618293c58b5f80$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this3.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hour12: true
                };
                _this3.meridiemCache = [
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 9),
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this3.extract(dt, intl, "dayperiod");
                });
            }
            return _this3.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length, defaultOK) {
        var _this4 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, length, defaultOK, $63618293c58b5f80$var$eras, function() {
            var intl = {
                era: length
            }; // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this4.eraCache[length]) _this4.eraCache[length] = [
                $63618293c58b5f80$var$DateTime.utc(-40, 1, 1),
                $63618293c58b5f80$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this4.extract(dt, intl, "era");
            });
            return _this4.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $63618293c58b5f80$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $63618293c58b5f80$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $63618293c58b5f80$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || $63618293c58b5f80$var$hasIntl() && new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $63618293c58b5f80$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $63618293c58b5f80$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ function $63618293c58b5f80$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $63618293c58b5f80$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                Object.assign(mergedVals, val),
                mergedZone || zone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $63618293c58b5f80$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $63618293c58b5f80$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $63618293c58b5f80$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
} // ISO and SQL parsing
var $63618293c58b5f80$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, $63618293c58b5f80$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, $63618293c58b5f80$var$isoTimeRegex = RegExp("" + $63618293c58b5f80$var$isoTimeBaseRegex.source + $63618293c58b5f80$var$offsetRegex.source + "?"), $63618293c58b5f80$var$isoTimeExtensionRegex = RegExp("(?:T" + $63618293c58b5f80$var$isoTimeRegex.source + ")?"), $63618293c58b5f80$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, $63618293c58b5f80$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/, $63618293c58b5f80$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/, $63618293c58b5f80$var$extractISOWeekData = $63618293c58b5f80$var$simpleParse("weekYear", "weekNumber", "weekDay"), $63618293c58b5f80$var$extractISOOrdinalData = $63618293c58b5f80$var$simpleParse("year", "ordinal"), $63618293c58b5f80$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/, // dumbed-down version of the ISO one
$63618293c58b5f80$var$sqlTimeRegex = RegExp($63618293c58b5f80$var$isoTimeBaseRegex.source + " ?(?:" + $63618293c58b5f80$var$offsetRegex.source + "|(" + $63618293c58b5f80$var$ianaRegex.source + "))?"), $63618293c58b5f80$var$sqlTimeExtensionRegex = RegExp("(?: " + $63618293c58b5f80$var$sqlTimeRegex.source + ")?");
function $63618293c58b5f80$var$int(match, pos, fallback) {
    var m = match[pos];
    return $63618293c58b5f80$var$isUndefined(m) ? fallback : $63618293c58b5f80$var$parseInteger(m);
}
function $63618293c58b5f80$var$extractISOYmd(match, cursor) {
    var item = {
        year: $63618293c58b5f80$var$int(match, cursor),
        month: $63618293c58b5f80$var$int(match, cursor + 1, 1),
        day: $63618293c58b5f80$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractISOTime(match, cursor) {
    var item = {
        hours: $63618293c58b5f80$var$int(match, cursor, 0),
        minutes: $63618293c58b5f80$var$int(match, cursor + 1, 0),
        seconds: $63618293c58b5f80$var$int(match, cursor + 2, 0),
        milliseconds: $63618293c58b5f80$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $63618293c58b5f80$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $63618293c58b5f80$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $63618293c58b5f80$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $63618293c58b5f80$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
} // ISO time parsing
var $63618293c58b5f80$var$isoTimeOnly = RegExp("^T?" + $63618293c58b5f80$var$isoTimeBaseRegex.source + "$"); // ISO duration parsing
var $63618293c58b5f80$var$isoDuration = /^-?P(?:(?:(-?\d{1,9})Y)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})W)?(?:(-?\d{1,9})D)?(?:T(?:(-?\d{1,9})H)?(?:(-?\d{1,9})M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,9}))?S)?)?)$/;
function $63618293c58b5f80$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($63618293c58b5f80$var$parseInteger(yearStr)),
            months: maybeNegate($63618293c58b5f80$var$parseInteger(monthStr)),
            weeks: maybeNegate($63618293c58b5f80$var$parseInteger(weekStr)),
            days: maybeNegate($63618293c58b5f80$var$parseInteger(dayStr)),
            hours: maybeNegate($63618293c58b5f80$var$parseInteger(hourStr)),
            minutes: maybeNegate($63618293c58b5f80$var$parseInteger(minuteStr)),
            seconds: maybeNegate($63618293c58b5f80$var$parseInteger(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($63618293c58b5f80$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $63618293c58b5f80$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $63618293c58b5f80$var$untruncateYear($63618293c58b5f80$var$parseInteger(yearStr)) : $63618293c58b5f80$var$parseInteger(yearStr),
        month: $63618293c58b5f80$var$monthsShort.indexOf(monthStr) + 1,
        day: $63618293c58b5f80$var$parseInteger(dayStr),
        hour: $63618293c58b5f80$var$parseInteger(hourStr),
        minute: $63618293c58b5f80$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $63618293c58b5f80$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $63618293c58b5f80$var$weekdaysLong.indexOf(weekdayStr) + 1 : $63618293c58b5f80$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
} // RFC 2822/5322
var $63618293c58b5f80$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $63618293c58b5f80$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $63618293c58b5f80$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $63618293c58b5f80$var$FixedOffsetZone(offset)
    ];
}
function $63618293c58b5f80$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
} // http date
var $63618293c58b5f80$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $63618293c58b5f80$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
function $63618293c58b5f80$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
var $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoYmdRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoWeekRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoOrdinalRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoTimeRegex);
var $63618293c58b5f80$var$extractISOYmdTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOYmd, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
var $63618293c58b5f80$var$extractISOWeekTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOWeekData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
var $63618293c58b5f80$var$extractISOOrdinalDateAndTime = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOOrdinalData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
var $63618293c58b5f80$var$extractISOTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
/**
 * @private
 */ function $63618293c58b5f80$var$parseISODate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOWeekTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOOrdinalDateAndTime
    ], [
        $63618293c58b5f80$var$isoTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeAndOffset
    ]);
}
function $63618293c58b5f80$var$parseRFC2822Date(s) {
    return $63618293c58b5f80$var$parse($63618293c58b5f80$var$preprocessRFC2822(s), [
        $63618293c58b5f80$var$rfc2822,
        $63618293c58b5f80$var$extractRFC2822
    ]);
}
function $63618293c58b5f80$var$parseHTTPDate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$rfc1123,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$rfc850,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$ascii,
        $63618293c58b5f80$var$extractASCII
    ]);
}
function $63618293c58b5f80$var$parseISODuration(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoDuration,
        $63618293c58b5f80$var$extractISODuration
    ]);
}
var $63618293c58b5f80$var$extractISOTimeOnly = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime);
function $63618293c58b5f80$var$parseISOTimeOnly(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoTimeOnly,
        $63618293c58b5f80$var$extractISOTimeOnly
    ]);
}
var $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlYmdRegex, $63618293c58b5f80$var$sqlTimeExtensionRegex);
var $63618293c58b5f80$var$sqlTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlTimeRegex);
var $63618293c58b5f80$var$extractISOYmdTimeOffsetAndIANAZone = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOYmd, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
function $63618293c58b5f80$var$parseSQL(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeOffsetAndIANAZone
    ], [
        $63618293c58b5f80$var$sqlTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $63618293c58b5f80$var$INVALID = "Invalid Duration"; // unit conversion constants
var $63618293c58b5f80$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $63618293c58b5f80$var$casualMatrix = Object.assign({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $63618293c58b5f80$var$lowOrderMatrix), $63618293c58b5f80$var$daysInYearAccurate = 365.2425, $63618293c58b5f80$var$daysInMonthAccurate = 30.436875, $63618293c58b5f80$var$accurateMatrix = Object.assign({
    years: {
        quarters: 4,
        months: 12,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 7,
        days: $63618293c58b5f80$var$daysInYearAccurate,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 28,
        days: $63618293c58b5f80$var$daysInYearAccurate / 4,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24 / 4,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440 / 4,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $63618293c58b5f80$var$daysInMonthAccurate / 7,
        days: $63618293c58b5f80$var$daysInMonthAccurate,
        hours: $63618293c58b5f80$var$daysInMonthAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInMonthAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400000
    }
}, $63618293c58b5f80$var$lowOrderMatrix); // units ordered by size
var $63618293c58b5f80$var$orderedUnits = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $63618293c58b5f80$var$reverseUnits = $63618293c58b5f80$var$orderedUnits.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"
function $63618293c58b5f80$var$clone(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : Object.assign({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
    };
    return new $63618293c58b5f80$var$Duration(conf);
}
function $63618293c58b5f80$var$antiTrunc(n) {
    return n < 0 ? Math.floor(n) : Math.ceil(n);
} // NB: mutates parameters
function $63618293c58b5f80$var$convert(matrix, fromMap, fromUnit, toMap, toUnit) {
    var conv = matrix[toUnit][fromUnit], raw = fromMap[fromUnit] / conv, sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]), // ok, so this is wild, but see the matrix in the tests
    added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? $63618293c58b5f80$var$antiTrunc(raw) : Math.trunc(raw);
    toMap[toUnit] += added;
    fromMap[fromUnit] -= added * conv;
} // NB: mutates parameters
function $63618293c58b5f80$var$normalizeValues(matrix, vals) {
    $63618293c58b5f80$var$reverseUnits.reduce(function(previous, current) {
        if (!$63618293c58b5f80$var$isUndefined(vals[current])) {
            if (previous) $63618293c58b5f80$var$convert(matrix, vals, previous, vals, current);
            return current;
        } else return previous;
    }, null);
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime.plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration.years}, {@link Duration.months}, {@link Duration.weeks}, {@link Duration.days}, {@link Duration.hours}, {@link Duration.minutes}, {@link Duration.seconds}, {@link Duration.milliseconds} accessors.
 * * **Configuration** See  {@link Duration.locale} and {@link Duration.numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration.plus}, {@link Duration.minus}, {@link Duration.normalize}, {@link Duration.set}, {@link Duration.reconfigure}, {@link Duration.shiftTo}, and {@link Duration.negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration.as}, {@link Duration.toISO}, {@link Duration.toFormat}, and {@link Duration.toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $63618293c58b5f80$var$Duration = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = accurate ? $63618293c58b5f80$var$accurateMatrix : $63618293c58b5f80$var$casualMatrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject(Object.assign({
            milliseconds: count
        }, opts));
    };
    Duration.fromObject = function fromObject(obj) {
        if (obj == null || typeof obj !== "object") throw new $63618293c58b5f80$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $63618293c58b5f80$var$normalizeObject(obj, Duration.normalizeUnit, [
                "locale",
                "numberingSystem",
                "conversionAccuracy",
                "zone" // a bit of debt; it's super inconvenient internally not to be able to blindly pass this
            ]),
            loc: $63618293c58b5f80$var$Locale.fromObject(obj),
            conversionAccuracy: obj.conversionAccuracy
        });
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $63618293c58b5f80$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) {
            var obj = Object.assign(parsed, opts);
            return Duration.fromObject(obj);
        } else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $63618293c58b5f80$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) {
            var obj = Object.assign(parsed, opts);
            return Duration.fromObject(obj);
        } else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * The duration will be converted to the set of units in the format string using {@link Duration.shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = Object.assign({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $63618293c58b5f80$var$INVALID;
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = Object.assign({}, this.values);
        if (opts.includeConfig) {
            base.conversionAccuracy = this.conversionAccuracy;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $63618293c58b5f80$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = Object.assign({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts);
        var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
        var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";
        if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
            fmt += opts.format === "basic" ? "ss" : ":ss";
            if (!opts.suppressMilliseconds || value.milliseconds !== 0) fmt += ".SSS";
        }
        var str = value.toFormat(fmt);
        if (opts.includePrefix) str = "T" + str;
        return str;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto.toMillis = function toMillis() {
        return this.as("milliseconds");
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$friendlyDuration(duration), result = {};
        for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits), _step; !(_step = _iterator()).done;){
            var k = _step.value;
            if ($63618293c58b5f80$var$hasOwnProperty(dur.values, k) || $63618293c58b5f80$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $63618293c58b5f80$var$clone(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$friendlyDuration(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i = 0, _Object$keys = Object.keys(this.values); _i < _Object$keys.length; _i++){
            var k = _Object$keys[_i];
            result[k] = $63618293c58b5f80$var$asNumber(fn(this.values[k], k));
        }
        return $63618293c58b5f80$var$clone(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = Object.assign(this.values, $63618293c58b5f80$var$normalizeObject(values, Duration.normalizeUnit, []));
        return $63618293c58b5f80$var$clone(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        }), opts = {
            loc: loc
        };
        if (conversionAccuracy) opts.conversionAccuracy = conversionAccuracy;
        return $63618293c58b5f80$var$clone(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $63618293c58b5f80$var$normalizeValues(this.matrix, vals);
        return $63618293c58b5f80$var$clone(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _iterator2 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits), _step2; !(_step2 = _iterator2()).done;){
            var k = _step2.value;
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0; // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                } // plus anything that's already in this unit
                if ($63618293c58b5f80$var$isNumber(vals[k])) own += vals[k];
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = own - i; // we'd like to absorb these fractions in another unit
                // plus anything further down the chain that should be rolled up in to this
                for(var down in vals)if ($63618293c58b5f80$var$orderedUnits.indexOf(down) > $63618293c58b5f80$var$orderedUnits.indexOf(k)) $63618293c58b5f80$var$convert(this.matrix, vals, down, built, k);
                 // otherwise, keep it in the wings to boil it later
            } else if ($63618293c58b5f80$var$isNumber(vals[k])) accumulated[k] = vals[k];
        } // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        return $63618293c58b5f80$var$clone(this, {
            values: built
        }, true).normalize();
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i2 = 0, _Object$keys2 = Object.keys(this.values); _i2 < _Object$keys2.length; _i2++){
            var k = _Object$keys2[_i2];
            negated[k] = -this.values[k];
        }
        return $63618293c58b5f80$var$clone(this, {
            values: negated
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _iterator3 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits), _step3; !(_step3 = _iterator3()).done;){
            var u = _step3.value;
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $63618293c58b5f80$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}();
function $63618293c58b5f80$var$friendlyDuration(durationish) {
    if ($63618293c58b5f80$var$isNumber(durationish)) return $63618293c58b5f80$var$Duration.fromMillis(durationish);
    else if ($63618293c58b5f80$var$Duration.isDuration(durationish)) return durationish;
    else if (typeof durationish === "object") return $63618293c58b5f80$var$Duration.fromObject(durationish);
    else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown duration argument " + durationish + " of type " + typeof durationish);
}
var $63618293c58b5f80$var$INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end
function $63618293c58b5f80$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $63618293c58b5f80$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link fromDateTimes}, {@link after}, {@link before}, or {@link fromISO}.
 * * **Accessors** Use {@link start} and {@link end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link count}, {@link length}, {@link hasSame}, {@link contains}, {@link isAfter}, or {@link isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link set}, {@link splitAt}, {@link splitBy}, {@link divideEqually}, {@link merge}, {@link xor}, {@link union}, {@link intersection}, or {@link difference}.
 * * **Comparison** To compare this Interval to another one, use {@link equals}, {@link overlaps}, {@link abutsStart}, {@link abutsEnd}, {@link engulfs}.
 * * **Output** To convert the Interval into other representations, see {@link toString}, {@link toISO}, {@link toISODate}, {@link toISOTime}, {@link toFormat}, and {@link toDuration}.
 */ var $63618293c58b5f80$var$Interval = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $63618293c58b5f80$var$friendlyDateTime(start), builtEnd = $63618293c58b5f80$var$friendlyDateTime(end);
        var validateError = $63618293c58b5f80$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = $63618293c58b5f80$var$friendlyDuration(duration), dt = $63618293c58b5f80$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = $63618293c58b5f80$var$friendlyDuration(duration), dt = $63618293c58b5f80$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $63618293c58b5f80$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $63618293c58b5f80$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $63618293c58b5f80$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $63618293c58b5f80$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + 1;
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($63618293c58b5f80$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = $63618293c58b5f80$var$friendlyDuration(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $63618293c58b5f80$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $63618293c58b5f80$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}();
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $63618293c58b5f80$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $63618293c58b5f80$var$Settings.defaultZone;
        var proto = $63618293c58b5f80$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.universal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $63618293c58b5f80$var$IANAZone.isValidSpecifier(zone) && $63618293c58b5f80$var$IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return $63618293c58b5f80$var$normalizeZone(input, $63618293c58b5f80$var$Settings.defaultZone);
    };
    Info.months = function months(length, _temp) {
        if (length === void 0) length = "long";
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$numberingSystem = _ref.numberingSystem, numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj, _ref$outputCalendar = _ref.outputCalendar, outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp2) {
        if (length === void 0) length = "long";
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$numberingSystem = _ref2.numberingSystem, numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj, _ref2$outputCalendar = _ref2.outputCalendar, outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp3) {
        if (length === void 0) length = "long";
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$numberingSystem = _ref3.numberingSystem, numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp5) {
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale;
        return $63618293c58b5f80$var$Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp6) {
        if (length === void 0) length = "short";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale;
        return $63618293c58b5f80$var$Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        var intl = false, intlTokens = false, zones = false, relative = false;
        if ($63618293c58b5f80$var$hasIntl()) {
            intl = true;
            intlTokens = $63618293c58b5f80$var$hasFormatToParts();
            relative = $63618293c58b5f80$var$hasRelative();
            try {
                zones = new Intl.DateTimeFormat("en", {
                    timeZone: "America/New_York"
                }).resolvedOptions().timeZone === "America/New_York";
            } catch (e) {
                zones = false;
            }
        }
        return {
            intl: intl,
            intlTokens: intlTokens,
            zones: zones,
            relative: relative
        };
    };
    return Info;
}();
function $63618293c58b5f80$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($63618293c58b5f80$var$Duration.fromMillis(ms).as("days"));
}
function $63618293c58b5f80$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $63618293c58b5f80$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $63618293c58b5f80$var$dayDiff
        ]
    ];
    var results = {};
    var lowestOrder, highWater;
    for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            var _cursor$plus;
            lowestOrder = unit;
            var delta = differ(cursor, later);
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));
            if (highWater > later) {
                var _cursor$plus2;
                cursor = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[unit] = delta - 1, _cursor$plus2));
                delta -= 1;
            } else cursor = highWater;
            results[unit] = delta;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $63618293c58b5f80$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $63618293c58b5f80$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus3;
            highWater = cursor.plus((_cursor$plus3 = {}, _cursor$plus3[lowestOrder] = 1, _cursor$plus3));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $63618293c58b5f80$var$Duration.fromObject(Object.assign(results, opts));
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $63618293c58b5f80$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $63618293c58b5f80$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $63618293c58b5f80$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
}; // eslint-disable-next-line
var $63618293c58b5f80$var$hanidecChars = $63618293c58b5f80$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $63618293c58b5f80$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($63618293c58b5f80$var$numberingSystems.hanidec) !== -1) value += $63618293c58b5f80$var$hanidecChars.indexOf(str[i]);
            else for(var key in $63618293c58b5f80$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $63618293c58b5f80$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $63618293c58b5f80$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $63618293c58b5f80$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $63618293c58b5f80$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $63618293c58b5f80$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($63618293c58b5f80$var$parseDigits(s));
        }
    };
}
var $63618293c58b5f80$var$NBSP = String.fromCharCode(160);
var $63618293c58b5f80$var$spaceOrNBSP = "( |" + $63618293c58b5f80$var$NBSP + ")";
var $63618293c58b5f80$var$spaceOrNBSPRegExp = new RegExp($63618293c58b5f80$var$spaceOrNBSP, "g");
function $63618293c58b5f80$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($63618293c58b5f80$var$spaceOrNBSPRegExp, $63618293c58b5f80$var$spaceOrNBSP);
}
function $63618293c58b5f80$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($63618293c58b5f80$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $63618293c58b5f80$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($63618293c58b5f80$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $63618293c58b5f80$var$stripInsensitivities(s) === $63618293c58b5f80$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $63618293c58b5f80$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $63618293c58b5f80$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $63618293c58b5f80$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $63618293c58b5f80$var$escapeToken(value) {
    // eslint-disable-next-line no-useless-escape
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function $63618293c58b5f80$var$unitForToken(token, loc) {
    var one = $63618293c58b5f80$var$digitRegex(loc), two = $63618293c58b5f80$var$digitRegex(loc, "{2}"), three = $63618293c58b5f80$var$digitRegex(loc, "{3}"), four = $63618293c58b5f80$var$digitRegex(loc, "{4}"), six = $63618293c58b5f80$var$digitRegex(loc, "{6}"), oneOrTwo = $63618293c58b5f80$var$digitRegex(loc, "{1,2}"), oneToThree = $63618293c58b5f80$var$digitRegex(loc, "{1,3}"), oneToSix = $63618293c58b5f80$var$digitRegex(loc, "{1,6}"), oneToNine = $63618293c58b5f80$var$digitRegex(loc, "{1,9}"), twoToFour = $63618293c58b5f80$var$digitRegex(loc, "{2,4}"), fourToSix = $63618293c58b5f80$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($63618293c58b5f80$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $63618293c58b5f80$var$oneOf(loc.eras("short", false), 0);
            case "GG":
                return $63618293c58b5f80$var$oneOf(loc.eras("long", false), 0);
            // years
            case "y":
                return $63618293c58b5f80$var$intUnit(oneToSix);
            case "yy":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            case "yyyy":
                return $63618293c58b5f80$var$intUnit(four);
            case "yyyyy":
                return $63618293c58b5f80$var$intUnit(fourToSix);
            case "yyyyyy":
                return $63618293c58b5f80$var$intUnit(six);
            // months
            case "M":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "MM":
                return $63618293c58b5f80$var$intUnit(two);
            case "MMM":
                return $63618293c58b5f80$var$oneOf(loc.months("short", true, false), 1);
            case "MMMM":
                return $63618293c58b5f80$var$oneOf(loc.months("long", true, false), 1);
            case "L":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "LL":
                return $63618293c58b5f80$var$intUnit(two);
            case "LLL":
                return $63618293c58b5f80$var$oneOf(loc.months("short", false, false), 1);
            case "LLLL":
                return $63618293c58b5f80$var$oneOf(loc.months("long", false, false), 1);
            // dates
            case "d":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "dd":
                return $63618293c58b5f80$var$intUnit(two);
            // ordinals
            case "o":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "ooo":
                return $63618293c58b5f80$var$intUnit(three);
            // time
            case "HH":
                return $63618293c58b5f80$var$intUnit(two);
            case "H":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "hh":
                return $63618293c58b5f80$var$intUnit(two);
            case "h":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "mm":
                return $63618293c58b5f80$var$intUnit(two);
            case "m":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "q":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "qq":
                return $63618293c58b5f80$var$intUnit(two);
            case "s":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "ss":
                return $63618293c58b5f80$var$intUnit(two);
            case "S":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "SSS":
                return $63618293c58b5f80$var$intUnit(three);
            case "u":
                return $63618293c58b5f80$var$simple(oneToNine);
            // meridiem
            case "a":
                return $63618293c58b5f80$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $63618293c58b5f80$var$intUnit(four);
            case "kk":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "WW":
                return $63618293c58b5f80$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $63618293c58b5f80$var$intUnit(one);
            case "EEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", false, false), 1);
            case "EEEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", false, false), 1);
            case "ccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", true, false), 1);
            case "cccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", true, false), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $63618293c58b5f80$var$simple(/[a-z_+-/]{1,256}?/i);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $63618293c58b5f80$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $63618293c58b5f80$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour: {
        numeric: "h",
        "2-digit": "hh"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    }
};
function $63618293c58b5f80$var$tokenForPart(part, locale, formatOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") return {
        literal: true,
        val: value
    };
    var style = formatOpts[type];
    var val = $63618293c58b5f80$var$partTypeStyleToTokenVal[type];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $63618293c58b5f80$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $63618293c58b5f80$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($63618293c58b5f80$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $63618293c58b5f80$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone;
    if (!$63618293c58b5f80$var$isUndefined(matches.Z)) zone = new $63618293c58b5f80$var$FixedOffsetZone(matches.Z);
    else if (!$63618293c58b5f80$var$isUndefined(matches.z)) zone = $63618293c58b5f80$var$IANAZone.create(matches.z);
    else zone = null;
    if (!$63618293c58b5f80$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$63618293c58b5f80$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$63618293c58b5f80$var$isUndefined(matches.u)) matches.S = $63618293c58b5f80$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone
    ];
}
var $63618293c58b5f80$var$dummyDateTimeCache = null;
function $63618293c58b5f80$var$getDummyDateTime() {
    if (!$63618293c58b5f80$var$dummyDateTimeCache) $63618293c58b5f80$var$dummyDateTimeCache = $63618293c58b5f80$var$DateTime.fromMillis(1555555555555);
    return $63618293c58b5f80$var$dummyDateTimeCache;
}
function $63618293c58b5f80$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $63618293c58b5f80$var$Formatter.macroTokenToFormatOpts(token.val);
    if (!formatOpts) return token;
    var formatter = $63618293c58b5f80$var$Formatter.create(locale, formatOpts);
    var parts = formatter.formatDateTimeParts($63618293c58b5f80$var$getDummyDateTime());
    var tokens = parts.map(function(p) {
        return $63618293c58b5f80$var$tokenForPart(p, locale, formatOpts);
    });
    if (tokens.includes(undefined)) return token;
    return tokens;
}
function $63618293c58b5f80$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $63618293c58b5f80$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $63618293c58b5f80$var$explainFromTokens(locale, input, format) {
    var tokens = $63618293c58b5f80$var$expandMacroTokens($63618293c58b5f80$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $63618293c58b5f80$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $63618293c58b5f80$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $63618293c58b5f80$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $63618293c58b5f80$var$dateTimeFromMatches(matches) : [
            null,
            null
        ], result = _ref6[0], zone = _ref6[1];
        if ($63618293c58b5f80$var$hasOwnProperty(matches, "a") && $63618293c58b5f80$var$hasOwnProperty(matches, "H")) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone
        };
    }
}
function $63618293c58b5f80$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $63618293c58b5f80$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        invalidReason
    ];
}
var $63618293c58b5f80$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $63618293c58b5f80$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $63618293c58b5f80$var$unitOutOfRange(unit, value) {
    return new $63618293c58b5f80$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $63618293c58b5f80$var$dayOfWeek(year, month, day) {
    var js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
    return js === 0 ? 7 : js;
}
function $63618293c58b5f80$var$computeOrdinal(year, month, day) {
    return day + ($63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder)[month - 1];
}
function $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal) {
    var table = $63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
/**
 * @private
 */ function $63618293c58b5f80$var$gregorianToWeek(gregObj) {
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day), weekday = $63618293c58b5f80$var$dayOfWeek(year, month, day);
    var weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $63618293c58b5f80$var$weeksInWeekYear(weekYear);
    } else if (weekNumber > $63618293c58b5f80$var$weeksInWeekYear(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return Object.assign({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $63618293c58b5f80$var$timeObject(gregObj));
}
function $63618293c58b5f80$var$weekToGregorian(weekData) {
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $63618293c58b5f80$var$dayOfWeek(weekYear, 1, 4), yearInDays = $63618293c58b5f80$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $63618293c58b5f80$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $63618293c58b5f80$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return Object.assign({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(weekData));
}
function $63618293c58b5f80$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day, ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day);
    return Object.assign({
        year: year,
        ordinal: ordinal
    }, $63618293c58b5f80$var$timeObject(gregData));
}
function $63618293c58b5f80$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal, _uncomputeOrdinal2 = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return Object.assign({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(ordinalData));
}
function $63618293c58b5f80$var$hasInvalidWeekData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.weekYear), validWeek = $63618293c58b5f80$var$integerBetween(obj.weekNumber, 1, $63618293c58b5f80$var$weeksInWeekYear(obj.weekYear)), validWeekday = $63618293c58b5f80$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $63618293c58b5f80$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $63618293c58b5f80$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidOrdinalData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validOrdinal = $63618293c58b5f80$var$integerBetween(obj.ordinal, 1, $63618293c58b5f80$var$daysInYear(obj.year));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $63618293c58b5f80$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidGregorianData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validMonth = $63618293c58b5f80$var$integerBetween(obj.month, 1, 12), validDay = $63618293c58b5f80$var$integerBetween(obj.day, 1, $63618293c58b5f80$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $63618293c58b5f80$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $63618293c58b5f80$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $63618293c58b5f80$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $63618293c58b5f80$var$integerBetween(minute, 0, 59), validSecond = $63618293c58b5f80$var$integerBetween(second, 0, 59), validMillisecond = $63618293c58b5f80$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $63618293c58b5f80$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $63618293c58b5f80$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $63618293c58b5f80$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $63618293c58b5f80$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
var $63618293c58b5f80$var$INVALID$2 = "Invalid DateTime";
var $63618293c58b5f80$var$MAX_DATE = 8.64e15;
function $63618293c58b5f80$var$unsupportedZone(zone) {
    return new $63618293c58b5f80$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
} // we cache week data on the DT object and this intermediates the cache
function $63618293c58b5f80$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $63618293c58b5f80$var$gregorianToWeek(dt.c);
    return dt.weekData;
} // clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $63618293c58b5f80$var$clone$1(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $63618293c58b5f80$var$DateTime(Object.assign({}, current, alts, {
        old: current
    }));
} // find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $63618293c58b5f80$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000; // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
     // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000; // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
     // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
} // convert an epoch timestamp into a calendar object with the given offset
function $63618293c58b5f80$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
} // convert a calendar object to a epoch timestamp
function $63618293c58b5f80$var$objToTS(obj, offset, zone) {
    return $63618293c58b5f80$var$fixOffset($63618293c58b5f80$var$objToLocalTS(obj), offset, zone);
} // create a new DT instance by adding a duration, adjusting for DSTs
function $63618293c58b5f80$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = Object.assign({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $63618293c58b5f80$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $63618293c58b5f80$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $63618293c58b5f80$var$objToLocalTS(c);
    var _fixOffset = $63618293c58b5f80$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
} // helper useful in turning the results of parsing into real dates
// by handling the zone options
function $63618293c58b5f80$var$parseDataToDateTime(parsed, parsedZone, opts, format, text) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0) {
        var interpretationZone = parsedZone || zone, inst = $63618293c58b5f80$var$DateTime.fromObject(Object.assign(parsed, opts, {
            zone: interpretationZone,
            // setZone is a valid option in the calling methods, but not in fromObject
            setZone: undefined
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $63618293c58b5f80$var$DateTime.invalid(new $63618293c58b5f80$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
} // if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $63618293c58b5f80$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $63618293c58b5f80$var$Formatter.create($63618293c58b5f80$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
} // technical time formats (e.g. the time part of ISO 8601), take some options
// and this commonizes their handling
function $63618293c58b5f80$var$toTechTimeFormat(dt, _ref) {
    var _ref$suppressSeconds = _ref.suppressSeconds, suppressSeconds = _ref$suppressSeconds === void 0 ? false : _ref$suppressSeconds, _ref$suppressMillisec = _ref.suppressMilliseconds, suppressMilliseconds = _ref$suppressMillisec === void 0 ? false : _ref$suppressMillisec, includeOffset = _ref.includeOffset, _ref$includePrefix = _ref.includePrefix, includePrefix = _ref$includePrefix === void 0 ? false : _ref$includePrefix, _ref$includeZone = _ref.includeZone, includeZone = _ref$includeZone === void 0 ? false : _ref$includeZone, _ref$spaceZone = _ref.spaceZone, spaceZone = _ref$spaceZone === void 0 ? false : _ref$spaceZone, _ref$format = _ref.format, format = _ref$format === void 0 ? "extended" : _ref$format;
    var fmt = format === "basic" ? "HHmm" : "HH:mm";
    if (!suppressSeconds || dt.second !== 0 || dt.millisecond !== 0) {
        fmt += format === "basic" ? "ss" : ":ss";
        if (!suppressMilliseconds || dt.millisecond !== 0) fmt += ".SSS";
    }
    if ((includeZone || includeOffset) && spaceZone) fmt += " ";
    if (includeZone) fmt += "z";
    else if (includeOffset) fmt += format === "basic" ? "ZZZ" : "ZZ";
    var str = $63618293c58b5f80$var$toTechFormat(dt, fmt);
    if (includePrefix) str = "T" + str;
    return str;
} // defaults for unspecified units in the supported calendars
var $63618293c58b5f80$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}; // Units in the supported calendars, sorted by bigness
var $63618293c58b5f80$var$orderedUnits$1 = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
]; // standardize case and plurality in units
function $63618293c58b5f80$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
    return normalized;
} // this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $63618293c58b5f80$var$quickDT(obj, zone) {
    // assume we have the higher-order units
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits$1), _step; !(_step = _iterator()).done;){
        var u = _step.value;
        if ($63618293c58b5f80$var$isUndefined(obj[u])) obj[u] = $63618293c58b5f80$var$defaultUnitValues[u];
    }
    var invalid = $63618293c58b5f80$var$hasInvalidGregorianData(obj) || $63618293c58b5f80$var$hasInvalidTimeData(obj);
    if (invalid) return $63618293c58b5f80$var$DateTime.invalid(invalid);
    var tsNow = $63618293c58b5f80$var$Settings.now(), offsetProvis = zone.offset(tsNow), _objToTS = $63618293c58b5f80$var$objToTS(obj, offsetProvis, zone), ts = _objToTS[0], o = _objToTS[1];
    return new $63618293c58b5f80$var$DateTime({
        ts: ts,
        zone: zone,
        o: o
    });
}
function $63618293c58b5f80$var$diffRelative(start, end, opts) {
    var round = $63618293c58b5f80$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $63618293c58b5f80$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator2 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(opts.units), _step2; !(_step2 = _iterator2()).done;){
        var unit = _step2.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link local}, {@link utc}, and (most flexibly) {@link fromObject}. To create one from a standard string format, use {@link fromISO}, {@link fromHTTP}, and {@link fromRFC2822}. To create one from a custom string format, use {@link fromFormat}. To create one from a native JS date, use {@link fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link toObject}), use the {@link year}, {@link month},
 * {@link day}, {@link hour}, {@link minute}, {@link second}, {@link millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link weekYear}, {@link weekNumber}, and {@link weekday} accessors.
 * * **Configuration** See the {@link locale} and {@link numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link set}, {@link reconfigure}, {@link setZone}, {@link setLocale}, {@link plus}, {@link minus}, {@link endOf}, {@link startOf}, {@link toUTC}, and {@link toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link toRelative}, {@link toRelativeCalendar}, {@link toJSON}, {@link toISO}, {@link toHTTP}, {@link toObject}, {@link toRFC2822}, {@link toString}, {@link toLocaleString}, {@link toFormat}, {@link toMillis} and {@link toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $63618293c58b5f80$var$DateTime = /*#__PURE__*/ function() {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $63618293c58b5f80$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $63618293c58b5f80$var$Invalid("invalid input") : null) || (!zone.isValid ? $63618293c58b5f80$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $63618293c58b5f80$var$isUndefined(config.ts) ? $63618293c58b5f80$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref2 = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref2[0];
                o = _ref2[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $63618293c58b5f80$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $63618293c58b5f80$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    } // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local(year, month, day, hour, minute, second, millisecond) {
        if ($63618293c58b5f80$var$isUndefined(year)) return DateTime.now();
        else return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, $63618293c58b5f80$var$Settings.defaultZone);
    };
    DateTime.utc = function utc(year, month, day, hour, minute, second, millisecond) {
        if ($63618293c58b5f80$var$isUndefined(year)) return new DateTime({
            ts: $63618293c58b5f80$var$Settings.now(),
            zone: $63618293c58b5f80$var$FixedOffsetZone.utcInstance
        });
        else return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, $63618293c58b5f80$var$FixedOffsetZone.utcInstance);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $63618293c58b5f80$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(milliseconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$63618293c58b5f80$var$MAX_DATE || milliseconds > $63618293c58b5f80$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(seconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj) {
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(obj.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        var tsNow = $63618293c58b5f80$var$Settings.now(), offsetProvis = zoneToUse.offset(tsNow), normalized = $63618293c58b5f80$var$normalizeObject(obj, $63618293c58b5f80$var$normalizeUnit, [
            "zone",
            "locale",
            "outputCalendar",
            "numberingSystem"
        ]), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = $63618293c58b5f80$var$Locale.fromObject(obj); // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $63618293c58b5f80$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $63618293c58b5f80$var$orderedWeekUnits;
            defaultValues = $63618293c58b5f80$var$defaultWeekUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToWeek(objNow);
        } else if (containsOrdinal) {
            units = $63618293c58b5f80$var$orderedOrdinalUnits;
            defaultValues = $63618293c58b5f80$var$defaultOrdinalUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToOrdinal(objNow);
        } else {
            units = $63618293c58b5f80$var$orderedUnits$1;
            defaultValues = $63618293c58b5f80$var$defaultUnitValues;
        } // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator3 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(units), _step3; !(_step3 = _iterator3()).done;){
            var u = _step3.value;
            var v = normalized[u];
            if (!$63618293c58b5f80$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        } // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $63618293c58b5f80$var$hasInvalidWeekData(normalized) : containsOrdinal ? $63618293c58b5f80$var$hasInvalidOrdinalData(normalized) : $63618293c58b5f80$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $63618293c58b5f80$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
         // compute the actual time
        var gregorian = useWeekData ? $63618293c58b5f80$var$weekToGregorian(normalized) : containsOrdinal ? $63618293c58b5f80$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $63618293c58b5f80$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        }); // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $63618293c58b5f80$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $63618293c58b5f80$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $63618293c58b5f80$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($63618293c58b5f80$var$isUndefined(text) || $63618293c58b5f80$var$isUndefined(fmt)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $63618293c58b5f80$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], invalid = _parseFromTokens[2];
        if (invalid) return DateTime.invalid(invalid);
        else return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $63618293c58b5f80$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } // INFO
    ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOpts = function resolvedLocaleOpts(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } // TRANSFORM
    ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($63618293c58b5f80$var$FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone($63618293c58b5f80$var$Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref3 = _temp === void 0 ? {} : _temp, _ref3$keepLocalTime = _ref3.keepLocalTime, keepLocalTime = _ref3$keepLocalTime === void 0 ? false : _ref3$keepLocalTime, _ref3$keepCalendarTim = _ref3.keepCalendarTime, keepCalendarTime = _ref3$keepCalendarTim === void 0 ? false : _ref3$keepCalendarTim;
        zone = $63618293c58b5f80$var$normalizeZone(zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $63618293c58b5f80$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $63618293c58b5f80$var$clone$1(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref4 = _temp2 === void 0 ? {} : _temp2, locale = _ref4.locale, numberingSystem = _ref4.numberingSystem, outputCalendar = _ref4.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $63618293c58b5f80$var$clone$1(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $63618293c58b5f80$var$normalizeObject(values, $63618293c58b5f80$var$normalizeUnit, []), settingWeekStuff = !$63618293c58b5f80$var$isUndefined(normalized.weekYear) || !$63618293c58b5f80$var$isUndefined(normalized.weekNumber) || !$63618293c58b5f80$var$isUndefined(normalized.weekday), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $63618293c58b5f80$var$weekToGregorian(Object.assign($63618293c58b5f80$var$gregorianToWeek(this.c), normalized));
        else if (!$63618293c58b5f80$var$isUndefined(normalized.ordinal)) mixed = $63618293c58b5f80$var$ordinalToGregorian(Object.assign($63618293c58b5f80$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = Object.assign(this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($63618293c58b5f80$var$isUndefined(normalized.day)) mixed.day = Math.min($63618293c58b5f80$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $63618293c58b5f80$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $63618293c58b5f80$var$clone$1(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$friendlyDuration(duration);
        return $63618293c58b5f80$var$clone$1(this, $63618293c58b5f80$var$adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$friendlyDuration(duration).negate();
        return $63618293c58b5f80$var$clone$1(this, $63618293c58b5f80$var$adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit) {
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $63618293c58b5f80$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
    } // OUTPUT
    ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $63618293c58b5f80$var$INVALID$2;
    };
    _proto.toLocaleString = function toLocaleString(opts) {
        if (opts === void 0) opts = $63618293c58b5f80$var$DATE_SHORT;
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).formatDateTime(this) : $63618293c58b5f80$var$INVALID$2;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toISODate(opts) + "T" + this.toISOTime(opts);
    };
    _proto.toISODate = function toISODate(_temp3) {
        var _ref5 = _temp3 === void 0 ? {} : _temp3, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format;
        var fmt = format === "basic" ? "yyyyMMdd" : "yyyy-MM-dd";
        if (this.year > 9999) fmt = "+" + fmt;
        return $63618293c58b5f80$var$toTechFormat(this, fmt);
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $63618293c58b5f80$var$toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp4) {
        var _ref6 = _temp4 === void 0 ? {} : _temp4, _ref6$suppressMillise = _ref6.suppressMilliseconds, suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise, _ref6$suppressSeconds = _ref6.suppressSeconds, suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds, _ref6$includeOffset = _ref6.includeOffset, includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset, _ref6$includePrefix = _ref6.includePrefix, includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        return $63618293c58b5f80$var$toTechTimeFormat(this, {
            suppressSeconds: suppressSeconds,
            suppressMilliseconds: suppressMilliseconds,
            includeOffset: includeOffset,
            includePrefix: includePrefix,
            format: format
        });
    };
    _proto.toRFC2822 = function toRFC2822() {
        return $63618293c58b5f80$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return $63618293c58b5f80$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        return $63618293c58b5f80$var$toTechFormat(this, "yyyy-MM-dd");
    };
    _proto.toSQLTime = function toSQLTime(_temp5) {
        var _ref7 = _temp5 === void 0 ? {} : _temp5, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includeZone = _ref7.includeZone, includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone;
        return $63618293c58b5f80$var$toTechTimeFormat(this, {
            includeOffset: includeOffset,
            includeZone: includeZone,
            spaceZone: true
        });
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $63618293c58b5f80$var$INVALID$2;
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = Object.assign({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } // COMPARE
    ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $63618293c58b5f80$var$Duration.invalid(this.invalid || otherDateTime.invalid, "created by diffing an invalid DateTime");
        var durOpts = Object.assign({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $63618293c58b5f80$var$maybeArray(unit).map($63618293c58b5f80$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $63618293c58b5f80$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $63618293c58b5f80$var$Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var otherZoneDateTime = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return otherZoneDateTime.startOf(unit) <= inputMs && inputMs <= otherZoneDateTime.endOf(unit);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $63618293c58b5f80$var$diffRelative(base, this.plus(padding), Object.assign(options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$diffRelative(options.base || DateTime.fromObject({
            zone: this.zone
        }), this, Object.assign(options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } // MISC
    ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $63618293c58b5f80$var$explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } // FORMAT PRESETS
    ;
    $63618293c58b5f80$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.universal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $63618293c58b5f80$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $63618293c58b5f80$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}();
function $63618293c58b5f80$var$friendlyDateTime(dateTimeish) {
    if ($63618293c58b5f80$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $63618293c58b5f80$var$isNumber(dateTimeish.valueOf())) return $63618293c58b5f80$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $63618293c58b5f80$var$DateTime.fromObject(dateTimeish);
    else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $63618293c58b5f80$var$VERSION = "1.28.1";
$63618293c58b5f80$exports.DateTime = $63618293c58b5f80$var$DateTime;
$63618293c58b5f80$exports.Duration = $63618293c58b5f80$var$Duration;
$63618293c58b5f80$exports.FixedOffsetZone = $63618293c58b5f80$var$FixedOffsetZone;
$63618293c58b5f80$exports.IANAZone = $63618293c58b5f80$var$IANAZone;
$63618293c58b5f80$exports.Info = $63618293c58b5f80$var$Info;
$63618293c58b5f80$exports.Interval = $63618293c58b5f80$var$Interval;
$63618293c58b5f80$exports.InvalidZone = $63618293c58b5f80$var$InvalidZone;
$63618293c58b5f80$exports.LocalZone = $63618293c58b5f80$var$LocalZone;
$63618293c58b5f80$exports.Settings = $63618293c58b5f80$var$Settings;
$63618293c58b5f80$exports.VERSION = $63618293c58b5f80$var$VERSION;
$63618293c58b5f80$exports.Zone = $63618293c58b5f80$var$Zone;



var $acw62 = parcelRequire("acw62");
/**
 * The single chokepoint for the credit-card sign convention in the UI.
 *
 * Storage convention (see docs/plans/archive/2026-04-22-balance-tracking-design.md):
 * balances are signed cents with liability negative. A credit card with
 * $1,200 owed is stored as -120000; an overpaid card with a $50 credit is
 * stored as +5000. Net worth = sum(all stored balances).
 *
 * Display convention: credit cards are framed as "amount owed" — positive
 * when in debt, negative when the card carries a credit.
 *
 * Every component that renders or accepts a credit-card balance MUST go
 * through these helpers instead of negating/abs-ing inline. Four separate
 * sign bugs (migration, record modal, Plaid sync, display) all came from
 * sites re-deriving this transform by hand.
 */ /**
 * Flip a sign without producing negative zero: `-0` survives arithmetic and
 * formats as "-$0.00", so a card sitting at exactly zero would read as owing
 * a negative amount.
 */ const $1d7c692b9128a045$var$flip = (cents)=>cents === 0 ? 0 : -cents;
const $1d7c692b9128a045$export$bd72e98d1c10a7e4 = (storedCents, isCreditCard)=>isCreditCard ? $1d7c692b9128a045$var$flip(storedCents) : storedCents;
const $1d7c692b9128a045$export$d717750c75a5d699 = (displayCents, isCreditCard)=>isCreditCard ? $1d7c692b9128a045$var$flip(displayCents) : displayCents;
const $1d7c692b9128a045$export$f7bcd4900af66aa4 = (storedCents, isCreditCard)=>{
    if (!isCreditCard) return {
        label: 'Current balance',
        amount: storedCents
    };
    return storedCents > 0 ? {
        label: 'Credit balance',
        amount: storedCents
    } : {
        label: 'Amount owed',
        amount: $1d7c692b9128a045$var$flip(storedCents)
    };
};



parcelRequire("acw62");
const $2c01155910a1aa73$export$f0d9cf1e329477be = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border-border flex max-h-80 flex-col gap-1.5 overflow-y-auto rounded-lg border p-2",
        children: children
    });
const $2c01155910a1aa73$export$be59229647a59a8 = ({ children: children, className: className, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
        className: `border-border flex items-center gap-2 border-b pb-1.5 last:border-b-0 last:pb-0 ${className ?? ''}`,
        ...props,
        children: children
    });
const $2c01155910a1aa73$export$7f714e6c560938e5 = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-destructive text-sm",
        children: children
    });
const $2c01155910a1aa73$export$ed2cd9eb2d1973f0 = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-muted-foreground m-0",
        children: children
    });
const $2c01155910a1aa73$export$f6126929dd4ef646 = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "mt-2 flex justify-end gap-2",
        children: children
    });
const $2c01155910a1aa73$export$1b027679229955ad = ({ children: children, className: className, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: `border-border bg-background rounded-md border px-4 py-1.5 text-sm disabled:cursor-not-allowed disabled:opacity-50 ${className ?? ''}`,
        ...props,
        children: children
    });





var $acw62 = parcelRequire("acw62");

/**
 * How many fraction digits a currency DISPLAYS (2 for USD, 0 for JPY).
 * Capped at 2 because storage is uniform hundredths; Money.toDecimalString
 * clamps three-decimal currencies (KWD) and non-ISO commodity codes to the
 * same two digits, so rendered values round-trip through digit-based parsing.
 */ const $a27971b9e51bd6a0$export$4ebd9d5522ae08b6 = (currency)=>{
    try {
        const digits = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency
        }).resolvedOptions().maximumFractionDigits;
        return Math.min(2, digits ?? 2);
    } catch  {
        return 2;
    }
};
const $a27971b9e51bd6a0$export$ccfcc1a96dac208f = (currency)=>10 ** (2 - $a27971b9e51bd6a0$export$4ebd9d5522ae08b6(currency));


const $9ac5aec7425fcb2d$export$effb70c60b100b26 = (currency)=>currency.startsWith('unit_');
const $9ac5aec7425fcb2d$var$clampDecimals = (decimals)=>Math.min(2, Math.max(0, decimals));
const $9ac5aec7425fcb2d$export$68ddd39be27a132c = (currency, unitsById)=>{
    const unit = unitsById.get(currency);
    return unit ? $9ac5aec7425fcb2d$var$clampDecimals(unit.displayDecimals) : (0, $a27971b9e51bd6a0$export$4ebd9d5522ae08b6)(currency);
};
const $9ac5aec7425fcb2d$export$ddd851adc5745811 = (currency, unitsById)=>10 ** (2 - $9ac5aec7425fcb2d$export$68ddd39be27a132c(currency, unitsById));
const $9ac5aec7425fcb2d$export$ba37dda4e3a0b386 = (money, unitsById, options)=>{
    const unit = unitsById.get(money.currency);
    if (!unit) return (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).toDecimalString(money, options);
    const digits = $9ac5aec7425fcb2d$var$clampDecimals(unit.displayDecimals);
    const value = money.amount / 100;
    const bare = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    }).format(value);
    if (options?.showCurrency === false) return bare;
    const label = Math.abs(value) === 1 ? unit.singular : unit.plural;
    return `${bare} ${label}`;
};
const $9ac5aec7425fcb2d$export$20aa680045b2e71b = (currency, unitsById)=>unitsById.get(currency)?.name ?? currency;


const $9b33a37eb331091e$export$17987e0a14ce8a32 = ()=>{
    const { data: data } = (0, $ce9d9e524be20f53$export$20437837b60921de)();
    return $acw62.useMemo(()=>{
        const map = new Map();
        for (const unit of data?.allUnits ?? [])map.set(unit._id, unit);
        return map;
    }, [
        data
    ]);
};
const $9b33a37eb331091e$export$ec768e6f1552891e = ()=>{
    const { loading: loading } = (0, $ce9d9e524be20f53$export$20437837b60921de)();
    return !loading;
};
const $9b33a37eb331091e$export$b44ac3096015d626 = ()=>{
    const unitsById = $9b33a37eb331091e$export$17987e0a14ce8a32();
    return $acw62.useCallback((money, options)=>(0, $9ac5aec7425fcb2d$export$ba37dda4e3a0b386)(money, unitsById, options), [
        unitsById
    ]);
};
const $9b33a37eb331091e$export$df99f23287eaf00e = ()=>{
    const unitsById = $9b33a37eb331091e$export$17987e0a14ce8a32();
    return $acw62.useCallback((currency)=>(0, $9ac5aec7425fcb2d$export$20aa680045b2e71b)(currency, unitsById), [
        unitsById
    ]);
};






parcelRequire("acw62");



const $1ea0ae3f3c1219da$export$32dc9018a66a99be = ({ baselineDate: baselineDate, baselineBalance: baselineBalance, recordedDate: recordedDate, needsStartingBalance: needsStartingBalance, selectedSum: selectedSum, recordedBalance: recordedBalance, isBalanced: isBalanced, pending: pending, isCreditCard: isCreditCard, currency: currency })=>{
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const fmt = (cents)=>formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt((0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(cents, isCreditCard), currency));
    // Explicit sign so the running change and the gap it has to close both read
    // as signed deltas. The sign follows the displayed value, not the stored one.
    const fmtSigned = (cents)=>{
        const display = (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(cents, isCreditCard);
        const magnitude = formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(display), currency));
        if (display > 0) return `+${magnitude}`;
        if (display < 0) return `\u{2212}${magnitude}`;
        return magnitude;
    };
    // The gap between the two trusted anchors — the amount the selection must
    // sum to. Null when there's no baseline to measure from.
    const difference = needsStartingBalance ? null : recordedBalance - baselineBalance;
    // How much the selection is still short of (or over) the difference — the
    // actionable number, since a specific remainder often maps to one unpicked
    // transaction. Zero exactly when the session balances.
    const remaining = difference === null ? null : difference - selectedSum;
    // Colour the selection and its remainder: green once they match the
    // difference, red while they don't, plain while sums are still streaming in.
    const selectedColor = pending || needsStartingBalance ? undefined : isBalanced ? 'text-positive' : 'text-destructive';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-muted rounded-lg p-3 text-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground",
                        children: [
                            "Previous balance",
                            baselineDate ? ` (${baselineDate})` : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tabular-nums",
                        children: needsStartingBalance ? "\u2014" : fmt(baselineBalance)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground",
                        children: [
                            "Recorded balance",
                            recordedDate ? ` (${recordedDate})` : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tabular-nums",
                        children: fmt(recordedBalance)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border mt-2 flex justify-between border-t pt-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground",
                        children: "Difference"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tabular-nums",
                        children: difference === null ? "\u2014" : fmtSigned(difference)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex justify-between font-semibold', selectedColor),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "Selected total"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tabular-nums",
                        children: pending ? "\u2026" : needsStartingBalance ? "\u2014" : fmtSigned(selectedSum)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex justify-between', selectedColor),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "Remaining"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tabular-nums",
                        children: pending ? "\u2026" : remaining === null ? "\u2014" : fmtSigned(remaining)
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
const $7ed8142efacaf742$export$cbf38a927edf6508 = (window, date)=>(window.baselineDate == null || date > window.baselineDate) && date <= window.anchorDate;
const $7ed8142efacaf742$export$8df98906c402b688 = (anchorDate)=>`Reconciliation adjustment \u{2014} ${anchorDate}`;
const $7ed8142efacaf742$export$b3652e185d28132b = ({ accountId: accountId, anchorId: anchorId, anchorDate: anchorDate, anchorBalance: anchorBalance, baselineDate: baselineDate, baselineBalance: baselineBalance, baselineResolved: baselineResolved, transactions: transactions, windowCovered: windowCovered, loadingTransactions: loadingTransactions, selectedIds: selectedIds, onSeedSelection: onSeedSelection, onReconciled: onReconciled })=>{
    const eligible = transactions.filter((t)=>t.reconciliation == null);
    const needsStartingBalance = baselineResolved && baselineDate == null;
    // Keyed by anchor id so switching the session to another anchor re-seeds.
    const [seededAnchorId, setSeededAnchorId] = $acw62.useState(null);
    // Reset the seed the moment the anchor changes — including when a session
    // ends and the same anchor is later reconciled again (the in-place timeline
    // keeps this hook mounted across sessions, so the seed must be cleared here
    // rather than by unmounting). Adjusting state during render is the idiomatic
    // way to derive from a changing input without an extra effect + commit.
    const [lastAnchorId, setLastAnchorId] = $acw62.useState(anchorId);
    if (anchorId !== lastAnchorId) {
        setLastAnchorId(anchorId);
        setSeededAnchorId(null);
    }
    const hasSeeded = seededAnchorId === anchorId;
    $acw62.useEffect(()=>{
        if (hasSeeded || !baselineResolved || needsStartingBalance || loadingTransactions || !windowCovered) return;
        setSeededAnchorId(anchorId);
        onSeedSelection(eligible.filter((t)=>$7ed8142efacaf742$export$cbf38a927edf6508({
                baselineDate: baselineDate,
                anchorDate: anchorDate
            }, t.date)));
    }, [
        hasSeeded,
        baselineResolved,
        needsStartingBalance,
        loadingTransactions,
        windowCovered,
        anchorId,
        eligible.length
    ]);
    // Derive the submitted set from the loaded list so it always matches the
    // displayed sum (the selection may hold rows that later re-fetched as
    // reconciled).
    const selectedIdSet = new Set(selectedIds);
    const selectedTransactions = eligible.filter((t)=>selectedIdSet.has(t._id));
    const selectedSum = selectedTransactions.reduce((s, t)=>s + t.amount, 0);
    const needed = anchorBalance - baselineBalance;
    // The balance the selection would produce if it were the complete set of
    // activity for the period. diff === expectedBalance - anchorBalance.
    const expectedBalance = baselineBalance + selectedSum;
    const diff = selectedSum - needed;
    const isBalanced = Math.round(diff) === 0;
    // The signed remainder still unaccounted for — what a "fix up" adjustment
    // transaction would need to be so the selection lands exactly on `needed`.
    const remaining = needed - selectedSum;
    // Until the default selection is seeded the sums are partial (pages are
    // still streaming in), so summaries should show placeholders instead of
    // flashing misleading "off" amounts that jump once loading settles.
    const summaryPending = !hasSeeded && !needsStartingBalance;
    const [reconcile, { loading: submitting }] = (0, $ce9d9e524be20f53$export$16d26a75ed907543)();
    const [error, setError] = $acw62.useState(null);
    const canSubmit = !submitting && baselineResolved && !needsStartingBalance && windowCovered && hasSeeded && isBalanced && (selectedTransactions.length > 0 || needed === 0);
    const submit = async ()=>{
        setError(null);
        const claimedIds = selectedTransactions.map((t)=>t._id);
        try {
            await reconcile({
                variables: {
                    anchorId: anchorId,
                    accountId: accountId,
                    rawTransactionIds: claimedIds
                }
            });
            onReconciled?.(claimedIds);
            return true;
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Reconciliation failed');
            return false;
        }
    };
    // "Fix up" is only meaningful once the period is fully loaded and seeded but
    // still off by a nonzero remainder — the whole point is to absorb that gap.
    // The action itself (opening a prefilled create-transaction modal) lives in
    // the UI; the hook only decides when it applies and exposes the amount.
    const canFixUp = !submitting && baselineResolved && !needsStartingBalance && windowCovered && hasSeeded && !summaryPending && !isBalanced;
    return {
        eligible: eligible,
        selectedTransactions: selectedTransactions,
        selectedSum: selectedSum,
        needed: needed,
        remaining: remaining,
        expectedBalance: expectedBalance,
        diff: diff,
        isBalanced: isBalanced,
        hasSeeded: hasSeeded,
        summaryPending: summaryPending,
        needsStartingBalance: needsStartingBalance,
        canSubmit: canSubmit,
        submit: submit,
        canFixUp: canFixUp,
        submitting: submitting,
        error: error
    };
};


/**
 * Rows per fetch. Reconciliation must load the whole period before it can
 * seed the selection, so fewer round trips beat smaller payloads — and the
 * lite query's rows are small (no account/benefit sub-objects).
 */ const $98ea2bd336690b9c$var$PAGE_SIZE = 500;
/**
 * A cursor-paginated raw-transaction list. Pages are newest-first; each
 * loadNextPage() call appends the next-older page. The cursor guard keeps
 * React strict-mode double-effects (and a manual click racing an auto-load
 * effect) from appending the same page twice.
 *
 * Uses the lite projection (no account/benefit) — the full BasicRawTransaction
 * fragment triggers per-row account sub-resolvers on the server, which made
 * loading this modal slow.
 */ const $98ea2bd336690b9c$var$usePagedRawTransactions = ({ variables: variables, skip: skip })=>{
    const { data: data, loading: loading, fetchMore: fetchMore } = (0, $ce9d9e524be20f53$export$4804775d7f2aae89)({
        variables: variables,
        skip: skip,
        // Makes `loading` reflect fetchMore, so load-more buttons can disable
        // themselves while a page is in flight.
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network'
    });
    const page = data?.allRawTransactions;
    const fetchedCursors = $acw62.useRef(new Set());
    const loadNextPage = $acw62.useCallback(()=>{
        if (!page?.hasMore || !page.endCursor) return;
        if (fetchedCursors.current.has(page.endCursor)) return;
        const cursor = page.endCursor;
        fetchedCursors.current.add(cursor);
        fetchMore({
            variables: {
                beforeCursor: cursor
            },
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>({
                    ...prev,
                    allRawTransactions: {
                        ...fetchMoreResult.allRawTransactions,
                        items: [
                            ...prev.allRawTransactions.items,
                            ...fetchMoreResult.allRawTransactions.items
                        ]
                    }
                })
        }).catch(()=>{
            // A transient failure must not pin the guard forever — forget the
            // cursor so the auto-paging loop and Load buttons can retry it.
            fetchedCursors.current.delete(cursor);
        });
    }, [
        page,
        fetchMore
    ]);
    return {
        items: page?.items ?? [],
        hasMore: page?.hasMore ?? false,
        loading: loading,
        loadNextPage: loadNextPage
    };
};
const $98ea2bd336690b9c$export$a68cbfa049020456 = (props)=>{
    // Display sign: credit cards are shown as "amount owed".
    const isCreditCard = props.isCreditCard ?? false;
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const fmt = (cents, currency = props.currency)=>formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
            amount: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(cents, isCreditCard),
            currency: currency
        }));
    // Fetch the reconciliation baseline from the server, mirroring the reconcile
    // mutation's derivation so the modal's math always matches the server's
    // validation: the nearest prior anchor. Daily Plaid readings live in their
    // own collection and never appear here, which is what makes the period span
    // "since the last attested balance" rather than one sync day.
    const { data: anyPrevData, loading: prevLoading } = (0, $ce9d9e524be20f53$export$4b244df86d92b624)({
        variables: {
            accountId: props.accountId,
            before: props.anchorDate,
            limit: 1
        },
        fetchPolicy: 'cache-and-network'
    });
    const baseline = prevLoading ? null : anyPrevData?.balanceAnchors[0] ?? null;
    // The server requires a prior anchor to baseline the reconciliation, so
    // the account's first anchor can't be reconciled directly — the user must
    // record a starting balance (e.g. the opening balance) first.
    const needsStartingBalance = !prevLoading && baseline == null;
    // The server doesn't constrain transaction dates (late-posting transactions
    // may legitimately belong to a neighboring period), so the main fetch is
    // only bounded by the anchor date. Pages are newest-first: the first
    // pages cover the period window (baseline.date, anchor.date], and older
    // history — including already-reconciled rows, shown disabled for context —
    // arrives via "Load earlier". The first page runs in parallel with the
    // baseline query (it doesn't depend on it); only the auto-paging loop below
    // waits for the baseline, since without one the window is unbounded.
    const { items: mainTxns, hasMore: hasMore, loading: loading, loadNextPage: loadNextPage } = $98ea2bd336690b9c$var$usePagedRawTransactions({
        variables: {
            accountId: props.accountId,
            endDate: props.anchorDate,
            // Reconciliation is about ALL account activity in the period, including
            // transactions already categorized (remainingAmount === 0). Without this
            // the server's default needs-categorization filter would hide them and
            // the balance could never reconcile.
            includeProcessed: true,
            limit: $98ea2bd336690b9c$var$PAGE_SIZE
        },
        skip: needsStartingBalance
    });
    // Transactions dated AFTER the anchor can also belong to this statement
    // (banks sometimes post with a later date than the balance reflects), and
    // the reconcile mutation accepts them. They're loaded on demand via "Load
    // later transactions" and fetched in full once requested — this set is
    // bounded by (anchor.date, today].
    const [includeLater, setIncludeLater] = $acw62.useState(false);
    const dayAfterAnchor = (0, $63618293c58b5f80$exports.DateTime).fromISO(props.anchorDate).plus({
        days: 1
    }).toISODate();
    const { items: laterTxns, hasMore: laterHasMore, loading: laterLoading, loadNextPage: loadNextLaterPage } = $98ea2bd336690b9c$var$usePagedRawTransactions({
        variables: {
            accountId: props.accountId,
            startDate: dayAfterAnchor,
            includeProcessed: true,
            limit: $98ea2bd336690b9c$var$PAGE_SIZE
        },
        skip: prevLoading || needsStartingBalance || !includeLater
    });
    $acw62.useEffect(()=>{
        if (!includeLater || laterLoading || !laterHasMore) return;
        loadNextLaterPage();
    }, [
        includeLater,
        laterLoading,
        laterHasMore,
        loadNextLaterPage
    ]);
    const inWindow = (t)=>(0, $7ed8142efacaf742$export$cbf38a927edf6508)({
            baselineDate: baseline?.date ?? null,
            anchorDate: props.anchorDate
        }, t.date);
    // Reconciliation needs the FULL window — the mutation only accepts a
    // transaction set that makes the period balance, so a truncated window would
    // make some periods impossible to reconcile. Pages are sorted newest-first,
    // so the window is covered once the oldest loaded row is at or before the
    // baseline date (or there is nothing left to load).
    const oldestLoaded = mainTxns.length > 0 ? mainTxns[mainTxns.length - 1].date : null;
    const windowCovered = !hasMore || baseline != null && oldestLoaded != null && oldestLoaded <= baseline.date;
    // Auto-fetch until the window is covered; beyond that, older history loads
    // on demand via the button. Waits for the baseline — without it the window
    // is unbounded and this loop would page through the account's entire
    // history (the first page has already been fetched in parallel by then).
    $acw62.useEffect(()=>{
        if (prevLoading || needsStartingBalance || loading || windowCovered) return;
        loadNextPage();
    }, [
        prevLoading,
        needsStartingBalance,
        loading,
        windowCovered,
        loadNextPage
    ]);
    // Later transactions render above the main list, keeping everything
    // newest-first.
    const allTxns = [
        ...laterTxns,
        ...mainTxns
    ];
    const [selected, setSelected] = $acw62.useState(()=>new Set());
    const session = (0, $7ed8142efacaf742$export$b3652e185d28132b)({
        accountId: props.accountId,
        anchorId: props.anchorId,
        anchorDate: props.anchorDate,
        anchorBalance: props.anchorBalance,
        baselineDate: baseline?.date ?? null,
        baselineBalance: baseline?.balance ?? 0,
        baselineResolved: !prevLoading,
        transactions: allTxns,
        windowCovered: windowCovered,
        loadingTransactions: loading,
        selectedIds: [
            ...selected
        ],
        // Only in-window transactions are auto-selected — earlier ones (loaded on
        // demand) are always an explicit opt-in.
        onSeedSelection: (txns)=>setSelected(new Set(txns.map((t)=>t._id)))
    });
    const toggle = (id)=>{
        setSelected((prev)=>{
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const succeeded = await session.submit();
        if (succeeded) {
            props.onSuccess?.();
            props.onRequestClose();
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                disabled: session.submitting,
                onClick: props.onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: "reconcile-form",
                disabled: !session.canSubmit,
                children: "Reconcile"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: props.onRequestClose,
        header: `Reconcile balance \u{2014} ${props.anchorDate}`,
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: "reconcile-form",
            onSubmit: (e)=>void handleSubmit(e),
            className: "flex flex-col gap-4",
            children: [
                needsStartingBalance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "border-border bg-muted m-0 rounded-lg border p-3 text-sm",
                    children: [
                        "This is the account's earliest recorded balance, so there is no previous balance to reconcile against. Record a starting balance (e.g. the account's opening balance) dated before",
                        ' ',
                        props.anchorDate,
                        ", then reconcile this one against it."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ea0ae3f3c1219da$export$32dc9018a66a99be), {
                    baselineDate: baseline?.date ?? null,
                    baselineBalance: baseline?.balance ?? 0,
                    recordedDate: props.anchorDate,
                    needsStartingBalance: needsStartingBalance,
                    selectedSum: session.selectedSum,
                    recordedBalance: props.anchorBalance,
                    isBalanced: session.isBalanced,
                    pending: session.summaryPending || prevLoading,
                    isCreditCard: isCreditCard,
                    currency: props.currency
                }),
                session.summaryPending && !needsStartingBalance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground text-xs",
                    children: "Loading all transactions in this period\u2026"
                }),
                !needsStartingBalance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$f6126929dd4ef646), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$1b027679229955ad), {
                        type: "button",
                        disabled: prevLoading || includeLater,
                        onClick: ()=>setIncludeLater(true),
                        children: !includeLater ? 'Load later transactions' : laterLoading || laterHasMore ? "Loading\u2026" : laterTxns.length === 0 ? `No transactions after ${props.anchorDate}` : 'All later transactions loaded'
                    })
                }),
                needsStartingBalance ? null : loading && allTxns.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
                    children: "Loading transactions\u2026"
                }) : allTxns.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
                    children: "No transactions found."
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$f0d9cf1e329477be), {
                    children: allTxns.map((txn)=>{
                        const isReconciled = txn.reconciliation != null;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2c01155910a1aa73$export$be59229647a59a8), {
                            className: isReconciled ? 'opacity-50' : '',
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: isReconciled || selected.has(txn._id),
                                    disabled: isReconciled,
                                    onChange: ()=>toggle(txn._id),
                                    className: "shrink-0"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-foreground min-w-0 flex-1 truncate text-sm",
                                    children: txn.description
                                }),
                                isReconciled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground shrink-0 text-xs",
                                    children: "reconciled"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-foreground shrink-0 text-sm tabular-nums",
                                    children: fmt(txn.amount, txn.currency)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `text-muted-foreground w-20 shrink-0 text-right text-xs ${isReconciled || inWindow(txn) ? '' : 'italic underline decoration-dotted'}`,
                                    title: isReconciled || inWindow(txn) ? undefined : 'Outside this period',
                                    children: txn.date
                                })
                            ]
                        }, txn._id);
                    })
                }),
                !needsStartingBalance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$f6126929dd4ef646), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$1b027679229955ad), {
                        type: "button",
                        // Also disabled while the window itself is still auto-paging in,
                        // so the button can't race the auto-load effect.
                        disabled: loading || !windowCovered || !hasMore,
                        onClick: loadNextPage,
                        children: loading ? "Loading\u2026" : hasMore ? 'Load earlier transactions' : 'All earlier transactions loaded'
                    })
                }),
                session.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$7f714e6c560938e5), {
                    children: session.error
                })
            ]
        })
    });
};






const $3c773088597ab155$var$mapObject = (array, mapper)=>{
    const result = {};
    array.forEach((t)=>{
        const [key, value] = mapper(t);
        result[key] = value;
    });
    return result;
};
const $3c773088597ab155$var$range = (a, b)=>{
    const start = b === undefined ? 0 : a;
    const end = b === undefined ? a : b;
    const length = Math.abs(end - start);
    const sign = length / (end - start);
    return Array(length).fill(undefined).map((_, i)=>start + sign * i);
};
const $3c773088597ab155$var$grouped = (array, count)=>{
    const result = [];
    array.forEach((el)=>{
        if (result.length === 0 || result[result.length - 1].length === count) result.push([
            el
        ]);
        else result[result.length - 1].push(el);
    });
    return result;
};
const $3c773088597ab155$var$allOptionArray = (array)=>{
    const nones = array.filter((v)=>v.isEmpty);
    if (nones.length > 0) return 0, $f8f45ddea4959097$exports.none;
    else return (0, $f8f45ddea4959097$exports.some)(array.map((o)=>o.get()));
};
const $3c773088597ab155$export$3f063810d7bf01bd = (arr, grouper)=>{
    const groups = new Map();
    arr.forEach((t)=>{
        const key = grouper(t);
        const existing = groups.get(key);
        if (existing) existing.push(t);
        else groups.set(key, [
            t
        ]);
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Array.from(groups.entries());
};
var $3c773088597ab155$export$2e2bcd8739ae039 = {
    range: $3c773088597ab155$var$range,
    mapObject: $3c773088597ab155$var$mapObject,
    grouped: $3c773088597ab155$var$grouped,
    allOptionArray: $3c773088597ab155$var$allOptionArray,
    groupBy: $3c773088597ab155$export$3f063810d7bf01bd
};



const $0c0f91b069db95d9$export$9144c32b59cbaec4 = (obj)=>(0, $63618293c58b5f80$exports.DateTime).fromObject({
        ...obj,
        zone: "UTC"
    });
const $0c0f91b069db95d9$export$66d5340adb0ab835 = (year, month)=>{
    const date = $0c0f91b069db95d9$export$9144c32b59cbaec4({
        year: year,
        month: month,
        day: 1
    });
    const firstDay = date.startOf("month").weekday % 7;
    const lastDay = date.endOf("month").weekday % 7;
    const lastMonth = date.minus({
        months: 1
    });
    const daysInLastMonth = lastMonth.daysInMonth;
    const lastMonthDays = (0, $3c773088597ab155$export$2e2bcd8739ae039).range(daysInLastMonth - firstDay, daysInLastMonth).map((i)=>lastMonth.set({
            day: i + 1
        }));
    const daysInMonth = date.daysInMonth;
    const thisMonthDays = (0, $3c773088597ab155$export$2e2bcd8739ae039).range(daysInMonth).map((i)=>date.set({
            day: i + 1
        }));
    const nextMonth = date.plus({
        months: 1
    });
    const nextMonthDays = (0, $3c773088597ab155$export$2e2bcd8739ae039).range(7 - lastDay - 1).map((i)=>nextMonth.set({
            day: i + 1
        }));
    return (0, $3c773088597ab155$export$2e2bcd8739ae039).grouped([
        ...lastMonthDays,
        ...thisMonthDays,
        ...nextMonthDays
    ], 7);
};
const $0c0f91b069db95d9$export$6b862160d295c8e = (dateString)=>(0, $63618293c58b5f80$exports.DateTime).fromISO(dateString, {
        zone: "UTC"
    });
const $0c0f91b069db95d9$export$d5805bbcec54c5ee = (seconds)=>(0, $63618293c58b5f80$exports.DateTime).fromSeconds(seconds, {
        zone: "UTC"
    });
const $0c0f91b069db95d9$export$d0bdf45af03a6ea3 = ()=>{
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    return $0c0f91b069db95d9$export$9144c32b59cbaec4({
        year: now.year,
        month: now.month,
        day: now.day
    });
};




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c31db635520dc385$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const $c31db635520dc385$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-left", $c31db635520dc385$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");



/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f88028b3cc726f6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $4f88028b3cc726f6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-down", $4f88028b3cc726f6$export$3efd853dbb351e94);



const $2042cfdcc9453ac5$export$ef9b1a59e592288f = (props)=>{
    const { className: className, options: options, value: value, onChange: onChange, getOptionLabel: getOptionLabel } = props;
    const label = getOptionLabel ? getOptionLabel(value) : value;
    const handleChange = (e)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        onChange(e.target.value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('has-focus:border-ring border-input has-focus:ring-ring/50 relative flex flex-row items-center gap-1 rounded-md border px-2 py-1 shadow-xs has-focus:ring-[3px]', className),
        children: [
            label,
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                className: "size-4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                className: "absolute inset-0 size-full cursor-pointer opacity-0",
                value: value,
                onChange: handleChange,
                children: options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: option,
                        children: getOptionLabel ? getOptionLabel(option) : option
                    }, option))
            })
        ]
    });
};


// prettier-ignore
const $612c5b1d0d74cd1a$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
const $612c5b1d0d74cd1a$var$cellStyle = 'flex size-8 flex-col items-center justify-center transition-none';
const $612c5b1d0d74cd1a$var$CalendarSelect = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { selectedDate: selectedDate, onDateSelect: onDateSelect, className: className, ...divProps } = props;
    const [year, setYear] = $acw62.useState(selectedDate.year);
    const [month, setMonth] = $acw62.useState(selectedDate.month);
    $acw62.useEffect(()=>{
        // Check if date is visible in the current month
        const firstOfMonth = (0, $0c0f91b069db95d9$export$9144c32b59cbaec4)({
            year: year,
            month: month,
            day: 1
        });
        const earliest = firstOfMonth.startOf('week').minus({
            days: 1
        });
        const latest = firstOfMonth.endOf('month').plus({
            days: 1
        }).endOf('week').minus({
            days: 1
        });
        if (selectedDate < earliest || selectedDate > latest) {
            setYear(selectedDate.year);
            setMonth(selectedDate.month);
        }
    }, [
        selectedDate
    ]);
    const handlePreviousMonth = ()=>{
        const newDate = (0, $0c0f91b069db95d9$export$9144c32b59cbaec4)({
            year: year,
            month: month,
            day: 1
        }).minus({
            months: 1
        });
        setMonth(newDate.month);
        setYear(newDate.year);
    };
    const handleNextMonth = ()=>{
        const newDate = (0, $0c0f91b069db95d9$export$9144c32b59cbaec4)({
            year: year,
            month: month,
            day: 1
        }).plus({
            months: 1
        });
        setMonth(newDate.month);
        setYear(newDate.year);
    };
    const renderDay = (date, i)=>{
        const isCurrentMonth = date.month === month;
        const isSelected = date.equals(selectedDate);
        const className = (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($612c5b1d0d74cd1a$var$cellStyle, !isCurrentMonth && 'text-muted-foreground', isSelected && 'bg-primary text-primary-foreground hover:bg-primary/80');
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
            variant: "ghost",
            tabIndex: -1,
            onClick: ()=>onDateSelect(date),
            className: className,
            children: date.day
        }, i);
    };
    const monthSelect = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2042cfdcc9453ac5$export$ef9b1a59e592288f), {
        options: $612c5b1d0d74cd1a$var$months,
        value: $612c5b1d0d74cd1a$var$months[month - 1],
        onChange: (value)=>setMonth($612c5b1d0d74cd1a$var$months.indexOf(value) + 1)
    });
    const currentYear = new Date().getFullYear();
    const yearSelect = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2042cfdcc9453ac5$export$ef9b1a59e592288f), {
        options: Array.from({
            length: 20
        }, (_, i)=>i + currentYear - 15).map((year)=>year.toString()),
        value: year.toString(),
        onChange: (value)=>setYear(parseInt(value))
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('bg-background ring-border mt-1 rounded-md p-2 shadow-md ring-1', className),
        ref: ref,
        ...divProps,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        className: $612c5b1d0d74cd1a$var$cellStyle,
                        tabIndex: -1,
                        onClick: handlePreviousMonth,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                            className: "size-4"
                        })
                    }),
                    monthSelect,
                    yearSelect,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        className: $612c5b1d0d74cd1a$var$cellStyle,
                        tabIndex: -1,
                        onClick: handleNextMonth,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                            className: "size-4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground flex flex-row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $612c5b1d0d74cd1a$var$cellStyle,
                        children: "Su"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $612c5b1d0d74cd1a$var$cellStyle,
                        children: "Mo"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $612c5b1d0d74cd1a$var$cellStyle,
                        children: "Tu"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $612c5b1d0d74cd1a$var$cellStyle,
                        children: "We"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $612c5b1d0d74cd1a$var$cellStyle,
                        children: "Th"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $612c5b1d0d74cd1a$var$cellStyle,
                        children: "Fr"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $612c5b1d0d74cd1a$var$cellStyle,
                        children: "Sa"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col",
                children: (0, $0c0f91b069db95d9$export$66d5340adb0ab835)(year, month).map((week, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-row",
                        children: week.map((d, j)=>renderDay(d, j))
                    }, i))
            })
        ]
    });
});
var $612c5b1d0d74cd1a$export$2e2bcd8739ae039 = $612c5b1d0d74cd1a$var$CalendarSelect;




var $acw62 = parcelRequire("acw62");

const $a7de46ea21e6828f$export$c86715117507e8e5 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { onChange: onChange, className: className, selectOnFocus: selectOnFocus, ...otherProps } = props;
    const handleChange = (e)=>{
        onChange?.(e.target.value);
    };
    const handleFocus = (e)=>{
        if (selectOnFocus) e.target.select();
        props.onFocus?.(e);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        ref: ref,
        ...otherProps,
        onFocus: handleFocus,
        onChange: handleChange,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50', 'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]', 'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive', className)
    });
});





var $acw62 = parcelRequire("acw62");



const $2fa899d90230d1ae$var$getPosition = (anchor, triggerRect, contentRect)=>{
    switch(anchor){
        case 'top-left':
            return {
                top: triggerRect.top,
                left: triggerRect.left
            };
        case 'top-right':
            return {
                top: triggerRect.bottom,
                left: triggerRect.right - contentRect.width
            };
        case 'bottom-left':
            return {
                top: triggerRect.bottom,
                left: triggerRect.left
            };
        case 'bottom-right':
            return {
                top: triggerRect.bottom,
                left: triggerRect.right - contentRect.width
            };
        default:
            return (0, $24175cbf70f85c9e$export$2e2bcd8739ae039)(anchor);
    }
};
const $2fa899d90230d1ae$export$5b6b19405a83ff9d = ({ anchorRef: anchorRef, anchor: anchor = 'top-left', children: children, open: open, onOutsideClick: onOutsideClick, onOutsideFocus: onOutsideFocus, onContentBlur: onContentBlur, focusControlsRef: focusControlsRef, passThroughOutsideClicks: passThroughOutsideClicks = false })=>{
    const contentRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!open || !passThroughOutsideClicks) return;
        const handlePointerDown = (e)=>{
            if (!(e.target instanceof Node)) return;
            if (contentRef.current?.contains(e.target)) return;
            if (anchorRef.current?.contains(e.target)) return;
            onOutsideClick?.();
        };
        document.addEventListener('pointerdown', handlePointerDown, true);
        return ()=>document.removeEventListener('pointerdown', handlePointerDown, true);
    }, [
        open,
        passThroughOutsideClicks,
        onOutsideClick,
        anchorRef
    ]);
    const updatePosition = $acw62.useCallback(()=>{
        const triggerEl = anchorRef.current;
        const contentEl = contentRef.current;
        if (!triggerEl || !contentEl) return;
        const triggerRect = triggerEl.getBoundingClientRect();
        const contentRect = contentEl.getBoundingClientRect();
        const next = $2fa899d90230d1ae$var$getPosition(anchor, triggerRect, contentRect);
        const viewport = window.visualViewport;
        if (viewport) {
            const margin = 8;
            const minTop = viewport.offsetTop + margin;
            const maxTop = viewport.offsetTop + viewport.height - contentRect.height - margin;
            if (maxTop >= minTop) next.top = Math.min(Math.max(next.top, minTop), maxTop);
            const minLeft = viewport.offsetLeft + margin;
            const maxLeft = viewport.offsetLeft + viewport.width - contentRect.width - margin;
            if (maxLeft >= minLeft) next.left = Math.min(Math.max(next.left, minLeft), maxLeft);
        }
        const newTop = `${Math.round(next.top * 100) / 100}px`;
        const newLeft = `${Math.round(next.left * 100) / 100}px`;
        if (newTop !== contentEl.style.top || newLeft !== contentEl.style.left) {
            contentEl.style.top = newTop;
            contentEl.style.left = newLeft;
            requestAnimationFrame(updatePosition);
        }
    }, [
        anchor,
        anchorRef
    ]);
    $acw62.useLayoutEffect(()=>{
        if (!open) return;
        const el = contentRef.current;
        if (!el) return;
        const ro = new ResizeObserver(updatePosition);
        ro.observe(el);
        updatePosition();
        window.addEventListener('resize', updatePosition);
        window.addEventListener('scroll', updatePosition, true);
        const viewport = window.visualViewport;
        viewport?.addEventListener('resize', updatePosition);
        viewport?.addEventListener('scroll', updatePosition);
        return ()=>{
            window.removeEventListener('resize', updatePosition);
            window.removeEventListener('scroll', updatePosition, true);
            viewport?.removeEventListener('resize', updatePosition);
            viewport?.removeEventListener('scroll', updatePosition);
            ro.disconnect();
        };
    }, [
        open,
        updatePosition
    ]);
    if (!open) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72de694199324d9d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94339ef075b24dd2$export$c6fdb837b070b4ff), {
            onOverlayClick: passThroughOutsideClicks ? undefined : onOutsideClick,
            interactive: !passThroughOutsideClicks,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed pointer-events-auto",
                ref: contentRef,
                style: {
                    top: '-10000px',
                    left: '-10000px'
                },
                onBlur: onContentBlur,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9feaa5924c876b6a$export$2e2bcd8739ae039), {
                    behavior: "continue",
                    onFocusOutside: onOutsideFocus,
                    focusControlsRef: focusControlsRef,
                    children: children
                })
            })
        })
    });
};
var $2fa899d90230d1ae$export$2e2bcd8739ae039 = $2fa899d90230d1ae$export$5b6b19405a83ff9d;


const $79f1e6c6881a02e0$var$DatePicker = (props)=>{
    const { selectedDate: selectedDate, onChange: onChange } = props;
    const [draft, setDraft] = $acw62.useState(selectedDate.toISODate());
    const [open, setOpen] = $acw62.useState(false);
    const inputRef = $acw62.useRef(null);
    const calendarRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        setDraft(selectedDate.toISODate());
    }, [
        selectedDate
    ]);
    const handleInputFocus = ()=>{
        inputRef.current?.setSelectionRange(0, draft.length);
        setOpen(true);
    };
    const handleInputChange = (newDraft)=>{
        setOpen(true);
        setDraft(newDraft);
    };
    // Push a typed draft up to the parent, reverting the field when it doesn't
    // parse. Shared by blur, Enter, and dismissing the calendar.
    const commitDraft = ()=>{
        const maybeDate = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(draft);
        if (maybeDate.isValid) onChange(maybeDate);
        else setDraft(selectedDate.toISODate());
    };
    const handleInputBlur = (e)=>{
        commitDraft();
        if (!calendarRef.current || !(e.relatedTarget instanceof Node) || !calendarRef.current.contains(e.relatedTarget)) setOpen(false);
    };
    const handleCancel = ()=>{
        commitDraft();
        setOpen(false);
    };
    const selectDate = (date)=>{
        onChange(date);
    };
    const handleSelectDate = (newDate)=>{
        selectDate(newDate);
        inputRef.current?.focus();
        setOpen(false);
    };
    const handleKeyDown = (e)=>{
        // A typed draft otherwise reaches the parent only on blur, so an Enter
        // that implicitly submits the surrounding form would submit the previous
        // date and silently drop the visible edit. Swallow that first Enter to
        // commit (or revert) the draft; once the field and the committed date
        // agree, Enter falls through and submits as usual.
        if (e.key === 'Enter') {
            if (draft !== selectedDate.toISODate()) {
                e.preventDefault();
                commitDraft();
                setOpen(false);
            }
            return;
        }
        const maybeDate = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(draft);
        if (maybeDate.isValid) {
            if (e.key === 'ArrowLeft') selectDate(maybeDate.minus({
                days: 1
            }));
            else if (e.key === 'ArrowRight') selectDate(maybeDate.plus({
                days: 1
            }));
            else if (e.key === 'ArrowUp') selectDate(maybeDate.minus({
                days: 7
            }));
            else if (e.key === 'ArrowDown') selectDate(maybeDate.plus({
                days: 7
            }));
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                id: props.id,
                "aria-invalid": props.invalid,
                ref: inputRef,
                selectOnFocus: true,
                onFocus: handleInputFocus,
                onChange: handleInputChange,
                onKeyDown: handleKeyDown,
                onBlur: handleInputBlur,
                value: draft
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fa899d90230d1ae$export$5b6b19405a83ff9d), {
                anchorRef: inputRef,
                anchor: "bottom-left",
                open: open,
                onOutsideClick: handleCancel,
                onOutsideFocus: handleCancel,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $612c5b1d0d74cd1a$export$2e2bcd8739ae039), {
                    ref: calendarRef,
                    selectedDate: selectedDate,
                    onDateSelect: handleSelectDate
                })
            })
        ]
    });
};
var $79f1e6c6881a02e0$export$2e2bcd8739ae039 = $79f1e6c6881a02e0$var$DatePicker;



parcelRequire("acw62");
const $f4af202f2e06e365$var$InputGroup = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-row items-start gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: props.htmlFor,
                className: "text-muted-foreground w-30 shrink-0 pt-1.5",
                children: props.label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-w-0 flex-1",
                children: props.children
            })
        ]
    });
};
var $f4af202f2e06e365$export$2e2bcd8739ae039 = $f4af202f2e06e365$var$InputGroup;






var $acw62 = parcelRequire("acw62");



/**
 * Symbol shown before the input ("$", "¥", …). Non-ISO commodity currencies
 * (TENNIS_CLASS) have no Intl symbol; fall back to no prefix — the field's
 * context names the unit.
 */ const $cf5f3d9d49aeb89e$var$currencyPrefix = (currency)=>{
    try {
        const parts = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency
        }).formatToParts(0);
        return parts.find((part)=>part.type === 'currency')?.value ?? '';
    } catch  {
        return '';
    }
};
const $cf5f3d9d49aeb89e$var$AmountInput = (props)=>{
    const { value: value, onChange: onChange } = props;
    const unitsById = (0, $9b33a37eb331091e$export$17987e0a14ce8a32)();
    const unitsSettled = (0, $9b33a37eb331091e$export$ec768e6f1552891e)();
    // Prop wins; otherwise follow the value being edited (call sites that
    // edit an existing foreign amount get the right unit without wiring).
    // Clearing the field makes `value` none — hold the last known currency
    // rather than snapping back to USD mid-edit.
    const heldCurrency = $acw62.useRef(null);
    const currency = props.currency ?? value.map((money)=>money.currency).getOrElse(heldCurrency.current ?? 'USD');
    heldCurrency.current = currency;
    // Typed digits are read in the currency's display unit, then scaled to
    // stored hundredths — "3000" in a JPY field is ¥3,000 (300,000
    // hundredths), not ¥30. Custom units carry their own display decimals.
    const digitScale = 10 ** (2 - (0, $9ac5aec7425fcb2d$export$68ddd39be27a132c)(currency, unitsById));
    const textAlign = (0, $f8f45ddea4959097$exports.Option)(props.textAlign).getOrElse('left');
    const initialMoney = value.getOrElse((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).zero(currency));
    const [draft, setDraft] = $acw62.useState((0, $9ac5aec7425fcb2d$export$ba37dda4e3a0b386)(initialMoney, unitsById, {
        showCurrency: false
    }));
    const setMoney = (money)=>{
        setDraft((0, $9ac5aec7425fcb2d$export$ba37dda4e3a0b386)(money, unitsById, {
            showCurrency: false
        }));
    };
    $acw62.useEffect(()=>{
        value.forEach((money)=>setMoney(money));
    }, [
        value
    ]);
    const parseMoney = (newValue)=>{
        const hasNumbers = !!newValue.match(/\d/);
        if (hasNumbers) {
            const sign = newValue[0] === '-' ? -1 : 1;
            const numbersOnly = newValue.replace(/\D/g, '');
            const digits = numbersOnly ? parseInt(numbersOnly, 10) : 0;
            const intAmount = sign * digits * digitScale;
            return (0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(intAmount, currency));
        } else return 0, $f8f45ddea4959097$exports.none;
    };
    // When the currency changes under a mounted input (the create-raw field
    // autofocuses as USD before an account is picked), keep the typed DIGITS
    // and reinterpret them in the new currency's unit: "20000" entered before
    // selecting a JPY wallet means ¥20,000 — not the ¥200 that carrying the
    // old cents value across would produce. Reformats the draft too (2 ↔ 0
    // fraction digits).
    const lastCurrency = $acw62.useRef(currency);
    $acw62.useEffect(()=>{
        if (lastCurrency.current === currency) return;
        lastCurrency.current = currency;
        // Only when an amount actually exists. With `value` empty the draft is
        // just the placeholder "0.00", and parsing it would report a real zero
        // amount to the parent — enough to enable Create and persist a
        // zero-valued raw the user never entered. That fires on its own whenever
        // an account query resolves a foreign currency after this input mounts
        // (the create-raw modal with a defaultAccountId).
        if (value.isEmpty) return;
        const parsed = parseMoney(draft);
        onChange(parsed);
        parsed.forEach((money)=>setMoney(money));
    // parseMoney/setMoney are recreated per render; the ref guard makes the
    // re-runs no-ops, so listing them (per exhaustive-deps) is harmless.
    }, [
        currency,
        draft,
        value,
        onChange,
        parseMoney,
        setMoney
    ]);
    // When the digit scale changes under the SAME currency — the units query
    // resolving a custom unit's displayDecimals after mount — the draft was
    // formatted at the old scale, and typed digits would now mis-parse ("3.00"
    // at a 0-decimal scale reads as 300). The stored value is authoritative
    // here (unlike a currency change, which preserves typed digits): reformat
    // the draft from it.
    const lastScale = $acw62.useRef(digitScale);
    $acw62.useEffect(()=>{
        if (lastScale.current === digitScale) return;
        lastScale.current = digitScale;
        value.forEach((money)=>{
            // A currency change also changes the scale, but there `value` still
            // holds the pre-switch money — the digit-preserving effect above owns
            // that case. Only reformat when the value is in the current currency.
            if (money.currency === currency) setMoney(money);
        });
    // setMoney is recreated per render; the ref guard makes re-runs no-ops.
    }, [
        digitScale,
        currency,
        value,
        setMoney
    ]);
    const handleChange = (newValue)=>{
        const parsed = parseMoney(newValue);
        onChange(parsed);
        if (parsed.isEmpty) setDraft(newValue);
        else setMoney(parsed.get());
    };
    const handleBlur = ()=>{
        const parsed = parseMoney(draft);
        setMoney(parsed.getOrElse((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).zero(currency)));
    };
    // A unit currency whose metadata hasn't arrived yet parses at the
    // provisional 2-decimal fallback — typing "3" there stores 0.03 units and
    // the later reformat can't recover the intent. Hold entry until the units
    // query settles (a session-cached fetch, so this window is a few ms at
    // worst); a token still unknown after settling is dangling and keeps the
    // fallback behavior.
    const awaitingUnitMetadata = !unitsSettled && (0, $9ac5aec7425fcb2d$export$effb70c60b100b26)(currency) && !unitsById.has(currency);
    const prefix = $cf5f3d9d49aeb89e$var$currencyPrefix(currency);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative w-full",
        children: [
            prefix !== '' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pointer-events-none absolute top-1/2 flex size-8 -translate-y-1/2 items-center justify-center text-sm",
                children: prefix
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                autoFocus: props.autoFocus,
                type: "text",
                value: draft,
                onChange: handleChange,
                onBlur: handleBlur,
                selectOnFocus: true,
                disabled: props.disabled || awaitingUnitMetadata,
                style: {
                    textAlign: textAlign
                },
                className: prefix !== '' ? 'pl-8' : undefined,
                inputMode: "decimal"
            })
        ]
    });
};
var $cf5f3d9d49aeb89e$export$2e2bcd8739ae039 = $cf5f3d9d49aeb89e$var$AmountInput;



const $84d63295abf08a9c$export$ecdd2de4d18981af = (props)=>{
    const formId = $acw62.useId();
    const [recordAnchor, { loading: loading }] = (0, $ce9d9e524be20f53$export$3a0b388d2d812ec5)();
    const [date, setDate] = $acw62.useState(props.initialDate ?? $0c0f91b069db95d9$export$d0bdf45af03a6ea3());
    // Default to a concrete zero rather than `none` so the field, which already
    // displays "0.00" on open, can be submitted as a zero balance without the
    // user having to type a digit to register a value.
    const [balance, setBalance] = $acw62.useState((0, $f8f45ddea4959097$exports.some)(props.initialBalance ?? (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).zero(props.currency ?? 'USD')));
    const [note, setNote] = $acw62.useState('');
    const [error, setError] = $acw62.useState(null);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        if (balance.isEmpty) {
            setError('Please enter a balance amount');
            return;
        }
        // The user enters the display value ("amount owed" for credit cards, with
        // a negative entry meaning an overpayment/statement credit); convert to
        // the stored sign convention.
        const storedBalance = (0, $1d7c692b9128a045$export$d717750c75a5d699)(balance.get().toInt().amount, props.isCreditCard ?? false);
        try {
            const result = await recordAnchor({
                variables: {
                    accountId: props.accountId,
                    date: date.toISODate() ?? '',
                    balance: storedBalance,
                    source: 'manual',
                    note: note.trim() || undefined
                }
            });
            const saved = result.data?.recordBalanceAnchor;
            if (saved) props.onSuccess?.(saved._id);
            props.onRequestClose();
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to record balance');
        }
    };
    const isValid = balance.nonEmpty;
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                disabled: loading,
                onClick: props.onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                disabled: loading || !isValid,
                type: "submit",
                form: formId,
                children: "Save"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: props.onRequestClose,
        header: "Record balance",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: (e)=>void handleSubmit(e),
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Date",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                        selectedDate: date,
                        onChange: setDate
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: props.isCreditCard ? 'Amount owed' : 'Balance',
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                        value: balance,
                        onChange: setBalance,
                        autoFocus: true,
                        currency: props.currency
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Note (optional)",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        value: note,
                        onChange: (e)=>setNote(e.target.value),
                        placeholder: "e.g. Statement closing balance",
                        className: "border-border bg-background text-foreground focus:ring-ring w-full rounded-md border px-3 py-2 text-sm focus:ring-1 focus:outline-none"
                    })
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-sm",
                    children: error
                })
            ]
        })
    });
};





/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $97332defb5de8faa$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 16-4 4-4-4",
            key: "f6ql7i"
        }
    ],
    [
        "path",
        {
            d: "M17 20V4",
            key: "1ejh1v"
        }
    ],
    [
        "path",
        {
            d: "m3 8 4-4 4 4",
            key: "11wl7u"
        }
    ],
    [
        "path",
        {
            d: "M7 4v16",
            key: "1glfcx"
        }
    ]
];
const $97332defb5de8faa$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-up-down", $97332defb5de8faa$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b0408904748dc3b8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
            key: "sc7q7i"
        }
    ]
];
const $b0408904748dc3b8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("funnel", $b0408904748dc3b8$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");


const $133c17dbc4a8c137$export$22a21a30456603eb = (props)=>{
    const { amount: amount, variant: variant = 'signed', align: align = 'right', inline: inline = false } = props;
    const approx = props.approx ?? null;
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const formatted = formatMoney(amount);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(align === 'right' ? 'text-right' : 'text-left', inline ? 'inline-block' : 'block'),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('tabular-nums', variant !== 'plain' && amount.isPositive && 'text-positive', variant === 'delta' && amount.isNegative && 'text-destructive'),
                children: formatted
            }),
            approx !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground text-xs tabular-nums",
                children: [
                    "= ",
                    formatMoney(approx)
                ]
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8240f8fcfc513968$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $8240f8fcfc513968$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("check", $8240f8fcfc513968$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");



const $43dfa5bdd4fb4a02$export$20dc64867e1691d0 = ({ selected: selected, onClick: onClick, label: label, count: count, icon: icon, iconSlot: iconSlot, header: header })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        role: "menuitem",
        onClick: onClick,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('hover:bg-accent/50 flex w-full cursor-pointer items-center gap-2 px-3 py-1.5 text-sm', header && 'text-muted-foreground pt-2 pb-1 text-xs font-semibold tracking-wider uppercase'),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-3.5 shrink-0', !selected && 'invisible')
            }),
            iconSlot && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "flex size-4 shrink-0 items-center justify-center",
                children: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "flex-1 text-left whitespace-nowrap",
                children: label
            }),
            count != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground pl-4 text-xs tabular-nums",
                children: count
            })
        ]
    });
const $43dfa5bdd4fb4a02$export$720e1e4f1cefa216 = /*#__PURE__*/ $acw62.createContext('pill');
const $43dfa5bdd4fb4a02$export$af8a1e35241194a0 = ({ anchorRef: anchorRef, onClick: onClick, label: label, value: value, pillText: pillText, active: active, truncateLabel: truncateLabel })=>{
    const style = $acw62.useContext($43dfa5bdd4fb4a02$export$720e1e4f1cefa216);
    if (style === 'row') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        ref: anchorRef,
        type: "button",
        onClick: onClick,
        className: "border-border flex w-full items-center gap-3 border-b py-3 text-left text-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "shrink-0",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('min-w-0 flex-1 truncate text-right', active ? 'text-foreground font-medium' : 'text-muted-foreground'),
                children: active ? value ?? pillText : 'Any'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                className: "text-muted-foreground size-4 shrink-0"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        ref: anchorRef,
        type: "button",
        onClick: onClick,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(// shrink-0 + nowrap so a row of pills keeps its natural widths in a
        // horizontally-scrolling filter bar instead of squeezing.
        'flex items-center gap-1 rounded-full px-3 py-1 text-sm whitespace-nowrap transition-colors', truncateLabel ? 'min-w-0' : 'shrink-0', active ? 'bg-accent text-foreground font-medium' : 'text-muted-foreground hover:text-foreground'),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(truncateLabel && 'truncate'),
                children: pillText ?? (value != null ? `${label}: ${value}` : label)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                className: "size-3.5 shrink-0"
            })
        ]
    });
};
const $43dfa5bdd4fb4a02$export$2ce9a4ab4bfc4b72 = ({ children: children, footer: footer })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('shadow-popover bg-popover text-popover-foreground outline-ring/50', 'flex max-h-[min(70vh,28rem)] max-w-[calc(100vw-1rem)] min-w-44 flex-col rounded-md outline-1'),
        children: [
            children,
            footer != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-border shrink-0 border-t px-3 py-2",
                children: footer
            })
        ]
    });
const $43dfa5bdd4fb4a02$export$d21937a90300cd7a = (props)=>{
    const { label: label, allLabel: allLabel, allCount: allCount, options: options, footer: footer, onOpenChange: onOpenChange, truncateLabel: truncateLabel, searchable: searchable } = props;
    const [open, setOpen] = $acw62.useState(false);
    const [query, setQuery] = $acw62.useState('');
    const changeOpen = (next)=>{
        setOpen(next);
        onOpenChange?.(next);
        if (!next) // A stale query would silently pre-filter the next visit's menu.
        setQuery('');
    };
    const selectedKeys = props.multiple ? props.value : [
        props.value
    ];
    const isSelected = (key)=>selectedKeys.includes(key);
    const anySelected = props.multiple ? props.value.length > 0 : props.value !== 'all';
    const clearAll = ()=>{
        if (props.multiple) props.onChange([]);
        else props.onChange('all');
        changeOpen(false);
    };
    const selectOption = (key)=>{
        if (props.multiple) // Toggle without closing, so several types can be picked in one visit
        props.onChange(isSelected(key) ? props.value.filter((k)=>k !== key) : [
            ...props.value,
            key
        ]);
        else {
            props.onChange(key);
            if (!options.find((option)=>option.key === key)?.keepOpen) changeOpen(false);
        }
    };
    // Rendering works from the query-narrowed list; everything about the
    // selection (labels, group toggles, icon alignment) still reads the full
    // one, so an active filter never changes what a selection means.
    const trimmedQuery = query.trim().toLowerCase();
    const visibleOptions = trimmedQuery ? options.filter((option)=>option.label.toLowerCase().includes(trimmedQuery)) : options;
    const identityOf = (option)=>option.group == null ? null : option.groupKey ?? option.group;
    const ungrouped = visibleOptions.filter((option)=>option.group == null);
    const groupOrder = [];
    const groupLabels = new Map();
    for (const option of visibleOptions){
        const identity = identityOf(option);
        if (identity != null && !groupOrder.includes(identity)) {
            groupOrder.push(identity);
            groupLabels.set(identity, option.group ?? identity);
        }
    }
    const groupKeys = (group)=>options.filter((option)=>identityOf(option) === group).map((o)=>o.key);
    const isGroupSelected = (group)=>{
        const keys = groupKeys(group);
        return keys.length > 0 && keys.every(isSelected);
    };
    const toggleGroup = (group)=>{
        if (!props.multiple) return;
        const keys = groupKeys(group);
        // Fully selected group toggles off; otherwise select the whole group
        // (keeping any selections from other groups)
        props.onChange(isGroupSelected(group) ? props.value.filter((k)=>!keys.includes(k)) : [
            ...props.value,
            ...keys.filter((k)=>!isSelected(k))
        ]);
    };
    const triggerSelectionLabel = ()=>{
        if (!anySelected) return null;
        if (!props.multiple) return options.find((option)=>option.key === props.value)?.label ?? null;
        // A selection covering exactly one whole group reads as the group name
        const wholeGroup = groupOrder.find((group)=>isGroupSelected(group) && props.value.length === groupKeys(group).length);
        if (wholeGroup != null) return groupLabels.get(wholeGroup) ?? wholeGroup;
        const first = options.find((option)=>isSelected(option.key));
        if (!first) return null;
        const extra = props.value.length - 1;
        return extra > 0 ? `${first.label} +${extra}` : first.label;
    };
    const anyIcons = options.some((option)=>option.icon != null);
    const renderOption = (option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($43dfa5bdd4fb4a02$export$20dc64867e1691d0, {
            selected: isSelected(option.key),
            onClick: ()=>selectOption(option.key),
            label: option.label,
            count: option.count,
            icon: option.icon,
            iconSlot: anyIcons
        }, option.key);
    const menu = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($43dfa5bdd4fb4a02$export$2ce9a4ab4bfc4b72, {
        footer: footer,
        children: [
            searchable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-border shrink-0 border-b p-2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                    autoFocus: true,
                    placeholder: "Search",
                    value: query,
                    onChange: setQuery,
                    className: "h-8 text-sm"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-h-0 flex-col overflow-y-auto py-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($43dfa5bdd4fb4a02$export$20dc64867e1691d0, {
                        selected: !anySelected,
                        onClick: clearAll,
                        label: allLabel,
                        count: allCount,
                        iconSlot: anyIcons
                    }),
                    trimmedQuery && visibleOptions.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground px-3 py-1.5 text-sm",
                        children: "No matches"
                    }),
                    groupOrder.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                            children: [
                                props.multiple ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($43dfa5bdd4fb4a02$export$20dc64867e1691d0, {
                                    header: true,
                                    selected: isGroupSelected(group),
                                    onClick: ()=>toggleGroup(group),
                                    label: groupLabels.get(group) ?? group,
                                    iconSlot: anyIcons
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-muted-foreground px-3 pt-2 pb-1 text-xs font-semibold tracking-wider uppercase",
                                    children: groupLabels.get(group) ?? group
                                }),
                                visibleOptions.filter((option)=>identityOf(option) === group).map(renderOption)
                            ]
                        }, group)),
                    ungrouped.map(renderOption)
                ]
            })
        ]
    });
    const selectionLabel = triggerSelectionLabel();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $497d44d806a05c0a$export$2e2bcd8739ae039), {
        open: open,
        popoverContents: menu,
        popoverAnchor: "bottom-left",
        onOutsideClick: ()=>changeOpen(false),
        children: (anchorRef)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($43dfa5bdd4fb4a02$export$af8a1e35241194a0, {
                anchorRef: anchorRef,
                onClick: ()=>changeOpen(!open),
                label: label,
                value: props.triggerLabel != null ? anySelected ? props.triggerLabel : null : selectionLabel,
                pillText: props.triggerLabel,
                active: anySelected,
                truncateLabel: truncateLabel
            })
    });
};


const $f21c7fd562fd4701$export$d3e643d9d6f4fa7f = (props)=>{
    const { data: data } = (0, $ce9d9e524be20f53$export$1f9e2535d0d42ab9)();
    const { data: groupsData } = (0, $ce9d9e524be20f53$export$9dda77d697c51272)();
    const allCategories = $acw62.useMemo(()=>data?.allCategories ?? [], [
        data
    ]);
    const groups = $acw62.useMemo(()=>groupsData?.allCategoryGroups ?? [], [
        groupsData
    ]);
    // Grouped browse order, same shape as CategoryPicker's: member ids that
    // don't resolve are dropped, and a category is in at most one group.
    const options = $acw62.useMemo(()=>{
        const byId = new Map(allCategories.map((category)=>[
                category._id,
                category
            ]));
        const grouped = new Set(groups.flatMap((group)=>group.categoryIds));
        return [
            ...groups.flatMap((group)=>group.categoryIds.flatMap((id)=>{
                    const category = byId.get(id);
                    return category ? [
                        {
                            key: category._id,
                            label: category.name,
                            group: group.name,
                            groupKey: group._id
                        }
                    ] : [];
                })),
            ...allCategories.filter((category)=>!grouped.has(category._id)).map((category)=>({
                    key: category._id,
                    label: category.name
                }))
        ];
    }, [
        allCategories,
        groups
    ]);
    // Drop ids that no longer exist (e.g. a deleted category persisted in
    // localStorage) — the previous implementation derived its selection the
    // same way.
    const knownIds = $acw62.useMemo(()=>new Set(allCategories.map((category)=>category._id)), [
        allCategories
    ]);
    const value = (props.categories ?? []).filter((id)=>knownIds.has(id));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
        multiple: true,
        searchable: true,
        label: "Categories",
        allLabel: "All categories",
        options: options,
        value: value,
        onChange: (ids)=>props.setCategories(ids.length > 0 ? ids : null)
    });
};





var $acw62 = parcelRequire("acw62");



// How many years the menu lists by default (current year plus the
// twenty-four before it) when no earlier bound is supplied. The year column
// scrolls, so a long list costs no header height — and imported statement
// history goes back far further than a single decade.
const $4fb4243874d8f910$var$DEFAULT_YEAR_SPAN = 25;
// Fixed English month labels rather than luxon's locale-dependent formatting,
// so the menu (and screenshot baselines) render the same everywhere.
const $4fb4243874d8f910$var$MONTH_LABELS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// The calendar-year range for a given year, as ISO date strings. fromObject
// always yields a valid date here, so toISODate never returns null; the ??
// fallbacks only satisfy the type.
const $4fb4243874d8f910$var$yearRange = (year)=>({
        startDate: (0, $0c0f91b069db95d9$export$9144c32b59cbaec4)({
            year: year,
            month: 1,
            day: 1
        }).toISODate() ?? null,
        endDate: (0, $0c0f91b069db95d9$export$9144c32b59cbaec4)({
            year: year,
            month: 12,
            day: 31
        }).toISODate() ?? null
    });
// The calendar-month range for a given year and month, as ISO date strings.
// Same toISODate caveat as yearRange.
const $4fb4243874d8f910$var$monthRange = (year, month)=>{
    const start = (0, $0c0f91b069db95d9$export$9144c32b59cbaec4)({
        year: year,
        month: month,
        day: 1
    });
    return {
        startDate: start.toISODate() ?? null,
        endDate: start.endOf('month').toISODate() ?? null
    };
};
// The year whose exact calendar range equals this value, or null. Both bounds
// must be present and match Jan 1 / Dec 31 of the same year — a frontier-
// truncated or half-open range reads as a custom range instead.
const $4fb4243874d8f910$var$matchedYear = (value)=>{
    if (!value.startDate || !value.endDate) return null;
    const year = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(value.startDate).year;
    const range = $4fb4243874d8f910$var$yearRange(year);
    return range.startDate === value.startDate && range.endDate === value.endDate ? year : null;
};
// The month whose exact calendar range equals this value, or null — the
// month-granularity sibling of matchedYear. The two are disjoint by
// construction: no whole-year range is also a whole-month range.
const $4fb4243874d8f910$var$matchedMonth = (value)=>{
    if (!value.startDate || !value.endDate) return null;
    const start = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(value.startDate);
    const range = $4fb4243874d8f910$var$monthRange(start.year, start.month);
    return range.startDate === value.startDate && range.endDate === value.endDate ? {
        year: start.year,
        month: start.month
    } : null;
};
const $4fb4243874d8f910$var$isEmpty = (value)=>!value.startDate && !value.endDate;
const $4fb4243874d8f910$export$bfb275743ab18881 = ({ value: value, onChange: onChange, minYear: minYear, truncateLabel: truncateLabel = false, emptyMeaning: emptyMeaning = 'filter-off' })=>{
    const now = (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)();
    const currentYear = now.year;
    const currentMonth = now.month;
    const earliestYear = minYear ?? currentYear - ($4fb4243874d8f910$var$DEFAULT_YEAR_SPAN - 1);
    const years = [];
    for(let year = currentYear; year >= earliestYear; year--)years.push(year);
    const activeYear = $4fb4243874d8f910$var$matchedYear(value);
    const activeMonth = $4fb4243874d8f910$var$matchedMonth(value);
    // A non-empty value that isn't a whole calendar year or month is a custom
    // range.
    const isCustomValue = !$4fb4243874d8f910$var$isEmpty(value) && activeYear === null && activeMonth === null;
    // Custom mode is derived rather than stored, so it can never contradict the
    // controlled value: the inputs are what a custom range looks like, and a menu
    // the user opened and asked for them in is the only other reason to show
    // them. Storing it would go stale the moment the value is cleared from
    // outside — the Transactions header's Reset filters, say — leaving the pill
    // reading "Custom range…" over an unfiltered list, with the inputs hidden
    // inside the closed menu and no way to see why.
    const [menuOpen, setMenuOpen] = $acw62.useState(false);
    const [customRequested, setCustomRequested] = $acw62.useState(false);
    const showCustom = isCustomValue || menuOpen && customRequested;
    // Which year's months the grid shows. Reset from the value on every open,
    // so the transient focus can't outlive the selection it followed.
    const [focusYear, setFocusYear] = $acw62.useState(currentYear);
    const changeOpen = (open)=>{
        if (open) setFocusYear(activeMonth?.year ?? activeYear ?? currentYear);
        else setCustomRequested(false);
        setMenuOpen(open);
    };
    // The footer sits after every year in DOM order, so a keyboard user who
    // picks "Custom range…" would otherwise tab through two decades of options
    // to reach the controls they just asked for. Move focus there instead —
    // only on the transition, so re-opening a menu that is already in custom
    // mode still lands on the option list.
    const startInputRef = $acw62.useRef(null);
    const focusStartInput = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (focusStartInput.current && showCustom) {
            focusStartInput.current = false;
            startInputRef.current?.focus();
        }
    }, [
        showCustom,
        customRequested
    ]);
    const selectAllTime = ()=>{
        onChange({
            startDate: null,
            endDate: null
        });
        changeOpen(false);
    };
    const selectCustom = ()=>{
        // Reveal the inputs without clearing, so a range already picked becomes
        // the starting point the user edits.
        focusStartInput.current = true;
        setCustomRequested(true);
    };
    const selectYear = (year)=>{
        // Clicking the year whose whole-year filter is already applied reads as
        // confirmation: keep it and close, saving the dismissal click.
        if (activeYear === year && !showCustom) {
            changeOpen(false);
            return;
        }
        setCustomRequested(false);
        setFocusYear(year);
        onChange($4fb4243874d8f910$var$yearRange(year));
    };
    const selectWholeYear = ()=>{
        onChange($4fb4243874d8f910$var$yearRange(focusYear));
        changeOpen(false);
    };
    const selectMonth = (month)=>{
        onChange($4fb4243874d8f910$var$monthRange(focusYear, month));
        changeOpen(false);
    };
    const handleStartChange = (e)=>{
        onChange({
            ...value,
            startDate: e.target.value || null
        });
    };
    const handleEndChange = (e)=>{
        onChange({
            ...value,
            endDate: e.target.value || null
        });
    };
    // The checked year while a month is active is the month's year: the value
    // lives inside it, and the grid beside it shows which slice.
    const checkedYear = activeMonth?.year ?? activeYear;
    const yearColumn = [];
    let lastDecade = null;
    for (const year of years){
        const decade = Math.floor(year / 10) * 10;
        if (decade !== lastDecade) {
            lastDecade = decade;
            yearColumn.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground px-3 pt-2 pb-1 text-xs font-semibold tracking-wider uppercase",
                children: [
                    decade,
                    "s"
                ]
            }, `decade-${decade}`));
        }
        yearColumn.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$20dc64867e1691d0), {
            selected: !showCustom && checkedYear === year,
            onClick: ()=>selectYear(year),
            label: String(year)
        }, year));
    }
    const menu = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$2ce9a4ab4bfc4b72), {
        footer: showCustom ? // Wraps rather than squeezes: two native date controls want ~325px
        // together, more than a 320px phone leaves once the menu is capped
        // to the viewport, and squeezing them clips the picker indicator.
        // Below that width the end date drops to its own line instead.
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-wrap items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    ref: startInputRef,
                    type: "date",
                    value: value.startDate ?? '',
                    onChange: handleStartChange,
                    className: "border-border bg-background text-foreground min-w-32 flex-1 rounded border px-2 py-1 text-sm"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground text-sm",
                    children: "to"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "date",
                    value: value.endDate ?? '',
                    onChange: handleEndChange,
                    className: "border-border bg-background text-foreground min-w-32 flex-1 rounded border px-2 py-1 text-sm"
                })
            ]
        }) : undefined,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex min-h-0",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "border-border flex w-40 shrink-0 flex-col overflow-y-auto border-r py-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$20dc64867e1691d0), {
                            selected: $4fb4243874d8f910$var$isEmpty(value) && !showCustom && emptyMeaning !== 'unset',
                            onClick: selectAllTime,
                            label: "All time"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$20dc64867e1691d0), {
                            selected: showCustom,
                            onClick: selectCustom,
                            label: "Custom range\u2026"
                        }),
                        yearColumn
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex min-w-0 flex-1 flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between gap-3 px-3 pt-2 pb-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-sm font-semibold tabular-nums",
                                    children: focusYear
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    role: "menuitem",
                                    onClick: selectWholeYear,
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('cursor-pointer rounded px-1.5 py-0.5 text-xs whitespace-nowrap', !showCustom && activeYear === focusYear ? 'bg-accent text-foreground font-medium' : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground'),
                                    children: "Whole year"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex min-h-0 flex-1 flex-col overflow-y-auto px-1 pb-1",
                            children: $4fb4243874d8f910$var$MONTH_LABELS.map((_, index)=>{
                                const month = $4fb4243874d8f910$var$MONTH_LABELS.length - index;
                                const label = $4fb4243874d8f910$var$MONTH_LABELS[month - 1];
                                const disabled = focusYear === currentYear && month > currentMonth;
                                const selected = !showCustom && activeMonth != null && activeMonth.year === focusYear && activeMonth.month === month;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    role: "menuitem",
                                    disabled: disabled,
                                    onClick: ()=>selectMonth(month),
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex cursor-pointer items-center gap-1.5 rounded px-2 py-1 text-sm', selected ? 'bg-accent font-medium' : 'hover:bg-accent/50', 'disabled:text-muted-foreground/50 disabled:cursor-default disabled:hover:bg-transparent'),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "w-5 shrink-0 text-right tabular-nums",
                                            children: month
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "opacity-60",
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: label
                                        })
                                    ]
                                }, month);
                            })
                        })
                    ]
                })
            ]
        })
    });
    const selectionLabel = showCustom ? "Custom range\u2026" : activeMonth ? `${$4fb4243874d8f910$var$MONTH_LABELS[activeMonth.month - 1]} ${activeMonth.year}` : activeYear !== null ? String(activeYear) : emptyMeaning === 'all-time' && $4fb4243874d8f910$var$isEmpty(value) ? 'All time' : null;
    // Self-contained flex wrapper so the component lays out the same whether a
    // consumer drops it into a flex filter row (the account Transactions tab) or
    // a plain block header slot (the review page), where a bare block-level
    // button would otherwise stretch to full width.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex items-center', truncateLabel ? 'min-w-0' : 'shrink-0'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $497d44d806a05c0a$export$2e2bcd8739ae039), {
            open: menuOpen,
            popoverContents: menu,
            popoverAnchor: "bottom-left",
            onOutsideClick: ()=>changeOpen(false),
            children: (anchorRef)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$af8a1e35241194a0), {
                    anchorRef: anchorRef,
                    onClick: ()=>changeOpen(!menuOpen),
                    label: "Dates",
                    value: selectionLabel,
                    active: selectionLabel != null,
                    truncateLabel: truncateLabel
                })
        })
    });
};





var $acw62 = parcelRequire("acw62");




const $6af385b0df2ffa07$export$42a852a2b6b56249 = ({ children: children, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `bg-background border-border rounded-md border ${className ?? ''}`,
        children: children
    });
const $6af385b0df2ffa07$export$8b251419efc915eb = ({ children: children, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `border-border border-b p-2 ${className ?? ''}`,
        children: children
    });
const $6af385b0df2ffa07$export$4b2c32e08f77ff18 = ({ children: children, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `h-[25vh] overflow-auto p-2 ${className ?? ''}`,
        children: children
    });
const $6af385b0df2ffa07$export$a06f1c675e846f6f = ({ children: children, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `border-border border-t p-2 ${className ?? ''}`,
        children: children
    });


/**
 * Ordering helpers for tag search results.
 *
 * Tags have no creation timestamp, but many follow a "<year> <name>" pattern
 * (e.g. "2024 Vegas trip"). When fuzzy-search scores tie, prefer the tag with
 * the most recent year so typing "Vegas" suggests the newest trip first.
 */ const $c43a9ca50fd39c89$var$YEAR_PATTERN = /\b(?:19|20)\d{2}\b/;
const $c43a9ca50fd39c89$export$e273c79116d5b1cf = (name)=>{
    const match = $c43a9ca50fd39c89$var$YEAR_PATTERN.exec(name);
    return match ? Number(match[0]) : null;
};
const $c43a9ca50fd39c89$export$f511e8a5e30af90 = (a, b)=>{
    const yearA = $c43a9ca50fd39c89$export$e273c79116d5b1cf(a.name);
    const yearB = $c43a9ca50fd39c89$export$e273c79116d5b1cf(b.name);
    if (yearA !== null && yearB !== null && yearA !== yearB) return yearB - yearA;
    return a.name.localeCompare(b.name);
};


/**
 * Fuse.js v5.2.3 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2020 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ const $33893b708b33402d$var$INFINITY = 1 / 0;
const $33893b708b33402d$var$isArray = (value)=>!Array.isArray ? Object.prototype.toString.call(value) === '[object Array]' : Array.isArray(value);
// Adapted from:
// https://github.com/lodash/lodash/blob/f4ca396a796435422bd4fd41fadbd225edddf175/.internal/baseToString.js
const $33893b708b33402d$var$baseToString = (value)=>{
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$33893b708b33402d$var$INFINITY ? '-0' : result;
};
const $33893b708b33402d$var$toString = (value)=>value == null ? '' : $33893b708b33402d$var$baseToString(value);
const $33893b708b33402d$var$isString = (value)=>typeof value === 'string';
const $33893b708b33402d$var$isNumber = (value)=>typeof value === 'number';
const $33893b708b33402d$var$isDefined = (value)=>value !== undefined && value !== null;
const $33893b708b33402d$var$isBlank = (value)=>!value.trim().length;
function $33893b708b33402d$var$get(obj, path) {
    let list = [];
    let arr = false;
    const _get = (obj, path)=>{
        if (!path) // If there's no path left, we've gotten to the object we care about.
        list.push(obj);
        else {
            const dotIndex = path.indexOf('.');
            let key = path;
            let remaining = null;
            if (dotIndex !== -1) {
                key = path.slice(0, dotIndex);
                remaining = path.slice(dotIndex + 1);
            }
            const value = obj[key];
            if ($33893b708b33402d$var$isDefined(value)) {
                if (!remaining && ($33893b708b33402d$var$isString(value) || $33893b708b33402d$var$isNumber(value))) list.push($33893b708b33402d$var$toString(value));
                else if ($33893b708b33402d$var$isArray(value)) {
                    arr = true;
                    // Search each item in the array.
                    for(let i = 0, len = value.length; i < len; i += 1)_get(value[i], remaining);
                } else if (remaining) // An object. Recurse further.
                _get(value, remaining);
            }
        }
    };
    _get(obj, path);
    if (arr) return list;
    return list[0];
}
const $33893b708b33402d$var$MatchOptions = {
    // Whether the matches should be included in the result set. When true, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When true, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $33893b708b33402d$var$BasicOptions = {
    // When true, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $33893b708b33402d$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $33893b708b33402d$var$AdvancedOptions = {
    // When true, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $33893b708b33402d$var$get
};
var $33893b708b33402d$var$Config = {
    ...$33893b708b33402d$var$BasicOptions,
    ...$33893b708b33402d$var$MatchOptions,
    ...$33893b708b33402d$var$FuzzyOptions,
    ...$33893b708b33402d$var$AdvancedOptions
};
function $33893b708b33402d$var$computeScore(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $33893b708b33402d$var$Config.distance } = {}) {
    const accuracy = errors / pattern.length;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $33893b708b33402d$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength) {
    let matchedIndices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) matchedIndices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) matchedIndices.push([
        start,
        i - 1
    ]);
    return matchedIndices;
}
// Machine word size
const $33893b708b33402d$var$MAX_BITS = 32;
function $33893b708b33402d$var$search(text, pattern, patternAlphabet, { location: location = $33893b708b33402d$var$Config.location, distance: distance = $33893b708b33402d$var$Config.distance, threshold: threshold = $33893b708b33402d$var$Config.threshold, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches } = {}) {
    if (pattern.length > $33893b708b33402d$var$MAX_BITS) throw new Error(`Pattern length exceeds max of ${$33893b708b33402d$var$MAX_BITS}.`);
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // A mask of the matches, used for building the indices
    const matchMask = [];
    if (includeMatches) for(let i = 0; i < textLen; i += 1)matchMask[i] = 0;
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $33893b708b33402d$var$computeScore(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (includeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << (patternLen <= $33893b708b33402d$var$MAX_BITS - 1 ? patternLen - 1 : $33893b708b33402d$var$MAX_BITS - 2);
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $33893b708b33402d$var$computeScore(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (charMatch && includeMatches) matchMask[currentLocation] = 1;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i !== 0) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $33893b708b33402d$var$computeScore(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $33893b708b33402d$var$computeScore(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    let result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: !finalScore ? 0.001 : finalScore
    };
    if (includeMatches) result.matchedIndices = $33893b708b33402d$var$convertMaskToIndices(matchMask, minMatchCharLength);
    return result;
}
function $33893b708b33402d$var$createPatternAlphabet(pattern) {
    let mask = {};
    let len = pattern.length;
    for(let i = 0; i < len; i += 1)mask[pattern.charAt(i)] = 0;
    for(let i = 0; i < len; i += 1)mask[pattern.charAt(i)] |= 1 << len - i - 1;
    return mask;
}
class $33893b708b33402d$var$BitapSearch {
    constructor(pattern, { location: location = $33893b708b33402d$var$Config.location, threshold: threshold = $33893b708b33402d$var$Config.threshold, distance: distance = $33893b708b33402d$var$Config.distance, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $33893b708b33402d$var$Config.isCaseSensitive } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        let index = 0;
        while(index < this.pattern.length){
            let pattern = this.pattern.substring(index, index + $33893b708b33402d$var$MAX_BITS);
            this.chunks.push({
                pattern: pattern,
                alphabet: $33893b708b33402d$var$createPatternAlphabet(pattern)
            });
            index += $33893b708b33402d$var$MAX_BITS;
        }
    }
    searchIn(value) {
        let text = value.$;
        return this.searchInString(text);
    }
    searchInString(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.matchedIndices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength } = this.options;
        let allMatchedIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        for(let i = 0, len = this.chunks.length; i < len; i += 1){
            let { pattern: pattern, alphabet: alphabet } = this.chunks[i];
            let result = $33893b708b33402d$var$search(text, pattern, alphabet, {
                location: location + $33893b708b33402d$var$MAX_BITS * i,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches
            });
            const { isMatch: isMatch, score: score, matchedIndices: matchedIndices } = result;
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && matchedIndices) allMatchedIndices = [
                ...allMatchedIndices,
                ...matchedIndices
            ];
        }
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.matchedIndices = allMatchedIndices;
        return result;
    }
}
class $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $33893b708b33402d$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $33893b708b33402d$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $33893b708b33402d$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $33893b708b33402d$var$ExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const matchedIndices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            matchedIndices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!matchedIndices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 1 : 0,
            matchedIndices: matchedIndices
        };
    }
}
// Token: !fire
class $33893b708b33402d$var$InverseExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            matchedIndices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $33893b708b33402d$var$PrefixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            matchedIndices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $33893b708b33402d$var$InversePrefixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            matchedIndices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $33893b708b33402d$var$SuffixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            matchedIndices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $33893b708b33402d$var$InverseSuffixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            matchedIndices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $33893b708b33402d$var$FuzzyMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern, { location: location = $33893b708b33402d$var$Config.location, threshold: threshold = $33893b708b33402d$var$Config.threshold, distance: distance = $33893b708b33402d$var$Config.distance, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $33893b708b33402d$var$Config.isCaseSensitive } = {}){
        super(pattern);
        this._bitapSearch = new $33893b708b33402d$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchInString(text);
    }
}
// ❗Order is important. DO NOT CHANGE.
const $33893b708b33402d$var$searchers = [
    $33893b708b33402d$var$ExactMatch,
    $33893b708b33402d$var$PrefixExactMatch,
    $33893b708b33402d$var$InversePrefixExactMatch,
    $33893b708b33402d$var$InverseSuffixExactMatch,
    $33893b708b33402d$var$SuffixExactMatch,
    $33893b708b33402d$var$InverseExactMatch,
    $33893b708b33402d$var$FuzzyMatch
];
const $33893b708b33402d$var$searchersLen = $33893b708b33402d$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $33893b708b33402d$var$SPACE_RE = / +(?=([^\"]*\"[^\"]*\")*[^\"]*$)/;
const $33893b708b33402d$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $33893b708b33402d$var$parseQuery(pattern, options = {}) {
    return pattern.split($33893b708b33402d$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($33893b708b33402d$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $33893b708b33402d$var$searchersLen){
                const searcher = $33893b708b33402d$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $33893b708b33402d$var$searchersLen){
                const searcher = $33893b708b33402d$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $33893b708b33402d$var$MultiMatchSet = new Set([
    $33893b708b33402d$var$FuzzyMatch.type,
    $33893b708b33402d$var$ExactMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that match `jscript`             |
 * | `'python`   | exact-match                | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $33893b708b33402d$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $33893b708b33402d$var$Config.isCaseSensitive, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, location: location = $33893b708b33402d$var$Config.location, threshold: threshold = $33893b708b33402d$var$Config.threshold, distance: distance = $33893b708b33402d$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $33893b708b33402d$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(value) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        let text = value.$;
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let indices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            indices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, matchedIndices: matchedIndices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($33893b708b33402d$var$MultiMatchSet.has(type)) indices = [
                            ...indices,
                            ...matchedIndices
                        ];
                        else indices.push(matchedIndices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    indices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.matchedIndices = indices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $33893b708b33402d$var$SPACE = /[^ ]+/g;
function $33893b708b33402d$var$createIndex(keys, list, { getFn: getFn = $33893b708b33402d$var$Config.getFn } = {}) {
    let indexedList = [];
    // List is Array<String>
    if ($33893b708b33402d$var$isString(list[0])) // Iterate over every string in the list
    for(let i = 0, len = list.length; i < len; i += 1){
        const value = list[i];
        if ($33893b708b33402d$var$isDefined(value) && !$33893b708b33402d$var$isBlank(value)) {
            let record = {
                $: value,
                idx: i,
                t: value.match($33893b708b33402d$var$SPACE).length
            };
            indexedList.push(record);
        }
    }
    else {
        // List is Array<Object>
        const keysLen = keys.length;
        for(let i = 0, len = list.length; i < len; i += 1){
            let item = list[i];
            let record = {
                idx: i,
                $: {}
            };
            // Iterate over every key (i.e, path), and fetch the value at that key
            for(let j = 0; j < keysLen; j += 1){
                let key = keys[j];
                let value = getFn(item, key);
                if (!$33893b708b33402d$var$isDefined(value)) continue;
                if ($33893b708b33402d$var$isArray(value)) {
                    let subRecords = [];
                    const stack = [
                        {
                            arrayIndex: -1,
                            value: value
                        }
                    ];
                    while(stack.length){
                        const { arrayIndex: arrayIndex, value: value } = stack.pop();
                        if (!$33893b708b33402d$var$isDefined(value)) continue;
                        if ($33893b708b33402d$var$isString(value) && !$33893b708b33402d$var$isBlank(value)) {
                            let subRecord = {
                                $: value,
                                idx: arrayIndex,
                                t: value.match($33893b708b33402d$var$SPACE).length
                            };
                            subRecords.push(subRecord);
                        } else if ($33893b708b33402d$var$isArray(value)) for(let k = 0, arrLen = value.length; k < arrLen; k += 1)stack.push({
                            arrayIndex: k,
                            value: value[k]
                        });
                    }
                    record.$[key] = subRecords;
                } else if (!$33893b708b33402d$var$isBlank(value)) {
                    let subRecord = {
                        $: value,
                        t: value.match($33893b708b33402d$var$SPACE).length
                    };
                    record.$[key] = subRecord;
                }
            }
            indexedList.push(record);
        }
    }
    return indexedList;
}
class $33893b708b33402d$var$KeyStore {
    constructor(keys){
        this._keys = {};
        this._keyNames = [];
        this._length = keys.length;
        // Iterate over every key
        if (keys.length && $33893b708b33402d$var$isString(keys[0])) for(let i = 0; i < this._length; i += 1){
            const key = keys[i];
            this._keys[key] = {
                weight: 1
            };
            this._keyNames.push(key);
        }
        else {
            let totalWeight = 0;
            for(let i = 0; i < this._length; i += 1){
                const key = keys[i];
                if (!Object.prototype.hasOwnProperty.call(key, 'name')) throw new Error('Missing "name" property in key object');
                const keyName = key.name;
                this._keyNames.push(keyName);
                if (!Object.prototype.hasOwnProperty.call(key, 'weight')) throw new Error('Missing "weight" property in key object');
                const weight = key.weight;
                if (weight <= 0 || weight >= 1) throw new Error('"weight" property in key must be in the range of (0, 1)');
                this._keys[keyName] = {
                    weight: weight
                };
                totalWeight += weight;
            }
            // Normalize weights so that their sum is equal to 1
            for(let i = 0; i < this._length; i += 1){
                const keyName = this._keyNames[i];
                const keyWeight = this._keys[keyName].weight;
                this._keys[keyName].weight = keyWeight / totalWeight;
            }
        }
    }
    get(key, name) {
        return this._keys[key] ? this._keys[key][name] : -1;
    }
    keys() {
        return this._keyNames;
    }
    count() {
        return this._length;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $33893b708b33402d$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$33893b708b33402d$var$isDefined(matches)) return;
    for(let i = 0, len = matches.length; i < len; i += 1){
        let match = matches[i];
        if (!$33893b708b33402d$var$isDefined(match.indices) || match.indices.length === 0) continue;
        let obj = {
            indices: match.indices,
            value: match.value
        };
        if (match.key) obj.key = match.key;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    }
}
function $33893b708b33402d$var$transformScore(result, data) {
    data.score = result.score;
}
const $33893b708b33402d$var$registeredSearchers = [];
function $33893b708b33402d$var$register(...args) {
    $33893b708b33402d$var$registeredSearchers.push(...args);
}
class $33893b708b33402d$var$Fuse {
    constructor(list, options = {}, index = null){
        this.options = {
            ...$33893b708b33402d$var$Config,
            ...options
        };
        this._processKeys(this.options.keys);
        this.setCollection(list, index);
    }
    setCollection(list, index = null) {
        this.list = list;
        this.listIsStringArray = $33893b708b33402d$var$isString(list[0]);
        if (index) this.setIndex(index);
        else this.setIndex(this._createIndex());
    }
    setIndex(listIndex) {
        this._indexedList = listIndex;
    }
    _processKeys(keys) {
        this._keyStore = new $33893b708b33402d$var$KeyStore(keys);
    }
    _createIndex() {
        return $33893b708b33402d$var$createIndex(this._keyStore.keys(), this.list, {
            getFn: this.options.getFn
        });
    }
    search(pattern, opts = {
        limit: false
    }) {
        pattern = pattern.trim();
        if (!pattern.length) return [];
        const { shouldSort: shouldSort } = this.options;
        let searcher = null;
        for(let i = 0, len = $33893b708b33402d$var$registeredSearchers.length; i < len; i += 1){
            let searcherClass = $33893b708b33402d$var$registeredSearchers[i];
            if (searcherClass.condition(pattern, this.options)) {
                searcher = new searcherClass(pattern, this.options);
                break;
            }
        }
        if (!searcher) searcher = new $33893b708b33402d$var$BitapSearch(pattern, this.options);
        let results = this._searchUsing(searcher);
        this._computeScore(results);
        if (shouldSort) this._sort(results);
        if (opts.limit && $33893b708b33402d$var$isNumber(opts.limit)) results = results.slice(0, opts.limit);
        return this._format(results);
    }
    _searchUsing(searcher) {
        const list = this._indexedList;
        const results = [];
        const { includeMatches: includeMatches } = this.options;
        // List is Array<String>
        if (this.listIsStringArray) // Iterate over every string in the list
        for(let i = 0, len = list.length; i < len; i += 1){
            let value = list[i];
            let { $: text, idx: idx, t: t } = value;
            if (!$33893b708b33402d$var$isDefined(text)) continue;
            let searchResult = searcher.searchIn(value);
            const { isMatch: isMatch, score: score } = searchResult;
            if (!isMatch) continue;
            let match = {
                score: score,
                value: text,
                t: t
            };
            if (includeMatches) match.indices = searchResult.matchedIndices;
            results.push({
                item: text,
                idx: idx,
                matches: [
                    match
                ]
            });
        }
        else {
            // List is Array<Object>
            const keyNames = this._keyStore.keys();
            const keysLen = this._keyStore.count();
            for(let i = 0, len = list.length; i < len; i += 1){
                let { $: item, idx: idx } = list[i];
                if (!$33893b708b33402d$var$isDefined(item)) continue;
                let matches = [];
                // Iterate over every key (i.e, path), and fetch the value at that key
                for(let j = 0; j < keysLen; j += 1){
                    let key = keyNames[j];
                    let value = item[key];
                    if (!$33893b708b33402d$var$isDefined(value)) continue;
                    if ($33893b708b33402d$var$isArray(value)) for(let k = 0, len = value.length; k < len; k += 1){
                        let arrItem = value[k];
                        const { $: text, idx: idx, t: t } = arrItem;
                        if (!$33893b708b33402d$var$isDefined(text)) continue;
                        let searchResult = searcher.searchIn(arrItem);
                        const { isMatch: isMatch, score: score } = searchResult;
                        if (!isMatch) continue;
                        let match = {
                            score: score,
                            key: key,
                            value: text,
                            idx: idx,
                            t: t
                        };
                        if (includeMatches) match.indices = searchResult.matchedIndices;
                        matches.push(match);
                    }
                    else {
                        const { $: text, t: t } = value;
                        let searchResult = searcher.searchIn(value);
                        const { isMatch: isMatch, score: score } = searchResult;
                        if (!isMatch) continue;
                        let match = {
                            score: score,
                            key: key,
                            value: text,
                            t: t
                        };
                        if (includeMatches) match.indices = searchResult.matchedIndices;
                        matches.push(match);
                    }
                }
                if (matches.length) results.push({
                    idx: idx,
                    item: item,
                    matches: matches
                });
            }
        }
        return results;
    }
    // Practical scoring function
    _computeScore(results) {
        const resultsLen = results.length;
        for(let i = 0; i < resultsLen; i += 1){
            const result = results[i];
            const matches = result.matches;
            const numMatches = matches.length;
            let totalScore = 1;
            for(let j = 0; j < numMatches; j += 1){
                const match = matches[j];
                const { key: key, t: t } = match;
                const keyWeight = this._keyStore.get(key, 'weight');
                const weight = keyWeight > -1 ? keyWeight : 1;
                const score = match.score === 0 && keyWeight > -1 ? Number.EPSILON : match.score;
                // Field-length norm: the shorter the field, the higher the weight.
                const norm = 1 / Math.sqrt(t);
                totalScore *= Math.pow(score, weight * norm);
            }
            result.score = totalScore;
        }
    }
    _sort(results) {
        results.sort(this.options.sortFn);
    }
    _format(results) {
        const finalOutput = [];
        const { includeMatches: includeMatches, includeScore: includeScore } = this.options;
        let transformers = [];
        if (includeMatches) transformers.push($33893b708b33402d$var$transformMatches);
        if (includeScore) transformers.push($33893b708b33402d$var$transformScore);
        for(let i = 0, len = results.length; i < len; i += 1){
            const result = results[i];
            const { idx: idx } = result;
            const data = {
                item: this.list[idx],
                refIndex: idx
            };
            if (transformers.length) for(let j = 0, len = transformers.length; j < len; j += 1)transformers[j](result, data);
            finalOutput.push(data);
        }
        return finalOutput;
    }
}
$33893b708b33402d$var$register($33893b708b33402d$var$ExtendedSearch);
$33893b708b33402d$var$Fuse.version = '5.2.3';
$33893b708b33402d$var$Fuse.createIndex = $33893b708b33402d$var$createIndex;
$33893b708b33402d$var$Fuse.config = $33893b708b33402d$var$Config;
var $33893b708b33402d$export$2e2bcd8739ae039 = $33893b708b33402d$var$Fuse;



var $acw62 = parcelRequire("acw62");
const $eefd5dff10250d61$export$bd221a7c56b93941 = (allItems, searchKeys, options)=>{
    const tieBreak = options?.tieBreak;
    // Every call site writes its keys inline (`['name']`), so the array is a new
    // reference on every render. Joined to a string for the memo below, which
    // would otherwise never hit and would be no better than rebuilding.
    const keyId = searchKeys.join(' ');
    // Memoised rather than built inline. This was `useRef(makeFuse())`, which
    // evaluates its argument on every render and keeps only the first result, so
    // a page mounting one picker per row rebuilt an index per row per render and
    // discarded all of them. The payee logo settings page is exactly that: a
    // hundred LogoSelects over the same 200-odd logos, reindexed on every
    // keystroke in the page's search box. Indexing costs time proportional to
    // the list, and none of that work was ever used.
    const fuse = $acw62.useMemo(()=>new (0, $33893b708b33402d$export$2e2bcd8739ae039)(allItems, {
            keys: searchKeys,
            threshold: 0.4,
            includeScore: true
        }), // searchKeys is deliberately absent: it is a fresh array every render and
    // is compared by content through keyId instead.
    [
        allItems,
        keyId
    ]);
    return {
        search: (query, searchOptions)=>{
            if (!query) return allItems;
            const results = fuse.search(query, searchOptions);
            if (tieBreak) results.sort((a, b)=>(a.score ?? 0) - (b.score ?? 0) || tieBreak(a.item, b.item));
            return results.map((result)=>result.item);
        }
    };
};


const $210ce82bb39e8417$export$e38bc1a2c4737950 = (props)=>{
    const { tags: tags, setTags: setTags, fieldFilters: fieldFilters, setFieldFilters: setFieldFilters } = props;
    const { data: tagsData, loading: tagsLoading } = (0, $ce9d9e524be20f53$export$1f229484873dfcfd)();
    const { data: fieldsData, loading: fieldsLoading } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)();
    const [isOpen, setIsOpen] = $acw62.useState(false);
    const [query, setQuery] = $acw62.useState('');
    const allTags = tagsData?.allTags ?? [];
    const allFields = fieldsData?.allFields ?? [];
    const { search: searchTags } = (0, $eefd5dff10250d61$export$bd221a7c56b93941)(allTags, [
        'name'
    ], {
        tieBreak: (0, $c43a9ca50fd39c89$export$f511e8a5e30af90)
    });
    const { search: searchFields } = (0, $eefd5dff10250d61$export$bd221a7c56b93941)(allFields, [
        'name'
    ]);
    const filteredTags = searchTags(query);
    const filteredFields = searchFields(query);
    // Normalize: drop tag IDs that no longer exist in allTags (e.g. deleted tags
    // persisted in localStorage). This mirrors the old TagFilterInput behavior
    // where the selection was always derived via all.filter(t => tags.includes(t._id)).
    const knownTagIds = $acw62.useMemo(()=>new Set(allTags.map((t)=>t._id)), [
        allTags
    ]);
    const activeTags = $acw62.useMemo(()=>tags ? tags.filter((id)=>knownTagIds.has(id)) : null, [
        tags,
        knownTagIds
    ]);
    const activeCount = (activeTags?.length ?? 0) + (fieldFilters?.length ?? 0);
    const hasActive = activeCount > 0;
    const handleClose = ()=>{
        setIsOpen(false);
        setQuery('');
    };
    // Tag handlers
    const handleTagToggle = (tagId)=>{
        const current = activeTags ?? [];
        const next = current.includes(tagId) ? current.filter((id)=>id !== tagId) : [
            ...current,
            tagId
        ];
        setTags(next.length > 0 ? next : null);
    };
    // Field handlers (lifted from FieldFilterInput)
    const filterByFieldId = (fieldId)=>fieldFilters?.find((f)=>f.fieldId === fieldId);
    const setFilter = (fieldId, filter)=>{
        const others = (fieldFilters || []).filter((f)=>f.fieldId !== fieldId);
        if (!filter) setFieldFilters(others.length > 0 ? others : null);
        else setFieldFilters([
            ...others,
            filter
        ]);
    };
    const handleEnumChange = (fieldId, value)=>{
        if (value === '') setFilter(fieldId, null);
        else if (value === '__UNSET__') setFilter(fieldId, {
            fieldId: fieldId,
            match: (0, $ce9d9e524be20f53$export$9d6b5f78b73e2a8d).Unset
        });
        else setFilter(fieldId, {
            fieldId: fieldId,
            match: (0, $ce9d9e524be20f53$export$9d6b5f78b73e2a8d).Exact,
            value: value
        });
    };
    const handleTextChange = (fieldId, value)=>{
        if (value === '') setFilter(fieldId, null);
        else setFilter(fieldId, {
            fieldId: fieldId,
            match: (0, $ce9d9e524be20f53$export$9d6b5f78b73e2a8d).Contains,
            value: value
        });
    };
    const handleTextUnset = (fieldId, checked)=>{
        if (checked) setFilter(fieldId, {
            fieldId: fieldId,
            match: (0, $ce9d9e524be20f53$export$9d6b5f78b73e2a8d).Unset
        });
        else setFilter(fieldId, null);
    };
    const enumSelectedValue = (fieldId)=>{
        const filter = filterByFieldId(fieldId);
        if (!filter) return '';
        if (filter.match === (0, $ce9d9e524be20f53$export$9d6b5f78b73e2a8d).Unset) return '__UNSET__';
        return filter.value ?? '';
    };
    const textInputValue = (fieldId)=>{
        const filter = filterByFieldId(fieldId);
        if (!filter || filter.match === (0, $ce9d9e524be20f53$export$9d6b5f78b73e2a8d).Unset) return '';
        return filter.value ?? '';
    };
    const isTextUnset = (fieldId)=>{
        const filter = filterByFieldId(fieldId);
        return filter?.match === (0, $ce9d9e524be20f53$export$9d6b5f78b73e2a8d).Unset;
    };
    const handleClearAll = ()=>{
        setTags(null);
        setFieldFilters(null);
        setQuery('');
        setIsOpen(false);
    };
    if (tagsLoading && !tagsData && fieldsLoading && !fieldsData) return null;
    if (allTags.length === 0 && allFields.length === 0) return null;
    const popoverContents = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6af385b0df2ffa07$export$42a852a2b6b56249), {
        className: "min-w-[280px]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6af385b0df2ffa07$export$8b251419efc915eb), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                    autoFocus: true,
                    type: "text",
                    placeholder: "Search tags and fields...",
                    value: query,
                    onChange: setQuery
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6af385b0df2ffa07$export$4b2c32e08f77ff18), {
                children: [
                    allTags.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground mb-1 text-xs font-medium uppercase tracking-wide",
                                children: "Tags"
                            }),
                            filteredTags.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground py-1 text-xs",
                                children: "No tags match."
                            }) : filteredTags.map((tag)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "flex cursor-pointer items-center gap-2 py-0.5 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            className: "h-3.5 w-3.5",
                                            checked: activeTags?.includes(tag._id) ?? false,
                                            onChange: ()=>handleTagToggle(tag._id)
                                        }),
                                        tag.name
                                    ]
                                }, tag._id))
                        ]
                    }),
                    allTags.length > 0 && allFields.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "border-border my-2"
                    }),
                    allFields.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground mb-1 text-xs font-medium uppercase tracking-wide",
                                children: "Fields"
                            }),
                            filteredFields.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground py-1 text-xs",
                                children: "No fields match."
                            }) : filteredFields.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mb-2 flex flex-col gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "text-muted-foreground text-xs",
                                            children: field.name
                                        }),
                                        field.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col gap-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    className: "border-input bg-background rounded-md border px-2 py-1 text-sm",
                                                    placeholder: "Contains...",
                                                    value: textInputValue(field._id),
                                                    disabled: isTextUnset(field._id),
                                                    onChange: (e)=>handleTextChange(field._id, e.target.value)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "text-muted-foreground flex items-center gap-1.5 text-xs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "h-3 w-3",
                                                            checked: isTextUnset(field._id),
                                                            onChange: (e)=>handleTextUnset(field._id, e.target.checked)
                                                        }),
                                                        "Unset only"
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            className: "border-input bg-background rounded-md border px-2 py-1 text-sm",
                                            value: enumSelectedValue(field._id),
                                            onChange: (e)=>handleEnumChange(field._id, e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "",
                                                    children: "Any"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "__UNSET__",
                                                    children: "Unset"
                                                }),
                                                field.values.map((v)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: v.value,
                                                        children: v.value
                                                    }, v.value))
                                            ]
                                        })
                                    ]
                                }, field._id))
                        ]
                    })
                ]
            }),
            hasActive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6af385b0df2ffa07$export$a06f1c675e846f6f), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "text-muted-foreground hover:text-foreground w-full text-left text-xs",
                    onClick: handleClearAll,
                    children: "Clear all"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $497d44d806a05c0a$export$2e2bcd8739ae039), {
        open: isOpen,
        popoverContents: popoverContents,
        onOutsideClick: handleClose,
        children: (ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$af8a1e35241194a0), {
                anchorRef: ref,
                onClick: ()=>isOpen ? handleClose() : setIsOpen(true),
                label: "Dimensions",
                value: hasActive ? String(activeCount) : null,
                active: hasActive
            })
    });
};







/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ad14973a512851d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $9ad14973a512851d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("search", $9ad14973a512851d$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");


const $5d5b3d85c2079de0$export$55d7609a8f1eccd2 = (props)=>{
    const { initialQuery: initialQuery, onSearch: onSearch, inputProps: inputProps } = props;
    const [query, setQuery] = $acw62.useState(initialQuery || '');
    const inputRef = $acw62.useRef(null);
    // The box holds a draft, so `initialQuery` seeds it rather than controlling
    // it — but the applied query can also change from *outside* (Reset filters,
    // or a back navigation onto an earlier filter state), and a box still
    // showing the query that is no longer applied is a lie about what the list
    // below is showing. Re-seed on those, and only those: the ref records what
    // this box last submitted, so a prop merely echoing our own submission
    // leaves in-progress typing alone.
    const submittedRef = $acw62.useRef(initialQuery || '');
    $acw62.useEffect(()=>{
        const applied = initialQuery || '';
        if (applied !== submittedRef.current) {
            submittedRef.current = applied;
            setQuery(applied);
        }
    }, [
        initialQuery
    ]);
    // Submitting via a real <form> is the only signal reliably fired by mobile
    // soft keyboards (Android's "Go"/search action button in particular), which
    // do not always dispatch an Enter keydown. stopPropagation keeps the submit
    // from bubbling to an enclosing form (e.g. when this renders inside another
    // modal's form) and triggering its onSubmit.
    const handleSubmit = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        submittedRef.current = query;
        onSearch(query);
    };
    // Clearing both empties the box and drops the active search — a typed-but-
    // unsubmitted query and an applied one look the same in the input, and
    // resetting to an applied filter the user is trying to remove helps nobody.
    const handleClear = ()=>{
        setQuery('');
        submittedRef.current = '';
        onSearch('');
        inputRef.current?.focus();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "relative flex flex-row",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                className: "text-muted-foreground absolute top-1/2 left-2 size-4 -translate-y-1/2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                ...inputProps,
                ref: inputRef,
                enterKeyHint: "search",
                value: query,
                onChange: setQuery,
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('pl-8', query && 'pr-8')
            }),
            query && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: handleClear,
                "aria-label": "Clear search",
                className: "text-muted-foreground hover:text-foreground absolute top-1/2 right-1 -translate-y-1/2 cursor-pointer p-1.5",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "size-4"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                style: {
                    display: 'none'
                },
                type: "submit",
                children: "Search"
            })
        ]
    });
};






const $d906535d40bd11c1$export$e5f08023f111098c = {
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).CreditCardPayment]: 'Credit Card Payment',
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).AccountTransfer]: 'Account Transfer',
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Prepaid]: 'Prepaid Reload',
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Refund]: 'Refund',
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Reimbursement]: 'Reimbursement',
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion]: 'Currency Conversion'
};
// Conversion is deliberately not offered here: a conversion can only be
// created from a two-currency raw selection, where CreateTransactionModal
// locks the type to it. Single-currency transfers can never become one.
const $d906535d40bd11c1$var$TRANSFER_TYPE_OPTIONS = [
    (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).CreditCardPayment,
    (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).AccountTransfer,
    (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Prepaid,
    (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Refund,
    (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Reimbursement
];
const $d906535d40bd11c1$var$isTransferType = (value)=>{
    return Object.keys($d906535d40bd11c1$export$e5f08023f111098c).includes(value);
};
const $d906535d40bd11c1$export$2ee929a1dd0aa042 = (props)=>{
    const { className: className, value: value, onChange: onChange, placeholder: placeholder = "Select type\u2026" } = props;
    // A conversion's type is immutable (server-enforced); when one is shown,
    // it is the only option and the control is locked.
    const disabled = props.disabled || value === (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion;
    const options = value === (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion ? [
        (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion
    ] : $d906535d40bd11c1$var$TRANSFER_TYPE_OPTIONS;
    const handleChange = (e)=>{
        const newValue = e.target.value;
        if ($d906535d40bd11c1$var$isTransferType(newValue)) onChange(newValue);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('has-focus:border-ring border-input has-focus:ring-ring/50 relative flex flex-row items-center gap-1 rounded-md border px-2 py-1 shadow-xs has-focus:ring-[3px]', className),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(value === null && 'text-muted-foreground'),
                children: value === null ? placeholder : $d906535d40bd11c1$export$e5f08023f111098c[value]
            }),
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                className: "size-4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                className: "absolute inset-0 h-full w-full cursor-pointer opacity-0 disabled:cursor-default",
                value: value ?? '',
                onChange: handleChange,
                disabled: disabled,
                children: [
                    value === null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: "",
                        disabled: true,
                        children: placeholder
                    }),
                    options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: option,
                            children: $d906535d40bd11c1$export$e5f08023f111098c[option]
                        }, option))
                ]
            })
        ]
    });
};


const $09cf10b6a8e400ec$var$PAGE_SIZE = 20;
const $09cf10b6a8e400ec$var$netAmountFilterLabels = {
    [(0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).All]: 'All Transactions',
    [(0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).Spending]: 'Spending',
    [(0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).Income]: 'Income',
    [(0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).Balanced]: 'Transfers'
};
const $09cf10b6a8e400ec$var$isNetAmountFilter = (value)=>value === String((0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).All) || value === String((0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).Spending) || value === String((0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).Income) || value === String((0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).Balanced);
const $09cf10b6a8e400ec$var$parseNetAmountFilter = (value)=>$09cf10b6a8e400ec$var$isNetAmountFilter(value) ? value : (0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).All;
const $09cf10b6a8e400ec$var$transactionLabel = (tx)=>tx.payee ?? tx.transferType ?? tx.description ?? 'Untitled';
const $09cf10b6a8e400ec$var$detectTransition = (currentNetAmount, newNetAmount)=>{
    if (currentNetAmount !== 0 && newNetAmount === 0) return 'becoming_balanced';
    if (currentNetAmount === 0 && newNetAmount !== 0) return 'becoming_unbalanced';
    return null;
};
const $09cf10b6a8e400ec$export$a9f100633b1fddb4 = (props)=>{
    const { rawTransactions: rawTransactionsToAdd, onAttached: onAttached, onRequestClose: onRequestClose } = props;
    const rawTransactionsKey = rawTransactionsToAdd.map((rt)=>rt._id).join(',');
    const addedAmount = rawTransactionsToAdd.reduce((sum, rt)=>sum + rt.amount, 0);
    const addedCurrency = rawTransactionsToAdd[0]?.currency ?? 'USD';
    const [search, setSearch] = $acw62.useState('');
    const [selectedTransactionId, setSelectedTransactionId] = $acw62.useState(null);
    const [submitError, setSubmitError] = $acw62.useState(null);
    const [showFilters, setShowFilters] = $acw62.useState(false);
    // Filter state
    const [netAmountFilter, setNetAmountFilter] = $acw62.useState((0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).All);
    const [categories, setCategories] = $acw62.useState(null);
    const [tags, setTags] = $acw62.useState(null);
    const [dateFilter, setDateFilter] = $acw62.useState({
        startDate: null,
        endDate: null
    });
    const [fieldFilters, setFieldFilters] = $acw62.useState(null);
    // Pagination state
    const [cursorStack, setCursorStack] = $acw62.useState([]);
    const [pageIndex, setPageIndex] = $acw62.useState(0);
    // Transition fields
    const [confirmClearFields, setConfirmClearFields] = $acw62.useState(false);
    const [transitionPayee, setTransitionPayee] = $acw62.useState('');
    const [transitionCategory, setTransitionCategory] = $acw62.useState('');
    const [transitionDescription, setTransitionDescription] = $acw62.useState('');
    const [transitionTransferType, setTransitionTransferType] = $acw62.useState((0, $ce9d9e524be20f53$export$1b5eb083c754a86b).AccountTransfer);
    const hasActiveFilters = netAmountFilter !== (0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).All || categories !== null || tags !== null || dateFilter.startDate !== null || dateFilter.endDate !== null || fieldFilters !== null;
    const activeFilterCount = (netAmountFilter !== (0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).All ? 1 : 0) + (categories !== null ? 1 : 0) + (tags !== null || fieldFilters !== null ? 1 : 0) + (dateFilter.startDate !== null || dateFilter.endDate !== null ? 1 : 0);
    const filterVariables = $acw62.useMemo(()=>({
            limit: $09cf10b6a8e400ec$var$PAGE_SIZE,
            // Conversions can't be extended, and they store the home currency at
            // the transaction level, so the currency filter alone would leave them
            // in. Both filters run before pagination so pages arrive full.
            excludeTransferTypes: [
                (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion
            ],
            // Only same-currency transactions can accept these rows; filtering
            // server-side keeps every page full of real candidates.
            currency: addedCurrency,
            ...search ? {
                search: search
            } : {},
            ...netAmountFilter !== (0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).All ? {
                netAmountFilter: netAmountFilter
            } : {},
            ...categories ? {
                categories: categories
            } : {},
            ...tags ? {
                tags: tags
            } : {},
            ...dateFilter.startDate ? {
                startDate: dateFilter.startDate
            } : {},
            ...dateFilter.endDate ? {
                endDate: dateFilter.endDate
            } : {},
            ...fieldFilters ? {
                fieldFilters: fieldFilters
            } : {}
        }), [
        addedCurrency,
        search,
        netAmountFilter,
        categories,
        tags,
        dateFilter.startDate,
        dateFilter.endDate,
        fieldFilters
    ]);
    const [loadTransactions, { data: data, loading: loading, error: error }] = (0, $ce9d9e524be20f53$export$ef9441937bc56420)({
        notifyOnNetworkStatusChange: true,
        // no-cache, not network-only: this modal pages with Prev/Next and
        // renders each response as exactly one page. The transactions field
        // policy (ApolloProvider) appends cursor fetches to the accumulated
        // list-view entry, so reading through the cache would show every page
        // at once here — and pollute the list view's entry in the process.
        fetchPolicy: 'no-cache'
    });
    const [addConsumption, { loading: attaching }] = (0, $ce9d9e524be20f53$export$9fe0c1647f422e4c)();
    const pageData = data?.transactions;
    const transactions = pageData?.items ?? [];
    const displayError = submitError ?? error?.message ?? null;
    const hasNextPage = pageData?.hasMore ?? false;
    const hasPrevPage = pageIndex > 0;
    // Transition detection
    const selectedTransaction = transactions.find((t)=>t._id === selectedTransactionId);
    const newNetAmount = selectedTransaction && rawTransactionsToAdd.length > 0 ? selectedTransaction.netAmount + addedAmount : null;
    const transition = selectedTransaction && newNetAmount !== null ? $09cf10b6a8e400ec$var$detectTransition(selectedTransaction.netAmount, newNetAmount) : null;
    // Reset transition fields when selection changes. The payee seeds from the
    // selection: a transfer becoming a payment usually keeps its counterparty
    // (the server falls back to it too), so the field starts filled rather
    // than forcing a retype.
    $acw62.useEffect(()=>{
        setConfirmClearFields(false);
        setTransitionPayee(selectedTransaction?.payee ?? '');
        setTransitionCategory('');
        setTransitionDescription(selectedTransaction?.description ?? '');
        setTransitionTransferType(selectedTransaction?.transferType ?? (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).AccountTransfer);
    }, [
        selectedTransactionId
    ]);
    // Load first page when filters/search change
    $acw62.useEffect(()=>{
        setCursorStack([]);
        setPageIndex(0);
        setSelectedTransactionId(null);
        loadTransactions({
            variables: filterVariables
        });
    }, [
        rawTransactionsKey,
        filterVariables,
        loadTransactions
    ]);
    const handleSearchSubmit = (query)=>{
        const nextSearch = query.trim();
        setSubmitError(null);
        if (nextSearch === search) {
            setCursorStack([]);
            setPageIndex(0);
            loadTransactions({
                variables: filterVariables
            });
        } else setSearch(nextSearch);
    };
    const handleNextPage = ()=>{
        if (!hasNextPage || loading || !pageData?.endCursor) return;
        const nextCursor = pageData.endCursor;
        setCursorStack((prev)=>{
            const next = [
                ...prev
            ];
            next[pageIndex] = nextCursor;
            return next;
        });
        setPageIndex((prev)=>prev + 1);
        setSelectedTransactionId(null);
        loadTransactions({
            variables: {
                ...filterVariables,
                beforeCursor: nextCursor
            }
        });
    };
    const handlePrevPage = ()=>{
        if (!hasPrevPage || loading) return;
        const prevIndex = pageIndex - 1;
        setPageIndex(prevIndex);
        setSelectedTransactionId(null);
        if (prevIndex === 0) loadTransactions({
            variables: filterVariables
        });
        else loadTransactions({
            variables: {
                ...filterVariables,
                beforeCursor: cursorStack[prevIndex - 1]
            }
        });
    };
    const handleResetFilters = ()=>{
        setNetAmountFilter((0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).All);
        setCategories(null);
        setTags(null);
        setDateFilter({
            startDate: null,
            endDate: null
        });
        setFieldFilters(null);
    };
    const canSubmit = ()=>{
        if (rawTransactionsToAdd.length === 0 || !selectedTransaction || loading || attaching) return false;
        if (transition === 'becoming_balanced' && !confirmClearFields) return false;
        if (transition === 'becoming_unbalanced' && (!transitionPayee.trim() || !transitionCategory.trim())) return false;
        return true;
    };
    const handleAttach = async (event)=>{
        event.preventDefault();
        if (rawTransactionsToAdd.length === 0 || !selectedTransactionId) return;
        setSubmitError(null);
        try {
            const result = await addConsumption({
                variables: {
                    transactionId: selectedTransactionId,
                    rawTransactionIds: rawTransactionsToAdd.map((rt)=>rt._id),
                    ...transition === 'becoming_balanced' ? {
                        clearFields: true,
                        description: transitionDescription,
                        transferType: transitionTransferType
                    } : {},
                    ...transition === 'becoming_unbalanced' ? {
                        payee: transitionPayee.trim(),
                        categoryName: transitionCategory.trim(),
                        description: transitionDescription
                    } : {}
                }
            });
            if (result.data?.addConsumptionToTransaction) {
                onAttached?.(rawTransactionsToAdd.map((rt)=>rt._id));
                onRequestClose();
            }
        } catch (mutationError) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            setSubmitError(mutationError.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: attaching,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "button",
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: handleAttach,
                disabled: !canSubmit(),
                children: attaching ? 'Attaching...' : 'Attach'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Add to transaction",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: rawTransactionsToAdd.length > 1 ? `Raw transactions (${rawTransactionsToAdd.length})` : 'Raw transaction',
                    children: rawTransactionsToAdd.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            rawTransactionsToAdd.map((rt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "border-border flex items-center justify-between rounded-lg border p-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: rt.description || 'Untitled'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-muted-foreground text-sm",
                                                    children: rt.date
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                            amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(rt.amount, rt.currency),
                                            variant: "plain"
                                        })
                                    ]
                                }, rt._id)),
                            rawTransactionsToAdd.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center justify-between px-3 text-sm font-semibold",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Total"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                        amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(addedAmount, addedCurrency),
                                        variant: "plain"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$7f714e6c560938e5), {
                        children: "Select a raw transaction to continue."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex-1",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d5b3d85c2079de0$export$55d7609a8f1eccd2), {
                                        inputProps: {
                                            placeholder: 'Search by payee or description'
                                        },
                                        initialQuery: "",
                                        onSearch: handleSearchSubmit
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    type: "button",
                                    variant: showFilters ? 'primary' : 'outline',
                                    onClick: ()=>setShowFilters(!showFilters),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0408904748dc3b8$export$2e2bcd8739ae039), {
                                            className: "mr-1 h-4 w-4"
                                        }),
                                        "Filters",
                                        activeFilterCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "ml-1 rounded-full bg-primary-foreground/30 px-1.5 text-xs",
                                            children: activeFilterCount
                                        })
                                    ]
                                })
                            ]
                        }),
                        showFilters && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('relative flex cursor-pointer items-center gap-1.5 rounded-md border px-3 py-1.5 text-sm shadow-xs transition', netAmountFilter !== (0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).All ? 'bg-primary text-primary-foreground hover:bg-primary/80' : 'border-input text-foreground hover:bg-accent/30'),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $97332defb5de8faa$export$2e2bcd8739ae039), {
                                            className: "h-3.5 w-3.5"
                                        }),
                                        $09cf10b6a8e400ec$var$netAmountFilterLabels[netAmountFilter],
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                            className: "h-3.5 w-3.5"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                            value: netAmountFilter,
                                            onChange: (e)=>setNetAmountFilter($09cf10b6a8e400ec$var$parseNetAmountFilter(e.target.value)),
                                            className: "absolute inset-0 cursor-pointer opacity-0",
                                            children: Object.values((0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8)).map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: value,
                                                    children: $09cf10b6a8e400ec$var$netAmountFilterLabels[value]
                                                }, value))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fb4243874d8f910$export$bfb275743ab18881), {
                                    value: dateFilter,
                                    onChange: setDateFilter
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21c7fd562fd4701$export$d3e643d9d6f4fa7f), {
                                    categories: categories,
                                    setCategories: setCategories
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $210ce82bb39e8417$export$e38bc1a2c4737950), {
                                    tags: tags,
                                    setTags: setTags,
                                    fieldFilters: fieldFilters,
                                    setFieldFilters: setFieldFilters
                                }),
                                hasActiveFilters && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    type: "button",
                                    variant: "ghost",
                                    className: "text-muted-foreground gap-1 px-2",
                                    onClick: handleResetFilters,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                            size: 14
                                        }),
                                        "Reset"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                loading && transactions.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$ed2cd9eb2d1973f0), {
                    children: "Loading..."
                }) : transactions.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$ed2cd9eb2d1973f0), {
                    children: "No transactions found."
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$f0d9cf1e329477be), {
                    children: transactions.map((tx)=>{
                        const checked = selectedTransactionId === tx._id;
                        const isTransfer = tx.netAmount === 0;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2c01155910a1aa73$export$be59229647a59a8), {
                            onClick: ()=>setSelectedTransactionId(tx._id),
                            className: "cursor-pointer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "radio",
                                    checked: checked,
                                    onChange: ()=>setSelectedTransactionId(tx._id)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-center gap-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: $09cf10b6a8e400ec$var$transactionLabel(tx)
                                                }),
                                                isTransfer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-muted-foreground rounded bg-accent px-1.5 py-0.5 text-xs",
                                                    children: "Transfer"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "text-muted-foreground flex flex-wrap gap-1.5 text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: tx.date
                                                }),
                                                tx.category?.name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: tx.category.name
                                                }),
                                                tx.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: tx.description
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                    amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(tx.netAmount, tx.currency),
                                    align: "right"
                                })
                            ]
                        }, tx._id);
                    })
                }),
                (hasPrevPage || hasNextPage) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            type: "button",
                            variant: "outline",
                            onClick: handlePrevPage,
                            disabled: !hasPrevPage || loading,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                    className: "mr-1 h-4 w-4"
                                }),
                                "Previous"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-muted-foreground text-sm",
                            children: [
                                "Page ",
                                pageIndex + 1
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            type: "button",
                            variant: "outline",
                            onClick: handleNextPage,
                            disabled: !hasNextPage || loading,
                            children: [
                                "Next",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                    className: "ml-1 h-4 w-4"
                                })
                            ]
                        })
                    ]
                }),
                transition === 'becoming_balanced' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "border-border bg-accent/30 flex flex-col gap-3 rounded-lg border p-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-sm",
                            children: [
                                "Adding ",
                                rawTransactionsToAdd.length > 1 ? 'these raw transactions' : 'this raw transaction',
                                ' ',
                                "will make the net amount zero, converting this payment into a transfer. The category will be cleared; the payee is kept as the transfer's counterparty. Tags and fields are preserved."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: "flex items-start gap-2 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: confirmClearFields,
                                    onChange: (e)=>setConfirmClearFields(e.target.checked),
                                    className: "mt-0.5"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "I understand, convert to transfer"
                                })
                            ]
                        }),
                        confirmClearFields && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                    label: "Transfer type",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d906535d40bd11c1$export$2ee929a1dd0aa042), {
                                        value: transitionTransferType,
                                        onChange: setTransitionTransferType
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                    label: "Description",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                        value: transitionDescription,
                                        onChange: setTransitionDescription,
                                        placeholder: "Add description"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                transition === 'becoming_unbalanced' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "border-border bg-accent/30 flex flex-col gap-3 rounded-lg border p-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-sm",
                            children: [
                                "Adding ",
                                rawTransactionsToAdd.length > 1 ? 'these raw transactions' : 'this raw transaction',
                                ' ',
                                "will make the net amount non-zero, converting this transfer into a payment. Please provide a payee and category."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                            label: "Payee",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                value: transitionPayee,
                                onChange: setTransitionPayee,
                                placeholder: "Payee name"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                            label: "Category",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                value: transitionCategory,
                                onChange: setTransitionCategory,
                                placeholder: "Category name"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                            label: "Description",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                value: transitionDescription,
                                onChange: setTransitionDescription,
                                placeholder: "Add description"
                            })
                        })
                    ]
                }),
                displayError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$7f714e6c560938e5), {
                    children: displayError
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");





const $67a956d651e15f74$export$77cacd66283e3934 = (props)=>{
    const formId = $acw62.useId();
    const [recordAnchor, { loading: loading }] = (0, $ce9d9e524be20f53$export$3a0b388d2d812ec5)();
    const [date, setDate] = $acw62.useState($0c0f91b069db95d9$export$d0bdf45af03a6ea3());
    const [value, setValue] = $acw62.useState((0, $f8f45ddea4959097$exports.none));
    const [error, setError] = $acw62.useState(null);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        if (value.isEmpty) {
            setError('Please enter a valid portfolio value');
            return;
        }
        try {
            await recordAnchor({
                variables: {
                    accountId: props.accountId,
                    date: date.toISODate() ?? '',
                    balance: value.get().toInt().amount,
                    source: 'manual'
                }
            });
            props.onSuccess?.();
            props.onRequestClose();
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to create snapshot');
        }
    };
    const isValid = value.nonEmpty;
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                disabled: loading,
                onClick: props.onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                disabled: loading || !isValid,
                type: "submit",
                form: formId,
                children: "Add Snapshot"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: props.onRequestClose,
        header: "Add portfolio snapshot",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: (e)=>void handleSubmit(e),
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Date",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                        selectedDate: date,
                        onChange: setDate
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Portfolio value",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                        value: value,
                        onChange: setValue,
                        autoFocus: true
                    })
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-sm",
                    children: error
                })
            ]
        })
    });
};









var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");

parcelRequire("acw62");



const $d4dd8122ba7d7dc8$export$a519fd59e714bf50 = ({ account: account, className: className })=>account.logo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: (0, $cd179cdb1a4beac3$export$2e8a6207c9cc2bb8)(account.logo),
        alt: "",
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-4 shrink-0 rounded-sm', className)
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f6f28ec3b697fb2$export$fdaddccc706daa3a), {
        account: account,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('shrink-0', className)
    });



parcelRequire("acw62");


parcelRequire("acw62");

const $cb274851c0cf98db$var$IconBadge = (props)=>{
    const { className: className, ...restContainerProps } = props.containerProps ?? {};
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('relative flex min-w-0 flex-row items-center text-sm', className),
        ...restContainerProps,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mr-2 h-4 w-4 min-w-4 flex-none align-middle",
                children: props.icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-w-0 flex-grow",
                children: props.children
            })
        ]
    });
};
var $cb274851c0cf98db$export$2e2bcd8739ae039 = $cb274851c0cf98db$var$IconBadge;


const $8c0f56add137aac0$export$42a331aab32dea1 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb274851c0cf98db$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd8122ba7d7dc8$export$a519fd59e714bf50), {
            account: props.account
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "block truncate",
            children: props.account.name
        })
    });





var $acw62 = parcelRequire("acw62");

const $f33b0e35771f6c56$export$97c2614e526eac07 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { className: className, ...otherProps } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ref: ref,
        ...otherProps,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50', 'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]', 'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive', className)
    });
});




var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");
const $8d4f139dd59f4c7b$var$sizeToScale = {
    small: 0.2,
    medium: 0.5
};
const $8d4f139dd59f4c7b$var$Loading = (props)=>{
    const size = props.size || 'small';
    const scale = $8d4f139dd59f4c7b$var$sizeToScale[size];
    const pixels = `${80 * scale}px`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex h-full justify-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                width: pixels,
                height: pixels,
                margin: 'auto'
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative inline-block h-20 w-20 origin-top-left",
                style: {
                    transform: `scale(${scale})`
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "border-muted-foreground absolute box-border block h-16 w-16 rounded-full border-8 border-transparent border-t-current m-2",
                        style: {
                            animation: 'loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                            animationDelay: '-0.45s'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "border-muted-foreground absolute box-border block h-16 w-16 rounded-full border-8 border-transparent border-t-current m-2",
                        style: {
                            animation: 'loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                            animationDelay: '-0.3s'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "border-muted-foreground absolute box-border block h-16 w-16 rounded-full border-8 border-transparent border-t-current m-2",
                        style: {
                            animation: 'loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                            animationDelay: '-0.15s'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "border-muted-foreground absolute box-border block h-16 w-16 rounded-full border-8 border-transparent border-t-current m-2",
                        style: {
                            animation: 'loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite'
                        }
                    })
                ]
            })
        })
    });
};
var $8d4f139dd59f4c7b$export$2e2bcd8739ae039 = $8d4f139dd59f4c7b$var$Loading;



parcelRequire("acw62");


const $966e498019531360$export$465e1f56ff413b13 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('py-2 px-2 min-w-40 cursor-pointer', props.selected ? 'bg-primary text-primary-foreground' : 'hover:bg-accent'),
        onClick: props.onSelect,
        children: props.showIcon ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb274851c0cf98db$export$2e2bcd8739ae039), {
            icon: props.icon,
            children: props.children
        }) : props.children
    });
};



parcelRequire("acw62");
const $8818bb13665615a3$var$PopoverBox = (props)=>{
    const x = (props.transform?.$x ?? 0) - 8;
    const y = (props.transform?.$y ?? 0) - 8;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-popover text-popover-foreground outline-ring/50 max-h-[30vh] overflow-auto rounded-md p-2 shadow-lg outline-1",
        style: {
            transform: `translate(${x}px, ${y}px)`
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "-m-2",
            children: props.children
        })
    });
};
var $8818bb13665615a3$export$2e2bcd8739ae039 = $8818bb13665615a3$var$PopoverBox;



parcelRequire("acw62");
const $97c709ff184e3686$var$SelectionBox = ({ children: children, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `bg-muted p-2 ${className ?? ''}`,
        children: children
    });
var $97c709ff184e3686$export$2e2bcd8739ae039 = $97c709ff184e3686$var$SelectionBox;


const $a4c47c8f3ce70a74$export$ff9602a365dc3ba = (render)=>(props)=>{
        const { option: option, key: key, ...rowProps } = props;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $966e498019531360$export$465e1f56ff413b13), {
            ...rowProps,
            children: render(option)
        }, key);
    };
const $a4c47c8f3ce70a74$export$48176e38fd28cd2c = (render)=>(props)=>{
        const { option: option, key: key, ...rowProps } = props;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $966e498019531360$export$465e1f56ff413b13), {
            showIcon: true,
            ...rowProps,
            children: render(option)
        }, key);
    };
const $a4c47c8f3ce70a74$var$SearchBox = (props)=>{
    const { creatable: creatable, initialQuery: initialQuery, onCancel: onCancel, onClear: onClear, onSearch: onSearch, onSubmit: onSubmit, renderOption: renderOption, renderSelection: renderSelection, showSearchIcon: showSearchIcon } = props;
    const [query, setQuery] = $acw62.useState(initialQuery || '');
    const [selection, setSelection] = $acw62.useState(null);
    const searchResults = onSearch(query);
    const totalRows = searchResults ? searchResults.length + (creatable ? 1 : 0) : 0;
    const transformIndex = (i)=>{
        if (i < 0 || i > totalRows - 1) return null;
        else return i;
    };
    const handleSubmitIndex = (i, results)=>{
        if (i >= 0 && i < results.length) onSubmit && onSubmit(results[i]);
        else if (creatable && i === results.length) creatable && creatable.onCreate(query);
    };
    const handleKeyDown = (e)=>{
        if (searchResults) {
            if (e.key === 'ArrowUp') {
                if (selection === null) setSelection(totalRows - 1);
                else setSelection(transformIndex(selection - 1));
            } else if (e.key === 'ArrowDown') {
                if (selection === null) setSelection(0);
                else setSelection(transformIndex(selection + 1));
            } else if (e.key === 'Enter') {
                if (selection === null) {
                    if (creatable) {
                        handleSubmitIndex(searchResults.length, searchResults);
                        props.focusControlsRef?.current?.focusForward();
                    } else onCancel && onCancel();
                } else {
                    handleSubmitIndex(selection, searchResults);
                    props.focusControlsRef?.current?.focusForward();
                }
                e.preventDefault();
            } else if (e.key === 'Tab') {
                if (selection === null) {
                    if (query === '') onClear && onClear();
                    else handleSubmitIndex(0, searchResults);
                } else handleSubmitIndex(selection, searchResults);
            }
        }
    };
    const handleSubmit = (option)=>{
        onSubmit && onSubmit(option);
    };
    const handleCreate = (query)=>{
        creatable && creatable.onCreate(query);
        setQuery('');
    };
    const handleInputChange = (value)=>{
        setQuery(value);
        setSelection(null);
    };
    const createRow = creatable && searchResults && creatable.shouldRenderCreate(query, searchResults) ? creatable.renderCreate({
        item: query,
        selected: selection === totalRows - 1,
        onSelect: ()=>handleCreate(query)
    }) : null;
    const results = searchResults ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            searchResults.map((option, index)=>renderOption({
                    option: option,
                    selected: selection === index,
                    onSelect: ()=>handleSubmit(option),
                    key: index
                })),
            createRow
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
        size: "medium"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8818bb13665615a3$export$2e2bcd8739ae039), {
        transform: showSearchIcon ? {
            $x: -22
        } : {},
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $97c709ff184e3686$export$2e2bcd8739ae039), {
                children: renderSelection({
                    query: query,
                    onChange: handleInputChange,
                    onKeyDown: handleKeyDown
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex max-w-[400px] flex-col justify-center",
                children: results
            })
        ]
    });
};
var $a4c47c8f3ce70a74$export$2e2bcd8739ae039 = $a4c47c8f3ce70a74$var$SearchBox;



parcelRequire("acw62");


parcelRequire("acw62");
const $b4dc78c051474272$export$75f6b60983b7e7a9 = (props)=>({
        width: props.width || '100%',
        height: props.height || '100%',
        fill: props.fill || 'currentColor'
    });


const $fcc2ca71751a51c2$var$Search = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 330 330",
        ...(0, $b4dc78c051474272$export$75f6b60983b7e7a9)(props),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                id: "XMLID_17_",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        id: "XMLID_18_",
                        d: "M125.005,165.008c-22.058,0-40.003-17.945-40.003-40.002c0-8.284-6.716-15-15-15c-8.284,0-15,6.716-15,15   c0,38.6,31.403,70.002,70.003,70.002c8.284,0,15-6.716,15-15C140.005,171.724,133.289,165.008,125.005,165.008z"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        id: "XMLID_19_",
                        d: "M325.606,304.394L223.329,202.117c16.706-21.256,26.682-48.04,26.682-77.111   C250.011,56.077,193.934,0,125.005,0C56.077,0,0,56.077,0,125.005C0,193.933,56.077,250.01,125.005,250.01   c29.07,0,55.855-9.975,77.111-26.681l102.278,102.277C307.322,328.536,311.161,330,315,330c3.839,0,7.678-1.464,10.606-4.394   C331.464,319.749,331.464,310.251,325.606,304.394z M30,125.005C30,72.619,72.619,30,125.005,30   c52.386,0,95.006,42.619,95.006,95.005c0,52.386-42.62,95.005-95.006,95.005C72.619,220.01,30,177.391,30,125.005z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {})
        ]
    });
};
var $fcc2ca71751a51c2$export$2e2bcd8739ae039 = $fcc2ca71751a51c2$var$Search;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $571554950b126d5b$var$SUPPORTS_TOUCH = typeof window !== 'undefined' && ('ontouchstart' in window || typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0);
const $571554950b126d5b$var$TextInputBase = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const inputRef = $acw62.useRef(null);
    const { autoFocus: autoFocus, onChange: onChange, selectOnFocus: selectOnFocus, ...otherProps } = props;
    const handleSelectAll = ()=>{
        const shouldSelect = selectOnFocus ?? $571554950b126d5b$var$SUPPORTS_TOUCH;
        if (shouldSelect) {
            const input = inputRef.current;
            if (input) input.select();
        }
    };
    $acw62.useEffect(()=>{
        if (autoFocus) setTimeout(()=>{
            handleSelectAll();
        }, 1);
    }, [
        autoFocus
    ]);
    const handleFocus = (e)=>{
        handleSelectAll();
        props.onFocus && props.onFocus(e);
    };
    const handleRef = (el)=>{
        inputRef.current = el;
        if (typeof ref === 'function') ref(el);
        else if (typeof ref === 'object' && ref !== null) // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-type-assertion
        ref.current = el;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        type: "text",
        ...otherProps,
        autoFocus: autoFocus,
        ref: handleRef,
        onChange: (e)=>onChange && onChange(e.target.value),
        onFocus: handleFocus
    });
});
var $571554950b126d5b$export$2e2bcd8739ae039 = $571554950b126d5b$var$TextInputBase;


const $451c4a7a25b26abe$var$PlainTextInput = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { className: className, ...otherProps } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $571554950b126d5b$export$2e2bcd8739ae039), {
        ref: ref,
        className: `w-full border-none bg-transparent p-0 text-sm text-muted-foreground placeholder:italic placeholder:text-muted-foreground/60 focus:text-foreground focus:outline-none ${className ?? ''}`,
        ...otherProps
    });
});
var $451c4a7a25b26abe$export$2e2bcd8739ae039 = $451c4a7a25b26abe$var$PlainTextInput;


const $ae61dcc9d21f7824$var$SearchInput = (props)=>{
    const { className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb274851c0cf98db$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fcc2ca71751a51c2$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $451c4a7a25b26abe$export$2e2bcd8739ae039), {
            className: `w-full ${className ?? ''}`,
            ...rest
        })
    });
};
var $ae61dcc9d21f7824$export$2e2bcd8739ae039 = $ae61dcc9d21f7824$var$SearchInput;




var $acw62 = parcelRequire("acw62");


const $73c0a5b23b29fec5$export$e27304b2ccea8337 = (query, options)=>{
    return query.length > 0 && options.find((item)=>item === query) === undefined;
};
const $73c0a5b23b29fec5$var$SearchPopover = (props)=>{
    const { renderButton: renderButton, ...searchBoxProps } = props;
    const [open, setOpen] = $acw62.useState(false);
    const handleClosePopover = ()=>setOpen(false);
    const focusControlsRef = $acw62.useRef(null);
    const handleSubmit = (value)=>{
        props.onSubmit && props.onSubmit(value);
        setTimeout(()=>setOpen(false), 1);
    };
    const handleCreate = (query)=>{
        props.creatable && props.creatable.onCreate(query);
        setTimeout(()=>setOpen(false), 1);
    };
    const creatable = props.creatable ? {
        ...props.creatable,
        onCreate: handleCreate
    } : props.creatable;
    const contents = open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4c47c8f3ce70a74$export$2e2bcd8739ae039), {
        ...searchBoxProps,
        creatable: creatable,
        onSubmit: handleSubmit,
        focusControlsRef: focusControlsRef
    }) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $497d44d806a05c0a$export$2e2bcd8739ae039), {
        focusControlsRef: focusControlsRef,
        popoverContents: contents,
        popoverAnchor: "top-left",
        open: open,
        onOutsideClick: handleClosePopover,
        onOutsideFocus: handleClosePopover,
        children: (anchorRef)=>renderButton({
                anchorRef: anchorRef,
                openPopover: ()=>setOpen(true)
            })
    });
};
var $73c0a5b23b29fec5$export$2e2bcd8739ae039 = $73c0a5b23b29fec5$var$SearchPopover;



const $295751b0f96fd69d$var$AccountSelect = (props)=>{
    const { excludeIds: excludeIds, currency: currency } = props;
    const { loading: loading, data: data } = (0, $ce9d9e524be20f53$export$cb6e321bdf608ddb)();
    // Every AccountSelect use picks a write destination (create, move,
    // import, credit target) — closed accounts accept nothing dated after
    // their close, so hide them rather than offer picks that will usually
    // fail. (Backdated writes into a closed account go through the account's
    // own pages, not this picker.)
    const accounts = (data?.allAccounts ?? []).filter((account)=>!(0, $e597f4605156a89e$export$881343af68ecca95)(account) && !excludeIds?.includes(account._id) && (currency == null || account.currency === currency));
    // The current selection stays searchable even when the filters above
    // exclude it (a closed or cross-currency account seeded by the caller):
    // Tab submits the first match, so the selection must be able to win that
    // slot or an untouched tab-through re-points to a different account.
    const searchable = props.selectedAccount.map((selected)=>accounts.some((account)=>account._id === selected._id) ? accounts : [
            selected,
            ...accounts
        ]).getOrElse(accounts);
    const { search: search } = (0, $eefd5dff10250d61$export$bd221a7c56b93941)(searchable, [
        'name'
    ]);
    const handleSearch = (query)=>{
        if (loading) return false;
        const results = search(query);
        // The current selection ranks first among matches. Tab submits the
        // first result, and the popover opens seeded with the selection's name —
        // so with two same-named accounts, an untouched tab-through must land
        // back on the selected one, not whichever duplicate sorts first.
        return props.selectedAccount.map((selected)=>results.some((account)=>account._id === selected._id) ? [
                selected,
                ...results.filter((account)=>account._id !== selected._id)
            ] : results).getOrElse(results);
    };
    const renderButton = ({ anchorRef: anchorRef, openPopover: openPopover })=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f33b0e35771f6c56$export$97c2614e526eac07), {
            ref: anchorRef,
            autoFocus: props.autoFocus,
            onClick: openPopover,
            onFocus: openPopover,
            children: props.selectedAccount.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd8122ba7d7dc8$export$a519fd59e714bf50), {
                            account: account
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "truncate",
                            children: account.name
                        })
                    ]
                })).getOrElse(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground text-left text-sm",
                children: "Select account..."
            }))
        });
    };
    const renderSelection = ({ query: query, onChange: onChange, onKeyDown: onKeyDown })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae61dcc9d21f7824$export$2e2bcd8739ae039), {
            autoFocus: true,
            value: query,
            onChange: onChange,
            onKeyDown: onKeyDown,
            placeholder: "Select account..."
        });
    const renderOption = (0, $a4c47c8f3ce70a74$export$ff9602a365dc3ba)((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c0f56add137aac0$export$42a331aab32dea1), {
            account: account
        }));
    const handleClear = ()=>props.onSelectAccount((0, $f8f45ddea4959097$exports.none));
    const handleSubmit = (account)=>props.onSelectAccount((0, $f8f45ddea4959097$exports.some)(account));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73c0a5b23b29fec5$export$2e2bcd8739ae039), {
        initialQuery: props.selectedAccount.map((account)=>account.name).getOrElse(''),
        onClear: handleClear,
        onSearch: handleSearch,
        onSubmit: handleSubmit,
        renderButton: renderButton,
        renderSelection: renderSelection,
        renderOption: renderOption
    });
};
var $295751b0f96fd69d$export$2e2bcd8739ae039 = $295751b0f96fd69d$var$AccountSelect;



/**
 * Evicts every cached `AllRawTransactions` page scoped to a given account so
 * the next visit refetches from the network.
 *
 * Used after moving raw transactions into an account: that destination may
 * already have cached (and now stale) list pages from a prior visit. Because
 * the list query is cache-first, navigating back would otherwise reuse the
 * cached pages that omit the moved rows. We can't surgically insert into every
 * cached filter/pagination combination, so we drop them and let them reload.
 */ const $074538a84be674b5$var$evictAccountRawTransactions = (cache, accountId)=>{
    cache.modify({
        fields: {
            // Store field names look like `allRawTransactions:{"accountId":"...",...}`;
            // drop this account's pages regardless of the other filter/pagination args.
            allRawTransactions: (existing, { storeFieldName: storeFieldName, DELETE: DELETE })=>storeFieldName.includes(`"accountId":"${accountId}"`) ? DELETE : existing
        }
    });
    cache.gc();
};
var $074538a84be674b5$export$2e2bcd8739ae039 = $074538a84be674b5$var$evictAccountRawTransactions;





parcelRequire("acw62");


const $dc4fc1c2b6dd6a24$export$747498014587774b = ({ label: label, summary: summary, active: active, disabledReason: disabledReason, loading: loading, onToggle: onToggle, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-row items-start gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: "text-muted-foreground w-30 shrink-0 pt-1.5 text-sm",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-w-0 flex-1",
                children: active ? children : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-muted-foreground flex min-h-9 flex-col justify-center py-1.5 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "truncate",
                            children: summary
                        }),
                        disabledReason ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-xs opacity-80",
                            children: disabledReason
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: active ? 'ghost' : 'outline',
                className: "mt-0.5 h-8 shrink-0 px-2.5 text-xs",
                disabled: !active && (Boolean(disabledReason) || loading),
                onClick: ()=>onToggle(!active),
                "aria-label": active ? `Leave ${label} unchanged` : `Change ${label}`,
                title: active ? 'Leave unchanged' : undefined,
                children: active ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "size-4"
                }) : 'Change'
            })
        ]
    });
const $dc4fc1c2b6dd6a24$export$9b8348546fe33128 = ({ label: label, count: count, armed: armed, onToggle: onToggle })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: onToggle,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs', armed ? 'border-destructive text-destructive line-through' : 'border-border text-foreground hover:bg-muted/50'),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: label
            }),
            count > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground",
                children: count
            })
        ]
    });
const $dc4fc1c2b6dd6a24$export$379455b567eff87d = (items, pick)=>{
    if (items.length === 0) return null;
    const first = pick(items[0]);
    return items.every((item)=>pick(item) === first) ? first : null;
};
const $dc4fc1c2b6dd6a24$export$bb410559a65d3418 = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
    className: "italic",
    children: "Mixed"
});





var $acw62 = parcelRequire("acw62");


const $2680a3b0889a19c1$var$formatCents = (cents)=>{
    const dollars = Math.abs(cents) / 100;
    return `$${dollars.toFixed(2)}`;
};
const $2680a3b0889a19c1$var$formatDateRange = (startDate, endDate)=>{
    const start = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(startDate);
    // Half-open bounds: the displayed end month is the last covered day's
    const end = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(endDate).minus({
        days: 1
    });
    const fmt = {
        month: 'short',
        year: 'numeric'
    };
    return `${start.toLocaleString(fmt)} \u2013 ${end.toLocaleString(fmt)}`;
};
const $2680a3b0889a19c1$export$d93277a13097bc58 = (benefit)=>benefit.periods.reduce((sum, p)=>sum + p.remainingAmount, 0);
const $2680a3b0889a19c1$export$35d29d6477d4b247 = (benefit)=>benefit.periods.reduce((sum, p)=>sum + p.amount, 0);
const $2680a3b0889a19c1$export$f3ac91982c9f686a = (benefit, date)=>benefit.periods.some((p)=>date >= p.startDate && date < p.endDate);
const $2680a3b0889a19c1$var$FeePeriodGroup = ({ feePeriod: feePeriod, transactionDate: transactionDate, onSelect: onSelect })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground flex items-center justify-between gap-2 text-xs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex min-w-0 items-center gap-1.5",
                        children: [
                            feePeriod.account.logo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, $cd179cdb1a4beac3$export$2e8a6207c9cc2bb8)(feePeriod.account.logo),
                                alt: "",
                                className: "size-4 shrink-0 rounded-sm"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f6f28ec3b697fb2$export$fdaddccc706daa3a), {
                                account: feePeriod.account,
                                className: "size-4 shrink-0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "truncate font-medium",
                                children: feePeriod.payee ?? feePeriod.account.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "shrink-0",
                        children: $2680a3b0889a19c1$var$formatDateRange(feePeriod.startDate, feePeriod.endDate)
                    })
                ]
            }),
            feePeriod.benefits.map((benefit)=>{
                const remaining = $2680a3b0889a19c1$export$d93277a13097bc58(benefit);
                const total = $2680a3b0889a19c1$export$35d29d6477d4b247(benefit);
                const fullyUsed = remaining <= 0 && total > 0;
                const outOfPeriod = transactionDate != null && !$2680a3b0889a19c1$export$f3ac91982c9f686a(benefit, transactionDate);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    onClick: ()=>onSelect(benefit, feePeriod),
                    title: outOfPeriod ? 'No period of this benefit covers the transaction date' : undefined,
                    className: `border-border hover:bg-muted/50 flex w-full items-center justify-between gap-2 rounded-md border p-2.5 text-left ${fullyUsed || outOfPeriod ? 'opacity-50' : ''}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-sm font-medium",
                            children: benefit.name
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-muted-foreground shrink-0 text-xs",
                            children: [
                                $2680a3b0889a19c1$var$formatCents(remaining),
                                " / ",
                                $2680a3b0889a19c1$var$formatCents(total)
                            ]
                        })
                    ]
                }, benefit._id);
            })
        ]
    });
const $2680a3b0889a19c1$export$c75002b314c2fe72 = ({ feePeriods: feePeriods, transactionDate: transactionDate, accountId: accountId, lockAccount: lockAccount = false, onSelect: onSelect })=>{
    const [showAll, setShowAll] = $acw62.useState(false);
    const periodsWithBenefits = feePeriods.filter((fp)=>fp.benefits.length > 0);
    // Each benefit lands on exactly one account, and which one depends on the
    // benefit rather than its fee period. A benefit that loads value elsewhere
    // (Uber Cash) is recorded there — createCardBenefit rejects the card as a
    // credit destination precisely because a card's own statement credits
    // arrive through its feed, so recording synthetic ones would double them.
    // The rest refund on the card. Hence per benefit, not per fee period: a
    // card charge and an Uber Cash spend select disjoint sets out of the same
    // fee period group.
    const accountPeriods = $acw62.useMemo(()=>{
        if (!accountId) return periodsWithBenefits;
        return periodsWithBenefits.map((fp)=>({
                ...fp,
                benefits: fp.benefits.filter((b)=>(b.creditAccountId ?? fp.account._id) === accountId)
            })).filter((fp)=>fp.benefits.length > 0);
    }, [
        periodsWithBenefits,
        accountId
    ]);
    // What "Show all benefits" reveals: normally everything, but a caller
    // that locks the account keeps that restriction and only widens dates.
    const showAllPool = lockAccount ? accountPeriods : periodsWithBenefits;
    // Filter to fee periods with at least one benefit period covering the
    // transaction date (benefit periods, not fee period dates — see
    // benefitCoversDate)
    const matchingPeriods = $acw62.useMemo(()=>{
        if (showAll) return showAllPool;
        if (!transactionDate) return accountPeriods;
        return accountPeriods.filter((fp)=>fp.benefits.some((b)=>$2680a3b0889a19c1$export$f3ac91982c9f686a(b, transactionDate)));
    }, [
        showAllPool,
        accountPeriods,
        transactionDate,
        showAll
    ]);
    // Counted over benefits, not fee periods: the account filter can narrow a
    // group's benefits while leaving the group itself on screen.
    const benefitCount = (periods)=>periods.reduce((sum, fp)=>sum + fp.benefits.length, 0);
    const hasHidden = !showAll && benefitCount(matchingPeriods) < benefitCount(showAllPool);
    if (periodsWithBenefits.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-muted-foreground text-sm",
        children: "No benefits found."
    });
    if (matchingPeriods.length === 0 && !showAll) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center gap-2 py-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground text-sm",
                children: accountPeriods.length === 0 ? 'No benefits on this account.' : 'No benefits cover this transaction date.'
            }),
            benefitCount(showAllPool) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setShowAll(true),
                className: "text-sm font-medium underline",
                children: "Show all benefits"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-3",
        children: [
            matchingPeriods.map((fp)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2680a3b0889a19c1$var$FeePeriodGroup, {
                    feePeriod: fp,
                    transactionDate: transactionDate,
                    onSelect: onSelect
                }, fp._id)),
            hasHidden && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setShowAll(true),
                className: "text-muted-foreground text-xs underline",
                children: "Show all benefits"
            })
        ]
    });
};










var $acw62 = parcelRequire("acw62");



const $a5f774b73aaf5820$export$4ead0eaee86eb5fb = (cents)=>{
    const dollars = Math.abs(cents) / 100;
    return `$${dollars.toFixed(2)}`;
};
const $a5f774b73aaf5820$export$317de5adef9ec643 = (cents)=>cents < 0 ? `-${$a5f774b73aaf5820$export$4ead0eaee86eb5fb(cents)}` : $a5f774b73aaf5820$export$4ead0eaee86eb5fb(cents);
const $a5f774b73aaf5820$export$5723d387948018e1 = (cents)=>{
    const abs = Math.abs(cents);
    return abs % 100 === 0 ? `$${abs / 100}` : `$${(abs / 100).toFixed(2)}`;
};
const $a5f774b73aaf5820$export$66a540377a2b3d1e = (cents)=>cents < 0 ? `-${$a5f774b73aaf5820$export$5723d387948018e1(cents)}` : $a5f774b73aaf5820$export$5723d387948018e1(cents);
const $a5f774b73aaf5820$export$9fd9a6c97e959d35 = (cents)=>`${cents < 0 ? '-' : '+'}${$a5f774b73aaf5820$export$5723d387948018e1(cents)}`;
const $a5f774b73aaf5820$export$409494cf6876ac3e = (endSeconds)=>(0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(endSeconds).minus({
        days: 1
    });
const $a5f774b73aaf5820$export$2e9241a0bdf6c8b8 = (startSeconds, endSeconds)=>{
    const start = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(startSeconds);
    const end = $a5f774b73aaf5820$export$409494cf6876ac3e(endSeconds);
    const startStr = start.toLocaleString(start.year === end.year ? {
        month: 'short',
        day: 'numeric'
    } : {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
    const endStr = end.toLocaleString({
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
    return `${startStr} \u{2013} ${endStr}`;
};
const $a5f774b73aaf5820$export$a053908c5c4ea08d = (startSeconds, endSeconds)=>{
    const start = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(startSeconds);
    // Half-open bounds: whole-month spans start and end on a month boundary
    const end = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(endSeconds);
    const wholeMonths = start.day === 1 && end.day === 1;
    if (!wholeMonths) return $a5f774b73aaf5820$export$2e9241a0bdf6c8b8(startSeconds, endSeconds);
    const months = (end.year - start.year) * 12 + (end.month - start.month);
    if (months === 1) return start.toLocaleString({
        month: 'long',
        year: 'numeric'
    });
    if (months === 3 && start.month % 3 === 1) return `Q${Math.ceil(start.month / 3)} ${start.year}`;
    if (months === 6 && (start.month === 1 || start.month === 7)) return `H${start.month === 1 ? 1 : 2} ${start.year}`;
    if (months === 12 && start.month === 1) return String(start.year);
    const lastMonth = $a5f774b73aaf5820$export$409494cf6876ac3e(endSeconds);
    if (start.year === lastMonth.year) return `${start.toLocaleString({
        month: 'short'
    })} \u{2013} ${lastMonth.toLocaleString({
        month: 'short'
    })} ${start.year}`;
    return $a5f774b73aaf5820$export$2e9241a0bdf6c8b8(startSeconds, endSeconds);
};
const $a5f774b73aaf5820$export$74b02150c48af0bd = (startSeconds, endSeconds)=>{
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    return (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(startSeconds) <= now && now < (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(endSeconds);
};
const $a5f774b73aaf5820$export$859cbae57b7e86ba = (periods)=>{
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    let nextUpcoming;
    let mostRecentPast;
    for (const period of periods){
        const pStart = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(period.startDate);
        if (pStart <= now && now < (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(period.endDate)) return period;
        if (pStart > now) {
            if (!nextUpcoming || period.startDate < nextUpcoming.startDate) nextUpcoming = period;
        } else if (!mostRecentPast || period.startDate > mostRecentPast.startDate) mostRecentPast = period;
    }
    return nextUpcoming ?? mostRecentPast;
};



const $a9d94318500ad031$export$260983a97254aea6 = (cache)=>{
    cache.evict({
        fieldName: 'allFeePeriods'
    });
    cache.evict({
        fieldName: 'feePeriodsByAccount'
    });
    cache.gc();
};
const $a9d94318500ad031$export$ab284278c04797d0 = (props)=>{
    const { rawTransaction: rawTransaction, benefitName: benefitName, onRequestClose: onRequestClose, onUnlinked: onUnlinked } = props;
    const [unlinkBenefit, { loading: loading }] = (0, $ce9d9e524be20f53$export$40c676965d981712)({
        update: $a9d94318500ad031$export$260983a97254aea6
    });
    const [error, setError] = $acw62.useState(null);
    const handleUnlink = async ()=>{
        setError(null);
        try {
            await unlinkBenefit({
                variables: {
                    rawTransactionId: rawTransaction._id
                }
            });
            onUnlinked?.();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: handleUnlink,
                disabled: loading,
                children: loading ? 'Unlinking...' : 'Unlink'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Unlink transaction",
        footer: footer,
        size: "sm",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-destructive/10 text-destructive mb-3 rounded-md p-3 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Are you sure you want to unlink",
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: rawTransaction.description
                    }),
                    " (",
                    (0, $0c0f91b069db95d9$export$6b862160d295c8e)(rawTransaction.date).toLocaleString({
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                    }),
                    ' ',
                    "\xb7 ",
                    (0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(rawTransaction.amount),
                    ") from",
                    ' ',
                    benefitName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: benefitName
                    }) : 'its benefit',
                    "? The transaction is not deleted \u2014 it just stops counting toward the benefit."
                ]
            })
        ]
    });
};


const $756d32f3d1195566$export$4610343c2350759f = (props)=>{
    const { rawTransactions: rawTransactions, onSaved: onSaved, onRequestClose: onRequestClose } = props;
    const formId = $acw62.useId();
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const single = rawTransactions.length === 1 ? rawTransactions[0] : null;
    const { data: feePeriodsData } = (0, $ce9d9e524be20f53$export$46a1dde66166f325)();
    // --- Row-level gates ---------------------------------------------------
    const allManual = rawTransactions.every((rt)=>!rt.plaidId && !rt.venmoId);
    const syncedCount = rawTransactions.filter((rt)=>rt.plaidId || rt.venmoId).length;
    const manualOnlyReason = allManual ? null : `${syncedCount === rawTransactions.length ? 'Synced' : `${syncedCount} of ${rawTransactions.length}`} row${syncedCount === 1 && rawTransactions.length > 1 ? ' is' : 's are'} synced from Plaid/Venmo`;
    const singleConsumed = single !== null && single.remainingAmount !== null && single.remainingAmount !== single.amount;
    const amountReason = single === null ? null : !allManual ? manualOnlyReason : singleConsumed ? 'Locked: a transaction consumes this row' : single.reconciliation ? 'Locked: this row is reconciled' : null;
    const uniformAccountId = (0, $dc4fc1c2b6dd6a24$export$379455b567eff87d)(rawTransactions, (rt)=>rt.account._id);
    const uniformCurrency = (0, $dc4fc1c2b6dd6a24$export$379455b567eff87d)(rawTransactions, (rt)=>rt.currency);
    const allUsd = rawTransactions.every((rt)=>rt.currency === 'USD');
    const anyBenefit = rawTransactions.some((rt)=>rt.benefitId != null);
    // --- Draft state --------------------------------------------------------
    const [active, setActive] = $acw62.useState(new Set());
    const [account, setAccount] = $acw62.useState((0, $f8f45ddea4959097$exports.none));
    const [rawDate, setRawDate] = $acw62.useState((0, $0c0f91b069db95d9$export$6b862160d295c8e)(rawTransactions[0].date));
    const [rawDescription, setRawDescription] = $acw62.useState('');
    const [amount, setAmount] = $acw62.useState(single ? (0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer(single)) : (0, $f8f45ddea4959097$exports.none));
    const [benefit, setBenefit] = $acw62.useState({
        kind: 'pick'
    });
    const [error, setError] = $acw62.useState(null);
    const [saving, setSaving] = $acw62.useState(false);
    // Linking requires a single account: a benefit's credits are recorded
    // against a specific account, so a cross-account selection has no benefit
    // that is eligible for every row. A staged account move retargets both the
    // gate and the picker — the move applies before the link on save, so
    // eligibility follows the destination, not where the rows sit now.
    // Clearing an existing link needs neither gate.
    const stagedAccountId = active.has('account') ? account.map((a)=>a._id).getOrElse(null) : null;
    const effectiveAccountId = stagedAccountId ?? uniformAccountId;
    const canLinkBenefit = allUsd && effectiveAccountId !== null;
    const benefitReason = canLinkBenefit || anyBenefit ? null : !allUsd ? 'Benefits are USD-only' : 'Selection spans multiple accounts';
    // --- Current-value summaries -------------------------------------------
    const uniformDate = (0, $dc4fc1c2b6dd6a24$export$379455b567eff87d)(rawTransactions, (rt)=>rt.date);
    const uniformRawDescription = (0, $dc4fc1c2b6dd6a24$export$379455b567eff87d)(rawTransactions, (rt)=>rt.description);
    const uniformBenefit = (0, $dc4fc1c2b6dd6a24$export$379455b567eff87d)(rawTransactions, (rt)=>rt.benefit?.name ?? null);
    const accountSummary = (0, $dc4fc1c2b6dd6a24$export$379455b567eff87d)(rawTransactions, (rt)=>rt.account.name) ?? (0, $dc4fc1c2b6dd6a24$export$bb410559a65d3418);
    const isActive = (key)=>active.has(key);
    const toggleRow = (key)=>(next)=>{
            setActive((prev)=>{
                const nextSet = new Set(prev);
                if (next) nextSet.add(key);
                else nextSet.delete(key);
                return nextSet;
            });
            if (!next) {
                // Reverting a staged account move invalidates a benefit picked for
                // the destination — make the user re-pick against the current rows.
                if (key === 'account') setBenefit((prev)=>prev.kind === 'link' ? {
                        kind: 'pick'
                    } : prev);
                return;
            }
            // Activating a row seeds its draft with the current value when the
            // selection agrees on one — with a single row selected this makes every
            // row behave like a plain edit form.
            switch(key){
                case 'account':
                    setAccount(uniformAccountId !== null ? (0, $f8f45ddea4959097$exports.some)(rawTransactions[0].account) : (0, $f8f45ddea4959097$exports.none));
                    break;
                case 'rawDate':
                    setRawDate((0, $0c0f91b069db95d9$export$6b862160d295c8e)(uniformDate ?? rawTransactions[0].date));
                    break;
                case 'rawDescription':
                    setRawDescription(uniformRawDescription ?? '');
                    break;
                case 'benefit':
                    setBenefit(canLinkBenefit ? {
                        kind: 'pick'
                    } : {
                        kind: 'clear'
                    });
                    break;
                default:
                    break;
            }
        };
    // --- Save ---------------------------------------------------------------
    const [updateRawTransactions] = (0, $ce9d9e524be20f53$export$a48dcf481f9e74a4)();
    const [setBenefitOnRawTransactions] = (0, $ce9d9e524be20f53$export$55bd5587b7471132)();
    const [updateSingleRawTransaction] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$a816827dbf97cab1));
    const rawChanges = {
        account: isActive('account') ? account.map((a)=>a._id).getOrElse(undefined) : undefined,
        description: isActive('rawDescription') ? rawDescription : undefined,
        date: isActive('rawDate') ? rawDate.toISODate() : undefined
    };
    const hasRawChanges = rawChanges.account !== undefined || rawChanges.description !== undefined || rawChanges.date !== undefined;
    const benefitChange = !isActive('benefit') ? undefined : benefit.kind === 'link' ? benefit.benefitId : benefit.kind === 'clear' ? null : undefined;
    const amountChange = single && isActive('amount') ? amount.map((m)=>m.amount).getOrElse(undefined) : undefined;
    const hasChanges = hasRawChanges || benefitChange !== undefined || amountChange !== undefined;
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!hasChanges || saving) return;
        setError(null);
        setSaving(true);
        // The save is not one transaction, so order the calls by failure
        // likelihood: the raw-level writes carry the validations the form can't
        // pre-check (cross-currency moves, closed accounts, reconciliation and
        // basis locks), while the patch calls only receive values the form
        // already constrained. Running the likely-rejection first means a failed
        // save normally leaves nothing applied.
        const run = async ()=>{
            const updatedById = new Map();
            if (amountChange !== undefined && single) {
                const result = await updateSingleRawTransaction({
                    variables: {
                        id: single._id,
                        amount: amountChange
                    }
                });
                const updated = result.data?.updateRawTransaction;
                if (updated) updatedById.set(updated._id, updated);
            }
            if (hasRawChanges) {
                const result = await updateRawTransactions({
                    variables: {
                        ids: rawTransactions.map((rt)=>rt._id),
                        account: rawChanges.account,
                        description: rawChanges.description,
                        date: rawChanges.date
                    }
                });
                for (const updated of result.data?.updateRawTransactions ?? [])updatedById.set(updated._id, updated);
                if (rawChanges.account !== undefined) {
                    // Moving rewrites each row's accountId, so cached list pages for
                    // every source account and the destination are stale — evict them
                    // so they refetch on next view (same reasoning as the Move modal).
                    const affectedAccountIds = new Set(rawTransactions.map((rt)=>rt.account._id));
                    affectedAccountIds.add(rawChanges.account);
                    affectedAccountIds.forEach((accountId)=>(0, $074538a84be674b5$export$2e2bcd8739ae039)(client.cache, accountId));
                    // A moved row may back a fee period as its charge; the resolver
                    // drops the link once accounts mismatch, so cached fee period
                    // queries go stale too.
                    (0, $a9d94318500ad031$export$260983a97254aea6)(client.cache);
                }
            }
            if (benefitChange !== undefined) {
                const result = await setBenefitOnRawTransactions({
                    variables: {
                        ids: rawTransactions.map((rt)=>rt._id),
                        benefit: benefitChange
                    }
                });
                for (const updated of result.data?.setBenefitOnRawTransactions ?? [])updatedById.set(updated._id, updated);
                // Benefit usage totals hang off fee period queries
                (0, $a9d94318500ad031$export$260983a97254aea6)(client.cache);
            }
            return [
                ...updatedById.values()
            ];
        };
        run().then((updated)=>{
            onRequestClose();
            onSaved(updated);
        }).catch((e)=>{
            setError(e instanceof Error ? e.message : 'Failed to save changes.');
        }).finally(()=>setSaving(false));
    };
    // --- Rendering ----------------------------------------------------------
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                disabled: saving,
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: !hasChanges || saving,
                children: saving ? "Saving\u2026" : 'Save'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        size: "lg",
        // A bottom sheet on a phone, as the transaction sheets are.
        className: "top-auto bottom-0 h-auto max-h-[92dvh] rounded-b-none sm:rounded-b-lg",
        header: single ? 'Edit activity' : `Edit ${rawTransactions.length} activity lines`,
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$747498014587774b), {
                    label: "Account",
                    summary: accountSummary,
                    active: isActive('account'),
                    onToggle: toggleRow('account'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $295751b0f96fd69d$export$2e2bcd8739ae039), {
                        selectedAccount: account,
                        onSelectAccount: (next)=>{
                            setAccount(next);
                            // A staged link was picked against the previous destination;
                            // changing it means re-picking, not silently carrying over.
                            setBenefit((prev)=>prev.kind === 'link' ? {
                                    kind: 'pick'
                                } : prev);
                        },
                        currency: uniformCurrency ?? undefined
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$747498014587774b), {
                    label: "Date",
                    summary: uniformDate ?? (0, $dc4fc1c2b6dd6a24$export$bb410559a65d3418),
                    active: isActive('rawDate'),
                    disabledReason: manualOnlyReason,
                    onToggle: toggleRow('rawDate'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                        selectedDate: rawDate,
                        onChange: setRawDate
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$747498014587774b), {
                    label: "Description",
                    summary: uniformRawDescription === null ? (0, $dc4fc1c2b6dd6a24$export$bb410559a65d3418) : uniformRawDescription || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "italic",
                        children: "Empty"
                    }),
                    active: isActive('rawDescription'),
                    disabledReason: manualOnlyReason,
                    onToggle: toggleRow('rawDescription'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        value: rawDescription,
                        onChange: setRawDescription,
                        placeholder: "Description"
                    })
                }),
                single && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$747498014587774b), {
                    label: "Amount",
                    summary: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                        variant: "plain",
                        amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer(single)
                    }),
                    active: isActive('amount'),
                    disabledReason: amountReason,
                    onToggle: toggleRow('amount'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                        value: amount,
                        onChange: setAmount,
                        textAlign: "left",
                        currency: single.currency
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$747498014587774b), {
                    label: "Benefit",
                    summary: uniformBenefit === null ? anyBenefit ? (0, $dc4fc1c2b6dd6a24$export$bb410559a65d3418) : 'None' : uniformBenefit ?? 'None',
                    active: isActive('benefit'),
                    disabledReason: benefitReason,
                    onToggle: toggleRow('benefit'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-2 pt-1.5",
                        children: benefit.kind === 'link' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "Link to ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-medium",
                                            children: benefit.benefitName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    className: "h-7 px-2.5 text-xs",
                                    onClick: ()=>setBenefit({
                                            kind: 'pick'
                                        }),
                                    children: "Change"
                                })
                            ]
                        }) : benefit.kind === 'clear' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "The benefit link will be removed"
                                }),
                                canLinkBenefit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    className: "h-7 px-2.5 text-xs",
                                    onClick: ()=>setBenefit({
                                            kind: 'pick'
                                        }),
                                    children: "Link instead\u2026"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "max-h-64 overflow-y-auto",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2680a3b0889a19c1$export$c75002b314c2fe72), {
                                        feePeriods: feePeriodsData?.allFeePeriods ?? [],
                                        transactionDate: Math.max(...rawTransactions.map((rt)=>(0, $0c0f91b069db95d9$export$6b862160d295c8e)(rt.date).toSeconds())),
                                        accountId: effectiveAccountId ?? undefined,
                                        // One pick links every selected row, so "Show all" may
                                        // widen dates but never cross accounts here.
                                        lockAccount: true,
                                        onSelect: (selected)=>setBenefit({
                                                kind: 'link',
                                                benefitId: selected._id,
                                                benefitName: selected.name
                                            })
                                    })
                                }),
                                anyBenefit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    className: "h-7 self-start px-2.5 text-xs",
                                    onClick: ()=>setBenefit({
                                            kind: 'clear'
                                        }),
                                    children: "Clear the current benefit instead"
                                })
                            ]
                        })
                    })
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-destructive text-sm",
                    children: error
                })
            ]
        })
    });
};





parcelRequire("acw62");




const $853b33c2f2306612$export$20f7ed2d7a96cfbc = (period, now)=>{
    const { startDate: startDate, endDate: endDate, amount: amount, usedAmount: usedAmount } = period;
    // Booked = the explicitly future-dated portion; posted is the remainder.
    // Derived this way round so usage without a dated transaction behind it
    // counts as posted (in hand), never as scheduled.
    let bookedAmount = 0;
    for (const rt of period.rawTransactions)if ((0, $0c0f91b069db95d9$export$6b862160d295c8e)(rt.date) > now) bookedAmount += rt.amount;
    const postedAmount = usedAmount - bookedAmount;
    const expired = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(endDate) <= now;
    const future = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(startDate) > now;
    const full = amount > 0 && usedAmount >= amount;
    let state;
    let openRemaining = 0;
    let missedAmount = 0;
    let daysLeft = null;
    if (amount > 0 && usedAmount > amount) state = 'over';
    else if (future) // A future window already covered by pre-generated credits is booked
    state = full ? 'booked' : 'future';
    else if (expired) {
        if (full) state = 'captured';
        else {
            // Floor usedAmount at 0 so net-negative windows (clawbacks exceeding
            // credits) forfeit at most the window's own amount
            missedAmount = Math.max(0, amount - Math.max(0, usedAmount));
            state = usedAmount > 0 ? 'partial' : 'missed';
        }
    } else if (full) state = bookedAmount > 0 ? 'booked' : 'captured';
    else {
        state = 'open';
        // Signed usedAmount, matching the server's remainingAmount resolver: a
        // net-negative window (reversal exceeding credits) has more than the cap
        // left to claim, not the cap
        openRemaining = Math.max(0, amount - usedAmount);
        daysLeft = Math.max(0, Math.floor((0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(endDate).diff(now, 'days').days));
    }
    return {
        startDate: startDate,
        endDate: endDate,
        amount: amount,
        usedAmount: usedAmount,
        postedAmount: postedAmount,
        bookedAmount: bookedAmount,
        state: state,
        openRemaining: openRemaining,
        missedAmount: missedAmount,
        daysLeft: daysLeft
    };
};
const $853b33c2f2306612$export$4007b2e641a2850f = (benefit, now)=>{
    const windows = [
        ...benefit.periods
    ].sort((a, b)=>a.startDate - b.startDate).map((period)=>$853b33c2f2306612$export$20f7ed2d7a96cfbc(period, now));
    const summary = {
        benefit: benefit,
        windows: windows,
        totalAmount: 0,
        totalUsed: 0,
        posted: 0,
        booked: 0,
        open: 0,
        missed: 0,
        future: 0,
        hasOver: false,
        nextOpenWindow: null,
        nextFutureWindow: null
    };
    for (const window of windows){
        summary.totalAmount += window.amount;
        summary.totalUsed += window.usedAmount;
        summary.posted += window.postedAmount;
        summary.booked += window.bookedAmount;
        summary.open += window.openRemaining;
        summary.missed += window.missedAmount;
        if (window.state === 'future') // Only the unclaimed remainder: a partially pre-covered future window
        // already carries its usage in the captured totals, and a net-negative
        // one has more than its cap still ahead
        summary.future += Math.max(0, window.amount - window.usedAmount);
        if (window.state === 'over') summary.hasOver = true;
        if (window.state === 'open' && (summary.nextOpenWindow == null || window.endDate < summary.nextOpenWindow.endDate)) // Nearest deadline, not first by start date — accepted custom windows
        // can overlap, so an earlier-starting window may close later
        summary.nextOpenWindow = window;
        if (window.state === 'future' && summary.nextFutureWindow == null) summary.nextFutureWindow = window;
    }
    return summary;
};
const $853b33c2f2306612$export$f9b975a80d6d4e01 = (feePeriod, now)=>{
    const stats = {
        feePeriod: feePeriod,
        benefits: feePeriod.benefits.map((benefit)=>$853b33c2f2306612$export$4007b2e641a2850f(benefit, now)),
        isCurrent: (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(feePeriod.startDate) <= now && now < (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(feePeriod.endDate),
        fee: feePeriod.amount,
        potential: 0,
        captured: 0,
        posted: 0,
        booked: 0,
        open: 0,
        missed: 0,
        future: 0,
        net: 0,
        openWindowCount: 0,
        missedWindowCount: 0,
        uncovered: 0
    };
    for (const summary of stats.benefits){
        stats.potential += summary.totalAmount;
        stats.captured += summary.totalUsed;
        stats.posted += summary.posted;
        stats.booked += summary.booked;
        stats.open += summary.open;
        stats.missed += summary.missed;
        stats.future += summary.future;
        stats.uncovered += summary.benefit.uncoveredAmount;
        for (const window of summary.windows){
            if (window.state === 'open') stats.openWindowCount++;
            if (window.missedAmount > 0) stats.missedWindowCount++;
        }
    }
    stats.net = stats.captured - stats.fee;
    return stats;
};
const $853b33c2f2306612$export$3ccbd4bba7610f22 = (feePeriods, now)=>{
    const items = [];
    for (const feePeriod of feePeriods)for (const benefit of feePeriod.benefits){
        for (const window of $853b33c2f2306612$export$4007b2e641a2850f(benefit, now).windows)if (window.state === 'open' && window.openRemaining > 0) items.push({
            feePeriod: feePeriod,
            benefit: benefit,
            window: window
        });
    }
    return items.sort((a, b)=>a.window.endDate - b.window.endDate || b.window.openRemaining - a.window.openRemaining);
};
const $853b33c2f2306612$export$f2a3b994c1e847e = (feePeriods, now, withinDays)=>{
    const horizon = now.plus({
        days: withinDays
    });
    const items = [];
    for (const feePeriod of feePeriods)for (const benefit of feePeriod.benefits){
        const { nextFutureWindow: nextFutureWindow } = $853b33c2f2306612$export$4007b2e641a2850f(benefit, now);
        if (nextFutureWindow != null && (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(nextFutureWindow.startDate) <= horizon) items.push({
            benefit: benefit,
            window: nextFutureWindow,
            remaining: Math.max(0, nextFutureWindow.amount - nextFutureWindow.usedAmount)
        });
    }
    return items.sort((a, b)=>a.window.startDate - b.window.startDate);
};
const $853b33c2f2306612$export$549a9d736f93e9f7 = (stats)=>{
    const capturedPos = Math.max(0, stats.captured);
    const posted = Math.max(0, Math.min(stats.posted, capturedPos));
    return {
        posted: posted,
        booked: capturedPos - posted
    };
};
const $853b33c2f2306612$export$27ccb103633d41b1 = (feePeriod)=>{
    // The axis must cover every window, not just the fee year: the editor
    // accepts custom windows anywhere, and an off-axis window would silently
    // vanish from the grid while still counting in totals. Windows that merely
    // *straddle* the fee-year start (the calendar snap-out case) keep the
    // left-clip fade — only a window lying entirely before the fee year
    // extends the axis leftward.
    const feeMonthStart = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(feePeriod.startDate).startOf('month');
    let startSeconds = feePeriod.startDate;
    let endSeconds = feePeriod.endDate;
    for (const benefit of feePeriod.benefits ?? [])for (const period of benefit.periods){
        if (period.endDate > endSeconds) endSeconds = period.endDate;
        if ((0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(period.endDate) <= feeMonthStart && period.startDate < startSeconds) startSeconds = period.startDate;
    }
    const start = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(startSeconds).startOf('month');
    const end = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(endSeconds);
    const months = end.diff(start, 'months').months;
    // Ceil so a partial final month gets its own column (a Feb 9 anniversary
    // year spans Feb..Feb, 13 columns) — otherwise the closing days of the fee
    // year would render past the axis, clipped and without a today line. The
    // epsilon keeps exact month boundaries (Apr 1 – Apr 1) at 12. No upper
    // clamp: the server permits fee periods of any length, and the grid
    // scrolls horizontally rather than truncating.
    const monthCount = Math.max(1, Math.ceil(months - 0.001));
    const labels = [];
    for(let i = 0; i < monthCount; i++)labels.push(start.plus({
        months: i
    }).toLocaleString({
        month: 'short'
    }).toUpperCase());
    return {
        start: start,
        monthCount: monthCount,
        labels: labels
    };
};
const $853b33c2f2306612$export$f727f9cb476b8c8a = (axis, seconds)=>{
    const dt = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(seconds);
    return (dt.year - axis.start.year) * 12 + (dt.month - axis.start.month) + (dt.day - 1) / dt.daysInMonth;
};
const $853b33c2f2306612$export$6861394b06ea24f3 = (axis, dt)=>{
    const utc = dt.toUTC();
    return (utc.year - axis.start.year) * 12 + (utc.month - axis.start.month) + (utc.day - 1) / utc.daysInMonth;
};




/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $68d48ea6a6653ccd$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
];
const $68d48ea6a6653ccd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("copy", $68d48ea6a6653ccd$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dbde4c3396582d11$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $dbde4c3396582d11$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("plus", $dbde4c3396582d11$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");






const $5cfc8dfd09486d37$export$e19156b242c24f97 = {
    monthly: 1,
    quarterly: 3,
    semi_annual: 6,
    annual: 12
};
/** Start of the m-month calendar unit containing `date` (month/quarter/half/year). */ const $5cfc8dfd09486d37$var$startOfUnit = (date, months)=>{
    const unitStartMonth = Math.floor((date.month - 1) / months) * months + 1;
    return date.set({
        month: unitStartMonth,
        day: 1
    }).startOf("day");
};
/** Whole-unit coverage span for a calendar-aligned schedule: the start snaps
 * outward to its unit boundary, the end floors to one. A span shorter than a
 * single unit still grants the unit it starts in. */ const $5cfc8dfd09486d37$var$calendarSpan = (start, end, months)=>{
    const anchor = $5cfc8dfd09486d37$var$startOfUnit(start, months);
    const floored = $5cfc8dfd09486d37$var$startOfUnit(end, months);
    return {
        anchor: anchor,
        endBound: floored > anchor ? floored : anchor.plus({
            months: months
        })
    };
};
const $5cfc8dfd09486d37$export$f83c96c9a2deaaa1 = (seconds)=>(0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(seconds).startOf("day");
const $5cfc8dfd09486d37$export$40edc1245c2584cb = (seconds)=>{
    const dt = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(seconds);
    const floored = dt.startOf("day");
    return dt.equals(floored) ? floored : floored.plus({
        days: 1
    });
};
const $5cfc8dfd09486d37$export$42234701d55e3643 = (args)=>{
    const months = $5cfc8dfd09486d37$export$e19156b242c24f97[args.cadence];
    const start = $5cfc8dfd09486d37$export$f83c96c9a2deaaa1(args.startDate);
    const end = $5cfc8dfd09486d37$export$40edc1245c2584cb(args.endDate);
    const { anchor: anchor, endBound: endBound } = args.calendarAligned ? $5cfc8dfd09486d37$var$calendarSpan(start, end, months) : {
        anchor: start,
        endBound: end
    };
    const periods = [];
    // Index-based stride (anchor.plus i*months) instead of chained plus, so a
    // Jan 31 anchor yields Mar 31, not the drifted Feb 28 + 1 month = Mar 28
    for(let i = 0;; i++){
        const periodStart = anchor.plus({
            months: months * i
        });
        if (periodStart >= endBound) break;
        const periodEnd = anchor.plus({
            months: months * (i + 1)
        });
        // Only an anniversary last row can overrun the bounds — calendar bounds
        // are already unit-aligned
        const clampedEnd = periodEnd > endBound ? endBound : periodEnd;
        const startDate = Math.floor(periodStart.toSeconds());
        const exception = args.exceptions?.find((e)=>e.startDate === startDate);
        periods.push({
            startDate: startDate,
            endDate: Math.floor(clampedEnd.toSeconds()),
            amount: exception?.amount ?? args.amountPerPeriod
        });
    }
    return periods;
};
/** Rows are exactly the whole calendar units of the unit-snapped bounds —
 * the same span explodeSchedule would produce. */ const $5cfc8dfd09486d37$var$matchesCalendar = (rows, months, bounds)=>{
    const { anchor: anchor, endBound: endBound } = $5cfc8dfd09486d37$var$calendarSpan($5cfc8dfd09486d37$export$f83c96c9a2deaaa1(bounds.startDate), $5cfc8dfd09486d37$export$40edc1245c2584cb(bounds.endDate), months);
    if (!rows[rows.length - 1].end.equals(endBound)) return false;
    for(let i = 0; i < rows.length; i++){
        if (!rows[i].start.equals(anchor.plus({
            months: months * i
        }))) return false;
        if (!rows[i].end.equals(anchor.plus({
            months: months * (i + 1)
        }))) return false;
    }
    return true;
};
/** Rows stride m months from the bounds start to the bounds end; the last
 * row may be clamped short of a full stride. */ const $5cfc8dfd09486d37$var$matchesAnniversary = (rows, months, bounds)=>{
    const anchor = $5cfc8dfd09486d37$export$f83c96c9a2deaaa1(bounds.startDate);
    if (!rows[rows.length - 1].end.equals($5cfc8dfd09486d37$export$40edc1245c2584cb(bounds.endDate))) return false;
    for(let i = 0; i < rows.length; i++){
        const { start: start, end: end } = rows[i];
        if (!start.equals(anchor.plus({
            months: months * i
        }))) return false;
        const strideEnd = anchor.plus({
            months: months * (i + 1)
        });
        if (i < rows.length - 1) {
            if (!end.equals(strideEnd)) return false;
        } else {
            if (end > strideEnd || end <= start) return false;
        }
    }
    return true;
};
const $5cfc8dfd09486d37$export$e7bebb98bee5e46f = (periods, bounds)=>{
    if (periods.length === 0) return null;
    const rows = [
        ...periods
    ].sort((a, b)=>a.startDate - b.startDate).map((p)=>({
            start: $5cfc8dfd09486d37$export$f83c96c9a2deaaa1(p.startDate),
            end: $5cfc8dfd09486d37$export$40edc1245c2584cb(p.endDate),
            amount: p.amount
        }));
    for (const row of rows){
        if (row.end <= row.start) return null;
    }
    // Contiguous, non-overlapping coverage: adjacent rows share the boundary
    for(let i = 1; i < rows.length; i++){
        if (!rows[i].start.equals(rows[i - 1].end)) return null;
    }
    // Each matcher pins the rows to the bounds (first start, last end, exact
    // strides), so a lone short row can only match a cadence whose re-explosion
    // reproduces it exactly — no expansion on re-save.
    let matched = null;
    const cadences = [
        "monthly",
        "quarterly",
        "semi_annual",
        "annual"
    ];
    for (const cadence of cadences){
        const months = $5cfc8dfd09486d37$export$e19156b242c24f97[cadence];
        if ($5cfc8dfd09486d37$var$matchesCalendar(rows, months, bounds)) {
            matched = {
                cadence: cadence,
                calendarAligned: true
            };
            break;
        }
        if ($5cfc8dfd09486d37$var$matchesAnniversary(rows, months, bounds)) {
            matched = {
                cadence: cadence,
                calendarAligned: false
            };
            break;
        }
    }
    if (!matched) return null;
    // Base amount = most common (earliest wins ties); the rest are exceptions
    const counts = new Map();
    for (const row of rows)counts.set(row.amount, (counts.get(row.amount) ?? 0) + 1);
    let base = rows[0].amount;
    let bestCount = 0;
    for (const row of rows){
        const count = counts.get(row.amount) ?? 0;
        if (count > bestCount) {
            base = row.amount;
            bestCount = count;
        }
    }
    const exceptions = rows.filter((row)=>row.amount !== base).map((row)=>({
            startDate: Math.floor(row.start.toSeconds()),
            amount: row.amount
        }));
    return {
        cadence: matched.cadence,
        calendarAligned: matched.calendarAligned,
        amountPerPeriod: base,
        exceptions: exceptions
    };
};
const $5cfc8dfd09486d37$export$31e47ee0e4d35172 = (sourceRows, sourceBounds, targetBounds)=>{
    const schedule = $5cfc8dfd09486d37$export$e7bebb98bee5e46f(sourceRows, sourceBounds);
    if (!schedule) return null;
    const rows = $5cfc8dfd09486d37$export$42234701d55e3643({
        cadence: schedule.cadence,
        calendarAligned: schedule.calendarAligned,
        amountPerPeriod: schedule.amountPerPeriod,
        startDate: targetBounds.startDate,
        endDate: targetBounds.endDate
    });
    const sorted = [
        ...sourceRows
    ].sort((a, b)=>a.startDate - b.startDate);
    // Calendar rows start on unit boundaries, but legacy callers may still
    // hold clamped rows (a Q1 row starting Mar 15 is still Q1), so matching
    // keys on the containing unit's start month instead of the raw start month
    const months = $5cfc8dfd09486d37$export$e19156b242c24f97[schedule.cadence];
    const unitMonth = (startDate)=>$5cfc8dfd09486d37$var$startOfUnit($5cfc8dfd09486d37$export$f83c96c9a2deaaa1(startDate), months).month;
    // nth occurrence of the row's calendar unit within a row list — the
    // ordinal disambiguates repeated units across multi-year spans
    const occurrenceOfUnit = (list, startDate)=>list.filter((r)=>r.startDate < startDate && unitMonth(r.startDate) === unitMonth(startDate)).length;
    // Exception startDates come from inference (day-floored); compare source
    // rows at the same granularity so legacy non-midnight starts still match
    const sourceIndexOf = (startDate)=>sorted.findIndex((p)=>$5cfc8dfd09486d37$export$f83c96c9a2deaaa1(p.startDate).equals($5cfc8dfd09486d37$export$f83c96c9a2deaaa1(startDate)));
    for (const exception of schedule.exceptions){
        let target;
        if (schedule.calendarAligned && rows.length !== sorted.length) {
            const month = unitMonth(exception.startDate);
            const occurrence = occurrenceOfUnit(sorted, exception.startDate);
            target = rows.filter((r)=>unitMonth(r.startDate) === month)[occurrence];
        } else // Structural position from the anchor — holds for equal-count copies
        // and for anniversary schedules whose anchor moved
        target = rows[sourceIndexOf(exception.startDate)];
        if (target) target.amount = exception.amount;
    }
    return rows;
};



/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $00824d397ec63c04$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $00824d397ec63c04$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("triangle-alert", $00824d397ec63c04$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");



/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2814ca8ca76f8609$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
            key: "yqzxt4"
        }
    ],
    [
        "path",
        {
            d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
            key: "4qinb0"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "8",
            y1: "2",
            y2: "5",
            key: "1041cp"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "5",
            y1: "8",
            y2: "8",
            key: "14m1p5"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "16",
            y1: "19",
            y2: "22",
            key: "rzdirn"
        }
    ],
    [
        "line",
        {
            x1: "19",
            x2: "22",
            y1: "16",
            y2: "16",
            key: "ox905f"
        }
    ]
];
const $2814ca8ca76f8609$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("unlink", $2814ca8ca76f8609$export$3efd853dbb351e94);


parcelRequire("acw62");




const $c39075059c0401f6$export$6d49a19ae083f17c = (props)=>{
    const { rawTransactions: rawTransactions, benefitName: benefitName, emptyText: emptyText, onUpdate: onUpdate } = props;
    const { unlinkBenefitTransactionModal: unlinkBenefitTransactionModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const handleUnlink = (rawTransaction)=>{
        unlinkBenefitTransactionModal.openModal({
            rawTransaction: rawTransaction,
            benefitName: benefitName,
            onUnlinked: onUpdate
        });
    };
    if (rawTransactions.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-muted-foreground text-xs italic",
        children: emptyText ?? 'No linked transactions in this period.'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-col",
        children: rawTransactions.map((rt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "group flex items-center gap-2 rounded py-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                        to: `/raw-transactions/${rt._id}`,
                        className: "hover:bg-accent flex min-w-0 flex-1 items-baseline gap-2 rounded px-1 py-0.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground shrink-0 text-xs tabular-nums",
                                children: (0, $0c0f91b069db95d9$export$6b862160d295c8e)(rt.date).toLocaleString({
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "min-w-0 flex-1 truncate text-xs",
                                children: rt.description
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "shrink-0 text-xs tabular-nums",
                                children: (0, $a5f774b73aaf5820$export$317de5adef9ec643)(rt.amount)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        size: "icon",
                        variant: "ghost",
                        className: "size-7 shrink-0",
                        title: "Unlink from benefit",
                        onClick: ()=>handleUnlink(rt),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2814ca8ca76f8609$export$2e2bcd8739ae039), {
                            className: "size-4"
                        })
                    })
                ]
            }, rt._id))
    });
};





const $e7db7ad6c25ad786$var$CADENCE_SHORT = {
    monthly: 'mo',
    quarterly: 'qtr',
    semi_annual: 'half',
    annual: 'yr'
};
/**
 * One-line schedule summary for the row's subtitle: "$15/mo ($35 Dec)",
 * falling back to the total for irregular rows.
 */ const $e7db7ad6c25ad786$var$scheduleLabel = (benefit, feePeriod, totalAmount)=>{
    const schedule = (0, $5cfc8dfd09486d37$export$e7bebb98bee5e46f)(benefit.periods, {
        startDate: feePeriod.startDate,
        endDate: feePeriod.endDate
    });
    if (schedule == null) return `${(0, $a5f774b73aaf5820$export$5723d387948018e1)(totalAmount)} total`;
    const base = `${(0, $a5f774b73aaf5820$export$5723d387948018e1)(schedule.amountPerPeriod)}/${$e7db7ad6c25ad786$var$CADENCE_SHORT[schedule.cadence]}`;
    if (schedule.exceptions.length === 0) return base;
    // Every exception, not just the first — the editor permits several. A
    // multi-year period can hold two exceptions in the same-named month
    // ("Dec ’25, Dec ’26"); append years only when needed to tell them apart.
    const monthNames = schedule.exceptions.map((exception)=>(0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(exception.startDate).toLocaleString({
            month: 'short'
        }));
    const exceptions = schedule.exceptions.map((exception, index)=>{
        const month = monthNames[index];
        const ambiguous = monthNames.some((name, other)=>other !== index && name === month);
        const year = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(exception.startDate).year;
        return `${(0, $a5f774b73aaf5820$export$5723d387948018e1)(exception.amount)} ${month}${ambiguous ? ` \u{2019}${String(year).slice(2)}` : ''}`;
    }).join(', ');
    return `${base} (${exceptions})`;
};
/** Sort key: rows needing action first, in-rhythm rows next, resolved last */ const $e7db7ad6c25ad786$var$rowRank = (summary)=>summary.nextOpenWindow != null ? 0 : summary.nextFutureWindow != null ? 1 : 2;
const $e7db7ad6c25ad786$var$rowSortValue = (summary)=>summary.nextOpenWindow?.endDate ?? summary.nextFutureWindow?.startDate ?? Number.MAX_SAFE_INTEGER;
const $e7db7ad6c25ad786$var$WindowCell = ({ window: window, axis: axis })=>{
    const startOffset = (0, $853b33c2f2306612$export$f727f9cb476b8c8a)(axis, window.startDate);
    const endOffset = (0, $853b33c2f2306612$export$f727f9cb476b8c8a)(axis, window.endDate);
    const clampedStart = Math.max(0, startOffset);
    const clampedEnd = Math.min(axis.monthCount, endOffset);
    if (clampedEnd <= clampedStart) return null;
    const left = clampedStart / axis.monthCount * 100;
    const width = (clampedEnd - clampedStart) / axis.monthCount * 100;
    const clippedLeft = startOffset < -0.05;
    const clippedRight = endOffset > axis.monthCount + 0.05;
    // Wide cells carry a text label; month-sized cells rely on tint + tooltip
    const wide = clampedEnd - clampedStart >= 1.8;
    const usedPct = window.amount > 0 ? Math.max(0, Math.min(100, Math.round(window.usedAmount / window.amount * 100))) : 0;
    let cellClass;
    let label = null;
    let fill = null;
    switch(window.state){
        case 'over':
            cellClass = 'bg-destructive/15 ring-1 ring-inset ring-destructive/50';
            label = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-destructive",
                children: wide ? 'over cap' : '!'
            });
            break;
        case 'captured':
            cellClass = 'bg-green-500/15 ring-1 ring-inset ring-green-500/25';
            if (wide) label = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-positive/90",
                children: [
                    "\u2713 ",
                    (0, $a5f774b73aaf5820$export$5723d387948018e1)(window.usedAmount)
                ]
            });
            break;
        case 'booked':
            cellClass = 'stripe-booked ring-1 ring-inset ring-green-500/30';
            label = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-positive/80",
                children: wide ? `\u{21BB} ${(0, $a5f774b73aaf5820$export$5723d387948018e1)(window.amount)}` : "\u21BB"
            });
            break;
        case 'open':
            cellClass = 'bg-blue-500/10 ring-2 ring-inset ring-blue-400/70';
            if (window.usedAmount > 0) fill = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "absolute inset-y-0 left-0 bg-green-500/20",
                style: {
                    width: `${usedPct}%`
                }
            });
            label = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-blue-600 dark:text-blue-300",
                children: wide ? `${(0, $a5f774b73aaf5820$export$5723d387948018e1)(window.openRemaining)} \xb7 ${window.daysLeft}d` : `${window.daysLeft}d`
            });
            break;
        case 'partial':
            cellClass = 'ring-1 ring-inset ring-amber-500/30 bg-transparent';
            fill = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "absolute inset-y-0 left-0 bg-green-500/15",
                        style: {
                            width: `${usedPct}%`
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "stripe-missed absolute inset-y-0 right-0",
                        style: {
                            width: `${100 - usedPct}%`
                        }
                    })
                ]
            });
            if (wide) label = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-amber-700 dark:text-amber-400",
                children: [
                    (0, $a5f774b73aaf5820$export$5723d387948018e1)(window.usedAmount),
                    " \xb7 \u2212",
                    (0, $a5f774b73aaf5820$export$5723d387948018e1)(window.missedAmount)
                ]
            });
            break;
        case 'missed':
            cellClass = 'bg-amber-500/10 ring-1 ring-inset ring-amber-500/35';
            if (wide) label = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-amber-700 dark:text-amber-400",
                children: [
                    "\u2212",
                    (0, $a5f774b73aaf5820$export$5723d387948018e1)(window.missedAmount)
                ]
            });
            break;
        case 'future':
            cellClass = 'bg-muted/40';
            break;
    }
    const stateNote = window.state === 'over' ? " \u2014 exceeds window amount" : window.state === 'booked' ? ` \u{2014} ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(window.bookedAmount)} booked ahead` : window.state === 'open' ? ` \u{2014} ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(window.openRemaining)} claimable, ${window.daysLeft} days left` : window.missedAmount > 0 ? ` \u{2014} ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(window.missedAmount)} expired unused` : '';
    const title = `${(0, $a5f774b73aaf5820$export$a053908c5c4ea08d)(window.startDate, window.endDate)}: ${(0, $a5f774b73aaf5820$export$317de5adef9ec643)(window.usedAmount)} / ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(window.amount)}${stateNote}`;
    const clipStyle = {};
    if (clippedLeft || clippedRight) {
        const from = clippedLeft ? 'transparent 0, black 12px' : 'black 0';
        const to = clippedRight ? 'black calc(100% - 12px), transparent 100%' : 'black 100%';
        clipStyle.maskImage = `linear-gradient(90deg, ${from}, ${to})`;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        title: title,
        className: `absolute inset-y-0 overflow-hidden rounded-[4px] ${cellClass}`,
        style: {
            left: `${left}%`,
            // Floor at 3px so a legitimate one-day window stays visible
            width: `max(calc(${width}% - 2px), 3px)`,
            ...clipStyle
        },
        children: [
            fill,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "absolute inset-0 flex items-center justify-center text-[10px] font-semibold whitespace-nowrap",
                children: label
            })
        ]
    });
};
const $e7db7ad6c25ad786$var$BenefitRow = (props)=>{
    const { summary: summary, feePeriod: feePeriod, axis: axis, todayPct: todayPct, onUpdate: onUpdate } = props;
    const { benefit: benefit } = summary;
    const { editCardBenefitModal: editCardBenefitModal, deleteCardBenefitModal: deleteCardBenefitModal, createTransactionForBenefitModal: createTransactionForBenefitModal, generateBenefitCreditsModal: generateBenefitCreditsModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const [expanded, setExpanded] = $acw62.useState(false);
    const transactions = $acw62.useMemo(()=>benefit.periods.flatMap((period)=>period.rawTransactions).sort((a, b)=>b.date.localeCompare(a.date)), [
        benefit.periods
    ]);
    // Secondary summary: deviations first (missed, open), then booked, then a
    // quiet "complete" for fully-resolved rows
    const summaryParts = [];
    if (summary.missed > 0) summaryParts.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "text-amber-600 dark:text-amber-400",
        children: [
            "\u2212",
            (0, $a5f774b73aaf5820$export$5723d387948018e1)(summary.missed)
        ]
    }, "missed"));
    if (summary.open > 0) summaryParts.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "text-blue-600 dark:text-blue-300",
        children: [
            (0, $a5f774b73aaf5820$export$5723d387948018e1)(summary.open),
            " open"
        ]
    }, "open"));
    if (summary.hasOver) summaryParts.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-destructive",
        children: "over cap"
    }, "over"));
    if (summaryParts.length < 2 && summary.booked > 0) summaryParts.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "text-positive/90",
        children: [
            (0, $a5f774b73aaf5820$export$5723d387948018e1)(summary.booked),
            " booked"
        ]
    }, "booked"));
    if (summaryParts.length === 0 && summary.totalAmount > 0 && summary.totalUsed >= summary.totalAmount) summaryParts.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-positive/90",
        children: "complete"
    }, "complete"));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border border-t",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setExpanded((prev)=>!prev),
                "aria-expanded": expanded,
                className: "hover:bg-accent/20 grid w-full cursor-pointer grid-cols-[11rem_1fr_7.5rem] items-center gap-3 px-4 py-2 text-left",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-1.5",
                                children: [
                                    expanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        className: "text-muted-foreground size-3 shrink-0"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                        className: "text-muted-foreground size-3 shrink-0"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "truncate text-[13px] font-medium",
                                        children: benefit.name
                                    }),
                                    benefit.uncoveredRawTransactions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                        className: "size-3 shrink-0 text-amber-600 dark:text-amber-400"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-muted-foreground truncate pl-[18px] text-[11px]",
                                children: [
                                    $e7db7ad6c25ad786$var$scheduleLabel(benefit, feePeriod, summary.totalAmount),
                                    benefit.creditAccount != null && ` \u{2192} ${benefit.creditAccount.name}`
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative h-6",
                        children: [
                            summary.windows.map((window)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e7db7ad6c25ad786$var$WindowCell, {
                                    window: window,
                                    axis: axis
                                }, window.startDate)),
                            todayPct != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "bg-foreground/40 absolute inset-y-[-3px] w-px",
                                style: {
                                    left: `${todayPct}%`
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-right text-xs tabular-nums",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-semibold",
                                        children: (0, $a5f774b73aaf5820$export$66a540377a2b3d1e)(summary.totalUsed)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-muted-foreground",
                                        children: [
                                            ' ',
                                            "/ ",
                                            (0, $a5f774b73aaf5820$export$5723d387948018e1)(summary.totalAmount)
                                        ]
                                    })
                                ]
                            }),
                            summaryParts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-[11px]",
                                children: summaryParts.flatMap((part, index)=>index === 0 ? [
                                        part
                                    ] : [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground",
                                            children: " \xb7 "
                                        }, `sep-${index}`),
                                        part
                                    ])
                            })
                        ]
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-3 px-4 pt-1 pb-3 pl-[38px]",
                children: [
                    benefit.description != null && benefit.description !== '' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground text-xs",
                        children: benefit.description
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "outline",
                                className: "px-2.5 py-1 text-xs",
                                onClick: ()=>createTransactionForBenefitModal.openModal({
                                        benefit: benefit,
                                        feePeriodPayee: feePeriod.payee,
                                        onSuccess: onUpdate
                                    }),
                                children: "Record use"
                            }),
                            benefit.creditAccountId != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "outline",
                                className: "px-2.5 py-1 text-xs",
                                onClick: ()=>generateBenefitCreditsModal.openModal({
                                        benefit: benefit,
                                        feePeriodPayee: feePeriod.payee,
                                        onSuccess: onUpdate
                                    }),
                                children: "Create credits"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "outline",
                                className: "px-2.5 py-1 text-xs",
                                onClick: ()=>editCardBenefitModal.openModal({
                                        benefit: benefit,
                                        feePeriodStartDate: feePeriod.startDate,
                                        feePeriodEndDate: feePeriod.endDate,
                                        onSuccess: onUpdate
                                    }),
                                children: "Edit"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                className: "text-destructive px-2.5 py-1 text-xs",
                                onClick: ()=>deleteCardBenefitModal.openModal({
                                        benefit: benefit,
                                        onDeleted: onUpdate
                                    }),
                                children: "Delete"
                            })
                        ]
                    }),
                    transactions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-muted-foreground mb-1 text-[11px] font-medium tracking-wide uppercase",
                                children: [
                                    transactions.length,
                                    " linked transaction",
                                    transactions.length === 1 ? '' : 's'
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c39075059c0401f6$export$6d49a19ae083f17c), {
                                rawTransactions: transactions,
                                benefitName: benefit.name,
                                onUpdate: onUpdate
                            })
                        ]
                    }),
                    benefit.uncoveredRawTransactions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "mb-1 flex items-center gap-1.5 text-xs text-amber-600 dark:text-amber-400",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                        className: "size-3.5 shrink-0"
                                    }),
                                    (0, $a5f774b73aaf5820$export$317de5adef9ec643)(benefit.uncoveredAmount),
                                    " in linked transactions outside every window"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c39075059c0401f6$export$6d49a19ae083f17c), {
                                rawTransactions: benefit.uncoveredRawTransactions,
                                benefitName: benefit.name,
                                onUpdate: onUpdate
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $e7db7ad6c25ad786$export$80ab0f99e4496af2 = ({ feePeriod: feePeriod, onUpdate: onUpdate })=>{
    // Time-dependent throughout (window states shift as the clock runs), so
    // compute per render rather than memoizing on feePeriod alone
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    const axis = (0, $853b33c2f2306612$export$27ccb103633d41b1)(feePeriod);
    const summaries = feePeriod.benefits.map((benefit)=>(0, $853b33c2f2306612$export$4007b2e641a2850f)(benefit, now)).sort((a, b)=>$e7db7ad6c25ad786$var$rowRank(a) - $e7db7ad6c25ad786$var$rowRank(b) || $e7db7ad6c25ad786$var$rowSortValue(a) - $e7db7ad6c25ad786$var$rowSortValue(b) || b.totalAmount - a.totalAmount);
    const todayOffset = (0, $853b33c2f2306612$export$6861394b06ea24f3)(axis, now);
    const todayPct = todayOffset >= 0 && todayOffset <= axis.monthCount ? todayOffset / axis.monthCount * 100 : null;
    return(// Fixed name/summary columns plus ~1.7rem per month column; the parent
    // provides overflow-x scrolling when the viewport is narrower
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            minWidth: `${20 + axis.monthCount * 1.7}rem`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground grid grid-cols-[11rem_1fr_7.5rem] items-end gap-3 px-4 pb-1.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "grid text-center text-[9px] font-medium tracking-wider",
                                style: {
                                    gridTemplateColumns: `repeat(${axis.monthCount}, minmax(0, 1fr))`
                                },
                                children: axis.labels.map((label, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: label
                                    }, index))
                            }),
                            todayPct != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-foreground/70 absolute -top-3 -translate-x-1/2 text-[9px] font-semibold tracking-wider whitespace-nowrap",
                                style: {
                                    left: `${todayPct}%`
                                },
                                children: now.toUTC().toLocaleString({
                                    month: 'short',
                                    day: 'numeric'
                                }).toUpperCase()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-right text-[10px]",
                        children: "captured / cap"
                    })
                ]
            }),
            summaries.map((summary)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e7db7ad6c25ad786$var$BenefitRow, {
                    summary: summary,
                    feePeriod: feePeriod,
                    axis: axis,
                    todayPct: todayPct,
                    onUpdate: onUpdate
                }, summary.benefit._id))
        ]
    }));
};



const $08f083f434263c0a$export$95cd9f30d7317f0f = ({ stats: stats })=>{
    if (stats.potential <= 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-muted/40 h-1.5 rounded-full"
    });
    const pct = (cents)=>`${Math.max(0, Math.min(100, cents / stats.potential * 100))}%`;
    const spans = (0, $853b33c2f2306612$export$549a9d736f93e9f7)(stats);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-muted/40 flex h-1.5 overflow-hidden rounded-full",
        title: `${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(Math.max(0, stats.captured))} of ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(stats.potential)} captured`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "bg-green-500/50",
                style: {
                    width: pct(spans.posted)
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "stripe-booked",
                style: {
                    width: pct(spans.booked)
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "bg-blue-400/60",
                style: {
                    width: pct(stats.open)
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "flex-1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "stripe-missed",
                style: {
                    width: pct(stats.missed)
                }
            })
        ]
    });
};
const $08f083f434263c0a$export$81edf677cff26e43 = (props)=>{
    const { stats: stats, defaultExpanded: defaultExpanded, previousFeePeriodId: previousFeePeriodId, onUpdate: onUpdate, onCopyFromPrevious: onCopyFromPrevious } = props;
    const { feePeriod: feePeriod, isCurrent: isCurrent } = stats;
    const { editFeePeriodModal: editFeePeriodModal, deleteFeePeriodModal: deleteFeePeriodModal, createCardBenefitModal: createCardBenefitModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const [expanded, setExpanded] = $acw62.useState(defaultExpanded);
    const [copying, setCopying] = $acw62.useState(false);
    // An edit can move a period across the current/past boundary while the
    // component keeps its key (so the initializer won't re-run). Re-sync the
    // default expansion when that flips, without clobbering manual toggles.
    $acw62.useEffect(()=>{
        setExpanded(defaultExpanded);
    }, [
        defaultExpanded
    ]);
    const startYear = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(feePeriod.startDate).year;
    const hasBenefits = feePeriod.benefits.length > 0;
    const showCopyButton = !hasBenefits && previousFeePeriodId != null;
    const handleCopy = async ()=>{
        if (previousFeePeriodId != null && !copying) {
            setCopying(true);
            try {
                await onCopyFromPrevious(previousFeePeriodId, feePeriod._id);
            } finally{
                setCopying(false);
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card rounded-lg border",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-1 pr-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setExpanded((prev)=>!prev),
                        "aria-expanded": expanded,
                        // Narrow screens keep only the year label and net; the meter and
                        // captured/missed columns return at lg (the app shell keeps a 300px sidebar above the sm breakpoint)
                        className: "grid flex-1 cursor-pointer grid-cols-[minmax(0,1fr)_auto] items-center gap-3 px-4 py-2.5 text-left lg:grid-cols-[minmax(10rem,14rem)_1fr_7.5rem_5rem_6rem]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex min-w-0 items-center gap-1.5",
                                children: [
                                    expanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        className: "text-muted-foreground size-3.5 shrink-0"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                        className: "text-muted-foreground size-3.5 shrink-0"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-sm font-semibold whitespace-nowrap",
                                        children: [
                                            "FY ",
                                            startYear
                                        ]
                                    }),
                                    isCurrent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "bg-primary/10 text-primary rounded-full px-2 py-0.5 text-[10px] font-medium",
                                        children: "Current"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-muted-foreground truncate text-xs",
                                        children: [
                                            (0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(feePeriod.amount),
                                            " fee"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "hidden lg:block",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08f083f434263c0a$export$95cd9f30d7317f0f, {
                                    stats: stats
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "hidden text-right text-xs tabular-nums lg:block",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-medium",
                                        children: (0, $a5f774b73aaf5820$export$66a540377a2b3d1e)(stats.captured)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-muted-foreground",
                                        children: [
                                            ' ',
                                            "/ ",
                                            (0, $a5f774b73aaf5820$export$5723d387948018e1)(stats.potential)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "hidden text-right text-xs tabular-nums lg:block",
                                children: stats.missed > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "text-amber-600 dark:text-amber-400",
                                    children: [
                                        "\u2212",
                                        (0, $a5f774b73aaf5820$export$5723d387948018e1)(stats.missed)
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground",
                                    children: "\u2014"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: `text-right text-xs font-medium tabular-nums ${stats.net >= 0 ? 'text-positive' : 'text-destructive'}`,
                                children: [
                                    "net ",
                                    (0, $a5f774b73aaf5820$export$9fd9a6c97e959d35)(stats.net)
                                ]
                            })
                        ]
                    }),
                    expanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex shrink-0 gap-0.5",
                        children: [
                            showCopyButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                size: "icon",
                                variant: "ghost",
                                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                                onClick: handleCopy,
                                disabled: copying,
                                title: "Copy benefits from previous period",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                size: "icon",
                                variant: "ghost",
                                title: "Add benefit",
                                onClick: ()=>createCardBenefitModal.openModal({
                                        feePeriodId: feePeriod._id,
                                        feePeriodStartDate: feePeriod.startDate,
                                        feePeriodEndDate: feePeriod.endDate,
                                        cardAccountId: feePeriod.accountId,
                                        onSuccess: onUpdate
                                    }),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                size: "icon",
                                variant: "ghost",
                                title: "Edit fee period",
                                onClick: ()=>editFeePeriodModal.openModal({
                                        feePeriod: feePeriod,
                                        onSuccess: onUpdate
                                    }),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                size: "icon",
                                variant: "ghost",
                                title: "Delete fee period",
                                onClick: ()=>deleteFeePeriodModal.openModal({
                                        feePeriod: feePeriod,
                                        onDeleted: onUpdate
                                    }),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            })
                        ]
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-muted-foreground border-border border-t px-4 py-1.5 pl-[38px] text-[11px]",
                        children: [
                            (0, $a5f774b73aaf5820$export$2e9241a0bdf6c8b8)(feePeriod.startDate, feePeriod.endDate),
                            " \xb7 ",
                            feePeriod.rawTransaction != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                to: `/raw-transactions/${feePeriod.rawTransaction._id}`,
                                className: "hover:text-foreground",
                                children: [
                                    "fee ",
                                    (0, $0c0f91b069db95d9$export$6b862160d295c8e)(feePeriod.rawTransaction.date).toLocaleString({
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    }),
                                    ' ',
                                    "\xb7 ",
                                    feePeriod.rawTransaction.description,
                                    " \xb7",
                                    ' ',
                                    (0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(feePeriod.rawTransaction.amount)
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "fee transaction: ",
                                    feePeriod.rawTransactionId
                                ]
                            }),
                            stats.uncovered !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-amber-600 dark:text-amber-400",
                                children: [
                                    ' ',
                                    "\xb7 ",
                                    (0, $a5f774b73aaf5820$export$317de5adef9ec643)(stats.uncovered),
                                    " linked outside windows"
                                ]
                            })
                        ]
                    }),
                    hasBenefits ? // The grid sets its own min width (it scales with the axis); on
                    // narrow screens it scrolls inside this container, not the page
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "border-border overflow-x-auto border-t pt-2 pb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7db7ad6c25ad786$export$80ab0f99e4496af2), {
                            feePeriod: feePeriod,
                            onUpdate: onUpdate
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border-border text-muted-foreground border-t px-4 py-4 text-center text-sm",
                        children: [
                            "No benefits for this period yet.",
                            showCopyButton && " Use the copy button to bring last year\u2019s over."
                        ]
                    })
                ]
            })
        ]
    });
};



var $acw62 = parcelRequire("acw62");
const $c97fcc07e588b835$export$88da3a4d83ed79ab = (intervalMs = 60000)=>{
    const [, setTick] = $acw62.useState(0);
    $acw62.useEffect(()=>{
        const id = setInterval(()=>setTick((tick)=>tick + 1), intervalMs);
        return ()=>clearInterval(id);
    }, [
        intervalMs
    ]);
};





parcelRequire("acw62");


const $9d5514a995335d19$var$TONE_CLASS = {
    default: '',
    sage: 'text-positive',
    blue: 'text-blue-600 dark:text-blue-300',
    amber: 'text-amber-600 dark:text-amber-400',
    red: 'text-destructive'
};
const $9d5514a995335d19$export$d27a382dda47f62b = ({ value: value, tone: tone = 'default', sub: sub })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card rounded-lg border px-3.5 py-2.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `text-base font-semibold tabular-nums ${$9d5514a995335d19$var$TONE_CLASS[tone]}`,
                children: value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground text-[11px] leading-snug",
                children: sub
            })
        ]
    });
const $9d5514a995335d19$var$formatDay = (seconds)=>(0, $a5f774b73aaf5820$export$409494cf6876ac3e)(seconds).toLocaleString({
        month: 'short',
        day: 'numeric'
    });
const $9d5514a995335d19$export$632a8846a2fb6da9 = ({ stats: stats })=>{
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    // The open windows sharing the nearest deadline, for "$175 expires Sep 30"
    let expiringSum = 0;
    let nearestEnd = null;
    for (const summary of stats.benefits)for (const window of summary.windows){
        if (window.state !== 'open' || window.openRemaining <= 0) continue;
        if (nearestEnd == null || window.endDate < nearestEnd) {
            nearestEnd = window.endDate;
            expiringSum = window.openRemaining;
        } else if (window.endDate === nearestEnd) expiringSum += window.openRemaining;
    }
    const openingSoon = (0, $853b33c2f2306612$export$f2a3b994c1e847e)([
        stats.feePeriod
    ], now, 60);
    // Sum EVERY future window inside the horizon, not buildOpeningSoon's
    // one-per-benefit list — a monthly credit can have two windows open
    // within 60 days
    const horizon = now.plus({
        days: 60
    });
    let openingSoonSum = 0;
    for (const summary of stats.benefits){
        for (const window of summary.windows)if (window.state === 'future' && (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(window.startDate) <= horizon) openingSoonSum += Math.max(0, window.amount - window.usedAmount);
    }
    // Built from signed captured (not potential − missed) so a clawed-back
    // expired window keeps its negative balance and an over-cap window keeps
    // its overage in the best case
    const maxNet = stats.captured + stats.open + stats.future - stats.fee;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid grid-cols-2 gap-2.5 lg:grid-cols-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9d5514a995335d19$export$d27a382dda47f62b, {
                value: `net ${(0, $a5f774b73aaf5820$export$9fd9a6c97e959d35)(stats.net)}`,
                tone: stats.net >= 0 ? 'sage' : 'red',
                sub: `posted + booked \u{2212} ${(0, $a5f774b73aaf5820$export$5723d387948018e1)(stats.fee)} fee`
            }),
            stats.open > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9d5514a995335d19$export$d27a382dda47f62b, {
                value: `${(0, $a5f774b73aaf5820$export$5723d387948018e1)(stats.open)} claimable`,
                tone: "blue",
                sub: nearestEnd != null ? `${stats.openWindowCount} open window${stats.openWindowCount === 1 ? '' : 's'} \xb7 ${(0, $a5f774b73aaf5820$export$5723d387948018e1)(expiringSum)} expires ${$9d5514a995335d19$var$formatDay(nearestEnd)}` : `${stats.openWindowCount} open windows`
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9d5514a995335d19$export$d27a382dda47f62b, {
                value: "nothing open",
                sub: openingSoon.length > 0 ? `next window opens ${(0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(openingSoon[0].window.startDate).toLocaleString({
                    month: 'short',
                    day: 'numeric'
                })}` : 'no upcoming windows'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9d5514a995335d19$export$d27a382dda47f62b, {
                value: stats.missed > 0 ? `${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(stats.missed)} missed` : 'nothing missed',
                tone: stats.missed > 0 ? 'amber' : 'default',
                sub: stats.missed > 0 ? `${stats.missedWindowCount} window${stats.missedWindowCount === 1 ? '' : 's'} expired unused` : 'no windows expired unused yet'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9d5514a995335d19$export$d27a382dda47f62b, {
                value: `${(0, $a5f774b73aaf5820$export$9fd9a6c97e959d35)(maxNet)} max`,
                sub: openingSoonSum > 0 ? `year-end net if nothing lapses \xb7 ${(0, $a5f774b73aaf5820$export$5723d387948018e1)(openingSoonSum)} opens within 60d` : 'year-end net if nothing else lapses'
            })
        ]
    });
};
const $9d5514a995335d19$var$CHART_HEIGHT = 128;
const $9d5514a995335d19$export$85386c748ee333ab = ({ years: years })=>{
    const ascending = [
        ...years
    ].sort((a, b)=>a.feePeriod.startDate - b.feePeriod.startDate);
    const scaleMax = Math.max(1, ...ascending.map((year)=>Math.max(year.captured, year.fee))) * 1.05;
    const px = (cents)=>Math.round(Math.max(0, cents) / scaleMax * $9d5514a995335d19$var$CHART_HEIGHT);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card rounded-lg border px-4 pt-3 pb-2.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-baseline justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground text-xs",
                        children: [
                            "Captured credits vs annual fee",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "opacity-70",
                                children: "(points & perks untracked)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground flex items-center gap-3 text-[10px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "inline-block h-2.5 w-2.5 rounded-[3px] bg-green-500/25 ring-1 ring-green-500/40 ring-inset"
                                    }),
                                    "captured"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "bg-foreground/50 inline-block h-[2px] w-3"
                                    }),
                                    "fee"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2 grid items-end gap-2",
                style: {
                    gridTemplateColumns: `repeat(${ascending.length}, minmax(0, 1fr))`
                },
                children: ascending.map((year)=>{
                    const startYear = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(year.feePeriod.startDate).year;
                    const spans = (0, $853b33c2f2306612$export$549a9d736f93e9f7)(year);
                    const posted = px(spans.posted);
                    const booked = px(spans.posted + spans.booked) - posted;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center gap-1",
                        title: `FY ${startYear}: ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(Math.max(0, year.captured))} of ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(year.potential)} captured \xb7 ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(year.fee)} fee \xb7 net ${(0, $a5f774b73aaf5820$export$9fd9a6c97e959d35)(year.net)}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative w-full",
                                style: {
                                    height: $9d5514a995335d19$var$CHART_HEIGHT
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "absolute inset-x-0 bottom-0 mx-auto w-6",
                                        children: [
                                            booked > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "stripe-booked w-full rounded-t-[4px] ring-1 ring-green-500/30 ring-inset",
                                                style: {
                                                    height: booked
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `w-full bg-green-500/25 ring-1 ring-green-500/40 ring-inset ${booked > 0 ? '' : 'rounded-t-[4px]'}`,
                                                style: {
                                                    height: Math.max(posted, spans.posted > 0 ? 2 : 0)
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-foreground/50 absolute left-1/2 h-[2px] w-9 max-w-full -translate-x-1/2",
                                        style: {
                                            bottom: px(year.fee)
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `text-[10px] font-medium tabular-nums ${year.net >= 0 ? 'text-positive' : 'text-destructive'}`,
                                children: (0, $a5f774b73aaf5820$export$9fd9a6c97e959d35)(Math.round(year.net / 100) * 100)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `text-[10px] tabular-nums ${year.isCurrent ? 'text-foreground font-medium' : 'text-muted-foreground'}`,
                                children: [
                                    "\u2019",
                                    String(startYear).slice(2)
                                ]
                            })
                        ]
                    }, year.feePeriod._id);
                })
            })
        ]
    });
};




parcelRequire("acw62");

const $20f86f33905a87dd$export$b3bb6a251ee1ac06 = ({ children: children, className: className, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        ...props,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-muted-foreground hover:text-foreground hover:border-foreground/30 hover:bg-muted/50 flex w-full cursor-pointer items-center justify-center gap-1.5 rounded-lg border-2 border-dashed py-3 text-sm transition-colors', className),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                className: "h-4 w-4"
            }),
            children
        ]
    });
};



const $63af3e702c74fd6f$export$5fcc2ea9fcaf9d47 = ()=>{
    const { id: accountId = '' } = (0, $926608a7a86d7371$export$99eaa27ddbbb95ef)();
    const { createFeePeriodModal: createFeePeriodModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    // Window states and countdowns are clock-derived; tick so a page left
    // open across a day boundary stays honest
    (0, $c97fcc07e588b835$export$88da3a4d83ed79ab)();
    const { data: feePeriodData, loading: loading, refetch: refetch } = (0, $ce9d9e524be20f53$export$97b73cd64565cbb0)({
        variables: {
            accountId: accountId
        }
    });
    const [copyBenefits] = (0, $ce9d9e524be20f53$export$a15cb28a00ce8458)();
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading benefits..."
        })
    });
    // Most recent fee period first. Window states depend on the clock, so
    // derive per render rather than memoizing on the query data alone.
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    const feePeriods = [
        ...feePeriodData?.feePeriodsByAccount ?? []
    ].sort((a, b)=>b.startDate - a.startDate);
    const yearStats = feePeriods.map((feePeriod)=>(0, $853b33c2f2306612$export$f9b975a80d6d4e01)(feePeriod, now));
    const currentStats = yearStats.find((stats)=>stats.isCurrent) ?? null;
    // With no current cycle, feature what findDisplayPeriod picks: the nearest
    // upcoming period (not the farthest-future prefill), else the most recent
    const expandedId = currentStats?.feePeriod._id ?? (0, $a5f774b73aaf5820$export$859cbae57b7e86ba)(feePeriods)?._id ?? null;
    const handleRefetch = ()=>{
        refetch();
    };
    const handleCreateFeePeriod = ()=>{
        createFeePeriodModal.openModal({
            accountId: accountId,
            excludeRawTransactionIds: feePeriods.map((fp)=>fp.rawTransactionId),
            onSuccess: handleRefetch
        });
    };
    const handleCopyFromPrevious = async (sourceFeePeriodId, targetFeePeriodId)=>{
        try {
            await copyBenefits({
                variables: {
                    sourceFeePeriodId: sourceFeePeriodId,
                    targetFeePeriodId: targetFeePeriodId
                }
            });
            refetch();
        } catch  {
        // Error is shown by Apollo
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-1 flex-col gap-3 overflow-y-auto p-4",
        children: feePeriods.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "border-border rounded-lg border border-dashed p-8 text-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground mb-4",
                    children: "No fee periods added yet"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground mb-4 text-sm",
                    children: "Add fee periods to track annual fees and their associated card benefits. Each fee period links to a fee charge transaction and contains the benefits for that period."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: handleCreateFeePeriod,
                    type: "button",
                    children: "Add your first fee period"
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                currentStats != null && currentStats.potential > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5514a995335d19$export$632a8846a2fb6da9), {
                    stats: currentStats
                }),
                yearStats.length >= 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5514a995335d19$export$85386c748ee333ab), {
                    years: yearStats
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f86f33905a87dd$export$b3bb6a251ee1ac06), {
                    onClick: handleCreateFeePeriod,
                    children: "Add Fee Period"
                }),
                yearStats.map((stats, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $08f083f434263c0a$export$81edf677cff26e43), {
                        stats: stats,
                        defaultExpanded: stats.feePeriod._id === expandedId,
                        // With the newest period first, the chronologically previous
                        // period is the next entry in the list
                        previousFeePeriodId: index < feePeriods.length - 1 && feePeriods[index + 1].benefits.length > 0 ? feePeriods[index + 1]._id : null,
                        onUpdate: handleRefetch,
                        onCopyFromPrevious: handleCopyFromPrevious
                    }, stats.feePeriod._id))
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");

const $5f9091afcb8d9899$export$8c292b02ce03981f = (store, newCategory)=>{
    const data = store.readQuery({
        query: (0, $ce9d9e524be20f53$export$d17ad941deb6ba54)
    });
    const categories = data?.allCategories || [];
    if (!categories.find((c)=>c._id === newCategory._id)) store.writeQuery({
        query: (0, $ce9d9e524be20f53$export$d17ad941deb6ba54),
        data: {
            allCategories: [
                ...categories,
                newCategory
            ]
        }
    });
};
const $5f9091afcb8d9899$export$77a8937f2ee84f73 = (store, oldCategory)=>{
    const data = store.readQuery({
        query: (0, $ce9d9e524be20f53$export$d17ad941deb6ba54)
    });
    const categories = data?.allCategories || [];
    const index = categories.findIndex((c)=>c._id === oldCategory._id);
    if (index !== -1) store.writeQuery({
        query: (0, $ce9d9e524be20f53$export$d17ad941deb6ba54),
        data: {
            allCategories: [
                ...categories.slice(0, index),
                ...categories.slice(index + 1)
            ]
        }
    });
};







var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");

const $c57dbaeaea7da703$export$358303cbde861097 = ({ options: options, value: value, onChange: onChange, className: className })=>{
    const selectedIndex = options.findIndex((option)=>option.value === value);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $85fc2fe65ff21506$exports.twMerge)('bg-muted relative inline-grid auto-cols-fr grid-flow-col rounded-lg p-1', className),
        children: [
            selectedIndex >= 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "aria-hidden": true,
                // Slides between segments; the track is padded by 0.25rem on each
                // side, so each segment is (100% - 0.5rem) / n wide and translateX
                // is relative to the thumb's own width
                className: "bg-background absolute inset-y-1 left-1 rounded-md shadow-sm transition-transform duration-300 ease-[cubic-bezier(0.3,1.35,0.5,1)] motion-reduce:transition-none",
                style: {
                    width: `calc((100% - 0.5rem) / ${options.length})`,
                    transform: `translateX(${selectedIndex * 100}%)`
                }
            }),
            options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    "aria-pressed": option.value === value,
                    className: `relative cursor-pointer rounded-md px-3 py-1.5 text-sm font-medium whitespace-nowrap transition-colors ${option.value === value ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'}`,
                    onClick: ()=>onChange(option.value),
                    children: option.label
                }, option.value))
        ]
    });
};


const $8a1576d3e1c876a5$export$7de928fcb7b09e8b = ({ value: value, onChange: onChange, cardAccountId: cardAccountId })=>{
    const [loadedToOther, setLoadedToOther] = $acw62.useState(value != null);
    const { data: data } = (0, $ce9d9e524be20f53$export$cb6e321bdf608ddb)({
        skip: !loadedToOther
    });
    const selectedAccount = $acw62.useMemo(()=>{
        const match = data?.allAccounts.find((a)=>a._id === value);
        return match ? (0, $f8f45ddea4959097$exports.some)(match) : (0, $f8f45ddea4959097$exports.none);
    }, [
        data,
        value
    ]);
    const handleSelect = (account)=>{
        onChange(account.map((a)=>a._id).getOrElse(null));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: "text-sm font-medium",
                children: "Credit destination"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c57dbaeaea7da703$export$358303cbde861097), {
                className: "self-start",
                options: [
                    {
                        value: 'card',
                        label: 'Refunded on this card'
                    },
                    {
                        value: 'other',
                        label: 'Loaded to another account'
                    }
                ],
                value: loadedToOther ? 'other' : 'card',
                onChange: (next)=>{
                    if (next === 'card') {
                        setLoadedToOther(false);
                        onChange(null);
                    } else setLoadedToOther(true);
                }
            }),
            loadedToOther ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $295751b0f96fd69d$export$2e2bcd8739ae039), {
                        selectedAccount: selectedAccount,
                        onSelectAccount: handleSelect,
                        excludeIds: [
                            cardAccountId
                        ],
                        // Benefit credits post as USD raws in the destination account.
                        currency: "USD"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground text-xs",
                        children: "Credits arrive on this account (e.g. Uber Cash) and can be recorded with one click from the Inbox"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground text-xs",
                children: "Credits post back to the card and are linked from its transaction feed"
            })
        ]
    });
};





/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2bae87ad456fae2e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14 17H5",
            key: "gfn3mx"
        }
    ],
    [
        "path",
        {
            d: "M19 7h-9",
            key: "6i9tg"
        }
    ],
    [
        "circle",
        {
            cx: "17",
            cy: "17",
            r: "3",
            key: "18b49y"
        }
    ],
    [
        "circle",
        {
            cx: "7",
            cy: "7",
            r: "3",
            key: "dfmy0x"
        }
    ]
];
const $2bae87ad456fae2e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("settings-2", $2bae87ad456fae2e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5faf23ec0b8e3e8e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
            key: "1s2grr"
        }
    ],
    [
        "path",
        {
            d: "M20 2v4",
            key: "1rf3ol"
        }
    ],
    [
        "path",
        {
            d: "M22 4h-4",
            key: "gwowj6"
        }
    ],
    [
        "circle",
        {
            cx: "4",
            cy: "20",
            r: "2",
            key: "6kqj1y"
        }
    ]
];
const $5faf23ec0b8e3e8e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("sparkles", $5faf23ec0b8e3e8e$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");



const $687e30a8e0ff8689$var$formatDate = (date)=>date.toLocaleString({
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
const $687e30a8e0ff8689$export$265a8bf67b012c7b = ({ periods: periods, onChange: onChange, defaultCustomize: defaultCustomize, defaultGenStartDate: defaultGenStartDate, onError: onError })=>{
    const [customize, setCustomize] = $acw62.useState(defaultCustomize);
    // AI generation state
    const [showGenerate, setShowGenerate] = $acw62.useState(false);
    const [genDescription, setGenDescription] = $acw62.useState('');
    const [genStartDate, setGenStartDate] = $acw62.useState(defaultGenStartDate);
    const [genYears, setGenYears] = $acw62.useState('1');
    const [generatePeriods, { loading: generating }] = (0, $ce9d9e524be20f53$export$1008bbcb8498d18d)();
    const handleAddPeriod = ()=>{
        onChange([
            ...periods,
            {
                startDate: (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)(),
                endDate: (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)(),
                amount: ''
            }
        ]);
    };
    const handleRemovePeriod = (index)=>{
        onChange(periods.filter((_, i)=>i !== index));
    };
    const handlePeriodDateChange = (index, field, value)=>{
        const updated = [
            ...periods
        ];
        updated[index] = {
            ...updated[index],
            [field]: value
        };
        onChange(updated);
    };
    const handlePeriodAmountChange = (index, value)=>{
        const updated = [
            ...periods
        ];
        updated[index] = {
            ...updated[index],
            amount: value
        };
        onChange(updated);
    };
    const handleGenerate = async ()=>{
        onError(null);
        try {
            if (!genStartDate.isValid) throw new Error('Invalid start date');
            const years = parseInt(genYears, 10);
            if (isNaN(years) || years < 1) throw new Error('Years must be at least 1');
            const result = await generatePeriods({
                variables: {
                    description: genDescription,
                    startDate: genStartDate.toISODate(),
                    years: years
                }
            });
            if (result.data) {
                const generated = result.data.generateBenefitPeriods.map((p)=>({
                        startDate: (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(p.startDate),
                        endDate: (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(p.endDate),
                        amount: (p.amount / 100).toFixed(2)
                    }));
                onChange(generated);
                setShowGenerate(false);
            }
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            onError(err.message);
        }
    };
    // Simple view is only meaningful for a single period; multi-period benefits
    // always show the full editor
    if (!customize && periods.length === 1) {
        const period = periods[0];
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-1",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Amount"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "ghost",
                            type: "button",
                            className: "text-muted-foreground text-sm",
                            onClick: ()=>setCustomize(true),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bae87ad456fae2e$export$2e2bcd8739ae039), {
                                    className: "mr-1 h-4 w-4"
                                }),
                                "Customize periods"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-muted-foreground pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm",
                            children: "$"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: period.amount,
                            onChange: (v)=>handlePeriodAmountChange(0, v),
                            placeholder: "0.00",
                            className: "pl-7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-muted-foreground text-xs",
                    children: [
                        "For ",
                        $687e30a8e0ff8689$var$formatDate(period.startDate),
                        " \u2013 ",
                        $687e30a8e0ff8689$var$formatDate(period.endDate)
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "text-sm font-medium",
                        children: "Periods"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "outline",
                                type: "button",
                                onClick: ()=>setShowGenerate(!showGenerate),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                        className: "mr-1 h-4 w-4"
                                    }),
                                    "Generate with AI"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "outline",
                                type: "button",
                                onClick: handleAddPeriod,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        className: "mr-1 h-4 w-4"
                                    }),
                                    "Add period"
                                ]
                            })
                        ]
                    })
                ]
            }),
            showGenerate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-muted/50 flex flex-col gap-2 rounded-md border p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "text-xs font-medium",
                                children: "Description"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                value: genDescription,
                                onChange: setGenDescription,
                                placeholder: 'e.g., "$10/month Uber credit, resets on the 1st"'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-1 flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "text-xs font-medium",
                                        children: "Start date"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                        selectedDate: genStartDate,
                                        onChange: setGenStartDate
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex w-24 flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "text-xs font-medium",
                                        children: "Years"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                        type: "number",
                                        value: genYears,
                                        onChange: setGenYears,
                                        min: "1"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "primary",
                        type: "button",
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        onClick: handleGenerate,
                        disabled: generating || !genDescription.trim(),
                        children: generating ? 'Generating...' : 'Generate'
                    })
                ]
            }),
            periods.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground text-sm",
                children: "No periods added yet. Add manually or generate with AI."
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col gap-2",
                children: periods.map((period, index)=>// flex-wrap lets the amount drop to its own full-width line on
                    // narrow screens instead of getting crushed next to the dates
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex shrink-0 items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-32",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                            selectedDate: period.startDate,
                                            onChange: (v)=>handlePeriodDateChange(index, 'startDate', v)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground text-sm",
                                        children: "\u2013"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-32",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                            selectedDate: period.endDate,
                                            onChange: (v)=>handlePeriodDateChange(index, 'endDate', v)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex min-w-36 flex-1 items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "relative flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-muted-foreground pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm",
                                                children: "$"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                                value: period.amount,
                                                onChange: (v)=>handlePeriodAmountChange(index, v),
                                                placeholder: "0.00",
                                                className: "pl-7"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                        size: "icon",
                                        variant: "ghost",
                                        type: "button",
                                        onClick: ()=>handleRemovePeriod(index),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        })
                                    })
                                ]
                            })
                        ]
                    }, index))
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");



const $0ebcc03374bb17f0$export$33147296b8d2b0c6 = {
    cadence: 'monthly',
    calendarAligned: false,
    amount: '',
    exceptions: []
};
const $0ebcc03374bb17f0$var$centsToDollars = (cents)=>(cents / 100).toFixed(2);
const $0ebcc03374bb17f0$export$e6af5835eb92fddd = (schedule)=>({
        cadence: schedule.cadence,
        calendarAligned: schedule.calendarAligned,
        amount: $0ebcc03374bb17f0$var$centsToDollars(schedule.amountPerPeriod),
        exceptions: schedule.exceptions.map((e)=>({
                startDate: e.startDate,
                amount: $0ebcc03374bb17f0$var$centsToDollars(e.amount)
            }))
    });
const $0ebcc03374bb17f0$var$parseCents = (dollars, label)=>{
    const cents = Math.round(parseFloat(dollars) * 100);
    if (isNaN(cents) || cents <= 0) throw new Error(`${label} must be positive`);
    return cents;
};
const $0ebcc03374bb17f0$export$29ddfb52dd34af8b = (state, bounds)=>{
    const starts = state.exceptions.map((e)=>e.startDate);
    if (new Set(starts).size !== starts.length) throw new Error('Each period can only have one exception');
    return (0, $5cfc8dfd09486d37$export$42234701d55e3643)({
        cadence: state.cadence,
        calendarAligned: state.calendarAligned,
        amountPerPeriod: $0ebcc03374bb17f0$var$parseCents(state.amount, 'Amount'),
        startDate: bounds.startDate,
        endDate: bounds.endDate,
        exceptions: state.exceptions.map((e)=>({
                startDate: e.startDate,
                amount: $0ebcc03374bb17f0$var$parseCents(e.amount, 'Exception amount')
            }))
    });
};
const $0ebcc03374bb17f0$var$CADENCE_OPTIONS = [
    {
        value: 'monthly',
        label: 'Monthly'
    },
    {
        value: 'quarterly',
        label: 'Quarterly'
    },
    {
        value: 'semi_annual',
        label: 'Semi-Annual'
    },
    {
        value: 'annual',
        label: 'Annual'
    }
];
const $0ebcc03374bb17f0$export$6f121fef6704acfe = ({ value: value, onChange: onChange, bounds: bounds })=>{
    const set = (key, val)=>onChange({
            ...value,
            [key]: val
        });
    // Preview periods for the exception pickers (amounts are irrelevant here)
    const periodOptions = $acw62.useMemo(()=>(0, $5cfc8dfd09486d37$export$42234701d55e3643)({
            cadence: value.cadence,
            calendarAligned: value.calendarAligned,
            amountPerPeriod: 0,
            startDate: bounds.startDate,
            endDate: bounds.endDate
        }).map((p)=>({
                startDate: p.startDate,
                label: (0, $a5f774b73aaf5820$export$a053908c5c4ea08d)(p.startDate, p.endDate)
            })), [
        value.cadence,
        value.calendarAligned,
        bounds.startDate,
        bounds.endDate
    ]);
    const handleAddException = ()=>{
        const taken = new Set(value.exceptions.map((e)=>e.startDate));
        const firstFree = periodOptions.find((p)=>!taken.has(p.startDate));
        if (!firstFree) return;
        set('exceptions', [
            ...value.exceptions,
            {
                startDate: firstFree.startDate,
                amount: ''
            }
        ]);
    };
    const handleExceptionChange = (index, change)=>{
        const updated = [
            ...value.exceptions
        ];
        updated[index] = {
            ...updated[index],
            ...change
        };
        set('exceptions', updated);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "text-xs font-medium",
                                children: "Frequency"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                className: "border-input bg-background rounded-md border px-3 py-1.5 text-sm",
                                value: value.cadence,
                                onChange: (e)=>{
                                    const match = $0ebcc03374bb17f0$var$CADENCE_OPTIONS.find((o)=>o.value === e.target.value);
                                    if (match) // Changing the frequency invalidates period-keyed exceptions
                                    onChange({
                                        ...value,
                                        cadence: match.value,
                                        exceptions: []
                                    });
                                },
                                children: $0ebcc03374bb17f0$var$CADENCE_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: opt.value,
                                        children: opt.label
                                    }, opt.value))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-1 flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "text-xs font-medium",
                                children: "Amount per period"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm",
                                        children: "$"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                        value: value.amount,
                                        onChange: (v)=>set('amount', v),
                                        placeholder: "0.00",
                                        className: "pl-7"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "flex items-center gap-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "checkbox",
                        checked: value.calendarAligned,
                        onChange: (e)=>{
                            // Realigning moves period boundaries, so period-keyed
                            // exceptions no longer apply
                            onChange({
                                ...value,
                                calendarAligned: e.target.checked,
                                exceptions: []
                            });
                        }
                    }),
                    "Align to calendar (e.g. monthly periods reset on the 1st)"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    value.exceptions.map((exception, index)=>{
                        // Each period can carry only one exception — hide periods already
                        // taken by other rows (explodeSchedule would drop the duplicate)
                        const takenByOthers = new Set(value.exceptions.filter((_, i)=>i !== index).map((e)=>e.startDate));
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                    className: "border-input bg-background w-40 rounded-md border px-3 py-1.5 text-sm",
                                    value: exception.startDate,
                                    onChange: (e)=>handleExceptionChange(index, {
                                            startDate: parseInt(e.target.value, 10)
                                        }),
                                    children: periodOptions.filter((p)=>!takenByOthers.has(p.startDate)).map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: p.startDate,
                                            children: p.label
                                        }, p.startDate))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm",
                                            children: "$"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                            value: exception.amount,
                                            onChange: (v)=>handleExceptionChange(index, {
                                                    amount: v
                                                }),
                                            placeholder: "0.00",
                                            className: "pl-7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    size: "icon",
                                    variant: "ghost",
                                    type: "button",
                                    onClick: ()=>set('exceptions', value.exceptions.filter((_, i)=>i !== index)),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    })
                                })
                            ]
                        }, index);
                    }),
                    value.exceptions.length < periodOptions.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        type: "button",
                        className: "text-muted-foreground self-start text-sm",
                        onClick: handleAddException,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "mr-1 h-4 w-4"
                            }),
                            "Different amount in a specific period"
                        ]
                    })
                ]
            })
        ]
    });
};





/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $62bf8c8bfdcf5adc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 4v7a4 4 0 0 1-4 4H4",
            key: "6o5b7l"
        }
    ],
    [
        "path",
        {
            d: "m9 10-5 5 5 5",
            key: "1kshq7"
        }
    ]
];
const $62bf8c8bfdcf5adc$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("corner-down-left", $62bf8c8bfdcf5adc$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

const $03be77ecee525e88$export$fda2cbba281a800a = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    // Forward the rest so callers can attach ARIA wiring (role="listbox", id)
    // without wrapping this in another element and breaking the layout.
    const { className: className, children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('shadow-popover bg-popover text-popover-foreground outline-ring/50 max-h-[30vh] overflow-y-auto rounded-md outline-1', className),
        ...rest,
        children: children
    });
});
const $03be77ecee525e88$export$ee388116d58b2caf = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { isSelected: isSelected, className: className, children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('px-3 py-2', isSelected && 'bg-accent', className),
        ...rest,
        children: children
    });
});



var $acw62 = parcelRequire("acw62");
const $d1427355809f336f$export$3a4682986e19a9b6 = (props)=>{
    const { initialQuery: initialQuery, search: search, onSubmit: onSubmit, autoSubmitFirstOnTab: autoSubmitFirstOnTab } = props;
    const [isOpen, setIsOpen] = $acw62.useState(false);
    const [query, setQuery] = $acw62.useState(initialQuery);
    const [selectedIndex, setSelectedIndex] = $acw62.useState(null);
    const searchResults = search(query);
    $acw62.useEffect(()=>{
        setSelectedIndex(null);
    }, [
        query
    ]);
    $acw62.useEffect(()=>{
        setQuery(initialQuery);
    }, [
        initialQuery
    ]);
    const transformIndex = (i)=>{
        if (i < 0 || i > searchResults.length - 1) return null;
        else return i;
    };
    const openPopover = ()=>setIsOpen(true);
    const closePopover = ()=>setIsOpen(false);
    // For callers whose results can reorder without a query change (async
    // suggestions being prepended): an index-based highlight would silently
    // point at a different option, so they drop it when that happens. Stable
    // so callers can list it in an effect's dependencies.
    const clearSelection = $acw62.useCallback(()=>setSelectedIndex(null), []);
    const handleSelect = (index)=>{
        setSelectedIndex(transformIndex(index));
    };
    const handleQueryChange = (value)=>{
        setIsOpen(true);
        setQuery(value);
    };
    const handleSubmit = (selectedIndex, results, focusDirection)=>{
        if (selectedIndex !== null && selectedIndex >= 0 && selectedIndex < results.length) onSubmit({
            query: query,
            selection: results[selectedIndex],
            focusDirection: focusDirection
        });
        else onSubmit({
            query: query,
            selection: null,
            focusDirection: focusDirection
        });
    };
    const handleKeyDown = (e)=>{
        if (searchResults) {
            if (e.key === 'ArrowUp') {
                if (selectedIndex === null) handleSelect(searchResults.length - 1);
                else handleSelect(selectedIndex - 1);
            } else if (e.key === 'ArrowDown') {
                if (selectedIndex === null) handleSelect(0);
                else handleSelect(selectedIndex + 1);
            } else if (e.key === 'Enter') {
                if (isOpen) {
                    handleSubmit(selectedIndex, searchResults);
                    e.preventDefault();
                }
            } else if (e.key === 'Tab') {
                // With the popover closed there is no selection to commit and no
                // mounted FocusTrap to route focus through (focusControlsRef is
                // populated by the popover) — leave Tab to the browser. Closed
                // implies unedited: any keystroke opens the popover, so there is
                // no uncommitted text to lose.
                if (!isOpen) return;
                const focusDirection = e.shiftKey ? 'backward' : 'forward';
                // Auto-select first result if nothing selected
                const autoFirst = autoSubmitFirstOnTab ? autoSubmitFirstOnTab(query) : query !== '';
                if (selectedIndex === null && autoFirst) handleSubmit(0, searchResults, focusDirection);
                else handleSubmit(selectedIndex, searchResults, focusDirection);
                e.preventDefault();
            } else if (e.key === 'Escape') handleSubmit(null, searchResults);
        }
    };
    return {
        isOpen: isOpen,
        query: query,
        selectedIndex: selectedIndex,
        searchResults: searchResults,
        handleQueryChange: handleQueryChange,
        handleKeyDown: handleKeyDown,
        openPopover: openPopover,
        closePopover: closePopover,
        clearSelection: clearSelection
    };
};



const $9eb11e6352514841$var$CategoryPicker = (props)=>{
    const { suggestions: suggestions, adornment: adornment, inputClassName: inputClassName, onEdited: onEdited } = props;
    const { loading: loading, data: data } = (0, $ce9d9e524be20f53$export$1f9e2535d0d42ab9)();
    const { data: groupsData } = (0, $ce9d9e524be20f53$export$9dda77d697c51272)();
    const { search: search } = (0, $eefd5dff10250d61$export$bd221a7c56b93941)(data?.allCategories || [], [
        'name'
    ]);
    // Browse order for the empty query: groups in display order (members in
    // member order), then ungrouped categories in name order. sectionByName
    // drives the section labels rendered between items; boundaries compare
    // by group ID, not label — names are not unique, so two adjacent groups
    // with the same name (or one literally named "Ungrouped") must still
    // render as separate sections.
    const { browseOrder: browseOrder, sectionByName: sectionByName } = $acw62.useMemo(()=>{
        const categories = data?.allCategories || [];
        const groups = groupsData?.allCategoryGroups || [];
        const byId = new Map(categories.map((c)=>[
                c._id,
                c
            ]));
        const grouped = new Set(groups.flatMap((g)=>g.categoryIds));
        const order = [];
        const sections = new Map();
        for (const group of groups)for (const id of group.categoryIds){
            const category = byId.get(id);
            if (category) {
                order.push(category.name);
                sections.set(category.name, {
                    key: group._id,
                    label: group.name
                });
            }
        }
        for (const category of categories)if (!grouped.has(category._id)) {
            order.push(category.name);
            if (groups.length > 0) sections.set(category.name, {
                key: '__ungrouped__',
                label: 'Ungrouped'
            });
        }
        return {
            browseOrder: order,
            sectionByName: sections
        };
    }, [
        data,
        groupsData
    ]);
    const optionToString = (option)=>typeof option === 'string' ? option : option.value;
    const optionKey = (option)=>typeof option === 'string' ? `category:${option}` : `${option.type}:${option.value}`;
    const renderOption = (option)=>{
        if (typeof option === 'string') return option;
        else if (option.type === 'suggested') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex w-full min-w-0 items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                    className: "size-3.5 shrink-0"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "min-w-0 flex-1 truncate",
                    children: option.value
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground shrink-0 text-xs",
                    children: option.detail
                })
            ]
        });
        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62bf8c8bfdcf5adc$export$2e2bcd8739ae039), {
                    className: "size-4"
                }),
                'Add "',
                option.value,
                '"'
            ]
        });
    };
    // The section an option renders under while browsing. Suggested options get
    // their own section; when suggestions are present but no groups exist, the
    // plain list still gets a label so the boundary below the suggestions reads
    // as a section break rather than a run-on.
    const sectionOf = (option)=>{
        if (typeof option !== 'string') return option.type === 'suggested' ? {
            key: '__suggested__',
            label: 'Suggested'
        } : undefined;
        const section = sectionByName.get(option);
        if (section) return section;
        return (suggestions ?? []).length > 0 ? {
            key: '__all__',
            label: 'All categories'
        } : undefined;
    };
    const anchorRef = $acw62.useRef(null);
    const popoverRef = $acw62.useRef(null);
    const activeItemRef = $acw62.useRef(null);
    const focusControlsRef = $acw62.useRef(null);
    // Submissions move focus out of the FocusTrap, which fires onFocusOutside
    // synchronously before the popover unmounts; this flag stops that from
    // re-committing the raw query over the just-committed selection
    const justSubmittedRef = $acw62.useRef(false);
    // Browsing = nothing typed beyond the current selection: the empty query,
    // or exactly the already-selected value (focusing a filled picker). An
    // auto-applied category would otherwise filter the dropdown to itself and
    // hide the alternative suggestions the picker exists to surface.
    const isBrowsing = (query)=>{
        const trimmed = query.trim();
        return trimmed === '' || trimmed === props.selectedCategory.getOrElse('');
    };
    const handleSearch = (query)=>{
        if (loading) return [];
        const trimmed = query.trim();
        const toOption = (s)=>({
                type: 'suggested',
                value: s.name,
                detail: s.detail
            });
        // Browsing pins every suggestion (unfiltered — the query is just the
        // current selection) above the grouped list; a suggested category also
        // stays visible in its own group. Typed queries keep the flat relevance
        // ranking with matching suggestions bumped to the top and deduplicated.
        if (isBrowsing(query)) return [
            ...(suggestions ?? []).map(toOption),
            ...browseOrder
        ];
        const q = trimmed.toLowerCase();
        const suggested = (suggestions ?? []).filter((s)=>s.name.toLowerCase().includes(q)).map(toOption);
        const suggestedNames = new Set(suggested.map(optionToString));
        const results = search(query, {
            limit: 80
        }).map(({ name: name })=>name).filter((name)=>!suggestedNames.has(name));
        return results.includes(trimmed) || suggestedNames.has(trimmed) ? [
            ...suggested,
            ...results
        ] : [
            ...suggested,
            ...results,
            {
                type: 'create',
                value: trimmed
            }
        ];
    };
    const handleSubmit = (state)=>{
        // Picking an option (click, or arrow/Tab selection) is a manual choice
        // just like typing, so it must also drop auto-apply provenance — while
        // a blur/tab-through commit of unchanged text (selection null) is not
        // an edit and must leave it alone.
        if (state.selection !== null) onEdited?.();
        const nextValue = state.selection ? optionToString(state.selection) : state.query;
        const trimmed = nextValue.trim();
        if (trimmed === '') props.onSelectCategory((0, $f8f45ddea4959097$exports.none));
        else props.onSelectCategory((0, $f8f45ddea4959097$exports.some)(trimmed));
        closePopover();
        justSubmittedRef.current = true;
        if (state.focusDirection === 'backward') focusControlsRef.current?.focusBackward();
        else focusControlsRef.current?.focusForward();
    };
    const { isOpen: isOpen, query: query, searchResults: searchResults, selectedIndex: selectedIndex, handleKeyDown: handleKeyDown, handleQueryChange: handleQueryChange, openPopover: openPopover, closePopover: closePopover, clearSelection: clearSelection } = (0, $d1427355809f336f$export$3a4682986e19a9b6)({
        initialQuery: props.selectedCategory.getOrElse(''),
        focusControlsRef: focusControlsRef,
        search: handleSearch,
        onSubmit: handleSubmit,
        // While browsing, Tab must commit the current query, not the browse
        // list's first item — auto-selecting there would silently replace a
        // filled category on tab-through.
        autoSubmitFirstOnTab: (query)=>!isBrowsing(query)
    });
    $acw62.useEffect(()=>{
        if (isOpen) justSubmittedRef.current = false;
    }, [
        isOpen
    ]);
    // Suggestions arrive asynchronously and prepend rows without changing the
    // query — and on a cold cache the groups query can land after the
    // categories query, rebuilding browseOrder under an open popover. Either
    // way an index-based keyboard highlight would silently move to a
    // different option, so drop it when the result ordering changes.
    $acw62.useEffect(()=>{
        clearSelection();
    }, [
        suggestions,
        browseOrder,
        clearSelection
    ]);
    // Commit typed text when focus leaves the picker (outside click/focus),
    // matching the Enter/Tab behavior — otherwise text typed without an
    // explicit selection is silently dropped
    const commitQuery = ()=>{
        if (justSubmittedRef.current) {
            justSubmittedRef.current = false;
            closePopover();
            return;
        }
        const trimmed = query.trim();
        if (trimmed === '') props.onSelectCategory((0, $f8f45ddea4959097$exports.none));
        else props.onSelectCategory((0, $f8f45ddea4959097$exports.some)(trimmed));
        closePopover();
    };
    $acw62.useLayoutEffect(()=>{
        if (isOpen && anchorRef.current && popoverRef.current) popoverRef.current.style.width = `${anchorRef.current.offsetWidth}px`;
    }, [
        anchorRef.current,
        popoverRef.current,
        isOpen
    ]);
    $acw62.useLayoutEffect(()=>{
        activeItemRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        selectedIndex
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        ref: anchorRef,
                        value: query,
                        onChange: (next)=>{
                            onEdited?.();
                            handleQueryChange(next);
                        },
                        onClick: openPopover,
                        onFocus: openPopover,
                        onKeyDown: handleKeyDown,
                        placeholder: "Category",
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(adornment != null && 'pr-20', inputClassName)
                    }),
                    adornment != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute inset-y-0 right-3 flex items-center",
                        children: adornment
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fa899d90230d1ae$export$5b6b19405a83ff9d), {
                anchorRef: anchorRef,
                anchor: "bottom-left",
                focusControlsRef: focusControlsRef,
                open: isOpen,
                onOutsideClick: commitQuery,
                onOutsideFocus: commitQuery,
                passThroughOutsideClicks: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$fda2cbba281a800a), {
                    ref: popoverRef,
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {}) : searchResults.map((result, index)=>{
                        const browsing = isBrowsing(query);
                        const section = browsing ? sectionOf(result) : undefined;
                        const previousSection = browsing && index > 0 ? sectionOf(searchResults[index - 1]) : undefined;
                        const showLabel = section != null && section.key !== previousSection?.key;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                            children: [
                                showLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-muted-foreground px-3 pb-1 pt-2 text-xs font-semibold",
                                    children: section.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$ee388116d58b2caf), {
                                    isSelected: selectedIndex === index,
                                    ref: selectedIndex === index ? activeItemRef : null,
                                    onClick: ()=>handleSubmit({
                                            query: query,
                                            selection: result
                                        }),
                                    children: renderOption(result)
                                })
                            ]
                        }, optionKey(result));
                    })
                })
            })
        ]
    });
};
var $9eb11e6352514841$export$2e2bcd8739ae039 = $9eb11e6352514841$var$CategoryPicker;





const $f1a154d4c7c0d4f2$export$a9ad4d45d17f8c67 = ({ onRequestClose: onRequestClose, feePeriodId: feePeriodId, feePeriodStartDate: feePeriodStartDate, feePeriodEndDate: feePeriodEndDate, cardAccountId: cardAccountId, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const [name, setName] = $acw62.useState('');
    const [description, setDescription] = $acw62.useState('');
    const [category, setCategory] = $acw62.useState((0, $f8f45ddea4959097$exports.none));
    const [mode, setMode] = $acw62.useState('cadence');
    const [schedule, setSchedule] = $acw62.useState((0, $0ebcc03374bb17f0$export$33147296b8d2b0c6));
    const [creditAccountId, setCreditAccountId] = $acw62.useState(null);
    const [periods, setPeriods] = $acw62.useState([
        {
            startDate: (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(feePeriodStartDate),
            // Editor rows show the inclusive last day; stored bounds are half-open
            endDate: (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(feePeriodEndDate).minus({
                days: 1
            }),
            amount: ''
        }
    ]);
    const [error, setError] = $acw62.useState(null);
    const [createBenefit, { loading: loading }] = (0, $ce9d9e524be20f53$export$ddae66c6df44b5a7)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            // Either mode sends explicit period rows — a schedule is just a way
            // of generating them (the DB stores only the rows)
            const periodInputs = mode === 'cadence' ? (0, $0ebcc03374bb17f0$export$29ddfb52dd34af8b)(schedule, {
                startDate: feePeriodStartDate,
                endDate: feePeriodEndDate
            }) : periods.map((p)=>{
                if (!p.startDate.isValid) throw new Error('Invalid start date');
                if (!p.endDate.isValid) throw new Error('Invalid end date');
                const cents = Math.round(parseFloat(p.amount) * 100);
                if (isNaN(cents)) throw new Error(`Invalid amount: ${p.amount}`);
                return {
                    startDate: Math.floor(p.startDate.toSeconds()),
                    // Editor rows are inclusive; stored bounds are half-open
                    endDate: Math.floor(p.endDate.plus({
                        days: 1
                    }).toSeconds()),
                    amount: cents
                };
            });
            await createBenefit({
                variables: {
                    feePeriodId: feePeriodId,
                    name: name.trim(),
                    description: description.trim() || null,
                    category: category.getOrElse(''),
                    creditAccountId: creditAccountId,
                    periods: periodInputs
                },
                update: (store, result)=>{
                    const newCategory = result?.data?.createCardBenefit?.category;
                    newCategory && (0, $5f9091afcb8d9899$export$8c292b02ce03981f)(store, newCategory);
                }
            });
            onSuccess();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const isValid = name.trim() && !category.isEmpty && (mode === 'cadence' ? schedule.amount.trim() !== '' : periods.length > 0);
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || !isValid,
                children: loading ? 'Creating...' : 'Create'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Create Benefit",
        footer: footer,
        size: "lg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: name,
                            onChange: setName,
                            placeholder: "e.g., Uber credit, streaming credit",
                            autoFocus: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: description,
                            onChange: setDescription,
                            placeholder: "Optional description"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Category"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9eb11e6352514841$export$2e2bcd8739ae039), {
                            selectedCategory: category,
                            onSelectCategory: setCategory
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground text-xs",
                            children: "Prefilled when creating transactions for this benefit"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c57dbaeaea7da703$export$358303cbde861097), {
                            className: "self-start",
                            options: [
                                {
                                    value: 'cadence',
                                    label: 'Regular schedule'
                                },
                                {
                                    value: 'custom',
                                    label: 'Custom periods'
                                }
                            ],
                            value: mode,
                            onChange: setMode
                        }),
                        mode === 'cadence' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ebcc03374bb17f0$export$6f121fef6704acfe), {
                            value: schedule,
                            onChange: setSchedule,
                            bounds: {
                                startDate: feePeriodStartDate,
                                endDate: feePeriodEndDate
                            }
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $687e30a8e0ff8689$export$265a8bf67b012c7b), {
                            periods: periods,
                            onChange: setPeriods,
                            defaultCustomize: false,
                            defaultGenStartDate: (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(feePeriodStartDate),
                            onError: setError
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a1576d3e1c876a5$export$7de928fcb7b09e8b), {
                    value: creditAccountId,
                    onChange: setCreditAccountId,
                    cardAccountId: cardAccountId
                })
            ]
        })
    });
};








var $acw62 = parcelRequire("acw62");










// Stored rows are half-open; the row editor shows the inclusive last day
const $3cfedea2bfca539e$var$toPeriodRow = (p)=>({
        startDate: (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(p.startDate),
        endDate: (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(p.endDate).minus({
            days: 1
        }),
        amount: (p.amount / 100).toFixed(2)
    });
const $3cfedea2bfca539e$export$aae09d000bde0783 = ({ onRequestClose: onRequestClose, benefit: benefit, feePeriodStartDate: feePeriodStartDate, feePeriodEndDate: feePeriodEndDate, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const { deleteCardBenefitModal: deleteCardBenefitModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const [name, setName] = $acw62.useState(benefit.name);
    const [description, setDescription] = $acw62.useState(benefit.description ?? '');
    const [category, setCategory] = $acw62.useState((0, $f8f45ddea4959097$exports.some)(benefit.category.name));
    // The DB stores only period rows; recover the schedule (if any) for the
    // high-level editor. Irregular or partial-coverage rows open in the
    // custom period editor.
    const inferred = $acw62.useMemo(()=>(0, $5cfc8dfd09486d37$export$e7bebb98bee5e46f)(benefit.periods, {
            startDate: feePeriodStartDate,
            endDate: feePeriodEndDate
        }), [
        benefit.periods,
        feePeriodStartDate,
        feePeriodEndDate
    ]);
    const [mode, setMode] = $acw62.useState(inferred != null ? 'cadence' : 'custom');
    const [schedule, setSchedule] = $acw62.useState(inferred != null ? (0, $0ebcc03374bb17f0$export$e6af5835eb92fddd)(inferred) : (0, $0ebcc03374bb17f0$export$33147296b8d2b0c6));
    const [creditAccountId, setCreditAccountId] = $acw62.useState(benefit.creditAccountId ?? null);
    const [periods, setPeriods] = $acw62.useState(inferred != null ? [] : benefit.periods.map($3cfedea2bfca539e$var$toPeriodRow));
    const [error, setError] = $acw62.useState(null);
    const [updateBenefit, { loading: loading }] = (0, $ce9d9e524be20f53$export$5dc743b5f02bd9da)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            const periodInputs = mode === 'cadence' ? (0, $0ebcc03374bb17f0$export$29ddfb52dd34af8b)(schedule, {
                startDate: feePeriodStartDate,
                endDate: feePeriodEndDate
            }) : periods.map((p)=>{
                if (!p.startDate.isValid) throw new Error('Invalid start date');
                if (!p.endDate.isValid) throw new Error('Invalid end date');
                const cents = Math.round(parseFloat(p.amount) * 100);
                if (isNaN(cents)) throw new Error(`Invalid amount: ${p.amount}`);
                return {
                    startDate: Math.floor(p.startDate.toSeconds()),
                    // Editor rows are inclusive; stored bounds are half-open
                    endDate: Math.floor(p.endDate.plus({
                        days: 1
                    }).toSeconds()),
                    amount: cents
                };
            });
            await updateBenefit({
                variables: {
                    id: benefit._id,
                    name: name.trim(),
                    description: description.trim() || null,
                    category: category.getOrElse(''),
                    // Empty string clears the credit account server-side
                    creditAccountId: creditAccountId ?? '',
                    periods: periodInputs
                },
                refetchQueries: [
                    {
                        query: (0, $ce9d9e524be20f53$export$57862cdd9be7ef37),
                        variables: {
                            accountId: benefit.accountId
                        }
                    }
                ],
                update: (store, result)=>{
                    const newCategory = result?.data?.updateCardBenefit?.category;
                    newCategory && (0, $5f9091afcb8d9899$export$8c292b02ce03981f)(store, newCategory);
                }
            });
            onSuccess();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const handleDelete = ()=>{
        onRequestClose();
        deleteCardBenefitModal.openModal({
            benefit: benefit,
            onDeleted: onSuccess
        });
    };
    // Switching to custom mode starts from the current rows (either the stored
    // ones or a preview of the schedule) so nothing is lost
    const handleSetCustom = ()=>{
        if (mode === 'custom') return;
        if (periods.length === 0) try {
            setPeriods((0, $0ebcc03374bb17f0$export$29ddfb52dd34af8b)(schedule, {
                startDate: feePeriodStartDate,
                endDate: feePeriodEndDate
            }).map((p)=>$3cfedea2bfca539e$var$toPeriodRow(p)));
        } catch  {
            setPeriods(benefit.periods.map($3cfedea2bfca539e$var$toPeriodRow));
        }
        setMode('custom');
    };
    const isValid = name.trim() && !category.isEmpty && (mode === 'cadence' ? schedule.amount.trim() !== '' : periods.length > 0);
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                onClick: handleDelete,
                children: "Delete"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || !isValid,
                children: loading ? 'Saving...' : 'Save'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Edit Benefit",
        footer: footer,
        size: "lg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: name,
                            onChange: setName,
                            placeholder: "Benefit name",
                            autoFocus: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: description,
                            onChange: setDescription,
                            placeholder: "Optional description"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Category"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9eb11e6352514841$export$2e2bcd8739ae039), {
                            selectedCategory: category,
                            onSelectCategory: setCategory
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground text-xs",
                            children: "Prefilled when creating transactions for this benefit"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c57dbaeaea7da703$export$358303cbde861097), {
                            className: "self-start",
                            options: [
                                {
                                    value: 'cadence',
                                    label: 'Regular schedule'
                                },
                                {
                                    value: 'custom',
                                    label: 'Custom periods'
                                }
                            ],
                            value: mode,
                            onChange: (next)=>next === 'custom' ? handleSetCustom() : setMode('cadence')
                        }),
                        mode === 'cadence' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ebcc03374bb17f0$export$6f121fef6704acfe), {
                            value: schedule,
                            onChange: setSchedule,
                            bounds: {
                                startDate: feePeriodStartDate,
                                endDate: feePeriodEndDate
                            }
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $687e30a8e0ff8689$export$265a8bf67b012c7b), {
                            periods: periods,
                            onChange: setPeriods,
                            defaultCustomize: benefit.periods.length !== 1,
                            defaultGenStartDate: (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)(),
                            onError: setError
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a1576d3e1c876a5$export$7de928fcb7b09e8b), {
                    value: creditAccountId,
                    onChange: setCreditAccountId,
                    cardAccountId: benefit.accountId
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");


const $214100802f307778$export$64d33e6c6a9bcdd = (props)=>{
    const { benefit: benefit, onRequestClose: onRequestClose, onDeleted: onDeleted } = props;
    const [deleteBenefit, { loading: loading }] = (0, $ce9d9e524be20f53$export$2da0d793ed75c38c)();
    const [error, setError] = $acw62.useState(null);
    const handleDelete = async ()=>{
        setError(null);
        try {
            await deleteBenefit({
                variables: {
                    id: benefit._id
                },
                refetchQueries: [
                    {
                        query: (0, $ce9d9e524be20f53$export$57862cdd9be7ef37),
                        variables: {
                            accountId: benefit.accountId
                        }
                    }
                ]
            });
            onDeleted();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: handleDelete,
                disabled: loading,
                children: loading ? 'Deleting...' : 'Delete'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Delete benefit",
        footer: footer,
        size: "sm",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-destructive/10 text-destructive mb-3 rounded-md p-3 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Are you sure you want to delete ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: benefit.name
                    }),
                    "? This action cannot be undone."
                ]
            })
        ]
    });
};







var $acw62 = parcelRequire("acw62");





const $00881f5c7ef9aa9e$export$700933a1074c5148 = ({ onRequestClose: onRequestClose, benefit: benefit, feePeriodPayee: feePeriodPayee, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const [payee, setPayee] = $acw62.useState(feePeriodPayee ?? benefit.name);
    const [category, setCategory] = $acw62.useState((0, $f8f45ddea4959097$exports.some)(benefit.category.name));
    const [description, setDescription] = $acw62.useState(benefit.name);
    const [error, setError] = $acw62.useState(null);
    // Only periods that still have room can be filled; sorted so the checkbox
    // list reads chronologically regardless of stored order.
    const fillable = $acw62.useMemo(()=>benefit.periods.filter((p)=>p.remainingAmount > 0).slice().sort((a, b)=>a.startDate - b.startDate), [
        benefit.periods
    ]);
    // Default to periods that have already started: precreating a credit dated
    // in the future is the surprising case, so it's opt-in per period.
    const nowSeconds = (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().toSeconds();
    const [selected, setSelected] = $acw62.useState(()=>new Set(fillable.filter((p)=>p.startDate <= nowSeconds).map((p)=>p.startDate)));
    const toggle = (startDate)=>{
        setSelected((prev)=>{
            const next = new Set(prev);
            if (next.has(startDate)) next.delete(startDate);
            else next.add(startDate);
            return next;
        });
    };
    const [generateCredits, { loading: loading }] = (0, $ce9d9e524be20f53$export$f754234a06224569)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            await generateCredits({
                variables: {
                    benefitId: benefit._id,
                    periodStartDates: fillable.filter((p)=>selected.has(p.startDate)).map((p)=>p.startDate),
                    payee: payee.trim() || undefined,
                    categoryName: category.getOrElse('') || undefined,
                    description: description.trim() || undefined
                },
                refetchQueries: [
                    {
                        query: (0, $ce9d9e524be20f53$export$57862cdd9be7ef37),
                        variables: {
                            accountId: benefit.accountId
                        }
                    }
                ]
            });
            onSuccess();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            setError(e.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || category.isEmpty || selected.size === 0,
                children: loading ? 'Creating...' : fillable.length === 0 ? 'Nothing to fill' : selected.size === 0 ? 'Select periods to fill' : `Create ${selected.size} credit${selected.size === 1 ? '' : 's'}`
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Create benefit credits",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-muted-foreground text-sm",
                    children: [
                        "Fills each selected period to its remaining amount on",
                        ' ',
                        benefit.creditAccount?.name ?? 'the credit account',
                        ", linked to this benefit. Already-covered periods are skipped; periods that haven\u2019t started yet are unchecked by default."
                    ]
                }),
                fillable.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground text-sm",
                    children: "Every period is already fully covered."
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-baseline justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "text-sm font-medium",
                                    children: "Periods to fill"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "flex gap-2 text-xs",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "text-muted-foreground underline",
                                            onClick: ()=>setSelected(new Set(fillable.map((p)=>p.startDate))),
                                            children: "All"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "text-muted-foreground underline",
                                            onClick: ()=>setSelected(new Set()),
                                            children: "None"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "border-border flex flex-col divide-y rounded-md border",
                            children: fillable.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "flex cursor-pointer items-center gap-2 px-3 py-2 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            className: "shrink-0",
                                            checked: selected.has(p.startDate),
                                            onChange: ()=>toggle(p.startDate)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "flex-1 truncate",
                                            children: [
                                                (0, $a5f774b73aaf5820$export$a053908c5c4ea08d)(p.startDate, p.endDate),
                                                p.startDate > nowSeconds && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-muted-foreground ml-1.5 text-xs",
                                                    children: "upcoming"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-muted-foreground shrink-0 text-xs",
                                            children: [
                                                (0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(p.remainingAmount),
                                                p.usedAmount > 0 && ` of ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(p.amount)}`
                                            ]
                                        })
                                    ]
                                }, p.startDate))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Payee"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: payee,
                            onChange: setPayee,
                            autoFocus: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Category"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9eb11e6352514841$export$2e2bcd8739ae039), {
                            selectedCategory: category,
                            onSelectCategory: setCategory
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: description,
                            onChange: setDescription
                        })
                    ]
                })
            ]
        })
    });
};





/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cab856bf30f1b37f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
            key: "q3az6g"
        }
    ],
    [
        "path",
        {
            d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8",
            key: "1h4pet"
        }
    ],
    [
        "path",
        {
            d: "M12 17.5v-11",
            key: "1jc1ny"
        }
    ]
];
const $cab856bf30f1b37f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("receipt", $cab856bf30f1b37f$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");








// useSearch takes a mutable array, so hand it a copy rather than the frozen
// manifest export. (LogoSelect gets one incidentally, by filtering out its
// "None" entry; the card manifest has no such entry to filter.)
const $8ec2c374587acf6c$var$OPTIONS = [
    ...(0, $86559021d806b4ea$export$cdf9be4b8896bd67)
];
const $8ec2c374587acf6c$var$RESULT_LIMIT = 40;
const $8ec2c374587acf6c$export$44a72c970db1fefb = ({ value: value, onChange: onChange, label: label = 'Card face', ariaLabel: ariaLabel, autoFocus: autoFocus, placeholder: placeholder = "Search card faces\u2026" })=>{
    const listboxId = $acw62.useId();
    const optionId = (index)=>`${listboxId}-option-${index}`;
    const activeItemRef = $acw62.useRef(null);
    const anchorRef = $acw62.useRef(null);
    const popoverRef = $acw62.useRef(null);
    const focusControlsRef = $acw62.useRef(null);
    const { search: search } = (0, $eefd5dff10250d61$export$bd221a7c56b93941)($8ec2c374587acf6c$var$OPTIONS, [
        'label',
        'value'
    ]);
    // useSearch returns every item verbatim for an empty query, ignoring the
    // Fuse limit, so cap it here rather than relying on that limit.
    const runSearch = (query)=>query.trim() === '' ? $8ec2c374587acf6c$var$OPTIONS.slice(0, $8ec2c374587acf6c$var$RESULT_LIMIT) : search(query, {
            limit: $8ec2c374587acf6c$var$RESULT_LIMIT
        });
    const handleSubmit = (state)=>{
        if (state.selection) onChange(state.selection.value);
        // Clear before closing, not after: handleQueryChange also sets isOpen, so
        // resetting the query last would immediately reopen the popover.
        handleQueryChange('');
        closePopover();
        if (state.focusDirection === 'backward') focusControlsRef.current?.focusBackward();
        else if (state.focusDirection === 'forward') focusControlsRef.current?.focusForward();
    };
    const handleClear = ()=>{
        onChange('');
        handleQueryChange('');
        closePopover();
    };
    const { isOpen: isOpen, query: query, searchResults: searchResults, selectedIndex: selectedIndex, handleKeyDown: handleKeyDown, handleQueryChange: handleQueryChange, openPopover: openPopover, closePopover: closePopover } = (0, $d1427355809f336f$export$3a4682986e19a9b6)({
        initialQuery: '',
        focusControlsRef: focusControlsRef,
        search: runSearch,
        onSubmit: handleSubmit
    });
    $acw62.useLayoutEffect(()=>{
        if (isOpen && anchorRef.current && popoverRef.current) popoverRef.current.style.width = `${anchorRef.current.offsetWidth}px`;
    }, [
        anchorRef.current,
        popoverRef.current,
        isOpen
    ]);
    $acw62.useLayoutEffect(()=>{
        activeItemRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        selectedIndex
    ]);
    const picker = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b39b2c71e902baf$export$ebcc69552e0d5c4c), {
                product: value,
                className: "w-12",
                alt: value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "relative flex-1",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                    ref: anchorRef,
                    value: query,
                    onChange: handleQueryChange,
                    onClick: openPopover,
                    onFocus: openPopover,
                    onKeyDown: handleKeyDown,
                    autoFocus: autoFocus,
                    selectOnFocus: true,
                    "aria-label": ariaLabel ?? (typeof label === 'string' ? label : undefined),
                    // Combobox wiring, as in LogoSelect: a bare text input plus styled
                    // divs gives assistive tech nothing, so arrow keys would only change
                    // colours as far as a screen reader is concerned.
                    role: "combobox",
                    "aria-expanded": isOpen,
                    "aria-controls": listboxId,
                    "aria-autocomplete": "list",
                    "aria-activedescendant": isOpen && selectedIndex !== null ? optionId(selectedIndex) : undefined,
                    placeholder: (0, $86559021d806b4ea$export$16faba7ad8bb8def)(value) ?? placeholder
                })
            }),
            value !== '' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: handleClear,
                className: "text-muted-foreground hover:text-foreground shrink-0 p-1",
                "aria-label": ariaLabel ? `Clear ${ariaLabel}` : 'Clear card face',
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "size-4"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fa899d90230d1ae$export$5b6b19405a83ff9d), {
                anchorRef: anchorRef,
                anchor: "bottom-left",
                focusControlsRef: focusControlsRef,
                open: isOpen,
                onOutsideClick: closePopover,
                onOutsideFocus: closePopover,
                passThroughOutsideClicks: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$fda2cbba281a800a), {
                    ref: popoverRef,
                    id: listboxId,
                    role: "listbox",
                    children: searchResults.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground px-3 py-2",
                        children: "No card faces match"
                    }) : searchResults.map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$ee388116d58b2caf), {
                            id: optionId(index),
                            role: "option",
                            "aria-selected": selectedIndex === index,
                            isSelected: selectedIndex === index,
                            ref: selectedIndex === index ? activeItemRef : null,
                            onClick: ()=>handleSubmit({
                                    query: query,
                                    selection: option
                                }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b39b2c71e902baf$export$ebcc69552e0d5c4c), {
                                        product: option.value,
                                        className: "w-10"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "truncate",
                                        children: option.label
                                    })
                                ]
                            })
                        }, option.value))
                })
            })
        ]
    });
    return label === null ? picker : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
        label: label,
        children: picker
    });
};







var $acw62 = parcelRequire("acw62");




const $7ab52d2c0e66eec5$var$PAGE_SIZE = 20;
const $7ab52d2c0e66eec5$var$formatAmount = (cents)=>{
    const abs = Math.abs(cents) / 100;
    const sign = cents < 0 ? '-' : '';
    return `${sign}$${abs.toFixed(2)}`;
};
const $7ab52d2c0e66eec5$export$ff27b476ad9a61f6 = (props)=>{
    const { accountId: accountId, value: value, onChange: onChange, includeProcessed: includeProcessed = true, excludeIds: excludeIds } = props;
    const [search, setSearch] = $acw62.useState('');
    const [dateFilter, setDateFilter] = $acw62.useState({
        startDate: null,
        endDate: null
    });
    // Pagination state
    const [cursorStack, setCursorStack] = $acw62.useState([]);
    const [pageIndex, setPageIndex] = $acw62.useState(0);
    const filterVariables = $acw62.useMemo(()=>({
            ...accountId ? {
                accountId: accountId
            } : {},
            includeProcessed: includeProcessed,
            limit: $7ab52d2c0e66eec5$var$PAGE_SIZE,
            ...search ? {
                search: search
            } : {},
            ...dateFilter.startDate ? {
                startDate: dateFilter.startDate
            } : {},
            ...dateFilter.endDate ? {
                endDate: dateFilter.endDate
            } : {},
            ...excludeIds && excludeIds.length > 0 ? {
                excludeIds: excludeIds
            } : {}
        }), [
        accountId,
        includeProcessed,
        excludeIds,
        search,
        dateFilter.startDate,
        dateFilter.endDate
    ]);
    const [loadTransactions, { data: data, loading: loading }] = (0, $ce9d9e524be20f53$export$d1531303a4748421)({
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only'
    });
    const pageData = data?.allRawTransactions;
    const transactions = pageData?.items ?? [];
    const hasNextPage = pageData?.hasMore ?? false;
    const hasPrevPage = pageIndex > 0;
    // Load first page when filters/search change
    $acw62.useEffect(()=>{
        setCursorStack([]);
        setPageIndex(0);
        loadTransactions({
            variables: filterVariables
        });
    }, [
        filterVariables,
        loadTransactions
    ]);
    const handleSearchSubmit = (query)=>{
        const nextSearch = query.trim();
        if (nextSearch === search) {
            setCursorStack([]);
            setPageIndex(0);
            loadTransactions({
                variables: filterVariables
            });
        } else setSearch(nextSearch);
    };
    const handleNextPage = ()=>{
        if (!hasNextPage || loading || !pageData?.endCursor) return;
        const nextCursor = pageData.endCursor;
        setCursorStack((prev)=>{
            const next = [
                ...prev
            ];
            next[pageIndex] = nextCursor;
            return next;
        });
        setPageIndex((prev)=>prev + 1);
        loadTransactions({
            variables: {
                ...filterVariables,
                beforeCursor: nextCursor
            }
        });
    };
    const handlePrevPage = ()=>{
        if (!hasPrevPage || loading) return;
        const prevIndex = pageIndex - 1;
        setPageIndex(prevIndex);
        if (prevIndex === 0) loadTransactions({
            variables: filterVariables
        });
        else loadTransactions({
            variables: {
                ...filterVariables,
                beforeCursor: cursorStack[prevIndex - 1]
            }
        });
    };
    const handleSelect = (tx)=>{
        onChange(tx._id, {
            _id: tx._id,
            amount: tx.amount,
            remainingAmount: tx.remainingAmount ?? null,
            currency: tx.currency,
            accountId: tx.account._id,
            date: tx.date
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d5b3d85c2079de0$export$55d7609a8f1eccd2), {
                            inputProps: {
                                placeholder: 'Search by description...'
                            },
                            initialQuery: "",
                            onSearch: handleSearchSubmit
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fb4243874d8f910$export$bfb275743ab18881), {
                        value: dateFilter,
                        onChange: setDateFilter
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$f0d9cf1e329477be), {
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {}) : transactions.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c01155910a1aa73$export$ed2cd9eb2d1973f0), {
                    children: "No transactions found"
                }) : transactions.map((tx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2c01155910a1aa73$export$be59229647a59a8), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "radio",
                                name: "rawTransactionPicker",
                                checked: value === tx._id,
                                onChange: ()=>handleSelect(tx),
                                className: "shrink-0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex min-w-0 flex-1 items-center justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex min-w-0 flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "truncate text-sm",
                                                children: tx.description
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-muted-foreground text-xs",
                                                children: tx.date
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground shrink-0 text-sm",
                                        children: $7ab52d2c0e66eec5$var$formatAmount(tx.amount)
                                    })
                                ]
                            })
                        ]
                    }, tx._id))
            }),
            (hasPrevPage || hasNextPage) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: handlePrevPage,
                        disabled: !hasPrevPage || loading,
                        className: "text-muted-foreground hover:text-foreground flex items-center gap-1 text-sm disabled:opacity-50",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                className: "size-4"
                            }),
                            "Previous"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: handleNextPage,
                        disabled: !hasNextPage || loading,
                        className: "text-muted-foreground hover:text-foreground flex items-center gap-1 text-sm disabled:opacity-50",
                        children: [
                            "Next",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                className: "size-4"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




const $e8aebcb304336dfa$var$formatAmount = (cents)=>{
    const abs = Math.abs(cents) / 100;
    const sign = cents < 0 ? '-' : '';
    return `${sign}$${abs.toFixed(2)}`;
};
const $e8aebcb304336dfa$export$a5cc206886d6b1a9 = ({ onRequestClose: onRequestClose, accountId: accountId, excludeRawTransactionIds: excludeRawTransactionIds, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const [selectedTransaction, setSelectedTransaction] = $acw62.useState(null);
    const [showPicker, setShowPicker] = $acw62.useState(false);
    const initialStart = (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)();
    const [startDate, setStartDate] = $acw62.useState(initialStart);
    const [endDate, setEndDate] = $acw62.useState(initialStart.plus({
        years: 1
    }).minus({
        days: 1
    }));
    const [payee, setPayee] = $acw62.useState('');
    const [cardProduct, setCardProduct] = $acw62.useState('');
    const [error, setError] = $acw62.useState(null);
    // Prefill the payee (card product name) with the account name as a sensible
    // default. Only fill the field once, and never clobber anything the user has
    // already typed while the account loads.
    const { data: accountData } = (0, $ce9d9e524be20f53$export$83a5bf0e4425c554)({
        variables: {
            id: accountId
        }
    });
    const accountName = accountData?.account?.name;
    const prefilledPayee = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (!prefilledPayee.current && accountName) {
            prefilledPayee.current = true;
            setPayee((prev)=>prev === '' ? accountName : prev);
        }
    }, [
        accountName
    ]);
    // Likewise the face: a new fee year is almost always the card's current
    // product, so start there and let the user pick otherwise the year the
    // card changed identity.
    const accountCardProduct = accountData?.account?.__typename === 'DepositoryAccount' ? accountData.account.cardProduct : null;
    const prefilledCardProduct = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (!prefilledCardProduct.current && accountCardProduct) {
            prefilledCardProduct.current = true;
            setCardProduct((prev)=>prev === '' ? accountCardProduct : prev);
        }
    }, [
        accountCardProduct
    ]);
    // Guard against linking a charge that already backs a fee period — surface
    // it here (and block Create) rather than only failing server-side after the
    // user has filled out the form. Query all fee periods, not just this
    // account's: a fee period keeps its rawTransactionId even after the charge
    // is moved to another account. Read past the cache so a period created on
    // another device/tab isn't missed, and hold Create until it resolves.
    const { data: linkedData, loading: linkedLoading } = (0, $ce9d9e524be20f53$export$4b01c6b56b3fa664)({
        fetchPolicy: 'network-only'
    });
    const linkedRawTransactionIds = $acw62.useMemo(()=>new Set((linkedData?.allFeePeriods ?? []).map((fp)=>fp.rawTransactionId)), [
        linkedData
    ]);
    const alreadyLinked = selectedTransaction != null && linkedRawTransactionIds.has(selectedTransaction._id);
    // Until the fresh list has resolved we can't be sure the selected charge is
    // free, so keep Create disabled while the check is pending.
    const linkCheckPending = selectedTransaction != null && linkedLoading;
    const [createFeePeriod, { loading: loading }] = (0, $ce9d9e524be20f53$export$14858aeec370c3a1)();
    const handleTransactionSelected = (_id, tx)=>{
        setSelectedTransaction(tx ?? null);
        setShowPicker(false);
        if (tx) {
            // Auto-fill start date from the transaction date
            const start = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(tx.date);
            if (start.isValid) {
                setStartDate(start);
                // Default end date to one year minus one day from the transaction date
                setEndDate(start.plus({
                    years: 1
                }).minus({
                    days: 1
                }));
            }
        }
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            if (!selectedTransaction) throw new Error('Fee transaction is required');
            if (!startDate.isValid) throw new Error('Invalid start date');
            if (!endDate.isValid) throw new Error('Invalid end date');
            await createFeePeriod({
                variables: {
                    accountId: accountId,
                    rawTransactionId: selectedTransaction._id,
                    startDate: Math.floor(startDate.toSeconds()),
                    // The picker's end date is inclusive; stored bounds are half-open
                    endDate: Math.floor(endDate.plus({
                        days: 1
                    }).toSeconds()),
                    amount: Math.abs(selectedTransaction.amount),
                    payee: payee || undefined,
                    cardProduct: cardProduct || undefined
                },
                refetchQueries: [
                    {
                        query: (0, $ce9d9e524be20f53$export$57862cdd9be7ef37),
                        variables: {
                            accountId: accountId
                        }
                    }
                ]
            });
            onSuccess();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || !selectedTransaction || alreadyLinked || linkCheckPending,
                children: loading ? 'Creating...' : 'Create'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Create Fee Period",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Fee Transaction"
                        }),
                        showPicker ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ab52d2c0e66eec5$export$ff27b476ad9a61f6), {
                            accountId: accountId,
                            value: selectedTransaction?._id ?? '',
                            onChange: handleTransactionSelected,
                            excludeIds: excludeRawTransactionIds
                        }) : selectedTransaction ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>setShowPicker(true),
                            className: "border-border hover:bg-muted/50 flex items-center gap-3 rounded-md border p-3 text-left transition-colors",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cab856bf30f1b37f$export$2e2bcd8739ae039), {
                                    className: "text-muted-foreground h-4 w-4 shrink-0"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex min-w-0 flex-1 flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "truncate text-sm font-medium",
                                            children: $e8aebcb304336dfa$var$formatAmount(selectedTransaction.amount)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground text-xs",
                                            children: selectedTransaction.date
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                    className: "text-muted-foreground h-3.5 w-3.5 shrink-0"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>setShowPicker(true),
                            className: "border-border hover:bg-muted/50 text-muted-foreground flex items-center justify-center gap-2 rounded-md border border-dashed p-4 text-sm transition-colors",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cab856bf30f1b37f$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                }),
                                "Select fee transaction"
                            ]
                        }),
                        alreadyLinked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-destructive text-xs",
                            children: "This transaction already has a fee period."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    id: formId,
                    onSubmit: handleSubmit,
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "text-sm font-medium",
                                    children: "Card that year"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ec2c374587acf6c$export$44a72c970db1fefb), {
                                    value: cardProduct,
                                    onChange: setCardProduct,
                                    label: null,
                                    ariaLabel: "Card that year"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "text-sm font-medium",
                                    children: "Payee (Card Product Name)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                    value: payee,
                                    onChange: setPayee,
                                    placeholder: "e.g. Chase Sapphire Reserve"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-1 flex-col gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "text-sm font-medium",
                                            children: "Start Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                            selectedDate: startDate,
                                            onChange: setStartDate
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-1 flex-col gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            className: "text-sm font-medium",
                                            children: "End Date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                            selectedDate: endDate,
                                            onChange: setEndDate
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};






var $acw62 = parcelRequire("acw62");







const $f6fa2512537244df$export$5041203fb1bdc8ee = ({ onRequestClose: onRequestClose, feePeriod: feePeriod, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const { deleteFeePeriodModal: deleteFeePeriodModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const [selectedTransaction, setSelectedTransaction] = $acw62.useState({
        _id: feePeriod.rawTransactionId,
        amount: feePeriod.amount,
        // Consumption state unknown from the fee period; treat as unconsumed
        remainingAmount: null,
        currency: 'USD',
        // Selection is display-only here; the account is not needed
        accountId: '',
        date: (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(feePeriod.startDate).toISODate() ?? ''
    });
    const [startDate, setStartDate] = $acw62.useState((0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(feePeriod.startDate));
    // Stored bounds are half-open; the picker shows the inclusive last day
    const [endDate, setEndDate] = $acw62.useState((0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(feePeriod.endDate).minus({
        days: 1
    }));
    const [payee, setPayee] = $acw62.useState(feePeriod.payee ?? '');
    const [cardProduct, setCardProduct] = $acw62.useState(feePeriod.cardProduct ?? '');
    const [error, setError] = $acw62.useState(null);
    const [updateFeePeriod, { loading: loading }] = (0, $ce9d9e524be20f53$export$c6418001d73d888f)();
    const handleTransactionSelected = (_id, tx)=>{
        setSelectedTransaction(tx ?? null);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            if (!selectedTransaction) throw new Error('Fee transaction is required');
            if (!startDate.isValid) throw new Error('Invalid start date');
            if (!endDate.isValid) throw new Error('Invalid end date');
            await updateFeePeriod({
                variables: {
                    id: feePeriod._id,
                    rawTransactionId: selectedTransaction._id,
                    startDate: Math.floor(startDate.toSeconds()),
                    endDate: Math.floor(endDate.plus({
                        days: 1
                    }).toSeconds()),
                    amount: Math.abs(selectedTransaction.amount),
                    payee: payee,
                    cardProduct: cardProduct || null
                },
                refetchQueries: [
                    {
                        query: (0, $ce9d9e524be20f53$export$57862cdd9be7ef37),
                        variables: {
                            accountId: feePeriod.accountId
                        }
                    }
                ]
            });
            onSuccess();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const handleDelete = ()=>{
        onRequestClose();
        deleteFeePeriodModal.openModal({
            feePeriod: feePeriod,
            onDeleted: onSuccess
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                onClick: handleDelete,
                children: "Delete"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || !selectedTransaction,
                children: loading ? 'Saving...' : 'Save'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Edit Fee Period",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Fee Transaction"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ab52d2c0e66eec5$export$ff27b476ad9a61f6), {
                            accountId: feePeriod.accountId,
                            value: selectedTransaction?._id ?? '',
                            onChange: handleTransactionSelected
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Card that year"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ec2c374587acf6c$export$44a72c970db1fefb), {
                            value: cardProduct,
                            onChange: setCardProduct,
                            label: null,
                            ariaLabel: "Card that year"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Payee (Card Product Name)"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: payee,
                            onChange: setPayee,
                            placeholder: "e.g. Chase Sapphire Reserve"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-1 flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "text-sm font-medium",
                                    children: "Start Date"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                    selectedDate: startDate,
                                    onChange: setStartDate
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-1 flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "text-sm font-medium",
                                    children: "End Date"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                    selectedDate: endDate,
                                    onChange: setEndDate
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");


const $c77acc9b330c7533$export$2c9a46b8ed400596 = (props)=>{
    const { feePeriod: feePeriod, onRequestClose: onRequestClose, onDeleted: onDeleted } = props;
    const [deleteFeePeriod, { loading: loading }] = (0, $ce9d9e524be20f53$export$5f8fb7bb9a730c4c)();
    const [error, setError] = $acw62.useState(null);
    const handleDelete = async ()=>{
        setError(null);
        try {
            await deleteFeePeriod({
                variables: {
                    id: feePeriod._id
                },
                refetchQueries: [
                    {
                        query: (0, $ce9d9e524be20f53$export$57862cdd9be7ef37),
                        variables: {
                            accountId: feePeriod.accountId
                        }
                    }
                ]
            });
            onDeleted();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: handleDelete,
                disabled: loading || feePeriod.benefits.length > 0,
                children: loading ? 'Deleting...' : 'Delete'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Delete fee period",
        footer: footer,
        size: "sm",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-destructive/10 text-destructive mb-3 rounded-md p-3 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Are you sure you want to delete this fee period? This action cannot be undone."
            }),
            feePeriod.benefits.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-destructive mt-2 text-sm",
                children: [
                    "This fee period has ",
                    feePeriod.benefits.length,
                    " benefit(s) linked. Delete all benefits first."
                ]
            })
        ]
    });
};








var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $0030bffa1359ca92$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $acw62.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $0030bffa1359ca92$export$71594e8a50f746f4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function $0030bffa1359ca92$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function $0030bffa1359ca92$export$8ee0fc9ee280b4ee(node) {
    return 'nodeType' in node;
}
function $0030bffa1359ca92$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($0030bffa1359ca92$export$5a096129d439f843(target)) return target;
    if (!$0030bffa1359ca92$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $0030bffa1359ca92$export$62858bae88b53fd0(node) {
    const { Document: Document } = $0030bffa1359ca92$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $0030bffa1359ca92$export$1b3bfaa9684536aa(node) {
    if ($0030bffa1359ca92$export$5a096129d439f843(node)) return false;
    return node instanceof $0030bffa1359ca92$export$38b2d434cce3ea22(node).HTMLElement;
}
function $0030bffa1359ca92$export$17eda790a720ec57(node) {
    return node instanceof $0030bffa1359ca92$export$38b2d434cce3ea22(node).SVGElement;
}
function $0030bffa1359ca92$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($0030bffa1359ca92$export$5a096129d439f843(target)) return target.document;
    if (!$0030bffa1359ca92$export$8ee0fc9ee280b4ee(target)) return document;
    if ($0030bffa1359ca92$export$62858bae88b53fd0(target)) return target;
    if ($0030bffa1359ca92$export$1b3bfaa9684536aa(target) || $0030bffa1359ca92$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $0030bffa1359ca92$export$700979bc83e7db82 = $0030bffa1359ca92$export$71594e8a50f746f4 ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $0030bffa1359ca92$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $acw62.useRef)(handler);
    $0030bffa1359ca92$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $acw62.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $0030bffa1359ca92$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $acw62.useRef)(null);
    const set = (0, $acw62.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $acw62.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $0030bffa1359ca92$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $acw62.useRef)(value);
    $0030bffa1359ca92$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $0030bffa1359ca92$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $acw62.useRef)();
    return (0, $acw62.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $0030bffa1359ca92$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $0030bffa1359ca92$export$90fc3a17d93f704c(onChange);
    const node = (0, $acw62.useRef)(null);
    const setNodeRef = (0, $acw62.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $0030bffa1359ca92$export$5cae361ad82dce8b(value) {
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $0030bffa1359ca92$var$ids = {};
function $0030bffa1359ca92$export$c485849f2e393253(prefix, value) {
    return (0, $acw62.useMemo)(()=>{
        if (value) return value;
        const id = $0030bffa1359ca92$var$ids[prefix] == null ? 0 : $0030bffa1359ca92$var$ids[prefix] + 1;
        $0030bffa1359ca92$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $0030bffa1359ca92$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $0030bffa1359ca92$export$e16d8520af44a096 = /*#__PURE__*/ $0030bffa1359ca92$var$createAdjustmentFn(1);
const $0030bffa1359ca92$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $0030bffa1359ca92$var$createAdjustmentFn(-1);
function $0030bffa1359ca92$export$d0e71af79cd586c6(event) {
    return 'clientX' in event && 'clientY' in event;
}
function $0030bffa1359ca92$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $0030bffa1359ca92$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $0030bffa1359ca92$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $0030bffa1359ca92$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $0030bffa1359ca92$export$36195c8aa1517e04(event) {
    if ($0030bffa1359ca92$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($0030bffa1359ca92$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $0030bffa1359ca92$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $0030bffa1359ca92$export$c4ffa16951855e28.Translate.toString(transform),
                $0030bffa1359ca92$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $0030bffa1359ca92$var$SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function $0030bffa1359ca92$export$44f71d798fd0a62b(element) {
    if (element.matches($0030bffa1359ca92$var$SELECTOR)) return element;
    return element.querySelector($0030bffa1359ca92$var$SELECTOR);
}



var $acw62 = parcelRequire("acw62");
const $768971a59ac63485$var$hiddenStyles = {
    display: 'none'
};
function $768971a59ac63485$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        style: $768971a59ac63485$var$hiddenStyles
    }, value);
}
function $768971a59ac63485$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $768971a59ac63485$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $acw62.useState)('');
    const announce = (0, $acw62.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $0bb7808e9486acbd$var$DndMonitorContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $0bb7808e9486acbd$export$1182af90218a7b81(listener) {
    const registerListener = (0, $acw62.useContext)($0bb7808e9486acbd$var$DndMonitorContext);
    (0, $acw62.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $0bb7808e9486acbd$var$useDndMonitorProvider() {
    const [listeners] = (0, $acw62.useState)(()=>new Set());
    const registerListener = (0, $acw62.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $acw62.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $0bb7808e9486acbd$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $0bb7808e9486acbd$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $0bb7808e9486acbd$var$Accessibility(_ref) {
    let { announcements: announcements = $0bb7808e9486acbd$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $0bb7808e9486acbd$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $768971a59ac63485$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $0030bffa1359ca92$export$c485849f2e393253)("DndLiveRegion");
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setMounted(true);
    }, []);
    $0bb7808e9486acbd$export$1182af90218a7b81((0, $acw62.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $768971a59ac63485$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $768971a59ac63485$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $11492dca620dcaa5$exports.createPortal)(markup, container) : markup;
}
var $0bb7808e9486acbd$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($0bb7808e9486acbd$var$Action || ($0bb7808e9486acbd$var$Action = {}));
function $0bb7808e9486acbd$var$noop() {}
function $0bb7808e9486acbd$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $acw62.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $0bb7808e9486acbd$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $acw62.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $0bb7808e9486acbd$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $0bb7808e9486acbd$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $0bb7808e9486acbd$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $0bb7808e9486acbd$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $0bb7808e9486acbd$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $0bb7808e9486acbd$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $0bb7808e9486acbd$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $0bb7808e9486acbd$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $0bb7808e9486acbd$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $0bb7808e9486acbd$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $0bb7808e9486acbd$var$distanceBetween($0bb7808e9486acbd$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $0bb7808e9486acbd$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $0bb7808e9486acbd$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $0bb7808e9486acbd$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $0bb7808e9486acbd$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $0bb7808e9486acbd$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $0bb7808e9486acbd$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $0bb7808e9486acbd$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $0bb7808e9486acbd$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $0bb7808e9486acbd$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $0bb7808e9486acbd$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $0bb7808e9486acbd$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $0bb7808e9486acbd$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
function $0bb7808e9486acbd$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $0bb7808e9486acbd$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
}
function $0bb7808e9486acbd$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $0bb7808e9486acbd$var$getAdjustedRect = /*#__PURE__*/ $0bb7808e9486acbd$var$createRectAdjustmentFn(1);
function $0bb7808e9486acbd$var$parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $0bb7808e9486acbd$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $0bb7808e9486acbd$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $0bb7808e9486acbd$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $0bb7808e9486acbd$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $0bb7808e9486acbd$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(element);
        if (transform) rect = $0bb7808e9486acbd$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $0bb7808e9486acbd$var$getTransformAgnosticClientRect(element) {
    return $0bb7808e9486acbd$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $0bb7808e9486acbd$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $0bb7808e9486acbd$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function $0bb7808e9486acbd$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function $0bb7808e9486acbd$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $0030bffa1359ca92$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(node) || (0, $0030bffa1359ca92$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(node);
        if (node !== element) {
            if ($0bb7808e9486acbd$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($0bb7808e9486acbd$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $0bb7808e9486acbd$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $0bb7808e9486acbd$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $0bb7808e9486acbd$var$getScrollableElement(element) {
    if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4) || !element) return null;
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element;
    if (!(0, $0030bffa1359ca92$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $0030bffa1359ca92$export$62858bae88b53fd0)(element) || element === (0, $0030bffa1359ca92$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $0bb7808e9486acbd$var$getScrollXCoordinate(element) {
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $0bb7808e9486acbd$var$getScrollYCoordinate(element) {
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $0bb7808e9486acbd$var$getScrollCoordinates(element) {
    return {
        x: $0bb7808e9486acbd$var$getScrollXCoordinate(element),
        y: $0bb7808e9486acbd$var$getScrollYCoordinate(element)
    };
}
var $0bb7808e9486acbd$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($0bb7808e9486acbd$var$Direction || ($0bb7808e9486acbd$var$Direction = {}));
function $0bb7808e9486acbd$var$isDocumentScrollingElement(element) {
    if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $0bb7808e9486acbd$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $0bb7808e9486acbd$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $0bb7808e9486acbd$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $0bb7808e9486acbd$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $0bb7808e9486acbd$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $0bb7808e9486acbd$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $0bb7808e9486acbd$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $0bb7808e9486acbd$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $0bb7808e9486acbd$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $0bb7808e9486acbd$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $0bb7808e9486acbd$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $0bb7808e9486acbd$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $0030bffa1359ca92$export$e16d8520af44a096)(acc, $0bb7808e9486acbd$var$getScrollCoordinates(node));
    }, $0bb7808e9486acbd$export$597cbd7bbd10deb4);
}
function $0bb7808e9486acbd$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $0bb7808e9486acbd$var$getScrollXCoordinate(node);
    }, 0);
}
function $0bb7808e9486acbd$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $0bb7808e9486acbd$var$getScrollYCoordinate(node);
    }, 0);
}
function $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $0bb7808e9486acbd$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $0bb7808e9486acbd$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const $0bb7808e9486acbd$var$properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        $0bb7808e9486acbd$var$getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        $0bb7808e9486acbd$var$getScrollYOffset
    ]
];
class $0bb7808e9486acbd$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $0bb7808e9486acbd$export$e4864aa91b5ed091(element);
        const scrollOffsets = $0bb7808e9486acbd$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $0bb7808e9486acbd$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class $0bb7808e9486acbd$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $0bb7808e9486acbd$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $0030bffa1359ca92$export$b204af158042fbac)(target);
}
function $0bb7808e9486acbd$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var $0bb7808e9486acbd$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($0bb7808e9486acbd$var$EventName || ($0bb7808e9486acbd$var$EventName = {}));
function $0bb7808e9486acbd$var$preventDefault(event) {
    event.preventDefault();
}
function $0bb7808e9486acbd$var$stopPropagation(event) {
    event.stopPropagation();
}
var $0bb7808e9486acbd$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($0bb7808e9486acbd$export$a8b1916dba3ae88b || ($0bb7808e9486acbd$export$a8b1916dba3ae88b = {}));
const $0bb7808e9486acbd$var$defaultKeyboardCodes = {
    start: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Space,
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Space,
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Enter,
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Tab
    ]
};
const $0bb7808e9486acbd$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $0bb7808e9486acbd$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$b204af158042fbac)(target));
        this.windowListeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($0bb7808e9486acbd$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(node);
        onStart($0bb7808e9486acbd$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $0030bffa1359ca92$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $0bb7808e9486acbd$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $0bb7808e9486acbd$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = 'smooth' } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $0bb7808e9486acbd$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $0bb7808e9486acbd$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right && !isRight || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down && !isBottom || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $0030bffa1359ca92$export$e16d8520af44a096)((0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$0bb7808e9486acbd$export$44d67f2a438aeba9.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $0bb7808e9486acbd$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $0bb7808e9486acbd$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function $0bb7808e9486acbd$var$isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $0bb7808e9486acbd$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $0030bffa1359ca92$export$b204af158042fbac)(target);
        this.documentListeners = new $0bb7808e9486acbd$var$Listeners(this.document);
        this.listeners = new $0bb7808e9486acbd$var$Listeners(listenerTarget);
        this.windowListeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.DragStart, $0bb7808e9486acbd$var$preventDefault);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.ContextMenu, $0bb7808e9486acbd$var$preventDefault);
        this.documentListeners.add($0bb7808e9486acbd$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($0bb7808e9486acbd$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($0bb7808e9486acbd$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($0bb7808e9486acbd$var$EventName.Click, $0bb7808e9486acbd$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($0bb7808e9486acbd$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        const delta = (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($0bb7808e9486acbd$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($0bb7808e9486acbd$var$isDelayConstraint(activationConstraint)) {
                if ($0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $0bb7808e9486acbd$var$events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class $0bb7808e9486acbd$export$b26af955418d6638 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $0030bffa1359ca92$export$b204af158042fbac)(event.target);
        super(props, $0bb7808e9486acbd$var$events, listenerTarget);
    }
}
$0bb7808e9486acbd$export$b26af955418d6638.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $0bb7808e9486acbd$var$events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var $0bb7808e9486acbd$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($0bb7808e9486acbd$var$MouseButton || ($0bb7808e9486acbd$var$MouseButton = {}));
class $0bb7808e9486acbd$export$b28554b50bf7f273 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        super(props, $0bb7808e9486acbd$var$events$1, (0, $0030bffa1359ca92$export$b204af158042fbac)(props.event.target));
    }
}
$0bb7808e9486acbd$export$b28554b50bf7f273.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $0bb7808e9486acbd$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $0bb7808e9486acbd$var$events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class $0bb7808e9486acbd$export$19b41baf2e1bcdc0 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        super(props, $0bb7808e9486acbd$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($0bb7808e9486acbd$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($0bb7808e9486acbd$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$0bb7808e9486acbd$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $0bb7808e9486acbd$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($0bb7808e9486acbd$export$eefe60e26f04c318 || ($0bb7808e9486acbd$export$eefe60e26f04c318 = {}));
var $0bb7808e9486acbd$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($0bb7808e9486acbd$export$f93aa492a37e1b0e || ($0bb7808e9486acbd$export$f93aa492a37e1b0e = {}));
function $0bb7808e9486acbd$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $0bb7808e9486acbd$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $0bb7808e9486acbd$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $0bb7808e9486acbd$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $0030bffa1359ca92$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $acw62.useMemo)(()=>{
        switch(activator){
            case $0bb7808e9486acbd$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $0bb7808e9486acbd$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $acw62.useRef)(null);
    const autoScroll = (0, $acw62.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $acw62.useMemo)(()=>order === $0bb7808e9486acbd$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $0bb7808e9486acbd$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $0bb7808e9486acbd$var$defaultScrollIntent = {
    x: {
        [$0bb7808e9486acbd$var$Direction.Backward]: false,
        [$0bb7808e9486acbd$var$Direction.Forward]: false
    },
    y: {
        [$0bb7808e9486acbd$var$Direction.Backward]: false,
        [$0bb7808e9486acbd$var$Direction.Forward]: false
    }
};
function $0bb7808e9486acbd$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(delta);
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $0bb7808e9486acbd$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$0bb7808e9486acbd$var$Direction.Backward]: previousIntent.x[$0bb7808e9486acbd$var$Direction.Backward] || direction.x === -1,
                [$0bb7808e9486acbd$var$Direction.Forward]: previousIntent.x[$0bb7808e9486acbd$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$0bb7808e9486acbd$var$Direction.Backward]: previousIntent.y[$0bb7808e9486acbd$var$Direction.Backward] || direction.y === -1,
                [$0bb7808e9486acbd$var$Direction.Forward]: previousIntent.y[$0bb7808e9486acbd$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $0bb7808e9486acbd$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $0bb7808e9486acbd$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $acw62.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $0bb7808e9486acbd$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($0bb7808e9486acbd$export$571c10ffffe014ab || ($0bb7808e9486acbd$export$571c10ffffe014ab = {}));
var $0bb7808e9486acbd$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($0bb7808e9486acbd$export$8e062c3160beefd5 || ($0bb7808e9486acbd$export$8e062c3160beefd5 = {}));
const $0bb7808e9486acbd$var$defaultValue = /*#__PURE__*/ new Map();
function $0bb7808e9486acbd$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $acw62.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $acw62.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(disabled);
    const measureDroppableContainers = (0, $acw62.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $acw62.useRef)(null);
    const droppableRects = (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $0bb7808e9486acbd$var$defaultValue;
        if (!previousValue || previousValue === $0bb7808e9486acbd$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $0bb7808e9486acbd$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $acw62.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $0bb7808e9486acbd$export$571c10ffffe014ab.Always:
                return false;
            case $0bb7808e9486acbd$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $0bb7808e9486acbd$var$useInitialValue(value, computeFn) {
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $0bb7808e9486acbd$var$useInitialRect(node, measure) {
    return $0bb7808e9486acbd$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $0bb7808e9486acbd$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $0030bffa1359ca92$export$90fc3a17d93f704c)(callback);
    const mutationObserver = (0, $acw62.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $0bb7808e9486acbd$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $0030bffa1359ca92$export$90fc3a17d93f704c)(callback);
    const resizeObserver = (0, $acw62.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $0bb7808e9486acbd$var$defaultMeasure(element) {
    return new $0bb7808e9486acbd$var$Rect($0bb7808e9486acbd$export$b6aa1f30c53d7454(element), element);
}
function $0bb7808e9486acbd$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $0bb7808e9486acbd$var$defaultMeasure;
    const [rect, setRect] = (0, $acw62.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $0bb7808e9486acbd$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: measureRect
    });
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $0bb7808e9486acbd$var$useRectDelta(rect) {
    const initialRect = $0bb7808e9486acbd$var$useInitialValue(rect);
    return $0bb7808e9486acbd$var$getRectDelta(rect, initialRect);
}
const $0bb7808e9486acbd$var$defaultValue$1 = [];
function $0bb7808e9486acbd$var$useScrollableAncestors(node) {
    const previousNode = (0, $acw62.useRef)(node);
    const ancestors = (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $0bb7808e9486acbd$var$defaultValue$1;
        if (previousValue && previousValue !== $0bb7808e9486acbd$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $0bb7808e9486acbd$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $acw62.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $0bb7808e9486acbd$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $acw62.useState)(null);
    const prevElements = (0, $acw62.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $acw62.useCallback)((event)=>{
        const scrollingElement = $0bb7808e9486acbd$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $0bb7808e9486acbd$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $0bb7808e9486acbd$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $0bb7808e9486acbd$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $0bb7808e9486acbd$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $acw62.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $0030bffa1359ca92$export$e16d8520af44a096)(acc, coordinates), $0bb7808e9486acbd$export$597cbd7bbd10deb4) : $0bb7808e9486acbd$var$getScrollOffsets(elements);
        return $0bb7808e9486acbd$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $acw62.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(scrollOffsets, initialScrollOffsets.current) : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
}
function $0bb7808e9486acbd$var$useSensorSetup(sensors) {
    (0, $acw62.useEffect)(()=>{
        if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $0bb7808e9486acbd$var$useSyntheticListeners(listeners, id) {
    return (0, $acw62.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $0bb7808e9486acbd$var$useWindowRect(element) {
    return (0, $acw62.useMemo)(()=>element ? $0bb7808e9486acbd$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $0bb7808e9486acbd$var$defaultValue$2 = [];
function $0bb7808e9486acbd$var$useRects(elements, measure) {
    if (measure === void 0) measure = $0bb7808e9486acbd$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $0bb7808e9486acbd$var$useWindowRect(firstElement ? (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(firstElement) : null);
    const [rects, setRects] = (0, $acw62.useState)($0bb7808e9486acbd$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $0bb7808e9486acbd$var$defaultValue$2;
            return elements.map((element)=>$0bb7808e9486acbd$var$isDocumentScrollingElement(element) ? windowRect : new $0bb7808e9486acbd$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: measureRects
    });
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $0bb7808e9486acbd$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $0bb7808e9486acbd$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $acw62.useState)(null);
    const handleResize = (0, $acw62.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $acw62.useCallback)((element)=>{
        const node = $0bb7808e9486acbd$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)(handleNodeChange);
    return (0, $acw62.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $0bb7808e9486acbd$var$defaultSensors = [
    {
        sensor: $0bb7808e9486acbd$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $0bb7808e9486acbd$export$44d67f2a438aeba9,
        options: {}
    }
];
const $0bb7808e9486acbd$var$defaultData = {
    current: {}
};
const $0bb7808e9486acbd$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $0bb7808e9486acbd$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $0bb7808e9486acbd$var$getTransformAgnosticClientRect,
        strategy: $0bb7808e9486acbd$export$571c10ffffe014ab.WhileDragging,
        frequency: $0bb7808e9486acbd$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $0bb7808e9486acbd$export$b6aa1f30c53d7454
    }
};
class $0bb7808e9486acbd$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $0bb7808e9486acbd$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $0bb7808e9486acbd$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $0bb7808e9486acbd$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $0bb7808e9486acbd$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $0bb7808e9486acbd$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $0bb7808e9486acbd$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: $0bb7808e9486acbd$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $0bb7808e9486acbd$var$noop
};
const $0bb7808e9486acbd$var$InternalContext = /*#__PURE__*/ (0, $acw62.createContext)($0bb7808e9486acbd$var$defaultInternalContext);
const $0bb7808e9486acbd$var$PublicContext = /*#__PURE__*/ (0, $acw62.createContext)($0bb7808e9486acbd$var$defaultPublicContext);
function $0bb7808e9486acbd$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $0bb7808e9486acbd$var$DroppableContainersMap()
        }
    };
}
function $0bb7808e9486acbd$var$reducer(state, action) {
    switch(action.type){
        case $0bb7808e9486acbd$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $0bb7808e9486acbd$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $0bb7808e9486acbd$var$Action.DragEnd:
        case $0bb7808e9486acbd$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $0bb7808e9486acbd$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $0bb7808e9486acbd$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $0bb7808e9486acbd$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $0bb7808e9486acbd$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const previousActivatorEvent = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(activatorEvent);
    const previousActiveId = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $acw62.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $0030bffa1359ca92$export$130b789831072f4c)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $0030bffa1359ca92$export$44f71d798fd0a62b)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $0bb7808e9486acbd$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $0bb7808e9486acbd$var$useMeasuringConfiguration(config) {
    return (0, $acw62.useMemo)(()=>({
            draggable: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $0bb7808e9486acbd$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $acw62.useRef)(false);
    const { x: x, y: y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $0bb7808e9486acbd$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $0bb7808e9486acbd$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $0bb7808e9486acbd$var$ActiveDraggableContext = /*#__PURE__*/ (0, $acw62.createContext)({
    ...$0bb7808e9486acbd$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $0bb7808e9486acbd$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($0bb7808e9486acbd$var$Status || ($0bb7808e9486acbd$var$Status = {}));
const $0bb7808e9486acbd$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $acw62.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $0bb7808e9486acbd$var$defaultSensors, collisionDetection: collisionDetection = $0bb7808e9486acbd$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $acw62.useReducer)($0bb7808e9486acbd$var$reducer, undefined, $0bb7808e9486acbd$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $0bb7808e9486acbd$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $acw62.useState)($0bb7808e9486acbd$var$Status.Uninitialized);
    const isInitialized = status === $0bb7808e9486acbd$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $acw62.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $acw62.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $0bb7808e9486acbd$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $acw62.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $acw62.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $acw62.useState)(null);
    const latestProps = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $0030bffa1359ca92$export$c485849f2e393253)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $acw62.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $0bb7808e9486acbd$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $0bb7808e9486acbd$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $0bb7808e9486acbd$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $acw62.useMemo)(()=>activatorEvent ? (0, $0030bffa1359ca92$export$36195c8aa1517e04)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $0bb7808e9486acbd$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $0bb7808e9486acbd$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $0bb7808e9486acbd$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $0bb7808e9486acbd$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $acw62.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $0bb7808e9486acbd$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $0bb7808e9486acbd$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $0bb7808e9486acbd$var$useWindowRect(draggingNode ? (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $0bb7808e9486acbd$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $0bb7808e9486acbd$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $0bb7808e9486acbd$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $0030bffa1359ca92$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollOffsets = $0bb7808e9486acbd$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $0030bffa1359ca92$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $0bb7808e9486acbd$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $0bb7808e9486acbd$export$ef1beab6d7287295(collisions, 'id');
    const [over, setOver] = (0, $acw62.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $0030bffa1359ca92$export$e16d8520af44a096)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $0bb7808e9486acbd$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $acw62.useRef)(null);
    const instantiateSensor = (0, $acw62.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($0bb7808e9486acbd$var$Status.Initializing);
                    dispatch({
                        type: $0bb7808e9486acbd$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $0bb7808e9486acbd$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($0bb7808e9486acbd$var$Action.DragEnd),
            onCancel: createHandler($0bb7808e9486acbd$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $0bb7808e9486acbd$var$Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $0bb7808e9486acbd$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($0bb7808e9486acbd$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $0bb7808e9486acbd$var$Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $acw62.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $0bb7808e9486acbd$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $0bb7808e9486acbd$var$useSensorSetup(sensors);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (activeNodeRect && status === $0bb7808e9486acbd$var$Status.Initializing) setStatus($0bb7808e9486acbd$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $acw62.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $acw62.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $0bb7808e9486acbd$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $acw62.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $acw62.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $0bb7808e9486acbd$var$NullContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $0bb7808e9486acbd$var$defaultRole = 'button';
const $0bb7808e9486acbd$var$ID_PREFIX = 'Draggable';
function $0bb7808e9486acbd$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $0030bffa1359ca92$export$c485849f2e393253)($0bb7808e9486acbd$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const { role: role = $0bb7808e9486acbd$var$defaultRole, roleDescription: roleDescription = 'draggable', tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $acw62.useContext)(isDragging ? $0bb7808e9486acbd$var$ActiveDraggableContext : $0bb7808e9486acbd$var$NullContext);
    const [node, setNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)();
    const [activatorNode, setActivatorNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)();
    const listeners = $0bb7808e9486acbd$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(data);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $acw62.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === $0bb7808e9486acbd$var$defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $0bb7808e9486acbd$export$4930f6bf413be70e() {
    return (0, $acw62.useContext)($0bb7808e9486acbd$var$PublicContext);
}
const $0bb7808e9486acbd$var$ID_PREFIX$1 = 'Droppable';
const $0bb7808e9486acbd$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $0bb7808e9486acbd$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $0030bffa1359ca92$export$c485849f2e393253)($0bb7808e9486acbd$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const previous = (0, $acw62.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $acw62.useRef)(false);
    const rect = (0, $acw62.useRef)(null);
    const callbackId = (0, $acw62.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$0bb7808e9486acbd$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $acw62.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $acw62.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(data);
    (0, $acw62.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch({
            type: $0bb7808e9486acbd$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $0bb7808e9486acbd$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $0bb7808e9486acbd$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $0bb7808e9486acbd$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $acw62.useState)(null);
    const [element, setElement] = (0, $acw62.useState)(null);
    const previousChildren = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children, clonedChildren ? (0, $acw62.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $0bb7808e9486acbd$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $0bb7808e9486acbd$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$InternalContext.Provider, {
        value: $0bb7808e9486acbd$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$ActiveDraggableContext.Provider, {
        value: $0bb7808e9486acbd$var$defaultTransform
    }, children));
}
const $0bb7808e9486acbd$var$baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const $0bb7808e9486acbd$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $0030bffa1359ca92$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const $0bb7808e9486acbd$var$PositionedOverlay = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $0bb7808e9486acbd$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$0bb7808e9486acbd$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $0bb7808e9486acbd$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $0bb7808e9486acbd$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $0bb7808e9486acbd$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(initial)
        },
        {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(final)
        }
    ];
};
const $0bb7808e9486acbd$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: 'ease',
    keyframes: $0bb7808e9486acbd$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $0bb7808e9486acbd$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function $0bb7808e9486acbd$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $0030bffa1359ca92$export$90fc3a17d93f704c)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $0bb7808e9486acbd$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(node).getComputedStyle(node);
        const parsedTransform = $0bb7808e9486acbd$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : $0bb7808e9486acbd$var$createDefaultDropAnimation(config);
        $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $0bb7808e9486acbd$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$0bb7808e9486acbd$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $0bb7808e9486acbd$var$key = 0;
function $0bb7808e9486acbd$var$useKey(id) {
    return (0, $acw62.useMemo)(()=>{
        if (id == null) return;
        $0bb7808e9486acbd$var$key++;
        return $0bb7808e9486acbd$var$key;
    }, [
        id
    ]);
}
const $0bb7808e9486acbd$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = 'div', className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $0bb7808e9486acbd$export$4930f6bf413be70e();
    const transform = (0, $acw62.useContext)($0bb7808e9486acbd$var$ActiveDraggableContext);
    const key = $0bb7808e9486acbd$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $0bb7808e9486acbd$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $0bb7808e9486acbd$var$useInitialValue(activeNodeRect);
    const dropAnimation = $0bb7808e9486acbd$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});



var $acw62 = parcelRequire("acw62");


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $0332ec5baeac6793$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $0332ec5baeac6793$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $0332ec5baeac6793$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $0332ec5baeac6793$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $0332ec5baeac6793$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $0332ec5baeac6793$var$normalizeDisabled(disabled) {
    if (typeof disabled === 'boolean') return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $0332ec5baeac6793$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $0332ec5baeac6793$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $0332ec5baeac6793$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$0332ec5baeac6793$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
};
function $0332ec5baeac6793$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $0332ec5baeac6793$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $0332ec5baeac6793$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $0332ec5baeac6793$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $0332ec5baeac6793$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $0332ec5baeac6793$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$0332ec5baeac6793$var$defaultScale$1
        };
    }
    const itemGap = $0332ec5baeac6793$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
};
function $0332ec5baeac6793$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $0332ec5baeac6793$var$ID_PREFIX = 'Sortable';
const $0332ec5baeac6793$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    activeIndex: -1,
    containerId: $0332ec5baeac6793$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $0332ec5baeac6793$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $0332ec5baeac6793$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $0332ec5baeac6793$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $0bb7808e9486acbd$export$4930f6bf413be70e)();
    const containerId = (0, $0030bffa1359ca92$export$c485849f2e393253)($0332ec5baeac6793$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $acw62.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'object' && 'id' in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $acw62.useRef)(items);
    const itemsHaveChanged = !$0332ec5baeac6793$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $0332ec5baeac6793$var$normalizeDisabled(disabledProp);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $acw62.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $acw62.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $0332ec5baeac6793$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0332ec5baeac6793$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $0332ec5baeac6793$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $0332ec5baeac6793$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $0332ec5baeac6793$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $0332ec5baeac6793$var$defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const $0332ec5baeac6793$var$transitionProperty = 'transform';
const $0332ec5baeac6793$var$disabledTransition = /*#__PURE__*/ (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transition.toString({
    property: $0332ec5baeac6793$var$transitionProperty,
    duration: 0,
    easing: 'linear'
});
const $0332ec5baeac6793$var$defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $0332ec5baeac6793$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $acw62.useState)(null);
    const previousIndex = (0, $acw62.useRef)(index);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $0bb7808e9486acbd$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $acw62.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $0332ec5baeac6793$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $0332ec5baeac6793$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $0332ec5baeac6793$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $0332ec5baeac6793$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $acw62.useContext)($0332ec5baeac6793$var$Context);
    const disabled = $0332ec5baeac6793$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $acw62.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $acw62.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $0bb7808e9486acbd$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $0bb7808e9486acbd$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: {
            ...$0332ec5baeac6793$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $0030bffa1359ca92$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $0332ec5baeac6793$var$isValidIndex(activeIndex) && $0332ec5baeac6793$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $0332ec5baeac6793$var$isValidIndex(activeIndex) && $0332ec5baeac6793$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $acw62.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $0332ec5baeac6793$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $acw62.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $acw62.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId != null && previous.current.activeId == null) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $0332ec5baeac6793$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $0030bffa1359ca92$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transition.toString({
            ...transition,
            property: $0332ec5baeac6793$var$transitionProperty
        });
        return undefined;
    }
}
function $0332ec5baeac6793$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === 'boolean') return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $0332ec5baeac6793$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) return true;
    return false;
}
const $0332ec5baeac6793$var$directions = [
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Right,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Up,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Left
];
const $0332ec5baeac6793$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($0332ec5baeac6793$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $0bb7808e9486acbd$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $0bb7808e9486acbd$export$ef1beab6d7287295)(collisions, 'id');
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $0bb7808e9486acbd$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $0332ec5baeac6793$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $0332ec5baeac6793$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $0332ec5baeac6793$var$isSameContainer(a, b) {
    if (!$0332ec5baeac6793$export$6424ec8a0d450b09(a) || !$0332ec5baeac6793$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $0332ec5baeac6793$var$isAfter(a, b) {
    if (!$0332ec5baeac6793$export$6424ec8a0d450b09(a) || !$0332ec5baeac6793$export$6424ec8a0d450b09(b)) return false;
    if (!$0332ec5baeac6793$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}




// Canonical lists of category appearance options, shared by the server
// (mutation validation) and the frontend (pickers and rendering). The
// frontend maps icon names to lucide-react components in
// src/categoryAppearance.tsx — keep that registry in sync with this list.
const $b6ddd498a221dbc5$export$975c46174dc0a150 = [
    "red",
    "orange",
    "amber",
    "emerald",
    "teal",
    "sky",
    "violet",
    "pink"
];
const $b6ddd498a221dbc5$export$e2e3e5e46b905df3 = (value)=>$b6ddd498a221dbc5$export$975c46174dc0a150.includes(value);
const $b6ddd498a221dbc5$export$a067559dfca27e2 = [
    "baby",
    "badge-dollar-sign",
    "banknote",
    "beer",
    "bike",
    "book-open",
    "briefcase",
    "building",
    "bus",
    "camera",
    "car",
    "car-taxi-front",
    "cat",
    "chef-hat",
    "code",
    "coffee",
    "coins",
    "credit-card",
    "dices",
    "dog",
    "donut",
    "droplets",
    "dumbbell",
    "film",
    "fuel",
    "gamepad-2",
    "gift",
    "graduation-cap",
    "hammer",
    "hand-coins",
    "heart-handshake",
    "heart-pulse",
    "home",
    "lamp",
    "landmark",
    "laptop",
    "martini",
    "music",
    "percent",
    "phone",
    "piano",
    "piggy-bank",
    "pill",
    "pizza",
    "plane",
    "receipt",
    "repeat",
    "scissors",
    "shapes",
    "shirt",
    "shopping-bag",
    "shopping-cart",
    "sofa",
    "spade",
    "sparkles",
    "stethoscope",
    "tag",
    "tennis-ball",
    "tennis-racket",
    "train-front",
    "tram-front",
    "trees",
    "trending-up",
    "tv",
    "umbrella",
    "user-round",
    "users-round",
    "utensils",
    "wifi",
    "wrench",
    "zap"
];
const $b6ddd498a221dbc5$export$aec4ec8c571a0835 = (value)=>$b6ddd498a221dbc5$export$a067559dfca27e2.includes(value);


/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2114c99dcc668b71$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m3 16 4 4 4-4",
            key: "1co6wj"
        }
    ],
    [
        "path",
        {
            d: "M7 20V4",
            key: "1yoxec"
        }
    ],
    [
        "path",
        {
            d: "M20 8h-5",
            key: "1vsyxs"
        }
    ],
    [
        "path",
        {
            d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10",
            key: "ag13bf"
        }
    ],
    [
        "path",
        {
            d: "M15 14h5l-5 6h5",
            key: "ur5jdg"
        }
    ]
];
const $2114c99dcc668b71$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-down-a-z", $2114c99dcc668b71$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a2dfa57d290a8089$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4.929 4.929 19.07 19.071",
            key: "196cmz"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const $a2dfa57d290a8089$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ban", $a2dfa57d290a8089$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $578293164592f2cd$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "9",
            cy: "12",
            r: "1",
            key: "1vctgf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "5",
            r: "1",
            key: "hp0tcf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "19",
            r: "1",
            key: "fkjjf6"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "12",
            r: "1",
            key: "1tmaij"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "5",
            r: "1",
            key: "19l28e"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "19",
            r: "1",
            key: "f4zoj3"
        }
    ]
];
const $578293164592f2cd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("grip-vertical", $578293164592f2cd$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $126ba921a4c40132$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
            key: "e79jfc"
        }
    ],
    [
        "circle",
        {
            cx: "13.5",
            cy: "6.5",
            r: ".5",
            fill: "currentColor",
            key: "1okk4w"
        }
    ],
    [
        "circle",
        {
            cx: "17.5",
            cy: "10.5",
            r: ".5",
            fill: "currentColor",
            key: "f64h9f"
        }
    ],
    [
        "circle",
        {
            cx: "6.5",
            cy: "12.5",
            r: ".5",
            fill: "currentColor",
            key: "qy21gx"
        }
    ],
    [
        "circle",
        {
            cx: "8.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "fotxhn"
        }
    ]
];
const $126ba921a4c40132$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("palette", $126ba921a4c40132$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");

const $a5ee6aaf43da69f6$export$f2f1601b72ada50d = (store, groups)=>{
    store.writeQuery({
        query: (0, $ce9d9e524be20f53$export$3843ec340ebce4f5),
        data: {
            allCategoryGroups: groups
        }
    });
};
const $a5ee6aaf43da69f6$export$b2f5ba7618faddbf = (store, categoryId)=>{
    const data = store.readQuery({
        query: (0, $ce9d9e524be20f53$export$3843ec340ebce4f5)
    });
    if (!data) return;
    store.writeQuery({
        query: (0, $ce9d9e524be20f53$export$3843ec340ebce4f5),
        data: {
            allCategoryGroups: data.allCategoryGroups.map((group)=>({
                    ...group,
                    categoryIds: group.categoryIds.filter((id)=>id !== categoryId)
                }))
        }
    });
};
const $a5ee6aaf43da69f6$export$82ff8835e0914fca = (store, newGroup)=>{
    const data = store.readQuery({
        query: (0, $ce9d9e524be20f53$export$3843ec340ebce4f5)
    });
    if (!data) // The query hasn't completed — writing [newGroup] here would make a
    // partial list look complete. Skip; the query's own response will
    // include the new group.
    return;
    const groups = data.allCategoryGroups;
    if (!groups.find((g)=>g._id === newGroup._id)) store.writeQuery({
        query: (0, $ce9d9e524be20f53$export$3843ec340ebce4f5),
        data: {
            allCategoryGroups: [
                ...groups,
                newGroup
            ]
        }
    });
};



/**
 * @license @lucide/lab v0.1.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $d3679701fdad3d7b$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "M2 12c5.5 0 10-4.5 10-10",
            key: "179xs2"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M22 12c-5.5 0-10 4.5-10 10",
            key: "gdzvca"
        }
    ]
];

/**
 * @license @lucide/lab v0.1.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $c55ddb4fd2c325a6$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "M10.7 4.7c3-3 7.4-3.6 9.8-1.2s1.8 6.8-1.2 9.8a9.5 9.5 0 0 1-4.3 2.5c-2.1.5-4.1.1-5.5-1.3S7.7 11.1 8.2 9a9.5 9.5 0 0 1 2.5-4.3",
            key: "zxj3xr"
        }
    ],
    [
        "path",
        {
            d: "M8.2 9 6 18l9-2.2",
            key: "1ivsmd"
        }
    ],
    [
        "path",
        {
            d: "m2 22 4-4",
            key: "vwo6p4"
        }
    ],
    [
        "circle",
        {
            cx: "20",
            cy: "20",
            r: "2",
            key: "a056ao"
        }
    ]
];



/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dbe0cbc446f3d7c2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5",
            key: "1u7htd"
        }
    ],
    [
        "path",
        {
            d: "M15 12h.01",
            key: "1k8ypt"
        }
    ],
    [
        "path",
        {
            d: "M19.38 6.813A9 9 0 0 1 20.8 10.2a2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
            key: "11xh7x"
        }
    ],
    [
        "path",
        {
            d: "M9 12h.01",
            key: "157uk2"
        }
    ]
];
const $dbe0cbc446f3d7c2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("baby", $dbe0cbc446f3d7c2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5afa39945382809a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
            key: "3c2336"
        }
    ],
    [
        "path",
        {
            d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8",
            key: "1h4pet"
        }
    ],
    [
        "path",
        {
            d: "M12 18V6",
            key: "zqpxq5"
        }
    ]
];
const $5afa39945382809a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("badge-dollar-sign", $5afa39945382809a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $399d1cc6b64aaf4c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M17 11h1a3 3 0 0 1 0 6h-1",
            key: "1yp76v"
        }
    ],
    [
        "path",
        {
            d: "M9 12v6",
            key: "1u1cab"
        }
    ],
    [
        "path",
        {
            d: "M13 12v6",
            key: "1sugkk"
        }
    ],
    [
        "path",
        {
            d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
            key: "1510fo"
        }
    ],
    [
        "path",
        {
            d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8",
            key: "19jb7n"
        }
    ]
];
const $399d1cc6b64aaf4c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("beer", $399d1cc6b64aaf4c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $caff87954e9a0d9d$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "18.5",
            cy: "17.5",
            r: "3.5",
            key: "15x4ox"
        }
    ],
    [
        "circle",
        {
            cx: "5.5",
            cy: "17.5",
            r: "3.5",
            key: "1noe27"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "5",
            r: "1",
            key: "19l28e"
        }
    ],
    [
        "path",
        {
            d: "M12 17.5V14l-3-3 4-3 2 3h2",
            key: "1npguv"
        }
    ]
];
const $caff87954e9a0d9d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("bike", $caff87954e9a0d9d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e1cfd183b457f6f1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 7v14",
            key: "1akyts"
        }
    ],
    [
        "path",
        {
            d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
            key: "ruj8y"
        }
    ]
];
const $e1cfd183b457f6f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("book-open", $e1cfd183b457f6f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $34c3e517ec92034a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
            key: "jecpp"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "6",
            rx: "2",
            key: "i6l2r4"
        }
    ]
];
const $34c3e517ec92034a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("briefcase", $34c3e517ec92034a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8474226e5f2f9b18$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 10h.01",
            key: "1nrarc"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M12 6h.01",
            key: "1vi96p"
        }
    ],
    [
        "path",
        {
            d: "M16 10h.01",
            key: "1m94wz"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M16 6h.01",
            key: "1x0f13"
        }
    ],
    [
        "path",
        {
            d: "M8 10h.01",
            key: "19clt8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M8 6h.01",
            key: "1dz90k"
        }
    ],
    [
        "path",
        {
            d: "M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3",
            key: "cabbwy"
        }
    ],
    [
        "rect",
        {
            x: "4",
            y: "2",
            width: "16",
            height: "20",
            rx: "2",
            key: "1uxh74"
        }
    ]
];
const $8474226e5f2f9b18$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("building", $8474226e5f2f9b18$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2546f381d3fa9e6e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 6v6",
            key: "18i7km"
        }
    ],
    [
        "path",
        {
            d: "M15 6v6",
            key: "1sg6z9"
        }
    ],
    [
        "path",
        {
            d: "M2 12h19.6",
            key: "de5uta"
        }
    ],
    [
        "path",
        {
            d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
            key: "1wwztk"
        }
    ],
    [
        "circle",
        {
            cx: "7",
            cy: "18",
            r: "2",
            key: "19iecd"
        }
    ],
    [
        "path",
        {
            d: "M9 18h5",
            key: "lrx6i"
        }
    ],
    [
        "circle",
        {
            cx: "16",
            cy: "18",
            r: "2",
            key: "1v4tcr"
        }
    ]
];
const $2546f381d3fa9e6e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("bus", $2546f381d3fa9e6e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7fca19d3fce363c2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
            key: "18u6gg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "13",
            r: "3",
            key: "1vg3eu"
        }
    ]
];
const $7fca19d3fce363c2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("camera", $7fca19d3fce363c2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5476308704ab732d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
            key: "5owen"
        }
    ],
    [
        "circle",
        {
            cx: "7",
            cy: "17",
            r: "2",
            key: "u2ysq9"
        }
    ],
    [
        "path",
        {
            d: "M9 17h6",
            key: "r8uit2"
        }
    ],
    [
        "circle",
        {
            cx: "17",
            cy: "17",
            r: "2",
            key: "axvx0g"
        }
    ]
];
const $5476308704ab732d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("car", $5476308704ab732d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c34d50d526b2b3d1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 2h4",
            key: "n1abiw"
        }
    ],
    [
        "path",
        {
            d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8",
            key: "1imjwt"
        }
    ],
    [
        "path",
        {
            d: "M7 14h.01",
            key: "1qa3f1"
        }
    ],
    [
        "path",
        {
            d: "M17 14h.01",
            key: "7oqj8z"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "8",
            x: "3",
            y: "10",
            rx: "2",
            key: "a7itu8"
        }
    ],
    [
        "path",
        {
            d: "M5 18v2",
            key: "ppbyun"
        }
    ],
    [
        "path",
        {
            d: "M19 18v2",
            key: "gy7782"
        }
    ]
];
const $c34d50d526b2b3d1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("car-taxi-front", $c34d50d526b2b3d1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cb8388bf04536181$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
            key: "x6xyqk"
        }
    ],
    [
        "path",
        {
            d: "M8 14v.5",
            key: "1nzgdb"
        }
    ],
    [
        "path",
        {
            d: "M16 14v.5",
            key: "1lajdz"
        }
    ],
    [
        "path",
        {
            d: "M11.25 16.25h1.5L12 17l-.75-.75Z",
            key: "12kq1m"
        }
    ]
];
const $cb8388bf04536181$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("cat", $cb8388bf04536181$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1a3e2b573c95ad75$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
            key: "1qvrer"
        }
    ],
    [
        "path",
        {
            d: "M6 17h12",
            key: "1jwigz"
        }
    ]
];
const $1a3e2b573c95ad75$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chef-hat", $1a3e2b573c95ad75$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2db246ad160134fa$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 18 6-6-6-6",
            key: "eg8j8"
        }
    ],
    [
        "path",
        {
            d: "m8 6-6 6 6 6",
            key: "ppft3o"
        }
    ]
];
const $2db246ad160134fa$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("code", $2db246ad160134fa$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6826835d9d90fe9d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 2v2",
            key: "7u0qdc"
        }
    ],
    [
        "path",
        {
            d: "M14 2v2",
            key: "6buw04"
        }
    ],
    [
        "path",
        {
            d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
            key: "pwadti"
        }
    ],
    [
        "path",
        {
            d: "M6 2v2",
            key: "colzsn"
        }
    ]
];
const $6826835d9d90fe9d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("coffee", $6826835d9d90fe9d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ec88f95add56de8$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "8",
            cy: "8",
            r: "6",
            key: "3yglwk"
        }
    ],
    [
        "path",
        {
            d: "M18.09 10.37A6 6 0 1 1 10.34 18",
            key: "t5s6rm"
        }
    ],
    [
        "path",
        {
            d: "M7 6h1v4",
            key: "1obek4"
        }
    ],
    [
        "path",
        {
            d: "m16.71 13.88.7.71-2.82 2.82",
            key: "1rbuyh"
        }
    ]
];
const $9ec88f95add56de8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("coins", $9ec88f95add56de8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $80b49fa3579a7ca3$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "12",
            height: "12",
            x: "2",
            y: "10",
            rx: "2",
            ry: "2",
            key: "6agr2n"
        }
    ],
    [
        "path",
        {
            d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6",
            key: "1o487t"
        }
    ],
    [
        "path",
        {
            d: "M6 18h.01",
            key: "uhywen"
        }
    ],
    [
        "path",
        {
            d: "M10 14h.01",
            key: "ssrbsk"
        }
    ],
    [
        "path",
        {
            d: "M15 6h.01",
            key: "cblpky"
        }
    ],
    [
        "path",
        {
            d: "M18 9h.01",
            key: "2061c0"
        }
    ]
];
const $80b49fa3579a7ca3$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("dices", $80b49fa3579a7ca3$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $da7acf661ca2b113$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.25 16.25h1.5L12 17z",
            key: "w7jh35"
        }
    ],
    [
        "path",
        {
            d: "M16 14v.5",
            key: "1lajdz"
        }
    ],
    [
        "path",
        {
            d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444a11.702 11.702 0 0 0-.493-3.309",
            key: "u7s9ue"
        }
    ],
    [
        "path",
        {
            d: "M8 14v.5",
            key: "1nzgdb"
        }
    ],
    [
        "path",
        {
            d: "M8.5 8.5c-.384 1.05-1.083 2.028-2.344 2.5-1.931.722-3.576-.297-3.656-1-.113-.994 1.177-6.53 4-7 1.923-.321 3.651.845 3.651 2.235A7.497 7.497 0 0 1 14 5.277c0-1.39 1.844-2.598 3.767-2.277 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
            key: "v8hric"
        }
    ]
];
const $da7acf661ca2b113$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("dog", $da7acf661ca2b113$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b2465b2f3c71097$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
            key: "19sr3x"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $7b2465b2f3c71097$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("donut", $7b2465b2f3c71097$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $348884b07a4fa71d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
            key: "1ptgy4"
        }
    ],
    [
        "path",
        {
            d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
            key: "1sl1rz"
        }
    ]
];
const $348884b07a4fa71d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("droplets", $348884b07a4fa71d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1b2187ead7f21382$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M17.596 12.768a2 2 0 1 0 2.829-2.829l-1.768-1.767a2 2 0 0 0 2.828-2.829l-2.828-2.828a2 2 0 0 0-2.829 2.828l-1.767-1.768a2 2 0 1 0-2.829 2.829z",
            key: "9m4mmf"
        }
    ],
    [
        "path",
        {
            d: "m2.5 21.5 1.4-1.4",
            key: "17g3f0"
        }
    ],
    [
        "path",
        {
            d: "m20.1 3.9 1.4-1.4",
            key: "1qn309"
        }
    ],
    [
        "path",
        {
            d: "M5.343 21.485a2 2 0 1 0 2.829-2.828l1.767 1.768a2 2 0 1 0 2.829-2.829l-6.364-6.364a2 2 0 1 0-2.829 2.829l1.768 1.767a2 2 0 0 0-2.828 2.829z",
            key: "1t2c92"
        }
    ],
    [
        "path",
        {
            d: "m9.6 14.4 4.8-4.8",
            key: "6umqxw"
        }
    ]
];
const $1b2187ead7f21382$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("dumbbell", $1b2187ead7f21382$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d8cd836460c6f743$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M7 3v18",
            key: "bbkbws"
        }
    ],
    [
        "path",
        {
            d: "M3 7.5h4",
            key: "zfgn84"
        }
    ],
    [
        "path",
        {
            d: "M3 12h18",
            key: "1i2n21"
        }
    ],
    [
        "path",
        {
            d: "M3 16.5h4",
            key: "1230mu"
        }
    ],
    [
        "path",
        {
            d: "M17 3v18",
            key: "in4fa5"
        }
    ],
    [
        "path",
        {
            d: "M17 7.5h4",
            key: "myr1c1"
        }
    ],
    [
        "path",
        {
            d: "M17 16.5h4",
            key: "go4c1d"
        }
    ]
];
const $d8cd836460c6f743$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("film", $d8cd836460c6f743$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8b48c2c9c03a8451$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 4 0v-6.998a2 2 0 0 0-.59-1.42L18 5",
            key: "1wtuz0"
        }
    ],
    [
        "path",
        {
            d: "M14 21V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16",
            key: "e09ifn"
        }
    ],
    [
        "path",
        {
            d: "M2 21h13",
            key: "1x0fut"
        }
    ],
    [
        "path",
        {
            d: "M3 9h11",
            key: "1p7c0w"
        }
    ]
];
const $8b48c2c9c03a8451$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("fuel", $8b48c2c9c03a8451$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a92113860a539098$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "6",
            x2: "10",
            y1: "11",
            y2: "11",
            key: "1gktln"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "8",
            y1: "9",
            y2: "13",
            key: "qnk9ow"
        }
    ],
    [
        "line",
        {
            x1: "15",
            x2: "15.01",
            y1: "12",
            y2: "12",
            key: "krot7o"
        }
    ],
    [
        "line",
        {
            x1: "18",
            x2: "18.01",
            y1: "10",
            y2: "10",
            key: "1lcuu1"
        }
    ],
    [
        "path",
        {
            d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
            key: "mfqc10"
        }
    ]
];
const $a92113860a539098$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("gamepad-2", $a92113860a539098$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6315759428919b56$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            x: "3",
            y: "8",
            width: "18",
            height: "4",
            rx: "1",
            key: "bkv52"
        }
    ],
    [
        "path",
        {
            d: "M12 8v13",
            key: "1c76mn"
        }
    ],
    [
        "path",
        {
            d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7",
            key: "6wjy6b"
        }
    ],
    [
        "path",
        {
            d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
            key: "1ihvrl"
        }
    ]
];
const $6315759428919b56$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("gift", $6315759428919b56$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d456d8ec70b00bbe$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
            key: "j76jl0"
        }
    ],
    [
        "path",
        {
            d: "M22 10v6",
            key: "1lu8f3"
        }
    ],
    [
        "path",
        {
            d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5",
            key: "1r8lef"
        }
    ]
];
const $d456d8ec70b00bbe$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("graduation-cap", $d456d8ec70b00bbe$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $712d717556ef1508$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 12-9.373 9.373a1 1 0 0 1-3.001-3L12 9",
            key: "1hayfq"
        }
    ],
    [
        "path",
        {
            d: "m18 15 4-4",
            key: "16gjal"
        }
    ],
    [
        "path",
        {
            d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172v-.344a2 2 0 0 0-.586-1.414l-1.657-1.657A6 6 0 0 0 12.516 3H9l1.243 1.243A6 6 0 0 1 12 8.485V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
            key: "15ts47"
        }
    ]
];
const $712d717556ef1508$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("hammer", $712d717556ef1508$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bfcb8924c7a113d6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19.414 14.414C21 12.828 22 11.5 22 9.5a5.5 5.5 0 0 0-9.591-3.676.6.6 0 0 1-.818.001A5.5 5.5 0 0 0 2 9.5c0 2.3 1.5 4 3 5.5l5.535 5.362a2 2 0 0 0 2.879.052 2.12 2.12 0 0 0-.004-3 2.124 2.124 0 1 0 3-3 2.124 2.124 0 0 0 3.004 0 2 2 0 0 0 0-2.828l-1.881-1.882a2.41 2.41 0 0 0-3.409 0l-1.71 1.71a2 2 0 0 1-2.828 0 2 2 0 0 1 0-2.828l2.823-2.762",
            key: "17lmqv"
        }
    ]
];
const $bfcb8924c7a113d6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("heart-handshake", $bfcb8924c7a113d6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $95e9e50748ea8ef2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
            key: "mvr1a0"
        }
    ],
    [
        "path",
        {
            d: "M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27",
            key: "auskq0"
        }
    ]
];
const $95e9e50748ea8ef2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("heart-pulse", $95e9e50748ea8ef2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bee7e1f6335e67ab$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8",
            key: "5wwlr5"
        }
    ],
    [
        "path",
        {
            d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
            key: "r6nss1"
        }
    ]
];
const $bee7e1f6335e67ab$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("house", $bee7e1f6335e67ab$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9c8e67ce72e6edc1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 12v6",
            key: "3ahymv"
        }
    ],
    [
        "path",
        {
            d: "M4.077 10.615A1 1 0 0 0 5 12h14a1 1 0 0 0 .923-1.385l-3.077-7.384A2 2 0 0 0 15 2H9a2 2 0 0 0-1.846 1.23Z",
            key: "1l7kg2"
        }
    ],
    [
        "path",
        {
            d: "M8 20a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1z",
            key: "1mmzpi"
        }
    ]
];
const $9c8e67ce72e6edc1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("lamp", $9c8e67ce72e6edc1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $27047bb67f23145f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 5a2 2 0 0 1 2 2v8.526a2 2 0 0 0 .212.897l1.068 2.127a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45l1.068-2.127A2 2 0 0 0 4 15.526V7a2 2 0 0 1 2-2z",
            key: "1pdavp"
        }
    ],
    [
        "path",
        {
            d: "M20.054 15.987H3.946",
            key: "14rxg9"
        }
    ]
];
const $27047bb67f23145f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("laptop", $27047bb67f23145f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1162da03de33774b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 22h8",
            key: "rmew8v"
        }
    ],
    [
        "path",
        {
            d: "M12 11v11",
            key: "ur9y6a"
        }
    ],
    [
        "path",
        {
            d: "m19 3-7 8-7-8Z",
            key: "1sgpiw"
        }
    ]
];
const $1162da03de33774b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("martini", $1162da03de33774b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $766b7a414a24981f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 18V5l12-2v13",
            key: "1jmyc2"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "18",
            r: "3",
            key: "fqmcym"
        }
    ],
    [
        "circle",
        {
            cx: "18",
            cy: "16",
            r: "3",
            key: "1hluhg"
        }
    ]
];
const $766b7a414a24981f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("music", $766b7a414a24981f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b97e024910b40ff$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "19",
            x2: "5",
            y1: "5",
            y2: "19",
            key: "1x9vlm"
        }
    ],
    [
        "circle",
        {
            cx: "6.5",
            cy: "6.5",
            r: "2.5",
            key: "4mh3h7"
        }
    ],
    [
        "circle",
        {
            cx: "17.5",
            cy: "17.5",
            r: "2.5",
            key: "1mdrzq"
        }
    ]
];
const $7b97e024910b40ff$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("percent", $7b97e024910b40ff$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $970c5cdf933ea69e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
            key: "9njp5v"
        }
    ]
];
const $970c5cdf933ea69e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("phone", $970c5cdf933ea69e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2f4779b8e709c4b2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8",
            key: "lag0yf"
        }
    ],
    [
        "path",
        {
            d: "M2 14h20",
            key: "myj16y"
        }
    ],
    [
        "path",
        {
            d: "M6 14v4",
            key: "9ng0ue"
        }
    ],
    [
        "path",
        {
            d: "M10 14v4",
            key: "1v8uk5"
        }
    ],
    [
        "path",
        {
            d: "M14 14v4",
            key: "1tqops"
        }
    ],
    [
        "path",
        {
            d: "M18 14v4",
            key: "18uqwm"
        }
    ]
];
const $2f4779b8e709c4b2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("piano", $2f4779b8e709c4b2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c42d182890f3ecf5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 17h3v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a3.16 3.16 0 0 0 2-2h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1a5 5 0 0 0-2-4V3a4 4 0 0 0-3.2 1.6l-.3.4H11a6 6 0 0 0-6 6v1a5 5 0 0 0 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1z",
            key: "1piglc"
        }
    ],
    [
        "path",
        {
            d: "M16 10h.01",
            key: "1m94wz"
        }
    ],
    [
        "path",
        {
            d: "M2 8v1a2 2 0 0 0 2 2h1",
            key: "1env43"
        }
    ]
];
const $c42d182890f3ecf5$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("piggy-bank", $c42d182890f3ecf5$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cbbc74248b5542c0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z",
            key: "wa1lgi"
        }
    ],
    [
        "path",
        {
            d: "m8.5 8.5 7 7",
            key: "rvfmvr"
        }
    ]
];
const $cbbc74248b5542c0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pill", $cbbc74248b5542c0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f65ee8c4f907f918$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 14-1 1",
            key: "11onhr"
        }
    ],
    [
        "path",
        {
            d: "m13.75 18.25-1.25 1.42",
            key: "1yisr3"
        }
    ],
    [
        "path",
        {
            d: "M17.775 5.654a15.68 15.68 0 0 0-12.121 12.12",
            key: "1qtqk6"
        }
    ],
    [
        "path",
        {
            d: "M18.8 9.3a1 1 0 0 0 2.1 7.7",
            key: "fbbbr2"
        }
    ],
    [
        "path",
        {
            d: "M21.964 20.732a1 1 0 0 1-1.232 1.232l-18-5a1 1 0 0 1-.695-1.232A19.68 19.68 0 0 1 15.732 2.037a1 1 0 0 1 1.232.695z",
            key: "1hyfdd"
        }
    ]
];
const $f65ee8c4f907f918$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pizza", $f65ee8c4f907f918$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $14abdb289fc4fd6a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
            key: "1v9wt8"
        }
    ]
];
const $14abdb289fc4fd6a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("plane", $14abdb289fc4fd6a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6b98cc9f5dadc552$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m17 2 4 4-4 4",
            key: "nntrym"
        }
    ],
    [
        "path",
        {
            d: "M3 11v-1a4 4 0 0 1 4-4h14",
            key: "84bu3i"
        }
    ],
    [
        "path",
        {
            d: "m7 22-4-4 4-4",
            key: "1wqhfi"
        }
    ],
    [
        "path",
        {
            d: "M21 13v1a4 4 0 0 1-4 4H3",
            key: "1rx37r"
        }
    ]
];
const $6b98cc9f5dadc552$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("repeat", $6b98cc9f5dadc552$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2c4b775586278895$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "6",
            cy: "6",
            r: "3",
            key: "1lh9wr"
        }
    ],
    [
        "path",
        {
            d: "M8.12 8.12 12 12",
            key: "1alkpv"
        }
    ],
    [
        "path",
        {
            d: "M20 4 8.12 15.88",
            key: "xgtan2"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "18",
            r: "3",
            key: "fqmcym"
        }
    ],
    [
        "path",
        {
            d: "M14.8 14.8 20 20",
            key: "ptml3r"
        }
    ]
];
const $2c4b775586278895$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("scissors", $2c4b775586278895$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c77b9d28827cc431$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
            key: "1bo67w"
        }
    ],
    [
        "rect",
        {
            x: "3",
            y: "14",
            width: "7",
            height: "7",
            rx: "1",
            key: "1bkyp8"
        }
    ],
    [
        "circle",
        {
            cx: "17.5",
            cy: "17.5",
            r: "3.5",
            key: "w3z12y"
        }
    ]
];
const $c77b9d28827cc431$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shapes", $c77b9d28827cc431$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0d47d6236e6e268e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
            key: "1wgbhj"
        }
    ]
];
const $0d47d6236e6e268e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shirt", $0d47d6236e6e268e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b42daf8f5fabfd7f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 10a4 4 0 0 1-8 0",
            key: "1ltviw"
        }
    ],
    [
        "path",
        {
            d: "M3.103 6.034h17.794",
            key: "awc11p"
        }
    ],
    [
        "path",
        {
            d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
            key: "o988cm"
        }
    ]
];
const $b42daf8f5fabfd7f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shopping-bag", $b42daf8f5fabfd7f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ee6f13a46cf9100a$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "8",
            cy: "21",
            r: "1",
            key: "jimo8o"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "21",
            r: "1",
            key: "13723u"
        }
    ],
    [
        "path",
        {
            d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
            key: "9zh506"
        }
    ]
];
const $ee6f13a46cf9100a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shopping-cart", $ee6f13a46cf9100a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6f295d27a23ce041$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3",
            key: "1dgpiv"
        }
    ],
    [
        "path",
        {
            d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
            key: "xacw8m"
        }
    ],
    [
        "path",
        {
            d: "M4 18v2",
            key: "jwo5n2"
        }
    ],
    [
        "path",
        {
            d: "M20 18v2",
            key: "1ar1qi"
        }
    ],
    [
        "path",
        {
            d: "M12 4v9",
            key: "oqhhn3"
        }
    ]
];
const $6f295d27a23ce041$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("sofa", $6f295d27a23ce041$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $aee0d9b9c699ca21$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 18v4",
            key: "jadmvz"
        }
    ],
    [
        "path",
        {
            d: "M2 14.499a5.5 5.5 0 0 0 9.591 3.675.6.6 0 0 1 .818.001A5.5 5.5 0 0 0 22 14.5c0-2.29-1.5-4-3-5.5l-5.492-5.312a2 2 0 0 0-3-.02L5 8.999c-1.5 1.5-3 3.2-3 5.5",
            key: "1aw2pz"
        }
    ]
];
const $aee0d9b9c699ca21$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("spade", $aee0d9b9c699ca21$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3883d84d119a3732$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 2v2",
            key: "1539x4"
        }
    ],
    [
        "path",
        {
            d: "M5 2v2",
            key: "1yf1q8"
        }
    ],
    [
        "path",
        {
            d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1",
            key: "rb5t3r"
        }
    ],
    [
        "path",
        {
            d: "M8 15a6 6 0 0 0 12 0v-3",
            key: "x18d4x"
        }
    ],
    [
        "circle",
        {
            cx: "20",
            cy: "10",
            r: "2",
            key: "ts1r5v"
        }
    ]
];
const $3883d84d119a3732$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("stethoscope", $3883d84d119a3732$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8872a1d80d2463f9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
            key: "vktsd0"
        }
    ],
    [
        "circle",
        {
            cx: "7.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "kqv944"
        }
    ]
];
const $8872a1d80d2463f9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("tag", $8872a1d80d2463f9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0584a174a80ff400$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 3.1V7a4 4 0 0 0 8 0V3.1",
            key: "1v71zp"
        }
    ],
    [
        "path",
        {
            d: "m9 15-1-1",
            key: "1yrq24"
        }
    ],
    [
        "path",
        {
            d: "m15 15 1-1",
            key: "1t0d6s"
        }
    ],
    [
        "path",
        {
            d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z",
            key: "1p0hjs"
        }
    ],
    [
        "path",
        {
            d: "m8 19-2 3",
            key: "13i0xs"
        }
    ],
    [
        "path",
        {
            d: "m16 19 2 3",
            key: "xo31yx"
        }
    ]
];
const $0584a174a80ff400$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("train-front", $0584a174a80ff400$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $abb9cf396a702aa9$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "16",
            height: "16",
            x: "4",
            y: "3",
            rx: "2",
            key: "1wxw4b"
        }
    ],
    [
        "path",
        {
            d: "M4 11h16",
            key: "mpoxn0"
        }
    ],
    [
        "path",
        {
            d: "M12 3v8",
            key: "1h2ygw"
        }
    ],
    [
        "path",
        {
            d: "m8 19-2 3",
            key: "13i0xs"
        }
    ],
    [
        "path",
        {
            d: "m18 22-2-3",
            key: "1p0ohu"
        }
    ],
    [
        "path",
        {
            d: "M8 15h.01",
            key: "a7atzg"
        }
    ],
    [
        "path",
        {
            d: "M16 15h.01",
            key: "rnfrdf"
        }
    ]
];
const $abb9cf396a702aa9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("tram-front", $abb9cf396a702aa9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fab2f21898bf5b1d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z",
            key: "1l6gj6"
        }
    ],
    [
        "path",
        {
            d: "M7 16v6",
            key: "1a82de"
        }
    ],
    [
        "path",
        {
            d: "M13 19v3",
            key: "13sx9i"
        }
    ],
    [
        "path",
        {
            d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
            key: "1sj9kv"
        }
    ]
];
const $fab2f21898bf5b1d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trees", $fab2f21898bf5b1d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ccfa55d03e3db029$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m17 2-5 5-5-5",
            key: "16satq"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "15",
            x: "2",
            y: "7",
            rx: "2",
            key: "1e6viu"
        }
    ]
];
const $ccfa55d03e3db029$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("tv", $ccfa55d03e3db029$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $263c071e3a2f8eee$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 13v7a2 2 0 0 0 4 0",
            key: "rpgb42"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M20.992 13a1 1 0 0 0 .97-1.274 10.284 10.284 0 0 0-19.923 0A1 1 0 0 0 3 13z",
            key: "124nyo"
        }
    ]
];
const $263c071e3a2f8eee$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("umbrella", $263c071e3a2f8eee$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0740549741641712$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "5",
            key: "1hypcn"
        }
    ],
    [
        "path",
        {
            d: "M20 21a8 8 0 0 0-16 0",
            key: "rfgkzh"
        }
    ]
];
const $0740549741641712$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user-round", $0740549741641712$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $26e74a24e9f2bb34$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 21a8 8 0 0 0-16 0",
            key: "3ypg7q"
        }
    ],
    [
        "circle",
        {
            cx: "10",
            cy: "8",
            r: "5",
            key: "o932ke"
        }
    ],
    [
        "path",
        {
            d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3",
            key: "10s06x"
        }
    ]
];
const $26e74a24e9f2bb34$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("users-round", $26e74a24e9f2bb34$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $699818e4e9574c07$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2",
            key: "cjf0a3"
        }
    ],
    [
        "path",
        {
            d: "M7 2v20",
            key: "1473qp"
        }
    ],
    [
        "path",
        {
            d: "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7",
            key: "j28e5"
        }
    ]
];
const $699818e4e9574c07$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("utensils", $699818e4e9574c07$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b144e577f231bbf4$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M2 8.82a15 15 0 0 1 20 0",
            key: "dnpr2z"
        }
    ],
    [
        "path",
        {
            d: "M5 12.859a10 10 0 0 1 14 0",
            key: "1x1e6c"
        }
    ],
    [
        "path",
        {
            d: "M8.5 16.429a5 5 0 0 1 7 0",
            key: "1bycff"
        }
    ]
];
const $b144e577f231bbf4$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("wifi", $b144e577f231bbf4$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $888d8be60abebd94$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
            key: "1ngwbx"
        }
    ]
];
const $888d8be60abebd94$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("wrench", $888d8be60abebd94$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $00b4789eeda33397$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
            key: "1xq2db"
        }
    ]
];
const $00b4789eeda33397$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("zap", $00b4789eeda33397$export$3efd853dbb351e94);


// Lucide Lab icons (experimental set, shipped as bare icon nodes rather
// than components) — wrapped here so they render like any other entry.
const $3076b7ee20dc9ec8$var$TennisBall = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)('tennis-ball', (0, $d3679701fdad3d7b$export$2e2bcd8739ae039));
const $3076b7ee20dc9ec8$var$TennisRacket = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)('tennis-racket', (0, $c55ddb4fd2c325a6$export$2e2bcd8739ae039));
const $3076b7ee20dc9ec8$export$b0372430f00fdb14 = {
    baby: (0, $dbe0cbc446f3d7c2$export$2e2bcd8739ae039),
    'badge-dollar-sign': (0, $5afa39945382809a$export$2e2bcd8739ae039),
    banknote: (0, $1571f1c57333e026$export$2e2bcd8739ae039),
    beer: (0, $399d1cc6b64aaf4c$export$2e2bcd8739ae039),
    bike: (0, $caff87954e9a0d9d$export$2e2bcd8739ae039),
    'book-open': (0, $e1cfd183b457f6f1$export$2e2bcd8739ae039),
    briefcase: (0, $34c3e517ec92034a$export$2e2bcd8739ae039),
    building: (0, $8474226e5f2f9b18$export$2e2bcd8739ae039),
    bus: (0, $2546f381d3fa9e6e$export$2e2bcd8739ae039),
    camera: (0, $7fca19d3fce363c2$export$2e2bcd8739ae039),
    car: (0, $5476308704ab732d$export$2e2bcd8739ae039),
    'car-taxi-front': (0, $c34d50d526b2b3d1$export$2e2bcd8739ae039),
    cat: (0, $cb8388bf04536181$export$2e2bcd8739ae039),
    'chef-hat': (0, $1a3e2b573c95ad75$export$2e2bcd8739ae039),
    code: (0, $2db246ad160134fa$export$2e2bcd8739ae039),
    coffee: (0, $6826835d9d90fe9d$export$2e2bcd8739ae039),
    coins: (0, $9ec88f95add56de8$export$2e2bcd8739ae039),
    'credit-card': (0, $1299b0a605d22052$export$2e2bcd8739ae039),
    dices: (0, $80b49fa3579a7ca3$export$2e2bcd8739ae039),
    dog: (0, $da7acf661ca2b113$export$2e2bcd8739ae039),
    donut: (0, $7b2465b2f3c71097$export$2e2bcd8739ae039),
    droplets: (0, $348884b07a4fa71d$export$2e2bcd8739ae039),
    dumbbell: (0, $1b2187ead7f21382$export$2e2bcd8739ae039),
    film: (0, $d8cd836460c6f743$export$2e2bcd8739ae039),
    fuel: (0, $8b48c2c9c03a8451$export$2e2bcd8739ae039),
    'gamepad-2': (0, $a92113860a539098$export$2e2bcd8739ae039),
    gift: (0, $6315759428919b56$export$2e2bcd8739ae039),
    'graduation-cap': (0, $d456d8ec70b00bbe$export$2e2bcd8739ae039),
    hammer: (0, $712d717556ef1508$export$2e2bcd8739ae039),
    'hand-coins': (0, $07139920b5ad0ce2$export$2e2bcd8739ae039),
    'heart-handshake': (0, $bfcb8924c7a113d6$export$2e2bcd8739ae039),
    'heart-pulse': (0, $95e9e50748ea8ef2$export$2e2bcd8739ae039),
    home: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039),
    lamp: (0, $9c8e67ce72e6edc1$export$2e2bcd8739ae039),
    landmark: (0, $05565f19ab398c04$export$2e2bcd8739ae039),
    laptop: (0, $27047bb67f23145f$export$2e2bcd8739ae039),
    martini: (0, $1162da03de33774b$export$2e2bcd8739ae039),
    music: (0, $766b7a414a24981f$export$2e2bcd8739ae039),
    percent: (0, $7b97e024910b40ff$export$2e2bcd8739ae039),
    phone: (0, $970c5cdf933ea69e$export$2e2bcd8739ae039),
    piano: (0, $2f4779b8e709c4b2$export$2e2bcd8739ae039),
    'piggy-bank': (0, $c42d182890f3ecf5$export$2e2bcd8739ae039),
    pill: (0, $cbbc74248b5542c0$export$2e2bcd8739ae039),
    pizza: (0, $f65ee8c4f907f918$export$2e2bcd8739ae039),
    plane: (0, $14abdb289fc4fd6a$export$2e2bcd8739ae039),
    receipt: (0, $cab856bf30f1b37f$export$2e2bcd8739ae039),
    repeat: (0, $6b98cc9f5dadc552$export$2e2bcd8739ae039),
    scissors: (0, $2c4b775586278895$export$2e2bcd8739ae039),
    shapes: (0, $c77b9d28827cc431$export$2e2bcd8739ae039),
    shirt: (0, $0d47d6236e6e268e$export$2e2bcd8739ae039),
    'shopping-bag': (0, $b42daf8f5fabfd7f$export$2e2bcd8739ae039),
    'shopping-cart': (0, $ee6f13a46cf9100a$export$2e2bcd8739ae039),
    sofa: (0, $6f295d27a23ce041$export$2e2bcd8739ae039),
    spade: (0, $aee0d9b9c699ca21$export$2e2bcd8739ae039),
    sparkles: (0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039),
    stethoscope: (0, $3883d84d119a3732$export$2e2bcd8739ae039),
    tag: (0, $8872a1d80d2463f9$export$2e2bcd8739ae039),
    'tennis-ball': $3076b7ee20dc9ec8$var$TennisBall,
    'tennis-racket': $3076b7ee20dc9ec8$var$TennisRacket,
    'train-front': (0, $0584a174a80ff400$export$2e2bcd8739ae039),
    'tram-front': (0, $abb9cf396a702aa9$export$2e2bcd8739ae039),
    trees: (0, $fab2f21898bf5b1d$export$2e2bcd8739ae039),
    'trending-up': (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
    tv: (0, $ccfa55d03e3db029$export$2e2bcd8739ae039),
    umbrella: (0, $263c071e3a2f8eee$export$2e2bcd8739ae039),
    'user-round': (0, $0740549741641712$export$2e2bcd8739ae039),
    'users-round': (0, $26e74a24e9f2bb34$export$2e2bcd8739ae039),
    utensils: (0, $699818e4e9574c07$export$2e2bcd8739ae039),
    wifi: (0, $b144e577f231bbf4$export$2e2bcd8739ae039),
    wrench: (0, $888d8be60abebd94$export$2e2bcd8739ae039),
    zap: (0, $00b4789eeda33397$export$2e2bcd8739ae039)
};
const $3076b7ee20dc9ec8$export$ad7a0cd51bd1ba13 = {
    red: 'bg-red-500/15 text-red-700 dark:text-red-400',
    orange: 'bg-orange-500/15 text-orange-700 dark:text-orange-400',
    amber: 'bg-amber-500/15 text-amber-700 dark:text-amber-400',
    emerald: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400',
    teal: 'bg-teal-500/15 text-teal-700 dark:text-teal-400',
    sky: 'bg-sky-500/15 text-sky-700 dark:text-sky-400',
    violet: 'bg-violet-500/15 text-violet-700 dark:text-violet-400',
    pink: 'bg-pink-500/15 text-pink-700 dark:text-pink-400'
};
const $3076b7ee20dc9ec8$export$82a131a635ff0632 = {
    red: 'text-red-700/80 dark:text-red-400/80',
    orange: 'text-orange-700/80 dark:text-orange-400/80',
    amber: 'text-amber-700/80 dark:text-amber-400/80',
    emerald: 'text-emerald-700/80 dark:text-emerald-400/80',
    teal: 'text-teal-700/80 dark:text-teal-400/80',
    sky: 'text-sky-700/80 dark:text-sky-400/80',
    violet: 'text-violet-700/80 dark:text-violet-400/80',
    pink: 'text-pink-700/80 dark:text-pink-400/80'
};
const $3076b7ee20dc9ec8$export$8d5a1948373ce7cc = {
    red: 'bg-red-500',
    orange: 'bg-orange-500',
    amber: 'bg-amber-500',
    emerald: 'bg-emerald-500',
    teal: 'bg-teal-500',
    sky: 'bg-sky-500',
    violet: 'bg-violet-500',
    pink: 'bg-pink-500'
};
const $3076b7ee20dc9ec8$export$409877b2c65a5d = (value)=>value != null && (0, $b6ddd498a221dbc5$export$aec4ec8c571a0835)(value) ? value : null;
const $3076b7ee20dc9ec8$export$e700a184e8fe2b12 = (value)=>value != null && (0, $b6ddd498a221dbc5$export$e2e3e5e46b905df3)(value) ? value : null;
const $3076b7ee20dc9ec8$export$1185a41b8d33b6b8 = (name)=>{
    let hash = 0;
    for (const char of name)hash = hash * 31 + char.charCodeAt(0) | 0;
    return (0, $b6ddd498a221dbc5$export$975c46174dc0a150)[Math.abs(hash) % (0, $b6ddd498a221dbc5$export$975c46174dc0a150).length];
};




parcelRequire("acw62");


const $6080e81c2b9604e9$export$bde99f6bf04aeea3 = (props)=>{
    const { category: category, className: className } = props;
    const color = category.color != null && (0, $b6ddd498a221dbc5$export$e2e3e5e46b905df3)(category.color) ? category.color : (0, $3076b7ee20dc9ec8$export$1185a41b8d33b6b8)(category.name);
    const Icon = category.icon != null && (0, $b6ddd498a221dbc5$export$aec4ec8c571a0835)(category.icon) ? (0, $3076b7ee20dc9ec8$export$b0372430f00fdb14)[category.icon] : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex size-9 max-md:size-8 shrink-0 items-center justify-center rounded-full', (0, $3076b7ee20dc9ec8$export$ad7a0cd51bd1ba13)[color], className),
        children: Icon ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
            className: "size-4"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-sm font-semibold",
            children: category.name.charAt(0).toUpperCase()
        })
    });
};




const $50bf382d7100a561$var$GROUP_PREFIX = 'grp:';
const $50bf382d7100a561$var$MUTATION_KINDS = [
    'reorder',
    'create',
    'rename',
    'delete'
];
const $50bf382d7100a561$var$MUTATION_KIND_LABELS = {
    reorder: "Couldn't save the new order",
    create: "Couldn't create the group",
    rename: "Couldn't rename the group",
    delete: "Couldn't delete the group"
};
const $50bf382d7100a561$var$buildDraft = (groups, previous)=>{
    // Keep the previous draft's order where possible so an in-flight drag
    // isn't clobbered; drop removed groups/categories, append new ones.
    const groupIds = new Set(groups.map((g)=>g._id));
    const keptOrder = (previous?.order ?? []).filter((id)=>groupIds.has(id));
    const keptSet = new Set(keptOrder);
    const order = [
        ...keptOrder,
        ...groups.map((g)=>g._id).filter((id)=>!keptSet.has(id))
    ];
    const members = {};
    for (const group of groups){
        const memberSet = new Set(group.categoryIds);
        const kept = (previous?.members[group._id] ?? []).filter((id)=>memberSet.has(id));
        const keptMembers = new Set(kept);
        members[group._id] = [
            ...kept,
            ...group.categoryIds.filter((id)=>!keptMembers.has(id))
        ];
    }
    return {
        order: order,
        members: members
    };
};
const $50bf382d7100a561$var$RearrangeCategoryRow = ({ category: category, sortable: sortable })=>{
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition, isDragging: isDragging } = (0, $0332ec5baeac6793$export$4ebcb6201122185a)({
        id: category._id,
        disabled: !sortable
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: setNodeRef,
        style: {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(transform),
            transition: transition
        },
        className: `border-border bg-card flex items-center gap-3 rounded-lg border p-3 ${isDragging ? 'opacity-50' : ''}`,
        children: [
            sortable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "text-muted-foreground hover:text-foreground cursor-grab touch-none",
                ...attributes,
                ...listeners,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $578293164592f2cd$export$2e2bcd8739ae039), {
                    className: "size-5"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6080e81c2b9604e9$export$bde99f6bf04aeea3), {
                category: category
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-foreground font-medium",
                children: category.name
            })
        ]
    });
};
/** A group section, itself sortable by its header grip. */ const $50bf382d7100a561$var$SortableGroupSection = ({ group: group, categories: categories, memberIds: memberIds, onAlphabetize: onAlphabetize, onRename: onRename, onSetColor: onSetColor, onDelete: onDelete })=>{
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition, isDragging: isDragging } = (0, $0332ec5baeac6793$export$4ebcb6201122185a)({
        id: `${$50bf382d7100a561$var$GROUP_PREFIX}${group._id}`
    });
    const [renaming, setRenaming] = $acw62.useState(false);
    const [coloring, setColoring] = $acw62.useState(false);
    const [draftName, setDraftName] = $acw62.useState(group.name);
    const groupColor = (0, $3076b7ee20dc9ec8$export$e700a184e8fe2b12)(group.color ?? null);
    const startRename = ()=>{
        setDraftName(group.name);
        setRenaming(true);
    };
    const commitRename = ()=>{
        setRenaming(false);
        const trimmed = draftName.trim();
        if (trimmed && trimmed !== group.name) onRename(trimmed);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: setNodeRef,
        style: {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(transform),
            transition: transition
        },
        className: isDragging ? 'opacity-50' : '',
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-2 flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "text-muted-foreground hover:text-foreground cursor-grab touch-none",
                        ...attributes,
                        ...listeners,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $578293164592f2cd$export$2e2bcd8739ae039), {
                            className: "size-4"
                        })
                    }),
                    renaming ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                autoFocus: true,
                                value: draftName,
                                onChange: setDraftName,
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        commitRename();
                                    } else if (e.key === 'Escape') setRenaming(false);
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                size: "icon",
                                onClick: commitRename,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                    className: "size-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                size: "icon",
                                onClick: ()=>setRenaming(false),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    className: "size-4"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-foreground text-sm font-semibold",
                                children: group.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground text-xs",
                                children: memberIds.length
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                size: "icon",
                                title: "Sort categories alphabetically",
                                disabled: onAlphabetize == null,
                                onClick: ()=>onAlphabetize?.(),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2114c99dcc668b71$export$2e2bcd8739ae039), {
                                    className: "size-3.5"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                size: "icon",
                                onClick: startRename,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                    className: "size-3.5"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                size: "icon",
                                title: "Group color",
                                onClick: ()=>setColoring((v)=>!v),
                                children: groupColor != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-3.5 rounded-full', (0, $3076b7ee20dc9ec8$export$8d5a1948373ce7cc)[groupColor])
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $126ba921a4c40132$export$2e2bcd8739ae039), {
                                    className: "size-3.5"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                size: "icon",
                                onClick: onDelete,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                    className: "size-3.5"
                                })
                            })
                        ]
                    })
                ]
            }),
            coloring && !renaming && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-2 flex items-center gap-1.5 pl-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        title: "Automatic color",
                        onClick: ()=>{
                            onSetColor(null);
                            setColoring(false);
                        },
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('border-border text-muted-foreground flex size-6 cursor-pointer items-center justify-center rounded-full border', groupColor == null && 'ring-primary ring-2'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2dfa57d290a8089$export$2e2bcd8739ae039), {
                            className: "size-3.5"
                        })
                    }),
                    (0, $b6ddd498a221dbc5$export$975c46174dc0a150).map((colorName)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            title: colorName,
                            onClick: ()=>{
                                onSetColor(colorName);
                                setColoring(false);
                            },
                            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-6 cursor-pointer rounded-full', (0, $3076b7ee20dc9ec8$export$8d5a1948373ce7cc)[colorName], groupColor === colorName && 'ring-primary ring-2')
                        }, colorName))
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0332ec5baeac6793$export$86155fde54f06e6a), {
                items: memberIds,
                strategy: (0, $0332ec5baeac6793$export$fe2be640df2ffb9e),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        categories.map((category)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($50bf382d7100a561$var$RearrangeCategoryRow, {
                                category: category,
                                sortable: true
                            }, category._id)),
                        categories.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "border-border text-muted-foreground rounded-lg border border-dashed p-3 text-sm",
                            children: "No categories \u2014 assign one from its category page"
                        })
                    ]
                })
            })
        ]
    });
};
const $50bf382d7100a561$export$9badc89c9c624662 = ({ categories: categories, groups: groups, groupsLoaded: groupsLoaded })=>{
    const [draft, setDraftState] = $acw62.useState(()=>$50bf382d7100a561$var$buildDraft(groups));
    const draftRef = $acw62.useRef(draft);
    const setDraft = $acw62.useCallback((next)=>{
        draftRef.current = next;
        setDraftState(next);
    }, []);
    // Reconcile when groups are created/deleted or members change elsewhere
    $acw62.useEffect(()=>{
        setDraft($50bf382d7100a561$var$buildDraft(groups, draftRef.current));
    }, [
        groups,
        setDraft
    ]);
    const [newGroupName, setNewGroupName] = $acw62.useState('');
    // True from enqueue until the create task settles (see handleCreateGroup).
    // The ref mirrors the state synchronously — state updates flush on a
    // microtask, so back-to-back submissions in one tick would both read the
    // stale render value without it.
    const [createPending, setCreatePending] = $acw62.useState(false);
    const createPendingRef = $acw62.useRef(false);
    const [createGroup] = (0, $ce9d9e524be20f53$export$c98005c22c1df9a0)();
    const [renameGroup] = (0, $ce9d9e524be20f53$export$443797c541be6504)();
    const [deleteGroup] = (0, $ce9d9e524be20f53$export$b944ea19df7f9ed0)();
    const [reorderGroups] = (0, $ce9d9e524be20f53$export$6b955fa2a90548cf)();
    const categoryById = $acw62.useMemo(()=>new Map(categories.map((c)=>[
                c._id,
                c
            ])), [
        categories
    ]);
    const groupById = new Map(groups.map((g)=>[
            g._id,
            g
        ]));
    const sensors = (0, $0bb7808e9486acbd$export$19012f58216d597f)((0, $0bb7808e9486acbd$export$cc72dd71f4ec69eb)((0, $0bb7808e9486acbd$export$b26af955418d6638), {
        activationConstraint: {
            distance: 4
        }
    }));
    // Every resolver on the server reads Settings and rewrites categoryGroups
    // wholesale, so ANY two concurrent group mutations (reorder, create,
    // rename, delete) can clobber each other's writes. All of them run
    // through this one queue; failures surface in a banner instead of
    // silently pretending the save happened.
    // Failures are tracked per operation kind, and a success clears only its
    // own kind: a queued reorder succeeding must not erase the explanation
    // that an earlier rename failed, and a later group edit succeeding must
    // not hide that a drag was rolled back. Each banner stands until the
    // operation that produced it succeeds on a retry.
    const [saveErrors, setSaveErrors] = $acw62.useState({});
    const queueRef = $acw62.useRef(Promise.resolve());
    const enqueue = $acw62.useCallback((kind, task)=>{
        queueRef.current = queueRef.current.then(async ()=>{
            try {
                await task();
                setSaveErrors((prev)=>{
                    if (!(kind in prev)) return prev;
                    const next = {
                        ...prev
                    };
                    delete next[kind];
                    return next;
                });
            } catch (e) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
                const err = e;
                setSaveErrors((prev)=>({
                        ...prev,
                        [kind]: err.message
                    }));
            }
        });
    }, []);
    // Latest props for queued tasks, which run after renders.
    const groupsRef = $acw62.useRef(groups);
    groupsRef.current = groups;
    // At most one reorder task waits in the queue; it reads the latest draft
    // when it runs, so drops made while it waits coalesce into that send.
    const reorderQueuedRef = $acw62.useRef(false);
    const persist = ()=>{
        if (reorderQueuedRef.current) return;
        reorderQueuedRef.current = true;
        enqueue('reorder', async ()=>{
            reorderQueuedRef.current = false;
            const snapshot = draftRef.current;
            try {
                await reorderGroups({
                    variables: {
                        groups: snapshot.order.map((id)=>({
                                id: id,
                                categoryIds: snapshot.members[id] ?? []
                            }))
                    },
                    update: (cache, result)=>{
                        const updated = result.data?.reorderCategoryGroups;
                        if (updated) (0, $a5ee6aaf43da69f6$export$f2f1601b72ada50d)(cache, updated);
                    }
                });
            } catch (e) {
                // The optimistic draft didn't save. If another reorder is already
                // queued it will resend the user's latest draft and supersede this
                // failure — resetting here would make that task snapshot the old
                // order and silently discard the newest drag. Only with nothing
                // queued do we fall back to the last server-confirmed state, so
                // the screen doesn't keep an order that doesn't exist.
                if (!reorderQueuedRef.current) setDraft($50bf382d7100a561$var$buildDraft(groupsRef.current));
                throw e;
            }
        });
    };
    const handleCreateGroup = ()=>{
        const name = newGroupName.trim();
        if (!name || createPendingRef.current || !groupsLoaded) return;
        // Apollo's loading flag only covers the mutation itself; while the task
        // waits in the queue it is still false, so without this flag repeated
        // clicks/Enters would enqueue the same name once per press (names are
        // not unique server-side — each would create a separate group).
        createPendingRef.current = true;
        setCreatePending(true);
        enqueue('create', async ()=>{
            try {
                const result = await createGroup({
                    variables: {
                        name: name
                    },
                    update: (cache, mutationResult)=>{
                        const created = mutationResult.data?.createCategoryGroup;
                        if (created) (0, $a5ee6aaf43da69f6$export$82ff8835e0914fca)(cache, created);
                    }
                });
                // Reconcile the draft synchronously: the cache write above only
                // schedules the props->draft effect, so a reorder queued right
                // behind this task would otherwise snapshot a draft that predates
                // the structural change and be rejected for a group-set mismatch.
                const created = result.data?.createCategoryGroup;
                if (created && !draftRef.current.order.includes(created._id)) setDraft({
                    order: [
                        ...draftRef.current.order,
                        created._id
                    ],
                    members: {
                        ...draftRef.current.members,
                        [created._id]: []
                    }
                });
                setNewGroupName('');
            } finally{
                createPendingRef.current = false;
                setCreatePending(false);
            }
        });
    };
    const handleRename = (groupId, name)=>{
        // Renames don't change the order/membership structure, so no draft
        // reconciliation is needed here.
        enqueue('rename', ()=>renameGroup({
                variables: {
                    id: groupId,
                    name: name
                }
            }));
    };
    const handleSetColor = (groupId, color)=>{
        // Color-only update: no name is sent, so a rename queued just before
        // this can never be reverted by a stale captured name.
        enqueue('rename', ()=>renameGroup({
                variables: {
                    id: groupId,
                    color: color
                }
            }));
    };
    const handleDelete = (groupId)=>{
        enqueue('delete', async ()=>{
            const result = await deleteGroup({
                variables: {
                    id: groupId
                },
                update: (cache, mutationResult)=>{
                    const updated = mutationResult.data?.deleteCategoryGroup;
                    if (updated) (0, $a5ee6aaf43da69f6$export$f2f1601b72ada50d)(cache, updated);
                }
            });
            // Same synchronous reconciliation as creation, for the same reason.
            const updated = result.data?.deleteCategoryGroup;
            if (updated) setDraft($50bf382d7100a561$var$buildDraft(updated, draftRef.current));
        });
    };
    /** Member IDs sorted by category name; unknown IDs keep their order last. */ const alphabetized = $acw62.useCallback((memberIds)=>[
            ...memberIds
        ].sort((a, b)=>(categoryById.get(a)?.name ?? '').localeCompare(categoryById.get(b)?.name ?? '')), [
        categoryById
    ]);
    const handleAlphabetize = (groupId)=>{
        const current = draftRef.current;
        const ids = current.members[groupId] ?? [];
        setDraft({
            ...current,
            members: {
                ...current.members,
                [groupId]: alphabetized(ids)
            }
        });
        persist();
    };
    /** The group ID containing a category row id, if any. */ const containerOf = (id)=>draftRef.current.order.find((groupId)=>(draftRef.current.members[groupId] ?? []).includes(id)) ?? null;
    const handleDragEnd = ({ active: active, over: over })=>{
        if (!over) return;
        const activeId = String(active.id);
        const overId = String(over.id);
        const current = draftRef.current;
        if (activeId.startsWith($50bf382d7100a561$var$GROUP_PREFIX)) {
            // Reorder whole groups by header drag; drops often land on a row —
            // resolve rows to their containing group.
            const activeKey = activeId.slice($50bf382d7100a561$var$GROUP_PREFIX.length);
            const overKey = overId.startsWith($50bf382d7100a561$var$GROUP_PREFIX) ? overId.slice($50bf382d7100a561$var$GROUP_PREFIX.length) : containerOf(overId);
            if (overKey != null && overKey !== activeKey) {
                const fromIndex = current.order.indexOf(activeKey);
                const toIndex = current.order.indexOf(overKey);
                if (fromIndex >= 0 && toIndex >= 0) {
                    setDraft({
                        ...current,
                        order: (0, $0332ec5baeac6793$export$5d49d615ad5ea2b0)(current.order, fromIndex, toIndex)
                    });
                    persist();
                }
            }
            return;
        }
        // Category rows only reorder within their own group
        const container = containerOf(activeId);
        if (container == null || containerOf(overId) !== container) return;
        const ids = current.members[container] ?? [];
        const fromIndex = ids.indexOf(activeId);
        const toIndex = ids.indexOf(overId);
        if (fromIndex >= 0 && toIndex >= 0 && fromIndex !== toIndex) {
            setDraft({
                ...current,
                members: {
                    ...current.members,
                    [container]: (0, $0332ec5baeac6793$export$5d49d615ad5ea2b0)(ids, fromIndex, toIndex)
                }
            });
            persist();
        }
    };
    const groupedIds = new Set(draft.order.flatMap((id)=>draft.members[id] ?? []));
    const ungrouped = categories.filter((c)=>!groupedIds.has(c._id));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-6",
        children: [
            $50bf382d7100a561$var$MUTATION_KINDS.flatMap((kind)=>{
                const message = saveErrors[kind];
                return message == null ? [] : [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                        children: [
                            $50bf382d7100a561$var$MUTATION_KIND_LABELS[kind],
                            ": ",
                            message
                        ]
                    }, kind)
                ];
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0bb7808e9486acbd$export$2d5c5ceac203fc1e), {
                sensors: sensors,
                collisionDetection: (0, $0bb7808e9486acbd$export$c3a6c1c7122b31c9),
                onDragEnd: handleDragEnd,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0332ec5baeac6793$export$86155fde54f06e6a), {
                    items: draft.order.map((id)=>`${$50bf382d7100a561$var$GROUP_PREFIX}${id}`),
                    strategy: (0, $0332ec5baeac6793$export$fe2be640df2ffb9e),
                    children: draft.order.flatMap((groupId)=>{
                        const group = groupById.get(groupId);
                        if (!group) return [];
                        const memberIds = draft.members[groupId] ?? [];
                        const members = memberIds.flatMap((id)=>{
                            const category = categoryById.get(id);
                            return category ? [
                                category
                            ] : [];
                        });
                        const sorted = alphabetized(memberIds);
                        const alreadySorted = sorted.every((id, i)=>id === memberIds[i]);
                        return [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($50bf382d7100a561$var$SortableGroupSection, {
                                group: group,
                                categories: members,
                                memberIds: memberIds,
                                onAlphabetize: alreadySorted ? null : ()=>handleAlphabetize(groupId),
                                onRename: (name)=>handleRename(groupId, name),
                                onSetColor: (color)=>handleSetColor(groupId, color),
                                onDelete: ()=>handleDelete(groupId)
                            }, groupId)
                        ];
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        value: newGroupName,
                        onChange: setNewGroupName,
                        placeholder: "New group name",
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleCreateGroup();
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        className: "shrink-0 whitespace-nowrap",
                        onClick: handleCreateGroup,
                        disabled: createPending || !groupsLoaded || !newGroupName.trim(),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "size-4"
                            }),
                            "Add group"
                        ]
                    })
                ]
            }),
            ungrouped.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-2 flex items-baseline gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-foreground text-sm font-semibold",
                                children: "Ungrouped"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground text-xs",
                                children: "sorted by name \u2014 set a group from each category's page"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-2",
                        children: ungrouped.map((category)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($50bf382d7100a561$var$RearrangeCategoryRow, {
                                category: category,
                                sortable: false
                            }, category._id))
                    })
                ]
            })
        ]
    });
};






const $833f55a7ff2d0d4a$var$ActionHeader = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('border-border flex flex-row items-center justify-between border-b p-2 max-md:gap-y-2 max-md:px-3 max-md:py-2', props.stackActionsOnMobile && 'max-md:flex-wrap'),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('min-w-0 flex-1 px-4 max-md:px-0', props.stackActionsOnMobile && 'max-md:basis-full'),
                children: props.content
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('ml-auto inline-flex shrink-0 items-center justify-end gap-1.5 px-4 max-md:px-0', // On its own mobile row the action group spans the width (still
                // right-aligned), so a flexible action — e.g. Activity's search box —
                // can claim the empty space beside the icons instead of leaving it.
                props.stackActionsOnMobile && 'max-md:w-full'),
                children: props.actions
            })
        ]
    });
};
var $833f55a7ff2d0d4a$export$2e2bcd8739ae039 = $833f55a7ff2d0d4a$var$ActionHeader;





/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $690b03dfd2e63764$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "5",
            r: "1",
            key: "gxeob9"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "19",
            r: "1",
            key: "lyex9k"
        }
    ]
];
const $690b03dfd2e63764$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ellipsis-vertical", $690b03dfd2e63764$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
const $7ec27fe8536d582e$export$22e3865480307310 = $acw62.createContext(null);
const $7ec27fe8536d582e$export$e0c95c699a0cf72a = ()=>{
    const context = $acw62.useContext($7ec27fe8536d582e$export$22e3865480307310);
    if (!context) throw new Error('PopoverMenu components must be used within PopoverMenu.');
    return context;
};


const $49e34d17f9b50791$export$32b7bd840a1eba80 = ({ children: children, renderTrigger: renderTrigger, above: above = false })=>{
    const [isMenuOpen, setIsMenuOpen] = $acw62.useState(false);
    const closeMenu = $acw62.useCallback(()=>setIsMenuOpen(false), []);
    const toggleMenu = $acw62.useCallback(()=>setIsMenuOpen((state)=>!state), []);
    const contextValue = $acw62.useMemo(()=>({
            closeMenu: closeMenu
        }), [
        closeMenu
    ]);
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ec27fe8536d582e$export$22e3865480307310).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('shadow-popover bg-popover text-popover-foreground outline-ring/50', 'flex max-h-[min(70dvh,40rem)] flex-col overflow-y-auto rounded-md outline-1'),
            children: children
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $497d44d806a05c0a$export$2e2bcd8739ae039), {
        open: isMenuOpen,
        popoverContents: content,
        popoverAnchor: above ? 'above-right' : 'top-right',
        onOutsideClick: closeMenu,
        children: (anchorRef)=>renderTrigger ? renderTrigger({
                ref: anchorRef,
                onClick: toggleMenu
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "ghost",
                size: "icon",
                ref: anchorRef,
                onClick: toggleMenu,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $690b03dfd2e63764$export$2e2bcd8739ae039), {
                    className: "size-5"
                })
            })
    });
};



parcelRequire("acw62");


const $697be26d3ac7a8ca$var$PopoverMenuItem = (props)=>{
    const { closeMenu: closeMenu } = (0, $7ec27fe8536d582e$export$e0c95c699a0cf72a)();
    const { onClick: onClick, onSelect: onSelect, disabled: disabled, children: children, iconLeft: iconLeft, className: className, ...rest } = props;
    const handleClick = (event)=>{
        onClick?.(event);
        if (event.defaultPrevented || disabled) return;
        closeMenu();
        onSelect?.();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('hover:bg-accent/50 flex w-full cursor-pointer', 'flex-row items-center justify-start gap-3 py-2 pr-10 pl-2', 'disabled:text-muted-foreground disabled:cursor-auto disabled:hover:bg-transparent', className),
        ...rest,
        type: "button",
        role: "menuitem",
        onClick: handleClick,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "size-3.5 [&>svg]:size-full",
                children: iconLeft
            }),
            children
        ]
    });
};
var $697be26d3ac7a8ca$export$2e2bcd8739ae039 = $697be26d3ac7a8ca$var$PopoverMenuItem;


const $76b8be3a3c79c085$var$CategoryRow = ({ category: category, onEdit: onEdit, onDelete: onDelete })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card hover:bg-accent flex items-center justify-between rounded-lg border pr-2 transition-colors",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                to: `/categories/${category._id}`,
                className: "flex min-w-0 flex-1 items-center gap-3 p-4 no-underline",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6080e81c2b9604e9$export$bde99f6bf04aeea3), {
                        category: category
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground truncate font-medium",
                        children: category.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49e34d17f9b50791$export$32b7bd840a1eba80), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {}),
                        onSelect: onEdit,
                        children: "Edit"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                            className: "text-destructive"
                        }),
                        className: "text-destructive",
                        onSelect: onDelete,
                        children: "Delete"
                    })
                ]
            })
        ]
    });
const $76b8be3a3c79c085$export$b0e2648bcd32fb5 = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Categories',
        reset: true
    });
    const { data: data, loading: loading, refetch: refetch } = (0, $ce9d9e524be20f53$export$1f9e2535d0d42ab9)();
    const { data: groupsData } = (0, $ce9d9e524be20f53$export$9dda77d697c51272)();
    const { createCategoryModal: createCategoryModal, editCategoryModal: editCategoryModal, deleteCategoryModal: deleteCategoryModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const [search, setSearch] = $acw62.useState('');
    const [rearranging, setRearranging] = $acw62.useState(false);
    const handleRefetch = ()=>{
        refetch();
    };
    const handleCreate = ()=>{
        createCategoryModal.openModal({
            onSuccess: handleRefetch
        });
    };
    const renderRow = (category)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($76b8be3a3c79c085$var$CategoryRow, {
            category: category,
            onEdit: ()=>editCategoryModal.openModal({
                    category: category,
                    onUpdate: handleRefetch,
                    onDelete: handleRefetch
                }),
            onDelete: ()=>deleteCategoryModal.openModal({
                    category: category,
                    onDeleted: handleRefetch
                })
        }, category._id);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading categories..."
        })
    });
    const allCategories = data?.allCategories || [];
    const groups = groupsData?.allCategoryGroups || [];
    const categoryById = new Map(allCategories.map((c)=>[
            c._id,
            c
        ]));
    const groupedIds = new Set(groups.flatMap((g)=>g.categoryIds));
    const matchesSearch = (category)=>category.name.toLowerCase().includes(search.toLowerCase());
    // Grouped sections in group order (members in member order), then the
    // ungrouped remainder sorted by name (allCategories arrives name-sorted).
    const sections = groups.map((group)=>({
            key: group._id,
            label: group.name,
            color: (0, $3076b7ee20dc9ec8$export$e700a184e8fe2b12)(group.color ?? null),
            categories: group.categoryIds.flatMap((id)=>{
                const category = categoryById.get(id);
                return category ? [
                    category
                ] : [];
            }).filter(matchesSearch)
        }));
    const ungrouped = allCategories.filter((c)=>!groupedIds.has(c._id)).filter(matchesSearch);
    const visibleCount = sections.reduce((sum, s)=>sum + s.categories.length, 0) + ungrouped.length;
    const actions = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: rearranging ? 'outline' : 'ghost',
                size: rearranging ? undefined : 'icon',
                onClick: ()=>setRearranging((v)=>!v),
                title: rearranging ? 'Done rearranging' : 'Rearrange groups',
                children: rearranging ? 'Done' : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $97332defb5de8faa$export$2e2bcd8739ae039), {
                    className: "size-5"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "ghost",
                size: "icon",
                onClick: handleCreate,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                    className: "size-5"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col overflow-y-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $833f55a7ff2d0d4a$export$2e2bcd8739ae039), {
                content: `${allCategories.length} categories`,
                actions: actions
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col gap-4 p-4",
                children: rearranging ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50bf382d7100a561$export$9badc89c9c624662), {
                    categories: allCategories,
                    groups: groups,
                    groupsLoaded: groupsData != null
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                    className: "text-muted-foreground absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    placeholder: "Search categories...",
                                    value: search,
                                    onChange: (e)=>setSearch(e.target.value),
                                    className: "border-border bg-background placeholder:text-muted-foreground w-full rounded-md border py-2 pl-9 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                                })
                            ]
                        }),
                        allCategories.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "border-border rounded-lg border border-dashed p-8 text-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-muted-foreground mb-4",
                                    children: "No categories created yet"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-muted-foreground mb-4 text-sm",
                                    children: 'Categories help you organize your transactions by type, like "Groceries", "Entertainment", or "Utilities".'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    onClick: handleCreate,
                                    type: "button",
                                    children: "Create your first category"
                                })
                            ]
                        }) : visibleCount === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-muted-foreground py-8 text-center text-sm",
                            children: [
                                'No categories matching "',
                                search,
                                '"'
                            ]
                        }) : groups.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-col gap-2",
                            children: ungrouped.map(renderRow)
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-6",
                            children: [
                                sections.filter((section)=>section.categories.length > 0).map((section)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mb-2 flex items-baseline gap-2",
                                                children: [
                                                    section.color != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-2 shrink-0 self-center rounded-full', (0, $3076b7ee20dc9ec8$export$8d5a1948373ce7cc)[section.color])
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "text-foreground text-sm font-semibold",
                                                        children: section.label
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-muted-foreground text-xs",
                                                        children: section.categories.length
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex flex-col gap-2",
                                                children: section.categories.map(renderRow)
                                            })
                                        ]
                                    }, section.key)),
                                ungrouped.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-2 flex items-baseline gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "text-foreground text-sm font-semibold",
                                                    children: "Ungrouped"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-muted-foreground text-xs",
                                                    children: ungrouped.length
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex flex-col gap-2",
                                            children: ungrouped.map(renderRow)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");









parcelRequire("acw62");



const $4ac5bab07fe90e16$var$selectedRing = 'ring-2 ring-primary';
const $4ac5bab07fe90e16$export$4ede8238cb83eada = (props)=>{
    const { name: name, icon: icon, color: color, onIconChange: onIconChange, onColorChange: onColorChange } = props;
    const previewName = name.trim() || '?';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6080e81c2b9604e9$export$bde99f6bf04aeea3), {
                        category: {
                            name: previewName,
                            icon: icon,
                            color: color
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                title: "Automatic color",
                                onClick: ()=>onColorChange(null),
                                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('border-border text-muted-foreground flex size-6 cursor-pointer items-center justify-center rounded-full border', color == null && $4ac5bab07fe90e16$var$selectedRing),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2dfa57d290a8089$export$2e2bcd8739ae039), {
                                    className: "size-3.5"
                                })
                            }),
                            (0, $b6ddd498a221dbc5$export$975c46174dc0a150).map((colorName)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    title: colorName,
                                    onClick: ()=>onColorChange(colorName),
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-6 cursor-pointer rounded-full', (0, $3076b7ee20dc9ec8$export$8d5a1948373ce7cc)[colorName], color === colorName && $4ac5bab07fe90e16$var$selectedRing)
                                }, colorName))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-8 gap-1 max-md:grid-cols-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        title: "Automatic (initial letter)",
                        onClick: ()=>onIconChange(null),
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-muted-foreground hover:bg-accent hover:text-foreground flex h-8 cursor-pointer items-center justify-center rounded-md', icon == null && `${$4ac5bab07fe90e16$var$selectedRing} bg-accent text-foreground`),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-sm font-semibold",
                            children: previewName.charAt(0).toUpperCase()
                        })
                    }),
                    (0, $b6ddd498a221dbc5$export$a067559dfca27e2).map((iconName)=>{
                        const Icon = (0, $3076b7ee20dc9ec8$export$b0372430f00fdb14)[iconName];
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            title: iconName,
                            onClick: ()=>onIconChange(iconName),
                            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-muted-foreground hover:bg-accent hover:text-foreground flex h-8 cursor-pointer items-center justify-center rounded-md', icon === iconName && `${$4ac5bab07fe90e16$var$selectedRing} bg-accent text-foreground`),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                className: "size-4"
                            })
                        }, iconName);
                    })
                ]
            })
        ]
    });
};




parcelRequire("acw62");

const $8cab135a818cb058$var$NO_GROUP = '';
const $8cab135a818cb058$export$7a845b1e34e10b8f = ({ value: value, onChange: onChange })=>{
    const { data: data } = (0, $ce9d9e524be20f53$export$9dda77d697c51272)();
    const groups = data?.allCategoryGroups || [];
    if (groups.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
        label: "Group",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
            value: value ?? $8cab135a818cb058$var$NO_GROUP,
            onChange: (e)=>onChange(e.target.value || null),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                    value: $8cab135a818cb058$var$NO_GROUP,
                    children: "No group"
                }),
                groups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: group._id,
                        children: group.name
                    }, group._id))
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");

const $654d5ea45aebf8c9$export$379139ebc1c2b235 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { onChange: onChange, className: className, ...otherProps } = props;
    const handleChange = (e)=>{
        onChange?.(e.target.value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
        ref: ref,
        ...otherProps,
        onChange: handleChange,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input w-full min-w-0 rounded-md border bg-transparent px-3 py-2 text-sm shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50', 'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]', 'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive', className)
    });
});





const $ba7ca1ebc614be26$export$8bab8f4f9f9355e5 = ()=>{
    const params = (0, $926608a7a86d7371$export$99eaa27ddbbb95ef)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const categoryId = params.id || '';
    const { deleteCategoryModal: deleteCategoryModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const { data: data, loading: loading } = (0, $ce9d9e524be20f53$export$b781d19289d47f28)({
        variables: {
            id: categoryId
        },
        skip: !categoryId
    });
    const [name, setName] = $acw62.useState('');
    const [description, setDescription] = $acw62.useState('');
    const [icon, setIcon] = $acw62.useState(null);
    const [color, setColor] = $acw62.useState(null);
    const [hasInitialized, setHasInitialized] = $acw62.useState(false);
    // undefined = untouched (show the stored group); null = "No group"
    const [groupOverride, setGroupOverride] = $acw62.useState(undefined);
    const [groupError, setGroupError] = $acw62.useState(null);
    const [updateCategory, { loading: updateLoading, error: updateError }] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$d216fbad2d4d64ac));
    // Track the group mutation's loading state too: on a group-only save
    // updateLoading stays false, and a second submit while the first
    // setCategoryGroup is in flight races two full-array writes (the older
    // selection can finish last and win).
    const [setCategoryGroup, { loading: groupSaving }] = (0, $ce9d9e524be20f53$export$2b522cad18185c8)();
    const { data: groupsData } = (0, $ce9d9e524be20f53$export$9dda77d697c51272)();
    const category = data?.categoryById;
    const storedGroupId = (groupsData?.allCategoryGroups || []).find((group)=>group.categoryIds.includes(categoryId))?._id ?? null;
    const groupId = groupOverride === undefined ? storedGroupId : groupOverride;
    $acw62.useEffect(()=>{
        if (category && !hasInitialized) {
            setName(category.name);
            setDescription(category.description || '');
            setIcon((0, $3076b7ee20dc9ec8$export$409877b2c65a5d)(category.icon));
            setColor((0, $3076b7ee20dc9ec8$export$e700a184e8fe2b12)(category.color));
            setHasInitialized(true);
        }
    }, [
        category,
        hasInitialized
    ]);
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: category?.name || 'Loading...',
        fallback: [
            {
                label: 'Categories',
                href: '/categories'
            }
        ]
    });
    if (!categoryId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "No category selected"
    });
    if (loading && !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "Loading category..."
    });
    if (!category) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "Category not found"
    });
    const groupChanged = groupOverride !== undefined && groupOverride !== storedGroupId;
    // Tracked separately from groupChanged: a group-only save must not send
    // the ordinary fields at all, or it would overwrite edits made elsewhere
    // since this form loaded with the form's stale values.
    const fieldsChanged = name !== category.name || description !== (category.description || '') || icon !== (0, $3076b7ee20dc9ec8$export$409877b2c65a5d)(category.icon) || color !== (0, $3076b7ee20dc9ec8$export$e700a184e8fe2b12)(category.color);
    const hasChanges = fieldsChanged || groupChanged;
    const handleSave = async (e)=>{
        e.preventDefault();
        if (!hasChanges || !name.trim() || updateLoading || groupSaving) return;
        setGroupError(null);
        if (fieldsChanged) await updateCategory({
            variables: {
                name: name.trim(),
                id: category._id,
                description: description.trim() || null,
                icon: icon,
                color: color
            }
        });
        if (groupChanged) // The generated hook exposes no error state, so an uncaught rejection
        // here would leave the select showing an unsaved value with no
        // explanation (and reset nothing).
        try {
            await setCategoryGroup({
                variables: {
                    categoryId: category._id,
                    groupId: groupId
                },
                update: (cache, result)=>{
                    const updated = result.data?.setCategoryGroup;
                    if (updated) (0, $a5ee6aaf43da69f6$export$f2f1601b72ada50d)(cache, updated);
                }
            });
            setGroupOverride(undefined);
        } catch (err) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            setGroupError(err.message);
        }
    };
    const handleDelete = ()=>{
        deleteCategoryModal.openModal({
            category: category,
            onDeleted: ()=>navigate('/categories')
        });
    };
    const handleReset = ()=>{
        setName(category.name);
        setDescription(category.description || '');
        setIcon((0, $3076b7ee20dc9ec8$export$409877b2c65a5d)(category.icon));
        setColor((0, $3076b7ee20dc9ec8$export$e700a184e8fe2b12)(category.color));
        setGroupOverride(undefined);
        setGroupError(null);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col gap-6 overflow-y-auto p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-lg font-semibold",
                        children: "Edit Category"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground text-sm",
                        children: "Update or delete this category"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSave,
                className: "flex max-w-md flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                        label: "Name",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            autoFocus: true,
                            value: name,
                            onChange: setName
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                        label: "Description",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $654d5ea45aebf8c9$export$379139ebc1c2b235), {
                            value: description,
                            onChange: setDescription,
                            placeholder: "Optional description for this category",
                            rows: 3
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cab135a818cb058$export$7a845b1e34e10b8f), {
                        value: groupId,
                        onChange: setGroupOverride
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                        label: "Appearance",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ac5bab07fe90e16$export$4ede8238cb83eada), {
                            name: name,
                            icon: icon,
                            color: color,
                            onIconChange: setIcon,
                            onColorChange: setColor
                        })
                    }),
                    updateError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-destructive text-sm",
                        children: updateError.message
                    }),
                    groupError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-destructive text-sm",
                        children: [
                            "Couldn't save the group: ",
                            groupError
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "primary",
                                type: "submit",
                                disabled: !hasChanges || !name.trim() || updateLoading || groupSaving,
                                children: updateLoading || groupSaving ? 'Saving...' : 'Save'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "outline",
                                type: "button",
                                onClick: handleReset,
                                disabled: !hasChanges,
                                children: "Reset"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "destructive",
                                type: "button",
                                onClick: handleDelete,
                                children: "Delete"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");








const $68f5ef05891ee960$export$f32142466c80dbff = ({ onRequestClose: onRequestClose, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const [name, setName] = $acw62.useState('');
    const [description, setDescription] = $acw62.useState('');
    const [icon, setIcon] = $acw62.useState(null);
    const [color, setColor] = $acw62.useState(null);
    const [groupId, setGroupId] = $acw62.useState(null);
    const [error, setError] = $acw62.useState(null);
    // Spans BOTH stages of a submit. createCategory's own loading flag drops
    // once the category exists, while the group assignment may still be in
    // flight — re-enabled buttons there would let a second submit create a
    // duplicate, or Cancel close a modal whose category already exists.
    const [submitting, setSubmitting] = $acw62.useState(false);
    const [createCategory] = (0, $ce9d9e524be20f53$export$b8da3e59c773b24a)();
    const [setCategoryGroup] = (0, $ce9d9e524be20f53$export$2b522cad18185c8)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (submitting) return;
        setError(null);
        setSubmitting(true);
        try {
            const result = await createCategory({
                variables: {
                    name: name.trim(),
                    description: description.trim() || null,
                    icon: icon,
                    color: color
                }
            });
            const created = result.data?.createCategory;
            if (created && groupId != null) // Best-effort: the category already exists at this point, so a
            // failed group assignment (e.g. the group was deleted concurrently)
            // must not present the whole creation as failed — retrying would
            // hit the unique-name constraint. The category stays ungrouped and
            // can be grouped from its page.
            try {
                await setCategoryGroup({
                    variables: {
                        categoryId: created._id,
                        groupId: groupId
                    },
                    update: (cache, groupResult)=>{
                        const updated = groupResult.data?.setCategoryGroup;
                        if (updated) (0, $a5ee6aaf43da69f6$export$f2f1601b72ada50d)(cache, updated);
                    }
                });
            } catch  {
            // Ignore — see above.
            }
            onSuccess();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        } finally{
            setSubmitting(false);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: submitting,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: submitting || !name.trim(),
                children: submitting ? 'Creating...' : 'Create'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Create Category",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Name",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        value: name,
                        onChange: setName,
                        placeholder: "e.g., Groceries, Entertainment",
                        autoFocus: true
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Description",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $654d5ea45aebf8c9$export$379139ebc1c2b235), {
                        value: description,
                        onChange: setDescription,
                        placeholder: "Optional description for this category",
                        rows: 3
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cab135a818cb058$export$7a845b1e34e10b8f), {
                    value: groupId,
                    onChange: setGroupId
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Appearance",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ac5bab07fe90e16$export$4ede8238cb83eada), {
                        name: name,
                        icon: icon,
                        color: color,
                        onIconChange: setIcon,
                        onColorChange: setColor
                    })
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");




const $7cef194d183a2158$export$ce90d147dee4714f = (props)=>{
    const { category: category, onRequestClose: onRequestClose, onDeleted: onDeleted } = props;
    const [deleteCategory, { loading: loading }] = (0, $ce9d9e524be20f53$export$a2281196ed640bc7)();
    const [error, setError] = $acw62.useState(null);
    const handleDelete = async ()=>{
        setError(null);
        try {
            await deleteCategory({
                variables: {
                    id: category._id
                },
                update: (store)=>{
                    (0, $5f9091afcb8d9899$export$77a8937f2ee84f73)(store, category);
                    (0, $a5ee6aaf43da69f6$export$b2f5ba7618faddbf)(store, category._id);
                }
            });
            onDeleted?.();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: handleDelete,
                disabled: loading,
                children: loading ? 'Deleting...' : 'Delete'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Delete category",
        footer: footer,
        size: "sm",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-destructive/10 text-destructive mb-3 rounded-md p-3 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Are you sure you want to delete ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: category.name
                    }),
                    "? This action cannot be undone."
                ]
            })
        ]
    });
};








var $acw62 = parcelRequire("acw62");


const $44fe23713dacf9c4$export$efe12b2e2f122c40 = (data)=>new Map((data?.allAccounts ?? []).map((account)=>[
            account._id,
            account
        ]));
const $44fe23713dacf9c4$export$3cb4e4363c734cdc = (accounts, balances)=>accounts.map((account)=>{
        const info = balances.get(account._id);
        return {
            currency: account.currency,
            balance: info?.balance ?? null,
            homeBalance: info?.homeBalance,
            creditCard: account.__typename === 'DepositoryAccount' && account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard
        };
    });




/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2cc4250f5d3ad942$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 20v-9",
            key: "1qisl0"
        }
    ],
    [
        "path",
        {
            d: "M14 7a4 4 0 0 1 4 4v3a6 6 0 0 1-12 0v-3a4 4 0 0 1 4-4z",
            key: "uouzyp"
        }
    ],
    [
        "path",
        {
            d: "M14.12 3.88 16 2",
            key: "qol33r"
        }
    ],
    [
        "path",
        {
            d: "M21 21a4 4 0 0 0-3.81-4",
            key: "1b0z45"
        }
    ],
    [
        "path",
        {
            d: "M21 5a4 4 0 0 1-3.55 3.97",
            key: "5cxbf6"
        }
    ],
    [
        "path",
        {
            d: "M22 13h-4",
            key: "1jl80f"
        }
    ],
    [
        "path",
        {
            d: "M3 21a4 4 0 0 1 3.81-4",
            key: "1fjd4g"
        }
    ],
    [
        "path",
        {
            d: "M3 5a4 4 0 0 0 3.55 3.97",
            key: "1d7oge"
        }
    ],
    [
        "path",
        {
            d: "M6 13H2",
            key: "82j7cp"
        }
    ],
    [
        "path",
        {
            d: "m8 2 1.88 1.88",
            key: "fmnt4t"
        }
    ],
    [
        "path",
        {
            d: "M9 7.13V6a3 3 0 1 1 6 0v1.13",
            key: "1vgav8"
        }
    ]
];
const $2cc4250f5d3ad942$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("bug", $2cc4250f5d3ad942$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $da03c070d837b197$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
            key: "1i5ecw"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $da03c070d837b197$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("settings", $da03c070d837b197$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");















const $895eaf5059a11fbb$export$3a4dcad6654a4c05 = (isoDate)=>{
    const date = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(isoDate);
    return date.year === (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().year ? date.toFormat('MMM d') : date.toFormat('MMM d, yyyy');
};
const $895eaf5059a11fbb$export$6f25eb35eacda85b = (isoDate)=>(0, $0c0f91b069db95d9$export$6b862160d295c8e)(isoDate).toFormat('MMM d, yyyy');



parcelRequire("acw62");

const $f7ce1c21778619db$export$ef41ebc44b9c1fe4 = ({ logo: logo, className: className = 'size-4', rounded: rounded = 'rounded-sm', alt: alt = '' })=>{
    if (!(0, $cd179cdb1a4beac3$export$f2c0893036cb40f8)(logo)) return null;
    const tile = (0, $cd179cdb1a4beac3$export$56459e09a3b6cec7).has(logo) ? 'bg-neutral-800' : 'bg-white';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: (0, $cd179cdb1a4beac3$export$2e8a6207c9cc2bb8)(logo),
        alt: alt,
        // Lazy: the picker can mount dozens of these at once, and eagerly
        // fetching every thumbnail on open is a lot of requests for a list the
        // user scrolls a few rows of.
        loading: "lazy",
        // object-contain, never cover: a wordmark cropped to fill its box is
        // unreadable, and letterboxing inside the tile is the lesser evil.
        className: `${className} ${tile} ${rounded} shrink-0 object-contain`
    });
};



// Freshness thresholds for an investment balance observation (balanceAsOf).
// Investments are valued by observation, not reconciliation: recent
// observations render nothing (quiet = healthy, and Plaid-synced accounts
// observe daily), a missed cadence gets a muted "as of" note, and a
// twice-missed monthly snapshot routine turns it amber.
const $ba405bcc20345af9$var$OBSERVATION_NOTE_DAYS = 14;
const $ba405bcc20345af9$var$OBSERVATION_STALE_DAYS = 60;
/**
 * Human-readable account type label, from the same option list that drives
 * the Type filter — one place to name a type (adding an enum value without a
 * matching option falls back by role).
 */ const $ba405bcc20345af9$var$getAccountTypeLabel = (account)=>(0, $e597f4605156a89e$export$6096865e4aa58c8a).find((option)=>option.matches(account))?.label ?? (account.__typename === 'InvestmentAccount' ? 'Investment' : 'Account');
/**
 * The row's icon: a credit card wears its face with the issuer badged onto
 * the corner; everything else keeps the institution logo it has always had.
 *
 * Both marks earn their place on a card, because they are not always the same
 * company — Barclays issues the JetBlue card, Chase issues the United ones —
 * and at this size the branding printed on the artwork is far too small to
 * read. So the face says which card it is and the badge says who bills you.
 *
 * A card with no face assigned falls through to the plain logo rather than a
 * card-shaped placeholder: most cards here are dormant and will never have
 * art, and shrinking their logo into an empty tile would cost every one of
 * those rows to make a handful line up.
 */ const $ba405bcc20345af9$var$RowIcon = ({ account: account, closed: closed })=>{
    const dimmed = closed ? 'opacity-50 grayscale' : '';
    const product = account.__typename === 'DepositoryAccount' && account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard ? account.cardProduct : null;
    if ((0, $86559021d806b4ea$export$f2ae116f2284ed4d)(product)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: `relative leading-none ${dimmed}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b39b2c71e902baf$export$ebcc69552e0d5c4c), {
                product: product,
                className: "w-10"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7ce1c21778619db$export$ef41ebc44b9c1fe4), {
                logo: account.logo,
                rounded: "rounded-[5px]",
                className: "ring-card group-hover:ring-accent absolute -bottom-1.5 -left-1.5 size-4 ring-2"
            })
        ]
    });
    return (0, $cd179cdb1a4beac3$export$f2c0893036cb40f8)(account.logo) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7ce1c21778619db$export$ef41ebc44b9c1fe4), {
        logo: account.logo,
        rounded: "rounded-lg",
        className: `size-8 ${dimmed}`
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f6f28ec3b697fb2$export$fdaddccc706daa3a), {
        account: account,
        className: `size-8 shrink-0 ${dimmed}`
    });
};
const $ba405bcc20345af9$export$b3e0a2e54ae1504b = ({ account: account, balance: balance, className: className = '', dragHandle: dragHandle, starred: starred = false, onToggleStar: onToggleStar, groupLabel: groupLabel })=>{
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const currencyLabel = (0, $9b33a37eb331091e$export$df99f23287eaf00e)();
    const closed = (0, $e597f4605156a89e$export$881343af68ecca95)(account);
    // Named in the type line like Closed is: rows surface outside the plain
    // active view (status filter, widened search results, revealed
    // disclosures), where an unmarked dormant account is indistinguishable
    // from a live one. Appears only once the balance data that derives the
    // state has streamed in.
    const inactive = (0, $e597f4605156a89e$export$ad17ddbed40f1c23)(account, balance);
    const isCreditCard = account.__typename === 'DepositoryAccount' && account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard;
    // Age in whole days of the observation backing an investment balance.
    // Null for depository accounts and for investment accounts with no
    // observations (a stored balance with no date has nothing to claim).
    // Closed accounts are exempt: the closing anchor is their final
    // observation by design, so aging it would render a permanent warning
    // about a refresh nobody expects.
    const observationAgeDays = account.__typename === 'InvestmentAccount' && !closed && balance?.balanceAsOf != null ? (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().diff((0, $0c0f91b069db95d9$export$6b862160d295c8e)(balance.balanceAsOf), 'days').days : null;
    // USD is the home currency, so only a foreign currency earns a mention.
    const typeLabel = $ba405bcc20345af9$var$getAccountTypeLabel(account);
    const meta = [
        typeLabel === groupLabel ? null : typeLabel,
        account.currency === 'USD' ? null : currencyLabel(account.currency),
        closed ? 'Closed' : null,
        inactive ? 'Inactive' : null
    ].filter((part)=>part != null);
    // Among assets (Starred, a connection), a card's positive amount would
    // read as money held, so it says it is owed. Under a Credit Card heading
    // the heading already says so.
    const owedInMixedList = isCreditCard && typeLabel !== groupLabel && balance != null && (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(balance.balance, true) > 0;
    const handleToggleStar = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onToggleStar?.();
    };
    // The star toggle is hidden on a phone, where it would crowd the name;
    // the account page's menu stars there. Rearrange mode (a drag handle)
    // keeps it everywhere, since starring is part of arranging.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `hover:bg-accent group flex flex-col gap-2 px-3 py-3 transition-colors sm:px-4 ${className}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-center gap-3",
            children: [
                dragHandle,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                    to: `/accounts/${account._id}`,
                    className: "flex min-w-0 flex-1 items-center gap-3 no-underline",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "flex w-10 shrink-0 justify-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ba405bcc20345af9$var$RowIcon, {
                                account: account,
                                closed: closed
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex min-w-0 flex-1 flex-col",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "flex min-w-0 items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: `line-clamp-2 text-sm font-medium break-words ${closed ? 'text-muted-foreground' : 'text-foreground'}`,
                                            children: account.name
                                        }),
                                        starred && !dragHandle && // The star button is hidden on a phone, so the row still
                                        // says it is starred.
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b006b04b8c21eb$export$2e2bcd8739ae039), {
                                            "aria-label": "Starred",
                                            className: "size-3 shrink-0 fill-amber-500 text-amber-500 sm:hidden"
                                        })
                                    ]
                                }),
                                meta.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground truncate text-xs",
                                    children: meta.join(" \xb7 ")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex shrink-0 flex-col items-end",
                            children: balance ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-foreground text-sm font-medium tabular-nums",
                                        children: formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
                                            amount: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(balance.balance, isCreditCard),
                                            currency: account.currency
                                        }))
                                    }),
                                    owedInMixedList && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground text-xs",
                                        children: "owed"
                                    }),
                                    account.__typename === 'DepositoryAccount' && account.currency !== 'USD' && balance.homeBalance != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-muted-foreground text-xs tabular-nums",
                                        children: [
                                            "\u2248",
                                            ' ',
                                            (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).toDecimalString((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
                                                // Same display-sign convention as the native line
                                                // above (credit cards render debt as positive
                                                // "owed").
                                                amount: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(balance.homeBalance, isCreditCard),
                                                currency: 'USD'
                                            }))
                                        ]
                                    }),
                                    account.__typename === 'DepositoryAccount' && balance.balanceStaleSince && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-muted-foreground text-xs",
                                        children: [
                                            "as of ",
                                            (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(balance.balanceStaleSince)
                                        ]
                                    }),
                                    observationAgeDays != null && balance.balanceAsOf != null && observationAgeDays > $ba405bcc20345af9$var$OBSERVATION_NOTE_DAYS && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: observationAgeDays > $ba405bcc20345af9$var$OBSERVATION_STALE_DAYS ? 'text-xs text-amber-600 dark:text-amber-500' : 'text-muted-foreground text-xs',
                                        children: [
                                            "as of ",
                                            (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(balance.balanceAsOf)
                                        ]
                                    })
                                ]
                            }) : // Balances stream in after the metadata renders — hold the cell
                            // with a quiet placeholder sized like the amount text.
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                "aria-hidden": "true",
                                className: "bg-muted h-5 w-20 animate-pulse rounded"
                            })
                        })
                    ]
                }),
                onToggleStar && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "ghost",
                    onClick: handleToggleStar,
                    className: `-mr-1 size-8 shrink-0 rounded-md p-1.5 hover:bg-foreground/10 ${dragHandle ? '' : 'hidden sm:flex'}`,
                    "aria-label": starred ? 'Unstar account' : 'Star account',
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b006b04b8c21eb$export$2e2bcd8739ae039), {
                        className: starred ? 'size-4 fill-amber-500 text-amber-500' : 'text-muted-foreground/40 hover:text-foreground size-4'
                    })
                })
            ]
        })
    });
};





parcelRequire("acw62");




/** An account's contribution to cross-currency totals, in USD cents. */ const $ba8a657c1d6c9967$var$homeValueOf = (account)=>account.currency === 'USD' ? account.balance : account.homeBalance ?? null;
/**
 * Subtotal of stored balances. Liabilities are stored negative, so a plain
 * sum is honest. A section made only of credit cards totals in the rows' own
 * display sign instead (debt as positive "owed"), so the header agrees with
 * the rows under it; a mixed group keeps the net-worth sign. A
 * single-currency section totals natively; a mixed-currency section totals
 * the USD-converted values instead, marked "≈".
 */ const $ba8a657c1d6c9967$var$subtotalLabel = (accounts, unitsById)=>{
    if (accounts.length === 0) return null;
    // Balances stream in after the list renders — a subtotal over a partial
    // set would understate silently, so show nothing until every row has one.
    const loaded = accounts.flatMap((account)=>account.balance === null ? [] : [
            {
                ...account,
                balance: account.balance
            }
        ]);
    if (loaded.length !== accounts.length) return null;
    const allCards = loaded.every((account)=>account.creditCard);
    const currency = loaded[0].currency;
    if (loaded.every((account)=>account.currency === currency)) {
        const amount = loaded.reduce((sum, account)=>sum + account.balance, 0);
        return (0, $9ac5aec7425fcb2d$export$ba37dda4e3a0b386)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
            amount: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(amount, allCards),
            currency: currency
        }), unitsById);
    }
    // Mixed currencies total in USD — but only when EVERY account has a home
    // value. Counting an unvalued account as zero (an unrated wallet, or a
    // foreign investment account, which exposes no homeBalance at all) would
    // understate the total while still labelling it a subtotal; showing nothing
    // is the honest option, as it already is for other unknowns.
    const homeValues = loaded.map($ba8a657c1d6c9967$var$homeValueOf);
    if (homeValues.some((value)=>value === null)) return null;
    const amount = homeValues.reduce((sum, value)=>(sum ?? 0) + (value ?? 0), 0);
    return `\u{2248} ${(0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).toDecimalString((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
        amount: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(amount ?? 0, allCards),
        currency: 'USD'
    }))}`;
};
const $ba8a657c1d6c9967$export$3df9704af69456d = (accounts)=>$ba8a657c1d6c9967$var$subtotalLabel(accounts, (0, $9b33a37eb331091e$export$17987e0a14ce8a32)());
const $ba8a657c1d6c9967$export$69ed894a7932b604 = ({ className: className, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('border-border bg-card divide-border flex flex-col divide-y overflow-hidden rounded-xl border', className),
        children: children
    });
const $ba8a657c1d6c9967$export$35443e9ddfb23303 = ({ label: label, badges: badges, accounts: accounts, collapsed: collapsed, onToggle: onToggle, dragHandle: dragHandle, children: children })=>{
    const subtotal = $ba8a657c1d6c9967$export$3df9704af69456d(accounts);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "flex flex-col gap-1.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                role: "button",
                tabIndex: 0,
                "aria-expanded": !collapsed,
                onClick: onToggle,
                onKeyDown: (e)=>{
                    // Only toggle for keys on the header itself — Enter/Space on a
                    // nested control (the drag grip) must not collapse the section.
                    if (e.target !== e.currentTarget) return;
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onToggle();
                    }
                },
                className: "group flex min-h-8 cursor-pointer items-center gap-1.5 px-1 select-none",
                children: [
                    dragHandle && // Clicks on the grip must not toggle the section
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        onClick: (e)=>e.stopPropagation(),
                        children: dragHandle
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-muted-foreground size-4 shrink-0 transition-transform duration-100', !collapsed && 'rotate-90')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground/80 group-hover:text-foreground min-w-0 truncate text-sm leading-5 font-semibold transition-colors",
                        children: label
                    }),
                    badges,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground shrink-0 text-xs tabular-nums",
                        children: accounts.length
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-1"
                    }),
                    subtotal != null && // Neutral either way: the sign says which way it goes.
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground shrink-0 text-sm leading-5 tabular-nums",
                        children: subtotal
                    })
                ]
            }),
            !collapsed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ba8a657c1d6c9967$export$69ed894a7932b604, {
                children: children
            })
        ]
    });
};


/** "2h ago", "Yesterday", "Jul 3": a sync's start time, relative to now. */ const $50548e5c82a04020$export$b4ea3b48dcf921f6 = (isoString)=>{
    const date = new Date(isoString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric'
    });
};








const $e12dfe293a05483a$export$b1f3ee03b26d9d13 = (token)=>token.institutionName ?? (token.accounts.length === 1 ? token.accounts[0].name : `\u{2022}\u{2022}\u{2022}${token.tokenSuffix}`);
/**
 * What the status line leads with. A connection Plaid has turned off, or
 * one whose last sync asked for a relink, needs the user; a failed sync is
 * worth a look; otherwise the line just says when it last synced.
 */ const $e12dfe293a05483a$var$healthOf = (token, lastSync, relinkedAt)=>{
    if (!token.active) return {
        tone: 'bad',
        label: 'Disconnected'
    };
    // A Plaid Link completed since the last sync supersedes that sync's
    // verdict, which is history until the next sync runs.
    if (relinkedAt != null && (lastSync == null || (0, $63618293c58b5f80$exports.DateTime).fromISO(lastSync.startedAt) < relinkedAt)) return {
        tone: 'good',
        label: 'Relinked'
    };
    if (lastSync?.result.needsRelink) return {
        tone: 'bad',
        label: 'Needs relink'
    };
    if (lastSync && lastSync.result.status !== 'success') return {
        tone: 'warn',
        label: 'Sync failed'
    };
    if (lastSync) {
        const when = (0, $50548e5c82a04020$export$b4ea3b48dcf921f6)(lastSync.startedAt);
        // Mid-sentence, the words lowercase; a date ("Jul 3") keeps its capital.
        const inSentence = when === 'Yesterday' || when === 'Just now' ? when.toLowerCase() : when;
        return {
            tone: 'good',
            label: `Synced ${inSentence}`
        };
    }
    return {
        tone: 'none',
        label: null
    };
};
const $e12dfe293a05483a$var$DOT_CLASS = {
    good: 'bg-green-600 dark:bg-green-500',
    warn: 'bg-amber-500',
    bad: 'bg-destructive',
    none: 'bg-muted-foreground/40'
};
// A problem reads in its color; a healthy line stays quiet.
const $e12dfe293a05483a$var$LABEL_CLASS = {
    good: '',
    warn: 'text-amber-600 dark:text-amber-500',
    bad: 'text-destructive',
    none: ''
};
const $e12dfe293a05483a$export$3abef6f45f2bd431 = ({ token: token, accounts: accounts, balances: balances, lastSync: lastSync, showSuffix: showSuffix = false, onRefetch: onRefetch })=>{
    const { editPlaidTokenModal: editPlaidTokenModal, deletePlaidTokenModal: deletePlaidTokenModal, manageConnectionModal: manageConnectionModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const [relinkedAt, setRelinkedAt] = $acw62.useState(null);
    const handleManageConnection = ()=>{
        if (!token) return;
        manageConnectionModal.openModal({
            plaidAccessTokenId: token._id,
            institutionName: token.institutionName,
            currentProducts: token.products,
            // Fires only after Plaid Link succeeds, which reauthenticates.
            onSuccess: ()=>{
                setRelinkedAt((0, $63618293c58b5f80$exports.DateTime).now());
                onRefetch();
            }
        });
    };
    const handleEditToken = ()=>{
        if (token) editPlaidTokenModal.openModal({
            token: token,
            onSuccess: onRefetch
        });
    };
    const handleDeleteToken = ()=>{
        if (token) deletePlaidTokenModal.openModal({
            token: token,
            onDeleted: onRefetch
        });
    };
    // The institution wears the logo its accounts already carry.
    const logo = token ? accounts.find((account)=>(0, $cd179cdb1a4beac3$export$f2c0893036cb40f8)(account.logo))?.logo : null;
    const title = token ? $e12dfe293a05483a$export$b1f3ee03b26d9d13(token) : 'Manual';
    const health = token ? $e12dfe293a05483a$var$healthOf(token, lastSync, relinkedAt) : null;
    const details = token ? [
        token.environment === 'production' ? null : 'Development',
        showSuffix ? `\u{2022}\u{2022}\u{2022}${token.tokenSuffix}` : null
    ].filter((part)=>part != null) : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ba8a657c1d6c9967$export$69ed894a7932b604), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-muted/40 flex items-center gap-3 px-3 py-3 sm:px-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "flex w-10 shrink-0 justify-center",
                        children: (0, $cd179cdb1a4beac3$export$f2c0893036cb40f8)(logo) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7ce1c21778619db$export$ef41ebc44b9c1fe4), {
                            logo: logo,
                            rounded: "rounded-lg",
                            className: "size-8"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "bg-muted text-muted-foreground flex size-8 items-center justify-center rounded-lg",
                            children: token ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05565f19ab398c04$export$2e2bcd8739ae039), {
                                className: "size-4"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33b542e8915cec79$export$2e2bcd8739ae039), {
                                className: "size-4"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-w-0 flex-1 flex-col",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex min-w-0 items-center gap-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-foreground truncate font-semibold",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground shrink-0 text-xs tabular-nums",
                                        children: accounts.length
                                    })
                                ]
                            }),
                            token && health && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-muted-foreground flex min-w-0 items-center gap-1.5 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        "aria-hidden": "true",
                                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-1.5 shrink-0 rounded-full', $e12dfe293a05483a$var$DOT_CLASS[health.tone])
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "truncate",
                                        children: [
                                            health.label != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: $e12dfe293a05483a$var$LABEL_CLASS[health.tone],
                                                children: health.label
                                            }),
                                            health.label != null && details.length > 0 && " \xb7 ",
                                            details.join(" \xb7 ")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    token && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "-mr-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49e34d17f9b50791$export$32b7bd840a1eba80), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                                    iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {}),
                                    onSelect: handleEditToken,
                                    children: "Edit Connection"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                                    iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da03c070d837b197$export$2e2bcd8739ae039), {}),
                                    onSelect: handleManageConnection,
                                    children: "Manage Connection"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                                    iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2cc4250f5d3ad942$export$2e2bcd8739ae039), {}),
                                    onSelect: ()=>navigate(`/connections/${token._id}/debug`),
                                    children: "Debug Sync"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                                    iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                        className: "text-destructive"
                                    }),
                                    onSelect: handleDeleteToken,
                                    className: "text-destructive",
                                    children: "Delete Connection"
                                })
                            ]
                        })
                    })
                ]
            }),
            accounts.length > 0 ? accounts.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba405bcc20345af9$export$b3e0a2e54ae1504b), {
                    account: account,
                    balance: balances.get(account._id)
                }, account._id)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground px-4 py-3 text-sm",
                children: "No accounts"
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");

/**
 * Holds the DOM node of the top-bar action slot (rendered by MainPane beside
 * the breadcrumb). Null until that slot mounts.
 */ const $eca5e0b4050b06eb$var$HeaderActionsContext = /*#__PURE__*/ $acw62.createContext(null);
const $eca5e0b4050b06eb$export$6e97079f8722c75e = $eca5e0b4050b06eb$var$HeaderActionsContext.Provider;
const $eca5e0b4050b06eb$export$223875819fd7cf93 = ({ children: children })=>{
    const slot = $acw62.useContext($eca5e0b4050b06eb$var$HeaderActionsContext);
    return slot ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(children, slot) : null;
};




/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5415d98bde6b29f1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const $5415d98bde6b29f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-alert", $5415d98bde6b29f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e3f86240925e7a9e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.801 10A10 10 0 1 1 17 3.335",
            key: "yps3ct"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
];
const $e3f86240925e7a9e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-check-big", $e3f86240925e7a9e$export$3efd853dbb351e94);


parcelRequire("acw62");



const $abca742d08aa83c1$var$SyncRow = ({ sync: sync })=>{
    const failed = sync.results.filter((result)=>result.status !== 'success');
    const hasError = sync.tokensFailed > 0;
    const StatusIcon = hasError ? (0, $5415d98bde6b29f1$export$2e2bcd8739ae039) : (0, $e3f86240925e7a9e$export$2e2bcd8739ae039);
    // Name the connections that failed when the session recorded them.
    const failedLabel = failed.length > 0 ? `${failed.map((result)=>result.institutionName).join(', ')} failed` : `${sync.tokensFailed} connection${sync.tokensFailed === 1 ? '' : 's'} failed`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-3 px-3 py-2.5 sm:px-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(StatusIcon, {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-4 shrink-0', hasError ? 'text-amber-500' : 'text-green-600 dark:text-green-500')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-w-0 flex-1 flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground text-sm",
                        children: (0, $50548e5c82a04020$export$b4ea3b48dcf921f6)(sync.startedAt)
                    }),
                    hasError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground truncate text-xs",
                        children: failedLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground shrink-0 text-sm tabular-nums",
                children: sync.transactionsCreated > 0 ? `+${sync.transactionsCreated} transaction${sync.transactionsCreated === 1 ? '' : 's'}` : 'No new transactions'
            })
        ]
    });
};
const $abca742d08aa83c1$export$5dca71c164c2e9ad = ()=>{
    const { data: data, loading: loading } = (0, $ce9d9e524be20f53$export$60773f2c3f6c88b3)({
        variables: {
            limit: 5
        },
        fetchPolicy: 'cache-and-network'
    });
    if (loading && !data) return null;
    if (!data?.recentSyncs || data.recentSyncs.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "flex flex-col gap-1.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-foreground/80 m-0 flex min-h-8 items-center px-1 text-sm font-semibold",
                children: "Recent syncs"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba8a657c1d6c9967$export$69ed894a7932b604), {
                children: data.recentSyncs.map((sync)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($abca742d08aa83c1$var$SyncRow, {
                        sync: sync
                    }, sync._id))
            })
        ]
    });
};



const $f016b1342bde9d89$export$2ad937ac55e586dd = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Connections',
        fallback: [
            {
                label: 'Settings',
                href: '/settings'
            }
        ]
    });
    const [searchParams, setSearchParams] = (0, $0c90f43fc3673aef$export$f1a78c17382fe22a)();
    const typeFilter = (0, $e597f4605156a89e$export$2fd2effeb17443f1)(searchParams.get('type'));
    // Same contextual default as the Accounts page: picking a type is a
    // narrowing gesture, and hiding inactive/closed matches would make the
    // very accounts being asked for vanish — so the status default widens.
    // An explicit pick always wins.
    const explicitFilter = (0, $e597f4605156a89e$export$49a87e04cfe7c710)(searchParams.get('filter'));
    const defaultFilter = typeFilter.length > 0 ? 'all' : 'active';
    const filter = explicitFilter ?? defaultFilter;
    const { data: accountsData, loading: accountsLoading, refetch: refetchAccounts } = (0, $ce9d9e524be20f53$export$cb6e321bdf608ddb)({
        fetchPolicy: 'cache-and-network'
    });
    const { data: tokensData, loading: tokensLoading, refetch: refetchTokens } = (0, $ce9d9e524be20f53$export$5e3a1aad06c8e637)({
        fetchPolicy: 'cache-and-network'
    });
    // Balances stream in after the metadata (they are derived server-side);
    // rows show a placeholder until they land.
    const { data: balancesData, refetch: refetchBalances } = (0, $ce9d9e524be20f53$export$6d85013179a40a0d)({
        fetchPolicy: 'cache-and-network'
    });
    // Same query (and cache entry) as the Recent syncs list below; each
    // connection's status line reads its latest result from it.
    const { data: syncsData } = (0, $ce9d9e524be20f53$export$60773f2c3f6c88b3)({
        variables: {
            limit: 5
        },
        fetchPolicy: 'cache-and-network'
    });
    const { connectPlaidModal: connectPlaidModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const handleRefetch = $acw62.useCallback(()=>{
        refetchAccounts();
        refetchTokens();
        refetchBalances();
    }, [
        refetchAccounts,
        refetchTokens,
        refetchBalances
    ]);
    const setFilter = (newFilter)=>{
        const next = new URLSearchParams(searchParams);
        // Only a non-default pick is real state (the default is contextual).
        if (newFilter === defaultFilter) next.delete('filter');
        else next.set('filter', newFilter);
        setSearchParams(next);
    };
    const setTypeFilter = (newTypeFilter)=>{
        const next = new URLSearchParams(searchParams);
        const serialized = (0, $e597f4605156a89e$export$e04f9e18b7296b99)(newTypeFilter);
        if (serialized == null) next.delete('type');
        else next.set('type', serialized);
        setSearchParams(next);
    };
    const handleConnect = ()=>{
        // linkPlaidAccount returns only a Boolean, so Apollo can't merge the
        // new token into the cached lists — refetch on success.
        connectPlaidModal.openModal({
            onSuccess: handleRefetch
        });
    };
    // cache-and-network reports loading during background refreshes — only
    // block on the initial fetch.
    if (accountsLoading && !accountsData || tokensLoading && !tokensData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading connections..."
        })
    });
    const balances = (0, $44fe23713dacf9c4$export$efe12b2e2f122c40)(balancesData);
    // Contextual defaults don't count as narrowing, and neither does an
    // explicit All — only a pick that actually restricts the view prunes
    // groups from the page.
    const explicitlyNarrowed = explicitFilter != null && explicitFilter !== 'all' || typeFilter.length > 0;
    const allAccounts = accountsData?.allAccounts ?? [];
    const tokens = tokensData?.allPlaidAccessTokens ?? [];
    const matchesStatus = (statusFilter, account)=>(0, $e597f4605156a89e$export$175da04470876f6a)(statusFilter, account, balances.get(account._id));
    // Each dropdown's counts respect the OTHER filter (GitHub-style cross
    // counts), mirroring the Accounts page.
    const typeMatchedAccounts = allAccounts.filter((account)=>(0, $e597f4605156a89e$export$86f6532dce6b4d32)(typeFilter, account));
    const statusMatchedAccounts = allAccounts.filter((account)=>matchesStatus(filter, account));
    const visibleAccounts = typeMatchedAccounts.filter((account)=>matchesStatus(filter, account));
    const statusOptions = [
        {
            key: 'active',
            label: 'Active',
            count: typeMatchedAccounts.filter((account)=>matchesStatus('active', account)).length
        },
        {
            key: 'inactive',
            label: 'Inactive',
            count: typeMatchedAccounts.filter((account)=>(0, $e597f4605156a89e$export$ad17ddbed40f1c23)(account, balances.get(account._id))).length
        },
        {
            key: 'closed',
            label: 'Closed',
            count: typeMatchedAccounts.filter((0, $e597f4605156a89e$export$881343af68ecca95)).length
        }
    ];
    const typeOptions = (0, $e597f4605156a89e$export$6096865e4aa58c8a).map((option)=>({
            key: option.key,
            label: option.label,
            group: option.group,
            count: statusMatchedAccounts.filter(option.matches).length,
            present: allAccounts.some(option.matches)
        })).filter((option)=>option.present || typeFilter.includes(option.key));
    // Group accounts by token.
    const grouped = [];
    const accountsWithToken = new Set();
    for (const token of tokens){
        const accountIds = new Set(token.accounts.map((a)=>a._id));
        const tokenAccounts = visibleAccounts.filter((account)=>accountIds.has(account._id));
        // A connection with no linked accounts at all stays visible under the
        // default view — this page is the only place to edit, debug, or delete
        // it. Explicit narrowing still prunes it (an empty group is noise
        // then), and a connection whose accounts are merely filtered out stays
        // hidden as before: the status filter is the way back in.
        const accountless = token.accounts.length === 0;
        if (tokenAccounts.length > 0 || accountless && !explicitlyNarrowed) grouped.push({
            token: token,
            accounts: tokenAccounts
        });
        tokenAccounts.forEach((a)=>accountsWithToken.add(a._id));
    }
    // Manual accounts (no token).
    const syntheticAccounts = visibleAccounts.filter((account)=>!accountsWithToken.has(account._id));
    const hasNoConnections = tokens.length === 0 && syntheticAccounts.length === 0;
    // Newest first from the server, so the first result per token wins.
    const lastSyncByToken = new Map();
    for (const sync of syncsData?.recentSyncs ?? []){
        for (const result of sync.results)if (!lastSyncByToken.has(result.tokenId)) lastSyncByToken.set(result.tokenId, {
            startedAt: sync.startedAt,
            result: result
        });
    }
    const renderBody = ()=>{
        if (hasNoConnections) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "border-border flex flex-col items-center gap-4 rounded-xl border border-dashed p-8",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground",
                    children: "No connections"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: handleConnect,
                    type: "button",
                    children: "Connect with Plaid"
                })
            ]
        });
        if (grouped.length === 0 && syntheticAccounts.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "text-muted-foreground py-8 text-center text-sm",
            children: typeFilter.length === 0 ? `No ${filter} accounts` : 'No matching accounts'
        });
        // Two connections to one bank are told apart by their id suffix.
        const titleCounts = new Map();
        for (const { token: token } of grouped){
            const title = (0, $e12dfe293a05483a$export$b1f3ee03b26d9d13)(token);
            titleCounts.set(title, (titleCounts.get(title) ?? 0) + 1);
        }
        const renderGroup = ({ token: token, accounts: accounts })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e12dfe293a05483a$export$3abef6f45f2bd431), {
                token: token,
                accounts: accounts,
                balances: balances,
                lastSync: lastSyncByToken.get(token._id),
                showSuffix: (titleCounts.get((0, $e12dfe293a05483a$export$b1f3ee03b26d9d13)(token)) ?? 0) > 1,
                onRefetch: handleRefetch
            }, token._id);
        // Disconnected connections sink below the manual accounts.
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-3",
            children: [
                grouped.filter(({ token: token })=>token.active).map(renderGroup),
                syntheticAccounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e12dfe293a05483a$export$3abef6f45f2bd431), {
                    token: null,
                    accounts: syntheticAccounts,
                    balances: balances,
                    onRefetch: handleRefetch
                }),
                grouped.filter(({ token: token })=>!token.active).map(renderGroup)
            ]
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col overflow-y-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eca5e0b4050b06eb$export$223875819fd7cf93), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "ghost",
                    size: "icon",
                    "aria-label": "Add connection",
                    onClick: handleConnect,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                        className: "size-5"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mx-auto flex w-full max-w-3xl flex-col gap-4 p-4 sm:px-6",
                children: [
                    allAccounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                                label: "Status",
                                allLabel: "All",
                                allCount: typeMatchedAccounts.length,
                                value: filter,
                                onChange: (key)=>setFilter((0, $e597f4605156a89e$export$fabe442d1eda117c)(key)),
                                options: statusOptions
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                                label: "Type",
                                allLabel: "All types",
                                allCount: statusMatchedAccounts.length,
                                multiple: true,
                                value: typeFilter,
                                onChange: setTypeFilter,
                                options: typeOptions
                            })
                        ]
                    }),
                    renderBody(),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $abca742d08aa83c1$export$5dca71c164c2e9ad), {})
                ]
            })
        ]
    });
};







var $acw62 = parcelRequire("acw62");





const $ee2f5a5388dc4da7$var$badgeClass = (tone)=>(0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('rounded px-1.5 py-0.5 text-xs font-medium whitespace-nowrap', tone === 'green' && 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300', tone === 'red' && 'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300', tone === 'amber' && 'bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-300', tone === 'blue' && 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300', tone === 'purple' && 'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300', tone === 'slate' && 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300');
/** The one-glance "how does this Plaid row relate to the DB" marker. */ const $ee2f5a5388dc4da7$var$DbStatusBadge = ({ row: row })=>{
    if (row.dbStatus === 'synced') return row.dbMatches ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: $ee2f5a5388dc4da7$var$badgeClass('green'),
        children: "in DB"
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: $ee2f5a5388dc4da7$var$badgeClass('amber'),
        children: "in DB, differs"
    });
    if (row.dbStatus === 'deleted') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: $ee2f5a5388dc4da7$var$badgeClass('slate'),
        children: "deleted in DB"
    });
    if (row.pending) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: $ee2f5a5388dc4da7$var$badgeClass('blue'),
        children: "pending"
    });
    if (!row.wouldSync) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: $ee2f5a5388dc4da7$var$badgeClass('slate'),
        children: [
            "skip: ",
            row.skipReason ?? 'filtered'
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: $ee2f5a5388dc4da7$var$badgeClass('red'),
        children: "not in DB"
    });
};
// An empty currency (Plaid rows carrying only unofficial_currency_code) must
// not be dressed up as USD — Money's fallback renders the bare number, which
// is what the sync would actually store.
const $ee2f5a5388dc4da7$var$formatAmount = (amount, currency)=>(0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).toDecimalString((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
        amount: amount,
        currency: currency
    })).trim();
const $ee2f5a5388dc4da7$var$truncateCursor = (cursor)=>cursor.length <= 24 ? cursor : `${cursor.slice(0, 12)}\u{2026}${cursor.slice(-8)}`;
const $ee2f5a5388dc4da7$var$CursorChip = ({ label: label, cursor: cursor })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "flex items-center gap-1 text-xs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground",
                children: label
            }),
            cursor ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "bg-muted rounded px-1.5 py-0.5 font-mono",
                        children: $ee2f5a5388dc4da7$var$truncateCursor(cursor)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        title: "Copy full cursor",
                        className: "text-muted-foreground hover:text-foreground cursor-pointer",
                        onClick: ()=>{
                            navigator.clipboard.writeText(cursor);
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                            className: "size-3"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground italic",
                children: "none (from start)"
            })
        ]
    });
const $ee2f5a5388dc4da7$var$prettyJson = (json)=>{
    try {
        return JSON.stringify(JSON.parse(json), null, 2);
    } catch  {
        return json;
    }
};
const $ee2f5a5388dc4da7$var$ExpandedRow = ({ row: row })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-muted/30 flex flex-col gap-3 p-3 text-xs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-2 gap-x-6 gap-y-1 md:grid-cols-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "transaction_id: "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-mono",
                                children: row.transactionId
                            })
                        ]
                    }),
                    row.pendingTransactionId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "pending_transaction_id: "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-mono",
                                children: row.pendingTransactionId
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "plaid account: "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-mono",
                                children: row.plaidAccountId
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "date / authorized: "
                            }),
                            row.date,
                            " / ",
                            row.authorizedDate ?? "\u2014"
                        ]
                    }),
                    row.personalFinanceCategory && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "category: "
                            }),
                            row.personalFinanceCategory
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "would sync: "
                            }),
                            row.wouldSync ? 'yes' : `no \u{2014} ${row.skipReason ?? 'filtered'}`
                        ]
                    })
                ]
            }),
            row.dbRawTransactionId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-x-6 gap-y-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "DB row: "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                to: `/raw-transactions/${row.dbRawTransactionId}`,
                                className: "text-primary font-mono underline",
                                children: row.dbRawTransactionId
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)((row.dbAmount !== row.amount || row.dbCurrency !== row.currency) && 'text-amber-600'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "DB amount: "
                            }),
                            row.dbAmount != null ? $ee2f5a5388dc4da7$var$formatAmount(row.dbAmount, row.dbCurrency ?? '') : "\u2014"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "DB date: "
                            }),
                            row.dbDate ?? "\u2014"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "DB description: "
                            }),
                            row.dbDescription ?? "\u2014"
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground",
                children: "No RawTransaction with this plaidId in the database."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                className: "bg-background border-border max-h-96 overflow-auto rounded border p-2 font-mono",
                children: $ee2f5a5388dc4da7$var$prettyJson(row.plaidJson)
            })
        ]
    });
const $ee2f5a5388dc4da7$var$TransactionRow = ({ row: row, expanded: expanded, onToggle: onToggle })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('border-border hover:bg-accent/30 cursor-pointer border-t', row.pending && 'opacity-70'),
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: "px-3 py-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: $ee2f5a5388dc4da7$var$badgeClass(row.stream === 'added' ? 'blue' : 'purple'),
                            children: row.stream
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: "px-3 py-1.5 whitespace-nowrap",
                        children: row.authorizedDate ?? row.date
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                        className: "max-w-96 truncate px-3 py-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-foreground",
                                children: row.name
                            }),
                            row.merchantName && row.merchantName !== row.name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-muted-foreground",
                                children: [
                                    " \xb7 ",
                                    row.merchantName
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: "text-muted-foreground px-3 py-1.5 whitespace-nowrap",
                        children: row.accountName ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "italic",
                            children: [
                                "unlinked (",
                                row.plaidAccountId.slice(-6),
                                ")"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('px-3 py-1.5 text-right font-mono whitespace-nowrap', row.amount > 0 ? 'text-positive' : 'text-foreground'),
                        children: $ee2f5a5388dc4da7$var$formatAmount(row.amount, row.currency)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                        className: "px-3 py-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2f5a5388dc4da7$var$DbStatusBadge, {
                            row: row
                        })
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                className: "border-border border-t",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                    colSpan: 6,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2f5a5388dc4da7$var$ExpandedRow, {
                        row: row
                    })
                })
            })
        ]
    });
const $ee2f5a5388dc4da7$var$matchesStatusFilter = (row, filter)=>{
    switch(filter){
        case 'all':
            return true;
        case 'pending':
            return row.pending;
        case 'missing':
            return row.dbStatus === 'missing' && !row.pending && row.wouldSync;
        case 'mismatch':
            return row.dbStatus === 'synced' && row.dbMatches === false;
        case 'skipped':
            return !row.wouldSync && !row.pending;
    }
};
const $ee2f5a5388dc4da7$export$e6bbfbb74d4b5b1e = ()=>{
    const params = (0, $926608a7a86d7371$export$99eaa27ddbbb95ef)();
    const accessTokenId = params.id || '';
    // Keyed by token id: navigating between two debug URLs reuses the same
    // component instance, and fetched pages from one token must never survive
    // into another's probe (wrong rows, wrong cursor).
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2f5a5388dc4da7$var$PlaidDebugForToken, {
        accessTokenId: accessTokenId
    }, accessTokenId);
};
const $ee2f5a5388dc4da7$var$PlaidDebugForToken = ({ accessTokenId: accessTokenId })=>{
    const { data: tokensData } = (0, $ce9d9e524be20f53$export$5e3a1aad06c8e637)();
    const token = tokensData?.allPlaidAccessTokens.find((t)=>t._id === accessTokenId);
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: token?.institutionName ? `Debug \xb7 ${token.institutionName}` : 'Debug',
        fallback: [
            {
                label: 'Settings',
                href: '/settings'
            },
            {
                label: 'Connections',
                href: '/connections'
            }
        ]
    });
    const [startMode, setStartMode] = $acw62.useState('stored');
    const [customCursor, setCustomCursor] = $acw62.useState('');
    const [countInput, setCountInput] = $acw62.useState('100');
    const [pages, setPages] = $acw62.useState([]);
    const [fetchError, setFetchError] = $acw62.useState(null);
    const [expandedId, setExpandedId] = $acw62.useState(null);
    const [accountFilter, setAccountFilter] = $acw62.useState('all');
    const [statusFilter, setStatusFilter] = $acw62.useState('all');
    // The preview is a live debugging probe — never serve or store cached pages.
    const [runPreview, { loading: loading }] = (0, $ce9d9e524be20f53$export$f4b3364035de1951)({
        fetchPolicy: 'no-cache'
    });
    const lastPage = pages.length > 0 ? pages[pages.length - 1] : null;
    // The start settings the displayed walk was actually fetched with. When
    // the controls no longer match, "Load next page" is disabled — it would
    // extend the old walk while the controls describe a different one.
    const [walkStartKey, setWalkStartKey] = $acw62.useState(null);
    const startKey = (mode, cursor)=>mode === 'custom' ? `custom:${cursor.trim()}` : mode;
    const walkStale = lastPage != null && walkStartKey !== startKey(startMode, customCursor);
    const fetchPage = async (reset)=>{
        setFetchError(null);
        const count = Math.min(Math.max(parseInt(countInput, 10) || 100, 1), 500);
        const variables = reset ? {
            accessTokenId: accessTokenId,
            count: count,
            ...startMode === 'start' ? {
                fromStart: true
            } : {},
            // Fetch is disabled while the custom cursor is blank, so this never
            // silently falls back to the stored cursor.
            ...startMode === 'custom' ? {
                cursor: customCursor.trim()
            } : {}
        } : {
            accessTokenId: accessTokenId,
            count: count,
            cursor: lastPage?.nextCursor
        };
        const result = await runPreview({
            variables: variables
        });
        if (result.error) {
            // Plaid invalidates the whole pagination loop when the underlying data
            // mutates mid-walk — the accumulated cursors are dead, so continuing
            // would just retry an invalid cursor. Drop the walk, but pin the next
            // Fetch to the cursor the walk actually started from: re-reading the
            // stored cursor could skip data if the hourly sync advanced it
            // concurrently.
            if (!reset && result.error.message.includes('TRANSACTIONS_SYNC_MUTATION_DURING_PAGINATION')) {
                const originalCursor = pages[0]?.usedCursor ?? null;
                setPages([]);
                if (originalCursor != null && originalCursor !== '') {
                    setStartMode('custom');
                    setCustomCursor(originalCursor);
                } else // A null usedCursor means the walk read from the very beginning.
                setStartMode('start');
                setFetchError("Plaid data changed while paginating (TRANSACTIONS_SYNC_MUTATION_DURING_PAGINATION); the accumulated pages were discarded. Press Fetch to restart the walk \u2014 the original starting cursor has been pre-selected.");
                return;
            }
            // A failed reset fetch must not leave the previous walk's pages on
            // screen: the controls describe the new probe, so stale rows (and
            // their still-loadable next cursor) would masquerade as its results.
            if (reset) setPages([]);
            setFetchError(result.error.message);
            return;
        }
        const page = result.data?.plaidSyncPreview;
        if (page) {
            if (reset) {
                setWalkStartKey(startKey(startMode, customCursor));
                // A new walk starts unfiltered: a selection from the previous walk
                // may name an account the new one lacks — and masking it instead
                // would let it snap back if a later page reintroduced the account.
                setAccountFilter('all');
            }
            setPages((previous)=>reset ? [
                    page
                ] : [
                    ...previous,
                    page
                ]);
        }
    };
    const rows = pages.flatMap((page)=>[
            ...page.added.map((row)=>({
                    ...row,
                    stream: 'added'
                })),
            ...page.modified.map((row)=>({
                    ...row,
                    stream: 'modified'
                }))
        ]);
    // Accounts across all fetched pages, newer pages winning.
    const accountsById = new Map();
    for (const page of pages)for (const account of page.accounts)accountsById.set(account.plaidAccountId, account);
    const accounts = [
        ...accountsById.values()
    ];
    const removed = pages.flatMap((page)=>page.removed);
    const accountOptions = [
        ...new Map(rows.map((row)=>[
                row.plaidAccountId,
                row.accountName ?? row.plaidAccountId
            ])).entries()
    ];
    // The filter resets to 'all' on every new walk (see fetchPage), and rows
    // only accumulate within a walk, so a selected option can never vanish.
    const visibleRows = rows.filter((row)=>(accountFilter === 'all' || row.plaidAccountId === accountFilter) && $ee2f5a5388dc4da7$var$matchesStatusFilter(row, statusFilter));
    const pendingCount = rows.filter((row)=>row.pending).length;
    const missingCount = rows.filter((row)=>row.dbStatus === 'missing' && !row.pending && row.wouldSync).length;
    const mismatchCount = rows.filter((row)=>row.dbStatus === 'synced' && row.dbMatches === false).length;
    const selectClass = 'border-input bg-background text-foreground rounded-md border px-2 py-1.5 text-sm';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col gap-4 overflow-y-auto p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-card flex flex-col gap-3 rounded-lg border p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-foreground font-medium",
                                children: token?.institutionName ?? 'Plaid token'
                            }),
                            token && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-muted-foreground font-mono text-sm",
                                        children: [
                                            "\u2022\u2022\u2022",
                                            token.tokenSuffix
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: $ee2f5a5388dc4da7$var$badgeClass(token.environment === 'production' ? 'blue' : 'amber'),
                                        children: token.environment
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: $ee2f5a5388dc4da7$var$badgeClass(token.active ? 'green' : 'red'),
                                        children: token.active ? 'active' : 'inactive'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground text-sm",
                        children: "Read-only transactionsSync probe: fetches pages directly from Plaid (including pending transactions that a real sync filters out) and marks how each row compares to the database. The stored sync cursor is never modified."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-end gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Start from"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        className: selectClass,
                                        value: startMode,
                                        // Editing the probe settings mid-flight would relabel results
                                        // fetched with the old settings — locked while loading, like
                                        // the other controls below.
                                        disabled: loading,
                                        onChange: (e)=>{
                                            if (e.target.value === 'stored' || e.target.value === 'start' || e.target.value === 'custom') setStartMode(e.target.value);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "stored",
                                                children: "Stored cursor (DB)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "start",
                                                children: "Beginning of history"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "custom",
                                                children: "Custom cursor"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            startMode === 'custom' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex min-w-64 flex-1 flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Cursor"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(selectClass, 'font-mono'),
                                        value: customCursor,
                                        disabled: loading,
                                        onChange: (e)=>setCustomCursor(e.target.value),
                                        placeholder: "Paste a cursor\u2026"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Page size"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "number",
                                        min: 1,
                                        max: 500,
                                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(selectClass, 'w-24'),
                                        value: countInput,
                                        disabled: loading,
                                        onChange: (e)=>setCountInput(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "primary",
                                disabled: loading || !accessTokenId || startMode === 'custom' && customCursor.trim() === '',
                                onClick: ()=>{
                                    fetchPage(true);
                                },
                                children: loading ? "Fetching\u2026" : 'Fetch'
                            }),
                            lastPage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "outline",
                                disabled: loading || !lastPage.hasMore || walkStale,
                                onClick: ()=>{
                                    fetchPage(false);
                                },
                                children: lastPage.hasMore ? 'Load next page' : 'No more pages'
                            }),
                            walkStale && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground self-center text-xs",
                                children: "Start settings changed \u2014 press Fetch to begin a new walk."
                            })
                        ]
                    }),
                    fetchError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                        children: fetchError
                    }),
                    lastPage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-x-6 gap-y-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2f5a5388dc4da7$var$CursorChip, {
                                label: `Used cursor (${lastPage.cursorSource}):`,
                                cursor: lastPage.usedCursor ?? null
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2f5a5388dc4da7$var$CursorChip, {
                                label: "Next cursor:",
                                cursor: lastPage.nextCursor
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-muted-foreground text-xs",
                                children: [
                                    pages.length,
                                    " page",
                                    pages.length === 1 ? '' : 's',
                                    " \xb7",
                                    ' ',
                                    rows.length,
                                    " rows \xb7 ",
                                    removed.length,
                                    " removed \xb7",
                                    ' ',
                                    lastPage.hasMore ? 'more available' : 'end of updates'
                                ]
                            })
                        ]
                    })
                ]
            }),
            loading && pages.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
                size: "medium"
            }),
            accounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-card flex flex-col gap-2 rounded-lg border p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground text-sm font-medium",
                        children: "Accounts in response"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-wrap gap-2",
                        children: accounts.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "border-border flex items-center gap-2 rounded border px-2 py-1 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-foreground",
                                        children: [
                                            account.name,
                                            account.mask ? ` \u{2022}\u{2022}${account.mask}` : ''
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-muted-foreground",
                                        children: [
                                            account.type,
                                            account.subtype ? `/${account.subtype}` : ''
                                        ]
                                    }),
                                    account.currentBalance != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-mono",
                                        children: $ee2f5a5388dc4da7$var$formatAmount(account.currentBalance, account.currency ?? '')
                                    }),
                                    account.accountName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: $ee2f5a5388dc4da7$var$badgeClass('green'),
                                        children: [
                                            "\u2192 ",
                                            account.accountName
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: $ee2f5a5388dc4da7$var$badgeClass('red'),
                                        children: "not linked"
                                    })
                                ]
                            }, account.plaidAccountId))
                    })
                ]
            }),
            pages.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-card flex flex-col rounded-lg border",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-3 p-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-foreground text-sm font-medium",
                                children: [
                                    "Transactions (",
                                    visibleRows.length,
                                    visibleRows.length !== rows.length ? ` of ${rows.length}` : '',
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-muted-foreground text-xs",
                                children: [
                                    pendingCount,
                                    " pending \xb7 ",
                                    missingCount,
                                    " not in DB \xb7",
                                    ' ',
                                    mismatchCount,
                                    " differ"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ml-auto flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        className: selectClass,
                                        value: accountFilter,
                                        onChange: (e)=>setAccountFilter(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All accounts"
                                            }),
                                            accountOptions.map(([id, name])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: id,
                                                    children: name
                                                }, id))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        className: selectClass,
                                        value: statusFilter,
                                        onChange: (e)=>{
                                            const value = e.target.value;
                                            if (value === 'all' || value === 'pending' || value === 'missing' || value === 'mismatch' || value === 'skipped') setStatusFilter(value);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "all",
                                                children: "All statuses"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "pending",
                                                children: "Pending only"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "missing",
                                                children: "Not in DB"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "mismatch",
                                                children: "In DB but differs"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "skipped",
                                                children: "Would be skipped"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    visibleRows.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-muted-foreground p-6 text-center text-sm",
                        children: [
                            "No transactions in the fetched pages",
                            rows.length > 0 ? ' match the filters' : '',
                            "."
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "w-full text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "text-muted-foreground text-left text-xs",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-2 font-medium",
                                                children: "Stream"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-2 font-medium",
                                                children: "Date"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-2 font-medium",
                                                children: "Description"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-2 font-medium",
                                                children: "Account"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-2 text-right font-medium",
                                                children: "Amount"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "px-3 py-2 font-medium",
                                                children: "DB status"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: visibleRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2f5a5388dc4da7$var$TransactionRow, {
                                            row: row,
                                            expanded: expandedId === row.transactionId,
                                            onToggle: ()=>setExpandedId(expandedId === row.transactionId ? null : row.transactionId)
                                        }, `${row.stream}-${row.transactionId}`))
                                })
                            ]
                        })
                    })
                ]
            }),
            removed.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-card flex flex-col gap-2 rounded-lg border p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-foreground text-sm font-medium",
                        children: [
                            "Removed by Plaid (",
                            removed.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-1",
                        children: removed.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-mono",
                                        children: entry.transactionId
                                    }),
                                    entry.dbRawTransactionId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                        to: `/raw-transactions/${entry.dbRawTransactionId}`,
                                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($ee2f5a5388dc4da7$var$badgeClass(entry.dbStatus === 'deleted' ? 'slate' : 'amber'), 'underline'),
                                        children: entry.dbStatus === 'deleted' ? 'already deleted in DB' : 'still present in DB'
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: $ee2f5a5388dc4da7$var$badgeClass('green'),
                                        children: "not in DB"
                                    })
                                ]
                            }, entry.transactionId))
                    })
                ]
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");


const $c2940bd35e7a5ee1$export$f9c6505dbbbc6719 = ({ onRequestClose: onRequestClose, token: token, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const [active, setActive] = $acw62.useState(token.active);
    const [error, setError] = $acw62.useState(null);
    const [updateToken, { loading: loading }] = (0, $ce9d9e524be20f53$export$8019a84102a1c641)();
    const hasChanges = active !== token.active;
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            await updateToken({
                variables: {
                    id: token._id,
                    active: active
                }
            });
            onSuccess();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const accountNames = token.accounts.map((a)=>a.name).join(', ') || 'No accounts';
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || !hasChanges,
                children: loading ? 'Saving...' : 'Save'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Edit Plaid Token",
        footer: footer,
        size: "sm",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-muted-foreground text-sm",
                            children: "Token"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "font-mono text-sm",
                            children: [
                                "\u2022\u2022\u2022",
                                token.tokenSuffix
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-muted-foreground text-sm",
                            children: "Connected Accounts"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-sm",
                            children: accountNames
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            id: "edit-active",
                            checked: active,
                            onChange: (e)=>setActive(e.target.checked),
                            className: "h-4 w-4"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "edit-active",
                            className: "text-sm",
                            children: "Active"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground text-xs",
                    children: "Inactive tokens will not be used for syncing transactions."
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");


const $3c4b38b1a9bb2157$export$e7d68b75d17031d1 = (props)=>{
    const { token: token, onRequestClose: onRequestClose, onDeleted: onDeleted } = props;
    const [deleteToken, { loading: loading }] = (0, $ce9d9e524be20f53$export$3e40c5d7e45f95c8)();
    const [error, setError] = $acw62.useState(null);
    const handleDelete = async ()=>{
        setError(null);
        try {
            await deleteToken({
                variables: {
                    id: token._id
                }
            });
            onDeleted?.();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const accountNames = token.accounts.map((a)=>a.name);
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: handleDelete,
                disabled: loading,
                children: loading ? 'Deleting...' : 'Delete'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Delete Plaid Token",
        footer: footer,
        size: "sm",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-destructive/10 text-destructive mb-3 rounded-md p-3 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "Are you sure you want to delete the token",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "font-mono text-sm",
                                children: [
                                    "\u2022\u2022\u2022",
                                    token.tokenSuffix
                                ]
                            }),
                            "?"
                        ]
                    }),
                    accountNames.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border-border rounded-md border p-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground mb-2 text-sm font-medium",
                                children: "Connected accounts that will be affected:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "text-muted-foreground list-inside list-disc text-sm",
                                children: accountNames.map((name)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: name
                                    }, name))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground text-sm",
                        children: "This action cannot be undone. The connected accounts will no longer be able to sync transactions."
                    })
                ]
            })
        ]
    });
};







var $acw62 = parcelRequire("acw62");
var $8a36ddd27b352a95$exports = {};

(function(global1, factory) {
    factory($8a36ddd27b352a95$exports, (parcelRequire("acw62")));
})($8a36ddd27b352a95$exports, function(exports1, React) {
    'use strict';
    var React__default = 'default' in React ? React['default'] : React;
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    function unwrapExports(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    function createCommonjsModule(fn, module) {
        return module = {
            exports: {}
        }, fn(module, module.exports), module.exports;
    }
    var useScript_1 = createCommonjsModule(function(module, exports1) {
        var __rest = commonjsGlobal && commonjsGlobal.__rest || function(s, e) {
            var t = {};
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
            if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
            }
            return t;
        };
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        exports1.scripts = void 0;
        // Previously loading/loaded scripts and their current status
        exports1.scripts = {}; // Check for existing <script> tags with this src. If so, update scripts[src]
        // and return the new status; otherwise, return undefined.
        var checkExisting = function(src) {
            var existing = document.querySelector("script[src=\"" + src + "\"]");
            if (existing) // Assume existing <script> tag is already loaded,
            // and cache that data for future use.
            return exports1.scripts[src] = {
                loading: false,
                error: null,
                scriptEl: existing
            };
            return undefined;
        };
        function useScript(_a) {
            var src = _a.src, _b = _a.checkForExisting, checkForExisting = _b === void 0 ? false : _b, attributes = __rest(_a, [
                "src",
                "checkForExisting"
            ]); // Check whether some instance of this hook considered this src.
            var status = src ? exports1.scripts[src] : undefined; // If requested, check for existing <script> tags with this src
            // (unless we've already loaded the script ourselves).
            if (!status && checkForExisting && src && isBrowser) status = checkExisting(src);
            var _c = (0, React__default.useState)(status ? status.loading : Boolean(src)), loading = _c[0], setLoading = _c[1];
            var _d = (0, React__default.useState)(status ? status.error : null), error = _d[0], setError = _d[1]; // Tracks if script is loaded so we can avoid duplicate script tags
            var _e = (0, React__default.useState)(false), scriptLoaded = _e[0], setScriptLoaded = _e[1];
            (0, React__default.useEffect)(function() {
                // Nothing to do on server, or if no src specified, or
                // if script is already loaded or "error" state.
                if (!isBrowser || !src || scriptLoaded || error) return; // Check again for existing <script> tags with this src
                // in case it's changed since mount.
                // eslint-disable-next-line react-hooks/exhaustive-deps
                status = exports1.scripts[src];
                if (!status && checkForExisting) status = checkExisting(src);
                 // Determine or create <script> element to listen to.
                var scriptEl;
                if (status) scriptEl = status.scriptEl;
                else {
                    scriptEl = document.createElement('script');
                    scriptEl.src = src;
                    Object.keys(attributes).forEach(function(key) {
                        if (scriptEl[key] === undefined) scriptEl.setAttribute(key, attributes[key]);
                        else scriptEl[key] = attributes[key];
                    });
                    status = exports1.scripts[src] = {
                        loading: true,
                        error: null,
                        scriptEl: scriptEl
                    };
                } // `status` is now guaranteed to be defined: either the old status
                // from a previous load, or a newly created one.
                var handleLoad = function() {
                    if (status) status.loading = false;
                    setLoading(false);
                    setScriptLoaded(true);
                };
                var handleError = function(error) {
                    if (status) status.error = error;
                    setError(error);
                };
                scriptEl.addEventListener('load', handleLoad);
                scriptEl.addEventListener('error', handleError);
                document.body.appendChild(scriptEl);
                return function() {
                    scriptEl.removeEventListener('load', handleLoad);
                    scriptEl.removeEventListener('error', handleError); // if we unmount, and we are still loading the script, then
                    // remove from the DOM & cache so we have a clean slate next time.
                    // this is similar to the `removeOnUnmount` behavior of the TS useScript hook
                    // https://github.com/juliencrn/usehooks-ts/blob/20667273744a22dd2cd2c48c38cd3c10f254ae47/packages/usehooks-ts/src/useScript/useScript.ts#L134
                    // but only applied when loading
                    if (status && status.loading) {
                        scriptEl.remove();
                        delete exports1.scripts[src];
                    }
                }; // we need to ignore the attributes as they're a new object per call, so we'd never skip an effect call
            }, [
                src
            ]);
            return [
                loading,
                error
            ];
        }
        exports1.default = useScript;
        var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    });
    unwrapExports(useScript_1);
    var useScript_2 = useScript_1.scripts;
    var lib = createCommonjsModule(function(module, exports1) {
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        exports1.scripts = exports1.default = void 0;
        Object.defineProperty(exports1, "default", {
            enumerable: true,
            get: function() {
                return __importDefault(useScript_1).default;
            }
        });
        Object.defineProperty(exports1, "scripts", {
            enumerable: true,
            get: function() {
                return useScript_1.scripts;
            }
        });
    });
    var useScript = unwrapExports(lib);
    var lib_1 = lib.scripts;
    var renameKeyInObject = function renameKeyInObject(o, oldKey, newKey) {
        var newObject = {};
        delete Object.assign(newObject, o, _defineProperty({}, newKey, o[oldKey]))[oldKey];
        return newObject;
    };
    /**
   * Wrap link handler creation and instance to clean up iframe via destroy() method
   */ var createPlaidHandler = function createPlaidHandler(config, creator) {
        var state = {
            plaid: null,
            open: false,
            onExitCallback: null
        }; // If Plaid is not available, throw an Error
        if (typeof window === 'undefined' || !window.Plaid) throw new Error('Plaid not loaded');
        state.plaid = creator(_objectSpread2(_objectSpread2({}, config), {}, {
            onExit: function onExit(error, metadata) {
                state.open = false;
                config.onExit && config.onExit(error, metadata);
                state.onExitCallback && state.onExitCallback();
            }
        }));
        var open = function open() {
            if (!state.plaid) return;
            state.open = true;
            state.onExitCallback = null;
            state.plaid.open();
        };
        var submit = function submit(data) {
            if (!state.plaid) return;
            state.plaid.submit(data);
        };
        var exit = function exit(exitOptions, callback) {
            if (!state.open || !state.plaid) {
                callback && callback();
                return;
            }
            state.onExitCallback = callback;
            state.plaid.exit(exitOptions);
            if (exitOptions && exitOptions.force) state.open = false;
        };
        var destroy = function destroy() {
            if (!state.plaid) return;
            state.plaid.destroy();
            state.plaid = null;
        };
        return {
            open: open,
            submit: submit,
            exit: exit,
            destroy: destroy
        };
    };
    var createPlaid = function createPlaid(options, creator) {
        var config = renameKeyInObject(options, 'publicKey', 'key');
        return createPlaidHandler(config, creator);
    };
    var PLAID_LINK_STABLE_URL = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
    var noop = function noop() {};
    /**
   * This hook loads Plaid script and manages the Plaid Link creation for you.
   * You get easy open & exit methods to call and loading & error states.
   *
   * This will destroy the Plaid UI on un-mounting so it's up to you to be
   * graceful to the user.
   *
   * A new Plaid instance is created every time the token and products options change.
   * It's up to you to prevent unnecessary re-creations on re-render.
   */ var usePlaidLink = function usePlaidLink(options) {
        // Asynchronously load the plaid/link/stable url into the DOM
        var _useScript = useScript({
            src: PLAID_LINK_STABLE_URL,
            checkForExisting: true
        }), _useScript2 = _slicedToArray(_useScript, 2), loading = _useScript2[0], error = _useScript2[1]; // internal state
        var _useState = React.useState(null), _useState2 = _slicedToArray(_useState, 2), plaid = _useState2[0], setPlaid = _useState2[1];
        var _useState3 = React.useState(false), _useState4 = _slicedToArray(_useState3, 2), iframeLoaded = _useState4[0], setIframeLoaded = _useState4[1];
        var products = (options.product || []).slice().sort().join(',');
        React.useEffect(function() {
            // If the link.js script is still loading, return prematurely
            if (loading) return;
             // If the token, publicKey, and received redirect URI are undefined, return prematurely
            if (!options.token && !options.publicKey && !options.receivedRedirectUri) return;
            if (error || !window.Plaid) {
                // eslint-disable-next-line no-console
                console.error('Error loading Plaid', error);
                return;
            } // if an old plaid instance exists, destroy it before
            // creating a new one
            if (plaid != null) plaid.exit({
                force: true
            }, function() {
                return plaid.destroy();
            });
            var next = createPlaid(_objectSpread2(_objectSpread2({}, options), {}, {
                onLoad: function onLoad() {
                    setIframeLoaded(true);
                    options.onLoad && options.onLoad();
                }
            }), window.Plaid.create);
            setPlaid(next); // destroy the Plaid iframe factory
            return function() {
                return next.exit({
                    force: true
                }, function() {
                    return next.destroy();
                });
            };
        }, [
            loading,
            error,
            options.publicKey,
            options.token,
            products
        ]);
        var ready = plaid != null && (!loading || iframeLoaded);
        var openNoOp = function openNoOp() {
            if (!options.token) console.warn('react-plaid-link: You cannot call open() without a valid token supplied to usePlaidLink. This is a no-op.');
        };
        return {
            error: error,
            ready: ready,
            submit: plaid ? plaid.submit : noop,
            exit: plaid ? plaid.exit : noop,
            open: plaid ? plaid.open : openNoOp
        };
    };
    var _excluded = [
        "children",
        "style",
        "className"
    ];
    var PlaidLink = function PlaidLink(props) {
        var children = props.children, style = props.style, className = props.className, config = _objectWithoutProperties(props, _excluded);
        var _usePlaidLink = usePlaidLink(_objectSpread2({}, config)), error = _usePlaidLink.error, open = _usePlaidLink.open;
        return /*#__PURE__*/ React__default.createElement("button", {
            disabled: Boolean(error),
            type: "button",
            className: className,
            style: _objectSpread2({
                padding: '6px 4px',
                outline: 'none',
                background: '#FFFFFF',
                border: '2px solid #F1F1F1',
                borderRadius: '4px'
            }, style),
            onClick: function onClick() {
                return open();
            }
        }, children);
    };
    PlaidLink.displayName = 'PlaidLink';
    var PlaidEmbeddedLink = function PlaidEmbeddedLink(props) {
        var style = props.style, className = props.className, onSuccess = props.onSuccess, onExit = props.onExit, onLoad = props.onLoad, onEvent = props.onEvent, token = props.token, receivedRedirectUri = props.receivedRedirectUri;
        var config = React.useMemo(function() {
            return {
                onSuccess: onSuccess,
                onExit: onExit,
                onLoad: onLoad,
                onEvent: onEvent,
                token: token,
                receivedRedirectUri: receivedRedirectUri
            };
        }, [
            onSuccess,
            onExit,
            onLoad,
            onEvent,
            token,
            receivedRedirectUri
        ]); // Asynchronously load the plaid/link/stable url into the DOM
        var _useScript = useScript({
            src: PLAID_LINK_STABLE_URL,
            checkForExisting: true
        }), _useScript2 = _slicedToArray(_useScript, 2), loading = _useScript2[0], error = _useScript2[1];
        var embeddedLinkTarget = React.useRef(null);
        React.useEffect(function() {
            // If the external link JS script is still loading, return prematurely
            if (loading) return;
            if (error || !window.Plaid) {
                // eslint-disable-next-line no-console
                console.error('Error loading Plaid', error);
                return;
            }
            if (config.token == null || config.token == '') {
                console.error('A token is required to initialize embedded Plaid Link');
                return;
            } // The embedded Link interface doesn't use the `usePlaidLink` hook to manage
            // its Plaid Link instance because the embedded Link integration in link-initialize
            // maintains its own handler internally.
            var _window$Plaid$createE = window.Plaid.createEmbedded(_objectSpread2({}, config), embeddedLinkTarget.current), destroy = _window$Plaid$createE.destroy; // Clean up embedded Link component on unmount
            return function() {
                destroy();
            };
        }, [
            loading,
            error,
            config,
            embeddedLinkTarget
        ]);
        return /*#__PURE__*/ React__default.createElement("div", {
            style: style,
            className: className,
            ref: embeddedLinkTarget
        });
    };
    // The following event names are stable and will not be deprecated or changed
    (function(PlaidLinkStableEvent) {
        PlaidLinkStableEvent["OPEN"] = "OPEN";
        PlaidLinkStableEvent["EXIT"] = "EXIT";
        PlaidLinkStableEvent["HANDOFF"] = "HANDOFF";
        PlaidLinkStableEvent["SELECT_INSTITUTION"] = "SELECT_INSTITUTION";
        PlaidLinkStableEvent["ERROR"] = "ERROR";
        PlaidLinkStableEvent["BANK_INCOME_INSIGHTS_COMPLETED"] = "BANK_INCOME_INSIGHTS_COMPLETED";
        PlaidLinkStableEvent["IDENTITY_VERIFICATION_PASS_SESSION"] = "IDENTITY_VERIFICATION_PASS_SESSION";
        PlaidLinkStableEvent["IDENTITY_VERIFICATION_FAIL_SESSION"] = "IDENTITY_VERIFICATION_FAIL_SESSION";
    })(exports1.PlaidLinkStableEvent || (exports1.PlaidLinkStableEvent = {}));
    exports1.PlaidEmbeddedLink = PlaidEmbeddedLink;
    exports1.PlaidLink = PlaidLink;
    exports1.usePlaidLink = usePlaidLink;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});




parcelRequire("acw62");


parcelRequire("acw62");

parcelRequire("acw62");
const $b15fc1f619bb443f$var$CheckFilled = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 400 400",
        height: props.height,
        width: props.width,
        fill: props.fill,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M400,0H0V400H400zM343.083,151.083L193.749,300.416c-4.011,4.011-9.429,6.251-15.083,6.251c-0.491,0-1.003-0.021-1.515-0.043c-6.165-0.448-11.84-3.541-15.552-8.491l-64-85.333c-7.083-9.429-5.163-22.805,4.267-29.867c9.429-7.083,22.805-5.163,29.867,4.267l49.237,65.664l131.947-131.947c8.341-8.341,21.824-8.341,30.165,0C351.424,140.259,351.424,142.741,343.083,151.083z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {})
        ]
    });
};
var $b15fc1f619bb443f$export$2e2bcd8739ae039 = $b15fc1f619bb443f$var$CheckFilled;



parcelRequire("acw62");
const $e1a1cf0ba923e9ad$var$MinusFilled = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        height: props.height,
        width: props.width,
        fill: props.fill,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M0,0V100H100V0H0zM20,43H80V57H20V43z"
            })
        })
    });
};
var $e1a1cf0ba923e9ad$export$2e2bcd8739ae039 = $e1a1cf0ba923e9ad$var$MinusFilled;


const $ad8caa31e29e010a$var$size = '16px';
const $ad8caa31e29e010a$var$iconFill = 'var(--color-primary-foreground)';
const $ad8caa31e29e010a$var$renderValue = (value)=>{
    switch(value){
        case 'minus':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1a1cf0ba923e9ad$export$2e2bcd8739ae039), {
                width: $ad8caa31e29e010a$var$size,
                height: $ad8caa31e29e010a$var$size,
                fill: $ad8caa31e29e010a$var$iconFill
            });
        case 'check':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b15fc1f619bb443f$export$2e2bcd8739ae039), {
                width: $ad8caa31e29e010a$var$size,
                height: $ad8caa31e29e010a$var$size,
                fill: $ad8caa31e29e010a$var$iconFill
            });
        case 'empty':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "size-4 bg-background"
            });
        default:
            (0, $24175cbf70f85c9e$export$2e2bcd8739ae039)(value);
    }
};
const $ad8caa31e29e010a$var$Base = (props)=>{
    const handleChange = (e)=>{
        if (e.shiftKey) props.onShiftClick && props.onShiftClick();
        else props.onClick && props.onClick();
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "size-4 cursor-pointer overflow-hidden rounded-[5px] bg-primary m-0.5 shadow-[0_1px_1px_0_rgb(0_0_0/12%),0_0_0_1px_rgb(64_68_82/16%),0_2px_5px_0_rgb(64_68_82/8%)]",
        onClick: handleChange,
        children: $ad8caa31e29e010a$var$renderValue(props.value)
    });
};
var $ad8caa31e29e010a$export$2e2bcd8739ae039 = $ad8caa31e29e010a$var$Base;


const $93d44a992b7c3d39$var$Checkbox = (props)=>{
    const { value: value, onChange: onChange, onShiftClick: onShiftClick } = props;
    const handleClick = ()=>onChange(!value);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad8caa31e29e010a$export$2e2bcd8739ae039), {
        value: value ? 'check' : 'empty',
        onClick: handleClick,
        onShiftClick: onShiftClick
    });
};
var $93d44a992b7c3d39$export$2e2bcd8739ae039 = $93d44a992b7c3d39$var$Checkbox;



const $04f5a5147fbce204$export$48f6a6ba262cec31 = (props)=>{
    const [step, setStep] = $acw62.useState('product-selection');
    const [transactions, setTransactions] = $acw62.useState(true);
    const [investments, setInvestments] = $acw62.useState(false);
    const [linkToken, setLinkToken] = $acw62.useState(null);
    const [getLinkToken, { loading: linkTokenLoading }] = (0, $ce9d9e524be20f53$export$4d955784ab97d150)();
    const [linkAccount] = (0, $ce9d9e524be20f53$export$ec41e5b1c0d93f43)();
    const selectedProducts = $acw62.useMemo(()=>{
        const products = [];
        if (transactions) products.push('transactions');
        if (investments) products.push('investments');
        return products;
    }, [
        transactions,
        investments
    ]);
    const handleContinue = ()=>{
        getLinkToken({
            variables: {
                env: 'production',
                products: selectedProducts
            }
        }).then((result)=>{
            if (result.data?.createLinkToken) {
                setLinkToken(result.data.createLinkToken);
                setStep('plaid-link');
            }
        });
    };
    const handleBack = ()=>{
        setStep('product-selection');
        setLinkToken(null);
    };
    const handlePlaidSuccess = (publicToken, metadata)=>{
        linkAccount({
            variables: {
                plaidEnvironment: 'production',
                token: publicToken,
                institutionId: metadata.institution?.institution_id,
                institutionName: metadata.institution?.name,
                products: selectedProducts
            }
        }).then(()=>{
            props.onSuccess?.();
            props.onRequestClose();
        });
    };
    const handlePlaidExit = ()=>{
        setStep('product-selection');
        setLinkToken(null);
    };
    if (step === 'product-selection') {
        const canContinue = transactions || investments;
        const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: props.onRequestClose,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    disabled: !canContinue || linkTokenLoading,
                    onClick: handleContinue,
                    children: linkTokenLoading ? 'Loading...' : 'Continue'
                })
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
            onRequestClose: props.onRequestClose,
            header: "Connect account with Plaid",
            footer: footer,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground",
                        children: "Select which Plaid products to authorize for this connection."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex cursor-pointer items-center gap-3",
                                onClick: ()=>setTransactions(!transactions),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93d44a992b7c3d39$export$2e2bcd8739ae039), {
                                        value: transactions,
                                        onChange: setTransactions
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-medium",
                                                children: "Transactions"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-muted-foreground text-sm",
                                                children: "Sync checking, savings, and credit card transactions"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex cursor-pointer items-center gap-3",
                                onClick: ()=>setInvestments(!investments),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93d44a992b7c3d39$export$2e2bcd8739ae039), {
                                        value: investments,
                                        onChange: setInvestments
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-medium",
                                                children: "Investments"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-muted-foreground text-sm",
                                                children: "Sync brokerage, 401k, and IRA account holdings"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
    // Step: plaid-link
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
        variant: "outline",
        onClick: handleBack,
        children: "Back"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: props.onRequestClose,
        header: "Connect account with Plaid",
        footer: footer,
        size: "lg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "h-[500px] w-full",
            children: linkToken && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a36ddd27b352a95$exports.PlaidEmbeddedLink), {
                token: linkToken,
                onSuccess: handlePlaidSuccess,
                onExit: handlePlaidExit,
                style: {
                    height: '100%',
                    width: '100%'
                }
            })
        })
    });
};




/**
 * Active ISO 4217 alphabetic codes — the canonical membership check for
 * currency slots, shared by server validation and the create-account modal.
 *
 * Deliberately NOT Intl.supportedValuesOf('currency'): that enumerates the
 * runtime's ICU locale data, which both lags the registry (Node 22 is
 * missing VED, the funds codes BOV/CHE/CHW/COU/MXV/USN/UYI/UYW, and the
 * X-codes) and keeps withdrawn codes (HRK, CUC, SLL, ZWL) — and it can
 * differ between the browser and the server, so the two would accept
 * different sets. This list is the registry's active table; update it on
 * the rare ISO amendment. Withdrawn since the last audit and therefore
 * absent: HRK (EUR, 2023), CUC (2021), SLL (SLE, 2024), ZWL (ZWG, 2024),
 * ANG (XCG, 2025), BGN (EUR, 2026). Also deliberately absent despite being registry
 * entries: XTS (testing) and XXX (no currency) — neither can denominate a
 * real account.
 */ const $f64be0977ced8873$var$ACTIVE_ISO_4217 = [
    'AED',
    'AFN',
    'ALL',
    'AMD',
    'AOA',
    'ARS',
    'AUD',
    'AWG',
    'AZN',
    'BAM',
    'BBD',
    'BDT',
    'BHD',
    'BIF',
    'BMD',
    'BND',
    'BOB',
    'BOV',
    'BRL',
    'BSD',
    'BTN',
    'BWP',
    'BYN',
    'BZD',
    'CAD',
    'CDF',
    'CHE',
    'CHF',
    'CHW',
    'CLF',
    'CLP',
    'CNY',
    'COP',
    'COU',
    'CRC',
    'CUP',
    'CVE',
    'CZK',
    'DJF',
    'DKK',
    'DOP',
    'DZD',
    'EGP',
    'ERN',
    'ETB',
    'EUR',
    'FJD',
    'FKP',
    'GBP',
    'GEL',
    'GHS',
    'GIP',
    'GMD',
    'GNF',
    'GTQ',
    'GYD',
    'HKD',
    'HNL',
    'HTG',
    'HUF',
    'IDR',
    'ILS',
    'INR',
    'IQD',
    'IRR',
    'ISK',
    'JMD',
    'JOD',
    'JPY',
    'KES',
    'KGS',
    'KHR',
    'KMF',
    'KPW',
    'KRW',
    'KWD',
    'KYD',
    'KZT',
    'LAK',
    'LBP',
    'LKR',
    'LRD',
    'LSL',
    'LYD',
    'MAD',
    'MDL',
    'MGA',
    'MKD',
    'MMK',
    'MNT',
    'MOP',
    'MRU',
    'MUR',
    'MVR',
    'MWK',
    'MXN',
    'MXV',
    'MYR',
    'MZN',
    'NAD',
    'NGN',
    'NIO',
    'NOK',
    'NPR',
    'NZD',
    'OMR',
    'PAB',
    'PEN',
    'PGK',
    'PHP',
    'PKR',
    'PLN',
    'PYG',
    'QAR',
    'RON',
    'RSD',
    'RUB',
    'RWF',
    'SAR',
    'SBD',
    'SCR',
    'SDG',
    'SEK',
    'SGD',
    'SHP',
    'SLE',
    'SOS',
    'SRD',
    'SSP',
    'STN',
    'SVC',
    'SYP',
    'SZL',
    'THB',
    'TJS',
    'TMT',
    'TND',
    'TOP',
    'TRY',
    'TTD',
    'TWD',
    'TZS',
    'UAH',
    'UGX',
    'USD',
    'USN',
    'UYI',
    'UYU',
    'UYW',
    'UZS',
    'VED',
    'VES',
    'VND',
    'VUV',
    'WST',
    'XAF',
    'XAG',
    'XAU',
    'XBA',
    'XBB',
    'XBC',
    'XBD',
    'XCD',
    'XCG',
    'XDR',
    'XOF',
    'XPD',
    'XPF',
    'XPT',
    'XSU',
    'XUA',
    'YER',
    'ZAR',
    'ZMW',
    'ZWG'
];
const $f64be0977ced8873$export$ef5b973501f82a92 = new Set($f64be0977ced8873$var$ACTIVE_ISO_4217);



var $acw62 = parcelRequire("acw62");

const $fb5e51eb75c78804$export$f7dd262aa2367f3d = (store, newAccount)=>{
    const data = store.readQuery({
        query: (0, $ce9d9e524be20f53$export$2f2991a875f1875d)
    });
    const existing = data?.allAccounts;
    if (existing && newAccount) store.writeQuery({
        query: (0, $ce9d9e524be20f53$export$2f2991a875f1875d),
        data: {
            allAccounts: [
                ...existing,
                newAccount
            ]
        }
    });
};








var $acw62 = parcelRequire("acw62");








// The "None" entry is handled by the clear button rather than as a searchable
// row — an empty option in a typeahead list is confusing to scroll past.
const $e7e865dd16cb1aeb$var$SELECTABLE = (0, $cd179cdb1a4beac3$export$e2ad04535ed8af93).filter((option)=>option.value !== '');
const $e7e865dd16cb1aeb$var$RESULT_LIMIT = 60;
const $e7e865dd16cb1aeb$var$labelFor = (value)=>(0, $cd179cdb1a4beac3$export$e2ad04535ed8af93).find((option)=>option.value === value)?.label ?? value;
const $e7e865dd16cb1aeb$export$6b5b4e301fbd3704 = ({ value: value, onChange: onChange, label: label = 'Logo', ariaLabel: ariaLabel, autoFocus: autoFocus, placeholder: placeholder = "Search logos\u2026", disabled: disabled })=>{
    // Stable ids so the input can point at the listbox and the active option.
    const listboxId = $acw62.useId();
    const optionId = (index)=>`${listboxId}-option-${index}`;
    const activeItemRef = $acw62.useRef(null);
    const anchorRef = $acw62.useRef(null);
    const popoverRef = $acw62.useRef(null);
    const focusControlsRef = $acw62.useRef(null);
    const { search: search } = (0, $eefd5dff10250d61$export$bd221a7c56b93941)($e7e865dd16cb1aeb$var$SELECTABLE, [
        'label',
        'value'
    ]);
    // useSearch returns every item verbatim for an empty query, ignoring the Fuse
    // limit, so an untouched picker would mount all 200 options and fetch the
    // whole ~1.6MB logo directory. Cap it here rather than relying on the limit.
    const runSearch = (value)=>value.trim() === '' ? $e7e865dd16cb1aeb$var$SELECTABLE.slice(0, $e7e865dd16cb1aeb$var$RESULT_LIMIT) : search(value, {
            limit: $e7e865dd16cb1aeb$var$RESULT_LIMIT
        });
    const handleSubmit = (state)=>{
        if (state.selection) onChange(state.selection.value);
        // Clear before closing, not after: handleQueryChange also sets isOpen, so
        // resetting the query last would immediately reopen the popover.
        handleQueryChange('');
        closePopover();
        // Tab sets focusDirection and useSearchPopover has already preventDefault-ed
        // the native move, so focus would be stranded on this input unless we move
        // it ourselves. Enter and clicks leave focus alone deliberately — in the
        // settings list each row has its own picker, and jumping to the next row's
        // input after a click would be surprising.
        if (state.focusDirection === 'backward') focusControlsRef.current?.focusBackward();
        else if (state.focusDirection === 'forward') focusControlsRef.current?.focusForward();
    };
    const handleClear = ()=>{
        onChange('');
        handleQueryChange('');
        closePopover();
    };
    const { isOpen: isOpen, query: query, searchResults: searchResults, selectedIndex: selectedIndex, handleKeyDown: handleKeyDown, handleQueryChange: handleQueryChange, openPopover: openPopover, closePopover: closePopover } = (0, $d1427355809f336f$export$3a4682986e19a9b6)({
        initialQuery: '',
        focusControlsRef: focusControlsRef,
        search: runSearch,
        onSubmit: handleSubmit
    });
    $acw62.useLayoutEffect(()=>{
        if (isOpen && anchorRef.current && popoverRef.current) popoverRef.current.style.width = `${anchorRef.current.offsetWidth}px`;
    }, [
        anchorRef.current,
        popoverRef.current,
        isOpen
    ]);
    $acw62.useLayoutEffect(()=>{
        activeItemRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        selectedIndex
    ]);
    const picker = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7ce1c21778619db$export$ef41ebc44b9c1fe4), {
                logo: value,
                className: "size-8",
                alt: value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "relative flex-1",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                    ref: anchorRef,
                    value: query,
                    onChange: handleQueryChange,
                    onClick: openPopover,
                    onFocus: openPopover,
                    onKeyDown: handleKeyDown,
                    autoFocus: autoFocus,
                    selectOnFocus: true,
                    disabled: disabled,
                    "aria-label": ariaLabel ?? (typeof label === 'string' ? label : undefined),
                    // Combobox wiring. The native <select> this replaced announced its
                    // expanded state and active option for free; a bare text input plus
                    // styled divs gives assistive tech nothing, so arrow keys would only
                    // change colours as far as a screen reader is concerned.
                    role: "combobox",
                    "aria-expanded": isOpen,
                    "aria-controls": listboxId,
                    "aria-autocomplete": "list",
                    "aria-activedescendant": isOpen && selectedIndex !== null ? optionId(selectedIndex) : undefined,
                    placeholder: value ? $e7e865dd16cb1aeb$var$labelFor(value) : placeholder
                })
            }),
            value && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                disabled: disabled,
                onClick: handleClear,
                className: "text-muted-foreground hover:text-foreground shrink-0 p-1",
                "aria-label": ariaLabel ? `Clear ${ariaLabel}` : 'Clear logo',
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "size-4"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fa899d90230d1ae$export$5b6b19405a83ff9d), {
                anchorRef: anchorRef,
                anchor: "bottom-left",
                focusControlsRef: focusControlsRef,
                open: isOpen,
                onOutsideClick: closePopover,
                onOutsideFocus: closePopover,
                passThroughOutsideClicks: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$fda2cbba281a800a), {
                    ref: popoverRef,
                    id: listboxId,
                    role: "listbox",
                    children: searchResults.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground px-3 py-2",
                        children: "No logos match"
                    }) : searchResults.map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$ee388116d58b2caf), {
                            id: optionId(index),
                            role: "option",
                            "aria-selected": selectedIndex === index,
                            isSelected: selectedIndex === index,
                            ref: selectedIndex === index ? activeItemRef : null,
                            onClick: ()=>handleSubmit({
                                    query: query,
                                    selection: option
                                }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7ce1c21778619db$export$ef41ebc44b9c1fe4), {
                                        logo: option.value,
                                        className: "size-5"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "truncate",
                                        children: option.label
                                    })
                                ]
                            })
                        }, option.value))
                })
            })
        ]
    });
    return label === null ? picker : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
        label: label,
        children: picker
    });
};





const $2cfc06a8466b0c9a$export$6b46babcc2b5aac3 = (props)=>{
    const formId = $acw62.useId();
    const lockedRole = props.role != null;
    const [role, setRole] = $acw62.useState(props.role ?? 'depository');
    const [createDepositoryAccount, { loading: depositoryLoading }] = (0, $ce9d9e524be20f53$export$9c00ed426f67b5b7)();
    const [createInvestmentAccount, { loading: investmentLoading }] = (0, $ce9d9e524be20f53$export$e242736be31c4ea0)();
    const loading = depositoryLoading || investmentLoading;
    const [name, setName] = $acw62.useState('');
    const [depositoryType, setDepositoryType] = $acw62.useState((0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Checking);
    const [investmentType, setInvestmentType] = $acw62.useState((0, $ce9d9e524be20f53$export$19445fdc19724941).Brokerage);
    const [logo, setLogo] = $acw62.useState('');
    const [trackBalance, setTrackBalance] = $acw62.useState(false);
    // Currency the account is denominated in. Non-USD makes the account a
    // wallet: raws are recorded in this currency and valued in USD through
    // conversion transfers. Two shapes: a 3-letter ISO code (USD, JPY) or a
    // custom unit picked by id — the id is what gets stored as the currency.
    const [currencyMode, setCurrencyMode] = $acw62.useState('code');
    const [currencyCode, setCurrencyCode] = $acw62.useState('USD');
    const [unitId, setUnitId] = $acw62.useState('');
    const { data: unitsData } = (0, $ce9d9e524be20f53$export$20437837b60921de)();
    const units = unitsData?.allUnits ?? [];
    const { createUnitModal: createUnitModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    // Membership, not just shape — the server enforces real ISO 4217 codes
    // (same vendored list, so browser and server can never disagree), so
    // catch the typo ("YEN") at the field instead of at submit.
    const codeValid = (0, $f64be0977ced8873$export$ef5b973501f82a92).has(currencyCode);
    const currency = currencyMode === 'code' ? currencyCode : unitId;
    const currencyValid = currencyMode === 'code' ? codeValid : unitId !== '';
    // The mutation's own loading flag drops as soon as createAccount resolves,
    // which would re-enable submit mid-chain and allow duplicate creates.
    const [submitting, setSubmitting] = $acw62.useState(false);
    const handleDepositoryTypeChange = (e)=>{
        const { value: value } = e.target;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        setDepositoryType(value);
    };
    const handleInvestmentTypeChange = (e)=>{
        const { value: value } = e.target;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        setInvestmentType(value);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        const create = role === 'investment' ? createInvestmentAccount({
            variables: {
                name: name,
                investmentType: investmentType,
                logo: logo || null
            },
            update: (store, result)=>{
                (0, $fb5e51eb75c78804$export$f7dd262aa2367f3d)(store, result?.data?.createInvestmentAccount);
            }
        }).then((result)=>result.data?.createInvestmentAccount._id) : createDepositoryAccount({
            variables: {
                name: name,
                depositoryType: depositoryType,
                logo: logo || null,
                trackBalance: trackBalance,
                currency: currency
            },
            update: (store, result)=>{
                (0, $fb5e51eb75c78804$export$f7dd262aa2367f3d)(store, result?.data?.createDepositoryAccount);
            }
        }).then((result)=>result.data?.createDepositoryAccount._id);
        create.then(()=>{
            props.onCreate?.();
            props.onRequestClose();
        }).finally(()=>{
            setSubmitting(false);
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                disabled: loading || submitting,
                onClick: props.onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                disabled: loading || submitting || name.length === 0 || role === 'depository' && !currencyValid,
                type: "submit",
                form: formId,
                children: "Create Account"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: props.onRequestClose,
        header: lockedRole && role === 'investment' ? 'Create investment account' : 'Create account',
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                !lockedRole && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c57dbaeaea7da703$export$358303cbde861097), {
                    options: [
                        {
                            value: 'depository',
                            label: 'Depository'
                        },
                        {
                            value: 'investment',
                            label: 'Investment'
                        }
                    ],
                    value: role,
                    onChange: setRole
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Name",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        value: name,
                        onChange: setName,
                        autoFocus: true
                    })
                }),
                role === 'depository' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Account type",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        value: depositoryType,
                        onChange: handleDepositoryTypeChange,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Checking,
                                children: "Checking"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Savings,
                                children: "Savings"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard,
                                children: "Credit Card"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Cash,
                                children: "Cash"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Wallet,
                                children: "Wallet"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Loan,
                                children: "Loan"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Ledger,
                                children: "Ledger"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Other,
                                children: "Other"
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Account type",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        value: investmentType,
                        onChange: handleInvestmentTypeChange,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$19445fdc19724941).Brokerage,
                                children: "Brokerage"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$19445fdc19724941)['401K'],
                                children: "401(k)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$19445fdc19724941).Ira,
                                children: "IRA"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$19445fdc19724941).RothIra,
                                children: "Roth IRA"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$19445fdc19724941).Hsa,
                                children: "HSA"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$19445fdc19724941).Education,
                                children: "529 plan"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$19445fdc19724941).Other,
                                children: "Other"
                            })
                        ]
                    })
                }),
                role === 'depository' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Currency",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c57dbaeaea7da703$export$358303cbde861097), {
                                options: [
                                    {
                                        value: 'code',
                                        label: 'Currency code'
                                    },
                                    {
                                        value: 'unit',
                                        label: 'Custom unit'
                                    }
                                ],
                                value: currencyMode,
                                onChange: setCurrencyMode
                            }),
                            currencyMode === 'code' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                        value: currencyCode,
                                        onChange: (value)=>setCurrencyCode(value.toUpperCase()),
                                        placeholder: "USD"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `text-xs ${codeValid ? 'text-muted-foreground' : 'text-destructive'}`,
                                        children: codeValid ? 'Non-USD makes this a wallet: record amounts in this currency, link them to USD with conversion transfers.' : 'Use an ISO currency code (e.g. USD, JPY). For passes, miles, and other non-monetary units, use a custom unit.'
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: unitId,
                                                onChange: (e)=>setUnitId(e.target.value),
                                                className: "flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        children: "Select a unit\u2026"
                                                    }),
                                                    units.map((unit)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: unit._id,
                                                            children: unit.name
                                                        }, unit._id))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                                variant: "outline",
                                                type: "button",
                                                onClick: ()=>createUnitModal.openModal({
                                                        onSuccess: (unit)=>setUnitId(unit._id)
                                                    }),
                                                children: "New unit"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground text-xs",
                                        children: 'For non-monetary wallets \u2014 passes, miles, credits. Amounts render with the unit\'s own labels ("3 passes"), and what they cost is tracked through conversion transfers.'
                                    })
                                ]
                            })
                        ]
                    })
                }),
                role === 'depository' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    className: "flex items-start gap-2 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            className: "mt-0.5",
                            checked: trackBalance,
                            onChange: (e)=>setTrackBalance(e.target.checked)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Track nonzero balance",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground block text-xs",
                                    children: "Shows on the inbox while the balance isn't zero \u2014 gift cards, credits, loans."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7e865dd16cb1aeb$export$6b5b4e301fbd3704), {
                    value: logo,
                    onChange: setLogo
                })
            ]
        })
    });
};









var $acw62 = parcelRequire("acw62");









const $e5d7882e633e6e7d$export$a3ac7176f40fcb07 = [
    {
        key: 'atmWithdrawal',
        label: 'ATM withdrawal',
        accountBinding: 'cashAccount',
        description: 'ATM withdrawal',
        transferType: (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).AccountTransfer,
        appliesTo: (netAmount)=>netAmount < 0
    }
];



// The sources are read-only context, not form fields, so they render as a
// card above the form rather than as InputGroup rows. Descriptions are
// frequently long (raw bank descriptors), so the card wraps them across
// lines instead of letting them run off the modal. With several rows the
// card totals them, since the inverse offsets the net, not any single row.
const $f075cae0ce41bbd8$var$SourceCard = ({ rawTransactions: rawTransactions, net: net })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-muted/40 flex flex-col gap-2 rounded-md border px-3 py-2.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground text-xs font-medium tracking-wide uppercase",
                children: rawTransactions.length === 1 ? 'Source transaction' : 'Source transactions'
            }),
            rawTransactions.map((rawTransaction)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row items-start justify-between gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-foreground min-w-0 flex-1 text-sm break-words",
                                    children: rawTransaction.description
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "shrink-0 text-sm",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                        variant: "plain",
                                        amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(rawTransaction.amount, rawTransaction.currency)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-muted-foreground flex flex-row items-center justify-between gap-3 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c0f56add137aac0$export$42a331aab32dea1), {
                                    account: rawTransaction.account
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "shrink-0 tabular-nums",
                                    children: rawTransaction.date
                                })
                            ]
                        })
                    ]
                }, rawTransaction._id)),
            rawTransactions.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border flex flex-row items-center justify-between gap-3 border-t pt-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground font-medium",
                        children: "Net"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                        variant: "plain",
                        amount: net
                    })
                ]
            })
        ]
    });
const $f075cae0ce41bbd8$export$42312d5e9dcecec6 = (props)=>{
    const formId = $acw62.useId();
    const combineId = $acw62.useId();
    const { onRequestClose: onRequestClose, onCreate: onCreate, rawTransactions: rawTransactions } = props;
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const currency = rawTransactions[0].currency;
    const net = rawTransactions.reduce((sum, r)=>sum + r.amount, 0);
    const inverseAmount = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(-net, currency);
    // The largest leg is the flow's identity (an ATM withdrawal next to its
    // fee refund), so its description seeds the form; the earliest date is
    // when the counterpart actually happened (the withdrawal, not a refund
    // that posted weeks later).
    const primary = rawTransactions.reduce((a, b)=>Math.abs(b.amount) > Math.abs(a.amount) ? b : a);
    const earliestDate = rawTransactions.reduce((a, b)=>b.date < a.date ? b : a).date;
    const [account, setAccount] = $acw62.useState((0, $f8f45ddea4959097$exports.none));
    const [date, setDate] = $acw62.useState($0c0f91b069db95d9$export$6b862160d295c8e(earliestDate));
    const [description, setDescription] = $acw62.useState(primary.description);
    const [combine, setCombine] = $acw62.useState(false);
    const [activePreset, setActivePreset] = $acw62.useState(null);
    const [error, setError] = $acw62.useState(null);
    const { data: bindingsData } = (0, $ce9d9e524be20f53$export$7d26fb86ec9e5950)();
    // Same query AccountSelect runs, so this is served from the cache; used to
    // resolve a preset's bound account id to the fragment the picker holds.
    const { data: accountsData } = (0, $ce9d9e524be20f53$export$cb6e321bdf608ddb)();
    const [createRawTransaction, { loading: creatingRaw }] = (0, $ce9d9e524be20f53$export$44575aef3a6c207)();
    const [createTransaction, { loading: creatingTransfer }] = (0, $ce9d9e524be20f53$export$5694853076d71b4a)();
    const [deleteRawTransactions, { loading: rollingBack }] = (0, $ce9d9e524be20f53$export$d89c4bc38f3faef7)();
    const [setBinding] = (0, $ce9d9e524be20f53$export$cd4833426b480f1a)();
    const loading = creatingRaw || creatingTransfer || rollingBack;
    // Combining consumes each source in full, and the server rejects a raw
    // that already has consumptions — the same rule as "Add to transaction" —
    // as well as any zero-amount raw (nothing to consume), so a zero row in
    // the selection would fail the transfer after the inverse was created.
    const sourcesCombinable = rawTransactions.every((r)=>r.amount !== 0 && (r.remainingAmount ?? r.amount) === r.amount);
    // A foreign transfer must land in ONE account — the cost it carries
    // becomes a single basis lot (validateTransferLegs) — so a positive
    // source leg (a refund) in one account plus the inverse landing in
    // another would be rejected. Gate the combine here instead of letting
    // submit create the raw and roll it back. USD transfers carry no lot and
    // may span destinations freely.
    const positiveDestinations = new Set(rawTransactions.filter((r)=>r.amount > 0).map((r)=>r.account._id));
    account.forEach((selectedAccount)=>{
        if (-net > 0) positiveDestinations.add(selectedAccount._id);
    });
    const foreignSplitDestination = currency !== 'USD' && positiveDestinations.size > 1;
    // The transfer submits no field values, and validateFields rejects a
    // missing required enum field — so with one configured, combining could
    // only fail after the raw was created. This modal deliberately has no
    // field inputs (the full create-transaction flow does); it gates the
    // checkbox instead. Matches the server's rule: only enum fields can be
    // required.
    const { data: fieldsData } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)();
    const requiredFields = (fieldsData?.allFields ?? []).filter((field)=>field.required && field.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum);
    const canCombine = // An unresolved fields query is not a confirmed-empty required set — on
    // a cold cache the combine stays down until AllFields answers, or a
    // fast submit could slip past the gate it exists for.
    fieldsData != null && sourcesCombinable && !foreignSplitDestination && requiredFields.length === 0;
    // The stored checkbox state survives a transient invalid account pick;
    // only what submit actually does must respect the gate.
    const effectiveCombine = combine && canCombine;
    const presets = (0, $e5d7882e633e6e7d$export$a3ac7176f40fcb07).filter((preset)=>preset.appliesTo(net));
    // A preset resolves its bound account from these queries at click time,
    // so it stands down until both have answered — clicking earlier would
    // silently skip the prefill it advertises.
    const presetsReady = bindingsData != null && accountsData != null;
    const applyPreset = (preset)=>{
        setActivePreset(preset);
        const boundId = bindingsData?.bindings.find((binding)=>binding.key === preset.accountBinding)?.entityId;
        const bound = accountsData?.allAccounts.find(// A closed or cross-currency bound account cannot receive the row;
        // leave the picker for the user rather than prefill a doomed choice.
        (candidate)=>candidate._id === boundId && !(0, $e597f4605156a89e$export$881343af68ecca95)(candidate) && candidate.currency === currency);
        if (bound) setAccount((0, $f8f45ddea4959097$exports.some)(bound));
        setDescription(preset.description);
        if (sourcesCombinable) setCombine(true);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        account.forEach((selectedAccount)=>{
            const run = async ()=>{
                setError(null);
                const rawResult = await createRawTransaction({
                    variables: {
                        props: {
                            accountId: selectedAccount._id,
                            amount: -net,
                            currency: currency,
                            date: date.toISODate() ?? '',
                            description: description
                        }
                    }
                });
                const created = rawResult.data?.createRawTransaction;
                if (!created) return;
                if (effectiveCombine) try {
                    await createTransaction({
                        variables: {
                            rawTransactions: [
                                ...rawTransactions.map((r)=>r._id),
                                created._id
                            ],
                            date: date.toISODate() ?? '',
                            description: // The transfer renders its own description as the row title,
                            // so it carries the same one the inverse raw was given.
                            description,
                            transferType: activePreset?.transferType ?? (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).AccountTransfer
                        }
                    });
                } catch (err) {
                    const transferError = err instanceof Error ? err.message : 'Transfer failed';
                    // Roll back the inverse raw so a failed transfer leaves the
                    // target account untouched instead of holding a stray row. The
                    // rollback itself can fail (connectivity loss — or the transfer
                    // actually committed and its response was lost, which makes the
                    // raw consumed and undeletable); surface that state instead of
                    // letting the error escape with the raw silently persisted.
                    try {
                        await deleteRawTransactions({
                            variables: {
                                ids: [
                                    created._id
                                ]
                            }
                        });
                        setError(transferError);
                    } catch  {
                        setError(`${transferError} \u{2014} and the created inverse row could not ` + 'be rolled back. Check the target account before retrying: ' + 'the row may still exist, or the transfer may actually ' + 'have gone through.');
                    }
                    return;
                }
                if (activePreset) {
                    // Remember the preset's account for next time (the same
                    // auto-remember the import modal uses). The flow has already
                    // succeeded, so a failure here is not worth surfacing.
                    const current = bindingsData?.bindings.find((binding)=>binding.key === activePreset.accountBinding)?.entityId;
                    if (current !== selectedAccount._id) setBinding({
                        variables: {
                            key: activePreset.accountBinding,
                            entityId: selectedAccount._id
                        }
                    }).then(()=>{
                        client.cache.evict({
                            fieldName: 'bindings'
                        });
                    }).catch(()=>{});
                }
                onRequestClose();
                onCreate?.({
                    // When combined, the created row is already fully consumed by the
                    // transfer — report it that way so lists don't show a stale
                    // remainder.
                    created: effectiveCombine ? {
                        ...created,
                        remainingAmount: 0
                    } : created,
                    consumedSourceIds: effectiveCombine ? rawTransactions.map((r)=>r._id) : undefined
                });
            };
            run();
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        size: "md",
        header: "Create inverse transaction",
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: onRequestClose,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    type: "submit",
                    disabled: account.isEmpty || loading,
                    form: formId,
                    children: "Create"
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f075cae0ce41bbd8$var$SourceCard, {
                    rawTransactions: rawTransactions,
                    net: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(net, currency)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    id: formId,
                    onSubmit: handleSubmit,
                    className: "flex flex-col gap-2",
                    children: [
                        presets.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                            label: "Shortcuts",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-wrap gap-2",
                                children: presets.map((preset)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                        variant: activePreset?.key === preset.key ? 'primary' : 'outline',
                                        className: "px-3 py-1 text-sm",
                                        disabled: !presetsReady,
                                        onClick: ()=>applyPreset(preset),
                                        children: preset.label
                                    }, preset.key))
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                            label: "Inverse amount",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex h-9 items-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                    variant: "plain",
                                    align: "left",
                                    amount: inverseAmount
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                            label: "Target account",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $295751b0f96fd69d$export$2e2bcd8739ae039), {
                                selectedAccount: account,
                                onSelectAccount: setAccount,
                                currency: currency
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                            label: "Date",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                selectedDate: date,
                                onChange: setDate
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                            label: "Description",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                value: description,
                                onChange: setDescription,
                                placeholder: "Description"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2 pt-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "checkbox",
                                    id: combineId,
                                    checked: effectiveCombine,
                                    disabled: !canCombine,
                                    onChange: (e)=>setCombine(e.target.checked),
                                    className: "h-4 w-4"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: combineId,
                                    className: "text-sm",
                                    children: "Combine into a transfer"
                                })
                            ]
                        }),
                        effectiveCombine && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-muted-foreground text-xs",
                            children: "Consumes the source rows and the inverse into one balanced transfer."
                        }),
                        !sourcesCombinable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-muted-foreground text-xs",
                            children: "Combining requires every source row to be nonzero and fully unallocated."
                        }),
                        foreignSplitDestination && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-muted-foreground text-xs",
                            children: [
                                "A ",
                                currency,
                                " transfer can only land in one account, but this selection's inflow and the target account would be two \u2014 so these rows cannot be combined here."
                            ]
                        }),
                        requiredFields.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-muted-foreground text-xs",
                            children: [
                                "Transfers require the",
                                ' ',
                                requiredFields.map((field)=>`"${field.name}"`).join(', '),
                                ' ',
                                "field, which this dialog cannot collect \u2014 create the inverse here, then combine through Create transaction."
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-destructive text-xs",
                            children: error
                        })
                    ]
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");








const $88365ccb87c7ae27$export$116adcc84ffb3f9e = 'Reconciliation adjustment';
const $88365ccb87c7ae27$export$1b6546e9bce004a5 = (props)=>{
    const formId = $acw62.useId();
    const { onRequestClose: onRequestClose, onCreate: onCreate, defaultAccount: defaultAccount, defaultAccountId: defaultAccountId, defaultAmount: defaultAmount, defaultDate: defaultDate, defaultDescription: defaultDescription, adjustmentForAnchorId: adjustmentForAnchorId } = props;
    const [account, setAccount] = $acw62.useState(defaultAccount ? (0, $f8f45ddea4959097$exports.some)(defaultAccount) : (0, $f8f45ddea4959097$exports.none));
    const { data: accountsData, error: accountsError } = (0, $ce9d9e524be20f53$export$cb6e321bdf608ddb)({
        skip: defaultAccount != null || defaultAccountId == null
    });
    // Apply the id-based default at most once, so a user who clears the
    // account afterwards doesn't have it snap back when the query resolves.
    const defaultApplied = $acw62.useRef(defaultAccount != null);
    $acw62.useEffect(()=>{
        if (defaultApplied.current) return;
        const match = accountsData?.allAccounts.find((a)=>a._id === defaultAccountId);
        if (match) {
            defaultApplied.current = true;
            setAccount((0, $f8f45ddea4959097$exports.some)(match));
        }
    }, [
        accountsData,
        defaultAccountId
    ]);
    const [amount, setAmount] = $acw62.useState(defaultAmount ? (0, $f8f45ddea4959097$exports.some)(defaultAmount) : (0, $f8f45ddea4959097$exports.none));
    const [date, setDate] = $acw62.useState(defaultDate ?? $0c0f91b069db95d9$export$d0bdf45af03a6ea3());
    const [description, setDescription] = $acw62.useState(defaultDescription ?? '');
    const [createRawTransaction, { loading: creatingRaw }] = (0, $ce9d9e524be20f53$export$44575aef3a6c207)();
    const [createTransaction, { loading: consuming }] = (0, $ce9d9e524be20f53$export$5694853076d71b4a)();
    const loading = creatingRaw || consuming;
    // Adjustment mode reads the reconciliationCategory binding to decide the
    // born-allocated consume; the queries are skipped entirely for the plain
    // create-row use of this modal.
    const isAdjustment = adjustmentForAnchorId != null;
    const { data: bindingsData, error: bindingsError } = (0, $ce9d9e524be20f53$export$7d26fb86ec9e5950)({
        skip: !isAdjustment
    });
    const { data: categoriesData, error: categoriesError } = (0, $ce9d9e524be20f53$export$1f9e2535d0d42ab9)({
        skip: !isAdjustment
    });
    const { data: fieldsData, error: fieldsError } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)({
        skip: !isAdjustment
    });
    const boundCategoryId = bindingsData?.bindings.find((binding)=>binding.key === 'reconciliationCategory')?.entityId;
    const adjustmentCategory = categoriesData?.allCategories.find((category)=>category._id === boundCategoryId);
    // The consume submits no field values, and the server rejects a payment
    // missing a required enum field — with one configured, skip the consume
    // and leave the adjustment for manual categorization rather than fail.
    const requiredFields = (fieldsData?.allFields ?? []).filter((field)=>field.required && field.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum);
    const hasRequiredFields = requiredFields.length > 0;
    const willAutoCategorize = isAdjustment && adjustmentCategory != null && !hasRequiredFields;
    // Unresolved config queries are not an empty configuration: submitting
    // before they answer would nondeterministically skip (or half-attempt)
    // the born-allocated consume a configured binding promises. A query is
    // settled once it has data OR a known failure — a failed config fetch
    // falls back to creating the adjustment unallocated (the degradation
    // path) instead of disabling Create forever.
    const settled = (data, error)=>data != null || error != null;
    const adjustmentConfigReady = !isAdjustment || settled(bindingsData, bindingsError) && settled(categoriesData, categoriesError) && settled(fieldsData, fieldsError);
    // Raw transactions are denominated in their account's currency — the
    // amount input follows the selected account (¥ for a JPY wallet).
    const accountCurrency = account.map((a)=>a.currency).getOrElse('USD');
    const maybeArgs = (0, $f8f45ddea4959097$exports.Option).allObject({
        account: account,
        amount: amount
    }).map((obj)=>{
        return {
            accountId: obj.account._id,
            amount: obj.amount.amount,
            currency: obj.account.currency,
            date: date.toISODate(),
            description: description,
            adjustmentForAnchorId: adjustmentForAnchorId
        };
    });
    const [error, setError] = $acw62.useState(null);
    const handleSubmit = (e)=>{
        e.preventDefault();
        maybeArgs.forEach((args)=>{
            const run = async ()=>{
                setError(null);
                let result;
                try {
                    result = await createRawTransaction({
                        variables: {
                            props: args
                        }
                    });
                } catch (err) {
                    setError(err instanceof Error ? err.message : 'Failed to create');
                    return;
                }
                const newTransaction = result.data?.createRawTransaction;
                if (!newTransaction) return;
                let consumed = false;
                if (willAutoCategorize && adjustmentCategory) // Born allocated: consume the adjustment into a categorized
                // payment right away, so it never lands in the inbox. A failure
                // here degrades instead of rolling back — the stamped row is the
                // essential part (the reconcile session needs it), and an
                // unconsumed adjustment is a to-do, not a broken state.
                try {
                    await createTransaction({
                        variables: {
                            rawTransactions: [
                                newTransaction._id
                            ],
                            date: date.toISODate() ?? '',
                            payee: $88365ccb87c7ae27$export$116adcc84ffb3f9e,
                            category: adjustmentCategory.name
                        }
                    });
                    consumed = true;
                } catch  {
                    consumed = false;
                }
                onRequestClose();
                onCreate?.(consumed ? // (previews exist only for fully unallocated rows) — null it
                // so the stale value isn't written back into the cache.
                {
                    ...newTransaction,
                    remainingAmount: 0,
                    homeAmountPreview: null
                } : newTransaction);
            };
            run();
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        size: "md",
        header: 'Create raw transaction',
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: onRequestClose,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    type: "submit",
                    disabled: maybeArgs.isEmpty || loading || !adjustmentConfigReady,
                    form: formId,
                    children: "Create"
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Amount",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                        value: amount,
                        onChange: setAmount,
                        autoFocus: true,
                        currency: accountCurrency
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Account",
                    children: isAdjustment ? // A fix-up belongs to the account whose anchor it closes — the
                    // server rejects any other, so the picker is replaced with the
                    // resolved account rather than offering choices that can only
                    // fail.
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex h-9 items-center",
                        children: account.map((selected)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c0f56add137aac0$export$42a331aab32dea1), {
                                account: selected
                            })).getOrElse(// A failed lookup must not read as an eternal loading
                        // state — the locked picker has no retry of its own, so
                        // say what happened and how to get out.
                        accountsError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-destructive text-sm",
                            children: "Couldn't load the account \u2014 close and try again."
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-muted-foreground text-sm",
                            children: "Loading account\u2026"
                        }))
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $295751b0f96fd69d$export$2e2bcd8739ae039), {
                        selectedAccount: account,
                        onSelectAccount: setAccount
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Date",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                        selectedDate: date,
                        onChange: setDate
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Description",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        value: description,
                        onChange: setDescription,
                        placeholder: "Description"
                    })
                }),
                isAdjustment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-muted-foreground pt-1 text-xs",
                    children: willAutoCategorize && adjustmentCategory ? `Recorded as a reconciliation adjustment and categorized as ` + `"${adjustmentCategory.name}" (payee "${$88365ccb87c7ae27$export$116adcc84ffb3f9e}").` : hasRequiredFields ? `Recorded as a reconciliation adjustment. The required ` + `${requiredFields.map((field)=>`"${field.name}"`).join(', ')} field${requiredFields.length === 1 ? '' : 's'} this dialog cannot collect prevent${requiredFields.length === 1 ? 's' : ''} automatic categorization \u{2014} categorize it from the inbox.` : "Recorded as a reconciliation adjustment. Set a Reconciliation category in Defaults to categorize adjustments automatically."
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-xs",
                    children: error
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");


const $0248a075196eba6a$export$db125e7042e4c220 = (store, payee)=>{
    const data = store.readQuery({
        query: (0, $ce9d9e524be20f53$export$93b6c794bcd86056)
    });
    const payees = data?.allPayees || [];
    if (!payees.find((p)=>p === payee)) store.writeQuery({
        query: (0, $ce9d9e524be20f53$export$93b6c794bcd86056),
        data: {
            allPayees: [
                ...payees,
                payee
            ]
        }
    });
};




/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b20c5205e441d74$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const $7b20c5205e441d74$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-left", $7b20c5205e441d74$export$3efd853dbb351e94);


const $916bd603f3ed4f80$var$formatCents = (cents)=>{
    const dollars = Math.abs(cents) / 100;
    return `$${dollars.toFixed(2)}`;
};
const $916bd603f3ed4f80$var$totalRemaining = (benefit)=>benefit.periods.reduce((sum, p)=>sum + p.remainingAmount, 0);
const $916bd603f3ed4f80$var$totalAmount = (benefit)=>benefit.periods.reduce((sum, p)=>sum + p.amount, 0);
const $916bd603f3ed4f80$export$988ca588b988dbeb = ({ benefit: benefit, feePeriodPayee: feePeriodPayee, onBack: onBack })=>{
    const remaining = $916bd603f3ed4f80$var$totalRemaining(benefit);
    const total = $916bd603f3ed4f80$var$totalAmount(benefit);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border flex items-center gap-3 rounded-md border p-3",
        children: [
            onBack && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onBack,
                className: "text-muted-foreground hover:text-foreground shrink-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                    className: "h-4 w-4"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-w-0 flex-1 flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-sm font-medium",
                        children: benefit.name
                    }),
                    feePeriodPayee && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-xs",
                        children: feePeriodPayee
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-muted-foreground shrink-0 text-xs",
                children: [
                    $916bd603f3ed4f80$var$formatCents(remaining),
                    " / ",
                    $916bd603f3ed4f80$var$formatCents(total)
                ]
            })
        ]
    });
};









var $acw62 = parcelRequire("acw62");







const $1af78646b91168e0$var$optionToString = (option)=>{
    if (typeof option === 'string') return option;
    else return option.value;
};
const $1af78646b91168e0$var$optionKey = (option)=>typeof option === 'string' ? `payee:${option}` : `${option.type}:${option.value}`;
const $1af78646b91168e0$var$renderOption = (option)=>{
    if (typeof option === 'string') return option;
    else if (option.type === 'suggested') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex w-full min-w-0 items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                className: "size-3.5 shrink-0"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "min-w-0 flex-1 truncate",
                children: option.value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground shrink-0 text-xs",
                children: option.detail
            })
        ]
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62bf8c8bfdcf5adc$export$2e2bcd8739ae039), {
                className: "size-4"
            }),
            'Add "',
            option.value,
            '"'
        ]
    });
};
const $1af78646b91168e0$var$PayeeInput = (props)=>{
    const { autoFocus: autoFocus, value: value, onChange: onChange, suggestions: suggestions, adornment: adornment, inputClassName: inputClassName, onEdited: onEdited } = props;
    const activeItemRef = $acw62.useRef(null);
    const anchorRef = $acw62.useRef(null);
    const popoverRef = $acw62.useRef(null);
    const focusControlsRef = $acw62.useRef(null);
    // Submissions move focus out of the FocusTrap, which fires onFocusOutside
    // synchronously before the popover unmounts; this flag stops that from
    // re-committing the raw query over the just-committed selection
    const justSubmittedRef = $acw62.useRef(false);
    const { loading: loading, data: data } = (0, $ce9d9e524be20f53$export$4c1a1d4cb0307c88)();
    const { search: search } = (0, $eefd5dff10250d61$export$bd221a7c56b93941)(data?.allPayees || [], []);
    const handleSearch = (query)=>{
        const q = query.trim().toLowerCase();
        const suggested = (suggestions ?? []).filter((s)=>q === '' || s.name.toLowerCase().includes(q)).map((s)=>({
                type: 'suggested',
                value: s.name,
                detail: s.detail
            }));
        const suggestedNames = new Set(suggested.map($1af78646b91168e0$var$optionToString));
        // useSearch ignores the limit for the empty query (it returns allItems
        // verbatim), and the empty state is now the common open state — cap it
        // here so a large payee history can't stall the popover.
        const results = search(query, {
            limit: 80
        }).filter((name)=>!suggestedNames.has(name)).slice(0, 80);
        const combined = [
            ...suggested,
            ...results
        ];
        // No create row for an empty query — "Add \"\"" is never a real option,
        // and the empty query is now common since the payee no longer prefills.
        if (query.trim() !== '' && !results.includes(query) && !suggestedNames.has(query)) combined.push({
            type: 'create',
            value: query
        });
        return combined;
    };
    const handleSubmit = (state)=>{
        // Picking an option (click, or arrow/Tab selection) is a manual choice
        // just like typing, so it must also drop auto-apply provenance — while
        // a blur/tab-through commit of unchanged text (selection null) is not
        // an edit and must leave it alone.
        if (state.selection !== null) onEdited?.();
        if (state.selection === null) onChange(state.query);
        else onChange($1af78646b91168e0$var$optionToString(state.selection));
        closePopover();
        justSubmittedRef.current = true;
        if (state.focusDirection === 'backward') focusControlsRef.current?.focusBackward();
        else focusControlsRef.current?.focusForward();
    };
    const { isOpen: isOpen, query: query, searchResults: searchResults, selectedIndex: selectedIndex, handleKeyDown: handleKeyDown, handleQueryChange: handleQueryChange, openPopover: openPopover, closePopover: closePopover, clearSelection: clearSelection } = (0, $d1427355809f336f$export$3a4682986e19a9b6)({
        initialQuery: value,
        focusControlsRef: focusControlsRef,
        search: handleSearch,
        onSubmit: handleSubmit,
        // Focusing a filled input is browsing, not typing: suggestions whose
        // names merely contain the current value sort above it, so Tab
        // auto-submitting the first result would silently replace a committed
        // "Amazon" with a suggested "Amazon Marketplace". Only a query the
        // user actually changed auto-submits its top match on Tab.
        autoSubmitFirstOnTab: (query)=>query.trim() !== '' && query.trim() !== value.trim()
    });
    $acw62.useEffect(()=>{
        if (isOpen) justSubmittedRef.current = false;
    }, [
        isOpen
    ]);
    // Suggestions arrive asynchronously and prepend rows without changing the
    // query; an index-based keyboard highlight would silently move to a
    // different option, so drop it when the suggestion set changes.
    $acw62.useEffect(()=>{
        clearSelection();
    }, [
        suggestions,
        clearSelection
    ]);
    // An autofocused mount fires onFocus before the user has done anything;
    // opening the typeahead then covers the fields below the moment the form
    // appears. Swallow that first focus — clicking, typing, or tabbing back
    // in still opens the popover as usual.
    const suppressInitialOpenRef = $acw62.useRef(autoFocus === true);
    const handleFocus = ()=>{
        if (suppressInitialOpenRef.current) {
            suppressInitialOpenRef.current = false;
            return;
        }
        openPopover();
    };
    // Commit typed text when focus leaves the input (outside click/focus),
    // matching the Enter/Tab behavior — otherwise text typed without an
    // explicit selection is silently dropped
    const commitQuery = ()=>{
        if (justSubmittedRef.current) {
            justSubmittedRef.current = false;
            closePopover();
            return;
        }
        onChange(query);
        closePopover();
    };
    $acw62.useLayoutEffect(()=>{
        if (isOpen && anchorRef.current && popoverRef.current) popoverRef.current.style.width = `${anchorRef.current.offsetWidth}px`;
    }, [
        anchorRef.current,
        popoverRef.current,
        isOpen
    ]);
    $acw62.useLayoutEffect(()=>{
        activeItemRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        selectedIndex
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        ref: anchorRef,
                        value: query,
                        onChange: (next)=>{
                            onEdited?.();
                            handleQueryChange(next);
                        },
                        onClick: openPopover,
                        onFocus: handleFocus,
                        onKeyDown: handleKeyDown,
                        autoFocus: autoFocus,
                        selectOnFocus: true,
                        placeholder: "Payee",
                        enterKeyHint: "next",
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(adornment != null && 'pr-20', inputClassName)
                    }),
                    adornment != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute inset-y-0 right-3 flex items-center",
                        children: adornment
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fa899d90230d1ae$export$5b6b19405a83ff9d), {
                anchorRef: anchorRef,
                anchor: "bottom-left",
                focusControlsRef: focusControlsRef,
                open: isOpen,
                onOutsideClick: commitQuery,
                onOutsideFocus: commitQuery,
                passThroughOutsideClicks: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$fda2cbba281a800a), {
                    ref: popoverRef,
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {}) : searchResults.map((result, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$ee388116d58b2caf), {
                            isSelected: selectedIndex === index,
                            ref: selectedIndex === index ? activeItemRef : null,
                            onClick: ()=>handleSubmit({
                                    query: query,
                                    selection: result
                                }),
                            children: $1af78646b91168e0$var$renderOption(result)
                        }, $1af78646b91168e0$var$optionKey(result)))
                })
            })
        ]
    });
};
var $1af78646b91168e0$export$2e2bcd8739ae039 = $1af78646b91168e0$var$PayeeInput;



const $f8be2ffe916cb2b8$export$bc5e0209b4065738 = ({ formId: formId, form: form, onChange: onChange, onSubmit: onSubmit })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        id: formId,
        onSubmit: onSubmit,
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Payee",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1af78646b91168e0$export$2e2bcd8739ae039), {
                    value: form.payee,
                    onChange: onChange('payee')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Description",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                    value: form.description,
                    onChange: onChange('description')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Category",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9eb11e6352514841$export$2e2bcd8739ae039), {
                    selectedCategory: form.category,
                    onSelectCategory: onChange('category')
                })
            })
        ]
    });




const $3351754deccad137$export$b180bbf49db341fd = (props)=>{
    const { benefit: benefit, feePeriodPayee: feePeriodPayee, onSuccess: onSuccess, onRequestClose: onRequestClose } = props;
    const formId = $acw62.useId();
    const [step, setStep] = $acw62.useState({
        type: 'pick-transaction'
    });
    const [selectedRawTransactionId, setSelectedRawTransactionId] = $acw62.useState('');
    const [form, setForm] = $acw62.useState({
        payee: feePeriodPayee ?? benefit.name,
        description: benefit.name,
        category: (0, $f8f45ddea4959097$exports.some)(benefit.category.name)
    });
    const handleChange = (key)=>(value)=>{
            setForm((prev)=>({
                    ...prev,
                    [key]: value
                }));
        };
    const handleRawTransactionChange = (rawTransactionId, transaction)=>{
        setSelectedRawTransactionId(rawTransactionId);
        if (transaction) setStep({
            type: 'form',
            rawTransactionId: rawTransactionId,
            date: (0, $0c0f91b069db95d9$export$6b862160d295c8e)(transaction.date)
        });
    };
    const [createTransaction, { loading: loading }] = (0, $ce9d9e524be20f53$export$5694853076d71b4a)();
    const [linkBenefit] = (0, $ce9d9e524be20f53$export$1d5034815fcbdd74)();
    const canSubmit = step.type === 'form' && !form.category.isEmpty;
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (step.type !== 'form' || !canSubmit) return;
        form.category.forEach((category)=>{
            createTransaction({
                variables: {
                    rawTransactions: [
                        step.rawTransactionId
                    ],
                    date: step.date.toISODate(),
                    payee: form.payee,
                    description: form.description,
                    category: category
                },
                refetchQueries: [
                    {
                        query: (0, $ce9d9e524be20f53$export$57862cdd9be7ef37),
                        variables: {
                            accountId: benefit.accountId
                        }
                    }
                ],
                update: (store, result)=>{
                    const tx = result?.data?.createTransaction;
                    if (tx) {
                        tx.category && (0, $5f9091afcb8d9899$export$8c292b02ce03981f)(store, tx.category);
                        tx.payee && (0, $0248a075196eba6a$export$db125e7042e4c220)(store, tx.payee);
                    }
                }
            }).then(async (response)=>{
                if (response.data) {
                    try {
                        await linkBenefit({
                            variables: {
                                rawTransactionId: step.rawTransactionId,
                                benefitId: benefit._id
                            }
                        });
                    } catch  {
                        onSuccess();
                        setStep({
                            type: 'link-failed'
                        });
                        return;
                    }
                    onSuccess();
                    onRequestClose();
                }
            });
        });
    };
    if (step.type === 'pick-transaction') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Select transaction",
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
            variant: "outline",
            onClick: onRequestClose,
            children: "Cancel"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $916bd603f3ed4f80$export$988ca588b988dbeb), {
                    benefit: benefit,
                    feePeriodPayee: feePeriodPayee
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ab52d2c0e66eec5$export$ff27b476ad9a61f6), {
                    value: selectedRawTransactionId,
                    onChange: handleRawTransactionChange,
                    includeProcessed: false
                })
            ]
        })
    });
    if (step.type === 'link-failed') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Benefit link failed",
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
            variant: "primary",
            onClick: onRequestClose,
            children: "Close"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "text-sm text-destructive",
            children: "The transaction was created, but the benefit could not be linked. You can link it manually from the raw transaction detail view."
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Create transaction with benefit",
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: onRequestClose,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    type: "submit",
                    form: formId,
                    disabled: loading || !canSubmit,
                    children: loading ? 'Creating...' : 'Create'
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $916bd603f3ed4f80$export$988ca588b988dbeb), {
                    benefit: benefit,
                    feePeriodPayee: feePeriodPayee,
                    onBack: ()=>setStep({
                            type: 'pick-transaction'
                        })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8be2ffe916cb2b8$export$bc5e0209b4065738), {
                    formId: formId,
                    form: form,
                    onChange: handleChange,
                    onSubmit: handleSubmit
                })
            ]
        })
    });
};


const $797bee7272dabf5c$export$36dae91202930fc1 = (0, $3351754deccad137$export$b180bbf49db341fd);









/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $beb58fc2118025b6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 18h.01",
            key: "lrp35t"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ],
    [
        "path",
        {
            d: "M16 18h.01",
            key: "kzsmim"
        }
    ]
];
const $beb58fc2118025b6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("calendar-days", $beb58fc2118025b6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $76c2bea761476961$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "9",
            y2: "9",
            key: "4lhtct"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "15",
            y2: "15",
            key: "vyu0kd"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "8",
            y1: "3",
            y2: "21",
            key: "1ggp8o"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "14",
            y1: "3",
            y2: "21",
            key: "weycgp"
        }
    ]
];
const $76c2bea761476961$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("hash", $76c2bea761476961$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $420bac4ddd218a80$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13 21h8",
            key: "1jsn5i"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ],
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ]
];
const $420bac4ddd218a80$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pencil-line", $420bac4ddd218a80$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");






const $d320129055480c52$export$3e5009ed1fce7d58 = (store, newTags)=>{
    const data = store.readQuery({
        query: (0, $ce9d9e524be20f53$export$15db7ce0a4517c9e)
    });
    const tags = data?.allTags || [];
    // One write with every missing tag — a write per tag would rebuild from
    // the same snapshot each time, so each would overwrite the one before it
    // and only the last new tag would survive.
    const seen = new Set(tags.map((t)=>t._id));
    const missing = newTags.filter((newTag)=>{
        if (seen.has(newTag._id)) return false;
        seen.add(newTag._id);
        return true;
    });
    if (missing.length > 0) store.writeQuery({
        query: (0, $ce9d9e524be20f53$export$15db7ce0a4517c9e),
        data: {
            allTags: [
                ...tags,
                ...missing
            ]
        }
    });
};







/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c6e669e1fd7e7ff8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ]
];
const $c6e669e1fd7e7ff8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("rotate-ccw", $c6e669e1fd7e7ff8$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");






/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $703a5bb3ec33b35f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.1 2.182a10 10 0 0 1 3.8 0",
            key: "5ilxe3"
        }
    ],
    [
        "path",
        {
            d: "M13.9 21.818a10 10 0 0 1-3.8 0",
            key: "11zvb9"
        }
    ],
    [
        "path",
        {
            d: "M17.609 3.721a10 10 0 0 1 2.69 2.7",
            key: "1iw5b2"
        }
    ],
    [
        "path",
        {
            d: "M2.182 13.9a10 10 0 0 1 0-3.8",
            key: "c0bmvh"
        }
    ],
    [
        "path",
        {
            d: "M20.279 17.609a10 10 0 0 1-2.7 2.69",
            key: "1ruxm7"
        }
    ],
    [
        "path",
        {
            d: "M21.818 10.1a10 10 0 0 1 0 3.8",
            key: "qkgqxc"
        }
    ],
    [
        "path",
        {
            d: "M3.721 6.391a10 10 0 0 1 2.7-2.69",
            key: "1mcia2"
        }
    ],
    [
        "path",
        {
            d: "M6.391 20.279a10 10 0 0 1-2.69-2.7",
            key: "1fvljs"
        }
    ]
];
const $703a5bb3ec33b35f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-dashed", $703a5bb3ec33b35f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a5d1dc6449205ac$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ]
];
const $8a5d1dc6449205ac$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-dot", $8a5d1dc6449205ac$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
const $549bdb4b32d8167b$var$LONG_PRESS_DURATION = 400;
// How long after a touch interaction ends to keep ignoring the mouse events
// browsers synthesize from it (touchend fires mousedown/mouseup/click).
const $549bdb4b32d8167b$var$SYNTHETIC_MOUSE_SUPPRESS_MS = 700;
const $549bdb4b32d8167b$export$c24ed0104d07eab9 = (onLongPress)=>{
    const pressTimerRef = $acw62.useRef(null);
    const suppressMouseTimerRef = $acw62.useRef(null);
    const triggeredRef = $acw62.useRef(false);
    const suppressMouseRef = $acw62.useRef(false);
    const onLongPressRef = $acw62.useRef(onLongPress);
    onLongPressRef.current = onLongPress;
    const clearPressTimer = $acw62.useCallback(()=>{
        if (pressTimerRef.current !== null) {
            window.clearTimeout(pressTimerRef.current);
            pressTimerRef.current = null;
        }
    }, []);
    $acw62.useEffect(()=>{
        return ()=>{
            clearPressTimer();
            if (suppressMouseTimerRef.current !== null) window.clearTimeout(suppressMouseTimerRef.current);
        };
    }, [
        clearPressTimer
    ]);
    const startPressTimer = $acw62.useCallback(()=>{
        triggeredRef.current = false;
        if (!onLongPressRef.current) return;
        clearPressTimer();
        pressTimerRef.current = window.setTimeout(()=>{
            pressTimerRef.current = null;
            triggeredRef.current = true;
            onLongPressRef.current?.();
        }, $549bdb4b32d8167b$var$LONG_PRESS_DURATION);
    }, [
        clearPressTimer
    ]);
    const handleTouchStart = $acw62.useCallback(()=>{
        suppressMouseRef.current = true;
        if (suppressMouseTimerRef.current !== null) {
            window.clearTimeout(suppressMouseTimerRef.current);
            suppressMouseTimerRef.current = null;
        }
        startPressTimer();
    }, [
        startPressTimer
    ]);
    const handleTouchDone = $acw62.useCallback(()=>{
        clearPressTimer();
        if (suppressMouseTimerRef.current !== null) window.clearTimeout(suppressMouseTimerRef.current);
        suppressMouseTimerRef.current = window.setTimeout(()=>{
            suppressMouseRef.current = false;
            suppressMouseTimerRef.current = null;
        }, $549bdb4b32d8167b$var$SYNTHETIC_MOUSE_SUPPRESS_MS);
    }, [
        clearPressTimer
    ]);
    const handleTouchMove = $acw62.useCallback(()=>{
        clearPressTimer();
    }, [
        clearPressTimer
    ]);
    const handleMouseDown = $acw62.useCallback((event)=>{
        if (suppressMouseRef.current || event.button !== 0) return;
        startPressTimer();
    }, [
        startPressTimer
    ]);
    const handleMouseUp = $acw62.useCallback(()=>{
        if (suppressMouseRef.current) return;
        clearPressTimer();
    }, [
        clearPressTimer
    ]);
    const handleContextMenu = $acw62.useCallback((event)=>{
        if (triggeredRef.current) event.preventDefault();
    }, []);
    const consumeLongPress = $acw62.useCallback(()=>{
        const wasTriggered = triggeredRef.current;
        triggeredRef.current = false;
        return wasTriggered;
    }, []);
    const longPressProps = $acw62.useMemo(()=>({
            onTouchStart: handleTouchStart,
            onTouchEnd: handleTouchDone,
            onTouchCancel: handleTouchDone,
            onTouchMove: handleTouchMove,
            onMouseDown: handleMouseDown,
            onMouseUp: handleMouseUp,
            onMouseLeave: handleMouseUp,
            onContextMenu: handleContextMenu,
            style: {
                WebkitTouchCallout: 'none'
            }
        }), [
        handleTouchStart,
        handleTouchDone,
        handleTouchMove,
        handleMouseDown,
        handleMouseUp,
        handleContextMenu
    ]);
    return {
        longPressProps: longPressProps,
        consumeLongPress: consumeLongPress
    };
};




// Compact status indicator: an icon with a hover tooltip instead of a labeled
// pill. Statuses are exception-only — "done" states (fully allocated,
// reconciled) render nothing, so a caught-up row stays completely clean and
// any icon at all means there is work to do.
const $767675606e144a8e$var$StatusIcon = ({ icon: Icon, label: label, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        title: label,
        "aria-label": label,
        className: "inline-flex items-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
            "aria-hidden": true,
            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-4', className)
        })
    });
// Fixed-size (size-5 sits inside the description's line box) so the copied
// feedback is an icon swap, never a row-height change.
// Selecting takes a hold, so the row answers the hold itself: its background
// fills toward the selection tint over the long-press duration.
const $767675606e144a8e$var$HOLD_FILL = 'active:bg-blue-600/10 active:duration-[400ms] dark:active:bg-blue-400/15';
// A tap this close to the row's left edge (its padding, and the first letters
// of the description) starts selecting, as a long press does: an unmarked
// shortcut to the check column that is not there yet.
const $767675606e144a8e$var$LEADING_EDGE = 44;
const $767675606e144a8e$var$SelectCheck = ({ open: open, selected: selected })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "aria-hidden": true,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex shrink-0 items-center overflow-hidden transition-[width,opacity] duration-200 ease-out motion-reduce:transition-none', open ? 'w-8 opacity-100' : 'w-0 opacity-0'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex size-5 shrink-0 items-center justify-center rounded-full border-[1.5px] transition-[background-color,border-color] duration-150 ease-out motion-reduce:transition-none', selected ? 'border-blue-600 bg-blue-600 text-white dark:border-blue-500 dark:bg-blue-500' : 'border-muted-foreground/60'),
            children: selected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                className: "size-3.5",
                strokeWidth: 3
            })
        })
    });
const $767675606e144a8e$export$d4b7d2b1a88c41ef = ({ text: text })=>{
    const [copied, setCopied] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (!copied) return;
        const timeout = setTimeout(()=>setCopied(false), 1500);
        return ()=>clearTimeout(timeout);
    }, [
        copied
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        title: copied ? 'Copied' : 'Copy description',
        "aria-label": "Copy description",
        onClick: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            // Only report success once the write lands — a denied or
            // unavailable clipboard must not flash "Copied" over nothing.
            navigator.clipboard?.writeText(text).then(()=>setCopied(true), ()=>{});
        },
        className: "text-muted-foreground hover:text-foreground hover:bg-muted-foreground/10 flex size-5 shrink-0 cursor-pointer items-center justify-center rounded",
        children: copied ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
            className: "size-3.5 text-positive"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
            className: "size-3.5"
        })
    });
};
const $767675606e144a8e$var$allocationStatus = (rawTransaction)=>{
    const { amount: amount, remainingAmount: remainingAmount } = rawTransaction;
    if (remainingAmount === 0) return 'allocated';
    // Legacy rows (null remainingAmount) are treated as unallocated, matching
    // the previous "Unprocessed" pill behavior.
    if (remainingAmount === null || remainingAmount === amount) return 'unallocated';
    return 'partial';
};
const $767675606e144a8e$export$e044a1597fe6ccb0 = (props)=>{
    const { rawTransaction: rawTransaction, selected: selected, onClick: onClick, onLongPress: onLongPress, href: href, showProcessedStatus: showProcessedStatus = false, reconciliationChecklist: reconciliationChecklist = false, missedReconciliation: missedReconciliation = false, outsidePeriod: outsidePeriod = false, compact: compact = false, renderAmount: renderAmount, copyDescription: copyDescription = false, rowAction: rowAction, leaving: leaving, selectMode: selectMode } = props;
    const isFuture = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(rawTransaction.date) > (0, $63618293c58b5f80$exports.DateTime).now();
    const isReconciled = Boolean(rawTransaction.reconciliation);
    // USD second line for foreign rows, from the server's draw preview (what
    // allocating this row now would cost).
    const approxHome = rawTransaction.currency !== 'USD' && rawTransaction.homeAmountPreview != null ? (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(rawTransaction.homeAmountPreview, 'USD') : null;
    const { longPressProps: longPressProps, consumeLongPress: consumeLongPress } = (0, $549bdb4b32d8167b$export$c24ed0104d07eab9)(onLongPress);
    const handleClick = $acw62.useCallback((event)=>{
        if (consumeLongPress()) {
            event.preventDefault();
            return;
        }
        if (selectMode === false && onLongPress != null && event.clientX - event.currentTarget.getBoundingClientRect().left < $767675606e144a8e$var$LEADING_EDGE) {
            event.preventDefault();
            onLongPress();
            return;
        }
        onClick?.();
    }, [
        consumeLongPress,
        onClick,
        onLongPress,
        selectMode
    ]);
    const className = (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('box-border w-full select-none', // Only when there is something to reveal — `group` is inherited by every
    // descendant's group-* utilities, so it isn't free to apply everywhere.
    rowAction && 'group', compact ? 'flex items-center gap-x-4 px-4 py-2' : (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('grid items-center gap-x-5 gap-y-1.5', reconciliationChecklist ? '[grid-template-columns:auto_1fr_auto] [grid-template-areas:"check_left_right"]' : '[grid-template-columns:1fr_auto] [grid-template-areas:"left_right""left_right"]', 'px-4 py-3'), 'transition-colors', 'not-last:border-border not-last:border-b', // Blue tint rather than a neutral: rows render both on the white page
    // background and on bg-muted inbox cards, where gray-on-gray selection
    // is invisible.
    selected ? 'bg-blue-600/10 dark:bg-blue-400/15' : (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('hover:bg-muted-foreground/10', selectMode !== undefined && $767675606e144a8e$var$HOLD_FILL), isFuture && 'italic opacity-60', reconciliationChecklist && isReconciled && 'opacity-45', // max-h-0 alone does NOT reach zero. box-border means max-height bounds the
    // border box, but the content box floors at zero, so the used height
    // bottoms out at the padding plus border — ~17px per row, which for a
    // claimed batch is a visible gap that then snaps shut at unmount. The
    // padding and border have to animate to zero too. (not-last: on the border
    // so it beats the not-last:border-b above at equal specificity.)
    //
    // max-h-12 is the open value: comfortably above a compact row's ~37px
    // without so much slack that the collapse looks like it starts late. All of
    // it is attached only when the caller opts in, so no other list picks up a
    // transition on every property.
    leaving !== undefined && 'overflow-hidden transition-all duration-200 ease-out', leaving === false && 'max-h-12', leaving === true && 'pointer-events-none max-h-0 -translate-y-1 py-0 opacity-0 not-last:border-b-0');
    const checklistIcon = reconciliationChecklist && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex w-4 shrink-0 items-center', !compact && '[grid-area:check]'),
        children: isReconciled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($767675606e144a8e$var$StatusIcon, {
            icon: (0, $8240f8fcfc513968$export$2e2bcd8739ae039),
            label: "Reconciled",
            className: "text-positive"
        }) : missedReconciliation ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($767675606e144a8e$var$StatusIcon, {
            icon: (0, $5415d98bde6b29f1$export$2e2bcd8739ae039),
            label: "Missed by reconciliation",
            className: "text-destructive"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "size-4",
            title: "Not yet reconciled",
            "aria-label": "Not yet reconciled"
        })
    });
    const dateClassName = (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-muted-foreground tabular-nums', outsidePeriod && 'italic underline decoration-dotted');
    const dateTitle = outsidePeriod ? 'Outside this period' : undefined;
    const compactContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            checklistIcon,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-foreground min-w-0 flex-1 truncate text-sm",
                title: rawTransaction.description,
                children: rawTransaction.description
            }),
            rawTransaction.benefit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "shrink-0 rounded-full bg-blue-800 px-2 py-0.5 text-[0.7rem] font-semibold text-white dark:bg-blue-600",
                children: rawTransaction.benefit.name
            }),
            rawTransaction.adjustmentForAnchorId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "shrink-0 rounded-full bg-amber-700 px-2 py-0.5 text-[0.7rem] font-semibold text-white dark:bg-amber-600",
                title: "Reconciliation adjustment",
                children: "Adjustment"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "shrink-0 text-sm",
                children: renderAmount ? renderAmount(rawTransaction) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                    amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(rawTransaction.amount, rawTransaction.currency),
                    approx: approxHome
                })
            }),
            rowAction,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(dateClassName, 'w-20 shrink-0 text-right text-xs'),
                title: dateTitle,
                children: (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(rawTransaction.date)
            })
        ]
    });
    const content = compact ? compactContent : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            checklistIcon,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-w-0 items-center [grid-area:left]",
                children: [
                    selectMode !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($767675606e144a8e$var$SelectCheck, {
                        open: selectMode,
                        selected: selected ?? false
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-w-0 flex-1 flex-col gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex min-w-0 items-center gap-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-foreground min-w-0 truncate",
                                        title: rawTransaction.description,
                                        children: rawTransaction.description
                                    }),
                                    copyDescription && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($767675606e144a8e$export$d4b7d2b1a88c41ef, {
                                        text: rawTransaction.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-muted-foreground flex flex-wrap items-center gap-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c0f56add137aac0$export$42a331aab32dea1), {
                                        account: rawTransaction.account
                                    }),
                                    rawTransaction.benefit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "rounded-full bg-blue-800 px-2 py-0.5 text-[0.7rem] font-semibold text-white dark:bg-blue-600",
                                        children: rawTransaction.benefit.name
                                    }),
                                    rawTransaction.adjustmentForAnchorId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "rounded-full bg-amber-700 px-2 py-0.5 text-[0.7rem] font-semibold text-white dark:bg-amber-600",
                                        title: "Reconciliation adjustment",
                                        children: "Adjustment"
                                    }),
                                    showProcessedStatus && (()=>{
                                        switch($767675606e144a8e$var$allocationStatus(rawTransaction)){
                                            case 'allocated':
                                                return null;
                                            case 'partial':
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($767675606e144a8e$var$StatusIcon, {
                                                    icon: (0, $8a5d1dc6449205ac$export$2e2bcd8739ae039),
                                                    label: "Partially allocated",
                                                    className: "text-amber-600 dark:text-amber-500"
                                                });
                                            case 'unallocated':
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($767675606e144a8e$var$StatusIcon, {
                                                    icon: (0, $703a5bb3ec33b35f$export$2e2bcd8739ae039),
                                                    label: "Unallocated",
                                                    className: "text-destructive"
                                                });
                                        }
                                    })()
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-w-0 flex-col items-end justify-center gap-1 pl-3 text-right [grid-area:right]",
                children: [
                    renderAmount ? renderAmount(rawTransaction) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                        amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(rawTransaction.amount, rawTransaction.currency),
                        approx: approxHome
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: dateClassName,
                        title: dateTitle,
                        children: (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(rawTransaction.date)
                    })
                ]
            })
        ]
    });
    const commonProps = {
        ...longPressProps,
        onClick: handleClick
    };
    if (href) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
        to: href,
        className: className,
        ...commonProps,
        children: content
    });
    // A row that acts on tap without being a link still takes the keyboard:
    // focusable, and Enter or Space does what a tap does.
    const keyboardProps = onClick ? {
        role: 'button',
        tabIndex: 0,
        onKeyDown: (event)=>{
            if (event.target !== event.currentTarget) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            onClick();
        }
    } : {};
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(className, onClick && 'focus-visible:outline-ring focus-visible:outline-2 focus-visible:-outline-offset-2'),
        ...commonProps,
        ...keyboardProps,
        children: content
    });
};


const $5474523a6079f1bc$var$MAIN = 'main';
const $5474523a6079f1bc$var$SLIDE = {
    duration: 0.26,
    ease: [
        0.2,
        0.8,
        0.2,
        1
    ]
};
const $5474523a6079f1bc$export$26da3dced10d02f0 = ({ screen: screen, main: main, renderScreen: renderScreen })=>{
    // Each screen's height, by key, so the sheet can follow whichever is in
    // view. Keyed rather than "the latest to mount": a screen that's left and
    // then returned to mid-slide is the same element coming back, not a new
    // one, and a screen that has gone reports no height worth following.
    const [heights, setHeights] = $acw62.useState({});
    const observer = $acw62.useMemo(()=>new ResizeObserver((entries)=>{
            setHeights((prev)=>{
                const next = {
                    ...prev
                };
                for (const entry of entries){
                    const node = entry.target;
                    if (node instanceof HTMLElement && node.isConnected && node.dataset.screen != null) next[node.dataset.screen] = node.offsetHeight;
                }
                return next;
            });
        }), []);
    $acw62.useEffect(()=>()=>observer.disconnect(), [
        observer
    ]);
    const observe = $acw62.useCallback((node)=>{
        if (node != null) observer.observe(node);
    }, [
        observer
    ]);
    const height = heights[screen ?? $5474523a6079f1bc$var$MAIN];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
        initial: false,
        animate: {
            height: height ?? 'auto'
        },
        transition: $5474523a6079f1bc$var$SLIDE,
        // Clipped, not hidden: a hidden overflow is still a scroll container,
        // and focusing a screen's search box would scroll it sideways.
        className: "overflow-clip",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "grid items-start [&>*]:[grid-area:1/1]",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                initial: false,
                children: screen == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                    ref: observe,
                    "data-screen": $5474523a6079f1bc$var$MAIN,
                    initial: {
                        x: '-18%',
                        opacity: 0.6
                    },
                    animate: {
                        x: 0,
                        opacity: 1
                    },
                    exit: {
                        x: '-18%',
                        opacity: 0.6
                    },
                    transition: $5474523a6079f1bc$var$SLIDE,
                    className: "bg-background z-0",
                    children: main
                }, $5474523a6079f1bc$var$MAIN) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                    ref: observe,
                    "data-screen": screen,
                    initial: {
                        x: '100%'
                    },
                    animate: {
                        x: 0
                    },
                    exit: {
                        x: '100%'
                    },
                    transition: $5474523a6079f1bc$var$SLIDE,
                    className: "bg-background z-10",
                    children: renderScreen(screen)
                }, screen)
            })
        })
    });
};
const $5474523a6079f1bc$export$5b7eb98d0fc5016b = ({ title: title, onBack: onBack, trailing: trailing, children: children })=>// A floor on the height, so a short screen (tags and fields) doesn't make
    // the sheet drop out from under the finger that opened it.
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex min-h-[50dvh] flex-col gap-3 sm:min-h-80",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border grid grid-cols-[1fr_auto_1fr] items-center border-b pb-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onBack,
                        className: "flex cursor-pointer items-center gap-0.5 justify-self-start text-sm text-blue-600 dark:text-blue-400",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                className: "size-4"
                            }),
                            "Back"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "justify-self-end",
                        children: trailing
                    })
                ]
            }),
            children
        ]
    });
const $5474523a6079f1bc$export$17b64a9acc653c87 = ({ onClick: onClick, leading: leading, label: label, detail: detail, selected: selected, suggested: suggested })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: onClick,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('hover:bg-muted flex w-full cursor-pointer items-center gap-3 px-3 py-2.5 text-left', selected && 'bg-muted'),
        children: [
            leading,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "min-w-0 flex-1 truncate",
                children: label
            }),
            suggested && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                className: "size-3.5 shrink-0 text-positive"
            }),
            detail != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground shrink-0 text-xs tabular-nums",
                children: detail
            }),
            selected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                className: "size-4 shrink-0 text-blue-600 dark:text-blue-400"
            })
        ]
    });
const $5474523a6079f1bc$export$f94f96c749c6beb1 = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border-border divide-border overflow-hidden rounded-xl border [&>*+*]:border-t",
        children: children
    });
const $5474523a6079f1bc$export$ebd8ead8a40ba458 = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground px-1 text-xs font-semibold tracking-wider uppercase",
        children: children
    });
const $5474523a6079f1bc$export$b25f334b2bd41010 = ({ icon: icon, onClick: onClick, open: open, children: children, toScreen: toScreen = false, wrap: wrap = false })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: onClick,
        "aria-expanded": toScreen ? undefined : open,
        className: "flex w-full cursor-pointer items-center gap-3 py-3 text-left",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground flex w-5 shrink-0 justify-center [&>svg]:size-4",
                children: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex min-w-0 flex-1 items-center gap-1.5', wrap ? 'flex-wrap' : 'overflow-hidden'),
                children: children
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-4 shrink-0 text-blue-600 transition-transform duration-200 dark:text-blue-400', open && 'rotate-90')
            })
        ]
    });
const $5474523a6079f1bc$export$c444937f05de96f3 = ({ icon: icon, value: value, onChange: onChange, placeholder: placeholder, onFocus: onFocus })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex w-full cursor-text items-center gap-3 py-3', // The field has no box of its own, so focus marks the line: a bar in
        // the text inputs' ring color along its foot (inset — the sheet clips
        // anything drawn past the lines' edges).
        'has-[input:focus-visible]:shadow-[inset_0_-2px_0_var(--ring)]'),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground flex w-5 shrink-0 justify-center [&>svg]:size-4",
                children: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                value: value,
                onChange: (event)=>onChange(event.target.value),
                onFocus: onFocus,
                placeholder: placeholder,
                onKeyDown: (event)=>{
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        event.currentTarget.blur();
                    }
                },
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('placeholder:text-muted-foreground min-w-0 flex-1 bg-transparent outline-none placeholder:font-normal', $5474523a6079f1bc$export$86f1a7fa7c9640cb(value !== ''))
            })
        ]
    });
const $5474523a6079f1bc$export$49bd1dfb0ad29c40 = ({ open: open, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        initial: false,
        children: open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            initial: {
                height: 0,
                opacity: 0
            },
            animate: {
                height: 'auto',
                opacity: 1
            },
            exit: {
                height: 0,
                opacity: 0
            },
            transition: {
                duration: 0.22,
                ease: [
                    0.2,
                    0.8,
                    0.2,
                    1
                ]
            },
            className: "overflow-hidden",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pb-3",
                children: children
            })
        })
    });
const $5474523a6079f1bc$export$86f1a7fa7c9640cb = (entered)=>entered ? 'text-foreground font-semibold' : 'text-muted-foreground';
const $5474523a6079f1bc$export$ae48ab4d12d567be = ({ detail: detail })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "inline-flex shrink-0 items-center gap-1 text-xs font-semibold text-positive",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                className: "size-3"
            }),
            detail
        ]
    });
const $5474523a6079f1bc$export$8be0d3de9c92b14f = ()=>{
    const { data: data } = (0, $ce9d9e524be20f53$export$1b5dafb855b1a431)();
    return $acw62.useMemo(()=>new Map((data?.payeesWithLogos ?? []).flatMap((p)=>p.logo != null ? [
                [
                    p.payee,
                    p.logo
                ]
            ] : [])), [
        data
    ]);
};
const $5474523a6079f1bc$export$a0afa665fb89834 = ({ name: name, logo: logo, className: className = 'size-10 rounded-xl text-base' })=>logo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7ce1c21778619db$export$ef41ebc44b9c1fe4), {
        logo: logo,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('shadow-[0_0_0_1px_var(--border)]', className),
        rounded: ""
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "aria-hidden": true,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex shrink-0 items-center justify-center font-bold', name.trim() === '' ? 'bg-muted text-muted-foreground' : (0, $3076b7ee20dc9ec8$export$ad7a0cd51bd1ba13)[(0, $3076b7ee20dc9ec8$export$1185a41b8d33b6b8)(name)], className),
        children: name.trim() === '' ? '?' : name.trim()[0].toUpperCase()
    });
const $5474523a6079f1bc$export$98a92a03d6411c29 = ({ onClick: onClick, leading: leading, children: children, fixed: fixed = false })=>{
    const className = 'bg-muted/60 border-border inline-flex min-w-0 max-w-full items-center gap-2 justify-self-start rounded-full border py-1.5 pr-3 pl-2 text-[15px]';
    if (fixed) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: className,
        children: [
            leading,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "min-w-0 truncate font-semibold",
                children: children
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: onClick,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(className, 'cursor-pointer'),
        children: [
            leading,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "flex min-w-0 items-center gap-1.5 truncate",
                children: children
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                className: "size-3.5 shrink-0 text-blue-600 dark:text-blue-400"
            })
        ]
    });
};
const $5474523a6079f1bc$export$8c257576c1ad093f = ({ description: description, account: account, date: date, display: display, partial: partial, detail: detail, error: error, editor: editor, onOpen: onOpen, onCancel: onCancel, onReset: onReset })=>{
    const [editing, setEditing] = $acw62.useState(false);
    const boxRef = $acw62.useRef(null);
    const open = editing || error != null;
    const finish = ()=>setEditing(false);
    // Opening selects the amount, so typing replaces it rather than adding to it.
    $acw62.useEffect(()=>{
        if (editing) boxRef.current?.querySelector('input')?.select();
    }, [
        editing
    ]);
    const amountButton = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        onClick: ()=>{
            onOpen();
            setEditing(true);
        },
        "aria-expanded": false,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('cursor-pointer border-b border-dashed border-blue-600/60 text-right tabular-nums dark:border-blue-400/60', partial ? 'text-foreground font-semibold' : 'text-muted-foreground'),
        children: display
    });
    const fade = {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.15
        }
    };
    return(// The editor takes over the line's own row — the descriptor isn't needed
    // while choosing how much of it to use — so the row keeps its height and
    // nothing below it moves.
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "grid min-h-[3.75rem] px-3 py-2.5 [&>*]:[grid-area:1/1]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
            initial: false,
            children: open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                ...fade,
                ref: boxRef,
                className: "flex flex-col gap-1",
                onKeyDown: (event)=>{
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        finish();
                    }
                    if (event.key === 'Escape') {
                        event.preventDefault();
                        event.stopPropagation();
                        onCancel();
                        finish();
                    }
                },
                onBlur: (event)=>{
                    if (!boxRef.current?.contains(event.relatedTarget)) finish();
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "min-w-0 flex-1",
                                children: editor()
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                title: "Use the whole line",
                                "aria-label": "Use the whole line",
                                onClick: ()=>{
                                    onReset();
                                    finish();
                                },
                                className: "bg-muted flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-lg",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6e669e1fd7e7ff8$export$2e2bcd8739ae039), {
                                    className: "size-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: finish,
                                className: "h-9 shrink-0 cursor-pointer rounded-lg bg-blue-600 px-3 text-sm font-semibold text-white dark:bg-blue-500",
                                children: "Done"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between gap-3 text-xs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: error != null ? 'text-destructive' : 'text-muted-foreground',
                                children: error ?? detail
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: date
                            })
                        ]
                    })
                ]
            }, "edit") : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                ...fade,
                className: "grid grid-cols-[minmax(0,1fr)_auto] items-center gap-x-3 gap-y-0.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex min-w-0 items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "truncate",
                                title: description,
                                children: description
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $767675606e144a8e$export$d4b7d2b1a88c41ef), {
                                text: description
                            })
                        ]
                    }),
                    amountButton,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground flex min-w-0 items-center gap-1.5 text-sm",
                        children: account
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-right text-sm",
                        children: date
                    })
                ]
            }, "line")
        })
    }));
};




/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e583651be68dae50$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 3 4 7l4 4",
            key: "9rb6wj"
        }
    ],
    [
        "path",
        {
            d: "M4 7h16",
            key: "6tx8e3"
        }
    ],
    [
        "path",
        {
            d: "m16 21 4-4-4-4",
            key: "siv7j2"
        }
    ],
    [
        "path",
        {
            d: "M20 17H4",
            key: "h6l3hr"
        }
    ]
];
const $e583651be68dae50$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-left-right", $e583651be68dae50$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $960851586a15b7fa$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8",
            key: "1h4pet"
        }
    ],
    [
        "path",
        {
            d: "M12 18V6",
            key: "zqpxq5"
        }
    ]
];
const $960851586a15b7fa$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-dollar-sign", $960851586a15b7fa$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a800148d042d893$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $8a800148d042d893$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("refresh-cw", $8a800148d042d893$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ddb0f78d8b840c54$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
            key: "qn84l0"
        }
    ],
    [
        "path",
        {
            d: "M13 5v2",
            key: "dyzc3o"
        }
    ],
    [
        "path",
        {
            d: "M13 17v2",
            key: "1ont0d"
        }
    ],
    [
        "path",
        {
            d: "M13 11v2",
            key: "1wjjxi"
        }
    ]
];
const $ddb0f78d8b840c54$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ticket", $ddb0f78d8b840c54$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $10875ae52ac5df60$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 14 4 9l5-5",
            key: "102s5s"
        }
    ],
    [
        "path",
        {
            d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11",
            key: "f3b9sd"
        }
    ]
];
const $10875ae52ac5df60$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("undo-2", $10875ae52ac5df60$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");




// A screen lists at most this many rows before search has to narrow it.
const $de7a15ad94ac6a08$var$BROWSE_LIMIT = 60;
const $de7a15ad94ac6a08$var$matches = (name, query)=>name.toLowerCase().includes(query.trim().toLowerCase());
const $de7a15ad94ac6a08$export$ac7b0e68191845f3 = ({ title: title, value: value, suggested: suggested, logos: logos, onPick: onPick, onClear: onClear, onBack: onBack })=>{
    const [query, setQuery] = $acw62.useState('');
    const { data: data } = (0, $ce9d9e524be20f53$export$4c1a1d4cb0307c88)();
    const all = data?.allPayees ?? [];
    const trimmed = query.trim();
    const hits = all.filter((p)=>$de7a15ad94ac6a08$var$matches(p, query)).slice(0, $de7a15ad94ac6a08$var$BROWSE_LIMIT);
    const isNew = trimmed !== '' && !all.some((p)=>p.toLowerCase() === trimmed.toLowerCase());
    const row = (name, detail)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$17b64a9acc653c87), {
            onClick: ()=>onPick(name),
            leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$a0afa665fb89834), {
                name: name,
                logo: logos.get(name),
                className: "size-7 rounded-lg text-xs"
            }),
            label: name,
            detail: detail,
            selected: name === value,
            suggested: detail != null
        }, name);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5474523a6079f1bc$export$5b7eb98d0fc5016b), {
        title: title,
        onBack: onBack,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                autoFocus: true,
                placeholder: "Search payees",
                value: query,
                onChange: setQuery
            }),
            onClear != null && trimmed === '' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$f94f96c749c6beb1), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$17b64a9acc653c87), {
                    onClick: onClear,
                    leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                        className: "text-muted-foreground size-4"
                    }),
                    label: "No payee"
                })
            }),
            isNew && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$f94f96c749c6beb1), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$17b64a9acc653c87), {
                    onClick: ()=>onPick(trimmed),
                    leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62bf8c8bfdcf5adc$export$2e2bcd8739ae039), {
                        className: "text-muted-foreground size-4"
                    }),
                    label: `New payee \u{201C}${trimmed}\u{201D}`
                })
            }),
            trimmed === '' && suggested.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$ebd8ead8a40ba458), {
                        children: "This merchant"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$f94f96c749c6beb1), {
                        children: suggested.map((s)=>row(s.name, s.detail))
                    })
                ]
            }),
            hits.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$ebd8ead8a40ba458), {
                        children: trimmed === '' ? 'All payees' : 'Matching'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$f94f96c749c6beb1), {
                        children: hits.map((p)=>row(p))
                    })
                ]
            })
        ]
    });
};
const $de7a15ad94ac6a08$export$915de2b652348ee = ({ value: value, suggested: suggested, onPick: onPick, onBack: onBack })=>{
    const [query, setQuery] = $acw62.useState('');
    const { data: data } = (0, $ce9d9e524be20f53$export$1f9e2535d0d42ab9)();
    const { data: groupsData } = (0, $ce9d9e524be20f53$export$9dda77d697c51272)();
    const categories = data?.allCategories ?? [];
    const byName = new Map(categories.map((c)=>[
            c.name,
            c
        ]));
    const trimmed = query.trim();
    const sections = $acw62.useMemo(()=>{
        const groups = groupsData?.allCategoryGroups ?? [];
        const byId = new Map(categories.map((c)=>[
                c._id,
                c
            ]));
        const grouped = new Set(groups.flatMap((g)=>g.categoryIds));
        const out = groups.map((g)=>({
                key: g._id,
                label: g.name,
                names: g.categoryIds.flatMap((id)=>{
                    const c = byId.get(id);
                    return c ? [
                        c.name
                    ] : [];
                })
            })).filter((s)=>s.names.length > 0);
        const rest = categories.filter((c)=>!grouped.has(c._id)).map((c)=>c.name).sort((a, b)=>a.localeCompare(b));
        if (rest.length > 0) out.push({
            key: '__rest__',
            label: out.length > 0 ? 'Ungrouped' : 'All categories',
            names: rest
        });
        return out;
    }, [
        categories,
        groupsData
    ]);
    const row = (name, detail)=>{
        const category = byName.get(name) ?? {
            name: name
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$17b64a9acc653c87), {
            onClick: ()=>onPick(name),
            leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6080e81c2b9604e9$export$bde99f6bf04aeea3), {
                category: category,
                className: "size-7 rounded-lg max-md:size-7"
            }),
            label: name,
            detail: detail,
            selected: name === value,
            suggested: detail != null
        }, name);
    };
    const hits = categories.filter((c)=>$de7a15ad94ac6a08$var$matches(c.name, query)).map((c)=>c.name);
    const isNew = trimmed !== '' && !categories.some((c)=>c.name.toLowerCase() === trimmed.toLowerCase());
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5474523a6079f1bc$export$5b7eb98d0fc5016b), {
        title: "Category",
        onBack: onBack,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                autoFocus: true,
                placeholder: `Search ${categories.length} categories`,
                value: query,
                onChange: setQuery
            }),
            trimmed !== '' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    isNew && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$f94f96c749c6beb1), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$17b64a9acc653c87), {
                            onClick: ()=>onPick(trimmed),
                            leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62bf8c8bfdcf5adc$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-4"
                            }),
                            label: `Add \u{201C}${trimmed}\u{201D}`
                        })
                    }),
                    hits.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$f94f96c749c6beb1), {
                        children: hits.slice(0, $de7a15ad94ac6a08$var$BROWSE_LIMIT).map((n)=>row(n))
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    suggested.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$ebd8ead8a40ba458), {
                                children: "This merchant"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$f94f96c749c6beb1), {
                                children: suggested.map((s)=>row(s.name, s.detail))
                            })
                        ]
                    }),
                    sections.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$ebd8ead8a40ba458), {
                                    children: s.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$f94f96c749c6beb1), {
                                    children: s.names.map((n)=>row(n))
                                })
                            ]
                        }, s.key))
                ]
            })
        ]
    });
};
const $de7a15ad94ac6a08$export$43056c6a412874af = {
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).CreditCardPayment]: (0, $1299b0a605d22052$export$2e2bcd8739ae039),
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).AccountTransfer]: (0, $e583651be68dae50$export$2e2bcd8739ae039),
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Prepaid]: (0, $ddb0f78d8b840c54$export$2e2bcd8739ae039),
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Refund]: (0, $10875ae52ac5df60$export$2e2bcd8739ae039),
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Reimbursement]: (0, $07139920b5ad0ce2$export$2e2bcd8739ae039),
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion]: (0, $8a800148d042d893$export$2e2bcd8739ae039)
};
const $de7a15ad94ac6a08$export$f7121fe80f407126 = ({ type: type, className: className = 'size-6' })=>{
    const Icon = type != null ? $de7a15ad94ac6a08$export$43056c6a412874af[type] : (0, $960851586a15b7fa$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "aria-hidden": true,
        className: `flex shrink-0 items-center justify-center rounded-md bg-indigo-500/15 text-indigo-700 dark:text-indigo-300 ${className}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
            className: "size-[60%]"
        })
    });
};
const $de7a15ad94ac6a08$export$9af25aa19ef1c6c9 = ({ value: value, suggested: suggested, onPick: onPick, onBack: onBack })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$5b7eb98d0fc5016b), {
        title: "Transfer type",
        onBack: onBack,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$f94f96c749c6beb1), {
            children: Object.values((0, $ce9d9e524be20f53$export$1b5eb083c754a86b)).filter((t)=>t !== (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion).map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$17b64a9acc653c87), {
                    onClick: ()=>onPick(t),
                    leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($de7a15ad94ac6a08$export$f7121fe80f407126, {
                        type: t,
                        className: "size-7 rounded-lg"
                    }),
                    label: (0, $d906535d40bd11c1$export$e5f08023f111098c)[t],
                    selected: t === value,
                    suggested: t === suggested
                }, t))
        })
    });






const $ec1c2b802b5e2c50$var$BANK_ACCOUNT_TYPES = [
    (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Checking,
    (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Savings
];
const $ec1c2b802b5e2c50$export$757f96e788c1c6eb = (transferLegs)=>{
    // Only simple two-leg transfers, one leg per account. With 3+ legs the
    // extras (fees, partial refunds) make the grouping ambiguous, and a
    // same-account pair could be anything.
    if (transferLegs.length !== 2) return null;
    if (transferLegs[0].account._id === transferLegs[1].account._id) return null;
    // Legs that don't net to zero aren't a transfer at all.
    if (transferLegs[0].amount + transferLegs[1].amount !== 0) return null;
    const legs = transferLegs.map((leg)=>({
            amount: leg.amount,
            type: leg.account.__typename === 'DepositoryAccount' ? leg.account.depositoryType : null
        }));
    // credit_card_payment: the bank leg pays out, the card leg pays down. The
    // direction is what separates it from a cash advance or a reversal.
    const cardPaidDown = legs.some((leg)=>leg.type === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard && leg.amount > 0);
    const bankPaidOut = legs.some((leg)=>leg.type != null && $ec1c2b802b5e2c50$var$BANK_ACCOUNT_TYPES.includes(leg.type) && leg.amount < 0);
    return cardPaidDown && bankPaidOut ? (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).CreditCardPayment : null;
};






var $acw62 = parcelRequire("acw62");
const $ef8f85bfb532ef83$export$de8d9585272b1a20 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        ref: ref,
        type: "button",
        onClick: (e)=>{
            e.stopPropagation();
            props.onClick();
        },
        className: "border-input text-muted-foreground hover:border-ring hover:text-foreground inline-flex h-6 shrink-0 cursor-pointer items-center gap-1.5 rounded-full border border-dashed px-2.5 text-xs transition",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "inline-flex [&>svg]:size-3",
                children: props.icon
            }),
            "+",
            ' ',
            props.label
        ]
    }));
const $ef8f85bfb532ef83$export$859f88f9f4d77ffe = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "bg-primary/10 text-primary inline-flex h-6 max-w-full min-w-0 items-center gap-1.5 rounded-full px-2.5 text-xs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "inline-flex shrink-0 [&>svg]:size-3",
                children: props.icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "truncate font-medium",
                children: props.label
            }),
            props.detail && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-primary/70 shrink-0",
                children: props.detail
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: (e)=>{
                    e.stopPropagation();
                    props.onRemove();
                },
                className: "hover:bg-primary/20 ml-0.5 shrink-0 cursor-pointer rounded",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "h-3 w-3"
                })
            })
        ]
    });





/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3a075d7302e2a23e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 5h13",
            key: "1pao27"
        }
    ],
    [
        "path",
        {
            d: "M13 12h8",
            key: "h98zly"
        }
    ],
    [
        "path",
        {
            d: "M13 19h8",
            key: "c3s6r1"
        }
    ],
    [
        "path",
        {
            d: "M3 10a2 2 0 0 0 2 2h3",
            key: "1npucw"
        }
    ],
    [
        "path",
        {
            d: "M3 5v12a2 2 0 0 0 2 2h3",
            key: "x1gjn2"
        }
    ]
];
const $3a075d7302e2a23e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("list-tree", $3a075d7302e2a23e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $39c065d00fa604c6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 4v16",
            key: "1654pz"
        }
    ],
    [
        "path",
        {
            d: "M4 7V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2",
            key: "e0r10z"
        }
    ],
    [
        "path",
        {
            d: "M9 20h6",
            key: "s66wpe"
        }
    ]
];
const $39c065d00fa604c6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("type", $39c065d00fa604c6$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");
const $81dd68c8d37816fd$export$dda6331b81ebb6db = (props)=>{
    const { fieldName: fieldName, value: value, onRemove: onRemove } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "bg-primary/10 text-primary inline-flex h-6 items-center gap-1 rounded-md px-2 text-xs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-primary/70",
                children: [
                    fieldName,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-medium",
                children: value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onRemove,
                className: "ml-0.5 rounded hover:bg-primary/20",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "h-3 w-3"
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");
const $d9005c57a49b2e7a$export$e0dca75a1c99dcf9 = (props)=>{
    const { fieldName: fieldName, value: value, isEditing: isEditing, onCommit: onCommit, onStartEdit: onStartEdit, onRemove: onRemove } = props;
    const [editValue, setEditValue] = $acw62.useState(value);
    const inputRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (isEditing) {
            setEditValue(value);
            // Focus after render
            requestAnimationFrame(()=>{
                inputRef.current?.focus();
            });
        }
    }, [
        isEditing,
        value
    ]);
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            onCommit(editValue);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            if (!value) // If no value was set yet, remove the field
            onRemove();
            else // Revert to original value
            onCommit(value);
        }
    };
    if (isEditing) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "bg-primary/10 text-primary inline-flex h-6 items-center gap-1 rounded-md px-2 text-xs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-primary/70",
                children: [
                    fieldName,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                ref: inputRef,
                type: "text",
                value: editValue,
                onChange: (e)=>setEditValue(e.target.value),
                onKeyDown: handleKeyDown,
                onBlur: ()=>onCommit(editValue),
                className: "w-20 min-w-0 border-none bg-transparent text-xs font-medium outline-none",
                placeholder: "type value..."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onRemove,
                className: "ml-0.5 rounded hover:bg-primary/20",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "h-3 w-3"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "bg-primary/10 text-primary inline-flex h-6 items-center gap-1 rounded-md px-2 text-xs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-primary/70",
                children: [
                    fieldName,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onStartEdit,
                className: "font-medium hover:underline",
                children: value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onRemove,
                className: "ml-0.5 rounded hover:bg-primary/20",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "h-3 w-3"
                })
            })
        ]
    });
};



parcelRequire("acw62");
const $a87593345326dab5$export$4325b389d599d493 = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "bg-muted-foreground text-background relative flex h-5 shrink-0 flex-row items-center overflow-hidden rounded-full px-2 text-xs",
        children: [
            props.name,
            props.showRemove && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "hover:bg-border absolute right-0 mr-0 ml-1 flex h-5 w-[22px] cursor-pointer items-center border-none bg-transparent pl-1 text-xl opacity-0 hover:opacity-100",
                onClick: ()=>props.onRemove && props.onRemove(),
                children: "\xd7"
            })
        ]
    });







const $5d5b27e6036e5285$var$resultKey = (result)=>result.kind === 'tag' ? `tag:${result.name}` : result.kind === 'attachment' ? `attachment:${result.candidate.key}` : result.kind === 'fieldBrowse' ? `browse:${result.fieldName}` : `field:${result.fieldId}:${result.value || '__text__'}`;
// With an empty search, the screen layout lists at most this many tags.
const $5d5b27e6036e5285$var$BROWSE_LIMIT = 60;
const $5d5b27e6036e5285$export$470985d1a1ba634f = ({ tags: tags, fieldValues: fieldValues, onChange: onChange, focusControlsRef: focusControlsRef, attachmentPills: attachmentPills, attachmentBlocks: attachmentBlocks, attachmentCandidates: attachmentCandidates, variant: variant = 'inline' })=>{
    const isScreen = variant === 'screen';
    const { data: tagsData } = (0, $ce9d9e524be20f53$export$1f229484873dfcfd)();
    const { data: fieldsData } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)();
    const [query, setQuery] = $acw62.useState('');
    const [isOpen, setIsOpen] = $acw62.useState(false);
    const [selectedIndex, setSelectedIndex] = $acw62.useState(null);
    const containerRef = $acw62.useRef(null);
    const inputRef = $acw62.useRef(null);
    const popoverRef = $acw62.useRef(null);
    const activeItemRef = $acw62.useRef(null);
    const [editingTextFieldId, setEditingTextFieldId] = $acw62.useState(null);
    const allTags = tagsData?.allTags ?? [];
    const fields = fieldsData?.allFields ?? [];
    const enumFields = $acw62.useMemo(()=>fields.filter((f)=>f.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum), [
        fields
    ]);
    const textFields = $acw62.useMemo(()=>fields.filter((f)=>f.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text), [
        fields
    ]);
    const tagFuse = $acw62.useMemo(()=>new (0, $33893b708b33402d$export$2e2bcd8739ae039)(allTags, {
            keys: [
                'name'
            ],
            threshold: 0.4,
            includeScore: true
        }), [
        allTags
    ]);
    const fieldFuse = $acw62.useMemo(()=>new (0, $33893b708b33402d$export$2e2bcd8739ae039)(fields, {
            keys: [
                'name'
            ],
            threshold: 0.4
        }), [
        fields
    ]);
    const textFieldFuse = $acw62.useMemo(()=>new (0, $33893b708b33402d$export$2e2bcd8739ae039)(textFields, {
            keys: [
                'name'
            ],
            threshold: 0.4
        }), [
        textFields
    ]);
    const candidateFuse = $acw62.useMemo(()=>new (0, $33893b708b33402d$export$2e2bcd8739ae039)(attachmentCandidates ?? [], {
            keys: [
                'searchText'
            ],
            threshold: 0.4
        }), [
        attachmentCandidates
    ]);
    const allValueItems = $acw62.useMemo(()=>enumFields.flatMap((f)=>f.values.map((val)=>({
                    fieldId: f._id,
                    fieldName: f.name,
                    value: val.value,
                    fieldType: (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum
                }))), [
        enumFields
    ]);
    const valueFuse = $acw62.useMemo(()=>new (0, $33893b708b33402d$export$2e2bcd8739ae039)(allValueItems, {
            keys: [
                'value'
            ],
            threshold: 0.4
        }), [
        allValueItems
    ]);
    const perFieldValueFuse = $acw62.useMemo(()=>Object.fromEntries(fields.map((f)=>[
                f._id,
                new (0, $33893b708b33402d$export$2e2bcd8739ae039)(f.values, {
                    keys: [
                        'value'
                    ],
                    threshold: 0.4
                })
            ])), [
        fields
    ]);
    const searchResults = $acw62.useMemo(()=>{
        if (!query.trim()) {
            if (!isScreen) return [];
            // Nothing typed yet: every tag not already applied, newest first, then
            // the fields not yet set.
            const browseTags = allTags.filter((t)=>!tags.includes(t.name)).sort((0, $c43a9ca50fd39c89$export$f511e8a5e30af90)).slice(0, $5d5b27e6036e5285$var$BROWSE_LIMIT).map((t)=>({
                    kind: 'tag',
                    name: t.name
                }));
            const browseFields = fields.filter((f)=>!(f._id in fieldValues)).sort((a, b)=>a.name.localeCompare(b.name)).map((f)=>f.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text ? {
                    kind: 'field',
                    fieldId: f._id,
                    fieldName: f.name,
                    value: '',
                    fieldType: (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text
                } : {
                    kind: 'fieldBrowse',
                    fieldName: f.name
                });
            return [
                ...browseTags,
                ...browseFields
            ];
        }
        const colonIndex = query.indexOf(':');
        if (colonIndex === -1) {
            const keyQuery = query.trim();
            const results = [];
            const fieldSeen = new Set();
            // Tags first (up to 5), newest year first among equal matches
            const tagMatches = tagFuse.search(keyQuery).sort((a, b)=>(a.score ?? 0) - (b.score ?? 0) || (0, $c43a9ca50fd39c89$export$f511e8a5e30af90)(a.item, b.item)).map((r)=>r.item);
            let tagCount = 0;
            for (const tag of tagMatches){
                if (tags.includes(tag.name)) continue;
                if (tagCount >= 5) break;
                results.push({
                    kind: 'tag',
                    name: tag.name
                });
                tagCount++;
            }
            // Enum fields by name
            const nameMatches = fieldFuse.search(keyQuery).map((r)=>r.item).filter((f)=>f.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum);
            for (const f of nameMatches){
                if (f._id in fieldValues) continue;
                for (const val of f.values){
                    const key = `${f._id}:${val.value}`;
                    if (fieldSeen.has(key)) continue;
                    fieldSeen.add(key);
                    results.push({
                        kind: 'field',
                        fieldId: f._id,
                        fieldName: f.name,
                        value: val.value,
                        fieldType: (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum
                    });
                }
            }
            // Enum fields by value
            for (const match of valueFuse.search(keyQuery)){
                if (match.item.fieldId in fieldValues) continue;
                const key = `${match.item.fieldId}:${match.item.value}`;
                if (fieldSeen.has(key)) continue;
                fieldSeen.add(key);
                results.push({
                    kind: 'field',
                    ...match.item
                });
            }
            // Text fields by name
            const textMatches = textFieldFuse.search(keyQuery).map((r)=>r.item);
            for (const tf of textMatches){
                if (tf._id in fieldValues) continue;
                results.push({
                    kind: 'field',
                    fieldId: tf._id,
                    fieldName: tf.name,
                    value: '',
                    fieldType: (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text
                });
            }
            // Contextual attachments last — they carry richer rows, so they read
            // as a distinct group at the bottom of the list
            for (const match of candidateFuse.search(keyQuery))results.push({
                kind: 'attachment',
                candidate: match.item
            });
            return results.slice(0, 15);
        } else {
            // Colon path: field:value search only
            const keyQuery = query.slice(0, colonIndex).trim();
            const valueQuery = query.slice(colonIndex + 1).trim();
            const matchedFields = keyQuery ? fieldFuse.search(keyQuery).map((r)=>r.item).filter((f)=>f.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum) : enumFields;
            const results = [];
            for (const f of matchedFields){
                if (f._id in fieldValues) continue;
                let matchedValues = f.values;
                if (valueQuery) {
                    const fuse = perFieldValueFuse[f._id];
                    matchedValues = fuse ? fuse.search(valueQuery).map((r)=>r.item) : [];
                }
                for (const val of matchedValues)results.push({
                    kind: 'field',
                    fieldId: f._id,
                    fieldName: f.name,
                    value: val.value,
                    fieldType: (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum
                });
            }
            return results.slice(0, 15);
        }
    }, [
        query,
        isScreen,
        allTags,
        tags,
        fields,
        enumFields,
        fieldValues,
        tagFuse,
        fieldFuse,
        textFieldFuse,
        valueFuse,
        perFieldValueFuse,
        candidateFuse
    ]);
    const showCreateTag = $acw62.useMemo(()=>{
        const trimmed = query.trim();
        if (!trimmed || trimmed.includes(':')) return false;
        const lower = trimmed.toLowerCase();
        return !allTags.some((t)=>t.name.toLowerCase() === lower) && !tags.some((t)=>t.toLowerCase() === lower);
    }, [
        query,
        allTags,
        tags
    ]);
    const selectableItems = $acw62.useMemo(()=>{
        const items = searchResults.map((r)=>({
                type: 'result',
                result: r
            }));
        if (showCreateTag) items.push({
            type: 'createTag',
            name: query.trim()
        });
        return items;
    }, [
        searchResults,
        showCreateTag,
        query
    ]);
    $acw62.useEffect(()=>{
        setSelectedIndex(null);
    }, [
        searchResults
    ]);
    $acw62.useLayoutEffect(()=>{
        activeItemRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        selectedIndex
    ]);
    $acw62.useLayoutEffect(()=>{
        if (isOpen && containerRef.current && popoverRef.current) popoverRef.current.style.width = `${Math.max(containerRef.current.offsetWidth, 250)}px`;
    }, [
        isOpen
    ]);
    const clearQuery = ()=>{
        setQuery('');
        setIsOpen(false);
        setSelectedIndex(null);
    };
    const handleSelectResult = (result)=>{
        if (result.kind === 'tag') {
            onChange([
                ...tags,
                result.name
            ], fieldValues);
            clearQuery();
            inputRef.current?.focus();
        } else if (result.kind === 'attachment') {
            result.candidate.onAttach();
            clearQuery();
            inputRef.current?.focus();
        } else if (result.kind === 'fieldBrowse') {
            // The colon search lists just this field's values.
            setQuery(`${result.fieldName}:`);
            setIsOpen(true);
            inputRef.current?.focus();
        } else if (result.fieldType === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text) {
            onChange(tags, {
                ...fieldValues,
                [result.fieldId]: ''
            });
            setEditingTextFieldId(result.fieldId);
            clearQuery();
        } else {
            onChange(tags, {
                ...fieldValues,
                [result.fieldId]: result.value
            });
            clearQuery();
            inputRef.current?.focus();
        }
    };
    const handleSelectItem = (item)=>{
        if (item.type === 'result') handleSelectResult(item.result);
        else {
            onChange([
                ...tags,
                item.name
            ], fieldValues);
            clearQuery();
            inputRef.current?.focus();
        }
    };
    const handleSelectAtIndex = (index)=>{
        const item = selectableItems[index ?? 0];
        if (item) handleSelectItem(item);
    };
    const handleRemoveTag = (index)=>{
        onChange([
            ...tags.slice(0, index),
            ...tags.slice(index + 1)
        ], fieldValues);
    };
    const handleRemoveField = (fieldId)=>{
        const newValues = {
            ...fieldValues
        };
        delete newValues[fieldId];
        onChange(tags, newValues);
        if (editingTextFieldId === fieldId) setEditingTextFieldId(null);
    };
    const handleTextFieldCommit = (fieldId, value)=>{
        if (value.trim()) onChange(tags, {
            ...fieldValues,
            [fieldId]: value.trim()
        });
        else {
            const newValues = {
                ...fieldValues
            };
            delete newValues[fieldId];
            onChange(tags, newValues);
        }
        setEditingTextFieldId(null);
        inputRef.current?.focus();
    };
    const handleInputChange = (value)=>{
        setQuery(value);
        setIsOpen(true);
    };
    const handleInputFocus = ()=>{
        if (query) setIsOpen(true);
    };
    // The screen layout's list is always showing; the inline popover isn't.
    const listOpen = isOpen || isScreen;
    const handleKeyDown = (e)=>{
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (!listOpen && query) setIsOpen(true);
            else if (selectableItems.length > 0) setSelectedIndex((prev)=>prev === null ? 0 : Math.min(prev + 1, selectableItems.length - 1));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (selectableItems.length > 0 && selectedIndex !== null) setSelectedIndex((prev)=>prev === 0 ? null : (prev ?? 0) - 1);
        } else if (e.key === 'Enter') // On the screen layout an empty search lists everything, so Enter
        // picks a row only once one is highlighted or the search is narrowed.
        {
            if (listOpen && selectableItems.length > 0 && (query.trim() !== '' || selectedIndex !== null)) {
                e.preventDefault();
                handleSelectAtIndex(selectedIndex);
            }
        } else if (e.key === 'Tab') {
            // Empty query (or nothing to pick): let Tab move focus past the input.
            if (!query || !listOpen || selectableItems.length === 0) {
                setIsOpen(false);
                return;
            }
            e.preventDefault();
            handleSelectAtIndex(selectedIndex);
            if (e.shiftKey) focusControlsRef?.current?.focusBackward();
            else focusControlsRef?.current?.focusForward();
        } else if (e.key === 'Backspace' && !query && tags.length > 0) onChange(tags.slice(0, tags.length - 1), fieldValues);
        else if (e.key === 'Escape') {
            e.preventDefault();
            setQuery('');
            setIsOpen(false);
            setSelectedIndex(null);
        }
    };
    const fieldEntries = Object.entries(fieldValues).map(([fieldId, value])=>{
        const field = fields.find((f)=>f._id === fieldId);
        return {
            fieldId: fieldId,
            fieldName: field?.name ?? fieldId,
            fieldType: field?.type ?? (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum,
            value: value
        };
    });
    // Applied values only — attachment slots may hold ghost "add" chips, which
    // are affordances rather than values and shouldn't shorten the prompt.
    const hasOwnPills = tags.length > 0 || fieldEntries.length > 0;
    const showPopover = isOpen && selectableItems.length > 0;
    const valuePills = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            tags.map((tag, i)=>isScreen ? // The inline pill's remove button shows on hover, which a phone
                // never has: here it's always showing.
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "bg-muted-foreground text-background inline-flex h-6 shrink-0 items-center gap-1 rounded-full pr-1 pl-2.5 text-xs",
                    children: [
                        tag,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            "aria-label": `Remove ${tag}`,
                            onClick: ()=>handleRemoveTag(i),
                            className: "hover:bg-background/20 cursor-pointer rounded-full p-0.5",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "size-3"
                            })
                        })
                    ]
                }, tag) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a87593345326dab5$export$4325b389d599d493), {
                    name: tag,
                    onRemove: ()=>handleRemoveTag(i),
                    showRemove: true
                }, tag)),
            fieldEntries.map((entry)=>entry.fieldType === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9005c57a49b2e7a$export$e0dca75a1c99dcf9), {
                    fieldName: entry.fieldName,
                    value: entry.value,
                    isEditing: editingTextFieldId === entry.fieldId,
                    onCommit: (value)=>handleTextFieldCommit(entry.fieldId, value),
                    onStartEdit: ()=>setEditingTextFieldId(entry.fieldId),
                    onRemove: ()=>handleRemoveField(entry.fieldId)
                }, entry.fieldId) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81dd68c8d37816fd$export$dda6331b81ebb6db), {
                    fieldName: entry.fieldName,
                    value: entry.value,
                    onRemove: ()=>handleRemoveField(entry.fieldId)
                }, entry.fieldId)),
            attachmentPills
        ]
    });
    if (isScreen) {
        // The keyboard's row: shaded like a hover, without the check that marks
        // a chosen value on the other screens.
        const highlight = (isSelected)=>isSelected ? '[&>button]:bg-muted' : undefined;
        const resultRow = (item, index)=>{
            const isSelected = selectedIndex === index;
            const ref = isSelected ? activeItemRef : null;
            if (item.type === 'createTag') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: ref,
                className: highlight(isSelected),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$17b64a9acc653c87), {
                    onClick: ()=>handleSelectItem(item),
                    leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62bf8c8bfdcf5adc$export$2e2bcd8739ae039), {
                        className: "text-muted-foreground size-4"
                    }),
                    label: `New tag \u{201C}${item.name}\u{201D}`
                })
            }, "create-tag");
            const { result: result } = item;
            const key = $5d5b27e6036e5285$var$resultKey(result);
            const leadingClass = 'text-muted-foreground size-4';
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: ref,
                className: highlight(isSelected),
                children: result.kind === 'attachment' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>handleSelectItem(item),
                    className: "hover:bg-muted w-full cursor-pointer px-3 py-2.5 text-left text-sm",
                    children: result.candidate.row
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$17b64a9acc653c87), {
                    onClick: ()=>handleSelectItem(item),
                    leading: result.kind === 'tag' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76c2bea761476961$export$2e2bcd8739ae039), {
                        className: leadingClass
                    }) : result.kind === 'fieldBrowse' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a075d7302e2a23e$export$2e2bcd8739ae039), {
                        className: leadingClass
                    }) : result.fieldType === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39c065d00fa604c6$export$2e2bcd8739ae039), {
                        className: leadingClass
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a075d7302e2a23e$export$2e2bcd8739ae039), {
                        className: leadingClass
                    }),
                    label: result.kind === 'tag' || result.kind === 'fieldBrowse' ? result.kind === 'tag' ? result.name : result.fieldName : result.fieldType === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text ? result.fieldName : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-muted-foreground",
                                children: [
                                    result.fieldName,
                                    ":"
                                ]
                            }),
                            " ",
                            result.value
                        ]
                    })
                })
            }, key);
        };
        // Rows in order, under a heading wherever the kind changes.
        const sectionOf = (item)=>item.type === 'createTag' ? 'create' : item.result.kind === 'tag' ? 'Tags' : item.result.kind === 'attachment' ? 'Benefits' : 'Fields';
        const groups = [];
        selectableItems.forEach((item, index)=>{
            const label = sectionOf(item);
            const last = groups.at(-1);
            if (last?.label === label) last.rows.push(resultRow(item, index));
            else groups.push({
                label: label,
                rows: [
                    resultRow(item, index)
                ]
            });
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-3",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                    ref: inputRef,
                    autoFocus: true,
                    value: query,
                    onChange: (value)=>{
                        setQuery(value);
                        setIsOpen(true);
                    },
                    onKeyDown: handleKeyDown,
                    placeholder: "Search tags and fields"
                }),
                (hasOwnPills || attachmentPills != null) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-wrap items-center gap-1.5",
                    children: valuePills
                }),
                attachmentBlocks,
                groups.map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                        children: [
                            g.label !== 'create' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$ebd8ead8a40ba458), {
                                children: g.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$f94f96c749c6beb1), {
                                children: g.rows
                            })
                        ]
                    }, g.label))
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: containerRef,
                onClick: (e)=>{
                    // Only a click on the strip's own padding focuses the type-ahead —
                    // clicks on pills (their remove buttons, the text-field pill's
                    // inline editor) must keep their own focus.
                    if (e.target === e.currentTarget) inputRef.current?.focus();
                },
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('dark:bg-input/30 border-input min-h-9 w-full cursor-text rounded-md border bg-transparent px-2 py-1 shadow-xs transition-[color,box-shadow]', 'focus-within:border-ring focus-within:ring-ring/50 focus-within:ring-[3px]', 'flex flex-wrap items-center gap-1'),
                children: [
                    valuePills,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        ref: inputRef,
                        value: query,
                        onChange: (e)=>handleInputChange(e.target.value),
                        onFocus: handleInputFocus,
                        onKeyDown: handleKeyDown,
                        // A short prompt once pills occupy the box — the full one would
                        // force an early wrap and imply the pills aren't part of the value
                        placeholder: hasOwnPills ? "Add\u2026" : 'Add tags or fields...',
                        className: "placeholder:text-muted-foreground min-w-24 flex-1 bg-transparent py-0.5 outline-none"
                    })
                ]
            }),
            attachmentBlocks,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fa899d90230d1ae$export$5b6b19405a83ff9d), {
                anchorRef: containerRef,
                anchor: "bottom-left",
                focusControlsRef: focusControlsRef,
                open: showPopover,
                onOutsideClick: ()=>setIsOpen(false),
                onOutsideFocus: ()=>setIsOpen(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$fda2cbba281a800a), {
                    ref: popoverRef,
                    children: selectableItems.map((item, index)=>{
                        const isSelected = selectedIndex === index;
                        const ref = isSelected ? activeItemRef : null;
                        if (item.type === 'result') {
                            const { result: result } = item;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$ee388116d58b2caf), {
                                isSelected: isSelected,
                                ref: ref,
                                onClick: ()=>handleSelectItem(item),
                                className: "cursor-pointer text-sm",
                                children: result.kind === 'tag' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-medium",
                                            children: result.name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground ml-1.5 text-xs",
                                            children: "#tag"
                                        })
                                    ]
                                }) : result.kind === 'attachment' ? result.candidate.row : result.kind === 'fieldBrowse' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "text-muted-foreground",
                                    children: [
                                        result.fieldName,
                                        ":"
                                    ]
                                }) : result.fieldType === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-medium",
                                            children: result.fieldName
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground ml-1.5 text-xs",
                                            children: "(text)"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-muted-foreground",
                                            children: [
                                                result.fieldName,
                                                ":"
                                            ]
                                        }),
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-medium",
                                            children: result.value
                                        })
                                    ]
                                })
                            }, $5d5b27e6036e5285$var$resultKey(result));
                        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $03be77ecee525e88$export$ee388116d58b2caf), {
                            isSelected: isSelected,
                            ref: ref,
                            onClick: ()=>handleSelectItem(item),
                            className: "border-border cursor-pointer border-t text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground",
                                    children: "Create tag"
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "font-medium",
                                    children: [
                                        "\u201C",
                                        item.name,
                                        "\u201D"
                                    ]
                                })
                            ]
                        }, "create-tag");
                    })
                })
            })
        ]
    });
};










// A top match covering at least this share of the merchant's history is
// auto-applied into untouched fields; anything less ambiguous stays a
// picker-only suggestion (sorted first in the payee/category dropdowns).
const $814f8eff791eb91e$var$AUTO_APPLY_RATIO = 0.6;
const $814f8eff791eb91e$export$f19dc3a4634f425c = ({ onRequestClose: onRequestClose, onCreate: onCreate, transactions: transactions, suggestion: externalSuggestion, expandBenefit: expandBenefit })=>{
    const formId = $acw62.useId();
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    // Field names for the tags line's summary (the tags screen asks the same).
    const { data: fieldsData } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)();
    // History for a single row. A query rather than a fetch from an effect, so
    // an answer already cached (the Inbox card asks for every row it shows —
    // see suggestionsByRow) is there on the first render: the sheet opens
    // prefilled instead of flipping from empty once a round trip lands.
    const { data: fetchedData } = (0, $ce9d9e524be20f53$export$5e3cc446f2bf8ebc)({
        variables: {
            rawTransactionIds: transactions.map((t)=>t._id)
        },
        skip: externalSuggestion != null || transactions.length !== 1
    });
    const suggestions = $acw62.useMemo(()=>{
        if (externalSuggestion) return [
            externalSuggestion
        ];
        return fetchedData?.suggestCategorizations ?? [];
    }, [
        externalSuggestion,
        fetchedData
    ]);
    const currency = transactions[0]?.currency ?? 'USD';
    const currencies = $acw62.useMemo(()=>[
            ...new Set(transactions.map((t)=>t.currency))
        ], [
        transactions
    ]);
    // Exactly two currencies is a conversion: the one transfer whose legs span
    // currencies (balanced by assertion — the legs define the exchange rate).
    const isConversion = currencies.length === 2;
    // Allocation math and the header total sum plain cent values and label them
    // with a single currency, so a selection across 3+ currencies can't be
    // represented coherently. Detect it and block submission rather than
    // silently treating it as one currency.
    const mixedCurrency = currencies.length > 2;
    // The still-unallocated (signed) amount of a raw transaction — its full amount
    // unless it was already partially consumed elsewhere.
    const remainingOf = (t)=>t.remainingAmount ?? t.amount;
    // Sum of the raws' still-unallocated (remaining) amounts. When this is zero
    // the selection is inherently a transfer regardless of how the user edits the
    // per-row allocations, which keeps the mode stable while editing a balanced
    // transfer's legs.
    const remainingNet = $acw62.useMemo(()=>transactions.reduce((sum, t)=>sum + remainingOf(t), 0), [
        transactions
    ]);
    const defaultAllocations = ()=>Object.fromEntries(transactions.map((t)=>[
                t._id,
                (0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(remainingOf(t)), t.currency))
            ]));
    // Per-raw allocation amounts (absolute, positive). Each raw defaults to its
    // still-unallocated remaining amount; allocating less leaves a remainder in
    // the inbox. Allocation is now available for every raw transaction, enabling
    // multi-raw partial payments and partial transfers.
    const [allocations, setAllocations] = $acw62.useState(defaultAllocations);
    // Reset allocations whenever the selected raw transactions change.
    $acw62.useEffect(()=>{
        setAllocations(defaultAllocations());
    }, [
        transactions
    ]);
    const allocationAbs = (t)=>(allocations[t._id] ?? (0, $f8f45ddea4959097$exports.none)).map((m)=>Math.abs(m.amount)).getOrElse(0);
    const allocationError = (t)=>{
        const abs = allocationAbs(t);
        if (abs <= 0) return 'empty';
        if (abs > Math.abs(remainingOf(t))) return 'over';
        return null;
    };
    const allocationsValid = transactions.every((t)=>allocationError(t) === null);
    // Signed sum of the allocated amounts. Drives the header readout and the
    // transfer net-zero requirement.
    const allocatedNet = transactions.reduce((sum, t)=>sum + Math.sign(t.amount) * allocationAbs(t), 0);
    // Treat the transaction as a balanced transfer when either the selection's
    // remaining amounts already net to zero (stable during editing), or the user
    // has allocated valid per-row amounts that net to zero. The latter makes
    // partial transfers reachable even when the full remaining amounts don't
    // balance (e.g. allocating $60 from a -$100 raw and a +$60 raw). A
    // conversion is always a transfer — its cross-currency sum is meaningless.
    const isBalanced = isConversion || remainingNet === 0 || allocationsValid && allocatedNet === 0;
    // Signed allocated total per currency — the conversion's legs. Valid when
    // both legs are nonzero and run in opposite directions (mirrors the server
    // validation).
    const conversionLegs = (()=>{
        if (!isConversion) return [];
        const byCurrency = new Map();
        for (const t of transactions)byCurrency.set(t.currency, (byCurrency.get(t.currency) ?? 0) + Math.sign(t.amount) * allocationAbs(t));
        // Outgoing leg first: reads as "from → to".
        return [
            ...byCurrency.entries()
        ].sort(([, a], [, b])=>a - b);
    })();
    // A conversion's foreign leg must live in ONE account: valuation charges the
    // whole home leg to every wallet a leg touches, so a leg split across two
    // wallets would double-count its cost. The server rejects it either way —
    // checking here keeps the modal from offering a Create that can only fail.
    const foreignLegSpansAccounts = $acw62.useMemo(()=>{
        const accountsByCurrency = new Map();
        for (const t of transactions){
            if (t.currency === 'USD') continue;
            const seen = accountsByCurrency.get(t.currency) ?? new Set();
            seen.add(t.account._id);
            accountsByCurrency.set(t.currency, seen);
        }
        return [
            ...accountsByCurrency.values()
        ].some((s)=>s.size > 1);
    }, [
        transactions
    ]);
    // A foreign transfer carries its basis to ONE destination: the cost it draws
    // becomes a single lot, which cannot live in two accounts at once. Same
    // reason as above, and the server rejects it either way.
    const transferSpansDestinations = $acw62.useMemo(()=>{
        if (isConversion) return false;
        const destinations = new Set(transactions.filter((t)=>t.currency !== 'USD' && t.amount > 0).map((t)=>t.account._id));
        return destinations.size > 1;
    }, [
        transactions,
        isConversion
    ]);
    const conversionLegsValid = isConversion && conversionLegs.length === 2 && conversionLegs.every(([, leg])=>leg !== 0) && Math.sign(conversionLegs[0][1]) !== Math.sign(conversionLegs[1][1]) && !foreignLegSpansAccounts;
    // Transfer-type inference: a credit card and a bank account moving money in
    // the payment direction. The selection already carries the amounts and each
    // account's depositoryType, so this needs no round-trip and lands before the
    // first paint. Every other shape is left to the user.
    //
    // Inferred from the *allocated* legs, the same signed amounts `allocatedNet`
    // balances on — not the raws' full amounts. A partial transfer (allocating
    // $60 from a -$100 raw against a +$60 one) and a raw already partly consumed
    // elsewhere both balance on allocations while their raw amounts do not, and
    // reading the raws would drop the type on exactly those.
    const suggestedTransferType = $acw62.useMemo(()=>isConversion ? null : (0, $ec1c2b802b5e2c50$export$757f96e788c1c6eb)(transactions.map((t)=>({
                amount: Math.sign(t.amount) * allocationAbs(t),
                account: t.account
            }))), [
        transactions,
        isConversion,
        allocations
    ]);
    // Null until the suggestion lands or the user picks: the select shows its
    // placeholder rather than a default that would silently label every
    // untouched transfer `account_transfer`.
    const [transferType, setTransferType] = $acw62.useState(null);
    const transferTypeManuallyChanged = $acw62.useRef(false);
    // Reset transfer type when the selected transactions change. A two-currency
    // selection can only be a conversion, so lock the type to it.
    $acw62.useEffect(()=>{
        setTransferType(isConversion ? (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion : null);
        transferTypeManuallyChanged.current = false;
    }, [
        transactions,
        isConversion
    ]);
    $acw62.useEffect(()=>{
        if (suggestedTransferType && !transferTypeManuallyChanged.current && !isConversion) setTransferType(suggestedTransferType);
    }, [
        suggestedTransferType,
        isConversion
    ]);
    const handleTransferTypeChange = (value)=>{
        transferTypeManuallyChanged.current = true;
        setTransferType(value);
    };
    // Payee deliberately does NOT prefill from the raw descriptor: the string
    // stays visible on the raw row below (with a copy affordance), so the
    // common case is typing a clean payee — or having the dominant historical
    // match auto-applied — rather than deleting a bank descriptor first.
    const [properties, setProperties] = $acw62.useState(()=>({
            payee: '',
            description: '',
            date: transactions.length > 0 ? (0, $63618293c58b5f80$exports.DateTime).min(...transactions.map((t)=>(0, $0c0f91b069db95d9$export$6b862160d295c8e)(t.date))) : (0, $63618293c58b5f80$exports.DateTime).local(),
            category: (0, $f8f45ddea4959097$exports.none),
            tags: [],
            fieldValues: {}
        }));
    // Auto-apply the dominant historical match directly into the fields — the
    // suggestion card is gone, so a confident match lands as the prefill (with
    // sparkle provenance rendered by the inputs) and an ambiguous one surfaces
    // only through the suggestion-sorted pickers. One-shot: a response that
    // arrives after the user started typing must not overwrite their input,
    // and only untouched fields are filled.
    const autoApplyAttempted = $acw62.useRef(false);
    const [autoApplied, setAutoApplied] = $acw62.useState(null);
    // Fields the user has started typing in, flagged on the first keystroke —
    // before the picker commits its text into `properties` on blur/submit. A
    // suggestion response landing mid-word would otherwise see the committed
    // value as untouched and overwrite the in-progress input.
    const editedFieldsRef = $acw62.useRef({
        payee: false,
        category: false
    });
    // Before paint: with the answer already cached, the sheet's first frame
    // shows the prefill rather than "Add payee" for one frame.
    $acw62.useLayoutEffect(()=>{
        if (autoApplyAttempted.current || isBalanced || suggestions.length === 0) return;
        autoApplyAttempted.current = true;
        // Low-confidence matches are offered in the pickers, never prefilled.
        const confident = suggestions.filter((s)=>s.confidence === (0, $ce9d9e524be20f53$export$f725fc4d50930da7).High);
        if (confident.length === 0) return;
        const threshold = confident[0].totalCount * $814f8eff791eb91e$var$AUTO_APPLY_RATIO;
        // The payee first, by its total across categories (payeeMatchCount —
        // the server always sends that payee's best option): history that
        // agrees on the payee but splits on the category (one café, filed as
        // Dining at home and Travel on a trip) still names the payee. Then its
        // own best category, which fills only if it too clears the bar.
        const dominant = confident.reduce((best, s)=>s.payeeMatchCount > best.payeeMatchCount ? s : best);
        if (dominant.payeeMatchCount < threshold) return;
        // Options arrive most frequent first.
        const top = confident.find((s)=>s.payee === dominant.payee) ?? dominant;
        const bothAgree = top.matchCount >= threshold;
        const fillPayee = !editedFieldsRef.current.payee && properties.payee === '' && top.payee !== '';
        const fillCategory = bothAgree && !editedFieldsRef.current.category && properties.category.isEmpty && top.categoryName !== '';
        if (!fillPayee && !fillCategory) return;
        setProperties((prev)=>({
                ...prev,
                payee: fillPayee ? top.payee : prev.payee,
                category: fillCategory ? (0, $f8f45ddea4959097$exports.some)(top.categoryName) : prev.category
            }));
        setAutoApplied({
            payee: fillPayee ? top.payee : undefined,
            category: fillCategory ? top.categoryName : undefined
        });
    }, [
        suggestions,
        isBalanced,
        properties
    ]);
    const handleChange = (key)=>(value)=>{
            setProperties({
                ...properties,
                [key]: value
            });
        };
    // ==================== Contextual attachments ====================
    // Benefit links and fee periods ride the Tags & Fields strip as contextual
    // sources. Both annotate exactly one raw and both are USD-only server-side
    // (linkBenefitToRawTransaction rejects non-USD raws; card-benefit amounts
    // are dollars throughout), and both belong to payments — so the sources
    // only offer themselves for a single USD raw in payment mode.
    const singleRaw = transactions.length === 1 ? transactions[0] : null;
    // Coarse shape gate — this feeds the query skip, which must not flap as
    // the user types in the allocation field.
    const attachmentsPossible = singleRaw != null && singleRaw.currency === 'USD' && !isBalanced;
    // Both attachments read the raw at face value — benefit usage sums the
    // whole linked raw's amount, and the fee period records the whole charge —
    // so this payment must consume the raw at face value: untouched by earlier
    // transactions, and allocated in full here. Either kind of shortfall (a
    // $20 allocation of a $100 raw, or a $100 raw that arrived with $50
    // already consumed elsewhere) would record a payment smaller than the
    // $100 the annotations claim.
    const attachmentsEligible = attachmentsPossible && singleRaw != null && remainingOf(singleRaw) === singleRaw.amount && allocationAbs(singleRaw) === Math.abs(singleRaw.amount);
    // One query feeds both sources: the benefit list, and the raw-already-backs-
    // a-fee-period check. Skipped entirely for selections that can't attach.
    // This is the hot categorize path, so it's the lean AttachmentFeePeriods
    // selection (no transaction histories), not FullFeePeriod. no-cache rather
    // than network-only: freshness is required either way — a stale "no fee
    // period yet" lets the payment through only for the follow-up to fail on
    // the server's duplicate check — and bypassing the cache also keeps the
    // lean periods from overwriting the benefits views' fuller normalized
    // data.
    const { data: feePeriodsData, loading: feePeriodsLoading } = (0, $ce9d9e524be20f53$export$6c4da8612d49971)({
        skip: !attachmentsPossible,
        fetchPolicy: 'no-cache'
    });
    const allFeePeriods = feePeriodsData?.allFeePeriods;
    const [attachedBenefit, setAttachedBenefit] = $acw62.useState(null);
    const [benefitPickerOpen, setBenefitPickerOpen] = $acw62.useState(expandBenefit === true);
    const benefitChipRef = $acw62.useRef(null);
    // The picker itself handles "none cover this date" (with a show-all
    // escape) and "no benefits at all", so the chip appears whenever any
    // benefit exists — and also while the picker is up because the b hotkey
    // requested it, so the shortcut surfaces the picker's loading and "No
    // benefits found" states instead of silently degrading to a plain create.
    const benefitSourceAvailable = attachmentsEligible && (allFeePeriods ?? []).some((fp)=>fp.benefits.length > 0);
    const rawDateSeconds = singleRaw != null ? (0, $0c0f91b069db95d9$export$6b862160d295c8e)(singleRaw.date).toSeconds() : 0;
    const attachBenefit = $acw62.useCallback((benefit, feePeriod)=>{
        setAttachedBenefit({
            benefit: benefit,
            feePeriod: feePeriod
        });
        setBenefitPickerOpen(false);
        // The prefill the standalone benefit flow applied, with the same
        // overwrite-but-editable semantics as applySuggestion. Detaching the
        // benefit later never un-fills these.
        setProperties((prev)=>({
                ...prev,
                payee: feePeriod.payee ?? benefit.name,
                description: benefit.name,
                category: (0, $f8f45ddea4959097$exports.some)(benefit.category.name)
            }));
    }, []);
    const [feePeriodDraft, setFeePeriodDraft] = $acw62.useState(null);
    // A fee period is keyed to a single annual-fee charge on a credit card, and
    // a raw that already backs one can't take another (the server rejects the
    // duplicate). Gated on the query having resolved so the chip can't flash in
    // before the already-linked check has data.
    const feePeriodSourceAvailable = attachmentsEligible && singleRaw.amount !== 0 && singleRaw.account.__typename === 'DepositoryAccount' && singleRaw.account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard && allFeePeriods != null && !allFeePeriods.some((fp)=>fp.rawTransactionId === singleRaw._id);
    // The server rejects a period whose half-open end isn't after its start.
    // The draft's dates are inclusive (a same-day start/end is a valid one-day
    // period), so only end-before-start is invalid — caught here so the main
    // Create stays disabled, rather than letting the payment land and the
    // follow-up die on server validation.
    const feePeriodDraftInvalid = feePeriodSourceAvailable && feePeriodDraft != null && feePeriodDraft.endDate < feePeriodDraft.startDate;
    const [linkBenefit] = (0, $ce9d9e524be20f53$export$1d5034815fcbdd74)();
    const [createFeePeriod] = (0, $ce9d9e524be20f53$export$14858aeec370c3a1)();
    // Set when a follow-up write (benefit link, fee period) failed after the
    // transaction was already created — the terminal acknowledge-and-close
    // state rendered below.
    const [followUpError, setFollowUpError] = $acw62.useState(null);
    const attachmentPills = attachmentsEligible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            attachedBenefit != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef8f85bfb532ef83$export$859f88f9f4d77ffe), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1299b0a605d22052$export$2e2bcd8739ae039), {}),
                label: attachedBenefit.benefit.name,
                detail: `${formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt((0, $2680a3b0889a19c1$export$d93277a13097bc58)(attachedBenefit.benefit), 'USD'))} left`,
                onRemove: ()=>setAttachedBenefit(null)
            }),
            (benefitSourceAvailable || benefitPickerOpen) && attachedBenefit == null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef8f85bfb532ef83$export$de8d9585272b1a20), {
                ref: benefitChipRef,
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1299b0a605d22052$export$2e2bcd8739ae039), {}),
                label: "Benefit",
                onClick: ()=>setBenefitPickerOpen((open)=>!open)
            }),
            feePeriodSourceAvailable && feePeriodDraft == null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef8f85bfb532ef83$export$de8d9585272b1a20), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cab856bf30f1b37f$export$2e2bcd8739ae039), {}),
                label: "Fee period",
                onClick: ()=>{
                    const start = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(singleRaw.date);
                    setFeePeriodDraft({
                        payee: singleRaw.account.name,
                        startDate: start,
                        endDate: start.plus({
                            years: 1
                        }).minus({
                            days: 1
                        })
                    });
                }
            })
        ]
    }) : undefined;
    // The fee period needs its own sub-form (payee, period bounds), so once
    // attached it renders as a block under the strip rather than a pill.
    // The benefit picker opens right under the chip that toggles it; below
    // the tags screen's browse list it would land past the bottom of the
    // sheet, and the tap would look like it did nothing.
    const benefitPicker = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$49bd1dfb0ad29c40), {
        open: benefitPickerOpen && attachmentsEligible && attachedBenefit == null,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "border-border rounded-xl border p-3",
            children: feePeriodsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground text-sm",
                children: "Loading benefits..."
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2680a3b0889a19c1$export$c75002b314c2fe72), {
                feePeriods: allFeePeriods ?? [],
                transactionDate: rawDateSeconds,
                onSelect: attachBenefit
            })
        })
    });
    const feePeriodBlock = feePeriodSourceAvailable && feePeriodDraft != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border flex flex-col gap-2 rounded-md border px-3 py-2.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "inline-flex items-center gap-1.5 text-sm font-medium",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cab856bf30f1b37f$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-3.5"
                            }),
                            "Fee period"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setFeePeriodDraft(null),
                        className: "text-muted-foreground hover:text-foreground cursor-pointer",
                        title: "Remove fee period",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                            className: "size-3.5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground w-12 shrink-0 text-xs",
                        children: "Payee"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        value: feePeriodDraft.payee,
                        onChange: (payee)=>setFeePeriodDraft({
                                ...feePeriodDraft,
                                payee: payee
                            }),
                        placeholder: "Card product name"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-start gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground w-12 shrink-0 pt-2 text-xs",
                        children: "Period"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-w-0 flex-1 flex-wrap items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                selectedDate: feePeriodDraft.startDate,
                                onChange: (startDate)=>setFeePeriodDraft({
                                        ...feePeriodDraft,
                                        startDate: startDate
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "\u2013"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                selectedDate: feePeriodDraft.endDate,
                                onChange: (endDate)=>setFeePeriodDraft({
                                        ...feePeriodDraft,
                                        endDate: endDate
                                    })
                            })
                        ]
                    })
                ]
            }),
            feePeriodDraftInvalid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-destructive text-xs",
                children: "End date is before the start date"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground text-xs",
                children: "Created on submit, anchored to this charge"
            })
        ]
    }) : null;
    const attachmentBlocks = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            benefitPicker,
            feePeriodBlock
        ]
    });
    // Qualifying benefits also surface through the strip's type-ahead, so
    // typing part of a name attaches without reaching for the chip.
    const attachmentCandidates = $acw62.useMemo(()=>{
        if (!benefitSourceAvailable || attachedBenefit != null || !allFeePeriods) return [];
        return allFeePeriods.flatMap((fp)=>fp.benefits.filter((b)=>(0, $2680a3b0889a19c1$export$f3ac91982c9f686a)(b, rawDateSeconds)).map((b)=>({
                    key: `benefit:${b._id}`,
                    searchText: `${b.name} ${fp.payee ?? fp.account.name} benefit`,
                    row: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "inline-flex min-w-0 items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1299b0a605d22052$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-3.5 shrink-0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "truncate font-medium",
                                children: b.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-muted-foreground shrink-0 text-xs",
                                children: [
                                    formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt((0, $2680a3b0889a19c1$export$d93277a13097bc58)(b), 'USD')),
                                    " left \xb7 benefit"
                                ]
                            })
                        ]
                    }),
                    onAttach: ()=>attachBenefit(b, fp)
                })));
    }, [
        benefitSourceAvailable,
        attachedBenefit,
        allFeePeriods,
        rawDateSeconds,
        formatMoney,
        attachBenefit
    ]);
    const [createTransaction, { loading: loading }] = (0, $ce9d9e524be20f53$export$5694853076d71b4a)();
    // The mutation's own `loading` clears as soon as the create resolves, but a
    // payment's attachment follow-ups may still be in flight — and the raws are
    // already consumed, so a second Create in that window would double-spend
    // the allocation. This lock spans the whole submit, follow-ups included.
    const [submitting, setSubmitting] = $acw62.useState(false);
    // For payment transactions, we need a category
    const paymentPayload = properties.category.map((category)=>({
            ...properties,
            category: category,
            rawTransactions: transactions.map((t)=>t._id)
        })).map((variables)=>({
            ...variables,
            date: variables.date.toISODate()
        }));
    // A balanced (transfer) selection must keep its allocations netting to zero
    // and carry a type — the select starts empty, and submitting past it would
    // store an untyped transfer that no later reader can tell from one whose
    // type was considered and left off. A conversion balances by assertion
    // instead, needing two nonzero opposite-direction legs, and its type is
    // fixed. An unbalanced (payment) selection needs a payee (nothing
    // prefills one anymore, and the server rejects a payment without it), a
    // category, and a nonzero net — a zero-net payment is a balanced
    // transfer, which the server rejects when it carries payee/category, so
    // block that submit here. An attached
    // fee-period draft must also hold valid bounds: the payment mutation runs
    // before the fee-period follow-up, so a doomed draft would otherwise
    // allocate the raw and then fail terminally.
    const canSubmit = !mixedCurrency && allocationsValid && (isConversion ? conversionLegsValid : isBalanced ? allocatedNet === 0 && !transferSpansDestinations && transferType != null : !paymentPayload.isEmpty && properties.payee.trim() !== '' && allocatedNet !== 0 && !feePeriodDraftInvalid);
    const pendingRef = $acw62.useRef(false);
    // Per-raw allocation input sent to the mutation (one entry per raw).
    const allocationInput = transactions.map((t)=>({
            rawTransactionId: t._id,
            amount: allocationAbs(t)
        }));
    // Raws allocated below their remaining amount keep an unallocated remainder;
    // report them back so the inbox keeps them (with the updated remainingAmount)
    // instead of removing them.
    const remainderUpdate = (()=>{
        const updated = transactions.filter((t)=>allocationAbs(t) < Math.abs(remainingOf(t))).map((t)=>({
                ...t,
                remainingAmount: remainingOf(t) - Math.sign(t.amount) * allocationAbs(t)
            }));
        return updated.length > 0 ? updated : undefined;
    })();
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (submitting) return;
        const pending = pendingRef.current;
        pendingRef.current = false;
        if (isBalanced) {
            // Create transfer transaction
            setSubmitting(true);
            createTransaction({
                variables: {
                    rawTransactions: transactions.map((t)=>t._id),
                    date: properties.date.toISODate(),
                    description: properties.description,
                    transferType: transferType,
                    // Optional counterparty (a refund's merchant, a reimbursement's
                    // payer) — omitted when the field was left empty.
                    payee: properties.payee.trim() !== '' ? properties.payee : undefined,
                    tags: properties.tags,
                    fieldValues: properties.fieldValues,
                    pending: pending,
                    allocations: allocationInput
                },
                update: (store, result)=>{
                    const tx = result?.data?.createTransaction;
                    if (tx?.payee) (0, $0248a075196eba6a$export$db125e7042e4c220)(store, tx.payee);
                }
            }).then((response)=>{
                if (response.data) {
                    onCreate({
                        rawTransactionIds: response.data.createTransaction.consumptions.map((c)=>c.rawTransactionId),
                        updatedRawTransactions: remainderUpdate
                    });
                    onRequestClose();
                }
            }).finally(()=>setSubmitting(false));
        } else {
            // Attachments are payment-only annotations; if edits flipped the
            // selection's shape since they were configured, they stand down (their
            // UI is hidden in those shapes too).
            const benefitToLink = attachmentsEligible ? attachedBenefit : null;
            const feePeriodToCreate = feePeriodSourceAvailable && feePeriodDraft != null ? feePeriodDraft : null;
            // Create payment transaction
            paymentPayload.forEach((variables)=>{
                setSubmitting(true);
                createTransaction({
                    variables: {
                        rawTransactions: variables.rawTransactions,
                        payee: variables.payee,
                        description: variables.description,
                        date: variables.date,
                        category: variables.category,
                        tags: variables.tags,
                        fieldValues: variables.fieldValues,
                        pending: pending,
                        allocations: allocationInput
                    },
                    update: (store, result)=>{
                        const tx = result?.data?.createTransaction;
                        if (tx) {
                            tx.category && (0, $5f9091afcb8d9899$export$8c292b02ce03981f)(store, tx.category);
                            tx.tags && (0, $d320129055480c52$export$3e5009ed1fce7d58)(store, tx.tags);
                            tx.payee && (0, $0248a075196eba6a$export$db125e7042e4c220)(store, tx.payee);
                        }
                    }
                }).then(async (response)=>{
                    if (!response.data) return;
                    // The raws are consumed regardless of how the follow-ups fare, so
                    // report the allocation to the owning list first.
                    onCreate({
                        rawTransactionIds: response.data.createTransaction.consumptions.map((c)=>c.rawTransactionId),
                        updatedRawTransactions: remainderUpdate
                    });
                    // Attachment follow-ups run after the create; a failure keeps the
                    // modal open saying what still needs doing by hand, instead of
                    // silently closing (or blocking the created transaction).
                    const failures = [];
                    if (benefitToLink != null && singleRaw != null) try {
                        await linkBenefit({
                            variables: {
                                rawTransactionId: singleRaw._id,
                                benefitId: benefitToLink.benefit._id
                            },
                            refetchQueries: [
                                {
                                    query: (0, $ce9d9e524be20f53$export$57862cdd9be7ef37),
                                    variables: {
                                        accountId: benefitToLink.benefit.accountId
                                    }
                                }
                            ]
                        });
                    } catch  {
                        failures.push("The benefit could not be linked \u2014 link it from the raw transaction page.");
                    }
                    if (feePeriodToCreate != null && singleRaw != null) try {
                        await createFeePeriod({
                            variables: {
                                accountId: singleRaw.account._id,
                                rawTransactionId: singleRaw._id,
                                startDate: Math.floor(feePeriodToCreate.startDate.toSeconds()),
                                // The picker's end date is inclusive; stored bounds are
                                // half-open (same conversion as CreateFeePeriodModal)
                                endDate: Math.floor(feePeriodToCreate.endDate.plus({
                                    days: 1
                                }).toSeconds()),
                                amount: Math.abs(singleRaw.amount),
                                payee: feePeriodToCreate.payee || undefined
                            },
                            refetchQueries: [
                                {
                                    query: (0, $ce9d9e524be20f53$export$57862cdd9be7ef37),
                                    variables: {
                                        accountId: singleRaw.account._id
                                    }
                                },
                                // Normalization updates existing entities everywhere, but
                                // can't add the new period to the cached root list that
                                // cache-first readers (the benefits overview) consume.
                                {
                                    query: (0, $ce9d9e524be20f53$export$3557c8d197445a9f)
                                }
                            ]
                        });
                    } catch  {
                        failures.push("The fee period could not be created \u2014 create it from the card benefits page.");
                    }
                    if (failures.length > 0) setFollowUpError(failures.join(' '));
                    else onRequestClose();
                }).finally(()=>setSubmitting(false));
            });
        }
    };
    const [dropdownOpen, setDropdownOpen] = $acw62.useState(false);
    const closeDropdown = $acw62.useCallback(()=>setDropdownOpen(false), []);
    const toggleDropdown = $acw62.useCallback(()=>setDropdownOpen((s)=>!s), []);
    const formRef = $acw62.useRef(null);
    const dropdownMenuContext = $acw62.useMemo(()=>({
            closeMenu: closeDropdown
        }), [
        closeDropdown
    ]);
    const dropdownContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ec27fe8536d582e$export$22e3865480307310).Provider, {
        value: dropdownMenuContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "shadow-popover bg-popover text-popover-foreground outline-ring/50 flex flex-col overflow-y-auto rounded-md outline-1",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: ()=>{
                    pendingRef.current = true;
                    formRef.current?.requestSubmit();
                },
                children: "Create as pending"
            })
        })
    });
    // ==================== The sheet ====================
    // One layout for every kind: a header (face, title, the one decision, the
    // amount), then lines for date, note, and tags and fields, then the bank
    // lines being used. Payee, category, transfer type, and tags and fields
    // each open as a second screen on the sheet.
    const payeeLogos = (0, $5474523a6079f1bc$export$8be0d3de9c92b14f)();
    const [screen, setScreen] = $acw62.useState(expandBenefit === true && attachmentsEligible ? 'tags' : null);
    const [openLine, setOpenLine] = $acw62.useState(null);
    const toggleLine = (line)=>setOpenLine((current)=>current === line ? null : line);
    // What the bank said, before anyone changed it: the default the date line
    // reads quietly against.
    const initialDate = $acw62.useMemo(()=>transactions.length > 0 ? (0, $63618293c58b5f80$exports.DateTime).min(...transactions.map((t)=>(0, $0c0f91b069db95d9$export$6b862160d295c8e)(t.date))) : (0, $63618293c58b5f80$exports.DateTime).local(), [
        transactions
    ]);
    const dateEntered = !properties.date.hasSame(initialDate, 'day');
    // History's picks, for the screens' "This merchant" sections.
    const dedupe = (items)=>{
        const seen = new Set();
        return items.filter((i)=>i.name !== '' && !seen.has(i.name) && seen.add(i.name));
    };
    // A payee is counted across its categories, a category by its own option.
    const payeeDetailOf = (s)=>`${s.payeeMatchCount} of ${s.totalCount}`;
    const detailOf = (s)=>`${s.matchCount} of ${s.totalCount}`;
    const payeeSuggestions = dedupe(suggestions.map((s)=>({
            name: s.payee,
            detail: payeeDetailOf(s)
        })));
    const categorySuggestions = dedupe(suggestions.map((s)=>({
            name: s.categoryName,
            detail: detailOf(s)
        })));
    // The provenance of the payee actually filled in.
    const filledPayeeSuggestion = suggestions.find((s)=>s.payee === autoApplied?.payee);
    const filledPayeeDetail = filledPayeeSuggestion != null ? payeeDetailOf(filledPayeeSuggestion) : undefined;
    // Picking by hand owns the field from then on (see editedFieldsRef), and
    // drops its "from history" mark.
    const pickPayee = (payee)=>{
        editedFieldsRef.current.payee = true;
        setAutoApplied((prev)=>prev == null ? prev : {
                ...prev,
                payee: undefined
            });
        setProperties((prev)=>({
                ...prev,
                payee: payee
            }));
        setScreen(null);
    };
    const pickCategory = (category)=>{
        editedFieldsRef.current.category = true;
        setAutoApplied((prev)=>prev == null ? prev : {
                ...prev,
                category: undefined
            });
        setProperties((prev)=>({
                ...prev,
                category: (0, $f8f45ddea4959097$exports.some)(category)
            }));
        setScreen(null);
    };
    // The accounts a transfer or conversion moves money between.
    const fromRaw = transactions.find((t)=>t.amount < 0) ?? transactions[0];
    // The second face shows another account, even when the first landing row
    // shares the source's.
    const toRaw = transactions.find((t)=>t.amount > 0 && t.account._id !== fromRaw?.account._id) ?? transactions.find((t)=>t.account._id !== fromRaw?.account._id) ?? transactions[transactions.length - 1];
    // Every account a predicate's rows touch: a transfer may draw from, or
    // land in, several, and the header has to say so rather than name the first.
    const accountsWhere = (pick)=>[
            ...new Map(transactions.filter(pick).map((t)=>[
                    t.account._id,
                    t.account.name
                ])).values()
        ];
    const sameAccount = new Set(transactions.map((t)=>t.account._id)).size === 1;
    const sideLabel = (names)=>names.length === 1 ? names[0] : `${names.length} accounts`;
    const accountFaces = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "relative size-10 shrink-0",
        children: [
            fromRaw && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd8122ba7d7dc8$export$a519fd59e714bf50), {
                account: fromRaw.account,
                className: "absolute top-0 left-0 size-7 rounded-lg shadow-[0_0_0_2px_var(--background)]"
            }),
            toRaw && !sameAccount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd8122ba7d7dc8$export$a519fd59e714bf50), {
                account: toRaw.account,
                className: "absolute right-0 bottom-0 size-7 rounded-lg shadow-[0_0_0_2px_var(--background)]"
            })
        ]
    });
    // ---- Header content by kind ----
    let face;
    let title;
    let sub;
    let amount;
    let amountDetail = null;
    let decision;
    if (!isBalanced) {
        face = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$a0afa665fb89834), {
            name: properties.payee,
            logo: payeeLogos.get(properties.payee)
        });
        title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            onClick: ()=>setScreen('payee'),
            className: "hover:bg-muted -mx-1.5 flex min-w-0 cursor-pointer items-start gap-1 rounded-lg px-1.5 text-left",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('line-clamp-2 min-w-0 text-[17px] leading-tight font-semibold break-words', properties.payee === '' && 'text-muted-foreground font-medium'),
                    children: properties.payee === '' ? 'Add payee' : properties.payee
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                    className: "mt-0.5 size-3.5 shrink-0 text-blue-600 dark:text-blue-400"
                })
            ]
        });
        sub = autoApplied?.payee != null && autoApplied.payee === properties.payee ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$ae48ab4d12d567be), {
            detail: filledPayeeDetail
        }) : transactions[0]?.account.name;
        amount = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
            variant: "plain",
            amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(allocatedNet, currency)
        });
        amountDetail = transactions.length > 1 ? `${transactions.length} lines` : singleRaw != null && allocationAbs(singleRaw) !== Math.abs(remainingOf(singleRaw)) ? `of ${formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(remainingOf(singleRaw), singleRaw.currency))}` : null;
        const category = properties.category.getOrElse('');
        decision = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$98a92a03d6411c29), {
            onClick: ()=>setScreen('category'),
            leading: category !== '' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($814f8eff791eb91e$var$CategoryPillAvatar, {
                name: category
            }) : undefined,
            children: category === '' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground",
                children: "Choose category"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('truncate', autoApplied?.category === category ? '' : 'font-semibold'),
                        children: category
                    }),
                    autoApplied?.category === category && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$ae48ab4d12d567be), {})
                ]
            })
        });
    } else if (isConversion) {
        const [outLeg, inLeg] = conversionLegs;
        face = accountFaces;
        title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "line-clamp-2 text-[17px] leading-tight font-semibold",
            children: [
                "To ",
                sideLabel(accountsWhere((t)=>t.currency === inLeg?.[0]))
            ]
        });
        sub = `From ${sideLabel(accountsWhere((t)=>t.currency === outLeg?.[0]))}`;
        amount = inLeg ? formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(inLeg[1], inLeg[0])) : null;
        amountDetail = outLeg ? formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(outLeg[1]), outLeg[0])) : null;
        decision = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$98a92a03d6411c29), {
            fixed: true,
            leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7a15ad94ac6a08$export$f7121fe80f407126), {
                type: (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion
            }),
            children: (0, $d906535d40bd11c1$export$e5f08023f111098c)[(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion]
        });
    } else {
        const moved = transactions.filter((t)=>t.amount > 0).reduce((sum, t)=>sum + allocationAbs(t), 0);
        face = accountFaces;
        title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "line-clamp-2 text-[17px] leading-tight font-semibold",
            children: sameAccount ? fromRaw?.account.name : `To ${sideLabel(accountsWhere((t)=>t.amount > 0))}`
        });
        sub = sameAccount ? `${transactions.length} lines` : `From ${sideLabel(accountsWhere((t)=>t.amount < 0))}`;
        amount = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
            variant: "plain",
            amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(moved, currency)
        });
        const suggestedApplied = transferType != null && transferType === suggestedTransferType && !transferTypeManuallyChanged.current;
        decision = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$98a92a03d6411c29), {
            onClick: ()=>setScreen('type'),
            leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7a15ad94ac6a08$export$f7121fe80f407126), {
                type: transferType
            }),
            children: transferType == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground",
                children: "Choose type"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('truncate', suggestedApplied ? '' : 'font-semibold'),
                        children: (0, $d906535d40bd11c1$export$e5f08023f111098c)[transferType]
                    }),
                    suggestedApplied && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$ae48ab4d12d567be), {})
                ]
            })
        });
    }
    // What stops Create, said where it's seen.
    const problem = mixedCurrency ? 'Pick lines in one currency, or in two for a conversion.' : isConversion && !conversionLegsValid ? foreignLegSpansAccounts ? "One conversion per wallet \u2014 split this into separate conversions." : 'The two sides must move in opposite directions.' : !isConversion && isBalanced && transferSpansDestinations ? "One destination per transfer \u2014 split this into separate transfers." : !isConversion && isBalanced && allocationsValid && allocatedNet !== 0 ? `These lines are ${formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(allocatedNet, currency))} off from netting to zero.` : null;
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-3 pb-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-x-3 gap-y-0.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "row-span-2 flex",
                        children: face
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "min-w-0",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        size: "icon",
                        onClick: onRequestClose,
                        "aria-label": "Close",
                        className: "row-span-2 -mr-2 self-start",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                            className: "size-4"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground min-w-0 truncate text-[12.5px]",
                        children: sub
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3",
                children: [
                    decision,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex flex-col items-end",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-2xl font-semibold tracking-tight whitespace-nowrap tabular-nums",
                                children: amount
                            }),
                            amountDetail != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground text-[12.5px] whitespace-nowrap tabular-nums",
                                children: amountDetail
                            })
                        ]
                    })
                ]
            }),
            problem != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-destructive/10 text-destructive rounded-lg px-3 py-2 text-sm",
                children: problem
            })
        ]
    });
    // ---- Lines ----
    const quickDates = [
        [
            initialDate.toFormat('LLL d'),
            initialDate
        ],
        [
            'Today',
            (0, $63618293c58b5f80$exports.DateTime).local().startOf('day')
        ],
        [
            'Yesterday',
            (0, $63618293c58b5f80$exports.DateTime).local().startOf('day').minus({
                days: 1
            })
        ]
    ];
    const fieldNames = new Map((fieldsData?.allFields ?? []).map((field)=>[
            field._id,
            field.name
        ]));
    const tagSummary = [
        ...properties.tags.map((t)=>({
                key: `tag:${t}`,
                label: t
            })),
        // Each field as it reads on the tags screen: its name, then its value.
        ...Object.entries(properties.fieldValues).map(([fieldId, value])=>({
                key: `field:${fieldId}`,
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-muted-foreground",
                            children: [
                                fieldNames.get(fieldId) ?? 'Field',
                                ":"
                            ]
                        }),
                        ' ',
                        value
                    ]
                })
            })),
        // Only what will actually be linked: an allocation edit can make the
        // selection ineligible, and submit then drops the benefit.
        ...attachmentsEligible && attachedBenefit != null ? [
            {
                key: 'benefit',
                label: attachedBenefit.benefit.name
            }
        ] : [],
        ...feePeriodSourceAvailable && feePeriodDraft != null ? [
            {
                key: 'fee',
                label: 'Fee period'
            }
        ] : []
    ];
    const lines = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border divide-border border-y [&>*+*]:border-t",
        children: [
            isBalanced && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$b25f334b2bd41010), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$a0afa665fb89834), {
                    name: properties.payee,
                    logo: payeeLogos.get(properties.payee),
                    className: "size-5 rounded-md text-[10px]"
                }),
                onClick: ()=>setScreen('payee'),
                toScreen: true,
                children: properties.payee === '' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    children: "Add payee"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: (0, $5474523a6079f1bc$export$86f1a7fa7c9640cb)(true),
                    children: properties.payee
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$b25f334b2bd41010), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $beb58fc2118025b6$export$2e2bcd8739ae039), {}),
                        onClick: ()=>toggleLine('date'),
                        open: openLine === 'date',
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: (0, $5474523a6079f1bc$export$86f1a7fa7c9640cb)(dateEntered),
                            children: properties.date.toFormat('LLL d, yyyy')
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$49bd1dfb0ad29c40), {
                        open: openLine === 'date',
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "no-scrollbar flex items-center gap-2 overflow-x-auto",
                            children: [
                                quickDates.map(([label, date])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            setProperties((prev)=>({
                                                    ...prev,
                                                    date: date
                                                }));
                                            setOpenLine(null);
                                        },
                                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('border-border shrink-0 cursor-pointer rounded-full border px-3 py-1.5 text-sm', properties.date.hasSame(date, 'day') && 'bg-primary text-primary-foreground border-primary'),
                                        children: label
                                    }, label)),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "shrink-0",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                        selectedDate: properties.date,
                                        onChange: handleChange('date')
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$c444937f05de96f3), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $420bac4ddd218a80$export$2e2bcd8739ae039), {}),
                value: properties.description,
                onChange: handleChange('description'),
                placeholder: "Add a note",
                // Editing the note closes the date's shortcuts, as switching lines did.
                onFocus: ()=>setOpenLine(null)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$b25f334b2bd41010), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76c2bea761476961$export$2e2bcd8739ae039), {}),
                onClick: ()=>setScreen('tags'),
                toScreen: true,
                wrap: true,
                children: tagSummary.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    children: "Tags and fields"
                }) : tagSummary.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "bg-muted border-border max-w-full truncate rounded-full border px-2 py-0.5 text-[13px] font-medium",
                        children: t.label
                    }, t.key))
            })
        ]
    });
    // ---- The bank lines being used ----
    const snapshots = $acw62.useRef({});
    const bankLine = (t)=>{
        const error = allocationError(t);
        const remaining = Math.abs(remainingOf(t));
        const signed = Math.sign(t.amount) * allocationAbs(t);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$8c257576c1ad093f), {
            description: t.description,
            account: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c0f56add137aac0$export$42a331aab32dea1), {
                account: t.account
            }),
            date: (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(t.date),
            display: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                variant: "plain",
                amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(signed, t.currency)
            }),
            partial: allocationAbs(t) !== remaining,
            detail: `of ${formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.sign(t.amount) * remaining, t.currency))}`,
            error: error === 'over' ? `At most ${formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(remaining, t.currency))}` : error === 'empty' ? 'Enter an amount' : null,
            onOpen: ()=>{
                snapshots.current[t._id] = allocations[t._id] ?? (0, $f8f45ddea4959097$exports.none);
            },
            onCancel: ()=>setAllocations((prev)=>({
                        ...prev,
                        [t._id]: snapshots.current[t._id] ?? prev[t._id]
                    })),
            onReset: ()=>setAllocations((prev)=>({
                        ...prev,
                        [t._id]: (0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(remaining, t.currency))
                    })),
            editor: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                    autoFocus: true,
                    value: allocations[t._id] ?? (0, $f8f45ddea4959097$exports.none),
                    onChange: (value)=>setAllocations((prev)=>({
                                ...prev,
                                [t._id]: value
                            })),
                    textAlign: "right",
                    currency: t.currency
                })
        }, t._id);
    };
    const bankLines = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-1.5 pt-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground flex justify-between px-1 text-xs font-semibold tracking-wider uppercase",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: transactions.length === 1 ? 'From' : `${transactions.length} bank lines`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "Using"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-muted/40 border-border overflow-hidden rounded-xl border",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "divide-border [&>*+*]:border-t",
                    children: transactions.map(bankLine)
                })
            }),
            transactions.length > 1 && !isBalanced && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-between px-1 pt-1 text-sm font-semibold",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "Total"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                        variant: "plain",
                        amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(allocatedNet, currency)
                    })
                ]
            })
        ]
    });
    // ---- Second screens ----
    const renderScreen = (key)=>{
        if (key === 'payee') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7a15ad94ac6a08$export$ac7b0e68191845f3), {
            title: "Payee",
            value: properties.payee,
            suggested: isBalanced ? [] : payeeSuggestions,
            logos: payeeLogos,
            onPick: isBalanced ? (payee)=>{
                setProperties((prev)=>({
                        ...prev,
                        payee: payee
                    }));
                setScreen(null);
            } : pickPayee,
            // A transfer's payee is optional, so it can be taken away again.
            onClear: isBalanced && properties.payee !== '' ? ()=>{
                setProperties((prev)=>({
                        ...prev,
                        payee: ''
                    }));
                setScreen(null);
            } : undefined,
            onBack: ()=>setScreen(null)
        });
        if (key === 'category') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7a15ad94ac6a08$export$915de2b652348ee), {
            value: properties.category.getOrElse('') || null,
            suggested: categorySuggestions,
            onPick: pickCategory,
            onBack: ()=>setScreen(null)
        });
        if (key === 'type') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7a15ad94ac6a08$export$9af25aa19ef1c6c9), {
            value: transferType,
            suggested: suggestedTransferType,
            onPick: (type)=>{
                handleTransferTypeChange(type);
                setScreen(null);
            },
            onBack: ()=>setScreen(null)
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$5b7eb98d0fc5016b), {
            title: "Tags and fields",
            onBack: ()=>setScreen(null),
            trailing: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setScreen(null),
                className: "cursor-pointer text-sm font-semibold text-blue-600 dark:text-blue-400",
                children: "Done"
            }),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d5b27e6036e5285$export$470985d1a1ba634f), {
                variant: "screen",
                tags: properties.tags,
                fieldValues: properties.fieldValues,
                onChange: (tags, fieldValues)=>setProperties((prev)=>({
                            ...prev,
                            tags: tags,
                            fieldValues: fieldValues
                        })),
                attachmentPills: attachmentPills,
                attachmentBlocks: attachmentBlocks,
                attachmentCandidates: attachmentCandidates
            })
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex w-full gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || submitting || !canSubmit,
                className: "flex-1 py-3 text-base",
                children: "Create"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $497d44d806a05c0a$export$2e2bcd8739ae039), {
                open: dropdownOpen,
                popoverContents: dropdownContent,
                popoverAnchor: "above-right",
                onOutsideClick: closeDropdown,
                children: (anchorRef)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        ref: anchorRef,
                        variant: "outline",
                        disabled: loading || submitting || !canSubmit,
                        onClick: toggleDropdown,
                        "aria-label": "More ways to create",
                        className: "px-3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b698d1771218a1ca$export$2e2bcd8739ae039), {
                            className: "size-4"
                        })
                    })
            })
        ]
    });
    // A follow-up write failed after the transaction was created: the raws are
    // consumed and the list already updated, so the only path forward is
    // acknowledging what still needs doing by hand. Mirrors the terminal state
    // the standalone benefit flow had.
    if (followUpError != null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Transaction created",
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
            variant: "primary",
            onClick: onRequestClose,
            children: "Close"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "text-destructive text-sm",
            children: followUpError
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        label: "New transaction",
        onRequestClose: onRequestClose,
        // On a phone, a sheet as tall as what it holds rather than the whole
        // screen; a centered dialog from sm up, as before.
        className: "top-auto bottom-0 h-auto max-h-[92dvh] rounded-b-none sm:rounded-b-lg",
        footer: screen == null ? footer : undefined,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
            id: formId,
            ref: formRef,
            // A second screen has no Create: Enter in its search box must not
            // submit the transaction behind it.
            onSubmit: (event)=>{
                if (screen != null) {
                    event.preventDefault();
                    return;
                }
                handleSubmit(event);
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$26da3dced10d02f0), {
                screen: screen,
                renderScreen: renderScreen,
                main: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        header,
                        lines,
                        bankLines
                    ]
                })
            })
        })
    });
};
/** A category's avatar, sized for the decision pill. */ const $814f8eff791eb91e$var$CategoryPillAvatar = ({ name: name })=>{
    const { data: data } = (0, $ce9d9e524be20f53$export$1f9e2535d0d42ab9)();
    const category = data?.allCategories.find((c)=>c.name === name) ?? {
        name: name
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6080e81c2b9604e9$export$bde99f6bf04aeea3), {
        category: category,
        className: "size-6 rounded-md max-md:size-6"
    });
};





parcelRequire("acw62");

const $3ff5f25c2c39fdc0$export$392c6f1c86e066f1 = (store, accounts)=>{
    const _data = store.readQuery({
        query: (0, $ce9d9e524be20f53$export$2f2991a875f1875d)
    });
    store.writeQuery({
        query: (0, $ce9d9e524be20f53$export$2f2991a875f1875d),
        data: {
            allAccounts: accounts
        }
    });
};




const $c82683fe303f89d0$export$92d028d636262c3b = (props)=>{
    const { account: account, onRequestClose: onRequestClose } = props;
    const [deleteAccount, { loading: loading }] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$843997ec67648183));
    const handleDelete = (event)=>{
        event.preventDefault();
        deleteAccount({
            variables: {
                accountId: account._id
            },
            update: (store, result)=>{
                const updatedAccounts = result.data?.deleteAccount;
                if (updatedAccounts) (0, $3ff5f25c2c39fdc0$export$392c6f1c86e066f1)(store, updatedAccounts);
            }
        }).then(()=>{
            props.onDeleted?.(account);
            onRequestClose();
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                type: "submit",
                onClick: handleDelete,
                disabled: loading,
                children: "Delete account"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Delete account",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                "Are you sure you want to delete ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: account.name
                }),
                "? This action cannot be undone."
            ]
        })
    });
};






var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

const $6e054dd754d7f7b3$var$RawTransactionList = ({ transactions: transactions, selectedIds: selectedIds = [], className: className, onClick: onClick, onLongPress: onLongPress, showProcessedStatus: showProcessedStatus = false, renderAmount: renderAmount, copyDescription: copyDescription = false, selectMode: selectMode })=>{
    const selectedIdSet = $acw62.useMemo(()=>new Set(selectedIds), [
        selectedIds
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: className,
        children: transactions.map((transaction)=>{
            const isSelected = selectedIdSet.has(transaction._id);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $767675606e144a8e$export$e044a1597fe6ccb0), {
                rawTransaction: transaction,
                selected: isSelected,
                onClick: onClick ? ()=>onClick(transaction) : undefined,
                href: onClick || renderAmount ? undefined : `/raw-transactions/${transaction._id}`,
                onLongPress: ()=>onLongPress && onLongPress(transaction),
                showProcessedStatus: showProcessedStatus,
                renderAmount: renderAmount,
                copyDescription: copyDescription,
                selectMode: selectMode
            }, transaction._id);
        })
    });
};
var $6e054dd754d7f7b3$export$2e2bcd8739ae039 = $6e054dd754d7f7b3$var$RawTransactionList;



const $3697c265fe0f835f$export$557dd6d24ce47eb3 = (props)=>{
    const [deleteRawTransaction, { loading: loading }] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$4e7cd97bb89476ed), {
        // The delete clears benefit links server-side (changing benefits'
        // computed usage), and a deleted row may also back a fee period as its
        // charge — which the fragment cannot see. Drop cached fee period
        // queries unconditionally, the same way link/unlink do.
        update: (0, $a9d94318500ad031$export$260983a97254aea6)
    });
    const [error, setError] = $acw62.useState(null);
    const handleDelete = ()=>{
        const ids = props.rawTransactions.map((rt)=>rt._id);
        setError(null);
        deleteRawTransaction({
            variables: {
                ids: ids
            }
        }).then(()=>{
            props.onRequestClose();
            props.onDelete(ids);
        }).catch((e)=>{
            setError(e instanceof Error ? e.message : 'Failed to delete.');
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: props.onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                onClick: handleDelete,
                disabled: loading,
                children: "Delete"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        header: "Confirm delete",
        onRequestClose: props.onRequestClose,
        footer: footer,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e054dd754d7f7b3$export$2e2bcd8739ae039), {
                transactions: props.rawTransactions
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-destructive mt-2 text-sm",
                children: error
            })
        ]
    });
};





parcelRequire("acw62");


const $9913936085049f24$var$formatDateString = (isoDate)=>{
    return (0, $0c0f91b069db95d9$export$6b862160d295c8e)(isoDate).toLocaleString({
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};
const $9913936085049f24$export$badab396be9b4ab9 = (props)=>{
    const { snapshot: snapshot, onRequestClose: onRequestClose } = props;
    const [deleteAnchor, { loading: deletingAnchor }] = (0, $ce9d9e524be20f53$export$b24be224d4f4a7fe)();
    const [deleteReading, { loading: deletingReading }] = (0, $ce9d9e524be20f53$export$c78712a61e8c6f22)();
    const loading = deletingAnchor || deletingReading;
    const handleDelete = (event)=>{
        event.preventDefault();
        const remove = snapshot.source === 'plaid' ? deleteReading({
            variables: {
                readingId: snapshot._id
            }
        }) : deleteAnchor({
            variables: {
                anchorId: snapshot._id
            }
        });
        remove.then(()=>{
            props.onDeleted?.();
            onRequestClose();
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                type: "submit",
                onClick: handleDelete,
                disabled: loading,
                children: "Delete snapshot"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Delete snapshot",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                "Are you sure you want to delete the snapshot for",
                ' ',
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: $9913936085049f24$var$formatDateString(snapshot.date)
                }),
                "? This action cannot be undone."
            ]
        })
    });
};






var $acw62 = parcelRequire("acw62");


const $7a0ee1611edf193c$export$7f1cdd4d2b7449b3 = (props)=>{
    const { transactionId: transactionId, onReset: onReset, onRequestClose: onRequestClose } = props;
    const [resetTransaction, { loading: loading }] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$496cb29f911ae157));
    const [error, setError] = $acw62.useState(null);
    const handleReset = async ()=>{
        setError(null);
        try {
            await resetTransaction({
                variables: {
                    id: transactionId
                }
            });
            onReset?.();
            onRequestClose();
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Failed to reset transaction');
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                onClick: ()=>void handleReset(),
                disabled: loading,
                children: loading ? 'Resetting...' : 'Reset'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Reset transaction",
        footer: footer,
        size: "sm",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-destructive/10 text-destructive mb-3 rounded-md p-3 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Are you sure you want to reset this transaction? It will be deleted and its raw transactions returned to the inbox."
            })
        ]
    });
};








var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



const $2974c03a106114e7$export$27772d5b36d5ef3a = ({ accountId: accountId })=>{
    const { data: accountData, refetch: refetchAccount } = (0, $ce9d9e524be20f53$export$83a5bf0e4425c554)({
        variables: {
            id: accountId
        },
        fetchPolicy: 'cache-and-network'
    });
    const account = accountData?.account;
    const closingAnchorId = account?.closingAnchorId ?? null;
    const { data: anchorsData, refetch: refetchAnchors } = (0, $ce9d9e524be20f53$export$4b244df86d92b624)({
        variables: {
            accountId: accountId
        },
        fetchPolicy: 'cache-and-network'
    });
    const anchors = anchorsData?.balanceAnchors ?? [];
    const closingAnchor = anchors.find((a)=>a._id === closingAnchorId) ?? null;
    // Gate all controls until both queries have resolved: acting before the
    // network lands could miss an existing designation (offering "close" on an
    // already-closed account) or clobber an unloaded anchor on the chosen date.
    const ready = account != null && anchorsData?.balanceAnchors != null;
    const [date, setDate] = $acw62.useState((0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)());
    const [error, setError] = $acw62.useState(null);
    const [recordAnchor, { loading: recording }] = (0, $ce9d9e524be20f53$export$3a0b388d2d812ec5)();
    const [setClosingAnchor, { loading: setting }] = (0, $ce9d9e524be20f53$export$2c19470a6f45d0b2)();
    const [deleteAnchor] = (0, $ce9d9e524be20f53$export$b24be224d4f4a7fe)();
    const busy = recording || setting;
    const handleClose = async ()=>{
        setError(null);
        if (!ready) return;
        const iso = date.toISODate();
        if (!iso) {
            setError('Pick a valid closing date');
            return;
        }
        // recordBalanceAnchor upserts by (account, date): if an anchor already
        // exists on this date, its balance/source is overwritten. Capture the
        // prior values so a refused designation can be fully reverted.
        const prior = anchors.find((a)=>a.date === iso) ?? null;
        try {
            const recorded = await recordAnchor({
                variables: {
                    accountId: accountId,
                    date: iso,
                    balance: 0,
                    source: 'manual'
                }
            });
            const anchorId = recorded.data?.recordBalanceAnchor._id;
            if (!anchorId) throw new Error('Failed to record closing balance');
            try {
                await setClosingAnchor({
                    variables: {
                        accountId: accountId,
                        anchorId: anchorId
                    }
                });
            } catch (designationErr) {
                // Revert the write so a rejected designation changes nothing: delete
                // a freshly created anchor, or restore a pre-existing one's values.
                if (prior) await recordAnchor({
                    variables: {
                        accountId: accountId,
                        date: iso,
                        balance: prior.balance,
                        source: prior.source
                    }
                }).catch(()=>undefined);
                else await deleteAnchor({
                    variables: {
                        anchorId: anchorId
                    }
                }).catch(()=>undefined);
                throw designationErr;
            }
            await Promise.all([
                refetchAccount(),
                refetchAnchors()
            ]);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to close the account');
        }
    };
    const handleReopen = async ()=>{
        setError(null);
        try {
            // Clears the designation only — the $0 anchor stays as history.
            await setClosingAnchor({
                variables: {
                    accountId: accountId,
                    anchorId: null
                }
            });
            await Promise.all([
                refetchAccount(),
                refetchAnchors()
            ]);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to reopen the account');
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border flex flex-col gap-3 rounded-md border p-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-medium",
                        children: "Closed"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-sm",
                        children: "Mark the account closed: a $0 balance on its final date, after which nothing can be added. The balance renders as zero from then on. Reconciliation stays available for the history inside."
                    })
                ]
            }),
            !ready ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground text-sm",
                children: "Loading\u2026"
            }) : closingAnchorId != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-sm",
                        children: [
                            "Closed",
                            closingAnchor ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    ' ',
                                    "on ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-medium",
                                        children: closingAnchor.date
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        disabled: setting,
                        onClick: ()=>void handleReopen(),
                        children: "Reopen"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                        label: "Closing date",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                            selectedDate: date,
                            onChange: setDate
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            disabled: busy,
                            onClick: ()=>void handleClose(),
                            children: "Mark account closed"
                        })
                    })
                ]
            }),
            error != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-destructive text-sm",
                children: error
            })
        ]
    });
};












/**
 * Set (or clear) the account's opening balance: a $0 balance anchor on its
 * inception date that attests the record is complete before it. The opener is
 * always zero — the account began empty, and the first deposit is a
 * transaction after it; an account whose early history is missing simply gets
 * no opener. Self-contained (fetches its own state and commits immediately)
 * rather than folded into the modal's deferred Save, because setting it is a
 * two-step create-then-designate that rolls back the created anchor if the
 * designation is refused.
 */ const $31d3dee7ad01891b$var$OpeningBalanceSection = ({ accountId: accountId })=>{
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const { data: accountData, refetch: refetchAccount } = (0, $ce9d9e524be20f53$export$83a5bf0e4425c554)({
        variables: {
            id: accountId
        },
        fetchPolicy: 'cache-and-network'
    });
    const account = accountData?.account;
    const currency = account?.currency ?? 'USD';
    const isCreditCard = account?.__typename === 'DepositoryAccount' && account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard;
    const openingAnchorId = account?.__typename === 'DepositoryAccount' ? account.openingAnchorId : null;
    const { data: anchorsData, refetch: refetchAnchors } = (0, $ce9d9e524be20f53$export$4b244df86d92b624)({
        variables: {
            accountId: accountId
        },
        fetchPolicy: 'cache-and-network'
    });
    const anchors = anchorsData?.balanceAnchors ?? [];
    const openingAnchor = anchors.find((a)=>a._id === openingAnchorId) ?? null;
    // Gate all controls until both queries have resolved. Opened from the
    // accounts list / side nav, the cached account entry (AccountListItem) has no
    // openingAnchorId, so cache-and-network yields no account until the network
    // lands: acting in that window would see no existing opener (clobbering an
    // unloaded one).
    const ready = account != null && anchorsData?.balanceAnchors != null;
    const [date, setDate] = $acw62.useState((0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)());
    const [error, setError] = $acw62.useState(null);
    const [recordAnchor, { loading: recording }] = (0, $ce9d9e524be20f53$export$3a0b388d2d812ec5)();
    const [setOpeningAnchor, { loading: setting }] = (0, $ce9d9e524be20f53$export$ab9ffb3bbc50f2da)();
    const [deleteAnchor] = (0, $ce9d9e524be20f53$export$b24be224d4f4a7fe)();
    const busy = recording || setting;
    const handleSet = async ()=>{
        setError(null);
        if (!ready) return;
        const iso = date.toISODate();
        if (!iso) {
            setError('Pick a valid start date');
            return;
        }
        // The opener must be the account's earliest point. Refuse a date that
        // already has an earlier anchor here (the server also rejects earlier
        // transactions and Plaid readings); surface that as a friendly message
        // before creating anything.
        const earlier = anchors.find((a)=>a.date < iso);
        if (earlier) {
            setError(`An earlier balance exists on ${earlier.date}. The opening balance ` + 'must be the earliest point on the account.');
            return;
        }
        // recordBalanceAnchor upserts by (account, date): if an anchor already
        // exists on this date, its balance/source is overwritten. Capture the prior
        // values so a refused designation can be fully reverted — otherwise a
        // failed set would silently leave that pre-existing balance changed.
        const prior = anchors.find((a)=>a.date === iso) ?? null;
        try {
            const recorded = await recordAnchor({
                variables: {
                    accountId: accountId,
                    date: iso,
                    balance: 0,
                    source: 'manual'
                }
            });
            const anchorId = recorded.data?.recordBalanceAnchor._id;
            if (!anchorId) throw new Error('Failed to record opening balance');
            try {
                await setOpeningAnchor({
                    variables: {
                        accountId: accountId,
                        anchorId: anchorId
                    }
                });
            } catch (designationErr) {
                // Revert the write so a rejected designation changes nothing: delete a
                // freshly created anchor, or restore a pre-existing one's prior values.
                if (prior) await recordAnchor({
                    variables: {
                        accountId: accountId,
                        date: iso,
                        balance: prior.balance,
                        source: prior.source
                    }
                }).catch(()=>undefined);
                else await deleteAnchor({
                    variables: {
                        anchorId: anchorId
                    }
                }).catch(()=>undefined);
                throw designationErr;
            }
            await Promise.all([
                refetchAccount(),
                refetchAnchors()
            ]);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to set opening balance');
        }
    };
    const handleClear = async ()=>{
        setError(null);
        try {
            await setOpeningAnchor({
                variables: {
                    accountId: accountId,
                    anchorId: null
                }
            });
            await Promise.all([
                refetchAccount(),
                refetchAnchors()
            ]);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to clear opening balance');
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border flex flex-col gap-3 rounded-md border p-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-medium",
                        children: "Opening balance"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-sm",
                        children: "Mark the account's start: a $0 balance on the date it began, below which history is complete. The first deposit is a transaction after it. If early history is missing, leave this unset."
                    })
                ]
            }),
            !ready ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground text-sm",
                children: "Loading\u2026"
            }) : openingAnchor ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-sm",
                        children: [
                            "Set to ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium",
                                children: openingAnchor.date
                            }),
                            " \xb7",
                            ' ',
                            formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
                                amount: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(openingAnchor.balance, isCreditCard),
                                currency: currency
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        disabled: setting,
                        onClick: ()=>void handleClear(),
                        children: "Clear"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                        label: "Start date",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                            selectedDate: date,
                            onChange: setDate
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            disabled: busy,
                            onClick: ()=>void handleSet(),
                            children: "Set opening balance ($0)"
                        })
                    })
                ]
            }),
            error != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-destructive text-sm",
                children: error
            })
        ]
    });
};
const $31d3dee7ad01891b$export$fa97ad412db87be1 = (props)=>{
    const formId = $acw62.useId();
    const { account: account, onRequestClose: onRequestClose } = props;
    const [name, setName] = $acw62.useState(account.name);
    const [depositoryType, setDepositoryType] = $acw62.useState(account.depositoryType);
    const [logo, setLogo] = $acw62.useState(account.logo ?? '');
    const [cardProduct, setCardProduct] = $acw62.useState(account.cardProduct ?? '');
    const [trackBalance, setTrackBalance] = $acw62.useState(account.trackBalance ?? false);
    const [updateAccount, { loading: updateLoading }] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$93133a4bb03cc76));
    const [deleteAccount, { loading: deleteLoading }] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$843997ec67648183));
    const [error, setError] = $acw62.useState(null);
    const hasChanges = name !== account.name || depositoryType !== account.depositoryType || logo !== (account.logo ?? '') || cardProduct !== (account.cardProduct ?? '') || trackBalance !== (account.trackBalance ?? false);
    const handleSubmit = (e)=>{
        e.preventDefault();
        setError(null);
        updateAccount({
            variables: {
                id: account._id,
                name: name,
                depositoryType: depositoryType,
                logo: logo || null,
                // Only sent when touched: a caller whose account shape predates
                // the field would otherwise clear it on every unrelated save
                cardProduct: cardProduct !== (account.cardProduct ?? '') ? cardProduct || null : undefined,
                trackBalance: trackBalance
            }
        }).then(()=>{
            props.onUpdate?.();
            onRequestClose();
        }).catch((err)=>{
            setError(err instanceof Error ? err.message : 'Failed to save');
        });
    };
    const handleAccountTypeChange = (e)=>{
        const { value: value } = e.target;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        setDepositoryType(value);
    };
    const handleDelete = ()=>{
        deleteAccount({
            variables: {
                accountId: account._id
            },
            update: (store, result)=>{
                const newAccounts = result?.data?.deleteAccount;
                if (newAccounts) (0, $3ff5f25c2c39fdc0$export$392c6f1c86e066f1)(store, newAccounts);
            }
        }).then(()=>{
            props.onDelete?.(account);
            onRequestClose();
        }).catch((err)=>{
            // Deletion can be refused server-side (existing transactions, fee
            // periods, an active Plaid connection, …) — surface it instead of
            // failing silently.
            setError(err instanceof Error ? err.message : 'Failed to delete');
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                onClick: handleDelete,
                disabled: deleteLoading,
                children: "Delete"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: updateLoading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: !hasChanges || updateLoading,
                children: "Save"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Edit account",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Name",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        autoFocus: true,
                        value: name,
                        onChange: setName
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Account type",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                        value: depositoryType,
                        onChange: handleAccountTypeChange,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Checking,
                                children: "Checking"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Savings,
                                children: "Savings"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard,
                                children: "Credit Card"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Cash,
                                children: "Cash"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Wallet,
                                children: "Wallet"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Loan,
                                children: "Loan"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Ledger,
                                children: "Ledger"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Other,
                                children: "Other"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7e865dd16cb1aeb$export$6b5b4e301fbd3704), {
                    value: logo,
                    onChange: setLogo
                }),
                depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ec2c374587acf6c$export$44a72c970db1fefb), {
                    value: cardProduct,
                    onChange: setCardProduct
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex cursor-pointer items-center gap-3",
                    onClick: ()=>setTrackBalance(!trackBalance),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93d44a992b7c3d39$export$2e2bcd8739ae039), {
                            value: trackBalance,
                            onChange: setTrackBalance
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-medium",
                                    children: "Track nonzero balance"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground text-sm",
                                    children: "Shows on the inbox while the balance isn't zero \u2014 gift cards, credits, loans."
                                })
                            ]
                        })
                    ]
                }),
                error != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31d3dee7ad01891b$var$OpeningBalanceSection, {
                    accountId: account._id
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2974c03a106114e7$export$27772d5b36d5ef3a), {
                    accountId: account._id
                })
            ]
        })
    });
};






var $acw62 = parcelRequire("acw62");









const $8e359df8738f89aa$export$a4041e40a25c6e66 = (props)=>{
    const { category: category, onRequestClose: onRequestClose } = props;
    const initialIcon = (0, $3076b7ee20dc9ec8$export$409877b2c65a5d)(category.icon);
    const initialColor = (0, $3076b7ee20dc9ec8$export$e700a184e8fe2b12)(category.color);
    const [name, setName] = $acw62.useState(category.name);
    const [icon, setIcon] = $acw62.useState(initialIcon);
    const [color, setColor] = $acw62.useState(initialColor);
    // undefined = untouched (show the stored group); null = "No group"
    const [groupOverride, setGroupOverride] = $acw62.useState(undefined);
    const [updateCategory, { loading: updateLoading }] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$d216fbad2d4d64ac));
    const [deleteCategory, { loading: deleteLoading }] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$83e8f73439ca83fa));
    // groupSaving keeps Save disabled during a group-only save, where
    // updateLoading stays false — otherwise a second submit races two
    // full-array setCategoryGroup writes and the older one can win.
    const [setCategoryGroup, { loading: groupSaving }] = (0, $ce9d9e524be20f53$export$2b522cad18185c8)();
    const { data: groupsData } = (0, $ce9d9e524be20f53$export$9dda77d697c51272)();
    const storedGroupId = (groupsData?.allCategoryGroups || []).find((group)=>group.categoryIds.includes(category._id))?._id ?? null;
    const groupId = groupOverride === undefined ? storedGroupId : groupOverride;
    const groupChanged = groupOverride !== undefined && groupOverride !== storedGroupId;
    const [saveError, setSaveError] = $acw62.useState(null);
    // Separate from groupChanged so a group-only save doesn't resend the
    // ordinary fields with this form's possibly-stale values.
    const fieldsChanged = name !== category.name || icon !== initialIcon || color !== initialColor;
    const hasChanges = fieldsChanged || groupChanged;
    const handleUpdate = (e)=>{
        e.preventDefault();
        if (updateLoading || groupSaving) return;
        setSaveError(null);
        // Sequential on purpose: if these ran concurrently and updateCategory
        // failed (say, a name conflict) while the group change succeeded, the
        // modal would report failure after applying half the save. The group
        // only moves once the field update has committed.
        const save = async ()=>{
            if (fieldsChanged) await updateCategory({
                variables: {
                    name: name,
                    id: category._id,
                    icon: icon,
                    color: color
                }
            });
            if (groupChanged) await setCategoryGroup({
                variables: {
                    categoryId: category._id,
                    groupId: groupId
                },
                update: (cache, result)=>{
                    const updated = result.data?.setCategoryGroup;
                    if (updated) (0, $a5ee6aaf43da69f6$export$f2f1601b72ada50d)(cache, updated);
                }
            });
        };
        save().then(()=>{
            props.onUpdate?.();
            onRequestClose();
        }).catch((err)=>{
            // Keep the modal open and say why, instead of an unhandled
            // rejection with the form silently stuck.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            setSaveError(err.message);
        });
    };
    const handleDelete = ()=>{
        deleteCategory({
            variables: {
                id: category._id
            },
            update: (store)=>{
                (0, $5f9091afcb8d9899$export$77a8937f2ee84f73)(store, category);
                (0, $a5ee6aaf43da69f6$export$b2f5ba7618faddbf)(store, category._id);
            }
        }).then(()=>{
            props.onDelete?.(category);
            onRequestClose();
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                onClick: handleDelete,
                disabled: deleteLoading,
                children: "Delete"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: updateLoading || groupSaving,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                onClick: handleUpdate,
                disabled: !hasChanges || updateLoading || groupSaving,
                children: "Save"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Edit category",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            onSubmit: handleUpdate,
            className: "flex flex-col gap-4",
            children: [
                saveError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: saveError
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Name",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        autoFocus: true,
                        value: name,
                        onChange: setName
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cab135a818cb058$export$7a845b1e34e10b8f), {
                    value: groupId,
                    onChange: setGroupOverride
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Appearance",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ac5bab07fe90e16$export$4ede8238cb83eada), {
                        name: name,
                        icon: icon,
                        color: color,
                        onIconChange: setIcon,
                        onColorChange: setColor
                    })
                })
            ]
        })
    });
};






var $acw62 = parcelRequire("acw62");







// Investment type options with human-readable labels
const $9134f1188f7e50bb$var$INVESTMENT_TYPE_OPTIONS = [
    {
        value: (0, $ce9d9e524be20f53$export$19445fdc19724941).Brokerage,
        label: 'Brokerage'
    },
    {
        value: (0, $ce9d9e524be20f53$export$19445fdc19724941)['401K'],
        label: '401(k)'
    },
    {
        value: (0, $ce9d9e524be20f53$export$19445fdc19724941).Ira,
        label: 'IRA'
    },
    {
        value: (0, $ce9d9e524be20f53$export$19445fdc19724941).RothIra,
        label: 'Roth IRA'
    },
    {
        value: (0, $ce9d9e524be20f53$export$19445fdc19724941).Hsa,
        label: 'HSA'
    },
    {
        value: (0, $ce9d9e524be20f53$export$19445fdc19724941).Education,
        label: '529 plan'
    },
    {
        value: (0, $ce9d9e524be20f53$export$19445fdc19724941).Other,
        label: 'Other'
    }
];
const $9134f1188f7e50bb$export$f528a29e04e91fcb = (props)=>{
    const formId = $acw62.useId();
    const { account: account, onRequestClose: onRequestClose } = props;
    const [name, setName] = $acw62.useState(account.name);
    const [investmentType, setInvestmentType] = $acw62.useState(account.investmentType);
    const [logo, setLogo] = $acw62.useState(account.logo ?? '');
    const [updateAccount, { loading: updateLoading }] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$a0ada81e3f1bb018));
    const [deleteAccount, { loading: deleteLoading }] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$843997ec67648183));
    const [error, setError] = $acw62.useState(null);
    const hasChanges = name !== account.name || investmentType !== account.investmentType || logo !== (account.logo ?? '');
    const handleSubmit = (e)=>{
        e.preventDefault();
        setError(null);
        updateAccount({
            variables: {
                id: account._id,
                name: name,
                investmentType: investmentType,
                logo: logo || null
            }
        }).then(()=>{
            props.onUpdate?.();
            onRequestClose();
        }).catch((err)=>{
            setError(err instanceof Error ? err.message : 'Failed to save');
        });
    };
    const handleDelete = ()=>{
        deleteAccount({
            variables: {
                accountId: account._id
            },
            update: (store, result)=>{
                const newAccounts = result?.data?.deleteAccount;
                if (newAccounts) (0, $3ff5f25c2c39fdc0$export$392c6f1c86e066f1)(store, newAccounts);
                // setAccounts only rewrites AllAccounts. The investments overview
                // reads a separate, cache-first allInvestmentAccounts query, so evict
                // the deleted account to drop its now-dangling row from every cached
                // list (otherwise it lingers, and tapping it hits a missing account).
                const id = store.identify({
                    __typename: 'InvestmentAccount',
                    _id: account._id
                });
                if (id != null) {
                    store.evict({
                        id: id
                    });
                    store.gc();
                }
            }
        }).then(()=>{
            props.onDelete?.(account);
            onRequestClose();
        }).catch((err)=>{
            // Deletion can be refused server-side (e.g. an active Plaid
            // connection) — surface it instead of failing silently.
            setError(err instanceof Error ? err.message : 'Failed to delete');
        });
    };
    const handleInvestmentTypeChange = (e)=>{
        const { value: value } = e.target;
        const validTypes = Object.values((0, $ce9d9e524be20f53$export$19445fdc19724941));
        if (validTypes.includes(value)) // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        setInvestmentType(value);
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                onClick: handleDelete,
                disabled: deleteLoading,
                children: "Delete"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: updateLoading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: !hasChanges || updateLoading,
                children: "Save"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Edit investment account",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Name",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        autoFocus: true,
                        value: name,
                        onChange: setName
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Account type",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                        value: investmentType,
                        onChange: handleInvestmentTypeChange,
                        children: $9134f1188f7e50bb$var$INVESTMENT_TYPE_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                value: opt.value,
                                children: opt.label
                            }, opt.value))
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7e865dd16cb1aeb$export$6b5b4e301fbd3704), {
                    value: logo,
                    onChange: setLogo
                }),
                error != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2974c03a106114e7$export$27772d5b36d5ef3a), {
                    accountId: account._id
                })
            ]
        })
    });
};









var $acw62 = parcelRequire("acw62");














var $acw62 = parcelRequire("acw62");

const $28bb13ba9d3f9376$export$6b8e0f7b9031826 = (transactionId, lineId)=>`/transactions/${transactionId}?line=${encodeURIComponent(lineId)}`;
const $28bb13ba9d3f9376$export$e9809e27349c024d = ({ openCreate: openCreate, allocateOnTap: allocateOnTap = false })=>{
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    // A lookup acts only if nothing happened while it was out: another tap,
    // any other gesture on the list (`cancel`, which useRawRowGestures calls
    // on every one), leaving the view (a filter change moves the URL too), or
    // unmounting all retire it, so a late answer can't pull the user off what
    // they moved on to.
    const latestTap = $acw62.useRef(0);
    const location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    $acw62.useEffect(()=>{
        latestTap.current += 1;
    }, [
        location.key
    ]);
    $acw62.useEffect(()=>()=>{
            latestTap.current += 1;
        }, []);
    const cancel = $acw62.useCallback(()=>{
        latestTap.current += 1;
    }, []);
    const open = $acw62.useCallback((rt)=>{
        const tap = ++latestTap.current;
        if (allocateOnTap) {
            openCreate(rt);
            return;
        }
        client.query({
            query: (0, $ce9d9e524be20f53$export$fd03690d37574f74),
            variables: {
                id: rt._id
            },
            // Allocation changes from many places; a stale answer would open a
            // transaction that no longer holds this line.
            fetchPolicy: 'network-only'
        }).then(({ data: data })=>{
            if (tap !== latestTap.current) return;
            const ids = [
                ...new Set(data.rawTransaction.consumers.map((c)=>c.transactionId))
            ];
            if (ids.length === 0) {
                // Nothing to allocate on a fully consumed line; its page is all
                // there is to open.
                if ((rt.remainingAmount ?? rt.amount) !== 0) openCreate(rt);
                else navigate(`/raw-transactions/${rt._id}`);
                return;
            }
            navigate(ids.length === 1 ? $28bb13ba9d3f9376$export$6b8e0f7b9031826(ids[0], rt._id) : `/raw-transactions/${rt._id}`);
        }).catch(()=>{
            if (tap === latestTap.current) navigate(`/raw-transactions/${rt._id}`);
        });
    }, [
        client,
        navigate,
        openCreate,
        allocateOnTap
    ]);
    return {
        open: open,
        cancel: cancel
    };
};
const $28bb13ba9d3f9376$export$9227a5765cfbd955 = ({ selectionState: selectionState, openCreate: openCreate, allocateOnTap: allocateOnTap })=>{
    const { selected: selected, setSelected: setSelected, clearSelection: clearSelection } = selectionState;
    const [explicit, setExplicit] = $acw62.useState(false);
    const selecting = explicit || selected.length > 0;
    const { open: open, cancel: cancel } = $28bb13ba9d3f9376$export$e9809e27349c024d({
        openCreate: openCreate,
        allocateOnTap: allocateOnTap
    });
    // A selection emptying — an action finished with it, or the last row was
    // unpicked — ends select mode too, so taps open rows again.
    const hadSelection = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (selected.length > 0) hadSelection.current = true;
        else if (hadSelection.current) {
            hadSelection.current = false;
            setExplicit(false);
        }
    }, [
        selected.length
    ]);
    const selectedIds = $acw62.useMemo(()=>selected.map((rt)=>rt._id), [
        selected
    ]);
    // Every gesture but an opening tap retires a pending lookup first.
    const stopSelecting = $acw62.useCallback(()=>{
        cancel();
        setExplicit(false);
        clearSelection();
    }, [
        cancel,
        clearSelection
    ]);
    const onClick = (rt)=>{
        if (selecting) {
            cancel();
            setSelected(rt)(!selectedIds.includes(rt._id));
            return;
        }
        open(rt);
    };
    const onLongPress = (rt)=>{
        cancel();
        setSelected(rt)(true);
    };
    return {
        selecting: selecting,
        startSelecting: ()=>{
            cancel();
            setExplicit(true);
        },
        stopSelecting: stopSelecting,
        rowProps: {
            selectedIds: selectedIds,
            onClick: onClick,
            onLongPress: onLongPress,
            selectMode: selecting
        }
    };
};




/** An uneditable field's current value, with the reason it is locked. */ const $1a4ffbeee2e27de2$var$ReadOnlyValue = ({ reason: reason, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-muted-foreground flex min-h-9 flex-col justify-center py-1.5 text-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "truncate",
                children: children
            }),
            reason ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-xs opacity-80",
                children: reason
            }) : null
        ]
    });
const $1a4ffbeee2e27de2$export$ce0c93f5b834f44 = (props)=>{
    const { rawTransaction: rawTransaction, onUpdate: onUpdate, onRequestClose: onRequestClose } = props;
    const formId = $acw62.useId();
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    // The list rows carry no consumption links, so the form loads the
    // transactions it links to itself. network-only: a stale cached link would
    // point at a transaction that no longer holds this line.
    const { data: consumersData } = (0, $ce9d9e524be20f53$export$3df9816e98d6b2cc)({
        variables: {
            ids: [
                rawTransaction._id
            ]
        },
        fetchPolicy: 'network-only'
    });
    const targets = $acw62.useMemo(()=>{
        const byId = new Map();
        for (const row of consumersData?.rawTransactionsByIds ?? [])for (const consumer of row.consumers)byId.set(consumer.transaction._id, consumer.transaction);
        return [
            ...byId.values()
        ];
    }, [
        consumersData
    ]);
    // The network-only fetch above also returns the row's current server
    // state. When a save runs no raw-level mutation, this is what goes back
    // to the caller — the prop row can lag a sync that landed before the
    // modal opened, and the caller writes what we hand it into its list.
    const freshRow = consumersData?.rawTransactionsByIds.find((rt)=>rt._id === rawTransaction._id) ?? null;
    // --- Field locks --------------------------------------------------------
    // Sync owns the identity fields of Plaid/Venmo rows — the server rejects
    // updates. Account and benefit stay editable on synced rows.
    const isManual = !rawTransaction.plaidId && !rawTransaction.venmoId;
    const syncedReason = isManual ? null : 'Synced from Plaid/Venmo';
    const isConsumed = rawTransaction.remainingAmount !== null && rawTransaction.remainingAmount !== rawTransaction.amount;
    const amountReason = syncedReason ?? (isConsumed ? 'Locked: a transaction consumes this row' : rawTransaction.reconciliation ? 'Locked: this row is reconciled' : null);
    // Linking is USD-only by server enforcement; clearing never is. A non-USD
    // row with a legacy link can therefore only clear it — no picker.
    const canLinkBenefit = rawTransaction.currency === 'USD';
    const benefitLockedReason = !canLinkBenefit && rawTransaction.benefitId == null ? 'Benefits are USD-only' : null;
    // --- Draft state --------------------------------------------------------
    const originalAmount = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer(rawTransaction);
    const originalDate = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(rawTransaction.date);
    const [amount, setAmount] = $acw62.useState((0, $f8f45ddea4959097$exports.some)(originalAmount));
    const [date, setDate] = $acw62.useState(originalDate);
    const [description, setDescription] = $acw62.useState(rawTransaction.description);
    const [account, setAccount] = $acw62.useState((0, $f8f45ddea4959097$exports.some)(rawTransaction.account));
    const [benefit, setBenefit] = $acw62.useState({
        kind: 'keep'
    });
    // Fetched only once the picker opens: AttachmentFeePeriods selects just
    // what BenefitPicker renders, and most edits never touch the benefit row —
    // the full fee-period query drags unbounded transaction histories along.
    const { data: feePeriodsData, loading: feePeriodsLoading, error: feePeriodsError, refetch: refetchFeePeriods } = (0, $ce9d9e524be20f53$export$6c4da8612d49971)({
        skip: benefit.kind !== 'picking'
    });
    const [error, setError] = $acw62.useState(null);
    const [saving, setSaving] = $acw62.useState(false);
    // --- Diffs --------------------------------------------------------------
    // An emptied amount is not "unchanged" — the form shows no value, so a
    // save must not silently keep the original. It blocks Save instead.
    const amountInvalid = amountReason === null && amount.isEmpty;
    const amountChanged = amountReason === null && amount.map((m)=>!m.equals(originalAmount)).getOrElse(false);
    const dateChanged = isManual && date.toISODate() !== originalDate.toISODate();
    const descriptionChanged = isManual && description !== rawTransaction.description;
    const accountChanged = account.map((a)=>a._id !== rawTransaction.account._id).getOrElse(false);
    const benefitChange = benefit.kind === 'link' && benefit.benefitId !== rawTransaction.benefitId ? benefit.benefitId : benefit.kind === 'clear' && rawTransaction.benefitId != null ? null : undefined;
    const hasChanges = amountChanged || dateChanged || descriptionChanged || accountChanged || benefitChange !== undefined;
    // --- Save ---------------------------------------------------------------
    const [updateRawTransaction] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$a816827dbf97cab1));
    const [updateRawTransactions] = (0, $ce9d9e524be20f53$export$a48dcf481f9e74a4)();
    const [setBenefitOnRawTransactions] = (0, $ce9d9e524be20f53$export$55bd5587b7471132)();
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!hasChanges || saving || amountInvalid) return;
        setError(null);
        setSaving(true);
        // The save is not one transaction, so order the calls by failure
        // likelihood: the raw-level write carries the validations the form can't
        // pre-check (cross-currency moves, closed accounts, reconciliation and
        // basis locks), so a failed save normally leaves nothing applied.
        const run = async ()=>{
            let updated = null;
            if (amountChanged || dateChanged || descriptionChanged || accountChanged) {
                if (isManual) {
                    // One call, one write: the resolver validates the whole effective
                    // (account, date, amount) combination before persisting anything,
                    // so a rejected date can never leave an already-saved amount
                    // behind.
                    const result = await updateRawTransaction({
                        variables: {
                            id: rawTransaction._id,
                            amount: amountChanged ? amount.map((m)=>m.amount).getOrElse(undefined) : undefined,
                            date: dateChanged ? date.toISODate() : undefined,
                            description: descriptionChanged ? description : undefined,
                            account: accountChanged ? account.map((a)=>a._id).getOrElse(undefined) : undefined
                        }
                    });
                    updated = result.data?.updateRawTransaction ?? updated;
                } else {
                    // A synced row can only change its account here (the other fields
                    // are provider-owned and locked above), and the single-row
                    // resolver rejects synced rows before looking at fields — the
                    // bulk mutation permits the account-only move.
                    const result = await updateRawTransactions({
                        variables: {
                            ids: [
                                rawTransaction._id
                            ],
                            account: account.map((a)=>a._id).getOrElse(undefined)
                        }
                    });
                    updated = result.data?.updateRawTransactions?.[0] ?? updated;
                }
                if (accountChanged) {
                    // Moving the row rewrites the normalized entity, but cached
                    // allRawTransactions pages for both accounts still hold the old
                    // membership — drop them. A moved row may also back a fee period
                    // as its charge; the resolver drops the link once accounts
                    // mismatch, so cached fee period queries go stale too.
                    (0, $074538a84be674b5$export$2e2bcd8739ae039)(client.cache, rawTransaction.account._id);
                    const nextAccountId = updated?.account._id;
                    if (nextAccountId) (0, $074538a84be674b5$export$2e2bcd8739ae039)(client.cache, nextAccountId);
                    (0, $a9d94318500ad031$export$260983a97254aea6)(client.cache);
                }
            }
            if (benefitChange !== undefined) {
                const result = await setBenefitOnRawTransactions({
                    variables: {
                        ids: [
                            rawTransaction._id
                        ],
                        benefit: benefitChange
                    }
                });
                updated = result.data?.setBenefitOnRawTransactions?.[0] ?? updated;
                // Benefit usage totals hang off fee period queries
                (0, $a9d94318500ad031$export$260983a97254aea6)(client.cache);
            }
            return updated;
        };
        run().then((updated)=>{
            onRequestClose();
            // Prefer what a raw-level mutation returned, then the row the
            // consumers fetch brought back (current server state — the prop can
            // be stale when a sync landed before the modal opened), and only
            // then the prop itself.
            onUpdate?.(updated ?? freshRow ?? rawTransaction);
        }).catch((e)=>{
            setError(e instanceof Error ? e.message : 'Failed to save changes.');
        }).finally(()=>setSaving(false));
    };
    // --- Rendering ----------------------------------------------------------
    const stagedAccountId = account.map((a)=>a._id).getOrElse(rawTransaction.account._id);
    const benefitControls = (()=>{
        if (benefitLockedReason !== null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1a4ffbeee2e27de2$var$ReadOnlyValue, {
            reason: benefitLockedReason,
            children: rawTransaction.benefit?.name ?? 'None'
        });
        switch(benefit.kind){
            case 'keep':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex min-h-9 flex-wrap items-center gap-2 py-1.5 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: rawTransaction.benefit ? undefined : 'text-muted-foreground',
                            children: rawTransaction.benefit?.name ?? 'None'
                        }),
                        canLinkBenefit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: "h-7 px-2.5 text-xs",
                            onClick: ()=>setBenefit({
                                    kind: 'picking'
                                }),
                            children: "Change"
                        }),
                        rawTransaction.benefitId != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: "h-7 px-2.5 text-xs",
                            onClick: ()=>setBenefit({
                                    kind: 'clear'
                                }),
                            children: "Clear"
                        })
                    ]
                });
            case 'picking':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-2 pt-1.5",
                    children: [
                        feePeriodsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-muted-foreground py-1.5 text-sm",
                            children: "Loading benefits\u2026"
                        }) : feePeriodsError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2 py-1.5 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-destructive",
                                    children: "Failed to load benefits."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    className: "h-7 px-2.5 text-xs",
                                    onClick: ()=>void refetchFeePeriods(),
                                    children: "Retry"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "max-h-64 overflow-y-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2680a3b0889a19c1$export$c75002b314c2fe72), {
                                feePeriods: feePeriodsData?.allFeePeriods ?? [],
                                transactionDate: date.toSeconds(),
                                accountId: stagedAccountId,
                                // No lockAccount: linking one row across accounts is the
                                // same escape hatch LinkBenefitModal offers behind "Show
                                // all benefits" — only a multi-row bulk link must stay on
                                // one account.
                                onSelect: (selected)=>setBenefit({
                                        kind: 'link',
                                        benefitId: selected._id,
                                        benefitName: selected.name
                                    })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: "h-7 self-start px-2.5 text-xs",
                            onClick: ()=>setBenefit({
                                    kind: 'keep'
                                }),
                            children: "Cancel"
                        })
                    ]
                });
            case 'link':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex min-h-9 flex-wrap items-center gap-2 py-1.5 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "Link to ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-medium",
                                    children: benefit.benefitName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: "h-7 px-2.5 text-xs",
                            onClick: ()=>setBenefit({
                                    kind: 'picking'
                                }),
                            children: "Change"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: "h-7 px-2.5 text-xs",
                            onClick: ()=>setBenefit({
                                    kind: 'keep'
                                }),
                            children: "Undo"
                        })
                    ]
                });
            case 'clear':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex min-h-9 flex-wrap items-center gap-2 py-1.5 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "The benefit link will be removed"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: "h-7 px-2.5 text-xs",
                            onClick: ()=>setBenefit({
                                    kind: 'keep'
                                }),
                            children: "Undo"
                        })
                    ]
                });
        }
    })();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        size: "lg",
        // A bottom sheet on a phone, as the transaction sheets are.
        className: "top-auto bottom-0 h-auto max-h-[92dvh] rounded-b-none sm:rounded-b-lg",
        header: "Edit activity",
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    disabled: saving,
                    onClick: onRequestClose,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    type: "submit",
                    disabled: !hasChanges || saving || amountInvalid,
                    form: formId,
                    children: saving ? "Saving\u2026" : 'Save'
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Amount",
                    children: amountReason === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                                value: amount,
                                onChange: setAmount,
                                textAlign: "left",
                                currency: rawTransaction.currency
                            }),
                            amountInvalid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-destructive text-xs",
                                children: "Enter an amount."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1a4ffbeee2e27de2$var$ReadOnlyValue, {
                        reason: amountReason,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                            variant: "plain",
                            align: "left",
                            amount: originalAmount
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Description",
                    children: isManual ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        value: description,
                        onChange: setDescription,
                        placeholder: "Description"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1a4ffbeee2e27de2$var$ReadOnlyValue, {
                        reason: syncedReason,
                        children: rawTransaction.description || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "italic",
                            children: "Empty"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Date",
                    children: isManual ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                        selectedDate: date,
                        onChange: setDate
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1a4ffbeee2e27de2$var$ReadOnlyValue, {
                        reason: syncedReason,
                        children: rawTransaction.date
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Account",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $295751b0f96fd69d$export$2e2bcd8739ae039), {
                        selectedAccount: account,
                        onSelectAccount: (next)=>{
                            setAccount(next);
                            // A staged link was picked against the previous account;
                            // changing it means re-picking, not silently carrying over.
                            setBenefit((prev)=>prev.kind === 'link' ? {
                                    kind: 'picking'
                                } : prev);
                        },
                        currency: rawTransaction.currency
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Benefit",
                    children: benefitControls
                }),
                targets.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: targets.length === 1 ? 'Transaction' : 'Transactions',
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex min-h-9 flex-col justify-center gap-1 py-1.5 text-sm",
                        children: targets.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                to: (0, $28bb13ba9d3f9376$export$6b8e0f7b9031826)(t._id, rawTransaction._id),
                                onClick: onRequestClose,
                                className: "truncate text-blue-600 hover:underline dark:text-blue-400",
                                children: t.payee || (t.transferType ? (0, $d906535d40bd11c1$export$e5f08023f111098c)[t.transferType] : 'Transfer')
                            }, t._id))
                    })
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-destructive text-sm",
                    children: error
                })
            ]
        })
    });
};








var $acw62 = parcelRequire("acw62");





const $1bf69211b39976a3$export$2f3c3eea6fa6f560 = (props)=>{
    const { snapshot: snapshot } = props;
    const formId = $acw62.useId();
    const [updateAnchor, { loading: loading }] = (0, $ce9d9e524be20f53$export$2a466906a4d7f6d8)();
    const [date, setDate] = $acw62.useState((0, $0c0f91b069db95d9$export$6b862160d295c8e)(snapshot.date));
    const [value, setValue] = $acw62.useState((0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(snapshot.value, 'USD')));
    const [error, setError] = $acw62.useState(null);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        if (value.isEmpty) {
            setError('Please enter a valid portfolio value');
            return;
        }
        try {
            await updateAnchor({
                variables: {
                    anchorId: snapshot._id,
                    date: date.toISODate() ?? '',
                    balance: value.get().toInt().amount
                }
            });
            props.onSuccess?.();
            props.onRequestClose();
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to update snapshot');
        }
    };
    const isValid = value.nonEmpty;
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                disabled: loading,
                onClick: props.onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                disabled: loading || !isValid,
                type: "submit",
                form: formId,
                children: "Save"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: props.onRequestClose,
        header: "Edit snapshot",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: (e)=>void handleSubmit(e),
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Date",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                        selectedDate: date,
                        onChange: setDate
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Portfolio value",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                        value: value,
                        onChange: setValue,
                        autoFocus: true
                    })
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-sm",
                    children: error
                })
            ]
        })
    });
};






var $acw62 = parcelRequire("acw62");








parcelRequire("acw62");

const $2c2910ec4d5b92fc$export$f3998c05c0dab84a = (props)=>{
    const { value: value, onChange: onChange } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex cursor-pointer items-center gap-2 select-none",
        onClick: ()=>onChange(!value),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93d44a992b7c3d39$export$2e2bcd8739ae039), {
                value: value,
                onChange: onChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-foreground text-sm",
                children: "Pending"
            })
        ]
    });
};





const $2bc847196d1d8775$export$69e5bcde13e175a7 = ({ transactions: transactions, onSaved: onSaved, onRequestClose: onRequestClose })=>{
    const formId = $acw62.useId();
    const { data: fieldsData, error: fieldsError, refetch: refetchFields } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)();
    const payments = transactions.filter((t)=>t.netAmount !== 0);
    const transfers = transactions.filter((t)=>t.netAmount === 0);
    const transferCount = transfers.length;
    const categoryReason = payments.length === 0 ? 'Transfers have no category' : null;
    const [active, setActive] = $acw62.useState(new Set());
    const [payee, setPayee] = $acw62.useState('');
    const [category, setCategory] = $acw62.useState((0, $f8f45ddea4959097$exports.none));
    const [description, setDescription] = $acw62.useState('');
    const [pending, setPending] = $acw62.useState(false);
    const [addTags, setAddTags] = $acw62.useState([]);
    const [setFields, setSetFields] = $acw62.useState({});
    const [removeTags, setRemoveTags] = $acw62.useState(new Set());
    const [removeFieldIds, setRemoveFieldIds] = $acw62.useState(new Set());
    const [error, setError] = $acw62.useState(null);
    const [saving, setSaving] = $acw62.useState(false);
    // A payee spans payments and transfers (a transfer's names its
    // counterparty); a category is a payment's alone.
    const uniformPayee = (0, $dc4fc1c2b6dd6a24$export$379455b567eff87d)(transactions, (t)=>t.payee ?? '');
    const uniformCategory = (0, $dc4fc1c2b6dd6a24$export$379455b567eff87d)(payments, (t)=>t.category?.name ?? null);
    const uniformDescription = (0, $dc4fc1c2b6dd6a24$export$379455b567eff87d)(transactions, (t)=>t.description ?? '');
    const uniformPending = (0, $dc4fc1c2b6dd6a24$export$379455b567eff87d)(transactions, (t)=>t.pending);
    const tagCounts = $acw62.useMemo(()=>{
        const counts = new Map();
        for (const t of transactions)for (const tag of t.tags)counts.set(tag.name, (counts.get(tag.name) ?? 0) + 1);
        return counts;
    }, [
        transactions
    ]);
    const fieldCounts = $acw62.useMemo(()=>{
        const counts = new Map();
        for (const t of transactions)for (const fieldId of Object.keys(t.fieldValues ?? {}))counts.set(fieldId, (counts.get(fieldId) ?? 0) + 1);
        return counts;
    }, [
        transactions
    ]);
    const fieldName = (fieldId)=>fieldsData?.allFields.find((f)=>f._id === fieldId)?.name ?? fieldId;
    const isActive = (key)=>active.has(key);
    const toggleRow = (key)=>(next)=>{
            setActive((prev)=>{
                const nextSet = new Set(prev);
                if (next) nextSet.add(key);
                else nextSet.delete(key);
                return nextSet;
            });
            if (!next) return;
            // Activating seeds the draft with the value the selection agrees on.
            switch(key){
                case 'payee':
                    setPayee(uniformPayee ?? '');
                    break;
                case 'category':
                    setCategory(uniformCategory !== null ? (0, $f8f45ddea4959097$exports.some)(uniformCategory) : (0, $f8f45ddea4959097$exports.none));
                    break;
                case 'description':
                    setDescription(uniformDescription ?? '');
                    break;
                case 'pending':
                    setPending(uniformPending ?? false);
                    break;
                default:
                    break;
            }
        };
    // Adding and removing the same tag (or field) would be order-dependent —
    // the newer intent wins and clears the older one.
    const handleAddChange = (tags, fieldValues)=>{
        setAddTags(tags);
        setSetFields(fieldValues);
        setRemoveTags((prev)=>{
            const next = new Set(prev);
            tags.forEach((tag)=>next.delete(tag));
            return next;
        });
        setRemoveFieldIds((prev)=>{
            const next = new Set(prev);
            Object.keys(fieldValues).forEach((id)=>next.delete(id));
            return next;
        });
    };
    const toggleRemoveTag = (tag)=>{
        setRemoveTags((prev)=>{
            const next = new Set(prev);
            if (next.has(tag)) next.delete(tag);
            else {
                next.add(tag);
                setAddTags((tags)=>tags.filter((t)=>t !== tag));
            }
            return next;
        });
    };
    const toggleRemoveField = (fieldId)=>{
        setRemoveFieldIds((prev)=>{
            const next = new Set(prev);
            if (next.has(fieldId)) next.delete(fieldId);
            else {
                next.add(fieldId);
                setSetFields((fields)=>{
                    const { [fieldId]: _removed, ...rest } = fields;
                    return rest;
                });
            }
            return next;
        });
    };
    // Category goes to the payments; everything else to the whole selection.
    // Clearing a payee is a transfer-only op (payments require one), so with
    // payments selected it blocks Save instead.
    const paymentOps = [];
    const sharedOps = [];
    if (isActive('payee')) sharedOps.push(payee.trim() ? {
        field: 'payee',
        op: (0, $ce9d9e524be20f53$export$176402696c519123).Set,
        value: payee.trim()
    } : {
        field: 'payee',
        op: (0, $ce9d9e524be20f53$export$176402696c519123).Unset
    });
    if (isActive('category')) paymentOps.push(category.map((name)=>({
            field: 'category',
            op: (0, $ce9d9e524be20f53$export$176402696c519123).Set,
            value: name
        })).getOrElse({
        field: 'category',
        op: (0, $ce9d9e524be20f53$export$176402696c519123).Unset
    }));
    if (isActive('description')) sharedOps.push(description.trim() ? {
        field: 'description',
        op: (0, $ce9d9e524be20f53$export$176402696c519123).Set,
        value: description.trim()
    } : {
        field: 'description',
        op: (0, $ce9d9e524be20f53$export$176402696c519123).Unset
    });
    if (isActive('pending')) sharedOps.push({
        field: 'pending',
        op: (0, $ce9d9e524be20f53$export$176402696c519123).Set,
        value: pending
    });
    if (isActive('tagsAndFields')) {
        if (addTags.length > 0) sharedOps.push({
            field: 'tags',
            op: (0, $ce9d9e524be20f53$export$176402696c519123).Add,
            value: addTags
        });
        if (removeTags.size > 0) sharedOps.push({
            field: 'tags',
            op: (0, $ce9d9e524be20f53$export$176402696c519123).Remove,
            value: [
                ...removeTags
            ]
        });
        if (Object.keys(setFields).length > 0) sharedOps.push({
            field: 'dimensionValues',
            op: (0, $ce9d9e524be20f53$export$176402696c519123).Add,
            value: setFields
        });
        if (removeFieldIds.size > 0) sharedOps.push({
            field: 'dimensionValues',
            op: (0, $ce9d9e524be20f53$export$176402696c519123).Remove,
            value: [
                ...removeFieldIds
            ]
        });
    }
    // The rejections the server would make, caught before anything is written:
    // a payment losing its payee or category, or any transaction losing a
    // required field. With those ruled out, the two patch calls below take only
    // values the form already constrained, so a save can't land half-applied.
    // Only what will be sent counts: removals staged on a row since left
    // unchanged are dropped from the ops, so they don't gate Save either.
    const stagedFieldRemovals = isActive('tagsAndFields') ? removeFieldIds : new Set();
    const removedRequiredFieldNames = (fieldsData?.allFields ?? []).filter((f)=>f.required && stagedFieldRemovals.has(f._id)).map((f)=>f.name);
    const clearsRequired = isActive('payee') && payee.trim() === '' && payments.length > 0 || isActive('category') && category.isEmpty || removedRequiredFieldNames.length > 0 || // Unverifiable until the fields load.
    stagedFieldRemovals.size > 0 && fieldsData === undefined;
    const hasChanges = paymentOps.length > 0 || sharedOps.length > 0;
    const [patchTransactions] = (0, $ce9d9e524be20f53$export$f3779a398990be49)();
    const handleSubmit = (event)=>{
        event.preventDefault();
        if (!hasChanges || clearsRequired || saving) return;
        setError(null);
        setSaving(true);
        // A patch can introduce a lookup value typed inline (a new category, tag,
        // or payee); the normalized entities don't join the cached root lists on
        // their own.
        const mergeLookupValues = (store, result)=>{
            for (const tx of result.data?.patchTransactions ?? []){
                if (tx.category) (0, $5f9091afcb8d9899$export$8c292b02ce03981f)(store, tx.category);
                (0, $d320129055480c52$export$3e5009ed1fce7d58)(store, tx.tags);
                if (tx.payee) (0, $0248a075196eba6a$export$db125e7042e4c220)(store, tx.payee);
            }
        };
        // patchTransactions validates every op before its one write, so ops on
        // the same targets ride one call and land or fail together. Only a
        // selection mixing payments and transfers needs a second call, for the
        // category the transfers can't take.
        const calls = transfers.length === 0 ? [
            {
                ids: transactions.map((t)=>t._id),
                operations: [
                    ...paymentOps,
                    ...sharedOps
                ]
            }
        ] : [
            {
                ids: transactions.map((t)=>t._id),
                operations: sharedOps
            },
            {
                ids: payments.map((t)=>t._id),
                operations: paymentOps
            }
        ];
        const run = async ()=>{
            for (const call of calls){
                if (call.operations.length === 0 || call.ids.length === 0) continue;
                await patchTransactions({
                    variables: {
                        transactionIds: call.ids,
                        operations: call.operations
                    },
                    update: mergeLookupValues
                });
            }
        };
        run().then(()=>{
            onRequestClose();
            onSaved?.();
        }).catch((e)=>{
            setError(e instanceof Error ? e.message : 'Failed to save changes.');
        }).finally(()=>setSaving(false));
    };
    const tagsSummary = tagCounts.size === 0 && fieldCounts.size === 0 ? 'None' : [
        tagCounts.size > 0 ? `${tagCounts.size} tag${tagCounts.size === 1 ? '' : 's'}` : null,
        fieldCounts.size > 0 ? `${fieldCounts.size} field${fieldCounts.size === 1 ? '' : 's'}` : null
    ].filter(Boolean).join(" \xb7 ");
    const kinds = [
        payments.length > 0 ? `${payments.length} payment${payments.length === 1 ? '' : 's'}` : null,
        transferCount > 0 ? `${transferCount} transfer${transferCount === 1 ? '' : 's'}` : null
    ].filter(Boolean).join(" \xb7 ");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        // The edit sheet's frame: a bottom sheet on a phone.
        className: "top-auto bottom-0 h-auto max-h-[92dvh] rounded-b-none sm:rounded-b-lg",
        header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Edit ",
                        transactions.length,
                        " transactions"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground text-sm font-normal",
                    children: kinds
                })
            ]
        }),
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    disabled: saving,
                    onClick: onRequestClose,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    type: "submit",
                    form: formId,
                    disabled: !hasChanges || clearsRequired || saving,
                    children: saving ? "Saving\u2026" : 'Save'
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$747498014587774b), {
                    label: "Payee",
                    summary: uniformPayee === null ? (0, $dc4fc1c2b6dd6a24$export$bb410559a65d3418) : uniformPayee || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "italic",
                        children: "Empty"
                    }),
                    active: isActive('payee'),
                    onToggle: toggleRow('payee'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1af78646b91168e0$export$2e2bcd8739ae039), {
                        value: payee,
                        onChange: setPayee
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$747498014587774b), {
                    label: "Category",
                    summary: payments.length === 0 ? 'None' : uniformCategory === null ? payments.some((t)=>t.category != null) ? (0, $dc4fc1c2b6dd6a24$export$bb410559a65d3418) : 'None' : uniformCategory,
                    active: isActive('category'),
                    disabledReason: categoryReason,
                    onToggle: toggleRow('category'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9eb11e6352514841$export$2e2bcd8739ae039), {
                        selectedCategory: category,
                        onSelectCategory: setCategory
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$747498014587774b), {
                    label: "Note",
                    summary: uniformDescription === null ? (0, $dc4fc1c2b6dd6a24$export$bb410559a65d3418) : uniformDescription || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "italic",
                        children: "Empty"
                    }),
                    active: isActive('description'),
                    onToggle: toggleRow('description'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        value: description,
                        onChange: setDescription,
                        placeholder: "Note"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$747498014587774b), {
                    label: "Tags & fields",
                    summary: tagsSummary,
                    active: isActive('tagsAndFields'),
                    onToggle: toggleRow('tagsAndFields'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d5b27e6036e5285$export$470985d1a1ba634f), {
                                tags: addTags,
                                fieldValues: setFields,
                                onChange: handleAddChange
                            }),
                            (tagCounts.size > 0 || fieldCounts.size > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap gap-1",
                                children: [
                                    [
                                        ...tagCounts.entries()
                                    ].map(([tag, count])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$9b8348546fe33128), {
                                            label: tag,
                                            count: count,
                                            armed: removeTags.has(tag),
                                            onToggle: ()=>toggleRemoveTag(tag)
                                        }, `tag:${tag}`)),
                                    [
                                        ...fieldCounts.entries()
                                    ].map(([fieldId, count])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$9b8348546fe33128), {
                                            label: fieldName(fieldId),
                                            count: count,
                                            armed: removeFieldIds.has(fieldId),
                                            onToggle: ()=>toggleRemoveField(fieldId)
                                        }, `field:${fieldId}`))
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4fc1c2b6dd6a24$export$747498014587774b), {
                    label: "Pending",
                    summary: uniformPending === null ? (0, $dc4fc1c2b6dd6a24$export$bb410559a65d3418) : uniformPending ? 'Yes' : 'No',
                    active: isActive('pending'),
                    onToggle: toggleRow('pending'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pt-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c2910ec4d5b92fc$export$f3998c05c0dab84a), {
                            value: pending,
                            onChange: setPending
                        })
                    })
                }),
                stagedFieldRemovals.size > 0 && fieldsData === undefined && fieldsError && // Which fields are required isn't known, so a removal can't be
                // checked, and Save waits on it.
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-destructive flex items-center gap-2 text-sm",
                    children: [
                        "Couldn't load fields.",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: "h-7 px-2.5 text-xs",
                            onClick: ()=>void refetchFields(),
                            children: "Retry"
                        })
                    ]
                }),
                removedRequiredFieldNames.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-destructive text-sm",
                    children: [
                        removedRequiredFieldNames.join(', '),
                        " can't be removed."
                    ]
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-destructive text-sm",
                    children: error
                })
            ]
        })
    });
};







/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $200392fae49ddb7e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 6v6l4 2",
            key: "mmk7yg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const $200392fae49ddb7e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("clock", $200392fae49ddb7e$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");














const $eb9c0713007ac1dd$export$d51151e4f01b4b50 = (amounts)=>{
    const byCurrency = new Map();
    for (const { amount: amount, currency: currency } of amounts)byCurrency.set(currency, (byCurrency.get(currency) ?? 0) + amount);
    return [
        ...byCurrency.entries()
    ].map(([currency, total])=>(0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(total, currency));
};






const $20f1bd65609d7cc1$var$draftOf = (transaction)=>({
        payee: transaction.payee ?? '',
        category: (0, (/*@__PURE__*/$parcel$interopDefault($f8f45ddea4959097$exports)))(transaction.category?.name),
        transferType: transaction.transferType ?? null,
        date: (0, $0c0f91b069db95d9$export$6b862160d295c8e)(transaction.date),
        description: transaction.description ?? '',
        tags: transaction.tags.map((tag)=>tag.name),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        fieldValues: transaction.fieldValues || {},
        pending: transaction.pending
    });
const $20f1bd65609d7cc1$var$sameDraft = (a, b)=>a.payee === b.payee && a.category.equals(b.category) && a.transferType === b.transferType && a.date.toISODate() === b.date.toISODate() && a.description === b.description && a.tags.join('\u0000') === b.tags.join('\u0000') && JSON.stringify(a.fieldValues) === JSON.stringify(b.fieldValues) && a.pending === b.pending;
/** A category's avatar, sized for the decision pill. */ const $20f1bd65609d7cc1$var$CategoryPillAvatar = ({ name: name })=>{
    const { data: data } = (0, $ce9d9e524be20f53$export$1f9e2535d0d42ab9)();
    const category = data?.allCategories.find((c)=>c.name === name) ?? {
        name: name
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6080e81c2b9604e9$export$bde99f6bf04aeea3), {
        category: category,
        className: "size-6 rounded-md max-md:size-6"
    });
};
/** A line the transaction is made of, as the create sheet lists it, read-only. */ const $20f1bd65609d7cc1$var$LineRow = ({ raw: raw, amount: amount })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid grid-cols-[minmax(0,1fr)_auto] items-center gap-x-3 gap-y-0.5 px-3 py-2.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "truncate",
                title: raw.description,
                children: raw.description
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-right tabular-nums",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                    variant: "plain",
                    amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(amount, raw.currency)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground flex min-w-0 items-center gap-1.5 text-sm",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c0f56add137aac0$export$42a331aab32dea1), {
                    account: raw.account
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground text-right text-sm",
                children: (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(raw.date)
            })
        ]
    });
const $20f1bd65609d7cc1$export$996d7fb3ae0eaea1 = ({ transaction: transaction, onSaved: onSaved, onRequestClose: onRequestClose })=>{
    const formId = $acw62.useId();
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const payeeLogos = (0, $5474523a6079f1bc$export$8be0d3de9c92b14f)();
    const { data: fieldsData } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)();
    // The lines: the list rows carry only their ids, so ask for the detail
    // (already cached when the sheet opens from the transaction's page).
    const { data: detailData } = (0, $ce9d9e524be20f53$export$27549920c2be446e)({
        variables: {
            id: transaction._id
        }
    });
    const lines = (detailData?.transactionById?.consumptions ?? []).flatMap((consumption)=>consumption.rawTransaction ? [
            {
                raw: consumption.rawTransaction,
                amount: consumption.amount
            }
        ] : []);
    const original = $acw62.useMemo(()=>$20f1bd65609d7cc1$var$draftOf(transaction), [
        transaction
    ]);
    const [draft, setDraft] = $acw62.useState(original);
    const set = (key)=>(value)=>setDraft((prev)=>({
                    ...prev,
                    [key]: value
                }));
    const isPayment = transaction.netAmount !== 0;
    const isConversion = transaction.transferType === (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion;
    const [screen, setScreen] = $acw62.useState(null);
    const [dateOpen, setDateOpen] = $acw62.useState(false);
    const [updateTransaction, { loading: loading, error: error }] = (0, $ce9d9e524be20f53$export$b1d214c903a2f723)();
    const hasChanges = !$20f1bd65609d7cc1$var$sameDraft(original, draft);
    // A payment needs its payee and category, as on create. A transfer's payee
    // is optional, and its type can be changed but not removed once it has one.
    const valid = isPayment ? draft.payee.trim() !== '' && !draft.category.isEmpty : original.transferType == null || draft.transferType != null;
    const handleSubmit = (event)=>{
        event.preventDefault();
        if (screen != null || !hasChanges || !valid || loading) return;
        updateTransaction({
            variables: {
                transaction: transaction._id,
                // An empty string clears a transfer's payee server-side.
                payee: draft.payee,
                description: draft.description,
                category: isPayment ? draft.category.getOrElse(null) : undefined,
                transferType: !isPayment && !isConversion ? draft.transferType : undefined,
                date: draft.date.toISODate(),
                pending: draft.pending,
                tags: draft.tags,
                fieldValues: draft.fieldValues
            },
            update: (store, result)=>{
                const tx = result.data?.updateTransaction;
                if (!tx) return;
                if (tx.category) (0, $5f9091afcb8d9899$export$8c292b02ce03981f)(store, tx.category);
                if (tx.tags) (0, $d320129055480c52$export$3e5009ed1fce7d58)(store, tx.tags);
                if (tx.payee) (0, $0248a075196eba6a$export$db125e7042e4c220)(store, tx.payee);
            }
        }).then(()=>{
            onRequestClose();
            onSaved?.();
        }).catch(()=>{
        // Surfaced through the mutation's error state below.
        });
    };
    // ---- Header ----
    const accountNames = (pick)=>[
            ...new Set(lines.filter((l)=>pick(l.amount)).map((l)=>l.raw.account.name))
        ];
    const sideLabel = (names)=>names.length === 1 ? names[0] : `${names.length} accounts`;
    const title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: ()=>setScreen('payee'),
        className: "hover:bg-muted -mx-1.5 flex min-w-0 cursor-pointer items-start gap-1 rounded-lg px-1.5 text-left",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('line-clamp-2 min-w-0 text-[17px] leading-tight font-semibold break-words', draft.payee === '' && 'text-muted-foreground font-medium'),
                children: draft.payee === '' ? 'Add payee' : draft.payee
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                className: "mt-0.5 size-3.5 shrink-0 text-blue-600 dark:text-blue-400"
            })
        ]
    });
    let face;
    let sub = null;
    let amount;
    let decision;
    if (isPayment) {
        face = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$a0afa665fb89834), {
            name: draft.payee,
            logo: payeeLogos.get(draft.payee)
        });
        sub = lines.length > 0 ? sideLabel(accountNames(()=>true)) : null;
        amount = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
            variant: "plain",
            amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(transaction.netAmount, transaction.currency)
        });
        const category = draft.category.getOrElse('');
        decision = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$98a92a03d6411c29), {
            onClick: ()=>setScreen('category'),
            leading: category !== '' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($20f1bd65609d7cc1$var$CategoryPillAvatar, {
                name: category
            }) : undefined,
            children: category === '' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground",
                children: "Choose category"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "truncate font-semibold",
                children: category
            })
        });
    } else {
        face = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7a15ad94ac6a08$export$f7121fe80f407126), {
            type: draft.transferType,
            className: "size-10 rounded-xl"
        });
        sub = lines.length > 0 ? `${sideLabel(accountNames((a)=>a < 0))} \u{2192} ${sideLabel(accountNames((a)=>a > 0))}` : null;
        // A transfer nets to zero; what moved is one side. A conversion's two
        // sides are in two currencies, so it shows both.
        amount = isConversion ? (0, $eb9c0713007ac1dd$export$d51151e4f01b4b50)(lines.map((l)=>({
                amount: l.amount,
                currency: l.raw.currency
            }))).sort((a, b)=>a.amount - b.amount).map((leg)=>formatMoney(leg)).join(" \u2192 ") : formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(transaction.consumptions.filter((c)=>c.amount > 0).reduce((sum, c)=>sum + c.amount, 0), transaction.currency));
        decision = isConversion ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$98a92a03d6411c29), {
            fixed: true,
            leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7a15ad94ac6a08$export$f7121fe80f407126), {
                type: (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion
            }),
            children: (0, $d906535d40bd11c1$export$e5f08023f111098c)[(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$98a92a03d6411c29), {
            onClick: ()=>setScreen('type'),
            leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7a15ad94ac6a08$export$f7121fe80f407126), {
                type: draft.transferType
            }),
            children: draft.transferType == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground",
                children: "Choose type"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "truncate font-semibold",
                children: (0, $d906535d40bd11c1$export$e5f08023f111098c)[draft.transferType]
            })
        });
    }
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-3 pb-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-x-3 gap-y-0.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "row-span-2 flex",
                        children: face
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "min-w-0",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        size: "icon",
                        onClick: onRequestClose,
                        "aria-label": "Close",
                        className: "row-span-2 -mr-2 self-start",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                            className: "size-4"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground min-w-0 truncate text-[12.5px]",
                        children: sub
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3",
                children: [
                    decision,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-2xl font-semibold tracking-tight whitespace-nowrap tabular-nums",
                        children: amount
                    })
                ]
            })
        ]
    });
    // ---- Lines ----
    const fieldNames = new Map((fieldsData?.allFields ?? []).map((field)=>[
            field._id,
            field.name
        ]));
    const tagSummary = [
        ...draft.tags.map((tag)=>({
                key: `tag:${tag}`,
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: tag
                })
            })),
        ...Object.entries(draft.fieldValues).filter(([, value])=>value != null && value !== '').map(([fieldId, value])=>({
                key: `field:${fieldId}`,
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-muted-foreground",
                            children: [
                                fieldNames.get(fieldId) ?? 'Field',
                                ":"
                            ]
                        }),
                        ' ',
                        value
                    ]
                })
            }))
    ];
    const sheetLines = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border divide-border border-y [&>*+*]:border-t",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$b25f334b2bd41010), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $beb58fc2118025b6$export$2e2bcd8739ae039), {}),
                        onClick: ()=>setDateOpen((open)=>!open),
                        open: dateOpen,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: (0, $5474523a6079f1bc$export$86f1a7fa7c9640cb)(true),
                            children: draft.date.toFormat('LLL d, yyyy')
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$49bd1dfb0ad29c40), {
                        open: dateOpen,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                            selectedDate: draft.date,
                            onChange: set('date')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$c444937f05de96f3), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $420bac4ddd218a80$export$2e2bcd8739ae039), {}),
                value: draft.description,
                onChange: set('description'),
                placeholder: "Add a note",
                onFocus: ()=>setDateOpen(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$b25f334b2bd41010), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76c2bea761476961$export$2e2bcd8739ae039), {}),
                onClick: ()=>setScreen('tags'),
                toScreen: true,
                wrap: true,
                children: tagSummary.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    children: "Tags & fields"
                }) : tagSummary.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "bg-muted border-border max-w-full truncate rounded-full border px-2 py-0.5 text-[13px] font-medium",
                        children: t.label
                    }, t.key))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                role: "checkbox",
                "aria-checked": draft.pending,
                onClick: ()=>set('pending')(!draft.pending),
                className: "flex w-full cursor-pointer items-center gap-3 py-3 text-left",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground flex w-5 shrink-0 justify-center [&>svg]:size-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex-1', (0, $5474523a6079f1bc$export$86f1a7fa7c9640cb)(draft.pending)),
                        children: "Pending"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "pointer-events-none",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad8caa31e29e010a$export$2e2bcd8739ae039), {
                            value: draft.pending ? 'check' : 'empty'
                        })
                    })
                ]
            })
        ]
    });
    const lineList = lines.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-1.5 pt-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground px-1 text-xs font-semibold tracking-wider uppercase",
                children: lines.length === 1 ? 'Line' : `${lines.length} lines`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-muted/40 border-border divide-border overflow-hidden rounded-xl border [&>*+*]:border-t",
                children: lines.map((line)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($20f1bd65609d7cc1$var$LineRow, {
                        raw: line.raw,
                        amount: line.amount
                    }, line.raw._id))
            })
        ]
    });
    // ---- Second screens ----
    const renderScreen = (key)=>{
        if (key === 'payee') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7a15ad94ac6a08$export$ac7b0e68191845f3), {
            title: "Payee",
            value: draft.payee,
            suggested: [],
            logos: payeeLogos,
            onPick: (payee)=>{
                set('payee')(payee);
                setScreen(null);
            },
            // A transfer's payee is optional, so it can be taken away again.
            onClear: !isPayment && draft.payee !== '' ? ()=>{
                set('payee')('');
                setScreen(null);
            } : undefined,
            onBack: ()=>setScreen(null)
        });
        if (key === 'category') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7a15ad94ac6a08$export$915de2b652348ee), {
            value: draft.category.getOrElse('') || null,
            suggested: [],
            onPick: (category)=>{
                set('category')((0, $f8f45ddea4959097$exports.some)(category));
                setScreen(null);
            },
            onBack: ()=>setScreen(null)
        });
        if (key === 'type') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de7a15ad94ac6a08$export$9af25aa19ef1c6c9), {
            value: draft.transferType,
            suggested: null,
            onPick: (type)=>{
                set('transferType')(type);
                setScreen(null);
            },
            onBack: ()=>setScreen(null)
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$5b7eb98d0fc5016b), {
            title: "Tags & fields",
            onBack: ()=>setScreen(null),
            trailing: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setScreen(null),
                className: "cursor-pointer text-sm font-semibold text-blue-600 dark:text-blue-400",
                children: "Done"
            }),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d5b27e6036e5285$export$470985d1a1ba634f), {
                variant: "screen",
                tags: draft.tags,
                fieldValues: draft.fieldValues,
                onChange: (tags, fieldValues)=>setDraft((prev)=>({
                            ...prev,
                            tags: tags,
                            fieldValues: fieldValues
                        }))
            })
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex w-full flex-col gap-2",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-destructive text-sm",
                children: [
                    "Couldn't save: ",
                    error.message
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: !hasChanges || !valid || loading,
                className: "w-full py-3 text-base",
                children: loading ? "Saving\u2026" : 'Save'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        label: isPayment ? 'Edit payment' : 'Edit transfer',
        onRequestClose: onRequestClose,
        // The create sheet's frame: a sheet as tall as what it holds on a
        // phone, a centered dialog from sm up.
        className: "top-auto bottom-0 h-auto max-h-[92dvh] rounded-b-none sm:rounded-b-lg",
        footer: screen == null ? footer : undefined,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
            id: formId,
            onSubmit: handleSubmit,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5474523a6079f1bc$export$26da3dced10d02f0), {
                screen: screen,
                renderScreen: renderScreen,
                main: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        header,
                        sheetLines,
                        lineList
                    ]
                })
            })
        })
    });
};





parcelRequire("acw62");








const $4638f71496b5e516$export$d59ace3569612be2 = (props)=>{
    const { field: field, onUpdate: onUpdate } = props;
    const { editFieldModal: editFieldModal, deleteFieldModal: deleteFieldModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const handleEdit = ()=>{
        editFieldModal.openModal({
            field: field,
            onSuccess: onUpdate
        });
    };
    const handleDelete = ()=>{
        deleteFieldModal.openModal({
            field: field,
            onDeleted: onUpdate
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card rounded-lg border p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-3 flex items-start justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "font-medium",
                                        children: field.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "rounded bg-muted px-1.5 py-0.5 text-xs font-medium capitalize text-muted-foreground",
                                        children: field.type
                                    }),
                                    field.required && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "bg-destructive/10 text-destructive rounded px-1.5 py-0.5 text-xs",
                                        children: "Required"
                                    }),
                                    field.allowMultiple && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "rounded bg-primary/10 px-1.5 py-0.5 text-xs text-primary",
                                        children: "Multi-select"
                                    })
                                ]
                            }),
                            field.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground mt-1 text-sm",
                                children: field.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                size: "icon",
                                variant: "ghost",
                                onClick: handleEdit,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                size: "icon",
                                variant: "ghost",
                                onClick: handleDelete,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            })
                        ]
                    })
                ]
            }),
            field.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border border-t pt-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground mb-2 text-sm font-medium",
                        children: "Values"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-wrap gap-2",
                        children: field.values.map((v)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "border-border bg-muted rounded-md border px-2 py-1 text-sm",
                                title: v.description || undefined,
                                children: v.value
                            }, v.value))
                    })
                ]
            })
        ]
    });
};



const $12648488522a12b4$export$ef18ccbe8f7f1919 = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Fields',
        fallback: [
            {
                label: 'Settings',
                href: '/settings'
            }
        ]
    });
    const { data: data, loading: loading, refetch: refetch } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)();
    const { createFieldModal: createFieldModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const handleRefetch = ()=>{
        refetch();
    };
    const handleCreate = ()=>{
        createFieldModal.openModal({
            onSuccess: handleRefetch
        });
    };
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading fields..."
        })
    });
    const fields = data?.allFields || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-4 p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-lg font-semibold",
                                children: "Fields"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground text-sm",
                                children: "Manage field attributes for your transactions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: handleCreate,
                        className: "hidden sm:inline-flex",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "mr-1 h-4 w-4"
                            }),
                            "Create Field"
                        ]
                    })
                ]
            }),
            fields.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border rounded-lg border border-dashed p-8 text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground mb-4",
                        children: "No fields created yet"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground mb-4 text-sm",
                        children: 'Fields let you add structured attributes to transactions, like "fulfillment" (pickup, delivery, restaurant) or "recurring" (one-time, monthly).'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        onClick: handleCreate,
                        type: "button",
                        children: "Create your first field"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f86f33905a87dd$export$b3bb6a251ee1ac06), {
                        onClick: handleCreate,
                        children: "Create Field"
                    }),
                    fields.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4638f71496b5e516$export$d59ace3569612be2), {
                            field: field,
                            onUpdate: handleRefetch
                        }, field._id))
                ]
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



const $85e9dc49a52af1f1$export$409ba391f35fb183 = ({ values: values, onChange: onChange, onError: onError })=>{
    const [newValue, setNewValue] = $acw62.useState('');
    const [newValueDescription, setNewValueDescription] = $acw62.useState('');
    const handleAddValue = ()=>{
        const trimmed = newValue.trim();
        if (!trimmed) return;
        if (trimmed.includes(':')) {
            onError('Values cannot contain colon (:) character');
            return;
        }
        if (values.some((v)=>v.value === trimmed)) {
            onError('Value already exists');
            return;
        }
        onChange([
            ...values,
            {
                value: trimmed,
                description: newValueDescription.trim()
            }
        ]);
        setNewValue('');
        setNewValueDescription('');
        onError(null);
    };
    const handleRemoveValue = (index)=>{
        onChange(values.filter((_, i)=>i !== index));
    };
    const handleUpdateValue = (index, field, newVal)=>{
        onChange(values.map((v, i)=>i === index ? {
                ...v,
                [field]: newVal
            } : v));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: "text-sm font-medium",
                children: "Values"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground text-xs",
                children: "Define the possible values for this field"
            }),
            values.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-border mt-2 flex flex-col gap-3 rounded-md border p-3",
                children: values.map((v, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-muted-foreground flex items-start pt-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $578293164592f2cd$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-1 flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                        value: v.value,
                                        onChange: (val)=>handleUpdateValue(index, 'value', val),
                                        placeholder: "Value name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $654d5ea45aebf8c9$export$379139ebc1c2b235), {
                                        value: v.description,
                                        onChange: (val)=>handleUpdateValue(index, 'description', val),
                                        placeholder: "Description (for LLM)",
                                        rows: 2
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>handleRemoveValue(index),
                                className: "text-muted-foreground hover:text-destructive pt-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border mt-2 flex flex-col gap-2 rounded-md border border-dashed p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground text-xs font-medium",
                        children: "Add new value"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        value: newValue,
                        onChange: setNewValue,
                        placeholder: "Value name...",
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleAddValue();
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $654d5ea45aebf8c9$export$379139ebc1c2b235), {
                        value: newValueDescription,
                        onChange: setNewValueDescription,
                        placeholder: "Description (for LLM)...",
                        rows: 2,
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter' && e.metaKey) {
                                e.preventDefault();
                                handleAddValue();
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        type: "button",
                        variant: "outline",
                        onClick: handleAddValue,
                        disabled: !newValue.trim(),
                        className: "self-start",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "mr-1 h-4 w-4"
                            }),
                            "Add Value"
                        ]
                    })
                ]
            })
        ]
    });
};





const $728d0704ed4afea7$export$1e2b48ba7ce01578 = ({ onRequestClose: onRequestClose, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const [name, setName] = $acw62.useState('');
    const [fieldType, setFieldType] = $acw62.useState((0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum);
    const [description, setDescription] = $acw62.useState('');
    const [values, setValues] = $acw62.useState([]);
    const [required, setRequired] = $acw62.useState(false);
    const [allowMultiple, setAllowMultiple] = $acw62.useState(false);
    const [error, setError] = $acw62.useState(null);
    const isText = fieldType === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text;
    const [createField, { loading: loading }] = (0, $ce9d9e524be20f53$export$dedb17a472ec9063)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            await createField({
                variables: {
                    name: name.trim(),
                    type: fieldType,
                    description: description.trim() || null,
                    values: isText ? [] : values.map((v)=>({
                            value: v.value,
                            description: v.description || null
                        })),
                    required: isText ? false : required,
                    allowMultiple: isText ? false : allowMultiple
                }
            });
            onSuccess();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || !name.trim() || !description.trim() || !isText && values.length === 0,
                children: "Create"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Create Field",
        footer: footer,
        size: "lg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: name,
                            onChange: setName,
                            placeholder: "e.g., fulfillment, recurring",
                            autoFocus: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Type"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setFieldType((0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum),
                                    className: `rounded-md border px-3 py-1.5 text-sm font-medium transition-colors ${fieldType === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum ? 'border-primary bg-primary/10 text-primary' : 'border-border text-muted-foreground hover:bg-muted'}`,
                                    children: "Enum"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setFieldType((0, $ce9d9e524be20f53$export$ed12481c953b8653).Text),
                                    className: `rounded-md border px-3 py-1.5 text-sm font-medium transition-colors ${fieldType === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text ? 'border-primary bg-primary/10 text-primary' : 'border-border text-muted-foreground hover:bg-muted'}`,
                                    children: "Text"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $654d5ea45aebf8c9$export$379139ebc1c2b235), {
                            value: description,
                            onChange: setDescription,
                            placeholder: "Describe what this field tracks and how it should be used by the LLM (1-3 sentences)",
                            rows: 3
                        })
                    ]
                }),
                !isText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85e9dc49a52af1f1$export$409ba391f35fb183), {
                            values: values,
                            onChange: setValues,
                            onError: setError
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            id: "required",
                                            checked: required,
                                            onChange: (e)=>setRequired(e.target.checked),
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "required",
                                            className: "text-sm",
                                            children: "Required on all transactions"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            id: "allowMultiple",
                                            checked: allowMultiple,
                                            onChange: (e)=>setAllowMultiple(e.target.checked),
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "allowMultiple",
                                            className: "text-sm",
                                            children: "Allow multiple values"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");





const $c9d5a4e4454d7a6d$export$7975bdb9eeefb6ca = ({ onRequestClose: onRequestClose, field: field, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const [name, setName] = $acw62.useState(field.name);
    const [description, setDescription] = $acw62.useState(field.description || '');
    const [values, setValues] = $acw62.useState(field.values.map((v)=>({
            value: v.value,
            description: v.description || ''
        })));
    const [required, setRequired] = $acw62.useState(field.required);
    const [allowMultiple, setAllowMultiple] = $acw62.useState(field.allowMultiple);
    const [error, setError] = $acw62.useState(null);
    const isText = field.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text;
    const [updateField, { loading: loading }] = (0, $ce9d9e524be20f53$export$68dc441545c63e86)();
    const hasChanges = name.trim() !== field.name || description.trim() !== (field.description || '') || !isText && (required !== field.required || allowMultiple !== field.allowMultiple || values.length !== field.values.length || values.some((v, i)=>v.value.trim() !== field.values[i]?.value || v.description.trim() !== (field.values[i]?.description || '')));
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            await updateField({
                variables: {
                    id: field._id,
                    name: name.trim(),
                    description: description.trim() || null,
                    ...isText ? {} : {
                        required: required,
                        allowMultiple: allowMultiple,
                        values: values.map((v)=>({
                                value: v.value.trim(),
                                description: v.description.trim() || null
                            }))
                    }
                }
            });
            onSuccess();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || !hasChanges || !name.trim() || !description.trim() || !isText && values.length === 0,
                children: loading ? 'Saving...' : 'Save'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Edit Field",
        footer: footer,
        size: "lg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: name,
                            onChange: setName,
                            placeholder: "e.g., fulfillment, recurring"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Type"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "border-border bg-muted rounded-md border px-3 py-1.5 text-sm font-medium capitalize",
                                    children: field.type
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground text-xs",
                                    children: "Type cannot be changed after creation"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $654d5ea45aebf8c9$export$379139ebc1c2b235), {
                            value: description,
                            onChange: setDescription,
                            placeholder: "Describe what this field tracks and how it should be used by the LLM (1-3 sentences)",
                            rows: 3
                        })
                    ]
                }),
                !isText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85e9dc49a52af1f1$export$409ba391f35fb183), {
                            values: values,
                            onChange: setValues,
                            onError: setError
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            id: "edit-required",
                                            checked: required,
                                            onChange: (e)=>setRequired(e.target.checked),
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "edit-required",
                                            className: "text-sm",
                                            children: "Required on all transactions"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            id: "edit-allowMultiple",
                                            checked: allowMultiple,
                                            onChange: (e)=>setAllowMultiple(e.target.checked),
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "edit-allowMultiple",
                                            className: "text-sm",
                                            children: "Allow multiple values"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");


const $12cca528a4917787$export$71db6c937d4fb507 = (props)=>{
    const { field: field, onRequestClose: onRequestClose, onDeleted: onDeleted } = props;
    const [deleteField, { loading: loading }] = (0, $ce9d9e524be20f53$export$39416e8dff3fda6f)();
    const [showForceOption, setShowForceOption] = $acw62.useState(false);
    const [error, setError] = $acw62.useState(null);
    const handleDelete = async (force)=>{
        setError(null);
        try {
            await deleteField({
                variables: {
                    id: field._id,
                    force: force
                }
            });
            onDeleted?.();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            if (err.message.includes('used in') && !force) setShowForceOption(true);
            else setError(err.message);
        }
    };
    const footer = showForceOption ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: ()=>handleDelete(true),
                disabled: loading,
                children: loading ? 'Deleting...' : 'Force delete'
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: ()=>handleDelete(false),
                disabled: loading,
                children: loading ? 'Deleting...' : 'Delete'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Delete field",
        footer: footer,
        size: "sm",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-destructive/10 text-destructive mb-3 rounded-md p-3 text-sm",
                children: error
            }),
            showForceOption ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "This field is used in transactions. Force delete will remove it from all transactions. Are you sure?"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Are you sure you want to delete ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: field.name
                    }),
                    "? This action cannot be undone."
                ]
            })
        ]
    });
};








/**
 * The registry of named entity bindings.
 *
 * A binding is a durable slot connecting a flow in code to an entity that
 * exists only in the user's database — "the account E-ZPass imports go to",
 * "the category benefit fees use". Code cannot name such entities directly
 * (they are user-created), so a flow declares a slot here and resolves it at
 * use time; the user's choice is stored in Settings.bindings and reused until
 * changed.
 *
 * Keys are code-owned: adding a flow means adding a key here. Values are
 * user-owned: which entity a key resolves to lives only in the database, set
 * via the setBinding mutation (typically remembered automatically the first
 * time the flow runs).
 */ const $86610e55c8afdf1c$export$5f9e987797135574 = {
    cashAccount: {
        entityType: 'account',
        label: 'Cash account',
        description: 'Prefilled by the "ATM withdrawal" shortcut when creating an inverse transaction'
    },
    ezpassImportAccount: {
        entityType: 'account',
        label: 'E-ZPass import account',
        description: 'Where E-ZPass imports land',
        // Imported rows are always USD, and the server rejects a raw whose
        // currency mismatches its account.
        currency: 'USD'
    },
    paycheckCategory: {
        entityType: 'category',
        label: 'Paycheck category',
        description: "The income category paycheck deposits land in \u2014 withheld payroll taxes merge into its node on the cash-flow map (deposits plus withholding)"
    },
    reconciliationCategory: {
        entityType: 'category',
        label: 'Reconciliation category',
        description: "Category for reconcile fix-up adjustments \u2014 when set, an adjustment is categorized the moment it is created"
    },
    retirementCategory: {
        entityType: 'category',
        label: 'Retirement category',
        description: "The income category 401(k)/HSA contributions land in \u2014 on the cash-flow map it pins beside the Saving tier, since those dollars are savings by definition"
    },
    taxYearField: {
        entityType: 'field',
        label: 'Tax year field',
        description: "The field naming which tax year a tax payment or refund settles \u2014 the payroll page reports taxes by tax year from it. An enum field gives a picker and typo-proof values; a text field works too."
    },
    taxesCategory: {
        entityType: 'category',
        label: 'Taxes category',
        description: "Where withheld payroll taxes merge on the cash-flow map \u2014 tax payments and refunds categorized here net against the withheld band"
    },
    venmoImportAccount: {
        entityType: 'account',
        label: 'Venmo import account',
        description: 'Where Venmo imports land',
        currency: 'USD'
    }
};
const $86610e55c8afdf1c$export$bc410b6ef8acab77 = (key)=>Object.prototype.hasOwnProperty.call($86610e55c8afdf1c$export$5f9e987797135574, key);
const $86610e55c8afdf1c$export$f69e7fae3174d69d = Object.keys($86610e55c8afdf1c$export$5f9e987797135574).filter($86610e55c8afdf1c$export$bc410b6ef8acab77);




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



var $jRevU = parcelRequire("jRevU");

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $39f04136db3724b2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
];
const $39f04136db3724b2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("loader-circle", $39f04136db3724b2$export$3efd853dbb351e94);


parcelRequire("acw62");


const $df4223aecf7e84d6$export$e5bc76ad4ac14cbb = ({ rows: rows, existingIds: existingIds, checkingExisting: checkingExisting = false })=>{
    if (rows.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground text-sm",
        children: "No transactions found in the pasted data."
    });
    const newRows = existingIds ? rows.filter((row)=>!existingIds.has(row.id)) : rows;
    const existingCount = rows.length - newRows.length;
    const newTotal = newRows.reduce((sum, row)=>sum + row.amount, 0);
    const countNoun = newRows.length === 1 ? 'transaction' : 'transactions';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border rounded-md border",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-muted/50 flex items-center justify-between gap-3 rounded-t-md border-b px-3 py-2 text-sm",
                children: [
                    checkingExisting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                className: "size-3.5 animate-spin"
                            }),
                            "Checking for duplicates\u2026"
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-foreground",
                                children: [
                                    newRows.length,
                                    " ",
                                    existingIds ? `new ${countNoun}` : countNoun
                                ]
                            }),
                            existingCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    ", ",
                                    existingCount,
                                    " already imported"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                        amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(newTotal, 'USD'),
                        variant: "plain"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "max-h-72 overflow-y-auto",
                children: rows.map((row)=>{
                    const isExisting = existingIds?.has(row.id) ?? false;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('not-last:border-border/50 flex items-center gap-3 px-3 py-2 not-last:border-b', isExisting && 'opacity-40'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-muted-foreground w-20 shrink-0 text-xs tabular-nums",
                                children: row.date
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-foreground min-w-0 flex-1 truncate text-sm",
                                title: row.description,
                                children: row.description
                            }),
                            isExisting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "bg-muted text-muted-foreground shrink-0 rounded-full px-2 py-0.5 text-[0.7rem]",
                                children: "imported"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "shrink-0 text-sm",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                    amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(row.amount, 'USD')
                                })
                            })
                        ]
                    }, row.id);
                })
            })
        ]
    });
};
const $df4223aecf7e84d6$var$MAX_ERROR_LINES = 3;
const $df4223aecf7e84d6$var$MAX_ERROR_LINE_LENGTH = 200;
// formatError embeds the offending value verbatim ("…got <entire paste>"), so
// lines must be truncated or a failed paste renders itself back as a wall of
// text.
const $df4223aecf7e84d6$var$truncateLine = (line)=>line.length > $df4223aecf7e84d6$var$MAX_ERROR_LINE_LENGTH ? `${line.slice(0, $df4223aecf7e84d6$var$MAX_ERROR_LINE_LENGTH)}\u{2026}` : line;
const $df4223aecf7e84d6$export$ca0c21def3b1a7a8 = ({ sourceName: sourceName, error: error })=>{
    const lines = (0, (/*@__PURE__*/$parcel$interopDefault($jRevU))).formatError((0, (/*@__PURE__*/$parcel$interopDefault($jRevU))).simplifyError(error));
    const shown = lines.slice(0, $df4223aecf7e84d6$var$MAX_ERROR_LINES);
    const hiddenCount = lines.length - shown.length;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-destructive/50 rounded-md border px-3 py-2 text-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-destructive",
                children: [
                    "Could not parse this as ",
                    sourceName,
                    " JSON."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground mt-1 flex flex-col gap-0.5 font-mono text-xs",
                children: [
                    shown.map((line, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "break-all",
                            children: $df4223aecf7e84d6$var$truncateLine(line)
                        }, i)),
                    hiddenCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            "\u2026and ",
                            hiddenCount,
                            " more"
                        ]
                    })
                ]
            })
        ]
    });
};



var $8447519b60c7a05a$exports = {};
"use strict";
Object.defineProperty($8447519b60c7a05a$exports, "__esModule", {
    value: true
});
$8447519b60c7a05a$exports.eitherObject = $8447519b60c7a05a$exports.success = $8447519b60c7a05a$exports.failure = void 0;

const $8447519b60c7a05a$var$formatValue = (val)=>{
    if (val instanceof $8447519b60c7a05a$var$AbstractEither) return val.inspect();
    else return JSON.stringify(val);
};
class $8447519b60c7a05a$var$AbstractEither {
    constructor(){
        this.failure = new $8447519b60c7a05a$var$FailureProjection(this);
    }
    map(f) {
        return this.isSuccess ? (0, $8447519b60c7a05a$exports.success)(f(this.getSuccessValue())) : (0, $8447519b60c7a05a$exports.failure)(this.getFailureValue());
    }
    flatMap(f) {
        return this.isSuccess ? f(this.getSuccessValue()) : (0, $8447519b60c7a05a$exports.failure)(this.getFailureValue());
    }
    getOrElse(def) {
        return this.isSuccess ? this.getSuccessValue() : def;
    }
    filter(p) {
        return this.isSuccess && p(this.getSuccessValue()) ? (0, $f8f45ddea4959097$exports.some)((0, $8447519b60c7a05a$exports.success)(this.getSuccessValue())) : $f8f45ddea4959097$exports.none;
    }
    toOption() {
        return this.isSuccess ? (0, $f8f45ddea4959097$exports.some)(this.getSuccessValue()) : $f8f45ddea4959097$exports.none;
    }
    equals(anything) {
        if (anything instanceof $8447519b60c7a05a$var$AbstractEither) {
            if (this.isSuccess && anything.isSuccess) return this.getSuccessValue() === anything.getSuccessValue();
            else if (this.isFailure && anything.isFailure) return this.getFailureValue() === anything.getFailureValue();
            else return false;
        } else return false;
    }
    inspect() {
        if (this.isSuccess) return `Success(${$8447519b60c7a05a$var$formatValue(this.getSuccessValue())})`;
        else return `Failure(${$8447519b60c7a05a$var$formatValue(this.getFailureValue())})`;
    }
}
class $8447519b60c7a05a$var$FailureProjection {
    constructor(e){
        this.e = e;
    }
    map(f) {
        return this.e.isFailure ? (0, $8447519b60c7a05a$exports.failure)(f(this.e.getFailureValue())) : (0, $8447519b60c7a05a$exports.success)(this.e.getSuccessValue());
    }
    flatMap(f) {
        return this.e.isFailure ? f(this.e.getFailureValue()) : (0, $8447519b60c7a05a$exports.success)(this.e.getSuccessValue());
    }
    getOrElse(def) {
        return this.e.isFailure ? this.e.getFailureValue() : def;
    }
    filter(p) {
        return this.e.isFailure && p(this.e.getFailureValue()) ? (0, $f8f45ddea4959097$exports.some)((0, $8447519b60c7a05a$exports.failure)(this.e.getFailureValue())) : $f8f45ddea4959097$exports.none;
    }
    toOption() {
        return this.e.isFailure ? (0, $f8f45ddea4959097$exports.some)(this.e.getFailureValue()) : $f8f45ddea4959097$exports.none;
    }
}
class $8447519b60c7a05a$var$_Failure extends $8447519b60c7a05a$var$AbstractEither {
    constructor(value){
        super();
        this.isSuccess = false;
        this.isFailure = true;
        this.failureValue = value;
    }
    getFailureValue() {
        return this.failureValue;
    }
    getSuccessValue() {
        throw new Error('Called Failure.success');
    }
}
class $8447519b60c7a05a$var$_Success extends $8447519b60c7a05a$var$AbstractEither {
    constructor(value){
        super();
        this.isSuccess = true;
        this.isFailure = false;
        this.successValue = value;
    }
    getFailureValue() {
        throw new Error('Called Success.failure');
    }
    getSuccessValue() {
        return this.successValue;
    }
}
const $8447519b60c7a05a$var$failure = (value)=>new $8447519b60c7a05a$var$_Failure(value);
$8447519b60c7a05a$exports.failure = $8447519b60c7a05a$var$failure;
const $8447519b60c7a05a$var$success = (value)=>new $8447519b60c7a05a$var$_Success(value);
$8447519b60c7a05a$exports.success = $8447519b60c7a05a$var$success;
const $8447519b60c7a05a$var$eitherObject = (obj)=>{
    const result = {};
    for(const key in obj)if (Object.hasOwnProperty.call(obj, key)) {
        const either = obj[key];
        if (either.isSuccess) result[key] = either.successValue;
        else return either;
    }
    return (0, $8447519b60c7a05a$exports.success)(result);
};
$8447519b60c7a05a$exports.eitherObject = $8447519b60c7a05a$var$eitherObject;
$8447519b60c7a05a$exports.default = {
    failure: $8447519b60c7a05a$exports.failure,
    success: $8447519b60c7a05a$exports.success,
    eitherObject: $8447519b60c7a05a$exports.eitherObject
};


var $375f147934bae838$exports = {};
"use strict";
var $375f147934bae838$var$__importDefault = $375f147934bae838$exports && $375f147934bae838$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($375f147934bae838$exports, "__esModule", {
    value: true
});
$375f147934bae838$exports.extract = $375f147934bae838$exports.formatError = void 0;


const $375f147934bae838$var$error_1 = $375f147934bae838$var$__importDefault((parcelRequire("jRevU")));
$375f147934bae838$exports.formatError = $375f147934bae838$var$error_1.default.formatError;
const $375f147934bae838$var$extractExact = (value)=>(input)=>{
        if (value === input) return (0, $8447519b60c7a05a$exports.success)(input);
        else return (0, $8447519b60c7a05a$exports.failure)($375f147934bae838$var$error_1.default.invalidValue(input));
    };
const $375f147934bae838$var$extractNull = $375f147934bae838$var$extractExact(null);
const $375f147934bae838$var$extractUndefined = $375f147934bae838$var$extractExact(undefined);
const $375f147934bae838$var$extractOneOf = (...extractors)=>(input)=>{
        const errors = [];
        for (const extractor of extractors){
            const result = extractor(input);
            if (result.isSuccess) return result;
            errors.push(result.failureValue);
        }
        return (0, $8447519b60c7a05a$exports.failure)($375f147934bae838$var$error_1.default.simplifyError($375f147934bae838$var$error_1.default.multiError(...errors)));
    };
const $375f147934bae838$var$extractNullable = (extractor)=>$375f147934bae838$var$extractOneOf($375f147934bae838$var$extractNull, extractor);
const $375f147934bae838$var$extractNullish = (extractor)=>$375f147934bae838$var$extractOneOf($375f147934bae838$var$extractNull, $375f147934bae838$var$extractUndefined, extractor);
const $375f147934bae838$var$extractOptional = (extractor)=>$375f147934bae838$var$extractOneOf($375f147934bae838$var$extractUndefined, extractor);
const $375f147934bae838$var$extractAny = $8447519b60c7a05a$exports.success;
const $375f147934bae838$var$extractArray = (extractor)=>(anything)=>{
        if (anything && Array.isArray(anything)) return anything.reduce((result, value, i)=>{
            const extracted = extractor(value).map((t)=>[
                    t
                ]).failure.map((e)=>$375f147934bae838$var$error_1.default.pathError(`${i}`, e));
            if (result.isSuccess && extracted.isSuccess) return (0, $8447519b60c7a05a$exports.success)([
                ...result.successValue,
                ...extracted.successValue
            ]);
            else if (result.isFailure && extracted.isFailure) return (0, $8447519b60c7a05a$exports.failure)($375f147934bae838$var$error_1.default.multiError(result.failureValue, extracted.failureValue));
            else return result.flatMap(()=>extracted);
        }, (0, $8447519b60c7a05a$exports.success)([])).failure.map($375f147934bae838$var$error_1.default.simplifyError);
        else return (0, $8447519b60c7a05a$exports.failure)($375f147934bae838$var$error_1.default.invalidArray(anything));
    };
const $375f147934bae838$var$extractBoolean = (anything)=>{
    if (typeof anything === 'boolean') return (0, $8447519b60c7a05a$exports.success)(anything);
    else return (0, $8447519b60c7a05a$exports.failure)($375f147934bae838$var$error_1.default.invalidBoolean(anything));
};
const $375f147934bae838$var$extractNumber = (anything)=>{
    if (typeof anything === 'number') return (0, $8447519b60c7a05a$exports.success)(anything);
    else return (0, $8447519b60c7a05a$exports.failure)($375f147934bae838$var$error_1.default.invalidNumber(anything));
};
const $375f147934bae838$var$extractObject = (anything)=>{
    if (anything && typeof anything === 'object' && !Array.isArray(anything)) return (0, $8447519b60c7a05a$exports.success)(anything);
    else return (0, $8447519b60c7a05a$exports.failure)($375f147934bae838$var$error_1.default.invalidObject(anything));
};
const $375f147934bae838$var$extractShape = (shape)=>(anything)=>$375f147934bae838$var$extractObject(anything).flatMap((obj)=>{
            // mapped is the original object minus any keys not in shape
            const mapped = {};
            Object.keys(shape).forEach((key)=>{
                const extractor = shape[key];
                const value = obj[key];
                mapped[key] = extractor(value);
            });
            return (0, $8447519b60c7a05a$exports.eitherObject)(mapped).map((extracted)=>// Put extra keys back in
                Object.assign(Object.assign({}, obj), extracted)).failure.map((_errorObj)=>{
                const errors = Object.keys(mapped).map((key)=>{
                    const result = mapped[key];
                    if (result.isFailure) return $375f147934bae838$var$error_1.default.pathError(key, result.failureValue);
                    else return null;
                }).filter((maybeError)=>!!maybeError);
                return $375f147934bae838$var$error_1.default.simplifyError($375f147934bae838$var$error_1.default.multiError(...errors));
            });
        });
const $375f147934bae838$var$extractString = (anything)=>{
    if (typeof anything === 'string') return (0, $8447519b60c7a05a$exports.success)(anything);
    else return (0, $8447519b60c7a05a$exports.failure)($375f147934bae838$var$error_1.default.invalidString(anything));
};
$375f147934bae838$exports.extract = {
    any: $375f147934bae838$var$extractAny,
    array: $375f147934bae838$var$extractArray,
    boolean: $375f147934bae838$var$extractBoolean,
    exact: $375f147934bae838$var$extractExact,
    null: $375f147934bae838$var$extractNull,
    nullable: $375f147934bae838$var$extractNullable,
    nullish: $375f147934bae838$var$extractNullish,
    optional: $375f147934bae838$var$extractOptional,
    number: $375f147934bae838$var$extractNumber,
    object: $375f147934bae838$var$extractObject,
    oneOf: $375f147934bae838$var$extractOneOf,
    shape: $375f147934bae838$var$extractShape,
    string: $375f147934bae838$var$extractString,
    undefined: $375f147934bae838$var$extractUndefined
};
$375f147934bae838$exports.default = {
    extract: $375f147934bae838$exports.extract,
    extractAny: $375f147934bae838$var$extractAny,
    extractArray: $375f147934bae838$var$extractArray,
    extractBoolean: $375f147934bae838$var$extractBoolean,
    extractNull: $375f147934bae838$var$extractNull,
    extractNullable: $375f147934bae838$var$extractNullable,
    extractNullish: $375f147934bae838$var$extractNullish,
    extractOptional: $375f147934bae838$var$extractOptional,
    extractNumber: $375f147934bae838$var$extractNumber,
    extractObject: $375f147934bae838$var$extractObject,
    extractOneOf: $375f147934bae838$var$extractOneOf,
    extractShape: $375f147934bae838$var$extractShape,
    extractString: $375f147934bae838$var$extractString,
    extractUndefined: $375f147934bae838$var$extractUndefined
};



var $jRevU = parcelRequire("jRevU");


const $46d0d678547d4ddd$export$18c43dcebf00e571 = (input)=>{
    try {
        return (0, $f8f45ddea4959097$exports.some)(JSON.parse(input));
    } catch  {
        return 0, $f8f45ddea4959097$exports.none;
    }
};


const $01143d4fdbb5e989$export$60eef3c0e038a9a7 = 'ezpass';
const $01143d4fdbb5e989$var$parseEzpassDate = (ezpassDate)=>{
    // EZPass format: "01/06/2026 06:40:54.903" or "01/06/2026"
    const parsed = (0, $63618293c58b5f80$exports.DateTime).fromFormat(ezpassDate, ezpassDate.includes(' ') ? 'MM/dd/yyyy HH:mm:ss.SSS' : 'MM/dd/yyyy', {
        zone: 'America/New_York'
    });
    return parsed.toISODate();
};
const $01143d4fdbb5e989$var$extractTransaction = (0, $375f147934bae838$exports.extract).shape({
    compositeId: (0, $375f147934bae838$exports.extract).string,
    amount: (0, $375f147934bae838$exports.extract).number,
    transactionDate: (0, $375f147934bae838$exports.extract).string,
    activity: (0, $375f147934bae838$exports.extract).string,
    exitPlazaName: (0, $375f147934bae838$exports.extract).string,
    entryPlazaName: (0, $375f147934bae838$exports.extract).string,
    exitPlazaIdName: (0, $375f147934bae838$exports.extract).string,
    entryPlazaIdName: (0, $375f147934bae838$exports.extract).string,
    agency: (0, $375f147934bae838$exports.extract).string,
    isTollorPayment: (0, $375f147934bae838$exports.extract).string,
    maskedCardNumber: (0, $375f147934bae838$exports.extract).optional((0, $375f147934bae838$exports.extract).string),
    payType: (0, $375f147934bae838$exports.extract).optional((0, $375f147934bae838$exports.extract).string)
});
/**
 * The readable half of a plaza field like "HCT - Hugh L. Carey Tunnel".
 *
 * Splits on the FIRST " - " only: the code is always first, but names can
 * contain the separator themselves ("RKB - RFK Br - Bronx" must keep
 * "RFK Br - Bronx", not collapse to "Bronx"). When the name half is empty
 * the code stands in — some agencies publish plazas as "T353 - " with no
 * name, and the code beats no description at all.
 */ const $01143d4fdbb5e989$var$extractPlazaName = (plazaIdName)=>{
    const value = (plazaIdName ?? '').trim();
    if (value === '' || value === '-') return null;
    const dashIndex = value.indexOf(' - ');
    if (dashIndex !== -1) return value.substring(dashIndex + 3).trim() || value.substring(0, dashIndex).trim() || null;
    return value.replace(/^-+|-+$/g, '').trim() || null;
};
/**
 * "<where> (<agency>)" — place first so the description still reads as it
 * always has, with the operator appended for context.
 *
 * Deliberately free of hand-maintained tables: agency codes and plaza names
 * are used exactly as E-ZPass publishes them, so a new bridge or a new
 * agency needs no code change. Entry and exit are both shown when they
 * differ, because exit alone collides — three distinct NJ Turnpike trips
 * all render as "I-278/Eliz/Goethal/V" without the entry.
 */ const $01143d4fdbb5e989$var$buildDescription = (transaction)=>{
    if (transaction.activity === 'PAYMENT') {
        const card = (transaction.maskedCardNumber ?? '').trim().slice(-4);
        const payType = (transaction.payType ?? '').trim();
        return card && payType ? `EZPass Replenishment (${payType} \u{2022}\u{2022}${card})` : 'EZPass Replenishment';
    }
    const entry = $01143d4fdbb5e989$var$extractPlazaName(transaction.entryPlazaIdName);
    const exit = $01143d4fdbb5e989$var$extractPlazaName(transaction.exitPlazaIdName);
    const where = entry && exit && entry !== exit ? `${entry} \u{2192} ${exit}` : exit ?? entry;
    const activity = (transaction.activity ?? '').trim();
    // A plain toll needs no label; anything else (credits, adjustments) keeps
    // the agency's own wording rather than a mapping we would have to extend.
    const label = activity === 'TOLL POSTING' ? where : where ? `${activity} \u{2014} ${where}` : activity;
    const agency = (transaction.agency ?? '').trim();
    if (!label) return agency ? `Toll (${agency})` : 'Toll';
    return agency ? `${label} (${agency})` : label;
};
const $01143d4fdbb5e989$var$transactionToResult = (transaction)=>{
    return {
        amount: Math.round(transaction.amount * 100),
        date: $01143d4fdbb5e989$var$parseEzpassDate(transaction.transactionDate),
        description: $01143d4fdbb5e989$var$buildDescription(transaction),
        externalSource: $01143d4fdbb5e989$export$60eef3c0e038a9a7,
        externalId: transaction.compositeId,
        ezpassData: transaction
    };
};
const $01143d4fdbb5e989$var$extractEzpass = (0, $375f147934bae838$exports.extract).shape({
    transactionList: (0, $375f147934bae838$exports.extract).shape({
        transaction: (0, $375f147934bae838$exports.extract).array($01143d4fdbb5e989$var$extractTransaction)
    })
});
const $01143d4fdbb5e989$var$ezpassFromJson = (json)=>{
    return $01143d4fdbb5e989$var$extractEzpass(json).map((ezpass)=>ezpass.transactionList.transaction.map($01143d4fdbb5e989$var$transactionToResult));
};
const $01143d4fdbb5e989$var$parseEzpass = (input)=>{
    return (0, $46d0d678547d4ddd$export$18c43dcebf00e571)(input).map($01143d4fdbb5e989$var$ezpassFromJson).getOrElseL(()=>(0, $8447519b60c7a05a$exports.failure)((0, (/*@__PURE__*/$parcel$interopDefault($jRevU))).invalidObject(input)));
};
var $01143d4fdbb5e989$export$2e2bcd8739ae039 = $01143d4fdbb5e989$var$parseEzpass;



const $ce4022b269f2e009$export$93f9feadb89f5d9d = (props)=>{
    const [text, setText] = $acw62.useState('');
    const [parsed, setParsed] = $acw62.useState(()=>(0, $01143d4fdbb5e989$export$2e2bcd8739ae039)(text));
    const [existingIds, setExistingIds] = $acw62.useState(new Set());
    const [checkExistingIds, { loading: checkingIds }] = (0, $ce9d9e524be20f53$export$96c4c66480c4375b)();
    const handleChange = (value)=>{
        const newParsed = (0, $01143d4fdbb5e989$export$2e2bcd8739ae039)(value);
        setText(value);
        setParsed(newParsed);
        props.onChange(newParsed.toOption());
        // Check which IDs already exist
        newParsed.toOption().forEach((transactions)=>{
            const externalIds = transactions.map((t)=>t.externalId);
            if (externalIds.length > 0) checkExistingIds({
                variables: {
                    externalSource: (0, $01143d4fdbb5e989$export$60eef3c0e038a9a7),
                    externalIds: externalIds
                }
            }).then((result)=>{
                const existing = result.data?.existingExternalIds ?? [];
                setExistingIds(new Set(existing));
            });
            else setExistingIds(new Set());
        });
    };
    const handleFormat = ()=>{
        (0, $46d0d678547d4ddd$export$18c43dcebf00e571)(text).map((json)=>JSON.stringify(json, null, 2)).forEach((formatted)=>setText(formatted));
    };
    let preview = null;
    if (parsed.isSuccess) preview = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4223aecf7e84d6$export$e5bc76ad4ac14cbb), {
        rows: parsed.successValue.map((t)=>({
                id: t.externalId,
                date: t.date,
                description: t.description,
                amount: t.amount
            })),
        existingIds: existingIds,
        checkingExisting: checkingIds
    });
    else if (text.trim() !== '') // An empty textarea trivially fails to parse; that is the resting state,
    // not an error worth surfacing.
    preview = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4223aecf7e84d6$export$ca0c21def3b1a7a8), {
        sourceName: "E-ZPass",
        error: parsed.failureValue
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $654d5ea45aebf8c9$export$379139ebc1c2b235), {
                        value: text,
                        onChange: handleChange,
                        placeholder: "Paste the JSON transaction history from your E-ZPass NY account\u2026",
                        spellCheck: false,
                        className: "h-36 resize-y font-mono text-xs"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: "px-3 py-1 text-sm",
                            onClick: handleFormat,
                            disabled: text.trim() === '',
                            children: "Format JSON"
                        })
                    })
                ]
            }),
            preview
        ]
    });
};




var $acw62 = parcelRequire("acw62");







var $jRevU = parcelRequire("jRevU");



const $05aa3583d4777ae2$var$parseVenmoDate = (venmoDate)=>(0, $63618293c58b5f80$exports.DateTime).fromISO(venmoDate, {
        zone: 'UTC'
    }).toLocal().toISODate();
const $05aa3583d4777ae2$var$parseVenmoAmount = (amount)=>{
    const signString = amount[0];
    if (signString !== '+' && signString !== '-') throw new Error(`Unexpected sign: ${amount}`);
    const sign = signString === '+' ? 1 : -1;
    const numbers = amount.substring(3).replace(/[.,]/g, '');
    return parseInt(numbers, 10) * sign;
};
const $05aa3583d4777ae2$var$extractPayment = (0, $375f147934bae838$exports.extract).shape({
    id: (0, $375f147934bae838$exports.extract).string,
    amount: (0, $375f147934bae838$exports.extract).string,
    date: (0, $375f147934bae838$exports.extract).string,
    title: (0, $375f147934bae838$exports.extract).shape({
        sender: (0, $375f147934bae838$exports.extract).shape({
            username: (0, $375f147934bae838$exports.extract).string,
            displayName: (0, $375f147934bae838$exports.extract).string
        }),
        receiver: (0, $375f147934bae838$exports.extract).shape({
            username: (0, $375f147934bae838$exports.extract).string,
            displayName: (0, $375f147934bae838$exports.extract).string
        })
    }),
    note: (0, $375f147934bae838$exports.extract).shape({
        content: (0, $375f147934bae838$exports.extract).string
    }),
    type: (0, $375f147934bae838$exports.extract).exact('payment')
});
const $05aa3583d4777ae2$var$paymentToResult = (payment)=>{
    const other = payment.title.sender.username === 'danwanf' ? payment.title.receiver.displayName : payment.title.sender.displayName;
    const amount = $05aa3583d4777ae2$var$parseVenmoAmount(payment.amount);
    const particle = amount >= 0 ? 'from' : 'to';
    return {
        amount: amount,
        date: $05aa3583d4777ae2$var$parseVenmoDate(payment.date),
        description: `Transfer ${particle} ${other}: ${payment.note.content}`,
        venmoId: payment.id
    };
};
const $05aa3583d4777ae2$var$extractTransfer = (0, $375f147934bae838$exports.extract).shape({
    id: (0, $375f147934bae838$exports.extract).string,
    amount: (0, $375f147934bae838$exports.extract).string,
    date: (0, $375f147934bae838$exports.extract).string,
    note: (0, $375f147934bae838$exports.extract).shape({
        name: (0, $375f147934bae838$exports.extract).string,
        lastFour: (0, $375f147934bae838$exports.extract).string
    }),
    type: (0, $375f147934bae838$exports.extract).exact('transfer')
});
const $05aa3583d4777ae2$var$transferToResult = (transfer)=>{
    const amount = $05aa3583d4777ae2$var$parseVenmoAmount(`- ${transfer.amount}`);
    console.log(transfer.amount, amount);
    return {
        amount: amount,
        date: $05aa3583d4777ae2$var$parseVenmoDate(transfer.date),
        description: `Bank transfer to ${transfer.note.name} ${transfer.note.lastFour}`,
        venmoId: transfer.id
    };
};
const $05aa3583d4777ae2$var$extractVenmo = (0, $375f147934bae838$exports.extract).shape({
    stories: (0, $375f147934bae838$exports.extract).array((0, $375f147934bae838$exports.extract).oneOf($05aa3583d4777ae2$var$extractPayment, $05aa3583d4777ae2$var$extractTransfer))
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $05aa3583d4777ae2$var$venmoFromJson = (json)=>{
    return $05aa3583d4777ae2$var$extractVenmo(json).map((venmo)=>venmo.stories.map((transaction)=>{
            switch(transaction.type){
                case 'transfer':
                    return $05aa3583d4777ae2$var$transferToResult(transaction);
                case 'payment':
                    return $05aa3583d4777ae2$var$paymentToResult(transaction);
                default:
                    return (0, $24175cbf70f85c9e$export$2e2bcd8739ae039)(transaction);
            }
        }));
};
const $05aa3583d4777ae2$var$parseVenmo = (input)=>{
    return (0, $46d0d678547d4ddd$export$18c43dcebf00e571)(input).map($05aa3583d4777ae2$var$venmoFromJson).getOrElseL(()=>(0, $8447519b60c7a05a$exports.failure)((0, (/*@__PURE__*/$parcel$interopDefault($jRevU))).invalidObject(input)));
};
var $05aa3583d4777ae2$export$2e2bcd8739ae039 = $05aa3583d4777ae2$var$parseVenmo;


const $1f0ae5d86ce60ab6$export$3d59806e3045e52e = (props)=>{
    const [text, setText] = $acw62.useState('');
    const [parsed, setParsed] = $acw62.useState(()=>(0, $05aa3583d4777ae2$export$2e2bcd8739ae039)(text));
    const handleChange = (value)=>{
        const newParsed = (0, $05aa3583d4777ae2$export$2e2bcd8739ae039)(value);
        setText(value);
        setParsed(newParsed);
        props.onChange(newParsed.toOption());
    };
    const handleFormat = ()=>{
        (0, $46d0d678547d4ddd$export$18c43dcebf00e571)(text).map((json)=>JSON.stringify(json, null, 2)).forEach((formatted)=>setText(formatted));
    };
    let preview = null;
    if (parsed.isSuccess) preview = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4223aecf7e84d6$export$e5bc76ad4ac14cbb), {
        rows: parsed.successValue.map((t)=>({
                id: t.venmoId,
                date: t.date,
                description: t.description,
                amount: t.amount
            }))
    });
    else if (text.trim() !== '') // An empty textarea trivially fails to parse; that is the resting state,
    // not an error worth surfacing.
    preview = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4223aecf7e84d6$export$ca0c21def3b1a7a8), {
        sourceName: "Venmo",
        error: parsed.failureValue
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $654d5ea45aebf8c9$export$379139ebc1c2b235), {
                        value: text,
                        onChange: handleChange,
                        placeholder: "Paste the JSON transaction feed from your Venmo account\u2026",
                        spellCheck: false,
                        className: "h-36 resize-y font-mono text-xs"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: "px-3 py-1 text-sm",
                            onClick: handleFormat,
                            disabled: text.trim() === '',
                            children: "Format JSON"
                        })
                    })
                ]
            }),
            preview
        ]
    });
};





// The binding slot remembering each source's destination account — imports
// from one source always target the same account, so the picker prefills
// from the binding and the chosen account is written back after a
// successful import. See common/bindings.ts.
const $27042ec4522110b1$var$BINDING_KEYS = {
    venmo: 'venmoImportAccount',
    ezpass: 'ezpassImportAccount'
};
const $27042ec4522110b1$var$SOURCES = {
    venmo: {
        name: 'Venmo',
        logo: 'venmo',
        description: 'Payments and transfers, pasted as JSON from venmo.com'
    },
    ezpass: {
        name: 'E-ZPass NY',
        logo: 'ezpass',
        description: 'Tolls and replenishments, pasted as JSON from your account'
    }
};
const $27042ec4522110b1$var$SourceButton = ({ source: source, onClick: onClick })=>{
    const { name: name, logo: logo, description: description } = $27042ec4522110b1$var$SOURCES[source];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: onClick,
        className: "border-input hover:bg-accent/30 flex w-full cursor-pointer items-center gap-3 rounded-md border px-4 py-3 text-left transition",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7ce1c21778619db$export$ef41ebc44b9c1fe4), {
                logo: logo,
                className: "size-8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-foreground",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground text-sm",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                className: "text-muted-foreground size-4 shrink-0"
            })
        ]
    });
};
const $27042ec4522110b1$export$ee15413196553934 = (props)=>{
    const { onImport: onImport, onRequestClose: onRequestClose } = props;
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const [importType, setImportType] = $acw62.useState(null);
    const [account, setAccount] = $acw62.useState((0, $f8f45ddea4959097$exports.none));
    const [createRawTransactions, { loading: loading }] = (0, $ce9d9e524be20f53$export$93673fb014a748bd)();
    const [setBinding] = (0, $ce9d9e524be20f53$export$cd4833426b480f1a)();
    const [parsed, setParsed] = $acw62.useState((0, $f8f45ddea4959097$exports.none));
    const { data: bindingsData } = (0, $ce9d9e524be20f53$export$7d26fb86ec9e5950)();
    // Same query AccountSelect runs, so this is served from the cache; used to
    // resolve the bound account id to the fragment the picker works with.
    const { data: accountsData } = (0, $ce9d9e524be20f53$export$cb6e321bdf608ddb)();
    // Prefill the account from the source's remembered binding, once per
    // source selection — after seeding, the field belongs to the user (a
    // cleared picker must not snap back).
    const [seededType, setSeededType] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        if (importType == null || seededType === importType) return;
        if (bindingsData == null || accountsData == null) return;
        setSeededType(importType);
        const boundId = bindingsData.bindings.find((binding)=>binding.key === $27042ec4522110b1$var$BINDING_KEYS[importType])?.entityId;
        const spec = (0, $86610e55c8afdf1c$export$5f9e987797135574)[$27042ec4522110b1$var$BINDING_KEYS[importType]];
        const bound = accountsData.allAccounts.find(// A bound account that has since closed accepts no new rows, and one
        // in the wrong currency would fail the server's account-currency
        // guard — leave the picker empty rather than prefill a doomed choice.
        (candidate)=>candidate._id === boundId && !(0, $e597f4605156a89e$export$881343af68ecca95)(candidate) && (spec.currency == null || candidate.currency === spec.currency));
        if (bound && account.isEmpty) setAccount((0, $f8f45ddea4959097$exports.some)(bound));
    }, [
        importType,
        seededType,
        bindingsData,
        accountsData,
        account
    ]);
    // Remember the destination for next time. The import has already
    // succeeded, so a failure here is not worth surfacing to the user.
    const rememberAccount = (type, accountId)=>{
        const key = $27042ec4522110b1$var$BINDING_KEYS[type];
        const current = bindingsData?.bindings.find((binding)=>binding.key === key)?.entityId;
        if (current === accountId) return;
        setBinding({
            variables: {
                key: key,
                entityId: accountId
            }
        }).then(()=>{
            client.cache.evict({
                fieldName: 'bindings'
            });
        }).catch(()=>{});
    };
    const handleVenmoChange = (value)=>{
        setParsed(value);
    };
    const handleEzpassChange = (value)=>{
        setParsed(value);
    };
    const handleSubmit = ()=>{
        if (importType == null) return;
        (0, $f8f45ddea4959097$exports.Option).allObject({
            account: account,
            transactions: parsed
        }).forEach(({ account: account, transactions: transactions })=>{
            createRawTransactions({
                variables: {
                    transactions: transactions.map((t)=>({
                            ...t,
                            currency: 'USD',
                            accountId: account._id
                        }))
                }
            }).then((result)=>{
                const newObjects = result?.data?.createRawTransactions;
                if (newObjects) {
                    client.cache.evict({
                        fieldName: 'existingExternalIds'
                    });
                    rememberAccount(importType, account._id);
                    onRequestClose();
                    onImport?.(newObjects);
                }
            });
        });
    };
    // Step 1: Select import type
    if (importType === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Import transactions",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($27042ec4522110b1$var$SourceButton, {
                    source: "venmo",
                    onClick: ()=>setImportType('venmo')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($27042ec4522110b1$var$SourceButton, {
                    source: "ezpass",
                    onClick: ()=>setImportType('ezpass')
                })
            ]
        })
    });
    // Step 2: Import data
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "ghost",
                className: "mr-auto",
                onClick: ()=>{
                    setImportType(null);
                    setParsed((0, $f8f45ddea4959097$exports.none));
                    setAccount((0, $f8f45ddea4959097$exports.none));
                    // Re-arm the prefill: re-entering a source should seed the
                    // just-cleared picker from its binding again.
                    setSeededType(null);
                },
                disabled: loading,
                children: "Back"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                disabled: parsed.isEmpty || account.isEmpty || loading,
                onClick: handleSubmit,
                children: "Import"
            })
        ]
    });
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7ce1c21778619db$export$ef41ebc44b9c1fe4), {
                logo: $27042ec4522110b1$var$SOURCES[importType].logo,
                className: "size-5"
            }),
            "Import from ",
            $27042ec4522110b1$var$SOURCES[importType].name
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: header,
        footer: footer,
        className: "sm:w-2xl",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Account",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $295751b0f96fd69d$export$2e2bcd8739ae039), {
                        selectedAccount: account,
                        onSelectAccount: setAccount,
                        autoFocus: true,
                        // Venmo/EZPass rows are always USD; a foreign destination would
                        // only be rejected by the server's currency guard.
                        currency: "USD"
                    })
                }),
                importType === 'venmo' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f0ae5d86ce60ab6$export$3d59806e3045e52e), {
                    onChange: handleVenmoChange
                }),
                importType === 'ezpass' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce4022b269f2e009$export$93f9feadb89f5d9d), {
                    onChange: handleEzpassChange
                })
            ]
        })
    });
};






var $acw62 = parcelRequire("acw62");





const $468f7c854dda6e96$export$a17b3c2052469c69 = (cents, currency)=>{
    const fraction = cents !== 0 && Math.abs(cents) < 100 ? 2 : 0;
    const amount = fraction ? cents / 100 : Math.round(cents / 100);
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: fraction,
            maximumFractionDigits: fraction
        }).format(amount);
    } catch  {
        return `${amount.toLocaleString('en-US', {
            minimumFractionDigits: fraction
        })} ${currency}`;
    }
};
const $468f7c854dda6e96$export$ff137379e7518313 = (cents, currency)=>`${cents < 0 ? "\u2212" : '+'}${$468f7c854dda6e96$export$a17b3c2052469c69(Math.abs(cents), currency)}`;
const $468f7c854dda6e96$export$dd5b97695b6c46d8 = (cents)=>(0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('tabular-nums', cents != null && cents > 0 && 'text-positive', cents != null && cents < 0 && 'text-destructive');
const $468f7c854dda6e96$export$dd9196c8186add55 = (quantity)=>Math.abs(quantity) < 1 && quantity !== 0 ? quantity.toLocaleString('en-US', {
        maximumSignificantDigits: 6
    }) : quantity.toLocaleString('en-US', {
        maximumFractionDigits: 4
    });
const $468f7c854dda6e96$export$bf8df31cf1819e85 = (quantity)=>`${quantity < 0 ? "\u2212" : '+'}${$468f7c854dda6e96$export$dd9196c8186add55(Math.abs(quantity))} sh`;


const $50bf07908bf4ee59$var$CASH_CHOICES = [
    {
        key: 'dividend',
        label: 'Dividend',
        kind: 'income',
        lands: 'Income',
        shares: false,
        note: 'Dividend'
    },
    {
        key: 'interest',
        label: 'Interest',
        kind: 'income',
        lands: 'Income',
        shares: false,
        note: 'Interest'
    },
    {
        key: 'gain',
        label: 'Capital gain',
        kind: 'gain',
        lands: 'Realized',
        shares: false,
        note: 'Capital gain'
    },
    {
        key: 'deposit',
        label: 'Deposit',
        kind: 'transfer',
        lands: 'Saved',
        shares: false,
        note: 'Deposit'
    },
    {
        key: 'withdrawal',
        label: 'Withdrawal',
        kind: 'transfer',
        lands: 'Saved',
        shares: false,
        note: 'Withdrawal'
    },
    {
        key: 'fee',
        label: 'Fee',
        kind: 'fee',
        lands: 'Fees',
        shares: false,
        note: 'Fee'
    },
    {
        key: 'writeoff',
        label: 'Write off',
        kind: 'writeoff',
        lands: 'Unexplained',
        shares: false,
        note: ''
    }
];
const $50bf07908bf4ee59$var$SHARE_CHOICES = [
    {
        key: 'trade',
        label: 'Trade',
        kind: 'trade',
        lands: 'Basis and cash',
        shares: true,
        note: 'Trade'
    },
    {
        key: 'transfer',
        label: 'Transfer in kind',
        kind: 'transfer',
        lands: 'Saved, at value',
        shares: true,
        note: 'Transfer'
    },
    {
        key: 'corporate',
        label: 'Split or corporate action',
        kind: 'corporate',
        lands: 'Shares only',
        shares: true,
        note: 'Corporate action'
    },
    {
        key: 'writeoff',
        label: 'Write off',
        kind: 'writeoff',
        lands: 'Unexplained',
        shares: true,
        note: ''
    }
];
const $50bf07908bf4ee59$export$9d4d6935fc8945d7 = (gap)=>gap.securityId != null;
const $50bf07908bf4ee59$export$ffc750fa02590898 = (gap)=>$50bf07908bf4ee59$export$9d4d6935fc8945d7(gap) ? $50bf07908bf4ee59$var$SHARE_CHOICES : $50bf07908bf4ee59$var$CASH_CHOICES.filter((choice)=>(gap.cash ?? 0) > 0 ? ![
            'withdrawal',
            'fee'
        ].includes(choice.key) : ![
            'dividend',
            'interest',
            'gain',
            'deposit'
        ].includes(choice.key));
const $50bf07908bf4ee59$export$2b0ba5d06e095a5c = (gaps)=>{
    const through = new Map();
    for (const gap of gaps){
        if (gap.status !== 'unbalanced') continue;
        const day = gap.balancedThrough ?? null;
        if (!through.has(gap.accountId)) {
            through.set(gap.accountId, day);
            continue;
        }
        // The earliest wins, and never balanced (null) is earliest of all.
        const current = through.get(gap.accountId) ?? null;
        if (current != null && (day == null || day < current)) through.set(gap.accountId, day);
    }
    return through;
};
const $50bf07908bf4ee59$export$3343c40eb4b2ade7 = (balancedThrough)=>balancedThrough == null ? 'Not balanced' : `Balanced through ${balancedThrough}`;
const $50bf07908bf4ee59$export$d73783ad1b90140a = {
    refetchQueries: [
        'InvestmentGaps',
        'InvestmentAdjustments',
        'InvestmentPeriods'
    ],
    awaitRefetchQueries: true,
    onQueryUpdated: (query)=>query.refetch().catch(()=>undefined)
};
const $50bf07908bf4ee59$export$f8a71b5bea382e75 = (gap)=>{
    const choices = $50bf07908bf4ee59$export$ffc750fa02590898(gap);
    const interest = gap.suggestion.subtype?.includes('interest') ?? false;
    const byKind = choices.find((choice)=>choice.kind === gap.suggestion.kind && (choice.kind !== 'transfer' || choice.shares === $50bf07908bf4ee59$export$9d4d6935fc8945d7(gap)) && (choice.kind !== 'income' || choice.key === 'interest' === interest));
    return byKind ?? choices[choices.length - 1];
};
const $50bf07908bf4ee59$export$2b8b276cc82d3a3b = (gaps)=>gaps.filter((gap)=>gap.pairedSecurityId == null);
const $50bf07908bf4ee59$export$9ad09e3feeefec25 = (gap, choice, fields)=>{
    // Within a check: its way round, and no bigger, give or take what the
    // checks themselves count as the same (a cent of cash, as the server's
    // sameCash; float noise in shares).
    const within = (value, check, shares)=>Math.sign(value) === Math.sign(check) && Math.abs(value) <= (shares ? Math.abs(check) * (1 + 1e-9) : Math.abs(check) + 1);
    const reached = gap.history.filter((step)=>step.day >= fields.date);
    const closesEach = (value, shares)=>value == null || value === 0 || reached.every((step)=>within(value, step.amount, shares));
    return {
        date: fields.date > gap.after && fields.date <= gap.day,
        shares: !choice.shares || closesEach(fields.quantity, true),
        cash: choice.shares ? fields.cents == null || fields.cents === 0 || gap.suggestion.cash != null && within(fields.cents, gap.suggestion.cash, false) : closesEach(fields.cents, false)
    };
};
const $50bf07908bf4ee59$export$90a7a236fe500cc8 = (gap, choice, fields)=>({
        accountId: gap.accountId,
        date: fields.date,
        kind: choice.kind,
        // A cash choice names the payout's security only when it's the choice suggested.
        securityId: choice.shares ? gap.securityId ?? undefined : choice.key === $50bf07908bf4ee59$export$f8a71b5bea382e75(gap).key ? gap.suggestion.securityId ?? undefined : undefined,
        quantity: choice.shares ? fields.quantity ?? undefined : undefined,
        // A corporate action moves no money; anything else records the cash.
        cash: choice.kind === 'corporate' || fields.cash == null ? undefined : fields.cash,
        note: fields.note.trim() === '' ? undefined : fields.note.trim(),
        // The gap it closes, as seen: the server refuses it if that's changed.
        gapSince: gap.since,
        gapDay: gap.day
    });
const $50bf07908bf4ee59$export$59228d057bab1ed7 = (gap)=>{
    const choice = $50bf07908bf4ee59$export$f8a71b5bea382e75(gap);
    return $50bf07908bf4ee59$export$90a7a236fe500cc8(gap, choice, {
        date: gap.suggestion.date,
        cash: gap.suggestion.cash ?? gap.cash ?? null,
        quantity: gap.suggestion.quantity ?? gap.quantity ?? null,
        note: choice.kind === 'writeoff' ? gap.suggestion.evidence ?? 'Rounding' : choice.note
    });
};




/** Dollars typed by hand ("−1,421.40", "$12") as cents; null when not a number. */ const $5ecb2bb1cb0d93cc$var$parseCents = (text)=>{
    const cleaned = text.replace(/[$,\s]/g, '').replace("\u2212", '-');
    if (cleaned === '' || Number.isNaN(Number(cleaned))) return null;
    return Math.round(Number(cleaned) * 100);
};
/**
 * What an activity row moved, as the checks count it: its shares, then its
 * cash ("—" when the checks can't count it). A row in another currency
 * isn't counted, so it shows the cash it moved in its own.
 */ const $5ecb2bb1cb0d93cc$var$movedBy = (row)=>{
    const { effect: effect } = row;
    const unknown = effect.foreign ? effect.foreignCash == null : effect.cashUnknown;
    const cash = effect.foreign ? effect.foreignCash ?? 0 : effect.cash;
    return [
        effect.quantity !== 0 ? (0, $468f7c854dda6e96$export$bf8df31cf1819e85)(effect.quantity) : null,
        unknown ? "\u2014" : cash !== 0 || effect.quantity === 0 ? (0, $468f7c854dda6e96$export$ff137379e7518313)(cash, row.currency) : null
    ].filter((part)=>part != null).join(" \xb7 ");
};
const $5ecb2bb1cb0d93cc$var$centsText = (cents)=>cents == null ? '' : (cents / 100).toFixed(2);
const $5ecb2bb1cb0d93cc$export$f7d70d5c9dc2cc15 = (props)=>{
    const { gap: opened } = props;
    // Its account (name, and the currency its amounts are in) as it is now: a
    // sync can change an account's currency.
    const { data: accountsData, loading: accountsRefreshing, error: accountsError, refetch: refetchAccounts } = (0, $ce9d9e524be20f53$export$34fd8d1d279e4cb6)({
        notifyOnNetworkStatusChange: true
    });
    const account = accountsData?.allInvestmentAccounts.find((a)=>a._id === opened.accountId);
    const currency = account?.currency ?? 'USD';
    // The gap as the checks have it now, not as it was when the sheet opened:
    // a refresh (a sync, another record) may have moved or closed it. Any
    // refetch shows as loading.
    const { data: gapsData, loading: gapsRefreshing, error: gapsError, refetch: refetchGaps } = (0, $ce9d9e524be20f53$export$2d57afd40a6482f)({
        notifyOnNetworkStatusChange: true
    });
    const same = (other)=>other.accountId === opened.accountId && other.securityId === opened.securityId;
    const live = gapsData == null ? opened : gapsData.investmentGaps.find(same);
    // Still the same gap, and its own card: not closed (or closed and opened
    // again: a new gap, with its own since), and not since paired into a trade
    // (whose share gap's sheet records both legs).
    const current = live != null && live.pairedSecurityId == null && live.since === opened.since ? live : null;
    const gap = current ?? opened;
    const formId = $acw62.useId();
    const choices = (0, $50bf07908bf4ee59$export$ffc750fa02590898)(gap);
    // Every field follows the live gap (its suggestion, its size) until the
    // person sets it, so a refresh's better evidence carries through. A pick
    // holds only while it still fits the gap (a refresh can turn it around).
    const [picked, setPicked] = $acw62.useState(null);
    const choice = choices.find((c)=>c.key === picked?.key) ?? (0, $50bf07908bf4ee59$export$f8a71b5bea382e75)(gap);
    const [typedDate, setTypedDate] = $acw62.useState(null);
    const date = typedDate ?? (0, $0c0f91b069db95d9$export$6b862160d295c8e)(gap.suggestion.date);
    const [typedCash, setTypedCash] = $acw62.useState(null);
    const cash = typedCash ?? $5ecb2bb1cb0d93cc$var$centsText(gap.suggestion.cash ?? gap.cash);
    // A gap is a difference of stored quantities, so it carries float noise; ten significant digits drop it.
    const [typedShares, setTypedShares] = $acw62.useState(null);
    const shares = typedShares ?? (gap.quantity != null ? String(Number(gap.quantity.toPrecision(10))) : '');
    const [typedNote, setTypedNote] = $acw62.useState(null);
    const note = typedNote ?? choice.note;
    const [error, setError] = $acw62.useState(null);
    const [create, { loading: loading }] = (0, $ce9d9e524be20f53$export$e285bb2a5fec598f)((0, $50bf07908bf4ee59$export$d73783ad1b90140a));
    // The account's activity over the gap's span: what the feed did say. The
    // checks apply a row on the date it posted, so these are the rows that
    // posted from the observation before the gap opened (exclusive in the
    // checks, shown for context) to the latest one: anything later isn't in
    // the gap yet. It's always fetched fresh (a sync may have added rows
    // since; a sync's refresh refetches it).
    const from = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(gap.after);
    const to = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(gap.day);
    const { data: activityData, loading: activityLoading, error: activityError, refetch: refetchActivity } = (0, $ce9d9e524be20f53$export$c310ea9dc61709c1)({
        variables: {
            from: from.toISODate(),
            to: to.toISODate(),
            accountId: opened.accountId,
            byPosting: true
        },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true
    });
    const activity = (activityData?.investmentActivity ?? []).filter((row)=>!row.effect.cancelled).sort((a, b)=>a.date.localeCompare(b.date));
    const pick = (key)=>{
        setPicked(choices.find((c)=>c.key === key) ?? choice);
    };
    const cents = $5ecb2bb1cb0d93cc$var$parseCents(cash);
    const quantity = shares.trim() === '' ? null : Number(shares);
    // A trade's cash only when a cash gap moved with it; otherwise its cash
    // would open one.
    const needsCash = !choice.shares || choice.kind === 'trade' && gap.suggestion.cash != null;
    const closes = (0, $50bf07908bf4ee59$export$9ad09e3feeefec25)(gap, choice, {
        date: date.toISODate() ?? gap.since,
        cents: cents,
        quantity: quantity
    });
    const valid = // Cash alone must be some amount; a trade's may be none, or left out.
    (!needsCash || (choice.shares ? cash.trim() === '' || cents != null : cents != null && cents !== 0)) && (!choice.shares || quantity != null && !Number.isNaN(quantity) && quantity !== 0) && (choice.kind !== 'writeoff' || note.trim() !== '') && closes.date && closes.shares && (!needsCash || closes.cash);
    // Recording needs the evidence fresh: the gap, its activity and its
    // account all loaded, without error, since the last refresh.
    const fresh = !gapsRefreshing && gapsError == null && !activityLoading && activityError == null && !accountsRefreshing && accountsError == null && account != null;
    const closed = current == null;
    const ready = !loading && fresh && !closed && valid;
    const retry = ()=>{
        if (gapsError != null) refetchGaps().catch(()=>undefined);
        if (activityError != null) refetchActivity().catch(()=>undefined);
        if (accountsError != null) refetchAccounts().catch(()=>undefined);
    };
    // While it records, the sheet stays: closing it could let the gap be recorded again.
    const close = ()=>{
        if (!loading) props.onRequestClose();
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if (!ready) return;
        setError(null);
        try {
            const result = await create({
                variables: (0, $50bf07908bf4ee59$export$90a7a236fe500cc8)(gap, choice, {
                    date: date.toISODate() ?? gap.since,
                    cash: needsCash ? cents : null,
                    quantity: choice.shares ? quantity : null,
                    note: note
                })
            });
            const id = result.data?.createInvestmentAdjustment._id;
            if (id != null) props.onRecorded?.(id, choice.label);
            props.onRequestClose();
        } catch (err) {
            setError(err instanceof Error ? err.message : "Couldn't record it");
            // Refused, maybe because the gap has moved on: fetch it as it is now.
            refetchGaps().catch(()=>undefined);
        }
    };
    const title = gap.securityLabel ?? 'Cash';
    const size = (0, $50bf07908bf4ee59$export$9d4d6935fc8945d7)(gap) ? (0, $468f7c854dda6e96$export$bf8df31cf1819e85)(gap.quantity ?? 0) : (0, $468f7c854dda6e96$export$ff137379e7518313)(gap.cash ?? 0, currency);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: close,
        header: "What was this?",
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    disabled: loading,
                    onClick: close,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    type: "submit",
                    form: formId,
                    disabled: !ready,
                    children: choice.kind === 'writeoff' ? 'Write off' : `Record ${choice.label.toLowerCase()}`
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: (event)=>void handleSubmit(event),
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "truncate font-medium",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-muted-foreground truncate text-sm",
                                    children: [
                                        account?.name ?? 'Account',
                                        " \xb7 since ",
                                        gap.since
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "shrink-0 font-semibold tabular-nums",
                            children: size
                        })
                    ]
                }),
                closed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    role: "status",
                    className: "text-positive text-sm",
                    children: live == null ? 'Balanced now' : live.pairedSecurityId != null ? 'Part of a trade now' : 'A new gap now'
                }),
                gap.suggestion.evidence != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-muted-foreground text-sm",
                    children: [
                        "\u21B3 ",
                        gap.suggestion.evidence
                    ]
                }),
                (gapsError != null || activityError != null || accountsError != null) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    role: "alert",
                    className: "bg-destructive/10 text-destructive flex items-center justify-between gap-3 rounded-lg px-3 py-2 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: gapsError != null ? "Couldn't refresh the gap." : activityError != null ? "Couldn't load activity." : "Couldn't refresh the account."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "underline",
                            onClick: retry,
                            children: "Retry"
                        })
                    ]
                }),
                (activity.length > 0 || activityLoading && activityData == null) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-muted-foreground text-xs tracking-wide uppercase",
                            children: "Activity"
                        }),
                        activityLoading && activityData == null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-muted-foreground text-sm",
                            children: "Loading activity..."
                        }),
                        activity.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between gap-3 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "min-w-0 truncate",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-muted-foreground tabular-nums",
                                                children: row.date
                                            }),
                                            " ",
                                            row.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "shrink-0 tabular-nums",
                                        children: $5ecb2bb1cb0d93cc$var$movedBy(row)
                                    })
                                ]
                            }, row._id))
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-wrap gap-1.5",
                    role: "group",
                    "aria-label": "Kind",
                    children: choices.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            "aria-pressed": c.key === choice.key,
                            onClick: ()=>pick(c.key),
                            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('rounded-full border px-3 py-1 text-sm', c.key === choice.key ? 'bg-primary text-primary-foreground border-primary' : 'border-border'),
                            children: c.label
                        }, c.key))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-muted-foreground text-sm",
                    children: [
                        "Counts as ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-foreground font-medium",
                            children: choice.lands
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Date",
                    htmlFor: `${formId}-date`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                        id: `${formId}-date`,
                        selectedDate: date,
                        onChange: setTypedDate,
                        invalid: !closes.date
                    })
                }),
                choice.shares && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Shares",
                    htmlFor: `${formId}-shares`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        id: `${formId}-shares`,
                        value: shares,
                        onChange: setTypedShares,
                        inputMode: "decimal",
                        "aria-invalid": !closes.shares
                    })
                }),
                needsCash && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Cash",
                    htmlFor: `${formId}-cash`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        id: `${formId}-cash`,
                        "aria-invalid": !closes.cash,
                        value: cash,
                        onChange: setTypedCash,
                        inputMode: "decimal",
                        placeholder: (0, $468f7c854dda6e96$export$a17b3c2052469c69)(0, currency)
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Note",
                    htmlFor: `${formId}-note`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        id: `${formId}-note`,
                        value: note,
                        onChange: setTypedNote,
                        placeholder: choice.kind === 'writeoff' ? 'Rounding' : ''
                    })
                }),
                error != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-sm",
                    children: error
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");




const $4f327dc1bbcd75a0$export$c72da5fb2cc7ff21 = (props)=>{
    const { rawTransaction: rawTransaction, currentBenefitName: currentBenefitName, onRequestClose: onRequestClose } = props;
    const { data: feePeriodsData, loading: feePeriodsLoading } = (0, $ce9d9e524be20f53$export$46a1dde66166f325)();
    const [linkBenefit, { loading: linking }] = (0, $ce9d9e524be20f53$export$1d5034815fcbdd74)({
        update: (0, $a9d94318500ad031$export$260983a97254aea6)
    });
    const [error, setError] = $acw62.useState(null);
    const handleSelect = (selected)=>{
        // BenefitPicker has no disabled state, so guard here: a second selection
        // while a mutation is in flight would queue conflicting link calls
        if (linking) return;
        setError(null);
        linkBenefit({
            variables: {
                rawTransactionId: rawTransaction._id,
                benefitId: selected._id
            }
        }).then(()=>onRequestClose()).catch((e)=>{
            setError(e instanceof Error ? e.message : 'Failed to link benefit.');
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        size: "md",
        header: currentBenefitName ? 'Change benefit' : 'Link benefit',
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
            variant: "outline",
            onClick: onRequestClose,
            children: "Cancel"
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-3",
            children: [
                currentBenefitName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-muted-foreground text-sm",
                    children: [
                        "Currently linked to ",
                        currentBenefitName,
                        ". Selecting a benefit replaces the link."
                    ]
                }),
                feePeriodsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground text-sm",
                    children: "Loading benefits\u2026"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2680a3b0889a19c1$export$c75002b314c2fe72), {
                    feePeriods: feePeriodsData?.allFeePeriods ?? [],
                    transactionDate: (0, $0c0f91b069db95d9$export$6b862160d295c8e)(rawTransaction.date).toSeconds(),
                    accountId: rawTransaction.account._id,
                    onSelect: handleSelect
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-destructive text-sm",
                    children: error
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");




const $e217ae5457fd610b$var$ALL_PRODUCTS = [
    {
        id: 'transactions',
        label: 'Transactions',
        description: 'Sync checking, savings, and credit card transactions'
    },
    {
        id: 'investments',
        label: 'Investments',
        description: 'Sync brokerage, 401k, and IRA account holdings'
    }
];
const $e217ae5457fd610b$export$d34371664a395c74 = (props)=>{
    // Default to ['transactions'] for old tokens that don't have products field set
    // (All old tokens were transactions-only since that was the only product before)
    const currentProducts = props.currentProducts && props.currentProducts.length > 0 ? props.currentProducts : [
        'transactions'
    ];
    const [step, setStep] = $acw62.useState('product-selection');
    const [linkToken, setLinkToken] = $acw62.useState(null);
    // Track selected products - start with current products checked
    const [selectedProducts, setSelectedProducts] = $acw62.useState(()=>new Set(currentProducts));
    const [getLinkToken, { loading: linkTokenLoading }] = (0, $ce9d9e524be20f53$export$19671fa43eafe14e)();
    const [updateProducts] = (0, $ce9d9e524be20f53$export$2082bb0a4062f3aa)();
    const handlePlaidSuccess = $acw62.useCallback((_publicToken, _metadata)=>{
        // Persist the updated products to the PlaidAccessToken record
        const allSelectedProducts = Array.from(selectedProducts);
        updateProducts({
            variables: {
                id: props.plaidAccessTokenId,
                products: allSelectedProducts
            }
        }).then(()=>{
            props.onSuccess?.();
            props.onRequestClose();
        });
    }, [
        props,
        selectedProducts,
        updateProducts
    ]);
    const handlePlaidExit = $acw62.useCallback(()=>{
        setStep('product-selection');
        setLinkToken(null);
    }, []);
    const { open: open, ready: ready } = (0, $8a36ddd27b352a95$exports.usePlaidLink)({
        token: linkToken,
        onSuccess: handlePlaidSuccess,
        onExit: handlePlaidExit
    });
    // Auto-open Plaid when ready and in plaid-link step
    $acw62.useEffect(()=>{
        if (ready && step === 'plaid-link') open();
    }, [
        ready,
        step,
        open
    ]);
    const toggleProduct = (productId)=>{
        setSelectedProducts((prev)=>{
            const next = new Set(prev);
            if (next.has(productId)) next.delete(productId);
            else next.add(productId);
            return next;
        });
    };
    const handleUpdate = ()=>{
        // Only pass products that are NEW (not already authorized)
        // For pure reauth, pass null so Plaid doesn't show institution picker
        const newProducts = Array.from(selectedProducts).filter((p)=>!currentProducts.includes(p));
        getLinkToken({
            variables: {
                plaidAccessTokenId: props.plaidAccessTokenId,
                products: newProducts.length > 0 ? newProducts : null
            }
        }).then((result)=>{
            if (result.data?.getLinkTokenForConnection) {
                setLinkToken(result.data.getLinkTokenForConnection);
                setStep('plaid-link');
            }
        });
    };
    const hasNewProducts = $e217ae5457fd610b$var$ALL_PRODUCTS.some((p)=>selectedProducts.has(p.id) && !currentProducts.includes(p.id));
    if (step === 'plaid-link') // Show a simple waiting state while Plaid popup is open
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: props.onRequestClose,
        header: `Manage ${props.institutionName ?? 'Connection'}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col items-center gap-4 py-8",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground",
                    children: "Complete the authentication in the Plaid window..."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: handlePlaidExit,
                    children: "Cancel"
                })
            ]
        })
    });
    const canUpdate = selectedProducts.size > 0;
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: props.onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                disabled: !canUpdate || linkTokenLoading,
                onClick: handleUpdate,
                children: linkTokenLoading ? 'Loading...' : hasNewProducts ? 'Add Products' : 'Re-authenticate'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: props.onRequestClose,
        header: `Manage ${props.institutionName ?? 'Connection'}`,
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground",
                    children: "Select which products to authorize. Check additional products to add them, or click Re-authenticate to refresh your credentials."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-col gap-3",
                    children: $e217ae5457fd610b$var$ALL_PRODUCTS.map((product)=>{
                        const isAuthorized = currentProducts.includes(product.id);
                        const isSelected = selectedProducts.has(product.id);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex cursor-pointer items-center gap-3",
                            onClick: ()=>toggleProduct(product.id),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93d44a992b7c3d39$export$2e2bcd8739ae039), {
                                    value: isSelected,
                                    onChange: ()=>toggleProduct(product.id)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-1 flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-medium",
                                                    children: product.label
                                                }),
                                                isAuthorized && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "rounded bg-green-100 px-1.5 py-0.5 text-xs font-medium text-green-700 dark:bg-green-900 dark:text-green-300",
                                                    children: "Authorized"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground text-sm",
                                            children: product.description
                                        })
                                    ]
                                })
                            ]
                        }, product.id);
                    })
                })
            ]
        })
    });
};










var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");






const $ad10a945edd6a61f$export$b6df4a590c2c36de = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
        variant: "ghost",
        size: "icon",
        type: "button",
        onClick: onClick,
        title: "Copy to all splits",
        "aria-label": "Copy to all splits",
        className: "shrink-0 p-1.5",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
            className: "size-4"
        })
    });
const $ad10a945edd6a61f$var$suggestionDetail = (s)=>`${s.matchCount} of ${s.totalCount}`;
// Sparkle + provenance rendered inside an input holding an auto-applied value.
const $ad10a945edd6a61f$var$AppliedBadge = ({ detail: detail })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "text-muted-foreground flex items-center gap-1 text-xs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                className: "text-foreground size-3"
            }),
            detail
        ]
    });
const $ad10a945edd6a61f$export$c926719e59417ac4 = ({ value: value, onChange: onChange, onCopyToAll: onCopyToAll, suggestions: suggestions, autoApplied: autoApplied, autoFocusPayee: autoFocusPayee, onFieldEdited: onFieldEdited })=>{
    const withCopyToAll = (field, input)=>onCopyToAll === undefined ? input : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-center gap-1",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-1",
                    children: input
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad10a945edd6a61f$export$b6df4a590c2c36de, {
                    onClick: ()=>onCopyToAll(field)
                })
            ]
        });
    // Distinct payees/categories in caller order (most-frequent first), each
    // carrying the provenance of its best match.
    const payeeSuggestions = $acw62.useMemo(()=>{
        const seen = new Set();
        const out = [];
        for (const s of suggestions ?? [])if (s.payee !== '' && !seen.has(s.payee)) {
            seen.add(s.payee);
            out.push({
                name: s.payee,
                detail: $ad10a945edd6a61f$var$suggestionDetail(s)
            });
        }
        return out;
    }, [
        suggestions
    ]);
    const categorySuggestions = $acw62.useMemo(()=>{
        const seen = new Set();
        const out = [];
        for (const s of suggestions ?? [])if (s.categoryName !== '' && !seen.has(s.categoryName)) {
            seen.add(s.categoryName);
            out.push({
                name: s.categoryName,
                detail: $ad10a945edd6a61f$var$suggestionDetail(s)
            });
        }
        return out;
    }, [
        suggestions
    ]);
    const payeeBadgeDetail = autoApplied?.payee != null && value.payee === autoApplied.payee ? payeeSuggestions.find((s)=>s.name === value.payee)?.detail ?? null : undefined;
    const currentCategory = value.category.getOrElse('');
    const categoryBadgeDetail = autoApplied?.category != null && currentCategory === autoApplied.category ? categorySuggestions.find((s)=>s.name === currentCategory)?.detail ?? null : undefined;
    // Brief green wash when values land via auto-apply, so the form visibly
    // "did something" rather than silently arriving pre-filled. One-shot:
    // `autoApplied` also changes identity when an edit clears a field's
    // provenance, and that must not flash the other field again.
    const [washed, setWashed] = $acw62.useState(false);
    const washedOnceRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (autoApplied == null || washedOnceRef.current) return;
        washedOnceRef.current = true;
        setWashed(true);
        const timeout = setTimeout(()=>setWashed(false), 1200);
        return ()=>clearTimeout(timeout);
    }, [
        autoApplied
    ]);
    const washClassName = (applied)=>(0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('transition-colors duration-700', washed && applied && 'bg-green-500/10 dark:bg-green-400/10');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Payee",
                children: withCopyToAll('payee', /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1af78646b91168e0$export$2e2bcd8739ae039), {
                    value: value.payee,
                    onChange: (payee)=>onChange({
                            ...value,
                            payee: payee
                        }),
                    autoFocus: autoFocusPayee,
                    onEdited: onFieldEdited ? ()=>onFieldEdited('payee') : undefined,
                    suggestions: payeeSuggestions,
                    adornment: payeeBadgeDetail !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad10a945edd6a61f$var$AppliedBadge, {
                        detail: payeeBadgeDetail
                    }) : undefined,
                    inputClassName: washClassName(autoApplied?.payee != null)
                }))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Category",
                children: withCopyToAll('category', /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9eb11e6352514841$export$2e2bcd8739ae039), {
                    selectedCategory: value.category,
                    onSelectCategory: (category)=>onChange({
                            ...value,
                            category: category
                        }),
                    onEdited: onFieldEdited ? ()=>onFieldEdited('category') : undefined,
                    suggestions: categorySuggestions,
                    adornment: categoryBadgeDetail !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad10a945edd6a61f$var$AppliedBadge, {
                        detail: categoryBadgeDetail
                    }) : undefined,
                    inputClassName: washClassName(autoApplied?.category != null)
                }))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Description",
                children: withCopyToAll('description', /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                    value: value.description,
                    onChange: (description)=>onChange({
                            ...value,
                            description: description
                        }),
                    placeholder: "Add description"
                }))
            })
        ]
    });
};



const $cb9be4568c64be10$export$bebf05392a43a0d3 = ({ onRequestClose: onRequestClose, transactions: transactions, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const netAmount = transactions.reduce((sum, tx)=>sum + tx.netAmount, 0);
    const isTransfer = netAmount === 0;
    const currency = transactions[0]?.currency ?? 'USD';
    const defaultDate = $acw62.useMemo(()=>{
        if (transactions.length === 0) return (0, $63618293c58b5f80$exports.DateTime).local();
        return (0, $63618293c58b5f80$exports.DateTime).max(...transactions.map((tx)=>(0, $0c0f91b069db95d9$export$6b862160d295c8e)(tx.date)));
    }, [
        transactions
    ]);
    const [form, setForm] = $acw62.useState(()=>{
        // A unanimous payee across the sources survives the merge as a prefill —
        // the common case is a charge and its refund from the same merchant,
        // where retyping "Amazon" would be pure friction. Any disagreement (or
        // all-empty) starts blank rather than guessing.
        const payees = [
            ...new Set(transactions.map((tx)=>tx.payee).filter((payee)=>payee != null && payee !== ''))
        ];
        return {
            payee: payees.length === 1 ? payees[0] : '',
            description: '',
            date: defaultDate,
            category: (0, $f8f45ddea4959097$exports.none),
            tags: [],
            fieldValues: {},
            transferType: (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).AccountTransfer
        };
    });
    const [mergeTransactions, { loading: loading, error: error }] = (0, $ce9d9e524be20f53$export$3b0b120d5fcdcbea)();
    const canSubmit = isTransfer || !form.category.isEmpty && form.payee.trim() !== '';
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!canSubmit) return;
        mergeTransactions({
            variables: {
                transactionIds: transactions.map((tx)=>tx._id),
                date: form.date.toISODate() ?? '',
                description: form.description,
                // A transfer's payee is its optional counterparty; empty means none.
                payee: isTransfer ? form.payee.trim() !== '' ? form.payee : undefined : form.payee,
                category: isTransfer ? undefined : form.category.isEmpty ? undefined : form.category.getOrElse(''),
                transferType: isTransfer ? form.transferType : undefined,
                tags: form.tags,
                fieldValues: form.fieldValues
            }
        }).then((result)=>{
            if (result.data) {
                onSuccess?.();
                client.refetchQueries({
                    include: [
                        'Transactions'
                    ]
                });
                onRequestClose();
            }
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "ghost",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || !canSubmit,
                children: "Merge"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Merge Transactions",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-6",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-muted-foreground flex items-center gap-1 text-sm",
                    children: [
                        "Merging ",
                        transactions.length,
                        " transactions \xb7 net",
                        ' ',
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                            inline: true,
                            variant: "plain",
                            amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(netAmount, currency)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        isTransfer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                            label: "Type",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d906535d40bd11c1$export$2ee929a1dd0aa042), {
                                value: form.transferType,
                                onChange: (transferType)=>setForm({
                                        ...form,
                                        transferType: transferType
                                    })
                            })
                        }),
                        !isTransfer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad10a945edd6a61f$export$c926719e59417ac4), {
                            value: {
                                payee: form.payee,
                                category: form.category,
                                description: form.description
                            },
                            onChange: ({ payee: payee, category: category, description: description })=>setForm({
                                    ...form,
                                    payee: payee,
                                    category: category,
                                    description: description
                                })
                        }),
                        isTransfer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                    label: "Description",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                        value: form.description,
                                        onChange: (description)=>setForm({
                                                ...form,
                                                description: description
                                            }),
                                        placeholder: "Add description"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                    label: "Payee",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1af78646b91168e0$export$2e2bcd8739ae039), {
                                        value: form.payee,
                                        onChange: (payee)=>setForm({
                                                ...form,
                                                payee: payee
                                            })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                            label: "Date",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                selectedDate: form.date,
                                onChange: (date)=>setForm({
                                        ...form,
                                        date: date
                                    })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                            label: "Tags & Fields",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d5b27e6036e5285$export$470985d1a1ba634f), {
                                tags: form.tags,
                                fieldValues: form.fieldValues,
                                onChange: (tags, fieldValues)=>setForm({
                                        ...form,
                                        tags: tags,
                                        fieldValues: fieldValues
                                    })
                            })
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-sm",
                    children: error.message
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
const $5e7a1f916ae1c08a$export$b5ea210650594713 = 'var(--color-blue-500, #2b7fff)';
const $5e7a1f916ae1c08a$export$ac669cb52583a1b = 'var(--color-teal-600, #009689)';
const $5e7a1f916ae1c08a$var$OVERLAP_COLOR = 'var(--color-amber-500, #fe9a00)';
const $5e7a1f916ae1c08a$var$HALF_HEIGHT = 32;
const $5e7a1f916ae1c08a$var$AXIS_GAP = 3; // bar-to-axis breathing room on each side
const $5e7a1f916ae1c08a$var$CHART_HEIGHT = $5e7a1f916ae1c08a$var$HALF_HEIGHT * 2 + $5e7a1f916ae1c08a$var$AXIS_GAP * 2 + 1;
const $5e7a1f916ae1c08a$var$AXIS_Y = $5e7a1f916ae1c08a$var$HALF_HEIGHT + $5e7a1f916ae1c08a$var$AXIS_GAP;
const $5e7a1f916ae1c08a$var$formatBucketLabel = (unit, startISO)=>{
    const start = (0, $63618293c58b5f80$exports.DateTime).fromISO(startISO, {
        zone: 'utc'
    });
    switch(unit){
        case 'year':
            return start.toFormat('yyyy');
        case 'quarter':
            return `Q${start.quarter} ${start.toFormat('yyyy')}`;
        default:
            return start.toFormat('MMM yyyy');
    }
};
/**
 * Indices of buckets that get an axis label: the first bucket plus each
 * year boundary, thinned to at most 8 so labels never collide. Spans with
 * fewer than three year boundaries (e.g. months within one year) fall back
 * to evenly spaced ticks instead.
 */ const $5e7a1f916ae1c08a$var$tickIndices = (buckets)=>{
    const yearStarts = buckets.map((bucket, index)=>({
            index: index,
            year: bucket.start.slice(0, 4)
        })).filter((entry, i, all)=>i === 0 || entry.year !== all[i - 1].year).map((entry)=>entry.index);
    if (yearStarts.length >= 3) {
        const step = Math.ceil(yearStarts.length / 8);
        return yearStarts.filter((_, i)=>i % step === 0);
    }
    const step = Math.max(1, Math.ceil(buckets.length / 6));
    return buckets.map((_, index)=>index).filter((index)=>index % step === 0);
};
/**
 * Tick label: full form (with year) on the first tick and at year
 * boundaries, short form (month/quarter only) for in-year filler ticks.
 */ const $5e7a1f916ae1c08a$var$tickLabel = (unit, buckets, index)=>{
    const isYearBoundary = index === 0 || buckets[index].start.slice(0, 4) !== buckets[index - 1].start.slice(0, 4);
    if (isYearBoundary || unit === 'year') return $5e7a1f916ae1c08a$var$formatBucketLabel(unit, buckets[index].start);
    const start = (0, $63618293c58b5f80$exports.DateTime).fromISO(buckets[index].start, {
        zone: 'utc'
    });
    return unit === 'quarter' ? `Q${start.quarter}` : start.toFormat('MMM');
};
const $5e7a1f916ae1c08a$export$576b5f62f466ec49 = ({ unit: unit, buckets: buckets, fromName: fromName, toName: toName, overlapStartDate: overlapStartDate, overlapEndDate: overlapEndDate })=>{
    const [hovered, setHovered] = $acw62.useState(null);
    if (buckets.length === 0) return null;
    const maxCount = Math.max(1, ...buckets.map((bucket)=>Math.max(bucket.fromCount, bucket.toCount)));
    const barHeight = (count)=>count === 0 ? 0 : Math.max(3, Math.round(count / maxCount * $5e7a1f916ae1c08a$var$HALF_HEIGHT));
    const columnPct = 100 / buckets.length;
    const barPct = Math.min(columnPct * 0.75, 6);
    const barX = (index)=>`${index * columnPct + (columnPct - barPct) / 2}%`;
    // A bucket is inside the overlap window when its period intersects it.
    const bucketInOverlap = (bucket)=>{
        if (!overlapStartDate || !overlapEndDate) return false;
        const bucketEnd = (0, $63618293c58b5f80$exports.DateTime).fromISO(bucket.start, {
            zone: 'utc'
        }).plus({
            [`${unit}s`]: 1
        }).toISODate();
        return bucket.start <= overlapEndDate && bucketEnd !== null && bucketEnd > overlapStartDate;
    };
    const overlapIndices = buckets.map((bucket, index)=>bucketInOverlap(bucket) ? index : -1).filter((index)=>index >= 0);
    const contestedCount = buckets.filter((bucket)=>bucket.fromCount > 0 && bucket.toCount > 0).length;
    const readout = hovered !== null ? `${$5e7a1f916ae1c08a$var$formatBucketLabel(unit, buckets[hovered].start)} \u{2014} ${fromName}: ${buckets[hovered].fromCount} \xb7 ${toName}: ${buckets[hovered].toCount}` : contestedCount > 0 ? `${contestedCount} ${contestedCount === 1 ? 'period has' : 'periods have'} transactions in both accounts` : 'No period has transactions in both accounts';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground flex items-center gap-4 text-xs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex min-w-0 items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "size-2.5 shrink-0 rounded-sm",
                                style: {
                                    backgroundColor: $5e7a1f916ae1c08a$export$b5ea210650594713
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "truncate",
                                children: [
                                    fromName,
                                    " (moving in) \u2191"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex min-w-0 items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "size-2.5 shrink-0 rounded-sm",
                                style: {
                                    backgroundColor: $5e7a1f916ae1c08a$export$ac669cb52583a1b
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "truncate",
                                children: [
                                    toName,
                                    " (already there) \u2193"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                width: "100%",
                height: $5e7a1f916ae1c08a$var$CHART_HEIGHT,
                role: "img",
                "aria-label": `Transaction counts per ${unit} for both accounts`,
                onMouseLeave: ()=>setHovered(null),
                children: [
                    hovered !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: `${hovered * columnPct}%`,
                        y: 0,
                        width: `${columnPct}%`,
                        height: $5e7a1f916ae1c08a$var$CHART_HEIGHT,
                        fill: "var(--color-muted)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "0",
                        y: $5e7a1f916ae1c08a$var$AXIS_Y,
                        width: "100%",
                        height: 1,
                        fill: "var(--color-border)"
                    }),
                    overlapIndices.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: `${overlapIndices[0] * columnPct}%`,
                        y: $5e7a1f916ae1c08a$var$AXIS_Y - 0.5,
                        width: `${(overlapIndices[overlapIndices.length - 1] - overlapIndices[0] + 1) * columnPct}%`,
                        height: 2,
                        fill: $5e7a1f916ae1c08a$var$OVERLAP_COLOR
                    }),
                    buckets.map((bucket, index)=>{
                        const upHeight = barHeight(bucket.fromCount);
                        const downHeight = barHeight(bucket.toCount);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                            children: [
                                upHeight > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                    x: barX(index),
                                    y: $5e7a1f916ae1c08a$var$AXIS_Y - $5e7a1f916ae1c08a$var$AXIS_GAP - upHeight,
                                    width: `${barPct}%`,
                                    height: upHeight,
                                    rx: 1.5,
                                    fill: $5e7a1f916ae1c08a$export$b5ea210650594713
                                }),
                                downHeight > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                    x: barX(index),
                                    y: $5e7a1f916ae1c08a$var$AXIS_Y + 1 + $5e7a1f916ae1c08a$var$AXIS_GAP,
                                    width: `${barPct}%`,
                                    height: downHeight,
                                    rx: 1.5,
                                    fill: $5e7a1f916ae1c08a$export$ac669cb52583a1b
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                    x: `${index * columnPct}%`,
                                    y: 0,
                                    width: `${columnPct}%`,
                                    height: $5e7a1f916ae1c08a$var$CHART_HEIGHT,
                                    fill: "transparent",
                                    onMouseEnter: ()=>setHovered(index)
                                })
                            ]
                        }, bucket.start);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground relative h-4 text-[10px]",
                children: $5e7a1f916ae1c08a$var$tickIndices(buckets).map((index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "absolute top-0 whitespace-nowrap",
                        style: {
                            left: `${index * columnPct}%`
                        },
                        children: $5e7a1f916ae1c08a$var$tickLabel(unit, buckets, index)
                    }, buckets[index].start))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground m-0 h-4 truncate text-xs",
                children: readout
            })
        ]
    });
};


// Per-side fetch cap. The overlap can span an account's whole history (the
// duplicate-import case this preview exists to catch), and rows render inline
// in the modal's own scroll — a nested scroll region is miserable on touch —
// so the cap bounds both the query and the DOM. Truncation is called out in
// the summary line.
const $3619c5ceeedcb022$var$PREVIEW_LIMIT = 100;
// Newest first (matching every other transaction list), then by amount and
// description within a day — so a duplicated import (same date, same amount,
// one row from each account) lands as adjacent rows the eye can pair up.
const $3619c5ceeedcb022$var$compareForPairing = (a, b)=>{
    const ta = a.transaction;
    const tb = b.transaction;
    if (ta.date !== tb.date) return ta.date < tb.date ? 1 : -1;
    if (ta.amount !== tb.amount) return ta.amount - tb.amount;
    if (ta.description !== tb.description) return ta.description < tb.description ? -1 : 1;
    return ta._id < tb._id ? -1 : 1;
};
const $3619c5ceeedcb022$var$sideColor = (side)=>side === 'from' ? (0, $5e7a1f916ae1c08a$export$b5ea210650594713) : (0, $5e7a1f916ae1c08a$export$ac669cb52583a1b);
const $3619c5ceeedcb022$var$SideDot = ({ side: side })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "aria-hidden": true,
        className: "inline-block size-2 shrink-0 rounded-sm",
        style: {
            backgroundColor: $3619c5ceeedcb022$var$sideColor(side)
        }
    });
// A compact, non-navigable rendition of RawTransactionRow's layout. The full
// row component requires the BasicRawTransaction fragment (see the projection
// note above), and its extras — long-press, benefit pill, allocation status —
// are all irrelevant to reviewing an overlap.
const $3619c5ceeedcb022$var$OverlapRow = ({ side: side, accountName: accountName, transaction: transaction })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid items-center gap-x-5 gap-y-1.5 border-l-2 px-4 py-3 [grid-template-columns:1fr_auto]",
        style: {
            borderLeftColor: $3619c5ceeedcb022$var$sideColor(side)
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-w-0 flex-col gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-foreground truncate",
                        title: transaction.description,
                        children: transaction.description
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground truncate text-sm",
                        children: accountName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-w-0 flex-col items-end justify-center gap-1 pl-3 text-right",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                        amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(transaction.amount, transaction.currency)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground tabular-nums",
                        children: transaction.date
                    })
                ]
            })
        ]
    });
const $3619c5ceeedcb022$export$896e19fec96841ae = ({ fromAccountId: fromAccountId, fromAccountName: fromAccountName, toAccountId: toAccountId, toAccountName: toAccountName, overlapStartDate: overlapStartDate, overlapEndDate: overlapEndDate })=>{
    const [expanded, setExpanded] = $acw62.useState(false);
    // network-only for the same reason as the migration preview itself: this
    // informs an irreversible action, so show current server state.
    const commonOptions = {
        skip: !expanded,
        fetchPolicy: 'network-only'
    };
    const commonVariables = {
        includeProcessed: true,
        limit: $3619c5ceeedcb022$var$PREVIEW_LIMIT,
        startDate: overlapStartDate,
        endDate: overlapEndDate
    };
    const fromQuery = (0, $ce9d9e524be20f53$export$4804775d7f2aae89)({
        variables: {
            ...commonVariables,
            accountId: fromAccountId
        },
        ...commonOptions
    });
    const toQuery = (0, $ce9d9e524be20f53$export$4804775d7f2aae89)({
        variables: {
            ...commonVariables,
            accountId: toAccountId
        },
        ...commonOptions
    });
    const toggle = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
        variant: "outline",
        className: "self-start px-2.5 py-1 text-xs shadow-none",
        onClick: ()=>setExpanded(!expanded),
        children: expanded ? 'Hide overlapping transactions' : 'Show the overlapping transactions'
    });
    if (!expanded) return toggle;
    const loading = fromQuery.loading || toQuery.loading;
    const error = fromQuery.error ?? toQuery.error;
    const fromPage = fromQuery.data?.allRawTransactions;
    const toPage = toQuery.data?.allRawTransactions;
    const merged = [
        ...(fromPage?.items ?? []).map((transaction)=>({
                side: 'from',
                transaction: transaction
            })),
        ...(toPage?.items ?? []).map((transaction)=>({
                side: 'to',
                transaction: transaction
            }))
    ].sort($3619c5ceeedcb022$var$compareForPairing);
    const truncated = fromPage?.hasMore || toPage?.hasMore;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            toggle,
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
                size: "small"
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-destructive m-0 text-sm",
                children: error.message
            }),
            !loading && !error && fromPage && toPage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-foreground m-0 flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-xs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex items-center gap-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3619c5ceeedcb022$var$SideDot, {
                                        side: "from"
                                    }),
                                    fromPage.items.length.toLocaleString(),
                                    " from ",
                                    fromAccountName,
                                    ' ',
                                    "(moving in)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                "aria-hidden": true,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex items-center gap-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3619c5ceeedcb022$var$SideDot, {
                                        side: "to"
                                    }),
                                    toPage.items.length.toLocaleString(),
                                    " in ",
                                    toAccountName,
                                    ' ',
                                    "(already there)"
                                ]
                            })
                        ]
                    }),
                    truncated && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-muted-foreground m-0 text-xs",
                        children: [
                            "Showing only the most recent ",
                            $3619c5ceeedcb022$var$PREVIEW_LIMIT,
                            " per account."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border-border divide-border bg-background divide-y rounded-md border",
                        children: [
                            merged.map(({ side: side, transaction: transaction })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3619c5ceeedcb022$var$OverlapRow, {
                                    side: side,
                                    transaction: transaction,
                                    accountName: side === 'from' ? fromAccountName : toAccountName
                                }, transaction._id)),
                            merged.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground m-0 p-3 text-sm",
                                children: "No transactions found in the overlap window."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




const $7def3c45114de0ab$var$formatRange = (oldest, newest)=>oldest && newest ? `${oldest} \u{2013} ${newest}` : '';
const $7def3c45114de0ab$export$5d3cb3ef2d739033 = (props)=>{
    const formId = $acw62.useId();
    const { account: account, onMigrated: onMigrated, onRequestClose: onRequestClose } = props;
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const [selectedAccount, setSelectedAccount] = $acw62.useState((0, $f8f45ddea4959097$exports.none));
    const [overlapConfirmed, setOverlapConfirmed] = $acw62.useState(false);
    const destinationId = selectedAccount.map((destination)=>destination._id).getOrElse('');
    // network-only: the preview drives an irreversible action, so it must
    // reflect the current server state, not a cached page.
    const { data: previewData, loading: previewLoading, error: previewError } = (0, $ce9d9e524be20f53$export$d2508b6395c940aa)({
        variables: {
            fromAccountId: account._id,
            toAccountId: destinationId
        },
        skip: destinationId === '',
        fetchPolicy: 'network-only'
    });
    const preview = destinationId ? previewData?.rawTransactionMigrationPreview : undefined;
    const [migrateRawTransactions, { loading: migrating, error: migrateError }] = (0, $ce9d9e524be20f53$export$caba9bf89508cc17)();
    const handleSelectAccount = (destination)=>{
        setSelectedAccount(destination);
        setOverlapConfirmed(false);
    };
    // Narrowed to a non-null pair so the overlap UI (warning text, transaction
    // preview) can use the window without re-null-checking each bound.
    const overlapWindow = preview?.overlapStartDate != null && preview?.overlapEndDate != null ? {
        start: preview.overlapStartDate,
        end: preview.overlapEndDate
    } : null;
    const hasOverlap = overlapWindow !== null;
    // Soft-deleted rows migrate too, so an account holding only deleted rows
    // is still migratable (that is what clears it for deletion). Likewise an
    // investment account whose only history is portfolio snapshots.
    const hasAnythingToMove = preview != null && preview.count + preview.deletedCount + preview.snapshotCount > 0;
    const canMigrate = preview != null && preview.blockers.length === 0 && hasAnythingToMove && (!hasOverlap || overlapConfirmed) && !previewLoading && !migrating;
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!canMigrate) return;
        selectedAccount.forEach((destination)=>{
            migrateRawTransactions({
                variables: {
                    fromAccountId: account._id,
                    toAccountId: destination._id,
                    force: overlapConfirmed
                }
            }).then(async ()=>{
                // A whole-account move staleness far more than the transaction
                // lists (account transaction counts, balances, insights), so
                // refetch all active queries rather than evicting surgically. This
                // is a rare admin action; the coarse reset is acceptable. The
                // migration has already succeeded at this point, so a failed
                // refetch must not keep the modal open (or reject unhandled).
                await client.resetStore().catch(()=>{});
                onMigrated?.();
                onRequestClose();
            }).catch(()=>{
            // Mutation failures surface via migrateError.
            });
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                disabled: migrating,
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                disabled: !canMigrate,
                type: "submit",
                form: formId,
                children: preview && preview.count > 0 ? `Migrate ${preview.count.toLocaleString()} transaction${preview.count === 1 ? '' : 's'}` : 'Migrate'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Migrate all transactions",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-muted-foreground m-0 text-sm",
                    children: [
                        "Move every transaction from ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: account.name
                        }),
                        " to another account."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Destination account",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $295751b0f96fd69d$export$2e2bcd8739ae039), {
                        autoFocus: true,
                        excludeIds: [
                            account._id
                        ],
                        selectedAccount: selectedAccount,
                        onSelectAccount: handleSelectAccount,
                        // The server blocks cross-currency migrations; don't offer them.
                        currency: account.currency
                    })
                }),
                previewLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
                    size: "small"
                }),
                previewError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-destructive m-0 text-sm",
                    children: previewError.message
                }),
                preview && !previewLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-foreground text-sm",
                            children: [
                                preview.count === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "m-0",
                                    children: preview.deletedCount > 0 ? `Only deleted transactions remain: ${preview.deletedCount.toLocaleString()} will move so nothing keeps referencing this account.` : 'There are no transactions to migrate.'
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "m-0",
                                    children: [
                                        preview.count.toLocaleString(),
                                        ' ',
                                        preview.count === 1 ? 'transaction' : 'transactions',
                                        " (",
                                        $7def3c45114de0ab$var$formatRange(preview.fromOldestDate, preview.fromNewestDate),
                                        ") will move.",
                                        ' ',
                                        preview.toCount === 0 ? 'The destination account has no transactions.' : `The destination account already has ${preview.toCount.toLocaleString()} ${preview.toCount === 1 ? 'transaction' : 'transactions'} (${$7def3c45114de0ab$var$formatRange(preview.toOldestDate, preview.toNewestDate)}).`
                                    ]
                                }),
                                preview.count > 0 && preview.deletedCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "m-0 mt-1",
                                    children: [
                                        preview.deletedCount.toLocaleString(),
                                        " deleted",
                                        ' ',
                                        preview.deletedCount === 1 ? 'transaction' : 'transactions',
                                        ' ',
                                        "will move too."
                                    ]
                                }),
                                preview.count > 0 && preview.feePeriodCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "m-0 mt-1",
                                    children: preview.feePeriodCount === 1 ? '1 fee period and its card benefits move too.' : `${preview.feePeriodCount} fee periods and their card benefits move too.`
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "m-0 mt-1",
                                    children: preview.snapshotCount > 0 ? `${preview.snapshotCount.toLocaleString()} portfolio ${preview.snapshotCount === 1 ? 'snapshot moves' : 'snapshots move'} too.` : 'Balance observations stay on the source account.'
                                })
                            ]
                        }),
                        preview.count > 0 && preview.timeline.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e7a1f916ae1c08a$export$576b5f62f466ec49), {
                            unit: preview.timelineUnit,
                            buckets: preview.timeline,
                            fromName: account.name,
                            toName: selectedAccount.map((destination)=>destination.name).getOrElse('Destination'),
                            overlapStartDate: preview.overlapStartDate ?? null,
                            overlapEndDate: preview.overlapEndDate ?? null
                        }),
                        preview.blockers.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "border-destructive/50 text-destructive rounded-md border p-3 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "m-0 font-medium",
                                    children: "This migration can\u2019t run yet:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                    className: "m-0 mt-1 list-disc pl-5",
                                    children: preview.blockers.map((blocker)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: blocker
                                        }, blocker))
                                })
                            ]
                        }),
                        preview.blockers.length === 0 && overlapWindow && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-2 rounded-md border border-amber-500/50 p-3 text-sm text-amber-600 dark:text-amber-400",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "m-0",
                                    children: [
                                        "Both accounts have transactions between",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: overlapWindow.start
                                        }),
                                        " and",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: overlapWindow.end
                                        }),
                                        ". This usually means the same history was imported into both accounts, so migrating may create duplicates."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3619c5ceeedcb022$export$896e19fec96841ae), {
                                    fromAccountId: account._id,
                                    fromAccountName: account.name,
                                    toAccountId: destinationId,
                                    toAccountName: selectedAccount.map((destination)=>destination.name).getOrElse('Destination'),
                                    overlapStartDate: overlapWindow.start,
                                    overlapEndDate: overlapWindow.end
                                }, destinationId),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: overlapConfirmed,
                                            onChange: (e)=>setOverlapConfirmed(e.target.checked),
                                            className: "shrink-0"
                                        }),
                                        "I\u2019ve reviewed the overlap and want to migrate anyway"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                migrateError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-destructive m-0 text-sm",
                    children: migrateError.message
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");

/** Record amounts are integer cents. */ const $ba9737c51f8d44f4$var$cents = (value)=>(value / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
    });
/** Line amounts are dollars as printed on the slip (pipeline convention). */ const $ba9737c51f8d44f4$var$dollars = (value)=>value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
    });
const $ba9737c51f8d44f4$var$isSlipLine = (value)=>{
    if (typeof value !== 'object' || value == null) return false;
    const record = {
        ...value
    };
    return typeof record.section === 'string' && typeof record.description === 'string' && typeof record.amount === 'number' && (record.ytd === undefined || typeof record.ytd === 'number');
};
const $ba9737c51f8d44f4$var$toSlipLines = (raw)=>Array.isArray(raw) ? raw.filter($ba9737c51f8d44f4$var$isSlipLine) : [];
// Section headings in the slip's own vocabulary, in print order.
const $ba9737c51f8d44f4$var$SECTION_LABELS = {
    earnings: 'Earnings',
    employeeTaxes: 'Employee taxes',
    preTax: 'Pre-tax deductions',
    postTax: 'Post-tax deductions',
    employerPaid: 'Employer paid',
    taxableWages: 'Taxable wages'
};
const $ba9737c51f8d44f4$export$dbeb373f4a8bfe3e = ({ record: record, onRequestClose: onRequestClose })=>{
    const lines = $acw62.useMemo(()=>$ba9737c51f8d44f4$var$toSlipLines(record.lines), [
        record.lines
    ]);
    const sections = $acw62.useMemo(()=>{
        const bySection = new Map();
        for (const line of lines){
            const existing = bySection.get(line.section);
            if (existing) existing.push(line);
            else bySection.set(line.section, [
                line
            ]);
        }
        return [
            ...bySection.entries()
        ];
    }, [
        lines
    ]);
    const summaryRows = [
        [
            'Gross',
            record.gross
        ],
        [
            'Taxes withheld',
            -record.taxesWithheld
        ],
        [
            'Other pre-tax',
            -record.otherPretax
        ],
        [
            'Net deposited',
            record.net
        ]
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "text-lg font-semibold",
                    children: record.slipId
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-muted-foreground text-sm",
                    children: [
                        record.employer,
                        " \xb7",
                        ' ',
                        (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(record.payDate).toLocaleString({
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric'
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                    className: "grid grid-cols-2 gap-x-6 gap-y-1 text-sm sm:grid-cols-4",
                    children: summaryRows.map(([label, value])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    className: "text-muted-foreground",
                                    children: label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    className: "font-medium tabular-nums",
                                    children: $ba9737c51f8d44f4$var$cents(value)
                                })
                            ]
                        }, label))
                }),
                sections.map(([section, sectionLines])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-muted-foreground mb-1 text-xs font-semibold uppercase tracking-wide",
                                children: $ba9737c51f8d44f4$var$SECTION_LABELS[section] ?? section
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "w-full text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "text-muted-foreground text-left text-xs",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "py-0.5 font-normal",
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "py-0.5 text-right font-normal",
                                                    children: "Amount"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "py-0.5 text-right font-normal",
                                                    children: "YTD"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: sectionLines.map((line, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-border border-t",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1 pr-2",
                                                        children: line.description
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1 text-right tabular-nums",
                                                        children: $ba9737c51f8d44f4$var$dollars(line.amount)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "text-muted-foreground py-1 text-right tabular-nums",
                                                        children: line.ytd != null ? $ba9737c51f8d44f4$var$dollars(line.ytd) : "\u2014"
                                                    })
                                                ]
                                            }, `${line.description}-${index}`))
                                    })
                                ]
                            })
                        ]
                    }, section)),
                lines.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground text-sm",
                    children: "No line items were stored for this record."
                })
            ]
        })
    });
};










var $acw62 = parcelRequire("acw62");









const $700392cc1136f4f2$var$emptyRow = (id, amount, date)=>({
        id: id,
        amount: amount,
        payee: '',
        category: (0, $f8f45ddea4959097$exports.none),
        description: '',
        date: date,
        tags: [],
        fieldValues: {}
    });
const $700392cc1136f4f2$var$SplitRowCard = ({ index: index, value: value, currency: currency, expanded: expanded, onToggle: onToggle, onChange: onChange, onCopyToAll: onCopyToAll, onDelete: onDelete })=>{
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const summary = [
        value.amount.map((m)=>formatMoney(m)).getOrElse('no amount'),
        value.date.toFormat('MMM d'),
        ...value.payee ? [
            value.payee
        ] : []
    ].join(" \xb7 ");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border rounded-lg border",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                role: "button",
                tabIndex: 0,
                onClick: onToggle,
                onKeyDown: (e)=>{
                    // Only toggle for keys on the header itself — Enter/Space on the
                    // nested delete button bubbles here and must activate the button,
                    // not toggle the card.
                    if (e.target !== e.currentTarget) return;
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onToggle();
                    }
                },
                className: "flex cursor-pointer items-center gap-2 px-4 py-3 select-none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                        className: "text-muted-foreground size-4 shrink-0 transition-transform duration-100",
                        style: {
                            transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "shrink-0 text-sm font-medium",
                        children: [
                            "Split ",
                            index + 1
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground min-w-0 truncate text-sm",
                        children: summary
                    }),
                    !expanded && value.category.isEmpty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-destructive shrink-0 text-xs",
                        children: "no category"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        onClick: (e)=>e.stopPropagation(),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "ghost",
                            size: "icon",
                            type: "button",
                            onClick: onDelete,
                            className: "shrink-0",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                className: "size-4"
                            })
                        })
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-3 px-4 pb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-3 sm:flex-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "sm:flex-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                    label: "Amount",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                                        value: value.amount.map((m)=>m.currency === currency ? m : (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(m.amount, currency)),
                                        onChange: (amount)=>onChange({
                                                ...value,
                                                amount: amount.map((m)=>(0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(m.amount, currency))
                                            }),
                                        currency: currency
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "sm:flex-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                    label: "Date",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                        selectedDate: value.date,
                                        onChange: (date)=>onChange({
                                                ...value,
                                                date: date
                                            })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad10a945edd6a61f$export$c926719e59417ac4), {
                        value: {
                            payee: value.payee,
                            category: value.category,
                            description: value.description
                        },
                        onChange: ({ payee: payee, category: category, description: description })=>onChange({
                                ...value,
                                payee: payee,
                                category: category,
                                description: description
                            }),
                        onCopyToAll: onCopyToAll
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                        label: "Tags & fields",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-start gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex-1",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d5b27e6036e5285$export$470985d1a1ba634f), {
                                        tags: value.tags,
                                        fieldValues: value.fieldValues,
                                        onChange: (tags, fieldValues)=>onChange({
                                                ...value,
                                                tags: tags,
                                                fieldValues: fieldValues
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad10a945edd6a61f$export$b6df4a590c2c36de), {
                                    onClick: ()=>onCopyToAll('tagsAndFields')
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $700392cc1136f4f2$export$359ece02c069a28 = (props)=>{
    const formId = $acw62.useId();
    const unitsById = (0, $9b33a37eb331091e$export$17987e0a14ce8a32)();
    const { rawTransactions: rawTransactions, onRequestClose: onRequestClose } = props;
    const currency = rawTransactions[0].currency;
    const netTotal = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(rawTransactions.reduce((sum, r)=>sum + r.amount, 0), currency);
    const total = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(netTotal.amount), currency);
    const earliestDate = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(rawTransactions.map((r)=>r.date).reduce((a, b)=>a <= b ? a : b));
    const [pending, setPending] = $acw62.useState(false);
    const nextIdRef = $acw62.useRef(1);
    // Start with a single zero-amount split. The intended flow is to type an
    // amount into the first split, then "Add split" to auto-fill the remainder
    // onto the second. Submitting still requires at least two splits.
    const [rows, setRows] = $acw62.useState(()=>[
            $700392cc1136f4f2$var$emptyRow(0, (0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).zero(currency)), earliestDate)
        ]);
    // Only the first split starts expanded; the rest collapse to summary rows
    // so the modal stays scannable, especially on mobile.
    const [expandedIds, setExpandedIds] = $acw62.useState(()=>new Set([
            0
        ]));
    const handleToggleRow = (id)=>()=>{
            setExpandedIds((current)=>{
                const next = new Set(current);
                if (next.has(id)) next.delete(id);
                else next.add(id);
                return next;
            });
        };
    const allocated = rows.map((r)=>r.amount.getOrElse((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).zero(currency))).reduce((a, b)=>(0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).plus(a, b), (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).zero(currency));
    const remaining = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).minus(total, allocated);
    const remainingColorClass = remaining.isZero ? 'text-foreground' : remaining.isNegative ? 'text-destructive' : 'text-muted-foreground';
    const allPositive = rows.every((r)=>r.amount.map((m)=>m.isPositive).getOrElse(false));
    const amountsComplete = allPositive && remaining.isZero;
    // Every split becomes a payment transaction, which requires a category, so a
    // row only yields a payload when it has both an amount and a category.
    const maybePayload = (0, $3c773088597ab155$export$2e2bcd8739ae039).allOptionArray(rows.map((row)=>row.amount.flatMap((m)=>row.category.map((categoryName)=>({
                    amount: Math.abs(m.amount),
                    payee: row.payee || undefined,
                    categoryName: categoryName,
                    tagNames: row.tags.length > 0 ? row.tags : undefined,
                    fieldValues: Object.keys(row.fieldValues).length > 0 ? row.fieldValues : undefined,
                    description: row.description || undefined,
                    pending: pending || undefined,
                    date: row.date.toISODate()
                })))));
    const [splitMutation, { loading: loading }] = (0, $ce9d9e524be20f53$export$2362b77adec85bb)();
    // A zero-decimal currency cannot express a sub-unit total, so a legacy raw
    // stored as e.g. ¥100.50 has no valid split: every row the generators
    // produce carries the residue and is rejected by the server's
    // whole-display-unit check. Block it up front with a reason rather than
    // offering buttons whose output can never submit.
    const unsplittableResidue = total.amount % (0, $9ac5aec7425fcb2d$export$ddd851adc5745811)(currency, unitsById) !== 0;
    // A split must produce at least two transactions to be meaningful, so block
    // submitting while fewer than two rows exist even if their amounts balance.
    const canSubmit = !loading && rows.length >= 2 && amountsComplete && !unsplittableResidue && !maybePayload.isEmpty;
    const handleSubmit = (e)=>{
        e.preventDefault();
        // Guard against submits that bypass the disabled button (e.g. Enter key):
        // don't create anything until the amounts balance and every split has a
        // category.
        if (!canSubmit) return;
        maybePayload.forEach((splits)=>{
            splitMutation({
                variables: {
                    rawTransactionIds: rawTransactions.map((r)=>r._id),
                    splits: splits,
                    // Every split carries its own date; this top-level default never
                    // applies, but the mutation requires it.
                    date: earliestDate.toISODate()
                }
            }).then((result)=>{
                if (result.data?.splitRawTransaction) {
                    props.onSplit(rawTransactions);
                    onRequestClose();
                }
            });
        });
    };
    // All row updates below use the functional setRows form: the click that
    // dismisses an open payee/category popover commits its draft in the same
    // event sequence, so handlers must read the rows as of that commit rather
    // than their render closure, or they'd overwrite the just-committed edit.
    const handleUpdateRow = (id)=>(row)=>{
            setRows((currentRows)=>currentRows.map((r)=>r.id === id ? row : r));
        };
    const handleRemoveRow = (id)=>()=>{
            setRows((currentRows)=>currentRows.filter((r)=>r.id !== id));
            setExpandedIds((current)=>{
                const next = new Set(current);
                next.delete(id);
                return next;
            });
        };
    const handleAddRow = ()=>{
        const id = nextIdRef.current++;
        setRows((currentRows)=>{
            const currentAllocated = currentRows.map((r)=>r.amount.getOrElse((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).zero(currency))).reduce((a, b)=>(0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).plus(a, b), (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).zero(currency));
            const currentRemaining = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).minus(total, currentAllocated);
            const newAmount = currentRemaining.isZero ? (0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).zero(currency)) : (0, $f8f45ddea4959097$exports.some)(currentRemaining);
            return [
                ...currentRows,
                $700392cc1136f4f2$var$emptyRow(id, newAmount, earliestDate)
            ];
        });
        // A new split is there to be filled in, so open it right away.
        setExpandedIds((current)=>new Set(current).add(id));
    };
    const handleCopyToAll = (id)=>(field)=>{
            setRows((currentRows)=>{
                const source = currentRows.find((r)=>r.id === id);
                if (!source) return currentRows;
                return currentRows.map((row)=>{
                    switch(field){
                        case 'payee':
                            return {
                                ...row,
                                payee: source.payee
                            };
                        case 'category':
                            return {
                                ...row,
                                category: source.category
                            };
                        case 'description':
                            return {
                                ...row,
                                description: source.description
                            };
                        case 'tagsAndFields':
                            // Copy fresh clones so later edits to one split don't mutate the
                            // arrays/objects shared into its siblings.
                            return {
                                ...row,
                                tags: [
                                    ...source.tags
                                ],
                                fieldValues: {
                                    ...source.fieldValues
                                }
                            };
                    }
                });
            });
        };
    // Divides the total into n parts, giving the leftover cents to the first
    // `total % n` parts so the amounts always sum back to the total.
    const evenAmount = (i, n)=>{
        // Distribute in the currency's display unit (whole yen for JPY, cents
        // for USD) so generated splits render exactly and survive re-editing —
        // ¥100 across three rows is ¥34/¥33/¥33, never sub-yen fractions. Any
        // sub-unit residue in the total itself (legacy data) lands on row 0 so
        // the rows still sum to the total.
        const unit = (0, $9ac5aec7425fcb2d$export$ddd851adc5745811)(currency, unitsById);
        const totalUnits = Math.floor(total.amount / unit);
        const residue = total.amount - totalUnits * unit;
        const baseUnits = Math.floor(totalUnits / n);
        const remainderUnits = totalUnits % n;
        const units = i < remainderUnits ? baseUnits + 1 : baseUnits;
        return (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(units * unit + (i === 0 ? residue : 0), currency);
    };
    const handleSplitEvenly = ()=>{
        setRows((currentRows)=>currentRows.map((r, i)=>({
                    ...r,
                    amount: (0, $f8f45ddea4959097$exports.some)(evenAmount(i, currentRows.length))
                })));
    };
    // Shortcut for annual charges paid up front: 12 even splits, each dated one
    // month after the previous. Anchored on the first split's date, so setting
    // that date before clicking chooses where the schedule starts.
    const handleSplitMonthly = ()=>{
        // Reserve ids for all potential new rows up front so the state updater
        // stays pure (safe under double-invocation).
        const baseId = nextIdRef.current;
        nextIdRef.current += 12;
        setRows((currentRows)=>{
            const n = 12;
            // Rows can be empty (all splits deleted), so fall back to the
            // transaction's earliest date rather than dereferencing a missing row.
            const anchor = currentRows[0]?.date ?? earliestDate;
            return (0, $3c773088597ab155$export$2e2bcd8739ae039).range(n).map((i)=>({
                    ...currentRows[i] ?? $700392cc1136f4f2$var$emptyRow(baseId + i, (0, $f8f45ddea4959097$exports.none), anchor),
                    amount: (0, $f8f45ddea4959097$exports.some)(evenAmount(i, n)),
                    date: anchor.plus({
                        months: i
                    })
                }));
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: !canSubmit,
                children: "Split"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        header: "Split into transactions",
        onRequestClose: onRequestClose,
        size: "lg",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                rawTransactions.length === 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-muted-foreground text-sm",
                    children: [
                        rawTransactions[0].description,
                        " \xb7",
                        ' ',
                        (0, $9ac5aec7425fcb2d$export$ba37dda4e3a0b386)(total, unitsById)
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "border-border max-h-32 overflow-y-auto rounded-md border p-2",
                            children: rawTransactions.map((raw)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-muted-foreground flex justify-between gap-4 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "truncate",
                                            children: raw.description
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "shrink-0",
                                            children: (0, $9ac5aec7425fcb2d$export$ba37dda4e3a0b386)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(raw.amount, currency), unitsById)
                                        })
                                    ]
                                }, raw._id))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-muted-foreground text-sm",
                            children: [
                                "Net ",
                                (0, $9ac5aec7425fcb2d$export$ba37dda4e3a0b386)(netTotal, unitsById),
                                " \xb7 each split consumes every raw transaction proportionally"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-center justify-between gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: `text-sm font-medium ${remainingColorClass}`,
                            children: [
                                rows.length,
                                " splits \xb7",
                                ' ',
                                (0, $9ac5aec7425fcb2d$export$ba37dda4e3a0b386)(remaining, unitsById),
                                " remaining",
                                rows.length < 2 && !unsplittableResidue && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "text-muted-foreground",
                                    children: [
                                        ' ',
                                        "\xb7 add at least 2 to split"
                                    ]
                                }),
                                unsplittableResidue && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "text-destructive",
                                    children: [
                                        ' ',
                                        "\xb7 this ",
                                        (0, $9ac5aec7425fcb2d$export$20aa680045b2e71b)(currency, unitsById),
                                        ' ',
                                        "amount includes a fraction of a",
                                        ' ',
                                        (0, $9ac5aec7425fcb2d$export$20aa680045b2e71b)(currency, unitsById),
                                        " unit and cannot be split"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    type: "button",
                                    onClick: handleSplitEvenly,
                                    disabled: unsplittableResidue,
                                    children: "Split evenly"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    type: "button",
                                    onClick: handleSplitMonthly,
                                    disabled: unsplittableResidue,
                                    children: "12 monthly"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        rows.map((row, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($700392cc1136f4f2$var$SplitRowCard, {
                                index: i,
                                value: row,
                                currency: currency,
                                expanded: expandedIds.has(row.id),
                                onToggle: handleToggleRow(row.id),
                                onChange: handleUpdateRow(row.id),
                                onCopyToAll: handleCopyToAll(row.id),
                                onDelete: handleRemoveRow(row.id)
                            }, row.id)),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            type: "button",
                            onClick: handleAddRow,
                            className: "text-muted-foreground w-full gap-2 border-dashed shadow-none",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                    className: "size-4"
                                }),
                                "Add split"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    className: "flex cursor-pointer items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            checked: pending,
                            onChange: (e)=>setPending(e.target.checked),
                            className: "h-4 w-4 rounded border-gray-300"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-foreground text-sm",
                            children: "Mark as pending (not finalized)"
                        })
                    ]
                })
            ]
        })
    });
};





/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $839eea37a960d2b1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const $839eea37a960d2b1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-x", $839eea37a960d2b1$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
const $d445317123c5c8b5$export$f4597344e9ae6f5f = [
    'RecentSyncs',
    'AllRawTransactions',
    'InboxBacklogSummary',
    'AllInvestmentAccounts',
    'AllInvestmentAccountsPerformance',
    'PortfolioPerformanceSummary',
    'PortfolioXIRR',
    'ConsolidatedPortfolioHistory',
    'PortfolioHistoryByAccount',
    'InvestmentReturnsMatrix',
    'InvestmentPeriods',
    'InvestmentHoldings',
    'InvestmentGaps',
    'InvestmentActivity',
    // Net worth and its split refresh together, so the split's rest is
    // never one side's new figures against the other's old.
    'NetWorth',
    'NetWorthInvestmentSplit'
];
// How stale the indicator may be before it is worth re-checking. The dot is a
// passive nudge on a manual action, so a few minutes of lag costs nothing —
// and this doubles as the guard that keeps flipping between tabs from turning
// into one request per flip.
const $d445317123c5c8b5$var$FRESH_FOR_MS = 300000;
// How often to re-evaluate staleness while visible. Local comparison only; a
// tick that finds fresh data makes no request.
const $d445317123c5c8b5$var$CHECK_INTERVAL_MS = 60000;
const $d445317123c5c8b5$var$nowMs = ()=>(0, $63618293c58b5f80$exports.DateTime).now().toMillis();
const $d445317123c5c8b5$export$e3811da6fd33476c = ()=>{
    const apolloClient = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const { data: data, refetch: refetch } = (0, $ce9d9e524be20f53$export$58942d93e6b347e6)();
    const available = data?.plaidUpdatesAvailable ?? false;
    // Marker for "a sync has finished since this tab last looked": the newest
    // *completed* session. Still-running sessions don't count — a sync in
    // flight hasn't finished writing what the list queries read — and a
    // session orphaned as 'running' by a crash must not mask later
    // completions (the query fetches a few sessions for exactly that reason).
    // undefined = no response yet; null = no completed sync exists.
    const latestCompletedSyncId = data == null ? undefined : data.recentSyncs.find((s)=>s.completedAt != null)?._id ?? null;
    // When the marker advances, some sync — the modal's, or the hourly
    // background cron's — finished and may have changed what the list queries
    // show. (After a modal sync this dedupes into the modal's own refetch.)
    // Keyed on the marker rather than an updatesAvailable true -> false flip
    // so a background sync whose pending state this tab never observed —
    // webhook and cron both landing between two availability checks — still
    // refreshes an open tab.
    const prevSyncIdRef = $acw62.useRef(undefined);
    $acw62.useEffect(()=>{
        if (latestCompletedSyncId === undefined) return;
        const prev = prevSyncIdRef.current;
        prevSyncIdRef.current = latestCompletedSyncId;
        if (prev === undefined || prev === latestCompletedSyncId) return;
        // A background sync writes balance readings and investment
        // transactions, so the whole set refreshes as a group.
        apolloClient.refetchQueries({
            include: $d445317123c5c8b5$export$f4597344e9ae6f5f
        });
    }, [
        latestCompletedSyncId,
        apolloClient
    ]);
    // Mounting issues the initial fetch, so the clock starts now.
    const lastFetchedAtRef = $acw62.useRef($d445317123c5c8b5$var$nowMs());
    $acw62.useEffect(()=>{
        const refetchIfStale = ()=>{
            if (document.visibilityState !== 'visible') return;
            if ($d445317123c5c8b5$var$nowMs() - lastFetchedAtRef.current < $d445317123c5c8b5$var$FRESH_FOR_MS) return;
            lastFetchedAtRef.current = $d445317123c5c8b5$var$nowMs();
            // A failed check just leaves the dot as it was; the next tick retries.
            refetch().catch(()=>undefined);
        };
        const timer = window.setInterval(refetchIfStale, $d445317123c5c8b5$var$CHECK_INTERVAL_MS);
        document.addEventListener('visibilitychange', refetchIfStale);
        return ()=>{
            window.clearInterval(timer);
            document.removeEventListener('visibilitychange', refetchIfStale);
        };
    }, [
        refetch
    ]);
    return available;
};




const $d8cf039892cc43a6$var$STEP_LABELS = {
    fetch_transactions: 'Fetch transactions',
    save_accounts: 'Save accounts',
    save_transactions: 'Save transactions',
    fetch_holdings: 'Fetch holdings',
    save_holdings: 'Save holdings',
    fetch_investment_transactions: 'Fetch investment transactions',
    save_investment_transactions: 'Save investment transactions'
};
const $d8cf039892cc43a6$var$initialState = {
    phase: 'connecting',
    tokenCount: 0,
    tokens: new Map()
};
const $d8cf039892cc43a6$var$syncReducer = (state, action)=>{
    switch(action.type){
        case 'SYNC_START':
            return {
                ...state,
                phase: 'syncing',
                tokenCount: action.tokenCount
            };
        case 'TOKEN_START':
            {
                const newTokens = new Map(state.tokens);
                newTokens.set(action.tokenId, {
                    tokenId: action.tokenId,
                    institutionName: action.institutionName,
                    status: 'syncing',
                    steps: []
                });
                return {
                    ...state,
                    tokens: newTokens
                };
            }
        case 'TOKEN_STEP':
            {
                const newTokens = new Map(state.tokens);
                const existing = newTokens.get(action.tokenId);
                if (existing) newTokens.set(action.tokenId, {
                    ...existing,
                    steps: [
                        ...existing.steps,
                        {
                            step: action.step,
                            status: action.status,
                            detail: action.detail,
                            timestamp: Date.now()
                        }
                    ]
                });
                return {
                    ...state,
                    tokens: newTokens
                };
            }
        case 'TOKEN_COMPLETE':
            {
                const newTokens = new Map(state.tokens);
                const existing = newTokens.get(action.tokenId);
                if (existing) newTokens.set(action.tokenId, {
                    ...existing,
                    status: 'success',
                    stats: action.stats
                });
                return {
                    ...state,
                    tokens: newTokens
                };
            }
        case 'TOKEN_ERROR':
            {
                const newTokens = new Map(state.tokens);
                const existing = newTokens.get(action.tokenId);
                if (existing) newTokens.set(action.tokenId, {
                    ...existing,
                    status: 'error',
                    error: action.error,
                    needsRelink: action.needsRelink
                });
                return {
                    ...state,
                    tokens: newTokens
                };
            }
        case 'TOKEN_RELINKED':
            {
                const newTokens = new Map(state.tokens);
                const existing = newTokens.get(action.tokenId);
                if (existing) newTokens.set(action.tokenId, {
                    ...existing,
                    status: 'success',
                    error: undefined,
                    needsRelink: false
                });
                return {
                    ...state,
                    tokens: newTokens
                };
            }
        case 'SYNC_COMPLETE':
            return {
                ...state,
                phase: 'complete',
                summary: action.summary
            };
        case 'ERROR':
            return {
                ...state,
                phase: 'error',
                errorMessage: action.message
            };
        default:
            return state;
    }
};
const $d8cf039892cc43a6$var$dispatchEventAction = (dispatch, event)=>{
    switch(event.type){
        case 'sync_start':
            dispatch({
                type: 'SYNC_START',
                tokenCount: event.tokenCount
            });
            break;
        case 'token_start':
            dispatch({
                type: 'TOKEN_START',
                tokenId: event.tokenId,
                institutionName: event.institutionName
            });
            break;
        case 'token_step':
            dispatch({
                type: 'TOKEN_STEP',
                tokenId: event.tokenId,
                step: event.step,
                status: event.status,
                detail: event.detail
            });
            break;
        case 'token_complete':
            dispatch({
                type: 'TOKEN_COMPLETE',
                tokenId: event.tokenId,
                stats: event.stats
            });
            break;
        case 'token_error':
            dispatch({
                type: 'TOKEN_ERROR',
                tokenId: event.tokenId,
                error: event.error,
                needsRelink: event.needsRelink
            });
            break;
        case 'sync_complete':
            dispatch({
                type: 'SYNC_COMPLETE',
                summary: {
                    sessionId: event.summary.sessionId,
                    durationMs: event.summary.durationMs,
                    tokensSucceeded: event.summary.tokensSucceeded,
                    tokensFailed: event.summary.tokensFailed,
                    totalTransactionsCreated: event.summary.totalTransactionsCreated,
                    totalAccountsCreated: event.summary.totalAccountsCreated,
                    totalAccountsUpdated: event.summary.totalAccountsUpdated
                }
            });
            break;
        case 'error':
            dispatch({
                type: 'ERROR',
                message: event.message
            });
            break;
    }
};
const $d8cf039892cc43a6$var$getLatestStepLabel = (steps)=>{
    if (steps.length === 0) return null;
    const last = steps[steps.length - 1];
    const label = $d8cf039892cc43a6$var$STEP_LABELS[last.step];
    if (last.status === 'start') return `${label}...`;
    return null;
};
const $d8cf039892cc43a6$var$buildStepDisplay = (steps)=>{
    const entries = [];
    for (const entry of steps)if (entry.status === 'start') entries.push({
        step: entry.step,
        label: $d8cf039892cc43a6$var$STEP_LABELS[entry.step],
        startTime: entry.timestamp
    });
    else {
        const existing = entries.find((e)=>e.step === entry.step && e.endTime == null);
        if (existing) {
            existing.endTime = entry.timestamp;
            existing.durationMs = entry.timestamp - existing.startTime;
            existing.detail = entry.detail;
            existing.errored = entry.status === 'error';
        }
    }
    return entries;
};
const $d8cf039892cc43a6$var$StepLog = ({ steps: steps })=>{
    const entries = $d8cf039892cc43a6$var$buildStepDisplay(steps);
    if (entries.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border-border/50 ml-6 border-l pl-3 pb-1",
        children: entries.map((entry, i)=>{
            const isTerminal = entry.endTime != null;
            const durationText = entry.durationMs != null ? `${(entry.durationMs / 1000).toFixed(1)}s` : null;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-row items-baseline gap-2 py-0.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-xs', entry.errored ? 'text-red-500' : isTerminal ? 'text-muted-foreground' : 'text-foreground'),
                        children: entry.label
                    }),
                    isTerminal && durationText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground/60 text-xs",
                        children: durationText
                    }),
                    isTerminal && entry.detail && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-xs', entry.errored ? 'text-red-500' : 'text-muted-foreground'),
                        children: entry.detail
                    }),
                    !isTerminal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                        className: "text-muted-foreground size-3 animate-spin"
                    })
                ]
            }, i);
        })
    });
};
const $d8cf039892cc43a6$var$TokenRow = ({ token: token, onRelink: onRelink })=>{
    const [expanded, setExpanded] = $acw62.useState(false);
    const hasSteps = token.steps.length > 0;
    const statusIcon = token.status === 'syncing' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
        className: "text-muted-foreground size-4 animate-spin"
    }) : token.status === 'success' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
        className: "size-4 text-green-500"
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
        className: "size-4 text-red-500"
    });
    const subtitleText = token.status === 'success' && token.stats ? `${token.stats.transactionsCreated} transactions` : token.status === 'error' ? token.error : token.status === 'syncing' ? $d8cf039892cc43a6$var$getLatestStepLabel(token.steps) : null;
    const handleToggle = ()=>{
        if (hasSteps) setExpanded((prev)=>!prev);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "py-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex flex-row items-center justify-between', hasSteps && 'cursor-pointer'),
                onClick: handleToggle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row items-center gap-2",
                        children: [
                            hasSteps ? expanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-4"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-4"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "size-4"
                            }),
                            statusIcon,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: token.institutionName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row items-center gap-2",
                        children: [
                            subtitleText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-sm', token.status === 'error' ? 'text-red-500' : 'text-muted-foreground'),
                                children: subtitleText
                            }),
                            token.needsRelink && onRelink && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "outline",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    onRelink();
                                },
                                children: "Relink"
                            })
                        ]
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d8cf039892cc43a6$var$StepLog, {
                steps: token.steps
            })
        ]
    });
};
const $d8cf039892cc43a6$var$SyncSummary = ({ summary: summary })=>{
    const durationSec = (summary.durationMs / 1000).toFixed(1);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border-border mt-4 border-t pt-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-muted-foreground flex flex-col gap-1 text-sm",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        summary.totalTransactionsCreated,
                        " new transactions,",
                        ' ',
                        summary.totalAccountsUpdated,
                        " accounts updated"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        summary.tokensSucceeded,
                        " succeeded, ",
                        summary.tokensFailed,
                        " failed"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        "Completed in ",
                        durationSec,
                        "s"
                    ]
                })
            ]
        })
    });
};
const $d8cf039892cc43a6$export$79808e15d21996bb = ({ onRequestClose: onRequestClose })=>{
    const apolloClient = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const [state, dispatch] = $acw62.useReducer($d8cf039892cc43a6$var$syncReducer, $d8cf039892cc43a6$var$initialState);
    const [relinkTokenId, setRelinkTokenId] = $acw62.useState(null);
    const [relinkLinkToken, setRelinkLinkToken] = $acw62.useState(null);
    const [createUpdateLinkToken] = (0, $ce9d9e524be20f53$export$d30b9f47d38efbc1)();
    // Refetch relevant queries as soon as sync completes. InboxBacklogSummary
    // feeds the inbox's review count, so it must refresh too — otherwise the
    // "Review (N)" button keeps its pre-sync count until the next navigation.
    // The investments-overview set refreshes as a group: sync writes balance
    // readings and investment transactions, and refetching one card while its
    // neighbors keep pre-sync numbers would misread. (refetchQueries only
    // touches queries with mounted observers, so off-page names are free.)
    $acw62.useEffect(()=>{
        if (state.phase === 'complete') apolloClient.refetchQueries({
            include: [
                ...(0, $d445317123c5c8b5$export$f4597344e9ae6f5f),
                'PlaidUpdatesAvailable'
            ]
        });
    }, [
        apolloClient,
        state.phase
    ]);
    // Start sync when modal opens
    $acw62.useEffect(()=>{
        let aborted = false;
        const startSync = async ()=>{
            try {
                // Auth rides on the httpOnly session cookie (BFF); in dev the
                // Parcel proxy makes this same-origin (.proxyrc.json).
                const response = await fetch('/api/sync/stream', {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        Accept: 'text/event-stream'
                    }
                });
                if (!response.ok) {
                    const text = await response.text();
                    throw new Error(`HTTP ${response.status}: ${text}`);
                }
                const reader = response.body?.getReader();
                if (!reader) throw new Error('No response body');
                const decoder = new TextDecoder();
                let buffer = '';
                while(!aborted){
                    const { done: done, value: value } = await reader.read();
                    if (done) break;
                    buffer += decoder.decode(value, {
                        stream: true
                    });
                    const lines = buffer.split('\n');
                    buffer = lines.pop() ?? '';
                    for (const line of lines)if (line.startsWith('data: ')) {
                        const data = line.slice(6);
                        if (data) try {
                            const event = JSON.parse(data);
                            $d8cf039892cc43a6$var$dispatchEventAction(dispatch, event);
                        } catch  {
                            dispatch({
                                type: 'ERROR',
                                message: 'Failed to parse sync event'
                            });
                        }
                    }
                }
            } catch (error) {
                if (!aborted) {
                    const message = error instanceof Error ? error.message : 'Unknown error';
                    dispatch({
                        type: 'ERROR',
                        message: message
                    });
                }
            }
        };
        startSync();
        return ()=>{
            aborted = true;
        };
    }, []);
    const handleRelink = (tokenId)=>{
        setRelinkTokenId(tokenId);
        createUpdateLinkToken({
            variables: {
                accessTokenId: tokenId
            }
        }).then((result)=>{
            if (result.data?.createUpdateLinkToken) setRelinkLinkToken(result.data.createUpdateLinkToken);
        }, ()=>{
            setRelinkTokenId(null);
        });
    };
    const handlePlaidSuccess = ()=>{
        // Update the token status in state to show success
        if (relinkTokenId) dispatch({
            type: 'TOKEN_RELINKED',
            tokenId: relinkTokenId
        });
        // Clear the relink state
        setRelinkTokenId(null);
        setRelinkLinkToken(null);
    };
    const handlePlaidExit = ()=>{
        // User exited Plaid Link without completing
        setRelinkTokenId(null);
        setRelinkLinkToken(null);
    };
    const headerText = relinkLinkToken ? 'Relink Account' : state.phase === 'connecting' ? 'Connecting...' : state.phase === 'syncing' ? 'Syncing Accounts' : state.phase === 'complete' ? 'Sync Complete' : 'Sync Error';
    const tokens = Array.from(state.tokens.values());
    // Show Plaid Link for relinking
    if (relinkLinkToken) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        header: headerText,
        onRequestClose: onRequestClose,
        size: "lg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "h-[500px] w-full",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a36ddd27b352a95$exports.PlaidEmbeddedLink), {
                token: relinkLinkToken,
                onSuccess: handlePlaidSuccess,
                onExit: handlePlaidExit,
                style: {
                    height: '100%',
                    width: '100%'
                }
            })
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        header: headerText,
        onRequestClose: onRequestClose,
        // The header's X can be a stretch to reach on a tall mobile sheet, so
        // mirror it with a footer Close. The error phase renders its own Close
        // in-body, so skip the duplicate there.
        footer: state.phase !== 'error' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
            variant: "outline",
            onClick: onRequestClose,
            children: "Close"
        }) : undefined,
        children: [
            state.phase === 'connecting' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex items-center justify-center py-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                    className: "text-muted-foreground size-8 animate-spin"
                })
            }),
            state.phase === 'error' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col items-center gap-4 py-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                        className: "size-8 text-red-500"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground",
                        children: state.errorMessage
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        onClick: onRequestClose,
                        children: "Close"
                    })
                ]
            }),
            (state.phase === 'syncing' || state.phase === 'complete') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    state.tokenCount === 0 && state.phase === 'complete' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground py-4 text-center",
                        children: "No connected accounts to sync."
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "divide-border divide-y",
                        children: tokens.map((token)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d8cf039892cc43a6$var$TokenRow, {
                                token: token,
                                onRelink: token.needsRelink ? ()=>handleRelink(token.tokenId) : undefined
                            }, token.tokenId))
                    }),
                    state.phase === 'complete' && state.summary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d8cf039892cc43a6$var$SyncSummary, {
                        summary: state.summary
                    })
                ]
            })
        ]
    });
};











var $acw62 = parcelRequire("acw62");












const $4cac1ff0320d9441$var$centsOf = (amount)=>amount.map((m)=>Math.abs(m.amount)).getOrElse(0);
const $4cac1ff0320d9441$export$2ec96fe5a59ded7e = (props)=>{
    const formId = $acw62.useId();
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const { onRequestClose: onRequestClose, onCreate: onCreate, rawTransaction: rawTransaction } = props;
    // The unconsumed portion is what can be tracked
    const remaining = rawTransaction.remainingAmount ?? rawTransaction.amount;
    // An inbound source cannot fund a credit (it would create a negative
    // stored-value balance); those default to — and are restricted to — loans
    const outbound = remaining < 0;
    const [kind, setKind] = $acw62.useState(outbound ? 'credit' : 'loan');
    const [name, setName] = $acw62.useState('');
    const [amount, setAmount] = $acw62.useState((0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(remaining), rawTransaction.currency)));
    const [createAccount, { loading: creatingAccount }] = (0, $ce9d9e524be20f53$export$9c00ed426f67b5b7)();
    const [createRawTransaction, { loading: creatingRaw }] = (0, $ce9d9e524be20f53$export$44575aef3a6c207)();
    const [createTransaction, { loading: creatingTransaction }] = (0, $ce9d9e524be20f53$export$5694853076d71b4a)();
    const [deleteRawTransactions] = (0, $ce9d9e524be20f53$export$d89c4bc38f3faef7)();
    const [error, setError] = $acw62.useState(null);
    const loading = creatingAccount || creatingRaw || creatingTransaction;
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const cents = $4cac1ff0320d9441$var$centsOf(amount);
    // createDepositoryAccount hardcodes USD, so a non-USD source would mix
    // currencies inside one tracked balance — disallow rather than corrupt
    const usdSource = rawTransaction.currency === 'USD';
    const valid = usdSource && name.trim().length > 0 && cents > 0 && cents <= Math.abs(remaining);
    const isPartial = cents < Math.abs(remaining);
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!valid) return;
        const run = async ()=>{
            const accountResult = await createAccount({
                variables: {
                    name: name.trim(),
                    // Credits are stored value (wallet); loans are receivables
                    depositoryType: kind === 'credit' ? (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Wallet : (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Other,
                    trackBalance: true
                }
            });
            const accountId = accountResult.data?.createDepositoryAccount._id;
            if (!accountId) return;
            // Inverse of the (possibly partial) source: the tracked account
            // receives what the source account gave up
            const sourceSign = Math.sign(remaining);
            const inverseAmount = -sourceSign * cents;
            const rawResult = await createRawTransaction({
                variables: {
                    props: {
                        accountId: accountId,
                        amount: inverseAmount,
                        currency: rawTransaction.currency,
                        date: rawTransaction.date,
                        description: name.trim()
                    }
                }
            });
            const trackedRawId = rawResult.data?.createRawTransaction._id;
            if (!trackedRawId) return;
            // Allocation amounts are positive magnitudes; the server applies each
            // raw transaction's own sign
            let transferResult;
            try {
                transferResult = await createTransaction({
                    variables: {
                        rawTransactions: [
                            rawTransaction._id,
                            trackedRawId
                        ],
                        date: rawTransaction.date,
                        transferType: (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Prepaid,
                        // Explicit allocations only when the source is partially consumed
                        allocations: isPartial ? [
                            {
                                rawTransactionId: rawTransaction._id,
                                amount: cents
                            },
                            {
                                rawTransactionId: trackedRawId,
                                amount: cents
                            }
                        ] : undefined
                    }
                });
            } catch (e) {
                // Roll back the inverse raw so the tracked balance is not left
                // altered by a failed transfer (the empty account stays settled
                // and therefore invisible)
                await deleteRawTransactions({
                    variables: {
                        ids: [
                            trackedRawId
                        ]
                    }
                });
                setError(e instanceof Error ? e.message : 'Transfer failed');
                return;
            }
            if (!transferResult.data) return;
            // Surface the new account on the outstanding cards and accounts list
            client.refetchQueries({
                include: [
                    'TrackedBalances',
                    'AllAccounts'
                ]
            });
            onCreate?.({
                rawTransactionIds: [
                    rawTransaction._id
                ],
                updatedRawTransactions: isPartial ? [
                    {
                        ...rawTransaction,
                        remainingAmount: remaining - sourceSign * cents
                    }
                ] : undefined
            });
            onRequestClose();
        };
        run();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        size: "md",
        header: "Track as credit",
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: onRequestClose,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    type: "submit",
                    disabled: !valid || loading,
                    form: formId,
                    children: [
                        "Track",
                        ' ',
                        amount.map((m)=>formatMoney(m, {
                                showCurrency: true
                            })).getOrElse('')
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Source",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-muted-foreground flex items-center gap-2 py-1 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                variant: "plain",
                                amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(remaining, rawTransaction.currency)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "min-w-0 truncate",
                                children: rawTransaction.description
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ml-auto shrink-0",
                                children: rawTransaction.date
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Type",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c57dbaeaea7da703$export$358303cbde861097), {
                        className: "self-start",
                        options: outbound ? [
                            {
                                value: 'credit',
                                label: 'Credit'
                            },
                            {
                                value: 'loan',
                                label: 'Loan'
                            }
                        ] : [
                            {
                                value: 'loan',
                                label: 'Loan'
                            }
                        ],
                        value: kind,
                        onChange: (next)=>setKind(next === 'loan' ? 'loan' : 'credit')
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Name",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                        autoFocus: true,
                        value: name,
                        onChange: setName,
                        placeholder: kind === 'credit' ? 'Ocean House gift card' : "Alex \u2014 ski house"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Amount set aside",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                        value: amount,
                        onChange: setAmount
                    })
                }),
                !usdSource && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-xs",
                    children: "Only USD transactions can be tracked for now."
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-xs",
                    children: error
                }),
                isPartial && valid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-muted-foreground text-xs",
                    children: [
                        "Creates a tracked account and a prepaid transfer. The remaining",
                        ' ',
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                            variant: "plain",
                            amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(remaining) - cents, rawTransaction.currency)
                        }),
                        ' ',
                        "of this transaction stays in your inbox."
                    ]
                })
            ]
        })
    });
};
const $4cac1ff0320d9441$export$a2f9bd98713d956c = (props)=>{
    const formId = $acw62.useId();
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const { onRequestClose: onRequestClose, accountId: accountId, accountName: accountName, currency: currency, balance: balance, latestAnchorDate: latestAnchorDate, onDone: onDone } = props;
    const [amount, setAmount] = $acw62.useState((0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(balance), currency)));
    const [date, setDate] = $acw62.useState((0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)());
    // The derived balance only counts raws strictly after the latest anchor;
    // an earlier-dated use would report success but change nothing
    const dateAfterAnchor = latestAnchorDate == null || (date.toISODate() ?? '') > latestAnchorDate;
    const [payee, setPayee] = $acw62.useState('');
    const [category, setCategory] = $acw62.useState((0, $f8f45ddea4959097$exports.none));
    const [createRawTransaction, { loading: creatingRaw }] = (0, $ce9d9e524be20f53$export$44575aef3a6c207)();
    const [createTransaction, { loading: creatingTransaction }] = (0, $ce9d9e524be20f53$export$5694853076d71b4a)();
    const [deleteRawTransactions] = (0, $ce9d9e524be20f53$export$d89c4bc38f3faef7)();
    const [error, setError] = $acw62.useState(null);
    const loading = creatingRaw || creatingTransaction;
    const cents = $4cac1ff0320d9441$var$centsOf(amount);
    const valid = cents > 0 && cents <= Math.abs(balance) && dateAfterAnchor && payee.trim().length > 0 && !category.isEmpty;
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!valid) return;
        const run = async ()=>{
            const rawResult = await createRawTransaction({
                variables: {
                    props: {
                        accountId: accountId,
                        amount: -Math.sign(balance) * cents,
                        currency: currency,
                        date: date.toISODate() ?? '',
                        description: payee.trim()
                    }
                }
            });
            const rawId = rawResult.data?.createRawTransaction._id;
            if (!rawId) return;
            try {
                await createTransaction({
                    variables: {
                        rawTransactions: [
                            rawId
                        ],
                        date: date.toISODate() ?? '',
                        payee: payee.trim(),
                        category: category.getOrElse('')
                    }
                });
            } catch (e) {
                // Roll back the raw so the tracked balance is unchanged (e.g. a
                // required-field rejection from validateFields)
                await deleteRawTransactions({
                    variables: {
                        ids: [
                            rawId
                        ]
                    }
                });
                setError(e instanceof Error ? e.message : 'Failed to record');
                return;
            }
            onDone?.();
            onRequestClose();
        };
        run();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        size: "md",
        header: `Record use \u{2014} ${accountName}`,
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: onRequestClose,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    type: "submit",
                    disabled: !valid || loading,
                    form: formId,
                    children: "Record expense"
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-muted-foreground text-sm",
                    children: [
                        formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(balance), currency), {
                            showCurrency: true
                        }),
                        ' ',
                        "remaining"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Amount",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                        value: amount,
                        onChange: setAmount
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Date",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                        selectedDate: date,
                        onChange: setDate
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Payee",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1af78646b91168e0$export$2e2bcd8739ae039), {
                        value: payee,
                        onChange: setPayee
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Category",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9eb11e6352514841$export$2e2bcd8739ae039), {
                        selectedCategory: category,
                        onSelectCategory: setCategory
                    })
                }),
                !dateAfterAnchor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-destructive text-xs",
                    children: [
                        "Date must be after the latest balance anchor (",
                        latestAnchorDate,
                        ")."
                    ]
                }),
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-xs",
                    children: error
                })
            ]
        })
    });
};
const $4cac1ff0320d9441$export$8889ee23e77f239e = (props)=>{
    const formId = $acw62.useId();
    const { onRequestClose: onRequestClose, accountId: accountId, accountName: accountName, currency: currency, balance: balance, latestAnchorDate: latestAnchorDate, onDone: onDone } = props;
    const [selectedRawId, setSelectedRawId] = $acw62.useState('');
    const [selectedRaw, setSelectedRaw] = $acw62.useState(null);
    const [amount, setAmount] = $acw62.useState((0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(balance), currency)));
    const [createRawTransaction, { loading: creatingRaw }] = (0, $ce9d9e524be20f53$export$44575aef3a6c207)();
    const [createTransaction, { loading: creatingTransaction }] = (0, $ce9d9e524be20f53$export$5694853076d71b4a)();
    const [deleteRawTransactions] = (0, $ce9d9e524be20f53$export$d89c4bc38f3faef7)();
    const [repayError, setRepayError] = $acw62.useState(null);
    const loading = creatingRaw || creatingTransaction;
    const cents = $4cac1ff0320d9441$var$centsOf(amount);
    // The picked raw must flow in the repayment direction (same sign as the
    // outstanding balance) and its UNCONSUMED portion must cover the amount,
    // or the transfer cannot net to zero and would strand an unallocated raw
    // on the tracked account.
    const sourceRemaining = selectedRaw === null ? 0 : Math.abs(selectedRaw.remainingAmount ?? selectedRaw.amount);
    const valid = selectedRaw !== null && // A repayment must come from another account — pairing a raw from the
    // tracked account itself would consume it while netting to zero
    selectedRaw.accountId !== accountId && // Repayment raws dated at/before the anchor would not affect the balance
    (latestAnchorDate == null || selectedRaw.date > latestAnchorDate) && selectedRaw.currency === currency && Math.sign(selectedRaw.amount) === Math.sign(balance) && cents > 0 && cents <= Math.abs(balance) && cents <= sourceRemaining;
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!valid || selectedRaw === null) return;
        const run = async ()=>{
            // The loan account gives up the receivable that the picked incoming
            // transaction repays
            const rawResult = await createRawTransaction({
                variables: {
                    props: {
                        accountId: accountId,
                        amount: -Math.sign(balance) * cents,
                        currency: currency,
                        date: selectedRaw.date,
                        description: `Repayment \u{2014} ${accountName}`
                    }
                }
            });
            const loanRawId = rawResult.data?.createRawTransaction._id;
            if (!loanRawId) return;
            const partialSource = cents < Math.abs(selectedRaw.remainingAmount ?? selectedRaw.amount);
            // Allocation amounts are positive magnitudes; the server applies each
            // raw transaction's own sign
            let transferResult;
            try {
                transferResult = await createTransaction({
                    variables: {
                        rawTransactions: [
                            selectedRaw._id,
                            loanRawId
                        ],
                        date: selectedRaw.date,
                        transferType: (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).AccountTransfer,
                        allocations: partialSource ? [
                            {
                                rawTransactionId: selectedRaw._id,
                                amount: cents
                            },
                            {
                                rawTransactionId: loanRawId,
                                amount: cents
                            }
                        ] : undefined
                    }
                });
            } catch (e) {
                await deleteRawTransactions({
                    variables: {
                        ids: [
                            loanRawId
                        ]
                    }
                });
                setRepayError(e instanceof Error ? e.message : 'Transfer failed');
                return;
            }
            if (!transferResult.data) return;
            onDone?.();
            onRequestClose();
        };
        run();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        size: "md",
        header: `Record repayment \u{2014} ${accountName}`,
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: onRequestClose,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    type: "submit",
                    disabled: !valid || loading,
                    form: formId,
                    children: "Record repayment"
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-muted-foreground text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                            variant: "plain",
                            amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(balance), currency)
                        }),
                        ' ',
                        "outstanding"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Incoming transaction",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ab52d2c0e66eec5$export$ff27b476ad9a61f6), {
                        value: selectedRawId,
                        includeProcessed: false,
                        onChange: (id, transaction)=>{
                            setSelectedRawId(id);
                            setSelectedRaw(transaction ?? null);
                            if (transaction) setAmount((0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.min(Math.abs(balance), Math.abs(transaction.remainingAmount ?? transaction.amount)), currency)));
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                    label: "Amount repaid",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                        value: amount,
                        onChange: setAmount
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-muted-foreground text-xs",
                    children: "Pairs the incoming transaction with the loan account as a transfer. For cash repayments, add a raw transaction to the receiving account first."
                }),
                repayError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-destructive text-xs",
                    children: repayError
                })
            ]
        })
    });
};





parcelRequire("acw62");








const $289da6ff88aef34d$export$a53f96d9aa53ca75 = (props)=>{
    const { unit: unit, onUpdate: onUpdate } = props;
    const { editUnitModal: editUnitModal, deleteUnitModal: deleteUnitModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const handleEdit = ()=>{
        editUnitModal.openModal({
            unit: unit,
            onSuccess: onUpdate
        });
    };
    const handleDelete = ()=>{
        deleteUnitModal.openModal({
            unit: unit,
            onDeleted: onUpdate
        });
    };
    const exampleAmount = 3..toFixed(unit.displayDecimals);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border-border bg-card rounded-lg border p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-start justify-between",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "font-medium",
                                    children: unit.name
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "bg-muted text-muted-foreground rounded px-1.5 py-0.5 text-xs font-medium",
                                    children: [
                                        "1 ",
                                        unit.singular,
                                        " \xb7 ",
                                        exampleAmount,
                                        " ",
                                        unit.plural
                                    ]
                                })
                            ]
                        }),
                        unit.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground mt-1 text-sm",
                            children: unit.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            size: "icon",
                            variant: "ghost",
                            onClick: handleEdit,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                className: "h-4 w-4"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            size: "icon",
                            variant: "ghost",
                            onClick: handleDelete,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                className: "h-4 w-4"
                            })
                        })
                    ]
                })
            ]
        })
    });
};


const $b5dacb16d832f4b6$export$f38c2e306dc3b554 = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Units',
        fallback: [
            {
                label: 'Settings',
                href: '/settings'
            }
        ]
    });
    const { data: data, loading: loading, refetch: refetch } = (0, $ce9d9e524be20f53$export$20437837b60921de)();
    const { createUnitModal: createUnitModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const handleRefetch = ()=>{
        refetch();
    };
    const handleCreate = ()=>{
        createUnitModal.openModal({
            onSuccess: handleRefetch
        });
    };
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading units..."
        })
    });
    const units = data?.allUnits || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-4 p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-lg font-semibold",
                                children: "Units"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground text-sm",
                                children: "Custom currencies for non-monetary wallets \u2014 passes, miles, credits"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: handleCreate,
                        className: "hidden sm:inline-flex",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "mr-1 h-4 w-4"
                            }),
                            "Create Unit"
                        ]
                    })
                ]
            }),
            units.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border rounded-lg border border-dashed p-8 text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground mb-4",
                        children: "No units created yet"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground mb-4 text-sm",
                        children: 'Units let a wallet account track things that aren\'t money \u2014 a 5-pack of tennis classes, airline miles, store credits \u2014 with amounts rendered in their own words ("3 passes"). Create an account denominated in a unit, then record what it cost as a conversion transfer.'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        onClick: handleCreate,
                        type: "button",
                        children: "Create your first unit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f86f33905a87dd$export$b3bb6a251ee1ac06), {
                        onClick: handleCreate,
                        children: "Create Unit"
                    }),
                    units.map((unit)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $289da6ff88aef34d$export$a53f96d9aa53ca75), {
                            unit: unit,
                            onUpdate: handleRefetch
                        }, unit._id))
                ]
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");




const $7efeb142a8fb3531$var$DECIMAL_CHOICES = [
    0,
    1,
    2
];
const $7efeb142a8fb3531$export$85f268471d8a3eae = ({ onRequestClose: onRequestClose, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const [name, setName] = $acw62.useState('');
    const [singular, setSingular] = $acw62.useState('');
    const [plural, setPlural] = $acw62.useState('');
    const [pluralEdited, setPluralEdited] = $acw62.useState(false);
    const [displayDecimals, setDisplayDecimals] = $acw62.useState(0);
    const [description, setDescription] = $acw62.useState('');
    const [error, setError] = $acw62.useState(null);
    const [createUnit, { loading: loading }] = (0, $ce9d9e524be20f53$export$ac83f9d48a6d7c8c)({
        refetchQueries: [
            {
                query: (0, $ce9d9e524be20f53$export$7b157d29dd825b13)
            }
        ]
    });
    // "pass" → "passes" is close enough for a prefill; any edit takes over.
    const handleSingularChange = (value)=>{
        setSingular(value);
        if (!pluralEdited) setPlural(value === '' ? '' : `${value}s`);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            const result = await createUnit({
                variables: {
                    name: name.trim(),
                    singular: singular.trim(),
                    plural: plural.trim(),
                    displayDecimals: displayDecimals,
                    description: description.trim() || null
                }
            });
            const unit = result.data?.createUnit;
            if (unit) onSuccess?.(unit);
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || !name.trim() || !singular.trim() || !plural.trim(),
                children: "Create"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Create Unit",
        footer: footer,
        size: "lg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: name,
                            onChange: setName,
                            placeholder: "e.g., Court 16 drills passes",
                            autoFocus: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground text-xs",
                            children: "Shown where accounts list their currency. Freely renamable later \u2014 transactions store an internal id, never the name."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-1 flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "text-sm font-medium",
                                    children: "Singular"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                    value: singular,
                                    onChange: handleSingularChange,
                                    placeholder: "pass"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-1 flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "text-sm font-medium",
                                    children: "Plural"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                    value: plural,
                                    onChange: (value)=>{
                                        setPlural(value);
                                        setPluralEdited(true);
                                    },
                                    placeholder: "passes"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground -mt-2 text-xs",
                    children: 'Amounts render with these labels: "1 pass", "3 passes".'
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Decimals"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex gap-2",
                            children: $7efeb142a8fb3531$var$DECIMAL_CHOICES.map((choice)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setDisplayDecimals(choice),
                                    className: `rounded-md border px-3 py-1.5 text-sm font-medium transition-colors ${displayDecimals === choice ? 'border-primary bg-primary/10 text-primary' : 'border-border text-muted-foreground hover:bg-muted'}`,
                                    children: 3..toFixed(choice)
                                }, choice))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground text-xs",
                            children: "How many decimal places amounts show and accept. Whole-unit things like passes want 0."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $654d5ea45aebf8c9$export$379139ebc1c2b235), {
                            value: description,
                            onChange: setDescription,
                            placeholder: "Optional: what this unit tracks (e.g. 5-pack of drills classes at Court 16)",
                            rows: 2
                        })
                    ]
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");




const $94fd56a5e1feddd6$var$DECIMAL_CHOICES = [
    0,
    1,
    2
];
const $94fd56a5e1feddd6$export$3bc29eec1e40bcb4 = ({ unit: unit, onRequestClose: onRequestClose, onSuccess: onSuccess })=>{
    const formId = $acw62.useId();
    const [name, setName] = $acw62.useState(unit.name);
    const [singular, setSingular] = $acw62.useState(unit.singular);
    const [plural, setPlural] = $acw62.useState(unit.plural);
    const [displayDecimals, setDisplayDecimals] = $acw62.useState(unit.displayDecimals);
    const [description, setDescription] = $acw62.useState(unit.description ?? '');
    const [error, setError] = $acw62.useState(null);
    const [updateUnit, { loading: loading }] = (0, $ce9d9e524be20f53$export$1a8852189f232b76)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        try {
            await updateUnit({
                variables: {
                    id: unit._id,
                    name: name.trim(),
                    singular: singular.trim(),
                    plural: plural.trim(),
                    displayDecimals: displayDecimals,
                    // Empty string is meaningful here: null means "no change" while
                    // '' clears the stored description, so send the trimmed value
                    // verbatim.
                    description: description.trim()
                }
            });
            onSuccess?.();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                type: "submit",
                form: formId,
                disabled: loading || !name.trim() || !singular.trim() || !plural.trim(),
                children: "Save"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Edit Unit",
        footer: footer,
        size: "lg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: [
                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-destructive/10 text-destructive rounded-md p-3 text-sm",
                    children: error
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: name,
                            onChange: setName,
                            autoFocus: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground text-xs",
                            children: "Renaming never touches transactions \u2014 they store the unit's id."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-1 flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "text-sm font-medium",
                                    children: "Singular"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                    value: singular,
                                    onChange: setSingular
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-1 flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "text-sm font-medium",
                                    children: "Plural"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                                    value: plural,
                                    onChange: setPlural
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Decimals"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex gap-2",
                            children: $94fd56a5e1feddd6$var$DECIMAL_CHOICES.map((choice)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setDisplayDecimals(choice),
                                    className: `rounded-md border px-3 py-1.5 text-sm font-medium transition-colors ${displayDecimals === choice ? 'border-primary bg-primary/10 text-primary' : 'border-border text-muted-foreground hover:bg-muted'}`,
                                    children: 3..toFixed(choice)
                                }, choice))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            className: "text-sm font-medium",
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $654d5ea45aebf8c9$export$379139ebc1c2b235), {
                            value: description,
                            onChange: setDescription,
                            rows: 2
                        })
                    ]
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");


const $86b7ce120063bb40$export$8b6c8909639719b6 = (props)=>{
    const { unit: unit, onRequestClose: onRequestClose, onDeleted: onDeleted } = props;
    const [deleteUnit, { loading: loading }] = (0, $ce9d9e524be20f53$export$6c48a9eed4669ece)({
        refetchQueries: [
            {
                query: (0, $ce9d9e524be20f53$export$7b157d29dd825b13)
            }
        ]
    });
    const [error, setError] = $acw62.useState(null);
    const handleDelete = async ()=>{
        setError(null);
        try {
            await deleteUnit({
                variables: {
                    id: unit._id
                }
            });
            onDeleted?.();
            onRequestClose();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: onRequestClose,
                disabled: loading,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "destructive",
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: handleDelete,
                disabled: loading,
                children: loading ? 'Deleting...' : 'Delete'
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Delete unit",
        footer: footer,
        size: "sm",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-destructive/10 text-destructive mb-3 rounded-md p-3 text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Are you sure you want to delete ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: unit.name
                    }),
                    "? This action cannot be undone. Deletion is refused while any account or transaction is denominated in this unit."
                ]
            })
        ]
    });
};










var $acw62 = parcelRequire("acw62");





const $514cd0919242acc0$export$5baa993b32c9b4e3 = (props)=>{
    const formId = $acw62.useId();
    const { rawTransactions: rawTransactions, onUpdate: onUpdate, onRequestClose: onRequestClose } = props;
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const [selectedAccount, setSelectedAccount] = $acw62.useState((0, $f8f45ddea4959097$exports.none));
    const [updateRawTransactions, { loading: loading }] = (0, $ce9d9e524be20f53$export$a48dcf481f9e74a4)();
    const handleSubmit = (e)=>{
        e.preventDefault();
        selectedAccount.forEach((account)=>{
            const movedIds = rawTransactions.map(({ _id: _id })=>_id);
            updateRawTransactions({
                variables: {
                    ids: movedIds,
                    account: account._id
                }
            }).then(()=>{
                // Moving rewrites each row's accountId, so any cached AllRawTransactions
                // page for the source account(s) or the destination — across every
                // filter/pagination variant — is now stale. The list query is
                // cache-first, so evict those pages to force a refetch on next view.
                // Centralized here (not in a caller) so every entry point stays correct.
                const affectedAccountIds = new Set(rawTransactions.map((rt)=>rt.account._id));
                affectedAccountIds.add(account._id);
                affectedAccountIds.forEach((accountId)=>(0, $074538a84be674b5$export$2e2bcd8739ae039)(client.cache, accountId));
                onRequestClose();
                onUpdate();
            });
        });
    };
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                disabled: loading,
                onClick: onRequestClose,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                disabled: loading || selectedAccount.isEmpty,
                type: "submit",
                form: formId,
                children: "Update"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
        onRequestClose: onRequestClose,
        header: "Move transactions",
        footer: footer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
            id: formId,
            onSubmit: handleSubmit,
            className: "flex flex-col gap-4",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Account",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $295751b0f96fd69d$export$2e2bcd8739ae039), {
                    autoFocus: true,
                    selectedAccount: selectedAccount,
                    onSelectAccount: setSelectedAccount,
                    // Raws can only move to an account in their own currency. A
                    // mixed-currency selection has no valid destination; leave the
                    // list unfiltered and let the server's per-row check explain.
                    currency: new Set(rawTransactions.map((rt)=>rt.currency)).size === 1 ? rawTransactions[0]?.currency : undefined
                })
            })
        })
    });
};


// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bbeaee87faaa63d1$var$defaultModalController = {
    state: {
        open: false
    },
    openModal: ()=>{},
    closeModal: ()=>{}
};
const $bbeaee87faaa63d1$var$useModal = ()=>{
    const [state, setState] = $acw62.useState({
        open: false
    });
    return {
        state: state,
        openModal: (props)=>{
            const onRequestClose = ()=>setState({
                    open: false
                });
            setState({
                open: true,
                props: {
                    ...props,
                    onRequestClose: onRequestClose
                }
            });
        },
        closeModal: ()=>setState({
                open: false
            })
    };
};
const $bbeaee87faaa63d1$export$2ee174121202e4c7 = ()=>{
    const context = $acw62.useContext($bbeaee87faaa63d1$var$ModalsContext);
    if (!context) throw new Error('useModals must be used within a ModalsProvider');
    return context;
};
const $bbeaee87faaa63d1$var$ModalsContext = /*#__PURE__*/ $acw62.createContext({
    addRawTransactionToPaymentModal: $bbeaee87faaa63d1$var$defaultModalController,
    addSnapshotModal: $bbeaee87faaa63d1$var$defaultModalController,
    reconcileGapModal: $bbeaee87faaa63d1$var$defaultModalController,
    bulkEditRawTransactionsModal: $bbeaee87faaa63d1$var$defaultModalController,
    bulkEditTransactionsModal: $bbeaee87faaa63d1$var$defaultModalController,
    editSnapshotModal: $bbeaee87faaa63d1$var$defaultModalController,
    connectPlaidModal: $bbeaee87faaa63d1$var$defaultModalController,
    createAccountModal: $bbeaee87faaa63d1$var$defaultModalController,
    createCardBenefitModal: $bbeaee87faaa63d1$var$defaultModalController,
    deleteCardBenefitModal: $bbeaee87faaa63d1$var$defaultModalController,
    editCardBenefitModal: $bbeaee87faaa63d1$var$defaultModalController,
    generateBenefitCreditsModal: $bbeaee87faaa63d1$var$defaultModalController,
    createFeePeriodModal: $bbeaee87faaa63d1$var$defaultModalController,
    editFeePeriodModal: $bbeaee87faaa63d1$var$defaultModalController,
    deleteFeePeriodModal: $bbeaee87faaa63d1$var$defaultModalController,
    createCategoryModal: $bbeaee87faaa63d1$var$defaultModalController,
    createFieldModal: $bbeaee87faaa63d1$var$defaultModalController,
    createInverseRawTransactionModal: $bbeaee87faaa63d1$var$defaultModalController,
    trackCreditModal: $bbeaee87faaa63d1$var$defaultModalController,
    recordUseModal: $bbeaee87faaa63d1$var$defaultModalController,
    recordLoanRepaymentModal: $bbeaee87faaa63d1$var$defaultModalController,
    createRawTransactionModal: $bbeaee87faaa63d1$var$defaultModalController,
    splitRawTransactionModal: $bbeaee87faaa63d1$var$defaultModalController,
    createTransactionForBenefitModal: $bbeaee87faaa63d1$var$defaultModalController,
    createTransactionModal: $bbeaee87faaa63d1$var$defaultModalController,
    deleteAccountModal: $bbeaee87faaa63d1$var$defaultModalController,
    deleteCategoryModal: $bbeaee87faaa63d1$var$defaultModalController,
    deleteFieldModal: $bbeaee87faaa63d1$var$defaultModalController,
    deletePlaidTokenModal: $bbeaee87faaa63d1$var$defaultModalController,
    deleteBalanceEntryModal: $bbeaee87faaa63d1$var$defaultModalController,
    deleteRawTransactionModal: $bbeaee87faaa63d1$var$defaultModalController,
    deleteSnapshotModal: $bbeaee87faaa63d1$var$defaultModalController,
    editRawTransactionModal: $bbeaee87faaa63d1$var$defaultModalController,
    editTransactionModal: $bbeaee87faaa63d1$var$defaultModalController,
    editAccountModal: $bbeaee87faaa63d1$var$defaultModalController,
    editInvestmentAccountModal: $bbeaee87faaa63d1$var$defaultModalController,
    editCategoryModal: $bbeaee87faaa63d1$var$defaultModalController,
    editFieldModal: $bbeaee87faaa63d1$var$defaultModalController,
    editPlaidTokenModal: $bbeaee87faaa63d1$var$defaultModalController,
    reconcileAnchorModal: $bbeaee87faaa63d1$var$defaultModalController,
    recordBalanceAnchorModal: $bbeaee87faaa63d1$var$defaultModalController,
    resetTransactionModal: $bbeaee87faaa63d1$var$defaultModalController,
    deleteReconciliationModal: $bbeaee87faaa63d1$var$defaultModalController,
    importTransactionsModal: $bbeaee87faaa63d1$var$defaultModalController,
    linkBenefitModal: $bbeaee87faaa63d1$var$defaultModalController,
    manageConnectionModal: $bbeaee87faaa63d1$var$defaultModalController,
    mergeTransactionsModal: $bbeaee87faaa63d1$var$defaultModalController,
    migrateAccountTransactionsModal: $bbeaee87faaa63d1$var$defaultModalController,
    payrollRecordModal: $bbeaee87faaa63d1$var$defaultModalController,
    syncModal: $bbeaee87faaa63d1$var$defaultModalController,
    unlinkBenefitTransactionModal: $bbeaee87faaa63d1$var$defaultModalController,
    updateRawTransactionsModal: $bbeaee87faaa63d1$var$defaultModalController,
    createUnitModal: $bbeaee87faaa63d1$var$defaultModalController,
    editUnitModal: $bbeaee87faaa63d1$var$defaultModalController,
    deleteUnitModal: $bbeaee87faaa63d1$var$defaultModalController
});
const $bbeaee87faaa63d1$export$d130e6a5a0bde89c = ({ children: children })=>{
    const addRawTransactionToPaymentModal = $bbeaee87faaa63d1$var$useModal();
    const addSnapshotModal = $bbeaee87faaa63d1$var$useModal();
    const reconcileGapModal = $bbeaee87faaa63d1$var$useModal();
    const bulkEditRawTransactionsModal = $bbeaee87faaa63d1$var$useModal();
    const bulkEditTransactionsModal = $bbeaee87faaa63d1$var$useModal();
    const editSnapshotModal = $bbeaee87faaa63d1$var$useModal();
    const connectPlaidModal = $bbeaee87faaa63d1$var$useModal();
    const createAccountModal = $bbeaee87faaa63d1$var$useModal();
    const createCardBenefitModal = $bbeaee87faaa63d1$var$useModal();
    const deleteCardBenefitModal = $bbeaee87faaa63d1$var$useModal();
    const editCardBenefitModal = $bbeaee87faaa63d1$var$useModal();
    const generateBenefitCreditsModal = $bbeaee87faaa63d1$var$useModal();
    const createFeePeriodModal = $bbeaee87faaa63d1$var$useModal();
    const editFeePeriodModal = $bbeaee87faaa63d1$var$useModal();
    const deleteFeePeriodModal = $bbeaee87faaa63d1$var$useModal();
    const createCategoryModal = $bbeaee87faaa63d1$var$useModal();
    const createFieldModal = $bbeaee87faaa63d1$var$useModal();
    const createInverseRawTransactionModal = $bbeaee87faaa63d1$var$useModal();
    const trackCreditModal = $bbeaee87faaa63d1$var$useModal();
    const recordUseModal = $bbeaee87faaa63d1$var$useModal();
    const recordLoanRepaymentModal = $bbeaee87faaa63d1$var$useModal();
    const createRawTransactionModal = $bbeaee87faaa63d1$var$useModal();
    const splitRawTransactionModal = $bbeaee87faaa63d1$var$useModal();
    const createTransactionForBenefitModal = $bbeaee87faaa63d1$var$useModal();
    const createTransactionModal = $bbeaee87faaa63d1$var$useModal();
    const deleteAccountModal = $bbeaee87faaa63d1$var$useModal();
    const deleteCategoryModal = $bbeaee87faaa63d1$var$useModal();
    const deleteFieldModal = $bbeaee87faaa63d1$var$useModal();
    const deletePlaidTokenModal = $bbeaee87faaa63d1$var$useModal();
    const deleteBalanceEntryModal = $bbeaee87faaa63d1$var$useModal();
    const deleteRawTransactionModal = $bbeaee87faaa63d1$var$useModal();
    const deleteSnapshotModal = $bbeaee87faaa63d1$var$useModal();
    const editRawTransactionModal = $bbeaee87faaa63d1$var$useModal();
    const editTransactionModal = $bbeaee87faaa63d1$var$useModal();
    const editAccountModal = $bbeaee87faaa63d1$var$useModal();
    const editInvestmentAccountModal = $bbeaee87faaa63d1$var$useModal();
    const editCategoryModal = $bbeaee87faaa63d1$var$useModal();
    const editFieldModal = $bbeaee87faaa63d1$var$useModal();
    const editPlaidTokenModal = $bbeaee87faaa63d1$var$useModal();
    const reconcileAnchorModal = $bbeaee87faaa63d1$var$useModal();
    const recordBalanceAnchorModal = $bbeaee87faaa63d1$var$useModal();
    const resetTransactionModal = $bbeaee87faaa63d1$var$useModal();
    const deleteReconciliationModal = $bbeaee87faaa63d1$var$useModal();
    const importTransactionsModal = $bbeaee87faaa63d1$var$useModal();
    const linkBenefitModal = $bbeaee87faaa63d1$var$useModal();
    const manageConnectionModal = $bbeaee87faaa63d1$var$useModal();
    const mergeTransactionsModal = $bbeaee87faaa63d1$var$useModal();
    const migrateAccountTransactionsModal = $bbeaee87faaa63d1$var$useModal();
    const payrollRecordModal = $bbeaee87faaa63d1$var$useModal();
    const syncModal = $bbeaee87faaa63d1$var$useModal();
    const unlinkBenefitTransactionModal = $bbeaee87faaa63d1$var$useModal();
    const updateRawTransactionsModal = $bbeaee87faaa63d1$var$useModal();
    const createUnitModal = $bbeaee87faaa63d1$var$useModal();
    const editUnitModal = $bbeaee87faaa63d1$var$useModal();
    const deleteUnitModal = $bbeaee87faaa63d1$var$useModal();
    const modals = {
        addRawTransactionToPaymentModal: addRawTransactionToPaymentModal,
        addSnapshotModal: addSnapshotModal,
        reconcileGapModal: reconcileGapModal,
        bulkEditRawTransactionsModal: bulkEditRawTransactionsModal,
        bulkEditTransactionsModal: bulkEditTransactionsModal,
        editSnapshotModal: editSnapshotModal,
        connectPlaidModal: connectPlaidModal,
        createAccountModal: createAccountModal,
        createCardBenefitModal: createCardBenefitModal,
        deleteCardBenefitModal: deleteCardBenefitModal,
        editCardBenefitModal: editCardBenefitModal,
        generateBenefitCreditsModal: generateBenefitCreditsModal,
        createFeePeriodModal: createFeePeriodModal,
        editFeePeriodModal: editFeePeriodModal,
        deleteFeePeriodModal: deleteFeePeriodModal,
        createCategoryModal: createCategoryModal,
        createFieldModal: createFieldModal,
        createInverseRawTransactionModal: createInverseRawTransactionModal,
        trackCreditModal: trackCreditModal,
        recordUseModal: recordUseModal,
        recordLoanRepaymentModal: recordLoanRepaymentModal,
        createRawTransactionModal: createRawTransactionModal,
        splitRawTransactionModal: splitRawTransactionModal,
        createTransactionForBenefitModal: createTransactionForBenefitModal,
        createTransactionModal: createTransactionModal,
        deleteAccountModal: deleteAccountModal,
        deleteCategoryModal: deleteCategoryModal,
        deleteFieldModal: deleteFieldModal,
        deletePlaidTokenModal: deletePlaidTokenModal,
        deleteBalanceEntryModal: deleteBalanceEntryModal,
        deleteRawTransactionModal: deleteRawTransactionModal,
        deleteSnapshotModal: deleteSnapshotModal,
        editRawTransactionModal: editRawTransactionModal,
        editTransactionModal: editTransactionModal,
        editAccountModal: editAccountModal,
        editInvestmentAccountModal: editInvestmentAccountModal,
        editCategoryModal: editCategoryModal,
        editFieldModal: editFieldModal,
        editPlaidTokenModal: editPlaidTokenModal,
        reconcileAnchorModal: reconcileAnchorModal,
        recordBalanceAnchorModal: recordBalanceAnchorModal,
        resetTransactionModal: resetTransactionModal,
        deleteReconciliationModal: deleteReconciliationModal,
        importTransactionsModal: importTransactionsModal,
        linkBenefitModal: linkBenefitModal,
        manageConnectionModal: manageConnectionModal,
        mergeTransactionsModal: mergeTransactionsModal,
        migrateAccountTransactionsModal: migrateAccountTransactionsModal,
        syncModal: syncModal,
        unlinkBenefitTransactionModal: unlinkBenefitTransactionModal,
        updateRawTransactionsModal: updateRawTransactionsModal,
        createUnitModal: createUnitModal,
        editUnitModal: editUnitModal,
        deleteUnitModal: deleteUnitModal,
        payrollRecordModal: payrollRecordModal
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($bbeaee87faaa63d1$var$ModalsContext.Provider, {
        value: modals,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $72de694199324d9d$export$2e2bcd8739ae039), {
                children: [
                    addRawTransactionToPaymentModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09cf10b6a8e400ec$export$a9f100633b1fddb4), {
                        ...addRawTransactionToPaymentModal.state.props
                    }),
                    addSnapshotModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67a956d651e15f74$export$77cacd66283e3934), {
                        ...addSnapshotModal.state.props
                    }),
                    reconcileGapModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ecb2bb1cb0d93cc$export$f7d70d5c9dc2cc15), {
                        ...reconcileGapModal.state.props
                    }),
                    bulkEditTransactionsModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bc847196d1d8775$export$69e5bcde13e175a7), {
                        ...bulkEditTransactionsModal.state.props
                    }),
                    bulkEditRawTransactionsModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $756d32f3d1195566$export$4610343c2350759f), {
                        ...bulkEditRawTransactionsModal.state.props
                    }),
                    editSnapshotModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1bf69211b39976a3$export$2f3c3eea6fa6f560), {
                        ...editSnapshotModal.state.props
                    }),
                    connectPlaidModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04f5a5147fbce204$export$48f6a6ba262cec31), {
                        ...connectPlaidModal.state.props
                    }),
                    createAccountModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2cfc06a8466b0c9a$export$6b46babcc2b5aac3), {
                        ...createAccountModal.state.props
                    }),
                    createCardBenefitModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1a154d4c7c0d4f2$export$a9ad4d45d17f8c67), {
                        ...createCardBenefitModal.state.props
                    }),
                    editCardBenefitModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cfedea2bfca539e$export$aae09d000bde0783), {
                        ...editCardBenefitModal.state.props
                    }),
                    deleteCardBenefitModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $214100802f307778$export$64d33e6c6a9bcdd), {
                        ...deleteCardBenefitModal.state.props
                    }),
                    generateBenefitCreditsModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00881f5c7ef9aa9e$export$700933a1074c5148), {
                        ...generateBenefitCreditsModal.state.props
                    }),
                    createFeePeriodModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e8aebcb304336dfa$export$a5cc206886d6b1a9), {
                        ...createFeePeriodModal.state.props
                    }),
                    editFeePeriodModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6fa2512537244df$export$5041203fb1bdc8ee), {
                        ...editFeePeriodModal.state.props
                    }),
                    deleteFeePeriodModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c77acc9b330c7533$export$2c9a46b8ed400596), {
                        ...deleteFeePeriodModal.state.props
                    }),
                    createCategoryModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68f5ef05891ee960$export$f32142466c80dbff), {
                        ...createCategoryModal.state.props
                    }),
                    createFieldModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $728d0704ed4afea7$export$1e2b48ba7ce01578), {
                        ...createFieldModal.state.props
                    }),
                    createInverseRawTransactionModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f075cae0ce41bbd8$export$42312d5e9dcecec6), {
                        ...createInverseRawTransactionModal.state.props
                    }),
                    trackCreditModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cac1ff0320d9441$export$2ec96fe5a59ded7e), {
                        ...trackCreditModal.state.props
                    }),
                    recordUseModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cac1ff0320d9441$export$a2f9bd98713d956c), {
                        ...recordUseModal.state.props
                    }),
                    recordLoanRepaymentModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cac1ff0320d9441$export$8889ee23e77f239e), {
                        ...recordLoanRepaymentModal.state.props
                    }),
                    createRawTransactionModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88365ccb87c7ae27$export$1b6546e9bce004a5), {
                        ...createRawTransactionModal.state.props
                    }),
                    splitRawTransactionModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $700392cc1136f4f2$export$359ece02c069a28), {
                        ...splitRawTransactionModal.state.props
                    }),
                    createTransactionForBenefitModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $797bee7272dabf5c$export$36dae91202930fc1), {
                        ...createTransactionForBenefitModal.state.props
                    }),
                    createTransactionModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $814f8eff791eb91e$export$f19dc3a4634f425c), {
                        ...createTransactionModal.state.props
                    }),
                    deleteAccountModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c82683fe303f89d0$export$92d028d636262c3b), {
                        ...deleteAccountModal.state.props
                    }),
                    deleteCategoryModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7cef194d183a2158$export$ce90d147dee4714f), {
                        ...deleteCategoryModal.state.props
                    }),
                    deleteFieldModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12cca528a4917787$export$71db6c937d4fb507), {
                        ...deleteFieldModal.state.props
                    }),
                    deletePlaidTokenModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c4b38b1a9bb2157$export$e7d68b75d17031d1), {
                        ...deletePlaidTokenModal.state.props
                    }),
                    deleteBalanceEntryModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a12bf80f6fca0b5$export$776b8bf98ad485ed), {
                        ...deleteBalanceEntryModal.state.props
                    }),
                    deleteRawTransactionModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3697c265fe0f835f$export$557dd6d24ce47eb3), {
                        ...deleteRawTransactionModal.state.props
                    }),
                    deleteSnapshotModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9913936085049f24$export$badab396be9b4ab9), {
                        ...deleteSnapshotModal.state.props
                    }),
                    editRawTransactionModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a4ffbeee2e27de2$export$ce0c93f5b834f44), {
                        ...editRawTransactionModal.state.props
                    }),
                    editTransactionModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f1bd65609d7cc1$export$996d7fb3ae0eaea1), {
                        ...editTransactionModal.state.props
                    }),
                    editAccountModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31d3dee7ad01891b$export$fa97ad412db87be1), {
                        ...editAccountModal.state.props
                    }),
                    editInvestmentAccountModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9134f1188f7e50bb$export$f528a29e04e91fcb), {
                        ...editInvestmentAccountModal.state.props
                    }),
                    editCategoryModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e359df8738f89aa$export$a4041e40a25c6e66), {
                        ...editCategoryModal.state.props
                    }),
                    editFieldModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9d5a4e4454d7a6d$export$7975bdb9eeefb6ca), {
                        ...editFieldModal.state.props
                    }),
                    editPlaidTokenModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2940bd35e7a5ee1$export$f9c6505dbbbc6719), {
                        ...editPlaidTokenModal.state.props
                    }),
                    reconcileAnchorModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98ea2bd336690b9c$export$a68cbfa049020456), {
                        ...reconcileAnchorModal.state.props
                    }),
                    recordBalanceAnchorModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84d63295abf08a9c$export$ecdd2de4d18981af), {
                        ...recordBalanceAnchorModal.state.props
                    }),
                    resetTransactionModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a0ee1611edf193c$export$7f1cdd4d2b7449b3), {
                        ...resetTransactionModal.state.props
                    }),
                    deleteReconciliationModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7db86d96a9b2815e$export$da78efecf8378488), {
                        ...deleteReconciliationModal.state.props
                    }),
                    importTransactionsModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27042ec4522110b1$export$ee15413196553934), {
                        ...importTransactionsModal.state.props
                    }),
                    linkBenefitModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f327dc1bbcd75a0$export$c72da5fb2cc7ff21), {
                        ...linkBenefitModal.state.props
                    }),
                    mergeTransactionsModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb9be4568c64be10$export$bebf05392a43a0d3), {
                        ...mergeTransactionsModal.state.props
                    }),
                    manageConnectionModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e217ae5457fd610b$export$d34371664a395c74), {
                        ...manageConnectionModal.state.props
                    }),
                    migrateAccountTransactionsModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7def3c45114de0ab$export$5d3cb3ef2d739033), {
                        ...migrateAccountTransactionsModal.state.props
                    }),
                    syncModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8cf039892cc43a6$export$79808e15d21996bb), {
                        ...syncModal.state.props
                    }),
                    unlinkBenefitTransactionModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9d94318500ad031$export$ab284278c04797d0), {
                        ...unlinkBenefitTransactionModal.state.props
                    }),
                    updateRawTransactionsModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $514cd0919242acc0$export$5baa993b32c9b4e3), {
                        ...updateRawTransactionsModal.state.props
                    }),
                    createUnitModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7efeb142a8fb3531$export$85f268471d8a3eae), {
                        ...createUnitModal.state.props
                    }),
                    editUnitModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94fd56a5e1feddd6$export$3bc29eec1e40bcb4), {
                        ...editUnitModal.state.props
                    }),
                    deleteUnitModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $86b7ce120063bb40$export$8b6c8909639719b6), {
                        ...deleteUnitModal.state.props
                    }),
                    payrollRecordModal.state.open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba9737c51f8d44f4$export$dbeb373f4a8bfe3e), {
                        ...payrollRecordModal.state.props
                    })
                ]
            })
        ]
    });
};




const $cf8a3466088e9562$export$7b3ff83b2e249bf6 = ()=>(0, $926608a7a86d7371$export$4138103a3ae699cc)();
const $cf8a3466088e9562$export$af19effd62c45729 = (type)=>(0, $e597f4605156a89e$export$6096865e4aa58c8a).find((option)=>option.matches({
            __typename: 'DepositoryAccount',
            depositoryType: type
        }))?.label ?? 'Unknown';
const $cf8a3466088e9562$var$tabClass = ({ isActive: isActive })=>(0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('shrink-0 whitespace-nowrap border-b-2 px-1 pb-2 text-sm font-medium no-underline transition', isActive ? 'border-primary text-foreground' : 'text-muted-foreground hover:text-foreground border-transparent');
const $cf8a3466088e9562$export$ae9e76cd6ee380b0 = ()=>{
    const params = (0, $926608a7a86d7371$export$99eaa27ddbbb95ef)();
    const accountId = params.id || '';
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const { deleteAccountModal: deleteAccountModal, editAccountModal: editAccountModal, editInvestmentAccountModal: editInvestmentAccountModal, migrateAccountTransactionsModal: migrateAccountTransactionsModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const { data: accountData, loading: accountLoading, refetch: refetchAccount } = (0, $ce9d9e524be20f53$export$83a5bf0e4425c554)({
        variables: {
            id: accountId
        },
        skip: !accountId
    });
    const account = accountData?.account;
    const { starredIds: starredIds, loading: starredLoading, toggleStar: toggleStar } = (0, $9e78a066568deb1b$export$6fedb39e019288e9)();
    // Shared key across the tab sub-routes so switching tabs updates this
    // crumb (and its href) in place instead of appending new entries.
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        key: `/accounts/${accountId}`,
        label: account?.name ?? 'Loading...',
        logo: account?.logo,
        fallback: [
            {
                label: 'Accounts',
                href: '/accounts'
            }
        ]
    });
    if (!accountId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "No account selected"
    });
    if (accountLoading && !accountData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "Loading account\u2026"
    });
    if (!account) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "Account not found"
    });
    const isInvestment = account.__typename === 'InvestmentAccount';
    const isCreditCard = account.__typename === 'DepositoryAccount' && account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard;
    const outletContext = {
        account: account,
        refetchAccount: ()=>void refetchAccount()
    };
    const handleEdit = ()=>{
        if (account.__typename === 'InvestmentAccount') editInvestmentAccountModal.openModal({
            account: account,
            onUpdate: ()=>void refetchAccount(),
            // The account page it lives on is gone once deleted — leave for the
            // investments overview.
            onDelete: ()=>navigate('/investments')
        });
        else editAccountModal.openModal({
            account: account,
            onUpdate: ()=>void refetchAccount()
        });
    };
    const handleDelete = ()=>{
        if (account.__typename !== 'DepositoryAccount') return;
        deleteAccountModal.openModal({
            account: account,
            onDeleted: ()=>navigate('/accounts')
        });
    };
    const handleMigrateTransactions = ()=>{
        migrateAccountTransactionsModal.openModal({
            account: account,
            onMigrated: ()=>void refetchAccount()
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between gap-4 p-4 pb-0 sm:p-8 sm:pb-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-w-0 items-center gap-3",
                        children: [
                            account.__typename === 'DepositoryAccount' && account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard && (0, $86559021d806b4ea$export$f2ae116f2284ed4d)(account.cardProduct) ? // A card shows its face (~1.6:1 at the logo's 32px height).
                            // Gated on the type, not merely on having a product: switching a
                            // card to Checking hides the picker but keeps the stored slug (so
                            // switching back restores the face), and a checking account must
                            // not wear credit-card artwork in the meantime.
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b39b2c71e902baf$export$ebcc69552e0d5c4c), {
                                product: account.cardProduct,
                                className: "w-20"
                            }) : account.logo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, $cd179cdb1a4beac3$export$2e8a6207c9cc2bb8)(account.logo),
                                alt: "",
                                className: "size-8 shrink-0 rounded-md"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f6f28ec3b697fb2$export$fdaddccc706daa3a), {
                                account: account,
                                className: "size-8 shrink-0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-foreground m-0 truncate text-3xl",
                                children: account.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex shrink-0 items-center gap-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49e34d17f9b50791$export$32b7bd840a1eba80), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                                    iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {}),
                                    onSelect: handleEdit,
                                    children: "Edit account"
                                }),
                                !starredLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                                    iconLeft: starredIds.includes(account._id) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ac1617fbee1ebd3$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b006b04b8c21eb$export$2e2bcd8739ae039), {}),
                                    onSelect: ()=>toggleStar(account._id),
                                    children: starredIds.includes(account._id) ? 'Unstar' : 'Star'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                                    iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76d71077487353ea$export$2e2bcd8739ae039), {}),
                                    onSelect: handleMigrateTransactions,
                                    children: "Migrate transactions"
                                }),
                                !isInvestment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                                    iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {}),
                                    onSelect: handleDelete,
                                    disabled: account.transactionCount > 0,
                                    title: account.transactionCount > 0 ? 'Accounts with transactions cannot be deleted' : undefined,
                                    className: "text-destructive",
                                    children: "Delete account"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                className: "border-border flex gap-5 overflow-x-auto border-b px-4 pt-4 [scrollbar-width:none] sm:px-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$b0d92dbee9b5b60d), {
                        to: `/accounts/${account._id}`,
                        end: true,
                        className: $cf8a3466088e9562$var$tabClass,
                        children: "Overview"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$b0d92dbee9b5b60d), {
                        to: `/accounts/${account._id}/transactions`,
                        className: $cf8a3466088e9562$var$tabClass,
                        children: "Transactions"
                    }),
                    !isInvestment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$b0d92dbee9b5b60d), {
                        to: `/accounts/${account._id}/reconcile`,
                        className: $cf8a3466088e9562$var$tabClass,
                        children: "Reconcile"
                    }),
                    isInvestment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$b0d92dbee9b5b60d), {
                        to: `/accounts/${account._id}/snapshots`,
                        className: $cf8a3466088e9562$var$tabClass,
                        children: "Snapshots"
                    }),
                    isCreditCard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$b0d92dbee9b5b60d), {
                        to: `/accounts/${account._id}/benefits`,
                        className: $cf8a3466088e9562$var$tabClass,
                        children: "Benefits"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-1 flex-col overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$910ae8079b2c2852), {
                    context: outletContext
                })
            })
        ]
    });
};





parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $004783abbde551e4$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$f9ff2e983beb6b86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a7f8a2555793d7d3$exports(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
$004783abbde551e4$exports = $004783abbde551e4$var$isFunction;


/* eslint no-console: 0 */ var $0c26188443d0bc67$var$isDev = false;
var $0c26188443d0bc67$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($0c26188443d0bc67$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


var $15ee4628980e0994$exports = {};

var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $15ee4628980e0994$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $15ee4628980e0994$var$isString(value) {
    return typeof value == 'string' || !$0488fde9aa355453$exports(value) && $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $15ee4628980e0994$var$stringTag;
}
$15ee4628980e0994$exports = $15ee4628980e0994$var$isString;


var $10ed4ab35db4c025$exports = {};
var $8f2e1f7d7f8ca8b6$exports = {};


/** `Object#toString` result references. */ var $8f2e1f7d7f8ca8b6$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $8f2e1f7d7f8ca8b6$var$isNumber(value) {
    return typeof value == 'number' || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $8f2e1f7d7f8ca8b6$var$numberTag;
}
$8f2e1f7d7f8ca8b6$exports = $8f2e1f7d7f8ca8b6$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $10ed4ab35db4c025$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $8f2e1f7d7f8ca8b6$exports(value) && value != +value;
}
$10ed4ab35db4c025$exports = $10ed4ab35db4c025$var$isNaN;


var $d299ac421c05c135$exports = {};
var $fd2d90f592c63519$exports = {};
var $38afcbfab85a0553$exports = {};

var $03e9beb856e9b4cd$exports = {};

var $6b5a5095e0934938$exports = {};


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($0488fde9aa355453$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};
var $4902f64a16640324$exports = {};
var $df2cd4bc93f21548$exports = {};
var $8d50e526a9e9b7fa$exports = {};
var $80f20c637ba11563$exports = {};
var $e95343b7bf5d617b$exports = {};
var $5037fd2e597c2a03$exports = {};
var $8360225fb63098b3$exports = {};

var $5e8d211f630cd46d$exports = {};
var $baf78e1246b3b18f$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
$baf78e1246b3b18f$exports = $baf78e1246b3b18f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($baf78e1246b3b18f$exports && $baf78e1246b3b18f$exports.keys && $baf78e1246b3b18f$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
$5e8d211f630cd46d$exports = $5e8d211f630cd46d$var$isMasked;



var $9c6b3ec69362487e$exports = {};
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$9c6b3ec69362487e$exports = $9c6b3ec69362487e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$f9ff2e983beb6b86$exports(value) || $5e8d211f630cd46d$exports(value)) return false;
    var pattern = $004783abbde551e4$exports(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($9c6b3ec69362487e$exports(value));
}
$8360225fb63098b3$exports = $8360225fb63098b3$var$baseIsNative;


var $d50b255f8680c47a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d50b255f8680c47a$exports = $d50b255f8680c47a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $d50b255f8680c47a$exports(object, key);
    return $8360225fb63098b3$exports(value) ? value : undefined;
}
$5037fd2e597c2a03$exports = $5037fd2e597c2a03$var$getNative;


/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $5037fd2e597c2a03$exports(Object, 'create');
$e95343b7bf5d617b$exports = $e95343b7bf5d617b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $e95343b7bf5d617b$exports ? $e95343b7bf5d617b$exports(null) : {};
    this.size = 0;
}
$80f20c637ba11563$exports = $80f20c637ba11563$var$hashClear;


var $60a2188452e03a76$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$60a2188452e03a76$exports = $60a2188452e03a76$var$hashDelete;


var $0ade0ffa62051a98$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($e95343b7bf5d617b$exports) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$0ade0ffa62051a98$exports = $0ade0ffa62051a98$var$hashGet;


var $0d7f9677a17b6bef$exports = {};

/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $e95343b7bf5d617b$exports ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
$0d7f9677a17b6bef$exports = $0d7f9677a17b6bef$var$hashHas;


var $d33db65186b62952$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e95343b7bf5d617b$exports && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
$d33db65186b62952$exports = $d33db65186b62952$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $80f20c637ba11563$exports;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $60a2188452e03a76$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $0ade0ffa62051a98$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $0d7f9677a17b6bef$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $d33db65186b62952$exports;
$8d50e526a9e9b7fa$exports = $8d50e526a9e9b7fa$var$Hash;


var $dd14efc87ba1cd5b$exports = {};
var $83df40714bf7006e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$83df40714bf7006e$exports = $83df40714bf7006e$var$listCacheClear;


var $d22fe27824ff9351$exports = {};
var $87257b05f5d9ad81$exports = {};
var $50557587dab070a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$50557587dab070a0$exports = $50557587dab070a0$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($50557587dab070a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$87257b05f5d9ad81$exports = $87257b05f5d9ad81$var$assocIndexOf;


/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d22fe27824ff9351$exports = $d22fe27824ff9351$var$listCacheDelete;


var $b2e6263d81cdc1b3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b2e6263d81cdc1b3$exports = $b2e6263d81cdc1b3$var$listCacheGet;


var $29e2bc7b7348833e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $87257b05f5d9ad81$exports(this.__data__, key) > -1;
}
$29e2bc7b7348833e$exports = $29e2bc7b7348833e$var$listCacheHas;


var $ff9311500b60ab72$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ff9311500b60ab72$exports = $ff9311500b60ab72$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $83df40714bf7006e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $d22fe27824ff9351$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $b2e6263d81cdc1b3$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $29e2bc7b7348833e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $ff9311500b60ab72$exports;
$dd14efc87ba1cd5b$exports = $dd14efc87ba1cd5b$var$ListCache;


var $19b02faa57603249$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $5037fd2e597c2a03$exports($23YZo, 'Map');
$19b02faa57603249$exports = $19b02faa57603249$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $8d50e526a9e9b7fa$exports,
        'map': new ($19b02faa57603249$exports || $dd14efc87ba1cd5b$exports),
        'string': new $8d50e526a9e9b7fa$exports
    };
}
$df2cd4bc93f21548$exports = $df2cd4bc93f21548$var$mapCacheClear;


var $44464964ade29765$exports = {};
var $c0b23e5f03c2595b$exports = {};
var $09c4668903e66c1d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$09c4668903e66c1d$exports = $09c4668903e66c1d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $09c4668903e66c1d$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$c0b23e5f03c2595b$exports = $c0b23e5f03c2595b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $c0b23e5f03c2595b$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$44464964ade29765$exports = $44464964ade29765$var$mapCacheDelete;


var $ba80406da5503086$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $c0b23e5f03c2595b$exports(this, key).get(key);
}
$ba80406da5503086$exports = $ba80406da5503086$var$mapCacheGet;


var $d3abe18ea687dfb7$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $c0b23e5f03c2595b$exports(this, key).has(key);
}
$d3abe18ea687dfb7$exports = $d3abe18ea687dfb7$var$mapCacheHas;


var $347643e3dcfcc207$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $c0b23e5f03c2595b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$347643e3dcfcc207$exports = $347643e3dcfcc207$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $df2cd4bc93f21548$exports;
$4902f64a16640324$var$MapCache.prototype['delete'] = $44464964ade29765$exports;
$4902f64a16640324$var$MapCache.prototype.get = $ba80406da5503086$exports;
$4902f64a16640324$var$MapCache.prototype.has = $d3abe18ea687dfb7$exports;
$4902f64a16640324$var$MapCache.prototype.set = $347643e3dcfcc207$exports;
$4902f64a16640324$exports = $4902f64a16640324$var$MapCache;


/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $4902f64a16640324$exports);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $4902f64a16640324$exports;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};

var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + '';
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($0488fde9aa355453$exports(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == 'string' || $6b5a5095e0934938$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4d60aa8c33155976$var$INFINITY ? '-0' : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4d60aa8c33155976$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fd2d90f592c63519$exports = $fd2d90f592c63519$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fd2d90f592c63519$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d299ac421c05c135$exports = $d299ac421c05c135$var$get;



var $0ada68b02fed3a09$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $0ada68b02fed3a09$var$isNil(value) {
    return value == null;
}
$0ada68b02fed3a09$exports = $0ada68b02fed3a09$var$isNil;


var $2ab3a7e25c8aba74$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $2ab3a7e25c8aba74$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $2ab3a7e25c8aba74$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8f2e1f7d7f8ca8b6$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($10ed4ab35db4c025$exports)))(value);
};
var $2ab3a7e25c8aba74$export$b931b78cbb3caf86 = function isNullish(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(value);
};
var $2ab3a7e25c8aba74$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $2ab3a7e25c8aba74$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(value);
};
var $2ab3a7e25c8aba74$var$idCounter = 0;
var $2ab3a7e25c8aba74$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$2ab3a7e25c8aba74$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $2ab3a7e25c8aba74$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$2ab3a7e25c8aba74$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(percent)) return defaultValue;
    var value;
    if ($2ab3a7e25c8aba74$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($10ed4ab35db4c025$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $2ab3a7e25c8aba74$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $2ab3a7e25c8aba74$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $2ab3a7e25c8aba74$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($2ab3a7e25c8aba74$export$7e4aa119212bc614(numberA) && $2ab3a7e25c8aba74$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $2ab3a7e25c8aba74$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $2ab3a7e25c8aba74$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $2ab3a7e25c8aba74$export$6ab1df3197f7c641 = function compareValues(a, b) {
    if ($2ab3a7e25c8aba74$export$7e4aa119212bc614(a) && $2ab3a7e25c8aba74$export$7e4aa119212bc614(b)) return a - b;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(a) && (0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(b)) return a.localeCompare(b);
    if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
    return String(a).localeCompare(String(b));
};








var $acw62 = parcelRequire("acw62");
var $8e8d907dd74ba153$exports = {};
'use strict';

$8e8d907dd74ba153$exports = (parcelRequire("2ph7Y"));



function $0f60d716238978d6$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $acw62 = parcelRequire("acw62");

function $909d5f835f4e917b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $909d5f835f4e917b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $909d5f835f4e917b$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $909d5f835f4e917b$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $909d5f835f4e917b$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $909d5f835f4e917b$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $909d5f835f4e917b$export$2b22758266a6fa48 = {
    svg: $909d5f835f4e917b$var$SVGContainerPropKeys,
    polygon: $909d5f835f4e917b$var$PolyElementKeys,
    polyline: $909d5f835f4e917b$var$PolyElementKeys
};
var $909d5f835f4e917b$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $909d5f835f4e917b$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($909d5f835f4e917b$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $909d5f835f4e917b$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $909d5f835f4e917b$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(props) || $909d5f835f4e917b$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($909d5f835f4e917b$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $909d5f835f4e917b$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $008f02516c156322$var$_excluded = [
    "children"
], $008f02516c156322$var$_excluded2 = [
    "children"
];
function $008f02516c156322$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $008f02516c156322$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $008f02516c156322$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $008f02516c156322$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $008f02516c156322$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $008f02516c156322$var$_typeof(o);
}
var $008f02516c156322$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart',
    contextmenu: 'onContextMenu',
    dblclick: 'onDoubleClick'
};
var $008f02516c156322$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $008f02516c156322$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $008f02516c156322$export$59a4d7d024cf1025 = [
    'none'
];
var $008f02516c156322$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $008f02516c156322$var$lastChildren = null;
var $008f02516c156322$var$lastResult = null;
var $008f02516c156322$export$45b10814cc054894 = function toArray(children) {
    if (children === $008f02516c156322$var$lastChildren && Array.isArray($008f02516c156322$var$lastResult)) return $008f02516c156322$var$lastResult;
    var result = [];
    (0, $acw62.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(child)) return;
        if ((0, $8e8d907dd74ba153$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $008f02516c156322$var$lastResult = result;
    $008f02516c156322$var$lastChildren = children;
    return result;
};
function $008f02516c156322$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $008f02516c156322$export$be63e0664592e141(t);
    });
    else types = [
        $008f02516c156322$export$be63e0664592e141(type)
    ];
    $008f02516c156322$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $008f02516c156322$export$64c61536a2b72e0f(children, type) {
    var result = $008f02516c156322$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $008f02516c156322$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $008f02516c156322$export$be63e0664592e141(t);
    });
    else types = [
        $008f02516c156322$export$be63e0664592e141(type)
    ];
    $008f02516c156322$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $008f02516c156322$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $008f02516c156322$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $008f02516c156322$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(child.type) && $008f02516c156322$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $008f02516c156322$export$392f6c9701718a4e = function hasClipDot(dot) {
    return dot && $008f02516c156322$var$_typeof(dot) === 'object' && 'clipDot' in dot;
};
var $008f02516c156322$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $909d5f835f4e917b$export$2b22758266a6fa48) === null || (0, $909d5f835f4e917b$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $909d5f835f4e917b$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return key.startsWith('data-') || !(0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $909d5f835f4e917b$export$190f430946f96110).includes(key)) || includeEvents && (0, $909d5f835f4e917b$export$f30789245f2c4d11).includes(key);
};
var $008f02516c156322$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $008f02516c156322$export$45b10814cc054894(children).forEach(function(entry) {
        if ($008f02516c156322$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $008f02516c156322$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($008f02516c156322$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $008f02516c156322$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $acw62.Children).count(nextChildren);
    if (count !== (0, $acw62.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $008f02516c156322$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$008f02516c156322$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $008f02516c156322$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $008f02516c156322$var$_objectWithoutProperties(_ref, $008f02516c156322$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $008f02516c156322$var$_objectWithoutProperties(_ref2, $008f02516c156322$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $0f60d716238978d6$export$d36bdfa510afb180)(nextProps, prevProps) && $008f02516c156322$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $0f60d716238978d6$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $008f02516c156322$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $008f02516c156322$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($008f02516c156322$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $008f02516c156322$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $008f02516c156322$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $008f02516c156322$var$REACT_BROWSER_EVENT_MAP[type]) return $008f02516c156322$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $008f02516c156322$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $008f02516c156322$export$45b10814cc054894(children).indexOf(child);
};


var $d8f008d3b0c1a5c3$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$d8f008d3b0c1a5c3$exports = (parcelRequire("eTYpT"));


var $9b23116271105198$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$9b23116271105198$exports = (parcelRequire("CKTDO"));


var $7d231ba5a67a42db$exports = {};
var $c032706da200ef36$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $c032706da200ef36$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$6b5a5095e0934938$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$c032706da200ef36$exports = $c032706da200ef36$var$baseExtremum;


var $da4e1fe5f8bd1939$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $da4e1fe5f8bd1939$var$baseGt(value, other) {
    return value > other;
}
$da4e1fe5f8bd1939$exports = $da4e1fe5f8bd1939$var$baseGt;


var $37dff9aa04444f9c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
$37dff9aa04444f9c$exports = $37dff9aa04444f9c$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $7d231ba5a67a42db$var$max(array) {
    return array && array.length ? $c032706da200ef36$exports(array, $37dff9aa04444f9c$exports, $da4e1fe5f8bd1939$exports) : undefined;
}
$7d231ba5a67a42db$exports = $7d231ba5a67a42db$var$max;


var $2c30ec7848ba160d$exports = {};

var $cdf01b2c29e1be9c$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $cdf01b2c29e1be9c$var$baseLt(value, other) {
    return value < other;
}
$cdf01b2c29e1be9c$exports = $cdf01b2c29e1be9c$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $2c30ec7848ba160d$var$min(array) {
    return array && array.length ? $c032706da200ef36$exports(array, $37dff9aa04444f9c$exports, $cdf01b2c29e1be9c$exports) : undefined;
}
$2c30ec7848ba160d$exports = $2c30ec7848ba160d$var$min;






var $1cb7998639d45551$exports = {};
var $b1d5985487d54dea$exports = {};
var $cc77dbb7c08db6a8$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$cc77dbb7c08db6a8$exports = $cc77dbb7c08db6a8$var$arrayPush;


var $035bd928078475ee$exports = {};

var $7d0c6fd0eb26be0e$exports = {};
var $fb8f823cdc90f511$exports = {};


/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $fb8f823cdc90f511$var$argsTag;
}
$fb8f823cdc90f511$exports = $fb8f823cdc90f511$var$baseIsArguments;



/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $fb8f823cdc90f511$exports(function() {
    return arguments;
}()) ? $fb8f823cdc90f511$exports : function(value) {
    return $61269cf1f3e020be$exports(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
$7d0c6fd0eb26be0e$exports = $7d0c6fd0eb26be0e$var$isArguments;



/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $0488fde9aa355453$exports(value) || $7d0c6fd0eb26be0e$exports(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
$035bd928078475ee$exports = $035bd928078475ee$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $035bd928078475ee$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $cc77dbb7c08db6a8$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$b1d5985487d54dea$exports = $b1d5985487d54dea$var$baseFlatten;


var $2f2d1bf022ac3e3d$exports = {};

var $5aba4f6d9f8304a3$exports = {};
var $e780807e2b795134$exports = {};
var $ec073f38db6e7d54$exports = {};
var $bbb2d98cae25b61a$exports = {};

var $e8ee1d354807980a$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $dd14efc87ba1cd5b$exports;
    this.size = 0;
}
$e8ee1d354807980a$exports = $e8ee1d354807980a$var$stackClear;


var $b2ddb9d63293f3a5$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$b2ddb9d63293f3a5$exports = $b2ddb9d63293f3a5$var$stackDelete;


var $80d0940a423a17dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$80d0940a423a17dc$exports = $80d0940a423a17dc$var$stackGet;


var $010f38d5d914cfa2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
$010f38d5d914cfa2$exports = $010f38d5d914cfa2$var$stackHas;


var $9280d00f89f25fa9$exports = {};



/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $dd14efc87ba1cd5b$exports) {
        var pairs = data.__data__;
        if (!$19b02faa57603249$exports || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4902f64a16640324$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9280d00f89f25fa9$exports = $9280d00f89f25fa9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $dd14efc87ba1cd5b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $e8ee1d354807980a$exports;
$bbb2d98cae25b61a$var$Stack.prototype['delete'] = $b2ddb9d63293f3a5$exports;
$bbb2d98cae25b61a$var$Stack.prototype.get = $80d0940a423a17dc$exports;
$bbb2d98cae25b61a$var$Stack.prototype.has = $010f38d5d914cfa2$exports;
$bbb2d98cae25b61a$var$Stack.prototype.set = $9280d00f89f25fa9$exports;
$bbb2d98cae25b61a$exports = $bbb2d98cae25b61a$var$Stack;


var $769812b29c18141e$exports = {};
var $567f2dd161ebd4f6$exports = {};

var $1081bd3a2e361911$exports = {};
var $a29ccdc0f60e279e$exports = {};

var $dda8f7b6b589544e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
$dda8f7b6b589544e$exports = $dda8f7b6b589544e$var$setCacheAdd;


var $66732c92c350622c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$66732c92c350622c$exports = $66732c92c350622c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4902f64a16640324$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $dda8f7b6b589544e$exports;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $66732c92c350622c$exports;
$a29ccdc0f60e279e$exports = $a29ccdc0f60e279e$var$SetCache;


var $aae24ad60cc3cfcb$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$aae24ad60cc3cfcb$exports = $aae24ad60cc3cfcb$var$arraySome;


var $1b44096ad4b9e2d5$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
$1b44096ad4b9e2d5$exports = $1b44096ad4b9e2d5$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $a29ccdc0f60e279e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$aae24ad60cc3cfcb$exports(other, function(othValue, othIndex) {
                if (!$1b44096ad4b9e2d5$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$1081bd3a2e361911$exports = $1081bd3a2e361911$var$equalArrays;


var $baf52b9e146f3da7$exports = {};

var $facf83d1449a27b8$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
$facf83d1449a27b8$exports = $facf83d1449a27b8$var$Uint8Array;




var $91d4444cbb077e0c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$91d4444cbb077e0c$exports = $91d4444cbb077e0c$var$mapToArray;


var $11f509f8f53d8c36$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11f509f8f53d8c36$exports = $11f509f8f53d8c36$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = '[object Boolean]', $baf52b9e146f3da7$var$dateTag = '[object Date]', $baf52b9e146f3da7$var$errorTag = '[object Error]', $baf52b9e146f3da7$var$mapTag = '[object Map]', $baf52b9e146f3da7$var$numberTag = '[object Number]', $baf52b9e146f3da7$var$regexpTag = '[object RegExp]', $baf52b9e146f3da7$var$setTag = '[object Set]', $baf52b9e146f3da7$var$stringTag = '[object String]', $baf52b9e146f3da7$var$symbolTag = '[object Symbol]';
var $baf52b9e146f3da7$var$arrayBufferTag = '[object ArrayBuffer]', $baf52b9e146f3da7$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $facf83d1449a27b8$exports(object), new $facf83d1449a27b8$exports(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $50557587dab070a0$exports(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $91d4444cbb077e0c$exports;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11f509f8f53d8c36$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1081bd3a2e361911$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
$baf52b9e146f3da7$exports = $baf52b9e146f3da7$var$equalByTag;


var $ac8a81cbae0357e8$exports = {};
var $7958eecccfe4cef6$exports = {};
var $9144d49da7a47a72$exports = {};


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0488fde9aa355453$exports(object) ? result : $cc77dbb7c08db6a8$exports(result, symbolsFunc(object));
}
$9144d49da7a47a72$exports = $9144d49da7a47a72$var$baseGetAllKeys;


var $51326a29f571e7cd$exports = {};
var $6549fed720324048$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$6549fed720324048$exports = $6549fed720324048$var$arrayFilter;


var $8fc9f7df9b0c06bb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
$8fc9f7df9b0c06bb$exports = $8fc9f7df9b0c06bb$var$stubArray;


/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $8fc9f7df9b0c06bb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $6549fed720324048$exports($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
$51326a29f571e7cd$exports = $51326a29f571e7cd$var$getSymbols;


var $08f0eaf3fbcb2fde$exports = {};
var $64568844439edb7f$exports = {};
var $b14d62a510ae7f2d$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$b14d62a510ae7f2d$exports = $b14d62a510ae7f2d$var$baseTimes;





var $f504n = parcelRequire("f504n");
var $d83738e053b5eb08$exports = {};
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d83738e053b5eb08$exports = $d83738e053b5eb08$var$isIndex;


var $156c3727697ab085$exports = {};
var $9d076681a0e29d68$exports = {};

var $15d215b19bcf1187$exports = {};
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
$15d215b19bcf1187$exports = $15d215b19bcf1187$var$isLength;



/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = '[object Arguments]', $9d076681a0e29d68$var$arrayTag = '[object Array]', $9d076681a0e29d68$var$boolTag = '[object Boolean]', $9d076681a0e29d68$var$dateTag = '[object Date]', $9d076681a0e29d68$var$errorTag = '[object Error]', $9d076681a0e29d68$var$funcTag = '[object Function]', $9d076681a0e29d68$var$mapTag = '[object Map]', $9d076681a0e29d68$var$numberTag = '[object Number]', $9d076681a0e29d68$var$objectTag = '[object Object]', $9d076681a0e29d68$var$regexpTag = '[object RegExp]', $9d076681a0e29d68$var$setTag = '[object Set]', $9d076681a0e29d68$var$stringTag = '[object String]', $9d076681a0e29d68$var$weakMapTag = '[object WeakMap]';
var $9d076681a0e29d68$var$arrayBufferTag = '[object ArrayBuffer]', $9d076681a0e29d68$var$dataViewTag = '[object DataView]', $9d076681a0e29d68$var$float32Tag = '[object Float32Array]', $9d076681a0e29d68$var$float64Tag = '[object Float64Array]', $9d076681a0e29d68$var$int8Tag = '[object Int8Array]', $9d076681a0e29d68$var$int16Tag = '[object Int16Array]', $9d076681a0e29d68$var$int32Tag = '[object Int32Array]', $9d076681a0e29d68$var$uint8Tag = '[object Uint8Array]', $9d076681a0e29d68$var$uint8ClampedTag = '[object Uint8ClampedArray]', $9d076681a0e29d68$var$uint16Tag = '[object Uint16Array]', $9d076681a0e29d68$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $61269cf1f3e020be$exports(value) && $15d215b19bcf1187$exports(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$a7f8a2555793d7d3$exports(value)];
}
$9d076681a0e29d68$exports = $9d076681a0e29d68$var$baseIsTypedArray;


var $692cb5474f422969$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$692cb5474f422969$exports = $692cb5474f422969$var$baseUnary;



var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $692cb5474f422969$exports($156c3727697ab085$var$nodeIsTypedArray) : $9d076681a0e29d68$exports;
$156c3727697ab085$exports = $156c3727697ab085$var$isTypedArray;


/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $0488fde9aa355453$exports(value), isArg = !isArr && $7d0c6fd0eb26be0e$exports(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $156c3727697ab085$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $b14d62a510ae7f2d$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $d83738e053b5eb08$exports(key, length)))) result.push(key);
    return result;
}
$64568844439edb7f$exports = $64568844439edb7f$var$arrayLikeKeys;


var $e811d2e210fb58cc$exports = {};
var $292432068be14a79$exports = {};
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
$292432068be14a79$exports = $292432068be14a79$var$isPrototype;


var $0b26005314403d97$exports = {};
var $ff813e49bf3cca3d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ff813e49bf3cca3d$exports = $ff813e49bf3cca3d$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $ff813e49bf3cca3d$exports(Object.keys, Object);
$0b26005314403d97$exports = $0b26005314403d97$var$nativeKeys;


/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$292432068be14a79$exports(object)) return $0b26005314403d97$exports(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$e811d2e210fb58cc$exports = $e811d2e210fb58cc$var$baseKeys;


var $ac2c42592aa05543$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $15d215b19bcf1187$exports(value.length) && !$004783abbde551e4$exports(value);
}
$ac2c42592aa05543$exports = $ac2c42592aa05543$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $ac2c42592aa05543$exports(object) ? $64568844439edb7f$exports(object) : $e811d2e210fb58cc$exports(object);
}
$08f0eaf3fbcb2fde$exports = $08f0eaf3fbcb2fde$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $9144d49da7a47a72$exports(object, $08f0eaf3fbcb2fde$exports, $51326a29f571e7cd$exports);
}
$7958eecccfe4cef6$exports = $7958eecccfe4cef6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $7958eecccfe4cef6$exports(object), objLength = objProps.length, othProps = $7958eecccfe4cef6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$ac8a81cbae0357e8$exports = $ac8a81cbae0357e8$var$equalObjects;


var $474f685f496bfe31$exports = {};
var $41ce0ff3b38ee753$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $5037fd2e597c2a03$exports($23YZo, 'DataView');
$41ce0ff3b38ee753$exports = $41ce0ff3b38ee753$var$DataView;



var $b0226bdea11cb834$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $5037fd2e597c2a03$exports($23YZo, 'Promise');
$b0226bdea11cb834$exports = $b0226bdea11cb834$var$Promise;


var $05f44e958da968eb$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $5037fd2e597c2a03$exports($23YZo, 'Set');
$05f44e958da968eb$exports = $05f44e958da968eb$var$Set;


var $aedce50092a1e6a6$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $5037fd2e597c2a03$exports($23YZo, 'WeakMap');
$aedce50092a1e6a6$exports = $aedce50092a1e6a6$var$WeakMap;




/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = '[object Map]', $474f685f496bfe31$var$objectTag = '[object Object]', $474f685f496bfe31$var$promiseTag = '[object Promise]', $474f685f496bfe31$var$setTag = '[object Set]', $474f685f496bfe31$var$weakMapTag = '[object WeakMap]';
var $474f685f496bfe31$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $9c6b3ec69362487e$exports($41ce0ff3b38ee753$exports), $474f685f496bfe31$var$mapCtorString = $9c6b3ec69362487e$exports($19b02faa57603249$exports), $474f685f496bfe31$var$promiseCtorString = $9c6b3ec69362487e$exports($b0226bdea11cb834$exports), $474f685f496bfe31$var$setCtorString = $9c6b3ec69362487e$exports($05f44e958da968eb$exports), $474f685f496bfe31$var$weakMapCtorString = $9c6b3ec69362487e$exports($aedce50092a1e6a6$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $a7f8a2555793d7d3$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($41ce0ff3b38ee753$exports && $474f685f496bfe31$var$getTag(new $41ce0ff3b38ee753$exports(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $19b02faa57603249$exports && $474f685f496bfe31$var$getTag(new $19b02faa57603249$exports) != $474f685f496bfe31$var$mapTag || $b0226bdea11cb834$exports && $474f685f496bfe31$var$getTag($b0226bdea11cb834$exports.resolve()) != $474f685f496bfe31$var$promiseTag || $05f44e958da968eb$exports && $474f685f496bfe31$var$getTag(new $05f44e958da968eb$exports) != $474f685f496bfe31$var$setTag || $aedce50092a1e6a6$exports && $474f685f496bfe31$var$getTag(new $aedce50092a1e6a6$exports) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $a7f8a2555793d7d3$exports(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9c6b3ec69362487e$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
$474f685f496bfe31$exports = $474f685f496bfe31$var$getTag;




var $f504n = parcelRequire("f504n");

/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = '[object Arguments]', $567f2dd161ebd4f6$var$arrayTag = '[object Array]', $567f2dd161ebd4f6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0488fde9aa355453$exports(object), othIsArr = $0488fde9aa355453$exports(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bbb2d98cae25b61a$exports);
        return objIsArr || $156c3727697ab085$exports(object) ? $1081bd3a2e361911$exports(object, other, bitmask, customizer, equalFunc, stack) : $baf52b9e146f3da7$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bbb2d98cae25b61a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bbb2d98cae25b61a$exports);
    return $ac8a81cbae0357e8$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$567f2dd161ebd4f6$exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$61269cf1f3e020be$exports(value) && !$61269cf1f3e020be$exports(other)) return value !== value && other !== other;
    return $567f2dd161ebd4f6$exports(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
$769812b29c18141e$exports = $769812b29c18141e$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bbb2d98cae25b61a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $769812b29c18141e$exports(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$ec073f38db6e7d54$exports = $ec073f38db6e7d54$var$baseIsMatch;


var $6b4f84f6be7f825c$exports = {};
var $0ff8edf4f90a7955$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$f9ff2e983beb6b86$exports(value);
}
$0ff8edf4f90a7955$exports = $0ff8edf4f90a7955$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $08f0eaf3fbcb2fde$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $0ff8edf4f90a7955$exports(value)
        ];
    }
    return result;
}
$6b4f84f6be7f825c$exports = $6b4f84f6be7f825c$var$getMatchData;


var $1f9d5e891556ddb9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1f9d5e891556ddb9$exports = $1f9d5e891556ddb9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $6b4f84f6be7f825c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1f9d5e891556ddb9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $ec073f38db6e7d54$exports(object, source, matchData);
    };
}
$e780807e2b795134$exports = $e780807e2b795134$var$baseMatches;


var $d5fe8a98fe4800eb$exports = {};


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;


var $85aaea8f77d790ae$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4d60aa8c33155976$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $15d215b19bcf1187$exports(length) && $d83738e053b5eb08$exports(key, length) && ($0488fde9aa355453$exports(object) || $7d0c6fd0eb26be0e$exports(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($03e9beb856e9b4cd$exports(path) && $0ff8edf4f90a7955$exports(srcValue)) return $1f9d5e891556ddb9$exports($4d60aa8c33155976$exports(path), srcValue);
    return function(object) {
        var objValue = $d299ac421c05c135$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $221e04e57e35dd04$exports(object, path) : $769812b29c18141e$exports(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
$d5fe8a98fe4800eb$exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;




var $87123e72266aa58c$exports = {};
var $d45a621b4548f6bb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$d45a621b4548f6bb$exports = $d45a621b4548f6bb$var$baseProperty;


var $e029d02f9dd10368$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $fd2d90f592c63519$exports(object, path);
    };
}
$e029d02f9dd10368$exports = $e029d02f9dd10368$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $03e9beb856e9b4cd$exports(path) ? $d45a621b4548f6bb$exports($4d60aa8c33155976$exports(path)) : $e029d02f9dd10368$exports(path);
}
$87123e72266aa58c$exports = $87123e72266aa58c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $37dff9aa04444f9c$exports;
    if (typeof value == 'object') return $0488fde9aa355453$exports(value) ? $d5fe8a98fe4800eb$exports(value[0], value[1]) : $e780807e2b795134$exports(value);
    return $87123e72266aa58c$exports(value);
}
$5aba4f6d9f8304a3$exports = $5aba4f6d9f8304a3$var$baseIteratee;


var $b613e194c1b157de$exports = {};
var $35fa3296f177aa01$exports = {};
var $34edfba366a0cfa1$exports = {};
var $9f0778b809a8c692$exports = {};
var $e7bbde6376f4568a$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e7bbde6376f4568a$exports = $e7bbde6376f4568a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $e7bbde6376f4568a$exports();
$9f0778b809a8c692$exports = $9f0778b809a8c692$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $9f0778b809a8c692$exports(object, iteratee, $08f0eaf3fbcb2fde$exports);
}
$34edfba366a0cfa1$exports = $34edfba366a0cfa1$var$baseForOwn;


var $f03eae3721f9ace8$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$ac2c42592aa05543$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$f03eae3721f9ace8$exports = $f03eae3721f9ace8$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $f03eae3721f9ace8$exports($34edfba366a0cfa1$exports);
$35fa3296f177aa01$exports = $35fa3296f177aa01$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $ac2c42592aa05543$exports(collection) ? Array(collection.length) : [];
    $35fa3296f177aa01$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$b613e194c1b157de$exports = $b613e194c1b157de$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $2f2d1bf022ac3e3d$var$map(collection, iteratee) {
    var func = $0488fde9aa355453$exports(collection) ? $d26d80da1ba3948c$exports : $b613e194c1b157de$exports;
    return func(collection, $5aba4f6d9f8304a3$exports(iteratee, 3));
}
$2f2d1bf022ac3e3d$exports = $2f2d1bf022ac3e3d$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $1cb7998639d45551$var$flatMap(collection, iteratee) {
    return $b1d5985487d54dea$exports($2f2d1bf022ac3e3d$exports(collection, iteratee), 1);
}
$1cb7998639d45551$exports = $1cb7998639d45551$var$flatMap;



var $da6130e1e4702e32$exports = {};
var $0d9811a54a2f955a$exports = {};
var $cfe77c1a7b7c7d6e$exports = {};
var $109fb88fe59de104$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$109fb88fe59de104$exports = $109fb88fe59de104$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cfe77c1a7b7c7d6e$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $109fb88fe59de104$exports(array, start, end);
}
$cfe77c1a7b7c7d6e$exports = $cfe77c1a7b7c7d6e$var$castSlice;


var $00fdf7eab00be2e7$exports = {};
/** Used to compose unicode character classes. */ var $00fdf7eab00be2e7$var$rsAstralRange = '\\ud800-\\udfff', $00fdf7eab00be2e7$var$rsComboMarksRange = '\\u0300-\\u036f', $00fdf7eab00be2e7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $00fdf7eab00be2e7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $00fdf7eab00be2e7$var$rsComboRange = $00fdf7eab00be2e7$var$rsComboMarksRange + $00fdf7eab00be2e7$var$reComboHalfMarksRange + $00fdf7eab00be2e7$var$rsComboSymbolsRange, $00fdf7eab00be2e7$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $00fdf7eab00be2e7$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $00fdf7eab00be2e7$var$reHasUnicode = RegExp('[' + $00fdf7eab00be2e7$var$rsZWJ + $00fdf7eab00be2e7$var$rsAstralRange + $00fdf7eab00be2e7$var$rsComboRange + $00fdf7eab00be2e7$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $00fdf7eab00be2e7$var$hasUnicode(string) {
    return $00fdf7eab00be2e7$var$reHasUnicode.test(string);
}
$00fdf7eab00be2e7$exports = $00fdf7eab00be2e7$var$hasUnicode;


var $9a986c87d425808c$exports = {};
var $43b96a6d93895c83$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $43b96a6d93895c83$var$asciiToArray(string) {
    return string.split('');
}
$43b96a6d93895c83$exports = $43b96a6d93895c83$var$asciiToArray;



var $c3bf9ebcb1b53b1d$exports = {};
/** Used to compose unicode character classes. */ var $c3bf9ebcb1b53b1d$var$rsAstralRange = '\\ud800-\\udfff', $c3bf9ebcb1b53b1d$var$rsComboMarksRange = '\\u0300-\\u036f', $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $c3bf9ebcb1b53b1d$var$rsComboRange = $c3bf9ebcb1b53b1d$var$rsComboMarksRange + $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange + $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange, $c3bf9ebcb1b53b1d$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $c3bf9ebcb1b53b1d$var$rsAstral = '[' + $c3bf9ebcb1b53b1d$var$rsAstralRange + ']', $c3bf9ebcb1b53b1d$var$rsCombo = '[' + $c3bf9ebcb1b53b1d$var$rsComboRange + ']', $c3bf9ebcb1b53b1d$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $c3bf9ebcb1b53b1d$var$rsModifier = '(?:' + $c3bf9ebcb1b53b1d$var$rsCombo + '|' + $c3bf9ebcb1b53b1d$var$rsFitz + ')', $c3bf9ebcb1b53b1d$var$rsNonAstral = '[^' + $c3bf9ebcb1b53b1d$var$rsAstralRange + ']', $c3bf9ebcb1b53b1d$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $c3bf9ebcb1b53b1d$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $c3bf9ebcb1b53b1d$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $c3bf9ebcb1b53b1d$var$reOptMod = $c3bf9ebcb1b53b1d$var$rsModifier + '?', $c3bf9ebcb1b53b1d$var$rsOptVar = '[' + $c3bf9ebcb1b53b1d$var$rsVarRange + ']?', $c3bf9ebcb1b53b1d$var$rsOptJoin = '(?:' + $c3bf9ebcb1b53b1d$var$rsZWJ + '(?:' + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair
].join('|') + ')' + $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + ')*', $c3bf9ebcb1b53b1d$var$rsSeq = $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + $c3bf9ebcb1b53b1d$var$rsOptJoin, $c3bf9ebcb1b53b1d$var$rsSymbol = '(?:' + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral + $c3bf9ebcb1b53b1d$var$rsCombo + '?',
    $c3bf9ebcb1b53b1d$var$rsCombo,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair,
    $c3bf9ebcb1b53b1d$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $c3bf9ebcb1b53b1d$var$reUnicode = RegExp($c3bf9ebcb1b53b1d$var$rsFitz + '(?=' + $c3bf9ebcb1b53b1d$var$rsFitz + ')|' + $c3bf9ebcb1b53b1d$var$rsSymbol + $c3bf9ebcb1b53b1d$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c3bf9ebcb1b53b1d$var$unicodeToArray(string) {
    return string.match($c3bf9ebcb1b53b1d$var$reUnicode) || [];
}
$c3bf9ebcb1b53b1d$exports = $c3bf9ebcb1b53b1d$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9a986c87d425808c$var$stringToArray(string) {
    return $00fdf7eab00be2e7$exports(string) ? $c3bf9ebcb1b53b1d$exports(string) : $43b96a6d93895c83$exports(string);
}
$9a986c87d425808c$exports = $9a986c87d425808c$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $0d9811a54a2f955a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $f5d9385a9cc7e413$exports(string);
        var strSymbols = $00fdf7eab00be2e7$exports(string) ? $9a986c87d425808c$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $cfe77c1a7b7c7d6e$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$0d9811a54a2f955a$exports = $0d9811a54a2f955a$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $da6130e1e4702e32$var$upperFirst = $0d9811a54a2f955a$exports('toUpperCase');
$da6130e1e4702e32$exports = $da6130e1e4702e32$var$upperFirst;


var $394ab417e9bd75cc$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $394ab417e9bd75cc$var$isEqual(value, other) {
    return $769812b29c18141e$exports(value, other);
}
$394ab417e9bd75cc$exports = $394ab417e9bd75cc$var$isEqual;


var $300ea168693086c2$exports = {};

var $e277a64de4eeade6$exports = {};




var $6f370ce7a904568e$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $6f370ce7a904568e$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$6f370ce7a904568e$exports = $6f370ce7a904568e$var$baseSortBy;



var $b53b4bd61680c3b6$exports = {};
var $13e53edf809f77b7$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $13e53edf809f77b7$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $6b5a5095e0934938$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $6b5a5095e0934938$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$13e53edf809f77b7$exports = $13e53edf809f77b7$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b53b4bd61680c3b6$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $13e53edf809f77b7$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$b53b4bd61680c3b6$exports = $b53b4bd61680c3b6$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e277a64de4eeade6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $d26d80da1ba3948c$exports(iteratees, function(iteratee) {
        if ($0488fde9aa355453$exports(iteratee)) return function(value) {
            return $fd2d90f592c63519$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $37dff9aa04444f9c$exports
    ];
    var index = -1;
    iteratees = $d26d80da1ba3948c$exports(iteratees, $692cb5474f422969$exports($5aba4f6d9f8304a3$exports));
    var result = $b613e194c1b157de$exports(collection, function(value, key, collection) {
        var criteria = $d26d80da1ba3948c$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $6f370ce7a904568e$exports(result, function(object, other) {
        return $b53b4bd61680c3b6$exports(object, other, orders);
    });
}
$e277a64de4eeade6$exports = $e277a64de4eeade6$var$baseOrderBy;


var $3db9ad8fe1351fef$exports = {};

var $81a5758ee0248452$exports = {};
var $e22d8f7aab4ea8e2$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$e22d8f7aab4ea8e2$exports = $e22d8f7aab4ea8e2$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $e22d8f7aab4ea8e2$exports(func, this, otherArgs);
    };
}
$81a5758ee0248452$exports = $81a5758ee0248452$var$overRest;


var $d9b21a2cad7f96c2$exports = {};
var $1dca5cc74bf5ffaf$exports = {};
var $7111863c3c692f0e$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
$7111863c3c692f0e$exports = $7111863c3c692f0e$var$constant;


var $31e24313ace94404$exports = {};

var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $5037fd2e597c2a03$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$31e24313ace94404$exports = $31e24313ace94404$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$31e24313ace94404$exports ? $37dff9aa04444f9c$exports : function(func, string) {
    return $31e24313ace94404$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $7111863c3c692f0e$exports(string),
        'writable': true
    });
};
$1dca5cc74bf5ffaf$exports = $1dca5cc74bf5ffaf$var$baseSetToString;


var $5c7bd4e931ae22e5$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$5c7bd4e931ae22e5$exports = $5c7bd4e931ae22e5$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $5c7bd4e931ae22e5$exports($1dca5cc74bf5ffaf$exports);
$d9b21a2cad7f96c2$exports = $d9b21a2cad7f96c2$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3db9ad8fe1351fef$var$baseRest(func, start) {
    return $d9b21a2cad7f96c2$exports($81a5758ee0248452$exports(func, start, $37dff9aa04444f9c$exports), func + '');
}
$3db9ad8fe1351fef$exports = $3db9ad8fe1351fef$var$baseRest;


var $81b21e8b41d211e8$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $81b21e8b41d211e8$var$isIterateeCall(value, index, object) {
    if (!$f9ff2e983beb6b86$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $ac2c42592aa05543$exports(object) && $d83738e053b5eb08$exports(index, object.length) : type == 'string' && index in object) return $50557587dab070a0$exports(object[index], value);
    return false;
}
$81b21e8b41d211e8$exports = $81b21e8b41d211e8$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $300ea168693086c2$var$sortBy = $3db9ad8fe1351fef$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $81b21e8b41d211e8$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $81b21e8b41d211e8$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $e277a64de4eeade6$exports(collection, $b1d5985487d54dea$exports(iteratees, 1), []);
});
$300ea168693086c2$exports = $300ea168693086c2$var$sortBy;


var $150bb5f05cbd0a1e$exports = {};
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if ($150bb5f05cbd0a1e$exports) $150bb5f05cbd0a1e$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($150bb5f05cbd0a1e$exports);


function $c7a5592297cca14c$var$_toConsumableArray(arr) {
    return $c7a5592297cca14c$var$_arrayWithoutHoles(arr) || $c7a5592297cca14c$var$_iterableToArray(arr) || $c7a5592297cca14c$var$_unsupportedIterableToArray(arr) || $c7a5592297cca14c$var$_nonIterableSpread();
}
function $c7a5592297cca14c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c7a5592297cca14c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c7a5592297cca14c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c7a5592297cca14c$var$_arrayLikeToArray(o, minLen);
}
function $c7a5592297cca14c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $c7a5592297cca14c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c7a5592297cca14c$var$_arrayLikeToArray(arr);
}
function $c7a5592297cca14c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $c7a5592297cca14c$var$identity = function identity(i) {
    return i;
};
var $c7a5592297cca14c$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $c7a5592297cca14c$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $c7a5592297cca14c$export$ca73b6d700d0505;
};
var $c7a5592297cca14c$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $c7a5592297cca14c$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $c7a5592297cca14c$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $c7a5592297cca14c$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $c7a5592297cca14c$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $c7a5592297cca14c$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $c7a5592297cca14c$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $c7a5592297cca14c$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $c7a5592297cca14c$export$c3095a23b368d1f2 = function curry(fn) {
    return $c7a5592297cca14c$var$curryN(fn.length, fn);
};
var $c7a5592297cca14c$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $c7a5592297cca14c$export$871de8747c9eaa88 = $c7a5592297cca14c$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $c7a5592297cca14c$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $c7a5592297cca14c$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $c7a5592297cca14c$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $c7a5592297cca14c$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $7df23a93099ed3d6$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $7df23a93099ed3d6$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $7df23a93099ed3d6$var$interpolateNumber = (0, $c7a5592297cca14c$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $7df23a93099ed3d6$var$uninterpolateNumber = (0, $c7a5592297cca14c$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $7df23a93099ed3d6$var$uninterpolateTruncation = (0, $c7a5592297cca14c$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $7df23a93099ed3d6$export$2e2bcd8739ae039 = {
    rangeStep: $7df23a93099ed3d6$var$rangeStep,
    getDigitCount: $7df23a93099ed3d6$var$getDigitCount,
    interpolateNumber: $7df23a93099ed3d6$var$interpolateNumber,
    uninterpolateNumber: $7df23a93099ed3d6$var$uninterpolateNumber,
    uninterpolateTruncation: $7df23a93099ed3d6$var$uninterpolateTruncation
};


function $83976b3dea6872a0$var$_toConsumableArray(arr) {
    return $83976b3dea6872a0$var$_arrayWithoutHoles(arr) || $83976b3dea6872a0$var$_iterableToArray(arr) || $83976b3dea6872a0$var$_unsupportedIterableToArray(arr) || $83976b3dea6872a0$var$_nonIterableSpread();
}
function $83976b3dea6872a0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $83976b3dea6872a0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $83976b3dea6872a0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $83976b3dea6872a0$var$_arrayLikeToArray(arr);
}
function $83976b3dea6872a0$var$_slicedToArray(arr, i) {
    return $83976b3dea6872a0$var$_arrayWithHoles(arr) || $83976b3dea6872a0$var$_iterableToArrayLimit(arr, i) || $83976b3dea6872a0$var$_unsupportedIterableToArray(arr, i) || $83976b3dea6872a0$var$_nonIterableRest();
}
function $83976b3dea6872a0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $83976b3dea6872a0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $83976b3dea6872a0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $83976b3dea6872a0$var$_arrayLikeToArray(o, minLen);
}
function $83976b3dea6872a0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $83976b3dea6872a0$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $83976b3dea6872a0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $83976b3dea6872a0$var$getValidInterval(_ref) {
    var _ref2 = $83976b3dea6872a0$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $83976b3dea6872a0$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0);
    var digitCount = (0, $7df23a93099ed3d6$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $83976b3dea6872a0$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(10).pow((0, $7df23a93099ed3d6$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $c7a5592297cca14c$export$f672e0b6f7222cd7)((0, $c7a5592297cca14c$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $c7a5592297cca14c$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $83976b3dea6872a0$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $83976b3dea6872a0$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $83976b3dea6872a0$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $83976b3dea6872a0$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $83976b3dea6872a0$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $83976b3dea6872a0$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $83976b3dea6872a0$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($83976b3dea6872a0$var$_toConsumableArray((0, $c7a5592297cca14c$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($83976b3dea6872a0$var$_toConsumableArray((0, $c7a5592297cca14c$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $c7a5592297cca14c$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $83976b3dea6872a0$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $83976b3dea6872a0$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $7df23a93099ed3d6$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $c7a5592297cca14c$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $83976b3dea6872a0$var$getTickValuesFn(_ref5) {
    var _ref6 = $83976b3dea6872a0$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $83976b3dea6872a0$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $83976b3dea6872a0$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $83976b3dea6872a0$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $83976b3dea6872a0$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $c7a5592297cca14c$export$f672e0b6f7222cd7)((0, $c7a5592297cca14c$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(n).mul(step)).toNumber();
    }), (0, $c7a5592297cca14c$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $c7a5592297cca14c$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $83976b3dea6872a0$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $83976b3dea6872a0$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $83976b3dea6872a0$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $83976b3dea6872a0$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $83976b3dea6872a0$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($83976b3dea6872a0$var$_toConsumableArray((0, $7df23a93099ed3d6$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $c7a5592297cca14c$export$66c1ae025e96b4bc)(values) : values;
}
var $83976b3dea6872a0$export$b84e75ccbfe6a612 = (0, $c7a5592297cca14c$export$fc10aeed3a532e2a)($83976b3dea6872a0$var$getNiceTickValuesFn);
var $83976b3dea6872a0$export$4cc7a216492b1f53 = (0, $c7a5592297cca14c$export$fc10aeed3a532e2a)($83976b3dea6872a0$var$getTickValuesFn);
var $83976b3dea6872a0$export$e9d28da780436e98 = (0, $c7a5592297cca14c$export$fc10aeed3a532e2a)($83976b3dea6872a0$var$getTickValuesFixedDomainFn);





var $acw62 = parcelRequire("acw62");
var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = 'Invariant failed';
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}



var $acw62 = parcelRequire("acw62");


var $04149ae279e74c50$var$_excluded = [
    "children",
    "className"
];
function $04149ae279e74c50$var$_extends() {
    $04149ae279e74c50$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $04149ae279e74c50$var$_extends.apply(this, arguments);
}
function $04149ae279e74c50$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $04149ae279e74c50$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $04149ae279e74c50$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $04149ae279e74c50$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $04149ae279e74c50$var$_objectWithoutProperties(props, $04149ae279e74c50$var$_excluded);
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-layer', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", $04149ae279e74c50$var$_extends({
        className: layerClass
    }, (0, $008f02516c156322$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $7f4b989d0f2e91c6$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $7f4b989d0f2e91c6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7f4b989d0f2e91c6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7f4b989d0f2e91c6$var$_typeof(o);
}
function $7f4b989d0f2e91c6$var$_extends() {
    $7f4b989d0f2e91c6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7f4b989d0f2e91c6$var$_extends.apply(this, arguments);
}
function $7f4b989d0f2e91c6$var$_slicedToArray(arr, i) {
    return $7f4b989d0f2e91c6$var$_arrayWithHoles(arr) || $7f4b989d0f2e91c6$var$_iterableToArrayLimit(arr, i) || $7f4b989d0f2e91c6$var$_unsupportedIterableToArray(arr, i) || $7f4b989d0f2e91c6$var$_nonIterableRest();
}
function $7f4b989d0f2e91c6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7f4b989d0f2e91c6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7f4b989d0f2e91c6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7f4b989d0f2e91c6$var$_arrayLikeToArray(o, minLen);
}
function $7f4b989d0f2e91c6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7f4b989d0f2e91c6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7f4b989d0f2e91c6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7f4b989d0f2e91c6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7f4b989d0f2e91c6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7f4b989d0f2e91c6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7f4b989d0f2e91c6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7f4b989d0f2e91c6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7f4b989d0f2e91c6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7f4b989d0f2e91c6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7f4b989d0f2e91c6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7f4b989d0f2e91c6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7f4b989d0f2e91c6$var$_callSuper(t, o, e) {
    return o = $7f4b989d0f2e91c6$var$_getPrototypeOf(o), $7f4b989d0f2e91c6$var$_possibleConstructorReturn(t, $7f4b989d0f2e91c6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $7f4b989d0f2e91c6$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $7f4b989d0f2e91c6$var$_possibleConstructorReturn(self, call) {
    if (call && ($7f4b989d0f2e91c6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7f4b989d0f2e91c6$var$_assertThisInitialized(self);
}
function $7f4b989d0f2e91c6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7f4b989d0f2e91c6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7f4b989d0f2e91c6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7f4b989d0f2e91c6$var$_getPrototypeOf(o) {
    $7f4b989d0f2e91c6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7f4b989d0f2e91c6$var$_getPrototypeOf(o);
}
function $7f4b989d0f2e91c6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7f4b989d0f2e91c6$var$_setPrototypeOf(subClass, superClass);
}
function $7f4b989d0f2e91c6$var$_setPrototypeOf(o, p) {
    $7f4b989d0f2e91c6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7f4b989d0f2e91c6$var$_setPrototypeOf(o, p);
}
function $7f4b989d0f2e91c6$var$_defineProperty(obj, key, value) {
    key = $7f4b989d0f2e91c6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7f4b989d0f2e91c6$var$_toPropertyKey(t) {
    var i = $7f4b989d0f2e91c6$var$_toPrimitive(t, "string");
    return "symbol" == $7f4b989d0f2e91c6$var$_typeof(i) ? i : i + "";
}
function $7f4b989d0f2e91c6$var$_toPrimitive(t, r) {
    if ("object" != $7f4b989d0f2e91c6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7f4b989d0f2e91c6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7f4b989d0f2e91c6$export$4f4d7676bdf949e5 = /*#__PURE__*/ function(_React$Component) {
    function ErrorBar() {
        $7f4b989d0f2e91c6$var$_classCallCheck(this, ErrorBar);
        return $7f4b989d0f2e91c6$var$_callSuper(this, ErrorBar, arguments);
    }
    $7f4b989d0f2e91c6$var$_inherits(ErrorBar, _React$Component);
    return $7f4b989d0f2e91c6$var$_createClass(ErrorBar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = $7f4b989d0f2e91c6$var$_objectWithoutProperties(_this$props, $7f4b989d0f2e91c6$var$_excluded);
                var svgProps = (0, $008f02516c156322$export$d697c39a2985a4c)(others, false);
                !!(this.props.direction === 'x' && xAxis.type !== 'number') && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
                var errorBars = data.map(function(entry) {
                    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
                    if (!errorVal) return null;
                    var lineCoordinates = [];
                    var lowBound, highBound;
                    if (Array.isArray(errorVal)) {
                        var _errorVal = $7f4b989d0f2e91c6$var$_slicedToArray(errorVal, 2);
                        lowBound = _errorVal[0];
                        highBound = _errorVal[1];
                    } else lowBound = highBound = errorVal;
                    if (layout === 'vertical') {
                        // error bar for horizontal charts, the y is fixed, x is a range value
                        var scale = xAxis.scale;
                        var yMid = y + offset;
                        var yMin = yMid + width;
                        var yMax = yMid - width;
                        var xMin = scale(value - lowBound);
                        var xMax = scale(value + highBound);
                        // the right line of |--|
                        lineCoordinates.push({
                            x1: xMax,
                            y1: yMin,
                            x2: xMax,
                            y2: yMax
                        });
                        // the middle line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMid,
                            x2: xMax,
                            y2: yMid
                        });
                        // the left line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMin,
                            x2: xMin,
                            y2: yMax
                        });
                    } else if (layout === 'horizontal') {
                        // error bar for horizontal charts, the x is fixed, y is a range value
                        var _scale = yAxis.scale;
                        var xMid = x + offset;
                        var _xMin = xMid - width;
                        var _xMax = xMid + width;
                        var _yMin = _scale(value - lowBound);
                        var _yMax = _scale(value + highBound);
                        // the top line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMax,
                            x2: _xMax,
                            y2: _yMax
                        });
                        // the middle line
                        lineCoordinates.push({
                            x1: xMid,
                            y1: _yMin,
                            x2: xMid,
                            y2: _yMax
                        });
                        // the bottom line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMin,
                            x2: _xMax,
                            y2: _yMin
                        });
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $7f4b989d0f2e91c6$var$_extends({
                        className: "recharts-errorBar",
                        key: "bar-".concat(lineCoordinates.map(function(c) {
                            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
                        }))
                    }, svgProps), lineCoordinates.map(function(coordinates) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $7f4b989d0f2e91c6$var$_extends({}, coordinates, {
                            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
                        }));
                    }));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: "recharts-errorBars"
                }, errorBars);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$7f4b989d0f2e91c6$var$_defineProperty($7f4b989d0f2e91c6$export$4f4d7676bdf949e5, "defaultProps", {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
});
$7f4b989d0f2e91c6$var$_defineProperty($7f4b989d0f2e91c6$export$4f4d7676bdf949e5, "displayName", 'ErrorBar');





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $bfae0ec07b91e499$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $bfae0ec07b91e499$var$_extends() {
    $bfae0ec07b91e499$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bfae0ec07b91e499$var$_extends.apply(this, arguments);
}
function $bfae0ec07b91e499$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bfae0ec07b91e499$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bfae0ec07b91e499$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bfae0ec07b91e499$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $bfae0ec07b91e499$var$_objectWithoutProperties(props, $bfae0ec07b91e499$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-surface', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $bfae0ec07b91e499$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("desc", null, desc), children);
}



var $acw62 = parcelRequire("acw62");




function $61aa615b92178b76$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $61aa615b92178b76$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $61aa615b92178b76$var$_typeof(o);
}
var $61aa615b92178b76$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $61aa615b92178b76$var$_extends() {
    $61aa615b92178b76$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $61aa615b92178b76$var$_extends.apply(this, arguments);
}
function $61aa615b92178b76$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $61aa615b92178b76$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $61aa615b92178b76$var$ownKeys(Object(t), !0).forEach(function(r) {
            $61aa615b92178b76$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $61aa615b92178b76$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $61aa615b92178b76$var$_defineProperty(obj, key, value) {
    key = $61aa615b92178b76$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $61aa615b92178b76$var$_toPropertyKey(t) {
    var i = $61aa615b92178b76$var$_toPrimitive(t, "string");
    return "symbol" == $61aa615b92178b76$var$_typeof(i) ? i : i + "";
}
function $61aa615b92178b76$var$_toPrimitive(t, r) {
    if ("object" != $61aa615b92178b76$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $61aa615b92178b76$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $61aa615b92178b76$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $61aa615b92178b76$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $61aa615b92178b76$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $61aa615b92178b76$var$symbolFactories = {
    symbolCircle: (0, $9b23116271105198$exports.symbolCircle),
    symbolCross: (0, $9b23116271105198$exports.symbolCross),
    symbolDiamond: (0, $9b23116271105198$exports.symbolDiamond),
    symbolSquare: (0, $9b23116271105198$exports.symbolSquare),
    symbolStar: (0, $9b23116271105198$exports.symbolStar),
    symbolTriangle: (0, $9b23116271105198$exports.symbolTriangle),
    symbolWye: (0, $9b23116271105198$exports.symbolWye)
};
var $61aa615b92178b76$var$RADIAN = Math.PI / 180;
var $61aa615b92178b76$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($da6130e1e4702e32$exports)))(type));
    return $61aa615b92178b76$var$symbolFactories[name] || (0, $9b23116271105198$exports.symbolCircle);
};
var $61aa615b92178b76$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $61aa615b92178b76$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $61aa615b92178b76$var$registerSymbol = function registerSymbol(key, factory) {
    $61aa615b92178b76$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($da6130e1e4702e32$exports)))(key))] = factory;
};
var $61aa615b92178b76$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = $61aa615b92178b76$var$_objectWithoutProperties(_ref, $61aa615b92178b76$var$_excluded);
    var props = $61aa615b92178b76$var$_objectSpread($61aa615b92178b76$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $61aa615b92178b76$var$getSymbolFactory(type);
        var symbol = (0, $9b23116271105198$exports.symbol)().type(symbolFactory).size($61aa615b92178b76$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $008f02516c156322$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $61aa615b92178b76$var$_extends({}, filteredProps, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$61aa615b92178b76$export$fa456266707bf4e4.registerSymbol = $61aa615b92178b76$var$registerSymbol;



function $ea93c1a04fc562aa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ea93c1a04fc562aa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ea93c1a04fc562aa$var$_typeof(o);
}
function $ea93c1a04fc562aa$var$_extends() {
    $ea93c1a04fc562aa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ea93c1a04fc562aa$var$_extends.apply(this, arguments);
}
function $ea93c1a04fc562aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea93c1a04fc562aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea93c1a04fc562aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ea93c1a04fc562aa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea93c1a04fc562aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ea93c1a04fc562aa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ea93c1a04fc562aa$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ea93c1a04fc562aa$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ea93c1a04fc562aa$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ea93c1a04fc562aa$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ea93c1a04fc562aa$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ea93c1a04fc562aa$var$_callSuper(t, o, e) {
    return o = $ea93c1a04fc562aa$var$_getPrototypeOf(o), $ea93c1a04fc562aa$var$_possibleConstructorReturn(t, $ea93c1a04fc562aa$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $ea93c1a04fc562aa$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $ea93c1a04fc562aa$var$_possibleConstructorReturn(self, call) {
    if (call && ($ea93c1a04fc562aa$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ea93c1a04fc562aa$var$_assertThisInitialized(self);
}
function $ea93c1a04fc562aa$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ea93c1a04fc562aa$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ea93c1a04fc562aa$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ea93c1a04fc562aa$var$_getPrototypeOf(o) {
    $ea93c1a04fc562aa$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ea93c1a04fc562aa$var$_getPrototypeOf(o);
}
function $ea93c1a04fc562aa$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ea93c1a04fc562aa$var$_setPrototypeOf(subClass, superClass);
}
function $ea93c1a04fc562aa$var$_setPrototypeOf(o, p) {
    $ea93c1a04fc562aa$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ea93c1a04fc562aa$var$_setPrototypeOf(o, p);
}
function $ea93c1a04fc562aa$var$_defineProperty(obj, key, value) {
    key = $ea93c1a04fc562aa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ea93c1a04fc562aa$var$_toPropertyKey(t) {
    var i = $ea93c1a04fc562aa$var$_toPrimitive(t, "string");
    return "symbol" == $ea93c1a04fc562aa$var$_typeof(i) ? i : i + "";
}
function $ea93c1a04fc562aa$var$_toPrimitive(t, r) {
    if ("object" != $ea93c1a04fc562aa$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ea93c1a04fc562aa$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ea93c1a04fc562aa$var$SIZE = 32;
var $ea93c1a04fc562aa$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    function DefaultLegendContent() {
        $ea93c1a04fc562aa$var$_classCallCheck(this, DefaultLegendContent);
        return $ea93c1a04fc562aa$var$_callSuper(this, DefaultLegendContent, arguments);
    }
    $ea93c1a04fc562aa$var$_inherits(DefaultLegendContent, _PureComponent);
    return $ea93c1a04fc562aa$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $ea93c1a04fc562aa$var$SIZE / 2;
                var sixthSize = $ea93c1a04fc562aa$var$SIZE / 6;
                var thirdSize = $ea93c1a04fc562aa$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $ea93c1a04fc562aa$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($ea93c1a04fc562aa$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($ea93c1a04fc562aa$var$SIZE / 8, "h").concat($ea93c1a04fc562aa$var$SIZE, "v").concat($ea93c1a04fc562aa$var$SIZE * 3 / 4, "h").concat(-$ea93c1a04fc562aa$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(data.legendIcon)) {
                    var iconProps = $ea93c1a04fc562aa$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $61aa615b92178b76$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $ea93c1a04fc562aa$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $ea93c1a04fc562aa$var$SIZE,
                    height: $ea93c1a04fc562aa$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ea93c1a04fc562aa$var$_defineProperty($ea93c1a04fc562aa$var$_defineProperty({
                        'recharts-legend-item': true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(entry.value) ? entry.value : null;
                    (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", $ea93c1a04fc562aa$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfae0ec07b91e499$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
}((0, $acw62.PureComponent));
$ea93c1a04fc562aa$var$_defineProperty($ea93c1a04fc562aa$export$99f8d96ed0cededa, "displayName", 'Legend');
$ea93c1a04fc562aa$var$_defineProperty($ea93c1a04fc562aa$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});



var $5b6e1b59a42de650$exports = {};

var $451cd6fc5b077ebe$exports = {};

var $a541279ebb64f2c9$exports = {};
var $565b5ed18efa4b9c$exports = {};
var $a9e76203bd7c412f$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$a9e76203bd7c412f$exports = $a9e76203bd7c412f$var$baseFindIndex;


var $c66d4063f81f4687$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c66d4063f81f4687$var$baseIsNaN(value) {
    return value !== value;
}
$c66d4063f81f4687$exports = $c66d4063f81f4687$var$baseIsNaN;


var $a1f1a90cd7caaefa$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a1f1a90cd7caaefa$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$a1f1a90cd7caaefa$exports = $a1f1a90cd7caaefa$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $565b5ed18efa4b9c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $a1f1a90cd7caaefa$exports(array, value, fromIndex) : $a9e76203bd7c412f$exports(array, $c66d4063f81f4687$exports, fromIndex);
}
$565b5ed18efa4b9c$exports = $565b5ed18efa4b9c$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $a541279ebb64f2c9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $565b5ed18efa4b9c$exports(array, value, 0) > -1;
}
$a541279ebb64f2c9$exports = $a541279ebb64f2c9$var$arrayIncludes;


var $ad409cc63f3cbe79$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $ad409cc63f3cbe79$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$ad409cc63f3cbe79$exports = $ad409cc63f3cbe79$var$arrayIncludesWith;



var $3fa8e773494800f5$exports = {};

var $6c554e32feae9faa$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6c554e32feae9faa$var$noop() {
// No operation performed.
}
$6c554e32feae9faa$exports = $6c554e32feae9faa$var$noop;



/** Used as references for various `Number` constants. */ var $3fa8e773494800f5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3fa8e773494800f5$var$createSet = !($05f44e958da968eb$exports && 1 / $11f509f8f53d8c36$exports(new $05f44e958da968eb$exports([
    ,
    -0
]))[1] == $3fa8e773494800f5$var$INFINITY) ? $6c554e32feae9faa$exports : function(values) {
    return new $05f44e958da968eb$exports(values);
};
$3fa8e773494800f5$exports = $3fa8e773494800f5$var$createSet;



/** Used as the size to enable large array optimizations. */ var $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $451cd6fc5b077ebe$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $a541279ebb64f2c9$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $ad409cc63f3cbe79$exports;
    } else if (length >= $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $3fa8e773494800f5$exports(array);
        if (set) return $11f509f8f53d8c36$exports(set);
        isCommon = false;
        includes = $1b44096ad4b9e2d5$exports;
        seen = new $a29ccdc0f60e279e$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$451cd6fc5b077ebe$exports = $451cd6fc5b077ebe$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $5b6e1b59a42de650$var$uniqBy(array, iteratee) {
    return array && array.length ? $451cd6fc5b077ebe$exports(array, $5aba4f6d9f8304a3$exports(iteratee, 2)) : [];
}
$5b6e1b59a42de650$exports = $5b6e1b59a42de650$var$uniqBy;



function $12cc16c3e91089ee$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($5b6e1b59a42de650$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($5b6e1b59a42de650$exports)))(payload, option);
    return payload;
}


function $1f4bd73be8c7e839$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1f4bd73be8c7e839$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1f4bd73be8c7e839$var$_typeof(o);
}
var $1f4bd73be8c7e839$var$_excluded = [
    "ref"
];
function $1f4bd73be8c7e839$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f4bd73be8c7e839$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f4bd73be8c7e839$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1f4bd73be8c7e839$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f4bd73be8c7e839$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1f4bd73be8c7e839$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1f4bd73be8c7e839$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1f4bd73be8c7e839$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1f4bd73be8c7e839$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1f4bd73be8c7e839$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1f4bd73be8c7e839$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1f4bd73be8c7e839$var$_callSuper(t, o, e) {
    return o = $1f4bd73be8c7e839$var$_getPrototypeOf(o), $1f4bd73be8c7e839$var$_possibleConstructorReturn(t, $1f4bd73be8c7e839$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $1f4bd73be8c7e839$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $1f4bd73be8c7e839$var$_possibleConstructorReturn(self, call) {
    if (call && ($1f4bd73be8c7e839$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1f4bd73be8c7e839$var$_assertThisInitialized(self);
}
function $1f4bd73be8c7e839$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1f4bd73be8c7e839$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1f4bd73be8c7e839$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1f4bd73be8c7e839$var$_getPrototypeOf(o) {
    $1f4bd73be8c7e839$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1f4bd73be8c7e839$var$_getPrototypeOf(o);
}
function $1f4bd73be8c7e839$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1f4bd73be8c7e839$var$_setPrototypeOf(subClass, superClass);
}
function $1f4bd73be8c7e839$var$_setPrototypeOf(o, p) {
    $1f4bd73be8c7e839$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1f4bd73be8c7e839$var$_setPrototypeOf(o, p);
}
function $1f4bd73be8c7e839$var$_defineProperty(obj, key, value) {
    key = $1f4bd73be8c7e839$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1f4bd73be8c7e839$var$_toPropertyKey(t) {
    var i = $1f4bd73be8c7e839$var$_toPrimitive(t, "string");
    return "symbol" == $1f4bd73be8c7e839$var$_typeof(i) ? i : i + "";
}
function $1f4bd73be8c7e839$var$_toPrimitive(t, r) {
    if ("object" != $1f4bd73be8c7e839$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1f4bd73be8c7e839$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1f4bd73be8c7e839$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1f4bd73be8c7e839$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1f4bd73be8c7e839$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1f4bd73be8c7e839$var$defaultUniqBy(entry) {
    return entry.value;
}
function $1f4bd73be8c7e839$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(content, props);
    var ref = props.ref, otherProps = $1f4bd73be8c7e839$var$_objectWithoutProperties(props, $1f4bd73be8c7e839$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ea93c1a04fc562aa$export$99f8d96ed0cededa), otherProps);
}
var $1f4bd73be8c7e839$var$EPS = 1;
var $1f4bd73be8c7e839$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    function Legend() {
        var _this;
        $1f4bd73be8c7e839$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $1f4bd73be8c7e839$var$_callSuper(this, Legend, [].concat(args));
        $1f4bd73be8c7e839$var$_defineProperty(_this, "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $1f4bd73be8c7e839$var$_inherits(Legend, _PureComponent);
    return $1f4bd73be8c7e839$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    box.height = this.wrapperNode.offsetHeight;
                    box.width = this.wrapperNode.offsetWidth;
                    return box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $1f4bd73be8c7e839$var$EPS || Math.abs(box.height - this.lastBoundingBox.height) > $1f4bd73be8c7e839$var$EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $1f4bd73be8c7e839$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var box = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - box.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $1f4bd73be8c7e839$var$_objectSpread($1f4bd73be8c7e839$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $1f4bd73be8c7e839$var$_objectSpread($1f4bd73be8c7e839$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $1f4bd73be8c7e839$var$renderContent(content, $1f4bd73be8c7e839$var$_objectSpread($1f4bd73be8c7e839$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $12cc16c3e91089ee$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $1f4bd73be8c7e839$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var _this$defaultProps$it = $1f4bd73be8c7e839$var$_objectSpread($1f4bd73be8c7e839$var$_objectSpread({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
                if (layout === 'vertical' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
}((0, $acw62.PureComponent));
$1f4bd73be8c7e839$var$_defineProperty($1f4bd73be8c7e839$export$ed247974535929c7, "displayName", 'Legend');
$1f4bd73be8c7e839$var$_defineProperty($1f4bd73be8c7e839$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});




function $3a45d033d706e33c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3a45d033d706e33c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a45d033d706e33c$var$_typeof(o);
}
function $3a45d033d706e33c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a45d033d706e33c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a45d033d706e33c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3a45d033d706e33c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a45d033d706e33c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3a45d033d706e33c$var$_defineProperty(obj, key, value) {
    key = $3a45d033d706e33c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3a45d033d706e33c$var$_toPropertyKey(t) {
    var i = $3a45d033d706e33c$var$_toPrimitive(t, "string");
    return "symbol" == $3a45d033d706e33c$var$_typeof(i) ? i : i + "";
}
function $3a45d033d706e33c$var$_toPrimitive(t, r) {
    if ("object" != $3a45d033d706e33c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3a45d033d706e33c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3a45d033d706e33c$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $1f4bd73be8c7e839$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendDefaultProps = (0, $1f4bd73be8c7e839$export$ed247974535929c7).defaultProps;
    var legendProps = legendDefaultProps !== undefined ? $3a45d033d706e33c$var$_objectSpread($3a45d033d706e33c$var$_objectSpread({}, legendDefaultProps), legendItem.props) : {};
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var itemDefaultProps = item.type.defaultProps;
        var itemProps = itemDefaultProps !== undefined ? $3a45d033d706e33c$var$_objectSpread($3a45d033d706e33c$var$_objectSpread({}, itemDefaultProps), item.props) : {};
        var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendProps.iconType || legendType || 'square',
            color: (0, $cd015374923bb5c7$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: itemProps
        };
    });
    return $3a45d033d706e33c$var$_objectSpread($3a45d033d706e33c$var$_objectSpread($3a45d033d706e33c$var$_objectSpread({}, legendProps), (0, $1f4bd73be8c7e839$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $cd015374923bb5c7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cd015374923bb5c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cd015374923bb5c7$var$_typeof(o);
}
function $cd015374923bb5c7$var$_toConsumableArray(arr) {
    return $cd015374923bb5c7$var$_arrayWithoutHoles(arr) || $cd015374923bb5c7$var$_iterableToArray(arr) || $cd015374923bb5c7$var$_unsupportedIterableToArray(arr) || $cd015374923bb5c7$var$_nonIterableSpread();
}
function $cd015374923bb5c7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cd015374923bb5c7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cd015374923bb5c7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cd015374923bb5c7$var$_arrayLikeToArray(o, minLen);
}
function $cd015374923bb5c7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cd015374923bb5c7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cd015374923bb5c7$var$_arrayLikeToArray(arr);
}
function $cd015374923bb5c7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cd015374923bb5c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd015374923bb5c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd015374923bb5c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cd015374923bb5c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd015374923bb5c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cd015374923bb5c7$var$_defineProperty(obj, key, value) {
    key = $cd015374923bb5c7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cd015374923bb5c7$var$_toPropertyKey(t) {
    var i = $cd015374923bb5c7$var$_toPrimitive(t, "string");
    return "symbol" == $cd015374923bb5c7$var$_typeof(i) ? i : i + "";
}
function $cd015374923bb5c7$var$_toPrimitive(t, r) {
    if ("object" != $cd015374923bb5c7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cd015374923bb5c7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cd015374923bb5c7$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(dataKey)) return defaultValue;
    if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $cd015374923bb5c7$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($1cb7998639d45551$exports)))(data, function(entry) {
        return $cd015374923bb5c7$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($2c30ec7848ba160d$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $cd015374923bb5c7$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(cur - before) !== (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(after - cur) === (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $cd015374923bb5c7$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _item$type;
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $cd015374923bb5c7$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $008f02516c156322$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var barItemDefaultProps = barItems[0].type.defaultProps;
                var barItemProps = barItemDefaultProps !== undefined ? $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
                var selfSize = barItemProps.barSize;
                var cateId = barItemProps[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(barSize) ? undefined : (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var $cd015374923bb5c7$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($cd015374923bb5c7$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($cd015374923bb5c7$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $cd015374923bb5c7$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $3a45d033d706e33c$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(offset[align])) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, $cd015374923bb5c7$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(offset[verticalAlign])) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, $cd015374923bb5c7$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $cd015374923bb5c7$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $cd015374923bb5c7$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $7f4b989d0f2e91c6$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $cd015374923bb5c7$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $cd015374923bb5c7$export$f97fc4a450f29a(entry, dataKey);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($2c30ec7848ba160d$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $cd015374923bb5c7$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $cd015374923bb5c7$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $cd015374923bb5c7$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $cd015374923bb5c7$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $cd015374923bb5c7$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $cd015374923bb5c7$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $cd015374923bb5c7$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $cd015374923bb5c7$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $cd015374923bb5c7$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $cd015374923bb5c7$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($10ed4ab35db4c025$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $cd015374923bb5c7$var$handlerWeakMap = new WeakMap();
var $cd015374923bb5c7$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!$cd015374923bb5c7$var$handlerWeakMap.has(defaultHandler)) $cd015374923bb5c7$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $cd015374923bb5c7$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $cd015374923bb5c7$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $d8f008d3b0c1a5c3$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $d8f008d3b0c1a5c3$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $d8f008d3b0c1a5c3$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $d8f008d3b0c1a5c3$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $d8f008d3b0c1a5c3$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($15ee4628980e0994$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($da6130e1e4702e32$exports)))(scale));
        return {
            scale: ($d8f008d3b0c1a5c3$exports[name] || $d8f008d3b0c1a5c3$exports.scalePoint)(),
            realScaleType: $d8f008d3b0c1a5c3$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $d8f008d3b0c1a5c3$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $cd015374923bb5c7$var$EPS = 1e-4;
var $cd015374923bb5c7$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $cd015374923bb5c7$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $cd015374923bb5c7$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $cd015374923bb5c7$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $cd015374923bb5c7$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(domain[0]) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $cd015374923bb5c7$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($10ed4ab35db4c025$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $cd015374923bb5c7$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($10ed4ab35db4c025$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $cd015374923bb5c7$var$STACK_OFFSET_MAP = {
    sign: $cd015374923bb5c7$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $9b23116271105198$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $9b23116271105198$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $9b23116271105198$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $9b23116271105198$exports.stackOffsetWiggle),
    positive: $cd015374923bb5c7$export$9f2c6ead70935022
};
var $cd015374923bb5c7$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $cd015374923bb5c7$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $9b23116271105198$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$cd015374923bb5c7$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $9b23116271105198$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $cd015374923bb5c7$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$type2;
        var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
        var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
        if (hide) return result;
        var axisId = defaultedProps[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, result), {}, $cd015374923bb5c7$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, res), {}, $cd015374923bb5c7$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $cd015374923bb5c7$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, result), {}, $cd015374923bb5c7$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $cd015374923bb5c7$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $83976b3dea6872a0$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($2c30ec7848ba160d$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $83976b3dea6872a0$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function $cd015374923bb5c7$export$6e87f3defb83c3f(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $2ab3a7e25c8aba74$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $cd015374923bb5c7$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(value) ? axis.scale(value) : null;
}
var $cd015374923bb5c7$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $cd015374923bb5c7$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $cd015374923bb5c7$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $cd015374923bb5c7$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var _item$type3;
    var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId;
    if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $cd015374923bb5c7$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($2c30ec7848ba160d$exports)))(entry.concat([
                result[0]
            ]).filter((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(entry.concat([
                result[1]
            ]).filter((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $cd015374923bb5c7$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $cd015374923bb5c7$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $cd015374923bb5c7$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cd015374923bb5c7$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cd015374923bb5c7$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($cd015374923bb5c7$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$cd015374923bb5c7$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($cd015374923bb5c7$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$cd015374923bb5c7$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $cd015374923bb5c7$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($300ea168693086c2$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $cd015374923bb5c7$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($394ab417e9bd75cc$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $cd015374923bb5c7$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var defaultedProps = graphicalItem.type.defaultProps ? $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
    var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
    return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, (0, $008f02516c156322$export$d697c39a2985a4c)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $cd015374923bb5c7$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $cd015374923bb5c7$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};




var $795299547b24e258$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $795299547b24e258$export$98f03c5d19621d70 = {
    isSsr: $795299547b24e258$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $795299547b24e258$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $795299547b24e258$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $795299547b24e258$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};


function $41867cca6cb93873$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $41867cca6cb93873$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $41867cca6cb93873$var$_typeof(o);
}
function $41867cca6cb93873$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41867cca6cb93873$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41867cca6cb93873$var$ownKeys(Object(t), !0).forEach(function(r) {
            $41867cca6cb93873$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41867cca6cb93873$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $41867cca6cb93873$var$_defineProperty(obj, key, value) {
    key = $41867cca6cb93873$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $41867cca6cb93873$var$_toPropertyKey(t) {
    var i = $41867cca6cb93873$var$_toPrimitive(t, "string");
    return "symbol" == $41867cca6cb93873$var$_typeof(i) ? i : i + "";
}
function $41867cca6cb93873$var$_toPrimitive(t, r) {
    if ("object" != $41867cca6cb93873$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $41867cca6cb93873$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $41867cca6cb93873$var$_toConsumableArray(arr) {
    return $41867cca6cb93873$var$_arrayWithoutHoles(arr) || $41867cca6cb93873$var$_iterableToArray(arr) || $41867cca6cb93873$var$_unsupportedIterableToArray(arr) || $41867cca6cb93873$var$_nonIterableSpread();
}
function $41867cca6cb93873$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $41867cca6cb93873$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $41867cca6cb93873$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $41867cca6cb93873$var$_arrayLikeToArray(o, minLen);
}
function $41867cca6cb93873$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $41867cca6cb93873$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $41867cca6cb93873$var$_arrayLikeToArray(arr);
}
function $41867cca6cb93873$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $41867cca6cb93873$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $41867cca6cb93873$var$MAX_CACHE_NUM = 2000;
var $41867cca6cb93873$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $41867cca6cb93873$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $41867cca6cb93873$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $41867cca6cb93873$var$autoCompleteStyle(name, value) {
    if ($41867cca6cb93873$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $41867cca6cb93873$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($41867cca6cb93873$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($41867cca6cb93873$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $41867cca6cb93873$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($41867cca6cb93873$var$camelToMiddleLine(s), ":").concat($41867cca6cb93873$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function $41867cca6cb93873$var$removeInvalidKeys(obj) {
    var copyObj = $41867cca6cb93873$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $41867cca6cb93873$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $795299547b24e258$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $41867cca6cb93873$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($41867cca6cb93873$var$stringCache.widthCache[cacheKey]) return $41867cca6cb93873$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($41867cca6cb93873$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $41867cca6cb93873$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $41867cca6cb93873$var$_objectSpread($41867cca6cb93873$var$_objectSpread({}, $41867cca6cb93873$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $41867cca6cb93873$var$stringCache.widthCache[cacheKey] = result;
        if (++$41867cca6cb93873$var$stringCache.cacheCount > $41867cca6cb93873$var$MAX_CACHE_NUM) {
            $41867cca6cb93873$var$stringCache.cacheCount = 0;
            $41867cca6cb93873$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $41867cca6cb93873$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};



var $17211428bc2045c4$exports = {};
var $96b401257ea00d24$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $31e24313ace94404$exports) $31e24313ace94404$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$96b401257ea00d24$exports = $96b401257ea00d24$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $17211428bc2045c4$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $5aba4f6d9f8304a3$exports(iteratee, 3);
    $34edfba366a0cfa1$exports(object, function(value, key, object) {
        $96b401257ea00d24$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$17211428bc2045c4$exports = $17211428bc2045c4$var$mapValues;


var $b3635322c399904d$exports = {};
var $492b7c32fdf9fe9f$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $492b7c32fdf9fe9f$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$492b7c32fdf9fe9f$exports = $492b7c32fdf9fe9f$var$arrayEvery;


var $7bc6550757287062$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $7bc6550757287062$var$baseEvery(collection, predicate) {
    var result = true;
    $35fa3296f177aa01$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$7bc6550757287062$exports = $7bc6550757287062$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $b3635322c399904d$var$every(collection, predicate, guard) {
    var func = $0488fde9aa355453$exports(collection) ? $492b7c32fdf9fe9f$exports : $7bc6550757287062$exports;
    if (guard && $81b21e8b41d211e8$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $5aba4f6d9f8304a3$exports(predicate, 3));
}
$b3635322c399904d$exports = $b3635322c399904d$var$every;






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


var $2405e375887ef8eb$exports = {};
(function(global, factory) {
    factory($2405e375887ef8eb$exports);
})($2405e375887ef8eb$exports, function(exports1) {
    'use strict';
    const { getOwnPropertyNames: getOwnPropertyNames, getOwnPropertySymbols: getOwnPropertySymbols } = Object;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { hasOwnProperty: hasOwnProperty } = Object.prototype;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            const { cache: cache } = state;
            const cachedA = cache.get(a);
            const cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            const result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the `@@toStringTag` of the value, if it exists.
     */ function getShortTag(value) {
        return value != null ? value[Symbol.toStringTag] : undefined;
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ const hasOwn = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    Object.hasOwn || ((object, property)=>hasOwnProperty.call(object, property));
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    const PREACT_VNODE = '__v';
    const PREACT_OWNER = '__o';
    const REACT_OWNER = '_owner';
    const { getOwnPropertyDescriptor: getOwnPropertyDescriptor, keys: keys } = Object;
    /**
     * Whether the array buffers are equal in value.
     */ function areArrayBuffersEqual(a, b) {
        return a.byteLength === b.byteLength && areTypedArraysEqual(new Uint8Array(a), new Uint8Array(b));
    }
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        let index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dataviews are equal in value.
     */ function areDataViewsEqual(a, b) {
        return a.byteLength === b.byteLength && areTypedArraysEqual(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength));
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        const size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        const matchedIndices = new Array(size);
        const aIterable = a.entries();
        let aResult;
        let bResult;
        let index = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            const bIterable = b.entries();
            let hasMatch = false;
            let matchIndex = 0;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                const aEntry = aResult.value;
                const bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ const areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        const properties = keys(a);
        let index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        const properties = getStrictProperties(a);
        let index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        let property;
        let descriptorA;
        let descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        const size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        const matchedIndices = new Array(size);
        const aIterable = a.values();
        let aResult;
        let bResult;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            const bIterable = b.values();
            let hasMatch = false;
            let matchIndex = 0;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        let index = a.byteLength;
        if (b.byteLength !== index || a.byteOffset !== b.byteOffset) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    const ARRAY_BUFFER_TAG = '[object ArrayBuffer]';
    const ARGUMENTS_TAG = '[object Arguments]';
    const BOOLEAN_TAG = '[object Boolean]';
    const DATA_VIEW_TAG = '[object DataView]';
    const DATE_TAG = '[object Date]';
    const ERROR_TAG = '[object Error]';
    const MAP_TAG = '[object Map]';
    const NUMBER_TAG = '[object Number]';
    const OBJECT_TAG = '[object Object]';
    const REG_EXP_TAG = '[object RegExp]';
    const SET_TAG = '[object Set]';
    const STRING_TAG = '[object String]';
    const TYPED_ARRAY_TAGS = {
        '[object Int8Array]': true,
        '[object Uint8Array]': true,
        '[object Uint8ClampedArray]': true,
        '[object Int16Array]': true,
        '[object Uint16Array]': true,
        '[object Int32Array]': true,
        '[object Uint32Array]': true,
        '[object Float16Array]': true,
        '[object Float32Array]': true,
        '[object Float64Array]': true,
        '[object BigInt64Array]': true,
        '[object BigUint64Array]': true
    };
    const URL_TAG = '[object URL]';
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const toString = Object.prototype.toString;
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator({ areArrayBuffersEqual: areArrayBuffersEqual, areArraysEqual: areArraysEqual, areDataViewsEqual: areDataViewsEqual, areDatesEqual: areDatesEqual, areErrorsEqual: areErrorsEqual, areFunctionsEqual: areFunctionsEqual, areMapsEqual: areMapsEqual, areNumbersEqual: areNumbersEqual, areObjectsEqual: areObjectsEqual, arePrimitiveWrappersEqual: arePrimitiveWrappersEqual, areRegExpsEqual: areRegExpsEqual, areSetsEqual: areSetsEqual, areTypedArraysEqual: areTypedArraysEqual, areUrlsEqual: areUrlsEqual, unknownTagComparators: unknownTagComparators }) {
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            const type = typeof a;
            if (type !== typeof b) return false;
            if (type !== 'object') {
                if (type === 'number') return areNumbersEqual(a, b, state);
                if (type === 'function') return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            const constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (Array.isArray(a)) return areArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            const tag = toString.call(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            if (TYPED_ARRAY_TAGS[tag]) return areTypedArraysEqual(a, b, state);
            if (tag === ARRAY_BUFFER_TAG) return areArrayBuffersEqual(a, b, state);
            if (tag === DATA_VIEW_TAG) return areDataViewsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            if (unknownTagComparators) {
                let unknownTagComparator = unknownTagComparators[tag];
                if (!unknownTagComparator) {
                    const shortTag = getShortTag(a);
                    if (shortTag) unknownTagComparator = unknownTagComparators[shortTag];
                }
                // If the custom config has an unknown tag comparator that matches the captured tag or the
                // @@toStringTag, it is the source of truth for whether the values are equal.
                if (unknownTagComparator) return unknownTagComparator(a, b, state);
            }
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig({ circular: circular, createCustomConfig: createCustomConfig, strict: strict }) {
        let config = {
            areArrayBuffersEqual: areArrayBuffersEqual,
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDataViewsEqual: areDataViewsEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? combineComparators(areTypedArraysEqual, areObjectsEqualStrict) : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual,
            unknownTagComparators: undefined
        };
        if (createCustomConfig) config = Object.assign({}, config, createCustomConfig(config));
        if (circular) {
            const areArraysEqual = createIsCircular(config.areArraysEqual);
            const areMapsEqual = createIsCircular(config.areMapsEqual);
            const areObjectsEqual = createIsCircular(config.areObjectsEqual);
            const areSetsEqual = createIsCircular(config.areSetsEqual);
            config = Object.assign({}, config, {
                areArraysEqual: areArraysEqual,
                areMapsEqual: areMapsEqual,
                areObjectsEqual: areObjectsEqual,
                areSetsEqual: areSetsEqual
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual({ circular: circular, comparator: comparator, createState: createState, equals: equals, strict: strict }) {
        if (createState) return function isEqual(a, b) {
            const { cache: cache = circular ? new WeakMap() : undefined, meta: meta } = createState();
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        const state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ const deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ const strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ const circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ const strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ const shallowEqual = createCustomEqual({
        createInternalComparator: ()=>sameValueZeroEqual
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ const strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: ()=>sameValueZeroEqual
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ const circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: ()=>sameValueZeroEqual
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ const strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: ()=>sameValueZeroEqual,
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options = {}) {
        const { circular: circular = false, createInternalComparator: createCustomInternalComparator, createState: createState, strict: strict = false } = options;
        const config = createEqualityComparatorConfig(options);
        const comparator = createEqualityComparator(config);
        const equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $7ff7dc42bcdc16d6$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $7ff7dc42bcdc16d6$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $7ff7dc42bcdc16d6$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $8fc08b46df15d7b3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8fc08b46df15d7b3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8fc08b46df15d7b3$var$_typeof(o);
}
function $8fc08b46df15d7b3$var$_toArray(arr) {
    return $8fc08b46df15d7b3$var$_arrayWithHoles(arr) || $8fc08b46df15d7b3$var$_iterableToArray(arr) || $8fc08b46df15d7b3$var$_unsupportedIterableToArray(arr) || $8fc08b46df15d7b3$var$_nonIterableRest();
}
function $8fc08b46df15d7b3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8fc08b46df15d7b3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8fc08b46df15d7b3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8fc08b46df15d7b3$var$_arrayLikeToArray(o, minLen);
}
function $8fc08b46df15d7b3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8fc08b46df15d7b3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8fc08b46df15d7b3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8fc08b46df15d7b3$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $8fc08b46df15d7b3$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $7ff7dc42bcdc16d6$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $7ff7dc42bcdc16d6$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($8fc08b46df15d7b3$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $28cf6a7385103719$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $28cf6a7385103719$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $28cf6a7385103719$var$_typeof(o);
}
function $28cf6a7385103719$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $28cf6a7385103719$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $28cf6a7385103719$var$ownKeys(Object(t), !0).forEach(function(r) {
            $28cf6a7385103719$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $28cf6a7385103719$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $28cf6a7385103719$var$_defineProperty(obj, key, value) {
    key = $28cf6a7385103719$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $28cf6a7385103719$var$_toPropertyKey(arg) {
    var key = $28cf6a7385103719$var$_toPrimitive(arg, "string");
    return $28cf6a7385103719$var$_typeof(key) === "symbol" ? key : String(key);
}
function $28cf6a7385103719$var$_toPrimitive(input, hint) {
    if ($28cf6a7385103719$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($28cf6a7385103719$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $28cf6a7385103719$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $28cf6a7385103719$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $28cf6a7385103719$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $28cf6a7385103719$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $28cf6a7385103719$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $28cf6a7385103719$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $28cf6a7385103719$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $28cf6a7385103719$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $28cf6a7385103719$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $28cf6a7385103719$var$_objectSpread($28cf6a7385103719$var$_objectSpread({}, res), {}, $28cf6a7385103719$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $28cf6a7385103719$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($28cf6a7385103719$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $28cf6a7385103719$var$isDev = false;
var $28cf6a7385103719$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($28cf6a7385103719$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $76a15591a87ba8e0$var$_slicedToArray(arr, i) {
    return $76a15591a87ba8e0$var$_arrayWithHoles(arr) || $76a15591a87ba8e0$var$_iterableToArrayLimit(arr, i) || $76a15591a87ba8e0$var$_unsupportedIterableToArray(arr, i) || $76a15591a87ba8e0$var$_nonIterableRest();
}
function $76a15591a87ba8e0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $76a15591a87ba8e0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $76a15591a87ba8e0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $76a15591a87ba8e0$var$_toConsumableArray(arr) {
    return $76a15591a87ba8e0$var$_arrayWithoutHoles(arr) || $76a15591a87ba8e0$var$_iterableToArray(arr) || $76a15591a87ba8e0$var$_unsupportedIterableToArray(arr) || $76a15591a87ba8e0$var$_nonIterableSpread();
}
function $76a15591a87ba8e0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $76a15591a87ba8e0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $76a15591a87ba8e0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $76a15591a87ba8e0$var$_arrayLikeToArray(o, minLen);
}
function $76a15591a87ba8e0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $76a15591a87ba8e0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $76a15591a87ba8e0$var$_arrayLikeToArray(arr);
}
function $76a15591a87ba8e0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $76a15591a87ba8e0$var$ACCURACY = 1e-4;
var $76a15591a87ba8e0$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $76a15591a87ba8e0$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $76a15591a87ba8e0$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $76a15591a87ba8e0$var$cubicBezierFactor(c1, c2);
        return $76a15591a87ba8e0$var$multyTime(params, t);
    };
};
var $76a15591a87ba8e0$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $76a15591a87ba8e0$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($76a15591a87ba8e0$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $76a15591a87ba8e0$var$multyTime(newParams, t);
    };
};
var $76a15591a87ba8e0$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $76a15591a87ba8e0$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $28cf6a7385103719$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $28cf6a7385103719$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $76a15591a87ba8e0$var$cubicBezier(x1, x2);
    var curveY = $76a15591a87ba8e0$var$cubicBezier(y1, y2);
    var derCurveX = $76a15591a87ba8e0$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $76a15591a87ba8e0$var$ACCURACY || derVal < $76a15591a87ba8e0$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $76a15591a87ba8e0$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $76a15591a87ba8e0$var$ACCURACY && Math.abs(newV) < $76a15591a87ba8e0$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $76a15591a87ba8e0$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $76a15591a87ba8e0$export$56c51296f72f0592(easing);
        case 'spring':
            return $76a15591a87ba8e0$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $76a15591a87ba8e0$export$56c51296f72f0592(easing);
            (0, $28cf6a7385103719$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $28cf6a7385103719$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $4cbf2cae0e990b76$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4cbf2cae0e990b76$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4cbf2cae0e990b76$var$_typeof(o);
}
function $4cbf2cae0e990b76$var$_toConsumableArray(arr) {
    return $4cbf2cae0e990b76$var$_arrayWithoutHoles(arr) || $4cbf2cae0e990b76$var$_iterableToArray(arr) || $4cbf2cae0e990b76$var$_unsupportedIterableToArray(arr) || $4cbf2cae0e990b76$var$_nonIterableSpread();
}
function $4cbf2cae0e990b76$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4cbf2cae0e990b76$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4cbf2cae0e990b76$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4cbf2cae0e990b76$var$_arrayLikeToArray(arr);
}
function $4cbf2cae0e990b76$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4cbf2cae0e990b76$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4cbf2cae0e990b76$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4cbf2cae0e990b76$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4cbf2cae0e990b76$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4cbf2cae0e990b76$var$_defineProperty(obj, key, value) {
    key = $4cbf2cae0e990b76$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4cbf2cae0e990b76$var$_toPropertyKey(arg) {
    var key = $4cbf2cae0e990b76$var$_toPrimitive(arg, "string");
    return $4cbf2cae0e990b76$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4cbf2cae0e990b76$var$_toPrimitive(input, hint) {
    if ($4cbf2cae0e990b76$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4cbf2cae0e990b76$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4cbf2cae0e990b76$var$_slicedToArray(arr, i) {
    return $4cbf2cae0e990b76$var$_arrayWithHoles(arr) || $4cbf2cae0e990b76$var$_iterableToArrayLimit(arr, i) || $4cbf2cae0e990b76$var$_unsupportedIterableToArray(arr, i) || $4cbf2cae0e990b76$var$_nonIterableRest();
}
function $4cbf2cae0e990b76$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4cbf2cae0e990b76$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4cbf2cae0e990b76$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4cbf2cae0e990b76$var$_arrayLikeToArray(o, minLen);
}
function $4cbf2cae0e990b76$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4cbf2cae0e990b76$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4cbf2cae0e990b76$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $4cbf2cae0e990b76$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $4cbf2cae0e990b76$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $4cbf2cae0e990b76$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $28cf6a7385103719$export$d6051a0f7a227332)(function(key, val) {
        if ($4cbf2cae0e990b76$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $4cbf2cae0e990b76$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $28cf6a7385103719$export$d6051a0f7a227332)(function(key, val) {
        if ($4cbf2cae0e990b76$var$needContinue(val)) return $4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, val), {}, {
            velocity: $4cbf2cae0e990b76$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $4cbf2cae0e990b76$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$4cbf2cae0e990b76$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $28cf6a7385103719$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, res), {}, $4cbf2cae0e990b76$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, res), {}, $4cbf2cae0e990b76$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $28cf6a7385103719$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($4cbf2cae0e990b76$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $4cbf2cae0e990b76$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $28cf6a7385103719$export$d6051a0f7a227332)(function(key, val) {
            return $4cbf2cae0e990b76$var$alpha.apply(void 0, $4cbf2cae0e990b76$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $28cf6a7385103719$export$d6051a0f7a227332)(function(key, val) {
                return $4cbf2cae0e990b76$var$alpha.apply(void 0, $4cbf2cae0e990b76$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread($4cbf2cae0e990b76$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $85b251bbd816cf83$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $85b251bbd816cf83$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $85b251bbd816cf83$var$_typeof(o);
}
var $85b251bbd816cf83$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $85b251bbd816cf83$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $85b251bbd816cf83$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $85b251bbd816cf83$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $85b251bbd816cf83$var$_toConsumableArray(arr) {
    return $85b251bbd816cf83$var$_arrayWithoutHoles(arr) || $85b251bbd816cf83$var$_iterableToArray(arr) || $85b251bbd816cf83$var$_unsupportedIterableToArray(arr) || $85b251bbd816cf83$var$_nonIterableSpread();
}
function $85b251bbd816cf83$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $85b251bbd816cf83$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $85b251bbd816cf83$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $85b251bbd816cf83$var$_arrayLikeToArray(o, minLen);
}
function $85b251bbd816cf83$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $85b251bbd816cf83$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $85b251bbd816cf83$var$_arrayLikeToArray(arr);
}
function $85b251bbd816cf83$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $85b251bbd816cf83$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $85b251bbd816cf83$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $85b251bbd816cf83$var$ownKeys(Object(t), !0).forEach(function(r) {
            $85b251bbd816cf83$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $85b251bbd816cf83$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $85b251bbd816cf83$var$_defineProperty(obj, key, value) {
    key = $85b251bbd816cf83$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $85b251bbd816cf83$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $85b251bbd816cf83$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $85b251bbd816cf83$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $85b251bbd816cf83$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $85b251bbd816cf83$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $85b251bbd816cf83$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $85b251bbd816cf83$var$_toPropertyKey(arg) {
    var key = $85b251bbd816cf83$var$_toPrimitive(arg, "string");
    return $85b251bbd816cf83$var$_typeof(key) === "symbol" ? key : String(key);
}
function $85b251bbd816cf83$var$_toPrimitive(input, hint) {
    if ($85b251bbd816cf83$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($85b251bbd816cf83$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $85b251bbd816cf83$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $85b251bbd816cf83$var$_setPrototypeOf(subClass, superClass);
}
function $85b251bbd816cf83$var$_setPrototypeOf(o, p) {
    $85b251bbd816cf83$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $85b251bbd816cf83$var$_setPrototypeOf(o, p);
}
function $85b251bbd816cf83$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $85b251bbd816cf83$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $85b251bbd816cf83$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $85b251bbd816cf83$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $85b251bbd816cf83$var$_possibleConstructorReturn(this, result);
    };
}
function $85b251bbd816cf83$var$_possibleConstructorReturn(self, call) {
    if (call && ($85b251bbd816cf83$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $85b251bbd816cf83$var$_assertThisInitialized(self);
}
function $85b251bbd816cf83$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $85b251bbd816cf83$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $85b251bbd816cf83$var$_getPrototypeOf(o) {
    $85b251bbd816cf83$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $85b251bbd816cf83$var$_getPrototypeOf(o);
}
var $85b251bbd816cf83$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $85b251bbd816cf83$var$_inherits(Animate, _PureComponent);
    var _super = $85b251bbd816cf83$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $85b251bbd816cf83$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($85b251bbd816cf83$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($85b251bbd816cf83$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $85b251bbd816cf83$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $85b251bbd816cf83$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $85b251bbd816cf83$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $85b251bbd816cf83$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $85b251bbd816cf83$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $2405e375887ef8eb$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $85b251bbd816cf83$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $4cbf2cae0e990b76$export$2e2bcd8739ae039)(from, to, (0, $76a15591a87ba8e0$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($85b251bbd816cf83$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $28cf6a7385103719$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($85b251bbd816cf83$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $28cf6a7385103719$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($85b251bbd816cf83$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $8fc08b46df15d7b3$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $85b251bbd816cf83$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $28cf6a7385103719$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $85b251bbd816cf83$var$_objectWithoutProperties(_this$props4, $85b251bbd816cf83$var$_excluded);
                var count = (0, $acw62.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $acw62.cloneElement)(container, $85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread({}, others), {}, {
                        style: $85b251bbd816cf83$var$_objectSpread($85b251bbd816cf83$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $acw62.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, $acw62.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $acw62.PureComponent));
$85b251bbd816cf83$var$Animate.displayName = 'Animate';
$85b251bbd816cf83$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$85b251bbd816cf83$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
var $85b251bbd816cf83$export$2e2bcd8739ae039 = $85b251bbd816cf83$var$Animate;




var $324cdcf3b9db18d1$export$2e2bcd8739ae039 = (0, $85b251bbd816cf83$export$2e2bcd8739ae039);






/**
 * @fileOverview Cross
 */ var $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$b43ffe30f81b14f2$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $acw62 = parcelRequire("acw62");



var $c9d0ae50fd1d1372$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c9d0ae50fd1d1372$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$c9d0ae50fd1d1372$exports = $c9d0ae50fd1d1372$var$last;



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");






function $59d4ad4b8fae5b14$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $59d4ad4b8fae5b14$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $59d4ad4b8fae5b14$var$_typeof(o);
}
function $59d4ad4b8fae5b14$var$_slicedToArray(arr, i) {
    return $59d4ad4b8fae5b14$var$_arrayWithHoles(arr) || $59d4ad4b8fae5b14$var$_iterableToArrayLimit(arr, i) || $59d4ad4b8fae5b14$var$_unsupportedIterableToArray(arr, i) || $59d4ad4b8fae5b14$var$_nonIterableRest();
}
function $59d4ad4b8fae5b14$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $59d4ad4b8fae5b14$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $59d4ad4b8fae5b14$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $59d4ad4b8fae5b14$var$_arrayLikeToArray(o, minLen);
}
function $59d4ad4b8fae5b14$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $59d4ad4b8fae5b14$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $59d4ad4b8fae5b14$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $59d4ad4b8fae5b14$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $59d4ad4b8fae5b14$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $59d4ad4b8fae5b14$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $59d4ad4b8fae5b14$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $59d4ad4b8fae5b14$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $59d4ad4b8fae5b14$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $59d4ad4b8fae5b14$var$_toPropertyKey(t) {
    var i = $59d4ad4b8fae5b14$var$_toPrimitive(t, "string");
    return "symbol" == $59d4ad4b8fae5b14$var$_typeof(i) ? i : i + "";
}
function $59d4ad4b8fae5b14$var$_toPrimitive(t, r) {
    if ("object" != $59d4ad4b8fae5b14$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $59d4ad4b8fae5b14$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $59d4ad4b8fae5b14$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $59d4ad4b8fae5b14$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $59d4ad4b8fae5b14$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $59d4ad4b8fae5b14$var$FIXED_CSS_LENGTH_UNITS = Object.keys($59d4ad4b8fae5b14$var$CONVERSION_RATES);
var $59d4ad4b8fae5b14$var$STR_NAN = 'NaN';
function $59d4ad4b8fae5b14$var$convertToPx(value, unit) {
    return value * $59d4ad4b8fae5b14$var$CONVERSION_RATES[unit];
}
var $59d4ad4b8fae5b14$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $59d4ad4b8fae5b14$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !$59d4ad4b8fae5b14$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($59d4ad4b8fae5b14$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $59d4ad4b8fae5b14$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    return $59d4ad4b8fae5b14$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $59d4ad4b8fae5b14$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $59d4ad4b8fae5b14$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
}();
function $59d4ad4b8fae5b14$var$calculateArithmetic(expr) {
    if (expr.includes($59d4ad4b8fae5b14$var$STR_NAN)) return $59d4ad4b8fae5b14$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $59d4ad4b8fae5b14$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $59d4ad4b8fae5b14$var$STR_NAN;
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $59d4ad4b8fae5b14$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $59d4ad4b8fae5b14$var$STR_NAN;
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $59d4ad4b8fae5b14$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $59d4ad4b8fae5b14$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = $59d4ad4b8fae5b14$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $59d4ad4b8fae5b14$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$PARENTHESES_REGEX, $59d4ad4b8fae5b14$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $59d4ad4b8fae5b14$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $59d4ad4b8fae5b14$var$calculateParentheses(newExpr);
    newExpr = $59d4ad4b8fae5b14$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $59d4ad4b8fae5b14$export$c891f73c9c6d00c9(expression) {
    try {
        return $59d4ad4b8fae5b14$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $59d4ad4b8fae5b14$var$STR_NAN;
    }
}
function $59d4ad4b8fae5b14$export$254eac204f89fd7d(expression) {
    var result = $59d4ad4b8fae5b14$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $59d4ad4b8fae5b14$var$STR_NAN) // notify the user
    return '';
    return result;
}


var $964be52cc11879b4$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $964be52cc11879b4$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $964be52cc11879b4$var$_extends() {
    $964be52cc11879b4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $964be52cc11879b4$var$_extends.apply(this, arguments);
}
function $964be52cc11879b4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $964be52cc11879b4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $964be52cc11879b4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $964be52cc11879b4$var$_slicedToArray(arr, i) {
    return $964be52cc11879b4$var$_arrayWithHoles(arr) || $964be52cc11879b4$var$_iterableToArrayLimit(arr, i) || $964be52cc11879b4$var$_unsupportedIterableToArray(arr, i) || $964be52cc11879b4$var$_nonIterableRest();
}
function $964be52cc11879b4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $964be52cc11879b4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $964be52cc11879b4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $964be52cc11879b4$var$_arrayLikeToArray(o, minLen);
}
function $964be52cc11879b4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $964be52cc11879b4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $964be52cc11879b4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $964be52cc11879b4$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $964be52cc11879b4$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($964be52cc11879b4$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $41867cca6cb93873$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $41867cca6cb93873$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $964be52cc11879b4$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $964be52cc11879b4$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $964be52cc11879b4$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $964be52cc11879b4$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $964be52cc11879b4$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(children) ? children.toString().split($964be52cc11879b4$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $964be52cc11879b4$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $964be52cc11879b4$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $964be52cc11879b4$var$getWordsWithoutCalculate(children);
        return $964be52cc11879b4$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $964be52cc11879b4$var$getWordsWithoutCalculate(children);
};
var $964be52cc11879b4$var$DEFAULT_FILL = '#808080';
var $964be52cc11879b4$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $964be52cc11879b4$var$DEFAULT_FILL : _ref5$fill, props = $964be52cc11879b4$var$_objectWithoutProperties(_ref5, $964be52cc11879b4$var$_excluded);
    var wordsByLines = (0, $acw62.useMemo)(function() {
        return $964be52cc11879b4$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $964be52cc11879b4$var$_objectWithoutProperties(props, $964be52cc11879b4$var$_excluded2);
    if (!(0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(propsX) || !(0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $59d4ad4b8fae5b14$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $59d4ad4b8fae5b14$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $59d4ad4b8fae5b14$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", $964be52cc11879b4$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $964be52cc11879b4$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
};






var $acw62 = parcelRequire("acw62");



function $0f9bc5dd76ad1109$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0f9bc5dd76ad1109$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0f9bc5dd76ad1109$var$_typeof(o);
}
function $0f9bc5dd76ad1109$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f9bc5dd76ad1109$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f9bc5dd76ad1109$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0f9bc5dd76ad1109$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f9bc5dd76ad1109$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0f9bc5dd76ad1109$var$_defineProperty(obj, key, value) {
    key = $0f9bc5dd76ad1109$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0f9bc5dd76ad1109$var$_toPropertyKey(t) {
    var i = $0f9bc5dd76ad1109$var$_toPrimitive(t, "string");
    return "symbol" == $0f9bc5dd76ad1109$var$_typeof(i) ? i : i + "";
}
function $0f9bc5dd76ad1109$var$_toPrimitive(t, r) {
    if ("object" != $0f9bc5dd76ad1109$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0f9bc5dd76ad1109$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0f9bc5dd76ad1109$var$_slicedToArray(arr, i) {
    return $0f9bc5dd76ad1109$var$_arrayWithHoles(arr) || $0f9bc5dd76ad1109$var$_iterableToArrayLimit(arr, i) || $0f9bc5dd76ad1109$var$_unsupportedIterableToArray(arr, i) || $0f9bc5dd76ad1109$var$_nonIterableRest();
}
function $0f9bc5dd76ad1109$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0f9bc5dd76ad1109$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0f9bc5dd76ad1109$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0f9bc5dd76ad1109$var$_arrayLikeToArray(o, minLen);
}
function $0f9bc5dd76ad1109$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0f9bc5dd76ad1109$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0f9bc5dd76ad1109$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $0f9bc5dd76ad1109$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $0f9bc5dd76ad1109$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $0f9bc5dd76ad1109$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $0f9bc5dd76ad1109$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $0f9bc5dd76ad1109$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $0f9bc5dd76ad1109$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $0f9bc5dd76ad1109$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $cd015374923bb5c7$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $cd015374923bb5c7$export$9d80152e23bae434)(scale);
        var ticks = (0, $cd015374923bb5c7$export$ac086aaa4358d590)(scale, $0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread({}, result), {}, $0f9bc5dd76ad1109$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $0f9bc5dd76ad1109$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $0f9bc5dd76ad1109$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $0f9bc5dd76ad1109$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $0f9bc5dd76ad1109$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $0f9bc5dd76ad1109$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $0f9bc5dd76ad1109$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $0f9bc5dd76ad1109$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $0f9bc5dd76ad1109$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $0f9bc5dd76ad1109$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $0f9bc5dd76ad1109$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var $0f9bc5dd76ad1109$export$88d525dabc04abcd = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, $acw62.isValidElement)(tick) && !(0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(tick) && typeof tick !== 'boolean' ? tick.className : '';
};


function $77be8884b5ec622c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $77be8884b5ec622c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $77be8884b5ec622c$var$_typeof(o);
}
var $77be8884b5ec622c$var$_excluded = [
    "offset"
];
function $77be8884b5ec622c$var$_toConsumableArray(arr) {
    return $77be8884b5ec622c$var$_arrayWithoutHoles(arr) || $77be8884b5ec622c$var$_iterableToArray(arr) || $77be8884b5ec622c$var$_unsupportedIterableToArray(arr) || $77be8884b5ec622c$var$_nonIterableSpread();
}
function $77be8884b5ec622c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $77be8884b5ec622c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $77be8884b5ec622c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $77be8884b5ec622c$var$_arrayLikeToArray(o, minLen);
}
function $77be8884b5ec622c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $77be8884b5ec622c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $77be8884b5ec622c$var$_arrayLikeToArray(arr);
}
function $77be8884b5ec622c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $77be8884b5ec622c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $77be8884b5ec622c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $77be8884b5ec622c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $77be8884b5ec622c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77be8884b5ec622c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77be8884b5ec622c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $77be8884b5ec622c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77be8884b5ec622c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $77be8884b5ec622c$var$_defineProperty(obj, key, value) {
    key = $77be8884b5ec622c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $77be8884b5ec622c$var$_toPropertyKey(t) {
    var i = $77be8884b5ec622c$var$_toPrimitive(t, "string");
    return "symbol" == $77be8884b5ec622c$var$_typeof(i) ? i : i + "";
}
function $77be8884b5ec622c$var$_toPrimitive(t, r) {
    if ("object" != $77be8884b5ec622c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $77be8884b5ec622c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $77be8884b5ec622c$var$_extends() {
    $77be8884b5ec622c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $77be8884b5ec622c$var$_extends.apply(this, arguments);
}
var $77be8884b5ec622c$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(formatter)) return formatter(label);
    return label;
};
var $77be8884b5ec622c$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $77be8884b5ec622c$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $77be8884b5ec622c$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(labelProps.id) ? (0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", $77be8884b5ec622c$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $77be8884b5ec622c$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $77be8884b5ec622c$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $77be8884b5ec622c$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $77be8884b5ec622c$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $77be8884b5ec622c$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $77be8884b5ec622c$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $77be8884b5ec622c$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $77be8884b5ec622c$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $77be8884b5ec622c$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $77be8884b5ec622c$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(position) && ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(position.x) || (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(position.x)) && ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(position.y) || (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(position.y))) return $77be8884b5ec622c$var$_objectSpread({
        x: x + (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $77be8884b5ec622c$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $77be8884b5ec622c$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(viewBox.cx);
};
function $77be8884b5ec622c$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $77be8884b5ec622c$var$_objectWithoutProperties(_ref4, $77be8884b5ec622c$var$_excluded);
    var props = $77be8884b5ec622c$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(children) && !/*#__PURE__*/ (0, $acw62.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(content)) return /*#__PURE__*/ (0, $acw62.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(content)) {
        label = /*#__PURE__*/ (0, $acw62.createElement)(content, props);
        if (/*#__PURE__*/ (0, $acw62.isValidElement)(label)) return label;
    } else label = $77be8884b5ec622c$var$getLabel(props);
    var isPolarLabel = $77be8884b5ec622c$var$isPolar(viewBox);
    var attrs = (0, $008f02516c156322$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $77be8884b5ec622c$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $77be8884b5ec622c$var$getAttrsOfPolarLabel(props) : $77be8884b5ec622c$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $964be52cc11879b4$export$5f1af8db9871e1d6), $77be8884b5ec622c$var$_extends({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$77be8884b5ec622c$export$b04be29aa201d4f5.displayName = 'Label';
var $77be8884b5ec622c$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(height)) {
        if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(top) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(cx) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $77be8884b5ec622c$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77be8884b5ec622c$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77be8884b5ec622c$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(label)) {
        if (label.type === $77be8884b5ec622c$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $acw62.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77be8884b5ec622c$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77be8884b5ec622c$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $77be8884b5ec622c$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $77be8884b5ec622c$var$parseViewBox(parentProps);
    var explicitChildren = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, $77be8884b5ec622c$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $77be8884b5ec622c$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($77be8884b5ec622c$var$_toConsumableArray(explicitChildren));
};
$77be8884b5ec622c$export$b04be29aa201d4f5.parseViewBox = $77be8884b5ec622c$var$parseViewBox;
$77be8884b5ec622c$export$b04be29aa201d4f5.renderCallByParent = $77be8884b5ec622c$var$renderCallByParent;





function $88ab0dba0fc78576$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $88ab0dba0fc78576$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $88ab0dba0fc78576$var$_typeof(o);
}
var $88ab0dba0fc78576$var$_excluded = [
    "valueAccessor"
], $88ab0dba0fc78576$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $88ab0dba0fc78576$var$_toConsumableArray(arr) {
    return $88ab0dba0fc78576$var$_arrayWithoutHoles(arr) || $88ab0dba0fc78576$var$_iterableToArray(arr) || $88ab0dba0fc78576$var$_unsupportedIterableToArray(arr) || $88ab0dba0fc78576$var$_nonIterableSpread();
}
function $88ab0dba0fc78576$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $88ab0dba0fc78576$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $88ab0dba0fc78576$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $88ab0dba0fc78576$var$_arrayLikeToArray(o, minLen);
}
function $88ab0dba0fc78576$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $88ab0dba0fc78576$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $88ab0dba0fc78576$var$_arrayLikeToArray(arr);
}
function $88ab0dba0fc78576$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $88ab0dba0fc78576$var$_extends() {
    $88ab0dba0fc78576$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $88ab0dba0fc78576$var$_extends.apply(this, arguments);
}
function $88ab0dba0fc78576$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $88ab0dba0fc78576$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $88ab0dba0fc78576$var$ownKeys(Object(t), !0).forEach(function(r) {
            $88ab0dba0fc78576$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $88ab0dba0fc78576$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $88ab0dba0fc78576$var$_defineProperty(obj, key, value) {
    key = $88ab0dba0fc78576$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $88ab0dba0fc78576$var$_toPropertyKey(t) {
    var i = $88ab0dba0fc78576$var$_toPrimitive(t, "string");
    return "symbol" == $88ab0dba0fc78576$var$_typeof(i) ? i : i + "";
}
function $88ab0dba0fc78576$var$_toPrimitive(t, r) {
    if ("object" != $88ab0dba0fc78576$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $88ab0dba0fc78576$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $88ab0dba0fc78576$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $88ab0dba0fc78576$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $88ab0dba0fc78576$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $88ab0dba0fc78576$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($c9d0ae50fd1d1372$exports)))(entry.value) : entry.value;
};
function $88ab0dba0fc78576$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $88ab0dba0fc78576$var$defaultAccessor : _ref$valueAccessor, restProps = $88ab0dba0fc78576$var$_objectWithoutProperties(_ref, $88ab0dba0fc78576$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $88ab0dba0fc78576$var$_objectWithoutProperties(restProps, $88ab0dba0fc78576$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $77be8884b5ec622c$export$b04be29aa201d4f5), $88ab0dba0fc78576$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $77be8884b5ec622c$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(clockWise) ? entry : $88ab0dba0fc78576$var$_objectSpread($88ab0dba0fc78576$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$88ab0dba0fc78576$export$835fcf23ab7bf88.displayName = 'LabelList';
function $88ab0dba0fc78576$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f9ff2e983beb6b86$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, $88ab0dba0fc78576$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $88ab0dba0fc78576$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, $88ab0dba0fc78576$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $88ab0dba0fc78576$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($88ab0dba0fc78576$var$_toConsumableArray(explicitChildren));
}
$88ab0dba0fc78576$export$835fcf23ab7bf88.renderCallByParent = $88ab0dba0fc78576$var$renderCallByParent;








var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $0658be17f7793a43$exports = {};

var $8e492c1d7a7ea307$exports = {};

/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $ff813e49bf3cca3d$exports(Object.getPrototypeOf, Object);
$8e492c1d7a7ea307$exports = $8e492c1d7a7ea307$var$getPrototype;



/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$61269cf1f3e020be$exports(value) || $a7f8a2555793d7d3$exports(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $8e492c1d7a7ea307$exports(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
$0658be17f7793a43$exports = $0658be17f7793a43$var$isPlainObject;


var $726b932117967293$exports = {};


/** `Object#toString` result references. */ var $726b932117967293$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $726b932117967293$var$isBoolean(value) {
    return value === true || value === false || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $726b932117967293$var$boolTag;
}
$726b932117967293$exports = $726b932117967293$var$isBoolean;




var $acw62 = parcelRequire("acw62");



function $70f75e095c9bb92d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $70f75e095c9bb92d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $70f75e095c9bb92d$var$_typeof(o);
}
function $70f75e095c9bb92d$var$_extends() {
    $70f75e095c9bb92d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $70f75e095c9bb92d$var$_extends.apply(this, arguments);
}
function $70f75e095c9bb92d$var$_slicedToArray(arr, i) {
    return $70f75e095c9bb92d$var$_arrayWithHoles(arr) || $70f75e095c9bb92d$var$_iterableToArrayLimit(arr, i) || $70f75e095c9bb92d$var$_unsupportedIterableToArray(arr, i) || $70f75e095c9bb92d$var$_nonIterableRest();
}
function $70f75e095c9bb92d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $70f75e095c9bb92d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $70f75e095c9bb92d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $70f75e095c9bb92d$var$_arrayLikeToArray(o, minLen);
}
function $70f75e095c9bb92d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $70f75e095c9bb92d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $70f75e095c9bb92d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $70f75e095c9bb92d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70f75e095c9bb92d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70f75e095c9bb92d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $70f75e095c9bb92d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70f75e095c9bb92d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $70f75e095c9bb92d$var$_defineProperty(obj, key, value) {
    key = $70f75e095c9bb92d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $70f75e095c9bb92d$var$_toPropertyKey(t) {
    var i = $70f75e095c9bb92d$var$_toPrimitive(t, "string");
    return "symbol" == $70f75e095c9bb92d$var$_typeof(i) ? i : i + "";
}
function $70f75e095c9bb92d$var$_toPrimitive(t, r) {
    if ("object" != $70f75e095c9bb92d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $70f75e095c9bb92d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $70f75e095c9bb92d$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $70f75e095c9bb92d$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $70f75e095c9bb92d$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $70f75e095c9bb92d$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $70f75e095c9bb92d$var$_objectSpread($70f75e095c9bb92d$var$_objectSpread({}, $70f75e095c9bb92d$var$defaultProps), rectangleProps);
    var pathRef = (0, $acw62.useRef)();
    var _useState = (0, $acw62.useState)(-1), _useState2 = $70f75e095c9bb92d$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $70f75e095c9bb92d$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $70f75e095c9bb92d$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $70f75e095c9bb92d$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $70f75e095c9bb92d$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $acw62 = parcelRequire("acw62");



function $b0f8b4122c292e26$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b0f8b4122c292e26$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b0f8b4122c292e26$var$_typeof(o);
}
function $b0f8b4122c292e26$var$_extends() {
    $b0f8b4122c292e26$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0f8b4122c292e26$var$_extends.apply(this, arguments);
}
function $b0f8b4122c292e26$var$_slicedToArray(arr, i) {
    return $b0f8b4122c292e26$var$_arrayWithHoles(arr) || $b0f8b4122c292e26$var$_iterableToArrayLimit(arr, i) || $b0f8b4122c292e26$var$_unsupportedIterableToArray(arr, i) || $b0f8b4122c292e26$var$_nonIterableRest();
}
function $b0f8b4122c292e26$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b0f8b4122c292e26$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b0f8b4122c292e26$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b0f8b4122c292e26$var$_arrayLikeToArray(o, minLen);
}
function $b0f8b4122c292e26$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b0f8b4122c292e26$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b0f8b4122c292e26$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b0f8b4122c292e26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b0f8b4122c292e26$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b0f8b4122c292e26$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b0f8b4122c292e26$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b0f8b4122c292e26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b0f8b4122c292e26$var$_defineProperty(obj, key, value) {
    key = $b0f8b4122c292e26$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b0f8b4122c292e26$var$_toPropertyKey(t) {
    var i = $b0f8b4122c292e26$var$_toPrimitive(t, "string");
    return "symbol" == $b0f8b4122c292e26$var$_typeof(i) ? i : i + "";
}
function $b0f8b4122c292e26$var$_toPrimitive(t, r) {
    if ("object" != $b0f8b4122c292e26$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b0f8b4122c292e26$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b0f8b4122c292e26$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $b0f8b4122c292e26$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $b0f8b4122c292e26$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $b0f8b4122c292e26$var$_objectSpread($b0f8b4122c292e26$var$_objectSpread({}, $b0f8b4122c292e26$var$defaultProps), props);
    var pathRef = (0, $acw62.useRef)();
    var _useState = (0, $acw62.useState)(-1), _useState2 = $b0f8b4122c292e26$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $b0f8b4122c292e26$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $b0f8b4122c292e26$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $b0f8b4122c292e26$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $b0f8b4122c292e26$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $acw62 = parcelRequire("acw62");




function $353ca4069312fa59$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $353ca4069312fa59$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $353ca4069312fa59$var$_typeof(o);
}
function $353ca4069312fa59$var$_extends() {
    $353ca4069312fa59$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $353ca4069312fa59$var$_extends.apply(this, arguments);
}
function $353ca4069312fa59$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $353ca4069312fa59$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $353ca4069312fa59$var$ownKeys(Object(t), !0).forEach(function(r) {
            $353ca4069312fa59$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $353ca4069312fa59$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $353ca4069312fa59$var$_defineProperty(obj, key, value) {
    key = $353ca4069312fa59$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $353ca4069312fa59$var$_toPropertyKey(t) {
    var i = $353ca4069312fa59$var$_toPrimitive(t, "string");
    return "symbol" == $353ca4069312fa59$var$_typeof(i) ? i : i + "";
}
function $353ca4069312fa59$var$_toPrimitive(t, r) {
    if ("object" != $353ca4069312fa59$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $353ca4069312fa59$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $353ca4069312fa59$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $353ca4069312fa59$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $353ca4069312fa59$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $353ca4069312fa59$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $353ca4069312fa59$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $353ca4069312fa59$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $353ca4069312fa59$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $353ca4069312fa59$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $353ca4069312fa59$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $353ca4069312fa59$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $353ca4069312fa59$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $353ca4069312fa59$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $353ca4069312fa59$var$_objectSpread($353ca4069312fa59$var$_objectSpread({}, $353ca4069312fa59$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $353ca4069312fa59$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $353ca4069312fa59$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $353ca4069312fa59$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $4696e249b64cd95e$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $4696e249b64cd95e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4696e249b64cd95e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4696e249b64cd95e$var$_typeof(o);
}
function $4696e249b64cd95e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4696e249b64cd95e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4696e249b64cd95e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4696e249b64cd95e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4696e249b64cd95e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4696e249b64cd95e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4696e249b64cd95e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4696e249b64cd95e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4696e249b64cd95e$var$_defineProperty(obj, key, value) {
    key = $4696e249b64cd95e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4696e249b64cd95e$var$_toPropertyKey(t) {
    var i = $4696e249b64cd95e$var$_toPrimitive(t, "string");
    return "symbol" == $4696e249b64cd95e$var$_typeof(i) ? i : i + "";
}
function $4696e249b64cd95e$var$_toPrimitive(t, r) {
    if ("object" != $4696e249b64cd95e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4696e249b64cd95e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $4696e249b64cd95e$var$defaultPropTransformer(option, props) {
    return $4696e249b64cd95e$var$_objectSpread($4696e249b64cd95e$var$_objectSpread({}, props), option);
}
function $4696e249b64cd95e$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $4696e249b64cd95e$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70f75e095c9bb92d$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b0f8b4122c292e26$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $353ca4069312fa59$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($4696e249b64cd95e$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $61aa615b92178b76$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $4696e249b64cd95e$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) return option.props;
    return option;
}
function $4696e249b64cd95e$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $4696e249b64cd95e$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = $4696e249b64cd95e$var$_objectWithoutProperties(_ref2, $4696e249b64cd95e$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) shape = /*#__PURE__*/ (0, $acw62.cloneElement)(option, $4696e249b64cd95e$var$_objectSpread($4696e249b64cd95e$var$_objectSpread({}, props), $4696e249b64cd95e$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($0658be17f7793a43$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($726b932117967293$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4696e249b64cd95e$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4696e249b64cd95e$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $4696e249b64cd95e$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function $4696e249b64cd95e$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function $4696e249b64cd95e$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function $4696e249b64cd95e$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $4696e249b64cd95e$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $4696e249b64cd95e$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $4696e249b64cd95e$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($4696e249b64cd95e$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $4696e249b64cd95e$export$7c9a98b3f068686f;
    else if ($4696e249b64cd95e$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $4696e249b64cd95e$export$b356b51e8337a02f;
    else if ($4696e249b64cd95e$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $4696e249b64cd95e$export$559c3a78b4889350;
    return comparison;
}
function $4696e249b64cd95e$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($4696e249b64cd95e$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if ($4696e249b64cd95e$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if ($4696e249b64cd95e$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function $4696e249b64cd95e$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($4696e249b64cd95e$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($4696e249b64cd95e$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($4696e249b64cd95e$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $4696e249b64cd95e$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $4696e249b64cd95e$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $4696e249b64cd95e$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($394ab417e9bd75cc$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $4696e249b64cd95e$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}



var $b5efd6b8794dbdeb$var$_excluded = [
    "x",
    "y"
];
function $b5efd6b8794dbdeb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b5efd6b8794dbdeb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b5efd6b8794dbdeb$var$_typeof(o);
}
function $b5efd6b8794dbdeb$var$_extends() {
    $b5efd6b8794dbdeb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b5efd6b8794dbdeb$var$_extends.apply(this, arguments);
}
function $b5efd6b8794dbdeb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5efd6b8794dbdeb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5efd6b8794dbdeb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b5efd6b8794dbdeb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5efd6b8794dbdeb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b5efd6b8794dbdeb$var$_defineProperty(obj, key, value) {
    key = $b5efd6b8794dbdeb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b5efd6b8794dbdeb$var$_toPropertyKey(t) {
    var i = $b5efd6b8794dbdeb$var$_toPrimitive(t, "string");
    return "symbol" == $b5efd6b8794dbdeb$var$_typeof(i) ? i : i + "";
}
function $b5efd6b8794dbdeb$var$_toPrimitive(t, r) {
    if ("object" != $b5efd6b8794dbdeb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b5efd6b8794dbdeb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b5efd6b8794dbdeb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b5efd6b8794dbdeb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b5efd6b8794dbdeb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $b5efd6b8794dbdeb$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $b5efd6b8794dbdeb$var$_objectWithoutProperties(_ref, $b5efd6b8794dbdeb$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $b5efd6b8794dbdeb$var$_objectSpread($b5efd6b8794dbdeb$var$_objectSpread($b5efd6b8794dbdeb$var$_objectSpread($b5efd6b8794dbdeb$var$_objectSpread($b5efd6b8794dbdeb$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $b5efd6b8794dbdeb$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4696e249b64cd95e$export$6428a7f2611ef1fa), $b5efd6b8794dbdeb$var$_extends({
        shapeType: "rectangle",
        propTransformer: $b5efd6b8794dbdeb$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $b5efd6b8794dbdeb$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === 'number') return minPointSize;
        var isValueNumberOrNil = (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(value) || (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(value);
        if (isValueNumberOrNil) return minPointSize(value, index);
        !isValueNumberOrNil && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        return defaultValue;
    };
};


var $e752e700473a8894$var$_excluded = [
    "value",
    "background"
];
var $e752e700473a8894$var$_Bar;
function $e752e700473a8894$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e752e700473a8894$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e752e700473a8894$var$_typeof(o);
}
function $e752e700473a8894$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e752e700473a8894$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e752e700473a8894$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e752e700473a8894$var$_extends() {
    $e752e700473a8894$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e752e700473a8894$var$_extends.apply(this, arguments);
}
function $e752e700473a8894$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e752e700473a8894$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e752e700473a8894$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e752e700473a8894$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e752e700473a8894$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e752e700473a8894$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e752e700473a8894$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e752e700473a8894$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e752e700473a8894$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e752e700473a8894$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e752e700473a8894$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e752e700473a8894$var$_callSuper(t, o, e) {
    return o = $e752e700473a8894$var$_getPrototypeOf(o), $e752e700473a8894$var$_possibleConstructorReturn(t, $e752e700473a8894$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $e752e700473a8894$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $e752e700473a8894$var$_possibleConstructorReturn(self, call) {
    if (call && ($e752e700473a8894$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e752e700473a8894$var$_assertThisInitialized(self);
}
function $e752e700473a8894$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e752e700473a8894$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e752e700473a8894$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e752e700473a8894$var$_getPrototypeOf(o) {
    $e752e700473a8894$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e752e700473a8894$var$_getPrototypeOf(o);
}
function $e752e700473a8894$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e752e700473a8894$var$_setPrototypeOf(subClass, superClass);
}
function $e752e700473a8894$var$_setPrototypeOf(o, p) {
    $e752e700473a8894$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e752e700473a8894$var$_setPrototypeOf(o, p);
}
function $e752e700473a8894$var$_defineProperty(obj, key, value) {
    key = $e752e700473a8894$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e752e700473a8894$var$_toPropertyKey(t) {
    var i = $e752e700473a8894$var$_toPrimitive(t, "string");
    return "symbol" == $e752e700473a8894$var$_typeof(i) ? i : i + "";
}
function $e752e700473a8894$var$_toPrimitive(t, r) {
    if ("object" != $e752e700473a8894$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e752e700473a8894$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e752e700473a8894$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    function Bar() {
        var _this;
        $e752e700473a8894$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $e752e700473a8894$var$_callSuper(this, Bar, [].concat(args));
        $e752e700473a8894$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $e752e700473a8894$var$_defineProperty(_this, "id", (0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('recharts-bar-'));
        $e752e700473a8894$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $e752e700473a8894$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $e752e700473a8894$var$_inherits(Bar, _PureComponent);
    return $e752e700473a8894$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $e752e700473a8894$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // https://github.com/recharts/recharts/issues/5415
                        // eslint-disable-next-line react/no-array-index-key
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b5efd6b8794dbdeb$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($394ab417e9bd75cc$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $008f02516c156322$export$d697c39a2985a4c)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $e752e700473a8894$var$_objectWithoutProperties(entry, $e752e700473a8894$var$_excluded);
                    if (!background) return null;
                    var props = $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b5efd6b8794dbdeb$export$f19074a6842f9217), $e752e700473a8894$var$_extends({
                        key: "background-bar-".concat(i),
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $7f4b989d0f2e91c6$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $cd015374923bb5c7$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $88ab0dba0fc78576$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, $acw62.PureComponent));
$e752e700473a8894$var$_Bar = $e752e700473a8894$export$bbc6c6369b38e3d1;
$e752e700473a8894$var$_defineProperty($e752e700473a8894$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$e752e700473a8894$var$_defineProperty($e752e700473a8894$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: false,
    isAnimationActive: !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $e752e700473a8894$var$_defineProperty($e752e700473a8894$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $cd015374923bb5c7$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var itemDefaultProps = item.type.defaultProps;
    var itemProps = itemDefaultProps !== undefined ? $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, itemDefaultProps), item.props) : item.props;
    var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $cd015374923bb5c7$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $cd015374923bb5c7$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $b5efd6b8794dbdeb$export$c20d73790de171f0)(minPointSizeProp, $e752e700473a8894$var$_Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $cd015374923bb5c7$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $cd015374923bb5c7$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $cd015374923bb5c7$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $e752e700473a8894$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});


function $7dad4d5151ba4a01$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7dad4d5151ba4a01$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7dad4d5151ba4a01$var$_typeof(o);
}
function $7dad4d5151ba4a01$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7dad4d5151ba4a01$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7dad4d5151ba4a01$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7dad4d5151ba4a01$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7dad4d5151ba4a01$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7dad4d5151ba4a01$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7dad4d5151ba4a01$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7dad4d5151ba4a01$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7dad4d5151ba4a01$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7dad4d5151ba4a01$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7dad4d5151ba4a01$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7dad4d5151ba4a01$var$_defineProperty(obj, key, value) {
    key = $7dad4d5151ba4a01$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7dad4d5151ba4a01$var$_toPropertyKey(t) {
    var i = $7dad4d5151ba4a01$var$_toPrimitive(t, "string");
    return "symbol" == $7dad4d5151ba4a01$var$_typeof(i) ? i : i + "";
}
function $7dad4d5151ba4a01$var$_toPrimitive(t, r) {
    if ("object" != $7dad4d5151ba4a01$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7dad4d5151ba4a01$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7dad4d5151ba4a01$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $e752e700473a8894$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort((0, $2ab3a7e25c8aba74$export$6ab1df3197f7c641));
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
                if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === 'no-gap') {
                    var gap = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $cd015374923bb5c7$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $cd015374923bb5c7$export$9d80152e23bae434)(scale);
        var ticks = (0, $cd015374923bb5c7$export$ac086aaa4358d590)(scale, $7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread({}, result), {}, $7dad4d5151ba4a01$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $7dad4d5151ba4a01$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $7dad4d5151ba4a01$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $7dad4d5151ba4a01$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $7dad4d5151ba4a01$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $7dad4d5151ba4a01$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    return $7dad4d5151ba4a01$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
}();
$7dad4d5151ba4a01$var$_defineProperty($7dad4d5151ba4a01$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $7dad4d5151ba4a01$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread({}, res), {}, $7dad4d5151ba4a01$var$_defineProperty({}, key, $7dad4d5151ba4a01$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $7dad4d5151ba4a01$var$_objectSpread($7dad4d5151ba4a01$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($17211428bc2045c4$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($b3635322c399904d$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $7dad4d5151ba4a01$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $7dad4d5151ba4a01$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $7dad4d5151ba4a01$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $b250a459bfd5f59b$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $19a932367b9d461a$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $7dad4d5151ba4a01$export$3ee78d51cffc2b68)(size, angle);
}
function $19a932367b9d461a$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $19a932367b9d461a$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $19a932367b9d461a$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $b250a459bfd5f59b$export$41514b9f058a6886)(ticks, interval + 1);
}




function $ca4e8736ea4f469e$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $b250a459bfd5f59b$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $582ebde04d312f24$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $582ebde04d312f24$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $582ebde04d312f24$var$_typeof(o);
}
function $582ebde04d312f24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $582ebde04d312f24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $582ebde04d312f24$var$ownKeys(Object(t), !0).forEach(function(r) {
            $582ebde04d312f24$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $582ebde04d312f24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $582ebde04d312f24$var$_defineProperty(obj, key, value) {
    key = $582ebde04d312f24$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $582ebde04d312f24$var$_toPropertyKey(t) {
    var i = $582ebde04d312f24$var$_toPrimitive(t, "string");
    return "symbol" == $582ebde04d312f24$var$_typeof(i) ? i : i + "";
}
function $582ebde04d312f24$var$_toPrimitive(t, r) {
    if ("object" != $582ebde04d312f24$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $582ebde04d312f24$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $582ebde04d312f24$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $582ebde04d312f24$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $582ebde04d312f24$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(interval) || (0, $795299547b24e258$export$98f03c5d19621d70).isSsr) return (0, $19a932367b9d461a$export$beeebbe3ff1b306b)(ticks, typeof interval === 'number' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $41867cca6cb93873$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $19a932367b9d461a$export$a1966f4ad955c82b)((0, $41867cca6cb93873$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $41867cca6cb93873$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $19a932367b9d461a$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $ca4e8736ea4f469e$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $582ebde04d312f24$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $582ebde04d312f24$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}



var $acw62 = parcelRequire("acw62");











var $247385db510d7b7c$var$_excluded = [
    "viewBox"
], $247385db510d7b7c$var$_excluded2 = [
    "viewBox"
], $247385db510d7b7c$var$_excluded3 = [
    "ticks"
];
function $247385db510d7b7c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $247385db510d7b7c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $247385db510d7b7c$var$_typeof(o);
}
function $247385db510d7b7c$var$_extends() {
    $247385db510d7b7c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $247385db510d7b7c$var$_extends.apply(this, arguments);
}
function $247385db510d7b7c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $247385db510d7b7c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $247385db510d7b7c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $247385db510d7b7c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $247385db510d7b7c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $247385db510d7b7c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $247385db510d7b7c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $247385db510d7b7c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $247385db510d7b7c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $247385db510d7b7c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $247385db510d7b7c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $247385db510d7b7c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $247385db510d7b7c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $247385db510d7b7c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $247385db510d7b7c$var$_callSuper(t, o, e) {
    return o = $247385db510d7b7c$var$_getPrototypeOf(o), $247385db510d7b7c$var$_possibleConstructorReturn(t, $247385db510d7b7c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $247385db510d7b7c$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $247385db510d7b7c$var$_possibleConstructorReturn(self, call) {
    if (call && ($247385db510d7b7c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $247385db510d7b7c$var$_assertThisInitialized(self);
}
function $247385db510d7b7c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $247385db510d7b7c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($247385db510d7b7c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $247385db510d7b7c$var$_getPrototypeOf(o) {
    $247385db510d7b7c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $247385db510d7b7c$var$_getPrototypeOf(o);
}
function $247385db510d7b7c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $247385db510d7b7c$var$_setPrototypeOf(subClass, superClass);
}
function $247385db510d7b7c$var$_setPrototypeOf(o, p) {
    $247385db510d7b7c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $247385db510d7b7c$var$_setPrototypeOf(o, p);
}
function $247385db510d7b7c$var$_defineProperty(obj, key, value) {
    key = $247385db510d7b7c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $247385db510d7b7c$var$_toPropertyKey(t) {
    var i = $247385db510d7b7c$var$_toPrimitive(t, "string");
    return "symbol" == $247385db510d7b7c$var$_typeof(i) ? i : i + "";
}
function $247385db510d7b7c$var$_toPrimitive(t, r) {
    if ("object" != $247385db510d7b7c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $247385db510d7b7c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $247385db510d7b7c$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    function CartesianAxis(props) {
        var _this;
        $247385db510d7b7c$var$_classCallCheck(this, CartesianAxis);
        _this = $247385db510d7b7c$var$_callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $247385db510d7b7c$var$_inherits(CartesianAxis, _Component);
    return $247385db510d7b7c$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $247385db510d7b7c$var$_objectWithoutProperties(_ref, $247385db510d7b7c$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $247385db510d7b7c$var$_objectWithoutProperties(_this$props, $247385db510d7b7c$var$_excluded2);
                return !(0, $0f60d716238978d6$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $0f60d716238978d6$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $0f60d716238978d6$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false)), (0, $008f02516c156322$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $247385db510d7b7c$var$_extends({}, props, {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $582ebde04d312f24$export$3d27d42b1034de5c)($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $008f02516c156322$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $008f02516c156322$export$d697c39a2985a4c)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $247385db510d7b7c$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $247385db510d7b7c$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $247385db510d7b7c$var$_objectWithoutProperties(_this$props8, $247385db510d7b7c$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $77be8884b5ec622c$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                var combinedClassName = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(props.className, 'recharts-cartesian-axis-tick-value');
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
                    className: combinedClassName
                }));
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) tickItem = option($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
                    className: combinedClassName
                }));
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $964be52cc11879b4$export$5f1af8db9871e1d6), $247385db510d7b7c$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $acw62.Component));
$247385db510d7b7c$var$_defineProperty($247385db510d7b7c$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$247385db510d7b7c$var$_defineProperty($247385db510d7b7c$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});



var $acw62 = parcelRequire("acw62");

var $6578d05764c8afc8$exports = {};
var $acb3703f94fb96ce$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $acb3703f94fb96ce$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$ac2c42592aa05543$exports(collection)) {
            var iteratee = $5aba4f6d9f8304a3$exports(predicate, 3);
            collection = $08f0eaf3fbcb2fde$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$acb3703f94fb96ce$exports = $acb3703f94fb96ce$var$createFind;


var $90893b1abc59631b$exports = {};


var $20712de2064d78dd$exports = {};
var $6ceabe126a95a54e$exports = {};
var $dc614d828223dea6$exports = {};
var $0542da1d887b1c4d$exports = {};
var $ef99cce288c7323e$exports = {};
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$ef99cce288c7323e$exports = $ef99cce288c7323e$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $ef99cce288c7323e$exports(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, '') : string;
}
$0542da1d887b1c4d$exports = $0542da1d887b1c4d$var$baseTrim;




/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($6b5a5095e0934938$exports(value)) return $dc614d828223dea6$var$NAN;
    if ($f9ff2e983beb6b86$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f9ff2e983beb6b86$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $0542da1d887b1c4d$exports(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
$dc614d828223dea6$exports = $dc614d828223dea6$var$toNumber;


/** Used as references for various `Number` constants. */ var $6ceabe126a95a54e$var$INFINITY = 1 / 0, $6ceabe126a95a54e$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6ceabe126a95a54e$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $dc614d828223dea6$exports(value);
    if (value === $6ceabe126a95a54e$var$INFINITY || value === -$6ceabe126a95a54e$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6ceabe126a95a54e$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$6ceabe126a95a54e$exports = $6ceabe126a95a54e$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $20712de2064d78dd$var$toInteger(value) {
    var result = $6ceabe126a95a54e$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$20712de2064d78dd$exports = $20712de2064d78dd$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $90893b1abc59631b$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $90893b1abc59631b$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $20712de2064d78dd$exports(fromIndex);
    if (index < 0) index = $90893b1abc59631b$var$nativeMax(length + index, 0);
    return $a9e76203bd7c412f$exports(array, $5aba4f6d9f8304a3$exports(predicate, 3), index);
}
$90893b1abc59631b$exports = $90893b1abc59631b$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $6578d05764c8afc8$var$find = $acb3703f94fb96ce$exports($90893b1abc59631b$exports);
$6578d05764c8afc8$exports = $6578d05764c8afc8$var$find;




var $74469ccda5093500$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($17f5c88c594eac51$exports)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        'l',
        offset.left,
        't',
        offset.top,
        'w',
        offset.width,
        'h',
        offset.height
    ].join('');
});



function $e573f10901a87cfb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e573f10901a87cfb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e573f10901a87cfb$var$_typeof(o);
}
var $e573f10901a87cfb$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e573f10901a87cfb$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e573f10901a87cfb$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e573f10901a87cfb$export$482c85f2026f212e = /*#__PURE__*/ (0, $acw62.createContext)({});
var $e573f10901a87cfb$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e573f10901a87cfb$export$b18854f928720bc8 = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $e573f10901a87cfb$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $acw62.createContext)(0);
var $e573f10901a87cfb$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $74469ccda5093500$export$7e29f973febe72ad)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e573f10901a87cfb$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $e573f10901a87cfb$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $acw62.useContext)($e573f10901a87cfb$export$e42cfe3f3988c70f);
};
function $e573f10901a87cfb$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return 'There are no available ids.';
    return "Available ids are: ".concat(keys, ".");
}
var $e573f10901a87cfb$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $acw62.useContext)($e573f10901a87cfb$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    return xAxis;
};
var $e573f10901a87cfb$export$1d855c2865750a72 = function useArbitraryXAxis() {
    var xAxisMap = (0, $acw62.useContext)($e573f10901a87cfb$export$92c2a2c8239475bf);
    return (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(xAxisMap);
};
var $e573f10901a87cfb$export$a691147b33d52613 = function useArbitraryYAxis() {
    var yAxisMap = (0, $acw62.useContext)($e573f10901a87cfb$export$40ceabe61e17c4dc);
    return (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(yAxisMap);
};
var $e573f10901a87cfb$export$631ee617f1052e16 = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, $acw62.useContext)($e573f10901a87cfb$export$40ceabe61e17c4dc);
    var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($6578d05764c8afc8$exports)))(yAxisMap, function(axis) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($b3635322c399904d$exports)))(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(yAxisMap);
};
var $e573f10901a87cfb$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $acw62.useContext)($e573f10901a87cfb$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    return yAxis;
};
var $e573f10901a87cfb$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $acw62.useContext)($e573f10901a87cfb$export$29b7735f8b5653b2);
    return viewBox;
};
var $e573f10901a87cfb$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $acw62.useContext)($e573f10901a87cfb$export$482c85f2026f212e);
};
var $e573f10901a87cfb$export$8854f7ece606854b = function useChartWidth() {
    return (0, $acw62.useContext)($e573f10901a87cfb$export$3c3f0c9338cf7530);
};
var $e573f10901a87cfb$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $acw62.useContext)($e573f10901a87cfb$export$b18854f928720bc8);
};


var $eae69ed53f30e7ce$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $eae69ed53f30e7ce$var$_excluded2 = [
    "offset"
];
function $eae69ed53f30e7ce$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $eae69ed53f30e7ce$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eae69ed53f30e7ce$var$_typeof(o);
}
function $eae69ed53f30e7ce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eae69ed53f30e7ce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eae69ed53f30e7ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            $eae69ed53f30e7ce$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eae69ed53f30e7ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eae69ed53f30e7ce$var$_defineProperty(obj, key, value) {
    key = $eae69ed53f30e7ce$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eae69ed53f30e7ce$var$_toPropertyKey(t) {
    var i = $eae69ed53f30e7ce$var$_toPrimitive(t, "string");
    return "symbol" == $eae69ed53f30e7ce$var$_typeof(i) ? i : i + "";
}
function $eae69ed53f30e7ce$var$_toPrimitive(t, r) {
    if ("object" != $eae69ed53f30e7ce$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $eae69ed53f30e7ce$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $eae69ed53f30e7ce$var$_extends() {
    $eae69ed53f30e7ce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eae69ed53f30e7ce$var$_extends.apply(this, arguments);
}
function $eae69ed53f30e7ce$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $eae69ed53f30e7ce$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $eae69ed53f30e7ce$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var $eae69ed53f30e7ce$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $eae69ed53f30e7ce$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $eae69ed53f30e7ce$var$_objectWithoutProperties(props, $eae69ed53f30e7ce$var$_excluded);
        var _filterProps = (0, $008f02516c156322$export$d697c39a2985a4c)(others, false), __ = _filterProps.offset, restOfFilteredProps = $eae69ed53f30e7ce$var$_objectWithoutProperties(_filterProps, $eae69ed53f30e7ce$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $eae69ed53f30e7ce$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $eae69ed53f30e7ce$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $eae69ed53f30e7ce$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $eae69ed53f30e7ce$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $eae69ed53f30e7ce$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $eae69ed53f30e7ce$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $eae69ed53f30e7ce$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $eae69ed53f30e7ce$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $cd015374923bb5c7$export$846dc5ac5fecff74)((0, $582ebde04d312f24$export$3d27d42b1034de5c)($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, (0, $247385db510d7b7c$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
        ticks: (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $eae69ed53f30e7ce$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $cd015374923bb5c7$export$846dc5ac5fecff74)((0, $582ebde04d312f24$export$3d27d42b1034de5c)($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, (0, $247385db510d7b7c$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
        ticks: (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $eae69ed53f30e7ce$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $eae69ed53f30e7ce$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $e573f10901a87cfb$export$8854f7ece606854b)();
    var chartHeight = (0, $e573f10901a87cfb$export$369ae257969c6f9f)();
    var offset = (0, $e573f10901a87cfb$export$99e5207fa7e69f17)();
    var propsIncludingDefaults = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $eae69ed53f30e7ce$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $eae69ed53f30e7ce$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $eae69ed53f30e7ce$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $eae69ed53f30e7ce$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $eae69ed53f30e7ce$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $eae69ed53f30e7ce$var$defaultProps.verticalFill,
        x: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, $e573f10901a87cfb$export$1d855c2865750a72)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, $e573f10901a87cfb$export$631ee617f1052e16)();
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) || x !== +x || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $eae69ed53f30e7ce$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $eae69ed53f30e7ce$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($eae69ed53f30e7ce$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($eae69ed53f30e7ce$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eae69ed53f30e7ce$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eae69ed53f30e7ce$var$HorizontalGridLines, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eae69ed53f30e7ce$var$VerticalGridLines, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eae69ed53f30e7ce$var$HorizontalStripes, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eae69ed53f30e7ce$var$VerticalStripes, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$eae69ed53f30e7ce$export$6440e27b9f186856.displayName = 'CartesianGrid';


var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");







function $af2055905739b7f2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $af2055905739b7f2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $af2055905739b7f2$var$_typeof(o);
}
function $af2055905739b7f2$var$_extends() {
    $af2055905739b7f2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $af2055905739b7f2$var$_extends.apply(this, arguments);
}
function $af2055905739b7f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af2055905739b7f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af2055905739b7f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $af2055905739b7f2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af2055905739b7f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $af2055905739b7f2$var$_defineProperty(obj, key, value) {
    key = $af2055905739b7f2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $af2055905739b7f2$var$_toPropertyKey(t) {
    var i = $af2055905739b7f2$var$_toPrimitive(t, "string");
    return "symbol" == $af2055905739b7f2$var$_typeof(i) ? i : i + "";
}
function $af2055905739b7f2$var$_toPrimitive(t, r) {
    if ("object" != $af2055905739b7f2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $af2055905739b7f2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $af2055905739b7f2$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $9b23116271105198$exports.curveBasisClosed),
    curveBasisOpen: (0, $9b23116271105198$exports.curveBasisOpen),
    curveBasis: (0, $9b23116271105198$exports.curveBasis),
    curveBumpX: (0, $9b23116271105198$exports.curveBumpX),
    curveBumpY: (0, $9b23116271105198$exports.curveBumpY),
    curveLinearClosed: (0, $9b23116271105198$exports.curveLinearClosed),
    curveLinear: (0, $9b23116271105198$exports.curveLinear),
    curveMonotoneX: (0, $9b23116271105198$exports.curveMonotoneX),
    curveMonotoneY: (0, $9b23116271105198$exports.curveMonotoneY),
    curveNatural: (0, $9b23116271105198$exports.curveNatural),
    curveStep: (0, $9b23116271105198$exports.curveStep),
    curveStepAfter: (0, $9b23116271105198$exports.curveStepAfter),
    curveStepBefore: (0, $9b23116271105198$exports.curveStepBefore)
};
var $af2055905739b7f2$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $af2055905739b7f2$var$getX = function getX(p) {
    return p.x;
};
var $af2055905739b7f2$var$getY = function getY(p) {
    return p.y;
};
var $af2055905739b7f2$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($da6130e1e4702e32$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $af2055905739b7f2$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $af2055905739b7f2$var$CURVE_FACTORIES[name] || (0, $9b23116271105198$exports.curveLinear);
};
var $af2055905739b7f2$export$2aa3fd96c49a84a8 = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $af2055905739b7f2$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $af2055905739b7f2$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $af2055905739b7f2$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $af2055905739b7f2$var$_objectSpread($af2055905739b7f2$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $9b23116271105198$exports.area)().y($af2055905739b7f2$var$getY).x1($af2055905739b7f2$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $9b23116271105198$exports.area)().x($af2055905739b7f2$var$getX).y1($af2055905739b7f2$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($af2055905739b7f2$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $9b23116271105198$exports.area)().y($af2055905739b7f2$var$getY).x1($af2055905739b7f2$var$getX).x0(baseLine);
    else if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $9b23116271105198$exports.area)().x($af2055905739b7f2$var$getX).y1($af2055905739b7f2$var$getY).y0(baseLine);
    else lineFunction = (0, $9b23116271105198$exports.line)().x($af2055905739b7f2$var$getX).y($af2055905739b7f2$var$getY);
    lineFunction.defined($af2055905739b7f2$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $af2055905739b7f2$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $af2055905739b7f2$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ $acw62.createElement("path", $af2055905739b7f2$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, false), (0, $909d5f835f4e917b$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};



var $acw62 = parcelRequire("acw62");



function $1ab98349969d46e2$var$_extends() {
    $1ab98349969d46e2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1ab98349969d46e2$var$_extends.apply(this, arguments);
}
var $1ab98349969d46e2$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ $acw62.createElement("circle", $1ab98349969d46e2$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, false), (0, $909d5f835f4e917b$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};









var $f8a3115883abd1dc$var$_excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
], $f8a3115883abd1dc$var$_excluded2 = [
    "key"
];
function $f8a3115883abd1dc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f8a3115883abd1dc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f8a3115883abd1dc$var$_typeof(o);
}
function $f8a3115883abd1dc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f8a3115883abd1dc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f8a3115883abd1dc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f8a3115883abd1dc$var$_extends() {
    $f8a3115883abd1dc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f8a3115883abd1dc$var$_extends.apply(this, arguments);
}
function $f8a3115883abd1dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8a3115883abd1dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8a3115883abd1dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f8a3115883abd1dc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8a3115883abd1dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f8a3115883abd1dc$var$_toConsumableArray(arr) {
    return $f8a3115883abd1dc$var$_arrayWithoutHoles(arr) || $f8a3115883abd1dc$var$_iterableToArray(arr) || $f8a3115883abd1dc$var$_unsupportedIterableToArray(arr) || $f8a3115883abd1dc$var$_nonIterableSpread();
}
function $f8a3115883abd1dc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f8a3115883abd1dc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f8a3115883abd1dc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f8a3115883abd1dc$var$_arrayLikeToArray(o, minLen);
}
function $f8a3115883abd1dc$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f8a3115883abd1dc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f8a3115883abd1dc$var$_arrayLikeToArray(arr);
}
function $f8a3115883abd1dc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f8a3115883abd1dc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f8a3115883abd1dc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f8a3115883abd1dc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f8a3115883abd1dc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f8a3115883abd1dc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f8a3115883abd1dc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f8a3115883abd1dc$var$_callSuper(t, o, e) {
    return o = $f8a3115883abd1dc$var$_getPrototypeOf(o), $f8a3115883abd1dc$var$_possibleConstructorReturn(t, $f8a3115883abd1dc$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $f8a3115883abd1dc$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $f8a3115883abd1dc$var$_possibleConstructorReturn(self, call) {
    if (call && ($f8a3115883abd1dc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f8a3115883abd1dc$var$_assertThisInitialized(self);
}
function $f8a3115883abd1dc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f8a3115883abd1dc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f8a3115883abd1dc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f8a3115883abd1dc$var$_getPrototypeOf(o) {
    $f8a3115883abd1dc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f8a3115883abd1dc$var$_getPrototypeOf(o);
}
function $f8a3115883abd1dc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f8a3115883abd1dc$var$_setPrototypeOf(subClass, superClass);
}
function $f8a3115883abd1dc$var$_setPrototypeOf(o, p) {
    $f8a3115883abd1dc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f8a3115883abd1dc$var$_setPrototypeOf(o, p);
}
function $f8a3115883abd1dc$var$_defineProperty(obj, key, value) {
    key = $f8a3115883abd1dc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f8a3115883abd1dc$var$_toPropertyKey(t) {
    var i = $f8a3115883abd1dc$var$_toPrimitive(t, "string");
    return "symbol" == $f8a3115883abd1dc$var$_typeof(i) ? i : i + "";
}
function $f8a3115883abd1dc$var$_toPrimitive(t, r) {
    if ("object" != $f8a3115883abd1dc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f8a3115883abd1dc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f8a3115883abd1dc$export$17d680238e50603e = /*#__PURE__*/ function(_PureComponent) {
    function Line() {
        var _this;
        $f8a3115883abd1dc$var$_classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $f8a3115883abd1dc$var$_callSuper(this, Line, [].concat(args));
        $f8a3115883abd1dc$var$_defineProperty(_this, "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        $f8a3115883abd1dc$var$_defineProperty(_this, "generateSimpleStrokeDasharray", function(totalLength, length) {
            return "".concat(length, "px ").concat(totalLength - length, "px");
        });
        $f8a3115883abd1dc$var$_defineProperty(_this, "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            // if lineLength is 0 return the default when no strokeDasharray is provided
            if (!lineLength) return _this.generateSimpleStrokeDasharray(totalLength, length);
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat($f8a3115883abd1dc$var$_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat($f8a3115883abd1dc$var$_toConsumableArray(Line.repeat(lines, count)), $f8a3115883abd1dc$var$_toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(', ');
        });
        $f8a3115883abd1dc$var$_defineProperty(_this, "id", (0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('recharts-line-'));
        $f8a3115883abd1dc$var$_defineProperty(_this, "pathRef", function(node) {
            _this.mainCurve = node;
        });
        $f8a3115883abd1dc$var$_defineProperty(_this, "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        $f8a3115883abd1dc$var$_defineProperty(_this, "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    $f8a3115883abd1dc$var$_inherits(Line, _PureComponent);
    return $f8a3115883abd1dc$var$_createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                if (totalLength !== this.state.totalLength) this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $7f4b989d0f2e91c6$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, $cd015374923bb5c7$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(item, {
                        key: "bar-".concat(item.props.dataKey),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false);
                var customDotProps = (0, $008f02516c156322$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        value: entry.value,
                        dataKey: dataKey,
                        payload: entry.payload,
                        points: points
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $f8a3115883abd1dc$var$_extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = $f8a3115883abd1dc$var$_objectWithoutProperties(_this$props3, $f8a3115883abd1dc$var$_excluded);
                var curveProps = $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, (0, $008f02516c156322$export$d697c39a2985a4c)(others, true)), {}, {
                    fill: 'none',
                    className: 'recharts-line-curve',
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $af2055905739b7f2$export$b0e83c3ef8d2db1), $f8a3115883abd1dc$var$_extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(width * 2, entry.x);
                                var _interpolatorY = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(height / 2, entry.y);
                                return $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($394ab417e9bd75cc$exports)))(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-line', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $008f02516c156322$export$d697c39a2985a4c)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $008f02516c156322$export$392f6c9701718a4e)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $88ab0dba0fc78576$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat($f8a3115883abd1dc$var$_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat($f8a3115883abd1dc$var$_toConsumableArray(result), $f8a3115883abd1dc$var$_toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) dotItem = option(props);
                else {
                    var key = props.key, dotProps = $f8a3115883abd1dc$var$_objectWithoutProperties(props, $f8a3115883abd1dc$var$_excluded2);
                    var className = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-line-dot', typeof option !== 'boolean' ? option.className : '');
                    dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ab98349969d46e2$export$d046b3c4a416f60d), $f8a3115883abd1dc$var$_extends({
                        key: key
                    }, dotProps, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
}((0, $acw62.PureComponent));
$f8a3115883abd1dc$var$_defineProperty($f8a3115883abd1dc$export$17d680238e50603e, "displayName", 'Line');
$f8a3115883abd1dc$var$_defineProperty($f8a3115883abd1dc$export$17d680238e50603e, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    fill: '#fff',
    points: [],
    isAnimationActive: !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $f8a3115883abd1dc$var$_defineProperty($f8a3115883abd1dc$export$17d680238e50603e, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === 'horizontal') return {
            x: (0, $cd015374923bb5c7$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(value) ? null : xAxis.scale(value),
            y: (0, $cd015374923bb5c7$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return $f8a3115883abd1dc$var$_objectSpread({
        points: points,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Line Chart
 */ 
var $acw62 = parcelRequire("acw62");


var $b392b5b21038a0ce$exports = {};
var $cd7742b81dd96fb0$exports = {};
var $d3906a592348eb7a$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d3906a592348eb7a$var$nativeCeil = Math.ceil, $d3906a592348eb7a$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $d3906a592348eb7a$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $d3906a592348eb7a$var$nativeMax($d3906a592348eb7a$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$d3906a592348eb7a$exports = $d3906a592348eb7a$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $cd7742b81dd96fb0$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $81b21e8b41d211e8$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $6ceabe126a95a54e$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $6ceabe126a95a54e$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $6ceabe126a95a54e$exports(step);
        return $d3906a592348eb7a$exports(start, end, step, fromRight);
    };
}
$cd7742b81dd96fb0$exports = $cd7742b81dd96fb0$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $b392b5b21038a0ce$var$range = $cd7742b81dd96fb0$exports();
$b392b5b21038a0ce$exports = $b392b5b21038a0ce$var$range;




var $ff695783c7d42c0c$exports = {};
var $d9f195cb3938646c$exports = {};

var $6d38303b9c8735ba$exports = {};

var $23YZo = parcelRequire("23YZo");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $23YZo.Date.now();
};
$6d38303b9c8735ba$exports = $6d38303b9c8735ba$var$now;



/** Error message constants. */ var $d9f195cb3938646c$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9f195cb3938646c$var$nativeMax = Math.max, $d9f195cb3938646c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d9f195cb3938646c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($d9f195cb3938646c$var$FUNC_ERROR_TEXT);
    wait = $dc614d828223dea6$exports(wait) || 0;
    if ($f9ff2e983beb6b86$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $d9f195cb3938646c$var$nativeMax($dc614d828223dea6$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d9f195cb3938646c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $6d38303b9c8735ba$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($6d38303b9c8735ba$exports());
    }
    function debounced() {
        var time = $6d38303b9c8735ba$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$d9f195cb3938646c$exports = $d9f195cb3938646c$var$debounce;



/** Error message constants. */ var $ff695783c7d42c0c$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ff695783c7d42c0c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($ff695783c7d42c0c$var$FUNC_ERROR_TEXT);
    if ($f9ff2e983beb6b86$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $d9f195cb3938646c$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$ff695783c7d42c0c$exports = $ff695783c7d42c0c$var$throttle;







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




function $c0a796aac01127ca$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c0a796aac01127ca$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c0a796aac01127ca$var$_typeof(o);
}
function $c0a796aac01127ca$var$_extends() {
    $c0a796aac01127ca$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c0a796aac01127ca$var$_extends.apply(this, arguments);
}
function $c0a796aac01127ca$var$_slicedToArray(arr, i) {
    return $c0a796aac01127ca$var$_arrayWithHoles(arr) || $c0a796aac01127ca$var$_iterableToArrayLimit(arr, i) || $c0a796aac01127ca$var$_unsupportedIterableToArray(arr, i) || $c0a796aac01127ca$var$_nonIterableRest();
}
function $c0a796aac01127ca$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c0a796aac01127ca$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c0a796aac01127ca$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c0a796aac01127ca$var$_arrayLikeToArray(o, minLen);
}
function $c0a796aac01127ca$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c0a796aac01127ca$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c0a796aac01127ca$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c0a796aac01127ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c0a796aac01127ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c0a796aac01127ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c0a796aac01127ca$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c0a796aac01127ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c0a796aac01127ca$var$_defineProperty(obj, key, value) {
    key = $c0a796aac01127ca$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c0a796aac01127ca$var$_toPropertyKey(t) {
    var i = $c0a796aac01127ca$var$_toPrimitive(t, "string");
    return "symbol" == $c0a796aac01127ca$var$_typeof(i) ? i : i + "";
}
function $c0a796aac01127ca$var$_toPrimitive(t, r) {
    if ("object" != $c0a796aac01127ca$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c0a796aac01127ca$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c0a796aac01127ca$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(value[0]) && (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $c0a796aac01127ca$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($300ea168693086c2$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $c0a796aac01127ca$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $c0a796aac01127ca$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $c0a796aac01127ca$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $c0a796aac01127ca$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $c0a796aac01127ca$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $c0a796aac01127ca$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $acw62 = parcelRequire("acw62");


function $32b135afcb061cab$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $32b135afcb061cab$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $32b135afcb061cab$var$_typeof(o);
}
function $32b135afcb061cab$var$_defineProperty(obj, key, value) {
    key = $32b135afcb061cab$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $32b135afcb061cab$var$_toPropertyKey(t) {
    var i = $32b135afcb061cab$var$_toPrimitive(t, "string");
    return "symbol" == $32b135afcb061cab$var$_typeof(i) ? i : i + "";
}
function $32b135afcb061cab$var$_toPrimitive(t, r) {
    if ("object" != $32b135afcb061cab$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $32b135afcb061cab$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $32b135afcb061cab$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $32b135afcb061cab$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $32b135afcb061cab$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($32b135afcb061cab$var$CSS_CLASS_PREFIX, $32b135afcb061cab$var$_defineProperty($32b135afcb061cab$var$_defineProperty($32b135afcb061cab$var$_defineProperty($32b135afcb061cab$var$_defineProperty({}, "".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-right"), (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateX) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), "".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-left"), (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateX) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), "".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-bottom"), (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateY) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), "".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-top"), (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateY) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y));
}
function $32b135afcb061cab$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $32b135afcb061cab$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $32b135afcb061cab$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $32b135afcb061cab$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $32b135afcb061cab$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $32b135afcb061cab$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $32b135afcb061cab$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $32b135afcb061cab$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $2a173c9072cdf4ec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2a173c9072cdf4ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2a173c9072cdf4ec$var$_typeof(o);
}
function $2a173c9072cdf4ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a173c9072cdf4ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a173c9072cdf4ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2a173c9072cdf4ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a173c9072cdf4ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2a173c9072cdf4ec$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2a173c9072cdf4ec$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2a173c9072cdf4ec$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2a173c9072cdf4ec$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2a173c9072cdf4ec$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2a173c9072cdf4ec$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2a173c9072cdf4ec$var$_callSuper(t, o, e) {
    return o = $2a173c9072cdf4ec$var$_getPrototypeOf(o), $2a173c9072cdf4ec$var$_possibleConstructorReturn(t, $2a173c9072cdf4ec$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $2a173c9072cdf4ec$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $2a173c9072cdf4ec$var$_possibleConstructorReturn(self, call) {
    if (call && ($2a173c9072cdf4ec$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2a173c9072cdf4ec$var$_assertThisInitialized(self);
}
function $2a173c9072cdf4ec$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2a173c9072cdf4ec$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2a173c9072cdf4ec$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2a173c9072cdf4ec$var$_getPrototypeOf(o) {
    $2a173c9072cdf4ec$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2a173c9072cdf4ec$var$_getPrototypeOf(o);
}
function $2a173c9072cdf4ec$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2a173c9072cdf4ec$var$_setPrototypeOf(subClass, superClass);
}
function $2a173c9072cdf4ec$var$_setPrototypeOf(o, p) {
    $2a173c9072cdf4ec$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2a173c9072cdf4ec$var$_setPrototypeOf(o, p);
}
function $2a173c9072cdf4ec$var$_defineProperty(obj, key, value) {
    key = $2a173c9072cdf4ec$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a173c9072cdf4ec$var$_toPropertyKey(t) {
    var i = $2a173c9072cdf4ec$var$_toPrimitive(t, "string");
    return "symbol" == $2a173c9072cdf4ec$var$_typeof(i) ? i : i + "";
}
function $2a173c9072cdf4ec$var$_toPrimitive(t, r) {
    if ("object" != $2a173c9072cdf4ec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2a173c9072cdf4ec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2a173c9072cdf4ec$var$EPSILON = 1;
var $2a173c9072cdf4ec$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    function TooltipBoundingBox() {
        var _this;
        $2a173c9072cdf4ec$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $2a173c9072cdf4ec$var$_callSuper(this, TooltipBoundingBox, [].concat(args));
        $2a173c9072cdf4ec$var$_defineProperty(_this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        $2a173c9072cdf4ec$var$_defineProperty(_this, "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $2a173c9072cdf4ec$var$_inherits(TooltipBoundingBox, _PureComponent);
    return $2a173c9072cdf4ec$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > $2a173c9072cdf4ec$var$EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > $2a173c9072cdf4ec$var$EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $32b135afcb061cab$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $2a173c9072cdf4ec$var$_objectSpread($2a173c9072cdf4ec$var$_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
}((0, $acw62.PureComponent));




function $3258e2bab55a6a07$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3258e2bab55a6a07$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3258e2bab55a6a07$var$_typeof(o);
}
function $3258e2bab55a6a07$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3258e2bab55a6a07$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3258e2bab55a6a07$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3258e2bab55a6a07$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3258e2bab55a6a07$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3258e2bab55a6a07$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3258e2bab55a6a07$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3258e2bab55a6a07$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3258e2bab55a6a07$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3258e2bab55a6a07$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3258e2bab55a6a07$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3258e2bab55a6a07$var$_callSuper(t, o, e) {
    return o = $3258e2bab55a6a07$var$_getPrototypeOf(o), $3258e2bab55a6a07$var$_possibleConstructorReturn(t, $3258e2bab55a6a07$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $3258e2bab55a6a07$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $3258e2bab55a6a07$var$_possibleConstructorReturn(self, call) {
    if (call && ($3258e2bab55a6a07$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3258e2bab55a6a07$var$_assertThisInitialized(self);
}
function $3258e2bab55a6a07$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3258e2bab55a6a07$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3258e2bab55a6a07$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3258e2bab55a6a07$var$_getPrototypeOf(o) {
    $3258e2bab55a6a07$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3258e2bab55a6a07$var$_getPrototypeOf(o);
}
function $3258e2bab55a6a07$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3258e2bab55a6a07$var$_setPrototypeOf(subClass, superClass);
}
function $3258e2bab55a6a07$var$_setPrototypeOf(o, p) {
    $3258e2bab55a6a07$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3258e2bab55a6a07$var$_setPrototypeOf(o, p);
}
function $3258e2bab55a6a07$var$_defineProperty(obj, key, value) {
    key = $3258e2bab55a6a07$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3258e2bab55a6a07$var$_toPropertyKey(t) {
    var i = $3258e2bab55a6a07$var$_toPrimitive(t, "string");
    return "symbol" == $3258e2bab55a6a07$var$_typeof(i) ? i : i + "";
}
function $3258e2bab55a6a07$var$_toPrimitive(t, r) {
    if ("object" != $3258e2bab55a6a07$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3258e2bab55a6a07$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3258e2bab55a6a07$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $3258e2bab55a6a07$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c0a796aac01127ca$export$6fe33945eebf9ac8), props);
}
var $3258e2bab55a6a07$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    function Tooltip() {
        $3258e2bab55a6a07$var$_classCallCheck(this, Tooltip);
        return $3258e2bab55a6a07$var$_callSuper(this, Tooltip, arguments);
    }
    $3258e2bab55a6a07$var$_inherits(Tooltip, _PureComponent);
    return $3258e2bab55a6a07$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $12cc16c3e91089ee$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $3258e2bab55a6a07$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2a173c9072cdf4ec$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $3258e2bab55a6a07$var$renderContent(content, $3258e2bab55a6a07$var$_objectSpread($3258e2bab55a6a07$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
}((0, $acw62.PureComponent));
$3258e2bab55a6a07$var$_defineProperty($3258e2bab55a6a07$export$28c660c63b792dea, "displayName", 'Tooltip');
$3258e2bab55a6a07$var$_defineProperty($3258e2bab55a6a07$export$28c660c63b792dea, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});







var $acw62 = parcelRequire("acw62");








function $aff99017769d4007$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $aff99017769d4007$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $aff99017769d4007$var$_typeof(o);
}
function $aff99017769d4007$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aff99017769d4007$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aff99017769d4007$var$ownKeys(Object(t), !0).forEach(function(r) {
            $aff99017769d4007$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aff99017769d4007$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $aff99017769d4007$var$_defineProperty(obj, key, value) {
    key = $aff99017769d4007$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aff99017769d4007$var$_toPropertyKey(t) {
    var i = $aff99017769d4007$var$_toPrimitive(t, "string");
    return "symbol" == $aff99017769d4007$var$_typeof(i) ? i : i + "";
}
function $aff99017769d4007$var$_toPrimitive(t, r) {
    if ("object" != $aff99017769d4007$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $aff99017769d4007$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $aff99017769d4007$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $aff99017769d4007$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $aff99017769d4007$var$PREFIX_LIST.reduce(function(res, entry) {
        return $aff99017769d4007$var$_objectSpread($aff99017769d4007$var$_objectSpread({}, res), {}, $aff99017769d4007$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $b0c0135ef9d67bd5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b0c0135ef9d67bd5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b0c0135ef9d67bd5$var$_typeof(o);
}
function $b0c0135ef9d67bd5$var$_extends() {
    $b0c0135ef9d67bd5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0c0135ef9d67bd5$var$_extends.apply(this, arguments);
}
function $b0c0135ef9d67bd5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b0c0135ef9d67bd5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b0c0135ef9d67bd5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b0c0135ef9d67bd5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b0c0135ef9d67bd5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b0c0135ef9d67bd5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b0c0135ef9d67bd5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b0c0135ef9d67bd5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b0c0135ef9d67bd5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b0c0135ef9d67bd5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b0c0135ef9d67bd5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b0c0135ef9d67bd5$var$_callSuper(t, o, e) {
    return o = $b0c0135ef9d67bd5$var$_getPrototypeOf(o), $b0c0135ef9d67bd5$var$_possibleConstructorReturn(t, $b0c0135ef9d67bd5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $b0c0135ef9d67bd5$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $b0c0135ef9d67bd5$var$_possibleConstructorReturn(self, call) {
    if (call && ($b0c0135ef9d67bd5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b0c0135ef9d67bd5$var$_assertThisInitialized(self);
}
function $b0c0135ef9d67bd5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b0c0135ef9d67bd5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b0c0135ef9d67bd5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $b0c0135ef9d67bd5$var$_getPrototypeOf(o) {
    $b0c0135ef9d67bd5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b0c0135ef9d67bd5$var$_getPrototypeOf(o);
}
function $b0c0135ef9d67bd5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b0c0135ef9d67bd5$var$_setPrototypeOf(subClass, superClass);
}
function $b0c0135ef9d67bd5$var$_setPrototypeOf(o, p) {
    $b0c0135ef9d67bd5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b0c0135ef9d67bd5$var$_setPrototypeOf(o, p);
}
function $b0c0135ef9d67bd5$var$_defineProperty(obj, key, value) {
    key = $b0c0135ef9d67bd5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b0c0135ef9d67bd5$var$_toPropertyKey(t) {
    var i = $b0c0135ef9d67bd5$var$_toPrimitive(t, "string");
    return "symbol" == $b0c0135ef9d67bd5$var$_typeof(i) ? i : i + "";
}
function $b0c0135ef9d67bd5$var$_toPrimitive(t, r) {
    if ("object" != $b0c0135ef9d67bd5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b0c0135ef9d67bd5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b0c0135ef9d67bd5$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $d8f008d3b0c1a5c3$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($b392b5b21038a0ce$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $b0c0135ef9d67bd5$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $b0c0135ef9d67bd5$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    function Brush(props) {
        var _this;
        $b0c0135ef9d67bd5$var$_classCallCheck(this, Brush);
        _this = $b0c0135ef9d67bd5$var$_callSuper(this, Brush, [
            props
        ]);
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $b0c0135ef9d67bd5$var$_defineProperty(_this, "handleSlideDragStart", function(e) {
            var event = $b0c0135ef9d67bd5$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
            endX: _this.handleTravellerDragStart.bind(_this, 'endX')
        };
        _this.state = {};
        return _this;
    }
    $b0c0135ef9d67bd5$var$_inherits(Brush, _PureComponent);
    return $b0c0135ef9d67bd5$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $b0c0135ef9d67bd5$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState($b0c0135ef9d67bd5$var$_defineProperty($b0c0135ef9d67bd5$var$_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState($b0c0135ef9d67bd5$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $acw62.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $b0c0135ef9d67bd5$var$_objectSpread($b0c0135ef9d67bd5$var$_objectSpread({}, (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $964be52cc11879b4$export$5f1af8db9871e1d6), $b0c0135ef9d67bd5$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $964be52cc11879b4$export$5f1af8db9871e1d6), $b0c0135ef9d67bd5$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-brush', className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 1;
                var style = (0, $aff99017769d4007$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $b0c0135ef9d67bd5$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $b0c0135ef9d67bd5$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
}((0, $acw62.PureComponent));
$b0c0135ef9d67bd5$var$_defineProperty($b0c0135ef9d67bd5$export$59bc2e3533b384a0, "displayName", 'Brush');
$b0c0135ef9d67bd5$var$_defineProperty($b0c0135ef9d67bd5$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $acw62 = parcelRequire("acw62");






var $8ca5391289a51027$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};





function $9ea7041db7d573c0$var$_extends() {
    $9ea7041db7d573c0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9ea7041db7d573c0$var$_extends.apply(this, arguments);
}
function $9ea7041db7d573c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9ea7041db7d573c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9ea7041db7d573c0$var$_typeof(o);
}
function $9ea7041db7d573c0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ea7041db7d573c0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ea7041db7d573c0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9ea7041db7d573c0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ea7041db7d573c0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9ea7041db7d573c0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9ea7041db7d573c0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9ea7041db7d573c0$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $9ea7041db7d573c0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9ea7041db7d573c0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ea7041db7d573c0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9ea7041db7d573c0$var$_callSuper(t, o, e) {
    return o = $9ea7041db7d573c0$var$_getPrototypeOf(o), $9ea7041db7d573c0$var$_possibleConstructorReturn(t, $9ea7041db7d573c0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $9ea7041db7d573c0$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $9ea7041db7d573c0$var$_possibleConstructorReturn(self, call) {
    if (call && ($9ea7041db7d573c0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9ea7041db7d573c0$var$_assertThisInitialized(self);
}
function $9ea7041db7d573c0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9ea7041db7d573c0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9ea7041db7d573c0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9ea7041db7d573c0$var$_getPrototypeOf(o) {
    $9ea7041db7d573c0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9ea7041db7d573c0$var$_getPrototypeOf(o);
}
function $9ea7041db7d573c0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9ea7041db7d573c0$var$_setPrototypeOf(subClass, superClass);
}
function $9ea7041db7d573c0$var$_setPrototypeOf(o, p) {
    $9ea7041db7d573c0$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9ea7041db7d573c0$var$_setPrototypeOf(o, p);
}
function $9ea7041db7d573c0$var$_defineProperty(obj, key, value) {
    key = $9ea7041db7d573c0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9ea7041db7d573c0$var$_toPropertyKey(t) {
    var i = $9ea7041db7d573c0$var$_toPrimitive(t, "string");
    return "symbol" == $9ea7041db7d573c0$var$_typeof(i) ? i : i + "";
}
function $9ea7041db7d573c0$var$_toPrimitive(t, r) {
    if ("object" != $9ea7041db7d573c0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9ea7041db7d573c0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9ea7041db7d573c0$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $7dad4d5151ba4a01$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
var $9ea7041db7d573c0$export$aa7f0b0106bff39 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceDot() {
        $9ea7041db7d573c0$var$_classCallCheck(this, ReferenceDot);
        return $9ea7041db7d573c0$var$_callSuper(this, ReferenceDot, arguments);
    }
    $9ea7041db7d573c0$var$_inherits(ReferenceDot, _React$Component);
    return $9ea7041db7d573c0$var$_createClass(ReferenceDot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, r = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                var isX = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(x);
                var isY = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(y);
                (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                if (!isX || !isY) return null;
                var coordinate = $9ea7041db7d573c0$var$getCoordinate(this.props);
                if (!coordinate) return null;
                var cx = coordinate.x, cy = coordinate.y;
                var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
                var clipPath = (0, $8ca5391289a51027$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                var dotProps = $9ea7041db7d573c0$var$_objectSpread($9ea7041db7d573c0$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, true)), {}, {
                    cx: cx,
                    cy: cy
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-reference-dot', className)
                }, ReferenceDot.renderDot(shape, dotProps), (0, $77be8884b5ec622c$export$b04be29aa201d4f5).renderCallByParent(this.props, {
                    x: cx - r,
                    y: cy - r,
                    width: 2 * r,
                    height: 2 * r
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$9ea7041db7d573c0$var$_defineProperty($9ea7041db7d573c0$export$aa7f0b0106bff39, "displayName", 'ReferenceDot');
$9ea7041db7d573c0$var$_defineProperty($9ea7041db7d573c0$export$aa7f0b0106bff39, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
});
$9ea7041db7d573c0$var$_defineProperty($9ea7041db7d573c0$export$aa7f0b0106bff39, "renderDot", function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ab98349969d46e2$export$d046b3c4a416f60d), $9ea7041db7d573c0$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
});



var $acw62 = parcelRequire("acw62");

var $cde44aad7de4d096$exports = {};


var $8cd52c0fe2cccbdf$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $8cd52c0fe2cccbdf$var$baseSome(collection, predicate) {
    var result;
    $35fa3296f177aa01$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$8cd52c0fe2cccbdf$exports = $8cd52c0fe2cccbdf$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $cde44aad7de4d096$var$some(collection, predicate, guard) {
    var func = $0488fde9aa355453$exports(collection) ? $aae24ad60cc3cfcb$exports : $8cd52c0fe2cccbdf$exports;
    if (guard && $81b21e8b41d211e8$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $5aba4f6d9f8304a3$exports(predicate, 3));
}
$cde44aad7de4d096$exports = $cde44aad7de4d096$var$some;











function $c541166c885e1544$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c541166c885e1544$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c541166c885e1544$var$_typeof(o);
}
function $c541166c885e1544$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c541166c885e1544$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c541166c885e1544$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c541166c885e1544$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c541166c885e1544$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c541166c885e1544$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c541166c885e1544$var$_callSuper(t, o, e) {
    return o = $c541166c885e1544$var$_getPrototypeOf(o), $c541166c885e1544$var$_possibleConstructorReturn(t, $c541166c885e1544$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c541166c885e1544$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c541166c885e1544$var$_possibleConstructorReturn(self, call) {
    if (call && ($c541166c885e1544$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c541166c885e1544$var$_assertThisInitialized(self);
}
function $c541166c885e1544$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c541166c885e1544$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c541166c885e1544$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c541166c885e1544$var$_getPrototypeOf(o) {
    $c541166c885e1544$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c541166c885e1544$var$_getPrototypeOf(o);
}
function $c541166c885e1544$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c541166c885e1544$var$_setPrototypeOf(subClass, superClass);
}
function $c541166c885e1544$var$_setPrototypeOf(o, p) {
    $c541166c885e1544$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c541166c885e1544$var$_setPrototypeOf(o, p);
}
function $c541166c885e1544$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c541166c885e1544$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c541166c885e1544$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c541166c885e1544$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c541166c885e1544$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c541166c885e1544$var$_defineProperty(obj, key, value) {
    key = $c541166c885e1544$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c541166c885e1544$var$_toPropertyKey(t) {
    var i = $c541166c885e1544$var$_toPrimitive(t, "string");
    return "symbol" == $c541166c885e1544$var$_typeof(i) ? i : i + "";
}
function $c541166c885e1544$var$_toPrimitive(t, r) {
    if ("object" != $c541166c885e1544$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c541166c885e1544$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c541166c885e1544$var$_slicedToArray(arr, i) {
    return $c541166c885e1544$var$_arrayWithHoles(arr) || $c541166c885e1544$var$_iterableToArrayLimit(arr, i) || $c541166c885e1544$var$_unsupportedIterableToArray(arr, i) || $c541166c885e1544$var$_nonIterableRest();
}
function $c541166c885e1544$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c541166c885e1544$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c541166c885e1544$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c541166c885e1544$var$_arrayLikeToArray(o, minLen);
}
function $c541166c885e1544$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c541166c885e1544$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c541166c885e1544$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c541166c885e1544$var$_extends() {
    $c541166c885e1544$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c541166c885e1544$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $c541166c885e1544$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $c541166c885e1544$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $c541166c885e1544$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($cde44aad7de4d096$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $c541166c885e1544$var$ReferenceLineImpl(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $e573f10901a87cfb$export$71e825c43eae6ca6)();
    var xAxis = (0, $e573f10901a87cfb$export$54f54805c81085c5)(xAxisId);
    var yAxis = (0, $e573f10901a87cfb$export$6f8958021ad81c20)(yAxisId);
    var viewBox = (0, $e573f10901a87cfb$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox) return null;
    (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $7dad4d5151ba4a01$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(fixedX);
    var isY = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $c541166c885e1544$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $c541166c885e1544$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $c541166c885e1544$var$_objectSpread($c541166c885e1544$var$_objectSpread({
        clipPath: clipPath
    }, (0, $008f02516c156322$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-reference-line', className)
    }, $c541166c885e1544$var$renderLine(shape, lineProps), (0, $77be8884b5ec622c$export$b04be29aa201d4f5).renderCallByParent(props, (0, $7dad4d5151ba4a01$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
var $c541166c885e1544$export$b2f28e248e7838eb = /*#__PURE__*/ function(_React$Component) {
    function ReferenceLine() {
        $c541166c885e1544$var$_classCallCheck(this, ReferenceLine);
        return $c541166c885e1544$var$_callSuper(this, ReferenceLine, arguments);
    }
    $c541166c885e1544$var$_inherits(ReferenceLine, _React$Component);
    return $c541166c885e1544$var$_createClass(ReferenceLine, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c541166c885e1544$var$ReferenceLineImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$c541166c885e1544$var$_defineProperty($c541166c885e1544$export$b2f28e248e7838eb, "displayName", 'ReferenceLine');
$c541166c885e1544$var$_defineProperty($c541166c885e1544$export$b2f28e248e7838eb, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
});



var $acw62 = parcelRequire("acw62");










function $ab818fa12c183ba2$var$_extends() {
    $ab818fa12c183ba2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ab818fa12c183ba2$var$_extends.apply(this, arguments);
}
function $ab818fa12c183ba2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ab818fa12c183ba2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ab818fa12c183ba2$var$_typeof(o);
}
function $ab818fa12c183ba2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab818fa12c183ba2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab818fa12c183ba2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ab818fa12c183ba2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab818fa12c183ba2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ab818fa12c183ba2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ab818fa12c183ba2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ab818fa12c183ba2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ab818fa12c183ba2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ab818fa12c183ba2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ab818fa12c183ba2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ab818fa12c183ba2$var$_callSuper(t, o, e) {
    return o = $ab818fa12c183ba2$var$_getPrototypeOf(o), $ab818fa12c183ba2$var$_possibleConstructorReturn(t, $ab818fa12c183ba2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $ab818fa12c183ba2$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $ab818fa12c183ba2$var$_possibleConstructorReturn(self, call) {
    if (call && ($ab818fa12c183ba2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ab818fa12c183ba2$var$_assertThisInitialized(self);
}
function $ab818fa12c183ba2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ab818fa12c183ba2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ab818fa12c183ba2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ab818fa12c183ba2$var$_getPrototypeOf(o) {
    $ab818fa12c183ba2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ab818fa12c183ba2$var$_getPrototypeOf(o);
}
function $ab818fa12c183ba2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ab818fa12c183ba2$var$_setPrototypeOf(subClass, superClass);
}
function $ab818fa12c183ba2$var$_setPrototypeOf(o, p) {
    $ab818fa12c183ba2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ab818fa12c183ba2$var$_setPrototypeOf(o, p);
}
function $ab818fa12c183ba2$var$_defineProperty(obj, key, value) {
    key = $ab818fa12c183ba2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ab818fa12c183ba2$var$_toPropertyKey(t) {
    var i = $ab818fa12c183ba2$var$_toPrimitive(t, "string");
    return "symbol" == $ab818fa12c183ba2$var$_typeof(i) ? i : i + "";
}
function $ab818fa12c183ba2$var$_toPrimitive(t, r) {
    if ("object" != $ab818fa12c183ba2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ab818fa12c183ba2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ab818fa12c183ba2$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $7dad4d5151ba4a01$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $8ca5391289a51027$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $7dad4d5151ba4a01$export$c7964a5b9439ae62)(p1, p2);
};
var $ab818fa12c183ba2$export$b4ec4f050ce240b9 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceArea() {
        $ab818fa12c183ba2$var$_classCallCheck(this, ReferenceArea);
        return $ab818fa12c183ba2$var$_callSuper(this, ReferenceArea, arguments);
    }
    $ab818fa12c183ba2$var$_inherits(ReferenceArea, _React$Component);
    return $ab818fa12c183ba2$var$_createClass(ReferenceArea, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                var hasX1 = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(x1);
                var hasX2 = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(x2);
                var hasY1 = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(y1);
                var hasY2 = (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(y2);
                var shape = this.props.shape;
                if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
                var rect = $ab818fa12c183ba2$var$getRect(hasX1, hasX2, hasY1, hasY2, this.props);
                if (!rect && !shape) return null;
                var clipPath = (0, $8ca5391289a51027$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-reference-area', className)
                }, ReferenceArea.renderRect(shape, $ab818fa12c183ba2$var$_objectSpread($ab818fa12c183ba2$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, true)), rect)), (0, $77be8884b5ec622c$export$b04be29aa201d4f5).renderCallByParent(this.props, rect));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ab818fa12c183ba2$var$_defineProperty($ab818fa12c183ba2$export$b4ec4f050ce240b9, "displayName", 'ReferenceArea');
$ab818fa12c183ba2$var$_defineProperty($ab818fa12c183ba2$export$b4ec4f050ce240b9, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
});
$ab818fa12c183ba2$var$_defineProperty($ab818fa12c183ba2$export$b4ec4f050ce240b9, "renderRect", function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70f75e095c9bb92d$export$4617fb02663045ef), $ab818fa12c183ba2$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
});





function $e8f3ee16c7c854b9$var$_toConsumableArray(arr) {
    return $e8f3ee16c7c854b9$var$_arrayWithoutHoles(arr) || $e8f3ee16c7c854b9$var$_iterableToArray(arr) || $e8f3ee16c7c854b9$var$_unsupportedIterableToArray(arr) || $e8f3ee16c7c854b9$var$_nonIterableSpread();
}
function $e8f3ee16c7c854b9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e8f3ee16c7c854b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e8f3ee16c7c854b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e8f3ee16c7c854b9$var$_arrayLikeToArray(o, minLen);
}
function $e8f3ee16c7c854b9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e8f3ee16c7c854b9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e8f3ee16c7c854b9$var$_arrayLikeToArray(arr);
}
function $e8f3ee16c7c854b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $e8f3ee16c7c854b9$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $c541166c885e1544$export$b2f28e248e7838eb));
    var dots = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $9ea7041db7d573c0$export$aa7f0b0106bff39));
    var elements = [].concat($e8f3ee16c7c854b9$var$_toConsumableArray(lines), $e8f3ee16c7c854b9$var$_toConsumableArray(dots));
    var areas = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $ab818fa12c183ba2$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $8ca5391289a51027$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $8ca5391289a51027$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(el.props[key1]) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $28edd11f6c7e9f5f$exports = {};
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
$28edd11f6c7e9f5f$exports = $28edd11f6c7e9f5f$var$EventEmitter;


var $bbd08cd38300f8df$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports)))();
var $bbd08cd38300f8df$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $bde81ec92d1b0fae$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bde81ec92d1b0fae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bde81ec92d1b0fae$var$_typeof(o);
}
function $bde81ec92d1b0fae$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bde81ec92d1b0fae$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bde81ec92d1b0fae$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bde81ec92d1b0fae$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bde81ec92d1b0fae$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bde81ec92d1b0fae$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bde81ec92d1b0fae$var$_defineProperty(obj, key, value) {
    key = $bde81ec92d1b0fae$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bde81ec92d1b0fae$var$_toPropertyKey(t) {
    var i = $bde81ec92d1b0fae$var$_toPrimitive(t, "string");
    return "symbol" == $bde81ec92d1b0fae$var$_typeof(i) ? i : i + "";
}
function $bde81ec92d1b0fae$var$_toPrimitive(t, r) {
    if ("object" != $bde81ec92d1b0fae$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bde81ec92d1b0fae$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $bde81ec92d1b0fae$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $bde81ec92d1b0fae$var$_classCallCheck(this, AccessibilityManager);
        $bde81ec92d1b0fae$var$_defineProperty(this, "activeIndex", 0);
        $bde81ec92d1b0fae$var$_defineProperty(this, "coordinateList", []);
        $bde81ec92d1b0fae$var$_defineProperty(this, "layout", 'horizontal');
    }
    return $bde81ec92d1b0fae$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
}();



function $77a63a99eb6fec8b$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(domainStart) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



function $2ae8a72d4579aba0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ae8a72d4579aba0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ae8a72d4579aba0$var$_typeof(o);
}
var $2ae8a72d4579aba0$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $2ae8a72d4579aba0$var$_extends() {
    $2ae8a72d4579aba0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2ae8a72d4579aba0$var$_extends.apply(this, arguments);
}
function $2ae8a72d4579aba0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ae8a72d4579aba0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ae8a72d4579aba0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2ae8a72d4579aba0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ae8a72d4579aba0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2ae8a72d4579aba0$var$_defineProperty(obj, key, value) {
    key = $2ae8a72d4579aba0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2ae8a72d4579aba0$var$_toPropertyKey(t) {
    var i = $2ae8a72d4579aba0$var$_toPrimitive(t, "string");
    return "symbol" == $2ae8a72d4579aba0$var$_typeof(i) ? i : i + "";
}
function $2ae8a72d4579aba0$var$_toPrimitive(t, r) {
    if ("object" != $2ae8a72d4579aba0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2ae8a72d4579aba0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2ae8a72d4579aba0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2ae8a72d4579aba0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2ae8a72d4579aba0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2ae8a72d4579aba0$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $2ae8a72d4579aba0$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $2ae8a72d4579aba0$var$_objectWithoutProperties(_ref, $2ae8a72d4579aba0$var$_excluded);
    var props = $2ae8a72d4579aba0$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(height) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(top) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $2ae8a72d4579aba0$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(props, true), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-cross', className),
        d: $2ae8a72d4579aba0$var$getPath(x, y, width, height, top, left)
    }));
};


function $f95663c86cd8230d$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $2f00d3350e823531$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $747acf019ef7786e$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $2f00d3350e823531$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $d690e81478a10d12$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d690e81478a10d12$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d690e81478a10d12$var$_typeof(o);
}
function $d690e81478a10d12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d690e81478a10d12$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d690e81478a10d12$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d690e81478a10d12$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d690e81478a10d12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d690e81478a10d12$var$_defineProperty(obj, key, value) {
    key = $d690e81478a10d12$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d690e81478a10d12$var$_toPropertyKey(t) {
    var i = $d690e81478a10d12$var$_toPrimitive(t, "string");
    return "symbol" == $d690e81478a10d12$var$_typeof(i) ? i : i + "";
}
function $d690e81478a10d12$var$_toPrimitive(t, r) {
    if ("object" != $d690e81478a10d12$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d690e81478a10d12$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d690e81478a10d12$export$b6a79797ad180576(props) {
    var _element$props$cursor, _defaultProps;
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
    if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps;
    var cursorComp = (0, $af2055905739b7f2$export$b0e83c3ef8d2db1);
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $2ae8a72d4579aba0$export$3c877bb842c36952);
    } else if (chartName === 'BarChart') {
        restProps = (0, $f95663c86cd8230d$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $70f75e095c9bb92d$export$4617fb02663045ef);
    } else if (layout === 'radial') {
        var _getRadialCursorPoint = (0, $2f00d3350e823531$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $353ca4069312fa59$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $747acf019ef7786e$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $af2055905739b7f2$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $008f02516c156322$export$d697c39a2985a4c)(elementPropsCursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-tooltip-cursor', elementPropsCursor.className)
    });
    return /*#__PURE__*/ (0, $acw62.isValidElement)(elementPropsCursor) ? /*#__PURE__*/ (0, $acw62.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/ (0, $acw62.createElement)(cursorComp, cursorProps);
}



var $6d459a69f64f5f55$var$_excluded = [
    "item"
], $6d459a69f64f5f55$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $6d459a69f64f5f55$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6d459a69f64f5f55$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6d459a69f64f5f55$var$_typeof(o);
}
function $6d459a69f64f5f55$var$_extends() {
    $6d459a69f64f5f55$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6d459a69f64f5f55$var$_extends.apply(this, arguments);
}
function $6d459a69f64f5f55$var$_slicedToArray(arr, i) {
    return $6d459a69f64f5f55$var$_arrayWithHoles(arr) || $6d459a69f64f5f55$var$_iterableToArrayLimit(arr, i) || $6d459a69f64f5f55$var$_unsupportedIterableToArray(arr, i) || $6d459a69f64f5f55$var$_nonIterableRest();
}
function $6d459a69f64f5f55$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d459a69f64f5f55$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6d459a69f64f5f55$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6d459a69f64f5f55$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6d459a69f64f5f55$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6d459a69f64f5f55$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6d459a69f64f5f55$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6d459a69f64f5f55$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6d459a69f64f5f55$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6d459a69f64f5f55$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6d459a69f64f5f55$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6d459a69f64f5f55$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6d459a69f64f5f55$var$_callSuper(t, o, e) {
    return o = $6d459a69f64f5f55$var$_getPrototypeOf(o), $6d459a69f64f5f55$var$_possibleConstructorReturn(t, $6d459a69f64f5f55$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $6d459a69f64f5f55$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $6d459a69f64f5f55$var$_possibleConstructorReturn(self, call) {
    if (call && ($6d459a69f64f5f55$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6d459a69f64f5f55$var$_assertThisInitialized(self);
}
function $6d459a69f64f5f55$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6d459a69f64f5f55$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6d459a69f64f5f55$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $6d459a69f64f5f55$var$_getPrototypeOf(o) {
    $6d459a69f64f5f55$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6d459a69f64f5f55$var$_getPrototypeOf(o);
}
function $6d459a69f64f5f55$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6d459a69f64f5f55$var$_setPrototypeOf(subClass, superClass);
}
function $6d459a69f64f5f55$var$_setPrototypeOf(o, p) {
    $6d459a69f64f5f55$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6d459a69f64f5f55$var$_setPrototypeOf(o, p);
}
function $6d459a69f64f5f55$var$_toConsumableArray(arr) {
    return $6d459a69f64f5f55$var$_arrayWithoutHoles(arr) || $6d459a69f64f5f55$var$_iterableToArray(arr) || $6d459a69f64f5f55$var$_unsupportedIterableToArray(arr) || $6d459a69f64f5f55$var$_nonIterableSpread();
}
function $6d459a69f64f5f55$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d459a69f64f5f55$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6d459a69f64f5f55$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6d459a69f64f5f55$var$_arrayLikeToArray(o, minLen);
}
function $6d459a69f64f5f55$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6d459a69f64f5f55$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6d459a69f64f5f55$var$_arrayLikeToArray(arr);
}
function $6d459a69f64f5f55$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6d459a69f64f5f55$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d459a69f64f5f55$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d459a69f64f5f55$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6d459a69f64f5f55$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d459a69f64f5f55$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6d459a69f64f5f55$var$_defineProperty(obj, key, value) {
    key = $6d459a69f64f5f55$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6d459a69f64f5f55$var$_toPropertyKey(t) {
    var i = $6d459a69f64f5f55$var$_toPrimitive(t, "string");
    return "symbol" == $6d459a69f64f5f55$var$_typeof(i) ? i : i + "";
}
function $6d459a69f64f5f55$var$_toPrimitive(t, r) {
    if ("object" != $6d459a69f64f5f55$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6d459a69f64f5f55$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6d459a69f64f5f55$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $6d459a69f64f5f55$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var $6d459a69f64f5f55$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $6d459a69f64f5f55$var$renderAsIs(element) {
    return element;
}
var $6d459a69f64f5f55$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $6d459a69f64f5f55$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, rangeObj), (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, rangeObj), (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $6d459a69f64f5f55$var$originCoordinate;
};
var $6d459a69f64f5f55$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($6d459a69f64f5f55$var$_toConsumableArray(result), $6d459a69f64f5f55$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(dataStartIndex) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $6d459a69f64f5f55$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $6d459a69f64f5f55$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $6d459a69f64f5f55$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
        // The data is sliced only when the active index is within the start/end index range.
        state.dataEndIndex - state.dataStartIndex >= activeIndex) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $2ab3a7e25c8aba74$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($6d459a69f64f5f55$var$_toConsumableArray(result), [
            (0, $cd015374923bb5c7$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $6d459a69f64f5f55$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $6d459a69f64f5f55$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $cd015374923bb5c7$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $6d459a69f64f5f55$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $6d459a69f64f5f55$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $6d459a69f64f5f55$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _childProps$domain2;
        var childProps = child.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale = childProps.scale, ticks = childProps.ticks, includeHidden = childProps.includeHidden;
        var axisId = childProps[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $6d459a69f64f5f55$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                var _defaultProps;
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
                return itemAxisId === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $77a63a99eb6fec8b$export$33279f645a5831b7)(childProps.domain, allowDataOverflow, type)) {
            domain = (0, $cd015374923bb5c7$export$a0bc8660980558a0)(childProps.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $cd015374923bb5c7$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $6d459a69f64f5f55$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _childProps$domain;
            var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $cd015374923bb5c7$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $2ab3a7e25c8aba74$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($b392b5b21038a0ce$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $cd015374923bb5c7$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($6d459a69f64f5f55$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $cd015374923bb5c7$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entry) ? finalDomain : [].concat($6d459a69f64f5f55$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $cd015374923bb5c7$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        var _defaultProps2, _defaultProps3;
                        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
                        var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
                        return itemAxisId === axisId && (includeHidden || !itemHide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $cd015374923bb5c7$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($b392b5b21038a0ce$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $cd015374923bb5c7$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $cd015374923bb5c7$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
                var itemHide = 'hide' in item.props ? item.props.hide : item.type.defaultProps.hide;
                return itemAxisId === axisId && (includeHidden || !itemHide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $e8f3ee16c7c854b9$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $cd015374923bb5c7$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty({}, axisId, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, childProps), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $6d459a69f64f5f55$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $6d459a69f64f5f55$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var childProps = child.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var axisId = childProps[axisIdKey];
        var originalDomain = $6d459a69f64f5f55$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($b392b5b21038a0ce$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $cd015374923bb5c7$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $e8f3ee16c7c854b9$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $cd015374923bb5c7$export$a0bc8660980558a0)(originalDomain, (0, $cd015374923bb5c7$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    var _defaultProps4, _defaultProps5;
                    var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
                    var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
                    return itemAxisId === axisId && !itemHide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $e8f3ee16c7c854b9$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty({}, axisId, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))($6d459a69f64f5f55$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $6d459a69f64f5f55$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $6d459a69f64f5f55$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $6d459a69f64f5f55$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $6d459a69f64f5f55$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($300ea168693086c2$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $6d459a69f64f5f55$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $b0c0135ef9d67bd5$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $6d459a69f64f5f55$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $008f02516c156322$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $6d459a69f64f5f55$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $6d459a69f64f5f55$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $b0c0135ef9d67bd5$export$59bc2e3533b384a0));
    var legendItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $1f4bd73be8c7e839$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $b0c0135ef9d67bd5$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $cd015374923bb5c7$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var $6d459a69f64f5f55$var$getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === 'xAxis') return axisObj[axisName].width;
    if (axisName === 'yAxis') return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var $6d459a69f64f5f55$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $6d459a69f64f5f55$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $6d459a69f64f5f55$var$hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $6d459a69f64f5f55$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var itemProps = item.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = itemProps["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty($6d459a69f64f5f55$var$_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $cd015374923bb5c7$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $008f02516c156322$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, $cd015374923bb5c7$export$570d306bee26c748)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: $6d459a69f64f5f55$var$getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $cd015374923bb5c7$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, pos), {}, {
                        position: $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, composedFn($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, $6d459a69f64f5f55$var$_defineProperty($6d459a69f64f5f55$var$_defineProperty($6d459a69f64f5f55$var$_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, $008f02516c156322$export$857ca101f741953)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $008f02516c156322$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $6d459a69f64f5f55$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $cd015374923bb5c7$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, result), {}, $6d459a69f64f5f55$var$_defineProperty({}, name, $6d459a69f64f5f55$var$getAxisMap(props, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $6d459a69f64f5f55$var$calculateOffset($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $6d459a69f64f5f55$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    var CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $6d459a69f64f5f55$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = $6d459a69f64f5f55$var$_callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            $6d459a69f64f5f55$var$_defineProperty(_this, "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            $6d459a69f64f5f55$var$_defineProperty(_this, "accessibilityManager", new (0, $bde81ec92d1b0fae$export$a2c2de1efa8671eb)());
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($6d459a69f64f5f55$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $6d459a69f64f5f55$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleOuterEvent", function(e) {
                var eventName = (0, $008f02516c156322$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleDoubleClick", function(e) {
                var onDoubleClick = _this.props.onDoubleClick;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onDoubleClick)) {
                    var _nextState5 = _this.getMouseInfo(e);
                    onDoubleClick(_nextState5, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "handleContextMenu", function(e) {
                var onContextMenu = _this.props.onContextMenu;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onContextMenu)) {
                    var _nextState6 = _this.getMouseInfo(e);
                    onContextMenu(_nextState6, e);
                }
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).emit((0, $bbd08cd38300f8df$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($6d459a69f64f5f55$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $6d459a69f64f5f55$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $6d459a69f64f5f55$var$originCoordinate;
                    _this.setState($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || '_recharts-cursor';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d690e81478a10d12$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($d299ac421c05c135$exports)))(_this.state, "".concat(axisType, "Map"));
                var elementDefaultProps = element.type.defaultProps;
                var elementProps = elementDefaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, elementDefaultProps), element.props) : element.props;
                var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $acw62.cloneElement)(element, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, axisOption), {}, {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $acw62.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $3a45d033d706e33c$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $6d459a69f64f5f55$var$_objectWithoutProperties(props, $6d459a69f64f5f55$var$_excluded);
                return /*#__PURE__*/ (0, $acw62.cloneElement)(item, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $6d459a69f64f5f55$var$_defineProperty(_this, "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $3258e2bab55a6a07$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $acw62.cloneElement)(tooltipItem, {
                    viewBox: $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $acw62.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $cd015374923bb5c7$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _this2 = _this, clipPathId = _this2.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var elementDefaultProps = element.type.defaultProps || {};
                var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
                return /*#__PURE__*/ (0, $acw62.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                // item is not a React Element so we don't need to resolve defaultProps.
                var key = item.props.key;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
                var dotProps = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $cd015374923bb5c7$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value
                }, (0, $008f02516c156322$export$d697c39a2985a4c)(activeDot, false)), (0, $909d5f835f4e917b$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y
                }), "".concat(key, "-basePoint-").concat(childIndex)));
                else if (isRange) result.push(null);
                return result;
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $3258e2bab55a6a07$export$28c660c63b792dea));
                // item is not a React Element so we don't need to resolve defaultProps
                var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $cd015374923bb5c7$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $cd015374923bb5c7$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $cd015374923bb5c7$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $acw62.cloneElement)(element, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $2ab3a7e25c8aba74$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $2ab3a7e25c8aba74$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $acw62.cloneElement)(element, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($6d459a69f64f5f55$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $acw62.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $acw62.cloneElement)(element, $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $6d459a69f64f5f55$var$_defineProperty(_this, "renderMap", {
                CartesianGrid: {
                    handler: $6d459a69f64f5f55$var$renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $6d459a69f64f5f55$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $6d459a69f64f5f55$var$renderAsIs
                },
                YAxis: {
                    handler: $6d459a69f64f5f55$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($ff695783c7d42c0c$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $6d459a69f64f5f55$var$_inherits(CategoricalChartWrapper, _Component);
        return $6d459a69f64f5f55$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $3258e2bab55a6a07$export$28c660c63b792dea));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $6d459a69f64f5f55$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === 'horizontal';
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === 'Scatter';
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $008f02516c156322$export$acdc716e08572f94)([
                        (0, $008f02516c156322$export$64c61536a2b72e0f)(prevProps.children, (0, $3258e2bab55a6a07$export$28c660c63b792dea))
                    ], [
                        (0, $008f02516c156322$export$64c61536a2b72e0f)(this.props.children, (0, $3258e2bab55a6a07$export$28c660c63b792dea))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(this.props.children, (0, $3258e2bab55a6a07$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $41867cca6cb93873$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    var toolTipData = $6d459a69f64f5f55$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        }, toolTipData);
                    }
                    if (toolTipData) return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $2ab3a7e25c8aba74$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $0f9bc5dd76ad1109$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $3258e2bab55a6a07$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onDoubleClick: this.handleDoubleClick,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onContextMenu: this.handleContextMenu
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $909d5f835f4e917b$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).on((0, $bbd08cd38300f8df$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).removeListener((0, $bbd08cd38300f8df$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $008f02516c156322$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $6d459a69f64f5f55$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, res), {}, $6d459a69f64f5f55$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $6d459a69f64f5f55$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, res), {}, $6d459a69f64f5f55$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        // graphicalItem is not a React Element so we don't need to resolve defaultProps
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemProps = item.type.defaultProps !== undefined ? $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
                        var itemDisplayName = (0, $008f02516c156322$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $70f75e095c9bb92d$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $0f9bc5dd76ad1109$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $4696e249b64cd95e$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $4696e249b64cd95e$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $4696e249b64cd95e$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $4696e249b64cd95e$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: itemProps.data
                            });
                            var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
                            return {
                                graphicalItem: $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $4696e249b64cd95e$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    if (!(0, $008f02516c156322$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $6d459a69f64f5f55$var$_objectWithoutProperties(_this$props6, $6d459a69f64f5f55$var$_excluded2);
                    var attrs = (0, $008f02516c156322$export$d697c39a2985a4c)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e573f10901a87cfb$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfae0ec07b91e499$export$7b92b459e668cb21), $6d459a69f64f5f55$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $008f02516c156322$export$a98d6da55570cb82)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'application';
                        attrs.onKeyDown = function(e) {
                            _this3.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this3.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e573f10901a87cfb$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $6d459a69f64f5f55$var$_extends({
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-wrapper', className),
                        style: $6d459a69f64f5f55$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this3.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfae0ec07b91e499$export$7b92b459e668cb21), $6d459a69f64f5f55$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $6d459a69f64f5f55$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $008f02516c156322$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
    }((0, $acw62.Component));
    $6d459a69f64f5f55$var$_defineProperty(CategoricalChartWrapper, "displayName", chartName);
    // todo join specific chart propTypes
    $6d459a69f64f5f55$var$_defineProperty(CategoricalChartWrapper, "defaultProps", $6d459a69f64f5f55$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps));
    $6d459a69f64f5f55$var$_defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $6d459a69f64f5f55$export$e5182fb58612e577(nextProps);
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $0f60d716238978d6$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $6d459a69f64f5f55$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, $6d459a69f64f5f55$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($6d459a69f64f5f55$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $008f02516c156322$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $008f02516c156322$export$64c61536a2b72e0f)(children, (0, $b0c0135ef9d67bd5$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($6d459a69f64f5f55$var$_objectSpread($6d459a69f64f5f55$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    });
    $6d459a69f64f5f55$var$_defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
        var dot;
        if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) dot = /*#__PURE__*/ (0, $acw62.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ab98349969d46e2$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: key
        }, dot);
    });
    var CategoricalChart = /*#__PURE__*/ (0, $acw62.forwardRef)(function CategoricalChart(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CategoricalChartWrapper, $6d459a69f64f5f55$var$_extends({}, props, {
            ref: ref
        }));
    });
    CategoricalChart.displayName = CategoricalChartWrapper.displayName;
    return CategoricalChart;
};




var $acw62 = parcelRequire("acw62");




function $f21953d5ea7d4fb8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f21953d5ea7d4fb8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f21953d5ea7d4fb8$var$_typeof(o);
}
function $f21953d5ea7d4fb8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f21953d5ea7d4fb8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f21953d5ea7d4fb8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f21953d5ea7d4fb8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f21953d5ea7d4fb8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f21953d5ea7d4fb8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f21953d5ea7d4fb8$var$_callSuper(t, o, e) {
    return o = $f21953d5ea7d4fb8$var$_getPrototypeOf(o), $f21953d5ea7d4fb8$var$_possibleConstructorReturn(t, $f21953d5ea7d4fb8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $f21953d5ea7d4fb8$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $f21953d5ea7d4fb8$var$_possibleConstructorReturn(self, call) {
    if (call && ($f21953d5ea7d4fb8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f21953d5ea7d4fb8$var$_assertThisInitialized(self);
}
function $f21953d5ea7d4fb8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f21953d5ea7d4fb8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f21953d5ea7d4fb8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f21953d5ea7d4fb8$var$_getPrototypeOf(o) {
    $f21953d5ea7d4fb8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f21953d5ea7d4fb8$var$_getPrototypeOf(o);
}
function $f21953d5ea7d4fb8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f21953d5ea7d4fb8$var$_setPrototypeOf(subClass, superClass);
}
function $f21953d5ea7d4fb8$var$_setPrototypeOf(o, p) {
    $f21953d5ea7d4fb8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f21953d5ea7d4fb8$var$_setPrototypeOf(o, p);
}
function $f21953d5ea7d4fb8$var$_defineProperty(obj, key, value) {
    key = $f21953d5ea7d4fb8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f21953d5ea7d4fb8$var$_toPropertyKey(t) {
    var i = $f21953d5ea7d4fb8$var$_toPrimitive(t, "string");
    return "symbol" == $f21953d5ea7d4fb8$var$_typeof(i) ? i : i + "";
}
function $f21953d5ea7d4fb8$var$_toPrimitive(t, r) {
    if ("object" != $f21953d5ea7d4fb8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f21953d5ea7d4fb8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f21953d5ea7d4fb8$var$_extends() {
    $f21953d5ea7d4fb8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f21953d5ea7d4fb8$var$_extends.apply(this, arguments);
}
/** Define of XAxis props */ function $f21953d5ea7d4fb8$var$XAxisImpl(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $e573f10901a87cfb$export$8854f7ece606854b)();
    var height = (0, $e573f10901a87cfb$export$369ae257969c6f9f)();
    var axisOptions = (0, $e573f10901a87cfb$export$54f54805c81085c5)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    $acw62.createElement((0, $247385db510d7b7c$export$bdd99f2cdf352bae), $f21953d5ea7d4fb8$var$_extends({}, axisOptions, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(axis, true);
        }
    })));
}
var $f21953d5ea7d4fb8$export$ea77231de273b52d = /*#__PURE__*/ function(_React$Component) {
    function XAxis() {
        $f21953d5ea7d4fb8$var$_classCallCheck(this, XAxis);
        return $f21953d5ea7d4fb8$var$_callSuper(this, XAxis, arguments);
    }
    $f21953d5ea7d4fb8$var$_inherits(XAxis, _React$Component);
    return $f21953d5ea7d4fb8$var$_createClass(XAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $acw62.createElement($f21953d5ea7d4fb8$var$XAxisImpl, this.props);
            }
        }
    ]);
}($acw62.Component);
$f21953d5ea7d4fb8$var$_defineProperty($f21953d5ea7d4fb8$export$ea77231de273b52d, "displayName", 'XAxis');
$f21953d5ea7d4fb8$var$_defineProperty($f21953d5ea7d4fb8$export$ea77231de273b52d, "defaultProps", {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
});



var $acw62 = parcelRequire("acw62");




function $0e2dfd8b3bfb4506$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0e2dfd8b3bfb4506$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0e2dfd8b3bfb4506$var$_typeof(o);
}
function $0e2dfd8b3bfb4506$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0e2dfd8b3bfb4506$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0e2dfd8b3bfb4506$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0e2dfd8b3bfb4506$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0e2dfd8b3bfb4506$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0e2dfd8b3bfb4506$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0e2dfd8b3bfb4506$var$_callSuper(t, o, e) {
    return o = $0e2dfd8b3bfb4506$var$_getPrototypeOf(o), $0e2dfd8b3bfb4506$var$_possibleConstructorReturn(t, $0e2dfd8b3bfb4506$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $0e2dfd8b3bfb4506$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $0e2dfd8b3bfb4506$var$_possibleConstructorReturn(self, call) {
    if (call && ($0e2dfd8b3bfb4506$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0e2dfd8b3bfb4506$var$_assertThisInitialized(self);
}
function $0e2dfd8b3bfb4506$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0e2dfd8b3bfb4506$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0e2dfd8b3bfb4506$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0e2dfd8b3bfb4506$var$_getPrototypeOf(o) {
    $0e2dfd8b3bfb4506$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0e2dfd8b3bfb4506$var$_getPrototypeOf(o);
}
function $0e2dfd8b3bfb4506$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0e2dfd8b3bfb4506$var$_setPrototypeOf(subClass, superClass);
}
function $0e2dfd8b3bfb4506$var$_setPrototypeOf(o, p) {
    $0e2dfd8b3bfb4506$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0e2dfd8b3bfb4506$var$_setPrototypeOf(o, p);
}
function $0e2dfd8b3bfb4506$var$_defineProperty(obj, key, value) {
    key = $0e2dfd8b3bfb4506$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0e2dfd8b3bfb4506$var$_toPropertyKey(t) {
    var i = $0e2dfd8b3bfb4506$var$_toPrimitive(t, "string");
    return "symbol" == $0e2dfd8b3bfb4506$var$_typeof(i) ? i : i + "";
}
function $0e2dfd8b3bfb4506$var$_toPrimitive(t, r) {
    if ("object" != $0e2dfd8b3bfb4506$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0e2dfd8b3bfb4506$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0e2dfd8b3bfb4506$var$_extends() {
    $0e2dfd8b3bfb4506$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e2dfd8b3bfb4506$var$_extends.apply(this, arguments);
}
var $0e2dfd8b3bfb4506$var$YAxisImpl = function YAxisImpl(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $e573f10901a87cfb$export$8854f7ece606854b)();
    var height = (0, $e573f10901a87cfb$export$369ae257969c6f9f)();
    var axisOptions = (0, $e573f10901a87cfb$export$6f8958021ad81c20)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    $acw62.createElement((0, $247385db510d7b7c$export$bdd99f2cdf352bae), $0e2dfd8b3bfb4506$var$_extends({}, axisOptions, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
var $0e2dfd8b3bfb4506$export$f96c4024c52de8f4 = /*#__PURE__*/ function(_React$Component) {
    function YAxis() {
        $0e2dfd8b3bfb4506$var$_classCallCheck(this, YAxis);
        return $0e2dfd8b3bfb4506$var$_callSuper(this, YAxis, arguments);
    }
    $0e2dfd8b3bfb4506$var$_inherits(YAxis, _React$Component);
    return $0e2dfd8b3bfb4506$var$_createClass(YAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $acw62.createElement($0e2dfd8b3bfb4506$var$YAxisImpl, this.props);
            }
        }
    ]);
}($acw62.Component);
$0e2dfd8b3bfb4506$var$_defineProperty($0e2dfd8b3bfb4506$export$f96c4024c52de8f4, "displayName", 'YAxis');
$0e2dfd8b3bfb4506$var$_defineProperty($0e2dfd8b3bfb4506$export$f96c4024c52de8f4, "defaultProps", {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
});



var $d1341a4ce4753cde$export$54d0e8420ac838ac = (0, $6d459a69f64f5f55$export$77871aede60e6838)({
    chartName: 'LineChart',
    GraphicalChild: (0, $f8a3115883abd1dc$export$17d680238e50603e),
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $f21953d5ea7d4fb8$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $7dad4d5151ba4a01$export$ece7de1383db5ac)
});



var $acw62 = parcelRequire("acw62");




function $0431397098acacbe$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0431397098acacbe$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0431397098acacbe$var$_typeof(o);
}
function $0431397098acacbe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0431397098acacbe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0431397098acacbe$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0431397098acacbe$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0431397098acacbe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0431397098acacbe$var$_defineProperty(obj, key, value) {
    key = $0431397098acacbe$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0431397098acacbe$var$_toPropertyKey(t) {
    var i = $0431397098acacbe$var$_toPrimitive(t, "string");
    return "symbol" == $0431397098acacbe$var$_typeof(i) ? i : i + "";
}
function $0431397098acacbe$var$_toPrimitive(t, r) {
    if ("object" != $0431397098acacbe$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0431397098acacbe$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0431397098acacbe$var$_slicedToArray(arr, i) {
    return $0431397098acacbe$var$_arrayWithHoles(arr) || $0431397098acacbe$var$_iterableToArrayLimit(arr, i) || $0431397098acacbe$var$_unsupportedIterableToArray(arr, i) || $0431397098acacbe$var$_nonIterableRest();
}
function $0431397098acacbe$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0431397098acacbe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0431397098acacbe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0431397098acacbe$var$_arrayLikeToArray(o, minLen);
}
function $0431397098acacbe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0431397098acacbe$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0431397098acacbe$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $0431397098acacbe$export$e60a4704009a0009 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $acw62.useRef)(null);
    var onResizeRef = (0, $acw62.useRef)();
    onResizeRef.current = onResize;
    (0, $acw62.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, 'current', {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, $acw62.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $0431397098acacbe$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $acw62.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $acw62.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($ff695783c7d42c0c$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $acw62.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)((0, $2ab3a7e25c8aba74$export$e50269385c77c348)(width) || (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $008f02516c156322$export$be63e0664592e141)(children.type).endsWith('Chart');
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, function(child) {
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) return /*#__PURE__*/ (0, $acw62.cloneElement)(child, $0431397098acacbe$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $0431397098acacbe$var$_objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-responsive-container', className),
        style: $0431397098acacbe$var$_objectSpread($0431397098acacbe$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});





const $c45cbe94b11ffc58$var$MS_PER_DAY = 86400000;
// Chart timestamps are UTC date-only values (both charts key off midnight-UTC
// dates), so all calendar math — boundaries and the labels themselves — runs
// in UTC. Doing it in the browser's local zone would, west of UTC, read a
// midnight-UTC point as the previous day and drop the final year's tick/label.
const $c45cbe94b11ffc58$var$UTC = {
    zone: 'utc'
};
const $c45cbe94b11ffc58$export$2319624620038bd2 = (minTs, maxTs)=>(ts)=>{
        const spanDays = Math.abs(maxTs - minTs) / $c45cbe94b11ffc58$var$MS_PER_DAY;
        const dt = (0, $63618293c58b5f80$exports.DateTime).fromMillis(ts, $c45cbe94b11ffc58$var$UTC);
        if (spanDays > 750) return dt.toFormat('yyyy');
        if (spanDays > 90) return dt.toFormat('MMM yyyy');
        return dt.toFormat('MMM d');
    };
const $c45cbe94b11ffc58$export$2fd906f40273e9a6 = (minTs, maxTs)=>{
    if (!(maxTs > minTs)) return [
        minTs
    ];
    const spanDays = (maxTs - minTs) / $c45cbe94b11ffc58$var$MS_PER_DAY;
    const start = (0, $63618293c58b5f80$exports.DateTime).fromMillis(minTs, $c45cbe94b11ffc58$var$UTC);
    const end = (0, $63618293c58b5f80$exports.DateTime).fromMillis(maxTs, $c45cbe94b11ffc58$var$UTC);
    const ticks = [];
    // Walk calendar boundaries from the first aligned point at or after the
    // start; boundaries before the start would be clipped by the axis domain.
    const collect = (first, advance)=>{
        for(let cur = first; cur <= end; cur = advance(cur))if (cur >= start) ticks.push(cur.toMillis());
    };
    if (spanDays > 750) {
        const years = end.year - start.year + 1;
        const step = Math.max(1, Math.ceil(years / 8));
        collect(start.startOf('year'), (dt)=>dt.plus({
                years: step
            }));
    } else if (spanDays > 90) {
        const months = Math.round(end.diff(start.startOf('month'), 'months').months) + 1;
        const step = Math.max(1, Math.ceil(months / 7));
        collect(start.startOf('month'), (dt)=>dt.plus({
                months: step
            }));
    } else {
        const step = Math.max(1, Math.ceil(spanDays / 6));
        collect(start.startOf('day'), (dt)=>dt.plus({
                days: step
            }));
    }
    return ticks.length > 0 ? ticks : [
        minTs
    ];
};



// Custom units render through their Unit metadata ("3 passes"); non-ISO
// commodity currencies (TENNIS_CLASS) make Intl's currency style throw and
// fall back to a plain number with the code as a suffix, mirroring
// Money.toDecimalString's fallback.
const $566ebfc1457f0dbd$var$formatCurrency = (cents, currency, unitsById)=>{
    if (unitsById.has(currency)) return (0, $9ac5aec7425fcb2d$export$ba37dda4e3a0b386)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(cents, currency), unitsById);
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(cents / 100);
    } catch  {
        const bare = new Intl.NumberFormat('en-US', {
            maximumFractionDigits: 2
        }).format(cents / 100);
        return `${bare} ${currency}`;
    }
};
// Compact axis labels ($1.2K, $304K) so the Y gutter stays narrow on mobile.
// The tooltip still shows the exact value. Custom units get the bare compact
// number — the unit label would widen the gutter, and the tooltip names it.
const $566ebfc1457f0dbd$var$formatCompactCurrency = (cents, currency, unitsById)=>{
    if (unitsById.has(currency)) return new Intl.NumberFormat('en-US', {
        notation: 'compact',
        maximumFractionDigits: 1
    }).format(cents / 100);
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            notation: 'compact',
            maximumFractionDigits: 1
        }).format(cents / 100);
    } catch  {
        return new Intl.NumberFormat('en-US', {
            notation: 'compact',
            maximumFractionDigits: 1
        }).format(cents / 100);
    }
};
/** Where a point's balance came from — mirrors the server's source union. */ const $566ebfc1457f0dbd$var$SOURCE_LABELS = {
    reading: 'Synced balance',
    reconciled: 'Reconciled ledger',
    estimated: 'Estimated from transactions',
    anchor: 'Recorded balance',
    opening: 'Starting balance',
    checkpoint: 'Reconciled checkpoint'
};
// Matches the reconcile timeline's status colors: green for reconciled,
// amber for a recorded balance still awaiting reconciliation, sky for the
// starting balance (the timeline's label for it, and the opening-balance
// badge on the anchor detail page).
const $566ebfc1457f0dbd$var$CHECKPOINT_COLOR = '#16a34a';
const $566ebfc1457f0dbd$var$PENDING_ANCHOR_COLOR = '#d97706';
const $566ebfc1457f0dbd$var$OPENING_ANCHOR_COLOR = '#0284c7';
const $566ebfc1457f0dbd$var$LINE_COLOR = '#3b82f6';
const $566ebfc1457f0dbd$var$RANGES = [
    {
        key: '1M',
        label: '1M',
        months: 1
    },
    {
        key: '3M',
        label: '3M',
        months: 3
    },
    {
        key: '6M',
        label: '6M',
        months: 6
    },
    {
        key: '1Y',
        label: '1Y',
        months: 12
    },
    {
        key: 'ALL',
        label: 'All',
        months: null
    }
];
const $566ebfc1457f0dbd$var$CustomTooltip = ({ active: active, payload: payload, label: label, currency: currency, unitsById: unitsById })=>{
    if (!active || !payload?.length || label === undefined) return null;
    const point = payload[0].payload;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-card border-border rounded-lg border px-3 py-2 shadow-md",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground mb-1 text-xs",
                children: (0, $63618293c58b5f80$exports.DateTime).fromMillis(label, {
                    zone: 'utc'
                }).toFormat('MMM d, yyyy')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-foreground text-sm font-semibold",
                children: $566ebfc1457f0dbd$var$formatCurrency(point.balance, currency, unitsById)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground mt-0.5 text-xs",
                children: $566ebfc1457f0dbd$var$SOURCE_LABELS[point.source] ?? point.source
            })
        ]
    });
};
const $566ebfc1457f0dbd$var$toMillis = (isoDate)=>(0, $63618293c58b5f80$exports.DateTime).fromISO(isoDate, {
        zone: 'utc'
    }).toMillis();
const $566ebfc1457f0dbd$export$b2e57ed472dc3b95 = ({ points: points, spans: spans, loading: loading, currency: currency, isCreditCard: isCreditCard })=>{
    const unitsById = (0, $9b33a37eb331091e$export$17987e0a14ce8a32)();
    const [range, setRange] = $acw62.useState('ALL');
    // Flatten to display-signed points sorted by day (the server already sorts,
    // but a defensive sort keeps the step line monotonic in time).
    const allPoints = $acw62.useMemo(()=>[
            ...points
        ].map((p)=>({
                timestamp: $566ebfc1457f0dbd$var$toMillis(p.date),
                balance: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(p.balance, isCreditCard ?? false),
                source: p.source
            })).sort((a, b)=>a.timestamp - b.timestamp), [
        points,
        isCreditCard
    ]);
    // Range clip: keep points on/after the window start. A synthetic carry point
    // at the window edge holds the last pre-window balance so the step line fills
    // the whole width rather than starting partway in.
    const rangeStart = $acw62.useMemo(()=>{
        const months = $566ebfc1457f0dbd$var$RANGES.find((r)=>r.key === range)?.months ?? null;
        if (months === null || allPoints.length === 0) return null;
        const last = allPoints[allPoints.length - 1].timestamp;
        return (0, $63618293c58b5f80$exports.DateTime).fromMillis(last).minus({
            months: months
        }).toMillis();
    }, [
        range,
        allPoints
    ]);
    const visiblePoints = $acw62.useMemo(()=>{
        if (rangeStart === null) return allPoints;
        const within = allPoints.filter((p)=>p.timestamp >= rangeStart);
        const lastBefore = [
            ...allPoints
        ].reverse().find((p)=>p.timestamp < rangeStart);
        if (lastBefore && (within.length === 0 || within[0].timestamp > rangeStart)) // Carry the pre-window balance in at the window edge so the step line
        // fills the full width. It keeps the carried source (so its tooltip and
        // solid/dashed styling are right) but is flagged so it draws no dot.
        return [
            {
                timestamp: rangeStart,
                balance: lastBefore.balance,
                source: lastBefore.source,
                isCarry: true
            },
            ...within
        ];
        return within;
    }, [
        allPoints,
        rangeStart
    ]);
    // Split into the solid + dashed series, marking the boundary points that
    // belong to both so the dashed estimated tail connects to the solid line.
    const chartData = $acw62.useMemo(()=>{
        const isEstimated = (source)=>source === 'estimated';
        return visiblePoints.map((p, i)=>{
            const prev = visiblePoints[i - 1];
            const next = visiblePoints[i + 1];
            const estimatedHere = isEstimated(p.source);
            // A boundary point is an attested point adjacent to an estimated one.
            const touchesEstimated = prev && isEstimated(prev.source) || next && isEstimated(next.source);
            return {
                timestamp: p.timestamp,
                source: p.source,
                balance: p.balance,
                solidBalance: estimatedHere ? null : p.balance,
                estimatedBalance: estimatedHere || touchesEstimated ? p.balance : null,
                checkpointBalance: p.source === 'checkpoint' && !p.isCarry ? p.balance : null,
                pendingAnchorBalance: p.source === 'anchor' && !p.isCarry ? p.balance : null,
                openingAnchorBalance: p.source === 'opening' && !p.isCarry ? p.balance : null
            };
        });
    }, [
        visiblePoints
    ]);
    const visibleSpans = $acw62.useMemo(()=>spans.map((s)=>({
                start: $566ebfc1457f0dbd$var$toMillis(s.startDate),
                end: $566ebfc1457f0dbd$var$toMillis(s.endDate)
            })).filter((s)=>rangeStart === null || s.end >= rangeStart), [
        spans,
        rangeStart
    ]);
    if (!loading && allPoints.length < 2) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground flex h-32 items-center justify-center text-sm",
        children: "Record at least two balances to see a chart."
    });
    // Format axis labels from the span actually on screen so a multi-year range
    // shows years and a multi-month range shows "MMM yyyy" instead of an
    // ambiguous bare "Jun 9". For spans past a few months, pin ticks to calendar
    // boundaries so the coarser labels stay aligned and unique; shorter windows
    // keep Recharts' automatic day-level ticks.
    const firstTs = chartData[0]?.timestamp ?? 0;
    const lastTs = chartData[chartData.length - 1]?.timestamp ?? firstTs;
    const spanDays = (lastTs - firstTs) / 86400000;
    const tickFormatter = (0, $c45cbe94b11ffc58$export$2319624620038bd2)(firstTs, lastTs);
    const ticks = spanDays > 90 ? (0, $c45cbe94b11ffc58$export$2fd906f40273e9a6)(firstTs, lastTs) : undefined;
    const hasCheckpoints = chartData.some((p)=>p.checkpointBalance !== null);
    const hasPendingAnchors = chartData.some((p)=>p.pendingAnchorBalance !== null);
    const hasOpeningAnchor = chartData.some((p)=>p.openingAnchorBalance !== null);
    const hasEstimated = chartData.some((p)=>p.source === 'estimated');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mb-2 flex justify-end",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "border-border inline-flex overflow-hidden rounded-lg border",
                    children: $566ebfc1457f0dbd$var$RANGES.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>setRange(r.key),
                            className: `px-2.5 py-1 text-xs transition ${range === r.key ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted'}`,
                            children: r.label
                        }, r.key))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
                width: "100%",
                height: 180,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d1341a4ce4753cde$export$54d0e8420ac838ac), {
                    data: chartData,
                    margin: {
                        top: 4,
                        right: 8,
                        left: 0,
                        bottom: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                            strokeDasharray: "3 3",
                            className: "stroke-border"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                            dataKey: "timestamp",
                            scale: "time",
                            type: "number",
                            domain: [
                                'dataMin',
                                'dataMax'
                            ],
                            ticks: ticks,
                            tickFormatter: tickFormatter,
                            tick: {
                                fontSize: 11
                            },
                            className: "text-muted-foreground"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                            tickFormatter: (cents)=>$566ebfc1457f0dbd$var$formatCompactCurrency(cents, currency, unitsById),
                            tick: {
                                fontSize: 11
                            },
                            width: 52,
                            className: "text-muted-foreground"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($566ebfc1457f0dbd$var$CustomTooltip, {
                                currency: currency,
                                unitsById: unitsById
                            })
                        }),
                        visibleSpans.map((span)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab818fa12c183ba2$export$b4ec4f050ce240b9), {
                                x1: span.start,
                                x2: span.end,
                                fill: $566ebfc1457f0dbd$var$CHECKPOINT_COLOR,
                                fillOpacity: 0.08,
                                stroke: "none"
                            }, `span-${span.start}`)),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                            type: "stepAfter",
                            dataKey: "estimatedBalance",
                            stroke: $566ebfc1457f0dbd$var$LINE_COLOR,
                            strokeWidth: 2,
                            strokeDasharray: "4 3",
                            dot: false,
                            activeDot: {
                                r: 4
                            },
                            isAnimationActive: false,
                            connectNulls: false,
                            name: "Estimated"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                            type: "stepAfter",
                            dataKey: "solidBalance",
                            stroke: $566ebfc1457f0dbd$var$LINE_COLOR,
                            strokeWidth: 2,
                            dot: chartData.length <= 30,
                            activeDot: {
                                r: 4
                            },
                            isAnimationActive: false,
                            connectNulls: false,
                            name: "Balance"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                            dataKey: "checkpointBalance",
                            stroke: "none",
                            dot: {
                                r: 4,
                                fill: $566ebfc1457f0dbd$var$CHECKPOINT_COLOR,
                                strokeWidth: 0
                            },
                            activeDot: false,
                            isAnimationActive: false,
                            name: "Reconciled checkpoint"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                            dataKey: "pendingAnchorBalance",
                            stroke: "none",
                            dot: {
                                r: 4,
                                fill: $566ebfc1457f0dbd$var$PENDING_ANCHOR_COLOR,
                                strokeWidth: 0
                            },
                            activeDot: false,
                            isAnimationActive: false,
                            name: "Recorded balance"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                            dataKey: "openingAnchorBalance",
                            stroke: "none",
                            dot: {
                                r: 4,
                                fill: $566ebfc1457f0dbd$var$OPENING_ANCHOR_COLOR,
                                strokeWidth: 0
                            },
                            activeDot: false,
                            isAnimationActive: false,
                            name: "Starting balance"
                        })
                    ]
                })
            }),
            (hasCheckpoints || hasPendingAnchors || hasOpeningAnchor || hasEstimated) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs",
                children: [
                    visibleSpans.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "inline-flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "inline-block h-2.5 w-3.5 rounded-xs",
                                style: {
                                    backgroundColor: $566ebfc1457f0dbd$var$CHECKPOINT_COLOR,
                                    opacity: 0.15
                                }
                            }),
                            "Reconciled span"
                        ]
                    }),
                    hasCheckpoints && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "inline-flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "inline-block size-2 rounded-full",
                                style: {
                                    backgroundColor: $566ebfc1457f0dbd$var$CHECKPOINT_COLOR
                                }
                            }),
                            "Reconciled checkpoint"
                        ]
                    }),
                    hasOpeningAnchor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "inline-flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "inline-block size-2 rounded-full",
                                style: {
                                    backgroundColor: $566ebfc1457f0dbd$var$OPENING_ANCHOR_COLOR
                                }
                            }),
                            "Starting balance"
                        ]
                    }),
                    hasPendingAnchors && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "inline-flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "inline-block size-2 rounded-full",
                                style: {
                                    backgroundColor: $566ebfc1457f0dbd$var$PENDING_ANCHOR_COLOR
                                }
                            }),
                            "Not yet reconciled"
                        ]
                    }),
                    hasEstimated && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "inline-flex items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                width: "14",
                                height: "6",
                                className: "inline-block",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                    x1: "0",
                                    y1: "3",
                                    x2: "14",
                                    y2: "3",
                                    stroke: $566ebfc1457f0dbd$var$LINE_COLOR,
                                    strokeWidth: "2",
                                    strokeDasharray: "4 3"
                                })
                            }),
                            "Estimated"
                        ]
                    })
                ]
            })
        ]
    });
};






parcelRequire("acw62");

parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");















var $551fcf7b84a33486$var$_excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
], $551fcf7b84a33486$var$_excluded2 = [
    "key"
];
var $551fcf7b84a33486$var$_Area;
function $551fcf7b84a33486$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $551fcf7b84a33486$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $551fcf7b84a33486$var$_typeof(o);
}
function $551fcf7b84a33486$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $551fcf7b84a33486$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $551fcf7b84a33486$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $551fcf7b84a33486$var$_extends() {
    $551fcf7b84a33486$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $551fcf7b84a33486$var$_extends.apply(this, arguments);
}
function $551fcf7b84a33486$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $551fcf7b84a33486$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $551fcf7b84a33486$var$ownKeys(Object(t), !0).forEach(function(r) {
            $551fcf7b84a33486$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $551fcf7b84a33486$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $551fcf7b84a33486$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $551fcf7b84a33486$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $551fcf7b84a33486$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $551fcf7b84a33486$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $551fcf7b84a33486$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $551fcf7b84a33486$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $551fcf7b84a33486$var$_callSuper(t, o, e) {
    return o = $551fcf7b84a33486$var$_getPrototypeOf(o), $551fcf7b84a33486$var$_possibleConstructorReturn(t, $551fcf7b84a33486$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $551fcf7b84a33486$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $551fcf7b84a33486$var$_possibleConstructorReturn(self, call) {
    if (call && ($551fcf7b84a33486$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $551fcf7b84a33486$var$_assertThisInitialized(self);
}
function $551fcf7b84a33486$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $551fcf7b84a33486$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($551fcf7b84a33486$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $551fcf7b84a33486$var$_getPrototypeOf(o) {
    $551fcf7b84a33486$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $551fcf7b84a33486$var$_getPrototypeOf(o);
}
function $551fcf7b84a33486$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $551fcf7b84a33486$var$_setPrototypeOf(subClass, superClass);
}
function $551fcf7b84a33486$var$_setPrototypeOf(o, p) {
    $551fcf7b84a33486$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $551fcf7b84a33486$var$_setPrototypeOf(o, p);
}
function $551fcf7b84a33486$var$_defineProperty(obj, key, value) {
    key = $551fcf7b84a33486$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $551fcf7b84a33486$var$_toPropertyKey(t) {
    var i = $551fcf7b84a33486$var$_toPrimitive(t, "string");
    return "symbol" == $551fcf7b84a33486$var$_typeof(i) ? i : i + "";
}
function $551fcf7b84a33486$var$_toPrimitive(t, r) {
    if ("object" != $551fcf7b84a33486$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $551fcf7b84a33486$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $551fcf7b84a33486$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    function Area() {
        var _this;
        $551fcf7b84a33486$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $551fcf7b84a33486$var$_callSuper(this, Area, [].concat(args));
        $551fcf7b84a33486$var$_defineProperty(_this, "state", {
            isAnimationFinished: true
        });
        $551fcf7b84a33486$var$_defineProperty(_this, "id", (0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('recharts-area-'));
        $551fcf7b84a33486$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $551fcf7b84a33486$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    $551fcf7b84a33486$var$_inherits(Area, _PureComponent);
    return $551fcf7b84a33486$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false);
                var customDotProps = (0, $008f02516c156322$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $551fcf7b84a33486$var$_objectSpread($551fcf7b84a33486$var$_objectSpread($551fcf7b84a33486$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        dataKey: dataKey,
                        value: entry.value,
                        payload: entry.payload,
                        points: points
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $551fcf7b84a33486$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxY = Math.max(baseLine, maxY);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxX = Math.max(baseLine, maxX);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($7d231ba5a67a42db$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === 'vertical') return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $551fcf7b84a33486$var$_objectWithoutProperties(_this$props4, $551fcf7b84a33486$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $af2055905739b7f2$export$b0e83c3ef8d2db1), $551fcf7b84a33486$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== 'none' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $af2055905739b7f2$export$b0e83c3ef8d2db1), $551fcf7b84a33486$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== 'none' && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $af2055905739b7f2$export$b0e83c3ef8d2db1), $551fcf7b84a33486$var$_extends({}, (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $551fcf7b84a33486$var$_objectSpread($551fcf7b84a33486$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') {
                            var interpolator = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($10ed4ab35db4c025$exports)))(baseLine)) {
                            var _interpolator = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $551fcf7b84a33486$var$_objectSpread($551fcf7b84a33486$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($394ab417e9bd75cc$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($394ab417e9bd75cc$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-area', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $008f02516c156322$export$d697c39a2985a4c)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $008f02516c156322$export$392f6c9701718a4e)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $88ab0dba0fc78576$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
}((0, $acw62.PureComponent));
$551fcf7b84a33486$var$_Area = $551fcf7b84a33486$export$ea1a111407f37557;
$551fcf7b84a33486$var$_defineProperty($551fcf7b84a33486$export$ea1a111407f37557, "displayName", 'Area');
$551fcf7b84a33486$var$_defineProperty($551fcf7b84a33486$export$ea1a111407f37557, "defaultProps", {
    stroke: '#3182bd',
    fill: '#3182bd',
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'line',
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
});
$551fcf7b84a33486$var$_defineProperty($551fcf7b84a33486$export$ea1a111407f37557, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseValue) && typeof baseValue === 'number') return baseValue;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === 'dataMin') return domainMin;
        if (baseValue === 'dataMax') return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === 'dataMin') return domain[0];
    if (baseValue === 'dataMax') return domain[1];
    return domain[0];
});
$551fcf7b84a33486$var$_defineProperty($551fcf7b84a33486$export$ea1a111407f37557, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $551fcf7b84a33486$var$_Area.getBaseValue(props, item, xAxis, yAxis);
    var isHorizontalLayout = layout === 'horizontal';
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = value[1] == null || hasStack && (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, dataKey) == null;
        if (isHorizontalLayout) return {
            x: (0, $cd015374923bb5c7$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $cd015374923bb5c7$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) return {
            x: entry.x,
            y: x != null && entry.y != null ? yAxis.scale(x) : null
        };
        return {
            x: x != null ? xAxis.scale(x) : null,
            y: entry.y
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
    return $551fcf7b84a33486$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
$551fcf7b84a33486$var$_defineProperty($551fcf7b84a33486$export$ea1a111407f37557, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(option)) dotItem = option(props);
    else {
        var className = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-area-dot', typeof option !== 'boolean' ? option.className : '');
        var key = props.key, rest = $551fcf7b84a33486$var$_objectWithoutProperties(props, $551fcf7b84a33486$var$_excluded2);
        dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ab98349969d46e2$export$d046b3c4a416f60d), $551fcf7b84a33486$var$_extends({}, rest, {
            key: key,
            className: className
        }));
    }
    return dotItem;
});

/**
 * @fileOverview Area Chart
 */ 




var $40df630ec903a4ea$export$f510429275d6f1a8 = (0, $6d459a69f64f5f55$export$77871aede60e6838)({
    chartName: 'AreaChart',
    GraphicalChild: (0, $551fcf7b84a33486$export$ea1a111407f37557),
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $f21953d5ea7d4fb8$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $7dad4d5151ba4a01$export$ece7de1383db5ac)
});





var $acw62 = parcelRequire("acw62");

const $2481f76376092917$var$DATE_RANGES = [
    {
        label: '1 month',
        value: '1M'
    },
    {
        label: '3 months',
        value: '3M'
    },
    {
        label: '6 months',
        value: '6M'
    },
    {
        label: '1 year',
        value: '1Y'
    },
    {
        label: '5 years',
        value: '5Y'
    }
];
const $2481f76376092917$var$getPresetRange = (range)=>{
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    switch(range){
        case '1M':
            return {
                startDate: now.minus({
                    months: 1
                }),
                endDate: null
            };
        case '3M':
            return {
                startDate: now.minus({
                    months: 3
                }),
                endDate: null
            };
        case '6M':
            return {
                startDate: now.minus({
                    months: 6
                }),
                endDate: null
            };
        case '1Y':
            return {
                startDate: now.minus({
                    years: 1
                }),
                endDate: null
            };
        case '5Y':
            return {
                startDate: now.minus({
                    years: 5
                }),
                endDate: null
            };
        case 'ALL':
        case 'CUSTOM':
            return {
                startDate: null,
                endDate: null
            };
    }
};
const $2481f76376092917$var$getActivePreset = (value)=>{
    if (value.endDate) return null; // Custom end date means no preset
    if (!value.startDate) return 'ALL';
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    const diffDays = now.diff(value.startDate, 'days').days;
    // Calendar months vary in length, so match against the full range of days
    // each preset can span (e.g., 3 months is 89-92 days)
    if (diffDays >= 27 && diffDays <= 32) return '1M';
    if (diffDays >= 88 && diffDays <= 93) return '3M';
    if (diffDays >= 179 && diffDays <= 185) return '6M';
    if (diffDays >= 364 && diffDays <= 367) return '1Y';
    if (diffDays >= 1824 && diffDays <= 1828) return '5Y';
    return null;
};
const $2481f76376092917$export$26dc5fbaa253de80 = ({ value: value, onChange: onChange })=>{
    const activePreset = $2481f76376092917$var$getActivePreset(value);
    const [showCustom, setShowCustom] = $acw62.useState(activePreset === null);
    const selection = showCustom ? 'CUSTOM' : activePreset === null ? 'CUSTOM' : activePreset === 'ALL' ? 'all' : activePreset;
    const handleSelect = (key)=>{
        if (key === 'all') {
            setShowCustom(false);
            onChange($2481f76376092917$var$getPresetRange('ALL'));
        } else if (key === 'CUSTOM') setShowCustom(true);
        else {
            const preset = $2481f76376092917$var$DATE_RANGES.find((r)=>r.value === key)?.value;
            if (preset) {
                setShowCustom(false);
                onChange($2481f76376092917$var$getPresetRange(preset));
            }
        }
    };
    const handleStartChange = (e)=>{
        const dateStr = e.target.value;
        onChange({
            ...value,
            startDate: dateStr ? (0, $63618293c58b5f80$exports.DateTime).fromISO(dateStr) : null
        });
    };
    const handleEndChange = (e)=>{
        const dateStr = e.target.value;
        onChange({
            ...value,
            endDate: dateStr ? (0, $63618293c58b5f80$exports.DateTime).fromISO(dateStr) : null
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                label: "Range",
                allLabel: "All time",
                options: [
                    ...$2481f76376092917$var$DATE_RANGES.map(({ label: label, value: preset })=>({
                            key: preset,
                            label: label
                        })),
                    {
                        key: 'CUSTOM',
                        label: "Custom\u2026"
                    }
                ],
                value: selection,
                onChange: handleSelect
            }),
            showCustom && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex basis-full items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "date",
                        value: value.startDate?.toISODate() ?? '',
                        onChange: handleStartChange,
                        className: "border-border bg-background text-foreground rounded border px-2 py-1 text-sm"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-sm",
                        children: "to"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "date",
                        value: value.endDate?.toISODate() ?? '',
                        onChange: handleEndChange,
                        className: "border-border bg-background text-foreground rounded border px-2 py-1 text-sm"
                    })
                ]
            })
        ]
    });
};
const $2481f76376092917$export$1799ff211e43f48e = (initialRange = 'ALL')=>{
    const [dateRange, setDateRange] = $acw62.useState(()=>$2481f76376092917$var$getPresetRange(initialRange));
    const filterByDateRange = (items)=>{
        return items.filter((item)=>{
            const itemDate = (0, $63618293c58b5f80$exports.DateTime).fromISO(item.date);
            if (dateRange.startDate && itemDate < dateRange.startDate) return false;
            if (dateRange.endDate && itemDate > dateRange.endDate) return false;
            return true;
        });
    };
    return {
        dateRange: dateRange,
        setDateRange: setDateRange,
        filterByDateRange: filterByDateRange
    };
};




// The categorical palette has exactly eight validated slots, so the stacked
// view shows at most eight bands: every account when eight or fewer have
// history, otherwise the seven largest by latest value plus an "Other" fold
// (which takes the eighth slot). Colors assign by descending size and stay
// stable while the control is open.
const $2cf5bc16d816990b$var$MAX_STACK_BANDS = 8;
const $2cf5bc16d816990b$var$OTHER_KEY = '__other__';
const $2cf5bc16d816990b$var$RESOLUTION_MAP = {
    daily: (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Daily,
    weekly: (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Weekly,
    monthly: (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Monthly
};
const $2cf5bc16d816990b$var$formatCurrency = (cents)=>{
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(cents / 100);
};
const $2cf5bc16d816990b$var$formatTooltipDate = (timestamp)=>{
    // UTC to match the midnight-UTC data points and the (UTC) axis labels, so a
    // hovered point reads the same date as its tick.
    return (0, $63618293c58b5f80$exports.DateTime).fromMillis(timestamp, {
        zone: 'utc'
    }).toFormat('MMM d, yyyy');
};
const $2cf5bc16d816990b$var$generateTicks = (data, resolution)=>{
    if (data.length === 0) return [];
    const minTs = data[0].timestamp;
    const maxTs = data[data.length - 1].timestamp;
    const ticks = [];
    switch(resolution){
        case (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Daily:
            {
                let current = (0, $63618293c58b5f80$exports.DateTime).fromMillis(minTs).startOf('day');
                const end = (0, $63618293c58b5f80$exports.DateTime).fromMillis(maxTs);
                while(current <= end){
                    ticks.push(current.toMillis());
                    current = current.plus({
                        days: 5
                    });
                }
                break;
            }
        case (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Weekly:
            {
                let current = (0, $63618293c58b5f80$exports.DateTime).fromMillis(minTs).startOf('month');
                const end = (0, $63618293c58b5f80$exports.DateTime).fromMillis(maxTs);
                while(current <= end){
                    ticks.push(current.toMillis());
                    current = current.plus({
                        months: 1
                    });
                }
                break;
            }
        case (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Monthly:
        default:
            {
                let current = (0, $63618293c58b5f80$exports.DateTime).fromMillis(minTs).startOf('year');
                const end = (0, $63618293c58b5f80$exports.DateTime).fromMillis(maxTs);
                while(current <= end){
                    ticks.push(current.toMillis());
                    current = current.plus({
                        years: 1
                    });
                }
                break;
            }
    }
    return ticks;
};
const $2cf5bc16d816990b$var$getResolution = (dateRange)=>{
    const { startDate: startDate } = dateRange;
    if (!startDate) return (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Monthly;
    const now = new Date();
    const diffDays = (now.getTime() - startDate.toMillis()) / 86400000;
    if (diffDays <= 95) return (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Daily;
    else if (diffDays <= 730) return (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Weekly;
    else return (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Monthly;
};
const $2cf5bc16d816990b$var$CustomTooltip = ({ active: active, payload: payload, label: label })=>{
    if (!active || !payload || label === undefined) return null;
    const dateStr = $2cf5bc16d816990b$var$formatTooltipDate(label);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card rounded-lg border p-3 shadow-lg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-foreground mb-2 font-medium",
                children: dateStr
            }),
            payload.map((entry, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    style: {
                        color: entry.color
                    },
                    className: "text-sm",
                    children: [
                        entry.name,
                        ": ",
                        entry.value == null ? "\u2014" : $2cf5bc16d816990b$var$formatCurrency(entry.value)
                    ]
                }, index))
        ]
    });
};
const $2cf5bc16d816990b$export$79fbfa18a38c1a18 = ({ accountId: accountId, emptyMessage: emptyMessage = 'Not enough data for chart. Add portfolio snapshots to see history.' })=>{
    const id = $acw62.useId();
    const gainGradientId = `${id}-gain`;
    const lossGradientId = `${id}-loss`;
    const { dateRange: dateRange, setDateRange: setDateRange } = (0, $2481f76376092917$export$1799ff211e43f48e)('3M');
    const [chartView, setChartView] = $acw62.useState('value');
    const [breakdown, setBreakdown] = $acw62.useState('total');
    const [manualResolution, setManualResolution] = $acw62.useState('auto');
    const autoResolution = $2cf5bc16d816990b$var$getResolution(dateRange);
    const resolution = manualResolution === 'auto' ? autoResolution : $2cf5bc16d816990b$var$RESOLUTION_MAP[manualResolution];
    const startDate = dateRange.startDate?.toISODate() ?? undefined;
    // Open-ended presets clamp at today: recordBalanceAnchor permits
    // future-dated anchors, and the chart must not extend past today to a
    // value the summary and cards (all today-clamped) disagree with.
    const endDate = dateRange.endDate?.toISODate() ?? (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().toISODate() ?? undefined;
    // cache-and-network: snapshot and transaction edits happen on other tabs,
    // so re-mounting the chart shows cached data instantly while refreshing.
    const { data: data, loading: loading } = (0, $ce9d9e524be20f53$export$2895a0c5aea6a6e1)({
        variables: {
            accountId: accountId,
            resolution: resolution,
            startDate: startDate,
            endDate: endDate
        },
        fetchPolicy: 'cache-and-network'
    });
    const rangedHistory = data?.consolidatedPortfolioHistory ?? [];
    // If the selected range has too few snapshots to chart (e.g. a closed
    // account whose history predates the window), fall back to all history.
    const needsFallback = !loading && startDate !== undefined && rangedHistory.length < 2;
    const { data: fallbackData, loading: fallbackLoading } = (0, $ce9d9e524be20f53$export$2895a0c5aea6a6e1)({
        variables: {
            accountId: accountId,
            resolution: (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Monthly,
            endDate: endDate
        },
        skip: !needsFallback
    });
    const fallbackHistory = fallbackData?.consolidatedPortfolioHistory ?? [];
    const usingFallback = needsFallback && fallbackHistory.length >= 2;
    // By-account breakdown: only meaningful on the consolidated chart (no
    // accountId) and only in the Value view — gain is defined portfolio-wide.
    // Its variables track the effective range: when the total line falls back
    // to all history, the stack must follow, or the pill would claim a
    // breakdown while silently rendering the total.
    const breakdownActive = breakdown === 'account' && accountId == null && chartView === 'value';
    const { data: byAccountData, loading: byAccountLoading, error: byAccountError } = (0, $ce9d9e524be20f53$export$36c0441e1d5ae93)({
        variables: usingFallback ? {
            resolution: (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Monthly,
            endDate: endDate
        } : {
            resolution: resolution,
            startDate: startDate,
            endDate: endDate
        },
        fetchPolicy: 'cache-and-network',
        skip: !breakdownActive
    });
    const { data: accountsData } = (0, $ce9d9e524be20f53$export$34fd8d1d279e4cb6)({
        skip: !breakdownActive
    });
    // Stacked rows: the union of every series' dates, each account
    // forward-filled onto it (zero before an account's first point, matching
    // how the consolidated history treats absent accounts).
    const stacked = $acw62.useMemo(()=>{
        const series = byAccountData?.portfolioHistoryByAccount ?? [];
        if (!breakdownActive || series.length === 0) return null;
        const nameOf = new Map((accountsData?.allInvestmentAccounts ?? []).map((account)=>[
                account._id,
                account.name
            ]));
        // Rank by CURRENT balance, not the ranged series' endpoint: palette
        // slots (and which accounts fold into Other) must not reshuffle when
        // the user changes the date range — color follows the account.
        const balanceOf = new Map((accountsData?.allInvestmentAccounts ?? []).map((account)=>[
                account._id,
                account.balance
            ]));
        const ranked = [
            ...series
        ].sort((a, b)=>(balanceOf.get(b.accountId) ?? 0) - (balanceOf.get(a.accountId) ?? 0));
        const foldNeeded = ranked.length > $2cf5bc16d816990b$var$MAX_STACK_BANDS;
        const top = foldNeeded ? ranked.slice(0, $2cf5bc16d816990b$var$MAX_STACK_BANDS - 1) : ranked;
        const rest = foldNeeded ? ranked.slice($2cf5bc16d816990b$var$MAX_STACK_BANDS - 1) : [];
        const dates = Array.from(new Set(series.flatMap((s)=>s.points.map((p)=>p.date)))).sort();
        // One ascending cursor per series makes the fill linear overall.
        const cursors = new Map(series.map((s)=>[
                s.accountId,
                {
                    index: 0,
                    value: 0
                }
            ]));
        const valueAt = (s, date)=>{
            const cursor = cursors.get(s.accountId);
            if (cursor == null) return 0;
            while(cursor.index < s.points.length && s.points[cursor.index].date <= date){
                cursor.value = s.points[cursor.index].portfolioValue;
                cursor.index++;
            }
            return cursor.value;
        };
        const rows = dates.map((date)=>{
            const row = {
                timestamp: new Date(date).getTime(),
                fullDate: date
            };
            for (const s of top)row[s.accountId] = valueAt(s, date);
            if (rest.length > 0) row[$2cf5bc16d816990b$var$OTHER_KEY] = rest.reduce((sum, s)=>sum + valueAt(s, date), 0);
            return row;
        });
        const bands = top.map((s, index)=>({
                key: s.accountId,
                name: nameOf.get(s.accountId) ?? 'Unknown account',
                // The raw --chart-N custom properties are the runtime-resolvable ones
                // (the @theme inline aliases are compile-time only).
                color: `var(--chart-${index + 1})`
            }));
        if (rest.length > 0) bands.push({
            key: $2cf5bc16d816990b$var$OTHER_KEY,
            name: `Other (${rest.length})`,
            color: `var(--chart-${$2cf5bc16d816990b$var$MAX_STACK_BANDS})`
        });
        return {
            rows: rows,
            bands: bands
        };
    }, [
        breakdownActive,
        byAccountData,
        accountsData
    ]);
    // Only block on loading when there is nothing cached to draw — a
    // background refresh keeps the previous chart on screen.
    if (loading && !data || needsFallback && fallbackLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border-border bg-card flex h-64 items-center justify-center rounded-lg border",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading chart..."
        })
    });
    const history = usingFallback ? fallbackHistory : rangedHistory;
    const effectiveResolution = usingFallback ? (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Monthly : resolution;
    if (history.length < 2) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border-border bg-card flex h-64 items-center justify-center rounded-lg border",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: emptyMessage
        })
    });
    const lastSnapshotLabel = (0, $63618293c58b5f80$exports.DateTime).fromISO(history[history.length - 1].date).toFormat('MMM d, yyyy');
    const chartData = history.map((point)=>({
            timestamp: new Date(point.date).getTime(),
            fullDate: point.date,
            portfolioValue: point.portfolioValue,
            // Null (unknown) from a transfer of unpriced shares on: the cost basis
            // line and gain area gap there rather than drawing 0 (connectNulls is
            // off by default).
            costBasis: point.costBasis,
            gain: point.gain
        }));
    const firstTs = chartData[0].timestamp;
    const lastTs = chartData[chartData.length - 1].timestamp;
    const spanDays = (lastTs - firstTs) / 86400000;
    const formatTickDate = (0, $c45cbe94b11ffc58$export$2319624620038bd2)(firstTs, lastTs);
    // Once the labels coarsen to "MMM yyyy"/year, the ticks have to coarsen with
    // them: otherwise a multi-year range viewed at the Weekly or Daily scale
    // keeps monthly/5-day ticks and repeats the same year label many times over.
    // Shorter spans keep the resolution-based ticks the scale control drives.
    const ticks = spanDays > 90 ? (0, $c45cbe94b11ffc58$export$2fd906f40273e9a6)(firstTs, lastTs) : $2cf5bc16d816990b$var$generateTicks(chartData, effectiveResolution);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card rounded-lg border p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-4 flex flex-wrap items-center gap-x-1 gap-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-foreground mr-auto font-medium",
                        children: "Portfolio history"
                    }),
                    accountId == null && chartView === 'value' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                        label: "Breakdown",
                        allLabel: "Total",
                        options: [
                            {
                                key: 'account',
                                label: 'By account'
                            }
                        ],
                        value: breakdown === 'total' ? 'all' : 'account',
                        onChange: (key)=>setBreakdown(key === 'account' ? 'account' : 'total')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                        label: "View",
                        allLabel: "Value",
                        options: [
                            {
                                key: 'gain',
                                label: 'Gain/Loss'
                            }
                        ],
                        value: chartView === 'value' ? 'all' : 'gain',
                        onChange: (key)=>setChartView(key === 'gain' ? 'gain' : 'value')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                        label: "Scale",
                        allLabel: "Auto",
                        options: [
                            {
                                key: 'daily',
                                label: 'Daily'
                            },
                            {
                                key: 'weekly',
                                label: 'Weekly'
                            },
                            {
                                key: 'monthly',
                                label: 'Monthly'
                            }
                        ],
                        value: manualResolution === 'auto' ? 'all' : manualResolution,
                        onChange: (key)=>setManualResolution(key === 'daily' || key === 'weekly' || key === 'monthly' ? key : 'auto')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2481f76376092917$export$26dc5fbaa253de80), {
                        value: dateRange,
                        onChange: setDateRange
                    })
                ]
            }),
            usingFallback && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-3 rounded-md border border-amber-500/50 px-3 py-2 text-sm text-amber-600 dark:text-amber-400",
                children: [
                    "No snapshots in the selected range \u2014 showing all available history. Data is not current: last snapshot ",
                    lastSnapshotLabel,
                    "."
                ]
            }),
            breakdownActive && (stacked == null || stacked.rows.length < 2) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex h-[300px] items-center justify-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    children: byAccountLoading && byAccountData == null ? 'Loading breakdown...' : byAccountError != null ? "Couldn\u2019t load the by-account breakdown." : 'Not enough data for a by-account breakdown.'
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
                width: "100%",
                height: 300,
                children: breakdownActive && stacked != null && stacked.rows.length >= 2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $40df630ec903a4ea$export$f510429275d6f1a8), {
                    data: stacked.rows,
                    margin: {
                        top: 10,
                        right: 30,
                        left: 20,
                        bottom: 10
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                            strokeDasharray: "3 3",
                            stroke: "var(--color-border)",
                            strokeWidth: 1.5
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                            dataKey: "timestamp",
                            type: "number",
                            scale: "time",
                            domain: [
                                'dataMin',
                                'dataMax'
                            ],
                            ticks: ticks,
                            tickFormatter: formatTickDate,
                            tick: {
                                fill: 'var(--color-muted-foreground)',
                                fontSize: 12
                            },
                            tickLine: {
                                stroke: 'var(--color-border)'
                            },
                            axisLine: {
                                stroke: 'var(--color-border)'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                            tick: {
                                fill: 'var(--color-muted-foreground)',
                                fontSize: 12
                            },
                            tickFormatter: $2cf5bc16d816990b$var$formatCurrency,
                            tickLine: {
                                stroke: 'var(--color-border)'
                            },
                            axisLine: {
                                stroke: 'var(--color-border)'
                            },
                            width: 80
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cf5bc16d816990b$var$CustomTooltip, {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f4bd73be8c7e839$export$ed247974535929c7), {
                            wrapperStyle: {
                                paddingTop: '10px'
                            }
                        }),
                        stacked.bands.map((band)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                                type: "monotone",
                                dataKey: band.key,
                                name: band.name,
                                stackId: "portfolio",
                                stroke: band.color,
                                strokeWidth: 1,
                                fill: band.color,
                                fillOpacity: 0.55,
                                isAnimationActive: false
                            }, band.key))
                    ]
                }) : chartView === 'value' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d1341a4ce4753cde$export$54d0e8420ac838ac), {
                    data: chartData,
                    margin: {
                        top: 10,
                        right: 30,
                        left: 20,
                        bottom: 10
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                            strokeDasharray: "3 3",
                            stroke: "var(--color-border)",
                            strokeWidth: 1.5
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                            dataKey: "timestamp",
                            type: "number",
                            scale: "time",
                            domain: [
                                'dataMin',
                                'dataMax'
                            ],
                            ticks: ticks,
                            tickFormatter: formatTickDate,
                            tick: {
                                fill: 'var(--color-muted-foreground)',
                                fontSize: 12
                            },
                            tickLine: {
                                stroke: 'var(--color-border)'
                            },
                            axisLine: {
                                stroke: 'var(--color-border)'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                            tick: {
                                fill: 'var(--color-muted-foreground)',
                                fontSize: 12
                            },
                            tickFormatter: $2cf5bc16d816990b$var$formatCurrency,
                            tickLine: {
                                stroke: 'var(--color-border)'
                            },
                            axisLine: {
                                stroke: 'var(--color-border)'
                            },
                            width: 80
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cf5bc16d816990b$var$CustomTooltip, {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f4bd73be8c7e839$export$ed247974535929c7), {
                            wrapperStyle: {
                                paddingTop: '10px'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c541166c885e1544$export$b2f28e248e7838eb), {
                            y: 0,
                            stroke: "var(--color-border)"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                            type: "monotone",
                            dataKey: "portfolioValue",
                            name: "Portfolio value",
                            stroke: "#3b82f6",
                            strokeWidth: 2,
                            dot: false,
                            activeDot: {
                                r: 4,
                                fill: '#3b82f6'
                            },
                            isAnimationActive: false
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                            type: "monotone",
                            dataKey: "costBasis",
                            name: "Cost basis",
                            stroke: "#6b7280",
                            strokeWidth: 2,
                            strokeDasharray: "5 5",
                            dot: false,
                            activeDot: {
                                r: 4,
                                fill: '#6b7280'
                            },
                            isAnimationActive: false
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $40df630ec903a4ea$export$f510429275d6f1a8), {
                    data: chartData,
                    margin: {
                        top: 10,
                        right: 30,
                        left: 20,
                        bottom: 10
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                    id: gainGradientId,
                                    x1: "0",
                                    y1: "0",
                                    x2: "0",
                                    y2: "1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                            offset: "5%",
                                            stopColor: "#22c55e",
                                            stopOpacity: 0.3
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                            offset: "95%",
                                            stopColor: "#22c55e",
                                            stopOpacity: 0
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                    id: lossGradientId,
                                    x1: "0",
                                    y1: "1",
                                    x2: "0",
                                    y2: "0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                            offset: "5%",
                                            stopColor: "#ef4444",
                                            stopOpacity: 0.3
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                            offset: "95%",
                                            stopColor: "#ef4444",
                                            stopOpacity: 0
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                            strokeDasharray: "3 3",
                            stroke: "var(--color-border)",
                            strokeWidth: 1.5
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                            dataKey: "timestamp",
                            type: "number",
                            scale: "time",
                            domain: [
                                'dataMin',
                                'dataMax'
                            ],
                            ticks: ticks,
                            tickFormatter: formatTickDate,
                            tick: {
                                fill: 'var(--color-muted-foreground)',
                                fontSize: 12
                            },
                            tickLine: {
                                stroke: 'var(--color-border)'
                            },
                            axisLine: {
                                stroke: 'var(--color-border)'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                            tick: {
                                fill: 'var(--color-muted-foreground)',
                                fontSize: 12
                            },
                            tickFormatter: $2cf5bc16d816990b$var$formatCurrency,
                            tickLine: {
                                stroke: 'var(--color-border)'
                            },
                            axisLine: {
                                stroke: 'var(--color-border)'
                            },
                            width: 80
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cf5bc16d816990b$var$CustomTooltip, {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c541166c885e1544$export$b2f28e248e7838eb), {
                            y: 0,
                            stroke: "var(--color-border)",
                            strokeWidth: 2
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                            type: "monotone",
                            dataKey: "gain",
                            name: "Gain/Loss",
                            stroke: "#22c55e",
                            strokeWidth: 2,
                            fill: `url(#${gainGradientId})`,
                            activeDot: {
                                r: 4
                            },
                            isAnimationActive: false
                        })
                    ]
                })
            })
        ]
    });
};


const $713b02e79a769670$export$ea33917a894bafbe = ({ accountId: accountId })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2cf5bc16d816990b$export$79fbfa18a38c1a18), {
        accountId: accountId,
        emptyMessage: "Not enough snapshots for chart. Add more portfolio snapshots to see history."
    });
};








var $acw62 = parcelRequire("acw62");




parcelRequire("acw62");

const $ec0ab6be8739f2b0$export$dc43af5edb95f354 = ({ accountId: accountId, institutionName: institutionName, className: className })=>{
    const { data: data } = (0, $ce9d9e524be20f53$export$14196d3121b7a06)({
        variables: {
            id: accountId
        }
    });
    const account = data?.account;
    const connection = account?.__typename === 'DepositoryAccount' || account?.__typename === 'InvestmentAccount' ? account.plaid : null;
    const lastSynced = connection?.lastSuccessfulSyncAt ? (0, $63618293c58b5f80$exports.DateTime).fromISO(connection.lastSuccessfulSyncAt).toRelative() : null;
    // connectionActive is null when the access-token record has been deleted —
    // that connection can no longer sync, so anything but an explicit true is
    // inactive. While the status query is still loading (connection == null)
    // the dot renders neutral instead.
    const connectionInactive = connection != null && connection.connectionActive !== true;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-muted-foreground m-0 flex items-center gap-1.5', className),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-1.5 shrink-0 rounded-full', connection == null ? 'bg-muted-foreground/40' : connectionInactive ? 'bg-amber-500' : 'bg-emerald-500')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "truncate",
                children: [
                    institutionName ?? 'Bank',
                    " via Plaid",
                    connectionInactive && " \xb7 connection inactive",
                    lastSynced && ` \xb7 synced ${lastSynced}`
                ]
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");

const $8c4ac37b1c8e1ad1$var$INDENT = '  ';
const $8c4ac37b1c8e1ad1$var$Punctuation = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-muted-foreground",
        children: children
    });
const $8c4ac37b1c8e1ad1$var$renderScalar = (value)=>{
    if (value === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-muted-foreground italic",
        children: "null"
    });
    switch(typeof value){
        case 'string':
            // JSON.stringify quotes AND escapes — a value containing `"` or a
            // newline must render as valid JSON, not alter the apparent structure.
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-emerald-700 dark:text-emerald-400",
                children: JSON.stringify(value)
            });
        case 'number':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-sky-700 dark:text-sky-400",
                children: value
            });
        default:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-purple-700 dark:text-purple-400",
                children: String(value)
            });
    }
};
const $8c4ac37b1c8e1ad1$var$renderValue = (value, depth)=>{
    if (value === null || typeof value !== 'object') return $8c4ac37b1c8e1ad1$var$renderScalar(value);
    const pad = $8c4ac37b1c8e1ad1$var$INDENT.repeat(depth + 1);
    const closePad = $8c4ac37b1c8e1ad1$var$INDENT.repeat(depth);
    if (Array.isArray(value)) {
        if (value.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c4ac37b1c8e1ad1$var$Punctuation, {
            children: "[]"
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c4ac37b1c8e1ad1$var$Punctuation, {
                    children: "["
                }),
                '\n',
                value.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                        children: [
                            pad,
                            $8c4ac37b1c8e1ad1$var$renderValue(item, depth + 1),
                            index < value.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c4ac37b1c8e1ad1$var$Punctuation, {
                                children: ","
                            }),
                            '\n'
                        ]
                    }, index)),
                closePad,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c4ac37b1c8e1ad1$var$Punctuation, {
                    children: "]"
                })
            ]
        });
    }
    const entries = Object.entries(value);
    if (entries.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c4ac37b1c8e1ad1$var$Punctuation, {
        children: '{}'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c4ac37b1c8e1ad1$var$Punctuation, {
                children: '{'
            }),
            '\n',
            entries.map(([key, item], index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                    children: [
                        pad,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-foreground font-medium",
                            children: JSON.stringify(key)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c4ac37b1c8e1ad1$var$Punctuation, {
                            children: ": "
                        }),
                        $8c4ac37b1c8e1ad1$var$renderValue(item, depth + 1),
                        index < entries.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c4ac37b1c8e1ad1$var$Punctuation, {
                            children: ","
                        }),
                        '\n'
                    ]
                }, key)),
            closePad,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c4ac37b1c8e1ad1$var$Punctuation, {
                children: '}'
            })
        ]
    });
};
const $8c4ac37b1c8e1ad1$export$77412d412e77b482 = ({ value: value, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('m-0 overflow-x-auto font-mono text-xs leading-relaxed whitespace-pre', className),
        children: $8c4ac37b1c8e1ad1$var$renderValue(value, 0)
    });



/** Narrow a parsed JSON value to a plain object. */ const $07c8a7dff6d529e2$var$asObject = (value)=>value != null && typeof value === 'object' && !Array.isArray(value) ? value : null;
const $07c8a7dff6d529e2$var$getString = (obj, key)=>{
    const value = obj?.[key];
    return typeof value === 'string' ? value : null;
};
const $07c8a7dff6d529e2$var$getNumber = (obj, key)=>{
    const value = obj?.[key];
    return typeof value === 'number' ? value : null;
};
/** Format a Plaid dollar amount (raw JSON stores dollars, not cents). */ const $07c8a7dff6d529e2$var$formatDollars = (dollars, currency)=>dollars == null ? null : (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).toDecimalString((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
        amount: Math.round(dollars * 100),
        currency: currency
    }));
const $07c8a7dff6d529e2$var$SummaryItem = ({ label: label, value: value })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-w-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground text-xs uppercase tracking-wide",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-foreground mt-0.5 truncate text-sm",
                title: value ?? undefined,
                children: value ?? "\u2014"
            })
        ]
    });
/** A collapsible section inside the Plaid card. Mirrors the chevron pattern the
 * synced-balances list used before it moved in here. */ const $07c8a7dff6d529e2$var$CardSection = ({ label: label, open: open, onToggle: onToggle, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border border-t",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                onClick: onToggle,
                className: "text-foreground hover:bg-muted/40 flex w-full cursor-pointer items-center gap-1.5 px-4 py-3 text-sm font-medium transition",
                children: [
                    open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        className: "text-muted-foreground size-4"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                        className: "text-muted-foreground size-4"
                    }),
                    label
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "px-4 pb-4",
                children: children
            })
        ]
    });
/**
 * A synced Plaid reading. Readings are write-once telemetry: no detail page,
 * no editing — just Promote (record an anchor for the same date; the reading
 * is kept) and Delete. This card is their only home in the UI.
 */ const $07c8a7dff6d529e2$var$ReadingRow = ({ reading: reading, currency: currency, isCreditCard: isCreditCard, onPromote: onPromote, onDelete: onDelete })=>{
    const amount = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
        amount: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(reading.balance, isCreditCard),
        currency: currency
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border-border bg-card rounded-xl border px-4 py-3 shadow-xs",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-wrap items-center gap-x-3 gap-y-1",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-foreground shrink-0 font-medium",
                    children: reading.date
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "ml-auto flex shrink-0 items-center gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                            amount: amount,
                            variant: "plain"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            onClick: ()=>onPromote(reading),
                            className: "h-7 px-2 text-xs",
                            children: "Promote"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>onDelete(reading),
                            className: "text-muted-foreground hover:text-destructive hover:bg-destructive/10 rounded-lg p-1.5 transition",
                            title: "Delete synced balance",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                className: "size-4"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $07c8a7dff6d529e2$export$4e3e9ff2200f5f59 = ({ account: account, onReadingChanged: onReadingChanged })=>{
    const plaid = account.plaid;
    const { recordBalanceAnchorModal: recordBalanceAnchorModal, deleteBalanceEntryModal: deleteBalanceEntryModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const [showSynced, setShowSynced] = $acw62.useState(false);
    const [showRaw, setShowRaw] = $acw62.useState(false);
    const [copied, setCopied] = $acw62.useState(false);
    const isCreditCard = account.__typename === 'DepositoryAccount' && account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard;
    // Both sections stay skipped until opened, so the card adds nothing to the
    // overview's initial request.
    const { data: readingData, refetch: refetchReadings, loading: readingsLoading } = (0, $ce9d9e524be20f53$export$a3b544ccb0f6d05)({
        variables: {
            accountId: account._id,
            limit: 200
        },
        fetchPolicy: 'cache-and-network',
        skip: !showSynced
    });
    const { data: jsonData, loading: jsonLoading, error: jsonError, refetch: refetchJson } = (0, $ce9d9e524be20f53$export$daca90b073bacfa0)({
        variables: {
            id: account._id
        },
        skip: !showRaw
    });
    const readings = readingData?.balanceReadings ?? [];
    const plaidJson = jsonData?.account?.plaid?.plaidJson ?? null;
    const parsed = $acw62.useMemo(()=>{
        if (!plaidJson) return null;
        try {
            const value = JSON.parse(plaidJson);
            return value;
        } catch  {
            return null;
        }
    }, [
        plaidJson
    ]);
    if (!plaid) return null;
    const handlePromote = (reading)=>{
        // Promoting a synced Plaid reading records an anchor on the same date as a
        // separate row — the reading is kept untouched. The balance is prefilled
        // but editable (credit-card statement balances differ from Plaid's
        // pending-inclusive snapshot).
        recordBalanceAnchorModal.openModal({
            accountId: account._id,
            currency: account.currency,
            isCreditCard: isCreditCard,
            initialDate: (0, $63618293c58b5f80$exports.DateTime).fromISO(reading.date),
            initialBalance: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
                amount: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(reading.balance, isCreditCard),
                currency: account.currency
            }),
            onSuccess: ()=>onReadingChanged?.()
        });
    };
    const handleDelete = (reading)=>{
        deleteBalanceEntryModal.openModal({
            kind: 'reading',
            entryId: reading._id,
            entryDate: reading.date,
            onDeleted: ()=>{
                refetchReadings();
                onReadingChanged?.();
            }
        });
    };
    const handleCopy = async ()=>{
        if (parsed == null) return;
        try {
            await navigator.clipboard.writeText(JSON.stringify(parsed, null, 2));
        } catch  {
            // Clipboard unavailable (e.g. permission denied) — don't claim success.
            return;
        }
        setCopied(true);
        window.setTimeout(()=>setCopied(false), 2000);
    };
    const obj = $07c8a7dff6d529e2$var$asObject(parsed);
    const balances = $07c8a7dff6d529e2$var$asObject(obj?.balances);
    const mask = $07c8a7dff6d529e2$var$getString(obj, 'mask');
    const officialName = $07c8a7dff6d529e2$var$getString(obj, 'official_name') ?? $07c8a7dff6d529e2$var$getString(obj, 'name');
    const type = $07c8a7dff6d529e2$var$getString(obj, 'type');
    const subtype = $07c8a7dff6d529e2$var$getString(obj, 'subtype');
    const currency = $07c8a7dff6d529e2$var$getString(balances, 'iso_currency_code') ?? 'USD';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card rounded-xl border shadow-xs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex items-center justify-between gap-4 px-4 py-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-foreground m-0 text-sm font-medium",
                            children: "Plaid"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec0ab6be8739f2b0$export$dc43af5edb95f354), {
                            accountId: account._id,
                            institutionName: plaid.institutionName,
                            className: "mt-0.5 text-xs"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07c8a7dff6d529e2$var$CardSection, {
                label: "Synced balances",
                open: showSynced,
                onToggle: ()=>setShowSynced((prev)=>!prev),
                children: readingsLoading && readings.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground m-0 text-sm",
                    children: "Loading\u2026"
                }) : readings.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground m-0 text-sm",
                    children: "No synced balances yet \u2014 they appear after the next sync."
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-col gap-2",
                    children: readings.map((reading)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07c8a7dff6d529e2$var$ReadingRow, {
                            reading: reading,
                            currency: account.currency,
                            isCreditCard: isCreditCard,
                            onPromote: handlePromote,
                            onDelete: handleDelete
                        }, reading._id))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07c8a7dff6d529e2$var$CardSection, {
                label: "Raw Plaid data",
                open: showRaw,
                onToggle: ()=>setShowRaw((prev)=>!prev),
                children: jsonLoading && !jsonData ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground m-0 text-sm",
                    children: "Loading\u2026"
                }) : jsonError && !jsonData ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col items-start gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-muted-foreground text-sm",
                            children: "Failed to load Plaid data"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            onClick: ()=>void refetchJson(),
                            children: "Retry"
                        })
                    ]
                }) : parsed == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground m-0 text-sm",
                    children: "No raw Plaid data stored yet \u2014 it appears after the next sync."
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07c8a7dff6d529e2$var$SummaryItem, {
                                    label: "Account number",
                                    value: mask ? `\u{2022}\u{2022}\u{2022}\u{2022} ${mask}` : null
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07c8a7dff6d529e2$var$SummaryItem, {
                                    label: "Official name",
                                    value: officialName
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07c8a7dff6d529e2$var$SummaryItem, {
                                    label: "Type",
                                    value: type ? [
                                        type,
                                        subtype
                                    ].filter(Boolean).join(' / ') : null
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07c8a7dff6d529e2$var$SummaryItem, {
                                    label: "Available",
                                    value: $07c8a7dff6d529e2$var$formatDollars($07c8a7dff6d529e2$var$getNumber(balances, 'available'), currency)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07c8a7dff6d529e2$var$SummaryItem, {
                                    label: "Current",
                                    value: $07c8a7dff6d529e2$var$formatDollars($07c8a7dff6d529e2$var$getNumber(balances, 'current'), currency)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07c8a7dff6d529e2$var$SummaryItem, {
                                    label: "Limit",
                                    value: $07c8a7dff6d529e2$var$formatDollars($07c8a7dff6d529e2$var$getNumber(balances, 'limit'), currency)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "border-border rounded-xl border",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "border-border flex items-center justify-between gap-4 border-b px-4 py-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-muted-foreground m-0 text-xs",
                                            children: "The account object from the most recent Plaid sync, verbatim."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                            variant: "outline",
                                            onClick: ()=>void handleCopy(),
                                            className: "shrink-0",
                                            children: [
                                                copied ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                                    className: "size-4"
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                                    className: "size-4"
                                                }),
                                                copied ? 'Copied' : 'Copy JSON'
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "p-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c4ac37b1c8e1ad1$export$77412d412e77b482), {
                                        value: parsed
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};




const $e38c31e3afde1857$export$dda7ccc8855a5db = (type)=>{
    switch(type){
        case (0, $ce9d9e524be20f53$export$19445fdc19724941).Brokerage:
            return 'Brokerage';
        case (0, $ce9d9e524be20f53$export$19445fdc19724941)['401K']:
            return '401(k)';
        case (0, $ce9d9e524be20f53$export$19445fdc19724941).Ira:
            return 'IRA';
        case (0, $ce9d9e524be20f53$export$19445fdc19724941).RothIra:
            return 'Roth IRA';
        case (0, $ce9d9e524be20f53$export$19445fdc19724941).Hsa:
            return 'HSA';
        case (0, $ce9d9e524be20f53$export$19445fdc19724941).Education:
            return '529 plan';
        case (0, $ce9d9e524be20f53$export$19445fdc19724941).Other:
            return 'Other';
        default:
            return 'Unknown';
    }
};
const $e38c31e3afde1857$var$formatCurrency = (cents)=>new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(cents / 100);
const $e38c31e3afde1857$export$9e0db4b4a2d37e8a = ({ account: account, refetchAccount: refetchAccount })=>{
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    // Performance (cost basis, XIRR) is computed server-side from cash flows
    // and snapshots, so it loads here rather than in the shared shell.
    // cache-and-network keeps it fresh when returning after edits on the
    // Transactions or Snapshots tabs.
    const { data: data, loading: loading, refetch: refetch } = (0, $ce9d9e524be20f53$export$b9614cb2f3723202)({
        variables: {
            id: account._id
        },
        fetchPolicy: 'cache-and-network'
    });
    const performance = data?.investmentAccount?.performance ?? null;
    const currencyLabel = (0, $9b33a37eb331091e$export$df99f23287eaf00e)();
    // Present (today-clamped) value once the detail query lands, so the facts
    // strip agrees with the Performance card — account.balance deliberately
    // follows the newest entry, future-dated anchors included.
    const currentValue = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
        amount: data?.investmentAccount?.presentBalance ?? account.balance,
        currency: account.currency
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col gap-6 overflow-y-auto p-4 sm:p-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-card flex flex-wrap items-start justify-between gap-x-6 gap-y-2 rounded-xl border px-4 py-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-muted-foreground m-0 text-sm",
                                children: [
                                    $e38c31e3afde1857$export$dda7ccc8855a5db(account.investmentType),
                                    " \xb7",
                                    ' ',
                                    currencyLabel(account.currency),
                                    ' ',
                                    "\xb7 ",
                                    account.transactionCount.toLocaleString(),
                                    ' ',
                                    account.transactionCount === 1 ? 'transaction' : 'transactions'
                                ]
                            }),
                            !account.plaid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground m-0 mt-1 text-xs",
                                children: "Manual investment"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-right",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground m-0 text-xs uppercase tracking-wide",
                                children: "Current value"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                amount: currentValue,
                                variant: "plain",
                                align: "right"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-card rounded-xl border p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-foreground m-0 mb-3 font-medium",
                        children: "Performance"
                    }),
                    performance == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground m-0 text-sm",
                        children: loading ? "Loading performance\u2026" : 'No performance data yet'
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-4 sm:grid-cols-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-muted-foreground text-sm",
                                        children: "Current Value"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-foreground font-medium",
                                        children: $e38c31e3afde1857$var$formatCurrency(performance.totalValue)
                                    })
                                ]
                            }),
                            performance.costBasis != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-muted-foreground text-sm",
                                        children: "Cost basis"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-foreground font-medium",
                                        children: $e38c31e3afde1857$var$formatCurrency(performance.costBasis)
                                    })
                                ]
                            }),
                            performance.totalGain != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-muted-foreground text-sm",
                                        children: "Total Gain/Loss"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `font-medium ${performance.totalGain > 0 ? 'text-positive' : performance.totalGain < 0 ? 'text-red-600 dark:text-red-400' : 'text-foreground'}`,
                                        children: [
                                            performance.totalGain > 0 ? '+' : '',
                                            $e38c31e3afde1857$var$formatCurrency(performance.totalGain)
                                        ]
                                    })
                                ]
                            }),
                            performance.xirr != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-muted-foreground text-sm",
                                        children: "Annualized Return"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "text-foreground font-medium",
                                        children: [
                                            (performance.xirr * 100).toFixed(2),
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $713b02e79a769670$export$ea33917a894bafbe), {
                accountId: account._id
            }),
            account.plaid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07c8a7dff6d529e2$export$4e3e9ff2200f5f59), {
                account: account,
                onReadingChanged: ()=>{
                    // Promoting/deleting a reading changes the derived performance,
                    // the portfolio history, and Account.balance server-side.
                    refetch();
                    client.refetchQueries({
                        include: [
                            'ConsolidatedPortfolioHistory'
                        ]
                    });
                    refetchAccount();
                }
            })
        ]
    });
};





const $dabce856953436fb$export$d7d9da435d4d3802 = ()=>{
    const { account: account, refetchAccount: refetchAccount } = (0, $cf8a3466088e9562$export$7b3ff83b2e249bf6)();
    if (account.__typename === 'InvestmentAccount') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e38c31e3afde1857$export$9e0db4b4a2d37e8a), {
        account: account,
        refetchAccount: refetchAccount
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($dabce856953436fb$var$DepositoryOverviewView, {
        account: account,
        refetchAccount: refetchAccount
    });
};
/**
 * Depository overview: the account facts that used to crowd the shared
 * header (type, currency, transaction count, current balance) plus the
 * balance history chart. Recording and reconciling balances live on the
 * Reconcile tab; the Plaid connection, its synced readings, and its raw data
 * live in the collapsible Plaid card below (Plaid-linked accounts only).
 */ const $dabce856953436fb$var$DepositoryOverviewView = ({ account: account, refetchAccount: refetchAccount })=>{
    // The chart's full series is assembled server-side (readings + reconciled
    // walks + estimated tails + anchors), so the client just renders it.
    const { data: historyData, loading: historyLoading, refetch: refetchHistory } = (0, $ce9d9e524be20f53$export$d44efaed59ed22d0)({
        variables: {
            accountId: account._id
        },
        fetchPolicy: 'cache-and-network'
    });
    const history = historyData?.balanceHistory;
    const currencyLabel = (0, $9b33a37eb331091e$export$df99f23287eaf00e)();
    const isCreditCard = account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard;
    const headline = (0, $1d7c692b9128a045$export$f7bcd4900af66aa4)(account.balance, isCreditCard);
    const currentBalance = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
        amount: headline.amount,
        currency: account.currency
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col gap-6 overflow-y-auto p-4 sm:p-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-card flex flex-wrap items-start justify-between gap-x-6 gap-y-2 rounded-xl border px-4 py-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "min-w-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-muted-foreground m-0 text-sm",
                            children: [
                                (0, $cf8a3466088e9562$export$af19effd62c45729)(account.depositoryType),
                                " \xb7",
                                ' ',
                                currencyLabel(account.currency),
                                ' ',
                                "\xb7 ",
                                account.transactionCount.toLocaleString(),
                                ' ',
                                account.transactionCount === 1 ? 'transaction' : 'transactions'
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-right",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground m-0 text-xs uppercase tracking-wide",
                                children: headline.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                amount: currentBalance,
                                variant: "plain",
                                align: "right"
                            }),
                            account.balanceStaleSince && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-muted-foreground mt-0.5 text-xs",
                                children: [
                                    "as of ",
                                    account.balanceStaleSince
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-card border-border rounded-xl border px-2 py-3 sm:p-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $566ebfc1457f0dbd$export$b2e57ed472dc3b95), {
                    points: history?.points ?? [],
                    spans: history?.spans ?? [],
                    loading: historyLoading,
                    currency: account.currency,
                    isCreditCard: isCreditCard
                })
            }),
            account.plaid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07c8a7dff6d529e2$export$4e3e9ff2200f5f59), {
                account: account,
                onReadingChanged: ()=>{
                    refetchHistory();
                    // Promoting the newest reading updates Account.balance server-side.
                    refetchAccount();
                }
            })
        ]
    });
};



parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");



var $f1q41 = parcelRequire("f1q41");
// The list's rows are narrowed server-side; a row created — or edited — while
// a filter is active (date, amount, search, account, allocation,
// reconciliation) may fall outside it, and keeping such a row in the cached
// page would contradict the filter until the next reload.
const $2f8143a39a28ff19$var$matchesFilters = (filters, rt)=>(!filters.startDate || rt.date >= filters.startDate) && (!filters.endDate || rt.date <= filters.endDate) && (!filters.search || rt.description.toLowerCase().includes(filters.search.toLowerCase())) && (!filters.accountId || rt.account._id === filters.accountId) && (!filters.accountIds?.length || filters.accountIds.includes(rt.account._id)) && // Mirrors the server's allocation clause for new-model rows: allocated
    // means fully consumed (remainingAmount 0). A legacy row has no
    // remainingAmount at all and is allocated through its `transaction`
    // linkage instead, which this fragment can't see — so a null remainder is
    // *unknown*, not unallocated, and is left for the server to judge rather
    // than being read as a mismatch.
    (filters.allocated === undefined || rt.remainingAmount == null || rt.remainingAmount === 0 === filters.allocated) && // Mirrors the server's reconciledAt existence check. A row a mutation just
    // created (e.g. Create inverse from the Activity list) is never reconciled,
    // so it must not land in a reconciled-only page.
    (filters.reconciled === undefined || rt.reconciliation != null === filters.reconciled) && // Mirrors the server's sign-blind magnitude bounds (both in cents).
    (filters.minAmount === undefined || Math.abs(rt.amount) >= filters.minAmount) && (filters.maxAmount === undefined || Math.abs(rt.amount) <= filters.maxAmount);
const $2f8143a39a28ff19$var$updateRawTransactions = (args)=>(mutation)=>{
        const { client: client, filters: filters, matchFilters: matchFilters = filters } = args;
        const { toAdd: toAdd, toRemove: toRemove, toReplace: toReplace } = mutation;
        const existing = client.readQuery({
            query: (0, $ce9d9e524be20f53$export$d0cf06536cad3268),
            variables: filters
        });
        // A null read means the cached entry is incomplete — the mutation link
        // just evicted stale homeAmountPreview fields — and the list is about to
        // refetch. Writing "only the new rows" here would replace the entry with
        // a small COMPLETE result, silently dropping every cached row and
        // cancelling the refetch that would have restored them. Skip the in-place
        // patch; the refetch delivers the fresh list, new rows included.
        if (existing?.allRawTransactions == null) return;
        let items = existing.allRawTransactions.items;
        const id = (rt)=>rt._id;
        if (toRemove) items = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).differenceWith(items, toRemove, (rt, removeId)=>rt._id === removeId);
        if (toReplace) {
            const replaceMap = new Map(toReplace.map((r)=>[
                    r._id,
                    r
                ]));
            // An edit can move a row outside the active narrowing (amount across a
            // bound, date out of range, description off a search) just as surely as a
            // create can land outside it. The server page would drop the row, so the
            // cached one must too — a replacement that no longer matches leaves
            // instead of being patched in place. Header already does this for the one
            // filter it can see (a row edited into another account leaves an
            // account-scoped list); this covers the rest.
            //
            // Matched against `matchFilters`, not `filters`: a page extended past a
            // date bound is wider than the variables that keyed it, so a row outside
            // the filter can still legitimately be on the page.
            items = items.flatMap((item)=>{
                const replacement = replaceMap.get(item._id);
                if (replacement == null) return [
                    item
                ];
                return $2f8143a39a28ff19$var$matchesFilters(matchFilters, replacement) ? [
                    replacement
                ] : [];
            });
        }
        if (toAdd) items = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).unionBy(items, toAdd.filter((rt)=>$2f8143a39a28ff19$var$matchesFilters(matchFilters, rt)), id);
        items = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).clone(items);
        items.sort((a, b)=>b.date.localeCompare(a.date));
        client.writeQuery({
            query: (0, $ce9d9e524be20f53$export$d0cf06536cad3268),
            variables: filters,
            data: {
                allRawTransactions: {
                    __typename: 'PaginatedRawTransactions',
                    items: items,
                    startCursor: existing.allRawTransactions.startCursor ?? null,
                    endCursor: existing.allRawTransactions.endCursor ?? null,
                    hasMore: existing.allRawTransactions.hasMore ?? false
                }
            }
        });
    };
var $2f8143a39a28ff19$export$2e2bcd8739ae039 = $2f8143a39a28ff19$var$updateRawTransactions;







parcelRequire("acw62");

const $46b86c7aa98be263$export$4596b845258929e5 = ({ onReset: onReset })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
        variant: "ghost",
        className: "text-muted-foreground h-auto shrink-0 gap-1 rounded-full px-2 py-1 text-sm font-normal",
        onClick: onReset,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                size: 14
            }),
            "Reset filters"
        ]
    });



var $acw62 = parcelRequire("acw62");

const $80f2d9c5153b63bf$export$6ccd138e4a7ead58 = (options)=>{
    const [searchParams, setSearchParams] = (0, $0c90f43fc3673aef$export$f1a78c17382fe22a)();
    const replace = options?.history !== 'push';
    const setParams = $acw62.useCallback((updates)=>{
        const next = new URLSearchParams(searchParams);
        for (const [key, value] of Object.entries(updates))if (value == null || value === '') next.delete(key);
        else next.set(key, value);
        // A no-op update (re-picking the filter already applied) must not push
        // an identical entry: the back button would then appear stuck, undoing
        // nothing visible per press.
        if (replace || next.toString() !== searchParams.toString()) setSearchParams(next, {
            replace: replace
        });
    }, [
        searchParams,
        setSearchParams,
        replace
    ]);
    return [
        searchParams,
        setParams
    ];
};





parcelRequire("acw62");

const $f474bccad37d15d6$export$7f94856880993f27 = ({ loading: loading, hasMore: hasMore, onMore: onMore, label: label })=>{
    if (!hasMore) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground flex justify-center py-4 text-sm",
        children: "End of list"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex justify-center py-3",
        children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-muted-foreground flex items-center gap-2 py-2 text-sm",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 animate-spin"
                }),
                "Loading more\u2026"
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
            onClick: onMore,
            variant: "outline",
            children: label ?? 'More'
        })
    });
};







const $25d6b5adca90bb97$export$72b1d89afdb38499 = (value)=>value === 'allocated' || value === 'unallocated' ? value : 'all';
const $25d6b5adca90bb97$export$e0ca7418676fa890 = ({ value: value, onChange: onChange })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
        label: "Allocation",
        allLabel: "All",
        options: [
            {
                key: 'allocated',
                label: 'Allocated'
            },
            {
                key: 'unallocated',
                label: 'Unallocated'
            }
        ],
        value: value,
        onChange: (key)=>onChange($25d6b5adca90bb97$export$72b1d89afdb38499(key))
    });



/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $05c245c7dcd30f27$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3v12",
            key: "1x0j5s"
        }
    ],
    [
        "path",
        {
            d: "m8 11 4 4 4-4",
            key: "1dohi6"
        }
    ],
    [
        "path",
        {
            d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
            key: "1ywtjm"
        }
    ]
];
const $05c245c7dcd30f27$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("import", $05c245c7dcd30f27$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $131c05e6196e399a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13 5h8",
            key: "a7qcls"
        }
    ],
    [
        "path",
        {
            d: "M13 12h8",
            key: "h98zly"
        }
    ],
    [
        "path",
        {
            d: "M13 19h8",
            key: "c3s6r1"
        }
    ],
    [
        "path",
        {
            d: "m3 17 2 2 4-4",
            key: "1jhpwq"
        }
    ],
    [
        "path",
        {
            d: "m3 7 2 2 4-4",
            key: "1obspn"
        }
    ]
];
const $131c05e6196e399a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("list-checks", $131c05e6196e399a$export$3efd853dbb351e94);


parcelRequire("acw62");
/*!
 * hotkeys-js v3.8.1
 * A simple micro-library for defining and dispatching keyboard shortcuts. It has no dependencies.
 * 
 * Copyright (c) 2020 kenny wong <wowohoo@qq.com>
 * http://jaywcjlove.github.io/hotkeys
 * 
 * Licensed under the MIT license.
 */ var $d949ebf04c50c323$var$isff = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase().indexOf('firefox') > 0 : false; // 绑定事件
function $d949ebf04c50c323$var$addEvent(object, event, method) {
    if (object.addEventListener) object.addEventListener(event, method, false);
    else if (object.attachEvent) object.attachEvent("on".concat(event), function() {
        method(window.event);
    });
} // 修饰键转换成对应的键码
function $d949ebf04c50c323$var$getMods(modifier, key) {
    var mods = key.slice(0, key.length - 1);
    for(var i = 0; i < mods.length; i++)mods[i] = modifier[mods[i].toLowerCase()];
    return mods;
} // 处理传的key字符串转换成数组
function $d949ebf04c50c323$var$getKeys(key) {
    if (typeof key !== 'string') key = '';
    key = key.replace(/\s/g, ''); // 匹配任何空白字符,包括空格、制表符、换页符等等
    var keys = key.split(','); // 同时设置多个快捷键，以','分割
    var index = keys.lastIndexOf(''); // 快捷键可能包含','，需特殊处理
    for(; index >= 0;){
        keys[index - 1] += ',';
        keys.splice(index, 1);
        index = keys.lastIndexOf('');
    }
    return keys;
} // 比较修饰键的数组
function $d949ebf04c50c323$var$compareArray(a1, a2) {
    var arr1 = a1.length >= a2.length ? a1 : a2;
    var arr2 = a1.length >= a2.length ? a2 : a1;
    var isIndex = true;
    for(var i = 0; i < arr1.length; i++)if (arr2.indexOf(arr1[i]) === -1) isIndex = false;
    return isIndex;
}
var $d949ebf04c50c323$var$_keyMap = {
    backspace: 8,
    tab: 9,
    clear: 12,
    enter: 13,
    return: 13,
    esc: 27,
    escape: 27,
    space: 32,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    del: 46,
    delete: 46,
    ins: 45,
    insert: 45,
    home: 36,
    end: 35,
    pageup: 33,
    pagedown: 34,
    capslock: 20,
    "\u21EA": 20,
    ',': 188,
    '.': 190,
    '/': 191,
    '`': 192,
    '-': $d949ebf04c50c323$var$isff ? 173 : 189,
    '=': $d949ebf04c50c323$var$isff ? 61 : 187,
    ';': $d949ebf04c50c323$var$isff ? 59 : 186,
    '\'': 222,
    '[': 219,
    ']': 221,
    '\\': 220
}; // Modifier Keys
var $d949ebf04c50c323$var$_modifier = {
    // shiftKey
    "\u21E7": 16,
    shift: 16,
    // altKey
    "\u2325": 18,
    alt: 18,
    option: 18,
    // ctrlKey
    "\u2303": 17,
    ctrl: 17,
    control: 17,
    // metaKey
    "\u2318": 91,
    cmd: 91,
    command: 91
};
var $d949ebf04c50c323$var$modifierMap = {
    16: 'shiftKey',
    18: 'altKey',
    17: 'ctrlKey',
    91: 'metaKey',
    shiftKey: 16,
    ctrlKey: 17,
    altKey: 18,
    metaKey: 91
};
var $d949ebf04c50c323$var$_mods = {
    16: false,
    18: false,
    17: false,
    91: false
};
var $d949ebf04c50c323$var$_handlers = {}; // F1~F12 special key
for(var $d949ebf04c50c323$var$k = 1; $d949ebf04c50c323$var$k < 20; $d949ebf04c50c323$var$k++)$d949ebf04c50c323$var$_keyMap["f".concat($d949ebf04c50c323$var$k)] = 111 + $d949ebf04c50c323$var$k;
var $d949ebf04c50c323$var$_downKeys = []; // 记录摁下的绑定键
var $d949ebf04c50c323$var$_scope = 'all'; // 默认热键范围
var $d949ebf04c50c323$var$elementHasBindEvent = []; // 已绑定事件的节点记录
// 返回键码
var $d949ebf04c50c323$var$code = function code(x) {
    return $d949ebf04c50c323$var$_keyMap[x.toLowerCase()] || $d949ebf04c50c323$var$_modifier[x.toLowerCase()] || x.toUpperCase().charCodeAt(0);
}; // 设置获取当前范围（默认为'所有'）
function $d949ebf04c50c323$var$setScope(scope) {
    $d949ebf04c50c323$var$_scope = scope || 'all';
} // 获取当前范围
function $d949ebf04c50c323$var$getScope() {
    return $d949ebf04c50c323$var$_scope || 'all';
} // 获取摁下绑定键的键值
function $d949ebf04c50c323$var$getPressedKeyCodes() {
    return $d949ebf04c50c323$var$_downKeys.slice(0);
} // 表单控件控件判断 返回 Boolean
// hotkey is effective only when filter return true
function $d949ebf04c50c323$var$filter(event) {
    var target = event.target || event.srcElement;
    var tagName = target.tagName;
    var flag = true; // ignore: isContentEditable === 'true', <input> and <textarea> when readOnly state is false, <select>
    if (target.isContentEditable || (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') && !target.readOnly) flag = false;
    return flag;
} // 判断摁下的键是否为某个键，返回true或者false
function $d949ebf04c50c323$var$isPressed(keyCode) {
    if (typeof keyCode === 'string') keyCode = $d949ebf04c50c323$var$code(keyCode); // 转换成键码
    return $d949ebf04c50c323$var$_downKeys.indexOf(keyCode) !== -1;
} // 循环删除handlers中的所有 scope(范围)
function $d949ebf04c50c323$var$deleteScope(scope, newScope) {
    var handlers;
    var i; // 没有指定scope，获取scope
    if (!scope) scope = $d949ebf04c50c323$var$getScope();
    for(var key in $d949ebf04c50c323$var$_handlers)if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_handlers, key)) {
        handlers = $d949ebf04c50c323$var$_handlers[key];
        for(i = 0; i < handlers.length;)if (handlers[i].scope === scope) handlers.splice(i, 1);
        else i++;
    }
     // 如果scope被删除，将scope重置为all
    if ($d949ebf04c50c323$var$getScope() === scope) $d949ebf04c50c323$var$setScope(newScope || 'all');
} // 清除修饰键
function $d949ebf04c50c323$var$clearModifier(event) {
    var key = event.keyCode || event.which || event.charCode;
    var i = $d949ebf04c50c323$var$_downKeys.indexOf(key); // 从列表中清除按压过的键
    if (i >= 0) $d949ebf04c50c323$var$_downKeys.splice(i, 1);
     // 特殊处理 cmmand 键，在 cmmand 组合快捷键 keyup 只执行一次的问题
    if (event.key && event.key.toLowerCase() === 'meta') $d949ebf04c50c323$var$_downKeys.splice(0, $d949ebf04c50c323$var$_downKeys.length);
     // 修饰键 shiftKey altKey ctrlKey (command||metaKey) 清除
    if (key === 93 || key === 224) key = 91;
    if (key in $d949ebf04c50c323$var$_mods) {
        $d949ebf04c50c323$var$_mods[key] = false; // 将修饰键重置为false
        for(var k in $d949ebf04c50c323$var$_modifier)if ($d949ebf04c50c323$var$_modifier[k] === key) $d949ebf04c50c323$var$hotkeys[k] = false;
    }
}
function $d949ebf04c50c323$var$unbind(keysInfo) {
    // unbind(), unbind all keys
    if (!keysInfo) Object.keys($d949ebf04c50c323$var$_handlers).forEach(function(key) {
        return delete $d949ebf04c50c323$var$_handlers[key];
    });
    else if (Array.isArray(keysInfo)) // support like : unbind([{key: 'ctrl+a', scope: 's1'}, {key: 'ctrl-a', scope: 's2', splitKey: '-'}])
    keysInfo.forEach(function(info) {
        if (info.key) $d949ebf04c50c323$var$eachUnbind(info);
    });
    else if (typeof keysInfo === 'object') // support like unbind({key: 'ctrl+a, ctrl+b', scope:'abc'})
    {
        if (keysInfo.key) $d949ebf04c50c323$var$eachUnbind(keysInfo);
    } else if (typeof keysInfo === 'string') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        // support old method
        // eslint-disable-line
        var scope = args[0], method = args[1];
        if (typeof scope === 'function') {
            method = scope;
            scope = '';
        }
        $d949ebf04c50c323$var$eachUnbind({
            key: keysInfo,
            scope: scope,
            method: method,
            splitKey: '+'
        });
    }
} // 解除绑定某个范围的快捷键
var $d949ebf04c50c323$var$eachUnbind = function eachUnbind(_ref) {
    var key = _ref.key, scope = _ref.scope, method = _ref.method, _ref$splitKey = _ref.splitKey, splitKey = _ref$splitKey === void 0 ? '+' : _ref$splitKey;
    var multipleKeys = $d949ebf04c50c323$var$getKeys(key);
    multipleKeys.forEach(function(originKey) {
        var unbindKeys = originKey.split(splitKey);
        var len = unbindKeys.length;
        var lastKey = unbindKeys[len - 1];
        var keyCode = lastKey === '*' ? '*' : $d949ebf04c50c323$var$code(lastKey);
        if (!$d949ebf04c50c323$var$_handlers[keyCode]) return; // 判断是否传入范围，没有就获取范围
        if (!scope) scope = $d949ebf04c50c323$var$getScope();
        var mods = len > 1 ? $d949ebf04c50c323$var$getMods($d949ebf04c50c323$var$_modifier, unbindKeys) : [];
        $d949ebf04c50c323$var$_handlers[keyCode] = $d949ebf04c50c323$var$_handlers[keyCode].map(function(record) {
            // 通过函数判断，是否解除绑定，函数相等直接返回
            var isMatchingMethod = method ? record.method === method : true;
            if (isMatchingMethod && record.scope === scope && $d949ebf04c50c323$var$compareArray(record.mods, mods)) return {};
            return record;
        });
    });
}; // 对监听对应快捷键的回调函数进行处理
function $d949ebf04c50c323$var$eventHandler(event, handler, scope) {
    var modifiersMatch; // 看它是否在当前范围
    if (handler.scope === scope || handler.scope === 'all') {
        // 检查是否匹配修饰符（如果有返回true）
        modifiersMatch = handler.mods.length > 0;
        for(var y in $d949ebf04c50c323$var$_mods){
            if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_mods, y)) {
                if (!$d949ebf04c50c323$var$_mods[y] && handler.mods.indexOf(+y) > -1 || $d949ebf04c50c323$var$_mods[y] && handler.mods.indexOf(+y) === -1) modifiersMatch = false;
            }
        } // 调用处理程序，如果是修饰键不做处理
        if (handler.mods.length === 0 && !$d949ebf04c50c323$var$_mods[16] && !$d949ebf04c50c323$var$_mods[18] && !$d949ebf04c50c323$var$_mods[17] && !$d949ebf04c50c323$var$_mods[91] || modifiersMatch || handler.shortcut === '*') {
            if (handler.method(event, handler) === false) {
                if (event.preventDefault) event.preventDefault();
                else event.returnValue = false;
                if (event.stopPropagation) event.stopPropagation();
                if (event.cancelBubble) event.cancelBubble = true;
            }
        }
    }
} // 处理keydown事件
function $d949ebf04c50c323$var$dispatch(event) {
    var asterisk = $d949ebf04c50c323$var$_handlers['*'];
    var key = event.keyCode || event.which || event.charCode; // 表单控件过滤 默认表单控件不触发快捷键
    if (!$d949ebf04c50c323$var$hotkeys.filter.call(this, event)) return; // Gecko(Firefox)的command键值224，在Webkit(Chrome)中保持一致
    // Webkit左右 command 键值不一样
    if (key === 93 || key === 224) key = 91;
    /**
   * Collect bound keys
   * If an Input Method Editor is processing key input and the event is keydown, return 229.
   * https://stackoverflow.com/questions/25043934/is-it-ok-to-ignore-keydown-events-with-keycode-229
   * http://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
   */ if ($d949ebf04c50c323$var$_downKeys.indexOf(key) === -1 && key !== 229) $d949ebf04c50c323$var$_downKeys.push(key);
    /**
   * Jest test cases are required.
   * ===============================
   */ [
        'ctrlKey',
        'altKey',
        'shiftKey',
        'metaKey'
    ].forEach(function(keyName) {
        var keyNum = $d949ebf04c50c323$var$modifierMap[keyName];
        if (event[keyName] && $d949ebf04c50c323$var$_downKeys.indexOf(keyNum) === -1) $d949ebf04c50c323$var$_downKeys.push(keyNum);
        else if (!event[keyName] && $d949ebf04c50c323$var$_downKeys.indexOf(keyNum) > -1) $d949ebf04c50c323$var$_downKeys.splice($d949ebf04c50c323$var$_downKeys.indexOf(keyNum), 1);
        else if (keyName === 'metaKey' && event[keyName] && $d949ebf04c50c323$var$_downKeys.length === 3) /**
       * Fix if Command is pressed:
       * ===============================
       */ {
            if (!(event.ctrlKey || event.shiftKey || event.altKey)) $d949ebf04c50c323$var$_downKeys = $d949ebf04c50c323$var$_downKeys.slice($d949ebf04c50c323$var$_downKeys.indexOf(keyNum));
        }
    });
    /**
   * -------------------------------
   */ if (key in $d949ebf04c50c323$var$_mods) {
        $d949ebf04c50c323$var$_mods[key] = true; // 将特殊字符的key注册到 hotkeys 上
        for(var k in $d949ebf04c50c323$var$_modifier)if ($d949ebf04c50c323$var$_modifier[k] === key) $d949ebf04c50c323$var$hotkeys[k] = true;
        if (!asterisk) return;
    } // 将 modifierMap 里面的修饰键绑定到 event 中
    for(var e in $d949ebf04c50c323$var$_mods)if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_mods, e)) $d949ebf04c50c323$var$_mods[e] = event[$d949ebf04c50c323$var$modifierMap[e]];
    /**
   * https://github.com/jaywcjlove/hotkeys/pull/129
   * This solves the issue in Firefox on Windows where hotkeys corresponding to special characters would not trigger.
   * An example of this is ctrl+alt+m on a Swedish keyboard which is used to type μ.
   * Browser support: https://caniuse.com/#feat=keyboardevent-getmodifierstate
   */ if (event.getModifierState && !(event.altKey && !event.ctrlKey) && event.getModifierState('AltGraph')) {
        if ($d949ebf04c50c323$var$_downKeys.indexOf(17) === -1) $d949ebf04c50c323$var$_downKeys.push(17);
        if ($d949ebf04c50c323$var$_downKeys.indexOf(18) === -1) $d949ebf04c50c323$var$_downKeys.push(18);
        $d949ebf04c50c323$var$_mods[17] = true;
        $d949ebf04c50c323$var$_mods[18] = true;
    } // 获取范围 默认为 `all`
    var scope = $d949ebf04c50c323$var$getScope(); // 对任何快捷键都需要做的处理
    if (asterisk) {
        for(var i = 0; i < asterisk.length; i++)if (asterisk[i].scope === scope && (event.type === 'keydown' && asterisk[i].keydown || event.type === 'keyup' && asterisk[i].keyup)) $d949ebf04c50c323$var$eventHandler(event, asterisk[i], scope);
    } // key 不在 _handlers 中返回
    if (!(key in $d949ebf04c50c323$var$_handlers)) return;
    for(var _i = 0; _i < $d949ebf04c50c323$var$_handlers[key].length; _i++){
        if (event.type === 'keydown' && $d949ebf04c50c323$var$_handlers[key][_i].keydown || event.type === 'keyup' && $d949ebf04c50c323$var$_handlers[key][_i].keyup) {
            if ($d949ebf04c50c323$var$_handlers[key][_i].key) {
                var record = $d949ebf04c50c323$var$_handlers[key][_i];
                var splitKey = record.splitKey;
                var keyShortcut = record.key.split(splitKey);
                var _downKeysCurrent = []; // 记录当前按键键值
                for(var a = 0; a < keyShortcut.length; a++)_downKeysCurrent.push($d949ebf04c50c323$var$code(keyShortcut[a]));
                if (_downKeysCurrent.sort().join('') === $d949ebf04c50c323$var$_downKeys.sort().join('')) // 找到处理内容
                $d949ebf04c50c323$var$eventHandler(event, record, scope);
            }
        }
    }
} // 判断 element 是否已经绑定事件
function $d949ebf04c50c323$var$isElementBind(element) {
    return $d949ebf04c50c323$var$elementHasBindEvent.indexOf(element) > -1;
}
function $d949ebf04c50c323$var$hotkeys(key, option, method) {
    $d949ebf04c50c323$var$_downKeys = [];
    var keys = $d949ebf04c50c323$var$getKeys(key); // 需要处理的快捷键列表
    var mods = [];
    var scope = 'all'; // scope默认为all，所有范围都有效
    var element = document; // 快捷键事件绑定节点
    var i = 0;
    var keyup = false;
    var keydown = true;
    var splitKey = '+'; // 对为设定范围的判断
    if (method === undefined && typeof option === 'function') method = option;
    if (Object.prototype.toString.call(option) === '[object Object]') {
        if (option.scope) scope = option.scope; // eslint-disable-line
        if (option.element) element = option.element; // eslint-disable-line
        if (option.keyup) keyup = option.keyup; // eslint-disable-line
        if (option.keydown !== undefined) keydown = option.keydown; // eslint-disable-line
        if (typeof option.splitKey === 'string') splitKey = option.splitKey; // eslint-disable-line
    }
    if (typeof option === 'string') scope = option; // 对于每个快捷键进行处理
    for(; i < keys.length; i++){
        key = keys[i].split(splitKey); // 按键列表
        mods = []; // 如果是组合快捷键取得组合快捷键
        if (key.length > 1) mods = $d949ebf04c50c323$var$getMods($d949ebf04c50c323$var$_modifier, key); // 将非修饰键转化为键码
        key = key[key.length - 1];
        key = key === '*' ? '*' : $d949ebf04c50c323$var$code(key); // *表示匹配所有快捷键
        // 判断key是否在_handlers中，不在就赋一个空数组
        if (!(key in $d949ebf04c50c323$var$_handlers)) $d949ebf04c50c323$var$_handlers[key] = [];
        $d949ebf04c50c323$var$_handlers[key].push({
            keyup: keyup,
            keydown: keydown,
            scope: scope,
            mods: mods,
            shortcut: keys[i],
            method: method,
            key: keys[i],
            splitKey: splitKey
        });
    } // 在全局document上设置快捷键
    if (typeof element !== 'undefined' && !$d949ebf04c50c323$var$isElementBind(element) && window) {
        $d949ebf04c50c323$var$elementHasBindEvent.push(element);
        $d949ebf04c50c323$var$addEvent(element, 'keydown', function(e) {
            $d949ebf04c50c323$var$dispatch(e);
        });
        $d949ebf04c50c323$var$addEvent(window, 'focus', function() {
            $d949ebf04c50c323$var$_downKeys = [];
        });
        $d949ebf04c50c323$var$addEvent(element, 'keyup', function(e) {
            $d949ebf04c50c323$var$dispatch(e);
            $d949ebf04c50c323$var$clearModifier(e);
        });
    }
}
var $d949ebf04c50c323$var$_api = {
    setScope: $d949ebf04c50c323$var$setScope,
    getScope: $d949ebf04c50c323$var$getScope,
    deleteScope: $d949ebf04c50c323$var$deleteScope,
    getPressedKeyCodes: $d949ebf04c50c323$var$getPressedKeyCodes,
    isPressed: $d949ebf04c50c323$var$isPressed,
    filter: $d949ebf04c50c323$var$filter,
    unbind: $d949ebf04c50c323$var$unbind
};
for(var $d949ebf04c50c323$var$a in $d949ebf04c50c323$var$_api)if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_api, $d949ebf04c50c323$var$a)) $d949ebf04c50c323$var$hotkeys[$d949ebf04c50c323$var$a] = $d949ebf04c50c323$var$_api[$d949ebf04c50c323$var$a];
if (typeof window !== 'undefined') {
    var $d949ebf04c50c323$var$_hotkeys = window.hotkeys;
    $d949ebf04c50c323$var$hotkeys.noConflict = function(deep) {
        if (deep && window.hotkeys === $d949ebf04c50c323$var$hotkeys) window.hotkeys = $d949ebf04c50c323$var$_hotkeys;
        return $d949ebf04c50c323$var$hotkeys;
    };
    window.hotkeys = $d949ebf04c50c323$var$hotkeys;
}
var $d949ebf04c50c323$export$2e2bcd8739ae039 = $d949ebf04c50c323$var$hotkeys;



var $acw62 = parcelRequire("acw62");
function $643289de0f480f5f$export$8117d1c774d4748d() {
    return (0, $d949ebf04c50c323$export$2e2bcd8739ae039).isPressed;
}
function $643289de0f480f5f$export$1b0c17123b4f3646(keys, callback, options, deps) {
    if (options instanceof Array) {
        deps = options;
        options = undefined;
    }
    var _ref = options || {}, enableOnTags = _ref.enableOnTags, filter = _ref.filter, keyup = _ref.keyup, keydown = _ref.keydown;
    var ref = (0, $acw62.useRef)(null);
    var memoisedCallback = (0, $acw62.useCallback)(function(keyboardEvent, hotkeysEvent) {
        if (ref.current === null || document.activeElement === ref.current) {
            callback(keyboardEvent, hotkeysEvent);
            return true;
        }
        return false;
    }, deps ? [
        ref
    ].concat(deps) : [
        ref
    ]);
    (0, $acw62.useEffect)(function() {
        if (options && options.enableOnTags) (0, $d949ebf04c50c323$export$2e2bcd8739ae039).filter = function(_ref2) {
            var target = _ref2.target, srcElement = _ref2.srcElement;
            // @ts-ignore
            var targetTagName = target && target.tagName || srcElement && srcElement.tagName;
            return Boolean(targetTagName && enableOnTags && enableOnTags.includes(targetTagName));
        };
        if (filter) (0, $d949ebf04c50c323$export$2e2bcd8739ae039).filter = filter;
        if (keyup && keydown !== true) options.keydown = false;
        (0, $d949ebf04c50c323$export$2e2bcd8739ae039)(keys, options || {}, memoisedCallback);
        return function() {
            return (0, $d949ebf04c50c323$export$2e2bcd8739ae039).unbind(keys, memoisedCallback);
        };
    }, [
        memoisedCallback,
        options,
        enableOnTags,
        filter,
        keys
    ]);
    return ref;
}









parcelRequire("acw62");

const $8836009201f6d637$export$9905d75c11ef308b = (props)=>{
    const { className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('border-border h-px border-b', className),
        role: "separator",
        ...rest
    });
};
const $8836009201f6d637$export$ef912b5a59ca772b = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground px-2 pt-2.5 pb-1 text-xs font-medium tracking-wide uppercase",
        role: "presentation",
        children: children
    });





parcelRequire("acw62");




const $f19cc5705d0e1661$export$5aad1ccc3a47254f = ({ className: className, ...props })=>{
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const updatesAvailable = (0, $d445317123c5c8b5$export$e3811da6fd33476c)();
    const handleClick = ()=>{
        modals.syncModal.openModal({});
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
        ...props,
        variant: "ghost",
        size: "icon",
        onClick: handleClick,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('relative', className),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                className: "size-5"
            }),
            updatesAvailable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "absolute right-1.5 top-1.5 size-2 rounded-full bg-blue-500"
            })
        ]
    });
};



parcelRequire("acw62");





parcelRequire("acw62");




/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3206cd97f03c9458$export$3efd853dbb351e94 = [
    [
        "polyline",
        {
            points: "22 12 16 12 14 15 10 15 8 12 2 12",
            key: "o97t9d"
        }
    ],
    [
        "path",
        {
            d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
            key: "oot6mr"
        }
    ]
];
const $3206cd97f03c9458$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("inbox", $3206cd97f03c9458$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4b66c39b6083b2b9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 5h16",
            key: "1tepv9"
        }
    ],
    [
        "path",
        {
            d: "M4 12h16",
            key: "1lakjw"
        }
    ],
    [
        "path",
        {
            d: "M4 19h16",
            key: "1djgab"
        }
    ]
];
const $4b66c39b6083b2b9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("menu", $4b66c39b6083b2b9$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");



const $c1f740d16830f15c$var$TABS = [
    {
        path: '/',
        label: 'Inbox',
        icon: (0, $3206cd97f03c9458$export$2e2bcd8739ae039),
        // The backlog and the expanded review are the Inbox's own drill-ins.
        matches: (p)=>[
                '/',
                '/backlog',
                '/inbox/review'
            ].includes(p.replace(/(.)\/+$/, '$1'))
    },
    {
        path: '/ledger',
        label: 'Ledger',
        icon: (0, $cab856bf30f1b37f$export$2e2bcd8739ae039),
        // A transaction's or a line's own page is still somewhere in the ledger.
        matches: (p)=>[
                '/ledger',
                '/transactions/',
                '/raw-transactions/'
            ].some((prefix)=>p.startsWith(prefix))
    },
    {
        path: '/accounts',
        label: 'Accounts',
        icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
        // A balance anchor is opened from an account's reconcile timeline.
        matches: (p)=>p === '/accounts' || [
                '/accounts/',
                '/balance-anchors/'
            ].some((prefix)=>p.startsWith(prefix))
    }
];
/** An account's numbers that a new raw transaction changes. */ const $c1f740d16830f15c$var$ACCOUNT_DERIVED_FIELDS = [
    'balance',
    'homeBalance',
    'balanceStaleSince',
    'hasRecentActivity',
    'transactionCount'
];
const $c1f740d16830f15c$var$itemClass = (active)=>(0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex min-w-0 flex-1 flex-col items-center justify-end gap-0.5 pt-1.5 pb-1 text-[0.7rem] no-underline', active ? 'text-foreground' : 'text-muted-foreground');
/**
 * True while a text field has focus — on a phone, while the keyboard is up.
 * The viewport resizes for the keyboard (`interactive-widget=resizes-content`),
 * so a bar pinned to the bottom would ride on top of it.
 *
 * A focused field that is removed (a modal closing on Enter) sends no
 * focusout, so while one has focus, a DOM observer also watches for it
 * leaving the page.
 */ const $c1f740d16830f15c$var$useTypingFocus = ()=>{
    const [typing, setTyping] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        const isTextField = (target)=>target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable || target instanceof HTMLInputElement && ![
                'button',
                'checkbox',
                'radio',
                'range',
                'submit',
                'reset',
                'file',
                'color'
            ].includes(target.type);
        let field = null;
        const removal = new MutationObserver(()=>{
            if (field != null && !field.isConnected) clear();
        });
        const clear = ()=>{
            field = null;
            removal.disconnect();
            setTyping(false);
        };
        const onFocusIn = (event)=>{
            if (!isTextField(event.target)) return clear();
            field = event.target;
            removal.observe(document.body, {
                childList: true,
                subtree: true
            });
            setTyping(true);
        };
        const onFocusOut = (event)=>{
            if (!isTextField(event.relatedTarget)) clear();
        };
        // A page that focuses a field as it mounts does so before this effect
        // listens.
        if (isTextField(document.activeElement)) {
            field = document.activeElement;
            removal.observe(document.body, {
                childList: true,
                subtree: true
            });
            setTyping(true);
        }
        document.addEventListener('focusin', onFocusIn);
        document.addEventListener('focusout', onFocusOut);
        return ()=>{
            document.removeEventListener('focusin', onFocusIn);
            document.removeEventListener('focusout', onFocusOut);
            removal.disconnect();
        };
    }, []);
    return typing;
};
/** How far the viewport must shrink below its tallest to count as a keyboard. */ const $c1f740d16830f15c$var$KEYBOARD_MIN_HEIGHT = 150;
/**
 * The viewport heights seen so far. Kept at module scope and measured from
 * page load on, whether or not the bar is mounted: it isn't on a landscape
 * phone past the mobile breakpoint, and what the keyboard does there has to
 * be known when the phone turns back.
 */ const $c1f740d16830f15c$var$keyboardHistory = {
    // Keyed by width, so rotating the phone starts a fresh baseline.
    tallest: new Map(),
    // A width first seen with the keyboard up (the phone rotated mid-typing)
    // has no unobscured height yet: the keyboard stays open there until the
    // view grows clear of the shortest it has been.
    shortestWhileOpen: new Map(),
    open: false,
    listeners: new Set()
};
const $c1f740d16830f15c$var$measureKeyboard = (viewport)=>{
    const { tallest: tallest, shortestWhileOpen: shortestWhileOpen } = $c1f740d16830f15c$var$keyboardHistory;
    const width = Math.round(viewport.width * viewport.scale);
    const height = viewport.height * viewport.scale;
    const known = tallest.get(width);
    if (known != null) {
        const max = Math.max(known, height);
        tallest.set(width, max);
        $c1f740d16830f15c$var$keyboardHistory.open = max - height > $c1f740d16830f15c$var$KEYBOARD_MIN_HEIGHT;
    } else if ($c1f740d16830f15c$var$keyboardHistory.open) {
        const min = Math.min(shortestWhileOpen.get(width) ?? height, height);
        shortestWhileOpen.set(width, min);
        if (height - min > $c1f740d16830f15c$var$KEYBOARD_MIN_HEIGHT) {
            tallest.set(width, height);
            $c1f740d16830f15c$var$keyboardHistory.open = false;
        }
    } else tallest.set(width, height);
    for (const listener of $c1f740d16830f15c$var$keyboardHistory.listeners)listener();
};
const $c1f740d16830f15c$var$viewport = typeof window === 'undefined' ? undefined : window.visualViewport;
if ($c1f740d16830f15c$var$viewport != null) {
    $c1f740d16830f15c$var$measureKeyboard($c1f740d16830f15c$var$viewport);
    $c1f740d16830f15c$var$viewport.addEventListener('resize', ()=>$c1f740d16830f15c$var$measureKeyboard($c1f740d16830f15c$var$viewport));
}
const $c1f740d16830f15c$var$subscribeKeyboard = (listener)=>{
    $c1f740d16830f15c$var$keyboardHistory.listeners.add(listener);
    return ()=>{
        $c1f740d16830f15c$var$keyboardHistory.listeners.delete(listener);
    };
};
/**
 * True while the visible viewport is well short of the tallest it has been
 * at this width — on a phone, while the soft keyboard is up. Focus alone
 * can't tell: Android's back gesture closes the keyboard but leaves the
 * field focused, which would leave the tab bar gone with nothing covering
 * its place. The visual viewport shrinks for the keyboard whether the
 * layout resizes (Android) or not (iOS).
 */ const $c1f740d16830f15c$var$useKeyboardOpen = ()=>$acw62.useSyncExternalStore($c1f740d16830f15c$var$subscribeKeyboard, ()=>$c1f740d16830f15c$var$keyboardHistory.open);
/**
 * Holds the DOM node laid over the tab bar (rendered by BottomBar), for a
 * page to put a bar of its own exactly where the tabs are — same box, same
 * bottom inset — instead of a fixed layer guessing at the tab bar's height.
 * Null while the tab bar isn't shown (on desktop, or while the keyboard is up).
 */ const $c1f740d16830f15c$var$BottomBarSlotContext = /*#__PURE__*/ $acw62.createContext(null);
const $c1f740d16830f15c$export$f199e5d2cab70941 = $c1f740d16830f15c$var$BottomBarSlotContext.Provider;
const $c1f740d16830f15c$export$5af099daf846d6b9 = ()=>$acw62.useContext($c1f740d16830f15c$var$BottomBarSlotContext);
const $c1f740d16830f15c$export$baad9f01dbfd9b39 = ({ onMore: onMore, slotRef: slotRef })=>{
    const { pathname: pathname } = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const typing = $c1f740d16830f15c$var$useTypingFocus();
    const keyboardOpen = $c1f740d16830f15c$var$useKeyboardOpen();
    const { data: data } = (0, $ce9d9e524be20f53$export$edf7816f5074c300)();
    const reviewCount = data?.inboxBacklogSummary.recentCount ?? 0;
    if (typing && keyboardOpen) return null;
    const activeTab = $c1f740d16830f15c$var$TABS.find((tab)=>tab.matches(pathname));
    const add = ()=>{
        modals.createRawTransactionModal.openModal({
            // The new row lands in the review queue. Evicting (not just
            // refetching) the lists reaches pages loaded earlier and no longer on
            // screen too, which a named refetch skips: they reload when next shown.
            onCreate: (transaction)=>{
                const { cache: cache } = client;
                cache.evict({
                    id: 'ROOT_QUERY',
                    fieldName: 'allRawTransactions'
                });
                cache.evict({
                    id: 'ROOT_QUERY',
                    fieldName: 'inboxBacklogSummary'
                });
                // Its account's derived numbers moved too, and nothing on screen
                // asks for them again unless they're gone.
                const account = cache.identify(transaction.account);
                if (account != null) for (const fieldName of $c1f740d16830f15c$var$ACCOUNT_DERIVED_FIELDS)cache.evict({
                    id: account,
                    fieldName: fieldName
                });
                cache.gc();
            }
        });
    };
    const tab = (index)=>{
        const { path: path, label: label, icon: Icon } = $c1f740d16830f15c$var$TABS[index];
        const active = activeTab?.path === path;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
            to: path,
            "aria-current": active ? 'page' : undefined,
            className: $c1f740d16830f15c$var$itemClass(active),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                            className: "size-5",
                            strokeWidth: active ? 2.25 : 1.75
                        }),
                        path === '/' && reviewCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "bg-primary text-primary-foreground absolute -top-1.5 left-3 min-w-4 rounded-full px-1 text-center text-[0.625rem] leading-4 font-medium tabular-nums",
                            children: reviewCount > 99 ? '99+' : reviewCount
                        })
                    ]
                }),
                label
            ]
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
        "aria-label": "Tab bar",
        className: "border-border bg-background relative flex shrink-0 items-stretch overflow-hidden border-t pb-[env(safe-area-inset-bottom)]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: slotRef,
                className: "pointer-events-none absolute inset-0 z-[1] [&>*]:pointer-events-auto"
            }),
            tab(0),
            tab(1),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: add,
                className: $c1f740d16830f15c$var$itemClass(false),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "bg-primary text-primary-foreground flex size-8 items-center justify-center rounded-full",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                            className: "size-5"
                        })
                    }),
                    "Add"
                ]
            }),
            tab(2),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: onMore,
                // Anywhere the tabs don't cover is somewhere under More.
                className: $c1f740d16830f15c$var$itemClass(activeTab == null),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b66c39b6083b2b9$export$2e2bcd8739ae039), {
                        className: "size-5",
                        strokeWidth: activeTab == null ? 2.25 : 1.75
                    }),
                    "More"
                ]
            })
        ]
    });
};







const $f3510f079d0deb75$export$fb0f67804b6488a4 = ({ open: open, count: count, total: total, menuItems: menuItems, primary: primary, onCancel: onCancel })=>{
    const slot = (0, $c1f740d16830f15c$export$5af099daf846d6b9)();
    const isMobile = (0, $d720d4657ad5543c$export$2b96349243a56116)();
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "ghost",
                size: "icon",
                onClick: onCancel,
                "aria-label": "Clear selection",
                className: "shrink-0 rounded-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    className: "size-5"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-w-0 flex-1 flex-col leading-tight",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "truncate font-semibold",
                        children: [
                            count,
                            " selected"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground truncate text-sm tabular-nums",
                        title: total,
                        children: total
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49e34d17f9b50791$export$32b7bd840a1eba80), {
                above: true,
                renderTrigger: ({ ref: ref, onClick: onClick })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        ref: ref,
                        variant: "outline",
                        onClick: onClick,
                        disabled: count === 0,
                        className: "shrink-0",
                        children: "More"
                    }),
                children: menuItems
            }),
            primary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "primary",
                className: "shrink-0",
                disabled: primary.disabled || count === 0,
                onClick: primary.onClick,
                children: primary.label
            })
        ]
    });
    const bar = (className)=>open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            initial: {
                y: '110%'
            },
            animate: {
                y: 0
            },
            exit: {
                y: '110%'
            },
            transition: {
                duration: 0.22,
                ease: 'easeOut'
            },
            role: "toolbar",
            "aria-label": "Selected rows",
            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('bg-background flex items-center gap-2', className),
            children: content
        }, "selection-bar");
    if (slot != null) return /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        children: bar('absolute inset-0 px-3 pb-[env(safe-area-inset-bottom)]')
    }), slot);
    // A phone with no slot is one typing, with the tab bar tucked away.
    if (isMobile) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72de694199324d9d$export$2e2bcd8739ae039), {
        children: bar('border-border fixed bottom-6 left-1/2 z-[1] w-[min(32rem,calc(100vw-2rem))] -translate-x-1/2 rounded-full border px-3 py-2 shadow-lg')
    });
};


const $d3bd1972ca95e7ca$export$377ee9046e4a9901 = ({ actions: actions, open: open, onCancel: onCancel })=>{
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3510f079d0deb75$export$fb0f67804b6488a4), {
        open: open || actions.hasSelected,
        count: actions.selectedCount,
        total: (0, $eb9c0713007ac1dd$export$d51151e4f01b4b50)(// What Create would consume: a partly allocated row's remainder.
        actions.selected.map((row)=>({
                amount: row.remainingAmount ?? row.amount,
                currency: row.currency
            }))).map((sum)=>formatMoney(sum)).join(" \xb7 "),
        menuItems: actions.selectionMenuItems,
        primary: {
            label: 'Create',
            disabled: !actions.canCreateTransaction,
            onClick: ()=>actions.openCreateTransactionModal()
        },
        onCancel: onCancel
    });
};


const $5789cc019e3b9369$export$8b251419efc915eb = ({ selectionState: selectionState, actions: selectionActions, gestures: gestures, filterContent: filterContent, extraActions: extraActions, accountId: accountId, showSyncButton: showSyncButton = true, showAddActions: showAddActions = true, stackActionsOnMobile: stackActionsOnMobile })=>{
    const { selected: selected } = selectionState;
    const sums = (0, $eb9c0713007ac1dd$export$d51151e4f01b4b50)(selected);
    const selectedCount = selected.length;
    const hasSelected = selectedCount > 0;
    const browse = gestures !== undefined;
    const selecting = gestures?.selecting ?? hasSelected;
    const total = hasSelected ? // One total per currency, so this group can be arbitrarily wide. It wraps
    // internally too, so a three-currency selection stacks whole amounts
    // rather than pushing the last one out of the header.
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "inline-flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1",
        children: sums.map((sum)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                variant: "plain",
                amount: sum
            }, sum.currency))
    }) : null;
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const { anyModalOpen: anyModalOpen, canCreateWithBenefit: canCreateWithBenefit, openCreateTransactionModal: openCreateTransactionModal, handleAddTransaction: handleAddTransaction, handleImport: handleImport, selectionMenuItems: selectionMenuItems } = selectionActions;
    const clearSelection = gestures?.stopSelecting ?? selectionState.clearSelection;
    (0, $643289de0f480f5f$export$1b0c17123b4f3646)('Escape', ()=>{
        if (anyModalOpen) return;
        if (selecting) clearSelection();
    }, [
        selecting,
        anyModalOpen,
        clearSelection
    ]);
    (0, $643289de0f480f5f$export$1b0c17123b4f3646)('c', (e)=>{
        if (anyModalOpen) return;
        e.preventDefault();
        openCreateTransactionModal();
    }, [
        selected,
        selectionActions.canCreateTransaction,
        anyModalOpen
    ]);
    (0, $643289de0f480f5f$export$1b0c17123b4f3646)('p', (e)=>{
        if (anyModalOpen) return;
        e.preventDefault();
        openCreateTransactionModal();
    }, [
        selected,
        selectionActions.canCreateTransaction,
        anyModalOpen
    ]);
    (0, $643289de0f480f5f$export$1b0c17123b4f3646)('b', (e)=>{
        if (anyModalOpen) return;
        e.preventDefault();
        if (!canCreateWithBenefit) return;
        openCreateTransactionModal({
            expandBenefit: true
        });
    }, [
        selected,
        canCreateWithBenefit,
        anyModalOpen
    ]);
    // Block-level flex (not inline-flex) so the row is bounded by the header
    // slot rather than shrink-to-fit — otherwise, in a header whose actions sit
    // on the same row (the review page), the summary runs under the action icons
    // instead of staying inside its slot.
    //
    // Bounded, it has to give somewhere. It wraps first: a total is a number and
    // clipping one is worse than a taller header, and a mixed-currency selection
    // renders one per currency, so the summary can outgrow any slot. The count is
    // the only part that may truncate, and only once wrapping has run out of
    // room — amounts are nowrap throughout, so each stays whole on its line.
    const headerContent = !browse && hasSelected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex min-w-0 flex-wrap items-center gap-x-1.5 gap-y-1 overflow-hidden pr-2 font-semibold whitespace-nowrap",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "ghost",
                className: "text-muted-foreground hover:text-foreground h-8 w-8 shrink-0 p-0",
                onClick: selectionState.clearSelection,
                title: "Clear selection",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                    size: 18
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                className: "min-w-0 cursor-pointer truncate",
                onClick: selectionState.clearSelection,
                title: "Clear selection",
                children: [
                    selectedCount,
                    " Selected"
                ]
            }),
            total
        ]
    }) : filterContent ?? null;
    const addItems = showAddActions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8836009201f6d637$export$ef912b5a59ca772b), {
                children: "Add"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: ()=>modals.createRawTransactionModal.openModal({
                        defaultAccountId: accountId,
                        onCreate: handleAddTransaction
                    }),
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {}),
                children: "Add transaction"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: ()=>modals.importTransactionsModal.openModal({
                        onImport: handleImport
                    }),
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05c245c7dcd30f27$export$2e2bcd8739ae039), {}),
                children: "Import"
            })
        ]
    });
    const actions = browse ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            extraActions,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                className: "shrink-0 gap-1.5 text-sm max-md:px-2.5",
                onClick: selecting ? clearSelection : gestures.startSelecting,
                "aria-pressed": selecting,
                "aria-label": selecting ? 'Done selecting' : 'Select rows',
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $131c05e6196e399a$export$2e2bcd8739ae039), {
                        className: "h-4 w-4"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "max-md:hidden",
                        children: selecting ? 'Done' : 'Select'
                    })
                ]
            }),
            showSyncButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f19cc5705d0e1661$export$5aad1ccc3a47254f), {}),
            addItems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49e34d17f9b50791$export$32b7bd840a1eba80), {
                children: addItems
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            extraActions,
            showSyncButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f19cc5705d0e1661$export$5aad1ccc3a47254f), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49e34d17f9b50791$export$32b7bd840a1eba80), {
                children: [
                    selectionMenuItems,
                    addItems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8836009201f6d637$export$9905d75c11ef308b), {}),
                            addItems
                        ]
                    })
                ]
            })
        ]
    });
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $833f55a7ff2d0d4a$export$2e2bcd8739ae039), {
        content: headerContent,
        actions: actions,
        // Browse mode has wrapping filters that need their own row on mobile;
        // the reconcile tab has no filters, so its actions stay inline — until a
        // selection puts the count and total where the (empty) filter row was.
        // That content is nowrap and shrink-to-fit, so on a phone it overlaps the
        // actions rather than truncating; giving them their own row is the fix.
        stackActionsOnMobile: stackActionsOnMobile ?? (browse || hasSelected)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            header,
            gestures && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3bd1972ca95e7ca$export$377ee9046e4a9901), {
                actions: selectionActions,
                open: gestures.selecting,
                onCancel: gestures.stopSelecting
            })
        ]
    });
};






/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $acd0522bfe4ba3cd$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 6v16",
            key: "nqf5sj"
        }
    ],
    [
        "path",
        {
            d: "m19 13 2-1a9 9 0 0 1-18 0l2 1",
            key: "y7qv08"
        }
    ],
    [
        "path",
        {
            d: "M9 11h6",
            key: "1fldmi"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "4",
            r: "2",
            key: "muu5ef"
        }
    ]
];
const $acd0522bfe4ba3cd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("anchor", $acd0522bfe4ba3cd$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $604e08b57548a73d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
            key: "1jaruq"
        }
    ]
];
const $604e08b57548a73d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("flag", $604e08b57548a73d$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");











const $e4870fadb257a2ad$export$828e1aaff3f02d36 = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A balance anchor interleaved into the transaction timeline: the date and
 * balance a reconciliation settled to (green, collapsible over the rows it
 * claimed), a balance still awaiting reconciliation (amber, reconcilable by
 * starting an in-place session), the baseline a span reconciles against
 * (neutral), or the starting balance the whole timeline stands on (sky).
 */ const $e4870fadb257a2ad$var$ObservationRow = ({ observation: observation, isBaseline: isBaseline, isStartingBalance: isStartingBalance, currency: currency, isCreditCard: isCreditCard, expanded: expanded, onToggle: onToggle, needed: needed, sessionActive: sessionActive, onStartReconcile: onStartReconcile, onCancelReconcile: onCancelReconcile, onFixUp: onFixUp })=>{
    // The active session, so the owning row can carry the Fix up / Cancel /
    // Reconcile actions inline (mirrored by the pinned top bar). Null on every
    // other row and while idle.
    const session = $acw62.useContext($e4870fadb257a2ad$export$828e1aaff3f02d36);
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const reconciled = Boolean(observation.reconciliation);
    // The starting balance outranks "Baseline": every anchor under a reconciled
    // span is a baseline, but only one is the floor the account is built on. It
    // can't outrank "Reconciled" — an anchor with a settled period of its own is
    // reporting that, not where it sits.
    const startingBalance = isStartingBalance && !reconciled;
    const label = reconciled ? 'Reconciled' : startingBalance ? 'Starting balance' : isBaseline ? 'Baseline' : 'Not reconciled';
    // Balances and their deltas render in the app-wide display convention:
    // credit-card anchors read as "amount owed" (toDisplayBalance), matching
    // the Overview tab, the observation detail page, and — in this tab — the
    // transaction rows themselves, which are also flipped to owed-space.
    const format = (cents)=>formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt((0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(cents, isCreditCard), currency));
    const claimedCount = observation.reconciliation?.rawTransactionIds.length;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        role: onToggle ? 'button' : undefined,
        onClick: onToggle,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(// min-h-10 is the height this row has when it carries a button (h-6
        // plus py-2), held whether or not one is present. The buttons are
        // conditional in several directions at once — Reconcile appears only
        // on unreconciled anchors with a baseline, and swaps for Fix up /
        // Cancel / Reconcile once a session starts — so without a floor the
        // row would jump 8px as those states change, and reconciled anchors
        // would sit shorter than their unreconciled neighbours in the same
        // timeline.
        'bg-muted/50 flex min-h-10 items-center gap-x-5 px-4 py-2 text-xs', 'not-last:border-border not-last:border-b', onToggle && 'hover:bg-muted cursor-pointer'),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "flex w-4 shrink-0 justify-center",
                children: onToggle && (expanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                    "aria-hidden": true,
                    className: "text-muted-foreground size-3.5"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                    "aria-hidden": true,
                    className: "text-muted-foreground size-3.5"
                }))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex items-center gap-1 font-medium', startingBalance ? 'text-sky-700 dark:text-sky-400' : reconciled || isBaseline ? 'text-muted-foreground' : 'text-amber-600 dark:text-amber-500'),
                title: startingBalance ? "The account starts here \u2014 nothing is dated before this balance." : undefined,
                children: [
                    startingBalance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $604e08b57548a73d$export$2e2bcd8739ae039), {
                        "aria-hidden": true,
                        className: "size-3"
                    }),
                    label
                ]
            }),
            reconciled && !expanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-muted-foreground",
                children: [
                    claimedCount,
                    " transaction",
                    claimedCount === 1 ? '' : 's'
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "ml-auto flex items-center gap-4",
                children: [
                    !reconciled && !startingBalance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-muted-foreground tabular-nums', // Desktop gives this space to the inline session actions. Mobile
                        // swaps in only the primary Reconcile (same footprint as the
                        // idle button), so the delta stays there — which is also what
                        // keeps the row's height steady: at 390px the idle row wraps
                        // around this text, and dropping it when a session starts
                        // collapsed the row from 49px to the 40px floor, shifting the
                        // whole timeline up by 9px. min-h alone can't hold a wrapped
                        // height; keeping the content that causes the wrap can.
                        sessionActive && 'md:hidden'),
                        children: needed === undefined ? 'needs an earlier baseline' : `needs ${format(needed)}`
                    }),
                    !reconciled && !sessionActive && onStartReconcile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        // touch-manipulation so a quick second tap (the mobile
                        // double-tap-to-reconcile flow below) is never eaten by the
                        // browser's double-tap zoom.
                        className: "h-6 touch-manipulation rounded px-2 py-0 text-xs",
                        onClick: onStartReconcile,
                        title: "Reconcile this balance against the period's transactions",
                        children: "Reconcile"
                    }),
                    sessionActive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            session && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "hidden items-center gap-1.5 md:flex",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                        variant: "outline",
                                        className: "h-6 rounded px-2 py-0 text-xs",
                                        disabled: !session.canFixUp,
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            onFixUp?.(session.remaining);
                                        },
                                        title: "Create a transaction that offsets the remaining amount",
                                        children: "Fix up"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                        variant: "outline",
                                        className: "h-6 rounded px-2 py-0 text-xs",
                                        disabled: session.submitting,
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            onCancelReconcile?.();
                                        },
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                        variant: "primary",
                                        className: "h-6 rounded px-2 py-0 text-xs",
                                        disabled: !session.canSubmit,
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            session.submit();
                                        },
                                        title: session.canSubmit ? `Reconcile against ${session.selectedTransactions.length} selected transaction${session.selectedTransactions.length === 1 ? '' : 's'}` : 'Adjust the selection until the expected balance matches',
                                        children: "Reconcile"
                                    })
                                ]
                            }),
                            session ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "primary",
                                className: "h-6 touch-manipulation rounded px-2 py-0 text-xs md:hidden",
                                disabled: !session.canSubmit,
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    session.submit();
                                },
                                title: session.canSubmit ? `Reconcile against ${session.selectedTransactions.length} selected transaction${session.selectedTransactions.length === 1 ? '' : 's'}` : 'Adjust the selection until the expected balance matches',
                                children: "Reconcile"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-medium text-blue-700 dark:text-blue-400",
                                children: "Reconciling\u2026"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground tabular-nums",
                        children: format(observation.balance)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                        to: `/balance-anchors/${observation._id}`,
                        onClick: (e)=>e.stopPropagation(),
                        className: "text-muted-foreground hover:text-foreground tabular-nums no-underline hover:underline",
                        title: "Open observation",
                        children: (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(observation.date)
                    })
                ]
            })
        ]
    });
};
/**
 * Per-row "record a balance dated here" affordance. Sparse accounts are
 * reconciled by dropping anchors (usually zero) at the points where the
 * balance is known, and typing the same date the row already shows is the
 * whole cost of that workflow — so the row offers it directly.
 *
 * Desktop only, deliberately. It reveals on hover, which touch has no
 * equivalent for, and a permanently visible target would have to be at least
 * 44px on a phone — the compact row spends ~236px of a 390px viewport on
 * fixed chrome already, and it sits between a tap that toggles selection and
 * a long press that navigates, so a small inline target invites mis-taps that
 * either write an anchor or discard a selection. The touch path is the
 * header's Record balance button, which prefills from the selected row.
 */ const $e4870fadb257a2ad$var$RecordBalanceRowAction = ({ date: date, onSelect: onSelect })=>onSelect ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
        variant: "ghost",
        // h-5 matches the row's tallest content (the text-sm description's line
        // box), so reserving a slot for the action doesn't make every row taller.
        // Only opacity toggles on hover — never presence — so running the cursor
        // down the list never reflows the rows either.
        className: "hidden h-5 w-6 shrink-0 rounded p-0 opacity-0 shadow-none focus-visible:opacity-100 group-hover:opacity-100 md:flex",
        title: `Record a balance dated ${date}`,
        "aria-label": `Record a balance dated ${date}`,
        // The row owns click (select) and long press (navigate); stop both here
        // so the action neither toggles the selection nor arms the press timer.
        onMouseDown: (e)=>e.stopPropagation(),
        onClick: (e)=>{
            e.stopPropagation();
            onSelect(date);
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acd0522bfe4ba3cd$export$2e2bcd8739ae039), {
            "aria-hidden": true,
            className: "text-muted-foreground size-3.5"
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "aria-hidden": true,
        className: "hidden h-5 w-6 shrink-0 md:block"
    });
const $e4870fadb257a2ad$export$ff3af39b0e278375 = ({ accountId: accountId, anchor: anchor, baseline: baseline, transactions: transactions, hasMoreTransactions: hasMoreTransactions, loadingMore: loadingMore, onLoadMore: onLoadMore, selectedIds: selectedIds, onSeedSelection: onSeedSelection, onReconciled: onReconciled, children: children })=>{
    const active = anchor != null && baseline != null;
    // Transactions arrive sorted newest-first, so the last one bounds the
    // loaded window; the span is covered once it reaches the baseline date.
    const oldestLoadedDate = transactions.length > 0 ? transactions[transactions.length - 1].date : null;
    const windowCovered = !active || !hasMoreTransactions || oldestLoadedDate != null && baseline != null && oldestLoadedDate <= baseline.date;
    // Auto-page until the period window is covered — the session needs the
    // full span before it can seed the selection or trust the sum. No-op while
    // idle so the reconcile list isn't force-paged without a session.
    $acw62.useEffect(()=>{
        if (!active || windowCovered || loadingMore || !onLoadMore) return;
        onLoadMore();
    }, [
        active,
        windowCovered,
        loadingMore,
        onLoadMore
    ]);
    // The hook is called unconditionally (it must be — hooks can't be gated),
    // but `baselineResolved: active` keeps it from seeding or paging while idle,
    // and its result is only surfaced through context when a session runs.
    const session = (0, $7ed8142efacaf742$export$b3652e185d28132b)({
        accountId: accountId,
        anchorId: anchor?._id ?? '',
        anchorDate: anchor?.date ?? '',
        anchorBalance: anchor?.balance ?? 0,
        baselineDate: baseline?.date ?? null,
        baselineBalance: baseline?.balance ?? 0,
        baselineResolved: active,
        transactions: transactions,
        windowCovered: windowCovered,
        loadingTransactions: loadingMore,
        selectedIds: selectedIds,
        onSeedSelection: onSeedSelection,
        onReconciled: onReconciled
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e4870fadb257a2ad$export$828e1aaff3f02d36.Provider, {
        value: active ? session : null,
        children: children
    });
};
const $e4870fadb257a2ad$export$c1d33472d727b085 = ({ anchor: anchor, onCancel: onCancel, onFixUp: onFixUp })=>{
    const session = $acw62.useContext($e4870fadb257a2ad$export$828e1aaff3f02d36);
    if (!session) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $833f55a7ff2d0d4a$export$2e2bcd8739ae039), {
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "text-sm font-medium whitespace-nowrap",
            children: [
                "Reconciling",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground ml-2 font-normal tabular-nums max-md:hidden",
                    children: (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(anchor.date)
                })
            ]
        }),
        // h-10 matches the idle header's icon buttons (size-5 glyph + p-2.5 =
        // 40px tall), so the row height is identical whether or not a session
        // is running.
        actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    className: "h-10 px-3 text-sm",
                    disabled: !session.canFixUp,
                    onClick: ()=>onFixUp(session.remaining),
                    title: "Create a transaction that offsets the remaining amount",
                    children: "Fix up"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    className: "h-10 px-3 text-sm",
                    disabled: session.submitting,
                    onClick: onCancel,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    className: "h-10 px-4 text-sm",
                    disabled: !session.canSubmit,
                    onClick: ()=>void session.submit(),
                    title: session.canSubmit ? `Reconcile against ${session.selectedTransactions.length} selected transaction${session.selectedTransactions.length === 1 ? '' : 's'}` : 'Adjust the selection until the expected balance matches',
                    children: "Reconcile"
                })
            ]
        })
    });
};
const $e4870fadb257a2ad$export$d0da5272f80239f2 = ({ anchor: anchor, baseline: baseline, currency: currency, isCreditCard: isCreditCard })=>{
    const session = $acw62.useContext($e4870fadb257a2ad$export$828e1aaff3f02d36);
    if (!session) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-background animate-in slide-in-from-bottom-2 fade-in border-t p-3 duration-200",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ea0ae3f3c1219da$export$32dc9018a66a99be), {
                baselineDate: baseline.date,
                baselineBalance: baseline.balance,
                recordedDate: anchor.date,
                needsStartingBalance: false,
                selectedSum: session.selectedSum,
                recordedBalance: anchor.balance,
                isBalanced: session.isBalanced,
                pending: session.summaryPending,
                isCreditCard: isCreditCard,
                currency: currency
            }),
            session.summaryPending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground mt-1.5 text-xs",
                children: "Loading all transactions in this period\u2026"
            }),
            session.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-destructive mt-1.5 text-right text-xs",
                children: session.error
            })
        ]
    });
};
/**
 * The claimed rows of an expanded reconciled anchor, fetched on demand. The
 * main list paginates unreconciled rows only, so a span's claimed history
 * isn't loaded until the user opens it — and then it's always the complete
 * set, never a page-bounded slice.
 */ const $e4870fadb257a2ad$var$ExpandedReconciliationRows = ({ anchorId: anchorId, onLongPress: onLongPress, renderAmount: renderAmount })=>{
    const { data: data, loading: loading, error: error } = (0, $ce9d9e524be20f53$export$61845bc4eb54f5b0)({
        variables: {
            anchorId: anchorId
        }
    });
    const rows = $acw62.useMemo(()=>{
        const claimed = data?.balanceAnchor?.reconciliation?.rawTransactions ?? [];
        return [
            ...claimed
        ].sort((a, b)=>b.date.localeCompare(a.date) || b._id.localeCompare(a._id));
    }, [
        data
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground not-last:border-border px-4 py-2 text-xs not-last:border-b",
        children: "Loading claimed transactions\u2026"
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-destructive not-last:border-border px-4 py-2 text-xs not-last:border-b",
        children: error.message
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: rows.map((transaction)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $767675606e144a8e$export$e044a1597fe6ccb0), {
                rawTransaction: transaction,
                onLongPress: ()=>onLongPress && onLongPress(transaction),
                reconciliationChecklist: true,
                compact: true,
                renderAmount: renderAmount,
                // A claimed row can never take an anchor (its date is inside a
                // reconciled span), but it still holds the empty slot so its amount
                // and date line up with the unclaimed rows above it.
                rowAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e4870fadb257a2ad$var$RecordBalanceRowAction, {
                    date: transaction.date
                })
            }, transaction._id))
    });
};
const $e4870fadb257a2ad$export$ca8ce1269aa19bdb = ({ isCreditCard: isCreditCard = false, currency: currencyProp, transactions: transactions, anchors: anchors, hasMoreTransactions: hasMoreTransactions, selectedIds: selectedIds = [], onClick: onClick, onLongPress: onLongPress, activeAnchorId: activeAnchorId = null, activeAnchor: activeAnchor = null, activeBaseline: activeBaseline = null, onStartReconcile: onStartReconcile, completedAnchorIds: completedAnchorIds, onCancelReconcile: onCancelReconcile, onFixUp: onFixUp, anchorsLoaded: anchorsLoaded = false, hasReadingBeforeAnchors: hasReadingBeforeAnchors = false, onAddStartingBalance: onAddStartingBalance, onRecordBalanceAt: onRecordBalanceAt, canRecordBalanceOn: canRecordBalanceOn, leavingIds: leavingIds })=>{
    const currency = currencyProp ?? transactions[0]?.currency ?? 'USD';
    const selectedIdSet = $acw62.useMemo(()=>new Set(selectedIds), [
        selectedIds
    ]);
    const leavingIdSet = $acw62.useMemo(()=>new Set(leavingIds ?? []), [
        leavingIds
    ]);
    const [expandedIds, setExpandedIds] = $acw62.useState(new Set());
    const toggleExpanded = (id)=>setExpandedIds((current)=>{
            const next = new Set(current);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    // Anchors sorted newest-first; each unreconciled anchor's baseline is
    // the nearest anchor below it, mirroring how the server resolves baselines.
    const sortedObservations = $acw62.useMemo(()=>[
            ...anchors
        ].sort((a, b)=>b.date.localeCompare(a.date)), [
        anchors
    ]);
    const baselineFor = $acw62.useMemo(()=>{
        const map = new Map();
        sortedObservations.forEach((observation, index)=>{
            map.set(observation._id, sortedObservations[index + 1]);
        });
        return map;
    }, [
        sortedObservations
    ]);
    // The session window, for marking boundary rows. Null when no session.
    const sessionWindow = activeAnchor && activeBaseline ? {
        baselineDate: activeBaseline.date,
        anchorDate: activeAnchor.date
    } : null;
    // Observations referenced as a reconciliation's baseline are labeled
    // neutrally (e.g. a starting balance); unreconciled ones can still be
    // reconciled to backfill their own earlier period.
    const baselineIds = $acw62.useMemo(()=>new Set(anchors.flatMap((a)=>a.reconciliation?.baselineAnchor ? [
                a.reconciliation.baselineAnchor._id
            ] : [])), [
        anchors
    ]);
    // Unreconciled transactions dated inside a reconciled span (baseline.date,
    // observation.date] were passed over by that reconciliation — flag them as
    // discrepancies, matching the server's needsReview span semantics. Rows
    // outside every span (including gaps before an unreconciled baseline that
    // no reconciliation has covered) simply haven't been reached and stay
    // quiet.
    const reconciledSpans = $acw62.useMemo(()=>{
        const spans = [];
        for (const a of anchors){
            // The span is stored on the reconciliation itself.
            if (!a.reconciliation) continue;
            spans.push({
                start: (0, $0c0f91b069db95d9$export$6b862160d295c8e)(a.reconciliation.startDate).toSeconds(),
                end: (0, $0c0f91b069db95d9$export$6b862160d295c8e)(a.reconciliation.endDate).toSeconds()
            });
        }
        return spans;
    }, [
        anchors
    ]);
    const isMissed = (seconds)=>reconciledSpans.some((span)=>seconds > span.start && seconds <= span.end);
    const items = $acw62.useMemo(()=>{
        const transactionItems = transactions.map((transaction)=>({
                kind: 'transaction',
                seconds: (0, $0c0f91b069db95d9$export$6b862160d295c8e)(transaction.date).toSeconds(),
                transaction: transaction
            }));
        // Transactions arrive sorted newest-first, so the last one bounds the
        // loaded window.
        const oldestLoaded = transactionItems.length > 0 ? transactionItems[transactionItems.length - 1].seconds : 0;
        const observationItems = sortedObservations.map((observation)=>({
                kind: 'observation',
                seconds: (0, $0c0f91b069db95d9$export$6b862160d295c8e)(observation.date).toSeconds(),
                observation: observation
            })).filter((item)=>!hasMoreTransactions || item.seconds >= oldestLoaded);
        // Descending by date; on ties the anchor sits above the transactions it
        // covers (a reconciliation includes its ending date).
        return [
            ...observationItems,
            ...transactionItems
        ].sort((a, b)=>b.seconds - a.seconds || (a.kind === b.kind ? 0 : a.kind === 'observation' ? -1 : 1));
    }, [
        transactions,
        sortedObservations,
        hasMoreTransactions
    ]);
    // In this tab, credit-card row amounts flip to "amount owed" space
    // (charges positive), matching the anchor balances and the session math so
    // the timeline reads like a statement. Rendered plain — the green
    // income-coloring of the cash-flow convention would invert meaning here.
    const renderOwedAmount = isCreditCard ? (rt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
            amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt((0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(rt.amount, true), rt.currency),
            variant: "plain"
        }) : undefined;
    // Rows arrive newest-first, so the last one is the earliest loaded
    // transaction. Once the whole timeline is loaded and no observation predates
    // it, the earliest period has no baseline to reconcile against — offer to
    // seed a starting balance dated the day before, which bootstraps an old
    // account into a reconcilable state.
    const oldestTransaction = transactions.length > 0 ? transactions[transactions.length - 1] : null;
    const hasEarlierObservation = oldestTransaction != null && anchors.some((anchor)=>anchor.date < oldestTransaction.date);
    const canAddStartingBalance = anchorsLoaded && !hasMoreTransactions && oldestTransaction != null && !hasEarlierObservation && onAddStartingBalance != null;
    // The account's earliest anchor is its starting balance once nothing is
    // dated on or before it — the exact complement of the bootstrap affordance
    // above, so a timeline shows one or the other and never both. Note "on or
    // before": a row sharing the anchor's own day can never be reconciled from
    // here (a span covers (baseline.date, ending.date]), so that anchor still
    // wants an earlier baseline. The server draws the same boundary, so this
    // tab and the Overview chart can't disagree about the same anchor.
    //
    // It takes the whole list being loaded to know: while older rows remain
    // unfetched, an earlier transaction may still turn up, and the anchor is
    // genuinely short a baseline until then. (Rows before the earliest anchor
    // can only be unreconciled — a reconciled one would sit inside a span whose
    // baseline is earlier still — so the paginated unreconciled list is enough
    // to decide.)
    const earliestAnchor = sortedObservations.length > 0 ? sortedObservations[sortedObservations.length - 1] : null;
    const startingBalanceId = earliestAnchor != null && !hasMoreTransactions && !hasReadingBeforeAnchors && (oldestTransaction == null || earliestAnchor.date < oldestTransaction.date) ? earliestAnchor._id : null;
    const body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            items.map((item)=>{
                if (item.kind === 'observation') {
                    const { observation: observation } = item;
                    const reconciled = Boolean(observation.reconciliation);
                    const isBaseline = baselineIds.has(observation._id);
                    const baseline = baselineFor.get(observation._id);
                    // An unreconciled baseline can itself be reconciled later
                    // (backfilling an earlier period without disturbing the span that
                    // references it) — but only when an earlier anchor exists; a true
                    // starting balance stays quiet instead of asking for a baseline it
                    // will never have.
                    const reconcilable = !reconciled && (!isBaseline || baseline !== undefined);
                    const expanded = expandedIds.has(observation._id);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e4870fadb257a2ad$var$ObservationRow, {
                                observation: observation,
                                isBaseline: isBaseline,
                                isStartingBalance: observation._id === startingBalanceId,
                                currency: currency,
                                isCreditCard: isCreditCard,
                                expanded: expanded,
                                onToggle: reconciled ? ()=>toggleExpanded(observation._id) : undefined,
                                needed: baseline ? observation.balance - baseline.balance : undefined,
                                sessionActive: observation._id === activeAnchorId,
                                onStartReconcile: reconcilable && baseline && onStartReconcile && !completedAnchorIds?.has(observation._id) ? ()=>onStartReconcile(observation._id) : undefined,
                                onCancelReconcile: onCancelReconcile,
                                onFixUp: onFixUp
                            }),
                            reconciled && expanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e4870fadb257a2ad$var$ExpandedReconciliationRows, {
                                anchorId: observation._id,
                                onLongPress: onLongPress,
                                renderAmount: renderOwedAmount
                            })
                        ]
                    }, `observation-${observation._id}`);
                }
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $767675606e144a8e$export$e044a1597fe6ccb0), {
                    rawTransaction: item.transaction,
                    selected: selectedIdSet.has(item.transaction._id),
                    onClick: onClick ? ()=>onClick(item.transaction) : undefined,
                    onLongPress: ()=>onLongPress && onLongPress(item.transaction),
                    reconciliationChecklist: true,
                    compact: true,
                    // A leaving row was just claimed, so it can never be a
                    // discrepancy — but for the length of the exit it looks like one
                    // from the outside: the anchor refetch lands the new span while
                    // the row is still cached with reconciliation == null, which is
                    // exactly the shape isMissed reports on. Without this the success
                    // animation flashes a red "missed by reconciliation" mark on the
                    // rows the reconciliation just succeeded in claiming.
                    missedReconciliation: !item.transaction.reconciliation && !leavingIdSet.has(item.transaction._id) && isMissed(item.seconds),
                    outsidePeriod: sessionWindow != null && !item.transaction.reconciliation && !(0, $7ed8142efacaf742$export$cbf38a927edf6508)(sessionWindow, item.transaction.date),
                    renderAmount: renderOwedAmount,
                    // Always a boolean, never undefined: max-height only animates from
                    // a resolved length, so a row that picks up its bounds in the same
                    // render that starts the exit would snap shut instead of
                    // collapsing. Every row in this list is armed from the start.
                    leaving: leavingIdSet.has(item.transaction._id),
                    rowAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e4870fadb257a2ad$var$RecordBalanceRowAction, {
                        date: item.transaction.date,
                        onSelect: activeAnchorId == null && canRecordBalanceOn?.(item.transaction.date) ? onRecordBalanceAt : undefined
                    })
                }, item.transaction._id);
            }),
            canAddStartingBalance && oldestTransaction && onAddStartingBalance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-muted/30 flex items-center gap-x-5 px-4 py-3 text-xs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "w-4 shrink-0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground",
                        children: [
                            "No balance recorded before",
                            ' ',
                            (0, $895eaf5059a11fbb$export$6f25eb35eacda85b)(oldestTransaction.date),
                            " \u2014 the earliest transactions have no baseline to reconcile against."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        className: "ml-auto h-7 shrink-0 rounded px-2.5 py-0 text-xs",
                        onClick: ()=>onAddStartingBalance((0, $0c0f91b069db95d9$export$6b862160d295c8e)(oldestTransaction.date).minus({
                                days: 1
                            })),
                        title: "Record a starting balance dated the day before the earliest transaction",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                className: "mr-1 size-3.5"
                            }),
                            "Add starting balance"
                        ]
                    })
                ]
            })
        ]
    });
    // The owner mounts the provider around this timeline (plus the session's top
    // action bar and the summary footer, which read the session from context).
    return body;
};




/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $357b00fa120a5c4e$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "5",
            x: "2",
            y: "3",
            rx: "1",
            key: "1wp1u1"
        }
    ],
    [
        "path",
        {
            d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8",
            key: "1s80jp"
        }
    ],
    [
        "path",
        {
            d: "M10 12h4",
            key: "a56b0p"
        }
    ]
];
const $357b00fa120a5c4e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("archive", $357b00fa120a5c4e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b33d9013e1e2b0b6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ]
];
const $b33d9013e1e2b0b6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pen", $b33d9013e1e2b0b6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $adb270212de20834$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
            key: "1oefj6"
        }
    ],
    [
        "path",
        {
            d: "M14 2v5a1 1 0 0 0 1 1h5",
            key: "wfsgrz"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
];
const $adb270212de20834$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file-text", $adb270212de20834$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $892eb034c4372097$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
            key: "fm4g5t"
        }
    ],
    [
        "path",
        {
            d: "M2 13h10",
            key: "pgb2dq"
        }
    ],
    [
        "path",
        {
            d: "m9 16 3-3-3-3",
            key: "6m91ic"
        }
    ]
];
const $892eb034c4372097$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("folder-input", $892eb034c4372097$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $864b7a37d506b74d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 17H7A5 5 0 0 1 7 7h2",
            key: "8i5ue5"
        }
    ],
    [
        "path",
        {
            d: "M15 7h2a5 5 0 1 1 0 10h-2",
            key: "1b9ql8"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "16",
            y1: "12",
            y2: "12",
            key: "1jonct"
        }
    ]
];
const $864b7a37d506b74d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("link-2", $864b7a37d506b74d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $aac5623678b36f9d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 3h5v5",
            key: "1806ms"
        }
    ],
    [
        "path",
        {
            d: "M8 3H3v5",
            key: "15dfkv"
        }
    ],
    [
        "path",
        {
            d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3",
            key: "1qrqzj"
        }
    ],
    [
        "path",
        {
            d: "m15 9 6-6",
            key: "ko1vev"
        }
    ]
];
const $aac5623678b36f9d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("split", $aac5623678b36f9d$export$3efd853dbb351e94);


parcelRequire("acw62");





const $e809c44401bdca50$export$3e6527a98b3f5155 = ({ selectionState: selectionState, onUpdate: onUpdate, includeProcessed: includeProcessed = false, removeFullyConsumed: removeFullyConsumed = false, accountId: accountId })=>{
    const { selected: selected } = selectionState;
    const sums = (0, $eb9c0713007ac1dd$export$d51151e4f01b4b50)(selected);
    const selectedCount = selected.length;
    const hasSelected = selectedCount > 0;
    const singleSelected = selectedCount === 1;
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    // While any modal is up, the header's hotkeys (Escape included) stand down
    // and let the modal handle keys. Checked against the whole registry rather
    // than a curated list of the modals this header itself opens: the owning
    // page can open others over the same mounted header (e.g. the reconcile
    // tab's Record balance dialog), and a curated list drifts as modals are
    // added.
    const anyModalOpen = Object.values(modals).some((modal)=>modal.state.open);
    // A fully consumed row has nothing left to allocate: the modal would open
    // with a zero allocation it can never submit, and the server rejects
    // consuming a zero-remaining raw either way — so every selected row must
    // still carry a remainder. Matters on lists that show processed rows (the
    // account All view, the reconcile tab). A null remainingAmount reads as
    // fully unconsumed, the same reading the server takes.
    const canCreateTransaction = hasSelected && selected.every((r)=>(r.remainingAmount ?? r.amount) !== 0);
    const openCreateTransactionModal = (options)=>{
        if (!canCreateTransaction) return;
        modals.createTransactionModal.openModal({
            onCreate: (data)=>handleCreate(data),
            transactions: selected,
            expandBenefit: options?.expandBenefit
        });
    };
    // A tap on an unallocated row: the create sheet for that row alone, with
    // the same list bookkeeping as creating from a selection.
    const openCreateForRow = (row)=>{
        modals.createTransactionModal.openModal({
            onCreate: (data)=>handleCreate(data, [
                    row
                ]),
            transactions: [
                row
            ]
        });
    };
    // Parking composes a new trackBalance account, an inverse raw transaction,
    // and a prepaid transfer — so the source must still have unconsumed amount
    // (null reads as fully unconsumed, the same reading the server takes), and
    // must be USD: createDepositoryAccount hardcodes the tracked account's
    // currency, and the modal permanently disables Create for a non-USD source.
    const canTrackCredit = singleSelected && (selected[0].remainingAmount ?? selected[0].amount) !== 0 && selected[0].currency === 'USD';
    const openDeleteRawTransactionModal = ()=>{
        if (selected.length === 0) return;
        modals.deleteRawTransactionModal.openModal({
            onDelete: handleDelete,
            rawTransactions: selected
        });
    };
    // The list shows processed rows (e.g. the account page's All view), so a
    // fully consumed row stays visible with a zero remainder instead of
    // disappearing; lists that exclude processed rows drop it instead.
    const keepsConsumedRows = includeProcessed && !removeFullyConsumed;
    const handleCreate = (data, // The rows the create consumed: the selection, unless a tap opened the
    // sheet on one row with nothing selected.
    rows = selected)=>{
        // A partially allocated raw transaction still has a remainder, so keep it
        // in the list (with its updated remainingAmount) instead of removing it.
        const updated = data.updatedRawTransactions ?? [];
        const keptIds = new Set(updated.map((r)=>r._id));
        const consumedIds = data.rawTransactionIds.filter((id)=>!keptIds.has(id));
        if (keepsConsumedRows) {
            const consumed = rows.filter((r)=>consumedIds.includes(r._id)).map((r)=>({
                    ...r,
                    remainingAmount: 0
                }));
            onUpdate({
                toReplace: [
                    ...updated,
                    ...consumed
                ]
            });
        } else onUpdate({
            toRemove: consumedIds,
            toReplace: updated
        });
        selectionState.clearSelection();
    };
    const handleRawSplit = (rawTransactions)=>{
        if (keepsConsumedRows) onUpdate({
            toReplace: rawTransactions.map((r)=>({
                    ...r,
                    remainingAmount: 0
                }))
        });
        else onUpdate({
            toRemove: rawTransactions.map((r)=>r._id)
        });
        selectionState.clearSelection();
    };
    const handleDelete = (deleted)=>{
        onUpdate({
            toRemove: deleted
        });
        selectionState.clearSelection();
    };
    const handleMoveUpdate = ()=>{
        // The moved rows leave the source account and join the destination; the
        // modal evicts both accounts' cached list pages so they refetch. Here we
        // only need to drop the now-stale selection.
        selectionState.clearSelection();
    };
    const handleAddTransaction = (newTransaction)=>{
        onUpdate({
            toAdd: [
                newTransaction
            ]
        });
    };
    const handleInverseCreated = (data)=>{
        // A combined inverse arrives fully consumed, so it only belongs on
        // lists that keep processed rows — inserting it into e.g. the review
        // list (which queries includeProcessed: false) would show a row the
        // next refetch takes away.
        if (data.consumedSourceIds == null || keepsConsumedRows) onUpdate({
            toAdd: [
                data.created
            ]
        });
        // Combined into a transfer: the sources are now fully consumed — same
        // list bookkeeping as creating a transaction from the selection.
        if (data.consumedSourceIds) handleCreate({
            rawTransactionIds: data.consumedSourceIds
        });
    };
    const handleImport = (imported)=>{
        onUpdate({
            toAdd: imported
        });
    };
    // Edit is a plain prefilled form for a single row, and the bulk modal for
    // larger selections — there each property must be explicitly activated to
    // apply ("set this field on all of these, touch nothing else"). Both gate
    // per property (synced rows lock date/description, transfers lock
    // payee/category, and so on), so there is nothing to pre-filter here.
    const canEdit = hasSelected;
    const handleEditSaved = (updated)=>{
        // In an account-scoped list a moved row leaves the list; otherwise patch
        // rows in place (date/description may have changed, which re-sorts).
        if (accountId) {
            const moved = updated.filter((r)=>r.account._id !== accountId);
            const stays = updated.filter((r)=>r.account._id === accountId);
            onUpdate({
                toRemove: moved.map((r)=>r._id),
                toReplace: stays
            });
        } else onUpdate({
            toReplace: updated
        });
        selectionState.clearSelection();
    };
    const handleEdit = ()=>{
        if (!canEdit) return;
        if (singleSelected) {
            modals.editRawTransactionModal.openModal({
                rawTransaction: selected[0],
                onUpdate: (updated)=>handleEditSaved([
                        updated
                    ])
            });
            return;
        }
        modals.bulkEditRawTransactionsModal.openModal({
            rawTransactions: selected,
            onSaved: handleEditSaved
        });
    };
    // The inverse offsets the selection's net, so the rows must share a
    // currency (sums holds one total per currency) and net to something — a
    // zero net is already balanced and has no inverse.
    const canCreateInverse = hasSelected && sums.length === 1 && selected.reduce((sum, r)=>sum + r.amount, 0) !== 0;
    const openInverseModal = ()=>{
        if (!canCreateInverse) return;
        modals.createInverseRawTransactionModal.openModal({
            rawTransactions: selected,
            onCreate: handleInverseCreated
        });
    };
    const openSplitRawTransactionModal = ()=>{
        if (!canSplitIntoTransactions) return;
        modals.splitRawTransactionModal.openModal({
            rawTransactions: selected,
            onSplit: handleRawSplit
        });
    };
    // Attaching consumes each raw in full, and the server rejects a raw that
    // already has consumptions — so every selected row must be untouched. A
    // transaction also holds one currency, so a mixed selection has no valid
    // target (the modal filters candidates to the selection's currency).
    const canAddToTransaction = hasSelected && sums.length === 1 && selected.every((r)=>(r.remainingAmount ?? r.amount) === r.amount);
    // Splitting works on one or more fresh raw transactions. With several
    // selected, each split consumes every raw proportionally, so they must share
    // a currency and their combined net must be non-zero (a zero net is a
    // transfer, and there is nothing to divide).
    const canSplitIntoTransactions = hasSelected && selected.reduce((sum, r)=>sum + r.amount, 0) !== 0 && selected.every((r)=>r.currency === selected[0].currency) && selected.every((r)=>r.amount !== 0) && // Splitting divides the whole row, so every selected row must still be
    // untouched. Null reads as fully unconsumed, same as canTrackCredit.
    selected.every((r)=>(r.remainingAmount ?? r.amount) === r.amount);
    // b is "categorize with a benefit": the create modal with its benefit
    // picker already expanded (the benefit rides the create as an attachment).
    // Mirrors the modal's attachment eligibility — one untouched USD raw (the
    // attachments record the raw at face value, so a partially consumed raw
    // can't take one; a single raw with a remainder is never balanced). For
    // any other selection the modal would ignore expandBenefit and open as a
    // plain create, so the benefit-specific shortcut stands down instead, as
    // it did before the flows merged.
    const canCreateWithBenefit = canCreateTransaction && singleSelected && selected[0].currency === 'USD' && (selected[0].remainingAmount ?? selected[0].amount) === selected[0].amount;
    // The selection's actions, grouped by what happens to the rows. Allocate:
    // the rows are consumed into a transaction and leave any unallocated/review
    // list — benefit links and fee periods ride Create transaction as
    // attachments in its Tags & Fields strip. Set up: a related record is
    // created (the counterpart leg of a transfer) but the rows stay put, still
    // awaiting allocation. Fix: the raw rows themselves are wrong — correct or
    // remove them.
    const selectionMenuItems = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8836009201f6d637$export$ef912b5a59ca772b), {
                children: "Allocate"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: ()=>openCreateTransactionModal(),
                disabled: !canCreateTransaction,
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $960851586a15b7fa$export$2e2bcd8739ae039), {}),
                children: "Create transaction"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: ()=>modals.addRawTransactionToPaymentModal.openModal({
                        rawTransactions: selected,
                        onAttached: (rawTransactionIds)=>{
                            if (keepsConsumedRows) onUpdate({
                                toReplace: selected.filter((r)=>rawTransactionIds.includes(r._id)).map((r)=>({
                                        ...r,
                                        remainingAmount: 0
                                    }))
                            });
                            else onUpdate({
                                toRemove: rawTransactionIds
                            });
                            selectionState.clearSelection();
                        }
                    }),
                disabled: !canAddToTransaction,
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $864b7a37d506b74d$export$2e2bcd8739ae039), {}),
                children: "Add to transaction"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: openSplitRawTransactionModal,
                disabled: !canSplitIntoTransactions,
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aac5623678b36f9d$export$2e2bcd8739ae039), {}),
                children: "Split"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: ()=>{
                    if (!canTrackCredit) return;
                    modals.trackCreditModal.openModal({
                        rawTransaction: selected[0],
                        onCreate: handleCreate
                    });
                },
                disabled: !canTrackCredit,
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357b00fa120a5c4e$export$2e2bcd8739ae039), {}),
                children: "Track as credit or loan"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8836009201f6d637$export$9905d75c11ef308b), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8836009201f6d637$export$ef912b5a59ca772b), {
                children: "Set up"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: openInverseModal,
                disabled: !canCreateInverse,
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e583651be68dae50$export$2e2bcd8739ae039), {}),
                children: "Create inverse"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8836009201f6d637$export$9905d75c11ef308b), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8836009201f6d637$export$ef912b5a59ca772b), {
                children: "Fix"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: ()=>{
                    if (!singleSelected) return;
                    const id = selected[0]._id;
                    selectionState.clearSelection();
                    navigate(`/raw-transactions/${id}`);
                },
                disabled: !singleSelected,
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {}),
                children: "Details"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: handleEdit,
                disabled: !canEdit,
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b33d9013e1e2b0b6$export$2e2bcd8739ae039), {}),
                children: "Edit"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: ()=>modals.updateRawTransactionsModal.openModal({
                        rawTransactions: selected,
                        onUpdate: handleMoveUpdate
                    }),
                disabled: !hasSelected,
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $892eb034c4372097$export$2e2bcd8739ae039), {}),
                children: "Move"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: openDeleteRawTransactionModal,
                disabled: !hasSelected,
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {}),
                children: "Delete"
            })
        ]
    });
    return {
        selected: selected,
        sums: sums,
        selectedCount: selectedCount,
        hasSelected: hasSelected,
        singleSelected: singleSelected,
        anyModalOpen: anyModalOpen,
        canCreateTransaction: canCreateTransaction,
        canCreateWithBenefit: canCreateWithBenefit,
        openCreateTransactionModal: openCreateTransactionModal,
        openCreateForRow: openCreateForRow,
        canEdit: canEdit,
        handleEdit: handleEdit,
        handleCreate: handleCreate,
        handleAddTransaction: handleAddTransaction,
        handleImport: handleImport,
        selectionMenuItems: selectionMenuItems
    };
};




parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

/**
 * Scroll offsets keyed by URL (pathname + search). Restoration only happens
 * on POP navigations (browser back/forward), so a fresh PUSH visit to a list
 * starts at the top — and clears any stale offset for that URL.
 *
 * Offsets are deliberately NOT keyed by `location.key`: some list views
 * normalize their filters into the URL on mount via `setSearchParams`, which
 * pushes a new history entry (new key) for the same URL and would orphan the
 * saved offset before it could be applied.
 *
 * The browser's native restoration only handles window scroll, which never
 * scrolls in this app's fixed-header layout, so the inner `overflow: auto`
 * container is tracked here instead.
 */ const $d572a5c00497591d$var$savedPositions = new Map();
// Bounds memory over a long session; oldest entries are dropped first.
const $d572a5c00497591d$var$MAX_SAVED_POSITIONS = 50;
const $d572a5c00497591d$export$c4ffdfe23dd48040 = (stateKey)=>{
    const ref = $acw62.useRef(null);
    const location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    const navigationType = (0, $926608a7a86d7371$export$1b3f31771c5d07c)();
    const key = location.pathname + location.search + (stateKey ? `|${stateKey}` : '');
    // Flips to true once the saved offset has been applied or invalidated.
    // Until then the restore effect below retries on every commit, because
    // list content typically renders several commits after mount.
    const done = $acw62.useRef(false);
    const lastLocationKey = $acw62.useRef(null);
    const lastKey = $acw62.useRef(null);
    // Decides, whenever the key changes, whether it has a pending restore.
    // A key change caused by a navigation (location.key changed with it)
    // restores on POP — covering both fresh mounts and filter URLs swapped in
    // place while the list stays mounted. A key change WITHOUT a navigation is
    // a state-held filter change: a new logical list that must not inherit
    // another state's offset. Deliberately depless rather than keyed on [key]:
    // the mount-time filter normalization described above pushes a new
    // location.key for the same URL, and must only update the navigation
    // marker — never cancel a pending restore.
    $acw62.useLayoutEffect(()=>{
        const navigated = location.key !== lastLocationKey.current;
        lastLocationKey.current = location.key;
        if (key === lastKey.current) return;
        lastKey.current = key;
        if (navigated && navigationType === (0, $6d23e34a443a4a03$export$e19cd5f9376f8cee).Pop && $d572a5c00497591d$var$savedPositions.has(key)) done.current = false;
        else {
            done.current = true;
            $d572a5c00497591d$var$savedPositions.delete(key);
        }
    });
    $acw62.useEffect(()=>{
        const el = ref.current;
        if (!el) return undefined;
        const handleScroll = ()=>{
            // Any scroll — user-initiated or the restore itself — becomes the
            // position of record. A user who starts scrolling before the data
            // finishes loading also cancels the pending restore, rather than
            // being yanked to the old position later.
            done.current = true;
            $d572a5c00497591d$var$savedPositions.delete(key);
            $d572a5c00497591d$var$savedPositions.set(key, el.scrollTop);
            if ($d572a5c00497591d$var$savedPositions.size > $d572a5c00497591d$var$MAX_SAVED_POSITIONS) {
                const oldest = $d572a5c00497591d$var$savedPositions.keys().next().value;
                if (oldest !== undefined) $d572a5c00497591d$var$savedPositions.delete(oldest);
            }
        };
        el.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return ()=>el.removeEventListener('scroll', handleScroll);
    }, [
        key
    ]);
    // No dependency array: content arrives asynchronously, so retry after
    // every commit until the container is tall enough to reach the offset.
    $acw62.useEffect(()=>{
        const el = ref.current;
        if (done.current || !el) return;
        const saved = $d572a5c00497591d$var$savedPositions.get(key);
        if (saved === undefined) {
            done.current = true;
            return;
        }
        if (el.scrollHeight - el.clientHeight >= saved) {
            done.current = true;
            el.scrollTop = saved;
        }
    });
    return ref;
};


const $82dd4a85a022dc3b$export$235db9c6287af77c = ({ header: header, body: body, footer: footer, className: className, scrollStateKey: scrollStateKey })=>{
    const scrollRef = (0, $d572a5c00497591d$export$c4ffdfe23dd48040)(scrollStateKey);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex min-h-0 flex-1 flex-col overflow-hidden', className),
        children: [
            header,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: scrollRef,
                className: "block min-h-0 flex-1 overflow-auto",
                children: body
            }),
            footer
        ]
    });
};





var $acw62 = parcelRequire("acw62");
const $026af87cc9705d5d$export$6d82c2edda5ea5bd = (allItems, initial)=>{
    const [selectedItems, setSelectedItems] = $acw62.useState(initial || []);
    const [lastSelected, setLastSelected] = $acw62.useState(null);
    const setSelectionToSet = (set)=>setSelectedItems([
            ...set.values()
        ]);
    const setSelected = (t)=>(isSelected)=>{
            setLastSelected(t);
            if (isSelected) // Selecting what's already selected (a second long press) is a no-op,
            // never a duplicate: the count, the total, and a create would all
            // double it.
            {
                if (!selectedItems.includes(t)) setSelectedItems([
                    ...selectedItems,
                    t
                ]);
            } else setSelectedItems(selectedItems.filter((s)=>s !== t));
        };
    const setShiftSelected = (t)=>{
        const itemSet = new Set(selectedItems);
        if (lastSelected !== null) {
            const startIndex = allItems.indexOf(lastSelected);
            const endIndex = allItems.indexOf(t);
            if (startIndex !== -1 && endIndex !== -1) {
                (0, $3c773088597ab155$export$2e2bcd8739ae039).range(startIndex, endIndex).forEach((i)=>{
                    itemSet.add(allItems[i]);
                });
                itemSet.add(allItems[startIndex]);
                itemSet.add(allItems[endIndex]);
            } else itemSet.add(t);
        } else itemSet.add(t);
        setSelectionToSet(itemSet);
    };
    const setSelection = (t)=>{
        setLastSelected(null);
        setSelectedItems(t);
    };
    const clearSelection = ()=>{
        setLastSelected(null);
        setSelectedItems([]);
    };
    return {
        allItems: allItems,
        selected: selectedItems,
        setSelected: setSelected,
        setShiftSelected: setShiftSelected,
        setSelection: setSelection,
        clearSelection: clearSelection
    };
};


const $dbd7c92ba7262ba3$var$EMPTY_DATE_FILTER = {
    startDate: null,
    endDate: null
};
// Must match the duration of RawTransactionRow's leaving transition — the row
// is unmounted (via the cache update) when this elapses, so a shorter value
// would clip the animation and a longer one would leave a gap of collapsed
// rows sitting at zero height.
const $dbd7c92ba7262ba3$var$ROW_EXIT_MS = 200;
const $dbd7c92ba7262ba3$var$RawTransactionView = (props)=>{
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const params = (0, $926608a7a86d7371$export$99eaa27ddbbb95ef)();
    const { recordBalanceAnchorModal: recordBalanceAnchorModal, createRawTransactionModal: createRawTransactionModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    // Skip when embedded in AccountTransactionsView; the AccountDetail layout
    // route owns the crumb there.
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)(params.id ? null : {
        label: 'Unreconciled',
        reset: true
    });
    // Reconcile is a separate workflow (its own account tab), pinned to the
    // complete unfiltered row set. Browse mode carries the allocation, date, and
    // search filters.
    const isReconcile = props.mode === 'reconcile';
    // Browse filters live in the URL query string so they survive navigation:
    // opening a transaction and hitting back returns to the same filtered list.
    // Because the query string is path-scoped (each account's Transactions tab is
    // its own URL), navigating to another account starts from the default
    // (unfiltered) view without any per-account bookkeeping. Reconcile mode has
    // its own route and ignores these entirely (see activeDateFilter below).
    const [searchParams, setParams] = (0, $80f2d9c5153b63bf$export$6ccd138e4a7ead58)();
    const allocationFilter = (0, $25d6b5adca90bb97$export$72b1d89afdb38499)(searchParams.get('allocation'));
    const dateFilter = {
        startDate: searchParams.get('startDate'),
        endDate: searchParams.get('endDate')
    };
    const search = searchParams.get('search') ?? '';
    // Date and search narrowing are excluded from Reconcile: anchors and their
    // deltas are account-wide, and a gap in the timeline is only visible on the
    // full, unfiltered row set.
    const activeDateFilter = isReconcile ? $dbd7c92ba7262ba3$var$EMPTY_DATE_FILTER : dateFilter;
    const activeSearch = isReconcile ? '' : search;
    // The browse filters currently narrowing the list, so Reset can clear them
    // in one history entry and the control can hide when there is nothing to
    // clear. Empty in reconcile mode, which ignores these entirely.
    const activeFilterKeys = isReconcile ? [] : [
        allocationFilter !== 'all' ? 'allocation' : null,
        dateFilter.startDate != null ? 'startDate' : null,
        dateFilter.endDate != null ? 'endDate' : null,
        search !== '' ? 'search' : null
    ].filter((key)=>key != null);
    const resetFilters = ()=>{
        setParams(Object.fromEntries(activeFilterKeys.map((key)=>[
                key,
                null
            ])));
    };
    const filters = {
        includeProcessed: props.includeProcessed,
        accountId: params.id,
        // The allocation filter narrows server-side (Unallocated is a to-do
        // queue). The Reconcile view paginates unreconciled rows only: claimed
        // history is summarized by its anchor rows and loads lazily on expansion,
        // so pages aren't consumed by rows hidden inside collapsed spans.
        // Unreconciled rows are exactly the interesting ones — gaps and stragglers
        // surface within the first pages instead of behind a span's worth of
        // clicks.
        allocated: isReconcile ? undefined : allocationFilter === 'allocated' ? true : allocationFilter === 'unallocated' ? false : undefined,
        reconciled: isReconcile ? false : undefined,
        startDate: activeDateFilter.startDate,
        endDate: activeDateFilter.endDate,
        search: activeSearch || undefined,
        // Unreconciled rows are sparse (a page can span years of reconciled
        // history), so the reconcile view fetches bigger pages.
        limit: isReconcile ? 50 : 10
    };
    // The Reconcile view interleaves balance anchors into the timeline —
    // reconciled anchors plus manual/statement balances awaiting
    // reconciliation (Plaid sync readings live in their own collection and
    // never appear here).
    const { data: anchorsData, loading: anchorsLoading, refetch: refetchAnchors } = (0, $ce9d9e524be20f53$export$4b244df86d92b624)({
        variables: {
            accountId: params.id ?? ''
        },
        skip: !params.id || !isReconcile
    });
    const anchors = anchorsData?.balanceAnchors ?? [];
    // The "add starting balance" affordance keys off the absence of an earlier
    // observation, so it must not fire while the anchors are still loading: an
    // empty-because-pending list would offer to bootstrap an account that
    // already has a baseline, and saving would create a nearer anchor that
    // shifts the server's baseline selection for later reconciliations.
    const anchorsLoaded = anchorsData !== undefined && !anchorsLoading;
    // The reconcile session lives here (above the ScrollTable) so its footer
    // action bar can render outside the scroll area, pinned below the list. The
    // active anchor and its baseline (the nearest earlier anchor) drive the
    // summary card and row highlighting inside the timeline.
    const [activeAnchorId, setActiveAnchorId] = $acw62.useState(null);
    // Anchors whose reconciliation succeeded but which the loaded data still
    // shows as unreconciled. They must not offer to start again in that window:
    // the server rejects a second reconciliation of the same anchor.
    const [completedAnchorIds, setCompletedAnchorIds] = $acw62.useState(()=>new Set());
    // Released by what the data says, not by a refetch resolving. Which response
    // won is not knowable from here — refetches can land out of order, and a
    // stale one can overwrite a newer anchor's reconciliation with null — so an
    // event-based release can free an anchor the data still shows unreconciled.
    // Reading the condition straight off `anchors` cannot disagree with what the
    // row renders, and it fails closed for free: a refetch that never lands
    // leaves the anchor locked, which is the truthful state of it.
    $acw62.useEffect(()=>{
        if (completedAnchorIds.size === 0) return;
        const stillLocked = [
            ...completedAnchorIds
        ].filter((id)=>!anchors.some((a)=>a._id === id && a.reconciliation != null));
        if (stillLocked.length !== completedAnchorIds.size) setCompletedAnchorIds(new Set(stillLocked));
    }, [
        anchors,
        completedAnchorIds
    ]);
    const sortedAnchors = $acw62.useMemo(()=>[
            ...anchors
        ].sort((a, b)=>b.date.localeCompare(a.date)), [
        anchors
    ]);
    const activeAnchorIndex = sortedAnchors.findIndex((a)=>a._id === activeAnchorId);
    const activeAnchor = activeAnchorIndex >= 0 ? sortedAnchors[activeAnchorIndex] : null;
    const activeBaseline = activeAnchor != null ? sortedAnchors[activeAnchorIndex + 1] ?? null : null;
    // A session runs only when the active anchor has a baseline to reconcile
    // against; while it does, the account's normal action bar is hidden.
    const reconcileSessionActive = activeAnchor != null && activeBaseline != null;
    // Anchor balances follow the credit-card display convention
    // (toDisplayBalance), so the timeline needs the account type. The account
    // detail layout has already fetched this account, so this resolves from
    // the cache.
    const { data: accountData, refetch: refetchAccount } = (0, $ce9d9e524be20f53$export$83a5bf0e4425c554)({
        variables: {
            id: params.id ?? ''
        },
        skip: !params.id || !isReconcile
    });
    const account = accountData?.account;
    const isCreditCard = account?.__typename === 'DepositoryAccount' && account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard;
    const accountCurrency = account && 'currency' in account ? account.currency : undefined;
    // Whether a synced Plaid reading predates the earliest anchor. Readings are
    // not reconcilable and never appear in this timeline, but they are attested
    // balances the Overview chart draws — so an anchor with one below it is not
    // where the account's history starts, and must not be labeled as if it were
    // (the chart, which sees both collections, agrees). Readings are written
    // only by sync, so a non-Plaid account can't have any and the query is
    // skipped; `limit: 1` because this only ever asks whether one exists.
    const earliestAnchorDate = sortedAnchors.length > 0 ? sortedAnchors[sortedAnchors.length - 1].date : null;
    const isPlaidLinked = account?.__typename === 'DepositoryAccount' && account.plaid != null;
    const { data: earlierReadingsData } = (0, $ce9d9e524be20f53$export$a3b544ccb0f6d05)({
        variables: {
            accountId: params.id ?? '',
            before: earliestAnchorDate ?? '',
            limit: 1
        },
        skip: !params.id || !isReconcile || !isPlaidLinked || earliestAnchorDate == null
    });
    // Unresolved counts as "yes" — the row must not claim to be the starting
    // balance and then take it back once the answer lands.
    const hasReadingBeforeAnchors = isPlaidLinked && earliestAnchorDate != null && (earlierReadingsData === undefined || earlierReadingsData.balanceReadings.length > 0);
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const [loadRawTransactions, { loading: loading, error: error, data: data, fetchMore: fetchMore }] = (0, $ce9d9e524be20f53$export$d1531303a4748421)({
        notifyOnNetworkStatusChange: true
    });
    const handleUpdateRawTransactions = (0, $2f8143a39a28ff19$export$2e2bcd8739ae039)({
        client: client,
        filters: filters
    });
    const all = data?.allRawTransactions?.items ?? [];
    const selectionState = (0, $026af87cc9705d5d$export$6d82c2edda5ea5bd)(all, []);
    const { selected: selected, setSelected: setSelected, setSelection: setSelection, clearSelection: clearSelection } = selectionState;
    // The reconcile session auto-pages via an effect, which can re-fire while a
    // fetch is still settling — the cursor guard keeps a repeated call from
    // appending the same page twice (mirrors ReconcileAnchorModal's guard).
    const lastRequestedCursor = $acw62.useRef(null);
    const handleReload = ()=>{
        clearSelection();
        // Navigating to another account (or changing filters) ends any session,
        // and retires any completed-but-unrefreshed anchor with it — the list it
        // belonged to is gone.
        setActiveAnchorId(null);
        setCompletedAnchorIds(new Set());
        // A fresh base query invalidates the pagination guard — the old cursor
        // belongs to the previous list.
        lastRequestedCursor.current = null;
        loadRawTransactions({
            variables: filters
        });
    };
    $acw62.useEffect(handleReload, [
        props.includeProcessed,
        params.id,
        allocationFilter,
        activeDateFilter.startDate,
        activeDateFilter.endDate,
        activeSearch
    ]);
    const hasMore = data?.allRawTransactions?.hasMore ?? false;
    // Page from the query's own endCursor, not the last visible row: cache
    // updates can remove rows (reconciling claims them), and if every loaded
    // row is removed while hasMore is true, an item-derived cursor no longer
    // exists — but endCursor survives removals and always marks the true
    // fetch frontier.
    const endCursor = data?.allRawTransactions?.endCursor ?? null;
    const handleMore = ()=>{
        if (fetchMore && hasMore && endCursor) {
            if (loading || lastRequestedCursor.current === endCursor) return;
            lastRequestedCursor.current = endCursor;
            fetchMore({
                variables: {
                    ...filters,
                    beforeCursor: endCursor
                },
                updateQuery: (previous, result)=>{
                    // Reconciling removes rows from the cached list; if the removed
                    // tail included the cursor row, the next page can overlap rows
                    // already loaded — dedupe by id instead of blindly appending.
                    const existingIds = new Set((previous.allRawTransactions?.items ?? []).map((rt)=>rt._id));
                    const moreItems = (result.fetchMoreResult?.allRawTransactions?.items ?? []).filter((rt)=>!existingIds.has(rt._id));
                    return {
                        ...previous,
                        allRawTransactions: {
                            ...previous.allRawTransactions,
                            items: [
                                ...previous.allRawTransactions?.items ?? [],
                                ...moreItems
                            ],
                            endCursor: result.fetchMoreResult?.allRawTransactions?.endCursor ?? null,
                            hasMore: result.fetchMoreResult?.allRawTransactions?.hasMore ?? false
                        }
                    };
                }
            }).catch(()=>{
                // A transient failure must not pin the guard forever — clear it so
                // the More button and session auto-paging can retry this page.
                lastRequestedCursor.current = null;
            });
        }
    };
    const selectedIds = $acw62.useMemo(()=>selected.map((transaction)=>transaction._id), [
        selected
    ]);
    const toggleRow = (transaction)=>{
        const isSelected = selectedIds.includes(transaction._id);
        setSelected(transaction)(!isSelected);
    };
    const selectionActions = (0, $e809c44401bdca50$export$3e6527a98b3f5155)({
        selectionState: selectionState,
        onUpdate: handleUpdateRawTransactions,
        includeProcessed: props.includeProcessed,
        removeFullyConsumed: allocationFilter === 'unallocated',
        accountId: params.id
    });
    // Browsing shares every activity list's gestures; the reconcile tab keeps
    // tap-to-select, since picking rows is how a reconciliation is built.
    const gestures = (0, $28bb13ba9d3f9376$export$9227a5765cfbd955)({
        selectionState: selectionState,
        openCreate: selectionActions.openCreateForRow
    });
    const endSession = ()=>{
        setActiveAnchorId(null);
        clearSelection();
    };
    // Rows a reconciliation just claimed, held in the list while they collapse
    // and fade out before the cache update removes them for real. Kept here
    // rather than in the timeline because the cache update is the owner's, and
    // the two have to stay in step: dropping the rows early would cut the
    // animation short, dropping them late would leave claimed rows in a list
    // that queries reconciled: false.
    const [leavingIds, setLeavingIds] = $acw62.useState([]);
    // The updater is carried with the pending removal rather than read at flush
    // time: it writes to the cache entry keyed by the filters in effect when the
    // reconcile happened, and those can change (switching accounts) before the
    // timer fires. Both paths out of here must target that same entry.
    const pendingRemoval = $acw62.useRef(null);
    // Run the pending cache removal now instead of on the timer. The animation
    // is presentation; the cache update is the actual consequence of
    // reconciling, so it must survive anything that cuts the animation short.
    // Skipping it would leave claimed rows in a cache-first `reconciled: false`
    // page that nothing is guaranteed to refetch — they would come back looking
    // unreconciled on the next visit to the tab.
    const flushRowRemoval = ()=>{
        const pending = pendingRemoval.current;
        if (!pending) return;
        window.clearTimeout(pending.timer);
        pendingRemoval.current = null;
        pending.update({
            toRemove: pending.claimedIds
        });
    };
    // Unmounting mid-animation (navigating away) is the common way to cut it
    // short. No setLeavingIds here — the component is going away, and the cache
    // is the only thing that outlives it.
    $acw62.useEffect(()=>()=>flushRowRemoval(), []);
    const scheduleRowRemoval = (claimedIds)=>{
        // A second reconcile landing inside the window is the other way to cut it
        // short: settle the first batch rather than dropping it on the floor.
        flushRowRemoval();
        const update = handleUpdateRawTransactions;
        pendingRemoval.current = {
            claimedIds: claimedIds,
            update: update,
            timer: window.setTimeout(()=>{
                pendingRemoval.current = null;
                update({
                    toRemove: claimedIds
                });
                setLeavingIds([]);
            }, $dbd7c92ba7262ba3$var$ROW_EXIT_MS)
        };
    };
    // "Fix up" opens the create-transaction modal prefilled to exactly offset the
    // remaining amount (dated the recorded anchor, with a templated description),
    // then adds the created row to the list and selects it so the session lands
    // balanced and ready to reconcile. Keeping create and reconcile as separate
    // steps (rather than one server call) means a failed create never leaves a
    // stray reconciliation behind — the user just sees the modal error.
    const openFixUpModal = (remainingCents)=>{
        if (!activeAnchor || accountCurrency == null) return;
        createRawTransactionModal.openModal({
            defaultAccountId: params.id,
            defaultAmount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(remainingCents, accountCurrency),
            defaultDate: (0, $0c0f91b069db95d9$export$6b862160d295c8e)(activeAnchor.date),
            defaultDescription: (0, $7ed8142efacaf742$export$8df98906c402b688)(activeAnchor.date),
            // Stamps the row as an adjustment for this anchor and (with the
            // reconciliationCategory binding set) consumes it on creation — see
            // CreateRawTransactionModal's adjustment mode.
            adjustmentForAnchorId: activeAnchor._id,
            onCreate: (newTransaction)=>{
                handleUpdateRawTransactions({
                    toAdd: [
                        newTransaction
                    ]
                });
                setSelected(newTransaction)(true);
            }
        });
    };
    const transactions = data?.allRawTransactions?.items;
    const handleLongPress = $acw62.useCallback((rt)=>{
        navigate(`/raw-transactions/${rt._id}`);
    }, [
        navigate
    ]);
    // Recording a balance almost always means "as of this row" — reconciling a
    // sparse account is mostly dropping zero anchors at the points where the
    // balance is known. Both entry points (the row hover action and the header
    // button below) prefill the modal's date from a transaction rather than
    // defaulting to today, so the date never has to be typed.
    const openRecordBalance = $acw62.useCallback((date)=>{
        recordBalanceAnchorModal.openModal({
            accountId: params.id ?? '',
            currency: account?.currency,
            isCreditCard: isCreditCard,
            initialDate: date ? (0, $0c0f91b069db95d9$export$6b862160d295c8e)(date) : undefined,
            onSuccess: ()=>{
                refetchAnchors();
                // Recording the newest anchor updates Account.balance server-side.
                refetchAccount();
            }
        });
    }, // account?.currency: the account query resolves after first render, and
    // a callback captured with `currency: undefined` would open a foreign
    // wallet's anchor modal in USD units.
    [
        params.id,
        isCreditCard,
        account?.currency
    ]);
    // Only prefill dates that can actually take a NEW anchor — the prefill is a
    // shortcut for creating one, and every other case leads somewhere the user
    // didn't ask to go:
    //
    //  - A date that already has an anchor is an edit, not a creation:
    //    recordBalanceAnchor upserts by (account, date), and the modal always
    //    submits source 'manual', so saving would quietly reclassify a statement
    //    anchor and overwrite its balance. That anchor also already renders as
    //    its own row here, so there is nothing to prefill toward.
    //  - A date strictly inside a reconciled span is rejected outright by
    //    assertNotInsideReconciledSpan, so prefilling it only leads to an error
    //    modal. Bounds are exclusive, matching isInsideReconciledSpan — a
    //    boundary date is an existing anchor and caught by the rule above.
    //
    // Gated on anchorsLoaded because "no anchor on this date" is unknowable
    // until the anchors arrive: an empty-because-pending list would call every
    // date free, and a prefilled Save during that window would upsert over a
    // real balance. Same reasoning as the starting-balance affordance above.
    const canRecordBalanceOn = $acw62.useCallback((date)=>{
        if (!anchorsLoaded) return false;
        if (anchors.some((anchor)=>anchor.date === date)) return false;
        return !anchors.some((anchor)=>anchor.reconciliation != null && anchor.reconciliation.startDate < date && date < anchor.reconciliation.endDate);
    }, [
        anchors,
        anchorsLoaded
    ]);
    // Touch has no hover, so the row action is desktop-only; on mobile the same
    // prefill comes from the selection the user already makes by tapping a row.
    // Exactly one selected row names an unambiguous date — with several selected
    // there is no single answer, so the button falls back to today.
    const selectedDate = selected.length === 1 && canRecordBalanceOn(selected[0].date) ? selected[0].date : undefined;
    // Reconcile-tab actions, kept on the same row as the sync/overflow icons.
    // Record balance seeds an anchor; Add transaction is retained here because
    // reconciling often surfaces a bank row that was never imported, and adding
    // it in place lets the period balance without leaving the flow.
    const reconcileActions = params.id && isReconcile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                className: "h-9 px-3 text-sm",
                title: selectedDate ? `Record a balance dated ${selectedDate}` : 'Record a balance',
                onClick: ()=>openRecordBalance(selectedDate),
                children: [
                    "Record balance",
                    selectedDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground ml-1.5 font-normal tabular-nums max-sm:hidden",
                        children: selectedDate
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "ghost",
                size: "icon",
                title: "Add transaction",
                onClick: ()=>createRawTransactionModal.openModal({
                        defaultAccountId: params.id,
                        onCreate: (newTransaction)=>handleUpdateRawTransactions({
                                toAdd: [
                                    newTransaction
                                ]
                            })
                    }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                    className: "size-5"
                })
            })
        ]
    }) : null;
    let bodyContent;
    if (transactions) {
        // Each workflow view surfaces only its own status dimension: the
        // Reconcile view is a timeline of checklist rows and balance anchors,
        // while browse mode shows only allocation exceptions. The timeline
        // renders whenever either side has content — anchors must stay visible
        // (and reconcilable, e.g. a zero-transaction reconcile of an unchanged
        // balance) even when no raw transactions are loaded.
        if (isReconcile && (transactions.length > 0 || anchors.length > 0)) bodyContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4870fadb257a2ad$export$ca8ce1269aa19bdb), {
            isCreditCard: isCreditCard,
            currency: accountCurrency,
            transactions: transactions,
            anchors: anchors,
            hasMoreTransactions: data?.allRawTransactions?.hasMore ?? false,
            selectedIds: selectedIds,
            onClick: toggleRow,
            onLongPress: handleLongPress,
            activeAnchorId: activeAnchorId,
            activeAnchor: activeAnchor,
            activeBaseline: activeBaseline,
            onStartReconcile: setActiveAnchorId,
            completedAnchorIds: completedAnchorIds,
            onCancelReconcile: endSession,
            onFixUp: openFixUpModal,
            anchorsLoaded: anchorsLoaded,
            hasReadingBeforeAnchors: hasReadingBeforeAnchors,
            onAddStartingBalance: (initialDate)=>recordBalanceAnchorModal.openModal({
                    accountId: params.id ?? '',
                    currency: account?.currency,
                    isCreditCard: isCreditCard,
                    initialDate: initialDate,
                    onSuccess: ()=>{
                        refetchAnchors();
                        // Recording the earliest anchor can update Account.balance
                        // server-side when it becomes the newest reading.
                        refetchAccount();
                    }
                }),
            onRecordBalanceAt: openRecordBalance,
            canRecordBalanceOn: canRecordBalanceOn,
            leavingIds: leavingIds
        }, params.id ?? 'all');
        else if (!isReconcile && transactions.length > 0) bodyContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e054dd754d7f7b3$export$2e2bcd8739ae039), {
            transactions: transactions,
            ...gestures.rowProps,
            showProcessedStatus: props.includeProcessed
        });
        else bodyContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
            children: allocationFilter === 'unallocated' ? 'Everything is allocated' : 'No transactions'
        });
    } else if (error) bodyContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "error"
    });
    else bodyContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
        size: "medium"
    });
    // While a session runs the top bar swaps from the account header to the
    // session's own action bar (Fix up / Cancel / Reconcile). Both are built on
    // ActionHeader, so the row keeps the same height — starting a session no
    // longer shifts the list down.
    const header = isReconcile && reconcileSessionActive && activeAnchor ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4870fadb257a2ad$export$c1d33472d727b085), {
        anchor: activeAnchor,
        onCancel: endSession,
        onFixUp: openFixUpModal
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5789cc019e3b9369$export$8b251419efc915eb), {
        selectionState: selectionState,
        actions: selectionActions,
        gestures: isReconcile ? undefined : gestures,
        accountId: params.id,
        extraActions: reconcileActions,
        filterContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-wrap items-center gap-2",
            children: [
                props.includeProcessed && !isReconcile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25d6b5adca90bb97$export$e0ca7418676fa890), {
                    value: allocationFilter,
                    onChange: (filter)=>setParams({
                            allocation: filter === 'all' ? null : filter
                        })
                }),
                !isReconcile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fb4243874d8f910$export$bfb275743ab18881), {
                            value: dateFilter,
                            onChange: (filter)=>setParams({
                                    startDate: filter.startDate,
                                    endDate: filter.endDate
                                })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "min-w-32 max-w-56 flex-1",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d5b3d85c2079de0$export$55d7609a8f1eccd2), {
                                initialQuery: search,
                                onSearch: (query)=>setParams({
                                        search: query
                                    }),
                                inputProps: {
                                    placeholder: 'Search'
                                }
                            }, params.id ?? 'all')
                        })
                    ]
                }),
                activeFilterKeys.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46b86c7aa98be263$export$4596b845258929e5), {
                    onReset: resetFilters
                })
            ]
        })
    });
    const scrollTable = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82dd4a85a022dc3b$export$235db9c6287af77c), {
        className: "min-h-0 w-full flex-1",
        scrollStateKey: [
            allocationFilter,
            activeDateFilter.startDate ?? '',
            activeDateFilter.endDate ?? '',
            activeSearch
        ].join('|'),
        body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                bodyContent,
                (all.length > 0 || hasMore) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f474bccad37d15d6$export$7f94856880993f27), {
                    loading: loading,
                    hasMore: hasMore,
                    onMore: handleMore
                })
            ]
        }),
        // The running-math summary renders as the list's footer (outside the
        // scroll area) so it holds a fixed spot below the list while a session
        // runs, without ever overlapping the rows the user is matching.
        footer: reconcileSessionActive && activeAnchor && activeBaseline ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4870fadb257a2ad$export$d0da5272f80239f2), {
            anchor: activeAnchor,
            baseline: activeBaseline,
            currency: accountCurrency ?? all[0]?.currency ?? 'USD',
            isCreditCard: isCreditCard
        }) : undefined
    });
    // Header + list share one column. In reconcile mode the session provider
    // wraps both so its top action bar and summary footer can read the session
    // from context; it stays mounted whether or not a session runs (passing a
    // null anchor while idle) so starting one never remounts the ScrollTable and
    // resets its scroll position. Browse mode never reconciles, so it renders the
    // column directly.
    const inner = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex min-h-0 w-full flex-1 flex-col",
        children: [
            header,
            scrollTable
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex h-full flex-col overflow-hidden",
        children: isReconcile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4870fadb257a2ad$export$ff3af39b0e278375), {
            accountId: params.id ?? '',
            anchor: activeAnchor,
            baseline: activeBaseline,
            transactions: transactions ?? [],
            hasMoreTransactions: hasMore,
            loadingMore: loading,
            onLoadMore: handleMore,
            selectedIds: selectedIds,
            onSeedSelection: setSelection,
            onReconciled: (claimedIds)=>{
                // The claimed rows leave the unreconciled list, and the anchor
                // gained a reconciliation. Drop the rows from the cached list
                // surgically — reloading would reset to the first page and throw
                // away everything the user paginated in.
                //
                // Mark them leaving first and cut them from the cache only once
                // they've animated out: a whole statement's worth of rows
                // vanishing in one frame reads as a glitch rather than as the
                // result of the reconcile. The anchor refetch runs immediately, so
                // the row turns green while its claimed rows are still collapsing.
                //
                // Between here and the refetch landing, the anchor's own row still
                // reads as unreconciled, so its Reconcile button would come back
                // the moment the session closes — and for the length of the exit
                // the claimed rows are still in the list to be reseeded against it.
                // That is enough to start the same anchor again, rebalance, and
                // submit a second time, which the server rejects outright
                // ("Anchor is already reconciled"). Hold it in a completed state
                // until its refreshed reconciliation arrives.
                const completedId = activeAnchor?._id;
                setActiveAnchorId(null);
                if (completedId) setCompletedAnchorIds((current)=>new Set(current).add(completedId));
                clearSelection();
                setLeavingIds(claimedIds);
                refetchAnchors();
                scheduleRowRemoval(claimedIds);
            },
            children: inner
        }) : inner
    });
};
var $dbd7c92ba7262ba3$export$2e2bcd8739ae039 = $dbd7c92ba7262ba3$var$RawTransactionView;


const $641619c3b52cfc92$export$c71d4e65ef72ff3e = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbd7c92ba7262ba3$export$2e2bcd8739ae039), {
        includeProcessed: true,
        mode: "reconcile"
    });



parcelRequire("acw62");

const $77aad9f0a27a5941$export$abc3224e24d2a532 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbd7c92ba7262ba3$export$2e2bcd8739ae039), {
        includeProcessed: true
    });







var $acw62 = parcelRequire("acw62");






const $aba9d9f93276c42c$var$PAGE_SIZE = 10;
/** Show previous page's data (at reduced opacity) while the next page loads. */ const $aba9d9f93276c42c$var$useStaleWhileLoading = (items, loading)=>{
    const prevRef = $acw62.useRef([]);
    $acw62.useEffect(()=>{
        if (items.length > 0) prevRef.current = items;
    }, [
        items
    ]);
    return items.length > 0 ? items : loading ? prevRef.current : [];
};
const $aba9d9f93276c42c$var$formatCurrency = (cents)=>new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(cents / 100);
// Format an ISO date string (e.g., "2024-01-15") for display
const $aba9d9f93276c42c$var$formatDateString = (isoDate)=>(0, $0c0f91b069db95d9$export$6b862160d295c8e)(isoDate).toLocaleString({
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
const $aba9d9f93276c42c$var$SnapshotRow = ({ snapshot: snapshot, onEdit: onEdit, onDelete: onDelete })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card flex items-center gap-3 rounded-lg border p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-1 flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground font-medium",
                        children: $aba9d9f93276c42c$var$formatDateString(snapshot.date)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground text-sm",
                        children: [
                            "Source: ",
                            snapshot.source
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col items-end",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-foreground font-medium",
                    children: $aba9d9f93276c42c$var$formatCurrency(snapshot.value)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49e34d17f9b50791$export$32b7bd840a1eba80), {
                children: [
                    snapshot.source === 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {}),
                        onSelect: onEdit,
                        children: "Edit"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                            className: "text-destructive"
                        }),
                        onSelect: onDelete,
                        className: "text-destructive",
                        children: "Delete"
                    })
                ]
            })
        ]
    });
};
const $aba9d9f93276c42c$export$68f94bff7f5a4ae8 = ()=>{
    const { account: account, refetchAccount: refetchAccount } = (0, $cf8a3466088e9562$export$7b3ff83b2e249bf6)();
    // The tab is only offered for investment accounts, but the route exists
    // for every account type. Portfolio snapshots are a merged view over
    // balance anchors/readings for ANY account id, so rendering this view for
    // a deep-linked depository account would expose its synced balance
    // history to edits/deletes under a "snapshots" label — redirect instead.
    if (account.__typename !== 'InvestmentAccount') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
        to: `/accounts/${account._id}`,
        replace: true
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aba9d9f93276c42c$var$SnapshotsContent, {
        account: account,
        refetchAccount: refetchAccount
    });
};
const $aba9d9f93276c42c$var$SnapshotsContent = ({ account: account, refetchAccount: refetchAccount })=>{
    const { addSnapshotModal: addSnapshotModal, deleteSnapshotModal: deleteSnapshotModal, editSnapshotModal: editSnapshotModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const [beforeCursor, setBeforeCursor] = $acw62.useState(null);
    const [cursorHistory, setCursorHistory] = $acw62.useState([]);
    // Reset pagination when navigating between accounts
    $acw62.useEffect(()=>{
        setBeforeCursor(null);
        setCursorHistory([]);
    }, [
        account._id
    ]);
    // The light account fragment has no snapshotCount — fetch the full
    // investment fragment for the count shown next to the pager.
    const { data: investmentData, refetch: refetchInvestment } = (0, $ce9d9e524be20f53$export$b9614cb2f3723202)({
        variables: {
            id: account._id
        },
        fetchPolicy: 'cache-and-network'
    });
    const snapshotCount = investmentData?.investmentAccount?.snapshotCount;
    const { data: data, previousData: previousData, loading: loading, error: error, refetch: refetchSnapshots } = (0, $ce9d9e524be20f53$export$72facc932598e46)({
        variables: {
            accountId: account._id,
            limit: $aba9d9f93276c42c$var$PAGE_SIZE,
            beforeCursor: beforeCursor ?? undefined
        }
    });
    const page = data?.portfolioSnapshotsPage;
    const items = page?.items ?? previousData?.portfolioSnapshotsPage?.items ?? [];
    const hasNextPage = page?.hasMore ?? false;
    const hasPrevPage = cursorHistory.length > 0;
    const displaySnapshots = $aba9d9f93276c42c$var$useStaleWhileLoading(items, loading);
    const handleNextPage = ()=>{
        if (page?.endCursor) {
            setCursorHistory((prev)=>[
                    ...prev,
                    beforeCursor ?? ''
                ]);
            setBeforeCursor(page.endCursor);
        }
    };
    const handlePrevPage = ()=>{
        const prev = cursorHistory[cursorHistory.length - 1];
        setCursorHistory((h)=>h.slice(0, -1));
        setBeforeCursor(prev === '' ? null : prev);
    };
    const handleChanged = ()=>{
        setBeforeCursor(null);
        setCursorHistory([]);
        refetchSnapshots();
        refetchInvestment();
        // Snapshots feed Account.balance server-side — keep the header fresh.
        refetchAccount();
    };
    const handleAdd = ()=>{
        addSnapshotModal.openModal({
            accountId: account._id,
            onSuccess: handleChanged
        });
    };
    const handleDelete = (snapshot)=>{
        deleteSnapshotModal.openModal({
            snapshot: snapshot,
            onDeleted: handleChanged
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col gap-4 overflow-y-auto p-4 sm:p-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-foreground m-0 font-medium",
                        children: "Portfolio Snapshots"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            snapshotCount != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-muted-foreground text-sm",
                                children: [
                                    snapshotCount,
                                    " snapshot",
                                    snapshotCount !== 1 ? 's' : ''
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                size: "icon",
                                onClick: handleAdd,
                                title: "Add snapshot",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                    className: "size-5"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                size: "icon",
                                onClick: handlePrevPage,
                                disabled: !hasPrevPage || loading,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                    className: "size-5"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                size: "icon",
                                onClick: handleNextPage,
                                disabled: !hasNextPage || loading,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                    className: "size-5"
                                })
                            })
                        ]
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-destructive rounded-lg border border-dashed p-6 text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-destructive mb-3 text-sm",
                        children: "Failed to load snapshots"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        onClick: ()=>void refetchSnapshots(),
                        children: "Retry"
                    })
                ]
            }) : displaySnapshots.length === 0 && !loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border rounded-lg border border-dashed p-6 text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground mb-3 text-sm",
                        children: "No snapshots recorded yet"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        onClick: handleAdd,
                        children: "Add first snapshot"
                    })
                ]
            }) : displaySnapshots.length === 0 && loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground py-4 text-center text-sm",
                children: "Loading snapshots..."
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `flex flex-col gap-2 transition-opacity${loading ? ' opacity-50' : ''}`,
                children: displaySnapshots.map((snapshot)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aba9d9f93276c42c$var$SnapshotRow, {
                        snapshot: snapshot,
                        onEdit: ()=>editSnapshotModal.openModal({
                                snapshot: snapshot,
                                onSuccess: handleChanged
                            }),
                        onDelete: ()=>handleDelete(snapshot)
                    }, snapshot._id))
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");













var $acw62 = parcelRequire("acw62");





const $b39558552c4e3a0d$export$29ebf17bfed7334d = (store, keys)=>{
    store.writeQuery({
        query: (0, $ce9d9e524be20f53$export$a9506d34966fbeb6),
        data: {
            accountTypeOrder: keys
        }
    });
};



const $03a2c4967b0b385d$var$STARRED = 'starred';
const $03a2c4967b0b385d$var$TYPE_PREFIX = 'type:';
// Starred rows duplicate accounts that also render in their type section, so
// their sortable IDs are prefixed to keep dnd-kit IDs unique. Starred is
// reorder-only: rows never drag into or out of it (star/unstar via the row
// toggle).
const $03a2c4967b0b385d$var$STARRED_PREFIX = 'starred:';
const $03a2c4967b0b385d$var$buildDraft = (accounts, persistedTypeOrder, starredIds, previous)=>{
    const sections = (0, $e597f4605156a89e$export$9b4ce3dceeb152b6)(previous?.typeOrder ?? persistedTypeOrder);
    const accountIds = new Set(accounts.map((a)=>a._id));
    // Keep the previous draft's per-section order where possible so an
    // in-flight drag isn't clobbered; drop removed accounts, append new ones
    // in list order.
    const idsByType = {};
    for (const section of sections){
        const sectionAccountIds = accounts.filter((account)=>section.matches(account)).map((account)=>account._id);
        const sectionSet = new Set(sectionAccountIds);
        const kept = (previous?.idsByType[section.key] ?? []).filter((id)=>sectionSet.has(id));
        const keptSet = new Set(kept);
        idsByType[section.key] = [
            ...kept,
            ...sectionAccountIds.filter((id)=>!keptSet.has(id))
        ];
    }
    // Same for starred: keep the previous draft's order for accounts that are
    // still starred, append newly starred ones in server order.
    const starredSet = new Set(starredIds.filter((id)=>accountIds.has(id)));
    const keptStarred = (previous?.starred ?? []).filter((id)=>starredSet.has(id));
    const keptStarredSet = new Set(keptStarred);
    const newlyStarred = starredIds.filter((id)=>starredSet.has(id) && !keptStarredSet.has(id));
    return {
        typeOrder: sections.map((section)=>section.key),
        idsByType: idsByType,
        starred: [
            ...keptStarred,
            ...newlyStarred
        ]
    };
};
const $03a2c4967b0b385d$var$RearrangeAccountRow = ({ account: account, balance: balance, sortableId: sortableId, starred: starred, onToggleStar: onToggleStar })=>{
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition, isDragging: isDragging } = (0, $0332ec5baeac6793$export$4ebcb6201122185a)({
        id: sortableId ?? account._id
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: setNodeRef,
        style: {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(transform),
            transition: transition
        },
        className: isDragging ? 'opacity-50' : '',
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba405bcc20345af9$export$b3e0a2e54ae1504b), {
            account: account,
            balance: balance,
            starred: starred,
            onToggleStar: onToggleStar,
            dragHandle: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "text-muted-foreground hover:text-foreground cursor-grab touch-none",
                ...attributes,
                ...listeners,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $578293164592f2cd$export$2e2bcd8739ae039), {
                    className: "h-5 w-5"
                })
            })
        })
    });
};
/**
 * A section that is itself sortable (dragged by its header grip).
 * Collapsing works while rearranging — a collapsed section is easier to
 * drag past.
 */ const $03a2c4967b0b385d$var$SortableTypeSection = ({ section: section, accountIds: accountIds, accountById: accountById, balances: balances, collapsed: collapsed, onToggle: onToggle, starredSet: starredSet, onToggleStar: onToggleStar })=>{
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition, isDragging: isDragging } = (0, $0332ec5baeac6793$export$4ebcb6201122185a)({
        id: `${$03a2c4967b0b385d$var$TYPE_PREFIX}${section.key}`
    });
    const accounts = accountIds.flatMap((id)=>{
        const account = accountById.get(id);
        return account ? [
            account
        ] : [];
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: setNodeRef,
        style: {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(transform),
            transition: transition
        },
        className: isDragging ? 'opacity-50' : '',
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba8a657c1d6c9967$export$35443e9ddfb23303), {
            label: section.label,
            accounts: (0, $44fe23713dacf9c4$export$3cb4e4363c734cdc)(accounts, balances),
            collapsed: collapsed,
            onToggle: onToggle,
            dragHandle: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "text-muted-foreground hover:text-foreground cursor-grab touch-none",
                ...attributes,
                ...listeners,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $578293164592f2cd$export$2e2bcd8739ae039), {
                    className: "h-4 w-4"
                })
            }),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0332ec5baeac6793$export$86155fde54f06e6a), {
                items: accountIds,
                strategy: (0, $0332ec5baeac6793$export$fe2be640df2ffb9e),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-col gap-2",
                    children: accounts.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($03a2c4967b0b385d$var$RearrangeAccountRow, {
                            account: account,
                            balance: balances.get(account._id),
                            starred: starredSet.has(account._id),
                            onToggleStar: ()=>onToggleStar(account._id)
                        }, account._id))
                })
            })
        })
    });
};
const $03a2c4967b0b385d$export$184504a6be1e6070 = ({ accounts: accounts, balances: balances, typeOrder: typeOrder, starredIds: starredIds, onToggleStar: onToggleStar, isCollapsed: isCollapsed, onToggleSection: onToggleSection })=>{
    const [draft, setDraftState] = $acw62.useState(()=>$03a2c4967b0b385d$var$buildDraft(accounts, typeOrder, starredIds));
    const draftRef = $acw62.useRef(draft);
    const setDraft = $acw62.useCallback((next)=>{
        draftRef.current = next;
        setDraftState(next);
    }, []);
    // Reconcile when accounts are created/deleted or starred/unstarred while
    // rearranging
    $acw62.useEffect(()=>{
        setDraft($03a2c4967b0b385d$var$buildDraft(accounts, typeOrder, starredIds, draftRef.current));
    }, [
        accounts,
        typeOrder,
        starredIds,
        setDraft
    ]);
    const [reorderAccountsMutation] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$da5e3aed71c44232));
    const [reorderTypesMutation] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$5aec791438878189));
    const [reorderStarredMutation] = (0, $6ce4d937b84048d1$export$609860bf8b0084c)((0, $ce9d9e524be20f53$export$db23f67c0febaad1));
    const accountById = $acw62.useMemo(()=>new Map(accounts.map((a)=>[
                a._id,
                a
            ])), [
        accounts
    ]);
    const sensors = (0, $0bb7808e9486acbd$export$19012f58216d597f)((0, $0bb7808e9486acbd$export$cc72dd71f4ec69eb)((0, $0bb7808e9486acbd$export$b26af955418d6638), {
        activationConstraint: {
            distance: 4
        }
    }));
    // The global account order is the concatenation of the type sections in
    // display order — reordering within a section rewrites it wholesale.
    const persistAccounts = (next)=>{
        reorderAccountsMutation({
            variables: {
                accounts: next.typeOrder.flatMap((key)=>next.idsByType[key] ?? [])
            }
        });
    };
    const persistTypes = (next)=>{
        reorderTypesMutation({
            variables: {
                typeKeys: next.typeOrder
            },
            optimisticResponse: {
                reorderAccountTypes: next.typeOrder
            },
            update: (cache, result)=>{
                const keys = result.data?.reorderAccountTypes;
                if (keys) (0, $b39558552c4e3a0d$export$29ebf17bfed7334d)(cache, keys);
            }
        });
    };
    const persistStarred = (starred)=>{
        reorderStarredMutation({
            variables: {
                accountIds: starred
            },
            optimisticResponse: {
                reorderStarredAccounts: starred
            },
            update: (cache, result)=>{
                const ids = result.data?.reorderStarredAccounts;
                if (ids) (0, $28ed348052d72cb7$export$46b7e047635b952b)(cache, ids);
            }
        });
    };
    /** The type-section key containing an account row id, if any. */ const containerOf = (id)=>draftRef.current.typeOrder.find((key)=>(draftRef.current.idsByType[key] ?? []).includes(id)) ?? null;
    const handleDragEnd = ({ active: active, over: over })=>{
        if (!over) return;
        const activeId = String(active.id);
        const overId = String(over.id);
        const current = draftRef.current;
        if (activeId.startsWith($03a2c4967b0b385d$var$STARRED_PREFIX)) {
            // Reorder within the starred section; drops anywhere else are no-ops
            // (starred rows never leave the section by dragging).
            if (overId.startsWith($03a2c4967b0b385d$var$STARRED_PREFIX) && overId !== activeId) {
                const fromIndex = current.starred.indexOf(activeId.slice($03a2c4967b0b385d$var$STARRED_PREFIX.length));
                const toIndex = current.starred.indexOf(overId.slice($03a2c4967b0b385d$var$STARRED_PREFIX.length));
                if (fromIndex >= 0 && toIndex >= 0) {
                    const next = {
                        ...current,
                        starred: (0, $0332ec5baeac6793$export$5d49d615ad5ea2b0)(current.starred, fromIndex, toIndex)
                    };
                    setDraft(next);
                    persistStarred(next.starred);
                }
            }
            return;
        }
        if (activeId.startsWith($03a2c4967b0b385d$var$TYPE_PREFIX)) {
            // Reorder whole type sections by header drag. The drop target is often
            // an account row rather than another header (rows are droppables in
            // the same DndContext) — resolve rows to their containing section.
            const activeKey = activeId.slice($03a2c4967b0b385d$var$TYPE_PREFIX.length);
            const overKey = overId.startsWith($03a2c4967b0b385d$var$TYPE_PREFIX) ? overId.slice($03a2c4967b0b385d$var$TYPE_PREFIX.length) : containerOf(overId);
            if (overKey != null && overKey !== activeKey) {
                const fromIndex = current.typeOrder.indexOf(activeKey);
                const toIndex = current.typeOrder.indexOf(overKey);
                if (fromIndex >= 0 && toIndex >= 0) {
                    const next = {
                        ...current,
                        typeOrder: (0, $0332ec5baeac6793$export$5d49d615ad5ea2b0)(current.typeOrder, fromIndex, toIndex)
                    };
                    setDraft(next);
                    persistTypes(next);
                }
            }
            return;
        }
        // Account rows only reorder within their own type section — a drop over
        // anything outside it (another section's row, a header) is a no-op.
        const container = containerOf(activeId);
        if (container == null || containerOf(overId) !== container) return;
        const ids = current.idsByType[container] ?? [];
        const fromIndex = ids.indexOf(activeId);
        const toIndex = ids.indexOf(overId);
        if (fromIndex >= 0 && toIndex >= 0 && fromIndex !== toIndex) {
            const next = {
                ...current,
                idsByType: {
                    ...current.idsByType,
                    [container]: (0, $0332ec5baeac6793$export$5d49d615ad5ea2b0)(ids, fromIndex, toIndex)
                }
            };
            setDraft(next);
            persistAccounts(next);
        }
    };
    const starredSet = new Set(draft.starred);
    const starredAccounts = draft.starred.flatMap((id)=>{
        const account = accountById.get(id);
        return account ? [
            account
        ] : [];
    });
    const sectionByKey = new Map((0, $e597f4605156a89e$export$9b4ce3dceeb152b6)(draft.typeOrder).map((section)=>[
            section.key,
            section
        ]));
    // Only sections with accounts render; empty sections keep their relative
    // position in draft.typeOrder for when they gain accounts
    const sections = draft.typeOrder.flatMap((key)=>{
        const section = sectionByKey.get(key);
        const ids = draft.idsByType[key] ?? [];
        return section && ids.length > 0 ? [
            {
                section: section,
                ids: ids
            }
        ] : [];
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0bb7808e9486acbd$export$2d5c5ceac203fc1e), {
        sensors: sensors,
        collisionDetection: (0, $0bb7808e9486acbd$export$c3a6c1c7122b31c9),
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                starredAccounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0332ec5baeac6793$export$86155fde54f06e6a), {
                    items: draft.starred.map((id)=>`${$03a2c4967b0b385d$var$STARRED_PREFIX}${id}`),
                    strategy: (0, $0332ec5baeac6793$export$fe2be640df2ffb9e),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba8a657c1d6c9967$export$35443e9ddfb23303), {
                        label: "Starred",
                        badges: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b006b04b8c21eb$export$2e2bcd8739ae039), {
                            className: "h-3.5 w-3.5 shrink-0 fill-amber-500 text-amber-500"
                        }),
                        accounts: (0, $44fe23713dacf9c4$export$3cb4e4363c734cdc)(starredAccounts, balances),
                        collapsed: isCollapsed($03a2c4967b0b385d$var$STARRED),
                        onToggle: ()=>onToggleSection($03a2c4967b0b385d$var$STARRED),
                        children: starredAccounts.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($03a2c4967b0b385d$var$RearrangeAccountRow, {
                                account: account,
                                balance: balances.get(account._id),
                                sortableId: `${$03a2c4967b0b385d$var$STARRED_PREFIX}${account._id}`,
                                starred: true,
                                onToggleStar: ()=>onToggleStar(account._id)
                            }, account._id))
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0332ec5baeac6793$export$86155fde54f06e6a), {
                    items: sections.map(({ section: section })=>`${$03a2c4967b0b385d$var$TYPE_PREFIX}${section.key}`),
                    strategy: (0, $0332ec5baeac6793$export$fe2be640df2ffb9e),
                    children: sections.map(({ section: section, ids: ids })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($03a2c4967b0b385d$var$SortableTypeSection, {
                            section: section,
                            accountIds: ids,
                            accountById: accountById,
                            balances: balances,
                            collapsed: isCollapsed(section.key),
                            onToggle: ()=>onToggleSection(section.key),
                            starredSet: starredSet,
                            onToggleStar: onToggleStar
                        }, section.key))
                })
            ]
        })
    });
};



var $acw62 = parcelRequire("acw62");
const $04992a260d2c1bbc$var$load = (storageKey)=>{
    try {
        const raw = window.localStorage.getItem(storageKey);
        const parsed = raw ? JSON.parse(raw) : [];
        if (Array.isArray(parsed)) return new Set(parsed.filter((id)=>typeof id === 'string'));
    } catch  {
    // Corrupt storage — fall through to empty
    }
    return new Set();
};
const $04992a260d2c1bbc$export$ede64fcf09dc2bf1 = (storageKey)=>{
    const [collapsed, setCollapsed] = $acw62.useState(()=>$04992a260d2c1bbc$var$load(storageKey));
    const toggle = $acw62.useCallback((id)=>{
        setCollapsed((prev)=>{
            // Re-read storage so multiple hook instances sharing a key (one per
            // section component) don't clobber each other's persisted entries.
            const next = $04992a260d2c1bbc$var$load(storageKey);
            if (prev.has(id)) next.delete(id);
            else next.add(id);
            try {
                window.localStorage.setItem(storageKey, JSON.stringify([
                    ...next
                ]));
            } catch  {
            // Storage unavailable — state still works for this session
            }
            return next;
        });
    }, [
        storageKey
    ]);
    const isCollapsed = $acw62.useCallback((id)=>collapsed.has(id), [
        collapsed
    ]);
    return {
        isCollapsed: isCollapsed,
        toggle: toggle
    };
};










const $86bd80b017698727$var$STARRED_SECTION = 'starred';
const $86bd80b017698727$export$f019e054845ddace = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Accounts',
        reset: true
    });
    const [searchParams, setSearchParams] = (0, $0c90f43fc3673aef$export$f1a78c17382fe22a)();
    // The By Connection tab became the standalone /connections page.
    const legacyConnectionsView = searchParams.get('view') === 'connections';
    const typeFilter = (0, $e597f4605156a89e$export$2fd2effeb17443f1)(searchParams.get('type'));
    // Search lives in the URL like the status/type filters, so it survives
    // navigation (opening an account and hitting back keeps the search).
    const search = searchParams.get('search') ?? '';
    // The status default is contextual: 'active' keeps the plain overview
    // decluttered, but once the user is narrowing — typing a name, picking a
    // type — hidden statuses would make the very account they asked for
    // vanish, so the default widens to 'all'. An explicit pick always wins.
    const explicitFilter = (0, $e597f4605156a89e$export$49a87e04cfe7c710)(searchParams.get('filter'));
    const searchNarrows = search.length > 0;
    const defaultFilter = searchNarrows || typeFilter.length > 0 ? 'all' : 'active';
    const filter = explicitFilter ?? defaultFilter;
    // AllAccounts is metadata-only (names, types, logos) so first paint never
    // waits on balance derivation. cache-and-network: render the cached list
    // instantly but always refresh it.
    const { data: data, loading: loading, refetch: refetch } = (0, $ce9d9e524be20f53$export$cb6e321bdf608ddb)({
        fetchPolicy: 'cache-and-network'
    });
    // Balances are the expensive part (derived server-side, changed by
    // raw-transaction mutations that don't touch this query's cache) and
    // stream in after the list renders — rows show a placeholder until then.
    const { data: balancesData, refetch: refetchBalances } = (0, $ce9d9e524be20f53$export$6d85013179a40a0d)({
        fetchPolicy: 'cache-and-network'
    });
    const { data: typeOrderData, loading: typeOrderLoading } = (0, $ce9d9e524be20f53$export$b1e5e46b10f75f8b)();
    const { starredIds: starredIds, loading: starredLoading, toggleStar: handleToggleStar } = (0, $9e78a066568deb1b$export$6fedb39e019288e9)();
    const { createAccountModal: createAccountModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const [rearranging, setRearranging] = $acw62.useState(false);
    const { isCollapsed: isCollapsed, toggle: toggle } = (0, $04992a260d2c1bbc$export$ede64fcf09dc2bf1)('accounts.collapsedSections');
    // Per-section reveal of the folded inactive rows. Ephemeral by design:
    // the fold is the default view, a reveal is a momentary look.
    const [expandedInactive, setExpandedInactive] = $acw62.useState(()=>new Set());
    const toggleInactive = (sectionKey)=>{
        setExpandedInactive((previous)=>{
            const next = new Set(previous);
            if (next.has(sectionKey)) next.delete(sectionKey);
            else next.add(sectionKey);
            return next;
        });
    };
    const setFilter = (newFilter)=>{
        const next = new URLSearchParams(searchParams);
        // The param is only present for a non-default pick. The default is
        // contextual (see above), so which value gets to be absent depends on
        // whether the view is narrowed — an explicit Active during a search is
        // real state and must be kept.
        if (newFilter === defaultFilter) next.delete('filter');
        else next.set('filter', newFilter);
        setSearchParams(next);
    };
    const setTypeFilter = (newTypeFilter)=>{
        const next = new URLSearchParams(searchParams);
        const serialized = (0, $e597f4605156a89e$export$e04f9e18b7296b99)(newTypeFilter);
        if (serialized == null) next.delete('type');
        else next.set('type', serialized);
        setSearchParams(next);
    };
    const setSearch = (value)=>{
        const next = new URLSearchParams(searchParams);
        if (value === '') next.delete('search');
        else next.set('search', value);
        // replace: the search box updates per keystroke, so pushing would bury the
        // previous page under one history entry per character typed.
        setSearchParams(next, {
            replace: true
        });
    };
    const handleRefetch = ()=>{
        refetch();
        refetchBalances();
    };
    const handleCreate = ()=>{
        createAccountModal.openModal({
            onCreate: handleRefetch
        });
    };
    const handleDoneRearranging = ()=>{
        setRearranging(false);
        // The rearrange persisted a new global order — refresh allAccounts
        refetch();
    };
    if (legacyConnectionsView) {
        // Only `view` is obsolete — /connections still parses `filter` and
        // `type`, so filtered bookmarks keep their behavior.
        const preserved = new URLSearchParams(searchParams);
        preserved.delete('view');
        const query = preserved.toString();
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
            to: query ? `/connections?${query}` : '/connections',
            replace: true
        });
    }
    // cache-and-network reports loading during the background refresh — only
    // show the spinner when there is no cached list to render
    if (loading && !data || typeOrderLoading || starredLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading accounts..."
        })
    });
    const allAccounts = data?.allAccounts ?? [];
    const balances = (0, $44fe23713dacf9c4$export$efe12b2e2f122c40)(balancesData);
    const starredSet = new Set(starredIds);
    // The status filter reads the balance slice (inactive = open + zero
    // balance + no recent activity), which streams in after the metadata —
    // until it lands, every account counts as active and nothing hides. A
    // starred inactive account also stays in the default view: a pin beats
    // the dormancy heuristic.
    const matchesStatus = (statusFilter, account)=>(0, $e597f4605156a89e$export$175da04470876f6a)(statusFilter, account, balances.get(account._id)) || statusFilter === 'active' && starredSet.has(account._id) && !(0, $e597f4605156a89e$export$881343af68ecca95)(account);
    // Each dropdown's counts respect the OTHER filter (GitHub-style cross
    // counts: with type=Credit Card selected, "Closed 2" means 2 closed
    // credit cards, and vice versa)
    const typeMatchedAccounts = allAccounts.filter((account)=>(0, $e597f4605156a89e$export$86f6532dce6b4d32)(typeFilter, account));
    const statusMatchedAccounts = allAccounts.filter((account)=>matchesStatus(filter, account));
    const visibleAccounts = typeMatchedAccounts.filter((account)=>matchesStatus(filter, account));
    const statusOptions = [
        {
            key: 'active',
            label: 'Active',
            count: typeMatchedAccounts.filter((account)=>matchesStatus('active', account)).length
        },
        {
            key: 'inactive',
            label: 'Inactive',
            count: typeMatchedAccounts.filter((account)=>(0, $e597f4605156a89e$export$ad17ddbed40f1c23)(account, balances.get(account._id))).length
        },
        {
            key: 'closed',
            label: 'Closed',
            count: typeMatchedAccounts.filter((0, $e597f4605156a89e$export$881343af68ecca95)).length
        }
    ];
    // Only types with at least one account are offered (plus current
    // selections, so they can always be cleared)
    const typeOptions = (0, $e597f4605156a89e$export$6096865e4aa58c8a).map((option)=>({
            key: option.key,
            label: option.label,
            group: option.group,
            count: statusMatchedAccounts.filter(option.matches).length,
            present: allAccounts.some(option.matches)
        })).filter((option)=>option.present || typeFilter.includes(option.key));
    const typeOrder = typeOrderData?.accountTypeOrder ?? [];
    const isSearching = search.length > 0;
    const accounts = visibleAccounts.filter((account)=>account.name.toLowerCase().includes(search.toLowerCase()));
    const accountById = new Map(visibleAccounts.map((a)=>[
            a._id,
            a
        ]));
    const starredAccounts = starredIds.flatMap((id)=>{
        const account = accountById.get(id);
        return account ? [
            account
        ] : [];
    });
    // One section per depository type (plus the single merged Investments
    // section) that has a visible or folded account, in the persisted section
    // order (unlisted sections follow in default order). In the default
    // 'active' view each section folds its inactive accounts into a
    // disclosure line instead of dropping them.
    const sections = (0, $e597f4605156a89e$export$9b4ce3dceeb152b6)(typeOrder).map((section)=>({
            section: section,
            accounts: visibleAccounts.filter(section.matches),
            inactiveAccounts: filter === 'active' ? typeMatchedAccounts.filter((account)=>section.matches(account) && !starredSet.has(account._id) && (0, $e597f4605156a89e$export$ad17ddbed40f1c23)(account, balances.get(account._id))) : []
        })).filter(({ accounts: sectionAccounts, inactiveAccounts: inactiveAccounts })=>sectionAccounts.length > 0 || inactiveAccounts.length > 0);
    const actions = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
        variant: "ghost",
        size: "icon",
        onClick: handleCreate,
        "aria-label": "Add account",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
            className: "size-5"
        })
    });
    const renderReadOnlyRows = (rows, groupLabel)=>rows.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba405bcc20345af9$export$b3e0a2e54ae1504b), {
                account: account,
                balance: balances.get(account._id),
                starred: starredSet.has(account._id),
                onToggleStar: ()=>handleToggleStar(account._id),
                groupLabel: groupLabel
            }, account._id));
    const renderStarredSection = ()=>starredAccounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba8a657c1d6c9967$export$35443e9ddfb23303), {
            label: "Starred",
            badges: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04b006b04b8c21eb$export$2e2bcd8739ae039), {
                className: "h-3.5 w-3.5 shrink-0 fill-amber-500 text-amber-500"
            }),
            accounts: (0, $44fe23713dacf9c4$export$3cb4e4363c734cdc)(starredAccounts, balances),
            collapsed: isCollapsed($86bd80b017698727$var$STARRED_SECTION),
            onToggle: ()=>toggle($86bd80b017698727$var$STARRED_SECTION),
            children: renderReadOnlyRows(starredAccounts)
        });
    const renderTypeSections = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                renderStarredSection(),
                sections.map(({ section: section, accounts: sectionAccounts, inactiveAccounts: inactiveAccounts })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ba8a657c1d6c9967$export$35443e9ddfb23303), {
                        label: section.label,
                        accounts: (0, $44fe23713dacf9c4$export$3cb4e4363c734cdc)(sectionAccounts, balances),
                        collapsed: isCollapsed(section.key),
                        onToggle: ()=>toggle(section.key),
                        children: [
                            renderReadOnlyRows(sectionAccounts, section.label),
                            inactiveAccounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                "aria-expanded": expandedInactive.has(section.key),
                                onClick: ()=>toggleInactive(section.key),
                                className: "text-muted-foreground hover:text-foreground hover:bg-accent flex items-center gap-1 px-3 py-2.5 text-left text-xs transition-colors sm:px-4",
                                children: [
                                    expandedInactive.has(section.key) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                        className: "size-3.5"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                        className: "size-3.5"
                                    }),
                                    inactiveAccounts.length,
                                    " inactive"
                                ]
                            }),
                            inactiveAccounts.length > 0 && expandedInactive.has(section.key) && renderReadOnlyRows(inactiveAccounts, section.label)
                        ]
                    }, section.key))
            ]
        });
    const renderAllAccountsTab = ()=>{
        if (allAccounts.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "border-border flex flex-col items-center gap-4 rounded-xl border border-dashed p-8",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground",
                    children: "No accounts"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: handleCreate,
                    type: "button",
                    children: "Add account"
                })
            ]
        });
        if (rearranging) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03a2c4967b0b385d$export$184504a6be1e6070), {
            accounts: allAccounts,
            balances: balances,
            typeOrder: typeOrder,
            starredIds: starredIds,
            onToggleStar: handleToggleStar,
            isCollapsed: isCollapsed,
            onToggleSection: toggle
        });
        // Sections can be nonempty with zero visible accounts (every match is
        // folded inactive) — the disclosures must still render so the folded
        // rows stay reachable in place.
        if (visibleAccounts.length === 0 && sections.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "text-muted-foreground py-8 text-center text-sm",
            children: typeFilter.length === 0 ? `No ${filter} accounts` : 'No matching accounts'
        });
        if (isSearching) // Searching flattens: no section chrome around a handful of hits
        return accounts.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-muted-foreground py-8 text-center text-sm",
            children: [
                'No accounts matching "',
                search,
                '"'
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba8a657c1d6c9967$export$69ed894a7932b604), {
            children: renderReadOnlyRows(accounts)
        });
        return renderTypeSections();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col overflow-y-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eca5e0b4050b06eb$export$223875819fd7cf93), {
                children: actions
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mx-auto flex w-full max-w-3xl flex-col gap-4 p-4 sm:px-6",
                children: [
                    rearranging ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-muted-foreground flex flex-1 items-center gap-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $97332defb5de8faa$export$2e2bcd8739ae039), {
                                        className: "size-4 shrink-0"
                                    }),
                                    "Rearranging"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "primary",
                                onClick: handleDoneRearranging,
                                children: "Done"
                            })
                        ]
                    }) : // One row on desktop; on a phone the search keeps the menu beside
                    // it and the filters wrap to their own row.
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-[1fr_auto] items-center gap-2 sm:flex",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative min-w-0 sm:flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        className: "text-muted-foreground pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "search",
                                        placeholder: "Search accounts",
                                        "aria-label": "Search accounts",
                                        value: search,
                                        onChange: (e)=>setSearch(e.target.value),
                                        className: "border-border bg-background placeholder:text-muted-foreground focus:ring-primary h-9 w-full rounded-lg border pr-3 pl-9 text-sm focus:ring-2 focus:outline-none"
                                    })
                                ]
                            }),
                            allAccounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "col-span-2 row-start-2 flex items-center gap-2 sm:order-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                                        label: "Status",
                                        allLabel: "All",
                                        allCount: typeMatchedAccounts.length,
                                        value: filter,
                                        onChange: (key)=>setFilter((0, $e597f4605156a89e$export$fabe442d1eda117c)(key)),
                                        options: statusOptions
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                                        label: "Type",
                                        allLabel: "All types",
                                        allCount: statusMatchedAccounts.length,
                                        multiple: true,
                                        value: typeFilter,
                                        onChange: setTypeFilter,
                                        options: typeOptions
                                    })
                                ]
                            }),
                            allAccounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "sm:order-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49e34d17f9b50791$export$32b7bd840a1eba80), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $97332defb5de8faa$export$2e2bcd8739ae039), {}),
                                        onSelect: ()=>{
                                            setSearch('');
                                            setRearranging(true);
                                        },
                                        children: "Rearrange Accounts"
                                    })
                                })
                            })
                        ]
                    }),
                    renderAllAccountsTab()
                ]
            })
        ]
    });
};





parcelRequire("acw62");



/**
 * The Analyst's spec language: the typed artifacts the agent produces and
 * pinned cards store. The invariant the whole feature hangs on: a pinned
 * card stores a SOURCE (how to get rows) and a CHART (how to draw them),
 * both plain JSON — refreshing a card re-executes the source against live
 * data and never involves the model.
 *
 * Two source tiers:
 * - `aggregation`: the typed engine — semantics baked in (homeNetAmount,
 *   payments-only default), validated forever, robust to refactors.
 * - `pipeline`: a guarded MongoDB aggregation pipeline for questions the
 *   engine never anticipated. Power tool; the server injects user scoping
 *   and rejects write/escape stages before execution.
 *
 * Zod is the single source of truth: the server validates specs with these
 * schemas, the agent's tool definitions are generated from them
 * (z.toJSONSchema), and the frontend gets the inferred types.
 */ // Namespace import deliberately: zod's ESM entry re-exports `z` as a
// namespace binding (`import * as z; export {z}`), which Parcel's scope
// hoisting mangles at runtime. The package also `export *`s every builder
// top-level, so the namespace form is equivalent and bundles correctly.

var $MqLpf = parcelRequire("MqLpf");

const $3b46909955ca740a$export$666f46faa7a9749 = $MqLpf.object({
    kind: $MqLpf.literal('relative'),
    preset: $MqLpf.enum([
        'trailing-30d',
        'trailing-90d',
        'trailing-12mo',
        'trailing-24mo',
        'ytd',
        'prev-year',
        'all-time'
    ])
});
const $3b46909955ca740a$export$2468eb4dd78018ad = $MqLpf.object({
    kind: $MqLpf.literal('absolute'),
    /** ISO dates, inclusive. */ startDate: $MqLpf.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    endDate: $MqLpf.string().regex(/^\d{4}-\d{2}-\d{2}$/)
}).superRefine((window, ctx)=>{
    // Shape alone admits 2026-02-30; a card must fail validation, not
    // silently return an empty window.
    if (!(0, $0c0f91b069db95d9$export$6b862160d295c8e)(window.startDate).isValid) ctx.addIssue({
        code: 'custom',
        message: `Invalid date: ${window.startDate}`
    });
    if (!(0, $0c0f91b069db95d9$export$6b862160d295c8e)(window.endDate).isValid) ctx.addIssue({
        code: 'custom',
        message: `Invalid date: ${window.endDate}`
    });
    if (window.startDate > window.endDate) ctx.addIssue({
        code: 'custom',
        message: 'startDate must be on or before endDate'
    });
});
const $3b46909955ca740a$export$5fb9e68ce65f2c0c = $MqLpf.discriminatedUnion('kind', [
    $3b46909955ca740a$export$666f46faa7a9749,
    $3b46909955ca740a$export$2468eb4dd78018ad
]);
const $3b46909955ca740a$export$ae5b9b41e97475a7 = $MqLpf.object({
    /** Category ids; the null sentinel 'uncategorized' matches rows with no category. */ categoryIds: $MqLpf.array($MqLpf.string()).optional(),
    /** Category group ids (from Settings.categoryGroups); expanded to members. */ categoryGroupIds: $MqLpf.array($MqLpf.string()).optional(),
    tagNames: $MqLpf.array($MqLpf.string()).optional(),
    /** Case-insensitive substring match on payee. */ payeeContains: $MqLpf.string().optional(),
    /** Exact payee names. */ payees: $MqLpf.array($MqLpf.string()).optional(),
    /** Enum/text field equality: dimensionValues[fieldId] === value. */ fieldEquals: $MqLpf.object({
        fieldId: $MqLpf.string(),
        value: $MqLpf.string()
    }).optional(),
    /**
     * Which transactions participate. Payments (netAmount !== 0) is the
     * default and almost always right — transfers are money movement, not
     * spending or income.
     */ transactionKind: $MqLpf.enum([
        'payments',
        'transfers',
        'all'
    ]).optional()
}).optional();
const $3b46909955ca740a$export$fdf7b42744b7b67 = $MqLpf.discriminatedUnion('dimension', [
    $MqLpf.object({
        dimension: $MqLpf.enum([
            'category',
            'categoryGroup',
            'payee',
            'tag',
            'month',
            'year',
            'weekday'
        ])
    }),
    // fieldValue requires the field id — without it every transaction would
    // silently group as '(unset)'.
    $MqLpf.object({
        dimension: $MqLpf.literal('fieldValue'),
        fieldId: $MqLpf.string().min(1)
    })
]);
const $3b46909955ca740a$var$groupIdentity = (dim)=>dim.dimension === 'fieldValue' ? `fieldValue:${dim.fieldId}` : dim.dimension;
const $3b46909955ca740a$export$99cd72a9b59a0915 = $MqLpf.object({
    kind: $MqLpf.literal('aggregation'),
    window: $3b46909955ca740a$export$5fb9e68ce65f2c0c,
    filters: $3b46909955ca740a$export$ae5b9b41e97475a7,
    /**
   * Zero, one, or two dimensions. Zero = a single total row. Two enables
   * shapes like category × month. Grouping by 'tag' fans a multi-tag
   * transaction into each of its tags — sums across tag rows can exceed
   * the filtered total.
   */ groupBy: $MqLpf.array($3b46909955ca740a$export$fdf7b42744b7b67).max(2).optional().refine((dims)=>dims == null || new Set(dims.map($3b46909955ca740a$var$groupIdentity)).size === dims.length, {
        message: 'groupBy dimensions must be distinct (two fieldValue dimensions need different fieldIds)'
    }),
    /**
   * All metrics are computed over homeNetAmount (USD cents, signed:
   * negative = money out). 'sum' is the default.
   */ metric: $MqLpf.enum([
        'sum',
        'count',
        'avg'
    ]).optional(),
    /** Keep the largest |value| rows, folding the rest into an 'other' row. */ topN: $MqLpf.number().int().min(1).max(100).optional()
});
const $3b46909955ca740a$export$3260147505262c2 = {
    check: (spec)=>spec.topN == null || (spec.groupBy?.length ?? 0) > 0,
    message: 'topN requires at least one groupBy dimension'
};
const $3b46909955ca740a$export$13fa4d707cb08b9c = $3b46909955ca740a$export$99cd72a9b59a0915.refine($3b46909955ca740a$export$3260147505262c2.check, {
    message: $3b46909955ca740a$export$3260147505262c2.message
});
const $3b46909955ca740a$export$fc6fe6d807cc0600 = [
    'transactions',
    'rawtransactions',
    'payrollRecords',
    'accounts',
    'categories',
    'tags',
    'fields',
    'portfoliosnapshots'
];
const $3b46909955ca740a$export$89f3263f03026b32 = $MqLpf.object({
    kind: $MqLpf.literal('pipeline'),
    collection: $MqLpf.enum($3b46909955ca740a$export$fc6fe6d807cc0600),
    /**
   * MongoDB aggregation stages. The server prepends user scoping, walks the
   * whole document rejecting write/escape operators, and guards $lookup —
   * see server/src/services/analyst/pipelineGuard.ts.
   */ pipeline: $MqLpf.array($MqLpf.record($MqLpf.string(), $MqLpf.unknown())).min(1).max(30)
});
const $3b46909955ca740a$export$674d3f10d8d68c9c = $MqLpf.discriminatedUnion('kind', [
    $3b46909955ca740a$export$13fa4d707cb08b9c,
    $3b46909955ca740a$export$89f3263f03026b32
]);
const $3b46909955ca740a$export$6aa3ac8dbdcdc829 = $MqLpf.discriminatedUnion('type', [
    $MqLpf.object({
        type: $MqLpf.literal('line'),
        x: $MqLpf.string(),
        y: $MqLpf.string(),
        /** Optional field whose values split rows into one line each. */ series: $MqLpf.string().optional(),
        /** Display-only sign flip — spending is negative; negate so it plots up. */ negate: $MqLpf.boolean().optional(),
        /** How y values render: 'cents' (default) as dollars, 'number' raw — use for count metrics. */ format: $MqLpf.enum([
            'cents',
            'number'
        ]).optional()
    }),
    $MqLpf.object({
        type: $MqLpf.literal('bars'),
        x: $MqLpf.string(),
        y: $MqLpf.string(),
        horizontal: $MqLpf.boolean().optional(),
        negate: $MqLpf.boolean().optional(),
        format: $MqLpf.enum([
            'cents',
            'number'
        ]).optional()
    }),
    $MqLpf.object({
        type: $MqLpf.literal('stackedArea'),
        x: $MqLpf.string(),
        y: $MqLpf.string(),
        series: $MqLpf.string(),
        negate: $MqLpf.boolean().optional(),
        format: $MqLpf.enum([
            'cents',
            'number'
        ]).optional()
    }),
    $MqLpf.object({
        type: $MqLpf.literal('stat'),
        /** Field holding the single value (first row is used). */ value: $MqLpf.string(),
        /** 'cents' renders $; 'number' renders the raw value. */ format: $MqLpf.enum([
            'cents',
            'number'
        ]).optional()
    }),
    $MqLpf.object({
        type: $MqLpf.literal('table'),
        columns: $MqLpf.array($MqLpf.string()).min(1),
        /** Column names (subset of `columns`) holding cent amounts. */ centsColumns: $MqLpf.array($MqLpf.string()).optional()
    })
]);
const $3b46909955ca740a$export$a8daae9538d2059 = $MqLpf.object({
    title: $MqLpf.string().min(1).max(120),
    /** One or two sentences of what the card shows / why it matters. */ commentary: $MqLpf.string().max(600).optional(),
    source: $3b46909955ca740a$export$674d3f10d8d68c9c,
    chart: $3b46909955ca740a$export$6aa3ac8dbdcdc829
});



var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");

parcelRequire("acw62");
/**
 * @fileOverview Bar Chart
 */ 




var $74d07378047db57c$export$94aefc399ef206a9 = (0, $6d459a69f64f5f55$export$77871aede60e6838)({
    chartName: 'BarChart',
    GraphicalChild: (0, $e752e700473a8894$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $f21953d5ea7d4fb8$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $7dad4d5151ba4a01$export$ece7de1383db5ac)
});

/**
 * @fileOverview Composed Chart
 */ 




var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");
function $4b833ab84f919bec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4b833ab84f919bec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4b833ab84f919bec$var$_typeof(o);
}
function $4b833ab84f919bec$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4b833ab84f919bec$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4b833ab84f919bec$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4b833ab84f919bec$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4b833ab84f919bec$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4b833ab84f919bec$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4b833ab84f919bec$var$_callSuper(t, o, e) {
    return o = $4b833ab84f919bec$var$_getPrototypeOf(o), $4b833ab84f919bec$var$_possibleConstructorReturn(t, $4b833ab84f919bec$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $4b833ab84f919bec$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $4b833ab84f919bec$var$_possibleConstructorReturn(self, call) {
    if (call && ($4b833ab84f919bec$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4b833ab84f919bec$var$_assertThisInitialized(self);
}
function $4b833ab84f919bec$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4b833ab84f919bec$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4b833ab84f919bec$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $4b833ab84f919bec$var$_getPrototypeOf(o) {
    $4b833ab84f919bec$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4b833ab84f919bec$var$_getPrototypeOf(o);
}
function $4b833ab84f919bec$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4b833ab84f919bec$var$_setPrototypeOf(subClass, superClass);
}
function $4b833ab84f919bec$var$_setPrototypeOf(o, p) {
    $4b833ab84f919bec$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4b833ab84f919bec$var$_setPrototypeOf(o, p);
}
function $4b833ab84f919bec$var$_defineProperty(obj, key, value) {
    key = $4b833ab84f919bec$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4b833ab84f919bec$var$_toPropertyKey(t) {
    var i = $4b833ab84f919bec$var$_toPrimitive(t, "string");
    return "symbol" == $4b833ab84f919bec$var$_typeof(i) ? i : i + "";
}
function $4b833ab84f919bec$var$_toPrimitive(t, r) {
    if ("object" != $4b833ab84f919bec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4b833ab84f919bec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4b833ab84f919bec$export$2363a7fa7edfe988 = /*#__PURE__*/ function(_React$Component) {
    function ZAxis() {
        $4b833ab84f919bec$var$_classCallCheck(this, ZAxis);
        return $4b833ab84f919bec$var$_callSuper(this, ZAxis, arguments);
    }
    $4b833ab84f919bec$var$_inherits(ZAxis, _React$Component);
    return $4b833ab84f919bec$var$_createClass(ZAxis, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
}($acw62.Component);
$4b833ab84f919bec$var$_defineProperty($4b833ab84f919bec$export$2363a7fa7edfe988, "displayName", 'ZAxis');
$4b833ab84f919bec$var$_defineProperty($4b833ab84f919bec$export$2363a7fa7edfe988, "defaultProps", {
    zAxisId: 0,
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number'
});









var $acw62 = parcelRequire("acw62");


var $d884628ff7961cb5$var$_excluded = [
    "option",
    "isActive"
];
function $d884628ff7961cb5$var$_extends() {
    $d884628ff7961cb5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d884628ff7961cb5$var$_extends.apply(this, arguments);
}
function $d884628ff7961cb5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d884628ff7961cb5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d884628ff7961cb5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d884628ff7961cb5$export$569fa72fa47640a8(_ref) {
    var option = _ref.option, isActive = _ref.isActive, props = $d884628ff7961cb5$var$_objectWithoutProperties(_ref, $d884628ff7961cb5$var$_excluded);
    if (typeof option === 'string') return /*#__PURE__*/ $acw62.createElement((0, $4696e249b64cd95e$export$6428a7f2611ef1fa), $d884628ff7961cb5$var$_extends({
        option: /*#__PURE__*/ $acw62.createElement((0, $61aa615b92178b76$export$fa456266707bf4e4), $d884628ff7961cb5$var$_extends({
            type: option
        }, props)),
        isActive: isActive,
        shapeType: "symbols"
    }, props));
    return /*#__PURE__*/ $acw62.createElement((0, $4696e249b64cd95e$export$6428a7f2611ef1fa), $d884628ff7961cb5$var$_extends({
        option: option,
        isActive: isActive,
        shapeType: "symbols"
    }, props));
}


var $f1fa5e465a89a19f$var$_Scatter;
function $f1fa5e465a89a19f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f1fa5e465a89a19f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f1fa5e465a89a19f$var$_typeof(o);
}
function $f1fa5e465a89a19f$var$_extends() {
    $f1fa5e465a89a19f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f1fa5e465a89a19f$var$_extends.apply(this, arguments);
}
function $f1fa5e465a89a19f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1fa5e465a89a19f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1fa5e465a89a19f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f1fa5e465a89a19f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1fa5e465a89a19f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f1fa5e465a89a19f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f1fa5e465a89a19f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f1fa5e465a89a19f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f1fa5e465a89a19f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f1fa5e465a89a19f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f1fa5e465a89a19f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f1fa5e465a89a19f$var$_callSuper(t, o, e) {
    return o = $f1fa5e465a89a19f$var$_getPrototypeOf(o), $f1fa5e465a89a19f$var$_possibleConstructorReturn(t, $f1fa5e465a89a19f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $f1fa5e465a89a19f$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $f1fa5e465a89a19f$var$_possibleConstructorReturn(self, call) {
    if (call && ($f1fa5e465a89a19f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f1fa5e465a89a19f$var$_assertThisInitialized(self);
}
function $f1fa5e465a89a19f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f1fa5e465a89a19f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f1fa5e465a89a19f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f1fa5e465a89a19f$var$_getPrototypeOf(o) {
    $f1fa5e465a89a19f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f1fa5e465a89a19f$var$_getPrototypeOf(o);
}
function $f1fa5e465a89a19f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f1fa5e465a89a19f$var$_setPrototypeOf(subClass, superClass);
}
function $f1fa5e465a89a19f$var$_setPrototypeOf(o, p) {
    $f1fa5e465a89a19f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f1fa5e465a89a19f$var$_setPrototypeOf(o, p);
}
function $f1fa5e465a89a19f$var$_defineProperty(obj, key, value) {
    key = $f1fa5e465a89a19f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f1fa5e465a89a19f$var$_toPropertyKey(t) {
    var i = $f1fa5e465a89a19f$var$_toPrimitive(t, "string");
    return "symbol" == $f1fa5e465a89a19f$var$_typeof(i) ? i : i + "";
}
function $f1fa5e465a89a19f$var$_toPrimitive(t, r) {
    if ("object" != $f1fa5e465a89a19f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f1fa5e465a89a19f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f1fa5e465a89a19f$export$1c460fb4285edadc = /*#__PURE__*/ function(_PureComponent) {
    function Scatter() {
        var _this;
        $f1fa5e465a89a19f$var$_classCallCheck(this, Scatter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $f1fa5e465a89a19f$var$_callSuper(this, Scatter, [].concat(args));
        $f1fa5e465a89a19f$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $f1fa5e465a89a19f$var$_defineProperty(_this, "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
        });
        $f1fa5e465a89a19f$var$_defineProperty(_this, "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
        });
        $f1fa5e465a89a19f$var$_defineProperty(_this, "id", (0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('recharts-scatter-'));
        return _this;
    }
    $f1fa5e465a89a19f$var$_inherits(Scatter, _PureComponent);
    return $f1fa5e465a89a19f$var$_createClass(Scatter, [
        {
            key: "renderSymbolsStatically",
            value: function renderSymbolsStatically(points) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, activeShape = _this$props.activeShape, activeIndex = _this$props.activeIndex;
                var baseProps = (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false);
                return points.map(function(entry, i) {
                    var isActive = activeIndex === i;
                    var option = isActive ? activeShape : shape;
                    var props = $f1fa5e465a89a19f$var$_objectSpread($f1fa5e465a89a19f$var$_objectSpread({}, baseProps), entry);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $f1fa5e465a89a19f$var$_extends({
                        className: "recharts-scatter-symbol",
                        key: "symbol-".concat(entry === null || entry === void 0 ? void 0 : entry.cx, "-").concat(entry === null || entry === void 0 ? void 0 : entry.cy, "-").concat(entry === null || entry === void 0 ? void 0 : entry.size, "-").concat(i)
                    }, (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        role: "img"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d884628ff7961cb5$export$569fa72fa47640a8), $f1fa5e465a89a19f$var$_extends({
                        option: option,
                        isActive: isActive,
                        key: "symbol-".concat(i)
                    }, props)));
                });
            }
        },
        {
            key: "renderSymbolsWithAnimation",
            value: function renderSymbolsWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, points = _this$props2.points, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevPoints = this.state.prevPoints;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $324cdcf3b9db18d1$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = points.map(function(entry, index) {
                        var prev = prevPoints && prevPoints[index];
                        if (prev) {
                            var interpolatorCx = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.cx, entry.cx);
                            var interpolatorCy = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.cy, entry.cy);
                            var interpolatorSize = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(prev.size, entry.size);
                            return $f1fa5e465a89a19f$var$_objectSpread($f1fa5e465a89a19f$var$_objectSpread({}, entry), {}, {
                                cx: interpolatorCx(t),
                                cy: interpolatorCy(t),
                                size: interpolatorSize(t)
                            });
                        }
                        var interpolator = (0, $2ab3a7e25c8aba74$export$d871d53bd7eeb390)(0, entry.size);
                        return $f1fa5e465a89a19f$var$_objectSpread($f1fa5e465a89a19f$var$_objectSpread({}, entry), {}, {
                            size: interpolator(t)
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), null, _this3.renderSymbolsStatically(stepData));
                });
            }
        },
        {
            key: "renderSymbols",
            value: function renderSymbols() {
                var _this$props3 = this.props, points = _this$props3.points, isAnimationActive = _this$props3.isAnimationActive;
                var prevPoints = this.state.prevPoints;
                if (isAnimationActive && points && points.length && (!prevPoints || !(0, (/*@__PURE__*/$parcel$interopDefault($394ab417e9bd75cc$exports)))(prevPoints, points))) return this.renderSymbolsWithAnimation();
                return this.renderSymbolsStatically(points);
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar() {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props4 = this.props, points = _this$props4.points, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, children = _this$props4.children;
                var errorBarItems = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(children, (0, $7f4b989d0f2e91c6$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                return errorBarItems.map(function(item, i) {
                    var _item$props = item.props, direction = _item$props.direction, errorDataKey = _item$props.dataKey;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(item, {
                        key: "".concat(direction, "-").concat(errorDataKey, "-").concat(points[i]),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: direction === 'x' ? 'vertical' : 'horizontal',
                        dataPointFormatter: function dataPointFormatter(dataPoint, dataKey) {
                            return {
                                x: dataPoint.cx,
                                y: dataPoint.cy,
                                value: direction === 'x' ? +dataPoint.node.x : +dataPoint.node.y,
                                errorVal: (0, $cd015374923bb5c7$export$f97fc4a450f29a)(dataPoint, dataKey)
                            };
                        }
                    });
                });
            }
        },
        {
            key: "renderLine",
            value: function renderLine() {
                var _this$props5 = this.props, points = _this$props5.points, line = _this$props5.line, lineType = _this$props5.lineType, lineJointType = _this$props5.lineJointType;
                var scatterProps = (0, $008f02516c156322$export$d697c39a2985a4c)(this.props, false);
                var customLineProps = (0, $008f02516c156322$export$d697c39a2985a4c)(line, false);
                var linePoints, lineItem;
                if (lineType === 'joint') linePoints = points.map(function(entry) {
                    return {
                        x: entry.cx,
                        y: entry.cy
                    };
                });
                else if (lineType === 'fitting') {
                    var _getLinearRegression = (0, $2ab3a7e25c8aba74$export$484982720961754e)(points), xmin = _getLinearRegression.xmin, xmax = _getLinearRegression.xmax, a = _getLinearRegression.a, b = _getLinearRegression.b;
                    var linearExp = function linearExp(x) {
                        return a * x + b;
                    };
                    linePoints = [
                        {
                            x: xmin,
                            y: linearExp(xmin)
                        },
                        {
                            x: xmax,
                            y: linearExp(xmax)
                        }
                    ];
                }
                var lineProps = $f1fa5e465a89a19f$var$_objectSpread($f1fa5e465a89a19f$var$_objectSpread($f1fa5e465a89a19f$var$_objectSpread({}, scatterProps), {}, {
                    fill: 'none',
                    stroke: scatterProps && scatterProps.fill
                }, customLineProps), {}, {
                    points: linePoints
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(line)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(line, lineProps);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($004783abbde551e4$exports)))(line)) lineItem = line(lineProps);
                else lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $af2055905739b7f2$export$b0e83c3ef8d2db1), $f1fa5e465a89a19f$var$_extends({}, lineProps, {
                    type: lineJointType
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: "recharts-scatter-line",
                    key: "recharts-scatter-line"
                }, lineItem);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, points = _this$props6.points, line = _this$props6.line, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, id = _this$props6.id, isAnimationActive = _this$props6.isAnimationActive;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('recharts-scatter', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    className: layerClass,
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, line && this.renderLine(), this.renderErrorBar(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
                    key: "recharts-scatter-symbols"
                }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && (0, $88ab0dba0fc78576$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        }
    ]);
}((0, $acw62.PureComponent));
$f1fa5e465a89a19f$var$_Scatter = $f1fa5e465a89a19f$export$1c460fb4285edadc;
$f1fa5e465a89a19f$var$_defineProperty($f1fa5e465a89a19f$export$1c460fb4285edadc, "displayName", 'Scatter');
$f1fa5e465a89a19f$var$_defineProperty($f1fa5e465a89a19f$export$1c460fb4285edadc, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    zAxisId: 0,
    legendType: 'circle',
    lineType: 'joint',
    lineJointType: 'linear',
    data: [],
    shape: 'circle',
    hide: false,
    isAnimationActive: !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'linear'
});
/**
 * Compose the data of each group
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $f1fa5e465a89a19f$var$_defineProperty($f1fa5e465a89a19f$export$1c460fb4285edadc, "getComposedData", function(_ref2) {
    var xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, zAxis = _ref2.zAxis, item = _ref2.item, displayedData = _ref2.displayedData, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, offset = _ref2.offset;
    var tooltipType = item.props.tooltipType;
    var cells = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(item.props.children, (0, $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea));
    var xAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
    var yAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
    var zAxisDataKey = zAxis && zAxis.dataKey;
    var defaultRangeZ = zAxis ? zAxis.range : (0, $4b833ab84f919bec$export$2363a7fa7edfe988).defaultProps.range;
    var defaultZ = defaultRangeZ && defaultRangeZ[0];
    var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
    var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
    var points = displayedData.map(function(entry, index) {
        var x = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, xAxisDataKey);
        var y = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, yAxisDataKey);
        var z = !(0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(zAxisDataKey) && (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, zAxisDataKey) || '-';
        var tooltipPayload = [
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
                unit: xAxis.unit || '',
                value: x,
                payload: entry,
                dataKey: xAxisDataKey,
                type: tooltipType
            },
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($0ada68b02fed3a09$exports)))(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
                unit: yAxis.unit || '',
                value: y,
                payload: entry,
                dataKey: yAxisDataKey,
                type: tooltipType
            }
        ];
        if (z !== '-') tooltipPayload.push({
            name: zAxis.name || zAxis.dataKey,
            unit: zAxis.unit || '',
            value: z,
            payload: entry,
            dataKey: zAxisDataKey,
            type: tooltipType
        });
        var cx = (0, $cd015374923bb5c7$export$6e87f3defb83c3f)({
            axis: xAxis,
            ticks: xAxisTicks,
            bandSize: xBandSize,
            entry: entry,
            index: index,
            dataKey: xAxisDataKey
        });
        var cy = (0, $cd015374923bb5c7$export$6e87f3defb83c3f)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: yBandSize,
            entry: entry,
            index: index,
            dataKey: yAxisDataKey
        });
        var size = z !== '-' ? zAxis.scale(z) : defaultZ;
        var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
        return $f1fa5e465a89a19f$var$_objectSpread($f1fa5e465a89a19f$var$_objectSpread({}, entry), {}, {
            cx: cx,
            cy: cy,
            x: cx - radius,
            y: cy - radius,
            xAxis: xAxis,
            yAxis: yAxis,
            zAxis: zAxis,
            width: 2 * radius,
            height: 2 * radius,
            size: size,
            node: {
                x: x,
                y: y,
                z: z
            },
            tooltipPayload: tooltipPayload,
            tooltipPosition: {
                x: cx,
                y: cy
            },
            payload: entry
        }, cells && cells[index] && cells[index].props);
    });
    return $f1fa5e465a89a19f$var$_objectSpread({
        points: points
    }, offset);
});






var $669260e8074ac2f0$export$f881f4f9e4007a57 = (0, $6d459a69f64f5f55$export$77871aede60e6838)({
    chartName: 'ComposedChart',
    GraphicalChild: [
        (0, $f8a3115883abd1dc$export$17d680238e50603e),
        (0, $551fcf7b84a33486$export$ea1a111407f37557),
        (0, $e752e700473a8894$export$bbc6c6369b38e3d1),
        (0, $f1fa5e465a89a19f$export$1c460fb4285edadc)
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $f21953d5ea7d4fb8$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4)
        },
        {
            axisType: 'zAxis',
            AxisComp: (0, $4b833ab84f919bec$export$2363a7fa7edfe988)
        }
    ],
    formatAxisMap: (0, $7dad4d5151ba4a01$export$ece7de1383db5ac)
});


/**
 * Renders an Analyst ChartSpec over source rows through the same recharts
 * conventions the Trends tab uses (palette vars, neutral tooltip, compact
 * cents axis), so generated cards look native next to the built views.
 */ const $5bb53f4bb9f03f52$var$formatCompact = (cents)=>{
    const dollars = Math.abs(cents) / 100;
    const sign = cents < 0 ? "\u2212" : '';
    if (dollars >= 100000) return `${sign}$${Math.round(dollars / 1000)}k`;
    if (dollars >= 10000) return `${sign}$${(dollars / 1000).toFixed(1)}k`;
    return `${sign}$${Math.round(dollars).toLocaleString('en-US')}`;
};
const $5bb53f4bb9f03f52$var$formatExact = (cents)=>`${cents < 0 ? "\u2212" : ''}${(Math.abs(cents) / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    })}`;
const $5bb53f4bb9f03f52$var$paletteColor = (index)=>`var(--chart-${index % 8 + 1})`;
const $5bb53f4bb9f03f52$var$asNumber = (value)=>typeof value === 'number' && Number.isFinite(value) ? value : 0;
const $5bb53f4bb9f03f52$var$signFor = (negate)=>negate === true ? -1 : 1;
const $5bb53f4bb9f03f52$var$asLabel = (value)=>typeof value === 'string' ? value : typeof value === 'number' || typeof value === 'boolean' ? String(value) : value == null ? '' : JSON.stringify(value);
const $5bb53f4bb9f03f52$var$NeutralTooltip = ({ active: active, label: label, payload: payload, cents: cents })=>{
    if (active !== true || payload == null || payload.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-popover text-popover-foreground rounded-lg border px-3 py-2 text-xs shadow-md",
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground mb-1 font-medium",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col gap-1",
                children: payload.map((entry, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: $5bb53f4bb9f03f52$var$asLabel(entry.dataKey)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-foreground ml-auto pl-4 font-medium tabular-nums",
                                children: cents ? $5bb53f4bb9f03f52$var$formatExact($5bb53f4bb9f03f52$var$asNumber(entry.value)) : $5bb53f4bb9f03f52$var$asNumber(entry.value).toLocaleString('en-US')
                            })
                        ]
                    }, i))
            })
        ]
    });
};
/**
 * Pivot long rows (x, series, y) into wide rows keyed by series value —
 * the shape recharts multi-series charts consume.
 */ const $5bb53f4bb9f03f52$var$pivot = (rows, x, y, series)=>{
    const seriesKeys = [];
    const byX = new Map();
    for (const row of rows){
        const xValue = $5bb53f4bb9f03f52$var$asLabel(row[x]);
        const sValue = $5bb53f4bb9f03f52$var$asLabel(row[series]) || '(none)';
        if (!seriesKeys.includes(sValue)) seriesKeys.push(sValue);
        const wide = byX.get(xValue) ?? {
            [x]: xValue
        };
        wide[sValue] = $5bb53f4bb9f03f52$var$asNumber(row[y]);
        byX.set(xValue, wide);
    }
    return {
        data: [
            ...byX.values()
        ],
        seriesKeys: seriesKeys
    };
};
const $5bb53f4bb9f03f52$var$axisProps = {
    tick: {
        fill: 'var(--muted-foreground)',
        fontSize: 12
    },
    tickLine: false
};
const $5bb53f4bb9f03f52$var$formatAxis = (cents)=>(value)=>cents ? $5bb53f4bb9f03f52$var$formatCompact(value) : value.toLocaleString('en-US');
const $5bb53f4bb9f03f52$export$11ac7fd6993ae64e = ({ chart: chart, rows: rows })=>{
    if (chart.type === 'stat') {
        const value = $5bb53f4bb9f03f52$var$asNumber(rows[0]?.[chart.value]);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "text-foreground py-6 text-center text-3xl font-semibold tabular-nums",
            children: chart.format === 'number' ? value.toLocaleString('en-US') : $5bb53f4bb9f03f52$var$formatExact(value)
        });
    }
    if (chart.type === 'table') {
        const centsColumns = new Set(chart.centsColumns ?? []);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "overflow-x-auto",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: "w-full text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                className: "text-muted-foreground text-left text-xs",
                                children: chart.columns.map((column)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1 pr-3 font-medium",
                                        children: column
                                    }, column))
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: rows.slice(0, 50).map((row, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    className: "border-border border-t",
                                    children: chart.columns.map((column)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1 pr-3 tabular-nums whitespace-nowrap",
                                            children: centsColumns.has(column) ? $5bb53f4bb9f03f52$var$formatExact($5bb53f4bb9f03f52$var$asNumber(row[column])) : $5bb53f4bb9f03f52$var$asLabel(row[column])
                                        }, column))
                                }, i))
                        })
                    ]
                }),
                rows.length > 50 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-muted-foreground mt-1 text-right text-[11px]",
                    children: [
                        rows.length - 50,
                        " more rows not shown"
                    ]
                })
            ]
        });
    }
    const height = 260;
    if (chart.type === 'bars') {
        const cents = chart.format !== 'number';
        const sign = $5bb53f4bb9f03f52$var$signFor(chart.negate);
        const data = rows.map((row)=>({
                [chart.x]: $5bb53f4bb9f03f52$var$asLabel(row[chart.x]),
                [chart.y]: sign * $5bb53f4bb9f03f52$var$asNumber(row[chart.y])
            }));
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                height: height
            },
            className: "w-full",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $74d07378047db57c$export$94aefc399ef206a9), {
                    data: data,
                    layout: chart.horizontal === true ? 'vertical' : 'horizontal',
                    margin: {
                        top: 8,
                        right: 12,
                        bottom: 0,
                        left: 8
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                            stroke: "var(--border)",
                            strokeDasharray: "3 3",
                            vertical: false
                        }),
                        chart.horizontal === true ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                                    type: "number",
                                    tickFormatter: $5bb53f4bb9f03f52$var$formatAxis(cents),
                                    ...$5bb53f4bb9f03f52$var$axisProps,
                                    axisLine: {
                                        stroke: 'var(--border)'
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                                    type: "category",
                                    dataKey: chart.x,
                                    width: 120,
                                    ...$5bb53f4bb9f03f52$var$axisProps,
                                    axisLine: false
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                                    dataKey: chart.x,
                                    ...$5bb53f4bb9f03f52$var$axisProps,
                                    axisLine: {
                                        stroke: 'var(--border)'
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                                    tickFormatter: $5bb53f4bb9f03f52$var$formatAxis(cents),
                                    width: 64,
                                    ...$5bb53f4bb9f03f52$var$axisProps,
                                    axisLine: false
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bb53f4bb9f03f52$var$NeutralTooltip, {
                                cents: cents
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e752e700473a8894$export$bbc6c6369b38e3d1), {
                            dataKey: chart.y,
                            fill: "var(--chart-1)",
                            radius: 2,
                            isAnimationActive: false
                        })
                    ]
                })
            })
        });
    }
    // line / stackedArea
    const cents = chart.format !== 'number';
    const sign = $5bb53f4bb9f03f52$var$signFor(chart.negate);
    const signedRows = sign === 1 ? rows : rows.map((row)=>({
            ...row,
            [chart.y]: sign * $5bb53f4bb9f03f52$var$asNumber(row[chart.y])
        }));
    const { data: data, seriesKeys: seriesKeys } = chart.type === 'line' && chart.series == null ? {
        data: signedRows.map((row)=>({
                [chart.x]: $5bb53f4bb9f03f52$var$asLabel(row[chart.x]),
                [chart.y]: $5bb53f4bb9f03f52$var$asNumber(row[chart.y])
            })),
        seriesKeys: [
            chart.y
        ]
    } : $5bb53f4bb9f03f52$var$pivot(signedRows, chart.x, chart.y, chart.type === 'line' ? chart.series ?? '' : chart.series);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            height: height
        },
        className: "w-full",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $669260e8074ac2f0$export$f881f4f9e4007a57), {
                data: data,
                margin: {
                    top: 8,
                    right: 12,
                    bottom: 0,
                    left: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                        stroke: "var(--border)",
                        strokeDasharray: "3 3",
                        vertical: false
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                        dataKey: chart.x,
                        ...$5bb53f4bb9f03f52$var$axisProps,
                        axisLine: {
                            stroke: 'var(--border)'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                        tickFormatter: $5bb53f4bb9f03f52$var$formatAxis(cents),
                        width: 64,
                        ...$5bb53f4bb9f03f52$var$axisProps,
                        axisLine: false
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bb53f4bb9f03f52$var$NeutralTooltip, {
                            cents: cents
                        })
                    }),
                    seriesKeys.map((key, i)=>chart.type === 'stackedArea' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                            dataKey: key,
                            stackId: "stack",
                            stroke: $5bb53f4bb9f03f52$var$paletteColor(i),
                            fill: $5bb53f4bb9f03f52$var$paletteColor(i),
                            fillOpacity: 0.45,
                            isAnimationActive: false
                        }, key) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                            dataKey: key,
                            stroke: $5bb53f4bb9f03f52$var$paletteColor(i),
                            strokeWidth: 2,
                            dot: false,
                            isAnimationActive: false
                        }, key))
                ]
            })
        })
    });
};


/**
 * Executes a card source through analystRun and renders its chart — the
 * shared body of pinned cards and freshly proposed ones. cache-and-network
 * keeps a revisited board current: the source re-runs against live data,
 * which is the whole point of pinning specs instead of results.
 */ const $e097fe89bbbd3c10$var$isRows = (value)=>Array.isArray(value) && value.every((row)=>typeof row === 'object' && row != null);
const $e097fe89bbbd3c10$export$1a6335571afab9cf = ({ source: source, chart: chart })=>{
    const { data: data, loading: loading, error: error } = (0, $ce9d9e524be20f53$export$7ec599901543f4fc)({
        variables: {
            source: source
        },
        fetchPolicy: 'cache-and-network'
    });
    if (error != null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-destructive py-6 text-center text-sm",
        children: [
            "This card failed to refresh: ",
            error.message
        ]
    });
    if (data == null && loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground py-10 text-center text-sm",
        children: "Running\u2026"
    });
    const rows = data?.analystRun;
    if (!$e097fe89bbbd3c10$var$isRows(rows)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground py-6 text-center text-sm",
        children: "No rows."
    });
    if (rows.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground py-6 text-center text-sm",
        children: "Nothing in this window."
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bb53f4bb9f03f52$export$11ac7fd6993ae64e), {
        chart: chart,
        rows: rows
    });
};



var $acw62 = parcelRequire("acw62");
const $a7dc05bbe2343059$export$bc7cff2b1ff769cd = ()=>{
    const [turns, setTurns] = $acw62.useState([]);
    const [busy, setBusy] = $acw62.useState(false);
    const turnsRef = $acw62.useRef(turns);
    turnsRef.current = turns;
    const updateLast = $acw62.useCallback((update)=>{
        setTurns((current)=>{
            if (current.length === 0) return current;
            const next = [
                ...current
            ];
            next[next.length - 1] = update(next[next.length - 1]);
            return next;
        });
    }, []);
    const ask = $acw62.useCallback(async (question)=>{
        if (busy || question.trim().length === 0) return;
        setBusy(true);
        // The assistant side of history must include delivered cards — a
        // card-only answer would otherwise vanish, making "break that down"
        // reference nothing.
        const history = turnsRef.current.flatMap((turn)=>{
            const cardsNote = turn.cards.length > 0 ? `\n[Delivered cards: ${JSON.stringify(turn.cards)}]` : '';
            const assistantText = `${turn.text}${cardsNote}`.trim();
            return [
                {
                    role: 'user',
                    text: turn.question
                },
                ...assistantText.length > 0 ? [
                    {
                        role: 'assistant',
                        text: assistantText
                    }
                ] : []
            ];
        });
        setTurns((current)=>[
                ...current,
                {
                    question: question,
                    text: '',
                    tools: [],
                    cards: [],
                    error: null,
                    streaming: true
                }
            ]);
        try {
            // Auth rides on the httpOnly session cookie; the dev proxy makes
            // this same-origin.
            const response = await fetch('/api/analyst/chat', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    question: question,
                    history: history
                })
            });
            if (!response.ok) {
                const text = await response.text();
                throw new Error(`HTTP ${response.status}: ${text}`);
            }
            const reader = response.body?.getReader();
            if (!reader) throw new Error('No response body');
            const decoder = new TextDecoder();
            let buffer = '';
            for(;;){
                const { done: done, value: value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, {
                    stream: true
                });
                const lines = buffer.split('\n');
                buffer = lines.pop() ?? '';
                for (const line of lines){
                    if (!line.startsWith('data: ')) continue;
                    const data = line.slice(6);
                    if (!data) continue;
                    const event = JSON.parse(data);
                    if (event.type === 'text_delta') updateLast((turn)=>({
                            ...turn,
                            text: turn.text + event.text
                        }));
                    else if (event.type === 'tool_started') updateLast((turn)=>({
                            ...turn,
                            tools: [
                                ...turn.tools,
                                {
                                    toolCallId: event.toolCallId,
                                    name: event.name,
                                    summary: event.summary,
                                    done: false,
                                    ok: true
                                }
                            ]
                        }));
                    else if (event.type === 'tool_finished') updateLast((turn)=>({
                            ...turn,
                            tools: turn.tools.map((tool)=>tool.toolCallId === event.toolCallId ? {
                                    ...tool,
                                    done: true,
                                    ok: event.ok
                                } : tool)
                        }));
                    else if (event.type === 'card') updateLast((turn)=>({
                            ...turn,
                            cards: [
                                ...turn.cards,
                                event.card
                            ]
                        }));
                    else if (event.type === 'error') updateLast((turn)=>({
                            ...turn,
                            error: event.message
                        }));
                }
            }
        } catch (error) {
            const message = error instanceof Error ? error.message : 'Analyst chat failed';
            updateLast((turn)=>({
                    ...turn,
                    error: message
                }));
        } finally{
            updateLast((turn)=>({
                    ...turn,
                    streaming: false
                }));
            setBusy(false);
        }
    }, [
        busy,
        updateLast
    ]);
    return {
        turns: turns,
        busy: busy,
        ask: ask
    };
};




/**
 * The Analyst tab: the pinned board (cards that re-run their sources
 * against live data on every visit) above the chat where the agent
 * explores the ledger and proposes new cards.
 */ const $acbbdb427c0b5d6c$var$SUGGESTIONS = [
    'How is my spending trending this year vs last?',
    'What are my five biggest payees this year?',
    'Which categories grew the most over the last 90 days?'
];
const $acbbdb427c0b5d6c$var$PinnedCard = ({ id: id, question: question, title: title, commentary: commentary, source: source, chart: chart, onUnpin: onUnpin })=>{
    const [showSource, setShowSource] = $acw62.useState(false);
    const parsedSource = (0, $3b46909955ca740a$export$674d3f10d8d68c9c).safeParse(source);
    const parsedChart = (0, $3b46909955ca740a$export$6aa3ac8dbdcdc829).safeParse(chart);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border rounded-lg border p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-1 flex items-baseline justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-foreground text-sm font-semibold",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex shrink-0 gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setShowSource((v)=>!v),
                                className: "text-muted-foreground hover:text-foreground text-xs",
                                children: "Source"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onUnpin(id),
                                className: "text-muted-foreground hover:text-foreground text-xs",
                                children: "Unpin"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground mb-2 text-xs",
                children: question
            }),
            parsedSource.success && parsedChart.success ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e097fe89bbbd3c10$export$1a6335571afab9cf), {
                source: parsedSource.data,
                chart: parsedChart.data
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-destructive py-4 text-center text-sm",
                children: "This card's stored spec is no longer valid \u2014 unpin and re-ask."
            }),
            commentary != null && commentary.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground mt-2 text-xs",
                children: commentary
            }),
            showSource && parsedSource.success && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                className: "bg-muted text-muted-foreground mt-2 max-h-48 overflow-auto rounded p-2 text-[11px]",
                children: JSON.stringify(parsedSource.data, null, 2)
            })
        ]
    });
};
const $acbbdb427c0b5d6c$var$ProposedCard = ({ card: card, question: question, onPin: onPin })=>{
    // Pinned-ness is this proposal's own mutation outcome — titles are
    // model-generated display text with no uniqueness, so they can never be
    // the identity. 'pinning' disables the button the instant the first
    // click lands, so a double-click cannot mint duplicate cards.
    const [state, setState] = $acw62.useState('idle');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card rounded-lg border p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-1 flex items-baseline justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-foreground text-sm font-semibold",
                        children: card.title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        className: "px-2 py-0.5 text-xs",
                        disabled: state !== 'idle',
                        onClick: ()=>{
                            setState('pinning');
                            onPin(question, card).then((ok)=>{
                                setState(ok ? 'pinned' : 'idle');
                            });
                        },
                        children: state === 'pinned' ? 'Pinned' : state === 'pinning' ? "Pinning\u2026" : 'Pin'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e097fe89bbbd3c10$export$1a6335571afab9cf), {
                source: card.source,
                chart: card.chart
            }),
            card.commentary != null && card.commentary.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground mt-2 text-xs",
                children: card.commentary
            })
        ]
    });
};
const $acbbdb427c0b5d6c$var$Turn = ({ turn: turn, onPin: onPin })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "self-end",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-primary text-primary-foreground max-w-xl rounded-lg px-3 py-1.5 text-sm",
                    children: turn.question
                })
            }),
            turn.tools.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-wrap gap-1.5",
                children: turn.tools.map((tool)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('rounded-full border px-2 py-0.5 text-[11px]', tool.done ? tool.ok ? 'border-border text-muted-foreground' : 'border-destructive text-destructive' : 'border-border text-foreground animate-pulse'),
                        title: tool.summary,
                        children: tool.name
                    }, tool.toolCallId))
            }),
            turn.cards.map((card, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acbbdb427c0b5d6c$var$ProposedCard, {
                    card: card,
                    question: turn.question,
                    onPin: onPin
                }, i)),
            turn.text.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-foreground max-w-3xl text-sm whitespace-pre-wrap",
                children: turn.text
            }),
            turn.error != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-destructive text-sm",
                children: turn.error
            }),
            turn.streaming && turn.text.length === 0 && turn.tools.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground text-sm",
                children: "Thinking\u2026"
            })
        ]
    });
const $acbbdb427c0b5d6c$export$940c04e354cf6222 = ()=>{
    const { data: data, error: error, refetch: refetch } = (0, $ce9d9e524be20f53$export$9a225e934a844fbf)({
        fetchPolicy: 'cache-and-network'
    });
    const [pinCard] = (0, $ce9d9e524be20f53$export$9853c752e055c1df)();
    const [unpinCard] = (0, $ce9d9e524be20f53$export$ab389ddab2f96c84)();
    const { turns: turns, busy: busy, ask: ask } = (0, $a7dc05bbe2343059$export$bc7cff2b1ff769cd)();
    const [draft, setDraft] = $acw62.useState('');
    const bottomRef = $acw62.useRef(null);
    const cards = data?.analystCards ?? [];
    const handlePin = async (question, card)=>{
        try {
            await pinCard({
                variables: {
                    question: question,
                    card: card
                }
            });
            refetch();
            return true;
        } catch  {
            return false;
        }
    };
    const handleUnpin = (id)=>{
        unpinCard({
            variables: {
                id: id
            },
            onCompleted: ()=>void refetch()
        });
    };
    const submit = ()=>{
        const question = draft.trim();
        if (question.length === 0 || busy) return;
        setDraft('');
        ask(question).then(()=>{
            bottomRef.current?.scrollIntoView({
                behavior: 'smooth'
            });
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mx-auto flex max-w-5xl flex-col gap-4 p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "text-foreground text-xl font-semibold",
                        children: "Insights"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground text-sm",
                        children: "Ask questions about the ledger; pin the answers. Pinned cards re-run their query against live data on every visit."
                    })
                ]
            }),
            error != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-destructive text-sm",
                children: [
                    "Couldn't load pinned cards: ",
                    error.message
                ]
            }),
            cards.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-1 gap-3 md:grid-cols-2",
                children: cards.map((card)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acbbdb427c0b5d6c$var$PinnedCard, {
                        id: card._id,
                        question: card.question,
                        title: card.title,
                        commentary: card.commentary ?? null,
                        source: card.source,
                        chart: card.chart,
                        onUnpin: handleUnpin
                    }, card._id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    turns.map((turn, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acbbdb427c0b5d6c$var$Turn, {
                            turn: turn,
                            onPin: handlePin
                        }, i)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        ref: bottomRef
                    })
                ]
            }),
            turns.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-wrap gap-2",
                children: $acbbdb427c0b5d6c$var$SUGGESTIONS.map((suggestion)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>void ask(suggestion),
                        className: "border-border text-muted-foreground hover:text-foreground rounded-full border px-3 py-1 text-xs",
                        children: suggestion
                    }, suggestion))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        value: draft,
                        onChange: (event)=>setDraft(event.target.value),
                        onKeyDown: (event)=>{
                            if (event.key === 'Enter') {
                                event.preventDefault();
                                submit();
                            }
                        },
                        placeholder: busy ? "Working\u2026" : "Ask about your money\u2026",
                        disabled: busy,
                        className: "border-border bg-background text-foreground placeholder:text-muted-foreground flex-1 rounded-lg border px-3 py-2 text-sm"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: submit,
                        disabled: busy,
                        children: "Ask"
                    })
                ]
            })
        ]
    });
};







var $acw62 = parcelRequire("acw62");

/**
 * Pure model-building for the cash-flow sankey. Everything here is derived
 * from data — category names and the fold into "everything else" come from
 * the rollup rows, never from hardcoded names, and no annotation is needed
 * anywhere: the diagram balances by explicit remainder bands ("Saving" when
 * income exceeded outflows, "From savings" when outflows exceeded income).
 *
 * The overview reads left to right: income sources merge into a single
 * income spine, the spine splits three ways (taxes / spending / saving),
 * and Spending fans out into categories. Merging at the spine dissolves
 * the "which dollars funded what" question — deposited money is fungible,
 * so no per-source attribution is claimed at all. The display order still
 * tells the household story by adjacency: the paycheck sits at the top
 * beside the Taxes and Spending offtakes, other incomes rise by size, the
 * largest windfall lands beside Saving, and a bound retirement category
 * pins to the very bottom — its dollars are definitionally savings.
 *
 * Amounts are integer cents throughout; formatting happens at render time.
 */ /** Sides always balance; the caller can rely on it for layout. */ const $2105210cbd797d00$var$totalOf = (nodes)=>nodes.reduce((sum, node)=>sum + node.value, 0);
const $2105210cbd797d00$export$127388d0d1029689 = (value, base)=>{
    // "<1%" is for positive slivers only — an exact zero shows no share at
    // all rather than implying one.
    if (base <= 0 || value <= 0 || value >= base) return null;
    const share = value / base;
    return share < 0.005 ? '<1%' : `${Math.round(share * 100)}%`;
};
/**
 * Keep the largest `keep` rows and fold the tail into one node, so the
 * diagram caps its node count no matter how many categories exist. A tail
 * of one is not folded — a fold node that replaces a single row would hide
 * information without saving space.
 */ const $2105210cbd797d00$var$foldTail = (nodes, keep, foldLabel)=>{
    if (nodes.length <= keep + 1) return nodes;
    const kept = nodes.slice(0, keep);
    const tail = nodes.slice(keep);
    return [
        ...kept,
        {
            key: null,
            label: foldLabel,
            sublabel: `${tail.length} smaller`,
            value: $2105210cbd797d00$var$totalOf(tail),
            kind: tail[0].kind
        }
    ];
};
const $2105210cbd797d00$var$byValueDesc = (a, b)=>b.value - a.value;
/**
 * Member categories below this share of Spending fold into their group's
 * "Other" node. Count caps never fire on a well-grouped long tail (no
 * single group exceeds them), yet most drawn nodes explain almost none of
 * the money — the floor folds by contribution instead. "Show all
 * categories" disables it along with the count caps.
 */ const $2105210cbd797d00$var$MEMBER_SHARE_FLOOR = 0.02;
/**
 * A windfall that arrives and sits unspent dominates the map as a
 * pass-through pair: the largest income node and the Saving tier are mostly
 * the same dollars, and drawn at true scale they crush every real flow into
 * slivers. When the pair dwarfs the largest other node, both members — and
 * the ribbon joining them — shrink by the same amount, so everything else
 * stays proportionate while labels keep true values.
 */ const $2105210cbd797d00$var$SCALE_BREAK_FACTOR = 2;
const $2105210cbd797d00$var$applyTieredScaleBreak = (model)=>{
    const saving = model.allocs.find((node)=>node.kind === 'saving-tier');
    const incomes = model.sources.filter((node)=>node.kind === 'income');
    if (saving == null || incomes.length === 0) return model;
    const largestIncome = incomes.reduce((a, b)=>b.value > a.value ? b : a);
    const reference = Math.max(0, ...[
        ...model.sources,
        ...model.allocs,
        ...model.groupCol,
        ...model.cats
    ].filter((node)=>node !== saving && node !== largestIncome).map((node)=>node.value));
    const cap = $2105210cbd797d00$var$SCALE_BREAK_FACTOR * reference;
    const passThrough = Math.min(saving.value, largestIncome.value);
    if (reference <= 0 || passThrough <= cap) return model;
    const hidden = passThrough - cap;
    const compressNode = (node)=>({
            ...node,
            displayValue: node.value - hidden
        });
    return {
        ...model,
        sources: model.sources.map((node)=>node === largestIncome ? compressNode(node) : node),
        allocs: model.allocs.map((node)=>node === saving ? compressNode(node) : node),
        scaleBreak: {
            label: largestIncome.label,
            hidden: hidden
        }
    };
};
const $2105210cbd797d00$export$50352cace0182bde = (model)=>({
        ...model,
        sources: model.sources.map(({ displayValue: _d, ...node })=>node),
        allocs: model.allocs.map(({ displayValue: _d, ...node })=>node),
        groupCol: model.groupCol.map(({ displayValue: _d, ...node })=>node),
        cats: model.cats.map(({ displayValue: _d, ...node })=>node)
    });
const $2105210cbd797d00$export$7b01e035c703c48d = ({ groups: groups, categoriesById: categoriesById, categoryGroups: categoryGroups = [], payroll: payroll, unreviewed: unreviewed, maxNodes: maxNodes = 7 })=>{
    // Null keys are the server's bucket for payments whose category was
    // unset; they stay in the totals under a plain name and aren't drillable.
    const labelFor = (key)=>key == null ? 'Uncategorized' : categoriesById.get(key)?.name ?? 'Unknown category';
    const withheld = payroll != null && payroll.taxesWithheld > 0 ? payroll.taxesWithheld : 0;
    let working = groups;
    // Paycheck merge: the withheld dollars join the paycheck's own income
    // node (deposits plus withholding — see FlowPayroll for why that is not
    // full gross); without a binding they render as the standalone band.
    let paycheckNode = null;
    if (withheld > 0) {
        const paycheckKey = payroll?.paycheckCategoryId ?? null;
        const paycheckGroup = paycheckKey != null ? working.find((group)=>group.key === paycheckKey) ?? null : null;
        // Only a positive-net paycheck group merges: a net-negative window
        // (reversal-heavy) would make the node smaller than the exact
        // withholding link it must emit, breaking ribbon conservation — the
        // category stays on the spend side and the standalone band carries
        // the withholding instead.
        if (paycheckGroup != null && paycheckGroup.net > 0) {
            working = working.filter((group)=>group !== paycheckGroup);
            paycheckNode = {
                key: paycheckKey,
                label: labelFor(paycheckKey),
                sublabel: 'incl. withheld pay',
                value: paycheckGroup.net + withheld,
                kind: 'income'
            };
        }
    }
    // Retirement pin: the bound category's inflow is income that is
    // definitionally savings, so it sits at the very bottom of the source
    // column, beside the Saving tier it becomes. Display-only — its dollars
    // flow through the spine like any other income.
    let retirementNode = null;
    const retirementKey = payroll?.retirementCategoryId ?? null;
    const retirementGroup = retirementKey != null ? working.find((group)=>group.key === retirementKey) ?? null : null;
    if (retirementGroup != null && retirementGroup.net > 0) {
        working = working.filter((group)=>group !== retirementGroup);
        retirementNode = {
            key: retirementKey,
            label: labelFor(retirementKey),
            value: retirementGroup.net,
            kind: 'income'
        };
    }
    // Taxes tier: withheld plus the bound category's cash net (payments add,
    // refunds subtract). A refund surplus flows back to the income side under
    // the category's own name.
    const taxesKey = payroll?.taxesCategoryId ?? null;
    const taxesGroup = taxesKey != null ? working.find((group)=>group.key === taxesKey) ?? null : null;
    if (taxesGroup != null) working = working.filter((group)=>group !== taxesGroup);
    const taxesTier = Math.max(0, withheld - (taxesGroup?.net ?? 0));
    const taxesRefund = Math.max(0, (taxesGroup?.net ?? 0) - withheld);
    const income = working.filter((group)=>group.net > 0);
    const spend = working.filter((group)=>group.net < 0);
    // The paycheck node is the withholding carrier: the ribbon attribution
    // needs it as a distinct node, so it never folds into "Other income" —
    // only the other incomes compete for the remaining slots.
    const foldableIncome = [
        ...income.map((group)=>({
                key: group.key,
                label: labelFor(group.key),
                value: group.net,
                kind: 'income'
            })),
        ...taxesRefund > 0 && taxesGroup != null ? [
            {
                key: taxesKey,
                label: labelFor(taxesKey),
                value: taxesRefund,
                kind: 'income'
            }
        ] : []
    ].sort($2105210cbd797d00$var$byValueDesc);
    // Display order tells the story by adjacency through the spine: the
    // withholding carrier leads (beside the Taxes and Spending offtakes),
    // other incomes rise in value so the largest lands beside Saving, and
    // the pinned retirement node sits at the very bottom.
    const reserved = (paycheckNode != null ? 1 : 0) + (retirementNode != null ? 1 : 0);
    // The same share floor as the member fans: income slivers fold into
    // "Other income" by contribution, with the count cap as backstop. The
    // floor is measured against the whole income side (carrier and pins
    // included), not just the foldable remainder.
    const incomeBase = $2105210cbd797d00$var$totalOf(foldableIncome) + (paycheckNode?.value ?? 0) + (retirementNode?.value ?? 0) + (paycheckNode == null ? withheld : 0);
    const incomeFloor = Number.isFinite(maxNodes) ? $2105210cbd797d00$var$MEMBER_SHARE_FLOOR * incomeBase : 0;
    const keptIncome = foldableIncome.filter((node)=>node.value >= incomeFloor);
    const incomeTail = foldableIncome.filter((node)=>node.value < incomeFloor);
    const flooredIncome = incomeTail.length <= 1 ? foldableIncome : [
        ...keptIncome,
        {
            key: null,
            label: 'Other income',
            sublabel: `${incomeTail.length} smaller`,
            value: $2105210cbd797d00$var$totalOf(incomeTail),
            kind: 'income'
        }
    ];
    const folded = $2105210cbd797d00$var$foldTail(flooredIncome, Math.max(1, maxNodes - reserved), 'Other income').sort((a, b)=>a.value - b.value);
    const sources = [
        ...paycheckNode != null ? [
            paycheckNode
        ] : [],
        ...withheld > 0 && paycheckNode == null ? [
            {
                key: null,
                label: 'Withheld pay',
                sublabel: 'taxes taken before deposit',
                value: withheld,
                kind: 'withheld'
            }
        ] : [],
        ...folded,
        ...retirementNode != null ? [
            retirementNode
        ] : []
    ];
    // Group tier: partition the spend categories by their category group.
    // A group with two or more active members becomes an aggregate that fans
    // into them; a group with one active member, and every ungrouped
    // category, stands as itself and ends in the group column — a child that
    // duplicates its parent would add space without information.
    const spendNodes = spend.map((group)=>({
            key: group.key,
            label: labelFor(group.key),
            value: -group.net,
            kind: 'spend'
        })).sort($2105210cbd797d00$var$byValueDesc);
    const groupByCategory = new Map();
    for (const categoryGroup of categoryGroups)for (const id of categoryGroup.categoryIds)groupByCategory.set(id, categoryGroup);
    const memberships = new Map();
    const standalone = [];
    for (const node of spendNodes){
        const categoryGroup = node.key != null ? groupByCategory.get(node.key) : undefined;
        if (categoryGroup == null) standalone.push(node);
        else {
            const members = memberships.get(categoryGroup._id) ?? [];
            members.push(node);
            memberships.set(categoryGroup._id, members);
        }
    }
    const groupEntries = [
        ...standalone
    ];
    for (const [groupId, members] of memberships){
        const info = categoryGroups.find((categoryGroup)=>categoryGroup._id === groupId);
        if (members.length === 1 || info == null) groupEntries.push(...members);
        else // No "N categories" sublabel: the fan to the node's right already
        // shows the members, and the extra text collides with child labels
        // when the bar is compact.
        groupEntries.push({
            key: null,
            groupId: groupId,
            label: info.name,
            color: info.color,
            value: $2105210cbd797d00$var$totalOf(members),
            kind: 'spend-group'
        });
    }
    const groupCol = $2105210cbd797d00$var$foldTail(groupEntries.sort($2105210cbd797d00$var$byValueDesc), maxNodes, 'Everything else');
    // Children fan out only for aggregates that survived the fold — a group
    // folded into the tail keeps its dollars inside the fold node.
    const spendingTotal = $2105210cbd797d00$var$totalOf(groupCol);
    const memberFloor = Number.isFinite(maxNodes) ? $2105210cbd797d00$var$MEMBER_SHARE_FLOOR * spendingTotal : 0;
    const cats = groupCol.flatMap((entry)=>{
        if (entry.kind !== 'spend-group' || entry.groupId == null) return [];
        const members = memberships.get(entry.groupId) ?? [];
        const kept = members.filter((member)=>member.value >= memberFloor);
        const tail = members.filter((member)=>member.value < memberFloor);
        // No member clears the floor: the group node stands terminal — a fan
        // of nothing but "Other" would duplicate the parent.
        if (kept.length === 0) return [];
        // A tail of one keeps its name (a fold node replacing a single row
        // hides information without saving space).
        // Plain "Other": the ribbon already names the group, and the long
        // form truncated into noise while clipping the right edge.
        const shaped = tail.length <= 1 ? members : [
            ...kept,
            {
                key: null,
                label: 'Other',
                sublabel: `${tail.length} smaller`,
                value: $2105210cbd797d00$var$totalOf(tail),
                kind: 'spend'
            }
        ];
        return $2105210cbd797d00$var$foldTail(shaped, maxNodes, `Other ${entry.label}`).map((member)=>({
                ...member,
                groupId: entry.groupId
            }));
    });
    // totals.income is real income only — the balancing "From savings" band
    // joins the source column (so ribbons conserve) but never the caption's
    // income figure, which would overstate the window and double-describe
    // the draw. The unreviewed band is kept out the same way: its dollars
    // are nobody's income or spending until someone allocates them.
    const incomeTotal = $2105210cbd797d00$var$totalOf(sources);
    const unreviewedNet = unreviewed?.net ?? 0;
    const unreviewedNode = (value)=>({
            key: null,
            label: 'Unreviewed',
            // Short: the band is usually a sliver, drawn with a one-line label.
            // The caption carries the full explanation.
            sublabel: `${unreviewed?.count ?? 0} to review`,
            value: value,
            kind: 'unreviewed'
        });
    if (unreviewedNet > 0) sources.push(unreviewedNode(unreviewedNet));
    const unreviewedOut = Math.max(0, -unreviewedNet);
    let saving = incomeTotal + Math.max(0, unreviewedNet) - taxesTier - spendingTotal - unreviewedOut;
    let fromSavings = 0;
    if (saving < 0) {
        fromSavings = -saving;
        saving = 0;
        sources.push({
            key: null,
            label: 'From savings',
            sublabel: "outflows beyond the window\u2019s income",
            value: fromSavings,
            kind: 'reserve-draw'
        });
    }
    const allocs = [];
    if (taxesTier > 0) allocs.push({
        // Drillable into the bound category's payees when a binding exists;
        // the binding also names the tier — a window with withholding but no
        // cash tax rows still belongs to the bound category.
        key: taxesKey,
        label: taxesKey != null ? labelFor(taxesKey) : 'Taxes withheld',
        sublabel: taxesKey != null && withheld > 0 ? 'incl. payroll withholding' : undefined,
        value: taxesTier,
        kind: 'taxes-tier'
    });
    if (spendingTotal > 0) allocs.push({
        key: null,
        label: 'Spending',
        value: spendingTotal,
        kind: 'spending-tier'
    });
    if (saving > 0) allocs.push({
        key: null,
        label: 'Saving',
        sublabel: retirementNode != null ? 'incl. retirement contributions' : 'not spent this window',
        value: saving,
        kind: 'saving-tier'
    });
    // Last in the column: never inside Spending, never fanned into the
    // category columns, and below Saving so its label sits in open space
    // rather than under the Spending fan (it is usually a sliver, whose
    // one-line label reaches toward the group bars).
    if (unreviewedOut > 0) allocs.push(unreviewedNode(unreviewedOut));
    return $2105210cbd797d00$var$applyTieredScaleBreak({
        sources: sources,
        allocs: allocs,
        groupCol: groupCol,
        cats: cats,
        totals: {
            income: incomeTotal,
            taxes: taxesTier,
            spending: spendingTotal,
            saving: saving,
            fromSavings: fromSavings,
            unreviewed: unreviewedNet,
            unreviewedCount: unreviewed?.count ?? 0
        },
        scaleBreak: null
    });
};
const $2105210cbd797d00$export$886e9fee34b09da5 = ({ groups: groups, maxNodes: maxNodes = 7 })=>{
    const inflows = groups.filter((group)=>group.net > 0);
    const outflows = groups.filter((group)=>group.net < 0);
    const inflowTotal = inflows.reduce((sum, group)=>sum + group.net, 0);
    const outflowTotal = outflows.reduce((sum, group)=>sum - group.net, 0);
    const fromTakeHome = outflowTotal - inflowTotal;
    const sources = [];
    if (fromTakeHome > 0) sources.push({
        key: null,
        label: 'From take-home',
        value: fromTakeHome,
        kind: 'take-home'
    });
    sources.push(...$2105210cbd797d00$var$foldTail(inflows.map((group)=>({
            key: group.key,
            label: group.key ?? 'No payee',
            value: group.net,
            kind: 'income'
        })).sort($2105210cbd797d00$var$byValueDesc), maxNodes, 'Other inflows'));
    const dests = $2105210cbd797d00$var$foldTail(outflows.map((group)=>({
            key: group.key,
            label: group.key ?? 'No payee',
            value: -group.net,
            kind: 'spend'
        })).sort($2105210cbd797d00$var$byValueDesc), maxNodes, 'Everything else');
    if (fromTakeHome < 0) dests.push({
        key: null,
        label: 'To take-home',
        value: -fromTakeHome,
        kind: 'take-home'
    });
    return {
        sources: sources,
        dests: dests,
        totals: {
            spend: outflowTotal,
            income: inflowTotal,
            covered: Math.min(outflowTotal, inflowTotal),
            fromSavings: Math.max(0, fromTakeHome),
            saved: Math.max(0, -fromTakeHome)
        },
        scaleBreak: null
    };
};



parcelRequire("acw62");

const $7366ceaa664bffba$var$CHART_H = 360;
const $7366ceaa664bffba$var$VIEW_W = 1000;
const $7366ceaa664bffba$var$NODE_W = 10;
const $7366ceaa664bffba$var$GAP = 7;
const $7366ceaa664bffba$var$TOP = 24;
const $7366ceaa664bffba$var$X_LEFT = 250;
const $7366ceaa664bffba$var$X_SPINE = 520;
const $7366ceaa664bffba$var$X_RIGHT = 770;
const $7366ceaa664bffba$var$MIN_NODE_H = 6;
// Node color by role. Spend nodes cycle the categorical palette in slot
// order (the ordering is CVD-validated; see globals.css); the semantic bands
// use fixed slots so they read the same in every window.
// 'spend-group' never appears on the payee drill (it is a tiered-overview
// construct), so it is excluded alongside 'spend'.
const $7366ceaa664bffba$var$KIND_COLOR = {
    income: 'var(--chart-3)',
    'reserve-draw': 'var(--muted-foreground)',
    saved: 'var(--chart-3)',
    'take-home': 'var(--muted-foreground)',
    // Withheld pay is income that never arrived — a fixed slot distinct from
    // deposited income so the band reads as its own phenomenon.
    withheld: 'var(--chart-4)',
    // The unreviewed band, too, is an overview-only construct (the drill is
    // scoped to one category's allocated payments).
    unreviewed: 'var(--muted-foreground)',
    // Tier kinds live in the overview's TieredSankey; listed here only
    // because this map is exhaustive over FlowNodeKind.
    'taxes-tier': 'var(--chart-1)',
    'spending-tier': 'var(--muted-foreground)',
    'saving-tier': 'var(--chart-3)'
};
const $7366ceaa664bffba$var$nodeColor = (node, spendIndex)=>node.kind === 'spend' || node.kind === 'spend-group' ? `var(--chart-${spendIndex % 8 + 1})` : $7366ceaa664bffba$var$KIND_COLOR[node.kind];
const $7366ceaa664bffba$var$drawnValueOf = (node)=>node.displayValue ?? node.value;
const $7366ceaa664bffba$var$layout = (nodes, scale)=>{
    let y = $7366ceaa664bffba$var$TOP;
    let spineY = $7366ceaa664bffba$var$TOP;
    let spendIndex = 0;
    return nodes.map((node)=>{
        const drawnValue = $7366ceaa664bffba$var$drawnValueOf(node);
        const h = Math.max($7366ceaa664bffba$var$MIN_NODE_H, drawnValue * scale);
        const laid = {
            node: node,
            y: y,
            h: h,
            spineY: spineY,
            drawnValue: drawnValue,
            color: $7366ceaa664bffba$var$nodeColor(node, node.kind === 'spend' ? spendIndex : 0)
        };
        if (node.kind === 'spend') spendIndex += 1;
        y += h + $7366ceaa664bffba$var$GAP;
        spineY += drawnValue * scale;
        return laid;
    });
};
// The axis-break convention: a background-colored gap crossed by two
// slanted hairlines, laid over the node bar and the mouth of its ribbon.
const $7366ceaa664bffba$var$BreakGlyph = ({ x0: x0, x1: x1, y: y })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: x0,
                y1: y + 4,
                x2: x1,
                y2: y - 4,
                className: "stroke-background",
                strokeWidth: 9
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: x0,
                y1: y + 8,
                x2: x1,
                y2: y,
                className: "stroke-muted-foreground",
                strokeWidth: 1.5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: x0,
                y1: y,
                x2: x1,
                y2: y - 8,
                className: "stroke-muted-foreground",
                strokeWidth: 1.5
            })
        ]
    });
const $7366ceaa664bffba$var$ribbonPath = (x0, y0, h0, x1, y1, h1)=>{
    const mid = (x0 + x1) / 2;
    return [
        `M ${x0} ${y0}`,
        `C ${mid} ${y0}, ${mid} ${y1}, ${x1} ${y1}`,
        `L ${x1} ${y1 + h1}`,
        `C ${mid} ${y1 + h1}, ${mid} ${y0 + h0}, ${x0} ${y0 + h0}`,
        'Z'
    ].join(' ');
};
// Long payee names would run off the right edge of the viewBox; the ribbon
// tooltip still carries the full name.
const $7366ceaa664bffba$var$truncate = (label, max = 24)=>label.length > max ? `${label.slice(0, max - 1)}\u{2026}` : label;
// Two lines when the node is tall enough, one compact line otherwise —
// short nodes stacked close together collide with two-line labels.
const $7366ceaa664bffba$var$NodeLabel = ({ laid: laid, x: x, anchor: anchor, formatValue: formatValue, share: share })=>{
    const { node: node, y: y, h: h } = laid;
    const mid = y + h / 2;
    const compressed = laid.drawnValue < node.value;
    const sublabel = compressed ? 'scale break' : node.sublabel;
    const value = formatValue(node.value) + (share != null ? ` \xb7 ${share}` : '');
    // The share lengthened the one-line form; compact labels shorten the
    // name to keep the whole line inside the label budget.
    const label = $7366ceaa664bffba$var$truncate(node.label, h < 30 && share != null ? 18 : 24);
    if (h >= 30) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                x: x,
                y: mid - 1,
                textAnchor: anchor,
                className: "fill-foreground text-[13px] font-semibold",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("text", {
                x: x,
                y: mid + 14,
                textAnchor: anchor,
                className: "fill-muted-foreground text-[11.5px]",
                children: [
                    value,
                    sublabel ? ` \xb7 ${sublabel}` : ''
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("text", {
        x: x,
        y: mid + 4.5,
        textAnchor: anchor,
        className: "fill-foreground text-[12.5px] font-semibold",
        children: [
            label,
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tspan", {
                className: "fill-muted-foreground text-[11.5px] font-normal",
                children: [
                    "\xb7 ",
                    value
                ]
            })
        ]
    });
};
const $7366ceaa664bffba$export$ac21bfdd444142f6 = (props)=>{
    const { sources: sources, dests: dests, onSelectDest: onSelectDest, formatValue: formatValue } = props;
    const total = sources.reduce((sum, node)=>sum + $7366ceaa664bffba$var$drawnValueOf(node), 0);
    if (total <= 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground py-12 text-center text-sm",
        children: "Nothing in this window."
    });
    const scale = $7366ceaa664bffba$var$CHART_H / total;
    // Share bases use TRUE values so a scale break can't distort them; each
    // side is its own base (the sides balance by construction).
    const sourcesTrue = sources.reduce((sum, node)=>sum + node.value, 0);
    const destsTrue = dests.reduce((sum, node)=>sum + node.value, 0);
    const shareSuffix = (value, base)=>{
        const share = (0, $2105210cbd797d00$export$127388d0d1029689)(value, base);
        return share != null ? ` (${share})` : '';
    };
    const left = $7366ceaa664bffba$var$layout(sources, scale);
    const right = $7366ceaa664bffba$var$layout(dests, scale);
    // The gaps between nodes push each side past the spine's height, so the
    // viewBox follows whichever side's last node ends lowest.
    const bottomOf = (side)=>{
        const last = side.at(-1);
        return last == null ? $7366ceaa664bffba$var$TOP : last.y + last.h;
    };
    const height = Math.max(bottomOf(left), bottomOf(right), $7366ceaa664bffba$var$TOP + $7366ceaa664bffba$var$CHART_H) + 16;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "overflow-x-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: `0 0 ${$7366ceaa664bffba$var$VIEW_W} ${height}`,
            className: "w-full min-w-[760px]",
            "aria-label": "Cash flow diagram",
            children: [
                left.map((laid)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: $7366ceaa664bffba$var$ribbonPath($7366ceaa664bffba$var$X_LEFT + $7366ceaa664bffba$var$NODE_W, laid.y, laid.h, $7366ceaa664bffba$var$X_SPINE, laid.spineY, laid.drawnValue * scale),
                        fill: laid.color,
                        opacity: laid.node.kind === 'income' ? 0.35 : 0.45,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                            children: `${laid.node.label} \u{2014} ${formatValue(laid.node.value)}`
                        })
                    }, `lr-${laid.node.kind}-${laid.node.key ?? laid.node.label}`)),
                right.map((laid)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: $7366ceaa664bffba$var$ribbonPath($7366ceaa664bffba$var$X_SPINE + $7366ceaa664bffba$var$NODE_W, laid.spineY, laid.drawnValue * scale, $7366ceaa664bffba$var$X_RIGHT, laid.y, laid.h),
                        fill: laid.color,
                        opacity: 0.5,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                            children: `${laid.node.label} \u{2014} ${formatValue(laid.node.value)}`
                        })
                    }, `rr-${laid.node.kind}-${laid.node.key ?? laid.node.label}`)),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: $7366ceaa664bffba$var$X_SPINE,
                    y: $7366ceaa664bffba$var$TOP,
                    width: $7366ceaa664bffba$var$NODE_W,
                    height: total * scale,
                    rx: 2,
                    className: "fill-border"
                }),
                left.map((laid)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: $7366ceaa664bffba$var$X_LEFT,
                                y: laid.y,
                                width: $7366ceaa664bffba$var$NODE_W,
                                height: laid.h,
                                rx: 2,
                                fill: laid.color
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7366ceaa664bffba$var$NodeLabel, {
                                laid: laid,
                                x: $7366ceaa664bffba$var$X_LEFT - 10,
                                anchor: "end",
                                formatValue: formatValue,
                                share: (0, $2105210cbd797d00$export$127388d0d1029689)(laid.node.value, sourcesTrue)
                            }),
                            laid.drawnValue < laid.node.value && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7366ceaa664bffba$var$BreakGlyph, {
                                x0: $7366ceaa664bffba$var$X_LEFT - 5,
                                x1: $7366ceaa664bffba$var$X_LEFT + $7366ceaa664bffba$var$NODE_W + 42,
                                y: laid.y + laid.h * 0.62
                            })
                        ]
                    }, `ln-${laid.node.kind}-${laid.node.key ?? laid.node.label}`)),
                right.map((laid)=>{
                    const key = laid.node.key;
                    const drillable = onSelectDest != null && key != null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        onClick: drillable ? ()=>onSelectDest(key) : undefined,
                        onKeyDown: drillable ? (event)=>{
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                onSelectDest(key);
                            }
                        } : undefined,
                        role: drillable ? 'button' : undefined,
                        tabIndex: drillable ? 0 : undefined,
                        "aria-label": drillable ? `${laid.node.label}: ${formatValue(laid.node.value)}${shareSuffix(laid.node.value, destsTrue)} \u{2014} break down` : undefined,
                        className: drillable ? 'cursor-pointer' : undefined,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: $7366ceaa664bffba$var$X_RIGHT,
                                y: laid.y,
                                width: $7366ceaa664bffba$var$NODE_W,
                                height: laid.h,
                                rx: 2,
                                fill: laid.color
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7366ceaa664bffba$var$NodeLabel, {
                                laid: laid,
                                x: $7366ceaa664bffba$var$X_RIGHT + 18,
                                anchor: "start",
                                formatValue: formatValue,
                                share: (0, $2105210cbd797d00$export$127388d0d1029689)(laid.node.value, destsTrue)
                            }),
                            laid.drawnValue < laid.node.value && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7366ceaa664bffba$var$BreakGlyph, {
                                x0: $7366ceaa664bffba$var$X_RIGHT - 42,
                                x1: $7366ceaa664bffba$var$X_RIGHT + $7366ceaa664bffba$var$NODE_W + 5,
                                y: laid.y + laid.h * 0.62
                            })
                        ]
                    }, `rn-${laid.node.kind}-${key ?? laid.node.label}`);
                })
            ]
        })
    });
};



parcelRequire("acw62");

const $533d5bd4a79a6c18$var$CHART_H = 400;
const $533d5bd4a79a6c18$var$VIEW_W = 1100;
const $533d5bd4a79a6c18$var$NODE_W = 10;
const $533d5bd4a79a6c18$var$GAP = 7;
const $533d5bd4a79a6c18$var$TOP = 24;
const $533d5bd4a79a6c18$var$X_LEFT = 225;
const $533d5bd4a79a6c18$var$X_SPINE = 430;
const $533d5bd4a79a6c18$var$X_MID = 520;
const $533d5bd4a79a6c18$var$X_GROUP = 700;
const $533d5bd4a79a6c18$var$X_RIGHT = 880;
const $533d5bd4a79a6c18$var$MIN_NODE_H = 6;
// Fixed color slots for the semantic roles; spend categories cycle the
// CVD-validated palette in slot order (see globals.css).
const $533d5bd4a79a6c18$var$KIND_COLOR = {
    income: 'var(--chart-3)',
    'reserve-draw': 'var(--muted-foreground)',
    withheld: 'var(--chart-4)',
    'taxes-tier': 'var(--chart-1)',
    'spending-tier': 'var(--muted-foreground)',
    'saving-tier': 'var(--chart-3)',
    unreviewed: 'var(--muted-foreground)'
};
// The unreviewed band is a to-do, not a flow: it draws hollow with a
// dashed outline so it reads as provisional next to the solid bars.
const $533d5bd4a79a6c18$var$nodeRectStyle = (laid)=>laid.node.kind === 'unreviewed' ? {
        fillOpacity: 0.25,
        stroke: laid.color,
        strokeWidth: 1,
        strokeDasharray: '3 2'
    } : {};
// A group's user-chosen color (category color list) wins; otherwise spend
// nodes and group aggregates cycle the palette in column order.
const $533d5bd4a79a6c18$var$nodeColor = (node, spendIndex)=>{
    if (node.kind === 'spend' || node.kind === 'spend-group') return node.color != null ? `var(--color-${node.color}-500)` : `var(--chart-${spendIndex % 8 + 1})`;
    return $533d5bd4a79a6c18$var$KIND_COLOR[node.kind] ?? 'var(--muted-foreground)';
};
const $533d5bd4a79a6c18$var$spineHeading = (model)=>{
    const extras = [
        ...model.totals.fromSavings > 0 ? [
            'savings'
        ] : [],
        ...model.totals.unreviewed > 0 ? [
            'unreviewed'
        ] : []
    ];
    return extras.length === 0 ? 'All income' : `Income + ${extras.join(' + ')}`;
};
const $533d5bd4a79a6c18$var$drawnValueOf = (node)=>node.displayValue ?? node.value;
const $533d5bd4a79a6c18$var$layout = (nodes, scale)=>{
    let y = $533d5bd4a79a6c18$var$TOP;
    let spineY = $533d5bd4a79a6c18$var$TOP;
    let spendIndex = 0;
    return nodes.map((node)=>{
        const drawnValue = $533d5bd4a79a6c18$var$drawnValueOf(node);
        const h = Math.max($533d5bd4a79a6c18$var$MIN_NODE_H, drawnValue * scale);
        const laid = {
            node: node,
            y: y,
            h: h,
            spineY: spineY,
            drawnValue: drawnValue,
            color: $533d5bd4a79a6c18$var$nodeColor(node, node.kind === 'spend' || node.kind === 'spend-group' ? spendIndex : 0)
        };
        if (node.kind === 'spend' || node.kind === 'spend-group') spendIndex += 1;
        y += h + $533d5bd4a79a6c18$var$GAP;
        spineY += drawnValue * scale;
        return laid;
    });
};
const $533d5bd4a79a6c18$var$ribbonPath = (x0, y0, h0, x1, y1, h1)=>{
    const mid = (x0 + x1) / 2;
    return [
        `M ${x0} ${y0}`,
        `C ${mid} ${y0}, ${mid} ${y1}, ${x1} ${y1}`,
        `L ${x1} ${y1 + h1}`,
        `C ${mid} ${y1 + h1}, ${mid} ${y0 + h0}, ${x0} ${y0 + h0}`,
        'Z'
    ].join(' ');
};
// The axis-break convention: a background-colored gap crossed by two
// slanted hairlines, laid over the node bar and the mouth of its ribbon.
const $533d5bd4a79a6c18$var$BreakGlyph = ({ x0: x0, x1: x1, y: y })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: x0,
                y1: y + 4,
                x2: x1,
                y2: y - 4,
                className: "stroke-background",
                strokeWidth: 9
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: x0,
                y1: y + 8,
                x2: x1,
                y2: y,
                className: "stroke-muted-foreground",
                strokeWidth: 1.5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: x0,
                y1: y,
                x2: x1,
                y2: y - 8,
                className: "stroke-muted-foreground",
                strokeWidth: 1.5
            })
        ]
    });
const $533d5bd4a79a6c18$var$truncate = (label, max = 24)=>label.length > max ? `${label.slice(0, max - 1)}\u{2026}` : label;
// Two lines when the node is tall enough, one compact line otherwise —
// short nodes stacked close together collide with two-line labels.
const $533d5bd4a79a6c18$var$NodeLabel = ({ laid: laid, x: x, anchor: anchor, formatValue: formatValue, share: share, wrapSublabel: wrapSublabel = false })=>{
    const { node: node, y: y, h: h } = laid;
    const mid = y + h / 2;
    const compressed = laid.drawnValue < node.value;
    const sublabel = compressed ? 'scale break' : node.sublabel;
    const value = formatValue(node.value) + (share != null ? ` \xb7 ${share}` : '');
    // The share lengthened the one-line form; compact labels shorten the
    // name to keep the whole line inside the label budget.
    const label = $533d5bd4a79a6c18$var$truncate(node.label, h < 30 && share != null ? 18 : 24);
    // A tall node with a sublabel puts it on its own line, so the value
    // line stays short and never runs under a neighboring column's bar;
    // wrapSublabel extends this down to 30px bars with tighter spacing.
    if (sublabel && (h >= 44 || wrapSublabel && h >= 30)) {
        const roomy = h >= 44;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                    x: x,
                    y: mid - (roomy ? 8 : 12),
                    textAnchor: anchor,
                    className: "fill-foreground text-[13px] font-semibold",
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                    x: x,
                    y: mid + (roomy ? 7 : 1.5),
                    textAnchor: anchor,
                    className: "fill-muted-foreground text-[11.5px]",
                    children: value
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                    x: x,
                    y: mid + (roomy ? 21 : 15),
                    textAnchor: anchor,
                    className: "fill-muted-foreground text-[11.5px]",
                    children: sublabel
                })
            ]
        });
    }
    if (h >= 30) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                x: x,
                y: mid - 1,
                textAnchor: anchor,
                className: "fill-foreground text-[13px] font-semibold",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("text", {
                x: x,
                y: mid + 14,
                textAnchor: anchor,
                className: "fill-muted-foreground text-[11.5px]",
                children: [
                    value,
                    sublabel ? ` \xb7 ${sublabel}` : ''
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("text", {
        x: x,
        y: mid + 4.5,
        textAnchor: anchor,
        className: "fill-foreground text-[12.5px] font-semibold",
        children: [
            label,
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tspan", {
                className: "fill-muted-foreground text-[11.5px] font-normal",
                children: [
                    "\xb7 ",
                    value,
                    sublabel ? ` \xb7 ${sublabel}` : ''
                ]
            })
        ]
    });
};
// Shared click/keyboard/aria wrapper for any node that carries a key.
const $533d5bd4a79a6c18$var$Drillable = ({ laid: laid, onSelectCategory: onSelectCategory, formatValue: formatValue, share: share, children: children })=>{
    const key = laid.node.key;
    const drillable = onSelectCategory != null && key != null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
        onClick: drillable ? ()=>onSelectCategory(key) : undefined,
        onKeyDown: drillable ? (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onSelectCategory(key);
            }
        } : undefined,
        role: drillable ? 'button' : undefined,
        tabIndex: drillable ? 0 : undefined,
        "aria-label": drillable ? `${laid.node.label}: ${formatValue(laid.node.value)}${share != null ? ` (${share})` : ''} \u{2014} break down` : undefined,
        className: drillable ? 'cursor-pointer' : undefined,
        children: children
    });
};
const $533d5bd4a79a6c18$export$294911bb82d11852 = (props)=>{
    const { model: model, onSelectCategory: onSelectCategory, formatValue: formatValue } = props;
    const { sources: sources, allocs: allocs, groupCol: groupCol, cats: cats } = model;
    const total = sources.reduce((sum, node)=>sum + $533d5bd4a79a6c18$var$drawnValueOf(node), 0);
    if (total <= 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground py-12 text-center text-sm",
        children: "Nothing in this window."
    });
    const scale = $533d5bd4a79a6c18$var$CHART_H / total;
    // Share bases use TRUE values (never drawn ones) so a scale break can't
    // distort percentages: sources and allocations against the spine,
    // groups and member categories against Spending.
    const spineTrue = sources.reduce((sum, node)=>sum + node.value, 0);
    const spendingTrue = groupCol.reduce((sum, node)=>sum + node.value, 0);
    const left = $533d5bd4a79a6c18$var$layout(sources, scale);
    const mid = $533d5bd4a79a6c18$var$layout(allocs, scale);
    const groupsLaid = $533d5bd4a79a6c18$var$layout(groupCol, scale);
    const right = $533d5bd4a79a6c18$var$layout(cats, scale);
    // Spending's right edge apportions among the group column by drawn
    // value, so the fan mouths stay glued to the box.
    const spendingLaid = mid.find((laid)=>laid.node.kind === 'spending-tier');
    const groupsDrawnTotal = groupsLaid.reduce((sum, laid)=>sum + laid.drawnValue, 0);
    // With no groups configured the cats column is empty and the group
    // column is the category fold — a four-column diagram using the legacy
    // geometry, so ungrouped users see the exact pre-tier layout with no
    // extra width.
    const hasCats = right.length > 0;
    const viewW = hasCats ? $533d5bd4a79a6c18$var$VIEW_W : 1000;
    const xMid = hasCats ? $533d5bd4a79a6c18$var$X_MID : 555;
    const xGroups = hasCats ? $533d5bd4a79a6c18$var$X_GROUP : 795;
    const bottomOf = (side)=>{
        const last = side.at(-1);
        return last == null ? $533d5bd4a79a6c18$var$TOP : last.y + last.h;
    };
    const height = Math.max(bottomOf(left), bottomOf(mid), bottomOf(groupsLaid), bottomOf(right), $533d5bd4a79a6c18$var$TOP + $533d5bd4a79a6c18$var$CHART_H) + 16;
    let groupOffset = 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "overflow-x-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: `0 0 ${viewW} ${height}`,
            className: "w-full min-w-[760px]",
            "aria-label": "Cash flow diagram",
            children: [
                left.map((laid)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: $533d5bd4a79a6c18$var$ribbonPath($533d5bd4a79a6c18$var$X_LEFT + $533d5bd4a79a6c18$var$NODE_W, laid.y, laid.h, $533d5bd4a79a6c18$var$X_SPINE, laid.spineY, laid.drawnValue * scale),
                        fill: laid.color,
                        opacity: laid.node.kind === 'income' ? 0.35 : laid.node.kind === 'unreviewed' ? 0.2 : 0.45,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                            children: `${laid.node.label} \u{2014} ${formatValue(laid.node.value)}`
                        })
                    }, `sr-${laid.node.kind}-${laid.node.key ?? laid.node.label}`)),
                mid.map((laid)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: $533d5bd4a79a6c18$var$ribbonPath($533d5bd4a79a6c18$var$X_SPINE + $533d5bd4a79a6c18$var$NODE_W, laid.spineY, laid.drawnValue * scale, xMid, laid.y, laid.h),
                        fill: laid.color,
                        opacity: laid.node.kind === 'unreviewed' ? 0.2 : 0.35,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                            children: `${laid.node.label} \u{2014} ${formatValue(laid.node.value)}`
                        })
                    }, `ar-${laid.node.kind}`)),
                spendingLaid != null && groupsDrawnTotal > 0 && groupsLaid.map((laid)=>{
                    const share = laid.drawnValue / groupsDrawnTotal;
                    const mouthY = spendingLaid.y + groupOffset / groupsDrawnTotal * spendingLaid.h;
                    const mouthH = share * spendingLaid.h;
                    groupOffset += laid.drawnValue;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: $533d5bd4a79a6c18$var$ribbonPath(xMid + $533d5bd4a79a6c18$var$NODE_W, mouthY, mouthH, xGroups, laid.y, laid.h),
                        fill: laid.color,
                        opacity: 0.5,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                            children: `${laid.node.label} \u{2014} ${formatValue(laid.node.value)}`
                        })
                    }, `gr-${laid.node.groupId ?? laid.node.key ?? laid.node.label}`);
                }),
                groupsLaid.filter((parent)=>parent.node.kind === 'spend-group' && parent.node.groupId != null).map((parent)=>{
                    const children = right.filter((child)=>child.node.groupId === parent.node.groupId);
                    const childTotal = children.reduce((sum, child)=>sum + child.drawnValue, 0);
                    if (childTotal <= 0) return null;
                    let offset = 0;
                    return children.map((child)=>{
                        const mouthY = parent.y + offset / childTotal * parent.h;
                        const mouthH = child.drawnValue / childTotal * parent.h;
                        offset += child.drawnValue;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: $533d5bd4a79a6c18$var$ribbonPath($533d5bd4a79a6c18$var$X_GROUP + $533d5bd4a79a6c18$var$NODE_W, mouthY, mouthH, $533d5bd4a79a6c18$var$X_RIGHT, child.y, child.h),
                            fill: child.color,
                            opacity: 0.5,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                                children: `${child.node.label} \u{2014} ${formatValue(child.node.value)}`
                            })
                        }, `mr-${String(parent.node.groupId)}-${child.node.key ?? child.node.label}`);
                    });
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                    x: $533d5bd4a79a6c18$var$X_SPINE + $533d5bd4a79a6c18$var$NODE_W / 2,
                    y: $533d5bd4a79a6c18$var$TOP - 8,
                    textAnchor: "middle",
                    className: "fill-muted-foreground text-[11.5px]",
                    children: $533d5bd4a79a6c18$var$spineHeading(model)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: $533d5bd4a79a6c18$var$X_SPINE,
                    y: $533d5bd4a79a6c18$var$TOP,
                    width: $533d5bd4a79a6c18$var$NODE_W,
                    height: total * scale,
                    rx: 2,
                    className: "fill-border"
                }),
                left.map((laid)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($533d5bd4a79a6c18$var$Drillable, {
                        laid: laid,
                        onSelectCategory: onSelectCategory,
                        formatValue: formatValue,
                        share: (0, $2105210cbd797d00$export$127388d0d1029689)(laid.node.value, spineTrue),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: $533d5bd4a79a6c18$var$X_LEFT,
                                y: laid.y,
                                width: $533d5bd4a79a6c18$var$NODE_W,
                                height: laid.h,
                                rx: 2,
                                fill: laid.color,
                                ...$533d5bd4a79a6c18$var$nodeRectStyle(laid)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($533d5bd4a79a6c18$var$NodeLabel, {
                                laid: laid,
                                x: $533d5bd4a79a6c18$var$X_LEFT - 10,
                                anchor: "end",
                                formatValue: formatValue,
                                share: (0, $2105210cbd797d00$export$127388d0d1029689)(laid.node.value, spineTrue)
                            }),
                            laid.drawnValue < laid.node.value && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($533d5bd4a79a6c18$var$BreakGlyph, {
                                x0: $533d5bd4a79a6c18$var$X_LEFT - 5,
                                x1: $533d5bd4a79a6c18$var$X_LEFT + $533d5bd4a79a6c18$var$NODE_W + 42,
                                y: laid.y + laid.h * 0.62
                            })
                        ]
                    }, `ln-${laid.node.kind}-${laid.node.key ?? laid.node.label}`)),
                mid.map((laid)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($533d5bd4a79a6c18$var$Drillable, {
                        laid: laid,
                        onSelectCategory: onSelectCategory,
                        formatValue: formatValue,
                        share: (0, $2105210cbd797d00$export$127388d0d1029689)(laid.node.value, spineTrue),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: xMid,
                                y: laid.y,
                                width: $533d5bd4a79a6c18$var$NODE_W,
                                height: laid.h,
                                rx: 2,
                                fill: laid.color,
                                ...$533d5bd4a79a6c18$var$nodeRectStyle(laid)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($533d5bd4a79a6c18$var$NodeLabel, {
                                laid: laid,
                                x: xMid + 18,
                                anchor: "start",
                                formatValue: formatValue,
                                share: (0, $2105210cbd797d00$export$127388d0d1029689)(laid.node.value, spineTrue),
                                wrapSublabel: true
                            }),
                            laid.drawnValue < laid.node.value && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($533d5bd4a79a6c18$var$BreakGlyph, {
                                x0: xMid - 42,
                                x1: xMid + $533d5bd4a79a6c18$var$NODE_W + 5,
                                y: laid.y + laid.h * 0.62
                            })
                        ]
                    }, `mn-${laid.node.kind}`)),
                groupsLaid.map((laid)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($533d5bd4a79a6c18$var$Drillable, {
                        laid: laid,
                        onSelectCategory: onSelectCategory,
                        formatValue: formatValue,
                        share: (0, $2105210cbd797d00$export$127388d0d1029689)(laid.node.value, spendingTrue),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: xGroups,
                                y: laid.y,
                                width: $533d5bd4a79a6c18$var$NODE_W,
                                height: laid.h,
                                rx: 2,
                                fill: laid.color
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($533d5bd4a79a6c18$var$NodeLabel, {
                                laid: laid,
                                x: xGroups + 14,
                                anchor: "start",
                                formatValue: formatValue,
                                share: (0, $2105210cbd797d00$export$127388d0d1029689)(laid.node.value, spendingTrue)
                            })
                        ]
                    }, `gn-${laid.node.groupId ?? laid.node.key ?? laid.node.label}`)),
                right.map((laid)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($533d5bd4a79a6c18$var$Drillable, {
                        laid: laid,
                        onSelectCategory: onSelectCategory,
                        formatValue: formatValue,
                        share: (0, $2105210cbd797d00$export$127388d0d1029689)(laid.node.value, spendingTrue),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: $533d5bd4a79a6c18$var$X_RIGHT,
                                y: laid.y,
                                width: $533d5bd4a79a6c18$var$NODE_W,
                                height: laid.h,
                                rx: 2,
                                fill: laid.color
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($533d5bd4a79a6c18$var$NodeLabel, {
                                laid: laid,
                                x: $533d5bd4a79a6c18$var$X_RIGHT + 18,
                                anchor: "start",
                                formatValue: formatValue,
                                share: (0, $2105210cbd797d00$export$127388d0d1029689)(laid.node.value, spendingTrue)
                            })
                        ]
                    }, `rn-${String(laid.node.groupId)}-${laid.node.key ?? laid.node.label}`))
            ]
        })
    });
};






var $acw62 = parcelRequire("acw62");
const $83cea620a50ed759$export$e302080132cf6fc = ()=>{
    const [dayKey, setDayKey] = $acw62.useState(()=>(0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().toISODate() ?? '');
    $acw62.useEffect(()=>{
        const refresh = ()=>{
            setDayKey((prev)=>(0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().toISODate() ?? prev);
        };
        window.addEventListener('focus', refresh);
        document.addEventListener('visibilitychange', refresh);
        return ()=>{
            window.removeEventListener('focus', refresh);
            document.removeEventListener('visibilitychange', refresh);
        };
    }, []);
    return dayKey;
};



/**
 * Node labels stay compact ($105k) while the caption below the chart uses
 * exact dollars — precision belongs in prose, not crammed beside a ribbon.
 */ const $a502907ef1d9bf81$var$formatCompact = (cents)=>{
    const dollars = Math.abs(cents) / 100;
    if (dollars >= 100000) return `$${Math.round(dollars / 1000).toLocaleString('en-US')}k`;
    if (dollars >= 10000) return `$${(dollars / 1000).toFixed(1)}k`;
    return dollars.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    });
};
const $a502907ef1d9bf81$var$formatExact = (cents)=>(Math.abs(cents) / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    });
const $a502907ef1d9bf81$var$RELATIVE_PRESETS = [
    {
        kind: '12mo',
        label: 'Trailing 12 months'
    },
    {
        kind: 'ytd',
        label: 'This year'
    }
];
const $a502907ef1d9bf81$var$resolveWindow = (mode, day)=>{
    const now = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(day);
    const iso = (d)=>d.toISODate() ?? '';
    switch(mode.kind){
        case '12mo':
            return {
                startDate: iso(now.minus({
                    years: 1
                }).plus({
                    days: 1
                })),
                endDate: iso(now)
            };
        case 'ytd':
            return {
                startDate: iso(now.startOf('year')),
                endDate: iso(now)
            };
        case 'absolute':
            return {
                // Far enough back that even hand-entered historical records
                // qualify; an open end runs through today.
                startDate: mode.value.startDate ?? '1900-01-01',
                endDate: mode.value.endDate ?? iso(now)
            };
    }
};
const $a502907ef1d9bf81$export$3ae9608212c7954e = ()=>{
    const dayKey = (0, $83cea620a50ed759$export$e302080132cf6fc)();
    const [windowMode, setWindowMode] = $acw62.useState({
        kind: '12mo'
    });
    const activeWindow = $acw62.useMemo(()=>$a502907ef1d9bf81$var$resolveWindow(windowMode, dayKey), [
        windowMode,
        dayKey
    ]);
    const [drillCategoryId, setDrillCategoryId] = $acw62.useState(null);
    const [trueScale, setTrueScale] = $acw62.useState(false);
    const [expandAll, setExpandAll] = $acw62.useState(false);
    const { data: categoriesData, loading: categoriesLoading, error: categoriesError } = (0, $ce9d9e524be20f53$export$1f9e2535d0d42ab9)({
        // Same freshness contract as the aggregates below: a category created
        // or renamed in another session should label this map after a revisit.
        fetchPolicy: 'cache-and-network'
    });
    const { data: categoryGroupsData, loading: categoryGroupsLoading, error: categoryGroupsError } = (0, $ce9d9e524be20f53$export$9dda77d697c51272)({
        fetchPolicy: 'cache-and-network'
    });
    const { data: flowData, loading: flowLoading, error: flowError } = (0, $ce9d9e524be20f53$export$532d39b2a97ef848)({
        variables: {
            startDate: activeWindow.startDate,
            endDate: activeWindow.endDate
        },
        // Aggregates go stale as soon as a payment is edited or synced anywhere
        // else in the app; nothing evicts them, so revalidate on every visit
        // while still painting the cached result immediately.
        fetchPolicy: 'cache-and-network'
    });
    const { data: payrollData, loading: payrollLoading, error: payrollError } = (0, $ce9d9e524be20f53$export$e68038f01f25b5a2)({
        variables: {
            startDate: activeWindow.startDate,
            endDate: activeWindow.endDate
        },
        fetchPolicy: 'cache-and-network'
    });
    // The taxes band needs to know which category is taxes; the binding is
    // user-set on the Defaults page (taxesCategory slot).
    const { data: bindingsData, loading: bindingsLoading, error: bindingsError } = (0, $ce9d9e524be20f53$export$7d26fb86ec9e5950)({
        fetchPolicy: 'cache-and-network'
    });
    // Raw rows nothing has consumed yet. The rollups above exclude them, so
    // without this their outflows would read as Saving with no indicator.
    const { data: unallocatedData, loading: unallocatedLoading, error: unallocatedError } = (0, $ce9d9e524be20f53$export$5cbc24df0057fcf4)({
        variables: {
            startDate: activeWindow.startDate,
            endDate: activeWindow.endDate
        },
        fetchPolicy: 'cache-and-network'
    });
    const { data: payeeData, loading: payeeLoading, error: payeeError } = (0, $ce9d9e524be20f53$export$e1cff32f4295f5ee)({
        variables: {
            startDate: activeWindow.startDate,
            endDate: activeWindow.endDate,
            categoryId: drillCategoryId ?? ''
        },
        skip: drillCategoryId == null,
        fetchPolicy: 'cache-and-network'
    });
    const categoriesById = $acw62.useMemo(()=>new Map((categoriesData?.allCategories ?? []).map((category)=>[
                category._id,
                category
            ])), [
        categoriesData
    ]);
    const payrollSummary = payrollData?.payrollSummary ?? null;
    const unallocated = unallocatedData?.unallocatedCashFlow ?? null;
    // A binding can dangle (category deleted after binding); treat it as
    // unset so withholding renders as the standalone band instead of an
    // "Unknown category" node with a dead drill. The Defaults page flags the
    // dangling row for cleanup.
    const boundCategory = (key)=>{
        const id = bindingsData?.bindings.find((binding)=>binding.key === key)?.entityId ?? null;
        return id != null && categoriesById.has(id) ? id : null;
    };
    const taxesCategoryId = boundCategory('taxesCategory');
    // Binding the same category to both slots is contradictory (its cash rows
    // cannot be both paycheck deposits and tax payments); taxes wins, because
    // the withholding's destination is the better-defined half.
    const boundPaycheckId = boundCategory('paycheckCategory');
    const paycheckCategoryId = boundPaycheckId != null && boundPaycheckId === taxesCategoryId ? null : boundPaycheckId;
    // Same policy down the chain: taxes > paycheck > retirement. Without
    // this, the retirement pin would extract the shared category before the
    // taxes tier could net against it, misreporting a refund as retirement
    // income and overstating taxes.
    const boundRetirementId = boundCategory('retirementCategory');
    const retirementCategoryId = boundRetirementId != null && (boundRetirementId === taxesCategoryId || boundRetirementId === paycheckCategoryId) ? null : boundRetirementId;
    const overview = $acw62.useMemo(()=>(0, $2105210cbd797d00$export$7b01e035c703c48d)({
            groups: (flowData?.cashFlowByCategory ?? []).map((group)=>({
                    key: group.key ?? null,
                    net: group.net
                })),
            categoriesById: categoriesById,
            categoryGroups: (categoryGroupsData?.allCategoryGroups ?? []).map((group)=>({
                    _id: group._id,
                    name: group.name,
                    categoryIds: group.categoryIds,
                    color: group.color ?? null
                })),
            // Always passed: the bindings shape the map (taxes tier from cash
            // rows, retirement pin) even before any payroll is imported.
            payroll: {
                taxesWithheld: payrollSummary?.taxesWithheld ?? 0,
                taxesCategoryId: taxesCategoryId,
                paycheckCategoryId: paycheckCategoryId,
                retirementCategoryId: retirementCategoryId
            },
            unreviewed: unallocated != null ? {
                net: unallocated.net,
                count: unallocated.count
            } : undefined,
            maxNodes: expandAll ? Number.POSITIVE_INFINITY : undefined
        }), [
        flowData,
        categoriesById,
        categoryGroupsData,
        payrollSummary,
        unallocated,
        taxesCategoryId,
        paycheckCategoryId,
        retirementCategoryId,
        expandAll
    ]);
    const drawnOverview = $acw62.useMemo(()=>trueScale ? (0, $2105210cbd797d00$export$50352cace0182bde)(overview) : overview, [
        overview,
        trueScale
    ]);
    const drill = $acw62.useMemo(()=>{
        if (drillCategoryId == null) return null;
        const groups = (payeeData?.cashFlowByPayee ?? []).map((group)=>({
                key: group.key ?? null,
                net: group.net
            }));
        // Drills must not lose the withheld share the overview merged in: on
        // the taxes drill it joins as an outflow, on the paycheck drill as an
        // inflow (the pay that never reached a payee). The paycheck row only
        // appears when the overview actually merged — a net-negative window
        // keeps the category on the spend side with the standalone band, and
        // its drill must reconcile with that node instead.
        const withheld = payrollSummary?.taxesWithheld ?? 0;
        const paycheckMerged = drillCategoryId === paycheckCategoryId && (flowData?.cashFlowByCategory.find((group)=>group.key === paycheckCategoryId)?.net ?? 0) > 0;
        const extra = withheld > 0 && drillCategoryId === taxesCategoryId ? [
            {
                key: 'Payroll withholding',
                net: -withheld
            }
        ] : withheld > 0 && paycheckMerged ? [
            {
                key: 'Withheld pay',
                net: withheld
            }
        ] : [];
        return (0, $2105210cbd797d00$export$886e9fee34b09da5)({
            groups: [
                ...groups,
                ...extra
            ]
        });
    }, [
        drillCategoryId,
        payeeData,
        flowData,
        taxesCategoryId,
        paycheckCategoryId,
        payrollSummary
    ]);
    const drillCategoryName = drillCategoryId != null ? categoriesById.get(drillCategoryId)?.name ?? 'Category' : null;
    const { totals: totals } = overview;
    // Caption percentages share one denominator: the money that actually
    // flowed this window (income, plus any savings draw, plus unreviewed
    // inflows — everything the spine carries).
    const captionBase = totals.income + totals.fromSavings + Math.max(0, totals.unreviewed);
    const withShare = (value)=>{
        const share = (0, $2105210cbd797d00$export$127388d0d1029689)(value, captionBase);
        return share != null ? ` (${share})` : '';
    };
    // Metadata gates rendering too: without the categories, every label is
    // unknown and — worse — windfall categories read as regular income. And a
    // failed query must not render as a plausible empty window.
    // The rollup gates both modes: the drill derives its synthetic rows and
    // header framing from it, so a payee response arriving ahead of a stale
    // or failed rollup must not render.
    const loading = categoriesLoading && categoriesData == null || categoryGroupsLoading && categoryGroupsData == null || payrollLoading && payrollData == null || bindingsLoading && bindingsData == null || flowLoading && flowData == null || unallocatedLoading && unallocatedData == null || drillCategoryId != null && payeeLoading && payeeData == null;
    const error = categoriesError ?? categoryGroupsError ?? payrollError ?? bindingsError ?? flowError ?? unallocatedError ?? (drillCategoryId != null ? payeeError : undefined);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mx-auto flex max-w-5xl flex-col gap-4 p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "text-foreground text-xl font-semibold",
                            children: drillCategoryName == null ? 'Cash flow' : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                        variant: "ghost",
                                        onClick: ()=>setDrillCategoryId(null),
                                        "aria-label": "Back to all categories",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                            className: "size-4"
                                        })
                                    }),
                                    drillCategoryName,
                                    " \xb7 by payee"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-1.5",
                        children: [
                            $a502907ef1d9bf81$var$RELATIVE_PRESETS.map((preset)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setWindowMode({
                                            kind: preset.kind
                                        }),
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('rounded-full border px-3 py-1 text-xs font-medium transition-colors', windowMode.kind === preset.kind ? 'border-primary bg-primary text-primary-foreground' : 'border-border text-muted-foreground hover:text-foreground'),
                                    children: preset.label
                                }, preset.kind)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fb4243874d8f910$export$bfb275743ab18881), {
                                value: windowMode.kind === 'absolute' ? windowMode.value : {
                                    startDate: null,
                                    endDate: null
                                },
                                onChange: (value)=>setWindowMode({
                                        kind: 'absolute',
                                        value: value
                                    }),
                                emptyMeaning: windowMode.kind === 'absolute' ? 'all-time' : 'unset'
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-destructive py-12 text-center text-sm",
                children: [
                    "Couldn't load cash flow: ",
                    error.message
                ]
            }),
            !error && loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground py-12 text-center text-sm",
                children: "Loading\u2026"
            }),
            !error && !loading && drill == null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $533d5bd4a79a6c18$export$294911bb82d11852), {
                        model: drawnOverview,
                        onSelectCategory: setDrillCategoryId,
                        formatValue: $a502907ef1d9bf81$var$formatCompact
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-muted-foreground text-xs",
                        children: [
                            payrollSummary != null && payrollSummary.taxesWithheld > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "Paychecks deposited ",
                                    $a502907ef1d9bf81$var$formatExact(payrollSummary.net),
                                    " of",
                                    ' ',
                                    $a502907ef1d9bf81$var$formatExact(payrollSummary.gross),
                                    " gross;",
                                    ' ',
                                    $a502907ef1d9bf81$var$formatExact(payrollSummary.taxesWithheld),
                                    " of the difference was tax withholding, shown here.",
                                    ' '
                                ]
                            }),
                            "Of ",
                            $a502907ef1d9bf81$var$formatExact(totals.income),
                            " in",
                            totals.fromSavings > 0 && ` plus ${$a502907ef1d9bf81$var$formatExact(totals.fromSavings)} from savings`,
                            totals.unreviewed > 0 && ` plus ${$a502907ef1d9bf81$var$formatExact(totals.unreviewed)} not yet reviewed`,
                            ":",
                            totals.taxes > 0 && ` ${$a502907ef1d9bf81$var$formatExact(totals.taxes)}${withShare(totals.taxes)} to taxes,`,
                            ' ',
                            $a502907ef1d9bf81$var$formatExact(totals.spending),
                            withShare(totals.spending),
                            " spent",
                            totals.unreviewed < 0 && `, ${$a502907ef1d9bf81$var$formatExact(totals.unreviewed)}${withShare(-totals.unreviewed)} not yet reviewed`,
                            totals.saving > 0 && `, ${$a502907ef1d9bf81$var$formatExact(totals.saving)}${withShare(totals.saving)} saved`,
                            ".",
                            ' ',
                            (totals.unreviewedCount > 0 || (unallocated?.foreignCount ?? 0) > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    "\u201CUnreviewed\u201D nets ",
                                    totals.unreviewedCount,
                                    ' ',
                                    totals.unreviewedCount === 1 ? 'raw transaction' : 'raw transactions',
                                    ' ',
                                    "no transaction has consumed yet",
                                    (unallocated?.foreignCount ?? 0) > 0 && `, and ${unallocated?.foreignCount} more in other currencies are not drawn until allocated`,
                                    "; it may hide transfer legs, so it is not counted as spending or income.",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                        to: `/ledger?layer=activity&view=review&start=${activeWindow.startDate}&end=${activeWindow.endDate}`,
                                        className: "text-foreground underline decoration-dotted underline-offset-2",
                                        children: "Review them"
                                    }),
                                    ".",
                                    ' '
                                ]
                            }),
                            overview.scaleBreak != null && (trueScale ? 'Drawn at true scale. ' : `Scale break: ${overview.scaleBreak.label} and \u{201C}Saving\u{201D} are drawn ${$a502907ef1d9bf81$var$formatExact(overview.scaleBreak.hidden)} shorter so smaller flows stay readable \u{2014} labels show true amounts. `),
                            overview.scaleBreak != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "text-foreground underline decoration-dotted underline-offset-2",
                                onClick: ()=>setTrueScale(!trueScale),
                                children: trueScale ? 'Restore scale break' : 'Show true scale'
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "text-foreground underline decoration-dotted underline-offset-2",
                                onClick: ()=>setExpandAll(!expandAll),
                                children: expandAll ? 'Fold small categories' : 'Show all categories'
                            })
                        ]
                    })
                ]
            }),
            !error && !loading && drill != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7366ceaa664bffba$export$ac21bfdd444142f6), {
                sources: drill.sources,
                dests: drill.dests,
                formatValue: $a502907ef1d9bf81$var$formatCompact
            })
        ]
    });
};








var $acw62 = parcelRequire("acw62");






/**
 * Pure model-building for the Trends tab: monthly non-cumulative spending
 * lines, this year against last, with group-level isolate/compare.
 *
 * Spend classification follows the flow model's offset rule at the window
 * level: a category is a spend category when its net over the fetched
 * two-year window is negative; inflows inside it reduce its monthly value
 * rather than counting as income (a refund-heavy month can dip below
 * zero — that is honest, not an error). Income-side categories never
 * contribute. Amounts are integer cents; plotted values are positive for
 * spending (−net).
 */ const $cea315a0247c166f$export$9c35129677b87195 = '__ungrouped';
/**
 * How many line pairs may carry end labels before they collide — beyond
 * this the chips remain the legend and lines end with bare dots.
 */ const $cea315a0247c166f$var$MAX_LABELED_SCOPES = 1;
const $cea315a0247c166f$var$MONTHS = 12;
const $cea315a0247c166f$var$monthIndex = (month, year)=>{
    const [y, m] = month.split('-').map(Number);
    return y === year && m >= 1 && m <= $cea315a0247c166f$var$MONTHS ? m - 1 : null;
};
/** Sum of −net per month for a set of category keys (null = uncategorized). */ const $cea315a0247c166f$var$seriesPoints = (perCategory, keys, year, lastMonth)=>{
    const points = Array.from({
        length: $cea315a0247c166f$var$MONTHS
    }, (_v, i)=>i <= lastMonth ? 0 : null);
    for (const key of keys){
        const byMonth = perCategory.get(key);
        if (byMonth == null) continue;
        for (const [month, net] of byMonth){
            const index = $cea315a0247c166f$var$monthIndex(month, year);
            if (index != null && index <= lastMonth) points[index] = (points[index] ?? 0) - net;
        }
    }
    return points;
};
const $cea315a0247c166f$var$sumPoints = (points, through)=>points.reduce((sum, value, i)=>i <= through && value != null ? sum + value : sum, 0);
const $cea315a0247c166f$export$35eebf1b4e188454 = ({ rows: rows, categoriesById: categoriesById, categoryGroups: categoryGroups, filterCategoryIds: filterCategoryIds, baseYear: baseYear, baseYearLastMonth: baseYearLastMonth, selectedGroupIds: selectedGroupIds, selectedCategoryIds: selectedCategoryIds, taxesCategoryId: taxesCategoryId })=>{
    // The echo year: with the base year unfinished, the year BEFORE the
    // comparison year fills the unlived months (dashed, from the frontier),
    // so the chart's right half reads "what the last two years did next"
    // instead of trailing off. Only meaningful when there is a gap.
    const echoYear = baseYear - 2;
    const hasEcho = baseYearLastMonth < $cea315a0247c166f$var$MONTHS - 1;
    const filter = filterCategoryIds != null ? new Set(filterCategoryIds) : null;
    // category → month → net, filter applied. The uncategorized bucket is a
    // real spend population and participates under the null key.
    // Classification (`windowNet`) sees only the months the chart shows —
    // the base year past its last complete month is excluded, so an
    // in-progress month can neither mint a $0 chip nor flip a category off
    // the spend side with a large refund.
    const perCategory = new Map();
    const windowNet = new Map();
    // The echo year classifies separately: a category retired since then
    // still belongs on the echo line, or its history understates.
    const echoNet = new Map();
    for (const row of rows){
        if (filter != null && (row.key == null || !filter.has(row.key))) continue;
        const byMonth = perCategory.get(row.key) ?? new Map();
        byMonth.set(row.month, (byMonth.get(row.month) ?? 0) + row.net);
        perCategory.set(row.key, byMonth);
        const baseIndex = $cea315a0247c166f$var$monthIndex(row.month, baseYear);
        const inEchoYear = $cea315a0247c166f$var$monthIndex(row.month, echoYear) != null;
        if (inEchoYear) echoNet.set(row.key, (echoNet.get(row.key) ?? 0) + row.net);
        else if (baseIndex == null || baseIndex <= baseYearLastMonth) windowNet.set(row.key, (windowNet.get(row.key) ?? 0) + row.net);
    }
    const spendKeys = new Set([
        ...windowNet.entries()
    ].filter(([, net])=>net < 0).map(([key])=>key));
    const echoSpendKeys = new Set([
        ...echoNet.entries()
    ].filter(([, net])=>net < 0).map(([key])=>key));
    // Taxes leaves every pool before grouping — it joins neither the total
    // nor its group's members nor the echo, regardless of which windows it
    // spent in (echo-only tax history must not leak spikes back into the
    // default line). The chip alone is gated on the comparison window
    // having something to show.
    const taxesKey = taxesCategoryId != null && spendKeys.has(taxesCategoryId) ? taxesCategoryId : null;
    if (taxesCategoryId != null) {
        spendKeys.delete(taxesCategoryId);
        echoSpendKeys.delete(taxesCategoryId);
    }
    // Partition the spend keys into groups; ungrouped ones (and the
    // uncategorized bucket) pool under the pseudo-group.
    const groupOf = new Map();
    for (const group of categoryGroups)for (const id of group.categoryIds)groupOf.set(id, group);
    const membersByGroup = new Map();
    for (const key of spendKeys){
        const group = key != null ? groupOf.get(key) : undefined;
        const groupId = group?._id ?? $cea315a0247c166f$export$9c35129677b87195;
        const members = membersByGroup.get(groupId) ?? new Set();
        members.add(key);
        membersByGroup.set(groupId, members);
    }
    const baseTotalOf = (keys)=>$cea315a0247c166f$var$sumPoints($cea315a0247c166f$var$seriesPoints(perCategory, keys, baseYear, baseYearLastMonth), baseYearLastMonth);
    const labelFor = (key)=>key == null ? 'Uncategorized' : categoriesById.get(key)?.name ?? 'Unknown category';
    const chips = [
        ...membersByGroup.entries()
    ].map(([groupId, members])=>{
        const group = categoryGroups.find((g)=>g._id === groupId);
        return {
            id: groupId,
            label: group?.name ?? 'Ungrouped',
            color: group?.color ?? null,
            baseTotal: baseTotalOf(members)
        };
    }).sort((a, b)=>b.baseTotal - a.baseTotal || a.label.localeCompare(b.label))// The taxes chip trails regardless of size — it is excluded context,
    // not a competitor for attention.
    .concat(taxesKey != null ? [
        {
            id: taxesKey,
            label: labelFor(taxesKey),
            color: null,
            baseTotal: baseTotalOf(new Set([
                taxesKey
            ]))
        }
    ] : []).map((chip, index)=>({
            ...chip,
            paletteIndex: index
        }));
    const activeGroups = selectedGroupIds.filter((id)=>membersByGroup.has(id) || id === taxesKey);
    const categoryChips = activeGroups.length === 1 && membersByGroup.has(activeGroups[0]) ? [
        ...membersByGroup.get(activeGroups[0]) ?? []
    ].map((key)=>{
        const keys = new Set([
            key
        ]);
        return {
            id: key ?? $cea315a0247c166f$export$9c35129677b87195,
            label: key == null ? 'Uncategorized' : categoriesById.get(key)?.name ?? 'Unknown category',
            color: null,
            baseTotal: baseTotalOf(keys)
        };
    }).sort((a, b)=>b.baseTotal - a.baseTotal || a.label.localeCompare(b.label)).map((chip, index)=>({
            ...chip,
            paletteIndex: index
        })) : [];
    let scopes;
    const activeCategories = activeGroups.length === 1 ? selectedCategoryIds.filter((id)=>categoryChips.some((chip)=>chip.id === id)) : [];
    const chipSlot = (row, id)=>row.find((chip)=>chip.id === id)?.paletteIndex ?? 0;
    const echoKeysForGroup = (groupId)=>{
        const keys = new Set(membersByGroup.get(groupId) ?? []);
        for (const key of echoSpendKeys){
            const group = key != null ? groupOf.get(key) : undefined;
            if ((group?._id ?? $cea315a0247c166f$export$9c35129677b87195) === groupId) keys.add(key);
        }
        return keys;
    };
    if (activeGroups.length === 0) scopes = [
        {
            id: 'total',
            label: 'All spending',
            color: null,
            paletteIndex: -1,
            keys: spendKeys,
            echoKeys: new Set([
                ...spendKeys,
                ...echoSpendKeys
            ])
        }
    ];
    else if (activeCategories.length > 0) scopes = activeCategories.map((id)=>({
            id: id,
            label: id === $cea315a0247c166f$export$9c35129677b87195 ? 'Uncategorized' : categoriesById.get(id)?.name ?? 'Unknown category',
            color: null,
            paletteIndex: chipSlot(categoryChips, id),
            keys: new Set([
                id === $cea315a0247c166f$export$9c35129677b87195 ? null : id
            ])
        }));
    else scopes = activeGroups.map((groupId)=>{
        if (groupId === taxesKey) {
            const keys = new Set([
                taxesKey
            ]);
            return {
                id: groupId,
                label: labelFor(taxesKey),
                color: null,
                paletteIndex: chipSlot(chips, groupId),
                keys: keys,
                echoKeys: keys
            };
        }
        const group = categoryGroups.find((g)=>g._id === groupId);
        return {
            id: groupId,
            label: group?.name ?? 'Ungrouped',
            color: group?.color ?? null,
            paletteIndex: chipSlot(chips, groupId),
            keys: membersByGroup.get(groupId) ?? new Set(),
            echoKeys: echoKeysForGroup(groupId)
        };
    });
    const labeled = scopes.length <= $cea315a0247c166f$var$MAX_LABELED_SCOPES;
    const series = scopes.flatMap((scope)=>[
            {
                id: `${scope.id}:base`,
                label: `${scope.label} \xb7 ${baseYear}`,
                color: scope.color,
                paletteIndex: scope.paletteIndex,
                dashed: false,
                // The frontier dot marks where the year currently ends; the year
                // label joins it when the chart is sparse enough to stay legible.
                endMarker: labeled ? 'dot-label' : 'dot',
                endLabel: String(baseYear),
                points: $cea315a0247c166f$var$seriesPoints(perCategory, scope.keys, baseYear, baseYearLastMonth)
            },
            {
                id: `${scope.id}:prev`,
                label: `${scope.label} \xb7 ${baseYear - 1}`,
                color: scope.color,
                paletteIndex: scope.paletteIndex,
                dashed: true,
                endMarker: labeled ? 'dot-label' : 'none',
                endLabel: String(baseYear - 1),
                points: $cea315a0247c166f$var$seriesPoints(perCategory, scope.keys, baseYear - 1, $cea315a0247c166f$var$MONTHS - 1)
            },
            // The echo: the prior-prior year, dashed and muted, drawn only for
            // the months after the frontier — context for the remainder, never
            // competing with the lived months.
            ...hasEcho && labeled ? [
                {
                    id: `${scope.id}:echo`,
                    label: `${scope.label} \xb7 ${echoYear}`,
                    color: scope.color,
                    paletteIndex: scope.paletteIndex,
                    dashed: true,
                    endMarker: 'dot-label',
                    endLabel: String(echoYear),
                    points: $cea315a0247c166f$var$seriesPoints(perCategory, scope.echoKeys ?? scope.keys, echoYear, $cea315a0247c166f$var$MONTHS - 1).map((value, index)=>index > baseYearLastMonth ? value : null)
                }
            ] : []
        ]);
    // Stacked view: bands over the current scope — or every group when
    // nothing is selected, since composition is the stacked view's point.
    const bandScopes = activeGroups.length > 0 ? scopes : chips.filter((chip)=>chip.id !== taxesKey).map((chip)=>({
            id: chip.id,
            label: chip.label,
            color: chip.color,
            paletteIndex: chip.paletteIndex,
            keys: membersByGroup.get(chip.id) ?? new Set()
        }));
    const stackBands = bandScopes.map((scope)=>({
            id: scope.id,
            label: scope.label,
            color: scope.color,
            paletteIndex: scope.paletteIndex,
            points: $cea315a0247c166f$var$seriesPoints(perCategory, scope.keys, baseYear, baseYearLastMonth).map((value)=>value == null ? null : Math.max(0, value))
        }));
    // The overlay must compare the same metric the bands draw: each scope
    // clamps at zero per month before summing, or a refund in one group
    // would depress a total whose base-year counterpart it cannot touch.
    const stackPrevPoints = Array.from({
        length: $cea315a0247c166f$var$MONTHS
    }, ()=>0);
    for (const scope of bandScopes){
        const points = $cea315a0247c166f$var$seriesPoints(perCategory, scope.keys, baseYear - 1, $cea315a0247c166f$var$MONTHS - 1);
        points.forEach((value, index)=>{
            stackPrevPoints[index] = (stackPrevPoints[index] ?? 0) + Math.max(0, value ?? 0);
        });
    }
    const stackPrevTotal = {
        id: 'stack:prev',
        label: `Total \xb7 ${baseYear - 1}`,
        color: null,
        paletteIndex: -1,
        dashed: true,
        endMarker: 'dot-label',
        endLabel: String(baseYear - 1),
        points: stackPrevPoints
    };
    // The caption compares like months: through the base year's last month.
    const totals = {
        months: baseYearLastMonth + 1,
        base: scopes.reduce((sum, scope)=>sum + $cea315a0247c166f$var$sumPoints($cea315a0247c166f$var$seriesPoints(perCategory, scope.keys, baseYear, baseYearLastMonth), baseYearLastMonth), 0),
        prev: scopes.reduce((sum, scope)=>sum + $cea315a0247c166f$var$sumPoints($cea315a0247c166f$var$seriesPoints(perCategory, scope.keys, baseYear - 1, $cea315a0247c166f$var$MONTHS - 1), baseYearLastMonth), 0)
    };
    // "What moved": per month, each scoped category this year against the
    // same month last year, sorted by the size of the change.
    const detailKeys = [
        ...new Set(scopes.flatMap((scope)=>[
                ...scope.keys
            ]))
    ];
    const monthDetails = Array.from({
        length: $cea315a0247c166f$var$MONTHS
    }, (_v, monthIdx)=>detailKeys.map((key)=>{
            const keys = new Set([
                key
            ]);
            const basePoints = $cea315a0247c166f$var$seriesPoints(perCategory, keys, baseYear, baseYearLastMonth);
            const prevPoints = $cea315a0247c166f$var$seriesPoints(perCategory, keys, baseYear - 1, $cea315a0247c166f$var$MONTHS - 1);
            const base = basePoints[monthIdx];
            const prev = prevPoints[monthIdx] ?? 0;
            return {
                key: key,
                label: labelFor(key),
                base: base,
                prev: prev,
                delta: base == null ? null : base - prev
            };
        }).filter((row)=>(row.base ?? 0) !== 0 || row.prev !== 0).sort((a, b)=>Math.abs(b.delta ?? b.prev) - Math.abs(a.delta ?? a.prev) || a.label.localeCompare(b.label)));
    return {
        chips: chips,
        categoryChips: categoryChips,
        activeGroupIds: activeGroups,
        activeCategoryIds: activeCategories,
        taxesChipId: taxesKey,
        monthDetails: monthDetails,
        series: series,
        stackBands: stackBands,
        stackPrevTotal: stackPrevTotal,
        totals: totals
    };
};


const $66388f373e463ee8$var$MONTH_LABELS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// The app's data starts in 2012; a year with nothing simply draws empty.
const $66388f373e463ee8$var$FIRST_YEAR = 2012;
const $66388f373e463ee8$var$formatCompact = (cents)=>{
    const dollars = cents / 100;
    if (Math.abs(dollars) >= 100000) return `$${Math.round(dollars / 1000)}k`;
    if (Math.abs(dollars) >= 10000) return `$${(dollars / 1000).toFixed(1)}k`;
    return dollars.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    });
};
const $66388f373e463ee8$var$formatExact = (cents)=>(cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    });
const $66388f373e463ee8$var$seriesColor = (series)=>{
    if (series.color != null) return `var(--color-${series.color}-500)`;
    if (series.paletteIndex < 0) return series.dashed ? 'var(--muted-foreground)' : 'var(--chart-3)';
    return `var(--chart-${series.paletteIndex % 8 + 1})`;
};
const $66388f373e463ee8$var$bandColor = (band)=>band.color != null ? `var(--color-${band.color}-500)` : `var(--chart-${band.paletteIndex % 8 + 1})`;
/**
 * Custom hover card: a small line swatch — solid or dotted, in the
 * series' color — beside neutral-colored text, so the comparison reads
 * from the swatches instead of a wall of tinted numbers.
 */ const $66388f373e463ee8$var$TrendsTooltip = ({ active: active, label: label, payload: payload, metaBySeries: metaBySeries })=>{
    if (active !== true || payload == null || payload.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-popover text-popover-foreground rounded-lg border px-3 py-2 text-xs shadow-md",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground mb-1 font-medium",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col gap-1",
                children: payload.flatMap((entry)=>{
                    const meta = typeof entry.dataKey === 'string' ? metaBySeries.get(entry.dataKey) : undefined;
                    if (meta == null || typeof entry.value !== 'number') return [];
                    return [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    width: "18",
                                    height: "4",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                        x1: "1",
                                        y1: "2",
                                        x2: "17",
                                        y2: "2",
                                        stroke: meta.stroke,
                                        strokeWidth: "2.5",
                                        strokeDasharray: meta.dashed ? '3 3' : undefined
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground",
                                    children: meta.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-foreground ml-auto pl-4 font-medium tabular-nums",
                                    children: $66388f373e463ee8$var$formatExact(entry.value)
                                })
                            ]
                        }, String(entry.dataKey))
                    ];
                })
            })
        ]
    });
};
/**
 * Per-point dot renderer: draws the series' end marker — a dot at its
 * last drawn point, plus the year label when the chart is sparse enough.
 * Recharts calls this for every point; other points draw nothing.
 */ const $66388f373e463ee8$var$endMarkerDot = (series, stroke, lastIndex)=>function EndMarkerDot(props) {
        const { cx: cx, cy: cy, index: index } = props;
        if (series.endMarker === 'none' || index !== lastIndex || cx == null || cy == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {}, `m-${series.id}-${String(index)}`);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: cx,
                    cy: cy,
                    r: 3.5,
                    fill: stroke
                }),
                series.endMarker === 'dot-label' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                    x: cx + 8,
                    y: cy + 4,
                    fontSize: 12,
                    fontWeight: 600,
                    fill: stroke,
                    children: series.endLabel
                })
            ]
        }, `m-${series.id}-${String(index)}`);
    };
const $66388f373e463ee8$var$lastDrawnIndex = (points)=>{
    for(let i = points.length - 1; i >= 0; i--){
        if (points[i] != null) return i;
    }
    return -1;
};
const $66388f373e463ee8$var$chipDotColor = (chip)=>chip.color != null ? `var(--color-${chip.color}-500)` : `var(--chart-${chip.paletteIndex % 8 + 1})`;
const $66388f373e463ee8$var$ChipRow = ({ chips: chips, selected: selected, onToggle: onToggle, onClear: onClear, allLabel: allLabel, formatValue: formatValue })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-wrap items-center gap-1.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: onClear,
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('rounded-full border px-3 py-1 text-xs font-medium transition-colors', selected.length === 0 ? 'border-primary bg-primary text-primary-foreground' : 'border-border text-muted-foreground hover:text-foreground'),
                children: allLabel
            }),
            chips.map((chip)=>{
                const active = selected.includes(chip.id);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    onClick: ()=>onToggle(chip.id),
                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition-colors', active ? 'border-primary text-foreground' : 'border-border text-muted-foreground hover:text-foreground'),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "size-2 rounded-full",
                            style: {
                                background: $66388f373e463ee8$var$chipDotColor(chip)
                            }
                        }),
                        chip.label,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-muted-foreground font-normal",
                            children: formatValue(chip.baseTotal)
                        })
                    ]
                }, chip.id);
            })
        ]
    });
const $66388f373e463ee8$export$2a1871d509f588c5 = ()=>{
    // Focus-refreshed so a tab left mounted across a month boundary picks
    // up the newly completed month.
    const dayKey = (0, $83cea620a50ed759$export$e302080132cf6fc)();
    const now = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(dayKey);
    const currentYear = now.year;
    // Null means "the current year": the default advances across New Year
    // by construction, while an explicitly picked year sticks.
    const [selectedYear, setSelectedYear] = $acw62.useState(null);
    const baseYear = selectedYear ?? currentYear;
    const [filterCategories, setFilterCategories] = $acw62.useState(null);
    const [selectedGroupIds, setSelectedGroupIds] = $acw62.useState([]);
    const [selectedCategoryIds, setSelectedCategoryIds] = $acw62.useState([]);
    const [viewMode, setViewMode] = $acw62.useState('lines');
    const [selectedMonth, setSelectedMonth] = $acw62.useState(null);
    const { data: categoriesData, loading: categoriesLoading, error: categoriesError } = (0, $ce9d9e524be20f53$export$1f9e2535d0d42ab9)({
        fetchPolicy: 'cache-and-network'
    });
    const { data: groupsData, loading: groupsLoading, error: groupsError } = (0, $ce9d9e524be20f53$export$9dda77d697c51272)({
        fetchPolicy: 'cache-and-network'
    });
    const { data: bindingsData, loading: bindingsLoading, error: bindingsError } = (0, $ce9d9e524be20f53$export$7d26fb86ec9e5950)({
        fetchPolicy: 'cache-and-network'
    });
    const { data: seriesData, loading: seriesLoading, error: seriesError } = (0, $ce9d9e524be20f53$export$e8213614668719ff)({
        variables: {
            // Three years: the pair, plus the echo year that fills the base
            // year's unlived months from the frontier.
            startDate: `${baseYear - 2}-01-01`,
            endDate: `${baseYear}-12-31`
        },
        fetchPolicy: 'cache-and-network'
    });
    const categoriesById = $acw62.useMemo(()=>new Map((categoriesData?.allCategories ?? []).map((category)=>[
                category._id,
                {
                    name: category.name
                }
            ])), [
        categoriesData
    ]);
    // Dangling binding (category deleted since) reads as unset.
    const taxesCategoryId = $acw62.useMemo(()=>{
        const id = bindingsData?.bindings.find((binding)=>binding.key === 'taxesCategory')?.entityId ?? null;
        return id != null && categoriesById.has(id) ? id : null;
    }, [
        bindingsData,
        categoriesById
    ]);
    const model = $acw62.useMemo(()=>(0, $cea315a0247c166f$export$35eebf1b4e188454)({
            rows: (seriesData?.cashFlowByCategoryByMonth ?? []).map((row)=>({
                    key: row.key ?? null,
                    month: row.month,
                    net: row.net
                })),
            categoriesById: categoriesById,
            categoryGroups: (groupsData?.allCategoryGroups ?? []).map((group)=>({
                    _id: group._id,
                    name: group.name,
                    categoryIds: group.categoryIds,
                    color: group.color ?? null
                })),
            filterCategoryIds: filterCategories,
            baseYear: baseYear,
            // The in-progress month plots as a misleading plunge (and skews
            // the caption's like-months comparison), so the base year ends at
            // the last complete month — except in January, when the partial
            // month is all there is.
            baseYearLastMonth: baseYear === currentYear ? Math.max(0, now.month - 2) : 11,
            selectedGroupIds: selectedGroupIds,
            selectedCategoryIds: selectedCategoryIds,
            taxesCategoryId: taxesCategoryId
        }), [
        seriesData,
        categoriesById,
        groupsData,
        filterCategories,
        baseYear,
        currentYear,
        now.month,
        selectedGroupIds,
        selectedCategoryIds,
        taxesCategoryId
    ]);
    const chartData = $acw62.useMemo(()=>$66388f373e463ee8$var$MONTH_LABELS.map((label, index)=>{
            const row = {
                month: label
            };
            for (const series of model.series)row[series.id] = series.points[index];
            return row;
        }), [
        model
    ]);
    const stackData = $acw62.useMemo(()=>$66388f373e463ee8$var$MONTH_LABELS.map((label, index)=>{
            const row = {
                month: label
            };
            for (const band of model.stackBands)row[band.id] = band.points[index];
            row[model.stackPrevTotal.id] = model.stackPrevTotal.points[index];
            return row;
        }), [
        model
    ]);
    const metaBySeries = $acw62.useMemo(()=>{
        const meta = new Map();
        for (const series of model.series)meta.set(series.id, {
            label: series.label,
            stroke: $66388f373e463ee8$var$seriesColor(series),
            dashed: series.dashed
        });
        for (const band of model.stackBands)meta.set(band.id, {
            label: `${band.label} \xb7 ${baseYear}`,
            stroke: $66388f373e463ee8$var$bandColor(band),
            dashed: false
        });
        meta.set(model.stackPrevTotal.id, {
            label: model.stackPrevTotal.label,
            stroke: 'var(--muted-foreground)',
            dashed: true
        });
        return meta;
    }, [
        model,
        baseYear
    ]);
    const toggleGroup = (id)=>{
        setSelectedCategoryIds([]);
        setSelectedGroupIds((current)=>current.includes(id) ? current.filter((g)=>g !== id) : [
                ...current,
                id
            ]);
    };
    const error = categoriesError ?? groupsError ?? bindingsError ?? seriesError;
    // The metadata queries gate rendering too: with groups still absent the
    // model would pool every category under "Ungrouped", and with
    // categories absent member chips would read "Unknown category".
    const loading = categoriesLoading && categoriesData == null || groupsLoading && groupsData == null || bindingsLoading && bindingsData == null || seriesLoading && seriesData == null;
    const delta = model.totals.prev > 0 ? (model.totals.base - model.totals.prev) / model.totals.prev : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mx-auto flex max-w-5xl flex-col gap-4 p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-foreground text-xl font-semibold",
                                children: "Spending"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-muted-foreground text-sm",
                                children: [
                                    "Each month\u2019s spending, ",
                                    baseYear,
                                    " solid against",
                                    ' ',
                                    baseYear - 1,
                                    " dashed. Inflows inside a spending category reduce that category instead of counting as income."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-1.5",
                        children: [
                            [
                                'lines',
                                'stacked'
                            ].map((mode)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setViewMode(mode),
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('rounded-full border px-3 py-1 text-xs font-medium capitalize transition-colors', viewMode === mode ? 'border-primary bg-primary text-primary-foreground' : 'border-border text-muted-foreground hover:text-foreground'),
                                    children: mode
                                }, mode)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                                label: "Year",
                                allLabel: String(currentYear),
                                triggerLabel: `${baseYear} vs ${baseYear - 1}`,
                                options: Array.from({
                                    length: currentYear - $66388f373e463ee8$var$FIRST_YEAR + 1
                                }, (_v, i)=>{
                                    const year = currentYear - i;
                                    return {
                                        key: String(year),
                                        label: String(year)
                                    };
                                }),
                                value: String(baseYear),
                                onChange: (value)=>// The clear row reports 'all' and means "back to the
                                    // current year" — stored as null so it keeps advancing.
                                    setSelectedYear(value === 'all' ? null : Number(value))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21c7fd562fd4701$export$d3e643d9d6f4fa7f), {
                                categories: filterCategories,
                                setCategories: setFilterCategories
                            })
                        ]
                    })
                ]
            }),
            error != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-destructive py-12 text-center text-sm",
                children: [
                    "Couldn\u2019t load spending: ",
                    error.message
                ]
            }),
            error == null && loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {}),
            error == null && !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "h-[380px] w-full",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
                            children: viewMode === 'lines' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d1341a4ce4753cde$export$54d0e8420ac838ac), {
                                data: chartData,
                                margin: {
                                    top: 8,
                                    right: 52,
                                    bottom: 0,
                                    left: 8
                                },
                                onClick: (state)=>{
                                    const index = $66388f373e463ee8$var$MONTH_LABELS.indexOf(String(state?.activeLabel ?? ''));
                                    if (index >= 0) setSelectedMonth((current)=>current === index ? null : index);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                                        stroke: "var(--border)",
                                        strokeDasharray: "3 3",
                                        vertical: false
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                                        dataKey: "month",
                                        tick: {
                                            fill: 'var(--muted-foreground)',
                                            fontSize: 12
                                        },
                                        tickLine: false,
                                        axisLine: {
                                            stroke: 'var(--border)'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                                        tickFormatter: (value)=>$66388f373e463ee8$var$formatCompact(value),
                                        tick: {
                                            fill: 'var(--muted-foreground)',
                                            fontSize: 12
                                        },
                                        tickLine: false,
                                        axisLine: false,
                                        width: 64
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                                        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($66388f373e463ee8$var$TrendsTooltip, {
                                            metaBySeries: metaBySeries
                                        })
                                    }),
                                    model.series.map((series)=>{
                                        const stroke = $66388f373e463ee8$var$seriesColor(series);
                                        // The echo year fades further and dashes tighter than
                                        // the comparison year, so the chart's right half reads
                                        // as two distinct histories, not a doubled line.
                                        const echo = series.id.endsWith(':echo');
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                                            dataKey: series.id,
                                            stroke: stroke,
                                            strokeWidth: series.dashed ? 1.5 : 2,
                                            strokeDasharray: echo ? '2 4' : series.dashed ? '5 4' : undefined,
                                            strokeOpacity: echo ? 0.45 : series.dashed ? 0.65 : 1,
                                            dot: $66388f373e463ee8$var$endMarkerDot(series, stroke, $66388f373e463ee8$var$lastDrawnIndex(series.points)),
                                            activeDot: {
                                                r: 3
                                            },
                                            isAnimationActive: false
                                        }, series.id);
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $669260e8074ac2f0$export$f881f4f9e4007a57), {
                                data: stackData,
                                margin: {
                                    top: 8,
                                    right: 52,
                                    bottom: 0,
                                    left: 8
                                },
                                onClick: (state)=>{
                                    const index = $66388f373e463ee8$var$MONTH_LABELS.indexOf(String(state?.activeLabel ?? ''));
                                    if (index >= 0) setSelectedMonth((current)=>current === index ? null : index);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                                        stroke: "var(--border)",
                                        strokeDasharray: "3 3",
                                        vertical: false
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                                        dataKey: "month",
                                        tick: {
                                            fill: 'var(--muted-foreground)',
                                            fontSize: 12
                                        },
                                        tickLine: false,
                                        axisLine: {
                                            stroke: 'var(--border)'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                                        tickFormatter: (value)=>$66388f373e463ee8$var$formatCompact(value),
                                        tick: {
                                            fill: 'var(--muted-foreground)',
                                            fontSize: 12
                                        },
                                        tickLine: false,
                                        axisLine: false,
                                        width: 64
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                                        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($66388f373e463ee8$var$TrendsTooltip, {
                                            metaBySeries: metaBySeries
                                        })
                                    }),
                                    model.stackBands.map((band)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                                            dataKey: band.id,
                                            stackId: "base",
                                            stroke: $66388f373e463ee8$var$bandColor(band),
                                            fill: $66388f373e463ee8$var$bandColor(band),
                                            fillOpacity: 0.45,
                                            strokeWidth: 1,
                                            isAnimationActive: false
                                        }, band.id)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                                        dataKey: model.stackPrevTotal.id,
                                        stroke: "var(--muted-foreground)",
                                        strokeWidth: 1.5,
                                        strokeDasharray: "5 4",
                                        dot: $66388f373e463ee8$var$endMarkerDot(model.stackPrevTotal, 'var(--muted-foreground)', $66388f373e463ee8$var$lastDrawnIndex(model.stackPrevTotal.points)),
                                        activeDot: {
                                            r: 3
                                        },
                                        isAnimationActive: false
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($66388f373e463ee8$var$ChipRow, {
                        chips: model.chips,
                        selected: model.activeGroupIds,
                        onToggle: toggleGroup,
                        onClear: ()=>{
                            setSelectedGroupIds([]);
                            setSelectedCategoryIds([]);
                        },
                        allLabel: "All spending",
                        formatValue: $66388f373e463ee8$var$formatCompact
                    }),
                    model.categoryChips.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($66388f373e463ee8$var$ChipRow, {
                        chips: model.categoryChips,
                        selected: model.activeCategoryIds,
                        onToggle: (id)=>setSelectedCategoryIds((current)=>current.includes(id) ? current.filter((c)=>c !== id) : [
                                    ...current,
                                    id
                                ]),
                        onClear: ()=>setSelectedCategoryIds([]),
                        allLabel: "Whole group",
                        formatValue: $66388f373e463ee8$var$formatCompact
                    }),
                    selectedMonth != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border-border rounded-lg border p-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-2 flex items-baseline justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-foreground text-sm font-semibold",
                                        children: [
                                            $66388f373e463ee8$var$MONTH_LABELS[selectedMonth],
                                            " ",
                                            baseYear,
                                            " \xb7 what moved"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setSelectedMonth(null),
                                        className: "text-muted-foreground hover:text-foreground text-xs",
                                        children: "Close"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "w-full text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "text-muted-foreground text-left",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "py-1 font-medium",
                                                    children: "Category"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                    className: "py-1 text-right font-medium",
                                                    children: [
                                                        $66388f373e463ee8$var$MONTH_LABELS[selectedMonth],
                                                        " ",
                                                        baseYear
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                    className: "py-1 text-right font-medium",
                                                    children: [
                                                        $66388f373e463ee8$var$MONTH_LABELS[selectedMonth],
                                                        " ",
                                                        baseYear - 1
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "py-1 text-right font-medium",
                                                    children: "\u0394"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                        children: [
                                            model.monthDetails[selectedMonth].slice(0, 8).map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: "border-border border-t",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-foreground py-1",
                                                            children: row.label
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "py-1 text-right tabular-nums",
                                                            children: row.base == null ? "\u2014" : $66388f373e463ee8$var$formatExact(row.base)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "text-muted-foreground py-1 text-right tabular-nums",
                                                            children: $66388f373e463ee8$var$formatExact(row.prev)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('py-1 text-right font-medium tabular-nums', row.delta != null && row.delta > 0 ? 'text-destructive' : 'text-muted-foreground'),
                                                            children: row.delta == null ? "\u2014" : `${row.delta > 0 ? '+' : ''}${$66388f373e463ee8$var$formatExact(row.delta)}`
                                                        })
                                                    ]
                                                }, row.key ?? '__uncategorized')),
                                            model.monthDetails[selectedMonth].length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                className: "border-border border-t",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    colSpan: 4,
                                                    className: "text-muted-foreground py-2 text-center",
                                                    children: "Nothing in this month."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            model.monthDetails[selectedMonth].length > 8 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-muted-foreground mt-1 text-right text-[11px]",
                                children: [
                                    model.monthDetails[selectedMonth].length - 8,
                                    " smaller changes not shown"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-muted-foreground text-xs",
                        children: [
                            "Jan\u2013",
                            $66388f373e463ee8$var$MONTH_LABELS[model.totals.months - 1],
                            ":",
                            ' ',
                            $66388f373e463ee8$var$formatExact(model.totals.base),
                            " vs",
                            ' ',
                            $66388f373e463ee8$var$formatExact(model.totals.prev),
                            " in ",
                            baseYear - 1,
                            delta != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    ' ',
                                    "(",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: delta > 0 ? 'text-destructive' : 'text-foreground',
                                        children: [
                                            delta > 0 ? '+' : '',
                                            Math.round(delta * 100),
                                            "%"
                                        ]
                                    }),
                                    ")"
                                ]
                            }),
                            model.taxesChipId != null && model.activeGroupIds.length === 0 && ` \u{2014} excluding ${categoriesById.get(model.taxesChipId)?.name ?? 'Taxes'}`,
                            ". Click a group to isolate it, several to compare, or a month to see what moved."
                        ]
                    })
                ]
            })
        ]
    });
};


const $91197becc4f4c199$var$TABS = [
    {
        key: 'flow',
        label: 'Flow'
    },
    {
        key: 'trends',
        label: 'Trends'
    },
    {
        key: 'insights',
        label: 'Insights'
    }
];
const $91197becc4f4c199$export$6268df79f24c119b = ()=>{
    // The page owns the breadcrumb: both tabs are "Analytics", and the
    // Trends branch must not depend on the Flow view having mounted.
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Analytics',
        reset: true
    });
    const [searchParams, setSearchParams] = (0, $0c90f43fc3673aef$export$f1a78c17382fe22a)();
    const param = searchParams.get('tab');
    const tab = param === 'trends' ? 'trends' : param === 'insights' ? 'insights' : 'flow';
    const selectTab = (next)=>{
        const updated = new URLSearchParams(searchParams);
        if (next === 'flow') updated.delete('tab');
        else updated.set('tab', next);
        setSearchParams(updated, {
            replace: true
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex-1 overflow-y-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mx-auto max-w-5xl px-4 pt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "border-border flex gap-1 border-b",
                    role: "tablist",
                    children: $91197becc4f4c199$var$TABS.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": tab === key,
                            onClick: ()=>selectTab(key),
                            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('-mb-px border-b-2 px-3 py-1.5 text-sm font-medium transition-colors', tab === key ? 'border-primary text-foreground' : 'text-muted-foreground hover:text-foreground border-transparent'),
                            children: label
                        }, key))
                })
            }),
            tab === 'flow' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a502907ef1d9bf81$export$3ae9608212c7954e), {}) : tab === 'trends' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66388f373e463ee8$export$2a1871d509f588c5), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acbbdb427c0b5d6c$export$940c04e354cf6222), {})
        ]
    });
};






parcelRequire("acw62");




// Years at or above this coverage read as "finish off the remainder"; below
// it they read as "this year was never really reviewed".
const $543391bd6fced84a$var$NEARLY_FINISHED_COVERAGE = 0.8;
const $543391bd6fced84a$var$coverage = (bucket)=>bucket.total > 0 ? (bucket.total - bucket.unallocated) / bucket.total : 0;
const $543391bd6fced84a$var$YearRow = ({ bucket: bucket, frontierDate: frontierDate })=>{
    const percent = Math.floor($543391bd6fced84a$var$coverage(bucket) * 100);
    // If the frontier falls inside this year, stop the drill-in the day
    // before it so the list matches the backlog count
    const yearEnd = frontierDate !== null && frontierDate.startsWith(`${bucket.year}-`) ? (0, $0c0f91b069db95d9$export$6b862160d295c8e)(frontierDate).minus({
        days: 1
    }).toISODate() ?? `${bucket.year}-12-31` : `${bucket.year}-12-31`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
        to: `/ledger?layer=activity&view=review&start=${bucket.year}-01-01&end=${yearEnd}`,
        className: "border-border hover:bg-muted/50 grid cursor-pointer grid-cols-[3.5rem_1fr_auto_auto] items-center gap-3 border-b px-4 py-3 transition-colors",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "font-semibold tabular-nums",
                children: bucket.year
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "bg-muted h-1.5 overflow-hidden rounded-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "block h-full rounded-full bg-green-700 dark:bg-green-500",
                    style: {
                        width: `${percent}%`
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-muted-foreground text-right text-sm whitespace-nowrap tabular-nums",
                children: [
                    bucket.unallocated.toLocaleString('en-US'),
                    " of",
                    ' ',
                    bucket.total.toLocaleString('en-US'),
                    " \xb7 ",
                    percent,
                    "% done"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                className: "text-muted-foreground size-4"
            })
        ]
    });
};
const $543391bd6fced84a$var$SectionHeading = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground px-4 pt-6 pb-2 text-xs font-semibold tracking-wide uppercase",
        children: children
    });
const $543391bd6fced84a$export$471ffbe87b75af04 = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Backlog',
        fallback: [
            {
                label: 'Inbox',
                href: '/'
            }
        ]
    });
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $ce9d9e524be20f53$export$edf7816f5074c300)({
        fetchPolicy: 'network-only'
    });
    const summary = data?.inboxBacklogSummary;
    if (loading && summary === undefined) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex h-full items-center justify-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
            size: "medium"
        })
    });
    if (summary === undefined && error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center gap-2 py-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground text-sm",
                children: "Couldn't load the backlog."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "text-foreground cursor-pointer text-sm underline",
                onClick: ()=>void refetch(),
                children: "Retry"
            })
        ]
    });
    if (summary === undefined || summary.backlogCount === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "No backlog \u2014 all historical activity is processed."
    });
    const processedPercent = summary.totalCount > 0 ? Math.round(summary.processedCount / summary.totalCount * 100) : 0;
    // Newest years first within each group: recent remainders are the most
    // likely to actually get finished.
    const yearsNewestFirst = [
        ...summary.years
    ].sort((a, b)=>b.year - a.year);
    const nearlyFinished = yearsNewestFirst.filter((bucket)=>$543391bd6fced84a$var$coverage(bucket) >= $543391bd6fced84a$var$NEARLY_FINISHED_COVERAGE);
    const mostlyUnreviewed = yearsNewestFirst.filter((bucket)=>$543391bd6fced84a$var$coverage(bucket) < $543391bd6fced84a$var$NEARLY_FINISHED_COVERAGE);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-full overflow-y-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "px-4 pt-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-2xl font-semibold",
                        children: [
                            summary.backlogCount.toLocaleString('en-US'),
                            " remaining"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-muted-foreground mt-0.5 text-sm",
                        children: [
                            summary.backlogOldestDate,
                            " \u2013 ",
                            summary.backlogNewestDate,
                            " \xb7 nothing newer is outstanding"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-muted mt-4 h-1.5 overflow-hidden rounded-full",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "h-full rounded-full bg-green-700 dark:bg-green-500",
                            style: {
                                width: `${processedPercent}%`
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-muted-foreground mt-1.5 text-xs",
                        children: [
                            processedPercent,
                            "% of all",
                            ' ',
                            summary.totalCount.toLocaleString('en-US'),
                            " historical raw transactions processed"
                        ]
                    })
                ]
            }),
            nearlyFinished.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($543391bd6fced84a$var$SectionHeading, {
                        children: "Nearly finished years"
                    }),
                    nearlyFinished.map((bucket)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($543391bd6fced84a$var$YearRow, {
                            bucket: bucket,
                            frontierDate: summary.frontierDate ?? null
                        }, bucket.year))
                ]
            }),
            mostlyUnreviewed.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($543391bd6fced84a$var$SectionHeading, {
                        children: "Mostly unreviewed"
                    }),
                    mostlyUnreviewed.map((bucket)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($543391bd6fced84a$var$YearRow, {
                            bucket: bucket,
                            frontierDate: summary.frontierDate ?? null
                        }, bucket.year))
                ]
            })
        ]
    });
};







/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $616a772d239eeda7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
            key: "1q158e"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ],
    [
        "path",
        {
            d: "M4 22V4",
            key: "1plyxx"
        }
    ],
    [
        "path",
        {
            d: "M7.656 2H8c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10.347",
            key: "xj1b71"
        }
    ]
];
const $616a772d239eeda7$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("flag-off", $616a772d239eeda7$export$3efd853dbb351e94);




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");

const $5c85b4944985fd4a$export$42a852a2b6b56249 = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex flex-col gap-4', className),
        ...props
    }));
const $5c85b4944985fd4a$export$155581e8dc02007a = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
        ref: ref,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-2xl font-semibold', className),
        ...props
    }));
const $5c85b4944985fd4a$export$8b251419efc915eb = /*#__PURE__*/ $acw62.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
        ref: ref,
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-lg', className),
        ...props
    }));
const $5c85b4944985fd4a$export$8732e8b6b8d8047b = ({ title: title, amount: amount, actions: actions })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-wrap items-start justify-between gap-x-4 gap-y-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-w-0 flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5c85b4944985fd4a$export$155581e8dc02007a, {
                        className: "break-words",
                        children: title
                    }),
                    amount != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-3xl tabular-nums",
                        children: amount
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex items-center gap-3",
                children: actions
            })
        ]
    });
const $5c85b4944985fd4a$export$1c13fee39bc6126e = 'text-destructive hover:bg-destructive/10 dark:hover:bg-destructive/15';



parcelRequire("acw62");

const $3019d26b5c607220$var$Section = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c85b4944985fd4a$export$8b251419efc915eb), {
                children: props.header
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overflow-hidden rounded border border-border",
                children: props.children
            })
        ]
    });
};
var $3019d26b5c607220$export$2e2bcd8739ae039 = $3019d26b5c607220$var$Section;









const $d69bc32c16614348$export$df121238a8835bce = ()=>{
    const params = (0, $926608a7a86d7371$export$99eaa27ddbbb95ef)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const anchorId = params.id || '';
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const { data: data, loading: loading, refetch: refetch } = (0, $ce9d9e524be20f53$export$aeaa97dc60d8067)({
        variables: {
            anchorId: anchorId
        },
        fetchPolicy: 'cache-and-network'
    });
    const anchor = data?.balanceAnchor;
    // The account supplies the currency and the credit-card sign convention. It
    // can't load until we know the anchor's account, hence skip.
    const { data: accountData, loading: accountLoading, refetch: refetchAccount } = (0, $ce9d9e524be20f53$export$83a5bf0e4425c554)({
        variables: {
            id: anchor?.accountId ?? ''
        },
        skip: !anchor
    });
    const account = accountData?.account;
    const currency = account?.currency ?? 'USD';
    const isDepository = account?.__typename === 'DepositoryAccount';
    const isCreditCard = isDepository && account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).CreditCard;
    // The account's anchors, only to decide whether this one can be the opening
    // balance: the opener must be the account's earliest anchor. The server is
    // the source of truth (it also rejects earlier transactions/readings); this
    // just avoids offering an action that would always fail.
    const { data: anchorsData } = (0, $ce9d9e524be20f53$export$4b244df86d92b624)({
        variables: {
            accountId: anchor?.accountId ?? ''
        },
        skip: !anchor
    });
    // Require the anchor list to be loaded before judging "earliest"/"latest":
    // an empty fallback while it loads would call every anchor both, and offer
    // designations the server would reject.
    const loadedAnchors = anchorsData?.balanceAnchors;
    const isEarliestAnchor = loadedAnchors != null && anchor != null && !loadedAnchors.some((a)=>a.date < anchor.date);
    const isLatestAnchor = loadedAnchors != null && anchor != null && !loadedAnchors.some((a)=>a.date > anchor.date);
    const isOpeningAnchor = isDepository && anchor != null && account.openingAnchorId === anchor._id;
    const isClosingAnchor = anchor != null && account?.closingAnchorId === anchor._id;
    const isDesignated = isOpeningAnchor || isClosingAnchor;
    const isReconciled = anchor?.reconciliation != null;
    // Date and balance are locked while referenced by a reconciliation (both
    // endpoints) OR while this anchor is the account's designated opening or
    // closing balance — a designated anchor marks a boundary date and is
    // required to stay zero, so both fields are pinned until the designation is
    // cleared.
    const dateLocked = isReconciled || isDesignated;
    const balanceLocked = isReconciled || isDesignated;
    const [note, setNote] = $acw62.useState('');
    const [date, setDate] = $acw62.useState(null);
    const [balance, setBalance] = $acw62.useState((0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).zero('USD')));
    const [error, setError] = $acw62.useState(null);
    const [saved, setSaved] = $acw62.useState(false);
    // Seed the edit form once the anchor (and its account's currency) is
    // known, and re-seed after a save refetch.
    $acw62.useEffect(()=>{
        if (!anchor) return;
        setNote(anchor.note ?? '');
        setDate((0, $0c0f91b069db95d9$export$6b862160d295c8e)(anchor.date));
        setBalance((0, $f8f45ddea4959097$exports.some)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
            amount: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(anchor.balance, isCreditCard),
            currency: currency
        })));
    }, [
        anchor?._id,
        anchor?.note,
        anchor?.date,
        anchor?.balance,
        isCreditCard,
        currency
    ]);
    const [updateAnchor, { loading: saving }] = (0, $ce9d9e524be20f53$export$2a466906a4d7f6d8)();
    const [setOpeningAnchor, { loading: settingOpening }] = (0, $ce9d9e524be20f53$export$ab9ffb3bbc50f2da)();
    const [setClosingAnchor, { loading: settingClosing }] = (0, $ce9d9e524be20f53$export$2c19470a6f45d0b2)();
    const [designationError, setDesignationError] = $acw62.useState(null);
    // Designate this anchor as the account's opening balance (its inception
    // floor), or clear the designation. Refresh both the anchor and the account
    // so the badge and the account header stay consistent.
    const handleSetOpening = async (makeOpening)=>{
        if (!anchor) return;
        setDesignationError(null);
        try {
            await setOpeningAnchor({
                variables: {
                    accountId: anchor.accountId,
                    anchorId: makeOpening ? anchor._id : null
                }
            });
            await Promise.all([
                refetch(),
                refetchAccount()
            ]);
        } catch (err) {
            setDesignationError(err instanceof Error ? err.message : 'Failed to update opening balance');
        }
    };
    // The mirror action: designate this anchor as the account's closing
    // balance (marking the account closed), or clear it (reopening).
    const handleSetClosing = async (makeClosing)=>{
        if (!anchor) return;
        setDesignationError(null);
        try {
            await setClosingAnchor({
                variables: {
                    accountId: anchor.accountId,
                    anchorId: makeClosing ? anchor._id : null
                }
            });
            await Promise.all([
                refetch(),
                refetchAccount()
            ]);
        } catch (err) {
            setDesignationError(err instanceof Error ? err.message : 'Failed to update closing balance');
        }
    };
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: anchor ? `Balance on ${anchor.date}` : anchorId,
        fallback: anchor ? [
            {
                label: 'Accounts',
                href: '/accounts'
            },
            {
                label: 'Balances',
                href: `/accounts/${anchor.accountId}`
            }
        ] : [
            {
                label: 'Accounts',
                href: '/accounts'
            }
        ]
    });
    if (!anchorId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "No balance selected"
    });
    if (loading && !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
        size: "medium"
    });
    if (!anchor) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "Balance anchor not found"
    });
    // Hold the page until the account resolves: it carries the currency and the
    // credit-card sign convention. Rendering the editor with the fallbacks
    // (USD, isCreditCard=false) would seed and save a credit-card balance with
    // the wrong sign, persisting an amount owed as a positive asset.
    if (accountLoading && !accountData) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
        size: "medium"
    });
    const displayBalance = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
        amount: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(anchor.balance, isCreditCard),
        currency: currency
    });
    const handleSave = async ()=>{
        setError(null);
        setSaved(false);
        if (balance.isEmpty) {
            setError('Please enter a balance amount');
            return;
        }
        // A referenced or designated anchor's date and balance are locked
        // server-side; send their current values so the note-only edit is
        // accepted rather than rejected.
        const storedBalance = balanceLocked ? anchor.balance : (0, $1d7c692b9128a045$export$d717750c75a5d699)(balance.get().toInt().amount, isCreditCard);
        const isoDate = dateLocked ? anchor.date : date?.toISODate() ?? anchor.date;
        try {
            await updateAnchor({
                variables: {
                    anchorId: anchor._id,
                    date: isoDate,
                    balance: storedBalance,
                    note: note.trim() === '' ? null : note.trim()
                }
            });
            setSaved(true);
            // Editing the newest anchor's balance updates Account.balance
            // server-side (non-Plaid accounts), so refresh the shared account cache
            // too — otherwise the account header stays stale on the way back.
            await Promise.all([
                refetch(),
                refetchAccount()
            ]);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to save changes');
        }
    };
    const handleReconcile = ()=>{
        modals.reconcileAnchorModal.openModal({
            anchorId: anchor._id,
            accountId: anchor.accountId,
            anchorDate: anchor.date,
            anchorBalance: anchor.balance,
            currency: currency,
            isCreditCard: isCreditCard,
            onSuccess: ()=>void refetch()
        });
    };
    const handleUnreconcile = ()=>{
        if (!anchor.reconciliation) return;
        modals.deleteReconciliationModal.openModal({
            reconciliationId: anchor.reconciliation._id,
            anchorDate: anchor.date,
            transactionCount: anchor.reconciliation.rawTransactions?.length ?? 0,
            onDeleted: ()=>void refetch()
        });
    };
    const handleDelete = ()=>{
        modals.deleteBalanceEntryModal.openModal({
            kind: 'anchor',
            entryId: anchor._id,
            entryDate: anchor.date,
            // Deleting the newest anchor rolls Account.balance back server-side.
            // Refresh the cached account before leaving so the destination's
            // cache-first header doesn't show the deleted balance, then navigate
            // back to the account's balances tab — this row is gone.
            onDeleted: ()=>{
                refetchAccount().finally(()=>navigate(`/accounts/${anchor.accountId}`));
            }
        });
    };
    const reconciliation = anchor.reconciliation;
    // The reconcile mutation returns a reconciliation without the
    // rawTransactions (and baselineAnchor) fields this page reads. Apollo can
    // briefly replace the richer detail-query object in the cache with that
    // partial one before refetch() lands, so treat those fields as possibly
    // absent rather than dereferencing them.
    const claimedTransactions = reconciliation?.rawTransactions ?? [];
    const baseline = reconciliation?.baselineAnchor ?? null;
    const changeCents = baseline != null ? (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(anchor.balance, isCreditCard) - (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(baseline.balance, isCreditCard) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-1 flex-col overflow-y-auto p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5c85b4944985fd4a$export$42a852a2b6b56249), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5c85b4944985fd4a$export$155581e8dc02007a), {
                            children: [
                                "Balance on ",
                                anchor.date
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-2",
                            children: [
                                isReconciled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "rounded-full bg-emerald-600 px-2 py-0.5 text-xs font-semibold text-white",
                                    children: [
                                        "Reconciled (",
                                        claimedTransactions.length,
                                        " txns)"
                                    ]
                                }),
                                anchor.needsReview && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "inline-flex items-center gap-1 rounded-full bg-amber-500 px-2 py-0.5 text-xs font-semibold text-white",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                            className: "size-3"
                                        }),
                                        "Review needed"
                                    ]
                                }),
                                isOpeningAnchor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "inline-flex items-center gap-1 rounded-full bg-sky-600 px-2 py-0.5 text-xs font-semibold text-white",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $604e08b57548a73d$export$2e2bcd8739ae039), {
                                            className: "size-3"
                                        }),
                                        "Opening balance"
                                    ]
                                }),
                                isClosingAnchor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "inline-flex items-center gap-1 rounded-full bg-slate-600 px-2 py-0.5 text-xs font-semibold text-white",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $616a772d239eeda7$export$2e2bcd8739ae039), {
                                            className: "size-3"
                                        }),
                                        "Closing balance"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap gap-2",
                            children: [
                                isReconciled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    onClick: handleUnreconcile,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10875ae52ac5df60$export$2e2bcd8739ae039), {
                                            className: "mr-1 size-4"
                                        }),
                                        "Unreconcile"
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    onClick: handleReconcile,
                                    children: "Reconcile"
                                }),
                                isOpeningAnchor ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    disabled: settingOpening,
                                    onClick: ()=>void handleSetOpening(false),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $604e08b57548a73d$export$2e2bcd8739ae039), {
                                            className: "mr-1 size-4"
                                        }),
                                        "Clear opening balance"
                                    ]
                                }) : isDepository && isEarliestAnchor && Math.round(anchor.balance) === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    disabled: settingOpening,
                                    onClick: ()=>void handleSetOpening(true),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $604e08b57548a73d$export$2e2bcd8739ae039), {
                                            className: "mr-1 size-4"
                                        }),
                                        "Set as opening balance"
                                    ]
                                }),
                                isClosingAnchor ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    disabled: settingClosing,
                                    onClick: ()=>void handleSetClosing(false),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $616a772d239eeda7$export$2e2bcd8739ae039), {
                                            className: "mr-1 size-4"
                                        }),
                                        "Reopen account"
                                    ]
                                }) : isLatestAnchor && Math.round(anchor.balance) === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    disabled: settingClosing,
                                    onClick: ()=>void handleSetClosing(true),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $616a772d239eeda7$export$2e2bcd8739ae039), {
                                            className: "mr-1 size-4"
                                        }),
                                        "Set as closing balance"
                                    ]
                                }),
                                !isReconciled && !isDesignated && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    variant: "destructive",
                                    onClick: handleDelete,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                            className: "mr-1 size-4"
                                        }),
                                        "Delete"
                                    ]
                                })
                            ]
                        }),
                        designationError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-destructive text-sm",
                            children: designationError
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
                    header: "Details",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-3 p-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                label: "Date",
                                children: dateLocked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-wrap items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: anchor.date
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground text-xs",
                                            children: isReconciled ? "Locked \u2014 unreconcile to change the date." : isOpeningAnchor ? "Locked \u2014 clear the opening balance to change the date." : "Locked \u2014 reopen the account to change the date."
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79f1e6c6881a02e0$export$2e2bcd8739ae039), {
                                    selectedDate: date ?? (0, $0c0f91b069db95d9$export$6b862160d295c8e)(anchor.date),
                                    onChange: setDate
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                label: isCreditCard ? 'Amount owed' : 'Balance',
                                children: balanceLocked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-wrap items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                            amount: displayBalance,
                                            variant: "plain",
                                            inline: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground text-xs",
                                            children: isReconciled ? "Locked \u2014 unreconcile to change the balance." : isOpeningAnchor ? "Locked \u2014 clear the opening balance to change it." : "Locked \u2014 reopen the account to change it."
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf5f3d9d49aeb89e$export$2e2bcd8739ae039), {
                                    value: balance,
                                    onChange: setBalance,
                                    currency: currency
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                label: "Source",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground inline-block rounded-full border border-current px-2 py-0.5 text-xs",
                                    children: anchor.source
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                label: "Note",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    value: note,
                                    onChange: (e)=>setNote(e.target.value),
                                    placeholder: "e.g. Statement closing balance",
                                    className: "border-border bg-background text-foreground focus:ring-ring w-full rounded-md border px-3 py-2 text-sm focus:ring-1 focus:outline-none"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                        variant: "primary",
                                        disabled: saving,
                                        onClick: ()=>void handleSave(),
                                        children: "Save"
                                    }),
                                    saved && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground text-sm",
                                        children: "Saved."
                                    }),
                                    error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-destructive text-sm",
                                        children: error
                                    })
                                ]
                            })
                        ]
                    })
                }),
                reconciliation ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
                            header: "Reconciliation",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col gap-3 p-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                        label: "Baseline",
                                        children: baseline ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                            to: `/balance-anchors/${baseline._id}`,
                                            className: "underline",
                                            children: [
                                                baseline.date,
                                                " \xb7",
                                                ' ',
                                                formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
                                                    amount: (0, $1d7c692b9128a045$export$bd72e98d1c10a7e4)(baseline.balance, isCreditCard),
                                                    currency: currency
                                                }))
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground italic",
                                            children: "(baseline removed)"
                                        })
                                    }),
                                    changeCents != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                        label: "Change",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                            amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer({
                                                amount: changeCents,
                                                currency: currency
                                            }),
                                            variant: "delta",
                                            inline: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                        label: "Ending",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                            amount: displayBalance,
                                            variant: "plain",
                                            inline: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                                        label: "Reconciled",
                                        children: (0, $63618293c58b5f80$exports.DateTime).fromMillis(reconciliation.reconciledAt).toLocaleString((0, $63618293c58b5f80$exports.DateTime).DATETIME_MED)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
                            header: `Transactions (${claimedTransactions.length})`,
                            children: claimedTransactions.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e054dd754d7f7b3$export$2e2bcd8739ae039), {
                                transactions: claimedTransactions
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-muted-foreground p-4 text-sm",
                                children: "No transactions \u2014 the balance was unchanged since the baseline."
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
                    header: "Reconciliation",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground p-4 text-sm",
                        children: "Not reconciled. Reconcile it against the account transactions to lock in the balance change since the last anchor."
                    })
                })
            ]
        })
    });
};





parcelRequire("acw62");




parcelRequire("acw62");







const $41649910134fa38c$var$formatDay = (dt)=>dt.toLocaleString({
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
// The card's face when it has one (a 34px chip is enough to tell a silver
// slab from a navy one), else the institution logo as before.
//
// The face follows the fee year the row is labelled with, not the account's
// current identity: the row name comes from the display period's product, so
// a lapsed Sapphire Reserve year on a card since converted to JetBlue must
// not put the JetBlue face beside the Reserve name. Falls back to the
// account's product for a period recorded before faces existed.
const $41649910134fa38c$var$CardLogo = ({ feePeriod: feePeriod })=>{
    const { account: account } = feePeriod;
    const product = feePeriod.cardProduct ?? account.cardProduct;
    return (0, $86559021d806b4ea$export$f2ae116f2284ed4d)(product) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b39b2c71e902baf$export$ebcc69552e0d5c4c), {
        product: product,
        className: "w-12"
    }) : account.logo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: (0, $cd179cdb1a4beac3$export$2e8a6207c9cc2bb8)(account.logo),
        alt: "",
        className: "size-5 shrink-0 rounded"
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f6f28ec3b697fb2$export$fdaddccc706daa3a), {
        account: account,
        className: "size-5 shrink-0"
    });
};
const $41649910134fa38c$var$NetLabel = ({ net: net })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `text-sm font-medium tabular-nums ${net >= 0 ? 'text-positive' : 'text-destructive'}`,
        children: (0, $a5f774b73aaf5820$export$9fd9a6c97e959d35)(net)
    });
/**
 * Cycle meter against the year's potential, fee position as a tick: bar past
 * the tick means the tracked credits already outran the fee.
 */ const $41649910134fa38c$var$CycleMeter = ({ stats: stats })=>{
    if (stats.potential <= 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-muted/40 h-2 rounded-full"
    });
    // Scale to whichever is larger: when the fee exceeds the tracked potential
    // (e.g. a card whose value is mostly untracked perks), a full bar must
    // still stop short of the tick instead of pretending the fee was covered
    const scale = Math.max(stats.potential, stats.fee);
    const pct = (cents)=>Math.max(0, Math.min(100, cents / scale * 100));
    const spans = (0, $853b33c2f2306612$export$549a9d736f93e9f7)(stats);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative",
        title: `${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(Math.max(0, stats.captured))} of ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(stats.potential)} captured \xb7 fee ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(stats.fee)}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-muted/40 flex h-2 overflow-hidden rounded-full",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "bg-green-500/50",
                        style: {
                            width: `${pct(spans.posted)}%`
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "stripe-booked",
                        style: {
                            width: `${pct(spans.booked)}%`
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "bg-blue-400/60",
                        style: {
                            width: `${pct(stats.open)}%`
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "stripe-missed",
                        style: {
                            width: `${pct(stats.missed)}%`
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "bg-foreground/70 absolute -inset-y-0.5 w-[2px] rounded-full",
                style: {
                    left: `${pct(stats.fee)}%`
                },
                title: `fee ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(stats.fee)}`
            })
        ]
    });
};
const $41649910134fa38c$export$408776bb88ffa78b = ({ group: group })=>{
    const { displayPeriod: displayPeriod } = group;
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    if (!group.isCurrent) {
        const endDay = (0, $a5f774b73aaf5820$export$409494cf6876ac3e)(displayPeriod.endDate);
        // A recently-lapsed card reads as a result; long-dormant ones as history
        const recentlyEnded = !group.isUpcoming && now.diff(endDay, 'days').days <= 400;
        const stats = (0, $853b33c2f2306612$export$f9b975a80d6d4e01)(displayPeriod, now);
        const yearCount = 1 + group.pastPeriods.length;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
            to: `/accounts/${group.accountId}/benefits`,
            className: "hover:bg-accent/20 flex items-center gap-2.5 px-4 py-2.5",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41649910134fa38c$var$CardLogo, {
                    feePeriod: displayPeriod
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "text-muted-foreground min-w-0 flex-1 truncate text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-foreground/80 font-medium",
                            children: group.name
                        }),
                        group.isUpcoming ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                " \xb7 starts ",
                                $41649910134fa38c$var$formatDay((0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(displayPeriod.startDate))
                            ]
                        }) : recentlyEnded ? // A custom window can stay open past the fee period's end — the
                        // result isn't final until nothing is left to claim
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                ' ',
                                "\xb7 ended ",
                                $41649910134fa38c$var$formatDay(endDay),
                                stats.open > 0 ? '' : " \u2014 final"
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                ' ',
                                "\xb7 no active fee period \xb7 ",
                                yearCount,
                                " fee year",
                                yearCount === 1 ? '' : 's'
                            ]
                        })
                    ]
                }),
                group.isUpcoming ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "text-muted-foreground text-xs tabular-nums",
                    children: [
                        (0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(displayPeriod.amount),
                        " fee"
                    ]
                }) : stats.open > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "text-xs font-medium text-blue-600 tabular-nums dark:text-blue-300",
                    children: [
                        (0, $a5f774b73aaf5820$export$5723d387948018e1)(stats.open),
                        " open"
                    ]
                }) : recentlyEnded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41649910134fa38c$var$NetLabel, {
                    net: stats.net
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground text-xs",
                    children: "history"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                    className: "text-muted-foreground size-3.5 shrink-0"
                })
            ]
        });
    }
    const stats = (0, $853b33c2f2306612$export$f9b975a80d6d4e01)(displayPeriod, now);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
        to: `/accounts/${group.accountId}/benefits`,
        // Narrow screens drop the meter and open columns (name + net only) so
        // the overview never scrolls horizontally
        className: "hover:bg-accent/20 grid grid-cols-[minmax(0,1fr)_5.5rem_auto] items-center gap-3 px-4 py-2.5 lg:grid-cols-[minmax(11rem,15rem)_1fr_9.5rem_5.5rem_auto]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "flex min-w-0 items-center gap-2.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41649910134fa38c$var$CardLogo, {
                        feePeriod: displayPeriod
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "block truncate text-sm font-medium",
                                children: group.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-muted-foreground block truncate text-[11px]",
                                children: [
                                    "to ",
                                    $41649910134fa38c$var$formatDay((0, $a5f774b73aaf5820$export$409494cf6876ac3e)(displayPeriod.endDate)),
                                    " \xb7",
                                    ' ',
                                    (0, $a5f774b73aaf5820$export$5723d387948018e1)(displayPeriod.amount),
                                    " fee"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "hidden lg:block",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41649910134fa38c$var$CycleMeter, {
                    stats: stats
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "hidden text-right text-xs tabular-nums lg:block",
                children: [
                    stats.open > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-blue-600 dark:text-blue-300",
                        children: [
                            stats.openWindowCount,
                            " open \xb7 ",
                            (0, $a5f774b73aaf5820$export$5723d387948018e1)(stats.open)
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground",
                        children: "nothing open"
                    }),
                    stats.missed > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-amber-600 dark:text-amber-400",
                        children: [
                            ' ',
                            "\xb7 \u2212",
                            (0, $a5f774b73aaf5820$export$5723d387948018e1)(stats.missed)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-right",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41649910134fa38c$var$NetLabel, {
                    net: stats.net
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                className: "text-muted-foreground size-3.5 shrink-0"
            })
        ]
    });
};







var $acw62 = parcelRequire("acw62");




const $461d0b2c26b673e6$var$OPENING_SOON_DAYS = 60;
const $461d0b2c26b673e6$var$OPENING_SOON_SHOWN = 4;
const $461d0b2c26b673e6$export$5ebc88470420b109 = ({ feePeriods: feePeriods, onUpdate: onUpdate })=>{
    const { createTransactionForBenefitModal: createTransactionForBenefitModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    const queue = (0, $853b33c2f2306612$export$3ccbd4bba7610f22)(feePeriods, now);
    const openTotal = queue.reduce((sum, item)=>sum + item.window.openRemaining, 0);
    const openingSoon = (0, $853b33c2f2306612$export$f2a3b994c1e847e)(feePeriods, now, $461d0b2c26b673e6$var$OPENING_SOON_DAYS);
    const openingSoonLine = openingSoon.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        className: "text-muted-foreground px-4 py-2 text-xs",
        children: [
            "Opening soon:",
            ' ',
            openingSoon.slice(0, $461d0b2c26b673e6$var$OPENING_SOON_SHOWN).map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                    children: [
                        index > 0 && " \xb7 ",
                        (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(item.window.startDate).toLocaleString({
                            month: 'short',
                            day: 'numeric'
                        }),
                        ' ',
                        "\u2014 ",
                        item.benefit.name,
                        " ",
                        (0, $a5f774b73aaf5820$export$5723d387948018e1)(item.remaining)
                    ]
                }, item.benefit._id)),
            openingSoon.length > $461d0b2c26b673e6$var$OPENING_SOON_SHOWN && ` \xb7 +${openingSoon.length - $461d0b2c26b673e6$var$OPENING_SOON_SHOWN} more`
        ]
    }) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                className: "text-muted-foreground mb-1.5 flex items-baseline gap-2 px-0.5 text-[11px] font-semibold tracking-wider uppercase",
                children: [
                    "Claim next",
                    queue.length > 0 && ` \u{2014} ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(openTotal)} open`
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-card divide-border divide-y rounded-lg border",
                children: [
                    queue.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground px-4 py-3 text-sm",
                        children: "Nothing to claim right now."
                    }),
                    queue.map((item)=>{
                        const { benefit: benefit, feePeriod: feePeriod, window: window } = item;
                        const usedPct = window.amount > 0 ? Math.max(0, Math.min(100, Math.round(window.usedAmount / window.amount * 100))) : 0;
                        const soon = window.daysLeft != null && window.daysLeft <= 60;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-3 px-4 py-2.5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "min-w-0 flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "truncate text-sm font-medium",
                                            children: [
                                                benefit.name,
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "text-muted-foreground hidden text-xs font-normal sm:inline",
                                                    children: [
                                                        "\xb7 ",
                                                        feePeriod.payee ?? feePeriod.account.name
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-muted-foreground truncate text-[11px]",
                                            children: [
                                                (0, $a5f774b73aaf5820$export$a053908c5c4ea08d)(window.startDate, window.endDate),
                                                window.usedAmount > 0 && ` \xb7 ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(window.usedAmount)} used`
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-muted/40 hidden h-1.5 w-36 overflow-hidden rounded-full lg:block",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-green-500/50 h-full",
                                        style: {
                                            width: `${usedPct}%`
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-right tabular-nums sm:w-24",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-sm font-semibold text-blue-600 dark:text-blue-300",
                                            children: (0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(window.openRemaining)
                                        }),
                                        window.usedAmount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-muted-foreground block text-[10px]",
                                            children: [
                                                "of ",
                                                (0, $a5f774b73aaf5820$export$5723d387948018e1)(window.amount)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: `rounded-full px-2 py-0.5 text-center text-[11px] font-medium tabular-nums sm:w-28 ${soon ? 'bg-blue-500/10 text-blue-600 ring-1 ring-blue-400/40 ring-inset dark:text-blue-300' : 'bg-muted/60 text-muted-foreground'}`,
                                    children: [
                                        (0, $a5f774b73aaf5820$export$409494cf6876ac3e)(window.endDate).toLocaleString({
                                            month: 'short',
                                            day: 'numeric'
                                        }),
                                        " \xb7 ",
                                        window.daysLeft,
                                        "d"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                    size: "icon",
                                    variant: "ghost",
                                    className: "shrink-0",
                                    title: "Record a use of this benefit",
                                    onClick: ()=>createTransactionForBenefitModal.openModal({
                                            benefit: benefit,
                                            feePeriodPayee: feePeriod.payee,
                                            onSuccess: onUpdate
                                        }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $960851586a15b7fa$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    })
                                })
                            ]
                        }, `${benefit._id}-${window.startDate}`);
                    }),
                    openingSoonLine
                ]
            })
        ]
    });
};






// Current cards first, then upcoming, then lapsed; alphabetical within each
const $ff1ad71ab74dacb2$var$groupSortKey = (group)=>group.isCurrent ? 0 : group.isUpcoming ? 1 : 2;
const $ff1ad71ab74dacb2$export$278bc258c14e1813 = (allFeePeriods)=>{
    const byAccount = new Map();
    for (const fp of allFeePeriods){
        const existing = byAccount.get(fp.accountId);
        if (existing) existing.push(fp);
        else byAccount.set(fp.accountId, [
            fp
        ]);
    }
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    const groups = [];
    for (const [accountId, feePeriods] of byAccount){
        feePeriods.sort((a, b)=>b.startDate - a.startDate);
        const display = (0, $a5f774b73aaf5820$export$859cbae57b7e86ba)(feePeriods);
        if (!display) continue;
        const others = feePeriods.filter((fp)=>fp !== display);
        groups.push({
            accountId: accountId,
            name: (0, $86559021d806b4ea$export$16faba7ad8bb8def)(display.cardProduct) ?? display.payee ?? display.account.name,
            displayPeriod: display,
            isCurrent: (0, $a5f774b73aaf5820$export$74b02150c48af0bd)(display.startDate, display.endDate),
            isUpcoming: (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(display.startDate) > now,
            upcomingPeriods: others.filter((fp)=>fp.startDate > display.startDate).reverse(),
            pastPeriods: others.filter((fp)=>fp.startDate <= display.startDate)
        });
    }
    return groups.sort((a, b)=>$ff1ad71ab74dacb2$var$groupSortKey(a) - $ff1ad71ab74dacb2$var$groupSortKey(b) || a.name.localeCompare(b.name));
};







const $2f287dea82674520$export$b06b821702967001 = ()=>{
    const { data: data, loading: loading, refetch: refetch } = (0, $ce9d9e524be20f53$export$46a1dde66166f325)();
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Benefits',
        reset: true
    });
    // Queue membership and countdowns are clock-derived; tick so a page left
    // open across a day boundary stays honest
    (0, $c97fcc07e588b835$export$88da3a4d83ed79ab)();
    const handleRefetch = ()=>{
        refetch();
    };
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading benefits..."
        })
    });
    // Time-dependent (window states shift with the clock), so derive per render
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    const allFeePeriods = data?.allFeePeriods ?? [];
    const cardGroups = (0, $ff1ad71ab74dacb2$export$278bc258c14e1813)(allFeePeriods);
    const currentGroups = cardGroups.filter((group)=>group.isCurrent);
    const currentPeriods = currentGroups.map((group)=>group.displayPeriod);
    // Portfolio totals across every card's current cycle
    let totalFees = 0;
    let totalCredits = 0;
    let totalMissed = 0;
    let missedWindows = 0;
    for (const feePeriod of currentPeriods){
        const stats = (0, $853b33c2f2306612$export$f9b975a80d6d4e01)(feePeriod, now);
        totalFees += stats.fee;
        totalCredits += stats.captured;
        totalMissed += stats.missed;
        missedWindows += stats.missedWindowCount;
    }
    const totalNet = totalCredits - totalFees;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col gap-4 overflow-y-auto p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-lg font-semibold",
                children: "Benefits"
            }),
            cardGroups.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-border rounded-lg border border-dashed p-8 text-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground",
                    children: "No card benefits."
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    currentPeriods.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-2.5 lg:grid-cols-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5514a995335d19$export$d27a382dda47f62b), {
                                value: (0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(totalFees),
                                sub: `fees \xb7 ${currentPeriods.length} active card${currentPeriods.length === 1 ? '' : 's'}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5514a995335d19$export$d27a382dda47f62b), {
                                // Signed: clawbacks can push the aggregate negative, and an
                                // unsigned total would contradict the net tile beside it
                                value: (0, $a5f774b73aaf5820$export$317de5adef9ec643)(totalCredits),
                                sub: "credits, posted + booked, current cycles"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5514a995335d19$export$d27a382dda47f62b), {
                                value: `net ${(0, $a5f774b73aaf5820$export$9fd9a6c97e959d35)(totalNet)}`,
                                tone: totalNet >= 0 ? 'sage' : 'red',
                                sub: "all current cycles"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5514a995335d19$export$d27a382dda47f62b), {
                                value: totalMissed > 0 ? (0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(totalMissed) : 'nothing',
                                tone: totalMissed > 0 ? 'amber' : 'default',
                                sub: totalMissed > 0 ? `missed \xb7 ${missedWindows} expired window${missedWindows === 1 ? '' : 's'}` : 'missed so far'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $461d0b2c26b673e6$export$5ebc88470420b109), {
                        feePeriods: allFeePeriods,
                        onUpdate: handleRefetch
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-muted-foreground mb-1.5 px-0.5 text-[11px] font-semibold tracking-wider uppercase",
                                children: "Cards"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "border-border bg-card divide-border divide-y rounded-lg border",
                                children: cardGroups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41649910134fa38c$export$408776bb88ffa78b), {
                                        group: group
                                    }, group.accountId))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

















var $acw62 = parcelRequire("acw62");







const $5f9e131a65ff6a75$var$BindingValuePicker = ({ bindingKey: bindingKey, entityId: entityId, accounts: accounts, categories: categories, fields: fields, onSet: onSet, onCreateAndBindCategory: onCreateAndBindCategory })=>{
    const spec = (0, $86610e55c8afdf1c$export$5f9e987797135574)[bindingKey];
    // Re-selecting the current value is a no-op, not a write: AccountSelect
    // opens on focus and submits its first match on Tab, so a keyboard pass
    // through the page must never rewrite (or worse, re-point) a binding the
    // user didn't touch.
    const handleChange = (nextEntityId)=>{
        if (nextEntityId !== entityId) onSet(bindingKey, nextEntityId);
    };
    if (spec.entityType === 'account') {
        const bound = accounts.find((account)=>account._id === entityId);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $295751b0f96fd69d$export$2e2bcd8739ae039), {
            selectedAccount: bound ? (0, $f8f45ddea4959097$exports.some)(bound) : (0, $f8f45ddea4959097$exports.none),
            // Slots whose flow is single-currency only offer matching accounts —
            // binding a EUR account to a USD import would just make the import
            // fail the server's currency guard later.
            currency: spec.currency,
            onSelectAccount: (selection)=>handleChange(selection.map((account)=>account._id).getOrElse(null))
        });
    }
    if (spec.entityType === 'field') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
        label: "Field",
        allLabel: "Not set",
        options: fields.map((field)=>({
                key: field._id,
                label: field.name
            })),
        value: entityId ?? 'all',
        onChange: (value)=>handleChange(value === 'all' ? null : value)
    });
    // Bindings store entity ids while CategoryPicker trades in names, so the
    // row maps between the two. A name that matches no category is the
    // picker's Add "…" path — the category is created and then bound, never
    // silently read as a clear (only an explicitly emptied picker clears).
    const boundCategory = categories.find((category)=>category._id === entityId);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9eb11e6352514841$export$2e2bcd8739ae039), {
        selectedCategory: boundCategory ? (0, $f8f45ddea4959097$exports.some)(boundCategory.name) : (0, $f8f45ddea4959097$exports.none),
        onSelectCategory: (selection)=>{
            if (selection.isEmpty) {
                handleChange(null);
                return;
            }
            selection.forEach((name)=>{
                const existing = categories.find((category)=>category.name === name);
                if (existing) handleChange(existing._id);
                else onCreateAndBindCategory(bindingKey, name);
            });
        }
    });
};
const $5f9e131a65ff6a75$var$BindingRow = ({ bindingKey: bindingKey, entityId: entityId, accounts: accounts, categories: categories, fields: fields, entitiesReady: entitiesReady, onSet: onSet, onCreateAndBindCategory: onCreateAndBindCategory })=>{
    const labelId = $acw62.useId();
    const spec = (0, $86610e55c8afdf1c$export$5f9e987797135574)[bindingKey];
    // A bound id whose entity no longer exists renders an empty picker, which
    // alone would misread as "not set" — say what happened and offer the way
    // out. Only once the entity list has loaded, though: an unresolved (or
    // failed) query is not evidence of deletion, and offering Clear on that
    // false reading would let a slow connection destroy a valid binding.
    const dangling = entitiesReady && entityId != null && (spec.entityType === 'account' ? !accounts.some((account)=>account._id === entityId) : spec.entityType === 'field' ? !fields.some((field)=>field._id === entityId) : !categories.some((category)=>category._id === entityId));
    // A closed account still exists, but every flow that reads its binding
    // deliberately skips it (a closed account accepts no new rows) — showing
    // it here as quietly valid would misrepresent what the flow will do.
    const boundAccount = spec.entityType === 'account' ? accounts.find((account)=>account._id === entityId) : undefined;
    const closedBound = boundAccount != null && (0, $e597f4605156a89e$export$881343af68ecca95)(boundAccount);
    // setBinding now refuses wrong-currency accounts, but rows stored before
    // that guard (or before a slot declared its currency) can still hold one
    // — and the flows deliberately skip it, so it must not present as
    // healthy.
    const currencyMismatch = boundAccount != null && spec.currency != null && boundAccount.currency !== spec.currency;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border flex flex-col justify-between gap-2 border-b py-3 last:border-b-0 sm:flex-row sm:items-center sm:gap-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: labelId,
                        className: "text-foreground text-sm font-medium",
                        children: spec.label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground text-sm",
                        children: spec.description
                    }),
                    entityId == null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground mt-0.5 text-xs",
                        children: "Not set \u2014 remembered the first time the flow runs"
                    }),
                    dangling && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-destructive mt-0.5 text-xs",
                        children: [
                            "The bound ",
                            spec.entityType,
                            " no longer exists \u2014 pick another or clear it."
                        ]
                    }),
                    closedBound && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-destructive mt-0.5 text-xs",
                        children: "The bound account is closed, so flows skip it \u2014 pick another or clear it."
                    }),
                    currencyMismatch && boundAccount && spec.currency && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-destructive mt-0.5 text-xs",
                        children: [
                            "The bound account is denominated in ",
                            boundAccount.currency,
                            ", but this slot requires ",
                            spec.currency,
                            " \u2014 flows skip it; pick another or clear it."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                role: "group",
                "aria-labelledby": labelId,
                className: "flex shrink-0 items-center gap-2 sm:w-72",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "min-w-0 flex-1",
                        children: entitiesReady || entityId == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5f9e131a65ff6a75$var$BindingValuePicker, {
                            bindingKey: bindingKey,
                            entityId: entityId,
                            accounts: accounts,
                            categories: categories,
                            fields: fields,
                            onSet: onSet,
                            onCreateAndBindCategory: onCreateAndBindCategory
                        }) : // A bound id with no loaded entity list must not render an
                        // interactive picker: it would show empty, and tabbing out of
                        // an empty search commits a clear (SearchBox invokes onClear
                        // on blur) — silently destroying a valid binding.
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-muted-foreground py-1.5 text-sm",
                            children: "Loading\u2026"
                        })
                    }),
                    (dangling || closedBound || currencyMismatch) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        className: "px-3 py-1.5 text-sm",
                        onClick: ()=>onSet(bindingKey, null),
                        children: "Clear"
                    })
                ]
            })
        ]
    });
};
const $5f9e131a65ff6a75$export$88111244a00d81e1 = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Defaults',
        fallback: [
            {
                label: 'Settings',
                href: '/settings'
            }
        ]
    });
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const { data: bindingsData, loading: loading, error: bindingsError, refetch: refetch } = (0, $ce9d9e524be20f53$export$7d26fb86ec9e5950)();
    const { data: accountsData } = (0, $ce9d9e524be20f53$export$cb6e321bdf608ddb)();
    const { data: categoriesData } = (0, $ce9d9e524be20f53$export$1f9e2535d0d42ab9)();
    const { data: fieldsData } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)();
    const [setBinding] = (0, $ce9d9e524be20f53$export$cd4833426b480f1a)();
    const [createCategory] = (0, $ce9d9e524be20f53$export$b8da3e59c773b24a)();
    const [error, setError] = $acw62.useState(null);
    // Writes are chained: the server resolver rewrites the whole bindings
    // array from what it read, so two in-flight setBinding calls could each
    // read the same original and the later one silently drop the other's
    // edit. Serializing here closes that within this page; cross-tab writes
    // stay last-write-wins, the same deliberate trade-off documented on the
    // categoryGroups resolver.
    const pendingWrite = $acw62.useRef(Promise.resolve());
    // Intent guard for the async create+bind below: every direct change to a
    // row bumps its token, and a category creation only binds if its token is
    // still current — so a slow create can never overwrite a newer choice the
    // user made while it was in flight.
    const bindingIntents = $acw62.useRef(new Map());
    const bumpIntent = (key)=>{
        const next = (bindingIntents.current.get(key) ?? 0) + 1;
        bindingIntents.current.set(key, next);
        return next;
    };
    const handleSet = (key, entityId)=>{
        setError(null);
        bumpIntent(key);
        pendingWrite.current = pendingWrite.current.then(()=>setBinding({
                variables: {
                    key: key,
                    entityId: entityId
                }
            })).then(()=>{
            // Root-field evict is the app's idiom for refreshing this query; the
            // active useBindingsQuery refetches and the row re-renders.
            client.cache.evict({
                fieldName: 'bindings'
            });
        }).catch((err)=>{
            // Also settles the chain, so a failed write never wedges later ones.
            setError(err instanceof Error ? err.message : 'Failed to save');
        });
    };
    // The category picker's Add "…" path: create the category first, then
    // bind its id — mirroring the inline get-or-create the transaction forms
    // do by name. The refetch keeps the just-created category in the row's
    // list, so its name resolves on the next render.
    const handleCreateAndBindCategory = (key, name)=>{
        setError(null);
        const intent = bumpIntent(key);
        createCategory({
            variables: {
                name: name
            },
            // Written into the cache synchronously (not refetched): the bound id
            // must resolve against the category list the moment the row
            // re-renders, or a valid fresh binding would present as dangling
            // until some later refetch happened to succeed.
            update: (store, result)=>{
                const created = result.data?.createCategory;
                if (created) (0, $5f9091afcb8d9899$export$8c292b02ce03981f)(store, created);
            }
        }).then((result)=>{
            const created = result.data?.createCategory;
            if (!created) return;
            // A newer selection on this row superseded the Add while the
            // category was being created — the category exists (harmless),
            // but it must not overwrite the newer choice.
            if (bindingIntents.current.get(key) === intent) handleSet(key, created._id);
        }).catch((err)=>{
            setError(err instanceof Error ? err.message : 'Failed to create category');
        });
    };
    if (loading && bindingsData == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading defaults..."
        })
    });
    // A failed bindings query is not an empty configuration — rendering the
    // rows as "Not set" would invite edits made against false state.
    if (bindingsData == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center gap-3 p-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-destructive text-sm",
                children: [
                    "Failed to load defaults",
                    bindingsError ? `: ${bindingsError.message}` : ''
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: ()=>void refetch(),
                children: "Retry"
            })
        ]
    });
    const bindings = bindingsData?.bindings ?? [];
    const boundEntityId = (key)=>bindings.find((binding)=>binding.key === key)?.entityId ?? null;
    return(// flex-1 + overflow-y-auto: MainPane puts routes in a flex column with
    // overflow-hidden, so the page must own its vertical scrolling or rows
    // past the viewport are unreachable.
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col gap-4 overflow-y-auto p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-lg font-semibold",
                        children: "Defaults"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground text-sm",
                        children: "Accounts and categories that recurring flows target \u2014 remembered automatically when a flow first runs, adjustable here"
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-destructive text-sm",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-border rounded-lg border px-4",
                children: (0, $86610e55c8afdf1c$export$f69e7fae3174d69d).map((bindingKey)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5f9e131a65ff6a75$var$BindingRow, {
                        bindingKey: bindingKey,
                        entityId: boundEntityId(bindingKey),
                        accounts: accountsData?.allAccounts ?? [],
                        categories: categoriesData?.allCategories ?? [],
                        fields: fieldsData?.allFields ?? [],
                        entitiesReady: (0, $86610e55c8afdf1c$export$5f9e987797135574)[bindingKey].entityType === 'account' ? accountsData != null : (0, $86610e55c8afdf1c$export$5f9e987797135574)[bindingKey].entityType === 'field' ? fieldsData != null : categoriesData != null,
                        onSet: handleSet,
                        onCreateAndBindCategory: handleCreateAndBindCategory
                    }, bindingKey))
            })
        ]
    }));
};








var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");





/**
 * A per-share price: the one quantity in the app that needs more precision
 * than Money's integer hundredths (private-company 409A prices carry up to
 * five decimals — $0.60875). Stored at rest as a decimal string exactly as
 * the source document states it; parsed once at the entity→domain boundary
 * into this class, so application code never touches the raw string and
 * misuse (lexicographic comparison, ad-hoc parseFloat) is unreachable
 * rather than merely discouraged.
 *
 * Internally the value is integer micro-dollars (1e-6 units) — an
 * implementation detail nothing outside this file sees. All money
 * arithmetic exits through {@link SharePrice.times}, which returns a Money
 * in integer cents; from there Money's own currency-mismatch throws guard
 * the rest of the pipeline.
 *
 * Parsing is pure string math (split on '.', pad the fraction) — no float
 * anywhere, so any canonical string round-trips exactly.
 */ class $7c753920dce0820f$var$SharePrice {
    constructor(micros, currency){
        /**
   * The money exit: this price times a whole number of shares, as Money in
   * integer cents (micros → cents rounds half away from zero; the product
   * is formed in BigInt so magnitude never silently mis-rounds). Shares may
   * be negative — a draw reversal — but must be integers.
   */ this.times = (shares)=>{
            if (!Number.isSafeInteger(shares)) throw new Error(`SharePrice.times: shares must be an integer, got ${shares}`);
            const product = BigInt(this.micros) * BigInt(shares);
            const divisor = BigInt(10000);
            const half = divisor / BigInt(2);
            const negative = product < BigInt(0);
            const magnitude = negative ? -product : product;
            const cents = (magnitude + half) / divisor;
            const signed = Number(negative ? -cents : cents);
            if (!Number.isSafeInteger(signed)) throw new Error("SharePrice.times: result exceeds safe integer range");
            return (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(signed, this.currency);
        };
        /**
   * This price times a fractional quantity (brokerage shares, fund units,
   * crypto), as Money in integer cents, rounded half away from zero once.
   * The quantity is taken at fifteen significant digits, exactly, in
   * BigInt: a decimal place count would drop the digits of a tiny crypto
   * quantity.
   */ this.timesQuantity = (quantity)=>{
            if (!Number.isFinite(quantity)) throw new Error(`SharePrice.timesQuantity: quantity must be finite, got ${quantity}`);
            // quantity = digits × 10^shift, digits a fifteen-digit integer.
            const [mantissa, exponent] = quantity.toExponential(14).split("e");
            const digits = BigInt(mantissa.replace(".", ""));
            const shift = Number(exponent) - 14;
            const tenTo = (n)=>BigInt(`1${"0".repeat(n)}`);
            const product = BigInt(this.micros) * digits * (shift > 0 ? tenTo(shift) : BigInt(1));
            const divisor = BigInt(10000) * (shift < 0 ? tenTo(-shift) : BigInt(1));
            const half = divisor / BigInt(2);
            const negative = product < BigInt(0);
            const magnitude = negative ? -product : product;
            const cents = (magnitude + half) / divisor;
            const signed = Number(negative ? -cents : cents);
            if (!Number.isSafeInteger(signed)) throw new Error("SharePrice.timesQuantity: result exceeds safe integer range");
            return (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(signed, this.currency);
        };
        /** Price delta (may be negative), e.g. sale price minus basis. */ this.minus = (other)=>{
            if (this.currency !== other.currency) throw new Error("Subtracting share prices in different currencies");
            return new $7c753920dce0820f$var$SharePrice(this.micros - other.micros, this.currency);
        };
        /** Numeric ordering: negative, zero, or positive like a comparator. */ this.compare = (other)=>{
            if (this.currency !== other.currency) throw new Error("Comparing share prices in different currencies");
            return this.micros - other.micros;
        };
        this.equals = (other)=>this.currency === other.currency && this.micros === other.micros;
        /**
   * Canonical decimal string — what gets stored and sent over GraphQL.
   * Minimum two decimals, trailing zeros beyond that stripped: "63.00",
   * "0.60875", "10.406". Round-trips through parse exactly.
   */ this.toString = ()=>{
            const negative = this.micros < 0;
            const magnitude = Math.abs(this.micros);
            const whole = Math.floor(magnitude / 1000000);
            const fraction = String(magnitude % 1000000).padStart(6, "0");
            const trimmed = fraction.replace(/0+$/, "").padEnd(2, "0");
            return `${negative ? "-" : ""}${whole}.${trimmed}`;
        };
        /** "$0.60875" for USD; "12.50 EUR"-style suffix for anything else. */ this.format = ()=>this.currency === "USD" ? `$${this.toString()}` : `${this.toString()} ${this.currency}`;
        /**
   * The price as a plain number — for chart scales and axes ONLY, never for
   * money math (that goes through {@link SharePrice.times}).
   */ this.toNumber = ()=>this.micros / 1000000;
        this.micros = micros;
        this.currency = currency;
    }
    static{
        /**
   * Parse a canonical decimal string: optional leading '$' and surrounding
   * whitespace tolerated, then digits with at most six decimals — no signs,
   * commas, or exponents. Throws on anything else. The integer part is
   * capped at nine digits so micros stay far inside safe-integer range.
   */ this.parse = (raw, currency)=>{
            const cleaned = raw.trim().replace(/^\$/, "");
            const match = /^(\d{1,9})(?:\.(\d{1,6}))?$/.exec(cleaned);
            if (!match) throw new Error(`Invalid share price "${raw}": expected a plain decimal with at most six decimal places`);
            const whole = Number(match[1]);
            const fraction = Number((match[2] ?? "").padEnd(6, "0"));
            return new $7c753920dce0820f$var$SharePrice(whole * 1000000 + fraction, currency);
        };
    }
    static{
        /** Like {@link SharePrice.parse} but returns null instead of throwing. */ this.tryParse = (raw, currency)=>{
            try {
                return $7c753920dce0820f$var$SharePrice.parse(raw, currency);
            } catch  {
                return null;
            }
        };
    }
    static{
        /**
   * Sum of price × shares terms, rounded ONCE at the end: rounding each
   * term to cents independently drifts by up to half a cent per term
   * (an event drawing many lots would accumulate the error). Terms must
   * share a currency; at least one term is required.
   */ this.sumTimes = (terms)=>{
            if (terms.length === 0) throw new Error("SharePrice.sumTimes: at least one term is required");
            const currency = terms[0][0].currency;
            let total = BigInt(0);
            for (const [price, shares] of terms){
                if (price.currency !== currency) throw new Error("Summing share prices in different currencies");
                if (!Number.isSafeInteger(shares)) throw new Error(`SharePrice.sumTimes: shares must be an integer, got ${shares}`);
                total += BigInt(price.micros) * BigInt(shares);
            }
            const divisor = BigInt(10000);
            const half = divisor / BigInt(2);
            const negative = total < BigInt(0);
            const magnitude = negative ? -total : total;
            const cents = (magnitude + half) / divisor;
            const signed = Number(negative ? -cents : cents);
            if (!Number.isSafeInteger(signed)) throw new Error("SharePrice.sumTimes: result exceeds safe integer range");
            return (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(signed, currency);
        };
    }
}
var $7c753920dce0820f$export$2e2bcd8739ae039 = $7c753920dce0820f$var$SharePrice;


const $4b9cbf18d627f8e6$var$toMs = (seconds)=>seconds * 1000;
/** Marks sorted ascending with prices parsed once. */ const $4b9cbf18d627f8e6$var$parsedMarks = (issuer)=>[
        ...issuer.marks
    ].sort((a, b)=>a.date - b.date).map((mark)=>({
            date: mark.date,
            price: (0, $7c753920dce0820f$export$2e2bcd8739ae039).parse(mark.price, mark.currency)
        }));
const $4b9cbf18d627f8e6$var$markAt = (marks, date)=>{
    let current = null;
    for (const mark of marks){
        if (mark.date <= date) current = mark.price;
        else break;
    }
    return current;
};
const $4b9cbf18d627f8e6$export$96e21e8d02caa689 = (issuer, todaySeconds)=>{
    const marks = $4b9cbf18d627f8e6$var$parsedMarks(issuer).filter((mark)=>mark.date <= todaySeconds);
    return marks.length > 0 ? marks[marks.length - 1] : null;
};
const $4b9cbf18d627f8e6$export$bde32c9ec0a9e0bd = (issuer)=>issuer.marks[0]?.currency ?? issuer.lots[0]?.currency ?? 'USD';
const $4b9cbf18d627f8e6$export$4ead0eaee86eb5fb = (value, currency)=>(value / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 2
    });
const $4b9cbf18d627f8e6$export$404b9ff92ca803cd = (lot)=>(0, $7c753920dce0820f$export$2e2bcd8739ae039).parse(lot.basisPerShare, lot.currency);
const $4b9cbf18d627f8e6$export$f51e1e2e54b5d4f4 = (issuer, { priceBasis: priceBasis, todaySeconds: todaySeconds })=>{
    const marks = $4b9cbf18d627f8e6$var$parsedMarks(issuer);
    if (marks.length === 0) return [];
    const latest = $4b9cbf18d627f8e6$export$96e21e8d02caa689(issuer, todaySeconds)?.price ?? null;
    const lots = [
        ...issuer.lots
    ].sort((a, b)=>a.acquiredDate - b.acquiredDate);
    const events = [
        ...issuer.events
    ].sort((a, b)=>a.date - b.date);
    // Proceeds an event banked, best-effort when undocumented: the stated
    // gross, else price x shares, else the mark of the day x shares. Without
    // the fallback an estimated sale would subtract its shares from the
    // realized+held line while adding nothing back — a permanent understatement
    // masquerading as continuity.
    const proceedsCents = (event)=>{
        if (event.grossCents != null) return event.grossCents;
        // A sale before the first mark still estimates at the earliest known
        // price rather than 0 — same best-effort rule as withheld settlements.
        const price = event.price != null ? (0, $7c753920dce0820f$export$2e2bcd8739ae039).parse(event.price, event.currency) : $4b9cbf18d627f8e6$var$markAt(marks, event.date) ?? marks[0].price;
        return price.times(event.sharesSold).amount;
    };
    const eventsByDate = new Map();
    for (const event of events){
        const list = eventsByDate.get(event.date) ?? [];
        list.push(event);
        eventsByDate.set(event.date, list);
    }
    // Option grants: strike parsed once, tranches sorted; exercises attribute
    // through lot.grantId (shares + withheld both came out of the grant).
    const grants = issuer.grants.map((grant)=>({
            id: grant._id,
            strike: (0, $7c753920dce0820f$export$2e2bcd8739ae039).parse(grant.strikePerShare, grant.currency),
            tranches: [
                ...grant.tranches
            ].sort((a, b)=>a.date - b.date)
        }));
    const exercisesByGrant = new Map();
    for (const lot of lots){
        if (lot.grantId == null) continue;
        const list = exercisesByGrant.get(lot.grantId) ?? [];
        list.push({
            date: lot.acquiredDate,
            shares: lot.sharesAcquired + (lot.sharesWithheldForTax ?? 0)
        });
        exercisesByGrant.set(lot.grantId, list);
    }
    /** Intrinsic value of vested-unexercised options at `date`, priced at `price`. */ const optionValueCents = (date, price)=>{
        if (price == null) return 0;
        let cents = 0;
        for (const grant of grants){
            // Cross-currency strike vs mark cannot be compared; such a grant
            // contributes nothing rather than throwing (unlinked-issuer armor).
            if (grant.strike.currency !== price.currency) continue;
            if (price.compare(grant.strike) <= 0) continue;
            const vested = grant.tranches.reduce((sum, tranche)=>tranche.date <= date ? sum + tranche.shares : sum, 0);
            const exercised = (exercisesByGrant.get(grant.id) ?? []).reduce((sum, exercise)=>exercise.date <= date ? sum + exercise.shares : sum, 0);
            const outstanding = Math.max(0, vested - exercised);
            if (outstanding === 0) continue;
            cents += price.minus(grant.strike).times(outstanding).amount;
        }
        return cents;
    };
    // The chart spans first mark → today: pre-mark dates would plot unknown
    // values as $0 (the server models them as null), and future-dated
    // documents (the mutations accept them) stay off like the server's
    // current valuation.
    const firstMarkDate = marks[0].date;
    const dates = [
        ...new Set([
            ...marks.map((mark)=>mark.date),
            ...lots.map((lot)=>lot.acquiredDate),
            ...events.map((event)=>event.date),
            ...grants.flatMap((grant)=>grant.tranches.map((tranche)=>tranche.date)),
            todaySeconds
        ])
    ].filter((date)=>date >= firstMarkDate && date <= todaySeconds).sort((a, b)=>a - b);
    return dates.map((date)=>{
        let acquired = 0;
        let withheld = 0;
        // Withheld shares settled a tax bill: their value freezes at the mark
        // of their settlement date, feeding the realized line.
        let withheldValueCents = 0;
        for (const lot of lots){
            if (lot.acquiredDate > date) break;
            acquired += lot.sharesAcquired;
            const lotWithheld = lot.sharesWithheldForTax ?? 0;
            if (lotWithheld > 0) {
                withheld += lotWithheld;
                // The lot's basis IS the settlement-date FMV (the model defines
                // basisPerShare as FMV at acquisition for releases and exercises),
                // so it beats any surrounding mark — a preceding one is stale and
                // a later one is look-ahead.
                withheldValueCents += $4b9cbf18d627f8e6$export$404b9ff92ca803cd(lot).times(lotWithheld).amount;
            }
        }
        let sold = 0;
        let grossCents = 0;
        for (const event of events){
            if (event.date > date) break;
            sold += event.sharesSold;
            grossCents += proceedsCents(event);
        }
        const priceOfDay = $4b9cbf18d627f8e6$var$markAt(marks, date);
        const heldPrice = priceBasis === 'today' ? latest ?? priceOfDay : priceOfDay;
        const value = (shares)=>heldPrice ? heldPrice.times(shares).amount / 100 : 0;
        const daySales = eventsByDate.get(date) ?? [];
        const sale = daySales.length > 0 ? {
            name: daySales.map((event)=>event.name).join(" \xb7 "),
            shares: daySales.reduce((sum, event)=>sum + event.sharesSold, 0),
            // Partial documentation makes the day's total unknown — a sum
            // over some of the sales would understate it as if complete.
            grossCents: daySales.some((event)=>event.grossCents == null) ? null : daySales.reduce((sum, event)=>sum + (event.grossCents ?? 0), 0)
        } : null;
        // Options are holdings too: intrinsic value rides every line, priced
        // like the shares (so the today-basis toggle revalues them as well).
        const optionCents = optionValueCents(date, heldPrice);
        return {
            timestamp: $4b9cbf18d627f8e6$var$toMs(date),
            neverSold: value(acquired + withheld) + optionCents / 100,
            actual: value(acquired - sold) + optionCents / 100,
            realizedHeld: value(acquired - sold) + (grossCents + withheldValueCents + optionCents) / 100,
            fmv: priceOfDay ? priceOfDay.toNumber() : null,
            sale: sale
        };
    });
};
const $4b9cbf18d627f8e6$export$1c54eef6c6212d26 = (issuer, todaySeconds)=>{
    const latest = $4b9cbf18d627f8e6$export$96e21e8d02caa689(issuer, todaySeconds);
    // Long-term means held MORE than one calendar year: acquired strictly
    // before today's one-year-ago anniversary (365-day math drifts across
    // leap years, and the anniversary itself is still short-term).
    const oneYearAgo = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(todaySeconds).minus({
        years: 1
    }).toSeconds();
    const drawnByLot = new Map();
    for (const event of issuer.events){
        if (event.date > todaySeconds) continue;
        for (const draw of event.draws)drawnByLot.set(draw.lotId, (drawnByLot.get(draw.lotId) ?? 0) + draw.shares);
    }
    return issuer.lots.filter((lot)=>lot.acquiredDate <= todaySeconds).sort((a, b)=>a.acquiredDate - b.acquiredDate).map((lot)=>{
        const basis = $4b9cbf18d627f8e6$export$404b9ff92ca803cd(lot);
        const remaining = lot.sharesAcquired - (drawnByLot.get(lot._id) ?? 0);
        // Cross-currency documents are storable on an unlinked issuer;
        // SharePrice.minus throws on a mismatch, so an incomparable pair
        // reads as unknown rather than crashing the page.
        const comparable = latest != null && latest.price.currency === basis.currency;
        return {
            lot: lot,
            basis: basis,
            sharesRemaining: remaining,
            basisCents: basis.times(remaining).amount,
            valueCents: latest ? latest.price.times(remaining).amount : null,
            unrealizedCents: comparable ? latest.price.minus(basis).times(remaining).amount : null,
            longTerm: lot.acquiredDate < oneYearAgo
        };
    });
};
const $4b9cbf18d627f8e6$export$bc7c0aa27a56e81b = (issuer, todaySeconds)=>{
    const rows = $4b9cbf18d627f8e6$export$1c54eef6c6212d26(issuer, todaySeconds).filter((row)=>row.sharesRemaining > 0);
    // The aggregate is unknown as soon as any held row's gain is — a partial
    // sum in the tile would contradict the em dash in the lots footer.
    const allKnown = rows.every((row)=>row.unrealizedCents != null);
    return {
        sharesHeld: issuer.sharesHeld,
        valueCents: issuer.valueCents ?? null,
        basisCents: rows.reduce((sum, row)=>sum + row.basisCents, 0),
        unrealizedCents: allKnown ? rows.reduce((sum, row)=>sum + (row.unrealizedCents ?? 0), 0) : null
    };
};
const $4b9cbf18d627f8e6$export$fb1ebb8f1ab536ac = (issuer, todaySeconds)=>{
    const currency = $4b9cbf18d627f8e6$export$bde32c9ec0a9e0bd(issuer);
    const events = issuer.events.filter((event)=>event.date <= todaySeconds);
    // Countable = has a gross AND is in the issuer's display currency —
    // cross-currency cents (storable on an unlinked issuer) can no more be
    // summed than compared, so they join the excluded count instead.
    const documented = events.filter((event)=>event.grossCents != null && event.currency === currency);
    const grossCents = documented.length > 0 ? documented.reduce((sum, event)=>sum + (event.grossCents ?? 0), 0) : null;
    const documentedShares = documented.reduce((sum, event)=>sum + event.sharesSold, 0);
    // Range and average sit in one tile, so both describe the same events:
    // the documented ones. Endpoints derive as gross over shares when there
    // is no recorded price — or when the event is estimated, whose price and
    // gross are allowed to disagree and whose gross is what the average uses.
    const prices = documented.map((event)=>event.price != null && !event.estimated ? (0, $7c753920dce0820f$export$2e2bcd8739ae039).parse(event.price, event.currency).toNumber() : event.sharesSold > 0 ? (event.grossCents ?? 0) / 100 / event.sharesSold : null).filter((price)=>price != null);
    return {
        eventCount: events.length,
        sharesSold: events.reduce((sum, event)=>sum + event.sharesSold, 0),
        grossCents: grossCents,
        documentedSharesSold: documentedShares,
        // Net counts every same-currency event that pins it down: a recorded
        // net (even with no gross), else gross minus recorded costs — the
        // waterfall's own derivation, or gross would masquerade as cash in hand.
        netCents: (()=>{
            const knownNet = events.filter((event)=>event.currency === currency && (event.netCents != null || event.grossCents != null));
            return knownNet.length > 0 ? knownNet.reduce((sum, event)=>sum + (event.netCents ?? (event.grossCents ?? 0) - event.withholdingCents - event.exerciseCostCents), 0) : null;
        })(),
        avgPriceDollars: grossCents != null && documentedShares > 0 ? grossCents / 100 / documentedShares : null,
        minPriceDollars: prices.length > 0 ? Math.min(...prices) : null,
        maxPriceDollars: prices.length > 0 ? Math.max(...prices) : null,
        // The two exclusion counts partition the excluded events: any other-
        // currency event is a currency exclusion whatever fields it carries;
        // "undocumented" means same-currency with no recorded gross.
        undocumentedCount: events.filter((event)=>event.currency === currency && event.grossCents == null).length,
        excludedCurrencyCount: events.filter((event)=>event.currency !== currency).length,
        netUnknownCount: events.filter((event)=>event.currency === currency && event.grossCents == null && event.netCents == null).length,
        estimatedCount: events.filter((event)=>event.estimated).length
    };
};



// Whole units for the big numbers, cents once a value is small enough that
// rounding would misstate it (a 61-cent position is not "$1").
const $ec2d1793cd89e9cd$var$dollars = (value, currency)=>value.toLocaleString('en-US', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: value !== 0 && Math.abs(value) < 10 ? 2 : 0
    });
const $ec2d1793cd89e9cd$var$dateLabel = (timestamp)=>new Date(timestamp).toLocaleDateString('en-US', {
        timeZone: 'UTC',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
/** Green $ badge on the actual line wherever a sale happened. */ const $ec2d1793cd89e9cd$var$SaleDot = (props)=>{
    const { cx: cx, cy: cy, payload: payload } = props;
    if (cx == null || cy == null || payload?.sale == null) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: cx,
                cy: cy - 14,
                r: 8,
                fill: "var(--chart-3)",
                stroke: "var(--color-background)",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                x: cx,
                y: cy - 10.5,
                textAnchor: "middle",
                fontSize: 10,
                fontWeight: 700,
                fill: "var(--color-background)",
                children: "$"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: cx,
                y1: cy - 6,
                x2: cx,
                y2: cy - 3,
                stroke: "var(--chart-3)",
                strokeWidth: 2,
                opacity: 0.6
            })
        ]
    });
};
const $ec2d1793cd89e9cd$var$SERIES = [
    {
        key: 'neverSold',
        name: 'If never sold',
        color: 'var(--color-muted-foreground)',
        dashed: true
    },
    {
        key: 'realizedHeld',
        name: 'Realized + held',
        color: 'var(--chart-2)',
        dashed: false
    },
    {
        key: 'actual',
        name: 'Actual holdings',
        color: 'var(--chart-1)',
        dashed: false
    }
];
const $ec2d1793cd89e9cd$var$ChartTooltip = ({ active: active, payload: payload, currency: currency })=>{
    if (!active || !payload || payload.length === 0) return null;
    const point = payload[0].payload;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-popover text-popover-foreground rounded-md border p-2 font-mono text-xs shadow-md",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mb-1 font-semibold",
                children: $ec2d1793cd89e9cd$var$dateLabel(point.timestamp)
            }),
            $ec2d1793cd89e9cd$var$SERIES.map((series)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center gap-1.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "inline-block w-3.5 border-t-2",
                            style: {
                                borderColor: series.color,
                                borderTopStyle: series.dashed ? 'dashed' : 'solid'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                series.name,
                                " ",
                                $ec2d1793cd89e9cd$var$dollars(point[series.key], currency)
                            ]
                        })
                    ]
                }, series.key)),
            point.fmv != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "inline-block w-3.5 border-t-2",
                        style: {
                            borderColor: 'var(--chart-4)'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "FMV",
                            ' ',
                            point.fmv.toLocaleString('en-US', {
                                style: 'currency',
                                currency: currency,
                                maximumFractionDigits: 6
                            }),
                            "/sh"
                        ]
                    })
                ]
            }),
            point.sale && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-1 flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "inline-block size-2.5 rounded-full",
                        style: {
                            background: 'var(--chart-3)'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "font-semibold",
                        children: [
                            point.sale.name,
                            ": sold ",
                            point.sale.shares.toLocaleString('en-US'),
                            ' ',
                            "sh",
                            point.sale.grossCents != null ? ` \u{2192} ${(0, $4b9cbf18d627f8e6$export$4ead0eaee86eb5fb)(point.sale.grossCents, currency)}` : ''
                        ]
                    })
                ]
            })
        ]
    });
};
const $ec2d1793cd89e9cd$var$PRICE_BASIS_OPTIONS = [
    {
        value: 'atTheTime',
        label: 'Price at the time'
    },
    {
        value: 'today',
        label: "Today's price"
    }
];
const $ec2d1793cd89e9cd$export$a5e5e2eac8df34e4 = ({ issuer: issuer })=>{
    const { dateRange: dateRange, setDateRange: setDateRange } = (0, $2481f76376092917$export$1799ff211e43f48e)('ALL');
    const [priceBasis, setPriceBasis] = $acw62.useState('atTheTime');
    const todaySeconds = $acw62.useMemo(()=>(0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().toSeconds(), []);
    const allPoints = $acw62.useMemo(()=>(0, $4b9cbf18d627f8e6$export$f51e1e2e54b5d4f4)(issuer, {
            priceBasis: priceBasis,
            todaySeconds: todaySeconds
        }), [
        issuer,
        priceBasis,
        todaySeconds
    ]);
    const points = $acw62.useMemo(()=>{
        // The picker's DateTimes live in the browser's zone; the points sit at
        // midnight UTC. Compare calendar days, not instants, or a boundary
        // point slips out of the window on either side of UTC.
        const utcDay = (value)=>Date.UTC(value.year, value.month - 1, value.day);
        const startMs = dateRange.startDate ? utcDay(dateRange.startDate) : null;
        const endMs = dateRange.endDate ? utcDay(dateRange.endDate) : null;
        const inside = allPoints.filter((point)=>(startMs == null || point.timestamp >= startMs) && (endMs == null || point.timestamp <= endMs));
        // A window cut between ledger dates still has a position: carry the
        // last preceding point onto each boundary so the steps enter (and, for
        // a historical end date, leave) at the right height — a quiet custom
        // window is a flat line, not "not enough history". Boundaries clamp to
        // the last real point (today): the series deliberately ends there, so
        // no synthetic point may extend it into the future, and a wholly
        // future window charts nothing.
        const lastRealTs = allPoints[allPoints.length - 1]?.timestamp ?? null;
        const carryTo = (boundaryMs)=>{
            const carried = [
                ...allPoints
            ].reverse().find((point)=>point.timestamp < boundaryMs);
            return carried ? {
                ...carried,
                timestamp: boundaryMs,
                sale: null
            } : null;
        };
        if (startMs != null && lastRealTs != null && startMs <= lastRealTs && (inside.length === 0 || inside[0].timestamp > startMs)) {
            const carried = carryTo(startMs);
            if (carried) inside.unshift(carried);
        }
        if (endMs != null && lastRealTs != null) {
            const endBoundary = Math.min(endMs, lastRealTs);
            if (inside.length === 0 || inside[inside.length - 1].timestamp < endBoundary) {
                const carried = carryTo(endBoundary + 1);
                if (carried) inside.push({
                    ...carried,
                    timestamp: endBoundary
                });
            }
        }
        return inside;
    }, [
        allPoints,
        dateRange
    ]);
    const latest = (0, $4b9cbf18d627f8e6$export$96e21e8d02caa689)(issuer, todaySeconds);
    const currency = (0, $4b9cbf18d627f8e6$export$bde32c9ec0a9e0bd)(issuer);
    // Controls render regardless — a range with too little to chart must stay
    // reversible from the range picker itself.
    const chartable = points.length >= 2;
    const firstTs = chartable ? points[0].timestamp : 0;
    const lastTs = chartable ? points[points.length - 1].timestamp : 0;
    const ticks = (0, $c45cbe94b11ffc58$export$2fd906f40273e9a6)(firstTs, lastTs);
    const formatTick = (0, $c45cbe94b11ffc58$export$2319624620038bd2)(firstTs, lastTs);
    const axisProps = {
        dataKey: 'timestamp',
        type: 'number',
        scale: 'time',
        domain: [
            'dataMin',
            'dataMax'
        ],
        ticks: ticks,
        tickFormatter: formatTick,
        tick: {
            fill: 'var(--color-muted-foreground)',
            fontSize: 12
        },
        tickLine: {
            stroke: 'var(--color-border)'
        },
        axisLine: {
            stroke: 'var(--color-border)'
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2 px-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2481f76376092917$export$26dc5fbaa253de80), {
                        value: dateRange,
                        onChange: setDateRange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex items-center gap-1",
                        children: $ec2d1793cd89e9cd$var$PRICE_BASIS_OPTIONS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                className: "px-2.5 py-1 text-xs",
                                variant: priceBasis === option.value ? 'primary' : 'outline',
                                onClick: ()=>setPriceBasis(option.value),
                                children: option.label
                            }, option.value))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground ml-auto flex items-center gap-1.5 text-xs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "inline-block size-2.5 rounded-full",
                                style: {
                                    background: 'var(--chart-3)'
                                }
                            }),
                            "$ = sale"
                        ]
                    })
                ]
            }),
            !chartable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground p-6 text-sm",
                children: "Not enough history to chart in this window \u2014 widen the range, or record a couple of marks first."
            }),
            chartable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
                        width: "100%",
                        height: 320,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d1341a4ce4753cde$export$54d0e8420ac838ac), {
                            data: points,
                            syncId: "equity",
                            margin: {
                                top: 18,
                                right: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                                    strokeDasharray: "3 3",
                                    stroke: "var(--color-border)",
                                    strokeWidth: 1.5
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                                    ...axisProps
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                                    tick: {
                                        fill: 'var(--color-muted-foreground)',
                                        fontSize: 12
                                    },
                                    tickFormatter: (value)=>$ec2d1793cd89e9cd$var$dollars(value, currency),
                                    tickLine: {
                                        stroke: 'var(--color-border)'
                                    },
                                    axisLine: {
                                        stroke: 'var(--color-border)'
                                    },
                                    width: 80
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                                    content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec2d1793cd89e9cd$var$ChartTooltip, {
                                        currency: currency
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f4bd73be8c7e839$export$ed247974535929c7), {
                                    wrapperStyle: {
                                        paddingTop: '8px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                                    type: "stepAfter",
                                    dataKey: "neverSold",
                                    name: "If never sold",
                                    stroke: "var(--color-muted-foreground)",
                                    strokeDasharray: "5 4",
                                    strokeWidth: 2,
                                    dot: false,
                                    isAnimationActive: false
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                                    type: "stepAfter",
                                    dataKey: "realizedHeld",
                                    name: "Realized + held",
                                    stroke: "var(--chart-2)",
                                    strokeWidth: 2,
                                    dot: false,
                                    isAnimationActive: false
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                                    type: "stepAfter",
                                    dataKey: "actual",
                                    name: "Actual holdings",
                                    stroke: "var(--chart-1)",
                                    strokeWidth: 2,
                                    dot: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec2d1793cd89e9cd$var$SaleDot, {}),
                                    isAnimationActive: false
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-muted-foreground px-1 text-xs",
                        children: [
                            "FMV per share",
                            latest ? ` \u{2014} latest ${latest.price.format()}` : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
                        width: "100%",
                        height: 110,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $40df630ec903a4ea$export$f510429275d6f1a8), {
                            data: points,
                            syncId: "equity",
                            margin: {
                                right: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                                    strokeDasharray: "3 3",
                                    stroke: "var(--color-border)",
                                    strokeWidth: 1.5
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                                    ...axisProps
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                                    tick: {
                                        fill: 'var(--color-muted-foreground)',
                                        fontSize: 12
                                    },
                                    tickFormatter: (value)=>// Marks can sit well under a currency unit ($0.60875); whole-
                                        // unit ticks would all read $0/$1 on such an axis.
                                        value.toLocaleString('en-US', {
                                            style: 'currency',
                                            currency: currency,
                                            maximumFractionDigits: value > 0 && value < 10 ? 2 : 0
                                        }),
                                    tickLine: {
                                        stroke: 'var(--color-border)'
                                    },
                                    axisLine: {
                                        stroke: 'var(--color-border)'
                                    },
                                    width: 80
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                                    content: ()=>null
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                                    type: "stepAfter",
                                    dataKey: "fmv",
                                    name: "FMV per share",
                                    stroke: "var(--chart-4)",
                                    strokeWidth: 2,
                                    fill: "var(--chart-4)",
                                    fillOpacity: 0.12,
                                    connectNulls: true,
                                    isAnimationActive: false
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};







var $acw62 = parcelRequire("acw62");


const $bde7ba4c26b4bf8e$var$dateLabel = (seconds)=>(0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(seconds).toLocaleString({
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
/**
 * The money waterfall of one sale: gross split into what taxes and exercise
 * cost took versus what was actually banked. Widths are proportional so the
 * 2023 tender's "why was the net only 2M of 4.66M" is visible at a glance.
 */ const $bde7ba4c26b4bf8e$var$Waterfall = ({ event: event, currency: currency })=>{
    const cents = (value)=>(0, $4b9cbf18d627f8e6$export$4ead0eaee86eb5fb)(value, currency);
    // Only an UNKNOWN gross has nothing to draw — a zero gross with positive
    // costs is a valid all-loss event whose shortfall must still show.
    const gross = event.grossCents;
    if (gross == null) return null;
    const withholding = event.withholdingCents;
    const exercise = event.exerciseCostCents;
    const net = event.netCents ?? gross - withholding - exercise;
    const segments = [
        {
            label: 'Net',
            value: net,
            className: 'bg-chart-3'
        },
        {
            label: 'Withholding',
            value: withholding,
            className: 'bg-chart-8'
        },
        {
            label: 'Exercise cost',
            value: exercise,
            className: 'bg-chart-4'
        }
    ].filter((segment)=>segment.value > 0);
    // Costs can legitimately exceed gross (net negative); scale to whichever
    // is larger so the bar never clips, and call the shortfall out in text
    // instead of hiding the loss.
    const scale = Math.max(gross, withholding + exercise);
    if (segments.length === 0 || scale <= 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-border flex h-2.5 w-full overflow-hidden rounded-full border",
                children: segments.map((segment)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: segment.className,
                        style: {
                            width: `${segment.value / scale * 100}%`
                        }
                    }, segment.label))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground flex flex-wrap gap-x-3 gap-y-0.5 text-xs",
                children: [
                    segments.map((segment)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('inline-block size-2 rounded-full', segment.className)
                                }),
                                segment.label,
                                " ",
                                cents(segment.value),
                                gross > 0 && ` (${Math.round(segment.value / gross * 100)}%)`
                            ]
                        }, segment.label)),
                    net < 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-destructive font-medium",
                        children: [
                            "Shortfall ",
                            cents(net),
                            " \u2014 costs exceeded gross"
                        ]
                    })
                ]
            })
        ]
    });
};
const $bde7ba4c26b4bf8e$export$d9b6df68b7fd1d03 = ({ issuer: issuer, todaySeconds: todaySeconds })=>{
    const currency = (0, $4b9cbf18d627f8e6$export$bde32c9ec0a9e0bd)(issuer);
    const cents = (value)=>(0, $4b9cbf18d627f8e6$export$4ead0eaee86eb5fb)(value, currency);
    const totals = (0, $4b9cbf18d627f8e6$export$fb1ebb8f1ab536ac)(issuer, todaySeconds);
    // Same cutoff as the header totals — a future-dated event can't show a
    // card above a summary that excludes it.
    const events = $acw62.useMemo(()=>issuer.events.filter((event)=>event.date <= todaySeconds).sort((a, b)=>b.date - a.date), [
        issuer,
        todaySeconds
    ]);
    if (events.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground py-6 text-center text-sm",
        children: issuer.events.length > 0 ? `No liquidity events yet \u{2014} ${issuer.events.length} future-dated event${issuer.events.length === 1 ? '' : 's'} not shown.` : 'No liquidity events recorded yet.'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-2 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-foreground text-base font-semibold",
                        children: "Liquidity events"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground text-xs tabular-nums",
                        children: [
                            totals.sharesSold.toLocaleString('en-US'),
                            " sh sold",
                            totals.grossCents != null && ` \xb7 gross ${cents(totals.grossCents)}`,
                            totals.netCents != null && ` \xb7 net ${cents(totals.netCents)}${totals.netUnknownCount > 0 ? ` (excl. ${totals.netUnknownCount} unknown)` : ''}`,
                            totals.undocumentedCount > 0 && ` \xb7 ${totals.undocumentedCount} undocumented excluded`,
                            totals.excludedCurrencyCount > 0 && ` \xb7 ${totals.excludedCurrencyCount} other-currency excluded`,
                            issuer.events.length > events.length && ` \xb7 ${issuer.events.length - events.length} future-dated not shown`
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col gap-2",
                children: events.map((event)=>{
                    const price = event.price != null ? (0, $7c753920dce0820f$export$2e2bcd8739ae039).parse(event.price, event.currency) : null;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border-border rounded-md border p-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-baseline gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-foreground font-medium",
                                                children: event.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-muted-foreground text-xs",
                                                children: $bde7ba4c26b4bf8e$var$dateLabel(event.date)
                                            }),
                                            event.estimated && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "border-border text-muted-foreground rounded-full border px-1.5 py-0.5 text-[10px] font-medium",
                                                children: "estimated"
                                            }),
                                            event.missingTransactionLinks > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "border-destructive/40 text-destructive rounded-full border px-1.5 py-0.5 text-[10px] font-medium",
                                                children: [
                                                    event.missingTransactionLinks,
                                                    " broken link",
                                                    event.missingTransactionLinks === 1 ? '' : 's'
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-muted-foreground text-sm tabular-nums",
                                        children: [
                                            event.sharesSold.toLocaleString('en-US'),
                                            " sh",
                                            price ? ` @ ${price.format()}` : '',
                                            event.grossCents != null ? ` \u{2192} ${cents(event.grossCents)} gross` : ''
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bde7ba4c26b4bf8e$var$Waterfall, {
                                    event: event,
                                    currency: currency
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-muted-foreground mt-1.5 flex flex-wrap gap-x-4 gap-y-0.5 text-xs",
                                children: [
                                    event.netCents != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Net",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-foreground font-medium tabular-nums",
                                                children: cents(event.netCents)
                                            })
                                        ]
                                    }),
                                    event.realizedGainCents != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Realized gain",
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-foreground font-medium tabular-nums",
                                                children: cents(event.realizedGainCents)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "Drawn from ",
                                            event.draws.length,
                                            " lot",
                                            event.draws.length === 1 ? '' : 's'
                                        ]
                                    }),
                                    event.note && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: event.note
                                    })
                                ]
                            })
                        ]
                    }, event._id);
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");


const $081f8192448e7394$var$shares = (value)=>value.toLocaleString('en-US');
const $081f8192448e7394$var$dateLabel = (seconds)=>(0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(seconds).toLocaleString({
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
const $081f8192448e7394$var$SOURCE_LABELS = {
    rsu_release: 'RSU release',
    exercise: 'Exercise',
    purchase: 'Purchase',
    other: 'Other'
};
const $081f8192448e7394$export$bd8fec9412fa85ba = ({ issuer: issuer, todaySeconds: todaySeconds })=>{
    const [showSoldOut, setShowSoldOut] = $acw62.useState(false);
    const currency = (0, $4b9cbf18d627f8e6$export$bde32c9ec0a9e0bd)(issuer);
    const cents = (value)=>(0, $4b9cbf18d627f8e6$export$4ead0eaee86eb5fb)(value, currency);
    const allRows = $acw62.useMemo(()=>(0, $4b9cbf18d627f8e6$export$1c54eef6c6212d26)(issuer, todaySeconds), [
        issuer,
        todaySeconds
    ]);
    const heldRows = allRows.filter((row)=>row.sharesRemaining > 0);
    const rows = showSoldOut ? allRows : heldRows;
    const soldOutCount = allRows.length - heldRows.length;
    const totals = heldRows.reduce((sum, row)=>({
            remaining: sum.remaining + row.sharesRemaining,
            basisCents: sum.basisCents + row.basisCents,
            valueCents: row.valueCents == null || sum.valueCents == null ? null : sum.valueCents + row.valueCents,
            unrealizedCents: row.unrealizedCents == null || sum.unrealizedCents == null ? null : sum.unrealizedCents + row.unrealizedCents
        }), {
        remaining: 0,
        basisCents: 0,
        valueCents: 0,
        unrealizedCents: 0
    });
    // buildLotRows omits future-dated lots; those are persisted records, so
    // say so rather than letting them look missing (same rule as events).
    const futureCount = issuer.lots.length - allRows.length;
    if (allRows.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground py-6 text-center text-sm",
        children: futureCount > 0 ? `No lots yet \u{2014} ${futureCount} future-dated lot${futureCount === 1 ? '' : 's'} not shown.` : 'No lots recorded yet.'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-1 flex flex-wrap items-baseline justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-foreground text-base font-semibold",
                        children: "Lots"
                    }),
                    futureCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground text-xs",
                        children: [
                            futureCount,
                            " future-dated not shown"
                        ]
                    }),
                    soldOutCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setShowSoldOut((value)=>!value),
                        className: "text-muted-foreground hover:text-foreground text-xs underline-offset-2 hover:underline",
                        children: showSoldOut ? 'Hide fully sold lots' : `Show ${soldOutCount} fully sold lot${soldOutCount === 1 ? '' : 's'}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: "w-full text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                className: "text-muted-foreground text-left text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1 pr-2 font-normal",
                                        children: "Acquired"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1 pr-2 font-normal",
                                        children: "Source"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1 pr-2 text-right font-normal",
                                        children: "Acquired sh"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1 pr-2 text-right font-normal",
                                        children: "Held sh"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1 pr-2 text-right font-normal",
                                        children: "Basis /sh"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1 pr-2 text-right font-normal",
                                        children: "Basis"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1 pr-2 text-right font-normal",
                                        children: "Value"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1 pr-2 text-right font-normal",
                                        children: "Unrealized"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                        className: "py-1 font-normal",
                                        children: "Term"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: rows.map((row)=>{
                                const soldOut = row.sharesRemaining === 0;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('border-border border-t', soldOut && 'text-muted-foreground'),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 pr-2 whitespace-nowrap",
                                            children: $081f8192448e7394$var$dateLabel(row.lot.acquiredDate)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "text-muted-foreground py-1.5 pr-2 whitespace-nowrap",
                                            children: $081f8192448e7394$var$SOURCE_LABELS[row.lot.source] ?? row.lot.source
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 pr-2 text-right tabular-nums",
                                            children: $081f8192448e7394$var$shares(row.lot.sharesAcquired)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 pr-2 text-right font-medium tabular-nums",
                                            children: $081f8192448e7394$var$shares(row.sharesRemaining)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 pr-2 text-right tabular-nums",
                                            children: row.basis.format()
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 pr-2 text-right tabular-nums",
                                            children: soldOut ? "\u2014" : cents(row.basisCents)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5 pr-2 text-right tabular-nums",
                                            children: soldOut || row.valueCents == null ? "\u2014" : cents(row.valueCents)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('py-1.5 pr-2 text-right tabular-nums', !soldOut && row.unrealizedCents != null && (row.unrealizedCents >= 0 ? 'text-positive' : 'text-destructive')),
                                            children: soldOut || row.unrealizedCents == null ? "\u2014" : cents(row.unrealizedCents)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            className: "py-1.5",
                                            children: soldOut ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-muted-foreground text-xs",
                                                children: "sold"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('rounded-full border px-1.5 py-0.5 text-[10px] font-medium', row.longTerm ? 'border-border text-muted-foreground' : 'border-destructive/40 text-destructive'),
                                                children: row.longTerm ? 'LT' : 'ST'
                                            })
                                        })
                                    ]
                                }, row.lot._id);
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tfoot", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                className: "border-border border-t-2 font-medium",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "py-1.5 pr-2",
                                        colSpan: 3,
                                        children: "Held total"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "py-1.5 pr-2 text-right tabular-nums",
                                        children: $081f8192448e7394$var$shares(totals.remaining)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "py-1.5 pr-2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "py-1.5 pr-2 text-right tabular-nums",
                                        children: cents(totals.basisCents)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "py-1.5 pr-2 text-right tabular-nums",
                                        children: totals.valueCents == null ? "\u2014" : cents(totals.valueCents)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "py-1.5 pr-2 text-right tabular-nums",
                                        children: totals.unrealizedCents == null ? "\u2014" : cents(totals.unrealizedCents)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "py-1.5"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};



const $ccb0657f9d138f61$var$StatTile = ({ label: label, value: value, detail: detail })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border rounded-md border p-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground text-xs",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-foreground text-lg font-semibold tabular-nums",
                children: value
            }),
            detail && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground text-xs",
                children: detail
            })
        ]
    });
const $ccb0657f9d138f61$export$df981316e86d14be = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Equity',
        reset: true
    });
    const { data: data, loading: loading, error: error } = (0, $ce9d9e524be20f53$export$3d4eca0a186358cf)({
        fetchPolicy: 'cache-and-network'
    });
    const issuers = $acw62.useMemo(()=>data?.equityIssuers ?? [], [
        data
    ]);
    const [selectedId, setSelectedId] = $acw62.useState(null);
    const issuer = issuers.find((candidate)=>candidate._id === selectedId) ?? issuers[0] ?? null;
    const todaySeconds = $acw62.useMemo(()=>(0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().toSeconds(), []);
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-destructive p-8 text-center text-sm",
        children: [
            "Couldn't load equity: ",
            error.message
        ]
    });
    if (loading && data == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground p-8 text-center text-sm",
        children: "Loading\u2026"
    });
    if (issuer == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-muted-foreground p-12 text-center text-sm",
        children: [
            "No equity recorded yet. Run",
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                className: "bg-muted rounded px-1 py-0.5",
                children: "yarn workspace server import:equity <manifest.json> --user <id>"
            }),
            ' ',
            "to load an issuer's marks, lots, and events."
        ]
    });
    const totals = (0, $4b9cbf18d627f8e6$export$bc7c0aa27a56e81b)(issuer, todaySeconds);
    const sales = (0, $4b9cbf18d627f8e6$export$fb1ebb8f1ab536ac)(issuer, todaySeconds);
    const latest = (0, $4b9cbf18d627f8e6$export$96e21e8d02caa689)(issuer, todaySeconds);
    // A fully sold issuer's held value is a known zero even with no marks;
    // and the server's valueCents follows the LATEST mark's currency, so a
    // sum with the sale cents is only meaningful when the currencies agree.
    const heldCents = totals.valueCents ?? (totals.sharesHeld === 0 ? 0 : null);
    const heldCurrencyOk = totals.sharesHeld === 0 || latest == null || latest.price.currency === (0, $4b9cbf18d627f8e6$export$bde32c9ec0a9e0bd)(issuer);
    const cents = (value)=>(0, $4b9cbf18d627f8e6$export$4ead0eaee86eb5fb)(value, (0, $4b9cbf18d627f8e6$export$bde32c9ec0a9e0bd)(issuer));
    // Recorded per-share endpoints keep SharePrice's six decimals; the
    // blended average is a derived figure and rounds to cents.
    const perShare = (value, maxDigits = 2)=>value.toLocaleString('en-US', {
            style: 'currency',
            currency: (0, $4b9cbf18d627f8e6$export$bde32c9ec0a9e0bd)(issuer),
            maximumFractionDigits: maxDigits
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex-1 overflow-y-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "mx-auto flex max-w-5xl flex-col gap-4 p-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-center justify-between gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                    className: "text-foreground text-xl font-semibold",
                                    children: [
                                        issuer.name,
                                        " equity"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-muted-foreground text-sm",
                                    children: "Share history, price marks, and liquidity events."
                                })
                            ]
                        }),
                        issuers.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-wrap gap-1.5",
                            children: issuers.map((candidate)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setSelectedId(candidate._id),
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('rounded-full border px-3 py-1 text-xs font-medium transition-colors', candidate._id === issuer._id ? 'border-primary bg-primary text-primary-foreground' : 'border-border text-muted-foreground hover:text-foreground'),
                                    children: candidate.name
                                }, candidate._id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-2 md:grid-cols-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ccb0657f9d138f61$var$StatTile, {
                            label: "Cashed out (gross)",
                            value: sales.eventCount === 0 ? cents(0) : sales.grossCents != null ? cents(sales.grossCents) : "\u2014",
                            detail: `pre-tax \xb7 ${sales.sharesSold.toLocaleString('en-US')} sh sold${sales.avgPriceDollars != null ? ` \xb7 avg ${perShare(sales.avgPriceDollars)}/sh${sales.documentedSharesSold !== sales.sharesSold ? ` (over ${sales.documentedSharesSold.toLocaleString('en-US')} documented sh)` : ''}` : ''}${sales.undocumentedCount > 0 ? ` \xb7 excl. ${sales.undocumentedCount} undocumented` : ''}${sales.excludedCurrencyCount > 0 ? ` \xb7 excl. ${sales.excludedCurrencyCount} other-currency` : ''}${sales.estimatedCount > 0 ? ` \xb7 ${sales.estimatedCount} estimated` : ''}`
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ccb0657f9d138f61$var$StatTile, {
                            label: "Still held",
                            value: heldCents != null && heldCurrencyOk ? cents(heldCents) : "\u2014",
                            detail: `${totals.sharesHeld.toLocaleString('en-US')} sh${latest ? ` \xb7 at the ${latest.price.format()} mark \xb7 ${(0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(latest.date).toLocaleString({
                                month: 'short',
                                year: 'numeric'
                            })}` : ''}`
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ccb0657f9d138f61$var$StatTile, {
                            label: "Total value",
                            value: heldCents != null && heldCurrencyOk ? sales.grossCents != null ? cents(sales.grossCents + heldCents) : sales.eventCount === 0 ? cents(heldCents) : "\u2014" : "\u2014",
                            detail: "cashed out + still held \xb7 pre-tax"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec2d1793cd89e9cd$export$a5e5e2eac8df34e4), {
                    issuer: issuer
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $081f8192448e7394$export$bd8fec9412fa85ba), {
                    issuer: issuer,
                    todaySeconds: todaySeconds
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bde7ba4c26b4bf8e$export$d9b6df68b7fd1d03), {
                    issuer: issuer,
                    todaySeconds: todaySeconds
                })
            ]
        })
    });
};











var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");


parcelRequire("acw62");

const $32895c25060bdb77$export$1eb62072ee845573 = 'bg-card border-border rounded-xl border';
const $32895c25060bdb77$export$b2a61672b90733e6 = ({ title: title, meta: meta, children: children, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($32895c25060bdb77$export$1eb62072ee845573, 'px-4 py-1', className),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-baseline justify-between gap-2 py-2.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground text-sm font-semibold",
                        children: title
                    }),
                    meta !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-xs",
                        children: meta
                    })
                ]
            }),
            children
        ]
    });



const $676fdaf4f964f427$var$compactCount = (n)=>n >= 1000 ? `${(n / 1000).toFixed(1).replace(/\.0$/, '')}k` : String(n);
const $676fdaf4f964f427$var$formatYearRange = (summary)=>{
    const oldest = summary.backlogOldestDate?.slice(0, 4);
    const newest = summary.backlogNewestDate?.slice(0, 4);
    if (!oldest || !newest) return '';
    return oldest === newest ? oldest : `${oldest}\u{2013}${newest}`;
};
const $676fdaf4f964f427$export$25a560a772e56498 = ({ summary: summary })=>{
    if (summary.backlogCount === 0) return null;
    // Each backlog year gets a labeled bar (mobile-friendly — no tooltips):
    // the faint track is that year's total raw transactions, the solid overlay
    // is what is still unreviewed, with the remaining count and year below.
    const maxYearTotal = Math.max(...summary.years.map((y)=>y.total));
    const processedPercent = summary.totalCount > 0 ? Math.round(summary.processedCount / summary.totalCount * 100) : 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)((0, $32895c25060bdb77$export$1eb62072ee845573), 'p-4'),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-baseline justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground text-sm font-semibold",
                        children: "Backlog"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground text-xs",
                        children: [
                            summary.backlogCount.toLocaleString('en-US'),
                            " items \xb7",
                            ' ',
                            $676fdaf4f964f427$var$formatYearRange(summary)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-3 flex items-end gap-[3px]",
                children: summary.years.map((bucket)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-w-0 flex-1 flex-col items-center gap-0.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative flex h-16 w-full items-end",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-muted-foreground/25 min-h-[3px] w-full rounded-t-sm",
                                        style: {
                                            height: `${bucket.total / maxYearTotal * 100}%`
                                        }
                                    }),
                                    bucket.unallocated > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "bg-muted-foreground/80 absolute bottom-0 min-h-[3px] w-full rounded-t-sm",
                                        style: {
                                            height: `${bucket.unallocated / maxYearTotal * 100}%`
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `text-[9px] leading-tight tabular-nums ${bucket.unallocated > 0 ? 'text-foreground' : 'text-muted-foreground/40'}`,
                                children: $676fdaf4f964f427$var$compactCount(bucket.unallocated)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-muted-foreground text-[9px] leading-tight",
                                children: [
                                    "\u2019",
                                    String(bucket.year).slice(2)
                                ]
                            })
                        ]
                    }, bucket.year))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground mt-2 flex items-center gap-3 text-[10px]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "bg-muted-foreground/80 inline-block size-2 rounded-[2px]"
                            }),
                            "unreviewed"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "bg-muted-foreground/25 inline-block size-2 rounded-[2px]"
                            }),
                            "total that year"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 flex items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground text-xs",
                        children: [
                            processedPercent,
                            "% of all history processed"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                        to: "/backlog",
                        className: "border-input text-foreground hover:bg-accent/30 rounded-md border px-3 py-1.5 text-xs font-medium whitespace-nowrap shadow-xs transition",
                        children: "Browse backlog"
                    })
                ]
            })
        ]
    });
};







var $acw62 = parcelRequire("acw62");





// Enough rows to see the shape of the problem without taking over the inbox.
const $67d754936473e916$var$VISIBLE_ROWS = 4;
const $67d754936473e916$var$Row = ({ transaction: transaction, onAssign: onAssign, assigning: assigning })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border -mx-4 grid grid-cols-[1fr_auto] items-center gap-x-3 border-t px-4 py-2.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                to: `/transactions/${transaction._id}`,
                className: "min-w-0 hover:underline",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "block truncate text-sm font-medium",
                        children: transaction.payee ?? transaction.description
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-xs",
                        children: (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(transaction.date)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-sm tabular-nums",
                        children: transaction.netAmount !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                            variant: "plain",
                            amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(transaction.netAmount, transaction.currency)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        onClick: onAssign,
                        disabled: assigning,
                        children: "Assign"
                    })
                ]
            })
        ]
    });
const $67d754936473e916$export$db1b7d5249eea904 = ({ rows: rows, hasMore: hasMore, onShowMore: onShowMore, onChanged: onChanged })=>{
    const [assignBasis] = (0, $ce9d9e524be20f53$export$a0fb838635ed18f0)();
    const [expanded, setExpanded] = $acw62.useState(false);
    const [assigningId, setAssigningId] = $acw62.useState(null);
    // Set when an assignment leaves the transaction unvalued: there was no
    // conversion to draw from, so the fix is recording one, not retrying.
    const [noBasisAvailable, setNoBasisAvailable] = $acw62.useState(false);
    // The server refuses to re-pick a transfer's draws once its destination lot
    // has funded something. Without showing this the button just resets and the
    // row sits there, which reads as the app ignoring the click.
    const [assignError, setAssignError] = $acw62.useState(null);
    if (rows.length === 0) return null;
    const visible = expanded ? rows : rows.slice(0, $67d754936473e916$var$VISIBLE_ROWS);
    const hiddenCount = rows.length - visible.length;
    const handleAssign = async (transactionId)=>{
        setAssigningId(transactionId);
        setAssignError(null);
        try {
            const result = await assignBasis({
                variables: {
                    transactionId: transactionId
                }
            });
            setNoBasisAvailable(result.data?.assignBasis.needsBasis === true);
            onChanged();
        } catch (error) {
            setAssignError(error instanceof Error ? error.message : 'Could not assign basis.');
        } finally{
            setAssigningId(null);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $32895c25060bdb77$export$b2a61672b90733e6), {
        title: "Transactions needing a US dollar value",
        meta: `${rows.length}${hasMore ? '+' : ''}`,
        children: [
            visible.map((transaction)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($67d754936473e916$var$Row, {
                    transaction: transaction,
                    assigning: assigningId === transaction._id,
                    onAssign: ()=>void handleAssign(transaction._id)
                }, transaction._id)),
            (hiddenCount > 0 || hasMore) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "text-muted-foreground border-border -mx-4 w-[calc(100%+2rem)] cursor-pointer border-t py-2.5 text-xs hover:underline",
                onClick: ()=>{
                    setExpanded(true);
                    if (hasMore) onShowMore();
                },
                children: hiddenCount > 0 ? `Show ${hiddenCount} more` : 'Show more'
            }),
            assignError !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-destructive border-border -mx-4 border-t px-4 py-2.5 text-xs",
                children: assignError
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground border-border -mx-4 border-t px-4 py-2.5 text-xs",
                children: noBasisAvailable ? 'No conversion has any value left to draw from. Record the withdrawal or purchase that funded this currency, then assign again.' : "Moved in a currency the app has no cost for yet. Record the conversion that funded it, then assign \u2014 a transfer listed here has to be assigned before anything spent at its destination can be."
            })
        ]
    });
};








var $acw62 = parcelRequire("acw62");








// The inbox stays scannable no matter how many credits accumulate: the card
// shows the largest few and the rest sit behind an inline expander.
const $83672a6e41d87bc3$var$VISIBLE_ROWS = 4;
// Credits are stored value (wallet); anything else tracked is a loan
const $83672a6e41d87bc3$var$isCredit = (row)=>row.account.depositoryType === (0, $ce9d9e524be20f53$export$1ae0be870e8f30b1).Wallet;
const $83672a6e41d87bc3$var$ageLabel = (row)=>{
    if (row.lastActivityDate == null) return null;
    const days = Math.max(0, Math.round((0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().diff((0, $0c0f91b069db95d9$export$6b862160d295c8e)(row.lastActivityDate), 'days').days));
    const verb = $83672a6e41d87bc3$var$isCredit(row) ? 'banked' : row.balance >= 0 ? 'lent' : 'borrowed';
    if (days < 1) return `${verb} today`;
    if (days < 60) return `${verb} ${days} day${days === 1 ? '' : 's'} ago`;
    const months = Math.round(days / 30);
    if (months < 24) return `${verb} ${months} months ago`;
    return `${verb} ${Math.round(months / 12)} years ago`;
};
/**
 * Whole-unit total in an account's currency. Custom units render through
 * their Unit metadata; Intl's currency style throws a RangeError on the
 * non-ISO codes the create-account modal advertises (TENNIS_CLASS), so this
 * falls back the same way Money.toDecimalString does: a bare number with the
 * code appended.
 */ const $83672a6e41d87bc3$var$wholeUnitTotal = (hundredths, currency, unitsById)=>{
    if (unitsById.has(currency)) return (0, $9ac5aec7425fcb2d$export$ba37dda4e3a0b386)((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(hundredths, currency), unitsById);
    const units = hundredths / 100;
    try {
        return units.toLocaleString('en-US', {
            style: 'currency',
            currency: currency,
            maximumFractionDigits: 0
        });
    } catch  {
        return `${units.toLocaleString('en-US', {
            maximumFractionDigits: 0
        })} ${currency}`;
    }
};
const $83672a6e41d87bc3$var$summaryLine = (rows, unitsById)=>{
    const credits = rows.filter($83672a6e41d87bc3$var$isCredit);
    const loans = rows.filter((row)=>!$83672a6e41d87bc3$var$isCredit(row));
    // Summed dollar totals only make sense in a single currency; with mixed
    // currencies fall back to counts (per-row amounts stay fully labeled)
    const mixed = new Set(rows.map((row)=>row.account.currency)).size > 1;
    const listCurrency = rows[0]?.account.currency ?? 'USD';
    const total = (list)=>mixed ? '' : ` \xb7 ${$83672a6e41d87bc3$var$wholeUnitTotal(list.reduce((sum, row)=>sum + Math.abs(row.balance), 0), listCurrency, unitsById)}`;
    return [
        credits.length > 0 && `${credits.length} credit${credits.length === 1 ? '' : 's'}${total(credits)}`,
        loans.length > 0 && `${loans.length} loan${loans.length === 1 ? '' : 's'}${total(loans)}`
    ].filter(Boolean).join("  \xb7  ");
};
const $83672a6e41d87bc3$export$a7d5a7b87448faa1 = ()=>{
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const unitsById = (0, $9b33a37eb331091e$export$17987e0a14ce8a32)();
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const [expanded, setExpanded] = $acw62.useState(false);
    const { data: data, error: error, refetch: refetch } = (0, $ce9d9e524be20f53$export$90b1a46cc327be66)({
        fetchPolicy: 'cache-and-network'
    });
    const rows = data?.trackedBalances ?? [];
    // A failed query must not silently hide open credits/loans
    if (data === undefined && error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)((0, $32895c25060bdb77$export$1eb62072ee845573), 'px-4 py-3'),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "text-muted-foreground text-xs",
                children: [
                    "Couldn't load outstanding balances.",
                    ' '
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "text-foreground cursor-pointer text-xs underline",
                onClick: ()=>void refetch(),
                children: "Retry"
            })
        ]
    });
    if (rows.length === 0) return null;
    const visible = expanded ? rows : rows.slice(0, $83672a6e41d87bc3$var$VISIBLE_ROWS);
    const hiddenCount = rows.length - visible.length;
    const totalOutstanding = rows.reduce((sum, row)=>sum + Math.abs(row.balance), 0);
    const handleDone = ()=>{
        refetch();
        // AllAccounts caches the derived balance field; keep it in sync
        client.refetchQueries({
            include: [
                'AllAccounts'
            ]
        });
    };
    const openResolution = (row)=>{
        if ($83672a6e41d87bc3$var$isCredit(row)) modals.recordUseModal.openModal({
            accountId: row.account._id,
            accountName: row.account.name,
            currency: row.account.currency,
            balance: row.balance,
            latestAnchorDate: row.latestAnchorDate ?? null,
            onDone: handleDone
        });
        else modals.recordLoanRepaymentModal.openModal({
            accountId: row.account._id,
            accountName: row.account.name,
            currency: row.account.currency,
            balance: row.balance,
            latestAnchorDate: row.latestAnchorDate ?? null,
            onDone: handleDone
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)((0, $32895c25060bdb77$export$1eb62072ee845573), 'px-4 py-1'),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-baseline justify-between gap-2 py-2.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground text-sm font-semibold",
                        children: "Outstanding"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-xs",
                        children: $83672a6e41d87bc3$var$summaryLine(rows, unitsById)
                    })
                ]
            }),
            visible.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                    to: `/accounts/${row.account._id}`,
                    className: "border-border hover:bg-muted-foreground/10 -mx-4 grid grid-cols-[auto_1fr_auto] items-center gap-x-3 gap-y-0.5 border-t px-4 py-2.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd8122ba7d7dc8$export$a519fd59e714bf50), {
                            account: row.account,
                            className: "row-span-2 size-5"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex min-w-0 items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-foreground truncate text-sm font-medium",
                                    children: row.account.name
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "border-border text-muted-foreground rounded-full border px-2 py-0.5 text-[0.7rem]",
                                    children: $83672a6e41d87bc3$var$isCredit(row) ? 'credit' : 'loan'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-right text-sm font-semibold tabular-nums",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                variant: "plain",
                                amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(row.balance), row.account.currency)
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-muted-foreground text-xs",
                            children: $83672a6e41d87bc3$var$ageLabel(row)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex justify-end text-xs",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "text-muted-foreground hover:text-foreground cursor-pointer",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openResolution(row);
                                },
                                children: $83672a6e41d87bc3$var$isCredit(row) ? "Record use \u203A" : "Record repayment \u203A"
                            })
                        })
                    ]
                }, row.account._id)),
            (hiddenCount > 0 || expanded) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "border-border text-muted-foreground hover:text-foreground w-full cursor-pointer border-t py-2.5 text-center text-xs",
                onClick: ()=>setExpanded(!expanded),
                children: expanded ? 'Show fewer' : new Set(rows.map((row)=>row.account.currency)).size > 1 ? `Show all ${rows.length}` : `Show all ${rows.length} \xb7 ${$83672a6e41d87bc3$var$wholeUnitTotal(totalOutstanding, rows[0]?.account.currency ?? 'USD', unitsById)} outstanding`
            })
        ]
    });
};













// The recent "to review" era starts this many days before Jan 1 of the
// current year; everything older is backlog. A fixed calendar cutoff keeps
// the split predictable — gaps between unallocated items don't move it.
const $e5a5329773e68f54$var$CUTOFF_LEAD_DAYS = 90;
const $e5a5329773e68f54$export$3d3b2142d981b7e6 = ()=>(0, $0c0f91b069db95d9$export$9144c32b59cbaec4)({
        year: (0, $63618293c58b5f80$exports.DateTime).utc().year,
        month: 1,
        day: 1
    }).minus({
        days: $e5a5329773e68f54$var$CUTOFF_LEAD_DAYS
    });



var $acw62 = parcelRequire("acw62");





const $fd54cadefa06c3a3$export$4acbb2ebc34e06c0 = (rows)=>{
    const ids = rows.map((row)=>row._id);
    (0, $ce9d9e524be20f53$export$5e3cc446f2bf8ebc)({
        variables: {
            rawTransactionIds: ids
        },
        skip: ids.length === 0,
        // History moves as rows are categorized anywhere in the app, so each
        // visit asks again rather than trusting what an earlier one cached.
        fetchPolicy: 'cache-and-network'
    });
};














/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3c0fdd0f1c350b23$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M17 7 7 17",
            key: "15tmo1"
        }
    ],
    [
        "path",
        {
            d: "M17 17H7V7",
            key: "1org7z"
        }
    ]
];
const $3c0fdd0f1c350b23$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-down-left", $3c0fdd0f1c350b23$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8e0fafd8685c1845$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13 16H8",
            key: "wsln4y"
        }
    ],
    [
        "path",
        {
            d: "M14 8H8",
            key: "1l3xfs"
        }
    ],
    [
        "path",
        {
            d: "M16 12H8",
            key: "1fr5h0"
        }
    ],
    [
        "path",
        {
            d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
            key: "ycz6yz"
        }
    ]
];
const $8e0fafd8685c1845$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("receipt-text", $8e0fafd8685c1845$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");







parcelRequire("acw62");

const $0a7baecaae56a667$export$1f1530db9dfbc9da = ({ category: category })=>{
    const Icon = category.icon != null && (0, $b6ddd498a221dbc5$export$aec4ec8c571a0835)(category.icon) ? (0, $3076b7ee20dc9ec8$export$b0372430f00fdb14)[category.icon] : null;
    const color = category.color != null && (0, $b6ddd498a221dbc5$export$e2e3e5e46b905df3)(category.color) ? category.color : (0, $3076b7ee20dc9ec8$export$1185a41b8d33b6b8)(category.name);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "flex shrink-0 items-center gap-1",
        children: [
            Icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                className: `size-3.5 shrink-0 ${(0, $3076b7ee20dc9ec8$export$82a131a635ff0632)[color]}`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: category.name
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");
const $0c13e6203680a429$export$f89288ccc27ab607 = ()=>{
    const { data: data } = (0, $ce9d9e524be20f53$export$cb6e321bdf608ddb)();
    return $acw62.useMemo(()=>{
        const map = new Map();
        for (const account of data?.allAccounts ?? [])map.set(account._id, account);
        return map;
    }, [
        data
    ]);
};




parcelRequire("acw62");
const $fefa95d9ac82ab87$export$f18c54b9630be5a3 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "bg-primary/10 text-primary flex h-5 shrink-0 items-center overflow-hidden rounded-md px-2 text-xs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "font-medium",
                children: [
                    props.fieldName,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "ml-1",
                children: props.value
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");





const $0dea4783a1231038$export$e47947e41f368277 = (props)=>{
    const { fieldValues: fieldValues, onChange: onChange, focusControlsRef: focusControlsRef } = props;
    const { data: data } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)();
    const [query, setQuery] = $acw62.useState('');
    const [isOpen, setIsOpen] = $acw62.useState(false);
    const [selectedIndex, setSelectedIndex] = $acw62.useState(null);
    const inputRef = $acw62.useRef(null);
    const popoverRef = $acw62.useRef(null);
    const activeItemRef = $acw62.useRef(null);
    const fields = data?.allFields || [];
    // Create Fuse instance for searching field names
    const fieldFuse = $acw62.useMemo(()=>new (0, $33893b708b33402d$export$2e2bcd8739ae039)(fields, {
            keys: [
                'name'
            ],
            threshold: 0.4
        }), [
        fields
    ]);
    // Separate enum and text fields
    const enumFields = $acw62.useMemo(()=>fields.filter((f)=>f.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum), [
        fields
    ]);
    const textFields = $acw62.useMemo(()=>fields.filter((f)=>f.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text), [
        fields
    ]);
    // Fuse instance for text field name searching
    const textFieldFuse = $acw62.useMemo(()=>new (0, $33893b708b33402d$export$2e2bcd8739ae039)(textFields, {
            keys: [
                'name'
            ],
            threshold: 0.4
        }), [
        textFields
    ]);
    // Flat list of all field:value pairs for value searching (enum fields only)
    const allValueItems = $acw62.useMemo(()=>enumFields.flatMap((dim)=>dim.values.map((val)=>({
                    fieldId: dim._id,
                    fieldName: dim.name,
                    value: val.value,
                    fieldType: (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum
                }))), [
        enumFields
    ]);
    // Single Fuse instance for searching across all values (no-colon path)
    const valueFuse = $acw62.useMemo(()=>new (0, $33893b708b33402d$export$2e2bcd8739ae039)(allValueItems, {
            keys: [
                'value'
            ],
            threshold: 0.4
        }), [
        allValueItems
    ]);
    // Per-field Fuse instances for value searching (colon path)
    const perFieldValueFuse = $acw62.useMemo(()=>Object.fromEntries(fields.map((dim)=>[
                dim._id,
                new (0, $33893b708b33402d$export$2e2bcd8739ae039)(dim.values, {
                    keys: [
                        'value'
                    ],
                    threshold: 0.4
                })
            ])), [
        fields
    ]);
    const searchResults = $acw62.useMemo(()=>{
        if (!query.trim()) return [];
        const colonIndex = query.indexOf(':');
        if (colonIndex === -1) {
            // No colon - search field names AND values
            const keyQuery = query.trim();
            const seen = new Set();
            const results = [];
            const addResult = (result)=>{
                const key = `${result.fieldId}:${result.value}`;
                if (seen.has(key)) return;
                seen.add(key);
                results.push(result);
            };
            // Match by enum field name - show all values from matching fields
            const nameMatches = keyQuery ? fieldFuse.search(keyQuery).map((r)=>r.item) : fields;
            for (const dim of nameMatches){
                if (dim._id in fieldValues) continue;
                if (dim.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text) continue; // Text fields handled separately
                for (const val of dim.values)addResult({
                    fieldId: dim._id,
                    fieldName: dim.name,
                    value: val.value,
                    fieldType: (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum
                });
            }
            // Match by field value - search values across all enum fields
            if (keyQuery) for (const match of valueFuse.search(keyQuery)){
                if (match.item.fieldId in fieldValues) continue;
                addResult(match.item);
            }
            // Match text fields by name
            const textMatches = keyQuery ? textFieldFuse.search(keyQuery).map((r)=>r.item) : textFields;
            for (const tf of textMatches){
                if (tf._id in fieldValues) continue;
                addResult({
                    fieldId: tf._id,
                    fieldName: tf.name,
                    value: '',
                    fieldType: (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text
                });
            }
            return results.slice(0, 15);
        } else {
            // Has colon - search both parts
            const keyQuery = query.slice(0, colonIndex).trim();
            const valueQuery = query.slice(colonIndex + 1).trim();
            // First filter by field name (enum fields only for colon search)
            const matchedFields = keyQuery ? fieldFuse.search(keyQuery).map((r)=>r.item).filter((f)=>f.type === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum) : enumFields;
            const results = [];
            for (const dim of matchedFields){
                if (dim._id in fieldValues) continue;
                // Then filter values if valueQuery exists
                let matchedValues = dim.values;
                if (valueQuery) {
                    const fuse = perFieldValueFuse[dim._id];
                    matchedValues = fuse ? fuse.search(valueQuery).map((r)=>r.item) : [];
                }
                for (const val of matchedValues)results.push({
                    fieldId: dim._id,
                    fieldName: dim.name,
                    value: val.value,
                    fieldType: (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum
                });
            }
            return results.slice(0, 15);
        }
    }, [
        query,
        fields,
        enumFields,
        textFields,
        fieldFuse,
        textFieldFuse,
        valueFuse,
        perFieldValueFuse,
        fieldValues
    ]);
    // Reset selection when results change
    $acw62.useEffect(()=>{
        setSelectedIndex(null);
    }, [
        searchResults.length
    ]);
    // Scroll active item into view
    $acw62.useLayoutEffect(()=>{
        activeItemRef.current?.scrollIntoView({
            block: 'nearest'
        });
    }, [
        selectedIndex
    ]);
    // Set popover width
    $acw62.useLayoutEffect(()=>{
        if (isOpen && inputRef.current && popoverRef.current) popoverRef.current.style.width = `${Math.max(inputRef.current.offsetWidth, 250)}px`;
    }, [
        isOpen
    ]);
    // Track which text field is currently being edited inline
    const [editingTextFieldId, setEditingTextFieldId] = $acw62.useState(null);
    const totalSelectableItems = searchResults.length;
    const handleRemove = (fieldId)=>{
        const newValues = {
            ...fieldValues
        };
        delete newValues[fieldId];
        onChange(newValues);
        if (editingTextFieldId === fieldId) setEditingTextFieldId(null);
    };
    const handleSelect = (result)=>{
        if (result.fieldType === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text) {
            // For text fields, add with empty string and start editing
            onChange({
                ...fieldValues,
                [result.fieldId]: ''
            });
            setEditingTextFieldId(result.fieldId);
        } else onChange({
            ...fieldValues,
            [result.fieldId]: result.value
        });
        setQuery('');
        setIsOpen(false);
        setSelectedIndex(null);
        // Keep focus for adding more (for enum fields)
        if (result.fieldType !== (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text) inputRef.current?.focus();
    };
    const handleInputChange = (value)=>{
        setQuery(value);
        setIsOpen(true);
    };
    const handleInputFocus = ()=>{
        if (query) setIsOpen(true);
    };
    const handleSelectOrCreate = (index)=>{
        const resultIndex = index ?? 0;
        if (searchResults[resultIndex]) handleSelect(searchResults[resultIndex]);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (!isOpen && query) setIsOpen(true);
            else if (totalSelectableItems > 0) setSelectedIndex((prev)=>prev === null ? 0 : Math.min(prev + 1, totalSelectableItems - 1));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (totalSelectableItems > 0 && selectedIndex !== null) setSelectedIndex((prev)=>prev === 0 ? null : (prev ?? 0) - 1);
        } else if (e.key === 'Enter') {
            if (isOpen && totalSelectableItems > 0) {
                e.preventDefault();
                handleSelectOrCreate(selectedIndex);
            }
        } else if (e.key === 'Tab') {
            if (!query) {
                // Empty input - let Tab pass through
                setIsOpen(false);
                return;
            }
            // Has query - select and move on
            e.preventDefault();
            if (selectedIndex !== null) handleSelectOrCreate(selectedIndex);
            else if (searchResults.length > 0) handleSelect(searchResults[0]);
            if (e.shiftKey) focusControlsRef?.current?.focusBackward();
            else focusControlsRef?.current?.focusForward();
        } else if (e.key === 'Escape') {
            e.preventDefault();
            setQuery('');
            setIsOpen(false);
            setSelectedIndex(null);
        }
    };
    const closePopover = ()=>{
        setIsOpen(false);
    };
    // Get field entries for pills
    const fieldEntries = Object.entries(fieldValues).map(([fieldId, value])=>{
        const field = fields.find((d)=>d._id === fieldId);
        return {
            fieldId: fieldId,
            fieldName: field?.name || fieldId,
            fieldType: field?.type ?? (0, $ce9d9e524be20f53$export$ed12481c953b8653).Enum,
            value: value
        };
    });
    const handleTextFieldCommit = (fieldId, value)=>{
        if (value.trim()) onChange({
            ...fieldValues,
            [fieldId]: value.trim()
        });
        else {
            // Remove if empty
            const newValues = {
                ...fieldValues
            };
            delete newValues[fieldId];
            onChange(newValues);
        }
        setEditingTextFieldId(null);
        inputRef.current?.focus();
    };
    const showPopover = isOpen && searchResults.length > 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            fieldEntries.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-wrap gap-1",
                children: fieldEntries.map((entry)=>entry.fieldType === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9005c57a49b2e7a$export$e0dca75a1c99dcf9), {
                        fieldName: entry.fieldName,
                        value: entry.value,
                        isEditing: editingTextFieldId === entry.fieldId,
                        onCommit: (value)=>handleTextFieldCommit(entry.fieldId, value),
                        onStartEdit: ()=>setEditingTextFieldId(entry.fieldId),
                        onRemove: ()=>handleRemove(entry.fieldId)
                    }, entry.fieldId) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81dd68c8d37816fd$export$dda6331b81ebb6db), {
                        fieldName: entry.fieldName,
                        value: entry.value,
                        onRemove: ()=>handleRemove(entry.fieldId)
                    }, entry.fieldId))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                ref: inputRef,
                value: query,
                onChange: handleInputChange,
                onFocus: handleInputFocus,
                onKeyDown: handleKeyDown,
                placeholder: "Add field..."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fa899d90230d1ae$export$5b6b19405a83ff9d), {
                anchorRef: inputRef,
                anchor: "bottom-left",
                focusControlsRef: focusControlsRef,
                open: showPopover,
                onOutsideClick: closePopover,
                onOutsideFocus: closePopover,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$fda2cbba281a800a), {
                    ref: popoverRef,
                    children: searchResults.map((result, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03be77ecee525e88$export$ee388116d58b2caf), {
                            isSelected: selectedIndex === index,
                            ref: selectedIndex === index ? activeItemRef : null,
                            onClick: ()=>handleSelect(result),
                            className: "cursor-pointer text-sm",
                            children: result.fieldType === (0, $ce9d9e524be20f53$export$ed12481c953b8653).Text ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-medium",
                                        children: result.fieldName
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground ml-1.5 text-xs",
                                        children: "(text)"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-muted-foreground",
                                        children: [
                                            result.fieldName,
                                            ":"
                                        ]
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-medium",
                                        children: result.value
                                    })
                                ]
                            })
                        }, `${result.fieldId}:${result.value || '__text__'}`))
                })
            })
        ]
    });
};



parcelRequire("acw62");

const $131e63675abc2981$export$b9c3f7b4f6aa1316 = (props)=>{
    const { fields: fields, fieldValues: fieldValues } = props;
    const entries = Object.entries(fieldValues).filter(([_, value])=>value != null && value !== '');
    if (entries.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-row flex-wrap gap-1",
        children: entries.map(([fieldId, value])=>{
            const field = fields.find((d)=>d._id === fieldId);
            const name = field?.name || fieldId;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fefa95d9ac82ab87$export$f18c54b9630be5a3), {
                fieldName: name,
                value: value
            }, fieldId);
        })
    });
};










var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");







const $1000a58b5aa0fad5$var$getSource = (rt)=>{
    if (rt.plaidId || rt.plaidInvestmentTransactionId) return 'Plaid';
    if (rt.venmoId) return 'Venmo';
    return 'Manual';
};
const $1000a58b5aa0fad5$export$e0242e06075791dc = ({ consumptions: consumptions, currency: currency, showTotal: showTotal = true, highlightId: highlightId })=>{
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    if (consumptions.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "px-4 py-3 text-muted-foreground",
        children: "No lines"
    });
    // A conversion consumes raws in two currencies; totals must stay
    // per-currency (a single cross-currency sum would be meaningless).
    const netAmounts = (0, $eb9c0713007ac1dd$export$d51151e4f01b4b50)(consumptions.map((c)=>({
            amount: c.amount,
            currency: c.rawTransaction?.currency ?? currency
        })));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col",
        children: [
            consumptions.map((consumption, index)=>{
                const rt = consumption.rawTransaction;
                // Each consumed slice is denominated in its raw's own currency; the
                // parent transaction's currency is only a fallback when the raw is
                // absent from the cache.
                const consumptionAmount = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(consumption.amount, rt?.currency ?? currency);
                if (!rt) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                    to: `/raw-transactions/${consumption.rawTransactionId}`,
                    className: "flex cursor-pointer items-center justify-between gap-4 px-4 py-3 transition-colors not-last:border-b not-last:border-border hover:bg-muted/50",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "min-w-0 truncate font-mono text-xs text-muted-foreground",
                            children: consumption.rawTransactionId
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                            amount: consumptionAmount
                        })
                    ]
                }, `${consumption.rawTransactionId}-${index}`);
                const fullAmount = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(rt.amount, rt.currency);
                const isPartial = consumption.amount !== rt.amount;
                const source = $1000a58b5aa0fad5$var$getSource(rt);
                const hasRemaining = rt.remainingAmount != null && rt.remainingAmount !== 0;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                    to: `/raw-transactions/${rt._id}`,
                    "aria-current": rt._id === highlightId ? 'true' : undefined,
                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-3 transition-colors not-last:border-b not-last:border-border hover:bg-muted/50', // Blue, as a selected activity row is: the line you came from.
                    rt._id === highlightId && 'bg-blue-600/10 dark:bg-blue-400/15'),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex min-w-0 flex-col gap-1.5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "truncate text-foreground",
                                    title: rt.description,
                                    children: rt.description
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-wrap items-center gap-1.5 text-muted-foreground",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c0f56add137aac0$export$42a331aab32dea1), {
                                            account: rt.account
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-xs",
                                            children: (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(rt.date)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "rounded bg-muted px-1.5 py-0.5 text-xs",
                                            children: source
                                        }),
                                        hasRemaining && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "rounded bg-amber-500/20 px-1.5 py-0.5 text-xs text-amber-600 dark:text-amber-400",
                                            children: [
                                                formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(rt.remainingAmount, rt.currency)),
                                                ' ',
                                                "remaining"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex shrink-0 flex-col items-end justify-center gap-1 text-right",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                    amount: consumptionAmount
                                }),
                                isPartial && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-xs text-muted-foreground",
                                    children: [
                                        "of ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                            amount: fullAmount,
                                            variant: "plain",
                                            inline: true
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, `${consumption.rawTransactionId}-${index}`);
            }),
            showTotal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between gap-4 border-t border-border bg-muted/50 px-4 py-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "font-medium",
                        children: "Net Amount"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex items-center gap-2",
                        children: netAmounts.map((amount)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                amount: amount
                            }, amount.currency))
                    })
                ]
            })
        ]
    });
};




const $79e5532136f915cc$export$9915f3319304db38 = ({ transactionId: transactionId, lineCount: lineCount, currency: currency })=>{
    const [open, setOpen] = $acw62.useState(false);
    const [load, { data: data, loading: loading, error: error, refetch: refetch }] = (0, $ce9d9e524be20f53$export$7b47b9a4f467b0c)({
        fetchPolicy: 'no-cache'
    });
    const panelId = $acw62.useId();
    const toggle = ()=>{
        if (!open) {
            // Fresh on every open: lines edited since the last one show as they are.
            if (data == null) load({
                variables: {
                    id: transactionId
                }
            });
            else refetch();
        }
        setOpen(!open);
    };
    const consumptions = data?.transactionById?.consumptions ?? null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border border-b",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: toggle,
                "aria-expanded": open,
                "aria-controls": panelId,
                className: "text-muted-foreground hover:text-foreground flex items-center gap-1 pb-2 pl-16 text-xs max-md:pl-[54px]",
                children: [
                    lineCount,
                    " lines",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('size-3.5 transition-transform', open && 'rotate-180')
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: panelId,
                className: "bg-muted/30 border-border border-t pl-12 text-sm max-md:pl-10",
                children: consumptions != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1000a58b5aa0fad5$export$e0242e06075791dc), {
                    consumptions: consumptions,
                    currency: currency,
                    showTotal: false
                }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-muted-foreground px-4 py-3",
                    children: "Couldn't load its lines."
                }) : loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex justify-center py-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
                        size: "small"
                    })
                }) : null
            })
        ]
    });
};


const $f91f4119c6509632$var$transferLabels = {
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).AccountTransfer]: 'Transfer',
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).CreditCardPayment]: 'Card payment',
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Prepaid]: 'Prepaid',
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Refund]: 'Refund',
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Reimbursement]: 'Reimbursement',
    [(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion]: 'Conversion'
};
const $f91f4119c6509632$var$Avatar = (props)=>{
    const { transaction: transaction } = props;
    const base = 'flex size-9 max-md:size-8 shrink-0 items-center justify-center rounded-full';
    const { category: category } = transaction;
    // The payee's own logo beats any category icon or the transfer arrows: it
    // identifies the merchant specifically, where the others only say what
    // kind of thing it was. A transfer only has one via its optional payee —
    // a refund's merchant, a reimbursement's payer — and the type badge on
    // the row still marks it as a transfer.
    if (transaction.logo != null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7ce1c21778619db$export$ef41ebc44b9c1fe4), {
        logo: transaction.logo,
        className: "size-9 max-md:size-8",
        // Rounded square, not a circle, matching every other logo in the app
        // (accounts, breadcrumbs, the picker). Most of these are App Store
        // icons drawn as squircles, so a circular crop also cuts into marks
        // that were designed to reach the corners.
        //
        // rounded-md is 8px against this 36px tile — the ~0.22 ratio Apple
        // draws icons for. rounded-lg resolves to 10px here (the theme sets
        // --radius: 0.625rem) and reads noticeably rounder than the artwork.
        rounded: "rounded-md",
        alt: transaction.payee ?? ''
    });
    if (transaction.netAmount === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `${base} bg-muted text-muted-foreground`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e583651be68dae50$export$2e2bcd8739ae039), {
            className: "size-4"
        })
    });
    // An explicitly chosen category icon wins even over the income arrow —
    // the green amount already signals direction.
    if (category?.icon != null && (0, $b6ddd498a221dbc5$export$aec4ec8c571a0835)(category.icon)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6080e81c2b9604e9$export$bde99f6bf04aeea3), {
        category: category
    });
    if (transaction.netAmount > 0) {
        // Icon-less income keeps the inflow arrow, but an explicitly chosen
        // category color still tints it (green otherwise).
        const tint = category?.color != null && (0, $b6ddd498a221dbc5$export$e2e3e5e46b905df3)(category.color) ? (0, $3076b7ee20dc9ec8$export$ad7a0cd51bd1ba13)[category.color] : 'bg-positive/15 text-positive';
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: `${base} ${tint}`,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c0fdd0f1c350b23$export$2e2bcd8739ae039), {
                className: "size-4"
            })
        });
    }
    if (category) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6080e81c2b9604e9$export$bde99f6bf04aeea3), {
        category: category
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `${base} bg-muted text-muted-foreground`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e0fafd8685c1845$export$2e2bcd8739ae039), {
            className: "size-4"
        })
    });
};
const $f91f4119c6509632$var$TransactionRow = (props)=>{
    const { transaction: transaction, selected: selected, onSelect: onSelect, onShiftSelect: onShiftSelect, isSelectMode: isSelectMode } = props;
    const { data: fieldsData } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)();
    const fields = fieldsData?.allFields || [];
    const accountsById = (0, $0c13e6203680a429$export$f89288ccc27ab607)();
    const isBalanced = transaction.netAmount === 0;
    const accounts = $acw62.useMemo(()=>{
        const ids = transaction.accountIds ?? [];
        return ids.map((id)=>accountsById.get(id)).filter((account)=>account != null);
    }, [
        transaction.accountIds,
        accountsById
    ]);
    const { longPressProps: longPressProps, consumeLongPress: consumeLongPress } = (0, $549bdb4b32d8167b$export$c24ed0104d07eab9)(()=>onSelect(true));
    const handleClick = (event)=>{
        // If long-press just triggered, prevent navigation and ignore
        if (consumeLongPress()) {
            event.preventDefault();
            return;
        }
        // In select mode: prevent navigation, toggle selection
        if (isSelectMode) {
            event.preventDefault();
            if (event.shiftKey && onShiftSelect) onShiftSelect();
            else onSelect(!selected);
            return;
        }
    };
    // A transfer's payee (its counterparty) identifies the row better than the
    // free-text description, so it takes the title when present — mirroring
    // payment rows — and the description falls back in when there is none.
    const title = isBalanced ? transaction.payee || transaction.description : transaction.payee;
    // For transfers the net is zero by definition; the interesting number is
    // how much moved, i.e. the inflow side of the consumptions. A conversion's
    // legs are in two currencies the fragment can't distinguish, so no single
    // moved amount exists — fall through to the "—" placeholder.
    const movedAmount = transaction.transferType === (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion ? 0 : transaction.consumptions.filter((consumption)=>consumption.amount > 0).reduce((sum, consumption)=>sum + consumption.amount, 0);
    // A refund or reimbursement is money crossing back over the household
    // boundary — the inflow reads like income, so it gets the payment rows'
    // treatment (full weight, green positive) rather than the muted movement
    // number the own-account transfer kinds keep.
    const isCounterpartyTransfer = transaction.transferType === (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Refund || transaction.transferType === (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Reimbursement;
    // Foreign-currency payments show their USD value beneath the native
    // amount. homeNetAmount equals netAmount for USD transactions, so only a
    // genuinely foreign row gets the second line.
    const approxHome = transaction.currency !== 'USD' && transaction.homeNetAmount != null ? (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(transaction.homeNetAmount, 'USD') : null;
    // The meta line shows the dimension that defines the row: a transfer is an
    // account movement, so it gets its accounts (with their avatars); a payment
    // is a categorized purchase, so it gets its category and the raw
    // description. Payments deliberately do not name their account — it repeats
    // the same card on nearly every row, and the account filter, ledger, and
    // detail page all answer that question.
    const { category: category, description: description } = transaction;
    const hasDescription = description != null && description !== '';
    // When the payee holds a transfer's title, the description would otherwise
    // vanish from the row — so it joins the meta line after the account chain,
    // mirroring payment rows (structural part first, free text last).
    const transferShowsDescription = isBalanced && Boolean(transaction.payee) && hasDescription;
    const metaTitle = isBalanced ? [
        accounts.map((account)=>account.name).join(" \u2192 ") || null,
        transferShowsDescription ? description : null
    ].filter((part)=>part != null).join(" \xb7 ") : [
        category?.name,
        hasDescription ? description : null
    ].filter((part)=>part != null).join(" \xb7 ");
    const hasChips = transaction.tags.length > 0 || Object.values(transaction.fieldValues || {}).some((value)=>value != null && value !== '');
    // A transaction made of several lines can open them in place, beneath
    // the row (which then leaves its bottom border to them). A transfer's two
    // legs are already on the row as its accounts, so only an unusual
    // transfer — three or more legs — gets the toggle.
    const lineCount = new Set(transaction.consumptions.map((consumption)=>consumption.rawTransactionId)).size;
    const hasLines = lineCount > (isBalanced ? 2 : 1);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                to: `/transactions/${transaction._id}`,
                onClick: handleClick,
                ...longPressProps,
                className: `${selected ? 'bg-accent' : 'bg-transparent'} hover:bg-accent grid ${isSelectMode ? '[grid-template-columns:max-content_minmax(0,1fr)_max-content]' : '[grid-template-columns:minmax(0,1fr)_max-content]'} gap-x-5 max-md:gap-x-2 items-center px-4 py-3 max-md:px-3 box-border w-full ${hasLines ? '' : 'border-b border-border'} select-none`,
                children: [
                    isSelectMode && // pointer-events-none: the row's own click handler toggles selection
                    // and prevents link navigation; the checkbox is display-only.
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none flex items-center self-center pr-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad8caa31e29e010a$export$2e2bcd8739ae039), {
                            value: selected ? 'check' : 'empty'
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-w-0 items-center gap-3 max-md:gap-2.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f91f4119c6509632$var$Avatar, {
                                transaction: transaction
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex min-w-0 flex-col gap-0.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-foreground truncate font-medium",
                                                title: title ?? '',
                                                children: title
                                            }),
                                            transaction.pending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "bg-warning/20 text-warning rounded px-1.5 py-0.5 text-xs font-medium shrink-0",
                                                children: "Pending"
                                            }),
                                            isBalanced && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "bg-muted text-muted-foreground rounded px-1.5 py-0.5 text-xs font-medium shrink-0",
                                                children: transaction.transferType ? $f91f4119c6509632$var$transferLabels[transaction.transferType] : 'Transfer'
                                            })
                                        ]
                                    }),
                                    metaTitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-muted-foreground flex items-center gap-1.5 overflow-hidden text-sm",
                                        title: metaTitle,
                                        children: isBalanced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                accounts.map((account, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                                                        children: [
                                                            index > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "shrink-0",
                                                                children: "\u2192"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "flex min-w-0 items-center gap-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd8122ba7d7dc8$export$a519fd59e714bf50), {
                                                                        account: account,
                                                                        className: "size-3.5 rounded-[3px]"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "truncate",
                                                                        children: account.name
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, account._id)),
                                                transferShowsDescription && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        accounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "shrink-0",
                                                            children: "\xb7"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "truncate",
                                                            children: description
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                category && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a7baecaae56a667$export$1f1530db9dfbc9da), {
                                                    category: category
                                                }),
                                                category && hasDescription && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "shrink-0",
                                                    children: "\xb7"
                                                }),
                                                hasDescription && // The raw bank string is the least interesting part, so
                                                // it alone truncates when the line runs out of room.
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "truncate",
                                                    children: description
                                                })
                                            ]
                                        })
                                    }),
                                    hasChips && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-0.5 flex flex-wrap items-center gap-1.5",
                                        children: [
                                            transaction.tags.map((tag)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "bg-muted text-muted-foreground rounded-full px-2 py-0.5 text-xs font-medium",
                                                    children: tag.name
                                                }, tag._id)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $131e63675abc2981$export$b9c3f7b4f6aa1316), {
                                                fields: fields,
                                                fieldValues: transaction.fieldValues || {}
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-w-0 flex-col items-end justify-center gap-0.5 text-right",
                        children: [
                            isBalanced ? isCounterpartyTransfer && movedAmount > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "font-medium",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                    amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(movedAmount, transaction.currency)
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-muted-foreground",
                                children: movedAmount > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                    variant: "plain",
                                    amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(movedAmount, transaction.currency)
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "\u2014"
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "font-medium",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                    amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(transaction.netAmount, transaction.currency),
                                    approx: approxHome
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground text-sm",
                                children: (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(transaction.date)
                            })
                        ]
                    })
                ]
            }),
            hasLines && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79e5532136f915cc$export$9915f3319304db38), {
                transactionId: transaction._id,
                lineCount: lineCount,
                currency: transaction.currency
            })
        ]
    });
};
var $f91f4119c6509632$export$2e2bcd8739ae039 = $f91f4119c6509632$var$TransactionRow;



const $099e0bbf7c7420da$var$RAW_TX_LIMIT = 10;
const $099e0bbf7c7420da$var$SectionHeading = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-muted border-border text-muted-foreground border-b px-4 py-2 text-sm font-medium",
        children: children
    });
const $099e0bbf7c7420da$export$4c3f144ef44053eb = ({ variant: variant, expanded: expanded = false })=>{
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const [searchParams] = (0, $0c90f43fc3673aef$export$f1a78c17382fe22a)();
    const [dateFilter, setDateFilter] = $acw62.useState(()=>({
            startDate: searchParams.get('start'),
            endDate: searchParams.get('end')
        }));
    $acw62.useEffect(()=>{
        const startDate = searchParams.get('start');
        const endDate = searchParams.get('end');
        // The URL owns the filter: a link or Back that changes or clears the
        // params changes it too.
        setDateFilter({
            startDate: startDate,
            endDate: endDate
        });
    }, [
        searchParams
    ]);
    // The default (unfiltered) scope starts at the shared backlog cutoff so
    // the initial pages stay within the recent era. Fixed per mount so a
    // session open across midnight can't shift the scope under the query.
    const [recencyFloor] = $acw62.useState(()=>(0, $e5a5329773e68f54$export$3d3b2142d981b7e6)().toISODate());
    const manualFilter = dateFilter.startDate !== null || dateFilter.endDate !== null;
    const windowStart = manualFilter ? null : recencyFloor;
    const filters = {
        includeProcessed: false,
        limit: $099e0bbf7c7420da$var$RAW_TX_LIMIT,
        startDate: dateFilter.startDate ?? windowStart,
        endDate: dateFilter.endDate
    };
    // Whether anything unallocated exists past the cutoff — drives the "Show
    // older" affordance once the recent era is spent. Kept fresh by the
    // refetch in handleUpdateRawTransactions below.
    const { data: summaryData } = (0, $ce9d9e524be20f53$export$edf7816f5074c300)();
    const backlogCount = summaryData?.inboxBacklogSummary.backlogCount ?? 0;
    // The other kind of loose end: transactions recorded before their line
    // arrived (pending). They sit above the queue in the full review view, so
    // a line and the transaction waiting for it are on one screen. Not in the
    // Inbox preview (its own card lists them), nor under a manual date filter
    // (a Backlog year is about old lines, not what's pending now).
    const showPending = variant === 'full' && !manualFilter;
    const pendingVariables = {
        pending: true,
        startDate: null,
        endDate: null,
        limit: 100
    };
    const { data: pendingData, error: pendingError, loading: pendingLoading, fetchMore: fetchMorePending, refetch: refetchPending } = (0, $ce9d9e524be20f53$export$c16de15367a0de91)({
        skip: !showPending,
        variables: pendingVariables,
        // A transaction marked posted (or newly entered pending) isn't added to
        // or removed from this cached filtered list by its own write — revalidate
        // on every visit, as the Inbox's pending card does.
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true
    });
    const pendingPage = showPending ? pendingData?.transactions : undefined;
    const pendingTransactions = pendingPage?.items ?? [];
    const pendingFailed = showPending && pendingError != null && pendingTransactions.length === 0;
    // Still waiting on the first pending answer: an empty queue can't yet be
    // called caught up — something may be pending.
    const pendingUnknown = showPending && pendingData == null && pendingError == null;
    const handleMorePending = ()=>{
        if (!pendingPage?.hasMore || !pendingPage.endCursor) return;
        // Pages merge in the cache (the transactions field policy).
        fetchMorePending({
            variables: {
                ...pendingVariables,
                beforeCursor: pendingPage.endCursor
            }
        });
    };
    const [loadRawTransactions, { loading: rawLoading, data: rawData, error: rawError, fetchMore: fetchMore }] = (0, $ce9d9e524be20f53$export$d1531303a4748421)({
        notifyOnNetworkStatusChange: true
    });
    const updateRawTransactionsCache = (0, $2f8143a39a28ff19$export$2e2bcd8739ae039)({
        client: client,
        filters: filters
    });
    const handleUpdateRawTransactions = (mutation)=>{
        updateRawTransactionsCache(mutation);
        // The inbox card's counts come from the summary query; keep them fresh
        client.refetchQueries({
            include: [
                'InboxBacklogSummary'
            ]
        });
    };
    // Rows from a previous date scope must not flash (or be selectable) while
    // the new scope loads — track which scope the displayed data belongs to
    const scopeKey = `${filters.startDate ?? ''}|${filters.endDate ?? ''}`;
    const [loadedScope, setLoadedScope] = $acw62.useState(null);
    // Guard completions against out-of-order resolution: only the latest
    // requested scope may mark itself loaded
    const latestScopeRef = $acw62.useRef(scopeKey);
    $acw62.useEffect(()=>{
        latestScopeRef.current = scopeKey;
        const requested = scopeKey;
        loadRawTransactions({
            variables: filters
        }).then(()=>{
            if (latestScopeRef.current === requested) setLoadedScope(requested);
        });
    }, [
        dateFilter
    ]);
    const scopeReady = loadedScope === scopeKey;
    const rawTransactions = scopeReady ? rawData?.allRawTransactions?.items ?? [] : [];
    const selectionState = (0, $026af87cc9705d5d$export$6d82c2edda5ea5bd)(rawTransactions, []);
    const { selected: selected } = selectionState;
    // A scope change replaces the visible rows; stale selections would let the
    // header act on rows the user can no longer see
    // clearSelection is recreated each render; a ref keeps this effect keyed
    // to the scope alone (depending on the function would loop)
    const clearSelectionRef = $acw62.useRef(selectionState.clearSelection);
    clearSelectionRef.current = selectionState.clearSelection;
    $acw62.useEffect(()=>{
        clearSelectionRef.current();
    }, [
        scopeKey
    ]);
    const isPreview = variant === 'preview';
    // Collapsed, the card shows only its first few rows; a selection must never
    // act on rows out of view, so rows that leave the view (the card folding
    // back, or a refresh reordering the list) drop out of it.
    $acw62.useEffect(()=>{
        if (!isPreview || expanded) return;
        const visible = new Set(rawTransactions.slice(0, $099e0bbf7c7420da$var$COLLAPSED_ROWS).map((rt)=>rt._id));
        const kept = selected.filter((rt)=>visible.has(rt._id));
        if (kept.length !== selected.length) selectionState.setSelection(kept);
    }, [
        expanded,
        rawTransactions,
        selected
    ]);
    const selectionActions = (0, $e809c44401bdca50$export$3e6527a98b3f5155)({
        selectionState: selectionState,
        onUpdate: handleUpdateRawTransactions
    });
    // Every row here is unallocated, so a tap opens the create sheet for it.
    const gestures = (0, $28bb13ba9d3f9376$export$9227a5765cfbd955)({
        selectionState: selectionState,
        openCreate: selectionActions.openCreateForRow,
        allocateOnTap: true
    });
    (0, $fd54cadefa06c3a3$export$4acbb2ebc34e06c0)(isPreview ? rawTransactions : []);
    // The full list's header owns Escape; the preview card has no header.
    (0, $643289de0f480f5f$export$1b0c17123b4f3646)('Escape', ()=>{
        if (isPreview && gestures.selecting && !selectionActions.anyModalOpen) gestures.stopSelecting();
    }, [
        isPreview,
        gestures.selecting,
        selectionActions.anyModalOpen
    ]);
    const pageHasMore = rawData?.allRawTransactions?.hasMore ?? false;
    // Whether the loaded rows already crossed the recency floor into the
    // backlog. Derived from the data rather than state so it survives
    // collapse/expand cycles and cache-restored lists.
    const extendedPastFloor = windowStart !== null && rawTransactions.some((rawTransaction)=>rawTransaction.date < windowStart);
    // The recent era is spent but the backlog isn't — "More" becomes "Show
    // older" and drops the date floor.
    const canExtend = windowStart !== null && !extendedPastFloor && !pageHasMore && backlogCount > 0;
    const hasMore = pageHasMore || canExtend;
    const moreLabel = canExtend ? 'Show older' : undefined;
    const handleMore = ()=>{
        if (fetchMore && hasMore) {
            const endCursor = rawData?.allRawTransactions?.endCursor ?? null;
            if (pageHasMore && !endCursor) return;
            // Paging past the recency floor (crossing it now, or having crossed it
            // already) drops the floor so the same cursor walk continues into the
            // backlog. An empty recent era has no cursor; the unbounded first page
            // is entirely backlog anyway.
            const startDate = windowStart !== null && (extendedPastFloor || !pageHasMore) ? null : filters.startDate;
            fetchMore({
                variables: {
                    ...filters,
                    startDate: startDate,
                    ...endCursor ? {
                        beforeCursor: endCursor
                    } : {}
                },
                updateQuery: (previous, result)=>{
                    const moreItems = result.fetchMoreResult?.allRawTransactions?.items ?? [];
                    return {
                        ...previous,
                        allRawTransactions: {
                            ...previous.allRawTransactions,
                            items: [
                                ...previous.allRawTransactions?.items ?? [],
                                ...moreItems
                            ],
                            endCursor: result.fetchMoreResult?.allRawTransactions?.endCursor ?? null,
                            hasMore: result.fetchMoreResult?.allRawTransactions?.hasMore ?? false
                        }
                    };
                }
            });
        }
    };
    if (!scopeReady && rawLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex h-full items-center justify-center py-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
            size: "medium"
        })
    });
    const header = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5789cc019e3b9369$export$8b251419efc915eb), {
        selectionState: selectionState,
        actions: selectionActions,
        gestures: gestures,
        showSyncButton: false,
        showAddActions: false,
        // One Dates pill and the Select button fit a phone row together, so
        // the actions stay beside the filter instead of dropping to a second
        // line and costing the (internally scrolled) list that height.
        stackActionsOnMobile: false,
        filterContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fb4243874d8f910$export$bfb275743ab18881), {
            value: dateFilter,
            onChange: setDateFilter,
            // Sharing the row means the pill has to fit beside the actions:
            // "Dates: Custom range…" is wider than a 320px phone leaves it.
            truncateLabel: true
        })
    });
    const errorBody = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center gap-2 py-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground text-sm",
                children: "Couldn't load transactions to review."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "text-foreground cursor-pointer text-sm underline",
                onClick: ()=>{
                    const requested = scopeKey;
                    loadRawTransactions({
                        variables: filters
                    }).then(()=>{
                        if (latestScopeRef.current === requested) setLoadedScope(requested);
                    });
                },
                children: "Retry"
            })
        ]
    });
    // An empty list can still have more to load: the recent era may be empty
    // while the backlog isn't (canExtend), or every loaded row was just
    // reviewed away with more pages remaining in scope (pageHasMore).
    const emptyMessage = hasMore ? canExtend ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "Nothing recent to review."
    }) : null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "All caught up!"
    });
    const emptyBody = hasMore ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            emptyMessage,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f474bccad37d15d6$export$7f94856880993f27), {
                loading: rawLoading,
                hasMore: true,
                onMore: handleMore,
                label: moreLabel
            })
        ]
    }) : emptyMessage;
    // Full: the list fills the view, rows scroll internally, and the
    // pagination footer stays pinned at the bottom of the screen instead of
    // trailing the last row — repeated "More" clicks never chase the button
    // down the page.
    if (variant === 'full') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-full min-h-0 flex-col",
        children: [
            header,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-y-auto",
                children: [
                    (pendingTransactions.length > 0 || pendingFailed) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($099e0bbf7c7420da$var$SectionHeading, {
                                children: "Pending"
                            }),
                            pendingFailed ? // Never let a failed load read as nothing pending.
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "border-border flex items-center gap-3 border-b px-4 py-3 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground",
                                        children: "Couldn't load pending transactions."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "text-foreground cursor-pointer underline",
                                        onClick: ()=>void refetchPending(),
                                        children: "Retry"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    pendingTransactions.map((transaction)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f91f4119c6509632$export$2e2bcd8739ae039), {
                                            transaction: transaction,
                                            selected: false,
                                            isSelectMode: false,
                                            onSelect: ()=>undefined
                                        }, transaction._id)),
                                    pendingPage?.hasMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f474bccad37d15d6$export$7f94856880993f27), {
                                        loading: pendingLoading,
                                        hasMore: true,
                                        onMore: handleMorePending
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($099e0bbf7c7420da$var$SectionHeading, {
                                children: "To review"
                            })
                        ]
                    }),
                    rawTransactions.length === 0 && rawError ? errorBody : rawTransactions.length === 0 ? pendingUnknown ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex justify-center py-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
                            size: "medium"
                        })
                    }) : emptyMessage : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e054dd754d7f7b3$export$2e2bcd8739ae039), {
                                transactions: rawTransactions,
                                ...gestures.rowProps
                            }),
                            !hasMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f474bccad37d15d6$export$7f94856880993f27), {
                                loading: false,
                                hasMore: false,
                                onMore: handleMore
                            })
                        ]
                    })
                ]
            }),
            hasMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-border flex justify-center border-t",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f474bccad37d15d6$export$7f94856880993f27), {
                    loading: rawLoading,
                    hasMore: true,
                    onMore: handleMore,
                    label: moreLabel
                })
            })
        ]
    });
    // Preview (the Inbox card): the first few rows, and every row once the card
    // has taken over the Inbox.
    const listProps = gestures.rowProps;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            rawTransactions.length === 0 ? // A failed load is never "caught up".
            rawError ? errorBody : emptyBody : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e054dd754d7f7b3$export$2e2bcd8739ae039), {
                        transactions: rawTransactions.slice(0, $099e0bbf7c7420da$var$COLLAPSED_ROWS),
                        ...listProps
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($099e0bbf7c7420da$var$Unfold, {
                        open: expanded,
                        children: [
                            rawTransactions.length > $099e0bbf7c7420da$var$COLLAPSED_ROWS && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e054dd754d7f7b3$export$2e2bcd8739ae039), {
                                className: "border-border border-t",
                                transactions: rawTransactions.slice($099e0bbf7c7420da$var$COLLAPSED_ROWS),
                                ...listProps
                            }),
                            hasMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "border-border flex justify-center border-t",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f474bccad37d15d6$export$7f94856880993f27), {
                                    loading: rawLoading,
                                    hasMore: true,
                                    onMore: handleMore,
                                    label: moreLabel
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3bd1972ca95e7ca$export$377ee9046e4a9901), {
                actions: selectionActions,
                open: gestures.selecting,
                onCancel: gestures.stopSelecting
            })
        ]
    });
};
const $099e0bbf7c7420da$var$COLLAPSED_ROWS = 3;
/**
 * Height that animates between nothing and its content's natural height (a
 * grid row going 0fr → 1fr), so no measuring. Closed, its contents are inert:
 * out of the tab order, and not something a tap can land on.
 */ const $099e0bbf7c7420da$var$Unfold = ({ open: open, children: children })=>{
    const innerRef = $acw62.useRef(null);
    // React 18 has no `inert` prop, hence the ref.
    $acw62.useEffect(()=>{
        if (innerRef.current) innerRef.current.inert = !open;
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "grid transition-[grid-template-rows] duration-300 ease-in-out motion-reduce:transition-none",
        style: {
            gridTemplateRows: open ? '1fr' : '0fr'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ref: innerRef,
            className: "min-h-0 overflow-hidden",
            children: children
        })
    });
};






var $acw62 = parcelRequire("acw62");


const $4080f01bf279e3bc$var$CreditRowItem = ({ row: row, onRecorded: onRecorded })=>{
    const [error, setError] = $acw62.useState(null);
    const [recordCredit, { loading: loading }] = (0, $ce9d9e524be20f53$export$2a9fd5e50f70d62f)();
    const handleRecord = async ()=>{
        setError(null);
        try {
            await recordCredit({
                variables: {
                    benefitId: row.benefitId
                },
                refetchQueries: [
                    {
                        query: (0, $ce9d9e524be20f53$export$cd3f83b43415ec72)
                    }
                ]
            });
            onRecorded();
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            const err = e;
            setError(err.message);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border flex items-center gap-3 px-4 py-2.5 not-last:border-b",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $960851586a15b7fa$export$2e2bcd8739ae039), {
                className: "text-muted-foreground size-4 shrink-0"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-w-0 flex-1 flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex min-w-0 items-baseline gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "truncate text-sm font-medium",
                                children: row.benefitName
                            }),
                            row.payee && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground truncate text-xs",
                                children: row.payee
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground text-xs",
                        children: [
                            (0, $a5f774b73aaf5820$export$a053908c5c4ea08d)(row.startDate, row.endDate),
                            ` \xb7 loads to ${row.creditAccountName}`
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-destructive text-xs",
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: handleRecord,
                disabled: loading,
                className: "shrink-0",
                children: loading ? 'Recording...' : `Record ${(0, $a5f774b73aaf5820$export$4ead0eaee86eb5fb)(row.remainingAmount)}`
            })
        ]
    });
};
const $4080f01bf279e3bc$export$e96cbc622733271 = ()=>{
    const { data: data, refetch: refetch } = (0, $ce9d9e524be20f53$export$6a6218148cb41524)({
        fetchPolicy: 'cache-and-network'
    });
    const rows = data?.upcomingBenefitCredits ?? [];
    return {
        rows: rows,
        refetch: refetch
    };
};
const $4080f01bf279e3bc$export$826f9f6120f423a8 = ({ rows: rows, onRecorded: onRecorded, hideHeading: hideHeading = false })=>{
    if (rows.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            !hideHeading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-muted border-border text-muted-foreground border-b px-4 py-2 text-sm font-medium",
                children: [
                    "Benefit credits to record (",
                    rows.length,
                    ")"
                ]
            }),
            rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4080f01bf279e3bc$var$CreditRowItem, {
                    row: row,
                    onRecorded: onRecorded
                }, `${row.benefitId}-${row.startDate}`))
        ]
    });
};


// Page size for the needs-basis to-do; "Show more" grows the limit, so no
// actionable row is ever stuck behind the cap.
const $e15262ef6128f3bb$var$NEEDS_BASIS_PAGE = 50;
const $e15262ef6128f3bb$var$PendingRow = ({ transaction: transaction })=>{
    const isPayment = transaction.netAmount !== 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
        to: `/transactions/${transaction._id}`,
        className: "border-border hover:bg-muted-foreground/10 -mx-4 grid grid-cols-[1fr_auto] items-center gap-x-3 border-t px-4 py-2.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "flex min-w-0 items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "bg-warning/20 text-warning rounded px-1.5 py-0.5 text-[0.7rem] font-medium",
                        children: "Pending"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "truncate text-sm font-medium",
                        children: isPayment ? transaction.payee : transaction.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-right text-sm tabular-nums",
                children: isPayment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                    variant: "plain",
                    amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(transaction.netAmount, transaction.currency)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground col-span-2 text-xs",
                children: (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(transaction.date)
            })
        ]
    });
};
const $e15262ef6128f3bb$export$17e4068f9ad0565b = ()=>{
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    // /inbox/review is the review card taking over the Inbox. Both routes
    // render this same element, so moving between them (the button, the
    // breadcrumb, Back) keeps the page mounted and the change animates.
    const location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    const [searchParams] = (0, $0c90f43fc3673aef$export$f1a78c17382fe22a)();
    // Normalized: the router also matches a trailing slash.
    const expanded = location.pathname.replace(/\/+$/, '') === '/inbox/review';
    // The two states share one scroller. Expanding starts the review at its
    // top; folding back returns the dashboard to where it was, not wherever
    // the review had scrolled to.
    const scrollerRef = $acw62.useRef(null);
    const dashboardScroll = $acw62.useRef(0);
    $acw62.useEffect(()=>{
        const scroller = scrollerRef.current;
        if (scroller == null) return;
        if (expanded) {
            dashboardScroll.current = scroller.scrollTop;
            scroller.scrollTop = 0;
        } else scroller.scrollTop = dashboardScroll.current;
    }, [
        expanded
    ]);
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)(expanded ? {
        label: 'Review',
        fallback: [
            {
                label: 'Inbox',
                href: '/'
            }
        ]
    } : {
        label: 'Inbox',
        reset: true
    });
    const { data: summaryData, error: summaryError, refetch: refetchSummary } = (0, $ce9d9e524be20f53$export$edf7816f5074c300)({
        // Render the cached dashboard instantly on revisits; the refresh lands
        // in place. network-only made every navigation a full-page spinner.
        fetchPolicy: 'cache-and-network'
    });
    const summary = summaryData?.inboxBacklogSummary;
    const frontierDate = summary?.frontierDate ?? null;
    const { data: pendingData, error: pendingError, refetch: refetchPending } = (0, $ce9d9e524be20f53$export$c16de15367a0de91)({
        fetchPolicy: 'cache-and-network',
        variables: {
            pending: true,
            startDate: null,
            endDate: null,
            limit: 100
        }
    });
    const pendingTransactions = pendingData?.transactions?.items ?? [];
    // Queried HERE, not inside the card: the "All caught up!" verdict below has
    // to be computed from the same data as the cards it sits above.
    const [needsBasisLimit, setNeedsBasisLimit] = $acw62.useState($e15262ef6128f3bb$var$NEEDS_BASIS_PAGE);
    const { data: needsBasisData, error: needsBasisError, refetch: refetchNeedsBasis } = (0, $ce9d9e524be20f53$export$2390a609b2cd0982)({
        fetchPolicy: 'cache-and-network',
        variables: {
            limit: needsBasisLimit
        }
    });
    const needsBasisRows = needsBasisData?.transactions.items ?? [];
    const { rows: creditRows, refetch: refetchCreditRows } = (0, $4080f01bf279e3bc$export$e96cbc622733271)();
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    // New rows land in the review card, so refresh the counts and the
    // embedded list after adding or importing.
    const refreshAfterAdd = ()=>{
        refetchSummary();
        client.refetchQueries({
            include: [
                'AllRawTransactions'
            ]
        });
    };
    // Quick action for manual (e.g. cash) transactions.
    const openAddRawTransactionModal = ()=>{
        modals.createRawTransactionModal.openModal({
            onCreate: refreshAfterAdd
        });
    };
    const openImportModal = ()=>{
        modals.importTransactionsModal.openModal({
            onImport: refreshAfterAdd
        });
    };
    // A dated /inbox/review link predates the card taking over the Inbox: it
    // was a Backlog year's review, which lives in the Ledger now.
    if (expanded && (searchParams.has('start') || searchParams.has('end'))) {
        const next = new URLSearchParams(searchParams);
        next.set('layer', 'activity');
        next.set('view', 'review');
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
            to: `/ledger?${next.toString()}`,
            replace: true
        });
    }
    // The other cards' data only matters when they're showing: an expanded
    // review never waits on (or fails for) jobs folded out of sight.
    const othersReady = pendingData !== undefined && needsBasisData !== undefined;
    const othersFailed = pendingError != null || needsBasisError != null;
    if (summary === undefined || !expanded && !othersReady) {
        // A failed initial query would otherwise leave the spinner forever
        if (summaryError || !expanded && othersFailed) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex h-full flex-col items-center justify-center gap-3",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground text-sm",
                    children: "Couldn't load the inbox."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "outline",
                    onClick: ()=>{
                        refetchSummary();
                        refetchPending();
                        refetchNeedsBasis();
                    },
                    children: "Retry"
                })
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex h-full items-center justify-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
                size: "medium"
            })
        });
    }
    const recentCount = summary.recentCount;
    const jobCount = (recentCount > 0 ? 1 : 0) + (pendingTransactions.length > 0 ? 1 : 0) + (needsBasisRows.length > 0 ? 1 : 0) + (creditRows.length > 0 ? 1 : 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-full flex-col overflow-hidden",
        children: [
            !expanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $eca5e0b4050b06eb$export$223875819fd7cf93), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        size: "icon",
                        className: "max-sm:hidden",
                        onClick: openAddRawTransactionModal,
                        title: "Add raw transaction",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                            className: "size-5"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f19cc5705d0e1661$export$5aad1ccc3a47254f), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49e34d17f9b50791$export$32b7bd840a1eba80), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                            onSelect: openImportModal,
                            iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05c245c7dcd30f27$export$2e2bcd8739ae039), {}),
                            children: "Import"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: scrollerRef,
                className: "min-h-0 flex-1 overflow-y-auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-4 p-4",
                    children: [
                        (recentCount > 0 || expanded) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $32895c25060bdb77$export$b2a61672b90733e6), {
                            title: "Review new transactions",
                            meta: `${recentCount} waiting${frontierDate ? ` \xb7 oldest ${(0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(frontierDate)}` : ''}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "border-border -mx-4 border-t",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $099e0bbf7c7420da$export$4c3f144ef44053eb), {
                                        variant: "preview",
                                        expanded: expanded
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "border-border border-t py-2.5",
                                    children: expanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                        variant: "outline",
                                        className: "w-full gap-1.5",
                                        onClick: ()=>navigate('/'),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                                className: "size-4"
                                            }),
                                            "Back to Inbox"
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                        variant: "primary",
                                        className: "w-full",
                                        onClick: ()=>navigate('/inbox/review'),
                                        children: [
                                            "Review (",
                                            recentCount,
                                            ")"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "grid transition-[grid-template-rows] duration-300 ease-in-out motion-reduce:transition-none",
                            style: {
                                gridTemplateRows: expanded ? '0fr' : '1fr'
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                // Folded, these cards are out of sight and out of reach: no
                                // tabbing or screen-reader visits to controls behind the review.
                                // (React 18 has no `inert` prop, hence the callback ref.)
                                ref: (el)=>{
                                    if (el) el.inert = expanded;
                                },
                                className: "flex min-h-0 flex-col gap-4 overflow-hidden",
                                children: othersReady && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67d754936473e916$export$db1b7d5249eea904), {
                                            rows: needsBasisRows,
                                            hasMore: needsBasisData?.transactions.hasMore ?? false,
                                            onShowMore: ()=>setNeedsBasisLimit((current)=>current + $e15262ef6128f3bb$var$NEEDS_BASIS_PAGE),
                                            onChanged: ()=>void refetchNeedsBasis()
                                        }),
                                        pendingTransactions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32895c25060bdb77$export$b2a61672b90733e6), {
                                            title: "Pending transactions",
                                            meta: `${pendingTransactions.length}`,
                                            children: pendingTransactions.map((tx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e15262ef6128f3bb$var$PendingRow, {
                                                    transaction: tx
                                                }, tx._id))
                                        }),
                                        creditRows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32895c25060bdb77$export$b2a61672b90733e6), {
                                            title: "Benefit credits to record",
                                            meta: `${creditRows.length}`,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "border-border -mx-4 border-t",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4080f01bf279e3bc$export$826f9f6120f423a8), {
                                                    rows: creditRows,
                                                    onRecorded: ()=>void refetchCreditRows(),
                                                    hideHeading: true
                                                })
                                            })
                                        }),
                                        jobCount === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-muted-foreground py-10 text-center text-sm",
                                            children: "All caught up!"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83672a6e41d87bc3$export$a7d5a7b87448faa1), {}),
                                        summary.backlogCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $676fdaf4f964f427$export$25a560a772e56498), {
                                            summary: summary
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};





parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");

// Same freshness semantics as the accounts list (AccountRowV2): recent
// observations render nothing — quiet means healthy — a missed cadence gets
// a muted "as of" note, a twice-missed monthly routine turns amber.
const $660ced10ade61cb3$var$OBSERVATION_NOTE_DAYS = 14;
const $660ced10ade61cb3$var$OBSERVATION_STALE_DAYS = 60;
const $660ced10ade61cb3$var$GROUPS = [
    {
        key: 'brokerage',
        label: 'Brokerage',
        types: [
            (0, $ce9d9e524be20f53$export$19445fdc19724941).Brokerage
        ]
    },
    {
        key: 'retirement',
        label: 'Retirement',
        types: [
            (0, $ce9d9e524be20f53$export$19445fdc19724941)['401K'],
            (0, $ce9d9e524be20f53$export$19445fdc19724941).Ira,
            (0, $ce9d9e524be20f53$export$19445fdc19724941).RothIra,
            (0, $ce9d9e524be20f53$export$19445fdc19724941).Hsa
        ]
    },
    {
        key: 'education',
        label: 'Education',
        types: [
            (0, $ce9d9e524be20f53$export$19445fdc19724941).Education
        ]
    },
    {
        key: 'other',
        label: 'Other',
        types: [
            (0, $ce9d9e524be20f53$export$19445fdc19724941).Other
        ]
    }
];
const $660ced10ade61cb3$var$formatCurrency = (cents)=>new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(cents / 100);
const $660ced10ade61cb3$var$formatShare = (share)=>share >= 0.1 ? `${(share * 100).toFixed(1)}%` : `${(share * 100).toFixed(2)}%`;
const $660ced10ade61cb3$var$formatPercent = (decimal)=>{
    const sign = decimal >= 0 ? '+' : '';
    return `${sign}${(decimal * 100).toFixed(2)}%`;
};
const $660ced10ade61cb3$var$getSubtitle = (account)=>account.plaid?.institutionName ?? 'Manual investment';
const $660ced10ade61cb3$var$Sparkline = ({ points: points })=>{
    if (points.length < 2) return null;
    const values = points.map((p)=>p.portfolioValue);
    const min = Math.min(...values);
    const max = Math.max(...values);
    const span = Math.max(max - min, 1);
    // X is proportional to elapsed time, not array index — a sparse series
    // (manual accounts with observation gaps) must not compress months into
    // the same width as a week.
    const times = points.map((p)=>new Date(p.date).getTime());
    const firstTime = times[0];
    const timeSpan = Math.max(times[times.length - 1] - firstTime, 1);
    const coords = values.map((v, i)=>{
        const x = (times[i] - firstTime) / timeSpan * 106 + 2;
        const y = 24 - (v - min) / span * 20;
        return `${x.toFixed(1)},${y.toFixed(1)}`;
    }).join(' ');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "110",
        height: "28",
        viewBox: "0 0 110 28",
        className: "shrink-0",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
            points: coords,
            fill: "none",
            className: "stroke-muted-foreground/60",
            strokeWidth: "1.5"
        })
    });
};
const $660ced10ade61cb3$var$FleetCard = ({ account: account, performance: performance, share: share, sparkline: sparkline, balanceStatus: balanceStatus })=>{
    const xirr = performance?.xirr;
    // Freshness pairs with the observation backing the DISPLAYED value —
    // balanceAsOf follows the unbounded newest entry and can be future-dated.
    const observationAgeDays = account.presentBalanceAsOf != null ? (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().diff((0, $0c0f91b069db95d9$export$6b862160d295c8e)(account.presentBalanceAsOf), 'days').days : null;
    const showFreshness = observationAgeDays != null && observationAgeDays > $660ced10ade61cb3$var$OBSERVATION_NOTE_DAYS;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
        to: `/accounts/${account._id}`,
        className: "border-border bg-card hover:bg-accent flex flex-col rounded-lg border p-3 no-underline transition-colors",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-baseline justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground truncate text-sm font-medium",
                        children: account.name
                    }),
                    xirr != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: `shrink-0 text-xs ${xirr > 0 ? 'text-positive' : xirr < 0 ? 'text-red-600 dark:text-red-400' : 'text-muted-foreground'}`,
                        children: [
                            $660ced10ade61cb3$var$formatPercent(xirr),
                            " XIRR"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground text-xs",
                children: $660ced10ade61cb3$var$getSubtitle(account)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-2 flex items-end justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground text-lg font-medium",
                        children: $660ced10ade61cb3$var$formatCurrency(account.presentBalance)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($660ced10ade61cb3$var$Sparkline, {
                        points: sparkline
                    })
                ]
            }),
            share != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-muted mt-2 h-1 rounded-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-muted-foreground/60 h-1 rounded-full",
                    style: {
                        width: `${Math.min(Math.max(share * 100, 1), 100)}%`
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-1 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-[11px]",
                        children: share != null ? `${$660ced10ade61cb3$var$formatShare(share)} of portfolio` : ''
                    }),
                    showFreshness && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: (observationAgeDays ?? 0) > $660ced10ade61cb3$var$OBSERVATION_STALE_DAYS ? 'text-[11px] text-amber-600 dark:text-amber-500' : 'text-muted-foreground text-[11px]',
                        children: [
                            "as of ",
                            account.presentBalanceAsOf
                        ]
                    })
                ]
            }),
            balanceStatus != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-warning mt-0.5 text-right text-[11px]",
                children: balanceStatus
            })
        ]
    });
};
const $660ced10ade61cb3$export$fea5dbc17d8cf2dc = ({ accounts: accounts, performanceByAccountId: performanceByAccountId, balanceStatusOf: balanceStatusOf })=>{
    const [dormantOpen, setDormantOpen] = $acw62.useState(false);
    // One batched request supplies every card's trailing-year sparkline. The
    // explicit endDate clamps at today — recordBalanceAnchor permits
    // future-dated anchors, and a scheduled balance must not render as
    // historical performance.
    const yearAgo = (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().minus({
        years: 1
    }).toISODate() ?? undefined;
    const todayISO = (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().toISODate() ?? undefined;
    const { data: historyData } = (0, $ce9d9e524be20f53$export$36c0441e1d5ae93)({
        variables: {
            resolution: (0, $ce9d9e524be20f53$export$7033551c6b85f4b7).Weekly,
            startDate: yearAgo,
            endDate: todayISO
        },
        fetchPolicy: 'cache-and-network'
    });
    const sparklines = $acw62.useMemo(()=>new Map((historyData?.portfolioHistoryByAccount ?? []).map((h)=>{
            // The shared-grid series zero-fills before an account's first
            // observation; those synthetic points would draw a young account
            // as a long verified-zero shelf plus a jump. The API marks them
            // unobserved — trim exactly those, so a genuinely observed idle
            // zero stretch stays visible.
            let firstObserved = 0;
            while(firstObserved < h.points.length && !h.points[firstObserved].observed)firstObserved++;
            return [
                h.accountId,
                h.points.slice(firstObserved)
            ];
        })), [
        historyData
    ]);
    // Classification, shares, and displayed amounts all read presentBalance
    // — the today-clamped value — because `balance` follows the newest entry
    // even when it is future-dated, so a scheduled zero would prematurely
    // fold a funded account into Dormant and a scheduled increase would
    // distort today's shares. Cards render for any nonzero present balance
    // (negative margin-debit accounts are real and must stay visible), but
    // the share denominator sums positive balances only.
    const funded = accounts.filter((account)=>account.presentBalance !== 0);
    const dormant = accounts.filter((account)=>account.presentBalance === 0);
    const dormantUnbalanced = dormant.filter((account)=>balanceStatusOf(account._id) != null).length;
    const totalValue = funded.reduce((sum, account)=>sum + Math.max(account.presentBalance, 0), 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            $660ced10ade61cb3$var$GROUPS.map((group)=>{
                const members = funded.filter((account)=>group.types.includes(account.investmentType)).sort((a, b)=>b.presentBalance - a.presentBalance);
                if (members.length === 0) return null;
                // The header's dollar figure is the honest net; its share matches
                // the cards by using positive balances only in both operands.
                const subtotal = members.reduce((sum, account)=>sum + account.presentBalance, 0);
                const positiveSubtotal = members.reduce((sum, account)=>sum + Math.max(account.presentBalance, 0), 0);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mb-2 flex items-baseline gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-foreground text-sm font-medium",
                                    children: group.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "text-muted-foreground text-xs",
                                    children: [
                                        $660ced10ade61cb3$var$formatCurrency(subtotal),
                                        totalValue > 0 && positiveSubtotal > 0 && ` \xb7 ${$660ced10ade61cb3$var$formatShare(positiveSubtotal / totalValue)}`
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "grid grid-cols-1 gap-2.5 md:grid-cols-2 xl:grid-cols-3",
                            children: members.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($660ced10ade61cb3$var$FleetCard, {
                                    account: account,
                                    performance: performanceByAccountId.get(account._id),
                                    share: account.presentBalance > 0 && totalValue > 0 ? account.presentBalance / totalValue : null,
                                    sparkline: sparklines.get(account._id) ?? [],
                                    balanceStatus: balanceStatusOf(account._id)
                                }, account._id))
                        })
                    ]
                }, group.key);
            }),
            dormant.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border rounded-lg border border-dashed",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setDormantOpen((open)=>!open),
                        className: "text-muted-foreground flex w-full cursor-pointer items-center gap-2 p-3 text-sm",
                        children: [
                            dormantOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "size-4 shrink-0"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                className: "size-4 shrink-0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    dormant.length,
                                    " dormant account",
                                    dormant.length !== 1 && 's',
                                    " \u2014 zero balance"
                                ]
                            }),
                            dormantUnbalanced > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-warning shrink-0 text-xs",
                                children: [
                                    dormantUnbalanced,
                                    " not balanced"
                                ]
                            }),
                            !dormantOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-muted-foreground/60 ml-auto hidden truncate text-xs sm:block",
                                children: [
                                    dormant.slice(0, 4).map((account)=>account.name).join(" \xb7 "),
                                    dormant.length > 4 && ` \xb7 +${dormant.length - 4} more`
                                ]
                            })
                        ]
                    }),
                    dormantOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "border-border grid grid-cols-1 gap-1 border-t p-2 md:grid-cols-2 xl:grid-cols-3",
                        children: dormant.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                to: `/accounts/${account._id}`,
                                className: "hover:bg-accent flex items-baseline justify-between gap-2 rounded-md px-2 py-1.5 no-underline",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground truncate text-sm",
                                        children: account.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `shrink-0 text-xs ${balanceStatusOf(account._id) != null ? 'text-warning' : 'text-muted-foreground/60'}`,
                                        children: balanceStatusOf(account._id) ?? $660ced10ade61cb3$var$getSubtitle(account)
                                    })
                                ]
                            }, account._id))
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");

const $d3f517f4683cf836$export$74e9ab091048a6db = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2cf5bc16d816990b$export$79fbfa18a38c1a18), {});
};





// The investments overview only surfaces investment-type filters (the banking
// subtypes never appear here).
const $afdda9a6b5a2e0d0$var$INVESTMENT_TYPE_OPTIONS = (0, $e597f4605156a89e$export$6096865e4aa58c8a).filter((option)=>option.group === 'Investments');
const $afdda9a6b5a2e0d0$var$formatCurrency = (cents)=>{
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(cents / 100);
};
const $afdda9a6b5a2e0d0$var$formatPercent = (decimal)=>{
    if (decimal == null) return '-';
    const sign = decimal >= 0 ? '+' : '';
    return `${sign}${(decimal * 100).toFixed(2)}%`;
};
const $afdda9a6b5a2e0d0$var$gainColor = (value)=>value != null && value > 0 ? 'text-positive' : value != null && value < 0 ? 'text-red-600 dark:text-red-400' : 'text-muted-foreground';
const $afdda9a6b5a2e0d0$var$PERIOD_LABELS = {
    '1W': '1 week',
    '1M': '1 month',
    YTD: 'Year to date',
    '1Y': '1 year'
};
const $afdda9a6b5a2e0d0$var$getAccountSubtitle = (account)=>{
    // V2 accounts use plaid.institutionName for Plaid accounts
    if (account.plaid?.institutionName) return account.plaid.institutionName;
    // Manual investment account
    return 'Manual investment';
};
const $afdda9a6b5a2e0d0$var$AccountRow = ({ account: account, performance: performance, balanceStatus: balanceStatus })=>{
    const gain = performance?.totalGain;
    const xirr = performance?.xirr;
    const isPositive = gain != null && gain > 0;
    const isNegative = gain != null && gain < 0;
    // Closed rows surface in the widened search/type-filter results (and the
    // explicit Closed view), so they carry the same marks as the main
    // accounts list: dimmed identity plus a named state.
    const closed = (0, $e597f4605156a89e$export$881343af68ecca95)(account);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
        to: `/accounts/${account._id}`,
        className: "border-border bg-card hover:bg-accent flex items-center gap-3 rounded-lg border p-4 no-underline transition-colors",
        children: [
            account.logo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, $cd179cdb1a4beac3$export$2e8a6207c9cc2bb8)(account.logo),
                alt: "",
                className: `h-6 w-6 rounded ${closed ? 'opacity-50 grayscale' : ''}`
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f6f28ec3b697fb2$export$fdaddccc706daa3a), {
                account: account,
                className: `size-6 shrink-0 ${closed ? 'opacity-50 grayscale' : ''}`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-1 flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `font-medium ${closed ? 'text-muted-foreground' : 'text-foreground'}`,
                        children: account.name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground text-sm",
                        children: [
                            $afdda9a6b5a2e0d0$var$getAccountSubtitle(account),
                            closed && " \xb7 Closed"
                        ]
                    }),
                    balanceStatus != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-warning text-sm",
                        children: balanceStatus
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col items-end",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-foreground font-medium",
                        children: $afdda9a6b5a2e0d0$var$formatCurrency(account.presentBalance)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm",
                        children: [
                            gain != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: isPositive ? 'text-positive' : isNegative ? 'text-red-600 dark:text-red-400' : 'text-muted-foreground',
                                children: [
                                    isPositive ? '+' : '',
                                    $afdda9a6b5a2e0d0$var$formatCurrency(gain)
                                ]
                            }),
                            xirr != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: xirr > 0 ? 'text-positive' : xirr < 0 ? 'text-red-600 dark:text-red-400' : 'text-muted-foreground',
                                children: [
                                    $afdda9a6b5a2e0d0$var$formatPercent(xirr),
                                    " XIRR"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $afdda9a6b5a2e0d0$export$f0abba7b2e9ab0ae = ()=>{
    const [searchParams, setSearchParams] = (0, $0c90f43fc3673aef$export$f1a78c17382fe22a)();
    const typeFilter = (0, $e597f4605156a89e$export$2fd2effeb17443f1)(searchParams.get('type'));
    // Search lives in the URL like the status/type filters, so it survives
    // navigation (opening an account and hitting back keeps the search).
    const search = searchParams.get('search') ?? '';
    // Contextual status default, matching the accounts overview: browsing
    // defaults to 'active', but narrowing by name or type widens to 'all' so
    // a searched-for closed account can't be hidden by a filter nobody set.
    // An explicit pick always wins.
    const explicitFilter = (0, $e597f4605156a89e$export$49a87e04cfe7c710)(searchParams.get('filter'));
    const defaultFilter = search.length > 0 || typeFilter.length > 0 ? 'all' : 'active';
    const filter = explicitFilter ?? defaultFilter;
    const { data: data, loading: loading, refetch: refetch } = (0, $ce9d9e524be20f53$export$34fd8d1d279e4cb6)();
    // Quiet when an account's checks balance; otherwise the last day they did.
    const { data: gapsData, error: gapsError, refetch: refetchGaps } = (0, $ce9d9e524be20f53$export$2d57afd40a6482f)({
        fetchPolicy: 'cache-and-network'
    });
    const { data: accountPerformanceData, refetch: refetchAccountPerformance } = (0, $ce9d9e524be20f53$export$a771ba3c52d2e375)();
    const { data: performanceData } = (0, $ce9d9e524be20f53$export$ab46317acd8c7e9f)();
    // The resolver's default path is present-observation aware (per-account
    // windows), matching the today-clamped total beside it.
    const { data: xirrData } = (0, $ce9d9e524be20f53$export$d26ea4fc663d858b)();
    const { createAccountModal: createAccountModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const setFilter = (newFilter)=>{
        const next = new URLSearchParams(searchParams);
        // The param is only present for a non-default pick; the default is
        // contextual, so an explicit Active during a search must be kept.
        if (newFilter === defaultFilter) next.delete('filter');
        else next.set('filter', newFilter);
        setSearchParams(next);
    };
    const setTypeFilter = (newTypeFilter)=>{
        const next = new URLSearchParams(searchParams);
        const serialized = (0, $e597f4605156a89e$export$e04f9e18b7296b99)(newTypeFilter);
        if (serialized == null) next.delete('type');
        else next.set('type', serialized);
        setSearchParams(next);
    };
    const setSearch = (value)=>{
        const next = new URLSearchParams(searchParams);
        if (value === '') next.delete('search');
        else next.set('search', value);
        // replace: the search box updates per keystroke, so pushing would bury the
        // previous page under one history entry per character typed.
        setSearchParams(next, {
            replace: true
        });
    };
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading investment accounts..."
        })
    });
    const rawAccounts = data?.allInvestmentAccounts ?? [];
    // Cross-counts, GitHub-PR-list style: each dropdown's counts respect the
    // OTHER filter (with type=IRA selected, "Closed 2" means 2 closed IRAs).
    const typeMatchedAccounts = rawAccounts.filter((account)=>(0, $e597f4605156a89e$export$86f6532dce6b4d32)(typeFilter, account));
    const statusMatchedAccounts = rawAccounts.filter((account)=>(0, $e597f4605156a89e$export$175da04470876f6a)(filter, account));
    const visibleAccounts = typeMatchedAccounts.filter((account)=>(0, $e597f4605156a89e$export$175da04470876f6a)(filter, account));
    const activeCount = typeMatchedAccounts.filter((a)=>!(0, $e597f4605156a89e$export$881343af68ecca95)(a)).length;
    const statusOptions = [
        {
            key: 'active',
            label: 'Active',
            count: activeCount
        },
        {
            key: 'closed',
            label: 'Closed',
            count: typeMatchedAccounts.length - activeCount
        }
    ];
    // Only types with at least one account are offered (plus current
    // selections, so they can always be cleared)
    const typeOptions = $afdda9a6b5a2e0d0$var$INVESTMENT_TYPE_OPTIONS.map((option)=>({
            key: option.key,
            label: option.label,
            count: statusMatchedAccounts.filter(option.matches).length,
            present: rawAccounts.some(option.matches)
        })).filter((option)=>option.present || typeFilter.includes(option.key));
    const accounts = visibleAccounts.filter((account)=>(account.name || '').toLowerCase().includes(search.toLowerCase())).sort((a, b)=>b.presentBalance - a.presentBalance);
    // The portfolio summary and history describe the whole portfolio, so hide
    // them while a status/type filter is slicing the list — a pooled XIRR next
    // to a filtered subset would misread.
    const isFiltering = filter !== 'active' || typeFilter.length > 0;
    // Only gate the summary on there being active accounts; the numbers below
    // themselves cover the whole portfolio (see totals).
    const activeAccounts = rawAccounts.filter((account)=>!(0, $e597f4605156a89e$export$881343af68ecca95)(account));
    // Per-account performance arrives after the account list; until then rows
    // and totals show balances only and the gain/XIRR figures stream in.
    const performanceByAccountId = new Map((accountPerformanceData?.allInvestmentAccounts ?? []).map((a)=>[
            a._id,
            a.performance
        ]));
    const performanceLoaded = accountPerformanceData != null;
    // Unknown when the gaps didn't load (or failed to refresh): no account
    // reads as balanced, or as still unbalanced, on old or missing data.
    const balancedThrough = (0, $50bf07908bf4ee59$export$2b0ba5d06e095a5c)(gapsData?.investmentGaps ?? []);
    const balanceStatusOf = (accountId)=>gapsError == null && balancedThrough.has(accountId) ? (0, $50bf07908bf4ee59$export$3343c40eb4b2ade7)(balancedThrough.get(accountId) ?? null) : undefined;
    // Totals cover the whole portfolio (every investment account, including
    // closed ones) so they stay consistent with portfolioXirr, the period
    // summary, and the chart — all of which aggregate server-side over all
    // accounts. Closed accounts are wound down to a zero balance, so they add
    // nothing to totalValue; their historical cost basis still counts toward
    // totalGain, matching the pooled XIRR. XIRR is the money-weighted return
    // across all cash flows — not gain / net contributions, which is
    // meaningless once any account has withdrawn more than it deposited.
    // Present (today-clamped) values, so the header can't disagree with the
    // fleet cards when a future-dated anchor exists.
    const totalValue = rawAccounts.reduce((sum, a)=>sum + a.presentBalance, 0);
    const totalCostBasis = rawAccounts.reduce((sum, a)=>sum + (performanceByAccountId.get(a._id)?.costBasis ?? 0), 0);
    const totalGain = totalValue - totalCostBasis;
    const portfolioXirr = xirrData?.portfolioXIRR.rate ?? null;
    const periods = performanceData?.portfolioPerformanceSummary ?? [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-1 flex-col overflow-y-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4 p-4",
            children: [
                rawAccounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                            label: "Status",
                            allLabel: "All",
                            allCount: typeMatchedAccounts.length,
                            value: filter,
                            onChange: (key)=>setFilter((0, $e597f4605156a89e$export$fabe442d1eda117c)(key)),
                            options: statusOptions
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                            label: "Type",
                            allLabel: "All types",
                            allCount: statusMatchedAccounts.length,
                            multiple: true,
                            value: typeFilter,
                            onChange: setTypeFilter,
                            options: typeOptions
                        })
                    ]
                }),
                !isFiltering && activeAccounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "border-border bg-card rounded-lg border p-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-muted-foreground mb-1 text-sm",
                            children: "Total portfolio value"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-foreground text-2xl font-semibold",
                            children: $afdda9a6b5a2e0d0$var$formatCurrency(totalValue)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex gap-2 text-sm",
                            children: [
                                performanceLoaded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: $afdda9a6b5a2e0d0$var$gainColor(totalGain),
                                    children: [
                                        totalGain > 0 ? '+' : '',
                                        $afdda9a6b5a2e0d0$var$formatCurrency(totalGain),
                                        " total gain"
                                    ]
                                }),
                                portfolioXirr != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: $afdda9a6b5a2e0d0$var$gainColor(portfolioXirr),
                                    children: [
                                        $afdda9a6b5a2e0d0$var$formatPercent(portfolioXirr),
                                        " XIRR"
                                    ]
                                })
                            ]
                        }),
                        periods.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "border-border mt-4 grid grid-cols-2 gap-3 border-t pt-4 sm:grid-cols-4",
                            children: periods.map((period)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-muted-foreground text-xs",
                                            children: $afdda9a6b5a2e0d0$var$PERIOD_LABELS[period.key] ?? period.key
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `font-medium ${$afdda9a6b5a2e0d0$var$gainColor(period.gainChange)}`,
                                            children: period.returnPercent != null ? $afdda9a6b5a2e0d0$var$formatPercent(period.returnPercent) : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `text-xs ${$afdda9a6b5a2e0d0$var$gainColor(period.gainChange)}`,
                                            children: period.gainChange == null ? "\u2014" : `${period.gainChange > 0 ? '+' : ''}${$afdda9a6b5a2e0d0$var$formatCurrency(period.gainChange)}`
                                        })
                                    ]
                                }, period.key))
                        })
                    ]
                }),
                !isFiltering && activeAccounts.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3f517f4683cf836$export$74e9ab091048a6db), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative flex-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                    className: "text-muted-foreground absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    placeholder: "Search accounts...",
                                    value: search,
                                    onChange: (e)=>setSearch(e.target.value),
                                    className: "border-border bg-background placeholder:text-muted-foreground focus:ring-primary w-full rounded-md border py-2 pr-3 pl-9 text-sm focus:ring-2 focus:outline-none"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            onClick: ()=>createAccountModal.openModal({
                                    role: 'investment',
                                    onCreate: ()=>{
                                        refetch();
                                        refetchAccountPerformance();
                                    }
                                }),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                    className: "mr-1 h-4 w-4"
                                }),
                                "Create"
                            ]
                        })
                    ]
                }),
                gapsError != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    role: "alert",
                    className: "bg-destructive/10 text-destructive flex items-center justify-between gap-3 rounded-lg px-3 py-2 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Couldn't check balances."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "underline",
                            onClick: ()=>void refetchGaps().catch(()=>undefined),
                            children: "Retry"
                        })
                    ]
                }),
                rawAccounts.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "border-border rounded-lg border border-dashed p-8 text-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground mb-4",
                            children: "No investment accounts connected"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground mb-4 text-sm",
                            children: "Connect an investment account through Plaid to track your portfolio performance."
                        })
                    ]
                }) : !isFiltering && search.length === 0 && activeAccounts.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660ced10ade61cb3$export$fea5dbc17d8cf2dc), {
                    accounts: activeAccounts,
                    performanceByAccountId: performanceByAccountId,
                    balanceStatusOf: balanceStatusOf
                }) : accounts.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-muted-foreground py-8 text-center text-sm",
                    children: search.length > 0 ? `No accounts matching "${search}"` : typeFilter.length === 0 ? `No ${filter} accounts` : 'No matching accounts'
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-col gap-2",
                    children: accounts.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($afdda9a6b5a2e0d0$var$AccountRow, {
                            account: account,
                            performance: performanceByAccountId.get(account._id),
                            balanceStatus: balanceStatusOf(account._id)
                        }, account._id))
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");


const $15cd282b652e0b04$var$sum = (values)=>values.reduce((total, value)=>total + value, 0);
const $15cd282b652e0b04$var$sumOf = (holdings, pick)=>{
    const unknown = holdings.filter((holding)=>pick(holding) == null);
    return {
        cents: $15cd282b652e0b04$var$sum(holdings.map((holding)=>pick(holding) ?? 0)),
        known: holdings.length - unknown.length,
        complete: unknown.length === 0,
        floor: unknown.every((holding)=>holding.quantity >= 0)
    };
};
const $15cd282b652e0b04$var$allKnown = (values)=>values.some((value)=>value == null) ? null : $15cd282b652e0b04$var$sum(values.map((value)=>value ?? 0));
const $15cd282b652e0b04$export$a13a7f98c3a6ebed = (key, name, holdings)=>{
    const [first] = holdings;
    const cash = holdings.every((holding)=>holding.cash);
    const oneSecurity = !cash;
    // A quote only when every holding has one and they agree.
    const quoted = holdings.every((holding)=>holding.price != null);
    const quotes = new Set(holdings.map((holding)=>Number(holding.price)));
    return {
        key: key,
        name: name,
        ticker: oneSecurity ? holdings.find((holding)=>holding.security.ticker != null)?.security.ticker ?? null : null,
        currency: first.currency,
        asOf: holdings.flatMap((holding)=>[
                holding.asOf,
                holding.priceDate ?? holding.asOf
            ]).sort()[0],
        quantity: oneSecurity && !cash ? $15cd282b652e0b04$var$sum(holdings.map((holding)=>holding.quantity)) : null,
        price: oneSecurity && !cash && quoted && quotes.size === 1 ? holdings.find((holding)=>holding.price != null)?.price ?? null : null,
        value: $15cd282b652e0b04$var$sumOf(holdings, (holding)=>holding.value),
        costBasis: cash ? null : $15cd282b652e0b04$var$allKnown(holdings.map((holding)=>holding.costBasis)),
        unrealized: cash ? null : $15cd282b652e0b04$var$allKnown(holdings.map((holding)=>holding.unrealized)),
        cash: cash,
        holdings: holdings
    };
};
const $15cd282b652e0b04$var$byValue = (a, b)=>b.value.cents - a.value.cents;
const $15cd282b652e0b04$export$36baf1badfa94867 = (holding)=>holding.accountId ?? holding.issuerId ?? '';
/** A security's stable identifiers: its identity key, CUSIP and ISIN. */ const $15cd282b652e0b04$var$identifiersOf = ({ security: security })=>[
        security.identityKey,
        ...security.cusip != null ? [
            `cusip:${security.cusip}`
        ] : [],
        ...security.isin != null ? [
            `isin:${security.isin}`
        ] : []
    ];
const $15cd282b652e0b04$export$f15d9fecc8ba66e9 = (holdings)=>{
    const parent = new Map();
    const find = (key)=>{
        const up = parent.get(key) ?? key;
        if (up === key) return key;
        const root = find(up);
        parent.set(key, root);
        return root;
    };
    for (const holding of holdings){
        const [first, ...rest] = $15cd282b652e0b04$var$identifiersOf(holding);
        for (const key of rest)parent.set(find(key), find(first));
    }
    return (holding)=>find(holding.security.identityKey);
};
const $15cd282b652e0b04$export$9f3aed1f55384dec = (holdings, // Identity over a larger set, when these are part of one: a bridge
// between two records may be a holding outside this subset.
assetOf = $15cd282b652e0b04$export$f15d9fecc8ba66e9(holdings))=>{
    const groups = new Map();
    for (const holding of holdings){
        const key = `${holding.cash ? 'cash' : assetOf(holding)} ${holding.currency}`;
        groups.set(key, [
            ...groups.get(key) ?? [],
            holding
        ]);
    }
    const rows = [
        ...groups.entries()
    ].map(([key, members])=>$15cd282b652e0b04$export$a13a7f98c3a6ebed(key, members[0].cash ? 'Cash' : members[0].security.name, members));
    return [
        ...rows.filter((row)=>!row.cash).sort($15cd282b652e0b04$var$byValue),
        ...rows.filter((row)=>row.cash).sort($15cd282b652e0b04$var$byValue)
    ];
};
const $15cd282b652e0b04$export$e039b1e1c3818c70 = (holdings)=>{
    const byCurrency = new Map();
    for (const holding of holdings)byCurrency.set(holding.currency, [
        ...byCurrency.get(holding.currency) ?? [],
        holding
    ]);
    return [
        ...byCurrency.entries()
    ].map(([currency, members])=>{
        const invested = members.filter((holding)=>!holding.cash);
        return {
            currency: currency,
            value: $15cd282b652e0b04$var$sumOf(members, (holding)=>holding.value),
            costBasis: $15cd282b652e0b04$var$sumOf(invested, (holding)=>holding.costBasis),
            unrealized: $15cd282b652e0b04$var$sumOf(invested, (holding)=>holding.unrealized)
        };
    }).sort((a, b)=>Number(b.currency === 'USD') - Number(a.currency === 'USD') || b.value.cents - a.value.cents);
};
const $15cd282b652e0b04$export$e655cfb73449ec4e = (holdings, accountName, // As for rowsBySecurity: identity over a larger set these are part of.
assetOf = $15cd282b652e0b04$export$f15d9fecc8ba66e9(holdings))=>{
    const groups = new Map();
    for (const holding of holdings){
        const key = $15cd282b652e0b04$export$36baf1badfa94867(holding);
        groups.set(key, [
            ...groups.get(key) ?? [],
            holding
        ]);
    }
    return [
        ...groups.entries()
    ].map(([key, members])=>({
            key: key,
            name: accountName(members[0]),
            totals: $15cd282b652e0b04$export$e039b1e1c3818c70(members),
            rows: $15cd282b652e0b04$export$9f3aed1f55384dec(members, assetOf)
        })).sort((a, b)=>(b.totals[0]?.value.cents ?? 0) - (a.totals[0]?.value.cents ?? 0));
};
const $15cd282b652e0b04$export$b6404f271f60629e = (row)=>row.unrealized != null && row.costBasis != null && row.costBasis > 0 ? row.unrealized / row.costBasis : null;
const $15cd282b652e0b04$export$bc58d7f8cf8938c3 = (rows, sort)=>{
    const descending = (pick)=>(a, b)=>{
            const [x, y] = [
                pick(a),
                pick(b)
            ];
            if (x == null || y == null) return Number(x == null) - Number(y == null) || $15cd282b652e0b04$var$byValue(a, b);
            return y - x || $15cd282b652e0b04$var$byValue(a, b);
        };
    const compare = sort === 'name' ? (a, b)=>a.name.localeCompare(b.name) || $15cd282b652e0b04$var$byValue(a, b) : sort === 'unrealized' ? descending((row)=>row.unrealized) : sort === 'return' ? descending($15cd282b652e0b04$export$b6404f271f60629e) : $15cd282b652e0b04$var$byValue;
    return [
        ...rows.filter((row)=>!row.cash).sort(compare),
        ...rows.filter((row)=>row.cash).sort($15cd282b652e0b04$var$byValue)
    ];
};
const $15cd282b652e0b04$export$18022b46b6e28aba = (holdings, filter, accountName, assetOf = $15cd282b652e0b04$export$f15d9fecc8ba66e9(holdings))=>{
    const query = filter.search.trim().toLowerCase();
    const inAccounts = holdings.filter((holding)=>filter.accounts.length === 0 || filter.accounts.includes($15cd282b652e0b04$export$36baf1badfa94867(holding)));
    if (query === '') return inAccounts;
    const matches = (text)=>text != null && text.toLowerCase().includes(query);
    const assets = new Set(inAccounts.filter((holding)=>matches(holding.security.name) || matches(holding.security.ticker)).map(assetOf));
    return inAccounts.filter((holding)=>assets.has(assetOf(holding)) || matches(accountName(holding)));
};
const $15cd282b652e0b04$export$92aae25ec06ba9a8 = [
    {
        key: 'taxable',
        label: 'Taxable'
    },
    {
        key: 'tax_deferred',
        label: 'Tax-deferred'
    },
    {
        key: 'tax_free',
        label: 'Tax-free'
    },
    {
        key: 'unknown',
        label: 'Unknown'
    }
];
const $15cd282b652e0b04$export$d3a00c0998457253 = (holdings)=>$15cd282b652e0b04$export$92aae25ec06ba9a8.flatMap(({ key: key, label: label })=>$15cd282b652e0b04$export$e039b1e1c3818c70(holdings.filter((holding)=>(holding.taxTreatment ?? 'unknown') === key)).map((total)=>({
                ...total,
                treatment: key,
                label: label
            })));






var $acw62 = parcelRequire("acw62");

const $d3a3f2d83b280457$export$b038e237dc823aed = ({ label: label, options: options, value: value, onChange: onChange })=>{
    const container = $acw62.useRef(null);
    const active = $acw62.useRef(null);
    // Keep the chosen option in view when the control scrolls — sideways
    // only, so it never moves the page.
    $acw62.useEffect(()=>{
        const box = container.current;
        const button = active.current;
        if (!box || !button) return;
        if (button.offsetLeft < box.scrollLeft) box.scrollLeft = button.offsetLeft;
        else if (button.offsetLeft + button.offsetWidth > box.scrollLeft + box.clientWidth) box.scrollLeft = button.offsetLeft + button.offsetWidth - box.clientWidth;
    }, [
        value
    ]);
    return(// Scrolls within itself rather than the page on a screen too narrow for
    // every option.
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: container,
        role: "radiogroup",
        "aria-label": label,
        className: "border-border relative inline-flex max-w-full overflow-x-auto rounded-lg border [scrollbar-width:none]",
        children: options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                ref: option.key === value ? active : undefined,
                type: "button",
                role: "radio",
                "aria-checked": option.key === value,
                onClick: ()=>onChange(option.key),
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('shrink-0 px-2.5 py-1 text-xs transition', option.key === value ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted'),
                children: option.label
            }, option.key))
    }));
};


const $faa3abd542deeac0$var$VIEWS = [
    {
        key: 'security',
        label: 'By security'
    },
    {
        key: 'account',
        label: 'By account'
    }
];
// Value is the default (the dropdown's "all"); the rest as options.
const $faa3abd542deeac0$var$SORTS = [
    {
        key: 'unrealized',
        label: 'Unrealized'
    },
    {
        key: 'return',
        label: 'Return'
    },
    {
        key: 'name',
        label: 'Name'
    }
];
/**
 * A sum of amounts: "—" when none is known; "≥" when only some are and the
 * rest can only add (see `partialClass` for when they could go either way).
 */ const $faa3abd542deeac0$var$formatSum = (value, currency)=>value.known === 0 ? "\u2014" : `${value.complete || !value.floor ? '' : "\u2265 "}${(0, $468f7c854dda6e96$export$a17b3c2052469c69)(value.cents, currency)}`;
/** A partial sum that isn't a floor goes uncolored: it could be over or under. */ const $faa3abd542deeac0$var$partialClass = (value)=>!value.complete && !value.floor ? 'text-muted-foreground' : null;
const $faa3abd542deeac0$var$formatPrice = (price, currency)=>{
    const amount = Number(price).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4
    });
    return currency === 'USD' ? `$${amount}` : `${amount} ${currency}`;
};
/** Holdings last observed this long ago say when. */ const $faa3abd542deeac0$var$STALE_DAYS = 14;
/** A share as a percent, one decimal (two under 1%). */ const $faa3abd542deeac0$var$formatShare = (ratio)=>`${(ratio * 100).toLocaleString('en-US', {
        maximumFractionDigits: Math.abs(ratio) < 0.01 ? 2 : 1,
        minimumFractionDigits: 1
    })}%`;
/** A return as a signed percent. */ const $faa3abd542deeac0$var$formatReturn = (ratio)=>`${ratio < 0 ? "\u2212" : '+'}${$faa3abd542deeac0$var$formatShare(Math.abs(ratio))}`;
// Every row is one grid with the same fixed column widths, so figures line
// up down the table. Columns appear as the card (a container) widens:
// value and unrealized always, basis next, then quantity and price.
const $faa3abd542deeac0$var$GRID = 'grid grid-cols-[minmax(0,1fr)_5.75rem_5.75rem] items-center gap-x-3 @md:gap-x-4 @md:grid-cols-[minmax(0,1fr)_6.5rem_6.5rem] @2xl:grid-cols-[minmax(0,1fr)_6.5rem_6.5rem_6.5rem] @4xl:grid-cols-[minmax(0,1fr)_6rem_6rem_6.5rem_6.5rem_6.5rem]';
const $faa3abd542deeac0$var$WIDE = 'hidden text-right @4xl:block';
const $faa3abd542deeac0$var$MEDIUM = 'hidden text-right @2xl:block';
const $faa3abd542deeac0$var$HeaderRow = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($faa3abd542deeac0$var$GRID, 'text-muted-foreground border-border border-b px-3 pb-2 text-xs'),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: "Security"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: $faa3abd542deeac0$var$WIDE,
                children: "Quantity"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: $faa3abd542deeac0$var$WIDE,
                children: "Price"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-right",
                children: "Value"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: $faa3abd542deeac0$var$MEDIUM,
                children: "Cost basis"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-right",
                children: "Unrealized"
            })
        ]
    });
/**
 * Stored securities the cash setting is offered for: ones a broker types
 * "other" or flags as cash-equivalent (where cash hides), and any already
 * set, to undo it. Never one that is cash by type.
 */ const $faa3abd542deeac0$var$settableOf = (holdings)=>[
        ...new Map(holdings.filter(({ security: security })=>security.source === 'plaid' && security.securityType !== 'cash' && (security.treatAsCash || security.isCash || security.securityType === 'other')).map(({ security: security })=>[
                security._id,
                security
            ])).values()
    ];
/** The cash setting, for the given holdings' settable securities. */ const $faa3abd542deeac0$var$CashToggle = ({ holdings: holdings })=>{
    // The Gains table refreshes itself on mount (cache-and-network).
    const [setTreatAsCash, { loading: loading }] = (0, $ce9d9e524be20f53$export$76f5b6594ca7408b)({
        refetchQueries: [
            'InvestmentHoldings'
        ]
    });
    const securities = $faa3abd542deeac0$var$settableOf(holdings);
    if (securities.length === 0) return null;
    const treated = securities.every((security)=>security.treatAsCash);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
        variant: "ghost",
        className: "gap-1.5",
        disabled: loading,
        onClick: ()=>{
            for (const security of securities)setTreatAsCash({
                variables: {
                    securityId: security._id,
                    treatAsCash: !treated
                }
            });
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ec88f95add56de8$export$2e2bcd8739ae039), {
                className: "size-3.5"
            }),
            treated ? "Don't count as cash" : 'Count as cash'
        ]
    });
};
/**
 * A row's figures. Value carries its share of the portfolio (in its
 * currency) beneath; unrealized, its return on cost.
 */ const $faa3abd542deeac0$var$Cells = ({ row: row, total: total, muted: muted = false })=>{
    const ratio = (0, $15cd282b652e0b04$export$b6404f271f60629e)(row);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($faa3abd542deeac0$var$WIDE, 'tabular-nums'),
                children: row.quantity != null ? (0, $468f7c854dda6e96$export$dd9196c8186add55)(row.quantity) : ''
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($faa3abd542deeac0$var$WIDE, 'tabular-nums'),
                children: row.price != null ? $faa3abd542deeac0$var$formatPrice(row.price, row.currency) : ''
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "flex flex-col items-end tabular-nums",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)(muted && 'text-muted-foreground', $faa3abd542deeac0$var$partialClass(row.value)),
                        children: $faa3abd542deeac0$var$formatSum(row.value, row.currency)
                    }),
                    row.value.known > 0 && total > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-xs",
                        children: $faa3abd542deeac0$var$formatShare(row.value.cents / total)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($faa3abd542deeac0$var$MEDIUM, 'tabular-nums'),
                children: row.cash ? '' : row.costBasis != null ? (0, $468f7c854dda6e96$export$a17b3c2052469c69)(row.costBasis, row.currency) : "\u2014"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex flex-col items-end', (0, $468f7c854dda6e96$export$dd5b97695b6c46d8)(row.unrealized)),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: row.cash ? '' : row.unrealized != null ? (0, $468f7c854dda6e96$export$ff137379e7518313)(row.unrealized, row.currency) : "\u2014"
                    }),
                    ratio != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-xs",
                        children: $faa3abd542deeac0$var$formatReturn(ratio)
                    })
                ]
            })
        ]
    });
};
/**
 * Everything about a row, for when the table is too narrow to show it:
 * its full name (or names: a cash holding's fund and account) first.
 */ const $faa3abd542deeac0$var$Details = ({ row: row, total: total, heading: heading = [
    row.name
] })=>{
    const ratio = (0, $15cd282b652e0b04$export$b6404f271f60629e)(row);
    // The oldest quote the row's value rests on.
    const priceDate = row.holdings.flatMap((holding)=>holding.priceDate != null ? [
            holding.priceDate
        ] : []).sort()[0] ?? null;
    const items = [
        ...row.quantity != null ? [
            [
                'Quantity',
                (0, $468f7c854dda6e96$export$dd9196c8186add55)(row.quantity)
            ]
        ] : [],
        ...row.price != null ? [
            [
                'Price',
                `${$faa3abd542deeac0$var$formatPrice(row.price, row.currency)}${priceDate ? ` \xb7 ${priceDate}` : ''}`
            ]
        ] : [],
        [
            'Value',
            $faa3abd542deeac0$var$formatSum(row.value, row.currency)
        ],
        ...row.cash ? [] : [
            [
                'Cost basis',
                row.costBasis != null ? (0, $468f7c854dda6e96$export$a17b3c2052469c69)(row.costBasis, row.currency) : "\u2014"
            ]
        ],
        ...row.cash ? [] : [
            [
                'Unrealized',
                row.unrealized != null ? `${(0, $468f7c854dda6e96$export$ff137379e7518313)(row.unrealized, row.currency)}${ratio != null ? ` \xb7 ${$faa3abd542deeac0$var$formatReturn(ratio)}` : ''}` : "\u2014"
            ]
        ],
        ...total > 0 && row.value.known > 0 ? [
            [
                'Share',
                $faa3abd542deeac0$var$formatShare(row.value.cents / total)
            ]
        ] : []
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2 px-3 py-2 pl-8 text-xs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground flex flex-col",
                children: heading.map((line)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "break-words",
                        children: line
                    }, line))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                className: "grid grid-cols-[auto_minmax(0,1fr)] gap-x-4 gap-y-1 @md:grid-cols-[auto_minmax(0,1fr)_auto_minmax(0,1fr)]",
                children: items.map(([label, value])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                className: "text-muted-foreground",
                                children: label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                className: "tabular-nums",
                                children: value
                            })
                        ]
                    }, label))
            })
        ]
    });
};
const $faa3abd542deeac0$var$SecurityRow = ({ row: row, total: total, accountName: accountName })=>{
    const [open, setOpen] = $acw62.useState(false);
    const accounts = $faa3abd542deeac0$var$rowsByAccountOf(row, accountName);
    // An investment's row offers the setting for the asset; cash's offers
    // undoing it per security, beside each (see the sub-rows).
    const settable = row.cash ? [] : row.holdings;
    const stale = (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)().diff((0, $0c0f91b069db95d9$export$6b862160d295c8e)(row.asOf), 'days').days > $faa3abd542deeac0$var$STALE_DAYS;
    const name = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "flex min-w-0 flex-col text-left",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "line-clamp-2 font-medium break-words",
                children: row.name
            }),
            (row.ticker != null || stale) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground text-xs",
                children: [
                    row.ticker,
                    stale ? `as of ${row.asOf}` : null
                ].filter((part)=>part != null).map((part, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                        children: [
                            index > 0 && " \xb7 ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "whitespace-nowrap",
                                children: part
                            })
                        ]
                    }, part))
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border border-b last:border-b-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                "aria-expanded": open,
                onClick: ()=>setOpen((state)=>!state),
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($faa3abd542deeac0$var$GRID, 'w-full px-3 py-2.5 text-left text-sm'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex min-w-0 items-center gap-1.5",
                        children: [
                            open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-4 shrink-0"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-4 shrink-0"
                            }),
                            name
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$Cells, {
                        row: row,
                        total: total
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-muted/40 pb-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$Details, {
                        row: row,
                        total: total
                    }),
                    (accounts.length > 1 || row.cash) && accounts.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$SubRow, {
                            ...account,
                            total: total
                        }, account.row.key)),
                    $faa3abd542deeac0$var$settableOf(settable).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "px-3 pt-1 pl-7",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$CashToggle, {
                            holdings: settable
                        })
                    })
                ]
            })
        ]
    });
};
/**
 * A security row's holdings, one sub-row per account (an account's several
 * records of the asset summed); for cash, one per account and security.
 */ const $faa3abd542deeac0$var$rowsByAccountOf = (row, accountName)=>{
    const groups = new Map();
    for (const holding of row.holdings){
        const account = (0, $15cd282b652e0b04$export$36baf1badfa94867)(holding);
        const key = row.cash ? `${account} ${holding.securityId}` : account;
        groups.set(key, [
            ...groups.get(key) ?? [],
            holding
        ]);
    }
    // Built from the row's own members, which are already one asset.
    return [
        ...groups.entries()
    ].map(([key, members])=>{
        const label = row.cash ? members[0].security.name : accountName(members[0]);
        return {
            row: (0, $15cd282b652e0b04$export$a13a7f98c3a6ebed)(key, label, members),
            label: label,
            detail: row.cash ? accountName(members[0]) : null
        };
    }).sort((a, b)=>b.row.value.cents - a.row.value.cents);
};
/**
 * One account's part of a row (or, under cash, one fund in one account),
 * itself expandable: on a narrow screen its names and figures are cut
 * short, so it opens to all of them, and for cash, to its cash setting.
 */ const $faa3abd542deeac0$var$SubRow = ({ row: row, label: label, detail: detail, total: total })=>{
    const [open, setOpen] = $acw62.useState(false);
    // Cash offers undoing the setting, per security.
    const settable = row.cash ? row.holdings.filter((holding)=>holding.security.treatAsCash) : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                "aria-expanded": open,
                onClick: ()=>setOpen((state)=>!state),
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($faa3abd542deeac0$var$GRID, 'w-full px-3 py-1.5 text-left text-xs'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex min-w-0 items-center gap-1.5 pl-5",
                        children: [
                            open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-3.5 shrink-0"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-3.5 shrink-0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex min-w-0 flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground line-clamp-2 break-words",
                                        children: label
                                    }),
                                    detail != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground/70 line-clamp-2 break-words",
                                        children: detail
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$Cells, {
                        row: row,
                        total: total,
                        muted: true
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pl-5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$Details, {
                        row: row,
                        total: total,
                        heading: detail != null ? [
                            label,
                            detail
                        ] : [
                            label
                        ]
                    }),
                    $faa3abd542deeac0$var$settableOf(settable).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "px-3 pb-1 pl-7",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$CashToggle, {
                            holdings: settable
                        })
                    })
                ]
            })
        ]
    });
};
/**
 * The totals by tax treatment: taxable gains apart from sheltered ones
 * (tax-deferred, tax-free). Only when there's more than one to tell apart.
 */ const $faa3abd542deeac0$var$TreatmentBreakdown = ({ holdings: holdings })=>{
    const rows = (0, $15cd282b652e0b04$export$d3a00c0998457253)(holdings);
    if (new Set(rows.map((row)=>row.treatment)).size < 2) return null;
    const currencies = new Set(rows.map((row)=>row.currency)).size;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        "aria-label": "By tax treatment",
        className: "@container",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "grid max-w-xl grid-cols-[minmax(0,1fr)_auto_auto] gap-x-6 gap-y-1 text-sm @md:grid-cols-[minmax(0,1fr)_auto_auto_auto]",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground text-xs",
                    children: "Tax treatment"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground text-right text-xs",
                    children: "Value"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground hidden text-right text-xs @md:block",
                    children: "Cost basis"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground text-right text-xs",
                    children: "Unrealized"
                }),
                rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "truncate",
                                children: currencies > 1 ? `${row.label} \xb7 ${row.currency}` : row.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-right tabular-nums', $faa3abd542deeac0$var$partialClass(row.value)),
                                children: $faa3abd542deeac0$var$formatSum(row.value, row.currency)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('hidden text-right tabular-nums @md:block', $faa3abd542deeac0$var$partialClass(row.costBasis)),
                                children: $faa3abd542deeac0$var$formatSum(row.costBasis, row.currency)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-right tabular-nums', row.unrealized.complete ? (0, $468f7c854dda6e96$export$dd5b97695b6c46d8)(row.unrealized.cents) : 'text-muted-foreground'),
                                children: row.unrealized.known === 0 ? "\u2014" : (0, $468f7c854dda6e96$export$ff137379e7518313)(row.unrealized.cents, row.currency)
                            })
                        ]
                    }, `${row.treatment} ${row.currency}`))
            ]
        })
    });
};
const $faa3abd542deeac0$export$2ac952587dee9ad4 = ()=>{
    const [view, setView] = $acw62.useState('security');
    const [sort, setSort] = $acw62.useState('value');
    const [accounts, setAccounts] = $acw62.useState([]);
    const [search, setSearch] = $acw62.useState('');
    // Derived from everything a sync or a setting can change, so it always
    // refreshes on mount, showing the cached figures meanwhile.
    const { data: data, loading: loading, error: error } = (0, $ce9d9e524be20f53$export$ead319b6397ec50e)({
        fetchPolicy: 'cache-and-network'
    });
    const { data: accountsData } = (0, $ce9d9e524be20f53$export$34fd8d1d279e4cb6)();
    const accountNames = $acw62.useMemo(()=>new Map((accountsData?.allInvestmentAccounts ?? []).map((account)=>[
                account._id,
                account.name
            ])), [
        accountsData
    ]);
    const accountName = $acw62.useCallback((holding)=>holding.accountId != null ? accountNames.get(holding.accountId) ?? 'Account' : holding.security.name.replace(/ options$/, ''), [
        accountNames
    ]);
    if (loading && data == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading holdings..."
        })
    });
    if (data == null && error != null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground p-8 text-center text-sm",
        children: "Couldn't load holdings."
    });
    const holdings = data?.investmentHoldings ?? [];
    if (holdings.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground p-8 text-center text-sm",
        children: "No holdings."
    });
    // The totals are of what's shown; a row's share is of the whole portfolio.
    // Which asset a holding is, from every holding: two records of one asset
    // may join only through a third the filter leaves out.
    const assetOf = (0, $15cd282b652e0b04$export$f15d9fecc8ba66e9)(holdings);
    const shown = (0, $15cd282b652e0b04$export$18022b46b6e28aba)(holdings, {
        accounts: accounts,
        search: search
    }, accountName, assetOf);
    const totals = (0, $15cd282b652e0b04$export$e039b1e1c3818c70)(shown);
    const portfolio = (0, $15cd282b652e0b04$export$e039b1e1c3818c70)(holdings);
    // A share needs the whole: with any holding unvalued, every known one's
    // would be overstated, so none is shown.
    const totalOf = (currency)=>{
        const value = portfolio.find((total)=>total.currency === currency)?.value;
        return value?.complete ? value.cents : 0;
    };
    const accountOptions = [
        ...new Map(holdings.map((holding)=>[
                (0, $15cd282b652e0b04$export$36baf1badfa94867)(holding),
                accountName(holding)
            ])).entries()
    ].map(([key, label])=>({
            key: key,
            label: label,
            count: holdings.filter((holding)=>(0, $15cd282b652e0b04$export$36baf1badfa94867)(holding) === key).length
        })).sort((a, b)=>a.label.localeCompare(b.label));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-1 flex-col overflow-y-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4 p-4 sm:px-8",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-end justify-between gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-col gap-2",
                            children: totals.map((total)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                                    className: "flex flex-wrap gap-x-8 gap-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                                    className: "text-muted-foreground text-xs",
                                                    children: "Value"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-2xl font-semibold tabular-nums', $faa3abd542deeac0$var$partialClass(total.value)),
                                                    children: $faa3abd542deeac0$var$formatSum(total.value, total.currency)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                                    className: "text-muted-foreground text-xs",
                                                    children: "Cost basis"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-2xl font-semibold tabular-nums', $faa3abd542deeac0$var$partialClass(total.costBasis)),
                                                    children: $faa3abd542deeac0$var$formatSum(total.costBasis, total.currency)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                                    className: "text-muted-foreground text-xs",
                                                    children: "Unrealized"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-2xl font-semibold', total.unrealized.complete ? (0, $468f7c854dda6e96$export$dd5b97695b6c46d8)(total.unrealized.cents) : 'text-muted-foreground tabular-nums'),
                                                    children: total.unrealized.known === 0 ? "\u2014" : (0, $468f7c854dda6e96$export$ff137379e7518313)(total.unrealized.cents, total.currency)
                                                })
                                            ]
                                        })
                                    ]
                                }, total.currency))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3a3f2d83b280457$export$b038e237dc823aed), {
                            label: "Group holdings",
                            options: $faa3abd542deeac0$var$VIEWS,
                            value: view,
                            onChange: setView
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$TreatmentBreakdown, {
                    holdings: shown
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative w-full sm:w-auto sm:min-w-40 sm:flex-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                    className: "text-muted-foreground absolute top-1/2 left-3 size-4 -translate-y-1/2"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "search",
                                    "aria-label": "Search holdings",
                                    placeholder: "Search holdings...",
                                    value: search,
                                    onChange: (event)=>setSearch(event.target.value),
                                    className: "border-border bg-background placeholder:text-muted-foreground focus:ring-primary w-full rounded-md border py-2 pr-3 pl-9 text-sm focus:ring-2 focus:outline-none"
                                })
                            ]
                        }),
                        accountOptions.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                            label: "Accounts",
                            allLabel: "All accounts",
                            allCount: holdings.length,
                            multiple: true,
                            value: accounts,
                            onChange: setAccounts,
                            options: accountOptions
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                            label: "Sort",
                            allLabel: "Value",
                            value: sort === 'value' ? 'all' : sort,
                            onChange: (key)=>setSort($faa3abd542deeac0$var$SORTS.find((option)=>option.key === key)?.key ?? 'value'),
                            options: $faa3abd542deeac0$var$SORTS
                        })
                    ]
                }),
                shown.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-muted-foreground p-8 text-center text-sm",
                    children: "No matching holdings."
                }) : view === 'security' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "border-border bg-card @container rounded-lg border pt-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$HeaderRow, {}),
                        (0, $15cd282b652e0b04$export$bc58d7f8cf8938c3)((0, $15cd282b652e0b04$export$9f3aed1f55384dec)(shown, assetOf), sort).map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$SecurityRow, {
                                row: row,
                                total: totalOf(row.currency),
                                accountName: accountName
                            }, row.key))
                    ]
                }) : (0, $15cd282b652e0b04$export$e655cfb73449ec4e)(shown, accountName, assetOf).map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "border-border bg-card @container rounded-lg border pt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-baseline justify-between px-3 pb-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "truncate text-sm font-semibold",
                                        children: group.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground text-sm tabular-nums",
                                        children: group.totals.map((total)=>$faa3abd542deeac0$var$formatSum(total.value, total.currency)).join(" \xb7 ")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$HeaderRow, {}),
                            (0, $15cd282b652e0b04$export$bc58d7f8cf8938c3)(group.rows, sort).map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($faa3abd542deeac0$var$SecurityRow, {
                                    row: row,
                                    total: totalOf(row.currency),
                                    accountName: accountName
                                }, row.key))
                        ]
                    }, group.key))
            ]
        })
    });
};






var $acw62 = parcelRequire("acw62");





const $0e5599b0d9982529$var$sizeOf = (gap, currency)=>{
    if (!(0, $50bf07908bf4ee59$export$9d4d6935fc8945d7)(gap)) return (0, $468f7c854dda6e96$export$ff137379e7518313)(gap.cash ?? 0, currency);
    const shares = (0, $468f7c854dda6e96$export$bf8df31cf1819e85)(gap.quantity ?? 0);
    // A paired trade carries its cash.
    return gap.suggestion.cash != null ? `${shares} \xb7 ${(0, $468f7c854dda6e96$export$ff137379e7518313)(gap.suggestion.cash, currency)}` : shares;
};
const $0e5599b0d9982529$var$GapCard = ({ gap: gap, accountName: accountName, currency: currency, undoing: undoing, onRecord: onRecord, onUndo: onUndo, onOpen: onOpen, busy: busy })=>{
    const choice = (0, $50bf07908bf4ee59$export$f8a71b5bea382e75)(gap);
    const duplicate = gap.suggestion.undoAdjustmentId != null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card flex flex-col gap-2.5 rounded-lg border p-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-start justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "truncate font-medium",
                                children: gap.securityLabel ?? 'Cash'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-muted-foreground truncate text-sm",
                                children: accountName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "shrink-0 font-semibold tabular-nums",
                        children: $0e5599b0d9982529$var$sizeOf(gap, currency)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2 text-xs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('rounded-full px-2 py-0.5', gap.status === 'settling' ? 'bg-muted text-muted-foreground' : 'bg-warning/15 text-warning'),
                        children: gap.status === 'settling' ? 'Settling' : `Since ${gap.since}`
                    }),
                    duplicate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground",
                        children: "Already in the feed"
                    }) : gap.suggestion.confident && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground",
                        children: [
                            "Looks like ",
                            choice.label.toLowerCase()
                        ]
                    })
                ]
            }),
            gap.suggestion.evidence != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground text-sm",
                children: [
                    "\u21B3 ",
                    gap.suggestion.evidence
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-wrap gap-2",
                children: duplicate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "primary",
                            disabled: busy || undoing == null,
                            onClick: onUndo,
                            children: [
                                "Delete recorded ",
                                (undoing === '' || undoing == null ? 'adjustment' : undoing).toLowerCase()
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            disabled: busy,
                            onClick: onOpen,
                            children: "Something else"
                        })
                    ]
                }) : gap.suggestion.confident ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "primary",
                            disabled: busy,
                            onClick: onRecord,
                            children: choice.kind === 'writeoff' ? 'Write off' : `Record ${choice.label.toLowerCase()}`
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            disabled: busy,
                            onClick: onOpen,
                            children: "Something else"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                    variant: "primary",
                    disabled: busy,
                    onClick: onOpen,
                    children: "What was this?"
                })
            })
        ]
    });
};
const $0e5599b0d9982529$export$9036408ccebce21c = ()=>{
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    // Any refetch (a record's, a sync's, a retry) shows as loading, which holds the cards.
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $ce9d9e524be20f53$export$2d57afd40a6482f)({
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true
    });
    const { data: adjustmentsData, loading: adjustmentsLoading, error: adjustmentsError, refetch: refetchAdjustments } = (0, $ce9d9e524be20f53$export$63f8c5540b7f5b5d)({
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true
    });
    // The accounts give the gaps their currencies, so they're refreshed alongside.
    const { data: accountsData, loading: accountsLoading, error: accountsError, refetch: refetchAccounts } = (0, $ce9d9e524be20f53$export$34fd8d1d279e4cb6)({
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true
    });
    const [create, { loading: recording }] = (0, $ce9d9e524be20f53$export$e285bb2a5fec598f)((0, $50bf07908bf4ee59$export$d73783ad1b90140a));
    const [remove, { loading: removing }] = (0, $ce9d9e524be20f53$export$ad50449646c4ffc3)((0, $50bf07908bf4ee59$export$d73783ad1b90140a));
    const [recorded, setRecorded] = $acw62.useState(null);
    const [failed, setFailed] = $acw62.useState(null);
    const accounts = new Map((accountsData?.allInvestmentAccounts ?? []).map((account)=>[
            account._id,
            account
        ]));
    const nameOf = (accountId)=>accounts.get(accountId)?.name ?? 'Account';
    const currencyOf = (accountId)=>accounts.get(accountId)?.currency ?? 'USD';
    // Retries whichever of the gaps and accounts failed (a retry that fails
    // leaves its error, and the cards still held off).
    const retry = ()=>{
        if (error != null) refetch().catch(()=>undefined);
        if (accountsError != null) refetchAccounts().catch(()=>undefined);
    };
    // Amounts are in their account's currency, so nothing shows until the accounts are in.
    if (loading && data == null || accountsLoading && accountsData == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground p-8 text-center",
        children: "Loading gaps..."
    });
    if (data == null && error != null || accountsData == null && accountsError != null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-muted-foreground flex flex-col items-center gap-2 p-8 text-center text-sm",
        children: [
            "Couldn't load gaps.",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: retry,
                children: "Retry"
            })
        ]
    });
    // History that's refreshing, or failed to, may list what's already
    // deleted: nothing deletes until it's fresh.
    const adjustmentsStale = adjustmentsLoading || adjustmentsError != null;
    // Gaps (and the accounts that give them their currencies) that are
    // refreshing, or failed to, may already be closed or changed (by a record
    // or a sync): nothing records, and nothing claims all's balanced, until
    // they're fresh.
    const stale = error != null || accountsError != null;
    const fresh = !stale && !loading && !accountsLoading;
    const gaps = (0, $50bf07908bf4ee59$export$2b8b276cc82d3a3b)(data?.investmentGaps ?? []);
    const needs = gaps.filter((gap)=>gap.status === 'unbalanced');
    const settling = gaps.filter((gap)=>gap.status === 'settling');
    const adjustments = [
        ...adjustmentsData?.investmentAdjustments ?? []
    ].sort((a, b)=>b.date.localeCompare(a.date));
    const open = (gap)=>modals.reconcileGapModal.openModal({
            gap: gap,
            onRecorded: (id, label)=>{
                setFailed(null);
                setRecorded({
                    id: id,
                    label: label
                });
            }
        });
    const record = async (gap)=>{
        setFailed(null);
        try {
            const result = await create({
                variables: (0, $50bf07908bf4ee59$export$59228d057bab1ed7)(gap)
            });
            const id = result.data?.createInvestmentAdjustment._id;
            if (id != null) setRecorded({
                id: id,
                label: (0, $50bf07908bf4ee59$export$f8a71b5bea382e75)(gap).label
            });
        } catch (err) {
            setFailed(err instanceof Error ? err.message : "Couldn't record it");
            // Refused, maybe because the gap has moved on (another tab, a sync):
            // fetch it as it is now. Only a success refetches on its own.
            refetch().catch(()=>undefined);
        }
    };
    // An adjustment stays (and so does its Undo) until the delete succeeds.
    // Deleted as a gap's duplicate, it names the gap: the server refuses it
    // if that gap no longer suggests it.
    const unrecord = async (adjustmentId, gap)=>{
        setFailed(null);
        try {
            await remove({
                variables: {
                    adjustmentId: adjustmentId,
                    gapSince: gap?.since,
                    gapDay: gap?.day
                }
            });
            setRecorded((current)=>current?.id === adjustmentId ? null : current);
        } catch (err) {
            setFailed(err instanceof Error ? err.message : "Couldn't delete it");
            // Refused, maybe because the gap has moved on or the adjustment is
            // already gone (another tab): fetch both as they are now.
            if (gap != null) {
                refetch().catch(()=>undefined);
                refetchAdjustments().catch(()=>undefined);
            }
        }
    };
    const noteOf = (adjustmentId)=>adjustmentsStale ? null : adjustments.find((adjustment)=>adjustment._id === adjustmentId)?.note ?? null;
    const card = (gap)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0e5599b0d9982529$var$GapCard, {
            gap: gap,
            accountName: nameOf(gap.accountId),
            currency: currencyOf(gap.accountId),
            undoing: noteOf(gap.suggestion.undoAdjustmentId),
            busy: recording || removing || !fresh || !accounts.has(gap.accountId),
            onRecord: ()=>void record(gap),
            onUndo: ()=>{
                const adjustmentId = gap.suggestion.undoAdjustmentId;
                if (adjustmentId != null) unrecord(adjustmentId, gap);
            },
            onOpen: ()=>open(gap)
        }, `${gap.accountId} ${gap.securityId ?? 'cash'}`);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-1 flex-col overflow-y-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "mx-auto flex w-full max-w-2xl flex-col gap-3 p-4",
            children: [
                recorded != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-primary text-primary-foreground flex items-center justify-between gap-3 rounded-lg px-3 py-2 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                recorded.label,
                                " recorded"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "underline",
                            disabled: removing || adjustmentsStale,
                            onClick: ()=>void unrecord(recorded.id),
                            children: "Undo"
                        })
                    ]
                }),
                failed != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    role: "alert",
                    className: "bg-destructive/10 text-destructive rounded-lg px-3 py-2 text-sm",
                    children: failed
                }),
                stale && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    role: "alert",
                    className: "bg-destructive/10 text-destructive flex items-center justify-between gap-3 rounded-lg px-3 py-2 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Couldn't refresh gaps."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "underline",
                            onClick: retry,
                            children: "Retry"
                        })
                    ]
                }),
                gaps.length === 0 && fresh && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "border-border bg-card text-muted-foreground rounded-lg border p-8 text-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-positive text-2xl",
                            children: "\u2713"
                        }),
                        "All balanced"
                    ]
                }),
                needs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-muted-foreground px-1 text-xs tracking-wide uppercase",
                            children: "Needs a look"
                        }),
                        needs.map(card)
                    ]
                }),
                settling.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                    className: "group border-border bg-card rounded-lg border",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("summary", {
                            className: "flex cursor-pointer list-none items-center justify-between px-3 py-2.5 [&::-webkit-details-marker]:hidden",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "flex items-center gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                            className: "text-muted-foreground size-4 transition-transform group-open:rotate-90"
                                        }),
                                        "Settling"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground",
                                    children: settling.length
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-col gap-2 p-2",
                            children: settling.map(card)
                        })
                    ]
                }),
                adjustmentsError != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    role: "alert",
                    className: "border-border bg-card text-destructive flex items-center justify-between gap-3 rounded-lg border px-3 py-2.5 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: adjustmentsData == null ? "Couldn't load adjustments." : "Couldn't refresh adjustments."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "underline",
                            onClick: ()=>void refetchAdjustments().catch(()=>undefined),
                            children: "Retry"
                        })
                    ]
                }),
                adjustments.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                    className: "group border-border bg-card rounded-lg border",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("summary", {
                            className: "flex cursor-pointer list-none items-center justify-between px-3 py-2.5 [&::-webkit-details-marker]:hidden",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "flex items-center gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                            className: "text-muted-foreground size-4 transition-transform group-open:rotate-90"
                                        }),
                                        "Adjustments"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground",
                                    children: adjustments.length
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-col",
                            children: adjustments.map((adjustment)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "border-border flex items-center justify-between gap-3 border-t px-3 py-2 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "truncate",
                                                    children: [
                                                        adjustment.kind,
                                                        adjustment.securityLabel,
                                                        nameOf(adjustment.accountId)
                                                    ].filter(Boolean).join(" \xb7 ")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "text-muted-foreground truncate text-xs",
                                                    children: [
                                                        adjustment.date,
                                                        adjustment.note ? ` \xb7 ${adjustment.note}` : ''
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex shrink-0 items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "tabular-nums",
                                                    children: [
                                                        adjustment.cash != null ? (0, $468f7c854dda6e96$export$ff137379e7518313)(adjustment.cash, adjustment.quantity == null ? adjustment.currency : currencyOf(adjustment.accountId)) : '',
                                                        adjustment.quantity != null ? ` ${(0, $468f7c854dda6e96$export$bf8df31cf1819e85)(adjustment.quantity)}` : ''
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    disabled: removing || adjustmentsStale,
                                                    onClick: ()=>void unrecord(adjustment._id),
                                                    children: "Delete"
                                                })
                                            ]
                                        })
                                    ]
                                }, adjustment._id))
                        })
                    ]
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

const $2961e1c0d914d10d$export$bc6cd1b6c18f4114 = (periods)=>{
    const linked = new Set(periods.flatMap((p)=>p.issuerId != null && p.accountId != null ? [
            p.accountId
        ] : []));
    return periods.filter((p)=>p.issuerId != null || p.accountId == null || !linked.has(p.accountId));
};
const $2961e1c0d914d10d$export$e355334cade9c748 = (period, key)=>period[key] ?? null;
const $2961e1c0d914d10d$export$3859c79b8169beb5 = (periods, key)=>{
    const values = periods.map((period)=>$2961e1c0d914d10d$export$e355334cade9c748(period, key));
    return {
        cents: values.reduce((total, value)=>total + (value ?? 0), 0),
        known: values.filter((value)=>value != null).length,
        complete: values.every((value)=>value != null)
    };
};




// A period runs from the close of its start day, so YTD starts at the
// prior year-end and All before any record.
const $2cb06009f5ded99a$var$PERIODS = [
    {
        key: '1W',
        label: '1W',
        start: (now)=>now.minus({
                weeks: 1
            })
    },
    {
        key: '1M',
        label: '1M',
        start: (now)=>now.minus({
                months: 1
            })
    },
    {
        key: 'YTD',
        label: 'YTD',
        start: (now)=>now.startOf('year').minus({
                days: 1
            })
    },
    {
        key: '1Y',
        label: '1Y',
        start: (now)=>now.minus({
                years: 1
            })
    },
    {
        key: 'All',
        label: 'All',
        start: (now)=>now.set({
                year: 1900,
                month: 1,
                day: 1
            })
    }
];
/**
 * The parts of a period's change, in the order they add up; market results
 * are colored. Fees come out (sign −1), so they show as what they took.
 */ const $2cb06009f5ded99a$var$PARTS = [
    {
        key: 'saved',
        label: 'Saved',
        gain: false
    },
    {
        key: 'income',
        label: 'Income',
        gain: false
    },
    {
        key: 'fees',
        label: 'Fees',
        gain: false,
        sign: -1
    },
    {
        key: 'realized',
        label: 'Realized',
        gain: true
    },
    {
        key: 'unrealizedChange',
        label: 'Unrealized',
        gain: true
    },
    {
        key: 'unclassified',
        label: 'Unclassified',
        gain: true
    },
    {
        key: 'residualChange',
        label: 'Residual',
        gain: false
    }
];
// Every row is one grid with the same fixed column widths, so figures line
// up down the table. Columns appear as the card widens: change and
// realized always; unrealized next; saved and income; then unclassified and
// residual. A row's detail has them all.
const $2cb06009f5ded99a$var$GRID = 'grid grid-cols-[minmax(0,1fr)_5.75rem_5.75rem] items-center gap-x-3 @md:grid-cols-[minmax(0,1fr)_6rem_6rem_6rem] @3xl:grid-cols-[minmax(10rem,1fr)_6.5rem_6.5rem_6.5rem_6.5rem_6.5rem] @6xl:grid-cols-[minmax(12rem,1fr)_6.5rem_6.5rem_6.5rem_6.5rem_6.5rem_6.5rem_6.5rem]';
const $2cb06009f5ded99a$var$NARROW = 'hidden text-right @md:block';
const $2cb06009f5ded99a$var$MEDIUM = 'hidden text-right @3xl:block';
const $2cb06009f5ded99a$var$WIDE = 'hidden text-right @6xl:block';
/** A signed amount, "—" when unknown; a gain colored, a partial sum muted. */ const $2cb06009f5ded99a$var$Amount = ({ cents: cents, currency: currency, gain: gain = true, partial: partial = false, className: className, as: Tag = 'span' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Tag, {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-right tabular-nums', partial ? 'text-muted-foreground' : gain && (0, $468f7c854dda6e96$export$dd5b97695b6c46d8)(cents), className),
        children: cents == null ? "\u2014" : (0, $468f7c854dda6e96$export$ff137379e7518313)(cents, currency)
    });
const $2cb06009f5ded99a$var$Cells = ({ period: period })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Amount, {
                cents: period.balanceChange ?? null,
                currency: period.currency
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Amount, {
                cents: period.realized ?? null,
                currency: period.currency
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Amount, {
                cents: period.unrealizedChange ?? null,
                currency: period.currency,
                className: $2cb06009f5ded99a$var$NARROW
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Amount, {
                cents: period.saved ?? null,
                currency: period.currency,
                gain: false,
                className: $2cb06009f5ded99a$var$MEDIUM
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Amount, {
                cents: period.income ?? null,
                currency: period.currency,
                gain: false,
                className: $2cb06009f5ded99a$var$MEDIUM
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Amount, {
                cents: period.unclassified ?? null,
                currency: period.currency,
                className: $2cb06009f5ded99a$var$WIDE
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Amount, {
                cents: period.residualChange ?? null,
                currency: period.currency,
                gain: false,
                className: $2cb06009f5ded99a$var$WIDE
            })
        ]
    });
const $2cb06009f5ded99a$var$Row = ({ period: period, name: name })=>{
    const [open, setOpen] = $acw62.useState(false);
    // Out of balance: a check moved. (Not exact for other reasons, like an
    // estimated sale or a missing price, isn't that; the detail says why.)
    const unbalanced = period.cashGap !== 0 || period.quantityGaps.length > 0;
    // A market part with no price is unknown though realized isn't.
    const unpriced = period.realizedUnknown == null && [
        period.unrealizedChange,
        period.unclassified,
        period.residualChange
    ].some((value)=>value == null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border border-b last:border-b-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                "aria-expanded": open,
                onClick: ()=>setOpen((state)=>!state),
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($2cb06009f5ded99a$var$GRID, 'w-full px-3 py-2.5 text-left text-sm'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex min-w-0 items-center gap-1.5",
                        children: [
                            open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-4 shrink-0"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-4 shrink-0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex min-w-0 flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "truncate font-medium",
                                        children: name
                                    }),
                                    unbalanced && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-warning text-xs",
                                        children: "Not reconciled"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Cells, {
                        period: period
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                className: "bg-muted/40 grid grid-cols-[minmax(0,1fr)_auto] gap-x-4 gap-y-1 px-3 py-2 pl-8 text-xs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dt", {
                        className: "text-muted-foreground",
                        children: [
                            period.from,
                            " \u2192 ",
                            period.to
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        className: "text-right tabular-nums",
                        children: period.balanceChange == null ? "\u2014" : (0, $468f7c854dda6e96$export$ff137379e7518313)(period.balanceChange, period.currency)
                    }),
                    $2cb06009f5ded99a$var$PARTS.map(({ key: key, label: label, gain: gain, sign: sign })=>{
                        const cents = (0, $2961e1c0d914d10d$export$e355334cade9c748)(period, key);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    className: "text-muted-foreground",
                                    children: label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Amount, {
                                    as: "dd",
                                    cents: cents == null ? null : cents * (sign ?? 1),
                                    currency: period.currency,
                                    gain: gain
                                })
                            ]
                        }, key);
                    }),
                    (period.realizedUnknown != null || unpriced) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                className: "text-muted-foreground",
                                children: "Unknown"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                className: "text-right",
                                children: period.realizedUnknown ?? 'price'
                            })
                        ]
                    }),
                    period.writtenOff !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                className: "text-muted-foreground",
                                children: "Written off"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Amount, {
                                as: "dd",
                                cents: period.writtenOff,
                                currency: period.currency,
                                gain: false
                            })
                        ]
                    }),
                    period.cashGap !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                className: "text-muted-foreground",
                                children: "Cash gap"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Amount, {
                                as: "dd",
                                cents: period.cashGap,
                                currency: period.currency,
                                gain: false
                            })
                        ]
                    }),
                    period.quantityGaps.map((gap)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    className: "text-muted-foreground",
                                    children: "Share gap"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                    className: "text-right tabular-nums",
                                    children: [
                                        gap.quantity > 0 ? '+' : "\u2212",
                                        Math.abs(gap.quantity).toLocaleString('en-US', {
                                            maximumSignificantDigits: 8
                                        }),
                                        " sh \xb7",
                                        ' ',
                                        gap.label
                                    ]
                                })
                            ]
                        }, gap.securityId))
                ]
            })
        ]
    });
};
const $2cb06009f5ded99a$export$a69b0d9623dc4718 = ({ accountNames: accountNames })=>{
    const [key, setKey] = $acw62.useState('1M');
    const now = (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)();
    const period = $2cb06009f5ded99a$var$PERIODS.find((p)=>p.key === key) ?? $2cb06009f5ded99a$var$PERIODS[1];
    const from = period.start(now).toISODate() ?? '';
    const to = now.toISODate() ?? '';
    // Derived from everything a sync or a setting can change, so it always
    // refreshes on mount, showing the cached figures meanwhile.
    const { data: data, loading: loading, error: error } = (0, $ce9d9e524be20f53$export$883d962555a42fa1)({
        variables: {
            from: from,
            to: to
        },
        fetchPolicy: 'cache-and-network'
    });
    const periods = [
        ...data?.investmentPeriods ?? []
    ].sort((a, b)=>Math.abs(b.balanceChange ?? 0) - Math.abs(a.balanceChange ?? 0));
    const nameOf = (p)=>p.issuerName ?? (p.accountId != null ? accountNames.get(p.accountId) ?? 'Account' : 'Account');
    const currencies = [
        ...new Set(periods.map((p)=>p.currency))
    ].sort((a, b)=>Number(b === 'USD') - Number(a === 'USD'));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "flex flex-col gap-3",
        "aria-labelledby": "gains-heading",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        id: "gains-heading",
                        className: "text-base font-semibold",
                        children: "Gains"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3a3f2d83b280457$export$b038e237dc823aed), {
                        label: "Gains period",
                        options: $2cb06009f5ded99a$var$PERIODS,
                        value: key,
                        onChange: setKey
                    })
                ]
            }),
            loading && data == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground p-4 text-sm",
                children: "Loading gains..."
            }) : data == null && error != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground p-4 text-sm",
                children: "Couldn't load gains."
            }) : periods.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-muted-foreground p-4 text-sm",
                children: "No holdings recorded in this period."
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-card @container rounded-lg border pt-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($2cb06009f5ded99a$var$GRID, 'text-muted-foreground border-border border-b px-3 pb-2 text-xs'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-right",
                                children: "Change"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-right",
                                children: "Realized"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: $2cb06009f5ded99a$var$NARROW,
                                children: "Unrealized"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: $2cb06009f5ded99a$var$MEDIUM,
                                children: "Saved"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: $2cb06009f5ded99a$var$MEDIUM,
                                children: "Income"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: $2cb06009f5ded99a$var$WIDE,
                                children: "Unclassified"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: $2cb06009f5ded99a$var$WIDE,
                                children: "Residual"
                            })
                        ]
                    }),
                    currencies.map((currency)=>{
                        const mine = (0, $2961e1c0d914d10d$export$bc6cd1b6c18f4114)(periods).filter((p)=>p.currency === currency);
                        const total = (field)=>(0, $2961e1c0d914d10d$export$3859c79b8169beb5)(mine, field);
                        const cell = (field, className)=>{
                            const sum = total(field);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Amount, {
                                cents: sum.known === 0 ? null : sum.cents,
                                currency: currency,
                                gain: $2cb06009f5ded99a$var$PARTS.find((part)=>part.key === field)?.gain ?? true,
                                partial: !sum.complete,
                                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('font-semibold', className)
                            });
                        };
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)($2cb06009f5ded99a$var$GRID, 'border-border border-b px-3 py-2.5 text-sm'),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "pl-5 font-semibold",
                                    children: currencies.length > 1 ? `Total ${currency}` : 'Total'
                                }),
                                cell('balanceChange'),
                                cell('realized'),
                                cell('unrealizedChange', $2cb06009f5ded99a$var$NARROW),
                                cell('saved', $2cb06009f5ded99a$var$MEDIUM),
                                cell('income', $2cb06009f5ded99a$var$MEDIUM),
                                cell('unclassified', $2cb06009f5ded99a$var$WIDE),
                                cell('residualChange', $2cb06009f5ded99a$var$WIDE)
                            ]
                        }, currency);
                    }),
                    periods.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2cb06009f5ded99a$var$Row, {
                            period: p,
                            name: nameOf(p)
                        }, p.issuerId != null ? `issuer:${p.issuerId}` : `account:${p.accountId}`))
                ]
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");


// Cell tint steps for the diverging red–neutral–green ramp. In percent view
// the |return| thresholds scale with the period length — +8% is a mild year
// but a strong quarter — and in dollar view the same six alphas are driven
// by the cell's share of the largest |gain| in the matrix.
const $9a9aa3669cdd2e6b$var$ALPHA_STEPS = [
    0.04,
    0.09,
    0.16,
    0.26,
    0.38,
    0.5
];
const $9a9aa3669cdd2e6b$var$YEAR_THRESHOLDS = [
    0.02,
    0.06,
    0.12,
    0.2,
    0.3
];
const $9a9aa3669cdd2e6b$var$PERCENT_THRESHOLDS = {
    [(0, $ce9d9e524be20f53$export$731580143a09eb02).Year]: $9a9aa3669cdd2e6b$var$YEAR_THRESHOLDS,
    [(0, $ce9d9e524be20f53$export$731580143a09eb02).Quarter]: $9a9aa3669cdd2e6b$var$YEAR_THRESHOLDS.map((t)=>t / 2),
    [(0, $ce9d9e524be20f53$export$731580143a09eb02).Month]: $9a9aa3669cdd2e6b$var$YEAR_THRESHOLDS.map((t)=>t / 4)
};
const $9a9aa3669cdd2e6b$var$DOLLAR_THRESHOLDS = [
    0.02,
    0.06,
    0.15,
    0.3,
    0.6
];
const $9a9aa3669cdd2e6b$var$steppedAlpha = (magnitude, thresholds)=>{
    let step = 0;
    while(step < thresholds.length && magnitude >= thresholds[step])step++;
    return $9a9aa3669cdd2e6b$var$ALPHA_STEPS[step];
};
// Exactly-zero cells take the legend's neutral midpoint, not a green tint —
// a flat period is not a gain.
const $9a9aa3669cdd2e6b$var$cellBackground = (value, alpha)=>value === 0 ? 'var(--color-muted)' : value > 0 ? `rgba(22, 163, 74, ${alpha})` : `rgba(220, 38, 38, ${alpha})`;
const $9a9aa3669cdd2e6b$var$formatPercentCell = (decimal)=>{
    const sign = decimal > 0 ? '+' : decimal < 0 ? "\u2212" : '';
    return `${sign}${(Math.abs(decimal) * 100).toFixed(1)}`;
};
const $9a9aa3669cdd2e6b$var$compactCurrency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 1
});
const $9a9aa3669cdd2e6b$var$formatDollarCell = (cents)=>{
    const sign = cents > 0 ? '+' : cents < 0 ? "\u2212" : '';
    return `${sign}${$9a9aa3669cdd2e6b$var$compactCurrency.format(Math.abs(cents) / 100)}`;
};
// Column labels: the newest yearly column is the running year ("YTD");
// quarter and month keys compress to "Q3 26" / "Aug 26".
const $9a9aa3669cdd2e6b$var$periodLabel = (key, granularity, isNewest)=>{
    switch(granularity){
        case (0, $ce9d9e524be20f53$export$731580143a09eb02).Year:
            return isNewest ? 'YTD' : key;
        case (0, $ce9d9e524be20f53$export$731580143a09eb02).Quarter:
            {
                const [year, quarter] = key.split('-');
                return `${quarter} ${year.slice(2)}`;
            }
        case (0, $ce9d9e524be20f53$export$731580143a09eb02).Month:
            {
                const parsed = (0, $63618293c58b5f80$exports.DateTime).fromFormat(key, 'yyyy-MM', {
                    zone: 'utc'
                });
                return parsed.isValid ? parsed.toFormat('MMM yy') : key;
            }
    }
};
const $9a9aa3669cdd2e6b$export$c99c87e8f585c88c = ({ accounts: accounts })=>{
    const [granularity, setGranularity] = $acw62.useState((0, $ce9d9e524be20f53$export$731580143a09eb02).Year);
    const [view, setView] = $acw62.useState('percent');
    const { data: data, loading: loading, error: error } = (0, $ce9d9e524be20f53$export$354be1f4a2728511)({
        variables: {
            granularity: granularity
        },
        fetchPolicy: 'cache-and-network'
    });
    const matrix = data?.investmentReturnsMatrix;
    const accountById = $acw62.useMemo(()=>new Map(accounts.map((account)=>[
                account._id,
                account
            ])), [
        accounts
    ]);
    // Rows sort by the row's presentValue (the server's today-clamped value,
    // the same figure that decided eligibility) so the matrix reads
    // size-first; the balance bar under each name carries the same weight
    // context linearly. account.balance is deliberately not used — it is not
    // today-clamped, so a future-dated anchor would make it disagree with the
    // eligibility rule.
    const rows = $acw62.useMemo(()=>{
        if (matrix == null) return [];
        return matrix.rows.flatMap((row)=>{
            const account = accountById.get(row.accountId);
            return account != null ? [
                {
                    ...row,
                    account: account
                }
            ] : [];
        }).sort((a, b)=>b.presentValue - a.presentValue);
    }, [
        matrix,
        accountById
    ]);
    if (matrix == null) {
        if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "border-border bg-card flex h-40 items-center justify-center rounded-lg border",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground",
                children: "Loading returns..."
            })
        });
        // Settled without data: the request failed. Say so briefly rather than
        // spinning forever or silently dropping the card.
        if (error != null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "border-border bg-card flex h-20 items-center justify-center rounded-lg border",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground",
                children: "Couldn't load returns."
            })
        });
        return null;
    }
    if (rows.length === 0 || matrix.periodKeys.length === 0) // The server returns no rows when every investment account is presently
    // unfunded. The matrix owns the whole Performance tab, so say why the
    // tab is empty rather than rendering nothing.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border-border bg-card flex h-24 items-center justify-center rounded-lg border",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground text-sm",
            children: "No funded investment accounts to compare yet."
        })
    });
    const maxBalance = Math.max(...rows.map((row)=>row.presentValue));
    const maxAbsGain = Math.max(1, ...rows.flatMap((row)=>row.periods.map((cell)=>Math.abs(cell.gainAmount ?? 0))));
    // The tally cells are different populations from the period cells (a span
    // total dwarfs any single period; the pooled row dwarfs any account), so
    // each population scales its dollar tints against its own maximum.
    const maxAbsRowTotal = Math.max(1, ...rows.map((row)=>Math.abs(row.total.gainAmount ?? 0)));
    const totals = matrix.totals;
    const maxAbsTotals = Math.max(1, ...(totals?.periods ?? []).map((cell)=>Math.abs(cell.gainAmount ?? 0)), Math.abs(totals?.total.gainAmount ?? 0));
    const percentThresholds = $9a9aa3669cdd2e6b$var$PERCENT_THRESHOLDS[granularity];
    // Legend bounds track the current scale: the outer swatches saturate at
    // the top tint threshold in percent view and at the matrix's largest
    // absolute gain in dollar view.
    const periodNoun = granularity === (0, $ce9d9e524be20f53$export$731580143a09eb02).Year ? 'year' : granularity === (0, $ce9d9e524be20f53$export$731580143a09eb02).Quarter ? 'quarter' : 'month';
    const topPercent = percentThresholds[percentThresholds.length - 1] * 100;
    const legendNegLabel = view === 'percent' ? `\u{2212}${topPercent}%` : `\u{2212}${$9a9aa3669cdd2e6b$var$compactCurrency.format(maxAbsGain / 100)}`;
    const legendPosLabel = view === 'percent' ? `+${topPercent}%` : `+${$9a9aa3669cdd2e6b$var$compactCurrency.format(maxAbsGain / 100)}`;
    const legendUnitLabel = view === 'percent' ? `return per ${periodNoun}, %` : `gain per ${periodNoun}, $`;
    const cellFor = (cell, dollarScale)=>{
        if (!cell.hasData) return {
            text: "\u2014",
            background: undefined,
            muted: true
        };
        if (view === 'percent') {
            if (cell.returnPercent == null) return {
                text: "\u2014",
                background: undefined,
                muted: true
            };
            return {
                text: $9a9aa3669cdd2e6b$var$formatPercentCell(cell.returnPercent),
                background: $9a9aa3669cdd2e6b$var$cellBackground(cell.returnPercent, $9a9aa3669cdd2e6b$var$steppedAlpha(Math.abs(cell.returnPercent), percentThresholds)),
                muted: false
            };
        }
        if (cell.gainAmount == null) return {
            text: "\u2014",
            background: undefined,
            muted: true
        };
        return {
            text: $9a9aa3669cdd2e6b$var$formatDollarCell(cell.gainAmount),
            background: $9a9aa3669cdd2e6b$var$cellBackground(cell.gainAmount, $9a9aa3669cdd2e6b$var$steppedAlpha(Math.abs(cell.gainAmount) / dollarScale, $9a9aa3669cdd2e6b$var$DOLLAR_THRESHOLDS)),
            muted: false
        };
    };
    const xirrCellFor = (xirr)=>xirr != null ? {
            text: $9a9aa3669cdd2e6b$var$formatPercentCell(xirr),
            background: $9a9aa3669cdd2e6b$var$cellBackground(xirr, $9a9aa3669cdd2e6b$var$steppedAlpha(Math.abs(xirr), $9a9aa3669cdd2e6b$var$YEAR_THRESHOLDS)),
            muted: false
        } : {
            text: "\u2014",
            background: undefined,
            muted: true
        };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border bg-card rounded-lg border p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-3 flex flex-wrap items-center gap-x-1 gap-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-foreground mr-auto font-medium",
                        children: "Returns by account"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                        label: "Scale",
                        allLabel: "Yearly",
                        options: [
                            {
                                key: 'quarterly',
                                label: 'Quarterly'
                            },
                            {
                                key: 'monthly',
                                label: 'Monthly'
                            }
                        ],
                        value: granularity === (0, $ce9d9e524be20f53$export$731580143a09eb02).Year ? 'all' : granularity === (0, $ce9d9e524be20f53$export$731580143a09eb02).Quarter ? 'quarterly' : 'monthly',
                        onChange: (key)=>setGranularity(key === 'quarterly' ? (0, $ce9d9e524be20f53$export$731580143a09eb02).Quarter : key === 'monthly' ? (0, $ce9d9e524be20f53$export$731580143a09eb02).Month : (0, $ce9d9e524be20f53$export$731580143a09eb02).Year)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                        label: "View",
                        allLabel: "% return",
                        options: [
                            {
                                key: 'dollar',
                                label: '$ gain'
                            }
                        ],
                        value: view === 'percent' ? 'all' : 'dollar',
                        onChange: (key)=>setView(key === 'dollar' ? 'dollar' : 'percent')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid gap-0.5",
                    style: {
                        gridTemplateColumns: `minmax(150px, 180px) 64px 68px repeat(${matrix.periodKeys.length}, minmax(56px, 1fr))`
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-muted-foreground flex h-7 items-center justify-center text-xs font-medium",
                            children: "XIRR"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-muted-foreground flex h-7 items-center justify-center text-xs font-medium",
                            children: "Total"
                        }),
                        matrix.periodKeys.map((key, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-muted-foreground flex h-7 items-center justify-center text-xs",
                                children: $9a9aa3669cdd2e6b$var$periodLabel(key, granularity, index === 0)
                            }, key)),
                        rows.map((row)=>{
                            const xirrCell = xirrCellFor(row.xirr);
                            const totalCell = cellFor(row.total, maxAbsRowTotal);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex min-w-0 flex-col justify-center gap-1 py-1 pr-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                                to: `/accounts/${row.accountId}`,
                                                className: "text-foreground truncate text-sm no-underline hover:underline",
                                                children: row.account.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "bg-muted h-1 w-14 shrink-0 rounded-full",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "bg-muted-foreground/60 h-1 rounded-full",
                                                            style: {
                                                                width: `${Math.max(row.presentValue / maxBalance * 100, 2)}%`
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-muted-foreground text-[11px] whitespace-nowrap",
                                                        children: $9a9aa3669cdd2e6b$var$compactCurrency.format(row.presentValue / 100)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `border-border flex h-full min-h-10 items-center justify-center rounded-md border text-xs ${xirrCell.muted ? 'text-muted-foreground/60' : 'text-foreground'}`,
                                        style: {
                                            backgroundColor: xirrCell.background
                                        },
                                        children: xirrCell.text
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `border-border flex h-full min-h-10 items-center justify-center rounded-md border text-xs ${totalCell.muted ? 'text-muted-foreground/60' : 'text-foreground'}`,
                                        style: {
                                            backgroundColor: totalCell.background
                                        },
                                        children: totalCell.text
                                    }),
                                    row.periods.map((cell)=>{
                                        const rendered = cellFor(cell, maxAbsGain);
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `flex h-full min-h-10 items-center justify-center rounded-md text-xs ${rendered.muted ? 'bg-muted/40 text-muted-foreground/60' : 'text-foreground'}`,
                                            style: {
                                                backgroundColor: rendered.background
                                            },
                                            children: rendered.text
                                        }, cell.periodKey);
                                    })
                                ]
                            }, row.accountId);
                        }),
                        totals != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "border-border mt-1 border-t pt-1",
                                    style: {
                                        gridColumn: '1 / -1'
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex min-w-0 flex-col justify-center gap-0.5 py-1 pr-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-foreground text-sm font-medium",
                                            children: "All accounts"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground text-[11px] whitespace-nowrap",
                                            children: $9a9aa3669cdd2e6b$var$compactCurrency.format(totals.presentValue / 100)
                                        })
                                    ]
                                }),
                                (()=>{
                                    const pooledXirr = xirrCellFor(totals.xirr);
                                    const grand = cellFor(totals.total, maxAbsTotals);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `border-border flex h-full min-h-10 items-center justify-center rounded-md border text-xs font-medium ${pooledXirr.muted ? 'text-muted-foreground/60' : 'text-foreground'}`,
                                                style: {
                                                    backgroundColor: pooledXirr.background
                                                },
                                                children: pooledXirr.text
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `border-border flex h-full min-h-10 items-center justify-center rounded-md border text-xs font-medium ${grand.muted ? 'text-muted-foreground/60' : 'text-foreground'}`,
                                                style: {
                                                    backgroundColor: grand.background
                                                },
                                                children: grand.text
                                            })
                                        ]
                                    });
                                })(),
                                totals.periods.map((cell)=>{
                                    const rendered = cellFor(cell, maxAbsTotals);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `flex h-full min-h-10 items-center justify-center rounded-md text-xs font-medium ${rendered.muted ? 'bg-muted/40 text-muted-foreground/60' : 'text-foreground'}`,
                                        style: {
                                            backgroundColor: rendered.background
                                        },
                                        children: rendered.text
                                    }, cell.periodKey);
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-[11px]",
                        children: legendNegLabel
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-3 w-5 rounded-sm",
                        style: {
                            backgroundColor: 'rgba(220, 38, 38, 0.5)'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-3 w-5 rounded-sm",
                        style: {
                            backgroundColor: 'rgba(220, 38, 38, 0.26)'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "bg-muted h-3 w-5 rounded-sm"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-3 w-5 rounded-sm",
                        style: {
                            backgroundColor: 'rgba(22, 163, 74, 0.26)'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "h-3 w-5 rounded-sm",
                        style: {
                            backgroundColor: 'rgba(22, 163, 74, 0.5)'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground text-[11px]",
                        children: legendPosLabel
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-muted-foreground ml-auto text-[11px]",
                        children: legendUnitLabel
                    })
                ]
            })
        ]
    });
};


const $acb7bf5f53f280b5$export$ec173b1df7f5418e = ()=>{
    const { data: data, loading: loading, error: error } = (0, $ce9d9e524be20f53$export$34fd8d1d279e4cb6)();
    const accountNames = $acw62.useMemo(()=>new Map((data?.allInvestmentAccounts ?? []).map((account)=>[
                account._id,
                account.name
            ])), [
        data
    ]);
    if (loading && data == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading investment accounts..."
        })
    });
    // A settled failure must not read as an empty portfolio.
    if (data == null && error != null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground p-8 text-center text-sm",
        children: "Couldn't load investment accounts."
    });
    const accounts = data?.allInvestmentAccounts ?? [];
    // Company stock has gains with no investment account, so they show either way.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-1 flex-col overflow-y-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4 p-4",
            children: [
                accounts.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a9aa3669cdd2e6b$export$c99c87e8f585c88c), {
                    accounts: accounts
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-muted-foreground p-4 text-center text-sm",
                    children: "No investment accounts connected."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2cb06009f5ded99a$export$a69b0d9623dc4718), {
                    accountNames: accountNames
                })
            ]
        })
    });
};



parcelRequire("acw62");



const $e071f54a6092fa6f$var$tabClass = ({ isActive: isActive })=>(0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('shrink-0 whitespace-nowrap border-b-2 px-1 pb-2 text-sm font-medium no-underline transition', isActive ? 'border-primary text-foreground' : 'text-muted-foreground hover:text-foreground border-transparent');
const $e071f54a6092fa6f$export$e33c718277d7d8f0 = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Investments',
        reset: true
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                className: "border-border flex gap-5 overflow-x-auto border-b px-4 pt-4 [scrollbar-width:none] sm:px-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$b0d92dbee9b5b60d), {
                        to: "/investments",
                        end: true,
                        className: $e071f54a6092fa6f$var$tabClass,
                        children: "Overview"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$b0d92dbee9b5b60d), {
                        to: "/investments/holdings",
                        className: $e071f54a6092fa6f$var$tabClass,
                        children: "Holdings"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$b0d92dbee9b5b60d), {
                        to: "/investments/reconcile",
                        className: $e071f54a6092fa6f$var$tabClass,
                        children: "Reconcile"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$b0d92dbee9b5b60d), {
                        to: "/investments/performance",
                        className: $e071f54a6092fa6f$var$tabClass,
                        children: "Performance"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-1 flex-col overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$910ae8079b2c2852), {})
            })
        ]
    });
};






parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



const $7e399d2cd4a15b28$export$e07fb7d96ed9d385 = ({ accounts: accounts, value: value, onChange: onChange })=>{
    const selectedCount = value.length;
    const triggerLabel = selectedCount === 0 ? 'All accounts' : selectedCount === 1 ? accounts.find((account)=>account._id === value[0])?.name ?? '1 account' : `${selectedCount} accounts`;
    const options = $acw62.useMemo(()=>(0, $e597f4605156a89e$export$b61c24e8eaadd648).flatMap((section)=>accounts.filter((account)=>section.matches(account)).sort((a, b)=>a.name.localeCompare(b.name)).map((account)=>({
                    key: account._id,
                    label: account.name,
                    group: section.label,
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4dd8122ba7d7dc8$export$a519fd59e714bf50), {
                        account: account
                    })
                }))), [
        accounts
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
        multiple: true,
        searchable: true,
        label: "Accounts",
        allLabel: "All accounts",
        triggerLabel: triggerLabel,
        options: options,
        value: value,
        onChange: onChange
    });
};




var $acw62 = parcelRequire("acw62");


const $65d89d752bbabb1b$export$b4cdf1ea571241de = (value)=>{
    if (!value) return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};
const $65d89d752bbabb1b$export$2a80bd8c3223c35f = (dollars)=>dollars == null ? undefined : Math.round(dollars * 100);
// A bound is a whole, positive number of cents. Quantizing with the same
// float step amountArg takes keeps the pill's label and the submitted bound
// agreeing on sub-cent input (1.005 would format as $1.01 but round to 100
// cents), and a bound of zero or less excludes nothing as a min and
// everything but zero-amount rows as a max — neither a filter anyone means.
const $65d89d752bbabb1b$var$quantizedBound = (dollars)=>{
    if (dollars == null) return null;
    const cents = Math.round(dollars * 100);
    return cents > 0 ? cents / 100 : null;
};
const $65d89d752bbabb1b$export$4aff31cbe6af231b = (value)=>{
    const minAmount = $65d89d752bbabb1b$var$quantizedBound(value.minAmount);
    const maxAmount = $65d89d752bbabb1b$var$quantizedBound(value.maxAmount);
    return minAmount != null && maxAmount != null && minAmount > maxAmount ? {
        minAmount: maxAmount,
        maxAmount: minAmount
    } : {
        minAmount: minAmount,
        maxAmount: maxAmount
    };
};
// Round thresholds for one-click noise floors; anything else is two keystrokes
// away in the custom inputs.
const $65d89d752bbabb1b$var$PRESETS = [
    100,
    500,
    1000,
    5000,
    10000
];
// Fixed en-US formatting rather than the runtime locale, so the pill (and
// screenshot baselines) render the same everywhere. Whole dollars drop the
// cents: the label reads "≥ $10,000", not "≥ $10,000.00".
//
// The $ is a labeling convenience, not a conversion: the server compares
// bounds against each row's amount at face value in its own currency (like
// the amountOver: search token), so on a wallet row the number is yen or
// miles. Accounts are overwhelmingly USD and a noise-floor/big-movers filter
// tolerates that edge — a deliberate call, not an oversight.
const $65d89d752bbabb1b$var$formatDollars = (value)=>new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
        maximumFractionDigits: 2
    }).format(value);
const $65d89d752bbabb1b$var$isEmpty = (value)=>value.minAmount == null && value.maxAmount == null;
// A range collapsed onto one number: "show me the $42.30 charge". Expressed
// as equal bounds rather than its own filter shape, so the query arguments,
// the URL, and the server's inclusive comparison are all unchanged — the
// shortcut is in the UI, not in the data.
const $65d89d752bbabb1b$var$isExact = (value)=>value.minAmount != null && value.minAmount === value.maxAmount;
// A bound the user typed: empty (or zero, which excludes nothing) reads as no
// bound at all rather than a filter for exactly-zero rows.
const $65d89d752bbabb1b$var$parseDraft = (draft)=>{
    const trimmed = draft.trim();
    if (!trimmed) return null;
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};
const $65d89d752bbabb1b$export$fd5db897b9e8f4da = ({ value: value, onChange: onChange })=>{
    const [menuOpen, setMenuOpen] = $acw62.useState(false);
    // Free-typed text, committed as bounds on blur/Enter. Re-seeded from the
    // committed value on every open and after every commit, so an outside reset
    // (e.g. the Transactions header's Reset filters) can't leave stale digits
    // behind the closed menu, and the two rows never disagree about what is
    // applied.
    const [exactDraft, setExactDraft] = $acw62.useState('');
    const [minDraft, setMinDraft] = $acw62.useState('');
    const [maxDraft, setMaxDraft] = $acw62.useState('');
    const seedDrafts = (v)=>{
        setExactDraft($65d89d752bbabb1b$var$isExact(v) ? String(v.minAmount) : '');
        setMinDraft(v.minAmount != null ? String(v.minAmount) : '');
        setMaxDraft(v.maxAmount != null ? String(v.maxAmount) : '');
    };
    const changeOpen = (open)=>{
        if (open) seedDrafts(value);
        setMenuOpen(open);
    };
    const apply = (bounds)=>{
        // A backwards range is an obvious slip of the keys; swapping beats
        // erroring inside a popover with no room for a message.
        const { minAmount: minAmount, maxAmount: maxAmount } = $65d89d752bbabb1b$export$4aff31cbe6af231b(bounds);
        seedDrafts({
            minAmount: minAmount,
            maxAmount: maxAmount
        });
        if (minAmount !== value.minAmount || maxAmount !== value.maxAmount) onChange({
            minAmount: minAmount,
            maxAmount: maxAmount
        });
    };
    const commitRange = ()=>{
        apply({
            minAmount: $65d89d752bbabb1b$var$parseDraft(minDraft),
            maxAmount: $65d89d752bbabb1b$var$parseDraft(maxDraft)
        });
    };
    // The exact box is a shortcut that writes both bounds at once. An empty one
    // commits nothing rather than clearing: this fires on every blur, including
    // tabbing down to the range inputs, and a filter that erased itself on the
    // way past would be worse than no shortcut. "Any amount" is how you clear.
    const commitExact = ()=>{
        const amount = $65d89d752bbabb1b$var$parseDraft(exactDraft);
        if (amount == null) return;
        apply({
            minAmount: amount,
            maxAmount: amount
        });
    };
    const handleKeyDown = (commit)=>(e)=>{
            if (e.key === 'Enter') {
                commit();
                setMenuOpen(false);
            }
        };
    const selectPreset = (preset)=>{
        onChange({
            minAmount: preset,
            maxAmount: null
        });
        changeOpen(false);
    };
    const clear = ()=>{
        onChange({
            minAmount: null,
            maxAmount: null
        });
        changeOpen(false);
    };
    const inputClassName = 'border-border bg-background text-foreground w-24 min-w-0 flex-1 rounded border px-2 py-1 text-sm';
    // Fixed-width row labels so the exact box and the range pair line up, and
    // so neither row needs a heading above it.
    const rowLabelClassName = 'text-muted-foreground w-11 shrink-0 text-sm';
    const menu = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$2ce9a4ab4bfc4b72), {
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: rowLabelClassName,
                            children: "Exact"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "number",
                            min: 0,
                            step: "any",
                            inputMode: "decimal",
                            placeholder: "Amount $",
                            "aria-label": "Exact amount in dollars",
                            value: exactDraft,
                            onChange: (e)=>setExactDraft(e.target.value),
                            onBlur: commitExact,
                            onKeyDown: handleKeyDown(commitExact),
                            className: inputClassName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: rowLabelClassName,
                            children: "Range"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "number",
                            min: 0,
                            step: "any",
                            inputMode: "decimal",
                            placeholder: "Min $",
                            "aria-label": "Minimum amount in dollars",
                            value: minDraft,
                            onChange: (e)=>setMinDraft(e.target.value),
                            onBlur: commitRange,
                            onKeyDown: handleKeyDown(commitRange),
                            className: inputClassName
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-muted-foreground text-sm",
                            children: "to"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "number",
                            min: 0,
                            step: "any",
                            inputMode: "decimal",
                            placeholder: "Max $",
                            "aria-label": "Maximum amount in dollars",
                            value: maxDraft,
                            onChange: (e)=>setMaxDraft(e.target.value),
                            onBlur: commitRange,
                            onKeyDown: handleKeyDown(commitRange),
                            className: inputClassName
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex min-h-0 flex-col overflow-y-auto py-1",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$20dc64867e1691d0), {
                    selected: $65d89d752bbabb1b$var$isEmpty(value),
                    onClick: clear,
                    label: "Any amount"
                }),
                $65d89d752bbabb1b$var$PRESETS.map((preset)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$20dc64867e1691d0), {
                        selected: value.minAmount === preset && value.maxAmount == null,
                        onClick: ()=>selectPreset(preset),
                        label: `\u{2265} ${$65d89d752bbabb1b$var$formatDollars(preset)}`
                    }, preset))
            ]
        })
    });
    const selectionLabel = $65d89d752bbabb1b$var$isExact(value) ? // back as a range would look like a bug in the pill.
    `= ${$65d89d752bbabb1b$var$formatDollars(value.minAmount ?? 0)}` : value.minAmount != null && value.maxAmount != null ? `${$65d89d752bbabb1b$var$formatDollars(value.minAmount)}\u{2013}${$65d89d752bbabb1b$var$formatDollars(value.maxAmount)}` : value.minAmount != null ? `\u{2265} ${$65d89d752bbabb1b$var$formatDollars(value.minAmount)}` : value.maxAmount != null ? `\u{2264} ${$65d89d752bbabb1b$var$formatDollars(value.maxAmount)}` : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $497d44d806a05c0a$export$2e2bcd8739ae039), {
        open: menuOpen,
        popoverContents: menu,
        popoverAnchor: "bottom-left",
        onOutsideClick: ()=>changeOpen(false),
        children: (anchorRef)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$af8a1e35241194a0), {
                anchorRef: anchorRef,
                onClick: ()=>changeOpen(!menuOpen),
                label: "Amount",
                value: selectionLabel,
                active: selectionLabel != null
            })
    });
};




/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $527b9d2547be6d0a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 5H3",
            key: "1qgfaw"
        }
    ],
    [
        "path",
        {
            d: "M12 19H3",
            key: "yhmn1j"
        }
    ],
    [
        "path",
        {
            d: "M14 3v4",
            key: "1sua03"
        }
    ],
    [
        "path",
        {
            d: "M16 17v4",
            key: "1q0r14"
        }
    ],
    [
        "path",
        {
            d: "M21 12h-9",
            key: "1o4lsq"
        }
    ],
    [
        "path",
        {
            d: "M21 19h-5",
            key: "1rlt1p"
        }
    ],
    [
        "path",
        {
            d: "M21 5h-7",
            key: "1oszz2"
        }
    ],
    [
        "path",
        {
            d: "M8 10v4",
            key: "tgpxqk"
        }
    ],
    [
        "path",
        {
            d: "M8 12H3",
            key: "a7s4jb"
        }
    ]
];
const $527b9d2547be6d0a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("sliders-horizontal", $527b9d2547be6d0a$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");







const $11c1f792a246c823$export$49acf422df288aa2 = ({ pills: pills, onReset: onReset })=>{
    const isMobile = (0, $d720d4657ad5543c$export$2b96349243a56116)();
    const [sheetOpen, setSheetOpen] = $acw62.useState(false);
    const activeCount = pills.filter((item)=>item.active).length;
    const reset = onReset ?? null;
    if (isMobile) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex min-w-0 items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setSheetOpen(true),
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('border-border flex shrink-0 items-center gap-1.5 rounded-full border px-3 py-1 text-sm whitespace-nowrap', activeCount > 0 ? 'text-foreground font-medium' : 'text-muted-foreground'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $527b9d2547be6d0a$export$2e2bcd8739ae039), {
                        className: "size-3.5"
                    }),
                    activeCount > 0 ? `Filters \xb7 ${activeCount}` : 'Filters'
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "no-scrollbar flex min-w-0 flex-1 items-center gap-2 overflow-x-auto",
                children: pills.filter((item)=>item.active).map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
                        children: item.pill
                    }, item.key))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72de694199324d9d$export$2e2bcd8739ae039), {
                children: sheetOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf217f12860fadff$export$2b77a92f1a5ad772), {
                    header: "Filters",
                    onRequestClose: ()=>setSheetOpen(false),
                    // A sheet as tall as its rows, not the full-height page a
                    // phone modal usually is.
                    className: "top-auto bottom-0 h-auto max-h-[85dvh] rounded-b-none",
                    footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            reset != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                className: "mr-auto",
                                onClick: reset,
                                children: "Reset"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                variant: "primary",
                                onClick: ()=>setSheetOpen(false),
                                children: "Done"
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$720e1e4f1cefa216).Provider, {
                        value: "row",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "-my-4 flex flex-col [&>*:last-child]:border-b-0",
                            children: pills.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
                                    children: item.pill
                                }, item.key))
                        })
                    })
                })
            })
        ]
    });
    const sorted = [
        ...pills
    ].sort((a, b)=>Number(b.active) - Number(a.active));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex min-w-0 items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "no-scrollbar flex min-w-0 flex-1 items-center gap-2 overflow-x-auto",
                children: sorted.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
                        children: item.pill
                    }, item.key))
            }),
            reset != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46b86c7aa98be263$export$4596b845258929e5), {
                onReset: reset
            })
        ]
    });
};











const $c48f8c83b4edf794$export$7ac2c54a204183bc = (value)=>value === 'reconciled' || value === 'unreconciled' ? value : 'all';
const $c48f8c83b4edf794$export$36acc80f0e75c1a = (filter)=>filter === 'reconciled' ? true : filter === 'unreconciled' ? false : undefined;
const $c48f8c83b4edf794$export$44e9e839b8b94c9e = ({ value: value, onChange: onChange })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
        label: "Reconciled",
        allLabel: "All",
        options: [
            {
                key: 'reconciled',
                label: 'Reconciled'
            },
            {
                key: 'unreconciled',
                label: 'Not reconciled'
            }
        ],
        value: value,
        onChange: (key)=>onChange($c48f8c83b4edf794$export$7ac2c54a204183bc(key))
    });







const $f3a74415a26d141b$var$ACTIVITY_LIMIT = 25;
// "2026-03-01" -> "Mar 1, 2026", for naming the edge the list pages past.
const $f3a74415a26d141b$var$formatBound = (date)=>(0, $0c0f91b069db95d9$export$6b862160d295c8e)(date).toFormat('MMM d, yyyy');
/**
 * Marks where the list leaves the date filter's window. The rows under it were
 * reached by paging past a bound, not by the filter — so a list that runs
 * wider than the pill above it says so, at the row where it starts.
 */ const $f3a74415a26d141b$var$OutsideWindowDivider = ({ label: label })=>// A separator rather than a plain div: it divides the list into the window
    // and what lies outside it, and the role is also what tells it apart from
    // the paging control of the same name at that end.
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "separator",
        "aria-label": label,
        className: "text-muted-foreground border-border bg-muted/40 border-y px-4 py-1.5 text-xs font-medium tracking-wide uppercase",
        children: label
    });
const $f3a74415a26d141b$export$e89e5028cb715ed2 = ()=>{
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const { data: accountsData } = (0, $ce9d9e524be20f53$export$cb6e321bdf608ddb)();
    const accounts = $acw62.useMemo(()=>accountsData?.allAccounts ?? [], [
        accountsData
    ]);
    // Filters live in the URL query string so they survive navigation: opening a
    // transaction and hitting back returns to the same filtered activity list.
    //
    // Each change is *pushed* rather than replaced, so the filters themselves
    // are navigable: browsing here is exploratory — narrow to an account, add a
    // date window, then a magnitude floor — and back is how you undo a step you
    // didn't mean to take, instead of rebuilding the previous view from the
    // menus. Opening a row and coming back still lands on the filters you left.
    const [searchParams, setParams] = (0, $80f2d9c5153b63bf$export$6ccd138e4a7ead58)({
        history: 'push'
    });
    const accountIds = $acw62.useMemo(()=>{
        const raw = searchParams.get('accounts');
        return raw ? raw.split(',') : [];
    }, [
        searchParams
    ]);
    const allocationFilter = (0, $25d6b5adca90bb97$export$72b1d89afdb38499)(searchParams.get('allocation'));
    const reconciledFilter = (0, $c48f8c83b4edf794$export$7ac2c54a204183bc)(searchParams.get('reconciled'));
    const dateFilter = {
        startDate: searchParams.get('startDate'),
        endDate: searchParams.get('endDate')
    };
    // Magnitude bounds, in dollars in the URL and cents on the query. A
    // hand-edited or shared URL can carry the pair backwards, which the server
    // rejects outright — swap it (as TransactionFilters does) rather than let
    // the whole page fall into its load-error state.
    const amountFilter = (0, $65d89d752bbabb1b$export$4aff31cbe6af231b)({
        minAmount: (0, $65d89d752bbabb1b$export$b4cdf1ea571241de)(searchParams.get('minAmount')),
        maxAmount: (0, $65d89d752bbabb1b$export$b4cdf1ea571241de)(searchParams.get('maxAmount'))
    });
    const search = searchParams.get('search') ?? '';
    // Every key the filter row owns, so Reset can clear them in one history
    // entry (and so "is anything filtered?" is one list, not seven conditions
    // that drift apart as filters are added).
    const activeFilterKeys = [
        accountIds.length > 0 ? 'accounts' : null,
        allocationFilter !== 'all' ? 'allocation' : null,
        reconciledFilter !== 'all' ? 'reconciled' : null,
        dateFilter.startDate != null ? 'startDate' : null,
        dateFilter.endDate != null ? 'endDate' : null,
        amountFilter.minAmount != null ? 'minAmount' : null,
        amountFilter.maxAmount != null ? 'maxAmount' : null,
        search !== '' ? 'search' : null
    ].filter((key)=>key != null);
    const resetFilters = ()=>{
        setParams(Object.fromEntries(activeFilterKeys.map((key)=>[
                key,
                null
            ])));
    };
    const filters = {
        includeProcessed: true,
        // The server unions accountId + accountIds; passing an empty array would
        // still narrow to nothing, so omit it entirely for the all-accounts view.
        accountIds: accountIds.length > 0 ? accountIds : undefined,
        allocated: allocationFilter === 'allocated' ? true : allocationFilter === 'unallocated' ? false : undefined,
        reconciled: (0, $c48f8c83b4edf794$export$36acc80f0e75c1a)(reconciledFilter),
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate,
        minAmount: (0, $65d89d752bbabb1b$export$2a80bd8c3223c35f)(amountFilter.minAmount),
        maxAmount: (0, $65d89d752bbabb1b$export$2a80bd8c3223c35f)(amountFilter.maxAmount),
        search: search || undefined,
        limit: $f3a74415a26d141b$var$ACTIVITY_LIMIT
    };
    const [loadRawTransactions, { loading: loading, error: error, data: data, fetchMore: fetchMore, networkStatus: networkStatus }] = (0, $ce9d9e524be20f53$export$d1531303a4748421)({
        notifyOnNetworkStatusChange: true
    });
    // This page's edge has been carried past that bound: a request was issued
    // for rows outside it, so the edge is no longer the filter's. It records
    // the *edge*, not the rows — outside rows can be deleted while the cursor
    // stays where the extension left it, and a later page must still be
    // requested unbounded or it would ask the server for rows older than a
    // cursor that is already older than the bound, and get nothing.
    //
    // Cleared only by `resetPagingState`, so it lives exactly as long as the
    // page it describes: a filter change or a base refetch replaces that page
    // and the fact retires with it. Reset on a failed request too, or a list
    // that never extended would look exhausted with no way to retry.
    const [extendedPastStart, setExtendedPastStart] = $acw62.useState(false);
    const [extendedPastEnd, setExtendedPastEnd] = $acw62.useState(false);
    // `hasMore` on the cached page answers for the older end only, so the newer
    // end keeps its own flag and spinner. Null is *unknown* rather than false:
    // only a fetch from that end can answer, and a page restored from the cache
    // on a return visit has never made one.
    const [hasNewer, setHasNewer] = $acw62.useState(null);
    // The scope whose newer request is in flight, rather than a bare flag. A
    // request outstanding when the filters change would otherwise keep the new
    // scope's spinner up and its control unclickable until the old one settled
    // — indefinitely, if it never does. Reading it as "mine" makes a stale
    // request invisible here the moment the scope changes.
    const [loadingNewerScope, setLoadingNewerScope] = $acw62.useState(null);
    // Advanced whenever the cached page is replaced, so a request issued
    // against the old one can be told apart from one issued against the new.
    const [pageGeneration, setPageGeneration] = $acw62.useState(0);
    const all = $acw62.useMemo(()=>data?.allRawTransactions?.items ?? [], [
        data
    ]);
    // `hasMore` and `endCursor` describe the older end of the cached page;
    // `startCursor` the newer end.
    const hasMore = data?.allRawTransactions?.hasMore ?? false;
    const endCursor = data?.allRawTransactions?.endCursor ?? null;
    const startCursor = data?.allRawTransactions?.startCursor ?? null;
    // Rows outside the filter's window, split off so each run can be introduced
    // by the bound it sits past. Sorted newest first, they can only be at the
    // ends — but the split is by date rather than by position, so a cache patch
    // that lands a row mid-list can't shift the boundary onto the wrong row.
    const { startDate: startDate, endDate: endDate } = dateFilter;
    const [newerRows, windowRows, olderRows] = $acw62.useMemo(()=>[
            endDate ? all.filter((rt)=>rt.date > endDate) : [],
            all.filter((rt)=>!(endDate && rt.date > endDate) && !(startDate && rt.date < startDate)),
            startDate ? all.filter((rt)=>rt.date < startDate) : []
        ], [
        all,
        startDate,
        endDate
    ]);
    // Whether the loaded list already runs past each bound — read from the rows
    // first and the click second. Apollo answers a remount from its cache, so
    // coming back to a list left extended restores the extended page; deriving
    // this from the rows recognizes that page for what it is, where a flag
    // reset on mount would send the next request back inside the bound and read
    // its empty answer as the end of the list.
    const pagedPastStart = olderRows.length > 0 || extendedPastStart;
    const pagedPastEnd = newerRows.length > 0 || extendedPastEnd;
    const handleUpdateRawTransactions = (0, $2f8143a39a28ff19$export$2e2bcd8739ae039)({
        client: client,
        filters: filters,
        // Rows a mutation creates are kept out of the cached page when they fall
        // outside the filters — but a page extended past a date bound is wider
        // than the variables that keyed it, so the check uses the window the list
        // is actually showing.
        matchFilters: pagedPastStart || pagedPastEnd ? {
            ...filters,
            startDate: pagedPastStart ? null : filters.startDate,
            endDate: pagedPastEnd ? null : filters.endDate
        } : undefined
    });
    const selectionState = (0, $026af87cc9705d5d$export$6d82c2edda5ea5bd)(all, []);
    const { clearSelection: clearSelection } = selectionState;
    const selectionActions = (0, $e809c44401bdca50$export$3e6527a98b3f5155)({
        selectionState: selectionState,
        onUpdate: handleUpdateRawTransactions,
        includeProcessed: true,
        // The Unallocated view excludes consumed rows server-side, so a row
        // consumed by a mutation must drop from the cached page too.
        removeFullyConsumed: allocationFilter === 'unallocated'
    });
    const gestures = (0, $28bb13ba9d3f9376$export$9227a5765cfbd955)({
        selectionState: selectionState,
        openCreate: selectionActions.openCreateForRow
    });
    // Page from the query's own cursors (surviving cache removals), guarded so a
    // repeated call can't append the same page twice. One guard per direction:
    // the two ends advance independently.
    const lastOlderCursor = $acw62.useRef(null);
    const lastNewerCursor = $acw62.useRef(null);
    // Everything the page holds *about the cached page* rather than about the
    // list: the guards against re-requesting a cursor, the exhausted-bound
    // claims, and the newer end's answer. It all describes one page, so it all
    // retires together — whichever way that page is replaced. Keeping it in one
    // place is the point: when the claims and the guards were reset separately,
    // a path that cleared one and not the other left the control offered and
    // inert, which is worse than not offering it.
    const resetPagingState = ()=>{
        // Retires every request issued against the page being replaced: their
        // answers describe rows that are no longer on screen.
        setPageGeneration((generation)=>generation + 1);
        lastOlderCursor.current = null;
        lastNewerCursor.current = null;
        setExtendedPastStart(false);
        setExtendedPastEnd(false);
        setHasNewer(null);
    };
    const handleReload = ()=>{
        clearSelection();
        resetPagingState();
        loadRawTransactions({
            variables: filters
        });
    };
    $acw62.useEffect(handleReload, [
        accountIds.join(','),
        allocationFilter,
        reconciledFilter,
        dateFilter.startDate,
        dateFilter.endDate,
        amountFilter.minAmount,
        amountFilter.maxAmount,
        search
    ]);
    // A refetch of the base query answers with a fresh bounded page, so a "that
    // bound is exhausted" claim recorded against the old one is a claim about
    // rows the server has just been asked about again. Cursor equality can't
    // see this: a sync that imports only rows *outside* the window returns the
    // same in-window page, and with it the same cursor, so the claim would
    // survive the very event most likely to have falsified it.
    //
    // Clearing is the conservative direction. The claim only ever hides a
    // control, so dropping it costs one request if the bound really is still
    // exhausted, where keeping it wrongly leaves the newly imported rows
    // unreachable until the filter changes.
    $acw62.useEffect(()=>{
        if (networkStatus !== (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch) return;
        resetPagingState();
    }, [
        networkStatus
    ]);
    const loadedIds = (previous)=>new Set((previous.allRawTransactions?.items ?? []).map((rt)=>rt._id));
    // A merged page can't just be concatenated at the end it came from. A cache
    // mutation can move a row past the cursor the fetch was issued against — an
    // added or edited row newer than `startCursor` sorts to the front while the
    // cursor stays put — and the rows that come back are then not all newer
    // than everything already loaded. Sorting the merge is what keeps the list
    // newest-first regardless, and matches what `updateRawTransactions` does to
    // the same list.
    const sortNewestFirst = (items)=>[
            ...items
        ].sort((a, b)=>b.date.localeCompare(a.date));
    // Identifies the page a request was issued against. A fetch is answered by
    // whatever the observable query is watching *now*, so one still in flight
    // when the page changes underneath it would merge rows into a page they
    // don't belong to.
    //
    // The filters alone can't identify it: a refetch replaces the page without
    // changing them, so a newer fetch issued before a sync could land after it
    // and re-establish, from an answer computed against the old rows, exactly
    // the exhausted-bound state `resetPagingState` had just cleared. The
    // generation is what distinguishes those two pages — it advances whenever
    // the paging state retires, which is precisely when an outstanding request
    // stops describing what is on screen.
    //
    // Mirrored into a ref because the comparison happens in an async callback,
    // where the render's value would be the one captured at request time.
    const scopeToken = `${JSON.stringify(filters)}#${pageGeneration}`;
    const scopeTokenRef = $acw62.useRef(scopeToken);
    scopeTokenRef.current = scopeToken;
    // Appends the page of rows older than `cursor`. `unbounded` drops the
    // filter's start date, which is what paging past that bound means.
    const fetchOlder = (cursor, unbounded)=>{
        lastOlderCursor.current = cursor;
        const scope = scopeToken;
        fetchMore({
            variables: {
                ...filters,
                startDate: unbounded ? undefined : filters.startDate,
                beforeCursor: cursor
            },
            updateQuery: (previous, result)=>{
                // Answered after the filters moved on: these rows were selected by a
                // scope the page no longer shows, so drop them rather than merge them
                // into a page they don't belong to.
                if (scopeTokenRef.current !== scope) return previous;
                const page = result.fetchMoreResult?.allRawTransactions;
                const existingIds = loadedIds(previous);
                const moreItems = (page?.items ?? []).filter((rt)=>!existingIds.has(rt._id));
                return {
                    ...previous,
                    allRawTransactions: {
                        ...previous.allRawTransactions,
                        items: sortNewestFirst([
                            ...previous.allRawTransactions?.items ?? [],
                            ...moreItems
                        ]),
                        // An empty page carries no cursor; keeping the previous one leaves
                        // the guard above able to recognize a repeat of this request.
                        endCursor: page?.endCursor ?? previous.allRawTransactions?.endCursor ?? null,
                        hasMore: page?.hasMore ?? false
                    }
                };
            }
        }).catch(()=>{
            if (scopeTokenRef.current !== scope) return;
            lastOlderCursor.current = null;
            // A failed page must not leave the list looking exhausted: put the
            // offer back so the click can be retried. Harmless when an earlier
            // extension landed rows — those keep `pagedPastStart` true on their own.
            if (unbounded) setExtendedPastStart(false);
        });
    };
    // The mirror image, prepending rows newer than `cursor`.
    const fetchNewer = (cursor)=>{
        lastNewerCursor.current = cursor;
        const scope = scopeToken;
        setLoadingNewerScope(scope);
        fetchMore({
            variables: {
                ...filters,
                endDate: undefined,
                afterCursor: cursor
            },
            updateQuery: (previous, result)=>{
                if (scopeTokenRef.current !== scope) return previous;
                const page = result.fetchMoreResult?.allRawTransactions;
                const existingIds = loadedIds(previous);
                const moreItems = (page?.items ?? []).filter((rt)=>!existingIds.has(rt._id));
                return {
                    ...previous,
                    allRawTransactions: {
                        ...previous.allRawTransactions,
                        items: sortNewestFirst([
                            ...moreItems,
                            ...previous.allRawTransactions?.items ?? []
                        ]),
                        // `hasMore` and `endCursor` belong to the older end of the list; a
                        // page fetched from the newer end must not answer for them, or
                        // reaching the newest row would read as reaching the oldest.
                        startCursor: page?.startCursor ?? previous.allRawTransactions?.startCursor ?? null
                    }
                };
            }
        }).then((result)=>{
            // Same as the merge: an answer from a scope the page has left says
            // nothing about the one it's showing, so leave `hasNewer` unknown.
            if (scopeTokenRef.current !== scope) return;
            setHasNewer(result.data?.allRawTransactions?.hasMore ?? false);
        }).catch(()=>{
            if (scopeTokenRef.current !== scope) return;
            lastNewerCursor.current = null;
            // Same as fetchOlder: a failure returns the control, and `hasNewer`
            // stays unknown rather than answering "no" on the strength of it.
            setExtendedPastEnd(false);
        }).finally(()=>{
            // Only ever clears its own: a late resolution must not take down a
            // spinner the current scope raised for a request still running.
            setLoadingNewerScope((current)=>current === scope ? null : current);
        });
    };
    // Only the current scope's request shows here; a stale one is invisible.
    const loadingNewer = loadingNewerScope === scopeToken;
    const isEmpty = all.length === 0;
    const handleMore = ()=>{
        if (loading) return;
        if (hasMore) {
            if (endCursor && lastOlderCursor.current !== endCursor) fetchOlder(endCursor, pagedPastStart);
            return;
        }
        // The window is exhausted: keep going past the filter's older bound.
        if (pagedPastStart || !startDate) return;
        if (!endCursor) {
            // No row to page from — and no scroll position or loaded page to
            // preserve either, so dropping the bound from the filter itself is the
            // same list in one request, with a URL that still says what is being
            // shown. Keyed on the cursor rather than on the row count: a page a
            // mutation emptied keeps its cursor, and paging from it is more precise
            // than widening.
            setParams({
                startDate: null
            });
            return;
        }
        setExtendedPastStart(true);
        fetchOlder(endCursor, true);
    };
    const handleMoreNewer = ()=>{
        if (loading || loadingNewer) return;
        // An empty window has no cursor, and this end has no widening to fall
        // back on — see `canPageNewer`.
        if (!startCursor || lastNewerCursor.current === startCursor) return;
        setExtendedPastEnd(true);
        fetchNewer(startCursor);
    };
    // The older end can be extended once per bound; past it, the cached page's
    // own `hasMore` takes over. The newer end has no such stored answer, so it
    // offers while the window has an end bound and retires only once a fetch
    // from that end has come back empty. It is not gated on the bound being in
    // the past: future-dated rows exist, and a bound is exactly the thing that
    // would hide them.
    //
    // Only the older end is offered on a window with no anchor, which looks
    // lopsided and isn't. With no cursor to page from, the control has to widen
    // the filter instead — and dropping the *start* date leaves an upper bound,
    // so a newest-first page lands on the rows just older than the window,
    // which is what was asked for. Dropping the *end* date leaves no upper
    // bound and lands on the newest rows in the account, which may be years
    // past the window. Reaching the rows just newer than a date needs the
    // server to paginate ascending from it, and `afterCursor` is opaque, so
    // there is nothing honest to anchor to yet (see todo/ledger-paging-edges.md).
    //
    // The test is the cursor, not the row count: a page a mutation emptied
    // keeps its `startCursor`, so it still has a real anchor and the control
    // still works. Only a window that never had rows has nothing to offer.
    const canPageOlder = !hasMore && !pagedPastStart && Boolean(startDate) && Boolean(data);
    const canPageNewer = startCursor !== null && Boolean(data) && (pagedPastEnd ? hasNewer !== false : Boolean(endDate));
    const rowProps = {
        ...gestures.rowProps,
        showProcessedStatus: true
    };
    let bodyContent;
    if (data) bodyContent = !isEmpty ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            endDate && newerRows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f3a74415a26d141b$var$OutsideWindowDivider, {
                        label: `Newer than ${$f3a74415a26d141b$var$formatBound(endDate)}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e054dd754d7f7b3$export$2e2bcd8739ae039), {
                        transactions: newerRows,
                        ...rowProps
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e054dd754d7f7b3$export$2e2bcd8739ae039), {
                transactions: windowRows,
                ...rowProps
            }),
            startDate && olderRows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f3a74415a26d141b$var$OutsideWindowDivider, {
                        label: `Older than ${$f3a74415a26d141b$var$formatBound(startDate)}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e054dd754d7f7b3$export$2e2bcd8739ae039), {
                        transactions: olderRows,
                        ...rowProps
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: allocationFilter === 'unallocated' ? 'Everything is allocated' : 'No transactions'
    });
    else if (error) bodyContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "Couldn't load activity."
    });
    else bodyContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
        size: "medium"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex h-full flex-col overflow-hidden",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex min-h-0 w-full flex-1 flex-col",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5789cc019e3b9369$export$8b251419efc915eb), {
                    selectionState: selectionState,
                    actions: selectionActions,
                    gestures: gestures,
                    showSyncButton: false,
                    // The search box rides the action row rather than the filter row: it
                    // needs a width the pills don't, and pairing it with the actions
                    // keeps the whole header to two rows on a phone.
                    extraActions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "min-w-0 flex-1 md:w-56 md:flex-none",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d5b3d85c2079de0$export$55d7609a8f1eccd2), {
                            initialQuery: search,
                            onSearch: (query)=>setParams({
                                    search: query
                                }),
                            inputProps: {
                                placeholder: 'Search'
                            }
                        })
                    }),
                    filterContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11c1f792a246c823$export$49acf422df288aa2), {
                        pills: [
                            {
                                key: 'dates',
                                active: dateFilter.startDate != null || dateFilter.endDate != null,
                                pill: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fb4243874d8f910$export$bfb275743ab18881), {
                                    value: dateFilter,
                                    onChange: (filter)=>setParams({
                                            startDate: filter.startDate,
                                            endDate: filter.endDate
                                        })
                                })
                            },
                            {
                                key: 'accounts',
                                active: accountIds.length > 0,
                                pill: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7e399d2cd4a15b28$export$e07fb7d96ed9d385), {
                                    accounts: accounts,
                                    value: accountIds,
                                    onChange: (ids)=>setParams({
                                            accounts: ids.join(',')
                                        })
                                })
                            },
                            {
                                key: 'allocation',
                                active: allocationFilter !== 'all',
                                pill: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25d6b5adca90bb97$export$e0ca7418676fa890), {
                                    value: allocationFilter,
                                    onChange: (filter)=>setParams({
                                            allocation: filter === 'all' ? null : filter
                                        })
                                })
                            },
                            {
                                key: 'reconciled',
                                active: reconciledFilter !== 'all',
                                pill: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c48f8c83b4edf794$export$44e9e839b8b94c9e), {
                                    value: reconciledFilter,
                                    onChange: (filter)=>setParams({
                                            reconciled: filter === 'all' ? null : filter
                                        })
                                })
                            },
                            {
                                key: 'amount',
                                active: amountFilter.minAmount != null || amountFilter.maxAmount != null,
                                pill: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $65d89d752bbabb1b$export$fd5db897b9e8f4da), {
                                    value: amountFilter,
                                    onChange: ({ minAmount: minAmount, maxAmount: maxAmount })=>setParams({
                                            minAmount: minAmount != null ? String(minAmount) : null,
                                            maxAmount: maxAmount != null ? String(maxAmount) : null
                                        })
                                })
                            }
                        ],
                        onReset: activeFilterKeys.length > 0 ? resetFilters : undefined
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82dd4a85a022dc3b$export$235db9c6287af77c), {
                    className: "min-h-0 w-full flex-1",
                    scrollStateKey: [
                        accountIds.join(','),
                        allocationFilter,
                        reconciledFilter,
                        dateFilter.startDate ?? '',
                        dateFilter.endDate ?? '',
                        amountFilter.minAmount ?? '',
                        amountFilter.maxAmount ?? '',
                        search
                    ].join('|'),
                    body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            canPageNewer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f474bccad37d15d6$export$7f94856880993f27), {
                                loading: loadingNewer,
                                hasMore: true,
                                onMore: handleMoreNewer,
                                label: pagedPastEnd || !endDate ? 'More newer' : `Newer than ${$f3a74415a26d141b$var$formatBound(endDate)}`
                            }),
                            bodyContent,
                            (!isEmpty || hasMore || canPageOlder) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f474bccad37d15d6$export$7f94856880993f27), {
                                loading: loading && !loadingNewer,
                                hasMore: hasMore || canPageOlder,
                                onMore: handleMore,
                                label: !hasMore && canPageOlder && startDate ? `Older than ${$f3a74415a26d141b$var$formatBound(startDate)}` : undefined
                            })
                        ]
                    })
                })
            ]
        })
    });
};








var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

const $620e6d3f9c6307d9$var$ListContent = (props)=>{
    const { ifEmpty: ifEmpty, renderItem: renderItem, loading: loading, error: error, data: data } = props;
    const ifLoading = props.ifLoading || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
        size: "medium"
    });
    const ifError = props.ifError || (()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            children: "error"
        }));
    const noData = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (noData && data) noData.current = false;
    });
    if (data) {
        if (data.length > 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
            children: data.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                    style: {
                        overflow: 'hidden'
                    },
                    layout: true,
                    initial: noData ? false : {
                        height: 0
                    },
                    animate: {
                        height: 'auto'
                    },
                    exit: {
                        height: 0
                    },
                    children: renderItem(item)
                }, item._id))
        });
        else return ifEmpty;
    } else if (error) return ifError({
        error: error
    });
    else if (loading) return ifLoading;
    else return ifLoading;
};
var $620e6d3f9c6307d9$export$2e2bcd8739ae039 = $620e6d3f9c6307d9$var$ListContent;







var $acw62 = parcelRequire("acw62");















const $d8cb54f7ccd33d2e$export$41df8fcd091094a2 = [
    (0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Spending,
    (0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Income
];
const $d8cb54f7ccd33d2e$export$24b20755aba944 = [
    (0, $ce9d9e524be20f53$export$41f0e3fcd76586db).CreditCardPayment,
    (0, $ce9d9e524be20f53$export$41f0e3fcd76586db).AccountTransfer,
    (0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Prepaid,
    (0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Refund,
    (0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Reimbursement,
    (0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Conversion,
    (0, $ce9d9e524be20f53$export$41f0e3fcd76586db).UntypedTransfer
];
const $d8cb54f7ccd33d2e$export$b9caea01985b9718 = {
    [(0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Spending]: 'Spending',
    [(0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Income]: 'Income',
    [(0, $ce9d9e524be20f53$export$41f0e3fcd76586db).CreditCardPayment]: (0, $d906535d40bd11c1$export$e5f08023f111098c)[(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).CreditCardPayment],
    [(0, $ce9d9e524be20f53$export$41f0e3fcd76586db).AccountTransfer]: (0, $d906535d40bd11c1$export$e5f08023f111098c)[(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).AccountTransfer],
    [(0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Prepaid]: (0, $d906535d40bd11c1$export$e5f08023f111098c)[(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Prepaid],
    [(0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Refund]: (0, $d906535d40bd11c1$export$e5f08023f111098c)[(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Refund],
    [(0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Reimbursement]: (0, $d906535d40bd11c1$export$e5f08023f111098c)[(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Reimbursement],
    [(0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Conversion]: (0, $d906535d40bd11c1$export$e5f08023f111098c)[(0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion],
    [(0, $ce9d9e524be20f53$export$41f0e3fcd76586db).UntypedTransfer]: 'No subtype'
};
const $d8cb54f7ccd33d2e$export$4a575512533ecd78 = (value)=>Object.keys($d8cb54f7ccd33d2e$export$b9caea01985b9718).includes(value);






var $f1q41 = parcelRequire("f1q41");


const $75595661f2cf46b5$var$isFieldFilterMatch = (value)=>value === (0, $ce9d9e524be20f53$export$9d6b5f78b73e2a8d).Exact || value === (0, $ce9d9e524be20f53$export$9d6b5f78b73e2a8d).Contains || value === (0, $ce9d9e524be20f53$export$9d6b5f78b73e2a8d).Regex || value === (0, $ce9d9e524be20f53$export$9d6b5f78b73e2a8d).Unset;
/**
 * URLs and saved filters from before the tiered Type filter carried an
 * exclusive netAmountFilter, plus transferTypes under BALANCED. Map them onto
 * the kinds they selected, so old links and revived localStorage keep
 * narrowing the same rows.
 */ const $75595661f2cf46b5$var$legacyKinds = (netAmountFilter, transferTypes)=>{
    if (netAmountFilter === (0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).Spending) return [
        (0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Spending
    ];
    if (netAmountFilter === (0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).Income) return [
        (0, $ce9d9e524be20f53$export$41f0e3fcd76586db).Income
    ];
    if (netAmountFilter === (0, $ce9d9e524be20f53$export$2e1a1b092c43cfb8).Balanced) {
        const subtypes = transferTypes?.filter((0, $d8cb54f7ccd33d2e$export$4a575512533ecd78)) ?? [];
        // BALANCED alone meant every transfer, which the tiered filter spells as
        // the whole Transfers group.
        return subtypes.length > 0 ? subtypes : [
            ...(0, $d8cb54f7ccd33d2e$export$24b20755aba944)
        ];
    }
    return null;
};
const $75595661f2cf46b5$var$extractor = (0, $375f147934bae838$exports.extract).shape({
    categories: (0, $375f147934bae838$exports.extract).nullable((0, $375f147934bae838$exports.extract).array((0, $375f147934bae838$exports.extract).string)),
    tags: (0, $375f147934bae838$exports.extract).nullable((0, $375f147934bae838$exports.extract).array((0, $375f147934bae838$exports.extract).string)),
    search: (0, $375f147934bae838$exports.extract).nullable((0, $375f147934bae838$exports.extract).string),
    fieldFilters: (0, $375f147934bae838$exports.extract).nullable((0, $375f147934bae838$exports.extract).array((0, $375f147934bae838$exports.extract).shape({
        fieldId: (0, $375f147934bae838$exports.extract).string,
        match: (0, $375f147934bae838$exports.extract).string,
        value: (0, $375f147934bae838$exports.extract).nullable((0, $375f147934bae838$exports.extract).string)
    }))),
    startDate: (0, $375f147934bae838$exports.extract).nullable((0, $375f147934bae838$exports.extract).string),
    endDate: (0, $375f147934bae838$exports.extract).nullable((0, $375f147934bae838$exports.extract).string),
    // nullish, not nullable: filters saved before these keys existed lack them
    // entirely, and a missing key must not throw away the rest of the filters.
    minAmount: (0, $375f147934bae838$exports.extract).nullish((0, $375f147934bae838$exports.extract).number),
    maxAmount: (0, $375f147934bae838$exports.extract).nullish((0, $375f147934bae838$exports.extract).number),
    kinds: (0, $375f147934bae838$exports.extract).nullish((0, $375f147934bae838$exports.extract).array((0, $375f147934bae838$exports.extract).string)),
    // Legacy keys, no longer written: nullish so their absence from new saves
    // is fine, kept readable so old saves map through legacyKinds.
    netAmountFilter: (0, $375f147934bae838$exports.extract).nullish((0, $375f147934bae838$exports.extract).string),
    transferTypes: (0, $375f147934bae838$exports.extract).nullish((0, $375f147934bae838$exports.extract).array((0, $375f147934bae838$exports.extract).string))
});
const $75595661f2cf46b5$export$24c6a3868cbe9851 = (filters, key)=>{
    window.localStorage.setItem(key, JSON.stringify(filters));
};
const $75595661f2cf46b5$export$e429458c9efa6908 = (sp, key)=>{
    if (sp.toString() === '') return $75595661f2cf46b5$var$TransactionFilters.fromLocalStorage(key).getOrElse($75595661f2cf46b5$var$TransactionFilters.empty);
    else return $75595661f2cf46b5$var$TransactionFilters.fromSearchParams(sp);
};
const $75595661f2cf46b5$var$empty = {
    categories: null,
    tags: null,
    search: null,
    fieldFilters: null,
    kinds: null,
    startDate: null,
    endDate: null,
    minAmount: null,
    maxAmount: null
};
class $75595661f2cf46b5$var$TransactionFilters {
    constructor(filters){
        this.merge = (overrides)=>{
            return new $75595661f2cf46b5$var$TransactionFilters({
                categories: this.categories,
                tags: this.tags,
                search: this.search,
                fieldFilters: this.fieldFilters,
                kinds: this.kinds,
                startDate: this.startDate,
                endDate: this.endDate,
                minAmount: this.minAmount,
                maxAmount: this.maxAmount,
                ...overrides
            });
        };
        this.toQueryString = ()=>{
            const { categories: categories, tags: tags, search: search, kinds: kinds, startDate: startDate, endDate: endDate, minAmount: minAmount, maxAmount: maxAmount } = this;
            // Through URLSearchParams so values are escaped: a search for "H&M"
            // must come back as "H&M", not as "H" plus a stray "M" parameter.
            // Commas stay readable — they join lists and are not a delimiter here.
            const params = new URLSearchParams();
            if (categories) params.set('categories', categories.join(','));
            if (tags) params.set('tags', tags.join(','));
            if (search) params.set('search', search);
            if (kinds) params.set('kinds', kinds.join(','));
            if (startDate) params.set('startDate', startDate);
            if (endDate) params.set('endDate', endDate);
            if (minAmount != null) params.set('minAmount', String(minAmount));
            if (maxAmount != null) params.set('maxAmount', String(maxAmount));
            return params.toString().replace(/%2C/g, ',');
        };
        this.equals = (other)=>{
            return this.categories?.sort().join(',') === other.categories?.sort().join(',') && this.tags?.sort().join(',') === other.tags?.sort().join(',') && this.search === other.search && JSON.stringify(this.fieldFilters) === JSON.stringify(other.fieldFilters) && this.kinds?.sort().join(',') === other.kinds?.sort().join(',') && this.startDate === other.startDate && this.endDate === other.endDate && this.minAmount === other.minAmount && this.maxAmount === other.maxAmount;
        };
        this.categories = filters.categories && filters.categories.length > 0 ? filters.categories : null;
        this.tags = filters.tags && filters.tags.length > 0 ? filters.tags : null;
        this.search = filters.search || null;
        this.fieldFilters = filters.fieldFilters && filters.fieldFilters.length > 0 ? filters.fieldFilters : null;
        this.kinds = filters.kinds && filters.kinds.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(filters.kinds) : null;
        this.startDate = filters.startDate || null;
        this.endDate = filters.endDate || null;
        // The server rejects negative or backwards magnitude bounds, and these
        // can arrive hand-typed in the URL or revived from older saved filters:
        // normalize (clamp to whole positive cents, swap a backwards pair)
        // before anything reads them.
        const bounds = (0, $65d89d752bbabb1b$export$4aff31cbe6af231b)({
            minAmount: filters.minAmount,
            maxAmount: filters.maxAmount
        });
        this.minAmount = bounds.minAmount;
        this.maxAmount = bounds.maxAmount;
    }
    static{
        this.empty = new $75595661f2cf46b5$var$TransactionFilters($75595661f2cf46b5$var$empty);
    }
    static{
        this.create = (values)=>$75595661f2cf46b5$var$TransactionFilters.empty.merge(values);
    }
    static{
        this.fromSearchParams = (sp)=>{
            // Hand-typed URLs can hold anything; unknown tokens are dropped here
            // rather than forwarded for the server to reject the whole query over.
            const kindsParam = sp.get('kinds');
            const kinds = kindsParam != null ? kindsParam.split(',').filter((0, $d8cb54f7ccd33d2e$export$4a575512533ecd78)) : $75595661f2cf46b5$var$legacyKinds(sp.get('netAmountFilter'), sp.get('transferTypes')?.split(','));
            return $75595661f2cf46b5$var$TransactionFilters.create({
                categories: (0, $f8f45ddea4959097$exports.Option)(sp.get('categories')).map((categories)=>categories.split(',')).getOrElse(null),
                tags: (0, $f8f45ddea4959097$exports.Option)(sp.get('tags')).map((tags)=>tags.split(',')).getOrElse(null),
                search: sp.get('search'),
                kinds: kinds,
                startDate: sp.get('startDate'),
                endDate: sp.get('endDate'),
                minAmount: (0, $65d89d752bbabb1b$export$b4cdf1ea571241de)(sp.get('minAmount')),
                maxAmount: (0, $65d89d752bbabb1b$export$b4cdf1ea571241de)(sp.get('maxAmount'))
            });
        };
    }
    static{
        this.fromLocalStorage = (key)=>{
            const savedFilters = window.localStorage.getItem(key);
            if (savedFilters) {
                const parsed = JSON.parse(savedFilters);
                return $75595661f2cf46b5$var$extractor(parsed).toOption().map((extracted)=>({
                        categories: extracted.categories,
                        tags: extracted.tags,
                        search: extracted.search,
                        fieldFilters: extracted.fieldFilters?.flatMap((f)=>{
                            if (!$75595661f2cf46b5$var$isFieldFilterMatch(f.match)) return [];
                            return [
                                {
                                    fieldId: f.fieldId,
                                    match: f.match,
                                    value: f.value
                                }
                            ];
                        }) ?? null,
                        kinds: extracted.kinds != null ? extracted.kinds.filter((0, $d8cb54f7ccd33d2e$export$4a575512533ecd78)) : $75595661f2cf46b5$var$legacyKinds(extracted.netAmountFilter, extracted.transferTypes),
                        startDate: extracted.startDate ?? null,
                        endDate: extracted.endDate ?? null,
                        minAmount: extracted.minAmount ?? null,
                        maxAmount: extracted.maxAmount ?? null
                    })).map($75595661f2cf46b5$var$TransactionFilters.create);
            } else return 0, $f8f45ddea4959097$exports.none;
        };
    }
}
var $75595661f2cf46b5$export$2e2bcd8739ae039 = $75595661f2cf46b5$var$TransactionFilters;


// The tiered Type menu: Payments (Spending, Income) then Transfers (the
// subtypes plus "No subtype"), each group header toggling its whole tier.
const $addadf5f5be1fcab$var$kindOptions = [
    ...(0, $d8cb54f7ccd33d2e$export$41df8fcd091094a2).map((kind)=>({
            key: kind,
            label: (0, $d8cb54f7ccd33d2e$export$b9caea01985b9718)[kind],
            group: 'Payments'
        })),
    ...(0, $d8cb54f7ccd33d2e$export$24b20755aba944).map((kind)=>({
            key: kind,
            label: (0, $d8cb54f7ccd33d2e$export$b9caea01985b9718)[kind],
            group: 'Transfers'
        }))
];
const $addadf5f5be1fcab$export$8b251419efc915eb = (props)=>{
    const { filters: filters, isSelectMode: isSelectMode, onUpdateFilters: onUpdateFilters, onEnterSelectMode: onEnterSelectMode, onClearSelection: onClearSelection } = props;
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const anyModalOpen = modals.createRawTransactionModal.state.open || modals.importTransactionsModal.state.open;
    (0, $643289de0f480f5f$export$1b0c17123b4f3646)('a', (e)=>{
        if (anyModalOpen) return;
        if (isSelectMode) return;
        e.preventDefault();
        modals.createRawTransactionModal.openModal({});
    }, [
        isSelectMode,
        anyModalOpen
    ]);
    const openImport = $acw62.useCallback(()=>{
        modals.importTransactionsModal.openModal({});
    }, [
        modals.importTransactionsModal
    ]);
    (0, $643289de0f480f5f$export$1b0c17123b4f3646)('Escape', ()=>{
        if (isSelectMode) onClearSelection();
    }, [
        isSelectMode,
        onClearSelection
    ]);
    const hasActiveFilters = !filters.equals((0, $75595661f2cf46b5$export$2e2bcd8739ae039).empty);
    const headerContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11c1f792a246c823$export$49acf422df288aa2), {
        pills: [
            {
                key: 'dates',
                active: filters.startDate != null || filters.endDate != null,
                pill: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fb4243874d8f910$export$bfb275743ab18881), {
                    value: {
                        startDate: filters.startDate,
                        endDate: filters.endDate
                    },
                    onChange: ({ startDate: startDate, endDate: endDate })=>onUpdateFilters(filters.merge({
                            startDate: startDate,
                            endDate: endDate
                        }))
                })
            },
            {
                key: 'type',
                active: filters.kinds != null,
                pill: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43dfa5bdd4fb4a02$export$d21937a90300cd7a), {
                    multiple: true,
                    label: "Type",
                    allLabel: "All Transactions",
                    options: $addadf5f5be1fcab$var$kindOptions,
                    value: filters.kinds ?? [],
                    onChange: (keys)=>onUpdateFilters(filters.merge({
                            kinds: keys.filter((0, $d8cb54f7ccd33d2e$export$4a575512533ecd78))
                        }))
                })
            },
            {
                key: 'amount',
                active: filters.minAmount != null || filters.maxAmount != null,
                pill: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $65d89d752bbabb1b$export$fd5db897b9e8f4da), {
                    value: {
                        minAmount: filters.minAmount,
                        maxAmount: filters.maxAmount
                    },
                    onChange: ({ minAmount: minAmount, maxAmount: maxAmount })=>onUpdateFilters(filters.merge({
                            minAmount: minAmount,
                            maxAmount: maxAmount
                        }))
                })
            },
            {
                key: 'categories',
                active: filters.categories != null,
                pill: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21c7fd562fd4701$export$d3e643d9d6f4fa7f), {
                    categories: filters.categories,
                    setCategories: (categories)=>onUpdateFilters(filters.merge({
                            categories: categories
                        }))
                })
            },
            {
                key: 'dimensions',
                active: filters.tags != null || filters.fieldFilters != null,
                pill: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $210ce82bb39e8417$export$e38bc1a2c4737950), {
                    tags: filters.tags,
                    setTags: (tags)=>onUpdateFilters(filters.merge({
                            tags: tags
                        })),
                    fieldFilters: filters.fieldFilters,
                    setFieldFilters: (fieldFilters)=>onUpdateFilters(filters.merge({
                            fieldFilters: fieldFilters
                        }))
                })
            }
        ],
        onReset: hasActiveFilters ? ()=>onUpdateFilters((0, $75595661f2cf46b5$export$2e2bcd8739ae039).empty) : undefined
    });
    const overflowMenu = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49e34d17f9b50791$export$32b7bd840a1eba80), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: ()=>modals.createRawTransactionModal.openModal({}),
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {}),
                children: "Add transaction"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
                onSelect: openImport,
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05c245c7dcd30f27$export$2e2bcd8739ae039), {}),
                children: "Import"
            })
        ]
    });
    // The search box rides the action row rather than the filter row (same as
    // the Activity page): it needs a width the pills don't, and pairing it with
    // Select and the overflow menu keeps the whole header to two rows on a
    // phone. The selection itself lives in the selection bar, so the filters
    // stay put while selecting.
    const actions = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-w-0 flex-1 md:w-56 md:flex-none",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d5b3d85c2079de0$export$55d7609a8f1eccd2), {
                    initialQuery: filters.search,
                    onSearch: (search)=>onUpdateFilters(filters.merge({
                            search: search
                        })),
                    inputProps: {
                        placeholder: 'Search'
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                className: "shrink-0 gap-1.5 text-sm max-md:px-2.5",
                onClick: isSelectMode ? onClearSelection : onEnterSelectMode,
                "aria-pressed": isSelectMode,
                "aria-label": isSelectMode ? 'Done selecting' : 'Select transactions',
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $131c05e6196e399a$export$2e2bcd8739ae039), {
                        className: "h-4 w-4"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "max-md:hidden",
                        children: isSelectMode ? 'Done' : 'Select'
                    })
                ]
            }),
            overflowMenu
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $833f55a7ff2d0d4a$export$2e2bcd8739ae039), {
        content: headerContent,
        actions: actions,
        stackActionsOnMobile: true
    });
};







/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ec781acee04dc321$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m8 6 4-4 4 4",
            key: "ybng9g"
        }
    ],
    [
        "path",
        {
            d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22",
            key: "1hyw0i"
        }
    ],
    [
        "path",
        {
            d: "m20 22-5-5",
            key: "1m27yz"
        }
    ]
];
const $ec781acee04dc321$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("merge", $ec781acee04dc321$export$3efd853dbb351e94);


parcelRequire("acw62");





const $da7df7f93029d529$export$7c694392bb71e5e5 = ({ open: open, selected: selected, onDone: onDone })=>{
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const sums = (0, $eb9c0713007ac1dd$export$d51151e4f01b4b50)(selected.map((tx)=>({
            amount: tx.netAmount,
            currency: tx.currency
        })));
    // Merged transactions must share one currency, and conversions can't merge
    // at all (their lines span two currencies). The server rejects both.
    const hasConversion = selected.some((tx)=>tx.transferType === (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion);
    const canMerge = selected.length >= 2 && sums.length === 1 && !hasConversion;
    // A save can move rows out of the filters the list was loaded with (a new
    // category, tag, or note), and Apollo won't recompute a cached list's
    // membership, so the list refetches. The selection holds the pre-save
    // fragments, so it ends too — a second edit from them would write stale
    // values back.
    const handleSaved = ()=>{
        client.cache.evict({
            id: 'ROOT_QUERY',
            fieldName: 'transactions'
        });
        client.cache.gc();
        onDone();
    };
    const edit = ()=>{
        if (selected.length === 1) modals.editTransactionModal.openModal({
            transaction: selected[0],
            onSaved: handleSaved
        });
        else if (selected.length > 1) modals.bulkEditTransactionsModal.openModal({
            transactions: selected,
            onSaved: handleSaved
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3510f079d0deb75$export$fb0f67804b6488a4), {
        open: open,
        count: selected.length,
        total: sums.map((sum)=>formatMoney(sum)).join(" \xb7 "),
        menuItems: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $697be26d3ac7a8ca$export$2e2bcd8739ae039), {
            onSelect: ()=>modals.mergeTransactionsModal.openModal({
                    transactions: selected,
                    onSuccess: onDone
                }),
            disabled: !canMerge,
            iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec781acee04dc321$export$2e2bcd8739ae039), {}),
            children: "Merge"
        }),
        primary: {
            label: 'Edit',
            onClick: edit
        },
        onCancel: onDone
    });
};



const $a2165ffc4f6c77e4$var$localStorageKey = 'transactionFilters';
const $a2165ffc4f6c77e4$export$bb1a96a334f100f0 = ()=>{
    const navigationType = (0, $926608a7a86d7371$export$1b3f31771c5d07c)();
    const [searchParams, setSearchParams] = (0, $0c90f43fc3673aef$export$f1a78c17382fe22a)();
    const initialFilters = (0, $75595661f2cf46b5$export$e429458c9efa6908)(searchParams, $a2165ffc4f6c77e4$var$localStorageKey);
    const [filters, setFilters] = $acw62.useState(initialFilters);
    // A filter the user changes pushes a history entry; bringing the URL into
    // the filters' own form (on mount, or after the URL changed underneath)
    // replaces it, so Back never steps through copies of the same list — e.g.
    // after the Ledger switches to this layer.
    const handleUpdateFilters = (newFilters, { replace: replace = false } = {})=>{
        (0, $75595661f2cf46b5$export$24c6a3868cbe9851)(newFilters, $a2165ffc4f6c77e4$var$localStorageKey);
        setSearchParams(newFilters.toQueryString(), {
            replace: replace
        });
        setFilters(newFilters);
    };
    $acw62.useEffect(()=>{
        setSearchParams(initialFilters.toQueryString(), {
            replace: true
        });
    }, []);
    $acw62.useEffect(()=>{
        if (searchParams.toString()) handleUpdateFilters((0, $75595661f2cf46b5$export$2e2bcd8739ae039).fromSearchParams(searchParams), {
            replace: true
        });
    }, [
        searchParams.toString()
    ]);
    const [loadTransactions, { loading: loading, error: error, data: data, fetchMore: fetchMore }] = (0, $ce9d9e524be20f53$export$ef9441937bc56420)({
        notifyOnNetworkStatusChange: true,
        // Back/forward re-renders the cached multi-page list instantly so
        // scroll restoration lands where the user left off; fresh navigations
        // still hit the network for up-to-date data.
        fetchPolicy: navigationType === (0, $6d23e34a443a4a03$export$e19cd5f9376f8cee).Pop ? 'cache-first' : 'network-only'
    });
    const pageData = data?.transactions;
    const all = pageData?.items ?? [];
    const variables = {
        categories: filters.categories,
        tags: filters.tags,
        search: filters.search,
        fieldFilters: filters.fieldFilters,
        kinds: filters.kinds,
        startDate: filters.startDate,
        endDate: filters.endDate,
        // Filter state carries dollars; the query args want cents.
        minAmount: (0, $65d89d752bbabb1b$export$2a80bd8c3223c35f)(filters.minAmount) ?? null,
        maxAmount: (0, $65d89d752bbabb1b$export$2a80bd8c3223c35f)(filters.maxAmount) ?? null
    };
    const selectionState = (0, $026af87cc9705d5d$export$6d82c2edda5ea5bd)(all, []);
    const { selected: selected, setSelected: setSelected, clearSelection: clearSelection } = selectionState;
    // Select mode is entered explicitly via the header button or implicitly by
    // long-pressing a row; the header's X (or Escape) exits both.
    const [explicitSelectMode, setExplicitSelectMode] = $acw62.useState(false);
    const exitSelectMode = ()=>{
        setExplicitSelectMode(false);
        clearSelection();
    };
    $acw62.useEffect(()=>{
        exitSelectMode();
        loadTransactions({
            variables: variables
        });
    }, [
        filters
    ]);
    const handleMore = ()=>{
        if (!fetchMore || !pageData?.hasMore || !pageData.endCursor) return;
        // Page merging happens in the cache (see the transactions field policy
        // in ApolloProvider), so the accumulated list survives navigation.
        fetchMore({
            variables: {
                ...variables,
                beforeCursor: pageData.endCursor
            }
        });
    };
    const isSelectMode = explicitSelectMode || selected.length > 0;
    const renderItem = (transaction)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f91f4119c6509632$export$2e2bcd8739ae039), {
            transaction: transaction,
            selected: selected.includes(transaction),
            isSelectMode: isSelectMode,
            onSelect: setSelected(transaction),
            onShiftSelect: ()=>selectionState.setShiftSelected(transaction)
        }, transaction._id);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $addadf5f5be1fcab$export$8b251419efc915eb), {
                filters: filters,
                isSelectMode: isSelectMode,
                onUpdateFilters: handleUpdateFilters,
                onEnterSelectMode: ()=>setExplicitSelectMode(true),
                onClearSelection: exitSelectMode
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82dd4a85a022dc3b$export$235db9c6287af77c), {
                // fieldFilters affect the query but are omitted from toQueryString,
                // so the URL alone cannot distinguish field-filtered list states.
                scrollStateKey: filters.fieldFilters ? JSON.stringify(filters.fieldFilters) : '',
                body: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $620e6d3f9c6307d9$export$2e2bcd8739ae039), {
                            loading: loading,
                            error: error,
                            data: all,
                            ifEmpty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
                                children: "No transactions"
                            }),
                            renderItem: renderItem
                        }),
                        all.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f474bccad37d15d6$export$7f94856880993f27), {
                            loading: loading,
                            hasMore: pageData?.hasMore ?? false,
                            onMore: handleMore
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da7df7f93029d529$export$7c694392bb71e5e5), {
                open: isSelectMode,
                selected: selected,
                onDone: exitSelectMode
            })
        ]
    });
};


const $56972fefe5e283d2$var$LAYERS = [
    {
        key: 'transactions',
        label: 'Transactions'
    },
    {
        key: 'activity',
        label: 'Activity'
    }
];
/**
 * Filters that mean the same thing on both layers, so they survive a switch.
 * Everything else names something only one layer has (categories and tags;
 * accounts and allocation) and is dropped.
 */ const $56972fefe5e283d2$var$SHARED_FILTER_KEYS = [
    'search',
    'startDate',
    'endDate',
    'minAmount',
    'maxAmount'
];
const $56972fefe5e283d2$export$c44708d2964ea82c = (params)=>params.get('layer') === 'activity' ? 'activity' : 'transactions';
const $56972fefe5e283d2$export$d860fd8b59a15ad0 = (params)=>$56972fefe5e283d2$export$c44708d2964ea82c(params) === 'activity' && params.get('view') === 'review' ? 'review' : 'all';
const $56972fefe5e283d2$export$57de0ac238e4e7a = (view)=>view === 'review' ? '/ledger?layer=activity&view=review' : '/ledger?layer=activity';
const $56972fefe5e283d2$export$a434bf79640982d4 = (current, layer)=>{
    const next = new URLSearchParams({
        layer: layer
    });
    for (const key of $56972fefe5e283d2$var$SHARED_FILTER_KEYS){
        const value = current.get(key);
        if (value != null) next.set(key, value);
    }
    return `/ledger?${next.toString()}`;
};
const $56972fefe5e283d2$export$53fc7b0c4a74de18 = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Ledger',
        reset: true
    });
    const [searchParams] = (0, $0c90f43fc3673aef$export$f1a78c17382fe22a)();
    const layer = $56972fefe5e283d2$export$c44708d2964ea82c(searchParams);
    const view = $56972fefe5e283d2$export$d860fd8b59a15ad0(searchParams);
    const { data: summaryData } = (0, $ce9d9e524be20f53$export$edf7816f5074c300)({
        skip: layer !== 'activity'
    });
    const reviewCount = summaryData?.inboxBacklogSummary.recentCount ?? null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex min-h-0 flex-1 flex-col overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border flex shrink-0 flex-wrap items-end justify-between gap-x-4 border-b px-4 pt-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                        "aria-label": "Ledger layer",
                        className: "flex gap-5",
                        children: $56972fefe5e283d2$var$LAYERS.map((option)=>{
                            const current = option.key === layer;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                // The current layer links to itself unchanged — a no-op, where
                                // the switch URL would drop its layer-only filters.
                                to: current ? `?${searchParams.toString()}` : $56972fefe5e283d2$export$a434bf79640982d4(searchParams, option.key),
                                "aria-current": current ? 'page' : undefined,
                                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('border-b-2 pb-2 text-sm font-medium no-underline transition', current ? 'border-primary text-foreground' : 'text-muted-foreground hover:text-foreground border-transparent'),
                                children: option.label
                            }, option.key);
                        })
                    }),
                    layer === 'activity' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                        "aria-label": "Activity view",
                        className: "mb-2 flex gap-1",
                        children: [
                            {
                                key: 'all',
                                label: 'All'
                            },
                            {
                                key: 'review',
                                label: 'Needs review'
                            }
                        ].map((option)=>{
                            const current = option.key === view;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                to: current ? `?${searchParams.toString()}` : $56972fefe5e283d2$export$57de0ac238e4e7a(option.key),
                                "aria-current": current ? 'page' : undefined,
                                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs no-underline transition', current ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted'),
                                children: [
                                    option.label,
                                    option.key === 'review' && reviewCount != null && reviewCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "tabular-nums opacity-80",
                                        children: reviewCount
                                    })
                                ]
                            }, option.key);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex min-h-0 flex-1 flex-col overflow-hidden",
                children: layer === 'transactions' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2165ffc4f6c77e4$export$bb1a96a334f100f0), {}) : view === 'review' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $099e0bbf7c7420da$export$4c3f144ef44053eb), {
                    variant: "full"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3a74415a26d141b$export$e89e5028cb715ed2), {})
            })
        ]
    });
};






/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2905799e904c1a8a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 16v5",
            key: "zza2cw"
        }
    ],
    [
        "path",
        {
            d: "M16 14v7",
            key: "1g90b9"
        }
    ],
    [
        "path",
        {
            d: "M20 10v11",
            key: "1iqoj0"
        }
    ],
    [
        "path",
        {
            d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15",
            key: "1fw8x9"
        }
    ],
    [
        "path",
        {
            d: "M4 18v3",
            key: "1yp0dc"
        }
    ],
    [
        "path",
        {
            d: "M8 14v7",
            key: "n3cwzv"
        }
    ]
];
const $2905799e904c1a8a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chart-no-axes-combined", $2905799e904c1a8a$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");






/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5f4bdaa89ec695b9$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            key: "1m3agn"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "9",
            r: "2",
            key: "af1f0g"
        }
    ],
    [
        "path",
        {
            d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
            key: "1xmnt7"
        }
    ]
];
const $5f4bdaa89ec695b9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("image", $5f4bdaa89ec695b9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $40c424bab0bc0a95$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
            key: "zw3jo"
        }
    ],
    [
        "path",
        {
            d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
            key: "1wduqc"
        }
    ],
    [
        "path",
        {
            d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
            key: "kqbvx6"
        }
    ]
];
const $40c424bab0bc0a95$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("layers", $40c424bab0bc0a95$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5473793717b51056$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 17 5-5-5-5",
            key: "1bji2h"
        }
    ],
    [
        "path",
        {
            d: "M21 12H9",
            key: "dn1m92"
        }
    ],
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ]
];
const $5473793717b51056$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("log-out", $5473793717b51056$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8572ce782cce49ee$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 22v-5",
            key: "1ega77"
        }
    ],
    [
        "path",
        {
            d: "M15 8V2",
            key: "18g5xt"
        }
    ],
    [
        "path",
        {
            d: "M17 8a1 1 0 0 1 1 1v4a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1z",
            key: "1xoxul"
        }
    ],
    [
        "path",
        {
            d: "M9 8V2",
            key: "14iosj"
        }
    ]
];
const $8572ce782cce49ee$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("plug", $8572ce782cce49ee$export$3efd853dbb351e94);


parcelRequire("acw62");




parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $ea1c59b72ef6a197$var$STORAGE_KEY = 'netWorth.revealed';
const $ea1c59b72ef6a197$var$loadRevealed = ()=>{
    try {
        return window.sessionStorage.getItem($ea1c59b72ef6a197$var$STORAGE_KEY) === '1';
    } catch  {
        // sessionStorage may be unavailable; start hidden.
        return false;
    }
};
const $ea1c59b72ef6a197$export$38544d70c0c90e8b = ()=>{
    try {
        window.sessionStorage.removeItem($ea1c59b72ef6a197$var$STORAGE_KEY);
    } catch  {
    // Best-effort; sessionStorage may be unavailable.
    }
};
const $ea1c59b72ef6a197$export$6cf5437de6ded9bb = ()=>{
    const [revealed, setRevealedState] = $acw62.useState($ea1c59b72ef6a197$var$loadRevealed);
    const setRevealed = $acw62.useCallback((next)=>{
        setRevealedState(next);
        try {
            if (next) window.sessionStorage.setItem($ea1c59b72ef6a197$var$STORAGE_KEY, '1');
            else window.sessionStorage.removeItem($ea1c59b72ef6a197$var$STORAGE_KEY);
        } catch  {
        // Best-effort; the reveal still applies until the page unmounts.
        }
    }, []);
    return [
        revealed,
        setRevealed
    ];
};





parcelRequire("acw62");

const $884578d2d7297b57$var$menuItemClass = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)([
    'group relative gap-2 flex min-w-0 flex-1 cursor-pointer flex-row items-center rounded-md px-3 py-1 w-full',
    'text-sidebar-foreground/70',
    'hover:bg-sidebar-accent has-[.action:hover]:hover:bg-transparent',
    '[&>svg]:size-4 [&>svg]:shrink-0'
], {
    variants: {
        isActive: {
            true: 'bg-sidebar-accent text-sidebar-accent-foreground font-normal',
            false: 'font-light'
        },
        isDragging: {
            true: 'border-sidebar-border bg-sidebar-accent/50 border',
            false: ''
        },
        level: {
            primary: 'text-md my-2',
            secondary: 'text-sm'
        }
    }
});
const $884578d2d7297b57$var$MenuItemContent = ({ iconLeft: iconLeft, iconRight: iconRight, label: label })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            iconLeft || null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-w-0 flex-1",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "block truncate text-left",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('action', '-my-1 flex flex-row items-center', 'pointer-events-none opacity-0', 'group-hover:pointer-events-auto group-hover:relative group-hover:opacity-100'),
                children: iconRight
            })
        ]
    });
};
const $884578d2d7297b57$export$519285cd418d549c = ({ path: path, queryString: queryString, isActive: isActive, isDragging: isDragging, iconLeft: iconLeft, iconRight: iconRight, label: label, level: level, onClick: onClick })=>{
    const match = !!(0, $926608a7a86d7371$export$6c330e8992e8a295)({
        path: path,
        end: true
    });
    const to = {
        pathname: path,
        search: queryString
    };
    const className = $884578d2d7297b57$var$menuItemClass({
        isActive: isActive ?? match,
        isDragging: isDragging,
        level: level ?? 'primary'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
        to: to,
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($884578d2d7297b57$var$MenuItemContent, {
            iconLeft: iconLeft,
            iconRight: iconRight,
            label: label
        })
    });
};
const $884578d2d7297b57$export$266a769812832828 = ({ iconLeft: iconLeft, iconRight: iconRight, label: label, ...rest })=>{
    const className = $884578d2d7297b57$var$menuItemClass({
        isActive: false,
        isDragging: false,
        level: 'primary'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ...rest,
        className: className,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($884578d2d7297b57$var$MenuItemContent, {
            iconLeft: iconLeft,
            iconRight: iconRight,
            label: label
        })
    });
};


const $e24e597302c703aa$export$a0973bcfe11b05c9 = ()=>{
    (0, $09fc5346bd733ea4$export$326e9553c5420a00)();
    (0, $ea1c59b72ef6a197$export$38544d70c0c90e8b)();
    // Server route from the BFF auth middleware: clears the session cookie
    // and the Auth0-side session, then returns to the app origin.
    window.location.assign('/logout');
};
const $e24e597302c703aa$var$LogoutButton = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$266a769812832828), {
        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {}),
        onClick: $e24e597302c703aa$export$a0973bcfe11b05c9,
        label: "Logout"
    });
var $e24e597302c703aa$export$2e2bcd8739ae039 = $e24e597302c703aa$var$LogoutButton;



const $53423000ad84ebd8$export$2db3b3648fd41ec1 = [
    {
        path: '/fields',
        label: 'Fields',
        description: "Named attributes on transactions \u2014 enum picks or freeform text",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40c424bab0bc0a95$export$2e2bcd8739ae039), {})
    },
    {
        path: '/units',
        label: 'Units',
        description: "Custom currencies for non-monetary wallets \u2014 passes, miles, credits",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ec88f95add56de8$export$2e2bcd8739ae039), {})
    },
    {
        path: '/payee-logos',
        label: 'Payee logos',
        description: 'Brand logos assigned per payee, shown on every matching transaction',
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f4bdaa89ec695b9$export$2e2bcd8739ae039), {})
    },
    {
        path: '/defaults',
        label: 'Defaults',
        description: 'Accounts and categories that recurring flows target automatically',
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $527b9d2547be6d0a$export$2e2bcd8739ae039), {})
    },
    {
        path: '/connections',
        label: 'Connections',
        description: 'Linked institutions, Plaid access tokens, and sync health',
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8572ce782cce49ee$export$2e2bcd8739ae039), {})
    }
];
const $53423000ad84ebd8$export$7d05e0deed78c249 = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Settings',
        reset: true
    });
    const isMobile = (0, $d720d4657ad5543c$export$2b96349243a56116)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-4 overflow-y-auto p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-lg font-semibold",
                        children: "Settings"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground text-sm",
                        children: "App configuration and connected services"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid gap-4 sm:grid-cols-2",
                children: $53423000ad84ebd8$export$2db3b3648fd41ec1.map((page)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                        to: page.path,
                        className: "border-border bg-card hover:bg-accent rounded-lg border p-4 transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-muted-foreground flex items-center gap-2 [&>svg]:size-4 [&>svg]:shrink-0",
                                children: [
                                    page.icon,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-foreground font-medium",
                                        children: page.label
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-muted-foreground mt-1 text-sm",
                                children: page.description
                            })
                        ]
                    }, page.path))
            }),
            isMobile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: (0, $e24e597302c703aa$export$a0973bcfe11b05c9),
                className: "border-border bg-card text-destructive flex cursor-pointer items-center gap-2 rounded-lg border p-4 text-left font-medium [&>svg]:size-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {}),
                    "Log out"
                ]
            })
        ]
    });
};




// Everything the tab bar doesn't hold, in the sidebar's order: the
// sidebar's folded "More" pages get a card of their own rather than a
// disclosure, since a sheet opened on purpose has the room.
const $ed8c617b0e987212$var$GROUPS = [
    [
        {
            path: '/analytics',
            label: 'Analytics',
            icon: (0, $2905799e904c1a8a$export$2e2bcd8739ae039)
        },
        {
            path: '/investments',
            label: 'Investments',
            icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039)
        }
    ],
    [
        {
            path: '/net-worth',
            label: 'Net worth',
            icon: (0, $0811c1891b547863$export$2e2bcd8739ae039)
        },
        {
            path: '/payroll',
            label: 'Payroll',
            icon: (0, $07139920b5ad0ce2$export$2e2bcd8739ae039)
        },
        {
            path: '/equity',
            label: 'Equity',
            icon: (0, $34c3e517ec92034a$export$2e2bcd8739ae039)
        },
        {
            path: '/benefits',
            label: 'Benefits',
            icon: (0, $6315759428919b56$export$2e2bcd8739ae039)
        }
    ],
    [
        {
            path: '/categories',
            label: 'Categories',
            icon: (0, $8872a1d80d2463f9$export$2e2bcd8739ae039)
        },
        {
            path: '/settings',
            label: 'Settings',
            icon: (0, $da03c070d837b197$export$2e2bcd8739ae039),
            within: (0, $53423000ad84ebd8$export$2db3b3648fd41ec1).map((page)=>page.path)
        }
    ]
];
const $ed8c617b0e987212$var$isAt = (pathname, place)=>[
        place.path,
        ...place.within ?? []
    ].some((path)=>pathname === path || pathname.startsWith(`${path}/`));
const $ed8c617b0e987212$export$3d49608eeba260fe = ({ open: open, onClose: onClose })=>{
    const { pathname: pathname } = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    const sheetRef = $acw62.useRef(null);
    // A modal sheet takes focus while it's open — the current place, else the
    // first — and hands it back to whatever opened it (More) when it closes.
    $acw62.useEffect(()=>{
        if (!open) return;
        const opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        const frame = requestAnimationFrame(()=>{
            const sheet = sheetRef.current;
            const target = sheet?.querySelector('[aria-current="page"]') ?? sheet?.querySelector('a');
            // Without moving the page behind; then within the sheet, which scrolls
            // on a short screen, so the focused row is never left off-screen.
            target?.focus({
                preventScroll: true
            });
            target?.scrollIntoView({
                block: 'nearest'
            });
        });
        return ()=>{
            cancelAnimationFrame(frame);
            opener?.focus({
                preventScroll: true
            });
        };
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        if (!open) return;
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleKeyDown);
        return ()=>window.removeEventListener('keydown', handleKeyDown);
    }, [
        open,
        onClose
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72de694199324d9d$export$2e2bcd8739ae039), {
        children: open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94339ef075b24dd2$export$c6fdb837b070b4ff), {
            onOverlayClick: onClose,
            dimBackground: true,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                ref: sheetRef,
                role: "dialog",
                "aria-modal": true,
                "aria-label": "More",
                initial: {
                    y: '100%'
                },
                animate: {
                    y: 0
                },
                exit: {
                    y: '100%'
                },
                transition: {
                    duration: 0.28,
                    ease: [
                        0.2,
                        0.8,
                        0.2,
                        1
                    ]
                },
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('bg-muted fixed inset-x-0 bottom-0 flex max-h-[92dvh] flex-col overflow-y-auto rounded-t-2xl', 'px-3.5 pb-[max(env(safe-area-inset-bottom),1rem)] shadow-[0_-8px_30px_rgba(0,0,0,0.18)]'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9feaa5924c876b6a$export$2e2bcd8739ae039), {
                    behavior: "trap",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex shrink-0 justify-center pt-2 pb-1.5",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "bg-muted-foreground/30 h-1.5 w-9 rounded-full"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                            "aria-label": "More places",
                            className: "flex flex-col gap-3.5 pt-1.5",
                            children: $ed8c617b0e987212$var$GROUPS.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-background ring-border flex flex-col overflow-hidden rounded-xl ring-1",
                                    children: group.map((place)=>{
                                        const active = $ed8c617b0e987212$var$isAt(pathname, place);
                                        const Icon = place.icon;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                            to: place.path,
                                            onClick: onClose,
                                            "aria-current": active ? 'page' : undefined,
                                            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-foreground relative flex min-h-[50px] items-center gap-3 px-3.5 text-base no-underline', // Dividers start past the icon, as in a grouped list.
                                            'not-first:before:bg-border not-first:before:absolute not-first:before:top-0 not-first:before:right-0 not-first:before:left-14 not-first:before:h-px', 'active:bg-muted', active && 'font-semibold'),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('flex size-[30px] shrink-0 items-center justify-center rounded-lg', active ? 'bg-primary text-primary-foreground' : 'bg-muted text-foreground'),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                                        className: "size-[18px]",
                                                        strokeWidth: active ? 2.25 : 1.75
                                                    })
                                                }),
                                                place.label
                                            ]
                                        }, place.path);
                                    })
                                }, group[0].path))
                        })
                    ]
                })
            })
        }, "more-sheet")
    });
};







/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b285ef0f6f9bf8bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $b285ef0f6f9bf8bf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("eye", $b285ef0f6f9bf8bf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $056e74b7b26d3329$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
            key: "ct8e1f"
        }
    ],
    [
        "path",
        {
            d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
            key: "151rxh"
        }
    ],
    [
        "path",
        {
            d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
            key: "13bj9a"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const $056e74b7b26d3329$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("eye-off", $056e74b7b26d3329$export$3efd853dbb351e94);



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");



const $c82641f1c27a498b$export$e14dab7236868a5 = "\u2022\u2022\u2022\u2022\u2022\u2022";
const $c82641f1c27a498b$var$wholeDollars = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});
const $c82641f1c27a498b$export$681285b165f871f = (cents)=>$c82641f1c27a498b$var$wholeDollars.format(Math.round(cents / 100));
const $c82641f1c27a498b$export$10f91d62690b335 = (cents)=>`${cents < 0 ? "\u2212" : '+'}${$c82641f1c27a498b$export$681285b165f871f(Math.abs(cents))}`;
const $c82641f1c27a498b$export$127388d0d1029689 = (share)=>{
    if (share > 0 && share < 0.005) return '<1%';
    return `${Math.round(share * 100)}%`;
};
/**
 * Past this, a percentage says more about how little was tracked at the
 * start than about growth ("+1,039,888% since Apr 2010").
 */ const $c82641f1c27a498b$var$MAX_MEANINGFUL_CHANGE = 10; // 1,000%
const $c82641f1c27a498b$export$861f00f1f30ae96d = (delta, base)=>{
    if (base === 0) return null;
    const ratio = delta / Math.abs(base);
    return Math.abs(ratio) > $c82641f1c27a498b$var$MAX_MEANINGFUL_CHANGE ? null : ratio;
};
const $c82641f1c27a498b$export$8dbb20f2bd92e70f = (ratio)=>{
    const percent = Math.abs(ratio * 100);
    const digits = percent < 10 ? 1 : 0;
    return `${ratio < 0 ? "\u2212" : '+'}${percent.toFixed(digits)}%`;
};
/**
 * Where a group's accounts live on the accounts page. Page routing, so it
 * lives here; a group missing from it links to the unfiltered list.
 */ const $c82641f1c27a498b$var$GROUP_ACCOUNT_TYPES = {
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Brokerage]: [
        'inv:brokerage'
    ],
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Retirement]: [
        'inv:401k',
        'inv:ira',
        'inv:roth_ira',
        'inv:hsa'
    ],
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Education]: [
        'inv:education'
    ],
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Cash]: [
        'dep:checking',
        'dep:savings',
        'dep:cash'
    ],
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).StoredValue]: [
        'dep:wallet'
    ],
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Spending]: [
        'dep:credit_card'
    ],
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Loans]: [
        'dep:loan'
    ],
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).SharedLedgers]: [
        'dep:ledger'
    ],
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Other]: [
        'dep:other',
        'inv:other'
    ]
};
const $c82641f1c27a498b$var$groupHref = (role)=>{
    if (role === (0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).CompanyStock) return '/equity';
    const types = $c82641f1c27a498b$var$GROUP_ACCOUNT_TYPES[role];
    return types ? `/accounts?type=${types.join(',')}` : '/accounts';
};
/**
 * The "Desert twilight" palette: dusk indigo and mauve, terracotta and
 * apricot, with a sky blue for contrast — as theme variables (globals.css)
 * so dark mode can re-step the deep ones lighter. Each group keeps its own
 * color — color follows the group, never its position — so a group
 * appearing or being hidden never recolors the rest.
 */ const $c82641f1c27a498b$var$GROUP_COLORS = {
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Brokerage]: 'var(--nw-brokerage)',
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Retirement]: 'var(--nw-retirement)',
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Education]: 'var(--nw-education)',
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).CompanyStock]: 'var(--nw-company-stock)',
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Cash]: 'var(--nw-cash)',
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).StoredValue]: 'var(--nw-stored-value)',
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Spending]: 'var(--nw-spending)',
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Loans]: 'var(--nw-loans)',
    [(0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).SharedLedgers]: 'var(--nw-shared-ledgers)'
};
/** For a group added on the server before it has a color here. */ const $c82641f1c27a498b$var$SPARE_COLORS = [
    '#7d9a7a',
    '#a86f4c',
    '#4f6d8f'
];
/** "Other" is neutral rather than a color of its own. */ const $c82641f1c27a498b$var$OTHER_COLOR = 'var(--muted-foreground)';
const $c82641f1c27a498b$export$c62fd5d3447ab72a = (groups)=>{
    let spare = 0;
    return new Map(groups.map((group)=>{
        const color = group.role === (0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).Other ? $c82641f1c27a498b$var$OTHER_COLOR : $c82641f1c27a498b$var$GROUP_COLORS[group.role] ?? $c82641f1c27a498b$var$SPARE_COLORS[spare++ % $c82641f1c27a498b$var$SPARE_COLORS.length];
        return [
            group.role,
            {
                label: group.label,
                note: group.note ?? null,
                color: color,
                href: $c82641f1c27a498b$var$groupHref(group.role)
            }
        ];
    }));
};
const $c82641f1c27a498b$export$80cb9ae906a6980a = (meta, role)=>meta.get(role) ?? {
        label: role,
        note: null,
        color: $c82641f1c27a498b$var$OTHER_COLOR,
        href: $c82641f1c27a498b$var$groupHref(role)
    };


/** How many horizontal gridlines the value axis aims for. */ const $52d478e26f78b962$var$TICK_COUNT = 9;
/** The groups drawn, in tooltip order. */ const $52d478e26f78b962$var$seriesFor = (roles, meta)=>roles.map((role)=>({
            key: role,
            label: (0, $c82641f1c27a498b$export$80cb9ae906a6980a)(meta, role).label,
            color: (0, $c82641f1c27a498b$export$80cb9ae906a6980a)(meta, role).color,
            valueOf: (row)=>row[role]
        }));
/**
 * The lowest and highest value drawn: stacked by sign, positives pile up
 * from zero and negatives down.
 */ const $52d478e26f78b962$var$extentOf = (rows, roles)=>{
    let low = Infinity;
    let high = -Infinity;
    for (const row of rows){
        let up = 0;
        let down = 0;
        for (const role of roles){
            const value = row[role] ?? 0;
            if (value > 0) up += value;
            else down += value;
        }
        low = Math.min(low, down);
        high = Math.max(high, up);
    }
    return Number.isFinite(low) ? [
        low,
        high
    ] : [
        0,
        0
    ];
};
/**
 * The round step (1, 2, 2.5 or 5 × a power of ten) whose tick count over
 * `range` comes closest to `count`.
 */ const $52d478e26f78b962$var$niceStep = (range, count)=>{
    const magnitude = 10 ** Math.floor(Math.log10(range / count));
    const candidates = [
        0.5,
        1,
        2,
        2.5,
        5,
        10
    ].map((nice)=>nice * magnitude);
    return candidates.reduce((best, step)=>Math.abs(range / step - count) < Math.abs(range / best - count) ? step : best);
};
/**
 * The value axis: fitted to what's drawn, with a little headroom, rather
 * than rounded out to wide ticks — a net worth that has never been
 * negative gets no negative band, and one with small debts gets only as
 * much room below zero as they take. Gridlines at round values inside it.
 */ const $52d478e26f78b962$var$valueAxis = ([low, high])=>{
    const span = high - low || Math.abs(high) || 100;
    const pad = span * 0.04;
    const domainLow = low >= 0 ? Math.max(0, low - pad) : low - pad;
    const domainHigh = high + pad;
    const step = $52d478e26f78b962$var$niceStep(domainHigh - domainLow, $52d478e26f78b962$var$TICK_COUNT);
    // By index, so no floating-point drift accumulates; `+ 0` turns the -0
    // that rounding up from below zero gives into 0 (never "-$0").
    const first = Math.ceil(domainLow / step);
    const ticks = [];
    for(let index = first; index * step <= domainHigh; index++)ticks.push(index * step + 0);
    return {
        domain: [
            domainLow,
            domainHigh
        ],
        ticks: ticks
    };
};
const $52d478e26f78b962$var$ChartTooltip = ({ active: active, payload: payload, label: label, revealed: revealed, series: series })=>{
    if (!active || !payload?.length || label === undefined) return null;
    const row = payload[0].payload;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-card border-border rounded-lg border px-3 py-2 shadow-md",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground text-xs",
                children: (0, $63618293c58b5f80$exports.DateTime).fromMillis(label, {
                    zone: 'utc'
                }).toFormat('MMM d, yyyy')
            }),
            revealed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-1 flex flex-col gap-0.5",
                children: [
                    series.map((entry)=>{
                        const value = entry.valueOf(row);
                        if (value == null) return null;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between gap-4 text-xs",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "flex items-center gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "size-2 rounded-full",
                                            style: {
                                                backgroundColor: entry.color
                                            }
                                        }),
                                        entry.label
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-foreground font-medium tabular-nums",
                                    children: (0, $c82641f1c27a498b$export$681285b165f871f)(value)
                                })
                            ]
                        }, entry.key);
                    }),
                    series.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border-border mt-0.5 flex items-center justify-between gap-4 border-t pt-0.5 text-xs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Total shown"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-foreground font-medium tabular-nums",
                                children: (0, $c82641f1c27a498b$export$681285b165f871f)(row.total)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $52d478e26f78b962$var$compactDollars = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 1
});
const $52d478e26f78b962$export$9a4eab7e4c0411b6 = ({ points: points, roles: roles, meta: meta, revealed: revealed })=>{
    const data = $acw62.useMemo(()=>points.map((point)=>({
                timestamp: (0, $63618293c58b5f80$exports.DateTime).fromISO(point.date, {
                    zone: 'utc'
                }).toMillis(),
                total: point.total,
                ...point.byRole
            })), [
        points
    ]);
    const series = $52d478e26f78b962$var$seriesFor(roles, meta);
    const axis = $acw62.useMemo(()=>$52d478e26f78b962$var$valueAxis($52d478e26f78b962$var$extentOf(data, roles)), [
        data,
        roles
    ]);
    const firstTs = data[0]?.timestamp ?? 0;
    const lastTs = data[data.length - 1]?.timestamp ?? firstTs;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "h-72 sm:h-96",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
            width: "100%",
            height: "100%",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $669260e8074ac2f0$export$f881f4f9e4007a57), {
                data: data,
                stackOffset: "sign",
                margin: {
                    top: 8,
                    right: 8,
                    left: 0,
                    bottom: 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                        strokeDasharray: "3 3",
                        vertical: false,
                        className: "stroke-border"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                        dataKey: "timestamp",
                        scale: "time",
                        type: "number",
                        domain: [
                            'dataMin',
                            'dataMax'
                        ],
                        ticks: (0, $c45cbe94b11ffc58$export$2fd906f40273e9a6)(firstTs, lastTs),
                        tickFormatter: (0, $c45cbe94b11ffc58$export$2319624620038bd2)(firstTs, lastTs),
                        tick: {
                            fontSize: 11
                        },
                        className: "text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                        type: "number",
                        domain: axis.domain,
                        ticks: axis.ticks,
                        interval: 0,
                        tickFormatter: (cents)=>revealed ? $52d478e26f78b962$var$compactDollars.format(cents / 100) : "\u2022\u2022\u2022",
                        tick: {
                            fontSize: 11
                        },
                        width: 56,
                        className: "text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($52d478e26f78b962$var$ChartTooltip, {
                            revealed: revealed,
                            series: series
                        })
                    }),
                    roles.map((role)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                            type: "stepAfter",
                            dataKey: role,
                            stackId: "roles",
                            stroke: (0, $c82641f1c27a498b$export$80cb9ae906a6980a)(meta, role).color,
                            strokeWidth: 1,
                            fill: (0, $c82641f1c27a498b$export$80cb9ae906a6980a)(meta, role).color,
                            fillOpacity: 0.85,
                            dot: false,
                            isAnimationActive: false
                        }, role))
                ]
            })
        })
    });
};
const $52d478e26f78b962$export$f10e8b175d49eec5 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-muted/60 h-72 animate-pulse rounded-lg sm:h-96"
    });



const $67381c0703932097$export$24ae19ab0f2eacad = (netWorth, { requestedStart: requestedStart })=>{
    const { history: history, roleSeries: roleSeries } = netWorth;
    const lastIndex = history.length - 1;
    // With nothing ever recorded, today's values are all that's known.
    const floor = history[0]?.date ?? netWorth.asOf;
    const start = requestedStart > floor ? requestedStart : floor;
    // The standing value at the start, then every later point through today.
    let startIndex = 0;
    for(let index = 0; index < history.length; index++)if (history[index].date <= start) startIndex = index;
    const chartPoints = (hidden)=>{
        if (lastIndex < 0) return [];
        const shown = roleSeries.filter((series)=>!hidden.includes(series.role));
        const pointAt = (index, date)=>{
            const byRole = {};
            let total = 0;
            for (const series of shown){
                byRole[series.role] = series.totals[index];
                total += series.totals[index];
            }
            return {
                date: date,
                total: total,
                byRole: byRole
            };
        };
        return [
            pointAt(startIndex, start),
            ...history.flatMap((point, index)=>point.date > start ? [
                    pointAt(index, point.date)
                ] : [])
        ];
    };
    const totalOn = (date)=>{
        if (date < floor) return null;
        let index = -1;
        while(index + 1 < history.length && history[index + 1].date <= date)index++;
        return index < 0 ? null : history[index].total;
    };
    return {
        start: start,
        startTotal: lastIndex < 0 ? null : history[startIndex].total,
        changeByRole: new Map(roleSeries.map((series)=>[
                series.role,
                {
                    start: series.totals[startIndex] ?? 0,
                    end: series.totals[lastIndex] ?? 0
                }
            ])),
        totalOn: totalOn,
        chartPoints: chartPoints
    };
};



const $d3c2acfec4948f09$export$6ec90fc85e750cbf = '1970-01-01';
const $d3c2acfec4948f09$export$cbf76c7eab457a0b = [
    {
        key: '1m',
        label: '1M'
    },
    {
        key: '3m',
        label: '3M'
    },
    {
        key: 'ytd',
        label: 'YTD'
    },
    {
        key: '1y',
        label: '1Y'
    },
    {
        key: '3y',
        label: '3Y'
    },
    {
        key: '5y',
        label: '5Y'
    },
    {
        key: '10y',
        label: '10Y'
    },
    {
        key: 'all',
        label: 'All'
    },
    {
        key: 'custom',
        label: 'Custom'
    }
];
const $d3c2acfec4948f09$export$6fc316f00e370847 = '1y';
const $d3c2acfec4948f09$export$ccd2c68328d5d883 = (key)=>$d3c2acfec4948f09$export$cbf76c7eab457a0b.find((period)=>period.key === key)?.key ?? $d3c2acfec4948f09$export$6fc316f00e370847;
const $d3c2acfec4948f09$export$4020122186ebb5bc = (since, today)=>{
    if (since == null || !/^\d{4}-\d{2}$/.test(since)) return null;
    const date = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(`${since}-01`);
    if (!date.isValid || date > today) return null;
    return date.toISODate();
};
const $d3c2acfec4948f09$export$cd60b42bd440715b = (key, today, since)=>{
    const iso = (date)=>date.toISODate() ?? '';
    switch(key){
        case '1m':
            return iso(today.minus({
                months: 1
            }));
        case '3m':
            return iso(today.minus({
                months: 3
            }));
        case 'ytd':
            return iso(today.startOf('year'));
        case '1y':
            return iso(today.minus({
                years: 1
            }));
        case '3y':
            return iso(today.minus({
                years: 3
            }));
        case '5y':
            return iso(today.minus({
                years: 5
            }));
        case '10y':
            return iso(today.minus({
                years: 10
            }));
        case 'all':
            return $d3c2acfec4948f09$export$6ec90fc85e750cbf;
        case 'custom':
            return $d3c2acfec4948f09$export$4020122186ebb5bc(since, today) ?? $d3c2acfec4948f09$export$cd60b42bd440715b($d3c2acfec4948f09$export$6fc316f00e370847, today, null);
    }
};
const $d3c2acfec4948f09$export$f2ef2aff5003557b = (key, requestedStart, actualStart)=>{
    if (key === 'all' || key === 'custom' || actualStart > requestedStart) return `since ${(0, $0c0f91b069db95d9$export$6b862160d295c8e)(actualStart).toFormat('MMM yyyy')}`;
    switch(key){
        case '1m':
            return 'over 1 month';
        case '3m':
            return 'over 3 months';
        case 'ytd':
            return 'this year';
        case '1y':
            return 'over 12 months';
        case '3y':
            return 'over 3 years';
        case '5y':
            return 'over 5 years';
        case '10y':
            return 'over 10 years';
    }
};


const $d1ed360c48cef970$export$5f9020c2720a74cd = (split, change)=>[
        {
            key: 'realized',
            label: 'Realized',
            cents: split.realized ?? null
        },
        {
            key: 'unrealized',
            label: 'Unrealized',
            cents: split.unrealized ?? null
        },
        // Market change that can't be split between realized and unrealized,
        // and what the checks couldn't explain: shown only when there is some.
        ...split.unclassified !== 0 ? [
            {
                key: 'unclassified',
                label: 'Unclassified',
                cents: split.unclassified ?? null
            }
        ] : [],
        ...split.residual !== 0 ? [
            {
                key: 'residual',
                label: 'Unexplained',
                cents: split.residual ?? null
            }
        ] : [],
        {
            key: 'income',
            label: 'Income',
            cents: split.income ?? null
        },
        {
            key: 'fees',
            label: 'Fees',
            cents: split.fees == null ? null : -split.fees
        },
        {
            key: 'else',
            label: 'Everything else',
            cents: split.investments == null || change == null ? null : change - split.investments
        }
    ];




/** A change as dollars and percent, or — hidden — percent (or direction). */ const $703c708530483efe$var$changeText = (delta, base, revealed)=>{
    const ratio = (0, $c82641f1c27a498b$export$861f00f1f30ae96d)(delta, base);
    if (revealed) return ratio != null ? `${(0, $c82641f1c27a498b$export$10f91d62690b335)(delta)} (${(0, $c82641f1c27a498b$export$8dbb20f2bd92e70f)(ratio)})` : (0, $c82641f1c27a498b$export$10f91d62690b335)(delta);
    // Hidden and with no meaningful percentage, direction is all that's left.
    if (ratio != null) return (0, $c82641f1c27a498b$export$8dbb20f2bd92e70f)(ratio);
    return delta > 0 ? 'Up' : delta < 0 ? 'Down' : '';
};
const $703c708530483efe$var$changeClass = (delta)=>(0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('tabular-nums', delta > 0 && 'text-positive', delta < 0 && 'text-destructive');
const $703c708530483efe$var$Change = ({ delta: delta, base: base, label: label, revealed: revealed })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: $703c708530483efe$var$changeClass(delta),
                children: $703c708530483efe$var$changeText(delta, base, revealed)
            }),
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground",
                children: label
            })
        ]
    });
/**
 * The groups in the URL's `hide` list (lowercase roles), in role order. An
 * older link's `stock=out` (from before any group could be hidden) still
 * hides company stock when there is no `hide` list.
 */ const $703c708530483efe$var$hiddenGroupsOf = (params)=>{
    const hide = params.get('hide');
    const tokens = new Set(hide == null ? params.get('stock') === 'out' ? [
        (0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).CompanyStock.toLowerCase()
    ] : [] : hide.split(',').map((token)=>token.trim()));
    return Object.values((0, $ce9d9e524be20f53$export$8b4ae5b47902f98d)).filter((role)=>tokens.has(role.toLowerCase()));
};
/**
 * The period's change by where it came from: what investments did, from
 * the gains split, and everything else (the rest of the change, which
 * includes what investments did before their records began; the heading
 * says when that is). Amounts follow the reveal (hidden, each reads as a
 * percent of where the period started).
 */ const $703c708530483efe$var$ChangeSplit = ({ from: from, to: to, change: change, base: base, revealed: revealed })=>{
    const { data: data, error: error, refetch: refetch } = (0, $ce9d9e524be20f53$export$c202ce6a22e6adcd)({
        variables: {
            from: from,
            to: to
        },
        fetchPolicy: 'cache-and-network'
    });
    if (data == null && error != null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-muted-foreground flex items-center gap-2 text-sm",
        children: [
            "Couldn't load investment returns.",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "underline",
                onClick: ()=>void refetch(),
                children: "Retry"
            })
        ]
    });
    if (data == null) return null;
    const split = data.netWorthInvestmentSplit;
    const lines = (0, $d1ed360c48cef970$export$5f9020c2720a74cd)(split, change);
    // What the parts don't cover, in full: when investment records start and
    // when some stop (each its own note: they can be different accounts'),
    // and which accounts aren't split, don't reconcile, or rest on estimates.
    const day = (iso)=>(0, $0c0f91b069db95d9$export$6b862160d295c8e)(iso).toFormat('MMM d, yyyy');
    const notes = [
        split.recordsFrom != null ? `Investment records from ${day(split.recordsFrom)}` : null,
        split.recordsThrough != null ? `Some investment records end ${day(split.recordsThrough)}` : null,
        split.unsplit.length > 0 ? `Not split: ${split.unsplit.join(', ')}` : null,
        split.unreconciled.length > 0 ? `Not reconciled: ${split.unreconciled.join(', ')}` : null,
        split.estimated.length > 0 ? `Estimated: ${split.estimated.join(', ')}` : null
    ].filter((note)=>note != null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        "aria-label": "Change by source",
        className: "flex flex-col gap-1.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-muted-foreground text-xs font-medium tracking-wide uppercase",
                children: "By source"
            }),
            notes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground text-xs",
                children: notes.join(" \xb7 ")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                className: "grid grid-cols-[auto_minmax(0,1fr)] gap-x-6 gap-y-1 text-sm sm:grid-cols-[auto_auto_auto_auto] sm:justify-start",
                children: lines.map((line)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                className: "text-muted-foreground",
                                children: line.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                className: line.cents == null || line.cents === 0 ? 'text-muted-foreground' : $703c708530483efe$var$changeClass(line.cents),
                                children: line.cents == null ? "\u2014" : line.cents === 0 ? revealed ? '$0' : '0%' : $703c708530483efe$var$changeText(line.cents, base, revealed)
                            })
                        ]
                    }, line.key))
            }),
            split.byTreatment.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                className: "group text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("summary", {
                        className: "text-muted-foreground flex w-fit cursor-pointer list-none items-center gap-1 text-xs [&::-webkit-details-marker]:hidden",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                className: "size-3.5 transition-transform group-open:rotate-90"
                            }),
                            "By tax treatment"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-1.5 grid w-fit grid-cols-[auto_auto_auto_auto] gap-x-6 gap-y-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground text-xs",
                                children: "Realized"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground text-xs",
                                children: "Unrealized"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground text-xs",
                                children: "Income"
                            }),
                            split.byTreatment.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground",
                                            children: (0, $15cd282b652e0b04$export$92aae25ec06ba9a8).find((treatment)=>treatment.key === row.taxTreatment)?.label ?? row.taxTreatment
                                        }),
                                        [
                                            [
                                                'realized',
                                                row.realized
                                            ],
                                            [
                                                'unrealized',
                                                row.unrealized
                                            ],
                                            [
                                                'income',
                                                row.income
                                            ]
                                        ].map(([part, cents])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: cents == null || cents === 0 ? 'text-muted-foreground' : $703c708530483efe$var$changeClass(cents),
                                                children: cents == null ? "\u2014" : cents === 0 ? revealed ? '$0' : '0%' : $703c708530483efe$var$changeText(cents, base, revealed)
                                            }, part))
                                    ]
                                }, row.taxTreatment))
                        ]
                    })
                ]
            })
        ]
    });
};
/**
 * The chart's legend, one chip per group holding something — and its
 * filter: pressed, a group is drawn; unpressed, it comes off the chart.
 * Only the chart: the headline and the groups below always count
 * everything.
 */ const $703c708530483efe$var$GroupLegend = ({ groups: groups, hidden: hidden, meta: meta, onToggle: onToggle })=>{
    // Even a lone group gets its chip: it is the only way back from a link
    // that hides it.
    if (groups.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "group",
        "aria-label": "Groups",
        className: "flex flex-wrap gap-1.5",
        children: groups.map((group)=>{
            const excluded = hidden.includes(group.role);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                "aria-pressed": !excluded,
                onClick: ()=>onToggle(group.role),
                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('border-border inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs transition', excluded ? 'text-muted-foreground border-dashed' : 'bg-muted/60 text-foreground'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "size-2 rounded-full border",
                        style: {
                            borderColor: (0, $c82641f1c27a498b$export$80cb9ae906a6980a)(meta, group.role).color,
                            backgroundColor: excluded ? 'transparent' : (0, $c82641f1c27a498b$export$80cb9ae906a6980a)(meta, group.role).color
                        }
                    }),
                    group.label
                ]
            }, group.role);
        })
    });
};
const $703c708530483efe$var$RoleGroup = ({ title: title, total: total, roles: roles, meta: meta, changeByRole: changeByRole, revealed: revealed })=>{
    if (roles.length === 0) return null;
    const groupTotal = Math.abs(total);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-muted-foreground border-border flex items-baseline justify-between border-b pb-1.5 text-xs font-medium tracking-wide uppercase",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tabular-nums",
                        children: revealed ? (0, $c82641f1c27a498b$export$681285b165f871f)(total) : (0, $c82641f1c27a498b$export$e14dab7236868a5)
                    })
                ]
            }),
            roles.map((role)=>{
                const share = groupTotal === 0 ? 0 : Math.abs(role.total) / groupTotal;
                // A group's change over the period, on the side its net sits on (a
                // group split across both sides would otherwise show it twice) —
                // and only once it existed at the period's start: a group that
                // started from nothing has no change worth a number.
                const change = changeByRole.get(role.role);
                const delta = change && change.start !== 0 && Math.sign(change.end) === Math.sign(role.total) ? change.end - change.start : 0;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                    to: (0, $c82641f1c27a498b$export$80cb9ae906a6980a)(meta, role.role).href,
                    className: "border-border hover:bg-muted-foreground/10 grid grid-cols-[minmax(0,1fr)_auto] items-center gap-x-3 gap-y-1.5 border-b px-1 py-2.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "flex min-w-0 items-baseline gap-1.5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "truncate text-sm font-medium",
                                    children: (0, $c82641f1c27a498b$export$80cb9ae906a6980a)(meta, role.role).label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground text-xs",
                                    children: role.accountCount
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "flex items-baseline justify-end gap-2 text-sm tabular-nums",
                            children: [
                                delta !== 0 && change && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('text-xs', $703c708530483efe$var$changeClass(delta)),
                                    children: $703c708530483efe$var$changeText(delta, change.start, revealed)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: revealed ? (0, $c82641f1c27a498b$export$681285b165f871f)(role.total) : (0, $c82641f1c27a498b$export$127388d0d1029689)(share)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "bg-muted col-span-2 h-1.5 overflow-hidden rounded-full",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "block h-full rounded-full",
                                style: {
                                    width: `${Math.max(share * 100, share > 0 ? 1 : 0)}%`,
                                    backgroundColor: (0, $c82641f1c27a498b$export$80cb9ae906a6980a)(meta, role.role).color
                                }
                            })
                        })
                    ]
                }, role.role);
            })
        ]
    });
};
const $703c708530483efe$var$AccountNote = ({ title: title, detail: detail, accounts: accounts })=>{
    if (accounts.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border-border rounded-md border p-3 text-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "font-medium",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground mt-0.5 text-xs",
                children: detail
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "mt-2 flex flex-col gap-1",
                children: accounts.map((account)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                            to: account.role === (0, $ce9d9e524be20f53$export$8b4ae5b47902f98d).CompanyStock ? '/equity' : `/accounts/${account.accountId}`,
                            className: "min-w-0 truncate underline-offset-2 hover:underline",
                            children: account.name
                        })
                    }, account.accountId))
            })
        ]
    });
};
const $703c708530483efe$var$Bar = ({ className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('bg-muted/60 animate-pulse rounded', className)
    });
/** The page's shape while its one load is in flight, so nothing jumps. */ const $703c708530483efe$var$NetWorthSkeleton = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-busy": "true",
        "aria-label": "Loading net worth",
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-start justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$Bar, {
                                className: "h-3 w-20"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$Bar, {
                                className: "h-8 w-44"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$Bar, {
                        className: "h-9 w-20 rounded-lg"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "-mt-3 flex flex-col gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$Bar, {
                        className: "h-4 w-48"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$Bar, {
                        className: "h-4 w-56"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$Bar, {
                        className: "h-7 w-80 max-w-full rounded-lg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-wrap gap-1.5",
                        children: [
                            'w-20',
                            'w-24',
                            'w-28',
                            'w-16',
                            'w-24'
                        ].map((width, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$Bar, {
                                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('h-5 rounded-full', width)
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52d478e26f78b962$export$f10e8b175d49eec5), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col gap-3",
                children: [
                    0,
                    1,
                    2,
                    3
                ].map((index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$Bar, {
                        className: "h-10 w-full"
                    }, index))
            })
        ]
    });
const $703c708530483efe$export$89010588e5feb9dc = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Net worth',
        reset: true
    });
    const [revealed, setRevealed] = (0, $ea1c59b72ef6a197$export$6cf5437de6ded9bb)();
    const [searchParams, setSearchParams] = (0, $0c90f43fc3673aef$export$f1a78c17382fe22a)();
    const period = (0, $d3c2acfec4948f09$export$ccd2c68328d5d883)(searchParams.get('period'));
    const since = searchParams.get('since');
    const hidden = $acw62.useMemo(()=>$703c708530483efe$var$hiddenGroupsOf(searchParams), [
        searchParams
    ]);
    const requestedStart = (0, $d3c2acfec4948f09$export$cd60b42bd440715b)(period, (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)(), since);
    const setParams = (changes)=>{
        const next = new URLSearchParams(searchParams);
        for (const [key, value] of Object.entries(changes))if (value == null) next.delete(key);
        else next.set(key, value);
        setSearchParams(next, {
            replace: true
        });
    };
    const { data: data, error: error, refetch: refetch } = (0, $ce9d9e524be20f53$export$77791f30fba5f4d)({
        variables: {
            startDate: (0, $d3c2acfec4948f09$export$6ec90fc85e750cbf)
        },
        fetchPolicy: 'cache-and-network'
    });
    const model = $acw62.useMemo(()=>data == null ? null : (0, $67381c0703932097$export$24ae19ab0f2eacad)(data.netWorth, {
            requestedStart: requestedStart
        }), [
        data,
        requestedStart
    ]);
    const points = $acw62.useMemo(()=>model == null ? [] : model.chartPoints(hidden), [
        model,
        hidden
    ]);
    if (data == null || model == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex-1 overflow-y-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "mx-auto flex max-w-3xl flex-col gap-4 p-4",
            children: error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col items-start gap-3 text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-destructive",
                        children: [
                            "Couldn't load net worth: ",
                            error.message
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        onClick: ()=>void refetch(),
                        children: "Retry"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$NetWorthSkeleton, {})
        })
    });
    const netWorth = data.netWorth;
    const meta = (0, $c82641f1c27a498b$export$c62fd5d3447ab72a)(netWorth.groups);
    const { total: total } = netWorth;
    const toggleGroup = (role)=>{
        const nextHidden = hidden.includes(role) ? hidden.filter((other)=>other !== role) : [
            ...hidden,
            role
        ];
        const hide = Object.values((0, $ce9d9e524be20f53$export$8b4ae5b47902f98d)).filter((value)=>nextHidden.includes(value)).map((value)=>value.toLowerCase()).join(',');
        // Once a chip is pressed, `hide` is the one source of truth.
        setParams({
            stock: null,
            hide: hide === '' ? null : hide
        });
    };
    const selectPeriod = (key)=>{
        if (key === 'custom') // Start from where the chart already begins.
        setParams({
            period: 'custom',
            since: since != null && (0, $d3c2acfec4948f09$export$4020122186ebb5bc)(since, (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)()) != null ? since : model.start.slice(0, 7)
        });
        else setParams({
            period: key === (0, $d3c2acfec4948f09$export$6fc316f00e370847) ? null : key,
            since: null
        });
    };
    const lastMonthEnd = (0, $0c0f91b069db95d9$export$6b862160d295c8e)(netWorth.asOf).startOf('month').minus({
        days: 1
    }).toISODate() ?? '';
    const monthBase = model.totalOn(lastMonthEnd);
    const periodBase = model.startTotal;
    const assetRoles = netWorth.roles.filter((role)=>role.total >= 0);
    const debtRoles = netWorth.roles.filter((role)=>role.total < 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex-1 overflow-y-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "mx-auto flex max-w-3xl flex-col gap-6 p-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-muted-foreground text-xs font-medium tracking-wide uppercase",
                                    children: "Net worth"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setRevealed(!revealed),
                                    className: "text-foreground mt-1 block text-left text-3xl font-semibold tracking-tight tabular-nums",
                                    "aria-label": revealed ? 'Hide amounts' : 'Show amounts',
                                    children: revealed ? (0, $c82641f1c27a498b$export$681285b165f871f)(total) : (0, $c82641f1c27a498b$export$e14dab7236868a5)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: "gap-1.5",
                            onClick: ()=>setRevealed(!revealed),
                            "aria-pressed": revealed,
                            children: [
                                revealed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056e74b7b26d3329$export$2e2bcd8739ae039), {
                                    className: "size-4"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b285ef0f6f9bf8bf$export$2e2bcd8739ae039), {
                                    className: "size-4"
                                }),
                                revealed ? 'Hide' : 'Show'
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "-mt-3 flex flex-col gap-0.5",
                    children: [
                        monthBase != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$Change, {
                            delta: total - monthBase,
                            base: monthBase,
                            label: `since ${(0, $0c0f91b069db95d9$export$6b862160d295c8e)(lastMonthEnd).toFormat('MMM d')}`,
                            revealed: revealed
                        }),
                        periodBase != null && points.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$Change, {
                            delta: total - periodBase,
                            base: periodBase,
                            label: (0, $d3c2acfec4948f09$export$f2ef2aff5003557b)(period, requestedStart, model.start),
                            revealed: revealed
                        })
                    ]
                }),
                periodBase != null && points.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$ChangeSplit, {
                    from: model.start,
                    to: netWorth.asOf,
                    change: total - periodBase,
                    base: periodBase,
                    revealed: revealed
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-wrap items-center justify-between gap-2",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex max-w-full min-w-0 flex-wrap items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3a3f2d83b280457$export$b038e237dc823aed), {
                                        label: "Period",
                                        options: (0, $d3c2acfec4948f09$export$cbf76c7eab457a0b),
                                        value: period,
                                        onChange: selectPeriod
                                    }),
                                    period === 'custom' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "text-muted-foreground inline-flex items-center gap-1.5 text-xs",
                                        children: [
                                            "Since",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "month",
                                                value: since != null && (0, $d3c2acfec4948f09$export$4020122186ebb5bc)(since, (0, $0c0f91b069db95d9$export$d0bdf45af03a6ea3)()) != null ? since : model.start.slice(0, 7),
                                                max: netWorth.asOf.slice(0, 7),
                                                onChange: (event)=>{
                                                    if (event.target.value !== '') setParams({
                                                        since: event.target.value
                                                    });
                                                },
                                                className: "border-border bg-background text-foreground rounded-md border px-2 py-0.5 text-xs"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$GroupLegend, {
                            // Only groups the chart can draw: one listed without a series
                            // (company stock that can't be valued) would be a dead toggle.
                            groups: netWorth.groups.filter((group)=>netWorth.roleSeries.some((series)=>series.role === group.role)),
                            hidden: hidden,
                            meta: meta,
                            onToggle: toggleGroup
                        }),
                        points.length > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52d478e26f78b962$export$9a4eab7e4c0411b6), {
                            points: points,
                            roles: netWorth.roleSeries.map((series)=>series.role).filter((role)=>!hidden.includes(role)),
                            meta: meta,
                            revealed: revealed
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground py-10 text-center text-sm",
                            children: "No balance history yet \u2014 only today\u2019s values are known."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground text-xs",
                            children: "Brief spikes are usually money moving between two accounts whose balances were recorded on different days."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-6 md:grid-cols-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$RoleGroup, {
                            title: "Assets",
                            total: assetRoles.reduce((sum, role)=>sum + role.total, 0),
                            roles: assetRoles,
                            meta: meta,
                            changeByRole: model.changeByRole,
                            revealed: revealed
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$RoleGroup, {
                            title: "Debts",
                            total: debtRoles.reduce((sum, role)=>sum + role.total, 0),
                            roles: debtRoles,
                            meta: meta,
                            changeByRole: model.changeByRole,
                            revealed: revealed
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($703c708530483efe$var$AccountNote, {
                    title: "Not counted",
                    detail: "Their dollar value is unknown: units with no dollar cost recorded behind them, or holdings priced in another currency.",
                    accounts: netWorth.unvaluedAccounts
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");

function $37621774baadbb77$export$7f80a7ae45fef160(count, flat, getItemKey) {
    const cache = new Array(count);
    return new Proxy(cache, {
        get (target, prop, receiver) {
            if (typeof prop === "string") {
                const c = prop.charCodeAt(0);
                if (c >= 48 && c <= 57) {
                    const i = +prop;
                    if (Number.isInteger(i) && i >= 0 && i < count) {
                        let v = target[i];
                        if (!v) {
                            const s = flat[i * 2];
                            v = target[i] = {
                                index: i,
                                key: getItemKey(i),
                                start: s,
                                size: flat[i * 2 + 1],
                                end: s + flat[i * 2 + 1],
                                lane: 0
                            };
                        }
                        return v;
                    }
                }
                if (prop === "length") return count;
            }
            return Reflect.get(target, prop, receiver);
        }
    });
}


function $af43570ba0a8567e$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    let isInitial = true;
    function memoizedFunction() {
        var _a;
        const debugEnabled = false;
        let depTime = 0;
        if (debugEnabled) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime = 0;
        if (debugEnabled) resultTime = Date.now();
        result = fn(...newDeps);
        if (debugEnabled) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        if ((opts == null ? void 0 : opts.onChange) && !(isInitial && opts.skipInitialOnChange)) opts.onChange(result);
        isInitial = false;
        return result;
    }
    memoizedFunction.updateDeps = (newDeps)=>{
        deps = newDeps;
    };
    return memoizedFunction;
}
function $af43570ba0a8567e$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $af43570ba0a8567e$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1.01;
const $af43570ba0a8567e$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return Object.assign(function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    }, {
        // The handle is closure-local, so a caller that has already
        // unsubscribed has no way to stop a queued call. Teardown paths use
        // this to drop the pending invocation instead of letting it land.
        cancel: ()=>{
            targetWindow.clearTimeout(timeoutId);
        }
    });
};


let $ae8077da5dad972b$var$_isIOSResult;
const $ae8077da5dad972b$var$isIOSWebKit = ()=>{
    if ($ae8077da5dad972b$var$_isIOSResult !== void 0) return $ae8077da5dad972b$var$_isIOSResult;
    if (typeof navigator === "undefined") return $ae8077da5dad972b$var$_isIOSResult = false;
    if (/iP(hone|od|ad)/.test(navigator.userAgent)) return $ae8077da5dad972b$var$_isIOSResult = true;
    const mtp = navigator.maxTouchPoints;
    return $ae8077da5dad972b$var$_isIOSResult = navigator.platform === "MacIntel" && mtp !== void 0 && mtp > 0;
};
const $ae8077da5dad972b$export$48219421215fc0ad = ()=>{
    $ae8077da5dad972b$var$_isIOSResult = void 0;
};
const $ae8077da5dad972b$var$getRect = (element)=>{
    const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = element;
    return {
        width: offsetWidth,
        height: offsetHeight
    };
};
const $ae8077da5dad972b$export$76974b428a49f15b = (index)=>index;
const $ae8077da5dad972b$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const len = end - start + 1;
    const arr = new Array(len);
    for(let i = 0; i < len; i++)arr[i] = start + i;
    return arr;
};
const $ae8077da5dad972b$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler($ae8077da5dad972b$var$getRect(element));
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const run = ()=>{
            const entry = entries[0];
            if (entry == null ? void 0 : entry.borderBoxSize) {
                const box = entry.borderBoxSize[0];
                if (box) {
                    handler({
                        width: box.inlineSize,
                        height: box.blockSize
                    });
                    return;
                }
            }
            handler($ae8077da5dad972b$var$getRect(element));
        };
        instance.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $ae8077da5dad972b$var$addEventListenerOptions = {
    passive: true
};
const $ae8077da5dad972b$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $ae8077da5dad972b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $ae8077da5dad972b$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $ae8077da5dad972b$var$observeOffset = (instance, cb, readOffset)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const registerScrollendEvent = instance.options.useScrollendEvent && $ae8077da5dad972b$var$supportsScrollend;
    let offset = 0;
    const fallback = registerScrollendEvent ? null : (0, $af43570ba0a8567e$export$61fc7d43ac8f84b0)(targetWindow, ()=>cb(offset, false), instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = readOffset(element);
            fallback == null || fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    element.addEventListener("scroll", handler, $ae8077da5dad972b$var$addEventListenerOptions);
    if (registerScrollendEvent) element.addEventListener("scrollend", endHandler, $ae8077da5dad972b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        if (registerScrollendEvent) element.removeEventListener("scrollend", endHandler);
        fallback == null || fallback.cancel();
    };
};
const $ae8077da5dad972b$export$fbc040aee017375a = (instance, cb)=>$ae8077da5dad972b$var$observeOffset(instance, cb, (el)=>{
        const { horizontal: horizontal, isRtl: isRtl } = instance.options;
        return horizontal ? el.scrollLeft * (isRtl && -1 || 1) : el.scrollTop;
    });
const $ae8077da5dad972b$export$518998f8c5d09287 = (instance, cb)=>$ae8077da5dad972b$var$observeOffset(instance, cb, (win)=>instance.options.horizontal ? win.scrollX : win.scrollY);
const $ae8077da5dad972b$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (instance.options.useCachedMeasurements) {
        const index = instance.indexFromElement(element);
        const key = instance.options.getItemKey(index);
        return instance.itemSizeCache.get(key) ?? instance.options.estimateSize(index);
    }
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    if (!entry) {
        const index = instance.indexFromElement(element);
        const key = instance.options.getItemKey(index);
        const cachedSize = instance.itemSizeCache.get(key);
        if (cachedSize !== void 0) return cachedSize;
    }
    return element[instance.options.horizontal ? "offsetWidth" : "offsetHeight"];
};
const $ae8077da5dad972b$var$scrollWithAdjustments = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: offset + adjustments,
        behavior: behavior
    });
};
const $ae8077da5dad972b$export$2162c5b3eeedd27 = $ae8077da5dad972b$var$scrollWithAdjustments;
const $ae8077da5dad972b$export$1cdb988e5ab69fe7 = $ae8077da5dad972b$var$scrollWithAdjustments;
class $ae8077da5dad972b$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollState = null;
        this.measurementsCache = [];
        this._flatMeasurements = null;
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.itemSizeCacheVersion = 0;
        this.laneAssignments = /* @__PURE__ */ new Map();
        this.pendingMin = null;
        this.prevLanes = void 0;
        this.lanesChangedFlag = false;
        this.lanesSettling = false;
        this.pendingScrollAnchor = null;
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this._iosDeferredAdjustment = 0;
        this._iosTouching = false;
        this._iosJustTouchEnded = false;
        this._iosTouchEndTimerId = null;
        this._intendedScrollOffset = null;
        this._clampedAdjustment = null;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.now = ()=>{
            var _a, _b, _c;
            return ((_c = (_b = (_a = this.targetWindow) == null ? void 0 : _a.performance) == null ? void 0 : _b.now) == null ? void 0 : _c.call(_b)) ?? Date.now();
        };
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        const run = ()=>{
                            const node = entry.target;
                            const index = this.indexFromElement(node);
                            if (!node.isConnected) {
                                this.observer.unobserve(node);
                                for (const [cacheKey, cachedNode] of this.elementsCache)if (cachedNode === node) {
                                    this.elementsCache.delete(cacheKey);
                                    break;
                                }
                                return;
                            }
                            if (!this.isIndexInRange(index)) return;
                            if (this.shouldMeasureDuringScroll(index)) this.resizeItem(index, this.options.measureElement(node, entry, this));
                        };
                        this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            var _a, _b;
            const merged = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $ae8077da5dad972b$export$76974b428a49f15b,
                rangeExtractor: $ae8077da5dad972b$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $ae8077da5dad972b$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                anchorTo: "start",
                followOnAppend: false,
                scrollEndThreshold: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                useScrollendEvent: false,
                useAnimationFrameWithResizeObserver: false,
                laneAssignmentMode: "estimate",
                useCachedMeasurements: false
            };
            for(const key in opts2){
                const v = opts2[key];
                if (v !== void 0) merged[key] = v;
            }
            const prevOptions = this.options;
            let anchor = null;
            let followOnAppend = null;
            let edgeKeysChanged = false;
            if (prevOptions !== void 0 && prevOptions.enabled && merged.enabled && merged.anchorTo === "end" && this.scrollElement !== null) {
                const prevCount = prevOptions.count;
                const nextCount = merged.count;
                const measurements = this.getMeasurements();
                const prevFirstKey = prevCount > 0 ? ((_a = measurements[0]) == null ? void 0 : _a.key) ?? prevOptions.getItemKey(0) : null;
                const prevLastKey = prevCount > 0 ? ((_b = measurements[prevCount - 1]) == null ? void 0 : _b.key) ?? prevOptions.getItemKey(prevCount - 1) : null;
                const didCountChange = nextCount !== prevCount;
                const didEdgeKeysChange = didCountChange || prevCount > 0 && nextCount > 0 && (merged.getItemKey(0) !== prevFirstKey || merged.getItemKey(nextCount - 1) !== prevLastKey);
                if (didEdgeKeysChange) {
                    edgeKeysChanged = true;
                    const item = prevCount > 0 ? this.getVirtualItemForOffset(this.getScrollOffset()) ?? measurements[0] : null;
                    if (item) anchor = [
                        item.key,
                        this.getScrollOffset() - item.start
                    ];
                    const behavior = merged.followOnAppend === true ? "auto" : merged.followOnAppend || null;
                    if (behavior && nextCount > prevCount && this.isAtEnd(prevOptions.scrollEndThreshold) && (prevCount === 0 || merged.getItemKey(nextCount - 1) !== prevLastKey)) followOnAppend = behavior;
                }
            }
            this.options = merged;
            if (edgeKeysChanged) {
                this.pendingMin = 0;
                this.itemSizeCacheVersion++;
            }
            let anchorResolved = false;
            let anchorDelta = 0;
            if (anchor && this.scrollOffset !== null) {
                const [anchorKey, anchorOffset] = anchor;
                const newMeasurements = this.getMeasurements();
                const { count: count, getItemKey: getItemKey } = this.options;
                let idx = 0;
                while(idx < count && getItemKey(idx) !== anchorKey)idx++;
                if (idx < count) {
                    const anchorItem = newMeasurements[idx];
                    if (anchorItem) {
                        const newOffset = Math.max(0, anchorItem.start + anchorOffset);
                        if (newOffset !== this.scrollOffset) {
                            anchorDelta = newOffset - this.scrollOffset;
                            this.scrollOffset = newOffset;
                            anchorResolved = true;
                        }
                    }
                }
            }
            if (anchorResolved || followOnAppend) this.pendingScrollAnchor = [
                anchorResolved ? anchor[0] : null,
                anchorResolved ? anchor[1] : 0,
                followOnAppend,
                anchorDelta
            ];
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            if (this.rafId != null && this.targetWindow) {
                this.targetWindow.cancelAnimationFrame(this.rafId);
                this.rafId = null;
            }
            this.scrollState = null;
            this.isScrolling = false;
            this.scrollDirection = null;
            this._iosDeferredAdjustment = 0;
            this._iosTouching = false;
            this._iosJustTouchEnded = false;
            this._clampedAdjustment = null;
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    if (isScrolling && this._intendedScrollOffset === null && offset === this.scrollOffset) return;
                    if (this._intendedScrollOffset !== null && Math.abs(offset - this._intendedScrollOffset) < 1.5) offset = this._intendedScrollOffset;
                    this._intendedScrollOffset = null;
                    if (this._clampedAdjustment !== null && Math.abs(offset - this._clampedAdjustment.maxAtWrite) >= 1.5) this._clampedAdjustment = null;
                    this.scrollAdjustments = 0;
                    const prevOffset = this.getScrollOffset();
                    this.scrollDirection = isScrolling ? prevOffset === offset ? this.scrollDirection : prevOffset < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this._flushIosDeferredIfReady();
                    if (this.scrollState) this.scheduleScrollReconcile();
                    this.maybeNotify();
                }));
                if ("addEventListener" in this.scrollElement) {
                    const scrollEl = this.scrollElement;
                    const onTouchStart = ()=>{
                        this._iosTouching = true;
                        this._iosJustTouchEnded = false;
                        if (this._iosTouchEndTimerId !== null && this.targetWindow != null) {
                            this.targetWindow.clearTimeout(this._iosTouchEndTimerId);
                            this._iosTouchEndTimerId = null;
                        }
                    };
                    const onTouchEnd = ()=>{
                        this._iosTouching = false;
                        if (!$ae8077da5dad972b$var$isIOSWebKit() || this.targetWindow == null) return;
                        this._iosJustTouchEnded = true;
                        this._iosTouchEndTimerId = this.targetWindow.setTimeout(()=>{
                            this._iosJustTouchEnded = false;
                            this._iosTouchEndTimerId = null;
                            this._flushIosDeferredIfReady();
                        }, 150);
                    };
                    scrollEl.addEventListener("touchstart", onTouchStart, $ae8077da5dad972b$var$addEventListenerOptions);
                    scrollEl.addEventListener("touchend", onTouchEnd, $ae8077da5dad972b$var$addEventListenerOptions);
                    this.unsubs.push(()=>{
                        scrollEl.removeEventListener("touchstart", onTouchStart);
                        scrollEl.removeEventListener("touchend", onTouchEnd);
                        if (this._iosTouchEndTimerId !== null && this.targetWindow != null) {
                            this.targetWindow.clearTimeout(this._iosTouchEndTimerId);
                            this._iosTouchEndTimerId = null;
                        }
                    });
                }
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
            }
            const anchor = this.pendingScrollAnchor;
            this.pendingScrollAnchor = null;
            if (anchor && this.scrollElement && this.options.enabled) {
                const [key, _offset, followOnAppend, anchorDelta] = anchor;
                if (key !== null && !followOnAppend) {
                    if ($ae8077da5dad972b$var$isIOSWebKit() && (this.isScrolling || this._iosTouching || this._iosJustTouchEnded)) {
                        if (anchorDelta !== 0) this._iosDeferredAdjustment += anchorDelta;
                    } else this._scrollToOffset(this.getScrollOffset(), {
                        adjustments: void 0,
                        behavior: void 0
                    });
                }
                if (followOnAppend) this.scrollToEnd({
                    behavior: followOnAppend
                });
            }
            this._retryClampedAdjustment();
        };
        this._retryClampedAdjustment = ()=>{
            if (this._clampedAdjustment === null || !this.scrollElement || !this.options.enabled) return;
            const { target: target, maxAtWrite: maxAtWrite } = this._clampedAdjustment;
            const max = this.getMaxScrollOffset();
            if (max > maxAtWrite + 0.5) {
                this._clampedAdjustment = target > max + 0.5 ? {
                    target: target,
                    maxAtWrite: max
                } : null;
                this._scrollToOffset(target, {
                    adjustments: void 0,
                    behavior: void 0
                });
            }
        };
        this._flushIosDeferredIfReady = ()=>{
            if (this._iosDeferredAdjustment === 0) return;
            if (this.isScrolling) return;
            if (this._iosTouching) return;
            if (this._iosJustTouchEnded) return;
            const cur = this.getScrollOffset();
            const max = this.getMaxScrollOffset();
            if (cur < 0 || cur > max) return;
            if (this._iosDeferredAdjustment < 0 && cur >= max - 1) {
                this._iosDeferredAdjustment = 0;
                return;
            }
            const delta = this._iosDeferredAdjustment;
            this._iosDeferredAdjustment = 0;
            this._scrollToOffset(cur, {
                adjustments: this.scrollAdjustments += delta,
                behavior: void 0
            });
        };
        this.rafId = null;
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getMeasurementOptions = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled,
                this.options.lanes,
                this.options.laneAssignmentMode,
                this.options.gap
            ], (count, paddingStart, scrollMargin, getItemKey, enabled, lanes, laneAssignmentMode, gap)=>{
            const lanesChanged = this.prevLanes !== void 0 && this.prevLanes !== lanes;
            if (lanesChanged) this.lanesChangedFlag = true;
            this.prevLanes = lanes;
            this.pendingMin = null;
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled,
                lanes: lanes,
                laneAssignmentMode: laneAssignmentMode,
                gap: gap
            };
        }, {
            key: false
        });
        this.isIndexInRange = (index)=>index >= 0 && index < this.options.count;
        this.getMeasurements = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCacheVersion
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled, lanes: lanes, laneAssignmentMode: laneAssignmentMode, gap: gap }, _itemSizeCacheVersion)=>{
            const itemSizeCache = this.itemSizeCache;
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                this.laneAssignments.clear();
                return [];
            }
            if (this.laneAssignments.size > count) {
                for (const index of this.laneAssignments.keys())if (index >= count) this.laneAssignments.delete(index);
            }
            if (this.lanesChangedFlag) {
                this.lanesChangedFlag = false;
                this.lanesSettling = true;
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                this.laneAssignments.clear();
                this.pendingMin = null;
            }
            if (this.measurementsCache.length === 0 && !this.lanesSettling) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.lanesSettling ? 0 : this.pendingMin ?? 0;
            this.pendingMin = null;
            if (this.lanesSettling && this.measurementsCache.length === count) this.lanesSettling = false;
            if (lanes === 1) {
                const need = count * 2;
                let flat = this._flatMeasurements;
                if (!flat || flat.length < need) {
                    const next = new Float64Array(need);
                    if (flat && min > 0) next.set(flat.subarray(0, min * 2));
                    flat = next;
                    this._flatMeasurements = flat;
                }
                let runningStart;
                if (min === 0) runningStart = paddingStart + scrollMargin;
                else {
                    const prevIdx = min - 1;
                    runningStart = flat[prevIdx * 2] + flat[prevIdx * 2 + 1] + gap;
                }
                for(let i = min; i < count; i++){
                    const key = getItemKey(i);
                    const measuredSize = itemSizeCache.get(key);
                    const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                    flat[i * 2] = runningStart;
                    flat[i * 2 + 1] = size;
                    runningStart += size + gap;
                }
                const view = (0, $37621774baadbb77$export$7f80a7ae45fef160)(count, flat, getItemKey);
                this.measurementsCache = view;
                return view;
            }
            const measurements = this.measurementsCache.slice(0, min);
            const laneLastIndex = new Array(lanes).fill(void 0);
            const laneEnds = new Float64Array(lanes);
            let filledLanes = 0;
            for(let m = 0; m < min; m++){
                const item = measurements[m];
                if (item) {
                    if (laneLastIndex[item.lane] === void 0) filledLanes++;
                    laneLastIndex[item.lane] = m;
                    laneEnds[item.lane] = item.end;
                }
            }
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const cachedLane = this.laneAssignments.get(i);
                let lane;
                let start;
                const shouldCacheLane = laneAssignmentMode === "estimate" || itemSizeCache.has(key);
                if (cachedLane !== void 0 && this.options.lanes > 1) {
                    lane = cachedLane;
                    const prevIndex = laneLastIndex[lane];
                    const prevInLane = prevIndex !== void 0 ? measurements[prevIndex] : void 0;
                    start = prevInLane ? prevInLane.end + gap : paddingStart + scrollMargin;
                } else if (filledLanes === lanes) {
                    let bestLane = 0;
                    let bestEnd = laneEnds[0];
                    let bestIdx = laneLastIndex[0];
                    for(let l = 1; l < lanes; l++){
                        const e = laneEnds[l];
                        if (e < bestEnd || e === bestEnd && laneLastIndex[l] < bestIdx) {
                            bestLane = l;
                            bestEnd = e;
                            bestIdx = laneLastIndex[l];
                        }
                    }
                    lane = bestLane;
                    start = bestEnd + gap;
                    if (shouldCacheLane) this.laneAssignments.set(i, lane);
                } else {
                    lane = i % this.options.lanes;
                    start = paddingStart + scrollMargin;
                    if (shouldCacheLane) this.laneAssignments.set(i, lane);
                }
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
                if (laneLastIndex[lane] === void 0) filledLanes++;
                laneLastIndex[lane] = i;
                laneEnds[lane] = end;
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset(),
                this.options.lanes
            ], (measurements, outerSize, scrollOffset, lanes)=>{
            if (measurements.length === 0 || outerSize === 0) {
                this.range = null;
                return null;
            }
            this.range = $ae8077da5dad972b$var$calculateRangeImpl(measurements, outerSize, scrollOffset, lanes, // Pass the typed array so binary search + forward-walk can read
            // start/end directly from Float64Array, skipping the Proxy traps.
            lanes === 1 && this._flatMeasurements != null ? this._flatMeasurements : null);
            return this.range;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualIndexes = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>{
            let startIndex = null;
            let endIndex = null;
            const range = this.calculateRange();
            if (range) {
                startIndex = range.startIndex;
                endIndex = range.endIndex;
            }
            this.maybeNotify.updateDeps([
                this.isScrolling,
                startIndex,
                endIndex
            ]);
            return [
                this.options.rangeExtractor,
                this.options.overscan,
                this.options.count,
                startIndex,
                endIndex
            ];
        }, (rangeExtractor, overscan, count, startIndex, endIndex)=>{
            return startIndex === null || endIndex === null ? [] : rangeExtractor({
                startIndex: startIndex,
                endIndex: endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this.shouldMeasureDuringScroll = (index)=>{
            var _a;
            if (!this.scrollState || this.scrollState.behavior !== "smooth") return true;
            const scrollIndex = this.scrollState.index ?? ((_a = this.getVirtualItemForOffset(this.scrollState.lastTargetOffset)) == null ? void 0 : _a.index);
            if (scrollIndex !== void 0 && this.range) {
                const bufferSize = Math.max(this.options.overscan, Math.ceil((this.range.endIndex - this.range.startIndex) / 2));
                const minIndex = Math.max(0, scrollIndex - bufferSize);
                const maxIndex = Math.min(this.options.count - 1, scrollIndex + bufferSize);
                return index >= minIndex && index <= maxIndex;
            }
            return true;
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key2)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key2);
                    }
                });
                return;
            }
            const index = this.indexFromElement(node);
            if (!this.isIndexInRange(index)) return;
            const key = this.options.getItemKey(index);
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if ((!this.isScrolling || this.scrollState) && this.shouldMeasureDuringScroll(index)) this.resizeItem(index, this.options.measureElement(node, void 0, this));
        };
        this.resizeItem = (index, size)=>{
            var _a, _b;
            if (!this.isIndexInRange(index)) return;
            let cachedSize;
            let itemStart;
            let key;
            const flat = this._flatMeasurements;
            if (this.options.lanes === 1 && flat !== null) {
                key = this.options.getItemKey(index);
                itemStart = flat[index * 2];
                cachedSize = flat[index * 2 + 1];
            } else {
                const item = this.measurementsCache[index];
                if (!item) return;
                key = item.key;
                itemStart = item.start;
                cachedSize = item.size;
            }
            const itemSize = this.itemSizeCache.get(key) ?? cachedSize;
            const delta = size - itemSize;
            if (delta !== 0) {
                const wasAtEnd = this.options.anchorTo === "end" && ((_a = this.scrollState) == null ? void 0 : _a.behavior) !== "smooth" && this.getVirtualDistanceFromEnd() <= this.options.scrollEndThreshold;
                const prevTotalSize = wasAtEnd ? this.getTotalSize() : 0;
                const scrollOffsetWithAdj = this.getScrollOffset() + this.scrollAdjustments;
                const isFirstMeasure = !this.itemSizeCache.has(key);
                const defaultShouldAdjust = isFirstMeasure ? // First measurement: compensate any item whose top sits above the
                // fold — the estimate→actual delta must be corrected regardless of
                // scroll direction, since the whole estimated block was above it.
                itemStart < scrollOffsetWithAdj : // Re-measurement: only compensate an item that is ENTIRELY above the
                // fold. An item that merely *spans* the fold (top above, bottom
                // below — e.g. a streaming chat message growing at its bottom)
                // changes size *below* the anchor point, so shifting scrollTop by the
                // delta would drag the viewport downward on every growth (#1218).
                // Also skip during backward scroll to avoid the "items jump while
                // scrolling up" cascade.
                itemStart + itemSize <= scrollOffsetWithAdj && this.scrollDirection !== "backward";
                const shouldAdjustScroll = ((_b = this.scrollState) == null ? void 0 : _b.behavior) !== "smooth" && (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(// The callback expects a VirtualItem; build one lazily only
                // when the consumer actually supplied a custom predicate.
                this.measurementsCache[index] ?? {
                    index: index,
                    key: key,
                    start: itemStart,
                    size: cachedSize,
                    end: itemStart + cachedSize,
                    lane: 0
                }, delta, this) : defaultShouldAdjust);
                if (this.pendingMin === null || index < this.pendingMin) this.pendingMin = index;
                this.itemSizeCache.set(key, size);
                this.itemSizeCacheVersion++;
                let adjustedSync = false;
                if (wasAtEnd) adjustedSync = this.applyScrollAdjustment(this.getTotalSize() - prevTotalSize);
                else if (shouldAdjustScroll) adjustedSync = this.applyScrollAdjustment(delta);
                this.notify(adjustedSync);
                this._retryClampedAdjustment();
            }
        };
        this.getVirtualItems = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.getVirtualIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            const flat = this._flatMeasurements;
            const useFlat = this.options.lanes === 1 && flat != null;
            const idx = $ae8077da5dad972b$var$findNearestBinarySearch(0, measurements.length - 1, useFlat ? (i)=>flat[i * 2] : (i)=>(0, $af43570ba0a8567e$export$9a1adf421b69c6a)(measurements[i]).start, offset);
            return (0, $af43570ba0a8567e$export$9a1adf421b69c6a)(measurements[idx]);
        };
        this.getMaxScrollOffset = ()=>{
            if (!this.scrollElement) return 0;
            if ("scrollHeight" in this.scrollElement) return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
            else {
                const doc = this.scrollElement.document.documentElement;
                return this.options.horizontal ? doc.scrollWidth - this.scrollElement.innerWidth : doc.scrollHeight - this.scrollElement.innerHeight;
            }
        };
        this.getVirtualDistanceFromEnd = ()=>{
            return Math.max(this.getTotalSize() - this.getSize() - this.getScrollOffset(), 0);
        };
        this.getDistanceFromEnd = ()=>{
            return Math.max(this.getMaxScrollOffset() - this.getScrollOffset(), 0);
        };
        this.isAtEnd = (threshold = this.options.scrollEndThreshold)=>{
            return this.getDistanceFromEnd() <= threshold;
        };
        this.getOffsetForAlignment = (toOffset, align, itemSize = 0)=>{
            if (!this.scrollElement) return 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") align = toOffset >= scrollOffset + size ? "end" : "start";
            if (align === "center") toOffset += (itemSize - size) / 2;
            else if (align === "end") toOffset -= size;
            const maxOffset = this.getMaxScrollOffset();
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            const item = this.measurementsCache[index];
            if (!item) return;
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            if (align === "end" && index === this.options.count - 1) return [
                this.getMaxScrollOffset(),
                align
            ];
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align, item.size),
                align
            ];
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior = "auto" } = {})=>{
            this._iosDeferredAdjustment = 0;
            const offset = this.getOffsetForAlignment(toOffset, align);
            const now = this.now();
            this.scrollState = {
                index: null,
                align: align,
                behavior: behavior,
                startedAt: now,
                lastTargetOffset: offset,
                stableFrames: 0
            };
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            this.scheduleScrollReconcile();
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior = "auto" } = {})=>{
            this._iosDeferredAdjustment = 0;
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const offsetInfo = this.getOffsetForIndex(index, initialAlign);
            if (!offsetInfo) return;
            const [offset, align] = offsetInfo;
            const now = this.now();
            this.scrollState = {
                index: index,
                align: align,
                behavior: behavior,
                startedAt: now,
                lastTargetOffset: offset,
                stableFrames: 0
            };
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            this.scheduleScrollReconcile();
        };
        this.scrollBy = (delta, { behavior: behavior = "auto" } = {})=>{
            const offset = this.getScrollOffset() + delta;
            const now = this.now();
            this.scrollState = {
                index: null,
                align: "start",
                behavior: behavior,
                startedAt: now,
                lastTargetOffset: offset,
                stableFrames: 0
            };
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            this.scheduleScrollReconcile();
        };
        this.scrollToEnd = ({ behavior: behavior = "auto" } = {})=>{
            if (this.options.count > 0) {
                this.scrollToIndex(this.options.count - 1, {
                    align: "end",
                    behavior: behavior
                });
                return;
            }
            this.scrollToOffset(Math.max(this.getTotalSize() - this.getSize(), 0), {
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else if (this.options.lanes === 1) {
                const lastIdx = measurements.length - 1;
                const flat = this._flatMeasurements;
                if (flat != null) end = flat[lastIdx * 2] + flat[lastIdx * 2 + 1];
                else end = ((_a = measurements[lastIdx]) == null ? void 0 : _a.end) ?? 0;
            } else {
                const endByLane = Array(this.options.lanes).fill(null);
                let endIndex = measurements.length - 1;
                while(endIndex >= 0 && endByLane.some((val)=>val === null)){
                    const item = measurements[endIndex];
                    if (endByLane[item.lane] === null) endByLane[item.lane] = item.end;
                    endIndex--;
                }
                end = Math.max(...endByLane.filter((val)=>val !== null));
            }
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this.takeSnapshot = ()=>{
            const snapshot = [];
            if (this.itemSizeCache.size === 0) return snapshot;
            const m = this.getMeasurements();
            for (const item of m)if (item && this.itemSizeCache.has(item.key)) snapshot.push({
                index: item.index,
                key: item.key,
                start: item.start,
                size: item.size,
                end: item.end,
                lane: item.lane
            });
            return snapshot;
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this._intendedScrollOffset = offset + (adjustments ?? 0);
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.pendingMin = null;
            this.itemSizeCache.clear();
            this.laneAssignments.clear();
            this.itemSizeCacheVersion++;
            this.notify(false);
        };
        this.setOptions(opts);
    }
    // Returns `true` when it performed a synchronous `scrollTop` write this
    // tick, `false` when the delta was zero or the write was deferred (iOS).
    // `resizeItem` uses that to decide whether the follow-up `notify` must be
    // synchronous so the grown transforms commit in the same paint (#1227).
    applyScrollAdjustment(delta, behavior) {
        if (delta === 0) return false;
        if ($ae8077da5dad972b$var$isIOSWebKit() && (this.isScrolling || this._iosTouching || this._iosJustTouchEnded)) {
            this._iosDeferredAdjustment += delta;
            return false;
        } else {
            const target = this.getScrollOffset() + this.scrollAdjustments + delta;
            const el = this.scrollElement;
            const maxAtWrite = el !== null && ("scrollHeight" in el || "document" in el) ? this.getMaxScrollOffset() : null;
            this._clampedAdjustment = maxAtWrite !== null && target > maxAtWrite + 0.5 ? {
                target: target,
                maxAtWrite: maxAtWrite
            } : null;
            this._scrollToOffset(this.getScrollOffset(), {
                adjustments: this.scrollAdjustments += delta,
                behavior: behavior
            });
            if (this.scrollOffset !== null) {
                this.scrollOffset += this.scrollAdjustments;
                if (this.scrollOffset < 0) this.scrollOffset = 0;
                this.scrollAdjustments = 0;
            }
            return true;
        }
    }
    scheduleScrollReconcile() {
        if (!this.targetWindow) {
            this.scrollState = null;
            return;
        }
        if (this.rafId != null) return;
        this.rafId = this.targetWindow.requestAnimationFrame(()=>{
            this.rafId = null;
            this.reconcileScroll();
        });
    }
    reconcileScroll() {
        if (!this.scrollState) return;
        const el = this.scrollElement;
        if (!el) return;
        const MAX_RECONCILE_MS = 5e3;
        if (this.now() - this.scrollState.startedAt > MAX_RECONCILE_MS) {
            this.scrollState = null;
            return;
        }
        const offsetInfo = this.scrollState.index != null ? this.getOffsetForIndex(this.scrollState.index, this.scrollState.align) : void 0;
        const targetOffset = offsetInfo ? offsetInfo[0] : this.scrollState.lastTargetOffset;
        const STABLE_FRAMES = 1;
        const targetChanged = targetOffset !== this.scrollState.lastTargetOffset;
        if (!targetChanged && (0, $af43570ba0a8567e$export$8a4f1dcc58a69dbd)(targetOffset, this.getScrollOffset())) {
            this.scrollState.stableFrames++;
            if (this.scrollState.stableFrames >= STABLE_FRAMES) {
                if (this.getScrollOffset() !== targetOffset) this._scrollToOffset(targetOffset, {
                    adjustments: void 0,
                    behavior: "auto"
                });
                this.scrollState = null;
                return;
            }
        } else {
            this.scrollState.stableFrames = 0;
            if (targetChanged) {
                const viewport = this.getSize() || 600;
                const distance = Math.abs(targetOffset - this.getScrollOffset());
                const keepSmooth = this.scrollState.behavior === "smooth" && distance > viewport;
                this.scrollState.lastTargetOffset = targetOffset;
                if (!keepSmooth) this.scrollState.behavior = "auto";
                this._scrollToOffset(targetOffset, {
                    adjustments: void 0,
                    behavior: keepSmooth ? "smooth" : "auto"
                });
            }
        }
        this.scheduleScrollReconcile();
    }
}
const $ae8077da5dad972b$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $ae8077da5dad972b$var$findNearestBinarySearchFlat(flat, high, value) {
    let low = 0;
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = flat[middle * 2];
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    return low > 0 ? low - 1 : 0;
}
function $ae8077da5dad972b$var$calculateRangeImpl(measurements, outerSize, scrollOffset, lanes, flat) {
    const lastIndex = measurements.length - 1;
    if (measurements.length <= lanes) return {
        startIndex: 0,
        endIndex: lastIndex
    };
    if (lanes === 1 && flat !== null) {
        const startIndex2 = $ae8077da5dad972b$var$findNearestBinarySearchFlat(flat, lastIndex, scrollOffset);
        let endIndex2 = startIndex2;
        const limit = scrollOffset + outerSize;
        while(endIndex2 < lastIndex && flat[endIndex2 * 2] + flat[endIndex2 * 2 + 1] < limit)endIndex2++;
        return {
            startIndex: startIndex2,
            endIndex: endIndex2
        };
    }
    const getStart = (index)=>measurements[index].start;
    let startIndex = $ae8077da5dad972b$var$findNearestBinarySearch(0, lastIndex, getStart, scrollOffset);
    let endIndex = startIndex;
    if (lanes === 1) while(endIndex < lastIndex && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    else if (lanes > 1) {
        const endPerLane = Array(lanes).fill(0);
        while(endIndex < lastIndex && endPerLane.some((pos)=>pos < scrollOffset + outerSize)){
            const item = measurements[endIndex];
            endPerLane[item.lane] = item.end;
            endIndex++;
        }
        const startPerLane = Array(lanes).fill(scrollOffset + outerSize);
        while(startIndex >= 0 && startPerLane.some((pos)=>pos >= scrollOffset)){
            const item = measurements[startIndex];
            startPerLane[item.lane] = item.start;
            startIndex--;
        }
        startIndex = Math.max(0, startIndex - startIndex % lanes);
        endIndex = Math.min(lastIndex, endIndex + (lanes - 1 - endIndex % lanes));
    }
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}


const $64d08e094a93fa77$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
function $64d08e094a93fa77$var$useVirtualizerBase({ useFlushSync: useFlushSync = true, directDomUpdates: directDomUpdates = false, directDomUpdatesMode: directDomUpdatesMode = "transform", ...options }) {
    const rerender = $acw62.useReducer((x)=>x + 1, 0)[1];
    const directRef = $acw62.useRef({
        enabled: directDomUpdates,
        mode: directDomUpdatesMode,
        container: null,
        lastSize: null,
        // Keyed by the element itself so a remounted node (same key, new DOM
        // node — e.g. when `enabled` is toggled off then on) is treated as fresh
        // and gets its style written.
        lastPositions: /* @__PURE__ */ new WeakMap(),
        prevRange: null
    });
    directRef.current.enabled = directDomUpdates;
    directRef.current.mode = directDomUpdatesMode;
    const applyContainerSize = (instance2)=>{
        const state = directRef.current;
        if (!state.enabled || !state.container) return;
        const totalSize = instance2.getTotalSize();
        if (totalSize !== state.lastSize) {
            state.lastSize = totalSize;
            const sizeAxis = instance2.options.horizontal ? "width" : "height";
            state.container.style[sizeAxis] = `${totalSize}px`;
        }
    };
    const applyDirectStyles = (instance2)=>{
        const state = directRef.current;
        if (!state.enabled || !state.container) return;
        applyContainerSize(instance2);
        const horizontal = !!instance2.options.horizontal;
        const useTransform = state.mode === "transform";
        const posAxis = horizontal ? "left" : "top";
        const scrollMargin = instance2.options.scrollMargin;
        const items = instance2.getVirtualItems();
        for (const item of items){
            const next = item.start - scrollMargin;
            const el = instance2.elementsCache.get(item.key);
            if (!el) continue;
            if (state.lastPositions.get(el) === next) continue;
            state.lastPositions.set(el, next);
            if (useTransform) el.style.transform = horizontal ? `translate3d(${next}px, 0, 0)` : `translate3d(0, ${next}px, 0)`;
            else el.style[posAxis] = `${next}px`;
        }
    };
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            const state = directRef.current;
            let shouldRerender = true;
            if (state.enabled) {
                applyDirectStyles(instance2);
                const range = instance2.range;
                const prev = state.prevRange;
                shouldRerender = !prev || prev.isScrolling !== instance2.isScrolling || prev.startIndex !== (range == null ? void 0 : range.startIndex) || prev.endIndex !== (range == null ? void 0 : range.endIndex);
                if (shouldRerender) state.prevRange = range ? {
                    startIndex: range.startIndex,
                    endIndex: range.endIndex,
                    isScrolling: instance2.isScrolling
                } : null;
            }
            if (shouldRerender) {
                if (useFlushSync && sync) (0, $11492dca620dcaa5$exports.flushSync)(rerender);
                else rerender();
            }
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $acw62.useState(()=>{
        const v = new (0, $ae8077da5dad972b$export$89be5a243e59c4b2)(resolvedOptions);
        return Object.assign(v, {
            containerRef: (node)=>{
                const state = directRef.current;
                state.container = node;
                state.lastSize = null;
                if (node && state.enabled) {
                    const total = v.getTotalSize();
                    state.lastSize = total;
                    const axis = v.options.horizontal ? "width" : "height";
                    node.style[axis] = `${total}px`;
                }
            }
        });
    });
    instance.setOptions(resolvedOptions);
    $64d08e094a93fa77$var$useIsomorphicLayoutEffect(()=>{
        return instance._didMount();
    }, []);
    $64d08e094a93fa77$var$useIsomorphicLayoutEffect(()=>{
        applyContainerSize(instance);
        return instance._willUpdate();
    });
    $64d08e094a93fa77$var$useIsomorphicLayoutEffect(()=>{
        applyDirectStyles(instance);
    });
    return instance;
}
function $64d08e094a93fa77$export$dd6d526d88b5a137(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        observeElementRect: $ae8077da5dad972b$export$5a50ff2cde8c3802,
        observeElementOffset: $ae8077da5dad972b$export$fbc040aee017375a,
        scrollToFn: (0, $ae8077da5dad972b$export$1cdb988e5ab69fe7),
        ...options
    });
}
function $64d08e094a93fa77$export$645722dcac657cb9(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $ae8077da5dad972b$export$e911b82c7a99311),
        observeElementOffset: (0, $ae8077da5dad972b$export$518998f8c5d09287),
        scrollToFn: (0, $ae8077da5dad972b$export$2162c5b3eeedd27),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}




var $acw62 = parcelRequire("acw62");
/**
 * Rewrites the cached `Transaction.logo` of every transaction with a given
 * payee, after that payee's logo assignment changes.
 *
 * Necessary because `Transaction.logo` is derived server-side from the payee
 * rather than stored on the transaction, so Apollo has no way to know a
 * `setPayeeLogo` mutation invalidated it. Refetching `PayeesWithLogos` alone
 * only fixes the settings page; `TransactionListView` reads cache-first on POP
 * navigation, so pressing Back after assigning a logo would show every affected
 * row with the old one and never hit the network.
 *
 * Writing the new value rather than evicting the field keeps those rows from
 * going incomplete and triggering a refetch — the correct value is already
 * known here.
 */ const $52c8320191f148ac$var$updateTransactionLogos = (cache, payee, logo)=>{
    // No public API enumerates normalized objects of a type, so read the store
    // and pick out Transaction entries by their cache id prefix.
    const ids = Object.keys(cache.extract()).filter((id)=>id.startsWith('Transaction:'));
    for (const id of ids)cache.modify({
        id: id,
        fields: {
            logo: (existing, { readField: readField })=>readField('payee') === payee ? logo : existing
        }
    });
};
var $52c8320191f148ac$export$2e2bcd8739ae039 = $52c8320191f148ac$var$updateTransactionLogos;








/**
 * Starting guess for a row's height, refined by measurement once each row
 * mounts. Rows are not uniform: below `sm` the picker wraps onto its own line,
 * which roughly doubles the row.
 */ const $55a95d70476bea65$var$ESTIMATED_ROW_HEIGHT = 60;
/** Rows rendered beyond the viewport, so scrolling does not reveal blanks. */ const $55a95d70476bea65$var$OVERSCAN = 8;
const $55a95d70476bea65$var$FILTERS = [
    {
        value: 'all',
        label: 'All'
    },
    {
        value: 'unassigned',
        label: 'Unassigned'
    },
    {
        value: 'assigned',
        label: 'Assigned'
    }
];
const $55a95d70476bea65$export$57e570fc31cf3859 = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Payee logos',
        fallback: [
            {
                label: 'Settings',
                href: '/settings'
            }
        ]
    });
    const client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    // cache-and-network: this list is derived from transactions, and no
    // transaction mutation invalidates it. Left on the default cache-first, a
    // revisit would keep showing payees that have since been renamed away and
    // counts that no longer match, with no request issued.
    const { data: data, loading: loading, error: queryError, refetch: refetch } = (0, $ce9d9e524be20f53$export$1b5dafb855b1a431)({
        fetchPolicy: 'cache-and-network'
    });
    const [setPayeeLogo] = (0, $ce9d9e524be20f53$export$6d35ada5387177c2)();
    const [clearPayeeLogo] = (0, $ce9d9e524be20f53$export$4ef18ce3a173b118)();
    const [query, setQuery] = $acw62.useState('');
    const [filter, setFilter] = $acw62.useState('all');
    /**
   * Payees whose assignment is currently in flight. A set rather than a single
   * value: changing a second row before the first finishes would otherwise
   * overwrite the first payee — re-enabling its picker mid-flight — and the
   * first response to land would clear the guard for both.
   */ const [saving, setSaving] = $acw62.useState(new Set());
    const [error, setError] = $acw62.useState(null);
    const rows = $acw62.useMemo(()=>data?.payeesWithLogos ?? [], [
        data
    ]);
    /** Logo slug -> every payee using it, so sharing is visible on each row. */ const payeesByLogo = $acw62.useMemo(()=>{
        const map = new Map();
        for (const row of rows){
            if (!row.logo) continue;
            map.set(row.logo, [
                ...map.get(row.logo) ?? [],
                row.payee
            ]);
        }
        return map;
    }, [
        rows
    ]);
    const filtered = $acw62.useMemo(()=>{
        const needle = query.trim().toLowerCase();
        return rows.filter((row)=>{
            if (filter === 'assigned' && !row.logo) return false;
            if (filter === 'unassigned' && row.logo) return false;
            if (!needle) return true;
            return row.payee.toLowerCase().includes(needle) || (row.logo ?? '').toLowerCase().includes(needle);
        });
    }, [
        rows,
        query,
        filter
    ]);
    const assignedCount = rows.filter((row)=>row.logo).length;
    /**
   * The list scrolls in its own container so only the rows on screen are in
   * the DOM. Every row mounts a live combobox, so rendering the whole list
   * cost about 0.4ms and 8 DOM nodes per row — a keystroke in the search box
   * above took over a second once a few thousand payees were on the page.
   * Windowing makes that cost independent of how many payees there are, which
   * is what lets the full list be reachable by scrolling instead of only by
   * searching.
   */ const scrollRef = $acw62.useRef(null);
    const virtualizer = (0, $64d08e094a93fa77$export$dd6d526d88b5a137)({
        count: filtered.length,
        getScrollElement: ()=>scrollRef.current,
        estimateSize: ()=>$55a95d70476bea65$var$ESTIMATED_ROW_HEIGHT,
        overscan: $55a95d70476bea65$var$OVERSCAN,
        // Payee is the row's identity, so a measured height follows its row
        // through a filter change rather than staying with the slot.
        getItemKey: (index)=>filtered[index]?.payee ?? index
    });
    const virtualRows = virtualizer.getVirtualItems();
    const handleChange = async (payee, logo)=>{
        // Also serves as a guard against a second submission for the same payee
        // while the first is in flight, which would race two creates against the
        // unique {user, payee} index.
        setSaving((pending)=>new Set(pending).add(payee));
        setError(null);
        try {
            if (logo) await setPayeeLogo({
                variables: {
                    payee: payee,
                    logo: logo
                }
            });
            else await clearPayeeLogo({
                variables: {
                    payee: payee
                }
            });
            // Transaction.logo is derived from the payee server-side, so Apollo
            // cannot know this mutation invalidated it. Without this, navigating back
            // to a cache-first transaction list shows the old logo indefinitely.
            (0, $52c8320191f148ac$export$2e2bcd8739ae039)(client.cache, payee, logo || null);
            await refetch();
        } catch (caught) {
            // The picker has already cleared its query by now, so without this the
            // change silently vanishes and the row looks unchanged for no stated
            // reason.
            setError(`Could not update ${payee}: ${caught instanceof Error ? caught.message : 'unknown error'}`);
        } finally{
            setSaving((pending)=>{
                const next = new Set(pending);
                next.delete(payee);
                return next;
            });
        }
    };
    // Only block on the very first load; cache-and-network keeps `loading` true
    // during background refreshes, which would otherwise flash the whole page.
    if (loading && !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex items-center justify-center p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "text-muted-foreground",
            children: "Loading payees..."
        })
    });
    // A failed first load is otherwise indistinguishable from having no payees:
    // data stays undefined and the page renders a confident "0 of 0".
    if (queryError && !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center gap-3 p-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-destructive",
                role: "alert",
                children: [
                    "Could not load payees: ",
                    queryError.message
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: ()=>void refetch(),
                children: "Try again"
            })
        ]
    });
    // A failed *background* refresh still has cached rows to show, so it must not
    // replace the page — but it must not be silent either. This list is derived
    // from transactions and nothing invalidates it, so the refresh is the only
    // thing correcting payees renamed or deleted elsewhere; swallowing its
    // failure presents a stale list as current, which is the exact problem
    // cache-and-network was added to solve.
    const refreshError = queryError && data ? queryError : null;
    return(// overflow-hidden, not auto: the list below owns the scrolling now, which
    // both keeps the search box in reach at any depth and gives the
    // virtualizer a scroll element with a bounded height to window against.
    // MainPane puts routes in a flex column with overflow-hidden, so this
    // element must claim its height with flex-1 or the list collapses.
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-1 flex-col gap-4 overflow-hidden p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-lg font-semibold",
                        children: "Payee logos"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-muted-foreground text-sm",
                        children: "Assign a brand logo to a payee. Every transaction with that payee shows it \u2014 nothing is stored on the transactions themselves, so changing a logo here updates all of them at once."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "min-w-48 flex-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7de46ea21e6828f$export$c86715117507e8e5), {
                            value: query,
                            onChange: setQuery,
                            placeholder: "Search payees or logos\u2026"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex gap-1",
                        children: $55a95d70476bea65$var$FILTERS.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setFilter(option.value),
                                className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('rounded-md px-3 py-1.5 text-sm', filter === option.value ? 'bg-accent text-accent-foreground' : 'text-muted-foreground hover:bg-accent/50'),
                                children: option.label
                            }, option.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-muted-foreground text-sm",
                children: [
                    assignedCount,
                    " of ",
                    rows.length,
                    " payees have a logo",
                    filtered.length !== rows.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " \xb7 ",
                            filtered.length,
                            " shown"
                        ]
                    })
                ]
            }),
            refreshError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                role: "alert",
                className: "border-destructive/40 bg-destructive/10 text-destructive flex flex-wrap items-center justify-between gap-2 rounded-lg border px-3 py-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "Showing previously loaded payees \u2014 refreshing failed:",
                            ' ',
                            refreshError.message
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                        variant: "outline",
                        onClick: ()=>void refetch(),
                        children: "Retry"
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "alert",
                className: "border-destructive/40 bg-destructive/10 text-destructive rounded-lg border px-3 py-2 text-sm",
                children: error
            }),
            filtered.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-border rounded-lg border border-dashed p-8 text-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground",
                    children: "No payees match"
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: scrollRef,
                // min-h-0 with the default flex-shrink, not flex-1: the box must
                // size to its rows when there are few (flex-1 would stretch an
                // empty bordered panel down the page) and shrink to the space left
                // when there are many, which is when it starts scrolling. min-h-0
                // is what lets a flex child shrink below its content height at all.
                className: "border-border min-h-0 overflow-y-auto rounded-lg border",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "relative w-full",
                    style: {
                        height: `${virtualizer.getTotalSize()}px`
                    },
                    children: virtualRows.map((virtualRow)=>{
                        const row = filtered[virtualRow.index];
                        const sharing = (payeesByLogo.get(row.logo ?? '') ?? []).filter((payee)=>payee !== row.payee);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            // measureElement reads data-index to record this row's real
                            // height, which the estimate above only approximates.
                            "data-index": virtualRow.index,
                            ref: virtualizer.measureElement,
                            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('absolute top-0 left-0 flex w-full flex-wrap items-center gap-3 p-3', // Absolute rows are out of flow, so `divide-y` on the
                            // parent has nothing to divide; each row draws its own
                            // separator instead.
                            virtualRow.index > 0 && 'border-border border-t'),
                            style: {
                                transform: `translateY(${virtualRow.start}px)`
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7ce1c21778619db$export$ef41ebc44b9c1fe4), {
                                    logo: row.logo,
                                    className: "size-8"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "min-w-40 flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "truncate font-medium",
                                            children: row.payee
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "text-muted-foreground text-xs",
                                            children: [
                                                row.transactionCount === 1 ? '1 transaction' : `${row.transactionCount} transactions`,
                                                sharing.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        " \xb7 ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            title: sharing.join(', '),
                                                            children: [
                                                                "shares ",
                                                                row.logo,
                                                                " with",
                                                                ' ',
                                                                sharing.length === 1 ? sharing[0] : `${sharing.length} other payees`
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "w-full sm:w-72",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7e865dd16cb1aeb$export$6b5b4e301fbd3704), {
                                        label: null,
                                        ariaLabel: `Logo for ${row.payee}`,
                                        disabled: saving.has(row.payee),
                                        value: row.logo ?? '',
                                        onChange: (logo)=>{
                                            handleChange(row.payee, logo);
                                        }
                                    })
                                })
                            ]
                        }, virtualRow.key);
                    })
                })
            })
        ]
    }));
};








var $acw62 = parcelRequire("acw62");



/** Record amounts are integer cents. */ const $d0e4eefb5185f412$var$cents = (value)=>(value / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2
    });
const $d0e4eefb5185f412$export$d94061e5db57f05d = ()=>{
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: 'Payroll',
        reset: true
    });
    const { data: data, loading: loading, error: error } = (0, $ce9d9e524be20f53$export$1d8c1b4eaf3a0f32)({
        fetchPolicy: 'cache-and-network'
    });
    const { data: taxData } = (0, $ce9d9e524be20f53$export$6fcc7ed8f7135ba3)({
        fetchPolicy: 'cache-and-network'
    });
    // Taxes by tax year: withholding attributes by pay date (a tax year by
    // construction) across ALL records — the employer filter deliberately
    // does not apply, a tax year spans employers. Cash events come from the
    // report, attributed by the bound tax year field.
    const taxYears = $acw62.useMemo(()=>{
        const byYear = new Map();
        const at = (year)=>{
            const existing = byYear.get(year) ?? {
                withheld: 0,
                paid: 0,
                refunded: 0
            };
            byYear.set(year, existing);
            return existing;
        };
        for (const record of data?.payrollRecords ?? [])at(String((0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(record.payDate).year)).withheld += record.taxesWithheld;
        for (const row of taxData?.taxYearReport.rows ?? []){
            const group = at(row.year);
            group.paid += row.paid;
            group.refunded += row.refunded;
        }
        return [
            ...byYear.entries()
        ].sort(([a], [b])=>b.localeCompare(a));
    }, [
        data,
        taxData
    ]);
    const { payrollRecordModal: payrollRecordModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const [employerFilter, setEmployerFilter] = $acw62.useState(null);
    const records = $acw62.useMemo(()=>(data?.payrollRecords ?? []).filter((record)=>employerFilter == null || record.employer === employerFilter), [
        data,
        employerFilter
    ]);
    const employers = $acw62.useMemo(()=>[
            ...new Set((data?.payrollRecords ?? []).map((r)=>r.employer))
        ].sort(), [
        data
    ]);
    const years = $acw62.useMemo(()=>{
        const byYear = new Map();
        for (const record of records){
            const year = (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(record.payDate).year;
            const existing = byYear.get(year);
            if (existing) existing.push(record);
            else byYear.set(year, [
                record
            ]);
        }
        // Records arrive newest-first; keep that order for the sections too.
        return [
            ...byYear.entries()
        ];
    }, [
        records
    ]);
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-destructive p-8 text-center text-sm",
        children: [
            "Couldn't load payroll: ",
            error.message
        ]
    });
    if (loading && data == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground p-8 text-center text-sm",
        children: "Loading\u2026"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex-1 overflow-y-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "mx-auto flex max-w-4xl flex-col gap-4 p-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-center justify-between gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-foreground text-xl font-semibold",
                                    children: "Payroll"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-muted-foreground text-sm",
                                    children: "Imported paychecks \u2014 gross pay, withholding, and what was deposited. Click a row for the full slip."
                                })
                            ]
                        }),
                        employers.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-wrap gap-1.5",
                            children: [
                                null,
                                ...employers
                            ].map((employer)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setEmployerFilter(employer),
                                    className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('rounded-full border px-3 py-1 text-xs font-medium transition-colors', employer === employerFilter ? 'border-primary bg-primary text-primary-foreground' : 'border-border text-muted-foreground hover:text-foreground'),
                                    children: employer ?? 'All'
                                }, employer ?? 'all'))
                        })
                    ]
                }),
                (taxData?.taxYearReport.fieldBound === true || taxYears.length > 0 && taxData != null) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mb-2 flex items-baseline justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-foreground text-base font-semibold",
                                    children: "Taxes by tax year"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground text-xs",
                                    children: "withholding by pay date \xb7 payments and refunds by the Tax year field"
                                })
                            ]
                        }),
                        taxData?.taxYearReport.fieldBound !== true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground text-sm",
                            children: "Bind a Tax year field on Defaults to attribute settlements and refunds to the year they settle \u2014 withholding alone is shown below."
                        }),
                        taxData?.taxYearReport.fieldBound === true && taxData.taxYearReport.unattributedCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-destructive mb-2 text-sm",
                            children: [
                                taxData.taxYearReport.unattributedCount,
                                " payment",
                                taxData.taxYearReport.unattributedCount === 1 ? '' : 's',
                                " in the taxes category ",
                                taxData.taxYearReport.unattributedCount === 1 ? 'has' : 'have',
                                " no tax year yet \u2014 set the Tax year field on them so they count."
                            ]
                        }),
                        taxYears.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "w-full text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: "text-muted-foreground text-left text-xs",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-1 font-medium",
                                                children: "Tax year"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-1 text-right font-medium",
                                                children: "Withheld"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-1 text-right font-medium",
                                                children: "Payments"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-1 text-right font-medium",
                                                children: "Refunds"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-1 text-right font-medium",
                                                children: "Total"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: taxYears.map(([year, group])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "border-border border-t",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "text-foreground py-1.5 font-medium",
                                                    children: year
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-1.5 text-right tabular-nums",
                                                    children: $d0e4eefb5185f412$var$cents(group.withheld)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-1.5 text-right tabular-nums",
                                                    children: $d0e4eefb5185f412$var$cents(group.paid)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-1.5 text-right tabular-nums",
                                                    children: group.refunded > 0 ? `\u{2212}${$d0e4eefb5185f412$var$cents(group.refunded)}` : $d0e4eefb5185f412$var$cents(0)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-1.5 text-right font-medium tabular-nums",
                                                    children: $d0e4eefb5185f412$var$cents(group.withheld + group.paid - group.refunded)
                                                })
                                            ]
                                        }, year))
                                })
                            ]
                        })
                    ]
                }),
                years.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-muted-foreground py-12 text-center text-sm",
                    children: [
                        "No payroll imported yet. Run",
                        ' ',
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                            className: "bg-muted rounded px-1 py-0.5",
                            children: "yarn workspace server import:payslips"
                        }),
                        ' ',
                        "to load parsed payslips."
                    ]
                }),
                years.map(([year, yearRecords])=>{
                    const totals = yearRecords.reduce((sum, record)=>({
                            gross: sum.gross + record.gross,
                            taxes: sum.taxes + record.taxesWithheld,
                            net: sum.net + record.net
                        }), {
                        gross: 0,
                        taxes: 0,
                        net: 0
                    });
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-muted-foreground flex flex-wrap items-baseline justify-between gap-x-4 border-b pb-1 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-foreground text-base font-semibold",
                                        children: year
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "tabular-nums",
                                        children: [
                                            yearRecords.length,
                                            " paychecks \xb7 gross ",
                                            $d0e4eefb5185f412$var$cents(totals.gross),
                                            " \xb7 taxes ",
                                            $d0e4eefb5185f412$var$cents(totals.taxes),
                                            " \xb7 net ",
                                            $d0e4eefb5185f412$var$cents(totals.net)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "w-full text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "text-muted-foreground text-left text-xs",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "py-1 font-normal",
                                                    children: "Pay date"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "py-1 font-normal",
                                                    children: "Employer"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "py-1 text-right font-normal",
                                                    children: "Gross"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "py-1 text-right font-normal",
                                                    children: "Taxes"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "py-1 text-right font-normal",
                                                    children: "Pre-tax"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: "py-1 text-right font-normal",
                                                    children: "Net"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: yearRecords.map((record)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: "border-border hover:bg-muted/50 cursor-pointer border-t",
                                                onClick: ()=>payrollRecordModal.openModal({
                                                        record: record
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 pr-2",
                                                        children: (0, $0c0f91b069db95d9$export$d5805bbcec54c5ee)(record.payDate).toLocaleString({
                                                            month: 'short',
                                                            day: 'numeric'
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "text-muted-foreground py-1.5 pr-2",
                                                        children: record.employer
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 text-right tabular-nums",
                                                        children: $d0e4eefb5185f412$var$cents(record.gross)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 text-right tabular-nums",
                                                        children: $d0e4eefb5185f412$var$cents(record.taxesWithheld)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "text-muted-foreground py-1.5 text-right tabular-nums",
                                                        children: $d0e4eefb5185f412$var$cents(record.otherPretax)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "py-1.5 text-right font-medium tabular-nums",
                                                        children: $d0e4eefb5185f412$var$cents(record.net)
                                                    })
                                                ]
                                            }, record._id))
                                    })
                                ]
                            })
                        ]
                    }, year);
                })
            ]
        })
    });
};




parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");



const $09ead012420c7c6a$export$a1ce833e6d55d931 = ({ consumers: consumers, currency: currency, totalAmount: totalAmount, remainingAmount: remainingAmount })=>{
    const consumedAmount = consumers.reduce((sum, c)=>sum + c.amount, 0);
    const remaining = remainingAmount ?? totalAmount - consumedAmount;
    if (consumers.length === 0 && remaining === totalAmount) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-muted-foreground px-4 py-3",
        children: "Not yet allocated to any transaction"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col",
        children: [
            consumers.map((consumer, index)=>{
                const tx = consumer.transaction;
                const consumedMoney = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(consumer.amount, currency);
                const isPartial = consumer.amount !== totalAmount;
                // Get display info based on transaction type
                // Payment = netAmount !== 0, Transfer = netAmount === 0
                const isPayment = tx.netAmount !== 0;
                const label = isPayment ? tx.payee ?? tx.description : tx.description;
                const date = tx.date;
                const path = `/transactions/${tx._id}`;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                    to: path,
                    className: "not-last:border-border hover:bg-muted/50 grid w-full cursor-pointer [grid-template-columns:1fr_auto] items-center gap-x-5 gap-y-1.5 px-4 py-3 transition-colors [grid-template-areas:'left_right''left_right'] not-last:border-b",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex min-w-0 flex-col gap-1.5 [grid-area:left]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-foreground truncate",
                                    title: label ?? '',
                                    children: label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-muted-foreground flex flex-wrap items-center gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-xs capitalize",
                                            children: isPayment ? 'Payment' : 'Transfer'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-xs",
                                            children: (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(date)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex min-w-0 flex-col items-end justify-center gap-1 pl-3 text-right [grid-area:right]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                    amount: consumedMoney
                                }),
                                isPartial && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-muted-foreground text-xs",
                                    children: [
                                        "of",
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                                            amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(totalAmount, currency),
                                            variant: "plain",
                                            inline: true
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, `${consumer.transactionId}-${index}`);
            }),
            remaining !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "not-last:border-border flex items-center justify-between gap-4 px-4 py-3 not-last:border-b",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-muted-foreground",
                        children: "Remaining"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                        amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(remaining, currency)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-border bg-muted/50 flex items-center justify-between gap-4 border-t px-4 py-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "font-medium",
                        children: "Total"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                        amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(totalAmount, currency)
                    })
                ]
            })
        ]
    });
};




parcelRequire("acw62");





parcelRequire("acw62");



const $4bbf8ec21d82e3df$export$f2a9864d3c68eb7b = ({ rawTransaction: rawTransaction })=>{
    const { linkBenefitModal: linkBenefitModal, unlinkBenefitTransactionModal: unlinkBenefitTransactionModal } = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const { benefit: benefit } = rawTransaction;
    const handleLink = ()=>{
        linkBenefitModal.openModal({
            rawTransaction: rawTransaction,
            currentBenefitName: benefit?.name
        });
    };
    const handleUnlink = ()=>{
        unlinkBenefitTransactionModal.openModal({
            rawTransaction: rawTransaction,
            benefitName: benefit?.name
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex min-h-9 flex-wrap items-center gap-2",
        children: [
            benefit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                to: `/accounts/${benefit.accountId}/benefits`,
                className: "underline",
                children: benefit.name
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-muted-foreground italic",
                children: "(none)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                className: "h-7 px-2.5 text-xs",
                onClick: handleLink,
                children: benefit ? 'Change' : 'Link benefit'
            }),
            benefit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                className: "h-7 gap-1.5 px-2.5 text-xs",
                onClick: handleUnlink,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2814ca8ca76f8609$export$2e2bcd8739ae039), {
                        className: "size-3.5"
                    }),
                    "Unlink"
                ]
            })
        ]
    });
};




// InputGroup labels carry pt-1.5 to line up with the first line of an h-9
// input; plain-text values need the same offset to sit on that line
const $e171412ead91d899$var$Value = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pt-1.5",
        children: children
    });
const $e171412ead91d899$var$Display = (props)=>{
    const { rawTransaction: rawTransaction } = props;
    const amount = (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromServer(rawTransaction);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2 p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Amount",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e171412ead91d899$var$Value, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                        amount: amount,
                        align: "left",
                        variant: "plain"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Description",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e171412ead91d899$var$Value, {
                    children: rawTransaction.description
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Date",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e171412ead91d899$var$Value, {
                    children: (0, $895eaf5059a11fbb$export$6f25eb35eacda85b)(rawTransaction.date)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Account",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e171412ead91d899$var$Value, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                        to: `/accounts/${rawTransaction.account._id}`,
                        className: "inline-flex max-w-full hover:underline",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c0f56add137aac0$export$42a331aab32dea1), {
                            account: rawTransaction.account
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Benefit",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4bbf8ec21d82e3df$export$f2a9864d3c68eb7b), {
                    rawTransaction: rawTransaction
                })
            }),
            rawTransaction.adjustmentForAnchorId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Adjustment",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e171412ead91d899$var$Value, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-muted-foreground",
                        children: [
                            "Created by reconcile fix up to close",
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                to: `/balance-anchors/${rawTransaction.adjustmentForAnchorId}`,
                                className: "hover:underline",
                                children: "this balance anchor"
                            }),
                            "."
                        ]
                    })
                })
            })
        ]
    });
};
var $e171412ead91d899$export$2e2bcd8739ae039 = $e171412ead91d899$var$Display;




parcelRequire("acw62");
const $1d3d0f92bf3b8c7f$var$JsonDisplay = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
        children: JSON.stringify(props.json, null, 2)
    });
};
var $1d3d0f92bf3b8c7f$export$2e2bcd8739ae039 = $1d3d0f92bf3b8c7f$var$JsonDisplay;





const $a338ca8b3f62daad$var$RawTransactionDetail = (props)=>{
    const { rawTransaction: rawTransaction, onDelete: onDelete } = props;
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const apolloClient = (0, $0868e36814f766fc$export$eb9a56e7a29e494)();
    const isConsumed = rawTransaction.remainingAmount !== null && rawTransaction.remainingAmount !== rawTransaction.amount;
    // Mirrors the server-side gates in deleteRawTransactions: a consumed or
    // reconciled line can't be deleted, so Delete isn't offered for one.
    const deleteBlockedReason = isConsumed ? 'consumed' : rawTransaction.reconciliation ? 'reconciled' : null;
    // The consuming transactions are deleted server-side, so refetch this raw
    // transaction to refresh its consumers list and remainingAmount.
    const [resetRawTransaction, { loading: resetting }] = (0, $ce9d9e524be20f53$export$6d9c901034bee97f)({
        refetchQueries: [
            'RetrieveRawTransaction'
        ]
    });
    const consumerCount = rawTransaction.consumers.length;
    // Unallocating deletes every consuming transaction and releases every other
    // line they consume, so the header button only arms it: the confirm row
    // names what goes before anything happens.
    const [confirmingReset, setConfirmingReset] = $acw62.useState(false);
    const otherLineCount = new Set(rawTransaction.consumers.flatMap((c)=>c.transaction.consumptions.map((consumption)=>consumption.rawTransactionId).filter((id)=>id !== rawTransaction._id))).size;
    const consumerNames = rawTransaction.consumers.map((c)=>c.transaction.payee || (c.transaction.transferType ? (0, $d906535d40bd11c1$export$e5f08023f111098c)[c.transaction.transferType] : 'Transfer'));
    const handleReset = ()=>{
        setConfirmingReset(false);
        resetRawTransaction({
            variables: {
                rawTransactionId: rawTransaction._id
            }
        });
    };
    const handleEdit = ()=>{
        // The modal owns the cache bookkeeping for account moves and benefit
        // changes, so there is nothing to clean up here.
        modals.editRawTransactionModal.openModal({
            rawTransaction: rawTransaction
        });
    };
    const handleDelete = ()=>{
        modals.deleteRawTransactionModal.openModal({
            rawTransactions: [
                rawTransaction
            ],
            onDelete: ()=>{
                // The account's cached list pages still contain the deleted row
                (0, $074538a84be674b5$export$2e2bcd8739ae039)(apolloClient.cache, rawTransaction.account._id);
                onDelete?.();
            }
        });
    };
    const sourceData = [
        [
            'Plaid',
            rawTransaction.plaidData
        ],
        [
            'Plaid investment',
            rawTransaction.plaidInvestmentTransactionData
        ],
        [
            'EZPass',
            rawTransaction.ezpassData
        ]
    ].flatMap(([label, json])=>json != null ? [
            {
                label: label,
                json: json
            }
        ] : []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5c85b4944985fd4a$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c85b4944985fd4a$export$8732e8b6b8d8047b), {
                title: rawTransaction.description || 'Activity',
                amount: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                    align: "left",
                    amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(rawTransaction.amount, rawTransaction.currency)
                }),
                actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            onClick: handleEdit,
                            children: "Edit"
                        }),
                        consumerCount > 0 && // Unallocating deletes every consuming transaction, so it
                        // takes a second press to confirm.
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: (0, $5c85b4944985fd4a$export$1c13fee39bc6126e),
                            disabled: resetting || confirmingReset,
                            onClick: ()=>setConfirmingReset(true),
                            children: "Unallocate"
                        }),
                        deleteBlockedReason === null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                            variant: "outline",
                            className: (0, $5c85b4944985fd4a$export$1c13fee39bc6126e),
                            onClick: handleDelete,
                            children: "Delete"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
                header: "Details",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e171412ead91d899$export$2e2bcd8739ae039), {
                    rawTransaction: rawTransaction
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
                header: consumerCount === 1 ? 'Transaction' : 'Transactions',
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09ead012420c7c6a$export$a1ce833e6d55d931), {
                        consumers: rawTransaction.consumers,
                        currency: rawTransaction.currency,
                        totalAmount: rawTransaction.amount,
                        remainingAmount: rawTransaction.remainingAmount
                    }),
                    confirmingReset && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border-border flex flex-wrap items-center justify-between gap-3 border-t px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-sm",
                                children: [
                                    "Delete ",
                                    consumerNames.join(', '),
                                    otherLineCount > 0 && ` and release ${otherLineCount} other line${otherLineCount === 1 ? '' : 's'}`,
                                    "?"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                        variant: "outline",
                                        onClick: ()=>setConfirmingReset(false),
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                        variant: "destructive",
                                        disabled: resetting,
                                        onClick: handleReset,
                                        children: "Unallocate"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            sourceData.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("details", {
                open: true,
                className: "group flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("summary", {
                        className: "flex cursor-pointer list-none items-center gap-1 text-lg select-none",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                className: "text-muted-foreground size-4 transition-transform group-open:rotate-90"
                            }),
                            "Source data"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col gap-4 pt-2",
                        children: sourceData.map(({ label: label, json: json })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
                                header: label,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d3d0f92bf3b8c7f$export$2e2bcd8739ae039), {
                                    json: json
                                })
                            }, label))
                    })
                ]
            })
        ]
    });
};
var $a338ca8b3f62daad$export$2e2bcd8739ae039 = $a338ca8b3f62daad$var$RawTransactionDetail;




const $72793ccc862844ff$export$54abbf651ce580fd = ()=>{
    const params = (0, $926608a7a86d7371$export$99eaa27ddbbb95ef)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const rawTransactionId = params.id || '';
    const { data: data, loading: loading } = (0, $ce9d9e524be20f53$export$920ac3c36ab45eb9)({
        variables: {
            id: rawTransactionId
        }
    });
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: data?.rawTransaction?.description ?? rawTransactionId,
        fallback: [
            {
                label: 'Activity',
                href: '/ledger?layer=activity'
            }
        ]
    });
    if (!rawTransactionId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "No raw transaction selected"
    });
    if (loading && !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
        size: "medium"
    });
    const rawTransaction = data?.rawTransaction;
    if (!rawTransaction) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "Raw transaction not found"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-1 flex-col overflow-y-auto p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a338ca8b3f62daad$export$2e2bcd8739ae039), {
            rawTransaction: rawTransaction,
            onDelete: ()=>navigate(`/accounts/${rawTransaction.account._id}/transactions`)
        })
    });
};





parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
// The app icon (src/brand/favicon.svg) as a component: one ribbon dividing
// into two half-width ones, the way a charge splits across transactions.
const $8e993814f36493fa$var$UPPER = 'M18 50H3A15 15 0 0 1 18 35H38C62 35 60 14 84 14A7.5 7.5 0 0 1 84 29C70 29 66 50 38 50Z';
const $8e993814f36493fa$var$LOWER = 'M18 50H38C66 50 70 71 84 71A7.5 7.5 0 0 1 84 86C60 86 62 65 38 65H18A15 15 0 0 1 3 50Z';
const $8e993814f36493fa$export$883745da02825b5b = ({ className: className })=>{
    // Gradient ids are document-global, so each instance needs its own.
    const id = $acw62.useId();
    const tile = `${id}-tile`;
    const glow = `${id}-glow`;
    const upper = `${id}-upper`;
    const lower = `${id}-lower`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 100 100",
        className: className,
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: tile,
                        x1: "0",
                        y1: "0",
                        x2: "1",
                        y2: "1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0",
                                stopColor: "#5a98f5"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1f4fae"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                        id: glow,
                        cx: ".22",
                        cy: ".12",
                        r: ".9",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff",
                                stopOpacity: ".28"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: ".6",
                                stopColor: "#fff",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: upper,
                        x1: "0",
                        y1: "0",
                        x2: "1",
                        y2: "0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "#eef4ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: lower,
                        x1: "0",
                        y1: "0",
                        x2: "1",
                        y2: "0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0",
                                stopColor: "#d5e4fd"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "#a9c7f8"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "100",
                height: "100",
                rx: "22",
                fill: `url(#${tile})`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "100",
                height: "100",
                rx: "22",
                fill: `url(#${glow})`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                transform: "translate(12.2 10) scale(0.8)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: $8e993814f36493fa$var$LOWER,
                        fill: `url(#${lower})`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: $8e993814f36493fa$var$UPPER,
                        fill: `url(#${upper})`
                    })
                ]
            })
        ]
    });
};








var $acw62 = parcelRequire("acw62");


const $5ab9deb96f974abd$var$loadStored = (key)=>{
    try {
        const raw = window.localStorage.getItem(key);
        return raw === null ? null : raw === 'true';
    } catch  {
        // Storage unavailable — fall back to route-derived state
        return null;
    }
};
const $5ab9deb96f974abd$export$5474ef78d3ddcbe5 = (props)=>{
    const { label: label, childPaths: childPaths, storageKey: storageKey, children: children } = props;
    const location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    const contentId = $acw62.useId();
    const childActive = childPaths.some((path)=>location.pathname.startsWith(path));
    const [open, setOpen] = $acw62.useState(()=>$5ab9deb96f974abd$var$loadStored(storageKey) ?? false);
    const effectiveOpen = open || childActive;
    const handleToggle = ()=>{
        setOpen((prev)=>{
            const next = !prev;
            try {
                window.localStorage.setItem(storageKey, String(next));
            } catch  {
            // Storage unavailable — state still works for this session
            }
            return next;
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$266a769812832828), {
                "aria-expanded": effectiveOpen,
                "aria-controls": contentId,
                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                    className: "transition-transform duration-100",
                    style: {
                        transform: effectiveOpen ? 'rotate(90deg)' : 'rotate(0deg)'
                    }
                }),
                label: label,
                onClick: handleToggle
            }),
            effectiveOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: contentId,
                className: "flex flex-col px-2",
                children: children
            }) : null
        ]
    });
};



/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $176d5bb5050be9a3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
            key: "kfwtm"
        }
    ]
];
const $176d5bb5050be9a3$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("moon", $176d5bb5050be9a3$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.561.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $552554c986ed6ef6$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M12 20v2",
            key: "1lh1kg"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 1.41 1.41",
            key: "149t6j"
        }
    ],
    [
        "path",
        {
            d: "m17.66 17.66 1.41 1.41",
            key: "ptbguv"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "m6.34 17.66-1.41 1.41",
            key: "1m8zz5"
        }
    ],
    [
        "path",
        {
            d: "m19.07 4.93-1.41 1.41",
            key: "1shlcs"
        }
    ]
];
const $552554c986ed6ef6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("sun", $552554c986ed6ef6$export$3efd853dbb351e94);


parcelRequire("acw62");


const $46aad3706650c622$export$95e6932d3dc9c35c = ()=>{
    const { theme: theme, toggleTheme: toggleTheme } = (0, $e48c19e6a5217ff7$export$2e2bcd8739ae039)();
    const icon = theme === 'dark' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $552554c986ed6ef6$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $176d5bb5050be9a3$export$2e2bcd8739ae039), {});
    const label = theme === 'dark' ? 'Light mode' : 'Dark mode';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$266a769812832828), {
        iconLeft: icon,
        label: label,
        onClick: toggleTheme
    });
};




const $0ec776156e987127$export$1ff3c3f08ae963c0 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "after:bg-sidebar-border relative after:absolute after:top-1/2 after:left-[5%] after:block after:h-px after:w-[90%] after:content-['']"
    });




parcelRequire("acw62");



const $e4cc5668cd9dc9a6$export$3826f2c15cf9a4f4 = ()=>{
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    const updatesAvailable = (0, $d445317123c5c8b5$export$e3811da6fd33476c)();
    const handleClick = ()=>{
        modals.syncModal.openModal({});
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$266a769812832828), {
        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                    className: "size-4 shrink-0"
                }),
                updatesAvailable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "absolute -right-1 -top-1 size-2 rounded-full bg-blue-500"
                })
            ]
        }),
        label: "Sync",
        onClick: handleClick
    });
};


const $9224377caed296dc$var$SideNav = (props)=>{
    const { isOpen: isOpen } = props;
    const location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    // The hub's child pages lost their own sidebar slots, so the Settings
    // entry stays highlighted while the user is anywhere in that area.
    const inSettingsArea = [
        '/settings',
        ...(0, $53423000ad84ebd8$export$2db3b3648fd41ec1).map((p)=>p.path)
    ].some((path)=>location.pathname === path || location.pathname.startsWith(`${path}/`));
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-sidebar-foreground flex-0 flex items-center gap-2.5 px-3 pt-2 pb-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e993814f36493fa$export$883745da02825b5b), {
                        className: "size-6 shrink-0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold tracking-tight",
                        children: "Transactions"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$519285cd418d549c), {
                        path: "/",
                        label: "Inbox",
                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3206cd97f03c9458$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$519285cd418d549c), {
                        path: "/ledger",
                        label: "Ledger",
                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cab856bf30f1b37f$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$519285cd418d549c), {
                        path: "/analytics",
                        label: "Analytics",
                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2905799e904c1a8a$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$519285cd418d549c), {
                        path: "/accounts",
                        label: "Accounts",
                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33b542e8915cec79$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$519285cd418d549c), {
                        path: "/investments",
                        label: "Investments",
                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ab9deb96f974abd$export$5474ef78d3ddcbe5), {
                        label: "More",
                        childPaths: [
                            '/net-worth',
                            '/payroll',
                            '/equity',
                            '/benefits'
                        ],
                        storageKey: "sideNavMoreOpen",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$519285cd418d549c), {
                                path: "/net-worth",
                                label: "Net worth",
                                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0811c1891b547863$export$2e2bcd8739ae039), {}),
                                level: "secondary"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$519285cd418d549c), {
                                path: "/payroll",
                                label: "Payroll",
                                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07139920b5ad0ce2$export$2e2bcd8739ae039), {}),
                                level: "secondary"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$519285cd418d549c), {
                                path: "/equity",
                                label: "Equity",
                                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3e517ec92034a$export$2e2bcd8739ae039), {}),
                                level: "secondary"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$519285cd418d549c), {
                                path: "/benefits",
                                label: "Benefits",
                                iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6315759428919b56$export$2e2bcd8739ae039), {}),
                                level: "secondary"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ec776156e987127$export$1ff3c3f08ae963c0), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$519285cd418d549c), {
                        path: "/categories",
                        label: "Categories",
                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8872a1d80d2463f9$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $884578d2d7297b57$export$519285cd418d549c), {
                        path: "/settings",
                        label: "Settings",
                        isActive: inSettingsArea,
                        iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da03c070d837b197$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ec776156e987127$export$1ff3c3f08ae963c0), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46aad3706650c622$export$95e6932d3dc9c35c), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4cc5668cd9dc9a6$export$3826f2c15cf9a4f4), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e24e597302c703aa$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('relative flex', 'transition-all duration-300 ease-out', isOpen ? 'w-[300px] min-w-[300px]' : 'w-0 min-w-0'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "navigation",
            "aria-label": "Primary navigation",
            className: (0, $3fb8b98e60e6c18f$export$1343a74baacb0543)('h-full w-[300px] min-w-[300px]', 'absolute top-0 right-0', 'bg-sidebar border-border flex flex-col gap-2 overflow-y-auto border-r px-2 py-2'),
            children: content
        })
    });
};
var $9224377caed296dc$export$2e2bcd8739ae039 = $9224377caed296dc$var$SideNav;





var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");


parcelRequire("acw62");




parcelRequire("acw62");




const $2f816be14386dc0b$export$d6f342edf8bc808d = ({ transaction: transaction })=>{
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const currencyLabel = (0, $9b33a37eb331091e$export$df99f23287eaf00e)();
    const draws = transaction.basisDraws;
    if (draws.length === 0 && !transaction.needsBasis) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
        header: "US dollar value",
        children: [
            transaction.needsBasis && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-muted-foreground mb-2 text-sm",
                children: draws.length === 0 ? `No value yet \u{2014} nothing has been converted into ${currencyLabel(transaction.currency)} for this to draw from. Record the conversion that funded it, then assign basis from the inbox.` : // what has to be unwound if this needs reassigning.
                `Partly valued \u{2014} the draws below are recorded, but there was not enough converted ${currencyLabel(transaction.currency)} to cover all of it. Record another conversion, then assign basis from the inbox.`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    draws.map((draw, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-baseline justify-between gap-3 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                            to: `/transactions/${draw.lotTransactionId}`,
                                            className: "hover:underline",
                                            children: draw.lotTransaction?.description || 'Conversion'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-muted-foreground ml-2 text-xs",
                                            children: [
                                                draw.lotTransaction && (0, $895eaf5059a11fbb$export$3a4dcad6654a4c05)(draw.lotTransaction.date),
                                                " \xb7 ",
                                                draw.units < 0 ? 'returned ' : '',
                                                formatMoney((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(Math.abs(draw.units), draw.currency))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tabular-nums",
                                    children: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).toDecimalString((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(-draw.homeAmount, 'USD'))
                                })
                            ]
                        }, `${draw.lotTransactionId}-${index}`)),
                    draws.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border-border flex items-baseline justify-between gap-3 border-t pt-2 text-sm font-medium",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "Drawn from ",
                                    draws.length,
                                    " conversions"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tabular-nums",
                                children: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).toDecimalString((0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(-draws.reduce((sum, draw)=>sum + draw.homeAmount, 0), 'USD'))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




parcelRequire("acw62");



const $8ab47b41d04c95ac$export$7e2358397153aa44 = ({ transaction: transaction, onReset: onReset })=>{
    const modals = (0, $bbeaee87faaa63d1$export$2ee174121202e4c7)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: ()=>modals.editTransactionModal.openModal({
                        transaction: transaction
                    }),
                children: "Edit"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                variant: "outline",
                className: (0, $5c85b4944985fd4a$export$1c13fee39bc6126e),
                title: "Delete this transaction and return its raw transactions to the inbox",
                onClick: ()=>modals.resetTransactionModal.openModal({
                        transactionId: transaction._id,
                        onReset: onReset
                    }),
                children: "Reset"
            })
        ]
    });
};




parcelRequire("acw62");




parcelRequire("acw62");

const $823ee6a6cd364aee$var$MultiTagDisplay = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-row flex-wrap gap-2",
        children: [
            props.tags.map((tag, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a87593345326dab5$export$4325b389d599d493), {
                    name: tag,
                    onRemove: ()=>props.onRemove && props.onRemove(index),
                    showRemove: props.showRemove
                }, tag)),
            props.children
        ]
    });
};
var $823ee6a6cd364aee$export$2e2bcd8739ae039 = $823ee6a6cd364aee$var$MultiTagDisplay;




// InputGroup labels carry pt-1.5 to line up with the first line of an h-9
// input; plain-text values need the same offset to sit on that line. This
// mirrors the raw transaction Display, so the two detail pages read as one
// pattern rather than two.
const $513e27f4ba91947f$var$Value = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pt-1.5",
        children: children
    });
// An unset value renders as an em dash rather than an empty row: a blank
// space beside a label is indistinguishable from a rendering bug.
const $513e27f4ba91947f$var$Empty = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-muted-foreground",
        children: "\u2014"
    });
const $513e27f4ba91947f$var$PendingValue = ({ pending: pending })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Value, {
        children: pending ? 'Pending' : 'Posted'
    });
/**
 * Tags and fields as read-only chips — the display half of TagsAndFieldsInput.
 * Field names live on the Field documents rather than on the transaction, so
 * the field list is fetched (from the cache, in practice: every list view
 * already asks for it).
 */ const $513e27f4ba91947f$var$TagsAndFieldsValue = ({ transaction: transaction })=>{
    const { data: data } = (0, $ce9d9e524be20f53$export$f7e7e8c15204f3c5)();
    const fields = data?.allFields ?? [];
    const tags = transaction.tags.map((tag)=>tag.name);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    const fieldValues = transaction.fieldValues || {};
    const hasFieldValues = Object.values(fieldValues).some((value)=>value != null && value !== '');
    if (tags.length === 0 && !hasFieldValues) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Value, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Empty, {})
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Value, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-1.5",
            children: [
                tags.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $823ee6a6cd364aee$export$2e2bcd8739ae039), {
                    tags: tags
                }),
                hasFieldValues && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $131e63675abc2981$export$b9c3f7b4f6aa1316), {
                    fields: fields,
                    fieldValues: fieldValues
                })
            ]
        })
    });
};
const $513e27f4ba91947f$export$9c535a24f9534599 = ({ payment: payment })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2 p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Payee",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Value, {
                    children: payment.payee || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Empty, {})
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Note",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Value, {
                    children: payment.description || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Empty, {})
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Date",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Value, {
                    children: (0, $895eaf5059a11fbb$export$6f25eb35eacda85b)(payment.date)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Category",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Value, {
                    children: payment.category ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a7baecaae56a667$export$1f1530db9dfbc9da), {
                        category: payment.category
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Empty, {})
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Tags & fields",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$TagsAndFieldsValue, {
                    transaction: payment
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Status",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$PendingValue, {
                    pending: payment.pending
                })
            })
        ]
    });
const $513e27f4ba91947f$export$9ad5d5a82b0055eb = ({ transfer: transfer })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2 p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Type",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Value, {
                    children: transfer.transferType ? (0, $d906535d40bd11c1$export$e5f08023f111098c)[transfer.transferType] : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Empty, {})
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Payee",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Value, {
                    children: transfer.payee || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Empty, {})
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Date",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Value, {
                    children: (0, $895eaf5059a11fbb$export$6f25eb35eacda85b)(transfer.date)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Note",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Value, {
                    children: transfer.description || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$Empty, {})
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Tags & fields",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$TagsAndFieldsValue, {
                    transaction: transfer
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af202f2e06e365$export$2e2bcd8739ae039), {
                label: "Status",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($513e27f4ba91947f$var$PendingValue, {
                    pending: transfer.pending
                })
            })
        ]
    });



const $12723bd3356c3c09$var$PaymentDetail = (props)=>{
    const { payment: payment } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5c85b4944985fd4a$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c85b4944985fd4a$export$8732e8b6b8d8047b), {
                title: payment.payee || 'Untitled Payment',
                amount: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                    align: "left",
                    amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(payment.netAmount, payment.currency),
                    approx: payment.currency !== 'USD' && payment.homeNetAmount != null ? (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(payment.homeNetAmount, 'USD') : null
                }),
                actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ab47b41d04c95ac$export$7e2358397153aa44), {
                    transaction: payment,
                    onReset: props.onReset
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
                header: "Details",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $513e27f4ba91947f$export$9c535a24f9534599), {
                    payment: payment
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f816be14386dc0b$export$d6f342edf8bc808d), {
                transaction: payment
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
                header: "Lines",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1000a58b5aa0fad5$export$e0242e06075791dc), {
                    consumptions: payment.consumptions,
                    highlightId: props.highlightLineId,
                    currency: payment.currency
                })
            })
        ]
    });
};
var $12723bd3356c3c09$export$2e2bcd8739ae039 = $12723bd3356c3c09$var$PaymentDetail;





parcelRequire("acw62");










const $69aa8a8c75cca983$var$formatTransferTitle = (transferType)=>{
    if (transferType && transferType in (0, $d906535d40bd11c1$export$e5f08023f111098c)) return (0, $d906535d40bd11c1$export$e5f08023f111098c)[transferType];
    return 'Transfer';
};
const $69aa8a8c75cca983$export$fdc3e8a89616a7d6 = (props)=>{
    const { transfer: transfer } = props;
    const formatMoney = (0, $9b33a37eb331091e$export$b44ac3096015d626)();
    const isConversion = transfer.transferType === (0, $ce9d9e524be20f53$export$1b5eb083c754a86b).Conversion;
    // A transfer nets to zero; the amount moved is the sum of one side.
    const movedAmount = transfer.consumptions.filter((c)=>c.amount > 0).reduce((sum, c)=>sum + c.amount, 0);
    // A conversion's legs live in two currencies; render them as
    // "-$137.49 → +¥20,000" (outgoing first) from the consumed raws.
    //
    // `rawTransaction` can be briefly absent: mutations on this page return the
    // UnifiedTransaction fragment, whose consumptions carry only
    // {rawTransactionId, amount}, so Apollo rewrites the cached consumption
    // objects without the nested raw until the detail query refetches. Drop
    // those legs rather than dereferencing undefined — a partial header for one
    // render beats a crash.
    const conversionLegs = isConversion ? (0, $eb9c0713007ac1dd$export$d51151e4f01b4b50)(transfer.consumptions.filter((c)=>c.rawTransaction?.currency != null).map((c)=>({
            amount: c.amount,
            currency: c.rawTransaction.currency
        }))).sort((a, b)=>a.amount - b.amount) : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5c85b4944985fd4a$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c85b4944985fd4a$export$8732e8b6b8d8047b), {
                // The payee (the counterparty) names the page when present — "Amazon"
                // beats "Refund" — with the kind still shown in the Details rows.
                title: transfer.payee || $69aa8a8c75cca983$var$formatTransferTitle(transfer.transferType ?? null),
                // Muted: money that moved between accounts, not money spent.
                amount: isConversion ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    children: conversionLegs.map((leg)=>formatMoney(leg)).join(" \u2192 ")
                }) : movedAmount > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-muted-foreground",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $133c17dbc4a8c137$export$22a21a30456603eb), {
                        align: "left",
                        amount: (0, $145d7e42bdaa79ff$export$2e2bcd8739ae039).fromInt(movedAmount, transfer.currency),
                        variant: "plain"
                    })
                }) : null,
                actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ab47b41d04c95ac$export$7e2358397153aa44), {
                    transaction: transfer,
                    onReset: props.onReset
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
                header: "Details",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $513e27f4ba91947f$export$9ad5d5a82b0055eb), {
                    transfer: transfer
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f816be14386dc0b$export$d6f342edf8bc808d), {
                transaction: transfer
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3019d26b5c607220$export$2e2bcd8739ae039), {
                header: "Lines",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1000a58b5aa0fad5$export$e0242e06075791dc), {
                    consumptions: transfer.consumptions,
                    highlightId: props.highlightLineId,
                    currency: transfer.currency
                })
            })
        ]
    });
};


const $b1d177a16c9cefbf$var$TransactionDetail = (props)=>{
    const { transaction: transaction } = props;
    // Determine if payment or transfer based on netAmount
    const isPayment = transaction.netAmount !== 0;
    // Key by transaction id so form state resets when navigating between
    // transactions (the route change reuses the same component instance)
    if (isPayment) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12723bd3356c3c09$export$2e2bcd8739ae039), {
        payment: transaction,
        onReset: props.onReset,
        highlightLineId: props.highlightLineId
    }, transaction._id);
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69aa8a8c75cca983$export$fdc3e8a89616a7d6), {
        transfer: transaction,
        onReset: props.onReset,
        highlightLineId: props.highlightLineId
    }, transaction._id);
};
var $b1d177a16c9cefbf$export$2e2bcd8739ae039 = $b1d177a16c9cefbf$var$TransactionDetail;





const $f55aa64410953466$var$getTransactionLabel = (transaction)=>{
    if (transaction.netAmount !== 0) return transaction.payee || 'Untitled Payment';
    // A transfer's payee (its counterparty) names it better than its kind
    // alone: "Amazon" beats "Refund" in the breadcrumb.
    if (transaction.payee) return transaction.payee;
    if (transaction.transferType && transaction.transferType in (0, $d906535d40bd11c1$export$e5f08023f111098c)) return (0, $d906535d40bd11c1$export$e5f08023f111098c)[transaction.transferType];
    return 'Transfer';
};
const $f55aa64410953466$export$a4ffe531f3ecfbd = ()=>{
    const params = (0, $926608a7a86d7371$export$99eaa27ddbbb95ef)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const [searchParams] = (0, $0c90f43fc3673aef$export$f1a78c17382fe22a)();
    const transactionId = params.id || '';
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $ce9d9e524be20f53$export$27549920c2be446e)({
        variables: {
            id: transactionId
        }
    });
    // Mutations returning UnifiedTransaction overwrite the Apollo cache without
    // consumptions.rawTransaction. Detect the stale shape and refetch once.
    $acw62.useEffect(()=>{
        const consumptions = data?.transactionById?.consumptions;
        if (consumptions?.some((c)=>!c.rawTransaction)) refetch();
    }, [
        data,
        refetch
    ]);
    const transaction = data?.transactionById;
    const breadcrumbLabel = transaction ? $f55aa64410953466$var$getTransactionLabel(transaction) : transactionId;
    (0, $09fc5346bd733ea4$export$942cde81de89b1ba)({
        label: breadcrumbLabel,
        fallback: [
            {
                label: 'Ledger',
                href: '/ledger'
            }
        ]
    });
    if (!transactionId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "No transaction selected"
    });
    if (loading && !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d4f139dd59f4c7b$export$2e2bcd8739ae039), {
        size: "medium"
    });
    if (error && !transaction) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: [
            "Failed to load transaction: ",
            error.message
        ]
    });
    if (!transaction) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4e98da5ab86bcf9$export$2e2bcd8739ae039), {
        children: "Transaction not found"
    });
    const handleReset = ()=>{
        navigate('/ledger');
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-1 flex-col overflow-y-auto p-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b1d177a16c9cefbf$export$2e2bcd8739ae039), {
            transaction: transaction,
            onReset: handleReset,
            highlightLineId: searchParams.get('line')
        })
    });
};




/** Redirect /investments/:id to /accounts/:id */ /**
 * A retired list page's address, sent on to the Ledger with its query
 * string intact (plus `extra`, e.g. the layer), so bookmarks and old links
 * keep their filters.
 */ const $a397b17af1315ec0$var$LedgerRedirect = ({ extra: extra = {} })=>{
    const location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    const params = new URLSearchParams(location.search);
    for (const [key, value] of Object.entries(extra))params.set(key, value);
    const query = params.toString();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
        to: query === '' ? '/ledger' : `/ledger?${query}`,
        replace: true
    });
};
const $a397b17af1315ec0$var$InvestmentRedirect = ()=>{
    const { id: id } = (0, $926608a7a86d7371$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
        to: `/accounts/${id}`,
        replace: true
    });
};
const $a397b17af1315ec0$var$PlaidDebugRedirect = ()=>{
    const { id: id } = (0, $926608a7a86d7371$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
        to: `/connections/${id}/debug`,
        replace: true
    });
};
const $a397b17af1315ec0$var$RoutedMainPane = ()=>{
    const isMobile = (0, $d720d4657ad5543c$export$2b96349243a56116)();
    const [isNavOpen, setIsNavOpen] = $acw62.useState(!isMobile);
    // A phone's More opens a sheet; the sidebar is desktop's.
    const [isMoreOpen, setIsMoreOpen] = $acw62.useState(false);
    const closeMore = $acw62.useCallback(()=>setIsMoreOpen(false), []);
    // The sheet exists only in the phone layout: leaving it (a rotation past
    // the breakpoint) closes the sheet rather than leaving it open to reappear.
    $acw62.useEffect(()=>{
        if (!isMobile) setIsMoreOpen(false);
    }, [
        isMobile
    ]);
    // Pages can portal their action buttons into this slot (via HeaderActions)
    // so they share the breadcrumb's row instead of adding a second header row.
    const [actionsSlot, setActionsSlot] = $acw62.useState(null);
    const [bottomBarSlot, setBottomBarSlot] = $acw62.useState(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09fc5346bd733ea4$export$d1cbd6d8a28c0f1), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eca5e0b4050b06eb$export$6e97079f8722c75e), {
            value: actionsSlot,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f740d16830f15c$export$f199e5d2cab70941), {
                value: bottomBarSlot,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex h-full w-full flex-1 flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative flex flex-1 flex-row overflow-hidden",
                            children: [
                                !isMobile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9224377caed296dc$export$2e2bcd8739ae039), {
                                    isOpen: isNavOpen
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-1 flex-col overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "border-border bg-background text-foreground flex h-14 items-center gap-1.5 border-b p-2 max-sm:pl-4",
                                            children: [
                                                !isMobile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd245b1ec6e3b89c$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    onClick: ()=>setIsNavOpen(!isNavOpen),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $efa6e18e6227061d$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0bc606ab8db3c36e$export$dabcc1ec9dd9d1cc), {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    ref: setActionsSlot,
                                                    className: "ml-auto flex shrink-0 items-center gap-1.5"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $926608a7a86d7371$export$3565eb3d00ca5a74), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e15262ef6128f3bb$export$17e4068f9ad0565b), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/inbox/review",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e15262ef6128f3bb$export$17e4068f9ad0565b), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/backlog",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $543391bd6fced84a$export$471ffbe87b75af04), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/ledger",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56972fefe5e283d2$export$53fc7b0c4a74de18), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/transactions",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a397b17af1315ec0$var$LedgerRedirect, {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/activity",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a397b17af1315ec0$var$LedgerRedirect, {
                                                        extra: {
                                                            layer: 'activity'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/analytics",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91197becc4f4c199$export$6268df79f24c119b), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/payroll",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0e4eefb5185f412$export$d94061e5db57f05d), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/equity",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccb0657f9d138f61$export$df981316e86d14be), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/net-worth",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $703c708530483efe$export$89010588e5feb9dc), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/transactions/:id",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f55aa64410953466$export$a4ffe531f3ecfbd), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/transfers",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
                                                        to: "/ledger",
                                                        replace: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/raw-transactions/:id",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72793ccc862844ff$export$54abbf651ce580fd), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/balance-anchors/:id",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d69bc32c16614348$export$df121238a8835bce), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/insights",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
                                                        to: "/analytics?tab=insights",
                                                        replace: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/settings",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53423000ad84ebd8$export$7d05e0deed78c249), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/fields",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12648488522a12b4$export$ef18ccbe8f7f1919), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/units",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5dacb16d832f4b6$export$f38c2e306dc3b554), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/defaults",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9e131a65ff6a75$export$88111244a00d81e1), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/payee-logos",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55a95d70476bea65$export$57e570fc31cf3859), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/categories",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76b8be3a3c79c085$export$b0e2648bcd32fb5), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/categories/:id",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba7ca1ebc614be26$export$8bab8f4f9f9355e5), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/accounts",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $86bd80b017698727$export$f019e054845ddace), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/accounts/:id",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf8a3466088e9562$export$ae9e76cd6ee380b0), {}),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                            index: true,
                                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dabce856953436fb$export$d7d9da435d4d3802), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                            path: "transactions",
                                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77aad9f0a27a5941$export$abc3224e24d2a532), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                            path: "reconcile",
                                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $641619c3b52cfc92$export$c71d4e65ef72ff3e), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                            path: "snapshots",
                                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aba9d9f93276c42c$export$68f94bff7f5a4ae8), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                            path: "benefits",
                                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63af3e702c74fd6f$export$5fcc2ea9fcaf9d47), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                            path: "plaid",
                                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
                                                                to: "..",
                                                                replace: true
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/benefits",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f287dea82674520$export$b06b821702967001), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/investments",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e071f54a6092fa6f$export$e33c718277d7d8f0), {}),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                            index: true,
                                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $afdda9a6b5a2e0d0$export$f0abba7b2e9ab0ae), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                            path: "holdings",
                                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $faa3abd542deeac0$export$2ac952587dee9ad4), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                            path: "reconcile",
                                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e5599b0d9982529$export$9036408ccebce21c), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                            path: "performance",
                                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acb7bf5f53f280b5$export$ec173b1df7f5418e), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/investments/:id",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a397b17af1315ec0$var$InvestmentRedirect, {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/connections",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f016b1342bde9d89$export$2ad937ac55e586dd), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/connections/:id/debug",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee2f5a5388dc4da7$export$e6bbfbb74d4b5b1e), {})
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/plaid-tokens",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
                                                        to: "/connections",
                                                        replace: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                                    path: "/plaid-tokens/:id/debug",
                                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a397b17af1315ec0$var$PlaidDebugRedirect, {})
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        isMobile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f740d16830f15c$export$baad9f01dbfd9b39), {
                            onMore: ()=>setIsMoreOpen(true),
                            slotRef: setBottomBarSlot
                        }),
                        isMobile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed8c617b0e987212$export$3d49608eeba260fe), {
                            open: isMoreOpen,
                            onClose: closeMore
                        })
                    ]
                })
            })
        })
    });
};
var $a397b17af1315ec0$export$2e2bcd8739ae039 = $a397b17af1315ec0$var$RoutedMainPane;



const $1bf5ad07cba18b49$var$App = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15f87bc0c48f0318$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                display: 'flex',
                flexDirection: 'row',
                height: '100dvh'
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c90f43fc3673aef$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e48c19e6a5217ff7$export$d8964aec282183a3), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bbeaee87faaa63d1$export$d130e6a5a0bde89c), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a397b17af1315ec0$export$2e2bcd8739ae039), {})
                    })
                })
            })
        })
    });
};
var $1bf5ad07cba18b49$export$2e2bcd8739ae039 = $1bf5ad07cba18b49$var$App;



var $acw62 = parcelRequire("acw62");
const $46c6904f274494a5$var$LinkTag = (props)=>{
    const link = document.createElement('link');
    link.rel = props.rel;
    link.href = props.href;
    $acw62.useEffect(()=>{
        document.head.appendChild(link);
    });
    return null;
};
var $46c6904f274494a5$export$2e2bcd8739ae039 = $46c6904f274494a5$var$LinkTag;


const $aeb42f28b6fc3a6c$var$rootElement = document.getElementById('root');
if (!$aeb42f28b6fc3a6c$var$rootElement) throw new Error('Root element not found');
const $aeb42f28b6fc3a6c$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($aeb42f28b6fc3a6c$var$rootElement);
// Auth is session-based (BFF): the server owns the OAuth flow with Auth0 and
// keeps the identity in an httpOnly cookie, so there is no client-side auth
// provider — AuthenticationRequired just probes /api/auth/me and redirects
// to the server's /login route when the session is missing.
$aeb42f28b6fc3a6c$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8207f3c9182267bf$export$2e2bcd8739ae039), {
    children: [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46c6904f274494a5$export$2e2bcd8739ae039), {
            rel: "stylesheet",
            href: "index.css"
        }),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1bf5ad07cba18b49$export$2e2bcd8739ae039), {}),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46c6904f274494a5$export$2e2bcd8739ae039), {
            rel: "stylesheet",
            href: "https://fonts.googleapis.com/css2?family=Ubuntu&family=Ubuntu+Mono&display=swap"
        })
    ]
}));


//# sourceMappingURL=frontend.17da70b8.js.map
